function _classCallCheck(t, e) {
	if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
}

!function (t, e) {
	"use strict";
	"object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function (t) {
		if (!t.document) throw new Error("jQuery requires a window with a document");
		return e(t)
	} : e(t)
}("undefined" != typeof window ? window : this, function (t, e) {
	"use strict";
	var i = [], n = t.document, r = Object.getPrototypeOf, o = i.slice, a = i.concat, s = i.push, l = i.indexOf, c = {}, u = c.toString, h = c.hasOwnProperty, d = h.toString, p = d.call(Object), f = {}, m = function (t) {
		return "function" == typeof t && "number" != typeof t.nodeType
	}, g = function (t) {
		return null != t && t === t.window
	}, v = {type: !0, src: !0, noModule: !0};

	function y(t, e, i) {
		var r, o = (e = e || n).createElement("script");
		if (o.text = t, i) for (r in v) i[r] && (o[r] = i[r]);
		e.head.appendChild(o).parentNode.removeChild(o)
	}

	function b(t) {
		return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? c[u.call(t)] || "object" : typeof t
	}

	var w = function (t, e) {
		return new w.fn.init(t, e)
	}, x = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

	function k(t) {
		var e = !!t && "length" in t && t.length, i = b(t);
		return !m(t) && !g(t) && ("array" === i || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
	}

	w.fn = w.prototype = {
		jquery: "3.3.1", constructor: w, length: 0, toArray: function () {
			return o.call(this)
		}, get: function (t) {
			return null == t ? o.call(this) : t < 0 ? this[t + this.length] : this[t]
		}, pushStack: function (t) {
			var e = w.merge(this.constructor(), t);
			return e.prevObject = this, e
		}, each: function (t) {
			return w.each(this, t)
		}, map: function (t) {
			return this.pushStack(w.map(this, function (e, i) {
				return t.call(e, i, e)
			}))
		}, slice: function () {
			return this.pushStack(o.apply(this, arguments))
		}, first: function () {
			return this.eq(0)
		}, last: function () {
			return this.eq(-1)
		}, eq: function (t) {
			var e = this.length, i = +t + (t < 0 ? e : 0);
			return this.pushStack(i >= 0 && i < e ? [this[i]] : [])
		}, end: function () {
			return this.prevObject || this.constructor()
		}, push: s, sort: i.sort, splice: i.splice
	}, w.extend = w.fn.extend = function () {
		var t, e, i, n, r, o, a = arguments[0] || {}, s = 1, l = arguments.length, c = !1;
		for ("boolean" == typeof a && (c = a, a = arguments[s] || {}, s++), "object" == typeof a || m(a) || (a = {}), s === l && (a = this, s--); s < l; s++) if (null != (t = arguments[s])) for (e in t) i = a[e], a !== (n = t[e]) && (c && n && (w.isPlainObject(n) || (r = Array.isArray(n))) ? (r ? (r = !1, o = i && Array.isArray(i) ? i : []) : o = i && w.isPlainObject(i) ? i : {}, a[e] = w.extend(c, o, n)) : void 0 !== n && (a[e] = n));
		return a
	}, w.extend({
		expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""), isReady: !0, error: function (t) {
			throw new Error(t)
		}, noop: function () {
		}, isPlainObject: function (t) {
			var e, i;
			return !(!t || "[object Object]" !== u.call(t)) && (!(e = r(t)) || "function" == typeof (i = h.call(e, "constructor") && e.constructor) && d.call(i) === p)
		}, isEmptyObject: function (t) {
			var e;
			for (e in t) return !1;
			return !0
		}, globalEval: function (t) {
			y(t)
		}, each: function (t, e) {
			var i, n = 0;
			if (k(t)) for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++) ; else for (n in t) if (!1 === e.call(t[n], n, t[n])) break;
			return t
		}, trim: function (t) {
			return null == t ? "" : (t + "").replace(x, "")
		}, makeArray: function (t, e) {
			var i = e || [];
			return null != t && (k(Object(t)) ? w.merge(i, "string" == typeof t ? [t] : t) : s.call(i, t)), i
		}, inArray: function (t, e, i) {
			return null == e ? -1 : l.call(e, t, i)
		}, merge: function (t, e) {
			for (var i = +e.length, n = 0, r = t.length; n < i; n++) t[r++] = e[n];
			return t.length = r, t
		}, grep: function (t, e, i) {
			for (var n = [], r = 0, o = t.length, a = !i; r < o; r++) !e(t[r], r) !== a && n.push(t[r]);
			return n
		}, map: function (t, e, i) {
			var n, r, o = 0, s = [];
			if (k(t)) for (n = t.length; o < n; o++) null != (r = e(t[o], o, i)) && s.push(r); else for (o in t) null != (r = e(t[o], o, i)) && s.push(r);
			return a.apply([], s)
		}, guid: 1, support: f
	}), "function" == typeof Symbol && (w.fn[Symbol.iterator] = i[Symbol.iterator]), w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (t, e) {
		c["[object " + e + "]"] = e.toLowerCase()
	});
	var _ = function (t) {
		var e, i, n, r, o, a, s, l, c, u, h, d, p, f, m, g, v, y, b, w = "sizzle" + 1 * new Date, x = t.document, k = 0, _ = 0, S = at(), C = at(), D = at(), T = function (t, e) {
				return t === e && (h = !0), 0
			}, M = {}.hasOwnProperty, E = [], A = E.pop, P = E.push, I = E.push, O = E.slice, L = function (t, e) {
				for (var i = 0, n = t.length; i < n; i++) if (t[i] === e) return i;
				return -1
			}, F = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", N = "[\\x20\\t\\r\\n\\f]", R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
			H = "\\[" + N + "*(" + R + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + N + "*\\]", $ = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + H + ")*)|.*)\\)|)",
			B = new RegExp(N + "+", "g"), z = new RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g"), j = new RegExp("^" + N + "*," + N + "*"), U = new RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"), W = new RegExp("=" + N + "*([^\\]'\"]*?)" + N + "*\\]", "g"), Y = new RegExp($),
			V = new RegExp("^" + R + "$"), q = {
				ID: new RegExp("^#(" + R + ")"),
				CLASS: new RegExp("^\\.(" + R + ")"),
				TAG: new RegExp("^(" + R + "|[*])"),
				ATTR: new RegExp("^" + H),
				PSEUDO: new RegExp("^" + $),
				CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)", "i"),
				bool: new RegExp("^(?:" + F + ")$", "i"),
				needsContext: new RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)", "i")
			}, G = /^(?:input|select|textarea|button)$/i, K = /^h\d$/i, X = /^[^{]+\{\s*\[native \w/, Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Q = /[+~]/, J = new RegExp("\\\\([\\da-f]{1,6}" + N + "?|(" + N + ")|.)", "ig"), tt = function (t, e, i) {
				var n = "0x" + e - 65536;
				return n != n || i ? e : n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320)
			}, et = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, it = function (t, e) {
				return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
			}, nt = function () {
				d()
			}, rt = yt(function (t) {
				return !0 === t.disabled && ("form" in t || "label" in t)
			}, {dir: "parentNode", next: "legend"});
		try {
			I.apply(E = O.call(x.childNodes), x.childNodes), E[x.childNodes.length].nodeType
		} catch (t) {
			I = {
				apply: E.length ? function (t, e) {
					P.apply(t, O.call(e))
				} : function (t, e) {
					for (var i = t.length, n = 0; t[i++] = e[n++];) ;
					t.length = i - 1
				}
			}
		}

		function ot(t, e, n, r) {
			var o, s, c, u, h, f, v, y = e && e.ownerDocument, k = e ? e.nodeType : 9;
			if (n = n || [], "string" != typeof t || !t || 1 !== k && 9 !== k && 11 !== k) return n;
			if (!r && ((e ? e.ownerDocument || e : x) !== p && d(e), e = e || p, m)) {
				if (11 !== k && (h = Z.exec(t))) if (o = h[1]) {
					if (9 === k) {
						if (!(c = e.getElementById(o))) return n;
						if (c.id === o) return n.push(c), n
					} else if (y && (c = y.getElementById(o)) && b(e, c) && c.id === o) return n.push(c), n
				} else {
					if (h[2]) return I.apply(n, e.getElementsByTagName(t)), n;
					if ((o = h[3]) && i.getElementsByClassName && e.getElementsByClassName) return I.apply(n, e.getElementsByClassName(o)), n
				}
				if (i.qsa && !D[t + " "] && (!g || !g.test(t))) {
					if (1 !== k) y = e, v = t; else if ("object" !== e.nodeName.toLowerCase()) {
						for ((u = e.getAttribute("id")) ? u = u.replace(et, it) : e.setAttribute("id", u = w), s = (f = a(t)).length; s--;) f[s] = "#" + u + " " + vt(f[s]);
						v = f.join(","), y = Q.test(t) && mt(e.parentNode) || e
					}
					if (v) try {
						return I.apply(n, y.querySelectorAll(v)), n
					} catch (t) {
					} finally {
						u === w && e.removeAttribute("id")
					}
				}
			}
			return l(t.replace(z, "$1"), e, n, r)
		}

		function at() {
			var t = [];
			return function e(i, r) {
				return t.push(i + " ") > n.cacheLength && delete e[t.shift()], e[i + " "] = r
			}
		}

		function st(t) {
			return t[w] = !0, t
		}

		function lt(t) {
			var e = p.createElement("fieldset");
			try {
				return !!t(e)
			} catch (t) {
				return !1
			} finally {
				e.parentNode && e.parentNode.removeChild(e), e = null
			}
		}

		function ct(t, e) {
			for (var i = t.split("|"), r = i.length; r--;) n.attrHandle[i[r]] = e
		}

		function ut(t, e) {
			var i = e && t, n = i && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
			if (n) return n;
			if (i) for (; i = i.nextSibling;) if (i === e) return -1;
			return t ? 1 : -1
		}

		function ht(t) {
			return function (e) {
				return "input" === e.nodeName.toLowerCase() && e.type === t
			}
		}

		function dt(t) {
			return function (e) {
				var i = e.nodeName.toLowerCase();
				return ("input" === i || "button" === i) && e.type === t
			}
		}

		function pt(t) {
			return function (e) {
				return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && rt(e) === t : e.disabled === t : "label" in e && e.disabled === t
			}
		}

		function ft(t) {
			return st(function (e) {
				return e = +e, st(function (i, n) {
					for (var r, o = t([], i.length, e), a = o.length; a--;) i[r = o[a]] && (i[r] = !(n[r] = i[r]))
				})
			})
		}

		function mt(t) {
			return t && void 0 !== t.getElementsByTagName && t
		}

		for (e in i = ot.support = {}, o = ot.isXML = function (t) {
			var e = t && (t.ownerDocument || t).documentElement;
			return !!e && "HTML" !== e.nodeName
		}, d = ot.setDocument = function (t) {
			var e, r, a = t ? t.ownerDocument || t : x;
			return a !== p && 9 === a.nodeType && a.documentElement ? (f = (p = a).documentElement, m = !o(p), x !== p && (r = p.defaultView) && r.top !== r && (r.addEventListener ? r.addEventListener("unload", nt, !1) : r.attachEvent && r.attachEvent("onunload", nt)), i.attributes = lt(function (t) {
				return t.className = "i", !t.getAttribute("className")
			}), i.getElementsByTagName = lt(function (t) {
				return t.appendChild(p.createComment("")), !t.getElementsByTagName("*").length
			}), i.getElementsByClassName = X.test(p.getElementsByClassName), i.getById = lt(function (t) {
				return f.appendChild(t).id = w, !p.getElementsByName || !p.getElementsByName(w).length
			}), i.getById ? (n.filter.ID = function (t) {
				var e = t.replace(J, tt);
				return function (t) {
					return t.getAttribute("id") === e
				}
			}, n.find.ID = function (t, e) {
				if (void 0 !== e.getElementById && m) {
					var i = e.getElementById(t);
					return i ? [i] : []
				}
			}) : (n.filter.ID = function (t) {
				var e = t.replace(J, tt);
				return function (t) {
					var i = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
					return i && i.value === e
				}
			}, n.find.ID = function (t, e) {
				if (void 0 !== e.getElementById && m) {
					var i, n, r, o = e.getElementById(t);
					if (o) {
						if ((i = o.getAttributeNode("id")) && i.value === t) return [o];
						for (r = e.getElementsByName(t), n = 0; o = r[n++];) if ((i = o.getAttributeNode("id")) && i.value === t) return [o]
					}
					return []
				}
			}), n.find.TAG = i.getElementsByTagName ? function (t, e) {
				return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : i.qsa ? e.querySelectorAll(t) : void 0
			} : function (t, e) {
				var i, n = [], r = 0, o = e.getElementsByTagName(t);
				if ("*" === t) {
					for (; i = o[r++];) 1 === i.nodeType && n.push(i);
					return n
				}
				return o
			}, n.find.CLASS = i.getElementsByClassName && function (t, e) {
				if (void 0 !== e.getElementsByClassName && m) return e.getElementsByClassName(t)
			}, v = [], g = [], (i.qsa = X.test(p.querySelectorAll)) && (lt(function (t) {
				f.appendChild(t).innerHTML = "<a id='" + w + "'></a><select id='" + w + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + N + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || g.push("\\[" + N + "*(?:value|" + F + ")"), t.querySelectorAll("[id~=" + w + "-]").length || g.push("~="), t.querySelectorAll(":checked").length || g.push(":checked"), t.querySelectorAll("a#" + w + "+*").length || g.push(".#.+[+~]")
			}), lt(function (t) {
				t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
				var e = p.createElement("input");
				e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && g.push("name" + N + "*[*^$|!~]?="), 2 !== t.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), f.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), g.push(",.*:")
			})), (i.matchesSelector = X.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && lt(function (t) {
				i.disconnectedMatch = y.call(t, "*"), y.call(t, "[s!='']:x"), v.push("!=", $)
			}), g = g.length && new RegExp(g.join("|")), v = v.length && new RegExp(v.join("|")), e = X.test(f.compareDocumentPosition), b = e || X.test(f.contains) ? function (t, e) {
				var i = 9 === t.nodeType ? t.documentElement : t, n = e && e.parentNode;
				return t === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n)))
			} : function (t, e) {
				if (e) for (; e = e.parentNode;) if (e === t) return !0;
				return !1
			}, T = e ? function (t, e) {
				if (t === e) return h = !0, 0;
				var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
				return n || (1 & (n = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !i.sortDetached && e.compareDocumentPosition(t) === n ? t === p || t.ownerDocument === x && b(x, t) ? -1 : e === p || e.ownerDocument === x && b(x, e) ? 1 : u ? L(u, t) - L(u, e) : 0 : 4 & n ? -1 : 1)
			} : function (t, e) {
				if (t === e) return h = !0, 0;
				var i, n = 0, r = t.parentNode, o = e.parentNode, a = [t], s = [e];
				if (!r || !o) return t === p ? -1 : e === p ? 1 : r ? -1 : o ? 1 : u ? L(u, t) - L(u, e) : 0;
				if (r === o) return ut(t, e);
				for (i = t; i = i.parentNode;) a.unshift(i);
				for (i = e; i = i.parentNode;) s.unshift(i);
				for (; a[n] === s[n];) n++;
				return n ? ut(a[n], s[n]) : a[n] === x ? -1 : s[n] === x ? 1 : 0
			}, p) : p
		}, ot.matches = function (t, e) {
			return ot(t, null, null, e)
		}, ot.matchesSelector = function (t, e) {
			if ((t.ownerDocument || t) !== p && d(t), e = e.replace(W, "='$1']"), i.matchesSelector && m && !D[e + " "] && (!v || !v.test(e)) && (!g || !g.test(e))) try {
				var n = y.call(t, e);
				if (n || i.disconnectedMatch || t.document && 11 !== t.document.nodeType) return n
			} catch (t) {
			}
			return ot(e, p, null, [t]).length > 0
		}, ot.contains = function (t, e) {
			return (t.ownerDocument || t) !== p && d(t), b(t, e)
		}, ot.attr = function (t, e) {
			(t.ownerDocument || t) !== p && d(t);
			var r = n.attrHandle[e.toLowerCase()], o = r && M.call(n.attrHandle, e.toLowerCase()) ? r(t, e, !m) : void 0;
			return void 0 !== o ? o : i.attributes || !m ? t.getAttribute(e) : (o = t.getAttributeNode(e)) && o.specified ? o.value : null
		}, ot.escape = function (t) {
			return (t + "").replace(et, it)
		}, ot.error = function (t) {
			throw new Error("Syntax error, unrecognized expression: " + t)
		}, ot.uniqueSort = function (t) {
			var e, n = [], r = 0, o = 0;
			if (h = !i.detectDuplicates, u = !i.sortStable && t.slice(0), t.sort(T), h) {
				for (; e = t[o++];) e === t[o] && (r = n.push(o));
				for (; r--;) t.splice(n[r], 1)
			}
			return u = null, t
		}, r = ot.getText = function (t) {
			var e, i = "", n = 0, o = t.nodeType;
			if (o) {
				if (1 === o || 9 === o || 11 === o) {
					if ("string" == typeof t.textContent) return t.textContent;
					for (t = t.firstChild; t; t = t.nextSibling) i += r(t)
				} else if (3 === o || 4 === o) return t.nodeValue
			} else for (; e = t[n++];) i += r(e);
			return i
		}, (n = ot.selectors = {
			cacheLength: 50, createPseudo: st, match: q, attrHandle: {}, find: {}, relative: {">": {dir: "parentNode", first: !0}, " ": {dir: "parentNode"}, "+": {dir: "previousSibling", first: !0}, "~": {dir: "previousSibling"}}, preFilter: {
				ATTR: function (t) {
					return t[1] = t[1].replace(J, tt), t[3] = (t[3] || t[4] || t[5] || "").replace(J, tt), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
				}, CHILD: function (t) {
					return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || ot.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && ot.error(t[0]), t
				}, PSEUDO: function (t) {
					var e, i = !t[6] && t[2];
					return q.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : i && Y.test(i) && (e = a(i, !0)) && (e = i.indexOf(")", i.length - e) - i.length) && (t[0] = t[0].slice(0, e), t[2] = i.slice(0, e)), t.slice(0, 3))
				}
			}, filter: {
				TAG: function (t) {
					var e = t.replace(J, tt).toLowerCase();
					return "*" === t ? function () {
						return !0
					} : function (t) {
						return t.nodeName && t.nodeName.toLowerCase() === e
					}
				}, CLASS: function (t) {
					var e = S[t + " "];
					return e || (e = new RegExp("(^|" + N + ")" + t + "(" + N + "|$)")) && S(t, function (t) {
						return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
					})
				}, ATTR: function (t, e, i) {
					return function (n) {
						var r = ot.attr(n, t);
						return null == r ? "!=" === e : !e || (r += "", "=" === e ? r === i : "!=" === e ? r !== i : "^=" === e ? i && 0 === r.indexOf(i) : "*=" === e ? i && r.indexOf(i) > -1 : "$=" === e ? i && r.slice(-i.length) === i : "~=" === e ? (" " + r.replace(B, " ") + " ").indexOf(i) > -1 : "|=" === e && (r === i || r.slice(0, i.length + 1) === i + "-"))
					}
				}, CHILD: function (t, e, i, n, r) {
					var o = "nth" !== t.slice(0, 3), a = "last" !== t.slice(-4), s = "of-type" === e;
					return 1 === n && 0 === r ? function (t) {
						return !!t.parentNode
					} : function (e, i, l) {
						var c, u, h, d, p, f, m = o !== a ? "nextSibling" : "previousSibling", g = e.parentNode, v = s && e.nodeName.toLowerCase(), y = !l && !s, b = !1;
						if (g) {
							if (o) {
								for (; m;) {
									for (d = e; d = d[m];) if (s ? d.nodeName.toLowerCase() === v : 1 === d.nodeType) return !1;
									f = m = "only" === t && !f && "nextSibling"
								}
								return !0
							}
							if (f = [a ? g.firstChild : g.lastChild], a && y) {
								for (b = (p = (c = (u = (h = (d = g)[w] || (d[w] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[t] || [])[0] === k && c[1]) && c[2], d = p && g.childNodes[p]; d = ++p && d && d[m] || (b = p = 0) || f.pop();) if (1 === d.nodeType && ++b && d === e) {
									u[t] = [k, p, b];
									break
								}
							} else if (y && (b = p = (c = (u = (h = (d = e)[w] || (d[w] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[t] || [])[0] === k && c[1]), !1 === b) for (; (d = ++p && d && d[m] || (b = p = 0) || f.pop()) && ((s ? d.nodeName.toLowerCase() !== v : 1 !== d.nodeType) || !++b || (y && ((u = (h = d[w] || (d[w] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[t] = [k, b]), d !== e));) ;
							return (b -= r) === n || b % n == 0 && b / n >= 0
						}
					}
				}, PSEUDO: function (t, e) {
					var i, r = n.pseudos[t] || n.setFilters[t.toLowerCase()] || ot.error("unsupported pseudo: " + t);
					return r[w] ? r(e) : r.length > 1 ? (i = [t, t, "", e], n.setFilters.hasOwnProperty(t.toLowerCase()) ? st(function (t, i) {
						for (var n, o = r(t, e), a = o.length; a--;) t[n = L(t, o[a])] = !(i[n] = o[a])
					}) : function (t) {
						return r(t, 0, i)
					}) : r
				}
			}, pseudos: {
				not: st(function (t) {
					var e = [], i = [], n = s(t.replace(z, "$1"));
					return n[w] ? st(function (t, e, i, r) {
						for (var o, a = n(t, null, r, []), s = t.length; s--;) (o = a[s]) && (t[s] = !(e[s] = o))
					}) : function (t, r, o) {
						return e[0] = t, n(e, null, o, i), e[0] = null, !i.pop()
					}
				}), has: st(function (t) {
					return function (e) {
						return ot(t, e).length > 0
					}
				}), contains: st(function (t) {
					return t = t.replace(J, tt), function (e) {
						return (e.textContent || e.innerText || r(e)).indexOf(t) > -1
					}
				}), lang: st(function (t) {
					return V.test(t || "") || ot.error("unsupported lang: " + t), t = t.replace(J, tt).toLowerCase(), function (e) {
						var i;
						do {
							if (i = m ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (i = i.toLowerCase()) === t || 0 === i.indexOf(t + "-")
						} while ((e = e.parentNode) && 1 === e.nodeType);
						return !1
					}
				}), target: function (e) {
					var i = t.location && t.location.hash;
					return i && i.slice(1) === e.id
				}, root: function (t) {
					return t === f
				}, focus: function (t) {
					return t === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
				}, enabled: pt(!1), disabled: pt(!0), checked: function (t) {
					var e = t.nodeName.toLowerCase();
					return "input" === e && !!t.checked || "option" === e && !!t.selected
				}, selected: function (t) {
					return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
				}, empty: function (t) {
					for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
					return !0
				}, parent: function (t) {
					return !n.pseudos.empty(t)
				}, header: function (t) {
					return K.test(t.nodeName)
				}, input: function (t) {
					return G.test(t.nodeName)
				}, button: function (t) {
					var e = t.nodeName.toLowerCase();
					return "input" === e && "button" === t.type || "button" === e
				}, text: function (t) {
					var e;
					return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
				}, first: ft(function () {
					return [0]
				}), last: ft(function (t, e) {
					return [e - 1]
				}), eq: ft(function (t, e, i) {
					return [i < 0 ? i + e : i]
				}), even: ft(function (t, e) {
					for (var i = 0; i < e; i += 2) t.push(i);
					return t
				}), odd: ft(function (t, e) {
					for (var i = 1; i < e; i += 2) t.push(i);
					return t
				}), lt: ft(function (t, e, i) {
					for (var n = i < 0 ? i + e : i; --n >= 0;) t.push(n);
					return t
				}), gt: ft(function (t, e, i) {
					for (var n = i < 0 ? i + e : i; ++n < e;) t.push(n);
					return t
				})
			}
		}).pseudos.nth = n.pseudos.eq, {radio: !0, checkbox: !0, file: !0, password: !0, image: !0}) n.pseudos[e] = ht(e);
		for (e in{submit: !0, reset: !0}) n.pseudos[e] = dt(e);

		function gt() {
		}

		function vt(t) {
			for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
			return n
		}

		function yt(t, e, i) {
			var n = e.dir, r = e.next, o = r || n, a = i && "parentNode" === o, s = _++;
			return e.first ? function (e, i, r) {
				for (; e = e[n];) if (1 === e.nodeType || a) return t(e, i, r);
				return !1
			} : function (e, i, l) {
				var c, u, h, d = [k, s];
				if (l) {
					for (; e = e[n];) if ((1 === e.nodeType || a) && t(e, i, l)) return !0
				} else for (; e = e[n];) if (1 === e.nodeType || a) if (u = (h = e[w] || (e[w] = {}))[e.uniqueID] || (h[e.uniqueID] = {}), r && r === e.nodeName.toLowerCase()) e = e[n] || e; else {
					if ((c = u[o]) && c[0] === k && c[1] === s) return d[2] = c[2];
					if (u[o] = d, d[2] = t(e, i, l)) return !0
				}
				return !1
			}
		}

		function bt(t) {
			return t.length > 1 ? function (e, i, n) {
				for (var r = t.length; r--;) if (!t[r](e, i, n)) return !1;
				return !0
			} : t[0]
		}

		function wt(t, e, i, n, r) {
			for (var o, a = [], s = 0, l = t.length, c = null != e; s < l; s++) (o = t[s]) && (i && !i(o, n, r) || (a.push(o), c && e.push(s)));
			return a
		}

		function xt(t, e, i, n, r, o) {
			return n && !n[w] && (n = xt(n)), r && !r[w] && (r = xt(r, o)), st(function (o, a, s, l) {
				var c, u, h, d = [], p = [], f = a.length, m = o || function (t, e, i) {
					for (var n = 0, r = e.length; n < r; n++) ot(t, e[n], i);
					return i
				}(e || "*", s.nodeType ? [s] : s, []), g = !t || !o && e ? m : wt(m, d, t, s, l), v = i ? r || (o ? t : f || n) ? [] : a : g;
				if (i && i(g, v, s, l), n) for (c = wt(v, p), n(c, [], s, l), u = c.length; u--;) (h = c[u]) && (v[p[u]] = !(g[p[u]] = h));
				if (o) {
					if (r || t) {
						if (r) {
							for (c = [], u = v.length; u--;) (h = v[u]) && c.push(g[u] = h);
							r(null, v = [], c, l)
						}
						for (u = v.length; u--;) (h = v[u]) && (c = r ? L(o, h) : d[u]) > -1 && (o[c] = !(a[c] = h))
					}
				} else v = wt(v === a ? v.splice(f, v.length) : v), r ? r(null, a, v, l) : I.apply(a, v)
			})
		}

		function kt(t) {
			for (var e, i, r, o = t.length, a = n.relative[t[0].type], s = a || n.relative[" "], l = a ? 1 : 0, u = yt(function (t) {
				return t === e
			}, s, !0), h = yt(function (t) {
				return L(e, t) > -1
			}, s, !0), d = [function (t, i, n) {
				var r = !a && (n || i !== c) || ((e = i).nodeType ? u(t, i, n) : h(t, i, n));
				return e = null, r
			}]; l < o; l++) if (i = n.relative[t[l].type]) d = [yt(bt(d), i)]; else {
				if ((i = n.filter[t[l].type].apply(null, t[l].matches))[w]) {
					for (r = ++l; r < o && !n.relative[t[r].type]; r++) ;
					return xt(l > 1 && bt(d), l > 1 && vt(t.slice(0, l - 1).concat({value: " " === t[l - 2].type ? "*" : ""})).replace(z, "$1"), i, l < r && kt(t.slice(l, r)), r < o && kt(t = t.slice(r)), r < o && vt(t))
				}
				d.push(i)
			}
			return bt(d)
		}

		return gt.prototype = n.filters = n.pseudos, n.setFilters = new gt, a = ot.tokenize = function (t, e) {
			var i, r, o, a, s, l, c, u = C[t + " "];
			if (u) return e ? 0 : u.slice(0);
			for (s = t, l = [], c = n.preFilter; s;) {
				for (a in i && !(r = j.exec(s)) || (r && (s = s.slice(r[0].length) || s), l.push(o = [])), i = !1, (r = U.exec(s)) && (i = r.shift(), o.push({
					value: i,
					type: r[0].replace(z, " ")
				}), s = s.slice(i.length)), n.filter) !(r = q[a].exec(s)) || c[a] && !(r = c[a](r)) || (i = r.shift(), o.push({value: i, type: a, matches: r}), s = s.slice(i.length));
				if (!i) break
			}
			return e ? s.length : s ? ot.error(t) : C(t, l).slice(0)
		}, s = ot.compile = function (t, e) {
			var i, r = [], o = [], s = D[t + " "];
			if (!s) {
				for (e || (e = a(t)), i = e.length; i--;) (s = kt(e[i]))[w] ? r.push(s) : o.push(s);
				(s = D(t, function (t, e) {
					var i = e.length > 0, r = t.length > 0, o = function (o, a, s, l, u) {
						var h, f, g, v = 0, y = "0", b = o && [], w = [], x = c, _ = o || r && n.find.TAG("*", u), S = k += null == x ? 1 : Math.random() || .1, C = _.length;
						for (u && (c = a === p || a || u); y !== C && null != (h = _[y]); y++) {
							if (r && h) {
								for (f = 0, a || h.ownerDocument === p || (d(h), s = !m); g = t[f++];) if (g(h, a || p, s)) {
									l.push(h);
									break
								}
								u && (k = S)
							}
							i && ((h = !g && h) && v--, o && b.push(h))
						}
						if (v += y, i && y !== v) {
							for (f = 0; g = e[f++];) g(b, w, a, s);
							if (o) {
								if (v > 0) for (; y--;) b[y] || w[y] || (w[y] = A.call(l));
								w = wt(w)
							}
							I.apply(l, w), u && !o && w.length > 0 && v + e.length > 1 && ot.uniqueSort(l)
						}
						return u && (k = S, c = x), b
					};
					return i ? st(o) : o
				}(o, r))).selector = t
			}
			return s
		}, l = ot.select = function (t, e, i, r) {
			var o, l, c, u, h, d = "function" == typeof t && t, p = !r && a(t = d.selector || t);
			if (i = i || [], 1 === p.length) {
				if ((l = p[0] = p[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && 9 === e.nodeType && m && n.relative[l[1].type]) {
					if (!(e = (n.find.ID(c.matches[0].replace(J, tt), e) || [])[0])) return i;
					d && (e = e.parentNode), t = t.slice(l.shift().value.length)
				}
				for (o = q.needsContext.test(t) ? 0 : l.length; o-- && (c = l[o], !n.relative[u = c.type]);) if ((h = n.find[u]) && (r = h(c.matches[0].replace(J, tt), Q.test(l[0].type) && mt(e.parentNode) || e))) {
					if (l.splice(o, 1), !(t = r.length && vt(l))) return I.apply(i, r), i;
					break
				}
			}
			return (d || s(t, p))(r, e, !m, i, !e || Q.test(t) && mt(e.parentNode) || e), i
		}, i.sortStable = w.split("").sort(T).join("") === w, i.detectDuplicates = !!h, d(), i.sortDetached = lt(function (t) {
			return 1 & t.compareDocumentPosition(p.createElement("fieldset"))
		}), lt(function (t) {
			return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
		}) || ct("type|href|height|width", function (t, e, i) {
			if (!i) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
		}), i.attributes && lt(function (t) {
			return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
		}) || ct("value", function (t, e, i) {
			if (!i && "input" === t.nodeName.toLowerCase()) return t.defaultValue
		}), lt(function (t) {
			return null == t.getAttribute("disabled")
		}) || ct(F, function (t, e, i) {
			var n;
			if (!i) return !0 === t[e] ? e.toLowerCase() : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
		}), ot
	}(t);
	w.find = _, w.expr = _.selectors, w.expr[":"] = w.expr.pseudos, w.uniqueSort = w.unique = _.uniqueSort, w.text = _.getText, w.isXMLDoc = _.isXML, w.contains = _.contains, w.escapeSelector = _.escape;
	var S = function (t, e, i) {
		for (var n = [], r = void 0 !== i; (t = t[e]) && 9 !== t.nodeType;) if (1 === t.nodeType) {
			if (r && w(t).is(i)) break;
			n.push(t)
		}
		return n
	}, C = function (t, e) {
		for (var i = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && i.push(t);
		return i
	}, D = w.expr.match.needsContext;

	function T(t, e) {
		return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
	}

	var M = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

	function E(t, e, i) {
		return m(e) ? w.grep(t, function (t, n) {
			return !!e.call(t, n, t) !== i
		}) : e.nodeType ? w.grep(t, function (t) {
			return t === e !== i
		}) : "string" != typeof e ? w.grep(t, function (t) {
			return l.call(e, t) > -1 !== i
		}) : w.filter(e, t, i)
	}

	w.filter = function (t, e, i) {
		var n = e[0];
		return i && (t = ":not(" + t + ")"), 1 === e.length && 1 === n.nodeType ? w.find.matchesSelector(n, t) ? [n] : [] : w.find.matches(t, w.grep(e, function (t) {
			return 1 === t.nodeType
		}))
	}, w.fn.extend({
		find: function (t) {
			var e, i, n = this.length, r = this;
			if ("string" != typeof t) return this.pushStack(w(t).filter(function () {
				for (e = 0; e < n; e++) if (w.contains(r[e], this)) return !0
			}));
			for (i = this.pushStack([]), e = 0; e < n; e++) w.find(t, r[e], i);
			return n > 1 ? w.uniqueSort(i) : i
		}, filter: function (t) {
			return this.pushStack(E(this, t || [], !1))
		}, not: function (t) {
			return this.pushStack(E(this, t || [], !0))
		}, is: function (t) {
			return !!E(this, "string" == typeof t && D.test(t) ? w(t) : t || [], !1).length
		}
	});
	var A, P = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
	(w.fn.init = function (t, e, i) {
		var r, o;
		if (!t) return this;
		if (i = i || A, "string" == typeof t) {
			if (!(r = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : P.exec(t)) || !r[1] && e) return !e || e.jquery ? (e || i).find(t) : this.constructor(e).find(t);
			if (r[1]) {
				if (e = e instanceof w ? e[0] : e, w.merge(this, w.parseHTML(r[1], e && e.nodeType ? e.ownerDocument || e : n, !0)), M.test(r[1]) && w.isPlainObject(e)) for (r in e) m(this[r]) ? this[r](e[r]) : this.attr(r, e[r]);
				return this
			}
			return (o = n.getElementById(r[2])) && (this[0] = o, this.length = 1), this
		}
		return t.nodeType ? (this[0] = t, this.length = 1, this) : m(t) ? void 0 !== i.ready ? i.ready(t) : t(w) : w.makeArray(t, this)
	}).prototype = w.fn, A = w(n);
	var I = /^(?:parents|prev(?:Until|All))/, O = {children: !0, contents: !0, next: !0, prev: !0};

	function L(t, e) {
		for (; (t = t[e]) && 1 !== t.nodeType;) ;
		return t
	}

	w.fn.extend({
		has: function (t) {
			var e = w(t, this), i = e.length;
			return this.filter(function () {
				for (var t = 0; t < i; t++) if (w.contains(this, e[t])) return !0
			})
		}, closest: function (t, e) {
			var i, n = 0, r = this.length, o = [], a = "string" != typeof t && w(t);
			if (!D.test(t)) for (; n < r; n++) for (i = this[n]; i && i !== e; i = i.parentNode) if (i.nodeType < 11 && (a ? a.index(i) > -1 : 1 === i.nodeType && w.find.matchesSelector(i, t))) {
				o.push(i);
				break
			}
			return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o)
		}, index: function (t) {
			return t ? "string" == typeof t ? l.call(w(t), this[0]) : l.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
		}, add: function (t, e) {
			return this.pushStack(w.uniqueSort(w.merge(this.get(), w(t, e))))
		}, addBack: function (t) {
			return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
		}
	}), w.each({
		parent: function (t) {
			var e = t.parentNode;
			return e && 11 !== e.nodeType ? e : null
		}, parents: function (t) {
			return S(t, "parentNode")
		}, parentsUntil: function (t, e, i) {
			return S(t, "parentNode", i)
		}, next: function (t) {
			return L(t, "nextSibling")
		}, prev: function (t) {
			return L(t, "previousSibling")
		}, nextAll: function (t) {
			return S(t, "nextSibling")
		}, prevAll: function (t) {
			return S(t, "previousSibling")
		}, nextUntil: function (t, e, i) {
			return S(t, "nextSibling", i)
		}, prevUntil: function (t, e, i) {
			return S(t, "previousSibling", i)
		}, siblings: function (t) {
			return C((t.parentNode || {}).firstChild, t)
		}, children: function (t) {
			return C(t.firstChild)
		}, contents: function (t) {
			return T(t, "iframe") ? t.contentDocument : (T(t, "template") && (t = t.content || t), w.merge([], t.childNodes))
		}
	}, function (t, e) {
		w.fn[t] = function (i, n) {
			var r = w.map(this, e, i);
			return "Until" !== t.slice(-5) && (n = i), n && "string" == typeof n && (r = w.filter(n, r)), this.length > 1 && (O[t] || w.uniqueSort(r), I.test(t) && r.reverse()), this.pushStack(r)
		}
	});
	var F = /[^\x20\t\r\n\f]+/g;

	function N(t) {
		return t
	}

	function R(t) {
		throw t
	}

	function H(t, e, i, n) {
		var r;
		try {
			t && m(r = t.promise) ? r.call(t).done(e).fail(i) : t && m(r = t.then) ? r.call(t, e, i) : e.apply(void 0, [t].slice(n))
		} catch (t) {
			i.apply(void 0, [t])
		}
	}

	w.Callbacks = function (t) {
		t = "string" == typeof t ? function (t) {
			var e = {};
			return w.each(t.match(F) || [], function (t, i) {
				e[i] = !0
			}), e
		}(t) : w.extend({}, t);
		var e, i, n, r, o = [], a = [], s = -1, l = function () {
			for (r = r || t.once, n = e = !0; a.length; s = -1) for (i = a.shift(); ++s < o.length;) !1 === o[s].apply(i[0], i[1]) && t.stopOnFalse && (s = o.length, i = !1);
			t.memory || (i = !1), e = !1, r && (o = i ? [] : "")
		}, c = {
			add: function () {
				return o && (i && !e && (s = o.length - 1, a.push(i)), function e(i) {
					w.each(i, function (i, n) {
						m(n) ? t.unique && c.has(n) || o.push(n) : n && n.length && "string" !== b(n) && e(n)
					})
				}(arguments), i && !e && l()), this
			}, remove: function () {
				return w.each(arguments, function (t, e) {
					for (var i; (i = w.inArray(e, o, i)) > -1;) o.splice(i, 1), i <= s && s--
				}), this
			}, has: function (t) {
				return t ? w.inArray(t, o) > -1 : o.length > 0
			}, empty: function () {
				return o && (o = []), this
			}, disable: function () {
				return r = a = [], o = i = "", this
			}, disabled: function () {
				return !o
			}, lock: function () {
				return r = a = [], i || e || (o = i = ""), this
			}, locked: function () {
				return !!r
			}, fireWith: function (t, i) {
				return r || (i = [t, (i = i || []).slice ? i.slice() : i], a.push(i), e || l()), this
			}, fire: function () {
				return c.fireWith(this, arguments), this
			}, fired: function () {
				return !!n
			}
		};
		return c
	}, w.extend({
		Deferred: function (e) {
			var i = [["notify", "progress", w.Callbacks("memory"), w.Callbacks("memory"), 2], ["resolve", "done", w.Callbacks("once memory"), w.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", w.Callbacks("once memory"), w.Callbacks("once memory"), 1, "rejected"]], n = "pending", r = {
				state: function () {
					return n
				}, always: function () {
					return o.done(arguments).fail(arguments), this
				}, catch: function (t) {
					return r.then(null, t)
				}, pipe: function () {
					var t = arguments;
					return w.Deferred(function (e) {
						w.each(i, function (i, n) {
							var r = m(t[n[4]]) && t[n[4]];
							o[n[1]](function () {
								var t = r && r.apply(this, arguments);
								t && m(t.promise) ? t.promise().progress(e.notify).done(e.resolve).fail(e.reject) : e[n[0] + "With"](this, r ? [t] : arguments)
							})
						}), t = null
					}).promise()
				}, then: function (e, n, r) {
					var o = 0;

					function a(e, i, n, r) {
						return function () {
							var s = this, l = arguments, c = function () {
								var t, c;
								if (!(e < o)) {
									if ((t = n.apply(s, l)) === i.promise()) throw new TypeError("Thenable self-resolution");
									c = t && ("object" == typeof t || "function" == typeof t) && t.then, m(c) ? r ? c.call(t, a(o, i, N, r), a(o, i, R, r)) : (o++, c.call(t, a(o, i, N, r), a(o, i, R, r), a(o, i, N, i.notifyWith))) : (n !== N && (s = void 0, l = [t]), (r || i.resolveWith)(s, l))
								}
							}, u = r ? c : function () {
								try {
									c()
								} catch (t) {
									w.Deferred.exceptionHook && w.Deferred.exceptionHook(t, u.stackTrace), e + 1 >= o && (n !== R && (s = void 0, l = [t]), i.rejectWith(s, l))
								}
							};
							e ? u() : (w.Deferred.getStackHook && (u.stackTrace = w.Deferred.getStackHook()), t.setTimeout(u))
						}
					}

					return w.Deferred(function (t) {
						i[0][3].add(a(0, t, m(r) ? r : N, t.notifyWith)), i[1][3].add(a(0, t, m(e) ? e : N)), i[2][3].add(a(0, t, m(n) ? n : R))
					}).promise()
				}, promise: function (t) {
					return null != t ? w.extend(t, r) : r
				}
			}, o = {};
			return w.each(i, function (t, e) {
				var a = e[2], s = e[5];
				r[e[1]] = a.add, s && a.add(function () {
					n = s
				}, i[3 - t][2].disable, i[3 - t][3].disable, i[0][2].lock, i[0][3].lock), a.add(e[3].fire), o[e[0]] = function () {
					return o[e[0] + "With"](this === o ? void 0 : this, arguments), this
				}, o[e[0] + "With"] = a.fireWith
			}), r.promise(o), e && e.call(o, o), o
		}, when: function (t) {
			var e = arguments.length, i = e, n = Array(i), r = o.call(arguments), a = w.Deferred(), s = function (t) {
				return function (i) {
					n[t] = this, r[t] = arguments.length > 1 ? o.call(arguments) : i, --e || a.resolveWith(n, r)
				}
			};
			if (e <= 1 && (H(t, a.done(s(i)).resolve, a.reject, !e), "pending" === a.state() || m(r[i] && r[i].then))) return a.then();
			for (; i--;) H(r[i], s(i), a.reject);
			return a.promise()
		}
	});
	var $ = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	w.Deferred.exceptionHook = function (e, i) {
		t.console && t.console.warn && e && $.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, i)
	}, w.readyException = function (e) {
		t.setTimeout(function () {
			throw e
		})
	};
	var B = w.Deferred();

	function z() {
		n.removeEventListener("DOMContentLoaded", z), t.removeEventListener("load", z), w.ready()
	}

	w.fn.ready = function (t) {
		return B.then(t).catch(function (t) {
			w.readyException(t)
		}), this
	}, w.extend({
		isReady: !1, readyWait: 1, ready: function (t) {
			(!0 === t ? --w.readyWait : w.isReady) || (w.isReady = !0, !0 !== t && --w.readyWait > 0 || B.resolveWith(n, [w]))
		}
	}), w.ready.then = B.then, "complete" === n.readyState || "loading" !== n.readyState && !n.documentElement.doScroll ? t.setTimeout(w.ready) : (n.addEventListener("DOMContentLoaded", z), t.addEventListener("load", z));
	var j = function (t, e, i, n, r, o, a) {
		var s = 0, l = t.length, c = null == i;
		if ("object" === b(i)) for (s in r = !0, i) j(t, e, s, i[s], !0, o, a); else if (void 0 !== n && (r = !0, m(n) || (a = !0), c && (a ? (e.call(t, n), e = null) : (c = e, e = function (t, e, i) {
			return c.call(w(t), i)
		})), e)) for (; s < l; s++) e(t[s], i, a ? n : n.call(t[s], s, e(t[s], i)));
		return r ? t : c ? e.call(t) : l ? e(t[0], i) : o
	}, U = /^-ms-/, W = /-([a-z])/g;

	function Y(t, e) {
		return e.toUpperCase()
	}

	function V(t) {
		return t.replace(U, "ms-").replace(W, Y)
	}

	var q = function (t) {
		return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
	};

	function G() {
		this.expando = w.expando + G.uid++
	}

	G.uid = 1, G.prototype = {
		cache: function (t) {
			var e = t[this.expando];
			return e || (e = {}, q(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {value: e, configurable: !0}))), e
		}, set: function (t, e, i) {
			var n, r = this.cache(t);
			if ("string" == typeof e) r[V(e)] = i; else for (n in e) r[V(n)] = e[n];
			return r
		}, get: function (t, e) {
			return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][V(e)]
		}, access: function (t, e, i) {
			return void 0 === e || e && "string" == typeof e && void 0 === i ? this.get(t, e) : (this.set(t, e, i), void 0 !== i ? i : e)
		}, remove: function (t, e) {
			var i, n = t[this.expando];
			if (void 0 !== n) {
				if (void 0 !== e) {
					i = (e = Array.isArray(e) ? e.map(V) : (e = V(e)) in n ? [e] : e.match(F) || []).length;
					for (; i--;) delete n[e[i]]
				}
				(void 0 === e || w.isEmptyObject(n)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
			}
		}, hasData: function (t) {
			var e = t[this.expando];
			return void 0 !== e && !w.isEmptyObject(e)
		}
	};
	var K = new G, X = new G, Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, Q = /[A-Z]/g;

	function J(t, e, i) {
		var n;
		if (void 0 === i && 1 === t.nodeType) if (n = "data-" + e.replace(Q, "-$&").toLowerCase(), "string" == typeof (i = t.getAttribute(n))) {
			try {
				i = function (t) {
					return "true" === t || "false" !== t && ("null" === t ? null : t === +t + "" ? +t : Z.test(t) ? JSON.parse(t) : t)
				}(i)
			} catch (t) {
			}
			X.set(t, e, i)
		} else i = void 0;
		return i
	}

	w.extend({
		hasData: function (t) {
			return X.hasData(t) || K.hasData(t)
		}, data: function (t, e, i) {
			return X.access(t, e, i)
		}, removeData: function (t, e) {
			X.remove(t, e)
		}, _data: function (t, e, i) {
			return K.access(t, e, i)
		}, _removeData: function (t, e) {
			K.remove(t, e)
		}
	}), w.fn.extend({
		data: function (t, e) {
			var i, n, r, o = this[0], a = o && o.attributes;
			if (void 0 === t) {
				if (this.length && (r = X.get(o), 1 === o.nodeType && !K.get(o, "hasDataAttrs"))) {
					for (i = a.length; i--;) a[i] && 0 === (n = a[i].name).indexOf("data-") && (n = V(n.slice(5)), J(o, n, r[n]));
					K.set(o, "hasDataAttrs", !0)
				}
				return r
			}
			return "object" == typeof t ? this.each(function () {
				X.set(this, t)
			}) : j(this, function (e) {
				var i;
				if (o && void 0 === e) return void 0 !== (i = X.get(o, t)) ? i : void 0 !== (i = J(o, t)) ? i : void 0;
				this.each(function () {
					X.set(this, t, e)
				})
			}, null, e, arguments.length > 1, null, !0)
		}, removeData: function (t) {
			return this.each(function () {
				X.remove(this, t)
			})
		}
	}), w.extend({
		queue: function (t, e, i) {
			var n;
			if (t) return e = (e || "fx") + "queue", n = K.get(t, e), i && (!n || Array.isArray(i) ? n = K.access(t, e, w.makeArray(i)) : n.push(i)), n || []
		}, dequeue: function (t, e) {
			e = e || "fx";
			var i = w.queue(t, e), n = i.length, r = i.shift(), o = w._queueHooks(t, e);
			"inprogress" === r && (r = i.shift(), n--), r && ("fx" === e && i.unshift("inprogress"), delete o.stop, r.call(t, function () {
				w.dequeue(t, e)
			}, o)), !n && o && o.empty.fire()
		}, _queueHooks: function (t, e) {
			var i = e + "queueHooks";
			return K.get(t, i) || K.access(t, i, {
				empty: w.Callbacks("once memory").add(function () {
					K.remove(t, [e + "queue", i])
				})
			})
		}
	}), w.fn.extend({
		queue: function (t, e) {
			var i = 2;
			return "string" != typeof t && (e = t, t = "fx", i--), arguments.length < i ? w.queue(this[0], t) : void 0 === e ? this : this.each(function () {
				var i = w.queue(this, t, e);
				w._queueHooks(this, t), "fx" === t && "inprogress" !== i[0] && w.dequeue(this, t)
			})
		}, dequeue: function (t) {
			return this.each(function () {
				w.dequeue(this, t)
			})
		}, clearQueue: function (t) {
			return this.queue(t || "fx", [])
		}, promise: function (t, e) {
			var i, n = 1, r = w.Deferred(), o = this, a = this.length, s = function () {
				--n || r.resolveWith(o, [o])
			};
			for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; a--;) (i = K.get(o[a], t + "queueHooks")) && i.empty && (n++, i.empty.add(s));
			return s(), r.promise(e)
		}
	});
	var tt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, et = new RegExp("^(?:([+-])=|)(" + tt + ")([a-z%]*)$", "i"), it = ["Top", "Right", "Bottom", "Left"], nt = function (t, e) {
		return "none" === (t = e || t).style.display || "" === t.style.display && w.contains(t.ownerDocument, t) && "none" === w.css(t, "display")
	}, rt = function (t, e, i, n) {
		var r, o, a = {};
		for (o in e) a[o] = t.style[o], t.style[o] = e[o];
		for (o in r = i.apply(t, n || []), e) t.style[o] = a[o];
		return r
	};

	function ot(t, e, i, n) {
		var r, o, a = 20, s = n ? function () {
			return n.cur()
		} : function () {
			return w.css(t, e, "")
		}, l = s(), c = i && i[3] || (w.cssNumber[e] ? "" : "px"), u = (w.cssNumber[e] || "px" !== c && +l) && et.exec(w.css(t, e));
		if (u && u[3] !== c) {
			for (l /= 2, c = c || u[3], u = +l || 1; a--;) w.style(t, e, u + c), (1 - o) * (1 - (o = s() / l || .5)) <= 0 && (a = 0), u /= o;
			u *= 2, w.style(t, e, u + c), i = i || []
		}
		return i && (u = +u || +l || 0, r = i[1] ? u + (i[1] + 1) * i[2] : +i[2], n && (n.unit = c, n.start = u, n.end = r)), r
	}

	var at = {};

	function st(t) {
		var e, i = t.ownerDocument, n = t.nodeName, r = at[n];
		return r || (e = i.body.appendChild(i.createElement(n)), r = w.css(e, "display"), e.parentNode.removeChild(e), "none" === r && (r = "block"), at[n] = r, r)
	}

	function lt(t, e) {
		for (var i, n, r = [], o = 0, a = t.length; o < a; o++) (n = t[o]).style && (i = n.style.display, e ? ("none" === i && (r[o] = K.get(n, "display") || null, r[o] || (n.style.display = "")), "" === n.style.display && nt(n) && (r[o] = st(n))) : "none" !== i && (r[o] = "none", K.set(n, "display", i)));
		for (o = 0; o < a; o++) null != r[o] && (t[o].style.display = r[o]);
		return t
	}

	w.fn.extend({
		show: function () {
			return lt(this, !0)
		}, hide: function () {
			return lt(this)
		}, toggle: function (t) {
			return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function () {
				nt(this) ? w(this).show() : w(this).hide()
			})
		}
	});
	var ct = /^(?:checkbox|radio)$/i, ut = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i, ht = /^$|^module$|\/(?:java|ecma)script/i,
		dt = {option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""]};

	function pt(t, e) {
		var i;
		return i = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [], void 0 === e || e && T(t, e) ? w.merge([t], i) : i
	}

	function ft(t, e) {
		for (var i = 0, n = t.length; i < n; i++) K.set(t[i], "globalEval", !e || K.get(e[i], "globalEval"))
	}

	dt.optgroup = dt.option, dt.tbody = dt.tfoot = dt.colgroup = dt.caption = dt.thead, dt.th = dt.td;
	var mt, gt, vt = /<|&#?\w+;/;

	function yt(t, e, i, n, r) {
		for (var o, a, s, l, c, u, h = e.createDocumentFragment(), d = [], p = 0, f = t.length; p < f; p++) if ((o = t[p]) || 0 === o) if ("object" === b(o)) w.merge(d, o.nodeType ? [o] : o); else if (vt.test(o)) {
			for (a = a || h.appendChild(e.createElement("div")), s = (ut.exec(o) || ["", ""])[1].toLowerCase(), l = dt[s] || dt._default, a.innerHTML = l[1] + w.htmlPrefilter(o) + l[2], u = l[0]; u--;) a = a.lastChild;
			w.merge(d, a.childNodes), (a = h.firstChild).textContent = ""
		} else d.push(e.createTextNode(o));
		for (h.textContent = "", p = 0; o = d[p++];) if (n && w.inArray(o, n) > -1) r && r.push(o); else if (c = w.contains(o.ownerDocument, o), a = pt(h.appendChild(o), "script"), c && ft(a), i) for (u = 0; o = a[u++];) ht.test(o.type || "") && i.push(o);
		return h
	}

	mt = n.createDocumentFragment().appendChild(n.createElement("div")), (gt = n.createElement("input")).setAttribute("type", "radio"), gt.setAttribute("checked", "checked"), gt.setAttribute("name", "t"), mt.appendChild(gt), f.checkClone = mt.cloneNode(!0).cloneNode(!0).lastChild.checked, mt.innerHTML = "<textarea>x</textarea>", f.noCloneChecked = !!mt.cloneNode(!0).lastChild.defaultValue;
	var bt = n.documentElement, wt = /^key/, xt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, kt = /^([^.]*)(?:\.(.+)|)/;

	function _t() {
		return !0
	}

	function St() {
		return !1
	}

	function Ct() {
		try {
			return n.activeElement
		} catch (t) {
		}
	}

	function Dt(t, e, i, n, r, o) {
		var a, s;
		if ("object" == typeof e) {
			for (s in"string" != typeof i && (n = n || i, i = void 0), e) Dt(t, s, i, n, e[s], o);
			return t
		}
		if (null == n && null == r ? (r = i, n = i = void 0) : null == r && ("string" == typeof i ? (r = n, n = void 0) : (r = n, n = i, i = void 0)), !1 === r) r = St; else if (!r) return t;
		return 1 === o && (a = r, (r = function (t) {
			return w().off(t), a.apply(this, arguments)
		}).guid = a.guid || (a.guid = w.guid++)), t.each(function () {
			w.event.add(this, e, r, n, i)
		})
	}

	w.event = {
		global: {}, add: function (t, e, i, n, r) {
			var o, a, s, l, c, u, h, d, p, f, m, g = K.get(t);
			if (g) for (i.handler && (i = (o = i).handler, r = o.selector), r && w.find.matchesSelector(bt, r), i.guid || (i.guid = w.guid++), (l = g.events) || (l = g.events = {}), (a = g.handle) || (a = g.handle = function (e) {
				return void 0 !== w && w.event.triggered !== e.type ? w.event.dispatch.apply(t, arguments) : void 0
			}), c = (e = (e || "").match(F) || [""]).length; c--;) p = m = (s = kt.exec(e[c]) || [])[1], f = (s[2] || "").split(".").sort(), p && (h = w.event.special[p] || {}, p = (r ? h.delegateType : h.bindType) || p, h = w.event.special[p] || {}, u = w.extend({
				type: p,
				origType: m,
				data: n,
				handler: i,
				guid: i.guid,
				selector: r,
				needsContext: r && w.expr.match.needsContext.test(r),
				namespace: f.join(".")
			}, o), (d = l[p]) || ((d = l[p] = []).delegateCount = 0, h.setup && !1 !== h.setup.call(t, n, f, a) || t.addEventListener && t.addEventListener(p, a)), h.add && (h.add.call(t, u), u.handler.guid || (u.handler.guid = i.guid)), r ? d.splice(d.delegateCount++, 0, u) : d.push(u), w.event.global[p] = !0)
		}, remove: function (t, e, i, n, r) {
			var o, a, s, l, c, u, h, d, p, f, m, g = K.hasData(t) && K.get(t);
			if (g && (l = g.events)) {
				for (c = (e = (e || "").match(F) || [""]).length; c--;) if (p = m = (s = kt.exec(e[c]) || [])[1], f = (s[2] || "").split(".").sort(), p) {
					for (h = w.event.special[p] || {}, d = l[p = (n ? h.delegateType : h.bindType) || p] || [], s = s[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = d.length; o--;) u = d[o], !r && m !== u.origType || i && i.guid !== u.guid || s && !s.test(u.namespace) || n && n !== u.selector && ("**" !== n || !u.selector) || (d.splice(o, 1), u.selector && d.delegateCount--, h.remove && h.remove.call(t, u));
					a && !d.length && (h.teardown && !1 !== h.teardown.call(t, f, g.handle) || w.removeEvent(t, p, g.handle), delete l[p])
				} else for (p in l) w.event.remove(t, p + e[c], i, n, !0);
				w.isEmptyObject(l) && K.remove(t, "handle events")
			}
		}, dispatch: function (t) {
			var e, i, n, r, o, a, s = w.event.fix(t), l = new Array(arguments.length), c = (K.get(this, "events") || {})[s.type] || [], u = w.event.special[s.type] || {};
			for (l[0] = s, e = 1; e < arguments.length; e++) l[e] = arguments[e];
			if (s.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, s)) {
				for (a = w.event.handlers.call(this, s, c), e = 0; (r = a[e++]) && !s.isPropagationStopped();) for (s.currentTarget = r.elem, i = 0; (o = r.handlers[i++]) && !s.isImmediatePropagationStopped();) s.rnamespace && !s.rnamespace.test(o.namespace) || (s.handleObj = o, s.data = o.data, void 0 !== (n = ((w.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, l)) && !1 === (s.result = n) && (s.preventDefault(), s.stopPropagation()));
				return u.postDispatch && u.postDispatch.call(this, s), s.result
			}
		}, handlers: function (t, e) {
			var i, n, r, o, a, s = [], l = e.delegateCount, c = t.target;
			if (l && c.nodeType && !("click" === t.type && t.button >= 1)) for (; c !== this; c = c.parentNode || this) if (1 === c.nodeType && ("click" !== t.type || !0 !== c.disabled)) {
				for (o = [], a = {}, i = 0; i < l; i++) void 0 === a[r = (n = e[i]).selector + " "] && (a[r] = n.needsContext ? w(r, this).index(c) > -1 : w.find(r, this, null, [c]).length), a[r] && o.push(n);
				o.length && s.push({elem: c, handlers: o})
			}
			return c = this, l < e.length && s.push({elem: c, handlers: e.slice(l)}), s
		}, addProp: function (t, e) {
			Object.defineProperty(w.Event.prototype, t, {
				enumerable: !0, configurable: !0, get: m(e) ? function () {
					if (this.originalEvent) return e(this.originalEvent)
				} : function () {
					if (this.originalEvent) return this.originalEvent[t]
				}, set: function (e) {
					Object.defineProperty(this, t, {enumerable: !0, configurable: !0, writable: !0, value: e})
				}
			})
		}, fix: function (t) {
			return t[w.expando] ? t : new w.Event(t)
		}, special: {
			load: {noBubble: !0}, focus: {
				trigger: function () {
					if (this !== Ct() && this.focus) return this.focus(), !1
				}, delegateType: "focusin"
			}, blur: {
				trigger: function () {
					if (this === Ct() && this.blur) return this.blur(), !1
				}, delegateType: "focusout"
			}, click: {
				trigger: function () {
					if ("checkbox" === this.type && this.click && T(this, "input")) return this.click(), !1
				}, _default: function (t) {
					return T(t.target, "a")
				}
			}, beforeunload: {
				postDispatch: function (t) {
					void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
				}
			}
		}
	}, w.removeEvent = function (t, e, i) {
		t.removeEventListener && t.removeEventListener(e, i)
	}, w.Event = function (t, e) {
		if (!(this instanceof w.Event)) return new w.Event(t, e);
		t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? _t : St, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && w.extend(this, e), this.timeStamp = t && t.timeStamp || Date.now(), this[w.expando] = !0
	}, w.Event.prototype = {
		constructor: w.Event, isDefaultPrevented: St, isPropagationStopped: St, isImmediatePropagationStopped: St, isSimulated: !1, preventDefault: function () {
			var t = this.originalEvent;
			this.isDefaultPrevented = _t, t && !this.isSimulated && t.preventDefault()
		}, stopPropagation: function () {
			var t = this.originalEvent;
			this.isPropagationStopped = _t, t && !this.isSimulated && t.stopPropagation()
		}, stopImmediatePropagation: function () {
			var t = this.originalEvent;
			this.isImmediatePropagationStopped = _t, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
		}
	}, w.each({
		altKey: !0,
		bubbles: !0,
		cancelable: !0,
		changedTouches: !0,
		ctrlKey: !0,
		detail: !0,
		eventPhase: !0,
		metaKey: !0,
		pageX: !0,
		pageY: !0,
		shiftKey: !0,
		view: !0,
		char: !0,
		charCode: !0,
		key: !0,
		keyCode: !0,
		button: !0,
		buttons: !0,
		clientX: !0,
		clientY: !0,
		offsetX: !0,
		offsetY: !0,
		pointerId: !0,
		pointerType: !0,
		screenX: !0,
		screenY: !0,
		targetTouches: !0,
		toElement: !0,
		touches: !0,
		which: function (t) {
			var e = t.button;
			return null == t.which && wt.test(t.type) ? null != t.charCode ? t.charCode : t.keyCode : !t.which && void 0 !== e && xt.test(t.type) ? 1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0 : t.which
		}
	}, w.event.addProp), w.each({mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout"}, function (t, e) {
		w.event.special[t] = {
			delegateType: e, bindType: e, handle: function (t) {
				var i, n = t.relatedTarget, r = t.handleObj;
				return n && (n === this || w.contains(this, n)) || (t.type = r.origType, i = r.handler.apply(this, arguments), t.type = e), i
			}
		}
	}), w.fn.extend({
		on: function (t, e, i, n) {
			return Dt(this, t, e, i, n)
		}, one: function (t, e, i, n) {
			return Dt(this, t, e, i, n, 1)
		}, off: function (t, e, i) {
			var n, r;
			if (t && t.preventDefault && t.handleObj) return n = t.handleObj, w(t.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
			if ("object" == typeof t) {
				for (r in t) this.off(r, e, t[r]);
				return this
			}
			return !1 !== e && "function" != typeof e || (i = e, e = void 0), !1 === i && (i = St), this.each(function () {
				w.event.remove(this, t, i, e)
			})
		}
	});
	var Tt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi, Mt = /<script|<style|<link/i, Et = /checked\s*(?:[^=]|=\s*.checked.)/i, At = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

	function Pt(t, e) {
		return T(t, "table") && T(11 !== e.nodeType ? e : e.firstChild, "tr") && w(t).children("tbody")[0] || t
	}

	function It(t) {
		return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
	}

	function Ot(t) {
		return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"), t
	}

	function Lt(t, e) {
		var i, n, r, o, a, s, l, c;
		if (1 === e.nodeType) {
			if (K.hasData(t) && (o = K.access(t), a = K.set(e, o), c = o.events)) for (r in delete a.handle, a.events = {}, c) for (i = 0, n = c[r].length; i < n; i++) w.event.add(e, r, c[r][i]);
			X.hasData(t) && (s = X.access(t), l = w.extend({}, s), X.set(e, l))
		}
	}

	function Ft(t, e, i, n) {
		e = a.apply([], e);
		var r, o, s, l, c, u, h = 0, d = t.length, p = d - 1, g = e[0], v = m(g);
		if (v || d > 1 && "string" == typeof g && !f.checkClone && Et.test(g)) return t.each(function (r) {
			var o = t.eq(r);
			v && (e[0] = g.call(this, r, o.html())), Ft(o, e, i, n)
		});
		if (d && (o = (r = yt(e, t[0].ownerDocument, !1, t, n)).firstChild, 1 === r.childNodes.length && (r = o), o || n)) {
			for (l = (s = w.map(pt(r, "script"), It)).length; h < d; h++) c = r, h !== p && (c = w.clone(c, !0, !0), l && w.merge(s, pt(c, "script"))), i.call(t[h], c, h);
			if (l) for (u = s[s.length - 1].ownerDocument, w.map(s, Ot), h = 0; h < l; h++) c = s[h], ht.test(c.type || "") && !K.access(c, "globalEval") && w.contains(u, c) && (c.src && "module" !== (c.type || "").toLowerCase() ? w._evalUrl && w._evalUrl(c.src) : y(c.textContent.replace(At, ""), u, c))
		}
		return t
	}

	function Nt(t, e, i) {
		for (var n, r = e ? w.filter(e, t) : t, o = 0; null != (n = r[o]); o++) i || 1 !== n.nodeType || w.cleanData(pt(n)), n.parentNode && (i && w.contains(n.ownerDocument, n) && ft(pt(n, "script")), n.parentNode.removeChild(n));
		return t
	}

	w.extend({
		htmlPrefilter: function (t) {
			return t.replace(Tt, "<$1></$2>")
		}, clone: function (t, e, i) {
			var n, r, o, a, s, l, c, u = t.cloneNode(!0), h = w.contains(t.ownerDocument, t);
			if (!(f.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || w.isXMLDoc(t))) for (a = pt(u), n = 0, r = (o = pt(t)).length; n < r; n++) s = o[n], l = a[n], c = void 0, "input" === (c = l.nodeName.toLowerCase()) && ct.test(s.type) ? l.checked = s.checked : "input" !== c && "textarea" !== c || (l.defaultValue = s.defaultValue);
			if (e) if (i) for (o = o || pt(t), a = a || pt(u), n = 0, r = o.length; n < r; n++) Lt(o[n], a[n]); else Lt(t, u);
			return (a = pt(u, "script")).length > 0 && ft(a, !h && pt(t, "script")), u
		}, cleanData: function (t) {
			for (var e, i, n, r = w.event.special, o = 0; void 0 !== (i = t[o]); o++) if (q(i)) {
				if (e = i[K.expando]) {
					if (e.events) for (n in e.events) r[n] ? w.event.remove(i, n) : w.removeEvent(i, n, e.handle);
					i[K.expando] = void 0
				}
				i[X.expando] && (i[X.expando] = void 0)
			}
		}
	}), w.fn.extend({
		detach: function (t) {
			return Nt(this, t, !0)
		}, remove: function (t) {
			return Nt(this, t)
		}, text: function (t) {
			return j(this, function (t) {
				return void 0 === t ? w.text(this) : this.empty().each(function () {
					1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
				})
			}, null, t, arguments.length)
		}, append: function () {
			return Ft(this, arguments, function (t) {
				1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Pt(this, t).appendChild(t)
			})
		}, prepend: function () {
			return Ft(this, arguments, function (t) {
				if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
					var e = Pt(this, t);
					e.insertBefore(t, e.firstChild)
				}
			})
		}, before: function () {
			return Ft(this, arguments, function (t) {
				this.parentNode && this.parentNode.insertBefore(t, this)
			})
		}, after: function () {
			return Ft(this, arguments, function (t) {
				this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
			})
		}, empty: function () {
			for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (w.cleanData(pt(t, !1)), t.textContent = "");
			return this
		}, clone: function (t, e) {
			return t = null != t && t, e = null == e ? t : e, this.map(function () {
				return w.clone(this, t, e)
			})
		}, html: function (t) {
			return j(this, function (t) {
				var e = this[0] || {}, i = 0, n = this.length;
				if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
				if ("string" == typeof t && !Mt.test(t) && !dt[(ut.exec(t) || ["", ""])[1].toLowerCase()]) {
					t = w.htmlPrefilter(t);
					try {
						for (; i < n; i++) 1 === (e = this[i] || {}).nodeType && (w.cleanData(pt(e, !1)), e.innerHTML = t);
						e = 0
					} catch (t) {
					}
				}
				e && this.empty().append(t)
			}, null, t, arguments.length)
		}, replaceWith: function () {
			var t = [];
			return Ft(this, arguments, function (e) {
				var i = this.parentNode;
				w.inArray(this, t) < 0 && (w.cleanData(pt(this)), i && i.replaceChild(e, this))
			}, t)
		}
	}), w.each({appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith"}, function (t, e) {
		w.fn[t] = function (t) {
			for (var i, n = [], r = w(t), o = r.length - 1, a = 0; a <= o; a++) i = a === o ? this : this.clone(!0), w(r[a])[e](i), s.apply(n, i.get());
			return this.pushStack(n)
		}
	});
	var Rt = new RegExp("^(" + tt + ")(?!px)[a-z%]+$", "i"), Ht = function (e) {
		var i = e.ownerDocument.defaultView;
		return i && i.opener || (i = t), i.getComputedStyle(e)
	}, $t = new RegExp(it.join("|"), "i");

	function Bt(t, e, i) {
		var n, r, o, a, s = t.style;
		return (i = i || Ht(t)) && ("" !== (a = i.getPropertyValue(e) || i[e]) || w.contains(t.ownerDocument, t) || (a = w.style(t, e)), !f.pixelBoxStyles() && Rt.test(a) && $t.test(e) && (n = s.width, r = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = i.width, s.width = n, s.minWidth = r, s.maxWidth = o)), void 0 !== a ? a + "" : a
	}

	function zt(t, e) {
		return {
			get: function () {
				if (!t()) return (this.get = e).apply(this, arguments);
				delete this.get
			}
		}
	}

	!function () {
		function e() {
			if (u) {
				c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", bt.appendChild(c).appendChild(u);
				var e = t.getComputedStyle(u);
				r = "1%" !== e.top, l = 12 === i(e.marginLeft), u.style.right = "60%", s = 36 === i(e.right), o = 36 === i(e.width), u.style.position = "absolute", a = 36 === u.offsetWidth || "absolute", bt.removeChild(c), u = null
			}
		}

		function i(t) {
			return Math.round(parseFloat(t))
		}

		var r, o, a, s, l, c = n.createElement("div"), u = n.createElement("div");
		u.style && (u.style.backgroundClip = "content-box", u.cloneNode(!0).style.backgroundClip = "", f.clearCloneStyle = "content-box" === u.style.backgroundClip, w.extend(f, {
			boxSizingReliable: function () {
				return e(), o
			}, pixelBoxStyles: function () {
				return e(), s
			}, pixelPosition: function () {
				return e(), r
			}, reliableMarginLeft: function () {
				return e(), l
			}, scrollboxSize: function () {
				return e(), a
			}
		}))
	}();
	var jt = /^(none|table(?!-c[ea]).+)/, Ut = /^--/, Wt = {position: "absolute", visibility: "hidden", display: "block"}, Yt = {letterSpacing: "0", fontWeight: "400"}, Vt = ["Webkit", "Moz", "ms"], qt = n.createElement("div").style;

	function Gt(t) {
		var e = w.cssProps[t];
		return e || (e = w.cssProps[t] = function (t) {
			if (t in qt) return t;
			for (var e = t[0].toUpperCase() + t.slice(1), i = Vt.length; i--;) if ((t = Vt[i] + e) in qt) return t
		}(t) || t), e
	}

	function Kt(t, e, i) {
		var n = et.exec(e);
		return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e
	}

	function Xt(t, e, i, n, r, o) {
		var a = "width" === e ? 1 : 0, s = 0, l = 0;
		if (i === (n ? "border" : "content")) return 0;
		for (; a < 4; a += 2) "margin" === i && (l += w.css(t, i + it[a], !0, r)), n ? ("content" === i && (l -= w.css(t, "padding" + it[a], !0, r)), "margin" !== i && (l -= w.css(t, "border" + it[a] + "Width", !0, r))) : (l += w.css(t, "padding" + it[a], !0, r), "padding" !== i ? l += w.css(t, "border" + it[a] + "Width", !0, r) : s += w.css(t, "border" + it[a] + "Width", !0, r));
		return !n && o >= 0 && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - o - l - s - .5))), l
	}

	function Zt(t, e, i) {
		var n = Ht(t), r = Bt(t, e, n), o = "border-box" === w.css(t, "boxSizing", !1, n), a = o;
		if (Rt.test(r)) {
			if (!i) return r;
			r = "auto"
		}
		return a = a && (f.boxSizingReliable() || r === t.style[e]), ("auto" === r || !parseFloat(r) && "inline" === w.css(t, "display", !1, n)) && (r = t["offset" + e[0].toUpperCase() + e.slice(1)], a = !0), (r = parseFloat(r) || 0) + Xt(t, e, i || (o ? "border" : "content"), a, n, r) + "px"
	}

	function Qt(t, e, i, n, r) {
		return new Qt.prototype.init(t, e, i, n, r)
	}

	w.extend({
		cssHooks: {
			opacity: {
				get: function (t, e) {
					if (e) {
						var i = Bt(t, "opacity");
						return "" === i ? "1" : i
					}
				}
			}
		}, cssNumber: {animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0}, cssProps: {}, style: function (t, e, i, n) {
			if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
				var r, o, a, s = V(e), l = Ut.test(e), c = t.style;
				if (l || (e = Gt(s)), a = w.cssHooks[e] || w.cssHooks[s], void 0 === i) return a && "get" in a && void 0 !== (r = a.get(t, !1, n)) ? r : c[e];
				"string" === (o = typeof i) && (r = et.exec(i)) && r[1] && (i = ot(t, e, r), o = "number"), null != i && i == i && ("number" === o && (i += r && r[3] || (w.cssNumber[s] ? "" : "px")), f.clearCloneStyle || "" !== i || 0 !== e.indexOf("background") || (c[e] = "inherit"), a && "set" in a && void 0 === (i = a.set(t, i, n)) || (l ? c.setProperty(e, i) : c[e] = i))
			}
		}, css: function (t, e, i, n) {
			var r, o, a, s = V(e);
			return Ut.test(e) || (e = Gt(s)), (a = w.cssHooks[e] || w.cssHooks[s]) && "get" in a && (r = a.get(t, !0, i)), void 0 === r && (r = Bt(t, e, n)), "normal" === r && e in Yt && (r = Yt[e]), "" === i || i ? (o = parseFloat(r), !0 === i || isFinite(o) ? o || 0 : r) : r
		}
	}), w.each(["height", "width"], function (t, e) {
		w.cssHooks[e] = {
			get: function (t, i, n) {
				if (i) return !jt.test(w.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? Zt(t, e, n) : rt(t, Wt, function () {
					return Zt(t, e, n)
				})
			}, set: function (t, i, n) {
				var r, o = Ht(t), a = "border-box" === w.css(t, "boxSizing", !1, o), s = n && Xt(t, e, n, a, o);
				return a && f.scrollboxSize() === o.position && (s -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(o[e]) - Xt(t, e, "border", !1, o) - .5)), s && (r = et.exec(i)) && "px" !== (r[3] || "px") && (t.style[e] = i, i = w.css(t, e)), Kt(0, i, s)
			}
		}
	}), w.cssHooks.marginLeft = zt(f.reliableMarginLeft, function (t, e) {
		if (e) return (parseFloat(Bt(t, "marginLeft")) || t.getBoundingClientRect().left - rt(t, {marginLeft: 0}, function () {
			return t.getBoundingClientRect().left
		})) + "px"
	}), w.each({margin: "", padding: "", border: "Width"}, function (t, e) {
		w.cssHooks[t + e] = {
			expand: function (i) {
				for (var n = 0, r = {}, o = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++) r[t + it[n] + e] = o[n] || o[n - 2] || o[0];
				return r
			}
		}, "margin" !== t && (w.cssHooks[t + e].set = Kt)
	}), w.fn.extend({
		css: function (t, e) {
			return j(this, function (t, e, i) {
				var n, r, o = {}, a = 0;
				if (Array.isArray(e)) {
					for (n = Ht(t), r = e.length; a < r; a++) o[e[a]] = w.css(t, e[a], !1, n);
					return o
				}
				return void 0 !== i ? w.style(t, e, i) : w.css(t, e)
			}, t, e, arguments.length > 1)
		}
	}), w.Tween = Qt, Qt.prototype = {
		constructor: Qt, init: function (t, e, i, n, r, o) {
			this.elem = t, this.prop = i, this.easing = r || w.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = n, this.unit = o || (w.cssNumber[i] ? "" : "px")
		}, cur: function () {
			var t = Qt.propHooks[this.prop];
			return t && t.get ? t.get(this) : Qt.propHooks._default.get(this)
		}, run: function (t) {
			var e, i = Qt.propHooks[this.prop];
			return this.options.duration ? this.pos = e = w.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : Qt.propHooks._default.set(this), this
		}
	}, Qt.prototype.init.prototype = Qt.prototype, Qt.propHooks = {
		_default: {
			get: function (t) {
				var e;
				return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = w.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
			}, set: function (t) {
				w.fx.step[t.prop] ? w.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[w.cssProps[t.prop]] && !w.cssHooks[t.prop] ? t.elem[t.prop] = t.now : w.style(t.elem, t.prop, t.now + t.unit)
			}
		}
	}, Qt.propHooks.scrollTop = Qt.propHooks.scrollLeft = {
		set: function (t) {
			t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
		}
	}, w.easing = {
		linear: function (t) {
			return t
		}, swing: function (t) {
			return .5 - Math.cos(t * Math.PI) / 2
		}, _default: "swing"
	}, w.fx = Qt.prototype.init, w.fx.step = {};
	var Jt, te, ee = /^(?:toggle|show|hide)$/, ie = /queueHooks$/;

	function ne() {
		te && (!1 === n.hidden && t.requestAnimationFrame ? t.requestAnimationFrame(ne) : t.setTimeout(ne, w.fx.interval), w.fx.tick())
	}

	function re() {
		return t.setTimeout(function () {
			Jt = void 0
		}), Jt = Date.now()
	}

	function oe(t, e) {
		var i, n = 0, r = {height: t};
		for (e = e ? 1 : 0; n < 4; n += 2 - e) r["margin" + (i = it[n])] = r["padding" + i] = t;
		return e && (r.opacity = r.width = t), r
	}

	function ae(t, e, i) {
		for (var n, r = (se.tweeners[e] || []).concat(se.tweeners["*"]), o = 0, a = r.length; o < a; o++) if (n = r[o].call(i, e, t)) return n
	}

	function se(t, e, i) {
		var n, r, o = 0, a = se.prefilters.length, s = w.Deferred().always(function () {
			delete l.elem
		}), l = function () {
			if (r) return !1;
			for (var e = Jt || re(), i = Math.max(0, c.startTime + c.duration - e), n = 1 - (i / c.duration || 0), o = 0, a = c.tweens.length; o < a; o++) c.tweens[o].run(n);
			return s.notifyWith(t, [c, n, i]), n < 1 && a ? i : (a || s.notifyWith(t, [c, 1, 0]), s.resolveWith(t, [c]), !1)
		}, c = s.promise({
			elem: t, props: w.extend({}, e), opts: w.extend(!0, {specialEasing: {}, easing: w.easing._default}, i), originalProperties: e, originalOptions: i, startTime: Jt || re(), duration: i.duration, tweens: [], createTween: function (e, i) {
				var n = w.Tween(t, c.opts, e, i, c.opts.specialEasing[e] || c.opts.easing);
				return c.tweens.push(n), n
			}, stop: function (e) {
				var i = 0, n = e ? c.tweens.length : 0;
				if (r) return this;
				for (r = !0; i < n; i++) c.tweens[i].run(1);
				return e ? (s.notifyWith(t, [c, 1, 0]), s.resolveWith(t, [c, e])) : s.rejectWith(t, [c, e]), this
			}
		}), u = c.props;
		for (!function (t, e) {
			var i, n, r, o, a;
			for (i in t) if (r = e[n = V(i)], o = t[i], Array.isArray(o) && (r = o[1], o = t[i] = o[0]), i !== n && (t[n] = o, delete t[i]), (a = w.cssHooks[n]) && "expand" in a) for (i in o = a.expand(o), delete t[n], o) i in t || (t[i] = o[i], e[i] = r); else e[n] = r
		}(u, c.opts.specialEasing); o < a; o++) if (n = se.prefilters[o].call(c, t, u, c.opts)) return m(n.stop) && (w._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)), n;
		return w.map(u, ae, c), m(c.opts.start) && c.opts.start.call(t, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), w.fx.timer(w.extend(l, {elem: t, anim: c, queue: c.opts.queue})), c
	}

	w.Animation = w.extend(se, {
		tweeners: {
			"*": [function (t, e) {
				var i = this.createTween(t, e);
				return ot(i.elem, t, et.exec(e), i), i
			}]
		}, tweener: function (t, e) {
			m(t) ? (e = t, t = ["*"]) : t = t.match(F);
			for (var i, n = 0, r = t.length; n < r; n++) i = t[n], se.tweeners[i] = se.tweeners[i] || [], se.tweeners[i].unshift(e)
		}, prefilters: [function (t, e, i) {
			var n, r, o, a, s, l, c, u, h = "width" in e || "height" in e, d = this, p = {}, f = t.style, m = t.nodeType && nt(t), g = K.get(t, "fxshow");
			for (n in i.queue || (null == (a = w._queueHooks(t, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () {
				a.unqueued || s()
			}), a.unqueued++, d.always(function () {
				d.always(function () {
					a.unqueued--, w.queue(t, "fx").length || a.empty.fire()
				})
			})), e) if (r = e[n], ee.test(r)) {
				if (delete e[n], o = o || "toggle" === r, r === (m ? "hide" : "show")) {
					if ("show" !== r || !g || void 0 === g[n]) continue;
					m = !0
				}
				p[n] = g && g[n] || w.style(t, n)
			}
			if ((l = !w.isEmptyObject(e)) || !w.isEmptyObject(p)) for (n in h && 1 === t.nodeType && (i.overflow = [f.overflow, f.overflowX, f.overflowY], null == (c = g && g.display) && (c = K.get(t, "display")), "none" === (u = w.css(t, "display")) && (c ? u = c : (lt([t], !0), c = t.style.display || c, u = w.css(t, "display"), lt([t]))), ("inline" === u || "inline-block" === u && null != c) && "none" === w.css(t, "float") && (l || (d.done(function () {
				f.display = c
			}), null == c && (u = f.display, c = "none" === u ? "" : u)), f.display = "inline-block")), i.overflow && (f.overflow = "hidden", d.always(function () {
				f.overflow = i.overflow[0], f.overflowX = i.overflow[1], f.overflowY = i.overflow[2]
			})), l = !1, p) l || (g ? "hidden" in g && (m = g.hidden) : g = K.access(t, "fxshow", {display: c}), o && (g.hidden = !m), m && lt([t], !0), d.done(function () {
				for (n in m || lt([t]), K.remove(t, "fxshow"), p) w.style(t, n, p[n])
			})), l = ae(m ? g[n] : 0, n, d), n in g || (g[n] = l.start, m && (l.end = l.start, l.start = 0))
		}], prefilter: function (t, e) {
			e ? se.prefilters.unshift(t) : se.prefilters.push(t)
		}
	}), w.speed = function (t, e, i) {
		var n = t && "object" == typeof t ? w.extend({}, t) : {complete: i || !i && e || m(t) && t, duration: t, easing: i && e || e && !m(e) && e};
		return w.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in w.fx.speeds ? n.duration = w.fx.speeds[n.duration] : n.duration = w.fx.speeds._default), null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function () {
			m(n.old) && n.old.call(this), n.queue && w.dequeue(this, n.queue)
		}, n
	}, w.fn.extend({
		fadeTo: function (t, e, i, n) {
			return this.filter(nt).css("opacity", 0).show().end().animate({opacity: e}, t, i, n)
		}, animate: function (t, e, i, n) {
			var r = w.isEmptyObject(t), o = w.speed(e, i, n), a = function () {
				var e = se(this, w.extend({}, t), o);
				(r || K.get(this, "finish")) && e.stop(!0)
			};
			return a.finish = a, r || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
		}, stop: function (t, e, i) {
			var n = function (t) {
				var e = t.stop;
				delete t.stop, e(i)
			};
			return "string" != typeof t && (i = e, e = t, t = void 0), e && !1 !== t && this.queue(t || "fx", []), this.each(function () {
				var e = !0, r = null != t && t + "queueHooks", o = w.timers, a = K.get(this);
				if (r) a[r] && a[r].stop && n(a[r]); else for (r in a) a[r] && a[r].stop && ie.test(r) && n(a[r]);
				for (r = o.length; r--;) o[r].elem !== this || null != t && o[r].queue !== t || (o[r].anim.stop(i), e = !1, o.splice(r, 1));
				!e && i || w.dequeue(this, t)
			})
		}, finish: function (t) {
			return !1 !== t && (t = t || "fx"), this.each(function () {
				var e, i = K.get(this), n = i[t + "queue"], r = i[t + "queueHooks"], o = w.timers, a = n ? n.length : 0;
				for (i.finish = !0, w.queue(this, t, []), r && r.stop && r.stop.call(this, !0), e = o.length; e--;) o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0), o.splice(e, 1));
				for (e = 0; e < a; e++) n[e] && n[e].finish && n[e].finish.call(this);
				delete i.finish
			})
		}
	}), w.each(["toggle", "show", "hide"], function (t, e) {
		var i = w.fn[e];
		w.fn[e] = function (t, n, r) {
			return null == t || "boolean" == typeof t ? i.apply(this, arguments) : this.animate(oe(e, !0), t, n, r)
		}
	}), w.each({slideDown: oe("show"), slideUp: oe("hide"), slideToggle: oe("toggle"), fadeIn: {opacity: "show"}, fadeOut: {opacity: "hide"}, fadeToggle: {opacity: "toggle"}}, function (t, e) {
		w.fn[t] = function (t, i, n) {
			return this.animate(e, t, i, n)
		}
	}), w.timers = [], w.fx.tick = function () {
		var t, e = 0, i = w.timers;
		for (Jt = Date.now(); e < i.length; e++) (t = i[e])() || i[e] !== t || i.splice(e--, 1);
		i.length || w.fx.stop(), Jt = void 0
	}, w.fx.timer = function (t) {
		w.timers.push(t), w.fx.start()
	}, w.fx.interval = 13, w.fx.start = function () {
		te || (te = !0, ne())
	}, w.fx.stop = function () {
		te = null
	}, w.fx.speeds = {slow: 600, fast: 200, _default: 400}, w.fn.delay = function (e, i) {
		return e = w.fx && w.fx.speeds[e] || e, i = i || "fx", this.queue(i, function (i, n) {
			var r = t.setTimeout(i, e);
			n.stop = function () {
				t.clearTimeout(r)
			}
		})
	}, function () {
		var t = n.createElement("input"), e = n.createElement("select").appendChild(n.createElement("option"));
		t.type = "checkbox", f.checkOn = "" !== t.value, f.optSelected = e.selected, (t = n.createElement("input")).value = "t", t.type = "radio", f.radioValue = "t" === t.value
	}();
	var le, ce = w.expr.attrHandle;
	w.fn.extend({
		attr: function (t, e) {
			return j(this, w.attr, t, e, arguments.length > 1)
		}, removeAttr: function (t) {
			return this.each(function () {
				w.removeAttr(this, t)
			})
		}
	}), w.extend({
		attr: function (t, e, i) {
			var n, r, o = t.nodeType;
			if (3 !== o && 8 !== o && 2 !== o) return void 0 === t.getAttribute ? w.prop(t, e, i) : (1 === o && w.isXMLDoc(t) || (r = w.attrHooks[e.toLowerCase()] || (w.expr.match.bool.test(e) ? le : void 0)), void 0 !== i ? null === i ? void w.removeAttr(t, e) : r && "set" in r && void 0 !== (n = r.set(t, i, e)) ? n : (t.setAttribute(e, i + ""), i) : r && "get" in r && null !== (n = r.get(t, e)) ? n : null == (n = w.find.attr(t, e)) ? void 0 : n)
		}, attrHooks: {
			type: {
				set: function (t, e) {
					if (!f.radioValue && "radio" === e && T(t, "input")) {
						var i = t.value;
						return t.setAttribute("type", e), i && (t.value = i), e
					}
				}
			}
		}, removeAttr: function (t, e) {
			var i, n = 0, r = e && e.match(F);
			if (r && 1 === t.nodeType) for (; i = r[n++];) t.removeAttribute(i)
		}
	}), le = {
		set: function (t, e, i) {
			return !1 === e ? w.removeAttr(t, i) : t.setAttribute(i, i), i
		}
	}, w.each(w.expr.match.bool.source.match(/\w+/g), function (t, e) {
		var i = ce[e] || w.find.attr;
		ce[e] = function (t, e, n) {
			var r, o, a = e.toLowerCase();
			return n || (o = ce[a], ce[a] = r, r = null != i(t, e, n) ? a : null, ce[a] = o), r
		}
	});
	var ue = /^(?:input|select|textarea|button)$/i, he = /^(?:a|area)$/i;

	function de(t) {
		return (t.match(F) || []).join(" ")
	}

	function pe(t) {
		return t.getAttribute && t.getAttribute("class") || ""
	}

	function fe(t) {
		return Array.isArray(t) ? t : "string" == typeof t && t.match(F) || []
	}

	w.fn.extend({
		prop: function (t, e) {
			return j(this, w.prop, t, e, arguments.length > 1)
		}, removeProp: function (t) {
			return this.each(function () {
				delete this[w.propFix[t] || t]
			})
		}
	}), w.extend({
		prop: function (t, e, i) {
			var n, r, o = t.nodeType;
			if (3 !== o && 8 !== o && 2 !== o) return 1 === o && w.isXMLDoc(t) || (e = w.propFix[e] || e, r = w.propHooks[e]), void 0 !== i ? r && "set" in r && void 0 !== (n = r.set(t, i, e)) ? n : t[e] = i : r && "get" in r && null !== (n = r.get(t, e)) ? n : t[e]
		}, propHooks: {
			tabIndex: {
				get: function (t) {
					var e = w.find.attr(t, "tabindex");
					return e ? parseInt(e, 10) : ue.test(t.nodeName) || he.test(t.nodeName) && t.href ? 0 : -1
				}
			}
		}, propFix: {for: "htmlFor", class: "className"}
	}), f.optSelected || (w.propHooks.selected = {
		get: function (t) {
			var e = t.parentNode;
			return e && e.parentNode && e.parentNode.selectedIndex, null
		}, set: function (t) {
			var e = t.parentNode;
			e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
		}
	}), w.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
		w.propFix[this.toLowerCase()] = this
	}), w.fn.extend({
		addClass: function (t) {
			var e, i, n, r, o, a, s, l = 0;
			if (m(t)) return this.each(function (e) {
				w(this).addClass(t.call(this, e, pe(this)))
			});
			if ((e = fe(t)).length) for (; i = this[l++];) if (r = pe(i), n = 1 === i.nodeType && " " + de(r) + " ") {
				for (a = 0; o = e[a++];) n.indexOf(" " + o + " ") < 0 && (n += o + " ");
				r !== (s = de(n)) && i.setAttribute("class", s)
			}
			return this
		}, removeClass: function (t) {
			var e, i, n, r, o, a, s, l = 0;
			if (m(t)) return this.each(function (e) {
				w(this).removeClass(t.call(this, e, pe(this)))
			});
			if (!arguments.length) return this.attr("class", "");
			if ((e = fe(t)).length) for (; i = this[l++];) if (r = pe(i), n = 1 === i.nodeType && " " + de(r) + " ") {
				for (a = 0; o = e[a++];) for (; n.indexOf(" " + o + " ") > -1;) n = n.replace(" " + o + " ", " ");
				r !== (s = de(n)) && i.setAttribute("class", s)
			}
			return this
		}, toggleClass: function (t, e) {
			var i = typeof t, n = "string" === i || Array.isArray(t);
			return "boolean" == typeof e && n ? e ? this.addClass(t) : this.removeClass(t) : m(t) ? this.each(function (i) {
				w(this).toggleClass(t.call(this, i, pe(this), e), e)
			}) : this.each(function () {
				var e, r, o, a;
				if (n) for (r = 0, o = w(this), a = fe(t); e = a[r++];) o.hasClass(e) ? o.removeClass(e) : o.addClass(e); else void 0 !== t && "boolean" !== i || ((e = pe(this)) && K.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : K.get(this, "__className__") || ""))
			})
		}, hasClass: function (t) {
			var e, i, n = 0;
			for (e = " " + t + " "; i = this[n++];) if (1 === i.nodeType && (" " + de(pe(i)) + " ").indexOf(e) > -1) return !0;
			return !1
		}
	});
	var me = /\r/g;
	w.fn.extend({
		val: function (t) {
			var e, i, n, r = this[0];
			return arguments.length ? (n = m(t), this.each(function (i) {
				var r;
				1 === this.nodeType && (null == (r = n ? t.call(this, i, w(this).val()) : t) ? r = "" : "number" == typeof r ? r += "" : Array.isArray(r) && (r = w.map(r, function (t) {
					return null == t ? "" : t + ""
				})), (e = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, r, "value") || (this.value = r))
			})) : r ? (e = w.valHooks[r.type] || w.valHooks[r.nodeName.toLowerCase()]) && "get" in e && void 0 !== (i = e.get(r, "value")) ? i : "string" == typeof (i = r.value) ? i.replace(me, "") : null == i ? "" : i : void 0
		}
	}), w.extend({
		valHooks: {
			option: {
				get: function (t) {
					var e = w.find.attr(t, "value");
					return null != e ? e : de(w.text(t))
				}
			}, select: {
				get: function (t) {
					var e, i, n, r = t.options, o = t.selectedIndex, a = "select-one" === t.type, s = a ? null : [], l = a ? o + 1 : r.length;
					for (n = o < 0 ? l : a ? o : 0; n < l; n++) if (((i = r[n]).selected || n === o) && !i.disabled && (!i.parentNode.disabled || !T(i.parentNode, "optgroup"))) {
						if (e = w(i).val(), a) return e;
						s.push(e)
					}
					return s
				}, set: function (t, e) {
					for (var i, n, r = t.options, o = w.makeArray(e), a = r.length; a--;) ((n = r[a]).selected = w.inArray(w.valHooks.option.get(n), o) > -1) && (i = !0);
					return i || (t.selectedIndex = -1), o
				}
			}
		}
	}), w.each(["radio", "checkbox"], function () {
		w.valHooks[this] = {
			set: function (t, e) {
				if (Array.isArray(e)) return t.checked = w.inArray(w(t).val(), e) > -1
			}
		}, f.checkOn || (w.valHooks[this].get = function (t) {
			return null === t.getAttribute("value") ? "on" : t.value
		})
	}), f.focusin = "onfocusin" in t;
	var ge = /^(?:focusinfocus|focusoutblur)$/, ve = function (t) {
		t.stopPropagation()
	};
	w.extend(w.event, {
		trigger: function (e, i, r, o) {
			var a, s, l, c, u, d, p, f, v = [r || n], y = h.call(e, "type") ? e.type : e, b = h.call(e, "namespace") ? e.namespace.split(".") : [];
			if (s = f = l = r = r || n, 3 !== r.nodeType && 8 !== r.nodeType && !ge.test(y + w.event.triggered) && (y.indexOf(".") > -1 && (b = y.split("."), y = b.shift(), b.sort()), u = y.indexOf(":") < 0 && "on" + y, (e = e[w.expando] ? e : new w.Event(y, "object" == typeof e && e)).isTrigger = o ? 2 : 3, e.namespace = b.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = r), i = null == i ? [e] : w.makeArray(i, [e]), p = w.event.special[y] || {}, o || !p.trigger || !1 !== p.trigger.apply(r, i))) {
				if (!o && !p.noBubble && !g(r)) {
					for (c = p.delegateType || y, ge.test(c + y) || (s = s.parentNode); s; s = s.parentNode) v.push(s), l = s;
					l === (r.ownerDocument || n) && v.push(l.defaultView || l.parentWindow || t)
				}
				for (a = 0; (s = v[a++]) && !e.isPropagationStopped();) f = s, e.type = a > 1 ? c : p.bindType || y, (d = (K.get(s, "events") || {})[e.type] && K.get(s, "handle")) && d.apply(s, i), (d = u && s[u]) && d.apply && q(s) && (e.result = d.apply(s, i), !1 === e.result && e.preventDefault());
				return e.type = y, o || e.isDefaultPrevented() || p._default && !1 !== p._default.apply(v.pop(), i) || !q(r) || u && m(r[y]) && !g(r) && ((l = r[u]) && (r[u] = null), w.event.triggered = y, e.isPropagationStopped() && f.addEventListener(y, ve), r[y](), e.isPropagationStopped() && f.removeEventListener(y, ve), w.event.triggered = void 0, l && (r[u] = l)), e.result
			}
		}, simulate: function (t, e, i) {
			var n = w.extend(new w.Event, i, {type: t, isSimulated: !0});
			w.event.trigger(n, null, e)
		}
	}), w.fn.extend({
		trigger: function (t, e) {
			return this.each(function () {
				w.event.trigger(t, e, this)
			})
		}, triggerHandler: function (t, e) {
			var i = this[0];
			if (i) return w.event.trigger(t, e, i, !0)
		}
	}), f.focusin || w.each({focus: "focusin", blur: "focusout"}, function (t, e) {
		var i = function (t) {
			w.event.simulate(e, t.target, w.event.fix(t))
		};
		w.event.special[e] = {
			setup: function () {
				var n = this.ownerDocument || this, r = K.access(n, e);
				r || n.addEventListener(t, i, !0), K.access(n, e, (r || 0) + 1)
			}, teardown: function () {
				var n = this.ownerDocument || this, r = K.access(n, e) - 1;
				r ? K.access(n, e, r) : (n.removeEventListener(t, i, !0), K.remove(n, e))
			}
		}
	});
	var ye = t.location, be = Date.now(), we = /\?/;
	w.parseXML = function (e) {
		var i;
		if (!e || "string" != typeof e) return null;
		try {
			i = (new t.DOMParser).parseFromString(e, "text/xml")
		} catch (t) {
			i = void 0
		}
		return i && !i.getElementsByTagName("parsererror").length || w.error("Invalid XML: " + e), i
	};
	var xe = /\[\]$/, ke = /\r?\n/g, _e = /^(?:submit|button|image|reset|file)$/i, Se = /^(?:input|select|textarea|keygen)/i;

	function Ce(t, e, i, n) {
		var r;
		if (Array.isArray(e)) w.each(e, function (e, r) {
			i || xe.test(t) ? n(t, r) : Ce(t + "[" + ("object" == typeof r && null != r ? e : "") + "]", r, i, n)
		}); else if (i || "object" !== b(e)) n(t, e); else for (r in e) Ce(t + "[" + r + "]", e[r], i, n)
	}

	w.param = function (t, e) {
		var i, n = [], r = function (t, e) {
			var i = m(e) ? e() : e;
			n[n.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == i ? "" : i)
		};
		if (Array.isArray(t) || t.jquery && !w.isPlainObject(t)) w.each(t, function () {
			r(this.name, this.value)
		}); else for (i in t) Ce(i, t[i], e, r);
		return n.join("&")
	}, w.fn.extend({
		serialize: function () {
			return w.param(this.serializeArray())
		}, serializeArray: function () {
			return this.map(function () {
				var t = w.prop(this, "elements");
				return t ? w.makeArray(t) : this
			}).filter(function () {
				var t = this.type;
				return this.name && !w(this).is(":disabled") && Se.test(this.nodeName) && !_e.test(t) && (this.checked || !ct.test(t))
			}).map(function (t, e) {
				var i = w(this).val();
				return null == i ? null : Array.isArray(i) ? w.map(i, function (t) {
					return {name: e.name, value: t.replace(ke, "\r\n")}
				}) : {name: e.name, value: i.replace(ke, "\r\n")}
			}).get()
		}
	});
	var De = /%20/g, Te = /#.*$/, Me = /([?&])_=[^&]*/, Ee = /^(.*?):[ \t]*([^\r\n]*)$/gm, Ae = /^(?:GET|HEAD)$/, Pe = /^\/\//, Ie = {}, Oe = {}, Le = "*/".concat("*"), Fe = n.createElement("a");

	function Ne(t) {
		return function (e, i) {
			"string" != typeof e && (i = e, e = "*");
			var n, r = 0, o = e.toLowerCase().match(F) || [];
			if (m(i)) for (; n = o[r++];) "+" === n[0] ? (n = n.slice(1) || "*", (t[n] = t[n] || []).unshift(i)) : (t[n] = t[n] || []).push(i)
		}
	}

	function Re(t, e, i, n) {
		var r = {}, o = t === Oe;

		function a(s) {
			var l;
			return r[s] = !0, w.each(t[s] || [], function (t, s) {
				var c = s(e, i, n);
				return "string" != typeof c || o || r[c] ? o ? !(l = c) : void 0 : (e.dataTypes.unshift(c), a(c), !1)
			}), l
		}

		return a(e.dataTypes[0]) || !r["*"] && a("*")
	}

	function He(t, e) {
		var i, n, r = w.ajaxSettings.flatOptions || {};
		for (i in e) void 0 !== e[i] && ((r[i] ? t : n || (n = {}))[i] = e[i]);
		return n && w.extend(!0, t, n), t
	}

	Fe.href = ye.href, w.extend({
		active: 0,
		lastModified: {},
		etag: {},
		ajaxSettings: {
			url: ye.href,
			type: "GET",
			isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ye.protocol),
			global: !0,
			processData: !0,
			async: !0,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			accepts: {"*": Le, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript"},
			contents: {xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/},
			responseFields: {xml: "responseXML", text: "responseText", json: "responseJSON"},
			converters: {"* text": String, "text html": !0, "text json": JSON.parse, "text xml": w.parseXML},
			flatOptions: {url: !0, context: !0}
		},
		ajaxSetup: function (t, e) {
			return e ? He(He(t, w.ajaxSettings), e) : He(w.ajaxSettings, t)
		},
		ajaxPrefilter: Ne(Ie),
		ajaxTransport: Ne(Oe),
		ajax: function (e, i) {
			"object" == typeof e && (i = e, e = void 0), i = i || {};
			var r, o, a, s, l, c, u, h, d, p, f = w.ajaxSetup({}, i), m = f.context || f, g = f.context && (m.nodeType || m.jquery) ? w(m) : w.event, v = w.Deferred(), y = w.Callbacks("once memory"), b = f.statusCode || {}, x = {}, k = {}, _ = "canceled", S = {
				readyState: 0, getResponseHeader: function (t) {
					var e;
					if (u) {
						if (!s) for (s = {}; e = Ee.exec(a);) s[e[1].toLowerCase()] = e[2];
						e = s[t.toLowerCase()]
					}
					return null == e ? null : e
				}, getAllResponseHeaders: function () {
					return u ? a : null
				}, setRequestHeader: function (t, e) {
					return null == u && (t = k[t.toLowerCase()] = k[t.toLowerCase()] || t, x[t] = e), this
				}, overrideMimeType: function (t) {
					return null == u && (f.mimeType = t), this
				}, statusCode: function (t) {
					var e;
					if (t) if (u) S.always(t[S.status]); else for (e in t) b[e] = [b[e], t[e]];
					return this
				}, abort: function (t) {
					var e = t || _;
					return r && r.abort(e), C(0, e), this
				}
			};
			if (v.promise(S), f.url = ((e || f.url || ye.href) + "").replace(Pe, ye.protocol + "//"), f.type = i.method || i.type || f.method || f.type, f.dataTypes = (f.dataType || "*").toLowerCase().match(F) || [""], null == f.crossDomain) {
				c = n.createElement("a");
				try {
					c.href = f.url, c.href = c.href, f.crossDomain = Fe.protocol + "//" + Fe.host != c.protocol + "//" + c.host
				} catch (t) {
					f.crossDomain = !0
				}
			}
			if (f.data && f.processData && "string" != typeof f.data && (f.data = w.param(f.data, f.traditional)), Re(Ie, f, i, S), u) return S;
			for (d in(h = w.event && f.global) && 0 == w.active++ && w.event.trigger("ajaxStart"), f.type = f.type.toUpperCase(), f.hasContent = !Ae.test(f.type), o = f.url.replace(Te, ""), f.hasContent ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(De, "+")) : (p = f.url.slice(o.length), f.data && (f.processData || "string" == typeof f.data) && (o += (we.test(o) ? "&" : "?") + f.data, delete f.data), !1 === f.cache && (o = o.replace(Me, "$1"), p = (we.test(o) ? "&" : "?") + "_=" + be++ + p), f.url = o + p), f.ifModified && (w.lastModified[o] && S.setRequestHeader("If-Modified-Since", w.lastModified[o]), w.etag[o] && S.setRequestHeader("If-None-Match", w.etag[o])), (f.data && f.hasContent && !1 !== f.contentType || i.contentType) && S.setRequestHeader("Content-Type", f.contentType), S.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Le + "; q=0.01" : "") : f.accepts["*"]), f.headers) S.setRequestHeader(d, f.headers[d]);
			if (f.beforeSend && (!1 === f.beforeSend.call(m, S, f) || u)) return S.abort();
			if (_ = "abort", y.add(f.complete), S.done(f.success), S.fail(f.error), r = Re(Oe, f, i, S)) {
				if (S.readyState = 1, h && g.trigger("ajaxSend", [S, f]), u) return S;
				f.async && f.timeout > 0 && (l = t.setTimeout(function () {
					S.abort("timeout")
				}, f.timeout));
				try {
					u = !1, r.send(x, C)
				} catch (t) {
					if (u) throw t;
					C(-1, t)
				}
			} else C(-1, "No Transport");

			function C(e, i, n, s) {
				var c, d, p, x, k, _ = i;
				u || (u = !0, l && t.clearTimeout(l), r = void 0, a = s || "", S.readyState = e > 0 ? 4 : 0, c = e >= 200 && e < 300 || 304 === e, n && (x = function (t, e, i) {
					for (var n, r, o, a, s = t.contents, l = t.dataTypes; "*" === l[0];) l.shift(), void 0 === n && (n = t.mimeType || e.getResponseHeader("Content-Type"));
					if (n) for (r in s) if (s[r] && s[r].test(n)) {
						l.unshift(r);
						break
					}
					if (l[0] in i) o = l[0]; else {
						for (r in i) {
							if (!l[0] || t.converters[r + " " + l[0]]) {
								o = r;
								break
							}
							a || (a = r)
						}
						o = o || a
					}
					if (o) return o !== l[0] && l.unshift(o), i[o]
				}(f, S, n)), x = function (t, e, i, n) {
					var r, o, a, s, l, c = {}, u = t.dataTypes.slice();
					if (u[1]) for (a in t.converters) c[a.toLowerCase()] = t.converters[a];
					for (o = u.shift(); o;) if (t.responseFields[o] && (i[t.responseFields[o]] = e), !l && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = o, o = u.shift()) if ("*" === o) o = l; else if ("*" !== l && l !== o) {
						if (!(a = c[l + " " + o] || c["* " + o])) for (r in c) if ((s = r.split(" "))[1] === o && (a = c[l + " " + s[0]] || c["* " + s[0]])) {
							!0 === a ? a = c[r] : !0 !== c[r] && (o = s[0], u.unshift(s[1]));
							break
						}
						if (!0 !== a) if (a && t.throws) e = a(e); else try {
							e = a(e)
						} catch (t) {
							return {state: "parsererror", error: a ? t : "No conversion from " + l + " to " + o}
						}
					}
					return {state: "success", data: e}
				}(f, x, S, c), c ? (f.ifModified && ((k = S.getResponseHeader("Last-Modified")) && (w.lastModified[o] = k), (k = S.getResponseHeader("etag")) && (w.etag[o] = k)), 204 === e || "HEAD" === f.type ? _ = "nocontent" : 304 === e ? _ = "notmodified" : (_ = x.state, d = x.data, c = !(p = x.error))) : (p = _, !e && _ || (_ = "error", e < 0 && (e = 0))), S.status = e, S.statusText = (i || _) + "", c ? v.resolveWith(m, [d, _, S]) : v.rejectWith(m, [S, _, p]), S.statusCode(b), b = void 0, h && g.trigger(c ? "ajaxSuccess" : "ajaxError", [S, f, c ? d : p]), y.fireWith(m, [S, _]), h && (g.trigger("ajaxComplete", [S, f]), --w.active || w.event.trigger("ajaxStop")))
			}

			return S
		},
		getJSON: function (t, e, i) {
			return w.get(t, e, i, "json")
		},
		getScript: function (t, e) {
			return w.get(t, void 0, e, "script")
		}
	}), w.each(["get", "post"], function (t, e) {
		w[e] = function (t, i, n, r) {
			return m(i) && (r = r || n, n = i, i = void 0), w.ajax(w.extend({url: t, type: e, dataType: r, data: i, success: n}, w.isPlainObject(t) && t))
		}
	}), w._evalUrl = function (t) {
		return w.ajax({url: t, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, throws: !0})
	}, w.fn.extend({
		wrapAll: function (t) {
			var e;
			return this[0] && (m(t) && (t = t.call(this[0])), e = w(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function () {
				for (var t = this; t.firstElementChild;) t = t.firstElementChild;
				return t
			}).append(this)), this
		}, wrapInner: function (t) {
			return m(t) ? this.each(function (e) {
				w(this).wrapInner(t.call(this, e))
			}) : this.each(function () {
				var e = w(this), i = e.contents();
				i.length ? i.wrapAll(t) : e.append(t)
			})
		}, wrap: function (t) {
			var e = m(t);
			return this.each(function (i) {
				w(this).wrapAll(e ? t.call(this, i) : t)
			})
		}, unwrap: function (t) {
			return this.parent(t).not("body").each(function () {
				w(this).replaceWith(this.childNodes)
			}), this
		}
	}), w.expr.pseudos.hidden = function (t) {
		return !w.expr.pseudos.visible(t)
	}, w.expr.pseudos.visible = function (t) {
		return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
	}, w.ajaxSettings.xhr = function () {
		try {
			return new t.XMLHttpRequest
		} catch (t) {
		}
	};
	var $e = {0: 200, 1223: 204}, Be = w.ajaxSettings.xhr();
	f.cors = !!Be && "withCredentials" in Be, f.ajax = Be = !!Be, w.ajaxTransport(function (e) {
		var i, n;
		if (f.cors || Be && !e.crossDomain) return {
			send: function (r, o) {
				var a, s = e.xhr();
				if (s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (a in e.xhrFields) s[a] = e.xhrFields[a];
				for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"), r) s.setRequestHeader(a, r[a]);
				i = function (t) {
					return function () {
						i && (i = n = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === t ? s.abort() : "error" === t ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o($e[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {binary: s.response} : {text: s.responseText}, s.getAllResponseHeaders()))
					}
				}, s.onload = i(), n = s.onerror = s.ontimeout = i("error"), void 0 !== s.onabort ? s.onabort = n : s.onreadystatechange = function () {
					4 === s.readyState && t.setTimeout(function () {
						i && n()
					})
				}, i = i("abort");
				try {
					s.send(e.hasContent && e.data || null)
				} catch (t) {
					if (i) throw t
				}
			}, abort: function () {
				i && i()
			}
		}
	}), w.ajaxPrefilter(function (t) {
		t.crossDomain && (t.contents.script = !1)
	}), w.ajaxSetup({
		accepts: {script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"}, contents: {script: /\b(?:java|ecma)script\b/}, converters: {
			"text script": function (t) {
				return w.globalEval(t), t
			}
		}
	}), w.ajaxPrefilter("script", function (t) {
		void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
	}), w.ajaxTransport("script", function (t) {
		var e, i;
		if (t.crossDomain) return {
			send: function (r, o) {
				e = w("<script>").prop({charset: t.scriptCharset, src: t.url}).on("load error", i = function (t) {
					e.remove(), i = null, t && o("error" === t.type ? 404 : 200, t.type)
				}), n.head.appendChild(e[0])
			}, abort: function () {
				i && i()
			}
		}
	});
	var ze, je = [], Ue = /(=)\?(?=&|$)|\?\?/;
	w.ajaxSetup({
		jsonp: "callback", jsonpCallback: function () {
			var t = je.pop() || w.expando + "_" + be++;
			return this[t] = !0, t
		}
	}), w.ajaxPrefilter("json jsonp", function (e, i, n) {
		var r, o, a, s = !1 !== e.jsonp && (Ue.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ue.test(e.data) && "data");
		if (s || "jsonp" === e.dataTypes[0]) return r = e.jsonpCallback = m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[s] = e[s].replace(Ue, "$1" + r) : !1 !== e.jsonp && (e.url += (we.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function () {
			return a || w.error(r + " was not called"), a[0]
		}, e.dataTypes[0] = "json", o = t[r], t[r] = function () {
			a = arguments
		}, n.always(function () {
			void 0 === o ? w(t).removeProp(r) : t[r] = o, e[r] && (e.jsonpCallback = i.jsonpCallback, je.push(r)), a && m(o) && o(a[0]), a = o = void 0
		}), "script"
	}), f.createHTMLDocument = ((ze = n.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === ze.childNodes.length), w.parseHTML = function (t, e, i) {
		return "string" != typeof t ? [] : ("boolean" == typeof e && (i = e, e = !1), e || (f.createHTMLDocument ? ((r = (e = n.implementation.createHTMLDocument("")).createElement("base")).href = n.location.href, e.head.appendChild(r)) : e = n), a = !i && [], (o = M.exec(t)) ? [e.createElement(o[1])] : (o = yt([t], e, a), a && a.length && w(a).remove(), w.merge([], o.childNodes)));
		var r, o, a
	}, w.fn.load = function (t, e, i) {
		var n, r, o, a = this, s = t.indexOf(" ");
		return s > -1 && (n = de(t.slice(s)), t = t.slice(0, s)), m(e) ? (i = e, e = void 0) : e && "object" == typeof e && (r = "POST"), a.length > 0 && w.ajax({url: t, type: r || "GET", dataType: "html", data: e}).done(function (t) {
			o = arguments, a.html(n ? w("<div>").append(w.parseHTML(t)).find(n) : t)
		}).always(i && function (t, e) {
			a.each(function () {
				i.apply(this, o || [t.responseText, e, t])
			})
		}), this
	}, w.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (t, e) {
		w.fn[e] = function (t) {
			return this.on(e, t)
		}
	}), w.expr.pseudos.animated = function (t) {
		return w.grep(w.timers, function (e) {
			return t === e.elem
		}).length
	}, w.offset = {
		setOffset: function (t, e, i) {
			var n, r, o, a, s, l, c = w.css(t, "position"), u = w(t), h = {};
			"static" === c && (t.style.position = "relative"), s = u.offset(), o = w.css(t, "top"), l = w.css(t, "left"), ("absolute" === c || "fixed" === c) && (o + l).indexOf("auto") > -1 ? (a = (n = u.position()).top, r = n.left) : (a = parseFloat(o) || 0, r = parseFloat(l) || 0), m(e) && (e = e.call(t, i, w.extend({}, s))), null != e.top && (h.top = e.top - s.top + a), null != e.left && (h.left = e.left - s.left + r), "using" in e ? e.using.call(t, h) : u.css(h)
		}
	}, w.fn.extend({
		offset: function (t) {
			if (arguments.length) return void 0 === t ? this : this.each(function (e) {
				w.offset.setOffset(this, t, e)
			});
			var e, i, n = this[0];
			return n ? n.getClientRects().length ? (e = n.getBoundingClientRect(), i = n.ownerDocument.defaultView, {top: e.top + i.pageYOffset, left: e.left + i.pageXOffset}) : {top: 0, left: 0} : void 0
		}, position: function () {
			if (this[0]) {
				var t, e, i, n = this[0], r = {top: 0, left: 0};
				if ("fixed" === w.css(n, "position")) e = n.getBoundingClientRect(); else {
					for (e = this.offset(), i = n.ownerDocument, t = n.offsetParent || i.documentElement; t && (t === i.body || t === i.documentElement) && "static" === w.css(t, "position");) t = t.parentNode;
					t && t !== n && 1 === t.nodeType && ((r = w(t).offset()).top += w.css(t, "borderTopWidth", !0), r.left += w.css(t, "borderLeftWidth", !0))
				}
				return {top: e.top - r.top - w.css(n, "marginTop", !0), left: e.left - r.left - w.css(n, "marginLeft", !0)}
			}
		}, offsetParent: function () {
			return this.map(function () {
				for (var t = this.offsetParent; t && "static" === w.css(t, "position");) t = t.offsetParent;
				return t || bt
			})
		}
	}), w.each({scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function (t, e) {
		var i = "pageYOffset" === e;
		w.fn[t] = function (n) {
			return j(this, function (t, n, r) {
				var o;
				if (g(t) ? o = t : 9 === t.nodeType && (o = t.defaultView), void 0 === r) return o ? o[e] : t[n];
				o ? o.scrollTo(i ? o.pageXOffset : r, i ? r : o.pageYOffset) : t[n] = r
			}, t, n, arguments.length)
		}
	}), w.each(["top", "left"], function (t, e) {
		w.cssHooks[e] = zt(f.pixelPosition, function (t, i) {
			if (i) return i = Bt(t, e), Rt.test(i) ? w(t).position()[e] + "px" : i
		})
	}), w.each({Height: "height", Width: "width"}, function (t, e) {
		w.each({padding: "inner" + t, content: e, "": "outer" + t}, function (i, n) {
			w.fn[n] = function (r, o) {
				var a = arguments.length && (i || "boolean" != typeof r), s = i || (!0 === r || !0 === o ? "margin" : "border");
				return j(this, function (e, i, r) {
					var o;
					return g(e) ? 0 === n.indexOf("outer") ? e["inner" + t] : e.document.documentElement["client" + t] : 9 === e.nodeType ? (o = e.documentElement, Math.max(e.body["scroll" + t], o["scroll" + t], e.body["offset" + t], o["offset" + t], o["client" + t])) : void 0 === r ? w.css(e, i, s) : w.style(e, i, r, s)
				}, e, a ? r : void 0, a)
			}
		})
	}), w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (t, e) {
		w.fn[e] = function (t, i) {
			return arguments.length > 0 ? this.on(e, null, t, i) : this.trigger(e)
		}
	}), w.fn.extend({
		hover: function (t, e) {
			return this.mouseenter(t).mouseleave(e || t)
		}
	}), w.fn.extend({
		bind: function (t, e, i) {
			return this.on(t, null, e, i)
		}, unbind: function (t, e) {
			return this.off(t, null, e)
		}, delegate: function (t, e, i, n) {
			return this.on(e, t, i, n)
		}, undelegate: function (t, e, i) {
			return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", i)
		}
	}), w.proxy = function (t, e) {
		var i, n, r;
		if ("string" == typeof e && (i = t[e], e = t, t = i), m(t)) return n = o.call(arguments, 2), (r = function () {
			return t.apply(e || this, n.concat(o.call(arguments)))
		}).guid = t.guid = t.guid || w.guid++, r
	}, w.holdReady = function (t) {
		t ? w.readyWait++ : w.ready(!0)
	}, w.isArray = Array.isArray, w.parseJSON = JSON.parse, w.nodeName = T, w.isFunction = m, w.isWindow = g, w.camelCase = V, w.type = b, w.now = Date.now, w.isNumeric = function (t) {
		var e = w.type(t);
		return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
	}, "function" == typeof define && define.amd && define("jquery", [], function () {
		return w
	});
	var We = t.jQuery, Ye = t.$;
	return w.noConflict = function (e) {
		return t.$ === w && (t.$ = Ye), e && t.jQuery === w && (t.jQuery = We), w
	}, e || (t.jQuery = t.$ = w), w
}), function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Popper = e()
}(this, function () {
	"use strict";
	for (var t = "undefined" != typeof window && "undefined" != typeof document, e = ["Edge", "Trident", "Firefox"], i = 0, n = 0; n < e.length; n += 1) if (t && navigator.userAgent.indexOf(e[n]) >= 0) {
		i = 1;
		break
	}
	var r = t && window.Promise ? function (t) {
		var e = !1;
		return function () {
			e || (e = !0, window.Promise.resolve().then(function () {
				e = !1, t()
			}))
		}
	} : function (t) {
		var e = !1;
		return function () {
			e || (e = !0, setTimeout(function () {
				e = !1, t()
			}, i))
		}
	};

	function o(t) {
		return t && "[object Function]" === {}.toString.call(t)
	}

	function a(t, e) {
		if (1 !== t.nodeType) return [];
		var i = t.ownerDocument.defaultView.getComputedStyle(t, null);
		return e ? i[e] : i
	}

	function s(t) {
		return "HTML" === t.nodeName ? t : t.parentNode || t.host
	}

	function l(t) {
		if (!t) return document.body;
		switch (t.nodeName) {
			case"HTML":
			case"BODY":
				return t.ownerDocument.body;
			case"#document":
				return t.body
		}
		var e = a(t), i = e.overflow, n = e.overflowX, r = e.overflowY;
		return /(auto|scroll|overlay)/.test(i + r + n) ? t : l(s(t))
	}

	var c = t && !(!window.MSInputMethodContext || !document.documentMode), u = t && /MSIE 10/.test(navigator.userAgent);

	function h(t) {
		return 11 === t ? c : 10 === t ? u : c || u
	}

	function d(t) {
		if (!t) return document.documentElement;
		for (var e = h(10) ? document.body : null, i = t.offsetParent || null; i === e && t.nextElementSibling;) i = (t = t.nextElementSibling).offsetParent;
		var n = i && i.nodeName;
		return n && "BODY" !== n && "HTML" !== n ? -1 !== ["TH", "TD", "TABLE"].indexOf(i.nodeName) && "static" === a(i, "position") ? d(i) : i : t ? t.ownerDocument.documentElement : document.documentElement
	}

	function p(t) {
		return null !== t.parentNode ? p(t.parentNode) : t
	}

	function f(t, e) {
		if (!(t && t.nodeType && e && e.nodeType)) return document.documentElement;
		var i = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING, n = i ? t : e, r = i ? e : t, o = document.createRange();
		o.setStart(n, 0), o.setEnd(r, 0);
		var a, s, l = o.commonAncestorContainer;
		if (t !== l && e !== l || n.contains(r)) return "BODY" === (s = (a = l).nodeName) || "HTML" !== s && d(a.firstElementChild) !== a ? d(l) : l;
		var c = p(t);
		return c.host ? f(c.host, e) : f(t, p(e).host)
	}

	function m(t) {
		var e = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft", i = t.nodeName;
		if ("BODY" === i || "HTML" === i) {
			var n = t.ownerDocument.documentElement;
			return (t.ownerDocument.scrollingElement || n)[e]
		}
		return t[e]
	}

	function g(t, e) {
		var i = "x" === e ? "Left" : "Top", n = "Left" === i ? "Right" : "Bottom";
		return parseFloat(t["border" + i + "Width"], 10) + parseFloat(t["border" + n + "Width"], 10)
	}

	function v(t, e, i, n) {
		return Math.max(e["offset" + t], e["scroll" + t], i["client" + t], i["offset" + t], i["scroll" + t], h(10) ? parseInt(i["offset" + t]) + parseInt(n["margin" + ("Height" === t ? "Top" : "Left")]) + parseInt(n["margin" + ("Height" === t ? "Bottom" : "Right")]) : 0)
	}

	function y(t) {
		var e = t.body, i = t.documentElement, n = h(10) && getComputedStyle(i);
		return {height: v("Height", e, i, n), width: v("Width", e, i, n)}
	}

	var b = function (t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}, w = function () {
		function t(t, e) {
			for (var i = 0; i < e.length; i++) {
				var n = e[i];
				n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
			}
		}

		return function (e, i, n) {
			return i && t(e.prototype, i), n && t(e, n), e
		}
	}(), x = function (t, e, i) {
		return e in t ? Object.defineProperty(t, e, {value: i, enumerable: !0, configurable: !0, writable: !0}) : t[e] = i, t
	}, k = Object.assign || function (t) {
		for (var e = 1; e < arguments.length; e++) {
			var i = arguments[e];
			for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
		}
		return t
	};

	function _(t) {
		return k({}, t, {right: t.left + t.width, bottom: t.top + t.height})
	}

	function S(t) {
		var e = {};
		try {
			if (h(10)) {
				e = t.getBoundingClientRect();
				var i = m(t, "top"), n = m(t, "left");
				e.top += i, e.left += n, e.bottom += i, e.right += n
			} else e = t.getBoundingClientRect()
		} catch (t) {
		}
		var r = {left: e.left, top: e.top, width: e.right - e.left, height: e.bottom - e.top}, o = "HTML" === t.nodeName ? y(t.ownerDocument) : {}, s = o.width || t.clientWidth || r.right - r.left, l = o.height || t.clientHeight || r.bottom - r.top, c = t.offsetWidth - s, u = t.offsetHeight - l;
		if (c || u) {
			var d = a(t);
			c -= g(d, "x"), u -= g(d, "y"), r.width -= c, r.height -= u
		}
		return _(r)
	}

	function C(t, e) {
		var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = h(10), r = "HTML" === e.nodeName, o = S(t), s = S(e), c = l(t), u = a(e), d = parseFloat(u.borderTopWidth, 10), p = parseFloat(u.borderLeftWidth, 10);
		i && r && (s.top = Math.max(s.top, 0), s.left = Math.max(s.left, 0));
		var f = _({top: o.top - s.top - d, left: o.left - s.left - p, width: o.width, height: o.height});
		if (f.marginTop = 0, f.marginLeft = 0, !n && r) {
			var g = parseFloat(u.marginTop, 10), v = parseFloat(u.marginLeft, 10);
			f.top -= d - g, f.bottom -= d - g, f.left -= p - v, f.right -= p - v, f.marginTop = g, f.marginLeft = v
		}
		return (n && !i ? e.contains(c) : e === c && "BODY" !== c.nodeName) && (f = function (t, e) {
			var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = m(e, "top"), r = m(e, "left"), o = i ? -1 : 1;
			return t.top += n * o, t.bottom += n * o, t.left += r * o, t.right += r * o, t
		}(f, e)), f
	}

	function D(t) {
		if (!t || !t.parentElement || h()) return document.documentElement;
		for (var e = t.parentElement; e && "none" === a(e, "transform");) e = e.parentElement;
		return e || document.documentElement
	}

	function T(t, e, i, n) {
		var r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = {top: 0, left: 0}, c = r ? D(t) : f(t, e);
		if ("viewport" === n) o = function (t) {
			var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], i = t.ownerDocument.documentElement, n = C(t, i), r = Math.max(i.clientWidth, window.innerWidth || 0), o = Math.max(i.clientHeight, window.innerHeight || 0), a = e ? 0 : m(i), s = e ? 0 : m(i, "left");
			return _({top: a - n.top + n.marginTop, left: s - n.left + n.marginLeft, width: r, height: o})
		}(c, r); else {
			var u = void 0;
			"scrollParent" === n ? "BODY" === (u = l(s(e))).nodeName && (u = t.ownerDocument.documentElement) : u = "window" === n ? t.ownerDocument.documentElement : n;
			var h = C(u, c, r);
			if ("HTML" !== u.nodeName || function t(e) {
				var i = e.nodeName;
				return "BODY" !== i && "HTML" !== i && ("fixed" === a(e, "position") || t(s(e)))
			}(c)) o = h; else {
				var d = y(t.ownerDocument), p = d.height, g = d.width;
				o.top += h.top - h.marginTop, o.bottom = p + h.top, o.left += h.left - h.marginLeft, o.right = g + h.left
			}
		}
		var v = "number" == typeof (i = i || 0);
		return o.left += v ? i : i.left || 0, o.top += v ? i : i.top || 0, o.right -= v ? i : i.right || 0, o.bottom -= v ? i : i.bottom || 0, o
	}

	function M(t, e, i, n, r) {
		var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
		if (-1 === t.indexOf("auto")) return t;
		var a = T(i, n, o, r), s = {top: {width: a.width, height: e.top - a.top}, right: {width: a.right - e.right, height: a.height}, bottom: {width: a.width, height: a.bottom - e.bottom}, left: {width: e.left - a.left, height: a.height}}, l = Object.keys(s).map(function (t) {
			return k({key: t}, s[t], {area: (e = s[t], e.width * e.height)});
			var e
		}).sort(function (t, e) {
			return e.area - t.area
		}), c = l.filter(function (t) {
			var e = t.width, n = t.height;
			return e >= i.clientWidth && n >= i.clientHeight
		}), u = c.length > 0 ? c[0].key : l[0].key, h = t.split("-")[1];
		return u + (h ? "-" + h : "")
	}

	function E(t, e, i) {
		var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
		return C(i, n ? D(e) : f(e, i), n)
	}

	function A(t) {
		var e = t.ownerDocument.defaultView.getComputedStyle(t), i = parseFloat(e.marginTop || 0) + parseFloat(e.marginBottom || 0), n = parseFloat(e.marginLeft || 0) + parseFloat(e.marginRight || 0);
		return {width: t.offsetWidth + n, height: t.offsetHeight + i}
	}

	function P(t) {
		var e = {left: "right", right: "left", bottom: "top", top: "bottom"};
		return t.replace(/left|right|bottom|top/g, function (t) {
			return e[t]
		})
	}

	function I(t, e, i) {
		i = i.split("-")[0];
		var n = A(t), r = {width: n.width, height: n.height}, o = -1 !== ["right", "left"].indexOf(i), a = o ? "top" : "left", s = o ? "left" : "top", l = o ? "height" : "width", c = o ? "width" : "height";
		return r[a] = e[a] + e[l] / 2 - n[l] / 2, r[s] = i === s ? e[s] - n[c] : e[P(s)], r
	}

	function O(t, e) {
		return Array.prototype.find ? t.find(e) : t.filter(e)[0]
	}

	function L(t, e, i) {
		return (void 0 === i ? t : t.slice(0, function (t, e, i) {
			if (Array.prototype.findIndex) return t.findIndex(function (t) {
				return t[e] === i
			});
			var n = O(t, function (t) {
				return t[e] === i
			});
			return t.indexOf(n)
		}(t, "name", i))).forEach(function (t) {
			t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
			var i = t.function || t.fn;
			t.enabled && o(i) && (e.offsets.popper = _(e.offsets.popper), e.offsets.reference = _(e.offsets.reference), e = i(e, t))
		}), e
	}

	function F(t, e) {
		return t.some(function (t) {
			var i = t.name;
			return t.enabled && i === e
		})
	}

	function N(t) {
		for (var e = [!1, "ms", "Webkit", "Moz", "O"], i = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < e.length; n++) {
			var r = e[n], o = r ? "" + r + i : t;
			if (void 0 !== document.body.style[o]) return o
		}
		return null
	}

	function R(t) {
		var e = t.ownerDocument;
		return e ? e.defaultView : window
	}

	function H(t, e, i, n) {
		i.updateBound = n, R(t).addEventListener("resize", i.updateBound, {passive: !0});
		var r = l(t);
		return function t(e, i, n, r) {
			var o = "BODY" === e.nodeName, a = o ? e.ownerDocument.defaultView : e;
			a.addEventListener(i, n, {passive: !0}), o || t(l(a.parentNode), i, n, r), r.push(a)
		}(r, "scroll", i.updateBound, i.scrollParents), i.scrollElement = r, i.eventsEnabled = !0, i
	}

	function $() {
		var t, e;
		this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (t = this.reference, e = this.state, R(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function (t) {
			t.removeEventListener("scroll", e.updateBound)
		}), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e))
	}

	function B(t) {
		return "" !== t && !isNaN(parseFloat(t)) && isFinite(t)
	}

	function z(t, e) {
		Object.keys(e).forEach(function (i) {
			var n = "";
			-1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(i) && B(e[i]) && (n = "px"), t.style[i] = e[i] + n
		})
	}

	var j = t && /Firefox/i.test(navigator.userAgent);

	function U(t, e, i) {
		var n = O(t, function (t) {
			return t.name === e
		}), r = !!n && t.some(function (t) {
			return t.name === i && t.enabled && t.order < n.order
		});
		if (!r) {
			var o = "`" + e + "`", a = "`" + i + "`";
			console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
		}
		return r
	}

	var W = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], Y = W.slice(3);

	function V(t) {
		var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], i = Y.indexOf(t), n = Y.slice(i + 1).concat(Y.slice(0, i));
		return e ? n.reverse() : n
	}

	var q = {FLIP: "flip", CLOCKWISE: "clockwise", COUNTERCLOCKWISE: "counterclockwise"};

	function G(t, e, i, n) {
		var r = [0, 0], o = -1 !== ["right", "left"].indexOf(n), a = t.split(/(\+|\-)/).map(function (t) {
			return t.trim()
		}), s = a.indexOf(O(a, function (t) {
			return -1 !== t.search(/,|\s/)
		}));
		a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
		var l = /\s*,\s*|\s+/, c = -1 !== s ? [a.slice(0, s).concat([a[s].split(l)[0]]), [a[s].split(l)[1]].concat(a.slice(s + 1))] : [a];
		return (c = c.map(function (t, n) {
			var r = (1 === n ? !o : o) ? "height" : "width", a = !1;
			return t.reduce(function (t, e) {
				return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e) ? (t[t.length - 1] = e, a = !0, t) : a ? (t[t.length - 1] += e, a = !1, t) : t.concat(e)
			}, []).map(function (t) {
				return function (t, e, i, n) {
					var r = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), o = +r[1], a = r[2];
					if (!o) return t;
					if (0 === a.indexOf("%")) {
						var s = void 0;
						switch (a) {
							case"%p":
								s = i;
								break;
							case"%":
							case"%r":
							default:
								s = n
						}
						return _(s)[e] / 100 * o
					}
					if ("vh" === a || "vw" === a) return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;
					return o
				}(t, r, e, i)
			})
		})).forEach(function (t, e) {
			t.forEach(function (i, n) {
				B(i) && (r[e] += i * ("-" === t[n - 1] ? -1 : 1))
			})
		}), r
	}

	var K = {
		placement: "bottom", positionFixed: !1, eventsEnabled: !0, removeOnDestroy: !1, onCreate: function () {
		}, onUpdate: function () {
		}, modifiers: {
			shift: {
				order: 100, enabled: !0, fn: function (t) {
					var e = t.placement, i = e.split("-")[0], n = e.split("-")[1];
					if (n) {
						var r = t.offsets, o = r.reference, a = r.popper, s = -1 !== ["bottom", "top"].indexOf(i), l = s ? "left" : "top", c = s ? "width" : "height", u = {start: x({}, l, o[l]), end: x({}, l, o[l] + o[c] - a[c])};
						t.offsets.popper = k({}, a, u[n])
					}
					return t
				}
			}, offset: {
				order: 200, enabled: !0, fn: function (t, e) {
					var i = e.offset, n = t.placement, r = t.offsets, o = r.popper, a = r.reference, s = n.split("-")[0], l = void 0;
					return l = B(+i) ? [+i, 0] : G(i, o, a, s), "left" === s ? (o.top += l[0], o.left -= l[1]) : "right" === s ? (o.top += l[0], o.left += l[1]) : "top" === s ? (o.left += l[0], o.top -= l[1]) : "bottom" === s && (o.left += l[0], o.top += l[1]), t.popper = o, t
				}, offset: 0
			}, preventOverflow: {
				order: 300, enabled: !0, fn: function (t, e) {
					var i = e.boundariesElement || d(t.instance.popper);
					t.instance.reference === i && (i = d(i));
					var n = N("transform"), r = t.instance.popper.style, o = r.top, a = r.left, s = r[n];
					r.top = "", r.left = "", r[n] = "";
					var l = T(t.instance.popper, t.instance.reference, e.padding, i, t.positionFixed);
					r.top = o, r.left = a, r[n] = s, e.boundaries = l;
					var c = e.priority, u = t.offsets.popper, h = {
						primary: function (t) {
							var i = u[t];
							return u[t] < l[t] && !e.escapeWithReference && (i = Math.max(u[t], l[t])), x({}, t, i)
						}, secondary: function (t) {
							var i = "right" === t ? "left" : "top", n = u[i];
							return u[t] > l[t] && !e.escapeWithReference && (n = Math.min(u[i], l[t] - ("right" === t ? u.width : u.height))), x({}, i, n)
						}
					};
					return c.forEach(function (t) {
						var e = -1 !== ["left", "top"].indexOf(t) ? "primary" : "secondary";
						u = k({}, u, h[e](t))
					}), t.offsets.popper = u, t
				}, priority: ["left", "right", "top", "bottom"], padding: 5, boundariesElement: "scrollParent"
			}, keepTogether: {
				order: 400, enabled: !0, fn: function (t) {
					var e = t.offsets, i = e.popper, n = e.reference, r = t.placement.split("-")[0], o = Math.floor, a = -1 !== ["top", "bottom"].indexOf(r), s = a ? "right" : "bottom", l = a ? "left" : "top", c = a ? "width" : "height";
					return i[s] < o(n[l]) && (t.offsets.popper[l] = o(n[l]) - i[c]), i[l] > o(n[s]) && (t.offsets.popper[l] = o(n[s])), t
				}
			}, arrow: {
				order: 500, enabled: !0, fn: function (t, e) {
					var i;
					if (!U(t.instance.modifiers, "arrow", "keepTogether")) return t;
					var n = e.element;
					if ("string" == typeof n) {
						if (!(n = t.instance.popper.querySelector(n))) return t
					} else if (!t.instance.popper.contains(n)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
					var r = t.placement.split("-")[0], o = t.offsets, s = o.popper, l = o.reference, c = -1 !== ["left", "right"].indexOf(r), u = c ? "height" : "width", h = c ? "Top" : "Left", d = h.toLowerCase(), p = c ? "left" : "top", f = c ? "bottom" : "right", m = A(n)[u];
					l[f] - m < s[d] && (t.offsets.popper[d] -= s[d] - (l[f] - m)), l[d] + m > s[f] && (t.offsets.popper[d] += l[d] + m - s[f]), t.offsets.popper = _(t.offsets.popper);
					var g = l[d] + l[u] / 2 - m / 2, v = a(t.instance.popper), y = parseFloat(v["margin" + h], 10), b = parseFloat(v["border" + h + "Width"], 10), w = g - t.offsets.popper[d] - y - b;
					return w = Math.max(Math.min(s[u] - m, w), 0), t.arrowElement = n, t.offsets.arrow = (x(i = {}, d, Math.round(w)), x(i, p, ""), i), t
				}, element: "[x-arrow]"
			}, flip: {
				order: 600, enabled: !0, fn: function (t, e) {
					if (F(t.instance.modifiers, "inner")) return t;
					if (t.flipped && t.placement === t.originalPlacement) return t;
					var i = T(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed), n = t.placement.split("-")[0], r = P(n), o = t.placement.split("-")[1] || "", a = [];
					switch (e.behavior) {
						case q.FLIP:
							a = [n, r];
							break;
						case q.CLOCKWISE:
							a = V(n);
							break;
						case q.COUNTERCLOCKWISE:
							a = V(n, !0);
							break;
						default:
							a = e.behavior
					}
					return a.forEach(function (s, l) {
						if (n !== s || a.length === l + 1) return t;
						n = t.placement.split("-")[0], r = P(n);
						var c = t.offsets.popper, u = t.offsets.reference, h = Math.floor, d = "left" === n && h(c.right) > h(u.left) || "right" === n && h(c.left) < h(u.right) || "top" === n && h(c.bottom) > h(u.top) || "bottom" === n && h(c.top) < h(u.bottom), p = h(c.left) < h(i.left),
							f = h(c.right) > h(i.right), m = h(c.top) < h(i.top), g = h(c.bottom) > h(i.bottom), v = "left" === n && p || "right" === n && f || "top" === n && m || "bottom" === n && g, y = -1 !== ["top", "bottom"].indexOf(n),
							b = !!e.flipVariations && (y && "start" === o && p || y && "end" === o && f || !y && "start" === o && m || !y && "end" === o && g);
						(d || v || b) && (t.flipped = !0, (d || v) && (n = a[l + 1]), b && (o = function (t) {
							return "end" === t ? "start" : "start" === t ? "end" : t
						}(o)), t.placement = n + (o ? "-" + o : ""), t.offsets.popper = k({}, t.offsets.popper, I(t.instance.popper, t.offsets.reference, t.placement)), t = L(t.instance.modifiers, t, "flip"))
					}), t
				}, behavior: "flip", padding: 5, boundariesElement: "viewport"
			}, inner: {
				order: 700, enabled: !1, fn: function (t) {
					var e = t.placement, i = e.split("-")[0], n = t.offsets, r = n.popper, o = n.reference, a = -1 !== ["left", "right"].indexOf(i), s = -1 === ["top", "left"].indexOf(i);
					return r[a ? "left" : "top"] = o[i] - (s ? r[a ? "width" : "height"] : 0), t.placement = P(e), t.offsets.popper = _(r), t
				}
			}, hide: {
				order: 800, enabled: !0, fn: function (t) {
					if (!U(t.instance.modifiers, "hide", "preventOverflow")) return t;
					var e = t.offsets.reference, i = O(t.instance.modifiers, function (t) {
						return "preventOverflow" === t.name
					}).boundaries;
					if (e.bottom < i.top || e.left > i.right || e.top > i.bottom || e.right < i.left) {
						if (!0 === t.hide) return t;
						t.hide = !0, t.attributes["x-out-of-boundaries"] = ""
					} else {
						if (!1 === t.hide) return t;
						t.hide = !1, t.attributes["x-out-of-boundaries"] = !1
					}
					return t
				}
			}, computeStyle: {
				order: 850, enabled: !0, fn: function (t, e) {
					var i = e.x, n = e.y, r = t.offsets.popper, o = O(t.instance.modifiers, function (t) {
						return "applyStyle" === t.name
					}).gpuAcceleration;
					void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
					var a = void 0 !== o ? o : e.gpuAcceleration, s = d(t.instance.popper), l = S(s), c = {position: r.position}, u = function (t, e) {
						var i = t.offsets, n = i.popper, r = i.reference, o = -1 !== ["left", "right"].indexOf(t.placement), a = -1 !== t.placement.indexOf("-"), s = r.width % 2 == n.width % 2, l = r.width % 2 == 1 && n.width % 2 == 1, c = function (t) {
							return t
						}, u = e ? o || a || s ? Math.round : Math.floor : c, h = e ? Math.round : c;
						return {left: u(l && !a && e ? n.left - 1 : n.left), top: h(n.top), bottom: h(n.bottom), right: u(n.right)}
					}(t, window.devicePixelRatio < 2 || !j), h = "bottom" === i ? "top" : "bottom", p = "right" === n ? "left" : "right", f = N("transform"), m = void 0, g = void 0;
					if (g = "bottom" === h ? "HTML" === s.nodeName ? -s.clientHeight + u.bottom : -l.height + u.bottom : u.top, m = "right" === p ? "HTML" === s.nodeName ? -s.clientWidth + u.right : -l.width + u.right : u.left, a && f) c[f] = "translate3d(" + m + "px, " + g + "px, 0)", c[h] = 0, c[p] = 0, c.willChange = "transform"; else {
						var v = "bottom" === h ? -1 : 1, y = "right" === p ? -1 : 1;
						c[h] = g * v, c[p] = m * y, c.willChange = h + ", " + p
					}
					var b = {"x-placement": t.placement};
					return t.attributes = k({}, b, t.attributes), t.styles = k({}, c, t.styles), t.arrowStyles = k({}, t.offsets.arrow, t.arrowStyles), t
				}, gpuAcceleration: !0, x: "bottom", y: "right"
			}, applyStyle: {
				order: 900, enabled: !0, fn: function (t) {
					var e, i;
					return z(t.instance.popper, t.styles), e = t.instance.popper, i = t.attributes, Object.keys(i).forEach(function (t) {
						!1 !== i[t] ? e.setAttribute(t, i[t]) : e.removeAttribute(t)
					}), t.arrowElement && Object.keys(t.arrowStyles).length && z(t.arrowElement, t.arrowStyles), t
				}, onLoad: function (t, e, i, n, r) {
					var o = E(r, e, t, i.positionFixed), a = M(i.placement, o, e, t, i.modifiers.flip.boundariesElement, i.modifiers.flip.padding);
					return e.setAttribute("x-placement", a), z(e, {position: i.positionFixed ? "fixed" : "absolute"}), i
				}, gpuAcceleration: void 0
			}
		}
	}, X = function () {
		function t(e, i) {
			var n = this, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
			b(this, t), this.scheduleUpdate = function () {
				return requestAnimationFrame(n.update)
			}, this.update = r(this.update.bind(this)), this.options = k({}, t.Defaults, a), this.state = {
				isDestroyed: !1,
				isCreated: !1,
				scrollParents: []
			}, this.reference = e && e.jquery ? e[0] : e, this.popper = i && i.jquery ? i[0] : i, this.options.modifiers = {}, Object.keys(k({}, t.Defaults.modifiers, a.modifiers)).forEach(function (e) {
				n.options.modifiers[e] = k({}, t.Defaults.modifiers[e] || {}, a.modifiers ? a.modifiers[e] : {})
			}), this.modifiers = Object.keys(this.options.modifiers).map(function (t) {
				return k({name: t}, n.options.modifiers[t])
			}).sort(function (t, e) {
				return t.order - e.order
			}), this.modifiers.forEach(function (t) {
				t.enabled && o(t.onLoad) && t.onLoad(n.reference, n.popper, n.options, t, n.state)
			}), this.update();
			var s = this.options.eventsEnabled;
			s && this.enableEventListeners(), this.state.eventsEnabled = s
		}

		return w(t, [{
			key: "update", value: function () {
				return function () {
					if (!this.state.isDestroyed) {
						var t = {instance: this, styles: {}, arrowStyles: {}, attributes: {}, flipped: !1, offsets: {}};
						t.offsets.reference = E(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = M(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = I(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = L(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t))
					}
				}.call(this)
			}
		}, {
			key: "destroy", value: function () {
				return function () {
					return this.state.isDestroyed = !0, F(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[N("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this
				}.call(this)
			}
		}, {
			key: "enableEventListeners", value: function () {
				return function () {
					this.state.eventsEnabled || (this.state = H(this.reference, this.options, this.state, this.scheduleUpdate))
				}.call(this)
			}
		}, {
			key: "disableEventListeners", value: function () {
				return $.call(this)
			}
		}]), t
	}();
	return X.Utils = ("undefined" != typeof window ? window : global).PopperUtils, X.placements = W, X.Defaults = K, X
}), function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? e(exports, require("jquery"), require("popper.js")) : "function" == typeof define && define.amd ? define(["exports", "jquery", "popper.js"], e) : e(t.bootstrap = {}, t.jQuery, t.Popper)
}(this, function (t, e, i) {
	"use strict";

	function n(t, e) {
		for (var i = 0; i < e.length; i++) {
			var n = e[i];
			n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
		}
	}

	function r(t, e, i) {
		return e && n(t.prototype, e), i && n(t, i), t
	}

	function o(t) {
		for (var e = 1; e < arguments.length; e++) {
			var i = null != arguments[e] ? arguments[e] : {}, n = Object.keys(i);
			"function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(i).filter(function (t) {
				return Object.getOwnPropertyDescriptor(i, t).enumerable
			}))), n.forEach(function (e) {
				var n, r, o;
				n = t, o = i[r = e], r in n ? Object.defineProperty(n, r, {value: o, enumerable: !0, configurable: !0, writable: !0}) : n[r] = o
			})
		}
		return t
	}

	e = e && e.hasOwnProperty("default") ? e.default : e, i = i && i.hasOwnProperty("default") ? i.default : i;
	var a, s, l, c, u, h, d, p, f, m, g, v, y, b, w, x, k, _, S, C, D, T, M, E, A, P, I, O, L, F, N, R, H, $, B, z, j, U, W, Y, V, q, G, K, X, Z, Q, J, tt, et, it, nt, rt, ot, at, st, lt, ct, ut, ht, dt, pt, ft, mt, gt, vt, yt, bt, wt, xt, kt, _t, St, Ct, Dt, Tt, Mt, Et, At, Pt, It, Ot, Lt, Ft, Nt,
		Rt, Ht, $t, Bt, zt, jt, Ut, Wt, Yt, Vt, qt, Gt, Kt, Xt, Zt, Qt, Jt, te, ee, ie, ne, re, oe, ae, se, le, ce, ue, he, de, pe, fe, me, ge, ve, ye, be, we, xe, ke, _e, Se, Ce, De, Te, Me = function (t) {
			var e = "transitionend";
			var i = {
				TRANSITION_END: "bsTransitionEnd", getUID: function (t) {
					for (; t += ~~(1e6 * Math.random()), document.getElementById(t);) ;
					return t
				}, getSelectorFromElement: function (t) {
					var e = t.getAttribute("data-target");
					e && "#" !== e || (e = t.getAttribute("href") || "");
					try {
						return document.querySelector(e) ? e : null
					} catch (t) {
						return null
					}
				}, getTransitionDurationFromElement: function (e) {
					if (!e) return 0;
					var i = t(e).css("transition-duration");
					return parseFloat(i) ? (i = i.split(",")[0], 1e3 * parseFloat(i)) : 0
				}, reflow: function (t) {
					return t.offsetHeight
				}, triggerTransitionEnd: function (i) {
					t(i).trigger(e)
				}, supportsTransitionEnd: function () {
					return Boolean(e)
				}, isElement: function (t) {
					return (t[0] || t).nodeType
				}, typeCheckConfig: function (t, e, n) {
					for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r)) {
						var o = n[r], a = e[r], s = a && i.isElement(a) ? "element" : (l = a, {}.toString.call(l).match(/\s([a-z]+)/i)[1].toLowerCase());
						if (!new RegExp(o).test(s)) throw new Error(t.toUpperCase() + ': Option "' + r + '" provided type "' + s + '" but expected type "' + o + '".')
					}
					var l
				}
			};
			return t.fn.emulateTransitionEnd = function (e) {
				var n = this, r = !1;
				return t(this).one(i.TRANSITION_END, function () {
					r = !0
				}), setTimeout(function () {
					r || i.triggerTransitionEnd(n)
				}, e), this
			}, t.event.special[i.TRANSITION_END] = {
				bindType: e, delegateType: e, handle: function (e) {
					if (t(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
				}
			}, i
		}(e), Ee = (s = "alert", c = "." + (l = "bs.alert"), u = (a = e).fn[s], h = {CLOSE: "close" + c, CLOSED: "closed" + c, CLICK_DATA_API: "click" + c + ".data-api"}, "alert", "fade", "show", d = function () {
			function t(t) {
				this._element = t
			}

			var e = t.prototype;
			return e.close = function (t) {
				var e = this._element;
				t && (e = this._getRootElement(t)), this._triggerCloseEvent(e).isDefaultPrevented() || this._removeElement(e)
			}, e.dispose = function () {
				a.removeData(this._element, l), this._element = null
			}, e._getRootElement = function (t) {
				var e = Me.getSelectorFromElement(t), i = !1;
				return e && (i = document.querySelector(e)), i || (i = a(t).closest(".alert")[0]), i
			}, e._triggerCloseEvent = function (t) {
				var e = a.Event(h.CLOSE);
				return a(t).trigger(e), e
			}, e._removeElement = function (t) {
				var e = this;
				if (a(t).removeClass("show"), a(t).hasClass("fade")) {
					var i = Me.getTransitionDurationFromElement(t);
					a(t).one(Me.TRANSITION_END, function (i) {
						return e._destroyElement(t, i)
					}).emulateTransitionEnd(i)
				} else this._destroyElement(t)
			}, e._destroyElement = function (t) {
				a(t).detach().trigger(h.CLOSED).remove()
			}, t._jQueryInterface = function (e) {
				return this.each(function () {
					var i = a(this), n = i.data(l);
					n || (n = new t(this), i.data(l, n)), "close" === e && n[e](this)
				})
			}, t._handleDismiss = function (t) {
				return function (e) {
					e && e.preventDefault(), t.close(this)
				}
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}]), t
		}(), a(document).on(h.CLICK_DATA_API, '[data-dismiss="alert"]', d._handleDismiss(new d)), a.fn[s] = d._jQueryInterface, a.fn[s].Constructor = d, a.fn[s].noConflict = function () {
			return a.fn[s] = u, d._jQueryInterface
		}, d), Ae = (f = "button", g = "." + (m = "bs.button"), v = ".data-api", y = (p = e).fn[f], b = "active", "btn", w = '[data-toggle^="button"]', '[data-toggle="buttons"]', "input", ".active", x = ".btn", k = {
			CLICK_DATA_API: "click" + g + v,
			FOCUS_BLUR_DATA_API: "focus" + g + v + " blur" + g + v
		}, _ = function () {
			function t(t) {
				this._element = t
			}

			var e = t.prototype;
			return e.toggle = function () {
				var t = !0, e = !0, i = p(this._element).closest('[data-toggle="buttons"]')[0];
				if (i) {
					var n = this._element.querySelector("input");
					if (n) {
						if ("radio" === n.type) if (n.checked && this._element.classList.contains(b)) t = !1; else {
							var r = i.querySelector(".active");
							r && p(r).removeClass(b)
						}
						if (t) {
							if (n.hasAttribute("disabled") || i.hasAttribute("disabled") || n.classList.contains("disabled") || i.classList.contains("disabled")) return;
							n.checked = !this._element.classList.contains(b), p(n).trigger("change")
						}
						n.focus(), e = !1
					}
				}
				e && this._element.setAttribute("aria-pressed", !this._element.classList.contains(b)), t && p(this._element).toggleClass(b)
			}, e.dispose = function () {
				p.removeData(this._element, m), this._element = null
			}, t._jQueryInterface = function (e) {
				return this.each(function () {
					var i = p(this).data(m);
					i || (i = new t(this), p(this).data(m, i)), "toggle" === e && i[e]()
				})
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}]), t
		}(), p(document).on(k.CLICK_DATA_API, w, function (t) {
			t.preventDefault();
			var e = t.target;
			p(e).hasClass("btn") || (e = p(e).closest(x)), _._jQueryInterface.call(p(e), "toggle")
		}).on(k.FOCUS_BLUR_DATA_API, w, function (t) {
			var e = p(t.target).closest(x)[0];
			p(e).toggleClass("focus", /^focus(in)?$/.test(t.type))
		}), p.fn[f] = _._jQueryInterface, p.fn[f].Constructor = _, p.fn[f].noConflict = function () {
			return p.fn[f] = y, _._jQueryInterface
		}, _), Pe = (C = "carousel", T = "." + (D = "bs.carousel"), M = ".data-api", E = (S = e).fn[C], A = {interval: 5e3, keyboard: !0, slide: !1, pause: "hover", wrap: !0}, P = {
			interval: "(number|boolean)",
			keyboard: "boolean",
			slide: "(boolean|string)",
			pause: "(string|boolean)",
			wrap: "boolean"
		}, I = "next", O = "prev", "left", "right", L = {
			SLIDE: "slide" + T,
			SLID: "slid" + T,
			KEYDOWN: "keydown" + T,
			MOUSEENTER: "mouseenter" + T,
			MOUSELEAVE: "mouseleave" + T,
			TOUCHEND: "touchend" + T,
			LOAD_DATA_API: "load" + T + M,
			CLICK_DATA_API: "click" + T + M
		}, "carousel", F = "active", "slide", "carousel-item-right", "carousel-item-left", "carousel-item-next", "carousel-item-prev", ".active", N = ".active.carousel-item", ".carousel-item", ".carousel-item-next, .carousel-item-prev", R = ".carousel-indicators", "[data-slide], [data-slide-to]", '[data-ride="carousel"]', H = function () {
			function t(t, e) {
				this._items = null, this._interval = null, this._activeElement = null, this._isPaused = !1, this._isSliding = !1, this.touchTimeout = null, this._config = this._getConfig(e), this._element = S(t)[0], this._indicatorsElement = this._element.querySelector(R), this._addEventListeners()
			}

			var e = t.prototype;
			return e.next = function () {
				this._isSliding || this._slide(I)
			}, e.nextWhenVisible = function () {
				!document.hidden && S(this._element).is(":visible") && "hidden" !== S(this._element).css("visibility") && this.next()
			}, e.prev = function () {
				this._isSliding || this._slide(O)
			}, e.pause = function (t) {
				t || (this._isPaused = !0), this._element.querySelector(".carousel-item-next, .carousel-item-prev") && (Me.triggerTransitionEnd(this._element), this.cycle(!0)), clearInterval(this._interval), this._interval = null
			}, e.cycle = function (t) {
				t || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), this._config.interval && !this._isPaused && (this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval))
			}, e.to = function (t) {
				var e = this;
				this._activeElement = this._element.querySelector(N);
				var i = this._getItemIndex(this._activeElement);
				if (!(t > this._items.length - 1 || t < 0)) if (this._isSliding) S(this._element).one(L.SLID, function () {
					return e.to(t)
				}); else {
					if (i === t) return this.pause(), void this.cycle();
					var n = i < t ? I : O;
					this._slide(n, this._items[t])
				}
			}, e.dispose = function () {
				S(this._element).off(T), S.removeData(this._element, D), this._items = null, this._config = null, this._element = null, this._interval = null, this._isPaused = null, this._isSliding = null, this._activeElement = null, this._indicatorsElement = null
			}, e._getConfig = function (t) {
				return t = o({}, A, t), Me.typeCheckConfig(C, t, P), t
			}, e._addEventListeners = function () {
				var t = this;
				this._config.keyboard && S(this._element).on(L.KEYDOWN, function (e) {
					return t._keydown(e)
				}), "hover" === this._config.pause && (S(this._element).on(L.MOUSEENTER, function (e) {
					return t.pause(e)
				}).on(L.MOUSELEAVE, function (e) {
					return t.cycle(e)
				}), "ontouchstart" in document.documentElement && S(this._element).on(L.TOUCHEND, function () {
					t.pause(), t.touchTimeout && clearTimeout(t.touchTimeout), t.touchTimeout = setTimeout(function (e) {
						return t.cycle(e)
					}, 500 + t._config.interval)
				}))
			}, e._keydown = function (t) {
				if (!/input|textarea/i.test(t.target.tagName)) switch (t.which) {
					case 37:
						t.preventDefault(), this.prev();
						break;
					case 39:
						t.preventDefault(), this.next()
				}
			}, e._getItemIndex = function (t) {
				return this._items = t && t.parentNode ? [].slice.call(t.parentNode.querySelectorAll(".carousel-item")) : [], this._items.indexOf(t)
			}, e._getItemByDirection = function (t, e) {
				var i = t === I, n = t === O, r = this._getItemIndex(e), o = this._items.length - 1;
				if ((n && 0 === r || i && r === o) && !this._config.wrap) return e;
				var a = (r + (t === O ? -1 : 1)) % this._items.length;
				return -1 === a ? this._items[this._items.length - 1] : this._items[a]
			}, e._triggerSlideEvent = function (t, e) {
				var i = this._getItemIndex(t), n = this._getItemIndex(this._element.querySelector(N)), r = S.Event(L.SLIDE, {relatedTarget: t, direction: e, from: n, to: i});
				return S(this._element).trigger(r), r
			}, e._setActiveIndicatorElement = function (t) {
				if (this._indicatorsElement) {
					var e = [].slice.call(this._indicatorsElement.querySelectorAll(".active"));
					S(e).removeClass(F);
					var i = this._indicatorsElement.children[this._getItemIndex(t)];
					i && S(i).addClass(F)
				}
			}, e._slide = function (t, e) {
				var i, n, r, o = this, a = this._element.querySelector(N), s = this._getItemIndex(a), l = e || a && this._getItemByDirection(t, a), c = this._getItemIndex(l), u = Boolean(this._interval);
				if (t === I ? (i = "carousel-item-left", n = "carousel-item-next", r = "left") : (i = "carousel-item-right", n = "carousel-item-prev", r = "right"), l && S(l).hasClass(F)) this._isSliding = !1; else if (!this._triggerSlideEvent(l, r).isDefaultPrevented() && a && l) {
					this._isSliding = !0, u && this.pause(), this._setActiveIndicatorElement(l);
					var h = S.Event(L.SLID, {relatedTarget: l, direction: r, from: s, to: c});
					if (S(this._element).hasClass("slide")) {
						S(l).addClass(n), Me.reflow(l), S(a).addClass(i), S(l).addClass(i);
						var d = Me.getTransitionDurationFromElement(a);
						S(a).one(Me.TRANSITION_END, function () {
							S(l).removeClass(i + " " + n).addClass(F), S(a).removeClass(F + " " + n + " " + i), o._isSliding = !1, setTimeout(function () {
								return S(o._element).trigger(h)
							}, 0)
						}).emulateTransitionEnd(d)
					} else S(a).removeClass(F), S(l).addClass(F), this._isSliding = !1, S(this._element).trigger(h);
					u && this.cycle()
				}
			}, t._jQueryInterface = function (e) {
				return this.each(function () {
					var i = S(this).data(D), n = o({}, A, S(this).data());
					"object" == typeof e && (n = o({}, n, e));
					var r = "string" == typeof e ? e : n.slide;
					if (i || (i = new t(this, n), S(this).data(D, i)), "number" == typeof e) i.to(e); else if ("string" == typeof r) {
						if (void 0 === i[r]) throw new TypeError('No method named "' + r + '"');
						i[r]()
					} else n.interval && (i.pause(), i.cycle())
				})
			}, t._dataApiClickHandler = function (e) {
				var i = Me.getSelectorFromElement(this);
				if (i) {
					var n = S(i)[0];
					if (n && S(n).hasClass("carousel")) {
						var r = o({}, S(n).data(), S(this).data()), a = this.getAttribute("data-slide-to");
						a && (r.interval = !1), t._jQueryInterface.call(S(n), r), a && S(n).data(D).to(a), e.preventDefault()
					}
				}
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}, {
				key: "Default", get: function () {
					return A
				}
			}]), t
		}(), S(document).on(L.CLICK_DATA_API, "[data-slide], [data-slide-to]", H._dataApiClickHandler), S(window).on(L.LOAD_DATA_API, function () {
			for (var t = [].slice.call(document.querySelectorAll('[data-ride="carousel"]')), e = 0, i = t.length; e < i; e++) {
				var n = S(t[e]);
				H._jQueryInterface.call(n, n.data())
			}
		}), S.fn[C] = H._jQueryInterface, S.fn[C].Constructor = H, S.fn[C].noConflict = function () {
			return S.fn[C] = E, H._jQueryInterface
		}, H), Ie = (B = "collapse", j = "." + (z = "bs.collapse"), U = ($ = e).fn[B], W = {toggle: !0, parent: ""}, Y = {toggle: "boolean", parent: "(string|element)"}, V = {
			SHOW: "show" + j,
			SHOWN: "shown" + j,
			HIDE: "hide" + j,
			HIDDEN: "hidden" + j,
			CLICK_DATA_API: "click" + j + ".data-api"
		}, q = "show", G = "collapse", K = "collapsing", X = "collapsed", "width", "height", ".show, .collapsing", Z = '[data-toggle="collapse"]', Q = function () {
			function t(t, e) {
				this._isTransitioning = !1, this._element = t, this._config = this._getConfig(e), this._triggerArray = $.makeArray(document.querySelectorAll('[data-toggle="collapse"][href="#' + t.id + '"],[data-toggle="collapse"][data-target="#' + t.id + '"]'));
				for (var i = [].slice.call(document.querySelectorAll(Z)), n = 0, r = i.length; n < r; n++) {
					var o = i[n], a = Me.getSelectorFromElement(o), s = [].slice.call(document.querySelectorAll(a)).filter(function (e) {
						return e === t
					});
					null !== a && 0 < s.length && (this._selector = a, this._triggerArray.push(o))
				}
				this._parent = this._config.parent ? this._getParent() : null, this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray), this._config.toggle && this.toggle()
			}

			var e = t.prototype;
			return e.toggle = function () {
				$(this._element).hasClass(q) ? this.hide() : this.show()
			}, e.show = function () {
				var e, i, n = this;
				if (!(this._isTransitioning || $(this._element).hasClass(q) || (this._parent && 0 === (e = [].slice.call(this._parent.querySelectorAll(".show, .collapsing")).filter(function (t) {
					return t.getAttribute("data-parent") === n._config.parent
				})).length && (e = null), e && (i = $(e).not(this._selector).data(z)) && i._isTransitioning))) {
					var r = $.Event(V.SHOW);
					if ($(this._element).trigger(r), !r.isDefaultPrevented()) {
						e && (t._jQueryInterface.call($(e).not(this._selector), "hide"), i || $(e).data(z, null));
						var o = this._getDimension();
						$(this._element).removeClass(G).addClass(K), this._element.style[o] = 0, this._triggerArray.length && $(this._triggerArray).removeClass(X).attr("aria-expanded", !0), this.setTransitioning(!0);
						var a = "scroll" + (o[0].toUpperCase() + o.slice(1)), s = Me.getTransitionDurationFromElement(this._element);
						$(this._element).one(Me.TRANSITION_END, function () {
							$(n._element).removeClass(K).addClass(G).addClass(q), n._element.style[o] = "", n.setTransitioning(!1), $(n._element).trigger(V.SHOWN)
						}).emulateTransitionEnd(s), this._element.style[o] = this._element[a] + "px"
					}
				}
			}, e.hide = function () {
				var t = this;
				if (!this._isTransitioning && $(this._element).hasClass(q)) {
					var e = $.Event(V.HIDE);
					if ($(this._element).trigger(e), !e.isDefaultPrevented()) {
						var i = this._getDimension();
						this._element.style[i] = this._element.getBoundingClientRect()[i] + "px", Me.reflow(this._element), $(this._element).addClass(K).removeClass(G).removeClass(q);
						var n = this._triggerArray.length;
						if (0 < n) for (var r = 0; r < n; r++) {
							var o = this._triggerArray[r], a = Me.getSelectorFromElement(o);
							null !== a && ($([].slice.call(document.querySelectorAll(a))).hasClass(q) || $(o).addClass(X).attr("aria-expanded", !1))
						}
						this.setTransitioning(!0), this._element.style[i] = "";
						var s = Me.getTransitionDurationFromElement(this._element);
						$(this._element).one(Me.TRANSITION_END, function () {
							t.setTransitioning(!1), $(t._element).removeClass(K).addClass(G).trigger(V.HIDDEN)
						}).emulateTransitionEnd(s)
					}
				}
			}, e.setTransitioning = function (t) {
				this._isTransitioning = t
			}, e.dispose = function () {
				$.removeData(this._element, z), this._config = null, this._parent = null, this._element = null, this._triggerArray = null, this._isTransitioning = null
			}, e._getConfig = function (t) {
				return (t = o({}, W, t)).toggle = Boolean(t.toggle), Me.typeCheckConfig(B, t, Y), t
			}, e._getDimension = function () {
				return $(this._element).hasClass("width") ? "width" : "height"
			}, e._getParent = function () {
				var e = this, i = null;
				Me.isElement(this._config.parent) ? (i = this._config.parent, void 0 !== this._config.parent.jquery && (i = this._config.parent[0])) : i = document.querySelector(this._config.parent);
				var n = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]', r = [].slice.call(i.querySelectorAll(n));
				return $(r).each(function (i, n) {
					e._addAriaAndCollapsedClass(t._getTargetFromElement(n), [n])
				}), i
			}, e._addAriaAndCollapsedClass = function (t, e) {
				if (t) {
					var i = $(t).hasClass(q);
					e.length && $(e).toggleClass(X, !i).attr("aria-expanded", i)
				}
			}, t._getTargetFromElement = function (t) {
				var e = Me.getSelectorFromElement(t);
				return e ? document.querySelector(e) : null
			}, t._jQueryInterface = function (e) {
				return this.each(function () {
					var i = $(this), n = i.data(z), r = o({}, W, i.data(), "object" == typeof e && e ? e : {});
					if (!n && r.toggle && /show|hide/.test(e) && (r.toggle = !1), n || (n = new t(this, r), i.data(z, n)), "string" == typeof e) {
						if (void 0 === n[e]) throw new TypeError('No method named "' + e + '"');
						n[e]()
					}
				})
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}, {
				key: "Default", get: function () {
					return W
				}
			}]), t
		}(), $(document).on(V.CLICK_DATA_API, Z, function (t) {
			"A" === t.currentTarget.tagName && t.preventDefault();
			var e = $(this), i = Me.getSelectorFromElement(this), n = [].slice.call(document.querySelectorAll(i));
			$(n).each(function () {
				var t = $(this), i = t.data(z) ? "toggle" : e.data();
				Q._jQueryInterface.call(t, i)
			})
		}), $.fn[B] = Q._jQueryInterface, $.fn[B].Constructor = Q, $.fn[B].noConflict = function () {
			return $.fn[B] = U, Q._jQueryInterface
		}, Q), Oe = (tt = "dropdown", it = "." + (et = "bs.dropdown"), nt = ".data-api", rt = (J = e).fn[tt], ot = new RegExp("38|40|27"), at = {
			HIDE: "hide" + it,
			HIDDEN: "hidden" + it,
			SHOW: "show" + it,
			SHOWN: "shown" + it,
			CLICK: "click" + it,
			CLICK_DATA_API: "click" + it + nt,
			KEYDOWN_DATA_API: "keydown" + it + nt,
			KEYUP_DATA_API: "keyup" + it + nt
		}, st = "disabled", lt = "show", "dropup", "dropright", "dropleft", ct = "dropdown-menu-right", "position-static", ut = '[data-toggle="dropdown"]', ".dropdown form", ht = ".dropdown-menu", ".navbar-nav", ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", "top-start", "top-end", "bottom-start", "bottom-end", "right-start", "left-start", dt = {
			offset: 0,
			flip: !0,
			boundary: "scrollParent",
			reference: "toggle",
			display: "dynamic"
		}, pt = {offset: "(number|string|function)", flip: "boolean", boundary: "(string|element)", reference: "(string|element)", display: "string"}, ft = function () {
			function t(t, e) {
				this._element = t, this._popper = null, this._config = this._getConfig(e), this._menu = this._getMenuElement(), this._inNavbar = this._detectNavbar(), this._addEventListeners()
			}

			var e = t.prototype;
			return e.toggle = function () {
				if (!this._element.disabled && !J(this._element).hasClass(st)) {
					var e = t._getParentFromElement(this._element), n = J(this._menu).hasClass(lt);
					if (t._clearMenus(), !n) {
						var r = {relatedTarget: this._element}, o = J.Event(at.SHOW, r);
						if (J(e).trigger(o), !o.isDefaultPrevented()) {
							if (!this._inNavbar) {
								if (void 0 === i) throw new TypeError("Bootstrap dropdown require Popper.js (https://popper.js.org)");
								var a = this._element;
								"parent" === this._config.reference ? a = e : Me.isElement(this._config.reference) && (a = this._config.reference, void 0 !== this._config.reference.jquery && (a = this._config.reference[0])), "scrollParent" !== this._config.boundary && J(e).addClass("position-static"), this._popper = new i(a, this._menu, this._getPopperConfig())
							}
							"ontouchstart" in document.documentElement && 0 === J(e).closest(".navbar-nav").length && J(document.body).children().on("mouseover", null, J.noop), this._element.focus(), this._element.setAttribute("aria-expanded", !0), J(this._menu).toggleClass(lt), J(e).toggleClass(lt).trigger(J.Event(at.SHOWN, r))
						}
					}
				}
			}, e.dispose = function () {
				J.removeData(this._element, et), J(this._element).off(it), this._element = null, (this._menu = null) !== this._popper && (this._popper.destroy(), this._popper = null)
			}, e.update = function () {
				this._inNavbar = this._detectNavbar(), null !== this._popper && this._popper.scheduleUpdate()
			}, e._addEventListeners = function () {
				var t = this;
				J(this._element).on(at.CLICK, function (e) {
					e.preventDefault(), e.stopPropagation(), t.toggle()
				})
			}, e._getConfig = function (t) {
				return t = o({}, this.constructor.Default, J(this._element).data(), t), Me.typeCheckConfig(tt, t, this.constructor.DefaultType), t
			}, e._getMenuElement = function () {
				if (!this._menu) {
					var e = t._getParentFromElement(this._element);
					e && (this._menu = e.querySelector(ht))
				}
				return this._menu
			}, e._getPlacement = function () {
				var t = J(this._element.parentNode), e = "bottom-start";
				return t.hasClass("dropup") ? (e = "top-start", J(this._menu).hasClass(ct) && (e = "top-end")) : t.hasClass("dropright") ? e = "right-start" : t.hasClass("dropleft") ? e = "left-start" : J(this._menu).hasClass(ct) && (e = "bottom-end"), e
			}, e._detectNavbar = function () {
				return 0 < J(this._element).closest(".navbar").length
			}, e._getPopperConfig = function () {
				var t = this, e = {};
				"function" == typeof this._config.offset ? e.fn = function (e) {
					return e.offsets = o({}, e.offsets, t._config.offset(e.offsets) || {}), e
				} : e.offset = this._config.offset;
				var i = {placement: this._getPlacement(), modifiers: {offset: e, flip: {enabled: this._config.flip}, preventOverflow: {boundariesElement: this._config.boundary}}};
				return "static" === this._config.display && (i.modifiers.applyStyle = {enabled: !1}), i
			}, t._jQueryInterface = function (e) {
				return this.each(function () {
					var i = J(this).data(et);
					if (i || (i = new t(this, "object" == typeof e ? e : null), J(this).data(et, i)), "string" == typeof e) {
						if (void 0 === i[e]) throw new TypeError('No method named "' + e + '"');
						i[e]()
					}
				})
			}, t._clearMenus = function (e) {
				if (!e || 3 !== e.which && ("keyup" !== e.type || 9 === e.which)) for (var i = [].slice.call(document.querySelectorAll(ut)), n = 0, r = i.length; n < r; n++) {
					var o = t._getParentFromElement(i[n]), a = J(i[n]).data(et), s = {relatedTarget: i[n]};
					if (e && "click" === e.type && (s.clickEvent = e), a) {
						var l = a._menu;
						if (J(o).hasClass(lt) && !(e && ("click" === e.type && /input|textarea/i.test(e.target.tagName) || "keyup" === e.type && 9 === e.which) && J.contains(o, e.target))) {
							var c = J.Event(at.HIDE, s);
							J(o).trigger(c), c.isDefaultPrevented() || ("ontouchstart" in document.documentElement && J(document.body).children().off("mouseover", null, J.noop), i[n].setAttribute("aria-expanded", "false"), J(l).removeClass(lt), J(o).removeClass(lt).trigger(J.Event(at.HIDDEN, s)))
						}
					}
				}
			}, t._getParentFromElement = function (t) {
				var e, i = Me.getSelectorFromElement(t);
				return i && (e = document.querySelector(i)), e || t.parentNode
			}, t._dataApiKeydownHandler = function (e) {
				if ((/input|textarea/i.test(e.target.tagName) ? !(32 === e.which || 27 !== e.which && (40 !== e.which && 38 !== e.which || J(e.target).closest(ht).length)) : ot.test(e.which)) && (e.preventDefault(), e.stopPropagation(), !this.disabled && !J(this).hasClass(st))) {
					var i = t._getParentFromElement(this), n = J(i).hasClass(lt);
					if ((n || 27 === e.which && 32 === e.which) && (!n || 27 !== e.which && 32 !== e.which)) {
						var r = [].slice.call(i.querySelectorAll(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)"));
						if (0 !== r.length) {
							var o = r.indexOf(e.target);
							38 === e.which && 0 < o && o--, 40 === e.which && o < r.length - 1 && o++, o < 0 && (o = 0), r[o].focus()
						}
					} else {
						if (27 === e.which) {
							var a = i.querySelector(ut);
							J(a).trigger("focus")
						}
						J(this).trigger("click")
					}
				}
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}, {
				key: "Default", get: function () {
					return dt
				}
			}, {
				key: "DefaultType", get: function () {
					return pt
				}
			}]), t
		}(), J(document).on(at.KEYDOWN_DATA_API, ut, ft._dataApiKeydownHandler).on(at.KEYDOWN_DATA_API, ht, ft._dataApiKeydownHandler).on(at.CLICK_DATA_API + " " + at.KEYUP_DATA_API, ft._clearMenus).on(at.CLICK_DATA_API, ut, function (t) {
			t.preventDefault(), t.stopPropagation(), ft._jQueryInterface.call(J(this), "toggle")
		}).on(at.CLICK_DATA_API, ".dropdown form", function (t) {
			t.stopPropagation()
		}), J.fn[tt] = ft._jQueryInterface, J.fn[tt].Constructor = ft, J.fn[tt].noConflict = function () {
			return J.fn[tt] = rt, ft._jQueryInterface
		}, ft), Le = (gt = "modal", yt = "." + (vt = "bs.modal"), bt = (mt = e).fn[gt], wt = {backdrop: !0, keyboard: !0, focus: !0, show: !0}, xt = {backdrop: "(boolean|string)", keyboard: "boolean", focus: "boolean", show: "boolean"}, kt = {
			HIDE: "hide" + yt,
			HIDDEN: "hidden" + yt,
			SHOW: "show" + yt,
			SHOWN: "shown" + yt,
			FOCUSIN: "focusin" + yt,
			RESIZE: "resize" + yt,
			CLICK_DISMISS: "click.dismiss" + yt,
			KEYDOWN_DISMISS: "keydown.dismiss" + yt,
			MOUSEUP_DISMISS: "mouseup.dismiss" + yt,
			MOUSEDOWN_DISMISS: "mousedown.dismiss" + yt,
			CLICK_DATA_API: "click" + yt + ".data-api"
		}, "modal-scrollbar-measure", "modal-backdrop", _t = "modal-open", St = "fade", Ct = "show", Dt = ".modal-dialog", '[data-toggle="modal"]', '[data-dismiss="modal"]', Tt = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Mt = ".sticky-top", Et = function () {
			function t(t, e) {
				this._config = this._getConfig(e), this._element = t, this._dialog = t.querySelector(Dt), this._backdrop = null, this._isShown = !1, this._isBodyOverflowing = !1, this._ignoreBackdropClick = !1, this._scrollbarWidth = 0
			}

			var e = t.prototype;
			return e.toggle = function (t) {
				return this._isShown ? this.hide() : this.show(t)
			}, e.show = function (t) {
				var e = this;
				if (!this._isTransitioning && !this._isShown) {
					mt(this._element).hasClass(St) && (this._isTransitioning = !0);
					var i = mt.Event(kt.SHOW, {relatedTarget: t});
					mt(this._element).trigger(i), this._isShown || i.isDefaultPrevented() || (this._isShown = !0, this._checkScrollbar(), this._setScrollbar(), this._adjustDialog(), mt(document.body).addClass(_t), this._setEscapeEvent(), this._setResizeEvent(), mt(this._element).on(kt.CLICK_DISMISS, '[data-dismiss="modal"]', function (t) {
						return e.hide(t)
					}), mt(this._dialog).on(kt.MOUSEDOWN_DISMISS, function () {
						mt(e._element).one(kt.MOUSEUP_DISMISS, function (t) {
							mt(t.target).is(e._element) && (e._ignoreBackdropClick = !0)
						})
					}), this._showBackdrop(function () {
						return e._showElement(t)
					}))
				}
			}, e.hide = function (t) {
				var e = this;
				if (t && t.preventDefault(), !this._isTransitioning && this._isShown) {
					var i = mt.Event(kt.HIDE);
					if (mt(this._element).trigger(i), this._isShown && !i.isDefaultPrevented()) {
						this._isShown = !1;
						var n = mt(this._element).hasClass(St);
						if (n && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), mt(document).off(kt.FOCUSIN), mt(this._element).removeClass(Ct), mt(this._element).off(kt.CLICK_DISMISS), mt(this._dialog).off(kt.MOUSEDOWN_DISMISS), n) {
							var r = Me.getTransitionDurationFromElement(this._element);
							mt(this._element).one(Me.TRANSITION_END, function (t) {
								return e._hideModal(t)
							}).emulateTransitionEnd(r)
						} else this._hideModal()
					}
				}
			}, e.dispose = function () {
				mt.removeData(this._element, vt), mt(window, document, this._element, this._backdrop).off(yt), this._config = null, this._element = null, this._dialog = null, this._backdrop = null, this._isShown = null, this._isBodyOverflowing = null, this._ignoreBackdropClick = null, this._scrollbarWidth = null
			}, e.handleUpdate = function () {
				this._adjustDialog()
			}, e._getConfig = function (t) {
				return t = o({}, wt, t), Me.typeCheckConfig(gt, t, xt), t
			}, e._showElement = function (t) {
				var e = this, i = mt(this._element).hasClass(St);
				this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.scrollTop = 0, i && Me.reflow(this._element), mt(this._element).addClass(Ct), this._config.focus && this._enforceFocus();
				var n = mt.Event(kt.SHOWN, {relatedTarget: t}), r = function () {
					e._config.focus && e._element.focus(), e._isTransitioning = !1, mt(e._element).trigger(n)
				};
				if (i) {
					var o = Me.getTransitionDurationFromElement(this._element);
					mt(this._dialog).one(Me.TRANSITION_END, r).emulateTransitionEnd(o)
				} else r()
			}, e._enforceFocus = function () {
				var t = this;
				mt(document).off(kt.FOCUSIN).on(kt.FOCUSIN, function (e) {
					document !== e.target && t._element !== e.target && 0 === mt(t._element).has(e.target).length && t._element.focus()
				})
			}, e._setEscapeEvent = function () {
				var t = this;
				this._isShown && this._config.keyboard ? mt(this._element).on(kt.KEYDOWN_DISMISS, function (e) {
					27 === e.which && (e.preventDefault(), t.hide())
				}) : this._isShown || mt(this._element).off(kt.KEYDOWN_DISMISS)
			}, e._setResizeEvent = function () {
				var t = this;
				this._isShown ? mt(window).on(kt.RESIZE, function (e) {
					return t.handleUpdate(e)
				}) : mt(window).off(kt.RESIZE)
			}, e._hideModal = function () {
				var t = this;
				this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._isTransitioning = !1, this._showBackdrop(function () {
					mt(document.body).removeClass(_t), t._resetAdjustments(), t._resetScrollbar(), mt(t._element).trigger(kt.HIDDEN)
				})
			}, e._removeBackdrop = function () {
				this._backdrop && (mt(this._backdrop).remove(), this._backdrop = null)
			}, e._showBackdrop = function (t) {
				var e = this, i = mt(this._element).hasClass(St) ? St : "";
				if (this._isShown && this._config.backdrop) {
					if (this._backdrop = document.createElement("div"), this._backdrop.className = "modal-backdrop", i && this._backdrop.classList.add(i), mt(this._backdrop).appendTo(document.body), mt(this._element).on(kt.CLICK_DISMISS, function (t) {
						e._ignoreBackdropClick ? e._ignoreBackdropClick = !1 : t.target === t.currentTarget && ("static" === e._config.backdrop ? e._element.focus() : e.hide())
					}), i && Me.reflow(this._backdrop), mt(this._backdrop).addClass(Ct), !t) return;
					if (!i) return void t();
					var n = Me.getTransitionDurationFromElement(this._backdrop);
					mt(this._backdrop).one(Me.TRANSITION_END, t).emulateTransitionEnd(n)
				} else if (!this._isShown && this._backdrop) {
					mt(this._backdrop).removeClass(Ct);
					var r = function () {
						e._removeBackdrop(), t && t()
					};
					if (mt(this._element).hasClass(St)) {
						var o = Me.getTransitionDurationFromElement(this._backdrop);
						mt(this._backdrop).one(Me.TRANSITION_END, r).emulateTransitionEnd(o)
					} else r()
				} else t && t()
			}, e._adjustDialog = function () {
				var t = this._element.scrollHeight > document.documentElement.clientHeight;
				!this._isBodyOverflowing && t && (this._element.style.paddingLeft = this._scrollbarWidth + "px"), this._isBodyOverflowing && !t && (this._element.style.paddingRight = this._scrollbarWidth + "px")
			}, e._resetAdjustments = function () {
				this._element.style.paddingLeft = "", this._element.style.paddingRight = ""
			}, e._checkScrollbar = function () {
				var t = document.body.getBoundingClientRect();
				this._isBodyOverflowing = t.left + t.right < window.innerWidth, this._scrollbarWidth = this._getScrollbarWidth()
			}, e._setScrollbar = function () {
				var t = this;
				if (this._isBodyOverflowing) {
					var e = [].slice.call(document.querySelectorAll(Tt)), i = [].slice.call(document.querySelectorAll(Mt));
					mt(e).each(function (e, i) {
						var n = i.style.paddingRight, r = mt(i).css("padding-right");
						mt(i).data("padding-right", n).css("padding-right", parseFloat(r) + t._scrollbarWidth + "px")
					}), mt(i).each(function (e, i) {
						var n = i.style.marginRight, r = mt(i).css("margin-right");
						mt(i).data("margin-right", n).css("margin-right", parseFloat(r) - t._scrollbarWidth + "px")
					});
					var n = document.body.style.paddingRight, r = mt(document.body).css("padding-right");
					mt(document.body).data("padding-right", n).css("padding-right", parseFloat(r) + this._scrollbarWidth + "px")
				}
			}, e._resetScrollbar = function () {
				var t = [].slice.call(document.querySelectorAll(Tt));
				mt(t).each(function (t, e) {
					var i = mt(e).data("padding-right");
					mt(e).removeData("padding-right"), e.style.paddingRight = i || ""
				});
				var e = [].slice.call(document.querySelectorAll("" + Mt));
				mt(e).each(function (t, e) {
					var i = mt(e).data("margin-right");
					void 0 !== i && mt(e).css("margin-right", i).removeData("margin-right")
				});
				var i = mt(document.body).data("padding-right");
				mt(document.body).removeData("padding-right"), document.body.style.paddingRight = i || ""
			}, e._getScrollbarWidth = function () {
				var t = document.createElement("div");
				t.className = "modal-scrollbar-measure", document.body.appendChild(t);
				var e = t.getBoundingClientRect().width - t.clientWidth;
				return document.body.removeChild(t), e
			}, t._jQueryInterface = function (e, i) {
				return this.each(function () {
					var n = mt(this).data(vt), r = o({}, wt, mt(this).data(), "object" == typeof e && e ? e : {});
					if (n || (n = new t(this, r), mt(this).data(vt, n)), "string" == typeof e) {
						if (void 0 === n[e]) throw new TypeError('No method named "' + e + '"');
						n[e](i)
					} else r.show && n.show(i)
				})
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}, {
				key: "Default", get: function () {
					return wt
				}
			}]), t
		}(), mt(document).on(kt.CLICK_DATA_API, '[data-toggle="modal"]', function (t) {
			var e, i = this, n = Me.getSelectorFromElement(this);
			n && (e = document.querySelector(n));
			var r = mt(e).data(vt) ? "toggle" : o({}, mt(e).data(), mt(this).data());
			"A" !== this.tagName && "AREA" !== this.tagName || t.preventDefault();
			var a = mt(e).one(kt.SHOW, function (t) {
				t.isDefaultPrevented() || a.one(kt.HIDDEN, function () {
					mt(i).is(":visible") && i.focus()
				})
			});
			Et._jQueryInterface.call(mt(e), r, this)
		}), mt.fn[gt] = Et._jQueryInterface, mt.fn[gt].Constructor = Et, mt.fn[gt].noConflict = function () {
			return mt.fn[gt] = bt, Et._jQueryInterface
		}, Et), Fe = (Pt = "tooltip", Ot = "." + (It = "bs.tooltip"), Lt = (At = e).fn[Pt], Ft = "bs-tooltip", Nt = new RegExp("(^|\\s)" + Ft + "\\S+", "g"), $t = {
			animation: !0,
			template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
			trigger: "hover focus",
			title: "",
			delay: 0,
			html: !(Ht = {AUTO: "auto", TOP: "top", RIGHT: "right", BOTTOM: "bottom", LEFT: "left"}),
			selector: !(Rt = {
				animation: "boolean",
				template: "string",
				title: "(string|element|function)",
				trigger: "string",
				delay: "(number|object)",
				html: "boolean",
				selector: "(string|boolean)",
				placement: "(string|function)",
				offset: "(number|string)",
				container: "(string|element|boolean)",
				fallbackPlacement: "(string|array)",
				boundary: "(string|element)"
			}),
			placement: "top",
			offset: 0,
			container: !1,
			fallbackPlacement: "flip",
			boundary: "scrollParent"
		}, "out", zt = {
			HIDE: "hide" + Ot,
			HIDDEN: "hidden" + Ot,
			SHOW: (Bt = "show") + Ot,
			SHOWN: "shown" + Ot,
			INSERTED: "inserted" + Ot,
			CLICK: "click" + Ot,
			FOCUSIN: "focusin" + Ot,
			FOCUSOUT: "focusout" + Ot,
			MOUSEENTER: "mouseenter" + Ot,
			MOUSELEAVE: "mouseleave" + Ot
		}, jt = "fade", Ut = "show", ".tooltip-inner", ".arrow", Wt = "hover", Yt = "focus", "click", "manual", Vt = function () {
			function t(t, e) {
				if (void 0 === i) throw new TypeError("Bootstrap tooltips require Popper.js (https://popper.js.org)");
				this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, this._popper = null, this.element = t, this.config = this._getConfig(e), this.tip = null, this._setListeners()
			}

			var e = t.prototype;
			return e.enable = function () {
				this._isEnabled = !0
			}, e.disable = function () {
				this._isEnabled = !1
			}, e.toggleEnabled = function () {
				this._isEnabled = !this._isEnabled
			}, e.toggle = function (t) {
				if (this._isEnabled) if (t) {
					var e = this.constructor.DATA_KEY, i = At(t.currentTarget).data(e);
					i || (i = new this.constructor(t.currentTarget, this._getDelegateConfig()), At(t.currentTarget).data(e, i)), i._activeTrigger.click = !i._activeTrigger.click, i._isWithActiveTrigger() ? i._enter(null, i) : i._leave(null, i)
				} else {
					if (At(this.getTipElement()).hasClass(Ut)) return void this._leave(null, this);
					this._enter(null, this)
				}
			}, e.dispose = function () {
				clearTimeout(this._timeout), At.removeData(this.element, this.constructor.DATA_KEY), At(this.element).off(this.constructor.EVENT_KEY), At(this.element).closest(".modal").off("hide.bs.modal"), this.tip && At(this.tip).remove(), this._isEnabled = null, this._timeout = null, this._hoverState = null, (this._activeTrigger = null) !== this._popper && this._popper.destroy(), this._popper = null, this.element = null, this.config = null, this.tip = null
			}, e.show = function () {
				var t = this;
				if ("none" === At(this.element).css("display")) throw new Error("Please use show on visible elements");
				var e = At.Event(this.constructor.Event.SHOW);
				if (this.isWithContent() && this._isEnabled) {
					At(this.element).trigger(e);
					var n = At.contains(this.element.ownerDocument.documentElement, this.element);
					if (e.isDefaultPrevented() || !n) return;
					var r = this.getTipElement(), o = Me.getUID(this.constructor.NAME);
					r.setAttribute("id", o), this.element.setAttribute("aria-describedby", o), this.setContent(), this.config.animation && At(r).addClass(jt);
					var a = "function" == typeof this.config.placement ? this.config.placement.call(this, r, this.element) : this.config.placement, s = this._getAttachment(a);
					this.addAttachmentClass(s);
					var l = !1 === this.config.container ? document.body : At(document).find(this.config.container);
					At(r).data(this.constructor.DATA_KEY, this), At.contains(this.element.ownerDocument.documentElement, this.tip) || At(r).appendTo(l), At(this.element).trigger(this.constructor.Event.INSERTED), this._popper = new i(this.element, r, {
						placement: s,
						modifiers: {offset: {offset: this.config.offset}, flip: {behavior: this.config.fallbackPlacement}, arrow: {element: ".arrow"}, preventOverflow: {boundariesElement: this.config.boundary}},
						onCreate: function (e) {
							e.originalPlacement !== e.placement && t._handlePopperPlacementChange(e)
						},
						onUpdate: function (e) {
							t._handlePopperPlacementChange(e)
						}
					}), At(r).addClass(Ut), "ontouchstart" in document.documentElement && At(document.body).children().on("mouseover", null, At.noop);
					var c = function () {
						t.config.animation && t._fixTransition();
						var e = t._hoverState;
						t._hoverState = null, At(t.element).trigger(t.constructor.Event.SHOWN), "out" === e && t._leave(null, t)
					};
					if (At(this.tip).hasClass(jt)) {
						var u = Me.getTransitionDurationFromElement(this.tip);
						At(this.tip).one(Me.TRANSITION_END, c).emulateTransitionEnd(u)
					} else c()
				}
			}, e.hide = function (t) {
				var e = this, i = this.getTipElement(), n = At.Event(this.constructor.Event.HIDE), r = function () {
					e._hoverState !== Bt && i.parentNode && i.parentNode.removeChild(i), e._cleanTipClass(), e.element.removeAttribute("aria-describedby"), At(e.element).trigger(e.constructor.Event.HIDDEN), null !== e._popper && e._popper.destroy(), t && t()
				};
				if (At(this.element).trigger(n), !n.isDefaultPrevented()) {
					if (At(i).removeClass(Ut), "ontouchstart" in document.documentElement && At(document.body).children().off("mouseover", null, At.noop), this._activeTrigger.click = !1, this._activeTrigger[Yt] = !1, this._activeTrigger[Wt] = !1, At(this.tip).hasClass(jt)) {
						var o = Me.getTransitionDurationFromElement(i);
						At(i).one(Me.TRANSITION_END, r).emulateTransitionEnd(o)
					} else r();
					this._hoverState = ""
				}
			}, e.update = function () {
				null !== this._popper && this._popper.scheduleUpdate()
			}, e.isWithContent = function () {
				return Boolean(this.getTitle())
			}, e.addAttachmentClass = function (t) {
				At(this.getTipElement()).addClass(Ft + "-" + t)
			}, e.getTipElement = function () {
				return this.tip = this.tip || At(this.config.template)[0], this.tip
			}, e.setContent = function () {
				var t = this.getTipElement();
				this.setElementContent(At(t.querySelectorAll(".tooltip-inner")), this.getTitle()), At(t).removeClass(jt + " " + Ut)
			}, e.setElementContent = function (t, e) {
				var i = this.config.html;
				"object" == typeof e && (e.nodeType || e.jquery) ? i ? At(e).parent().is(t) || t.empty().append(e) : t.text(At(e).text()) : t[i ? "html" : "text"](e)
			}, e.getTitle = function () {
				var t = this.element.getAttribute("data-original-title");
				return t || (t = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title), t
			}, e._getAttachment = function (t) {
				return Ht[t.toUpperCase()]
			}, e._setListeners = function () {
				var t = this;
				this.config.trigger.split(" ").forEach(function (e) {
					if ("click" === e) At(t.element).on(t.constructor.Event.CLICK, t.config.selector, function (e) {
						return t.toggle(e)
					}); else if ("manual" !== e) {
						var i = e === Wt ? t.constructor.Event.MOUSEENTER : t.constructor.Event.FOCUSIN, n = e === Wt ? t.constructor.Event.MOUSELEAVE : t.constructor.Event.FOCUSOUT;
						At(t.element).on(i, t.config.selector, function (e) {
							return t._enter(e)
						}).on(n, t.config.selector, function (e) {
							return t._leave(e)
						})
					}
					At(t.element).closest(".modal").on("hide.bs.modal", function () {
						return t.hide()
					})
				}), this.config.selector ? this.config = o({}, this.config, {trigger: "manual", selector: ""}) : this._fixTitle()
			}, e._fixTitle = function () {
				var t = typeof this.element.getAttribute("data-original-title");
				(this.element.getAttribute("title") || "string" !== t) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""), this.element.setAttribute("title", ""))
			}, e._enter = function (t, e) {
				var i = this.constructor.DATA_KEY;
				(e = e || At(t.currentTarget).data(i)) || (e = new this.constructor(t.currentTarget, this._getDelegateConfig()), At(t.currentTarget).data(i, e)), t && (e._activeTrigger["focusin" === t.type ? Yt : Wt] = !0), At(e.getTipElement()).hasClass(Ut) || e._hoverState === Bt ? e._hoverState = Bt : (clearTimeout(e._timeout), e._hoverState = Bt, e.config.delay && e.config.delay.show ? e._timeout = setTimeout(function () {
					e._hoverState === Bt && e.show()
				}, e.config.delay.show) : e.show())
			}, e._leave = function (t, e) {
				var i = this.constructor.DATA_KEY;
				(e = e || At(t.currentTarget).data(i)) || (e = new this.constructor(t.currentTarget, this._getDelegateConfig()), At(t.currentTarget).data(i, e)), t && (e._activeTrigger["focusout" === t.type ? Yt : Wt] = !1), e._isWithActiveTrigger() || (clearTimeout(e._timeout), e._hoverState = "out", e.config.delay && e.config.delay.hide ? e._timeout = setTimeout(function () {
					"out" === e._hoverState && e.hide()
				}, e.config.delay.hide) : e.hide())
			}, e._isWithActiveTrigger = function () {
				for (var t in this._activeTrigger) if (this._activeTrigger[t]) return !0;
				return !1
			}, e._getConfig = function (t) {
				return "number" == typeof (t = o({}, this.constructor.Default, At(this.element).data(), "object" == typeof t && t ? t : {})).delay && (t.delay = {
					show: t.delay,
					hide: t.delay
				}), "number" == typeof t.title && (t.title = t.title.toString()), "number" == typeof t.content && (t.content = t.content.toString()), Me.typeCheckConfig(Pt, t, this.constructor.DefaultType), t
			}, e._getDelegateConfig = function () {
				var t = {};
				if (this.config) for (var e in this.config) this.constructor.Default[e] !== this.config[e] && (t[e] = this.config[e]);
				return t
			}, e._cleanTipClass = function () {
				var t = At(this.getTipElement()), e = t.attr("class").match(Nt);
				null !== e && e.length && t.removeClass(e.join(""))
			}, e._handlePopperPlacementChange = function (t) {
				var e = t.instance;
				this.tip = e.popper, this._cleanTipClass(), this.addAttachmentClass(this._getAttachment(t.placement))
			}, e._fixTransition = function () {
				var t = this.getTipElement(), e = this.config.animation;
				null === t.getAttribute("x-placement") && (At(t).removeClass(jt), this.config.animation = !1, this.hide(), this.show(), this.config.animation = e)
			}, t._jQueryInterface = function (e) {
				return this.each(function () {
					var i = At(this).data(It), n = "object" == typeof e && e;
					if ((i || !/dispose|hide/.test(e)) && (i || (i = new t(this, n), At(this).data(It, i)), "string" == typeof e)) {
						if (void 0 === i[e]) throw new TypeError('No method named "' + e + '"');
						i[e]()
					}
				})
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}, {
				key: "Default", get: function () {
					return $t
				}
			}, {
				key: "NAME", get: function () {
					return Pt
				}
			}, {
				key: "DATA_KEY", get: function () {
					return It
				}
			}, {
				key: "Event", get: function () {
					return zt
				}
			}, {
				key: "EVENT_KEY", get: function () {
					return Ot
				}
			}, {
				key: "DefaultType", get: function () {
					return Rt
				}
			}]), t
		}(), At.fn[Pt] = Vt._jQueryInterface, At.fn[Pt].Constructor = Vt, At.fn[Pt].noConflict = function () {
			return At.fn[Pt] = Lt, Vt._jQueryInterface
		}, Vt), Ne = (Gt = "popover", Xt = "." + (Kt = "bs.popover"), Zt = (qt = e).fn[Gt], Qt = "bs-popover", Jt = new RegExp("(^|\\s)" + Qt + "\\S+", "g"), te = o({}, Fe.Default, {
			placement: "right",
			trigger: "click",
			content: "",
			template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
		}), ee = o({}, Fe.DefaultType, {content: "(string|element|function)"}), "fade", ".popover-header", ".popover-body", ie = {
			HIDE: "hide" + Xt,
			HIDDEN: "hidden" + Xt,
			SHOW: "show" + Xt,
			SHOWN: "shown" + Xt,
			INSERTED: "inserted" + Xt,
			CLICK: "click" + Xt,
			FOCUSIN: "focusin" + Xt,
			FOCUSOUT: "focusout" + Xt,
			MOUSEENTER: "mouseenter" + Xt,
			MOUSELEAVE: "mouseleave" + Xt
		}, ne = function (t) {
			var e, i;

			function n() {
				return t.apply(this, arguments) || this
			}

			i = t, (e = n).prototype = Object.create(i.prototype), (e.prototype.constructor = e).__proto__ = i;
			var o = n.prototype;
			return o.isWithContent = function () {
				return this.getTitle() || this._getContent()
			}, o.addAttachmentClass = function (t) {
				qt(this.getTipElement()).addClass(Qt + "-" + t)
			}, o.getTipElement = function () {
				return this.tip = this.tip || qt(this.config.template)[0], this.tip
			}, o.setContent = function () {
				var t = qt(this.getTipElement());
				this.setElementContent(t.find(".popover-header"), this.getTitle());
				var e = this._getContent();
				"function" == typeof e && (e = e.call(this.element)), this.setElementContent(t.find(".popover-body"), e), t.removeClass("fade show")
			}, o._getContent = function () {
				return this.element.getAttribute("data-content") || this.config.content
			}, o._cleanTipClass = function () {
				var t = qt(this.getTipElement()), e = t.attr("class").match(Jt);
				null !== e && 0 < e.length && t.removeClass(e.join(""))
			}, n._jQueryInterface = function (t) {
				return this.each(function () {
					var e = qt(this).data(Kt), i = "object" == typeof t ? t : null;
					if ((e || !/destroy|hide/.test(t)) && (e || (e = new n(this, i), qt(this).data(Kt, e)), "string" == typeof t)) {
						if (void 0 === e[t]) throw new TypeError('No method named "' + t + '"');
						e[t]()
					}
				})
			}, r(n, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}, {
				key: "Default", get: function () {
					return te
				}
			}, {
				key: "NAME", get: function () {
					return Gt
				}
			}, {
				key: "DATA_KEY", get: function () {
					return Kt
				}
			}, {
				key: "Event", get: function () {
					return ie
				}
			}, {
				key: "EVENT_KEY", get: function () {
					return Xt
				}
			}, {
				key: "DefaultType", get: function () {
					return ee
				}
			}]), n
		}(Fe), qt.fn[Gt] = ne._jQueryInterface, qt.fn[Gt].Constructor = ne, qt.fn[Gt].noConflict = function () {
			return qt.fn[Gt] = Zt, ne._jQueryInterface
		}, ne), Re = (oe = "scrollspy", se = "." + (ae = "bs.scrollspy"), le = (re = e).fn[oe], ce = {offset: 10, method: "auto", target: ""}, ue = {offset: "number", method: "string", target: "(string|element)"}, he = {
			ACTIVATE: "activate" + se,
			SCROLL: "scroll" + se,
			LOAD_DATA_API: "load" + se + ".data-api"
		}, "dropdown-item", de = "active", '[data-spy="scroll"]', ".active", pe = ".nav, .list-group", fe = ".nav-link", ".nav-item", me = ".list-group-item", ".dropdown", ge = ".dropdown-item", ".dropdown-toggle", "offset", ve = "position", ye = function () {
			function t(t, e) {
				var i = this;
				this._element = t, this._scrollElement = "BODY" === t.tagName ? window : t, this._config = this._getConfig(e), this._selector = this._config.target + " " + fe + "," + this._config.target + " " + me + "," + this._config.target + " " + ge, this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, re(this._scrollElement).on(he.SCROLL, function (t) {
					return i._process(t)
				}), this.refresh(), this._process()
			}

			var e = t.prototype;
			return e.refresh = function () {
				var t = this, e = this._scrollElement === this._scrollElement.window ? "offset" : ve, i = "auto" === this._config.method ? e : this._config.method, n = i === ve ? this._getScrollTop() : 0;
				this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight(), [].slice.call(document.querySelectorAll(this._selector)).map(function (t) {
					var e, r = Me.getSelectorFromElement(t);
					if (r && (e = document.querySelector(r)), e) {
						var o = e.getBoundingClientRect();
						if (o.width || o.height) return [re(e)[i]().top + n, r]
					}
					return null
				}).filter(function (t) {
					return t
				}).sort(function (t, e) {
					return t[0] - e[0]
				}).forEach(function (e) {
					t._offsets.push(e[0]), t._targets.push(e[1])
				})
			}, e.dispose = function () {
				re.removeData(this._element, ae), re(this._scrollElement).off(se), this._element = null, this._scrollElement = null, this._config = null, this._selector = null, this._offsets = null, this._targets = null, this._activeTarget = null, this._scrollHeight = null
			}, e._getConfig = function (t) {
				if ("string" != typeof (t = o({}, ce, "object" == typeof t && t ? t : {})).target) {
					var e = re(t.target).attr("id");
					e || (e = Me.getUID(oe), re(t.target).attr("id", e)), t.target = "#" + e
				}
				return Me.typeCheckConfig(oe, t, ue), t
			}, e._getScrollTop = function () {
				return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop
			}, e._getScrollHeight = function () {
				return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
			}, e._getOffsetHeight = function () {
				return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height
			}, e._process = function () {
				var t = this._getScrollTop() + this._config.offset, e = this._getScrollHeight(), i = this._config.offset + e - this._getOffsetHeight();
				if (this._scrollHeight !== e && this.refresh(), i <= t) {
					var n = this._targets[this._targets.length - 1];
					this._activeTarget !== n && this._activate(n)
				} else {
					if (this._activeTarget && t < this._offsets[0] && 0 < this._offsets[0]) return this._activeTarget = null, void this._clear();
					for (var r = this._offsets.length; r--;) this._activeTarget !== this._targets[r] && t >= this._offsets[r] && (void 0 === this._offsets[r + 1] || t < this._offsets[r + 1]) && this._activate(this._targets[r])
				}
			}, e._activate = function (t) {
				this._activeTarget = t, this._clear();
				var e = this._selector.split(",");
				e = e.map(function (e) {
					return e + '[data-target="' + t + '"],' + e + '[href="' + t + '"]'
				});
				var i = re([].slice.call(document.querySelectorAll(e.join(","))));
				i.hasClass("dropdown-item") ? (i.closest(".dropdown").find(".dropdown-toggle").addClass(de), i.addClass(de)) : (i.addClass(de), i.parents(pe).prev(fe + ", " + me).addClass(de), i.parents(pe).prev(".nav-item").children(fe).addClass(de)), re(this._scrollElement).trigger(he.ACTIVATE, {relatedTarget: t})
			}, e._clear = function () {
				var t = [].slice.call(document.querySelectorAll(this._selector));
				re(t).filter(".active").removeClass(de)
			}, t._jQueryInterface = function (e) {
				return this.each(function () {
					var i = re(this).data(ae);
					if (i || (i = new t(this, "object" == typeof e && e), re(this).data(ae, i)), "string" == typeof e) {
						if (void 0 === i[e]) throw new TypeError('No method named "' + e + '"');
						i[e]()
					}
				})
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}, {
				key: "Default", get: function () {
					return ce
				}
			}]), t
		}(), re(window).on(he.LOAD_DATA_API, function () {
			for (var t = [].slice.call(document.querySelectorAll('[data-spy="scroll"]')), e = t.length; e--;) {
				var i = re(t[e]);
				ye._jQueryInterface.call(i, i.data())
			}
		}), re.fn[oe] = ye._jQueryInterface, re.fn[oe].Constructor = ye, re.fn[oe].noConflict = function () {
			return re.fn[oe] = le, ye._jQueryInterface
		}, ye), He = (xe = "." + (we = "bs.tab"), ke = (be = e).fn.tab, _e = {
			HIDE: "hide" + xe,
			HIDDEN: "hidden" + xe,
			SHOW: "show" + xe,
			SHOWN: "shown" + xe,
			CLICK_DATA_API: "click" + xe + ".data-api"
		}, "dropdown-menu", Se = "active", "disabled", "fade", "show", ".dropdown", ".nav, .list-group", Ce = ".active", De = "> li > .active", '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]', ".dropdown-toggle", "> .dropdown-menu .active", Te = function () {
			function t(t) {
				this._element = t
			}

			var e = t.prototype;
			return e.show = function () {
				var t = this;
				if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && be(this._element).hasClass(Se) || be(this._element).hasClass("disabled"))) {
					var e, i, n = be(this._element).closest(".nav, .list-group")[0], r = Me.getSelectorFromElement(this._element);
					if (n) {
						var o = "UL" === n.nodeName ? De : Ce;
						i = (i = be.makeArray(be(n).find(o)))[i.length - 1]
					}
					var a = be.Event(_e.HIDE, {relatedTarget: this._element}), s = be.Event(_e.SHOW, {relatedTarget: i});
					if (i && be(i).trigger(a), be(this._element).trigger(s), !s.isDefaultPrevented() && !a.isDefaultPrevented()) {
						r && (e = document.querySelector(r)), this._activate(this._element, n);
						var l = function () {
							var e = be.Event(_e.HIDDEN, {relatedTarget: t._element}), n = be.Event(_e.SHOWN, {relatedTarget: i});
							be(i).trigger(e), be(t._element).trigger(n)
						};
						e ? this._activate(e, e.parentNode, l) : l()
					}
				}
			}, e.dispose = function () {
				be.removeData(this._element, we), this._element = null
			}, e._activate = function (t, e, i) {
				var n = this, r = ("UL" === e.nodeName ? be(e).find(De) : be(e).children(Ce))[0], o = i && r && be(r).hasClass("fade"), a = function () {
					return n._transitionComplete(t, r, i)
				};
				if (r && o) {
					var s = Me.getTransitionDurationFromElement(r);
					be(r).one(Me.TRANSITION_END, a).emulateTransitionEnd(s)
				} else a()
			}, e._transitionComplete = function (t, e, i) {
				if (e) {
					be(e).removeClass("show " + Se);
					var n = be(e.parentNode).find("> .dropdown-menu .active")[0];
					n && be(n).removeClass(Se), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !1)
				}
				if (be(t).addClass(Se), "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !0), Me.reflow(t), be(t).addClass("show"), t.parentNode && be(t.parentNode).hasClass("dropdown-menu")) {
					var r = be(t).closest(".dropdown")[0];
					if (r) {
						var o = [].slice.call(r.querySelectorAll(".dropdown-toggle"));
						be(o).addClass(Se)
					}
					t.setAttribute("aria-expanded", !0)
				}
				i && i()
			}, t._jQueryInterface = function (e) {
				return this.each(function () {
					var i = be(this), n = i.data(we);
					if (n || (n = new t(this), i.data(we, n)), "string" == typeof e) {
						if (void 0 === n[e]) throw new TypeError('No method named "' + e + '"');
						n[e]()
					}
				})
			}, r(t, null, [{
				key: "VERSION", get: function () {
					return "4.1.3"
				}
			}]), t
		}(), be(document).on(_e.CLICK_DATA_API, '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]', function (t) {
			t.preventDefault(), Te._jQueryInterface.call(be(this), "show")
		}), be.fn.tab = Te._jQueryInterface, be.fn.tab.Constructor = Te, be.fn.tab.noConflict = function () {
			return be.fn.tab = ke, Te._jQueryInterface
		}, Te);
	!function (t) {
		if (void 0 === t) throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
		var e = t.fn.jquery.split(" ")[0].split(".");
		if (e[0] < 2 && e[1] < 9 || 1 === e[0] && 9 === e[1] && e[2] < 1 || 4 <= e[0]) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")
	}(e), t.Util = Me, t.Alert = Ee, t.Button = Ae, t.Carousel = Pe, t.Collapse = Ie, t.Dropdown = Oe, t.Modal = Le, t.Popover = Ne, t.Scrollspy = Re, t.Tab = He, t.Tooltip = Fe, Object.defineProperty(t, "__esModule", {value: !0})
}), function (t) {
	var e = !1;
	if ("function" == typeof define && define.amd && (define(t), e = !0), "object" == typeof exports && (module.exports = t(), e = !0), !e) {
		var i = window.Cookies, n = window.Cookies = t();
		n.noConflict = function () {
			return window.Cookies = i, n
		}
	}
}(function () {
	function t() {
		for (var t = 0, e = {}; t < arguments.length; t++) {
			var i = arguments[t];
			for (var n in i) e[n] = i[n]
		}
		return e
	}

	return function e(i) {
		function n(e, r, o) {
			var a;
			if ("undefined" != typeof document) {
				if (arguments.length > 1) {
					if ("number" == typeof (o = t({path: "/"}, n.defaults, o)).expires) {
						var s = new Date;
						s.setMilliseconds(s.getMilliseconds() + 864e5 * o.expires), o.expires = s
					}
					o.expires = o.expires ? o.expires.toUTCString() : "";
					try {
						a = JSON.stringify(r), /^[\{\[]/.test(a) && (r = a)
					} catch (t) {
					}
					r = i.write ? i.write(r, e) : encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = (e = (e = encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
					var l = "";
					for (var c in o) o[c] && (l += "; " + c, !0 !== o[c] && (l += "=" + o[c]));
					return document.cookie = e + "=" + r + l
				}
				e || (a = {});
				for (var u = document.cookie ? document.cookie.split("; ") : [], h = /(%[0-9A-Z]{2})+/g, d = 0; d < u.length; d++) {
					var p = u[d].split("="), f = p.slice(1).join("=");
					this.json || '"' !== f.charAt(0) || (f = f.slice(1, -1));
					try {
						var m = p[0].replace(h, decodeURIComponent);
						if (f = i.read ? i.read(f, m) : i(f, m) || f.replace(h, decodeURIComponent), this.json) try {
							f = JSON.parse(f)
						} catch (t) {
						}
						if (e === m) {
							a = f;
							break
						}
						e || (a[m] = f)
					} catch (t) {
					}
				}
				return a
			}
		}

		return n.set = n, n.get = function (t) {
			return n.call(n, t)
		}, n.getJSON = function () {
			return n.apply({json: !0}, [].slice.call(arguments))
		}, n.defaults = {}, n.remove = function (e, i) {
			n(e, "", t(i, {expires: -1}))
		}, n.withConverter = e, n
	}(function () {
	})
}), function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.moment = e()
}(this, function () {
	"use strict";
	var t, e;

	function i() {
		return t.apply(null, arguments)
	}

	function n(t) {
		return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t)
	}

	function r(t) {
		return null != t && "[object Object]" === Object.prototype.toString.call(t)
	}

	function o(t) {
		return void 0 === t
	}

	function a(t) {
		return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t)
	}

	function s(t) {
		return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t)
	}

	function l(t, e) {
		var i, n = [];
		for (i = 0; i < t.length; ++i) n.push(e(t[i], i));
		return n
	}

	function c(t, e) {
		return Object.prototype.hasOwnProperty.call(t, e)
	}

	function u(t, e) {
		for (var i in e) c(e, i) && (t[i] = e[i]);
		return c(e, "toString") && (t.toString = e.toString), c(e, "valueOf") && (t.valueOf = e.valueOf), t
	}

	function h(t, e, i, n) {
		return Ce(t, e, i, n, !0).utc()
	}

	function d(t) {
		return null == t._pf && (t._pf = {empty: !1, unusedTokens: [], unusedInput: [], overflow: -2, charsLeftOver: 0, nullInput: !1, invalidMonth: null, invalidFormat: !1, userInvalidated: !1, iso: !1, parsedDateParts: [], meridiem: null, rfc2822: !1, weekdayMismatch: !1}), t._pf
	}

	function p(t) {
		if (null == t._isValid) {
			var i = d(t), n = e.call(i.parsedDateParts, function (t) {
				return null != t
			}), r = !isNaN(t._d.getTime()) && i.overflow < 0 && !i.empty && !i.invalidMonth && !i.invalidWeekday && !i.weekdayMismatch && !i.nullInput && !i.invalidFormat && !i.userInvalidated && (!i.meridiem || i.meridiem && n);
			if (t._strict && (r = r && 0 === i.charsLeftOver && 0 === i.unusedTokens.length && void 0 === i.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return r;
			t._isValid = r
		}
		return t._isValid
	}

	function f(t) {
		var e = h(NaN);
		return null != t ? u(d(e), t) : d(e).userInvalidated = !0, e
	}

	e = Array.prototype.some ? Array.prototype.some : function (t) {
		for (var e = Object(this), i = e.length >>> 0, n = 0; n < i; n++) if (n in e && t.call(this, e[n], n, e)) return !0;
		return !1
	};
	var m = i.momentProperties = [];

	function g(t, e) {
		var i, n, r;
		if (o(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), o(e._i) || (t._i = e._i), o(e._f) || (t._f = e._f), o(e._l) || (t._l = e._l), o(e._strict) || (t._strict = e._strict), o(e._tzm) || (t._tzm = e._tzm), o(e._isUTC) || (t._isUTC = e._isUTC), o(e._offset) || (t._offset = e._offset), o(e._pf) || (t._pf = d(e)), o(e._locale) || (t._locale = e._locale), 0 < m.length) for (i = 0; i < m.length; i++) o(r = e[n = m[i]]) || (t[n] = r);
		return t
	}

	var v = !1;

	function y(t) {
		g(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === v && (v = !0, i.updateOffset(this), v = !1)
	}

	function b(t) {
		return t instanceof y || null != t && null != t._isAMomentObject
	}

	function w(t) {
		return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
	}

	function x(t) {
		var e = +t, i = 0;
		return 0 !== e && isFinite(e) && (i = w(e)), i
	}

	function k(t, e, i) {
		var n, r = Math.min(t.length, e.length), o = Math.abs(t.length - e.length), a = 0;
		for (n = 0; n < r; n++) (i && t[n] !== e[n] || !i && x(t[n]) !== x(e[n])) && a++;
		return a + o
	}

	function _(t) {
		!1 === i.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t)
	}

	function S(t, e) {
		var n = !0;
		return u(function () {
			if (null != i.deprecationHandler && i.deprecationHandler(null, t), n) {
				for (var r, o = [], a = 0; a < arguments.length; a++) {
					if (r = "", "object" == typeof arguments[a]) {
						for (var s in r += "\n[" + a + "] ", arguments[0]) r += s + ": " + arguments[0][s] + ", ";
						r = r.slice(0, -2)
					} else r = arguments[a];
					o.push(r)
				}
				_(t + "\nArguments: " + Array.prototype.slice.call(o).join("") + "\n" + (new Error).stack), n = !1
			}
			return e.apply(this, arguments)
		}, e)
	}

	var C, D = {};

	function T(t, e) {
		null != i.deprecationHandler && i.deprecationHandler(t, e), D[t] || (_(e), D[t] = !0)
	}

	function M(t) {
		return t instanceof Function || "[object Function]" === Object.prototype.toString.call(t)
	}

	function E(t, e) {
		var i, n = u({}, t);
		for (i in e) c(e, i) && (r(t[i]) && r(e[i]) ? (n[i] = {}, u(n[i], t[i]), u(n[i], e[i])) : null != e[i] ? n[i] = e[i] : delete n[i]);
		for (i in t) c(t, i) && !c(e, i) && r(t[i]) && (n[i] = u({}, n[i]));
		return n
	}

	function A(t) {
		null != t && this.set(t)
	}

	i.suppressDeprecationWarnings = !1, i.deprecationHandler = null, C = Object.keys ? Object.keys : function (t) {
		var e, i = [];
		for (e in t) c(t, e) && i.push(e);
		return i
	};
	var P = {};

	function I(t, e) {
		var i = t.toLowerCase();
		P[i] = P[i + "s"] = P[e] = t
	}

	function O(t) {
		return "string" == typeof t ? P[t] || P[t.toLowerCase()] : void 0
	}

	function L(t) {
		var e, i, n = {};
		for (i in t) c(t, i) && (e = O(i)) && (n[e] = t[i]);
		return n
	}

	var F = {};

	function N(t, e) {
		F[t] = e
	}

	function R(t, e, i) {
		var n = "" + Math.abs(t), r = e - n.length;
		return (0 <= t ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + n
	}

	var H = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, $ = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, B = {}, z = {};

	function j(t, e, i, n) {
		var r = n;
		"string" == typeof n && (r = function () {
			return this[n]()
		}), t && (z[t] = r), e && (z[e[0]] = function () {
			return R(r.apply(this, arguments), e[1], e[2])
		}), i && (z[i] = function () {
			return this.localeData().ordinal(r.apply(this, arguments), t)
		})
	}

	function U(t, e) {
		return t.isValid() ? (e = W(e, t.localeData()), B[e] = B[e] || function (t) {
			var e, i, n, r = t.match(H);
			for (e = 0, i = r.length; e < i; e++) z[r[e]] ? r[e] = z[r[e]] : r[e] = (n = r[e]).match(/\[[\s\S]/) ? n.replace(/^\[|\]$/g, "") : n.replace(/\\/g, "");
			return function (e) {
				var n, o = "";
				for (n = 0; n < i; n++) o += M(r[n]) ? r[n].call(e, t) : r[n];
				return o
			}
		}(e), B[e](t)) : t.localeData().invalidDate()
	}

	function W(t, e) {
		var i = 5;

		function n(t) {
			return e.longDateFormat(t) || t
		}

		for ($.lastIndex = 0; 0 <= i && $.test(t);) t = t.replace($, n), $.lastIndex = 0, i -= 1;
		return t
	}

	var Y = /\d/, V = /\d\d/, q = /\d{3}/, G = /\d{4}/, K = /[+-]?\d{6}/, X = /\d\d?/, Z = /\d\d\d\d?/, Q = /\d\d\d\d\d\d?/, J = /\d{1,3}/, tt = /\d{1,4}/, et = /[+-]?\d{1,6}/, it = /\d+/, nt = /[+-]?\d+/, rt = /Z|[+-]\d\d:?\d\d/gi, ot = /Z|[+-]\d\d(?::?\d\d)?/gi,
		at = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, st = {};

	function lt(t, e, i) {
		st[t] = M(e) ? e : function (t, n) {
			return t && i ? i : e
		}
	}

	function ct(t, e) {
		return c(st, t) ? st[t](e._strict, e._locale) : new RegExp(ut(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (t, e, i, n, r) {
			return e || i || n || r
		})))
	}

	function ut(t) {
		return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
	}

	var ht = {};

	function dt(t, e) {
		var i, n = e;
		for ("string" == typeof t && (t = [t]), a(e) && (n = function (t, i) {
			i[e] = x(t)
		}), i = 0; i < t.length; i++) ht[t[i]] = n
	}

	function pt(t, e) {
		dt(t, function (t, i, n, r) {
			n._w = n._w || {}, e(t, n._w, n, r)
		})
	}

	var ft = 0, mt = 1, gt = 2, vt = 3, yt = 4, bt = 5, wt = 6, xt = 7, kt = 8;

	function _t(t) {
		return St(t) ? 366 : 365
	}

	function St(t) {
		return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
	}

	j("Y", 0, 0, function () {
		var t = this.year();
		return t <= 9999 ? "" + t : "+" + t
	}), j(0, ["YY", 2], 0, function () {
		return this.year() % 100
	}), j(0, ["YYYY", 4], 0, "year"), j(0, ["YYYYY", 5], 0, "year"), j(0, ["YYYYYY", 6, !0], 0, "year"), I("year", "y"), N("year", 1), lt("Y", nt), lt("YY", X, V), lt("YYYY", tt, G), lt("YYYYY", et, K), lt("YYYYYY", et, K), dt(["YYYYY", "YYYYYY"], ft), dt("YYYY", function (t, e) {
		e[ft] = 2 === t.length ? i.parseTwoDigitYear(t) : x(t)
	}), dt("YY", function (t, e) {
		e[ft] = i.parseTwoDigitYear(t)
	}), dt("Y", function (t, e) {
		e[ft] = parseInt(t, 10)
	}), i.parseTwoDigitYear = function (t) {
		return x(t) + (68 < x(t) ? 1900 : 2e3)
	};
	var Ct, Dt = Tt("FullYear", !0);

	function Tt(t, e) {
		return function (n) {
			return null != n ? (Et(this, t, n), i.updateOffset(this, e), this) : Mt(this, t)
		}
	}

	function Mt(t, e) {
		return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN
	}

	function Et(t, e, i) {
		t.isValid() && !isNaN(i) && ("FullYear" === e && St(t.year()) && 1 === t.month() && 29 === t.date() ? t._d["set" + (t._isUTC ? "UTC" : "") + e](i, t.month(), At(i, t.month())) : t._d["set" + (t._isUTC ? "UTC" : "") + e](i))
	}

	function At(t, e) {
		if (isNaN(t) || isNaN(e)) return NaN;
		var i = (e % 12 + 12) % 12;
		return t += (e - i) / 12, 1 === i ? St(t) ? 29 : 28 : 31 - i % 7 % 2
	}

	Ct = Array.prototype.indexOf ? Array.prototype.indexOf : function (t) {
		var e;
		for (e = 0; e < this.length; ++e) if (this[e] === t) return e;
		return -1
	}, j("M", ["MM", 2], "Mo", function () {
		return this.month() + 1
	}), j("MMM", 0, 0, function (t) {
		return this.localeData().monthsShort(this, t)
	}), j("MMMM", 0, 0, function (t) {
		return this.localeData().months(this, t)
	}), I("month", "M"), N("month", 8), lt("M", X), lt("MM", X, V), lt("MMM", function (t, e) {
		return e.monthsShortRegex(t)
	}), lt("MMMM", function (t, e) {
		return e.monthsRegex(t)
	}), dt(["M", "MM"], function (t, e) {
		e[mt] = x(t) - 1
	}), dt(["MMM", "MMMM"], function (t, e, i, n) {
		var r = i._locale.monthsParse(t, n, i._strict);
		null != r ? e[mt] = r : d(i).invalidMonth = t
	});
	var Pt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, It = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), Ot = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");

	function Lt(t, e) {
		var i;
		if (!t.isValid()) return t;
		if ("string" == typeof e) if (/^\d+$/.test(e)) e = x(e); else if (!a(e = t.localeData().monthsParse(e))) return t;
		return i = Math.min(t.date(), At(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i), t
	}

	function Ft(t) {
		return null != t ? (Lt(this, t), i.updateOffset(this, !0), this) : Mt(this, "Month")
	}

	var Nt = at, Rt = at;

	function Ht() {
		function t(t, e) {
			return e.length - t.length
		}

		var e, i, n = [], r = [], o = [];
		for (e = 0; e < 12; e++) i = h([2e3, e]), n.push(this.monthsShort(i, "")), r.push(this.months(i, "")), o.push(this.months(i, "")), o.push(this.monthsShort(i, ""));
		for (n.sort(t), r.sort(t), o.sort(t), e = 0; e < 12; e++) n[e] = ut(n[e]), r[e] = ut(r[e]);
		for (e = 0; e < 24; e++) o[e] = ut(o[e]);
		this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + n.join("|") + ")", "i")
	}

	function $t(t) {
		var e = new Date(Date.UTC.apply(null, arguments));
		return t < 100 && 0 <= t && isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t), e
	}

	function Bt(t, e, i) {
		var n = 7 + e - i;
		return -(7 + $t(t, 0, n).getUTCDay() - e) % 7 + n - 1
	}

	function zt(t, e, i, n, r) {
		var o, a, s = 1 + 7 * (e - 1) + (7 + i - n) % 7 + Bt(t, n, r);
		return s <= 0 ? a = _t(o = t - 1) + s : s > _t(t) ? (o = t + 1, a = s - _t(t)) : (o = t, a = s), {year: o, dayOfYear: a}
	}

	function jt(t, e, i) {
		var n, r, o = Bt(t.year(), e, i), a = Math.floor((t.dayOfYear() - o - 1) / 7) + 1;
		return a < 1 ? n = a + Ut(r = t.year() - 1, e, i) : a > Ut(t.year(), e, i) ? (n = a - Ut(t.year(), e, i), r = t.year() + 1) : (r = t.year(), n = a), {week: n, year: r}
	}

	function Ut(t, e, i) {
		var n = Bt(t, e, i), r = Bt(t + 1, e, i);
		return (_t(t) - n + r) / 7
	}

	j("w", ["ww", 2], "wo", "week"), j("W", ["WW", 2], "Wo", "isoWeek"), I("week", "w"), I("isoWeek", "W"), N("week", 5), N("isoWeek", 5), lt("w", X), lt("ww", X, V), lt("W", X), lt("WW", X, V), pt(["w", "ww", "W", "WW"], function (t, e, i, n) {
		e[n.substr(0, 1)] = x(t)
	}), j("d", 0, "do", "day"), j("dd", 0, 0, function (t) {
		return this.localeData().weekdaysMin(this, t)
	}), j("ddd", 0, 0, function (t) {
		return this.localeData().weekdaysShort(this, t)
	}), j("dddd", 0, 0, function (t) {
		return this.localeData().weekdays(this, t)
	}), j("e", 0, 0, "weekday"), j("E", 0, 0, "isoWeekday"), I("day", "d"), I("weekday", "e"), I("isoWeekday", "E"), N("day", 11), N("weekday", 11), N("isoWeekday", 11), lt("d", X), lt("e", X), lt("E", X), lt("dd", function (t, e) {
		return e.weekdaysMinRegex(t)
	}), lt("ddd", function (t, e) {
		return e.weekdaysShortRegex(t)
	}), lt("dddd", function (t, e) {
		return e.weekdaysRegex(t)
	}), pt(["dd", "ddd", "dddd"], function (t, e, i, n) {
		var r = i._locale.weekdaysParse(t, n, i._strict);
		null != r ? e.d = r : d(i).invalidWeekday = t
	}), pt(["d", "e", "E"], function (t, e, i, n) {
		e[n] = x(t)
	});
	var Wt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Yt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Vt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), qt = at, Gt = at, Kt = at;

	function Xt() {
		function t(t, e) {
			return e.length - t.length
		}

		var e, i, n, r, o, a = [], s = [], l = [], c = [];
		for (e = 0; e < 7; e++) i = h([2e3, 1]).day(e), n = this.weekdaysMin(i, ""), r = this.weekdaysShort(i, ""), o = this.weekdays(i, ""), a.push(n), s.push(r), l.push(o), c.push(n), c.push(r), c.push(o);
		for (a.sort(t), s.sort(t), l.sort(t), c.sort(t), e = 0; e < 7; e++) s[e] = ut(s[e]), l[e] = ut(l[e]), c[e] = ut(c[e]);
		this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + a.join("|") + ")", "i")
	}

	function Zt() {
		return this.hours() % 12 || 12
	}

	function Qt(t, e) {
		j(t, 0, 0, function () {
			return this.localeData().meridiem(this.hours(), this.minutes(), e)
		})
	}

	function Jt(t, e) {
		return e._meridiemParse
	}

	j("H", ["HH", 2], 0, "hour"), j("h", ["hh", 2], 0, Zt), j("k", ["kk", 2], 0, function () {
		return this.hours() || 24
	}), j("hmm", 0, 0, function () {
		return "" + Zt.apply(this) + R(this.minutes(), 2)
	}), j("hmmss", 0, 0, function () {
		return "" + Zt.apply(this) + R(this.minutes(), 2) + R(this.seconds(), 2)
	}), j("Hmm", 0, 0, function () {
		return "" + this.hours() + R(this.minutes(), 2)
	}), j("Hmmss", 0, 0, function () {
		return "" + this.hours() + R(this.minutes(), 2) + R(this.seconds(), 2)
	}), Qt("a", !0), Qt("A", !1), I("hour", "h"), N("hour", 13), lt("a", Jt), lt("A", Jt), lt("H", X), lt("h", X), lt("k", X), lt("HH", X, V), lt("hh", X, V), lt("kk", X, V), lt("hmm", Z), lt("hmmss", Q), lt("Hmm", Z), lt("Hmmss", Q), dt(["H", "HH"], vt), dt(["k", "kk"], function (t, e, i) {
		var n = x(t);
		e[vt] = 24 === n ? 0 : n
	}), dt(["a", "A"], function (t, e, i) {
		i._isPm = i._locale.isPM(t), i._meridiem = t
	}), dt(["h", "hh"], function (t, e, i) {
		e[vt] = x(t), d(i).bigHour = !0
	}), dt("hmm", function (t, e, i) {
		var n = t.length - 2;
		e[vt] = x(t.substr(0, n)), e[yt] = x(t.substr(n)), d(i).bigHour = !0
	}), dt("hmmss", function (t, e, i) {
		var n = t.length - 4, r = t.length - 2;
		e[vt] = x(t.substr(0, n)), e[yt] = x(t.substr(n, 2)), e[bt] = x(t.substr(r)), d(i).bigHour = !0
	}), dt("Hmm", function (t, e, i) {
		var n = t.length - 2;
		e[vt] = x(t.substr(0, n)), e[yt] = x(t.substr(n))
	}), dt("Hmmss", function (t, e, i) {
		var n = t.length - 4, r = t.length - 2;
		e[vt] = x(t.substr(0, n)), e[yt] = x(t.substr(n, 2)), e[bt] = x(t.substr(r))
	});
	var te, ee = Tt("Hours", !0), ie = {
		calendar: {sameDay: "[Today at] LT", nextDay: "[Tomorrow at] LT", nextWeek: "dddd [at] LT", lastDay: "[Yesterday at] LT", lastWeek: "[Last] dddd [at] LT", sameElse: "L"},
		longDateFormat: {LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A"},
		invalidDate: "Invalid date",
		ordinal: "%d",
		dayOfMonthOrdinalParse: /\d{1,2}/,
		relativeTime: {future: "in %s", past: "%s ago", s: "a few seconds", ss: "%d seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years"},
		months: It,
		monthsShort: Ot,
		week: {dow: 0, doy: 6},
		weekdays: Wt,
		weekdaysMin: Vt,
		weekdaysShort: Yt,
		meridiemParse: /[ap]\.?m?\.?/i
	}, ne = {}, re = {};

	function oe(t) {
		return t ? t.toLowerCase().replace("_", "-") : t
	}

	function ae(t) {
		var e = null;
		if (!ne[t] && "undefined" != typeof module && module && module.exports) try {
			e = te._abbr, require("./locale/" + t), se(e)
		} catch (t) {
		}
		return ne[t]
	}

	function se(t, e) {
		var i;
		return t && ((i = o(e) ? ce(t) : le(t, e)) ? te = i : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), te._abbr
	}

	function le(t, e) {
		if (null !== e) {
			var i, n = ie;
			if (e.abbr = t, null != ne[t]) T("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), n = ne[t]._config; else if (null != e.parentLocale) if (null != ne[e.parentLocale]) n = ne[e.parentLocale]._config; else {
				if (null == (i = ae(e.parentLocale))) return re[e.parentLocale] || (re[e.parentLocale] = []), re[e.parentLocale].push({name: t, config: e}), null;
				n = i._config
			}
			return ne[t] = new A(E(n, e)), re[t] && re[t].forEach(function (t) {
				le(t.name, t.config)
			}), se(t), ne[t]
		}
		return delete ne[t], null
	}

	function ce(t) {
		var e;
		if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return te;
		if (!n(t)) {
			if (e = ae(t)) return e;
			t = [t]
		}
		return function (t) {
			for (var e, i, n, r, o = 0; o < t.length;) {
				for (e = (r = oe(t[o]).split("-")).length, i = (i = oe(t[o + 1])) ? i.split("-") : null; 0 < e;) {
					if (n = ae(r.slice(0, e).join("-"))) return n;
					if (i && i.length >= e && k(r, i, !0) >= e - 1) break;
					e--
				}
				o++
			}
			return te
		}(t)
	}

	function ue(t) {
		var e, i = t._a;
		return i && -2 === d(t).overflow && (e = i[mt] < 0 || 11 < i[mt] ? mt : i[gt] < 1 || i[gt] > At(i[ft], i[mt]) ? gt : i[vt] < 0 || 24 < i[vt] || 24 === i[vt] && (0 !== i[yt] || 0 !== i[bt] || 0 !== i[wt]) ? vt : i[yt] < 0 || 59 < i[yt] ? yt : i[bt] < 0 || 59 < i[bt] ? bt : i[wt] < 0 || 999 < i[wt] ? wt : -1, d(t)._overflowDayOfYear && (e < ft || gt < e) && (e = gt), d(t)._overflowWeeks && -1 === e && (e = xt), d(t)._overflowWeekday && -1 === e && (e = kt), d(t).overflow = e), t
	}

	function he(t, e, i) {
		return null != t ? t : null != e ? e : i
	}

	function de(t) {
		var e, n, r, o, a, s = [];
		if (!t._d) {
			var l, c;
			for (l = t, c = new Date(i.now()), r = l._useUTC ? [c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()] : [c.getFullYear(), c.getMonth(), c.getDate()], t._w && null == t._a[gt] && null == t._a[mt] && function (t) {
				var e, i, n, r, o, a, s, l;
				if (null != (e = t._w).GG || null != e.W || null != e.E) o = 1, a = 4, i = he(e.GG, t._a[ft], jt(De(), 1, 4).year), n = he(e.W, 1), ((r = he(e.E, 1)) < 1 || 7 < r) && (l = !0); else {
					o = t._locale._week.dow, a = t._locale._week.doy;
					var c = jt(De(), o, a);
					i = he(e.gg, t._a[ft], c.year), n = he(e.w, c.week), null != e.d ? ((r = e.d) < 0 || 6 < r) && (l = !0) : null != e.e ? (r = e.e + o, (e.e < 0 || 6 < e.e) && (l = !0)) : r = o
				}
				n < 1 || n > Ut(i, o, a) ? d(t)._overflowWeeks = !0 : null != l ? d(t)._overflowWeekday = !0 : (s = zt(i, n, r, o, a), t._a[ft] = s.year, t._dayOfYear = s.dayOfYear)
			}(t), null != t._dayOfYear && (a = he(t._a[ft], r[ft]), (t._dayOfYear > _t(a) || 0 === t._dayOfYear) && (d(t)._overflowDayOfYear = !0), n = $t(a, 0, t._dayOfYear), t._a[mt] = n.getUTCMonth(), t._a[gt] = n.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) t._a[e] = s[e] = r[e];
			for (; e < 7; e++) t._a[e] = s[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
			24 === t._a[vt] && 0 === t._a[yt] && 0 === t._a[bt] && 0 === t._a[wt] && (t._nextDay = !0, t._a[vt] = 0), t._d = (t._useUTC ? $t : function (t, e, i, n, r, o, a) {
				var s = new Date(t, e, i, n, r, o, a);
				return t < 100 && 0 <= t && isFinite(s.getFullYear()) && s.setFullYear(t), s
			}).apply(null, s), o = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[vt] = 24), t._w && void 0 !== t._w.d && t._w.d !== o && (d(t).weekdayMismatch = !0)
		}
	}

	var pe = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
		fe = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/, me = /Z|[+-]\d\d(?::?\d\d)?/,
		ge = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/]],
		ve = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
		ye = /^\/?Date\((\-?\d+)/i;

	function be(t) {
		var e, i, n, r, o, a, s = t._i, l = pe.exec(s) || fe.exec(s);
		if (l) {
			for (d(t).iso = !0, e = 0, i = ge.length; e < i; e++) if (ge[e][1].exec(l[1])) {
				r = ge[e][0], n = !1 !== ge[e][2];
				break
			}
			if (null == r) return void (t._isValid = !1);
			if (l[3]) {
				for (e = 0, i = ve.length; e < i; e++) if (ve[e][1].exec(l[3])) {
					o = (l[2] || " ") + ve[e][0];
					break
				}
				if (null == o) return void (t._isValid = !1)
			}
			if (!n && null != o) return void (t._isValid = !1);
			if (l[4]) {
				if (!me.exec(l[4])) return void (t._isValid = !1);
				a = "Z"
			}
			t._f = r + (o || "") + (a || ""), _e(t)
		} else t._isValid = !1
	}

	var we = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	var xe = {UT: 0, GMT: 0, EDT: -240, EST: -300, CDT: -300, CST: -360, MDT: -360, MST: -420, PDT: -420, PST: -480};

	function ke(t) {
		var e, i, n, r = we.exec(t._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
		if (r) {
			var o = function (t, e, i, n, r, o) {
				var a = [function (t) {
					var e = parseInt(t, 10);
					return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e
				}(t), Ot.indexOf(e), parseInt(i, 10), parseInt(n, 10), parseInt(r, 10)];
				return o && a.push(parseInt(o, 10)), a
			}(r[4], r[3], r[2], r[5], r[6], r[7]);
			if (i = o, n = t, (e = r[1]) && Yt.indexOf(e) !== new Date(i[0], i[1], i[2]).getDay() && (d(n).weekdayMismatch = !0, !(n._isValid = !1))) return;
			t._a = o, t._tzm = function (t, e, i) {
				if (t) return xe[t];
				if (e) return 0;
				var n = parseInt(i, 10), r = n % 100;
				return (n - r) / 100 * 60 + r
			}(r[8], r[9], r[10]), t._d = $t.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), d(t).rfc2822 = !0
		} else t._isValid = !1
	}

	function _e(t) {
		if (t._f !== i.ISO_8601) if (t._f !== i.RFC_2822) {
			t._a = [], d(t).empty = !0;
			var e, n, r, o, a, s, l, u, h = "" + t._i, p = h.length, f = 0;
			for (r = W(t._f, t._locale).match(H) || [], e = 0; e < r.length; e++) o = r[e], (n = (h.match(ct(o, t)) || [])[0]) && (0 < (a = h.substr(0, h.indexOf(n))).length && d(t).unusedInput.push(a), h = h.slice(h.indexOf(n) + n.length), f += n.length), z[o] ? (n ? d(t).empty = !1 : d(t).unusedTokens.push(o), s = o, u = t, null != (l = n) && c(ht, s) && ht[s](l, u._a, u, s)) : t._strict && !n && d(t).unusedTokens.push(o);
			d(t).charsLeftOver = p - f, 0 < h.length && d(t).unusedInput.push(h), t._a[vt] <= 12 && !0 === d(t).bigHour && 0 < t._a[vt] && (d(t).bigHour = void 0), d(t).parsedDateParts = t._a.slice(0), d(t).meridiem = t._meridiem, t._a[vt] = function (t, e, i) {
				var n;
				return null == i ? e : null != t.meridiemHour ? t.meridiemHour(e, i) : (null != t.isPM && ((n = t.isPM(i)) && e < 12 && (e += 12), n || 12 !== e || (e = 0)), e)
			}(t._locale, t._a[vt], t._meridiem), de(t), ue(t)
		} else ke(t); else be(t)
	}

	function Se(t) {
		var e, c, h, m, v = t._i, w = t._f;
		return t._locale = t._locale || ce(t._l), null === v || void 0 === w && "" === v ? f({nullInput: !0}) : ("string" == typeof v && (t._i = v = t._locale.preparse(v)), b(v) ? new y(ue(v)) : (s(v) ? t._d = v : n(w) ? function (t) {
			var e, i, n, r, o;
			if (0 === t._f.length) return d(t).invalidFormat = !0, t._d = new Date(NaN);
			for (r = 0; r < t._f.length; r++) o = 0, e = g({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[r], _e(e), p(e) && (o += d(e).charsLeftOver, o += 10 * d(e).unusedTokens.length, d(e).score = o, (null == n || o < n) && (n = o, i = e));
			u(t, i || e)
		}(t) : w ? _e(t) : o(c = (e = t)._i) ? e._d = new Date(i.now()) : s(c) ? e._d = new Date(c.valueOf()) : "string" == typeof c ? (h = e, null === (m = ye.exec(h._i)) ? (be(h), !1 === h._isValid && (delete h._isValid, ke(h), !1 === h._isValid && (delete h._isValid, i.createFromInputFallback(h)))) : h._d = new Date(+m[1])) : n(c) ? (e._a = l(c.slice(0), function (t) {
			return parseInt(t, 10)
		}), de(e)) : r(c) ? function (t) {
			if (!t._d) {
				var e = L(t._i);
				t._a = l([e.year, e.month, e.day || e.date, e.hour, e.minute, e.second, e.millisecond], function (t) {
					return t && parseInt(t, 10)
				}), de(t)
			}
		}(e) : a(c) ? e._d = new Date(c) : i.createFromInputFallback(e), p(t) || (t._d = null), t))
	}

	function Ce(t, e, i, o, a) {
		var s, l = {};
		return !0 !== i && !1 !== i || (o = i, i = void 0), (r(t) && function (t) {
			if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
			var e;
			for (e in t) if (t.hasOwnProperty(e)) return !1;
			return !0
		}(t) || n(t) && 0 === t.length) && (t = void 0), l._isAMomentObject = !0, l._useUTC = l._isUTC = a, l._l = i, l._i = t, l._f = e, l._strict = o, (s = new y(ue(Se(l))))._nextDay && (s.add(1, "d"), s._nextDay = void 0), s
	}

	function De(t, e, i, n) {
		return Ce(t, e, i, n, !1)
	}

	i.createFromInputFallback = S("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (t) {
		t._d = new Date(t._i + (t._useUTC ? " UTC" : ""))
	}), i.ISO_8601 = function () {
	}, i.RFC_2822 = function () {
	};
	var Te = S("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
		var t = De.apply(null, arguments);
		return this.isValid() && t.isValid() ? t < this ? this : t : f()
	}), Me = S("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
		var t = De.apply(null, arguments);
		return this.isValid() && t.isValid() ? this < t ? this : t : f()
	});

	function Ee(t, e) {
		var i, r;
		if (1 === e.length && n(e[0]) && (e = e[0]), !e.length) return De();
		for (i = e[0], r = 1; r < e.length; ++r) e[r].isValid() && !e[r][t](i) || (i = e[r]);
		return i
	}

	var Ae = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

	function Pe(t) {
		var e = L(t), i = e.year || 0, n = e.quarter || 0, r = e.month || 0, o = e.week || 0, a = e.day || 0, s = e.hour || 0, l = e.minute || 0, c = e.second || 0, u = e.millisecond || 0;
		this._isValid = function (t) {
			for (var e in t) if (-1 === Ct.call(Ae, e) || null != t[e] && isNaN(t[e])) return !1;
			for (var i = !1, n = 0; n < Ae.length; ++n) if (t[Ae[n]]) {
				if (i) return !1;
				parseFloat(t[Ae[n]]) !== x(t[Ae[n]]) && (i = !0)
			}
			return !0
		}(e), this._milliseconds = +u + 1e3 * c + 6e4 * l + 1e3 * s * 60 * 60, this._days = +a + 7 * o, this._months = +r + 3 * n + 12 * i, this._data = {}, this._locale = ce(), this._bubble()
	}

	function Ie(t) {
		return t instanceof Pe
	}

	function Oe(t) {
		return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t)
	}

	function Le(t, e) {
		j(t, 0, 0, function () {
			var t = this.utcOffset(), i = "+";
			return t < 0 && (t = -t, i = "-"), i + R(~~(t / 60), 2) + e + R(~~t % 60, 2)
		})
	}

	Le("Z", ":"), Le("ZZ", ""), lt("Z", ot), lt("ZZ", ot), dt(["Z", "ZZ"], function (t, e, i) {
		i._useUTC = !0, i._tzm = Ne(ot, t)
	});
	var Fe = /([\+\-]|\d\d)/gi;

	function Ne(t, e) {
		var i = (e || "").match(t);
		if (null === i) return null;
		var n = ((i[i.length - 1] || []) + "").match(Fe) || ["-", 0, 0], r = 60 * n[1] + x(n[2]);
		return 0 === r ? 0 : "+" === n[0] ? r : -r
	}

	function Re(t, e) {
		var n, r;
		return e._isUTC ? (n = e.clone(), r = (b(t) || s(t) ? t.valueOf() : De(t).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), i.updateOffset(n, !1), n) : De(t).local()
	}

	function He(t) {
		return 15 * -Math.round(t._d.getTimezoneOffset() / 15)
	}

	function $e() {
		return !!this.isValid() && this._isUTC && 0 === this._offset
	}

	i.updateOffset = function () {
	};
	var Be = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/, ze = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	function je(t, e) {
		var i, n, r, o = t, s = null;
		return Ie(t) ? o = {ms: t._milliseconds, d: t._days, M: t._months} : a(t) ? (o = {}, e ? o[e] = t : o.milliseconds = t) : (s = Be.exec(t)) ? (i = "-" === s[1] ? -1 : 1, o = {
			y: 0,
			d: x(s[gt]) * i,
			h: x(s[vt]) * i,
			m: x(s[yt]) * i,
			s: x(s[bt]) * i,
			ms: x(Oe(1e3 * s[wt])) * i
		}) : (s = ze.exec(t)) ? (i = "-" === s[1] ? -1 : (s[1], 1), o = {y: Ue(s[2], i), M: Ue(s[3], i), w: Ue(s[4], i), d: Ue(s[5], i), h: Ue(s[6], i), m: Ue(s[7], i), s: Ue(s[8], i)}) : null == o ? o = {} : "object" == typeof o && ("from" in o || "to" in o) && (r = function (t, e) {
			var i;
			return t.isValid() && e.isValid() ? (e = Re(e, t), t.isBefore(e) ? i = We(t, e) : ((i = We(e, t)).milliseconds = -i.milliseconds, i.months = -i.months), i) : {milliseconds: 0, months: 0}
		}(De(o.from), De(o.to)), (o = {}).ms = r.milliseconds, o.M = r.months), n = new Pe(o), Ie(t) && c(t, "_locale") && (n._locale = t._locale), n
	}

	function Ue(t, e) {
		var i = t && parseFloat(t.replace(",", "."));
		return (isNaN(i) ? 0 : i) * e
	}

	function We(t, e) {
		var i = {milliseconds: 0, months: 0};
		return i.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(i.months, "M").isAfter(e) && --i.months, i.milliseconds = +e - +t.clone().add(i.months, "M"), i
	}

	function Ye(t, e) {
		return function (i, n) {
			var r;
			return null === n || isNaN(+n) || (T(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), r = i, i = n, n = r), Ve(this, je(i = "string" == typeof i ? +i : i, n), t), this
		}
	}

	function Ve(t, e, n, r) {
		var o = e._milliseconds, a = Oe(e._days), s = Oe(e._months);
		t.isValid() && (r = null == r || r, s && Lt(t, Mt(t, "Month") + s * n), a && Et(t, "Date", Mt(t, "Date") + a * n), o && t._d.setTime(t._d.valueOf() + o * n), r && i.updateOffset(t, a || s))
	}

	je.fn = Pe.prototype, je.invalid = function () {
		return je(NaN)
	};
	var qe = Ye(1, "add"), Ge = Ye(-1, "subtract");

	function Ke(t, e) {
		var i = 12 * (e.year() - t.year()) + (e.month() - t.month()), n = t.clone().add(i, "months");
		return -(i + (e - n < 0 ? (e - n) / (n - t.clone().add(i - 1, "months")) : (e - n) / (t.clone().add(i + 1, "months") - n))) || 0
	}

	function Xe(t) {
		var e;
		return void 0 === t ? this._locale._abbr : (null != (e = ce(t)) && (this._locale = e), this)
	}

	i.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", i.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
	var Ze = S("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (t) {
		return void 0 === t ? this.localeData() : this.locale(t)
	});

	function Qe() {
		return this._locale
	}

	function Je(t, e) {
		j(0, [t, t.length], 0, e)
	}

	function ti(t, e, i, n, r) {
		var o;
		return null == t ? jt(this, n, r).year : ((o = Ut(t, n, r)) < e && (e = o), function (t, e, i, n, r) {
			var o = zt(t, e, i, n, r), a = $t(o.year, 0, o.dayOfYear);
			return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this
		}.call(this, t, e, i, n, r))
	}

	j(0, ["gg", 2], 0, function () {
		return this.weekYear() % 100
	}), j(0, ["GG", 2], 0, function () {
		return this.isoWeekYear() % 100
	}), Je("gggg", "weekYear"), Je("ggggg", "weekYear"), Je("GGGG", "isoWeekYear"), Je("GGGGG", "isoWeekYear"), I("weekYear", "gg"), I("isoWeekYear", "GG"), N("weekYear", 1), N("isoWeekYear", 1), lt("G", nt), lt("g", nt), lt("GG", X, V), lt("gg", X, V), lt("GGGG", tt, G), lt("gggg", tt, G), lt("GGGGG", et, K), lt("ggggg", et, K), pt(["gggg", "ggggg", "GGGG", "GGGGG"], function (t, e, i, n) {
		e[n.substr(0, 2)] = x(t)
	}), pt(["gg", "GG"], function (t, e, n, r) {
		e[r] = i.parseTwoDigitYear(t)
	}), j("Q", 0, "Qo", "quarter"), I("quarter", "Q"), N("quarter", 7), lt("Q", Y), dt("Q", function (t, e) {
		e[mt] = 3 * (x(t) - 1)
	}), j("D", ["DD", 2], "Do", "date"), I("date", "D"), N("date", 9), lt("D", X), lt("DD", X, V), lt("Do", function (t, e) {
		return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient
	}), dt(["D", "DD"], gt), dt("Do", function (t, e) {
		e[gt] = x(t.match(X)[0])
	});
	var ei = Tt("Date", !0);
	j("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), I("dayOfYear", "DDD"), N("dayOfYear", 4), lt("DDD", J), lt("DDDD", q), dt(["DDD", "DDDD"], function (t, e, i) {
		i._dayOfYear = x(t)
	}), j("m", ["mm", 2], 0, "minute"), I("minute", "m"), N("minute", 14), lt("m", X), lt("mm", X, V), dt(["m", "mm"], yt);
	var ii = Tt("Minutes", !1);
	j("s", ["ss", 2], 0, "second"), I("second", "s"), N("second", 15), lt("s", X), lt("ss", X, V), dt(["s", "ss"], bt);
	var ni, ri = Tt("Seconds", !1);
	for (j("S", 0, 0, function () {
		return ~~(this.millisecond() / 100)
	}), j(0, ["SS", 2], 0, function () {
		return ~~(this.millisecond() / 10)
	}), j(0, ["SSS", 3], 0, "millisecond"), j(0, ["SSSS", 4], 0, function () {
		return 10 * this.millisecond()
	}), j(0, ["SSSSS", 5], 0, function () {
		return 100 * this.millisecond()
	}), j(0, ["SSSSSS", 6], 0, function () {
		return 1e3 * this.millisecond()
	}), j(0, ["SSSSSSS", 7], 0, function () {
		return 1e4 * this.millisecond()
	}), j(0, ["SSSSSSSS", 8], 0, function () {
		return 1e5 * this.millisecond()
	}), j(0, ["SSSSSSSSS", 9], 0, function () {
		return 1e6 * this.millisecond()
	}), I("millisecond", "ms"), N("millisecond", 16), lt("S", J, Y), lt("SS", J, V), lt("SSS", J, q), ni = "SSSS"; ni.length <= 9; ni += "S") lt(ni, it);

	function oi(t, e) {
		e[wt] = x(1e3 * ("0." + t))
	}

	for (ni = "S"; ni.length <= 9; ni += "S") dt(ni, oi);
	var ai = Tt("Milliseconds", !1);
	j("z", 0, 0, "zoneAbbr"), j("zz", 0, 0, "zoneName");
	var si = y.prototype;

	function li(t) {
		return t
	}

	si.add = qe, si.calendar = function (t, e) {
		var n = t || De(), r = Re(n, this).startOf("day"), o = i.calendarFormat(this, r) || "sameElse", a = e && (M(e[o]) ? e[o].call(this, n) : e[o]);
		return this.format(a || this.localeData().calendar(o, this, De(n)))
	}, si.clone = function () {
		return new y(this)
	}, si.diff = function (t, e, i) {
		var n, r, o;
		if (!this.isValid()) return NaN;
		if (!(n = Re(t, this)).isValid()) return NaN;
		switch (r = 6e4 * (n.utcOffset() - this.utcOffset()), e = O(e)) {
			case"year":
				o = Ke(this, n) / 12;
				break;
			case"month":
				o = Ke(this, n);
				break;
			case"quarter":
				o = Ke(this, n) / 3;
				break;
			case"second":
				o = (this - n) / 1e3;
				break;
			case"minute":
				o = (this - n) / 6e4;
				break;
			case"hour":
				o = (this - n) / 36e5;
				break;
			case"day":
				o = (this - n - r) / 864e5;
				break;
			case"week":
				o = (this - n - r) / 6048e5;
				break;
			default:
				o = this - n
		}
		return i ? o : w(o)
	}, si.endOf = function (t) {
		return void 0 === (t = O(t)) || "millisecond" === t ? this : ("date" === t && (t = "day"), this.startOf(t).add(1, "isoWeek" === t ? "week" : t).subtract(1, "ms"))
	}, si.format = function (t) {
		t || (t = this.isUtc() ? i.defaultFormatUtc : i.defaultFormat);
		var e = U(this, t);
		return this.localeData().postformat(e)
	}, si.from = function (t, e) {
		return this.isValid() && (b(t) && t.isValid() || De(t).isValid()) ? je({to: this, from: t}).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
	}, si.fromNow = function (t) {
		return this.from(De(), t)
	}, si.to = function (t, e) {
		return this.isValid() && (b(t) && t.isValid() || De(t).isValid()) ? je({from: this, to: t}).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
	}, si.toNow = function (t) {
		return this.to(De(), t)
	}, si.get = function (t) {
		return M(this[t = O(t)]) ? this[t]() : this
	}, si.invalidAt = function () {
		return d(this).overflow
	}, si.isAfter = function (t, e) {
		var i = b(t) ? t : De(t);
		return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = O(o(e) ? "millisecond" : e)) ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf())
	}, si.isBefore = function (t, e) {
		var i = b(t) ? t : De(t);
		return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = O(o(e) ? "millisecond" : e)) ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf())
	}, si.isBetween = function (t, e, i, n) {
		return ("(" === (n = n || "()")[0] ? this.isAfter(t, i) : !this.isBefore(t, i)) && (")" === n[1] ? this.isBefore(e, i) : !this.isAfter(e, i))
	}, si.isSame = function (t, e) {
		var i, n = b(t) ? t : De(t);
		return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = O(e || "millisecond")) ? this.valueOf() === n.valueOf() : (i = n.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()))
	}, si.isSameOrAfter = function (t, e) {
		return this.isSame(t, e) || this.isAfter(t, e)
	}, si.isSameOrBefore = function (t, e) {
		return this.isSame(t, e) || this.isBefore(t, e)
	}, si.isValid = function () {
		return p(this)
	}, si.lang = Ze, si.locale = Xe, si.localeData = Qe, si.max = Me, si.min = Te, si.parsingFlags = function () {
		return u({}, d(this))
	}, si.set = function (t, e) {
		if ("object" == typeof t) for (var i = function (t) {
			var e = [];
			for (var i in t) e.push({unit: i, priority: F[i]});
			return e.sort(function (t, e) {
				return t.priority - e.priority
			}), e
		}(t = L(t)), n = 0; n < i.length; n++) this[i[n].unit](t[i[n].unit]); else if (M(this[t = O(t)])) return this[t](e);
		return this
	}, si.startOf = function (t) {
		switch (t = O(t)) {
			case"year":
				this.month(0);
			case"quarter":
			case"month":
				this.date(1);
			case"week":
			case"isoWeek":
			case"day":
			case"date":
				this.hours(0);
			case"hour":
				this.minutes(0);
			case"minute":
				this.seconds(0);
			case"second":
				this.milliseconds(0)
		}
		return "week" === t && this.weekday(0), "isoWeek" === t && this.isoWeekday(1), "quarter" === t && this.month(3 * Math.floor(this.month() / 3)), this
	}, si.subtract = Ge, si.toArray = function () {
		var t = this;
		return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()]
	}, si.toObject = function () {
		var t = this;
		return {years: t.year(), months: t.month(), date: t.date(), hours: t.hours(), minutes: t.minutes(), seconds: t.seconds(), milliseconds: t.milliseconds()}
	}, si.toDate = function () {
		return new Date(this.valueOf())
	}, si.toISOString = function (t) {
		if (!this.isValid()) return null;
		var e = !0 !== t, i = e ? this.clone().utc() : this;
		return i.year() < 0 || 9999 < i.year() ? U(i, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : M(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", U(i, "Z")) : U(i, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ")
	}, si.inspect = function () {
		if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
		var t = "moment", e = "";
		this.isLocal() || (t = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", e = "Z");
		var i = "[" + t + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", r = e + '[")]';
		return this.format(i + n + "-MM-DD[T]HH:mm:ss.SSS" + r)
	}, si.toJSON = function () {
		return this.isValid() ? this.toISOString() : null
	}, si.toString = function () {
		return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
	}, si.unix = function () {
		return Math.floor(this.valueOf() / 1e3)
	}, si.valueOf = function () {
		return this._d.valueOf() - 6e4 * (this._offset || 0)
	}, si.creationData = function () {
		return {input: this._i, format: this._f, locale: this._locale, isUTC: this._isUTC, strict: this._strict}
	}, si.year = Dt, si.isLeapYear = function () {
		return St(this.year())
	}, si.weekYear = function (t) {
		return ti.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
	}, si.isoWeekYear = function (t) {
		return ti.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4)
	}, si.quarter = si.quarters = function (t) {
		return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3)
	}, si.month = Ft, si.daysInMonth = function () {
		return At(this.year(), this.month())
	}, si.week = si.weeks = function (t) {
		var e = this.localeData().week(this);
		return null == t ? e : this.add(7 * (t - e), "d")
	}, si.isoWeek = si.isoWeeks = function (t) {
		var e = jt(this, 1, 4).week;
		return null == t ? e : this.add(7 * (t - e), "d")
	}, si.weeksInYear = function () {
		var t = this.localeData()._week;
		return Ut(this.year(), t.dow, t.doy)
	}, si.isoWeeksInYear = function () {
		return Ut(this.year(), 1, 4)
	}, si.date = ei, si.day = si.days = function (t) {
		if (!this.isValid()) return null != t ? this : NaN;
		var e, i, n = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
		return null != t ? (e = t, i = this.localeData(), t = "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = i.weekdaysParse(e)) ? e : null : parseInt(e, 10), this.add(t - n, "d")) : n
	}, si.weekday = function (t) {
		if (!this.isValid()) return null != t ? this : NaN;
		var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
		return null == t ? e : this.add(t - e, "d")
	}, si.isoWeekday = function (t) {
		if (!this.isValid()) return null != t ? this : NaN;
		if (null != t) {
			var e = (i = t, n = this.localeData(), "string" == typeof i ? n.weekdaysParse(i) % 7 || 7 : isNaN(i) ? null : i);
			return this.day(this.day() % 7 ? e : e - 7)
		}
		return this.day() || 7;
		var i, n
	}, si.dayOfYear = function (t) {
		var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
		return null == t ? e : this.add(t - e, "d")
	}, si.hour = si.hours = ee, si.minute = si.minutes = ii, si.second = si.seconds = ri, si.millisecond = si.milliseconds = ai, si.utcOffset = function (t, e, n) {
		var r, o = this._offset || 0;
		if (!this.isValid()) return null != t ? this : NaN;
		if (null != t) {
			if ("string" == typeof t) {
				if (null === (t = Ne(ot, t))) return this
			} else Math.abs(t) < 16 && !n && (t *= 60);
			return !this._isUTC && e && (r = He(this)), this._offset = t, this._isUTC = !0, null != r && this.add(r, "m"), o !== t && (!e || this._changeInProgress ? Ve(this, je(t - o, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, i.updateOffset(this, !0), this._changeInProgress = null)), this
		}
		return this._isUTC ? o : He(this)
	}, si.utc = function (t) {
		return this.utcOffset(0, t)
	}, si.local = function (t) {
		return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(He(this), "m")), this
	}, si.parseZone = function () {
		if (null != this._tzm) this.utcOffset(this._tzm, !1, !0); else if ("string" == typeof this._i) {
			var t = Ne(rt, this._i);
			null != t ? this.utcOffset(t) : this.utcOffset(0, !0)
		}
		return this
	}, si.hasAlignedHourOffset = function (t) {
		return !!this.isValid() && (t = t ? De(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0)
	}, si.isDST = function () {
		return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
	}, si.isLocal = function () {
		return !!this.isValid() && !this._isUTC
	}, si.isUtcOffset = function () {
		return !!this.isValid() && this._isUTC
	}, si.isUtc = $e, si.isUTC = $e, si.zoneAbbr = function () {
		return this._isUTC ? "UTC" : ""
	}, si.zoneName = function () {
		return this._isUTC ? "Coordinated Universal Time" : ""
	}, si.dates = S("dates accessor is deprecated. Use date instead.", ei), si.months = S("months accessor is deprecated. Use month instead", Ft), si.years = S("years accessor is deprecated. Use year instead", Dt), si.zone = S("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (t, e) {
		return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset()
	}), si.isDSTShifted = S("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
		if (!o(this._isDSTShifted)) return this._isDSTShifted;
		var t = {};
		if (g(t, this), (t = Se(t))._a) {
			var e = t._isUTC ? h(t._a) : De(t._a);
			this._isDSTShifted = this.isValid() && 0 < k(t._a, e.toArray())
		} else this._isDSTShifted = !1;
		return this._isDSTShifted
	});
	var ci = A.prototype;

	function ui(t, e, i, n) {
		var r = ce(), o = h().set(n, e);
		return r[i](o, t)
	}

	function hi(t, e, i) {
		if (a(t) && (e = t, t = void 0), t = t || "", null != e) return ui(t, e, i, "month");
		var n, r = [];
		for (n = 0; n < 12; n++) r[n] = ui(t, n, i, "month");
		return r
	}

	function di(t, e, i, n) {
		"boolean" == typeof t ? a(e) && (i = e, e = void 0) : (e = t, t = !1, a(i = e) && (i = e, e = void 0)), e = e || "";
		var r, o = ce(), s = t ? o._week.dow : 0;
		if (null != i) return ui(e, (i + s) % 7, n, "day");
		var l = [];
		for (r = 0; r < 7; r++) l[r] = ui(e, (r + s) % 7, n, "day");
		return l
	}

	ci.calendar = function (t, e, i) {
		var n = this._calendar[t] || this._calendar.sameElse;
		return M(n) ? n.call(e, i) : n
	}, ci.longDateFormat = function (t) {
		var e = this._longDateFormat[t], i = this._longDateFormat[t.toUpperCase()];
		return e || !i ? e : (this._longDateFormat[t] = i.replace(/MMMM|MM|DD|dddd/g, function (t) {
			return t.slice(1)
		}), this._longDateFormat[t])
	}, ci.invalidDate = function () {
		return this._invalidDate
	}, ci.ordinal = function (t) {
		return this._ordinal.replace("%d", t)
	}, ci.preparse = li, ci.postformat = li, ci.relativeTime = function (t, e, i, n) {
		var r = this._relativeTime[i];
		return M(r) ? r(t, e, i, n) : r.replace(/%d/i, t)
	}, ci.pastFuture = function (t, e) {
		var i = this._relativeTime[0 < t ? "future" : "past"];
		return M(i) ? i(e) : i.replace(/%s/i, e)
	}, ci.set = function (t) {
		var e, i;
		for (i in t) M(e = t[i]) ? this[i] = e : this["_" + i] = e;
		this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source)
	}, ci.months = function (t, e) {
		return t ? n(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || Pt).test(e) ? "format" : "standalone"][t.month()] : n(this._months) ? this._months : this._months.standalone
	}, ci.monthsShort = function (t, e) {
		return t ? n(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[Pt.test(e) ? "format" : "standalone"][t.month()] : n(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone
	}, ci.monthsParse = function (t, e, i) {
		var n, r, o;
		if (this._monthsParseExact) return function (t, e, i) {
			var n, r, o, a = t.toLocaleLowerCase();
			if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n) o = h([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(o, "").toLocaleLowerCase(), this._longMonthsParse[n] = this.months(o, "").toLocaleLowerCase();
			return i ? "MMM" === e ? -1 !== (r = Ct.call(this._shortMonthsParse, a)) ? r : null : -1 !== (r = Ct.call(this._longMonthsParse, a)) ? r : null : "MMM" === e ? -1 !== (r = Ct.call(this._shortMonthsParse, a)) ? r : -1 !== (r = Ct.call(this._longMonthsParse, a)) ? r : null : -1 !== (r = Ct.call(this._longMonthsParse, a)) ? r : -1 !== (r = Ct.call(this._shortMonthsParse, a)) ? r : null
		}.call(this, t, e, i);
		for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
			if (r = h([2e3, n]), i && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp("^" + this.months(r, "").replace(".", "") + "$", "i"), this._shortMonthsParse[n] = new RegExp("^" + this.monthsShort(r, "").replace(".", "") + "$", "i")), i || this._monthsParse[n] || (o = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[n] = new RegExp(o.replace(".", ""), "i")), i && "MMMM" === e && this._longMonthsParse[n].test(t)) return n;
			if (i && "MMM" === e && this._shortMonthsParse[n].test(t)) return n;
			if (!i && this._monthsParse[n].test(t)) return n
		}
	}, ci.monthsRegex = function (t) {
		return this._monthsParseExact ? (c(this, "_monthsRegex") || Ht.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (c(this, "_monthsRegex") || (this._monthsRegex = Rt), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex)
	}, ci.monthsShortRegex = function (t) {
		return this._monthsParseExact ? (c(this, "_monthsRegex") || Ht.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (c(this, "_monthsShortRegex") || (this._monthsShortRegex = Nt), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex)
	}, ci.week = function (t) {
		return jt(t, this._week.dow, this._week.doy).week
	}, ci.firstDayOfYear = function () {
		return this._week.doy
	}, ci.firstDayOfWeek = function () {
		return this._week.dow
	}, ci.weekdays = function (t, e) {
		return t ? n(this._weekdays) ? this._weekdays[t.day()] : this._weekdays[this._weekdays.isFormat.test(e) ? "format" : "standalone"][t.day()] : n(this._weekdays) ? this._weekdays : this._weekdays.standalone
	}, ci.weekdaysMin = function (t) {
		return t ? this._weekdaysMin[t.day()] : this._weekdaysMin
	}, ci.weekdaysShort = function (t) {
		return t ? this._weekdaysShort[t.day()] : this._weekdaysShort
	}, ci.weekdaysParse = function (t, e, i) {
		var n, r, o;
		if (this._weekdaysParseExact) return function (t, e, i) {
			var n, r, o, a = t.toLocaleLowerCase();
			if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n) o = h([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(o, "").toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(o, "").toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(o, "").toLocaleLowerCase();
			return i ? "dddd" === e ? -1 !== (r = Ct.call(this._weekdaysParse, a)) ? r : null : "ddd" === e ? -1 !== (r = Ct.call(this._shortWeekdaysParse, a)) ? r : null : -1 !== (r = Ct.call(this._minWeekdaysParse, a)) ? r : null : "dddd" === e ? -1 !== (r = Ct.call(this._weekdaysParse, a)) ? r : -1 !== (r = Ct.call(this._shortWeekdaysParse, a)) ? r : -1 !== (r = Ct.call(this._minWeekdaysParse, a)) ? r : null : "ddd" === e ? -1 !== (r = Ct.call(this._shortWeekdaysParse, a)) ? r : -1 !== (r = Ct.call(this._weekdaysParse, a)) ? r : -1 !== (r = Ct.call(this._minWeekdaysParse, a)) ? r : null : -1 !== (r = Ct.call(this._minWeekdaysParse, a)) ? r : -1 !== (r = Ct.call(this._weekdaysParse, a)) ? r : -1 !== (r = Ct.call(this._shortWeekdaysParse, a)) ? r : null
		}.call(this, t, e, i);
		for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
			if (r = h([2e3, 1]).day(n), i && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp("^" + this.weekdays(r, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[n] = new RegExp("^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[n] = new RegExp("^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[n] || (o = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[n] = new RegExp(o.replace(".", ""), "i")), i && "dddd" === e && this._fullWeekdaysParse[n].test(t)) return n;
			if (i && "ddd" === e && this._shortWeekdaysParse[n].test(t)) return n;
			if (i && "dd" === e && this._minWeekdaysParse[n].test(t)) return n;
			if (!i && this._weekdaysParse[n].test(t)) return n
		}
	}, ci.weekdaysRegex = function (t) {
		return this._weekdaysParseExact ? (c(this, "_weekdaysRegex") || Xt.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (c(this, "_weekdaysRegex") || (this._weekdaysRegex = qt), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex)
	}, ci.weekdaysShortRegex = function (t) {
		return this._weekdaysParseExact ? (c(this, "_weekdaysRegex") || Xt.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (c(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Gt), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
	}, ci.weekdaysMinRegex = function (t) {
		return this._weekdaysParseExact ? (c(this, "_weekdaysRegex") || Xt.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (c(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Kt), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
	}, ci.isPM = function (t) {
		return "p" === (t + "").toLowerCase().charAt(0)
	}, ci.meridiem = function (t, e, i) {
		return 11 < t ? i ? "pm" : "PM" : i ? "am" : "AM"
	}, se("en", {
		dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/, ordinal: function (t) {
			var e = t % 10;
			return t + (1 === x(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th")
		}
	}), i.lang = S("moment.lang is deprecated. Use moment.locale instead.", se), i.langData = S("moment.langData is deprecated. Use moment.localeData instead.", ce);
	var pi = Math.abs;

	function fi(t, e, i, n) {
		var r = je(e, i);
		return t._milliseconds += n * r._milliseconds, t._days += n * r._days, t._months += n * r._months, t._bubble()
	}

	function mi(t) {
		return t < 0 ? Math.floor(t) : Math.ceil(t)
	}

	function gi(t) {
		return 4800 * t / 146097
	}

	function vi(t) {
		return 146097 * t / 4800
	}

	function yi(t) {
		return function () {
			return this.as(t)
		}
	}

	var bi = yi("ms"), wi = yi("s"), xi = yi("m"), ki = yi("h"), _i = yi("d"), Si = yi("w"), Ci = yi("M"), Di = yi("y");

	function Ti(t) {
		return function () {
			return this.isValid() ? this._data[t] : NaN
		}
	}

	var Mi = Ti("milliseconds"), Ei = Ti("seconds"), Ai = Ti("minutes"), Pi = Ti("hours"), Ii = Ti("days"), Oi = Ti("months"), Li = Ti("years"), Fi = Math.round, Ni = {ss: 44, s: 45, m: 45, h: 22, d: 26, M: 11}, Ri = Math.abs;

	function Hi(t) {
		return (0 < t) - (t < 0) || +t
	}

	function $i() {
		if (!this.isValid()) return this.localeData().invalidDate();
		var t, e, i = Ri(this._milliseconds) / 1e3, n = Ri(this._days), r = Ri(this._months);
		e = w((t = w(i / 60)) / 60), i %= 60, t %= 60;
		var o = w(r / 12), a = r %= 12, s = n, l = e, c = t, u = i ? i.toFixed(3).replace(/\.?0+$/, "") : "", h = this.asSeconds();
		if (!h) return "P0D";
		var d = h < 0 ? "-" : "", p = Hi(this._months) !== Hi(h) ? "-" : "", f = Hi(this._days) !== Hi(h) ? "-" : "", m = Hi(this._milliseconds) !== Hi(h) ? "-" : "";
		return d + "P" + (o ? p + o + "Y" : "") + (a ? p + a + "M" : "") + (s ? f + s + "D" : "") + (l || c || u ? "T" : "") + (l ? m + l + "H" : "") + (c ? m + c + "M" : "") + (u ? m + u + "S" : "")
	}

	var Bi = Pe.prototype;
	return Bi.isValid = function () {
		return this._isValid
	}, Bi.abs = function () {
		var t = this._data;
		return this._milliseconds = pi(this._milliseconds), this._days = pi(this._days), this._months = pi(this._months), t.milliseconds = pi(t.milliseconds), t.seconds = pi(t.seconds), t.minutes = pi(t.minutes), t.hours = pi(t.hours), t.months = pi(t.months), t.years = pi(t.years), this
	}, Bi.add = function (t, e) {
		return fi(this, t, e, 1)
	}, Bi.subtract = function (t, e) {
		return fi(this, t, e, -1)
	}, Bi.as = function (t) {
		if (!this.isValid()) return NaN;
		var e, i, n = this._milliseconds;
		if ("month" === (t = O(t)) || "year" === t) return e = this._days + n / 864e5, i = this._months + gi(e), "month" === t ? i : i / 12;
		switch (e = this._days + Math.round(vi(this._months)), t) {
			case"week":
				return e / 7 + n / 6048e5;
			case"day":
				return e + n / 864e5;
			case"hour":
				return 24 * e + n / 36e5;
			case"minute":
				return 1440 * e + n / 6e4;
			case"second":
				return 86400 * e + n / 1e3;
			case"millisecond":
				return Math.floor(864e5 * e) + n;
			default:
				throw new Error("Unknown unit " + t)
		}
	}, Bi.asMilliseconds = bi, Bi.asSeconds = wi, Bi.asMinutes = xi, Bi.asHours = ki, Bi.asDays = _i, Bi.asWeeks = Si, Bi.asMonths = Ci, Bi.asYears = Di, Bi.valueOf = function () {
		return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * x(this._months / 12) : NaN
	}, Bi._bubble = function () {
		var t, e, i, n, r, o = this._milliseconds, a = this._days, s = this._months, l = this._data;
		return 0 <= o && 0 <= a && 0 <= s || o <= 0 && a <= 0 && s <= 0 || (o += 864e5 * mi(vi(s) + a), s = a = 0), l.milliseconds = o % 1e3, t = w(o / 1e3), l.seconds = t % 60, e = w(t / 60), l.minutes = e % 60, i = w(e / 60), l.hours = i % 24, s += r = w(gi(a += w(i / 24))), a -= mi(vi(r)), n = w(s / 12), s %= 12, l.days = a, l.months = s, l.years = n, this
	}, Bi.clone = function () {
		return je(this)
	}, Bi.get = function (t) {
		return t = O(t), this.isValid() ? this[t + "s"]() : NaN
	}, Bi.milliseconds = Mi, Bi.seconds = Ei, Bi.minutes = Ai, Bi.hours = Pi, Bi.days = Ii, Bi.weeks = function () {
		return w(this.days() / 7)
	}, Bi.months = Oi, Bi.years = Li, Bi.humanize = function (t) {
		if (!this.isValid()) return this.localeData().invalidDate();
		var e, i, n, r, o, a, s, l, c, u, h = this.localeData(),
			d = (e = !t, i = h, n = je(this).abs(), r = Fi(n.as("s")), o = Fi(n.as("m")), a = Fi(n.as("h")), s = Fi(n.as("d")), l = Fi(n.as("M")), c = Fi(n.as("y")), (u = r <= Ni.ss && ["s", r] || r < Ni.s && ["ss", r] || o <= 1 && ["m"] || o < Ni.m && ["mm", o] || a <= 1 && ["h"] || a < Ni.h && ["hh", a] || s <= 1 && ["d"] || s < Ni.d && ["dd", s] || l <= 1 && ["M"] || l < Ni.M && ["MM", l] || c <= 1 && ["y"] || ["yy", c])[2] = e, u[3] = 0 < +this, u[4] = i, function (t, e, i, n, r) {
				return r.relativeTime(e || 1, !!i, t, n)
			}.apply(null, u));
		return t && (d = h.pastFuture(+this, d)), h.postformat(d)
	}, Bi.toISOString = $i, Bi.toString = $i, Bi.toJSON = $i, Bi.locale = Xe, Bi.localeData = Qe, Bi.toIsoString = S("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", $i), Bi.lang = Ze, j("X", 0, 0, "unix"), j("x", 0, 0, "valueOf"), lt("x", nt), lt("X", /[+-]?\d+(\.\d{1,3})?/), dt("X", function (t, e, i) {
		i._d = new Date(1e3 * parseFloat(t, 10))
	}), dt("x", function (t, e, i) {
		i._d = new Date(x(t))
	}), i.version = "2.22.2", t = De, i.fn = si, i.min = function () {
		return Ee("isBefore", [].slice.call(arguments, 0))
	}, i.max = function () {
		return Ee("isAfter", [].slice.call(arguments, 0))
	}, i.now = function () {
		return Date.now ? Date.now() : +new Date
	}, i.utc = h, i.unix = function (t) {
		return De(1e3 * t)
	}, i.months = function (t, e) {
		return hi(t, e, "months")
	}, i.isDate = s, i.locale = se, i.invalid = f, i.duration = je, i.isMoment = b, i.weekdays = function (t, e, i) {
		return di(t, e, i, "weekdays")
	}, i.parseZone = function () {
		return De.apply(null, arguments).parseZone()
	}, i.localeData = ce, i.isDuration = Ie, i.monthsShort = function (t, e) {
		return hi(t, e, "monthsShort")
	}, i.weekdaysMin = function (t, e, i) {
		return di(t, e, i, "weekdaysMin")
	}, i.defineLocale = le, i.updateLocale = function (t, e) {
		if (null != e) {
			var i, n, r = ie;
			null != (n = ae(t)) && (r = n._config), (i = new A(e = E(r, e))).parentLocale = ne[t], ne[t] = i, se(t)
		} else null != ne[t] && (null != ne[t].parentLocale ? ne[t] = ne[t].parentLocale : null != ne[t] && delete ne[t]);
		return ne[t]
	}, i.locales = function () {
		return C(ne)
	}, i.weekdaysShort = function (t, e, i) {
		return di(t, e, i, "weekdaysShort")
	}, i.normalizeUnits = O, i.relativeTimeRounding = function (t) {
		return void 0 === t ? Fi : "function" == typeof t && (Fi = t, !0)
	}, i.relativeTimeThreshold = function (t, e) {
		return void 0 !== Ni[t] && (void 0 === e ? Ni[t] : (Ni[t] = e, "s" === t && (Ni.ss = e - 1), !0))
	}, i.calendarFormat = function (t, e) {
		var i = t.diff(e, "days", !0);
		return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse"
	}, i.prototype = si, i.HTML5_FMT = {DATETIME_LOCAL: "YYYY-MM-DDTHH:mm", DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss", DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS", DATE: "YYYY-MM-DD", TIME: "HH:mm", TIME_SECONDS: "HH:mm:ss", TIME_MS: "HH:mm:ss.SSS", WEEK: "YYYY-[W]WW", MONTH: "YYYY-MM"}, i
}), function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("popper.js")) : "function" == typeof define && define.amd ? define(["popper.js"], e) : t.Tooltip = e(t.Popper)
}(this, function (t) {
	"use strict";
	t = t && t.hasOwnProperty("default") ? t.default : t;
	var e = function (t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}, i = function () {
		function t(t, e) {
			for (var i, n = 0; n < e.length; n++) (i = e[n]).enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
		}

		return function (e, i, n) {
			return i && t(e.prototype, i), n && t(e, n), e
		}
	}(), n = Object.assign || function (t) {
		for (var e, i = 1; i < arguments.length; i++) for (var n in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
		return t
	}, r = {
		container: !1,
		delay: 0,
		html: !1,
		placement: "top",
		title: "",
		template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
		trigger: "hover focus",
		offset: 0,
		arrowSelector: ".tooltip-arrow, .tooltip__arrow",
		innerSelector: ".tooltip-inner, .tooltip__inner"
	}, o = function () {
		function o(t, i) {
			e(this, o), a.call(this), i = n({}, r, i), t.jquery && (t = t[0]), this.reference = t, this.options = i;
			var s = "string" == typeof i.trigger ? i.trigger.split(" ").filter(function (t) {
				return -1 !== ["click", "hover", "focus"].indexOf(t)
			}) : [];
			this._isOpen = !1, this._popperOptions = {}, this._setEventListeners(t, s, i)
		}

		return i(o, [{
			key: "_create", value: function (t, e, i, n) {
				var r = window.document.createElement("div");
				r.innerHTML = e.trim();
				var o = r.childNodes[0];
				o.id = "tooltip_" + Math.random().toString(36).substr(2, 10), o.setAttribute("aria-hidden", "false");
				var a = r.querySelector(this.options.innerSelector);
				return this._addTitleContent(t, i, n, a), o
			}
		}, {
			key: "_addTitleContent", value: function (t, e, i, n) {
				if (1 === e.nodeType || 11 === e.nodeType) i && n.appendChild(e); else if (function (t) {
					return t && "[object Function]" === {}.toString.call(t)
				}(e)) {
					var r = e.call(t);
					i ? n.innerHTML = r : n.textContent = r
				} else i ? n.innerHTML = e : n.textContent = e
			}
		}, {
			key: "_show", value: function (e, i) {
				if (this._isOpen && !this._isOpening) return this;
				if (this._isOpen = !0, this._tooltipNode) return this._tooltipNode.style.visibility = "visible", this._tooltipNode.setAttribute("aria-hidden", "false"), this.popperInstance.update(), this;
				var r = e.getAttribute("title") || i.title;
				if (!r) return this;
				var o = this._create(e, i.template, r, i.html);
				e.setAttribute("aria-describedby", o.id);
				var a = this._findContainer(i.container, e);
				return this._append(o, a), this._popperOptions = n({}, i.popperOptions, {placement: i.placement}), this._popperOptions.modifiers = n({}, this._popperOptions.modifiers, {
					arrow: {element: this.options.arrowSelector},
					offset: {offset: i.offset}
				}), i.boundariesElement && (this._popperOptions.modifiers.preventOverflow = {boundariesElement: i.boundariesElement}), this.popperInstance = new t(e, o, this._popperOptions), this._tooltipNode = o, this
			}
		}, {
			key: "_hide", value: function () {
				return this._isOpen ? (this._isOpen = !1, this._tooltipNode.style.visibility = "hidden", this._tooltipNode.setAttribute("aria-hidden", "true"), this) : this
			}
		}, {
			key: "_dispose", value: function () {
				var t = this;
				return this._events.forEach(function (e) {
					var i = e.func, n = e.event;
					t.reference.removeEventListener(n, i)
				}), this._events = [], this._tooltipNode && (this._hide(), this.popperInstance.destroy(), !this.popperInstance.options.removeOnDestroy && (this._tooltipNode.parentNode.removeChild(this._tooltipNode), this._tooltipNode = null)), this
			}
		}, {
			key: "_findContainer", value: function (t, e) {
				return "string" == typeof t ? t = window.document.querySelector(t) : !1 === t && (t = e.parentNode), t
			}
		}, {
			key: "_append", value: function (t, e) {
				e.appendChild(t)
			}
		}, {
			key: "_setEventListeners", value: function (t, e, i) {
				var n = this, r = [], o = [];
				e.forEach(function (t) {
					"hover" === t ? (r.push("mouseenter"), o.push("mouseleave")) : "focus" === t ? (r.push("focus"), o.push("blur")) : "click" === t && (r.push("click"), o.push("click"))
				}), r.forEach(function (e) {
					var r = function (e) {
						!0 === n._isOpening || (e.usedByTooltip = !0, n._scheduleShow(t, i.delay, i, e))
					};
					n._events.push({event: e, func: r}), t.addEventListener(e, r)
				}), o.forEach(function (e) {
					var r = function (e) {
						!0 === e.usedByTooltip || n._scheduleHide(t, i.delay, i, e)
					};
					n._events.push({event: e, func: r}), t.addEventListener(e, r), "click" === e && i.closeOnClickOutside && document.addEventListener("mousedown", function (e) {
						if (n._isOpening) {
							var i = n.popperInstance.popper;
							t.contains(e.target) || i.contains(e.target) || r(e)
						}
					}, !0)
				})
			}
		}, {
			key: "_scheduleShow", value: function (t, e, i) {
				var n = this;
				this._isOpening = !0;
				var r = e && e.show || e || 0;
				this._showTimeout = window.setTimeout(function () {
					return n._show(t, i)
				}, r)
			}
		}, {
			key: "_scheduleHide", value: function (t, e, i, n) {
				var r = this;
				this._isOpening = !1;
				var o = e && e.hide || e || 0;
				window.setTimeout(function () {
					if (window.clearTimeout(r._showTimeout), !1 !== r._isOpen && document.body.contains(r._tooltipNode)) {
						if ("mouseleave" === n.type) if (r._setTooltipNodeEvent(n, t, e, i)) return;
						r._hide(t, i)
					}
				}, o)
			}
		}, {
			key: "_updateTitleContent", value: function (t) {
				if (void 0 !== this._tooltipNode) {
					var e = this._tooltipNode.parentNode.querySelector(this.options.innerSelector);
					this._clearTitleContent(e, this.options.html, this.reference.getAttribute("title") || this.options.title), this._addTitleContent(this.reference, t, this.options.html, e), this.options.title = t, this.popperInstance.update()
				} else void 0 !== this.options.title && (this.options.title = t)
			}
		}, {
			key: "_clearTitleContent", value: function (t, e, i) {
				1 === i.nodeType || 11 === i.nodeType ? e && t.removeChild(i) : e ? t.innerHTML = "" : t.textContent = ""
			}
		}]), o
	}(), a = function () {
		var t = this;
		this.show = function () {
			return t._show(t.reference, t.options)
		}, this.hide = function () {
			return t._hide()
		}, this.dispose = function () {
			return t._dispose()
		}, this.toggle = function () {
			return t._isOpen ? t.hide() : t.show()
		}, this.updateTitleContent = function (e) {
			return t._updateTitleContent(e)
		}, this._events = [], this._setTooltipNodeEvent = function (e, i, n, r) {
			var o = e.relatedreference || e.toElement || e.relatedTarget;
			return !!t._tooltipNode.contains(o) && (t._tooltipNode.addEventListener(e.type, function n(o) {
				var a = o.relatedreference || o.toElement || o.relatedTarget;
				t._tooltipNode.removeEventListener(e.type, n), i.contains(a) || t._scheduleHide(i, r.delay, r, o)
			}), !0)
		}
	};
	return o
}), function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.PerfectScrollbar = e()
}(this, function () {
	"use strict";

	function t(t) {
		return getComputedStyle(t)
	}

	function e(t, e) {
		for (var i in e) {
			var n = e[i];
			"number" == typeof n && (n += "px"), t.style[i] = n
		}
		return t
	}

	function i(t) {
		var e = document.createElement("div");
		return e.className = t, e
	}

	var n = "undefined" != typeof Element && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);

	function r(t, e) {
		if (!n) throw new Error("No element matching method supported");
		return n.call(t, e)
	}

	function o(t) {
		t.remove ? t.remove() : t.parentNode && t.parentNode.removeChild(t)
	}

	function a(t, e) {
		return Array.prototype.filter.call(t.children, function (t) {
			return r(t, e)
		})
	}

	var s = {
		main: "ps", element: {
			thumb: function (t) {
				return "ps__thumb-" + t
			}, rail: function (t) {
				return "ps__rail-" + t
			}, consuming: "ps__child--consume"
		}, state: {
			focus: "ps--focus", clicking: "ps--clicking", active: function (t) {
				return "ps--active-" + t
			}, scrolling: function (t) {
				return "ps--scrolling-" + t
			}
		}
	}, l = {x: null, y: null};

	function c(t, e) {
		var i = t.element.classList, n = s.state.scrolling(e);
		i.contains(n) ? clearTimeout(l[e]) : i.add(n)
	}

	function u(t, e) {
		l[e] = setTimeout(function () {
			return t.isAlive && t.element.classList.remove(s.state.scrolling(e))
		}, t.settings.scrollingThreshold)
	}

	var h = function (t) {
		this.element = t, this.handlers = {}
	}, d = {isEmpty: {configurable: !0}};
	h.prototype.bind = function (t, e) {
		void 0 === this.handlers[t] && (this.handlers[t] = []), this.handlers[t].push(e), this.element.addEventListener(t, e, !1)
	}, h.prototype.unbind = function (t, e) {
		var i = this;
		this.handlers[t] = this.handlers[t].filter(function (n) {
			return !(!e || n === e) || (i.element.removeEventListener(t, n, !1), !1)
		})
	}, h.prototype.unbindAll = function () {
		for (var t in this.handlers) this.unbind(t)
	}, d.isEmpty.get = function () {
		var t = this;
		return Object.keys(this.handlers).every(function (e) {
			return 0 === t.handlers[e].length
		})
	}, Object.defineProperties(h.prototype, d);
	var p = function () {
		this.eventElements = []
	};

	function f(t) {
		if ("function" == typeof window.CustomEvent) return new CustomEvent(t);
		var e = document.createEvent("CustomEvent");
		return e.initCustomEvent(t, !1, !1, void 0), e
	}

	p.prototype.eventElement = function (t) {
		var e = this.eventElements.filter(function (e) {
			return e.element === t
		})[0];
		return e || (e = new h(t), this.eventElements.push(e)), e
	}, p.prototype.bind = function (t, e, i) {
		this.eventElement(t).bind(e, i)
	}, p.prototype.unbind = function (t, e, i) {
		var n = this.eventElement(t);
		n.unbind(e, i), n.isEmpty && this.eventElements.splice(this.eventElements.indexOf(n), 1)
	}, p.prototype.unbindAll = function () {
		this.eventElements.forEach(function (t) {
			return t.unbindAll()
		}), this.eventElements = []
	}, p.prototype.once = function (t, e, i) {
		var n = this.eventElement(t), r = function (t) {
			n.unbind(e, r), i(t)
		};
		n.bind(e, r)
	};
	var m = function (t, e, i, n, r) {
		var o;
		if (void 0 === n && (n = !0), void 0 === r && (r = !1), "top" === e) o = ["contentHeight", "containerHeight", "scrollTop", "y", "up", "down"]; else {
			if ("left" !== e) throw new Error("A proper axis should be provided");
			o = ["contentWidth", "containerWidth", "scrollLeft", "x", "left", "right"]
		}
		!function (t, e, i, n, r) {
			var o = i[0], a = i[1], s = i[2], l = i[3], h = i[4], d = i[5];
			void 0 === n && (n = !0);
			void 0 === r && (r = !1);
			var p = t.element;
			t.reach[l] = null, p[s] < 1 && (t.reach[l] = "start");
			p[s] > t[o] - t[a] - 1 && (t.reach[l] = "end");
			e && (p.dispatchEvent(f("ps-scroll-" + l)), e < 0 ? p.dispatchEvent(f("ps-scroll-" + h)) : e > 0 && p.dispatchEvent(f("ps-scroll-" + d)), n && function (t, e) {
				c(t, e), u(t, e)
			}(t, l));
			t.reach[l] && (e || r) && p.dispatchEvent(f("ps-" + l + "-reach-" + t.reach[l]))
		}(t, i, o, n, r)
	};

	function g(t) {
		return parseInt(t, 10) || 0
	}

	var v = {
		isWebKit: "undefined" != typeof document && "WebkitAppearance" in document.documentElement.style,
		supportsTouch: "undefined" != typeof window && ("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
		supportsIePointer: "undefined" != typeof navigator && navigator.msMaxTouchPoints,
		isChrome: "undefined" != typeof navigator && /Chrome/i.test(navigator && navigator.userAgent)
	}, y = function (t) {
		var i = t.element, n = Math.floor(i.scrollTop);
		t.containerWidth = i.clientWidth, t.containerHeight = i.clientHeight, t.contentWidth = i.scrollWidth, t.contentHeight = i.scrollHeight, i.contains(t.scrollbarXRail) || (a(i, s.element.rail("x")).forEach(function (t) {
			return o(t)
		}), i.appendChild(t.scrollbarXRail)), i.contains(t.scrollbarYRail) || (a(i, s.element.rail("y")).forEach(function (t) {
			return o(t)
		}), i.appendChild(t.scrollbarYRail)), !t.settings.suppressScrollX && t.containerWidth + t.settings.scrollXMarginOffset < t.contentWidth ? (t.scrollbarXActive = !0, t.railXWidth = t.containerWidth - t.railXMarginWidth, t.railXRatio = t.containerWidth / t.railXWidth, t.scrollbarXWidth = b(t, g(t.railXWidth * t.containerWidth / t.contentWidth)), t.scrollbarXLeft = g((t.negativeScrollAdjustment + i.scrollLeft) * (t.railXWidth - t.scrollbarXWidth) / (t.contentWidth - t.containerWidth))) : t.scrollbarXActive = !1, !t.settings.suppressScrollY && t.containerHeight + t.settings.scrollYMarginOffset < t.contentHeight ? (t.scrollbarYActive = !0, t.railYHeight = t.containerHeight - t.railYMarginHeight, t.railYRatio = t.containerHeight / t.railYHeight, t.scrollbarYHeight = b(t, g(t.railYHeight * t.containerHeight / t.contentHeight)), t.scrollbarYTop = g(n * (t.railYHeight - t.scrollbarYHeight) / (t.contentHeight - t.containerHeight))) : t.scrollbarYActive = !1, t.scrollbarXLeft >= t.railXWidth - t.scrollbarXWidth && (t.scrollbarXLeft = t.railXWidth - t.scrollbarXWidth), t.scrollbarYTop >= t.railYHeight - t.scrollbarYHeight && (t.scrollbarYTop = t.railYHeight - t.scrollbarYHeight), function (t, i) {
			var n = {width: i.railXWidth}, r = Math.floor(t.scrollTop);
			i.isRtl ? n.left = i.negativeScrollAdjustment + t.scrollLeft + i.containerWidth - i.contentWidth : n.left = t.scrollLeft;
			i.isScrollbarXUsingBottom ? n.bottom = i.scrollbarXBottom - r : n.top = i.scrollbarXTop + r;
			e(i.scrollbarXRail, n);
			var o = {top: r, height: i.railYHeight};
			i.isScrollbarYUsingRight ? i.isRtl ? o.right = i.contentWidth - (i.negativeScrollAdjustment + t.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth : o.right = i.scrollbarYRight - t.scrollLeft : i.isRtl ? o.left = i.negativeScrollAdjustment + t.scrollLeft + 2 * i.containerWidth - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth : o.left = i.scrollbarYLeft + t.scrollLeft;
			e(i.scrollbarYRail, o), e(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth}), e(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth})
		}(i, t), t.scrollbarXActive ? i.classList.add(s.state.active("x")) : (i.classList.remove(s.state.active("x")), t.scrollbarXWidth = 0, t.scrollbarXLeft = 0, i.scrollLeft = 0), t.scrollbarYActive ? i.classList.add(s.state.active("y")) : (i.classList.remove(s.state.active("y")), t.scrollbarYHeight = 0, t.scrollbarYTop = 0, i.scrollTop = 0)
	};

	function b(t, e) {
		return t.settings.minScrollbarLength && (e = Math.max(e, t.settings.minScrollbarLength)), t.settings.maxScrollbarLength && (e = Math.min(e, t.settings.maxScrollbarLength)), e
	}

	function w(t, e) {
		var i = e[0], n = e[1], r = e[2], o = e[3], a = e[4], l = e[5], h = e[6], d = e[7], p = e[8], f = t.element, m = null, g = null, v = null;

		function b(e) {
			f[h] = m + v * (e[r] - g), c(t, d), y(t), e.stopPropagation(), e.preventDefault()
		}

		function w() {
			u(t, d), t[p].classList.remove(s.state.clicking), t.event.unbind(t.ownerDocument, "mousemove", b)
		}

		t.event.bind(t[a], "mousedown", function (e) {
			m = f[h], g = e[r], v = (t[n] - t[i]) / (t[o] - t[l]), t.event.bind(t.ownerDocument, "mousemove", b), t.event.once(t.ownerDocument, "mouseup", w), t[p].classList.add(s.state.clicking), e.stopPropagation(), e.preventDefault()
		})
	}

	var x = {
		"click-rail": function (t) {
			t.event.bind(t.scrollbarY, "mousedown", function (t) {
				return t.stopPropagation()
			}), t.event.bind(t.scrollbarYRail, "mousedown", function (e) {
				var i = e.pageY - window.pageYOffset - t.scrollbarYRail.getBoundingClientRect().top > t.scrollbarYTop ? 1 : -1;
				t.element.scrollTop += i * t.containerHeight, y(t), e.stopPropagation()
			}), t.event.bind(t.scrollbarX, "mousedown", function (t) {
				return t.stopPropagation()
			}), t.event.bind(t.scrollbarXRail, "mousedown", function (e) {
				var i = e.pageX - window.pageXOffset - t.scrollbarXRail.getBoundingClientRect().left > t.scrollbarXLeft ? 1 : -1;
				t.element.scrollLeft += i * t.containerWidth, y(t), e.stopPropagation()
			})
		}, "drag-thumb": function (t) {
			w(t, ["containerWidth", "contentWidth", "pageX", "railXWidth", "scrollbarX", "scrollbarXWidth", "scrollLeft", "x", "scrollbarXRail"]), w(t, ["containerHeight", "contentHeight", "pageY", "railYHeight", "scrollbarY", "scrollbarYHeight", "scrollTop", "y", "scrollbarYRail"])
		}, keyboard: function (t) {
			var e = t.element;
			t.event.bind(t.ownerDocument, "keydown", function (i) {
				if (!(i.isDefaultPrevented && i.isDefaultPrevented() || i.defaultPrevented) && (r(e, ":hover") || r(t.scrollbarX, ":focus") || r(t.scrollbarY, ":focus"))) {
					var n, o = document.activeElement ? document.activeElement : t.ownerDocument.activeElement;
					if (o) {
						if ("IFRAME" === o.tagName) o = o.contentDocument.activeElement; else for (; o.shadowRoot;) o = o.shadowRoot.activeElement;
						if (r(n = o, "input,[contenteditable]") || r(n, "select,[contenteditable]") || r(n, "textarea,[contenteditable]") || r(n, "button,[contenteditable]")) return
					}
					var a = 0, s = 0;
					switch (i.which) {
						case 37:
							a = i.metaKey ? -t.contentWidth : i.altKey ? -t.containerWidth : -30;
							break;
						case 38:
							s = i.metaKey ? t.contentHeight : i.altKey ? t.containerHeight : 30;
							break;
						case 39:
							a = i.metaKey ? t.contentWidth : i.altKey ? t.containerWidth : 30;
							break;
						case 40:
							s = i.metaKey ? -t.contentHeight : i.altKey ? -t.containerHeight : -30;
							break;
						case 32:
							s = i.shiftKey ? t.containerHeight : -t.containerHeight;
							break;
						case 33:
							s = t.containerHeight;
							break;
						case 34:
							s = -t.containerHeight;
							break;
						case 36:
							s = t.contentHeight;
							break;
						case 35:
							s = -t.contentHeight;
							break;
						default:
							return
					}
					t.settings.suppressScrollX && 0 !== a || t.settings.suppressScrollY && 0 !== s || (e.scrollTop -= s, e.scrollLeft += a, y(t), function (i, n) {
						var r = Math.floor(e.scrollTop);
						if (0 === i) {
							if (!t.scrollbarYActive) return !1;
							if (0 === r && n > 0 || r >= t.contentHeight - t.containerHeight && n < 0) return !t.settings.wheelPropagation
						}
						var o = e.scrollLeft;
						if (0 === n) {
							if (!t.scrollbarXActive) return !1;
							if (0 === o && i < 0 || o >= t.contentWidth - t.containerWidth && i > 0) return !t.settings.wheelPropagation
						}
						return !0
					}(a, s) && i.preventDefault())
				}
			})
		}, wheel: function (e) {
			var i = e.element;

			function n(n) {
				var r = function (t) {
					var e = t.deltaX, i = -1 * t.deltaY;
					return void 0 !== e && void 0 !== i || (e = -1 * t.wheelDeltaX / 6, i = t.wheelDeltaY / 6), t.deltaMode && 1 === t.deltaMode && (e *= 10, i *= 10), e != e && i != i && (e = 0, i = t.wheelDelta), t.shiftKey ? [-i, -e] : [e, i]
				}(n), o = r[0], a = r[1];
				if (!function (e, n, r) {
					if (!v.isWebKit && i.querySelector("select:focus")) return !0;
					if (!i.contains(e)) return !1;
					for (var o = e; o && o !== i;) {
						if (o.classList.contains(s.element.consuming)) return !0;
						var a = t(o);
						if ([a.overflow, a.overflowX, a.overflowY].join("").match(/(scroll|auto)/)) {
							var l = o.scrollHeight - o.clientHeight;
							if (l > 0 && !(0 === o.scrollTop && r > 0 || o.scrollTop === l && r < 0)) return !0;
							var c = o.scrollWidth - o.clientWidth;
							if (c > 0 && !(0 === o.scrollLeft && n < 0 || o.scrollLeft === c && n > 0)) return !0
						}
						o = o.parentNode
					}
					return !1
				}(n.target, o, a)) {
					var l = !1;
					e.settings.useBothWheelAxes ? e.scrollbarYActive && !e.scrollbarXActive ? (a ? i.scrollTop -= a * e.settings.wheelSpeed : i.scrollTop += o * e.settings.wheelSpeed, l = !0) : e.scrollbarXActive && !e.scrollbarYActive && (o ? i.scrollLeft += o * e.settings.wheelSpeed : i.scrollLeft -= a * e.settings.wheelSpeed, l = !0) : (i.scrollTop -= a * e.settings.wheelSpeed, i.scrollLeft += o * e.settings.wheelSpeed), y(e), (l = l || function (t, n) {
						var r = Math.floor(i.scrollTop), o = 0 === i.scrollTop, a = r + i.offsetHeight === i.scrollHeight, s = 0 === i.scrollLeft, l = i.scrollLeft + i.offsetWidth === i.scrollWidth;
						return !(Math.abs(n) > Math.abs(t) ? o || a : s || l) || !e.settings.wheelPropagation
					}(o, a)) && !n.ctrlKey && (n.stopPropagation(), n.preventDefault())
				}
			}

			void 0 !== window.onwheel ? e.event.bind(i, "wheel", n) : void 0 !== window.onmousewheel && e.event.bind(i, "mousewheel", n)
		}, touch: function (e) {
			if (v.supportsTouch || v.supportsIePointer) {
				var i = e.element, n = {}, r = 0, o = {}, a = null;
				v.supportsTouch ? (e.event.bind(i, "touchstart", h), e.event.bind(i, "touchmove", d), e.event.bind(i, "touchend", p)) : v.supportsIePointer && (window.PointerEvent ? (e.event.bind(i, "pointerdown", h), e.event.bind(i, "pointermove", d), e.event.bind(i, "pointerup", p)) : window.MSPointerEvent && (e.event.bind(i, "MSPointerDown", h), e.event.bind(i, "MSPointerMove", d), e.event.bind(i, "MSPointerUp", p)))
			}

			function l(t, n) {
				i.scrollTop -= n, i.scrollLeft -= t, y(e)
			}

			function c(t) {
				return t.targetTouches ? t.targetTouches[0] : t
			}

			function u(t) {
				return !(t.pointerType && "pen" === t.pointerType && 0 === t.buttons || (!t.targetTouches || 1 !== t.targetTouches.length) && (!t.pointerType || "mouse" === t.pointerType || t.pointerType === t.MSPOINTER_TYPE_MOUSE))
			}

			function h(t) {
				if (u(t)) {
					var e = c(t);
					n.pageX = e.pageX, n.pageY = e.pageY, r = (new Date).getTime(), null !== a && clearInterval(a)
				}
			}

			function d(a) {
				if (u(a)) {
					var h = c(a), d = {pageX: h.pageX, pageY: h.pageY}, p = d.pageX - n.pageX, f = d.pageY - n.pageY;
					if (function (e, n, r) {
						if (!i.contains(e)) return !1;
						for (var o = e; o && o !== i;) {
							if (o.classList.contains(s.element.consuming)) return !0;
							var a = t(o);
							if ([a.overflow, a.overflowX, a.overflowY].join("").match(/(scroll|auto)/)) {
								var l = o.scrollHeight - o.clientHeight;
								if (l > 0 && !(0 === o.scrollTop && r > 0 || o.scrollTop === l && r < 0)) return !0;
								var c = o.scrollLeft - o.clientWidth;
								if (c > 0 && !(0 === o.scrollLeft && n < 0 || o.scrollLeft === c && n > 0)) return !0
							}
							o = o.parentNode
						}
						return !1
					}(a.target, p, f)) return;
					l(p, f), n = d;
					var m = (new Date).getTime(), g = m - r;
					g > 0 && (o.x = p / g, o.y = f / g, r = m), function (t, n) {
						var r = Math.floor(i.scrollTop), o = i.scrollLeft, a = Math.abs(t), s = Math.abs(n);
						if (s > a) {
							if (n < 0 && r === e.contentHeight - e.containerHeight || n > 0 && 0 === r) return 0 === window.scrollY && n > 0 && v.isChrome
						} else if (a > s && (t < 0 && o === e.contentWidth - e.containerWidth || t > 0 && 0 === o)) return !0;
						return !0
					}(p, f) && a.preventDefault()
				}
			}

			function p() {
				e.settings.swipeEasing && (clearInterval(a), a = setInterval(function () {
					e.isInitialized ? clearInterval(a) : o.x || o.y ? Math.abs(o.x) < .01 && Math.abs(o.y) < .01 ? clearInterval(a) : (l(30 * o.x, 30 * o.y), o.x *= .8, o.y *= .8) : clearInterval(a)
				}, 10))
			}
		}
	}, k = function (n, r) {
		var o = this;
		if (void 0 === r && (r = {}), "string" == typeof n && (n = document.querySelector(n)), !n || !n.nodeName) throw new Error("no element is specified to initialize PerfectScrollbar");
		for (var a in this.element = n, n.classList.add(s.main), this.settings = {
			handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
			maxScrollbarLength: null,
			minScrollbarLength: null,
			scrollingThreshold: 1e3,
			scrollXMarginOffset: 0,
			scrollYMarginOffset: 0,
			suppressScrollX: !1,
			suppressScrollY: !1,
			swipeEasing: !0,
			useBothWheelAxes: !1,
			wheelPropagation: !0,
			wheelSpeed: 1
		}, r) o.settings[a] = r[a];
		this.containerWidth = null, this.containerHeight = null, this.contentWidth = null, this.contentHeight = null;
		var l, c, u = function () {
			return n.classList.add(s.state.focus)
		}, h = function () {
			return n.classList.remove(s.state.focus)
		};
		this.isRtl = "rtl" === t(n).direction, this.isNegativeScroll = (c = n.scrollLeft, n.scrollLeft = -1, l = n.scrollLeft < 0, n.scrollLeft = c, l), this.negativeScrollAdjustment = this.isNegativeScroll ? n.scrollWidth - n.clientWidth : 0, this.event = new p, this.ownerDocument = n.ownerDocument || document, this.scrollbarXRail = i(s.element.rail("x")), n.appendChild(this.scrollbarXRail), this.scrollbarX = i(s.element.thumb("x")), this.scrollbarXRail.appendChild(this.scrollbarX), this.scrollbarX.setAttribute("tabindex", 0), this.event.bind(this.scrollbarX, "focus", u), this.event.bind(this.scrollbarX, "blur", h), this.scrollbarXActive = null, this.scrollbarXWidth = null, this.scrollbarXLeft = null;
		var d = t(this.scrollbarXRail);
		this.scrollbarXBottom = parseInt(d.bottom, 10), isNaN(this.scrollbarXBottom) ? (this.isScrollbarXUsingBottom = !1, this.scrollbarXTop = g(d.top)) : this.isScrollbarXUsingBottom = !0, this.railBorderXWidth = g(d.borderLeftWidth) + g(d.borderRightWidth), e(this.scrollbarXRail, {display: "block"}), this.railXMarginWidth = g(d.marginLeft) + g(d.marginRight), e(this.scrollbarXRail, {display: ""}), this.railXWidth = null, this.railXRatio = null, this.scrollbarYRail = i(s.element.rail("y")), n.appendChild(this.scrollbarYRail), this.scrollbarY = i(s.element.thumb("y")), this.scrollbarYRail.appendChild(this.scrollbarY), this.scrollbarY.setAttribute("tabindex", 0), this.event.bind(this.scrollbarY, "focus", u), this.event.bind(this.scrollbarY, "blur", h), this.scrollbarYActive = null, this.scrollbarYHeight = null, this.scrollbarYTop = null;
		var f = t(this.scrollbarYRail);
		this.scrollbarYRight = parseInt(f.right, 10), isNaN(this.scrollbarYRight) ? (this.isScrollbarYUsingRight = !1, this.scrollbarYLeft = g(f.left)) : this.isScrollbarYUsingRight = !0, this.scrollbarYOuterWidth = this.isRtl ? function (e) {
			var i = t(e);
			return g(i.width) + g(i.paddingLeft) + g(i.paddingRight) + g(i.borderLeftWidth) + g(i.borderRightWidth)
		}(this.scrollbarY) : null, this.railBorderYWidth = g(f.borderTopWidth) + g(f.borderBottomWidth), e(this.scrollbarYRail, {display: "block"}), this.railYMarginHeight = g(f.marginTop) + g(f.marginBottom), e(this.scrollbarYRail, {display: ""}), this.railYHeight = null, this.railYRatio = null, this.reach = {
			x: n.scrollLeft <= 0 ? "start" : n.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
			y: n.scrollTop <= 0 ? "start" : n.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
		}, this.isAlive = !0, this.settings.handlers.forEach(function (t) {
			return x[t](o)
		}), this.lastScrollTop = Math.floor(n.scrollTop), this.lastScrollLeft = n.scrollLeft, this.event.bind(this.element, "scroll", function (t) {
			return o.onScroll(t)
		}), y(this)
	};
	return k.prototype.update = function () {
		this.isAlive && (this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0, e(this.scrollbarXRail, {display: "block"}), e(this.scrollbarYRail, {display: "block"}), this.railXMarginWidth = g(t(this.scrollbarXRail).marginLeft) + g(t(this.scrollbarXRail).marginRight), this.railYMarginHeight = g(t(this.scrollbarYRail).marginTop) + g(t(this.scrollbarYRail).marginBottom), e(this.scrollbarXRail, {display: "none"}), e(this.scrollbarYRail, {display: "none"}), y(this), m(this, "top", 0, !1, !0), m(this, "left", 0, !1, !0), e(this.scrollbarXRail, {display: ""}), e(this.scrollbarYRail, {display: ""}))
	}, k.prototype.onScroll = function (t) {
		this.isAlive && (y(this), m(this, "top", this.element.scrollTop - this.lastScrollTop), m(this, "left", this.element.scrollLeft - this.lastScrollLeft), this.lastScrollTop = Math.floor(this.element.scrollTop), this.lastScrollLeft = this.element.scrollLeft)
	}, k.prototype.destroy = function () {
		this.isAlive && (this.event.unbindAll(), o(this.scrollbarX), o(this.scrollbarY), o(this.scrollbarXRail), o(this.scrollbarYRail), this.removePsClasses(), this.element = null, this.scrollbarX = null, this.scrollbarY = null, this.scrollbarXRail = null, this.scrollbarYRail = null, this.isAlive = !1)
	}, k.prototype.removePsClasses = function () {
		this.element.className = this.element.className.split(" ").filter(function (t) {
			return !t.match(/^ps([-_].+|)$/)
		}).join(" ")
	}, k
});
var Sticky = function () {
	function t() {
		var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
		_classCallCheck(this, t), this.selector = e, this.elements = [], this.version = "1.2.0", this.vp = this.getViewportSize(), this.body = document.querySelector("body"), this.options = {
			wrap: i.wrap || !1,
			marginTop: i.marginTop || 0,
			stickyFor: i.stickyFor || 0,
			stickyClass: i.stickyClass || null,
			stickyContainer: i.stickyContainer || "body"
		}, this.updateScrollTopPosition = this.updateScrollTopPosition.bind(this), this.updateScrollTopPosition(), window.addEventListener("load", this.updateScrollTopPosition), window.addEventListener("scroll", this.updateScrollTopPosition), this.run()
	}

	return t.prototype.run = function () {
		var t = this, e = setInterval(function () {
			if ("complete" === document.readyState) {
				clearInterval(e);
				var i = document.querySelectorAll(t.selector);
				t.forEach(i, function (e) {
					return t.renderElement(e)
				})
			}
		}, 10)
	}, t.prototype.renderElement = function (t) {
		var e = this;
		t.sticky = {}, t.sticky.active = !1, t.sticky.marginTop = parseInt(t.getAttribute("data-margin-top")) || this.options.marginTop, t.sticky.stickyFor = parseInt(t.getAttribute("data-sticky-for")) || this.options.stickyFor, t.sticky.stickyClass = t.getAttribute("data-sticky-class") || this.options.stickyClass, t.sticky.wrap = !!t.hasAttribute("data-sticky-wrap") || this.options.wrap, t.sticky.stickyContainer = this.options.stickyContainer, t.sticky.container = this.getStickyContainer(t), t.sticky.container.rect = this.getRectangle(t.sticky.container), t.sticky.rect = this.getRectangle(t), "img" === t.tagName.toLowerCase() && (t.onload = function () {
			return t.sticky.rect = e.getRectangle(t)
		}), t.sticky.wrap && this.wrapElement(t), this.activate(t)
	}, t.prototype.wrapElement = function (t) {
		t.insertAdjacentHTML("beforebegin", "<span></span>"), t.previousSibling.appendChild(t)
	}, t.prototype.activate = function (t) {
		t.sticky.rect.top + t.sticky.rect.height < t.sticky.container.rect.top + t.sticky.container.rect.height && t.sticky.stickyFor < this.vp.width && !t.sticky.active && (t.sticky.active = !0), this.elements.indexOf(t) < 0 && this.elements.push(t), t.sticky.resizeEvent || (this.initResizeEvents(t), t.sticky.resizeEvent = !0), t.sticky.scrollEvent || (this.initScrollEvents(t), t.sticky.scrollEvent = !0), this.setPosition(t)
	}, t.prototype.initResizeEvents = function (t) {
		var e = this;
		t.sticky.resizeListener = function () {
			return e.onResizeEvents(t)
		}, window.addEventListener("resize", t.sticky.resizeListener)
	}, t.prototype.destroyResizeEvents = function (t) {
		window.removeEventListener("resize", t.sticky.resizeListener)
	}, t.prototype.onResizeEvents = function (t) {
		this.vp = this.getViewportSize(), t.sticky.rect = this.getRectangle(t), t.sticky.container.rect = this.getRectangle(t.sticky.container), t.sticky.rect.top + t.sticky.rect.height < t.sticky.container.rect.top + t.sticky.container.rect.height && t.sticky.stickyFor < this.vp.width && !t.sticky.active ? t.sticky.active = !0 : (t.sticky.rect.top + t.sticky.rect.height >= t.sticky.container.rect.top + t.sticky.container.rect.height || t.sticky.stickyFor >= this.vp.width && t.sticky.active) && (t.sticky.active = !1), this.setPosition(t)
	}, t.prototype.initScrollEvents = function (t) {
		var e = this;
		t.sticky.scrollListener = function () {
			return e.onScrollEvents(t)
		}, window.addEventListener("scroll", t.sticky.scrollListener)
	}, t.prototype.destroyScrollEvents = function (t) {
		window.removeEventListener("scroll", t.sticky.scrollListener)
	}, t.prototype.onScrollEvents = function (t) {
		t.sticky.active && this.setPosition(t)
	}, t.prototype.setPosition = function (t) {
		this.css(t, {position: "", width: "", top: "", left: ""}), this.vp.height < t.sticky.rect.height || !t.sticky.active || (t.sticky.rect.width || (t.sticky.rect = this.getRectangle(t)), t.sticky.wrap && this.css(t.parentNode, {
			display: "block",
			width: t.sticky.rect.width + "px",
			height: t.sticky.rect.height + "px"
		}), 0 === t.sticky.rect.top && t.sticky.container === this.body ? this.css(t, {position: "fixed", top: t.sticky.rect.top + "px", left: t.sticky.rect.left + "px", width: t.sticky.rect.width + "px"}) : this.scrollTop > t.sticky.rect.top - t.sticky.marginTop ? (this.css(t, {
			position: "fixed",
			width: t.sticky.rect.width + "px",
			left: t.sticky.rect.left + "px"
		}), this.scrollTop + t.sticky.rect.height + t.sticky.marginTop > t.sticky.container.rect.top + t.sticky.container.offsetHeight ? (t.sticky.stickyClass && t.classList.remove(t.sticky.stickyClass), this.css(t, {top: t.sticky.container.rect.top + t.sticky.container.offsetHeight - (this.scrollTop + t.sticky.rect.height) + "px"})) : (t.sticky.stickyClass && t.classList.add(t.sticky.stickyClass), this.css(t, {top: t.sticky.marginTop + "px"}))) : (t.sticky.stickyClass && t.classList.remove(t.sticky.stickyClass), this.css(t, {
			position: "",
			width: "",
			top: "",
			left: ""
		}), t.sticky.wrap && this.css(t.parentNode, {display: "", width: "", height: ""})))
	}, t.prototype.update = function () {
		var t = this;
		this.forEach(this.elements, function (e) {
			e.sticky.rect = t.getRectangle(e), e.sticky.container.rect = t.getRectangle(e.sticky.container), t.activate(e), t.setPosition(e)
		})
	}, t.prototype.destroy = function () {
		var t = this;
		this.forEach(this.elements, function (e) {
			t.destroyResizeEvents(e), t.destroyScrollEvents(e), delete e.sticky
		})
	}, t.prototype.getStickyContainer = function (t) {
		for (var e = t.parentNode; !e.hasAttribute("data-sticky-container") && !e.parentNode.querySelector(t.sticky.stickyContainer) && e !== this.body;) e = e.parentNode;
		return e
	}, t.prototype.getRectangle = function (t) {
		this.css(t, {position: "", width: "", top: "", left: ""});
		var e = Math.max(t.offsetWidth, t.clientWidth, t.scrollWidth), i = Math.max(t.offsetHeight, t.clientHeight, t.scrollHeight), n = 0, r = 0;
		do {
			n += t.offsetTop || 0, r += t.offsetLeft || 0, t = t.offsetParent
		} while (t);
		return {top: n, left: r, width: e, height: i}
	}, t.prototype.getViewportSize = function () {
		return {width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0), height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)}
	}, t.prototype.updateScrollTopPosition = function () {
		this.scrollTop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0) || 0
	}, t.prototype.forEach = function (t, e) {
		for (var i = 0, n = t.length; i < n; i++) e(t[i])
	}, t.prototype.css = function (t, e) {
		for (var i in e) e.hasOwnProperty(i) && (t.style[i] = e[i])
	}, t
}();
!function (t, e) {
	"undefined" != typeof exports ? module.exports = e : "function" == typeof define && define.amd ? define([], e) : t.Sticky = e
}(this, Sticky), function (t) {
	"function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? module.exports = t() : window.wNumb = t()
}(function () {
	"use strict";
	var t = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];

	function e(t) {
		return t.split("").reverse().join("")
	}

	function i(t, e) {
		return t.substring(0, e.length) === e
	}

	function n(t, e, i) {
		if ((t[e] || t[i]) && t[e] === t[i]) throw new Error(e)
	}

	function r(t) {
		return "number" == typeof t && isFinite(t)
	}

	function o(t, i, n, o, a, s, l, c, u, h, d, p) {
		var f, m, g, v, y, b = p, w = "", x = "";
		return s && (p = s(p)), !!r(p) && (!1 !== t && 0 === parseFloat(p.toFixed(t)) && (p = 0), p < 0 && (f = !0, p = Math.abs(p)), !1 !== t && (y = t, v = (v = p).toString().split("e"), p = (+((v = (v = Math.round(+(v[0] + "e" + (v[1] ? +v[1] + y : y)))).toString().split("e"))[0] + "e" + (v[1] ? +v[1] - y : -y))).toFixed(y)), -1 !== (p = p.toString()).indexOf(".") ? (g = (m = p.split("."))[0], n && (w = n + m[1])) : g = p, i && (g = e(g).match(/.{1,3}/g), g = e(g.join(e(i)))), f && c && (x += c), o && (x += o), f && u && (x += u), x += g, x += w, a && (x += a), h && (x = h(x, b)), x)
	}

	function a(t, e, n, o, a, s, l, c, u, h, d, p) {
		var f, m = "";
		return d && (p = d(p)), !(!p || "string" != typeof p) && (c && i(p, c) && (p = p.replace(c, ""), f = !0), o && i(p, o) && (p = p.replace(o, "")), u && i(p, u) && (p = p.replace(u, ""), f = !0), a && function (t, e) {
			return t.slice(-1 * e.length) === e
		}(p, a) && (p = p.slice(0, -1 * a.length)), e && (p = p.split(e).join("")), n && (p = p.replace(n, ".")), f && (m += "-"), "" !== (m = (m += p).replace(/[^0-9\.\-.]/g, "")) && (m = Number(m), l && (m = l(m)), !!r(m) && m))
	}

	function s(e, i, n) {
		var r, o = [];
		for (r = 0; r < t.length; r += 1) o.push(e[t[r]]);
		return o.push(n), i.apply("", o)
	}

	return function e(i) {
		if (!(this instanceof e)) return new e(i);
		"object" == typeof i && (i = function (e) {
			var i, r, o, a = {};
			for (void 0 === e.suffix && (e.suffix = e.postfix), i = 0; i < t.length; i += 1) if (void 0 === (o = e[r = t[i]])) "negative" !== r || a.negativeBefore ? "mark" === r && "." !== a.thousand ? a[r] = "." : a[r] = !1 : a[r] = "-"; else if ("decimals" === r) {
				if (!(o >= 0 && o < 8)) throw new Error(r);
				a[r] = o
			} else if ("encoder" === r || "decoder" === r || "edit" === r || "undo" === r) {
				if ("function" != typeof o) throw new Error(r);
				a[r] = o
			} else {
				if ("string" != typeof o) throw new Error(r);
				a[r] = o
			}
			return n(a, "mark", "thousand"), n(a, "prefix", "negative"), n(a, "prefix", "negativeBefore"), a
		}(i), this.to = function (t) {
			return s(i, o, t)
		}, this.from = function (t) {
			return s(i, a, t)
		})
	}
}), function (t) {
	"function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof module && module.exports ? module.exports = function (e, i) {
		return void 0 === i && (i = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), t(i), i
	} : t(jQuery)
}(function (t) {
	"use strict";

	function e(e) {
		var i = e.data;
		e.isDefaultPrevented() || (e.preventDefault(), t(e.target).closest("form").ajaxSubmit(i))
	}

	function i(e) {
		var i = e.target, n = t(i);
		if (!n.is("[type=submit],[type=image]")) {
			var r = n.closest("[type=submit]");
			if (0 === r.length) return;
			i = r[0]
		}
		var o = i.form;
		if (o.clk = i, "image" === i.type) if (void 0 !== e.offsetX) o.clk_x = e.offsetX, o.clk_y = e.offsetY; else if ("function" == typeof t.fn.offset) {
			var a = n.offset();
			o.clk_x = e.pageX - a.left, o.clk_y = e.pageY - a.top
		} else o.clk_x = e.pageX - i.offsetLeft, o.clk_y = e.pageY - i.offsetTop;
		setTimeout(function () {
			o.clk = o.clk_x = o.clk_y = null
		}, 100)
	}

	function n() {
		if (t.fn.ajaxSubmit.debug) {
			var e = "[jquery.form] " + Array.prototype.join.call(arguments, "");
			window.console && window.console.log ? window.console.log(e) : window.opera && window.opera.postError && window.opera.postError(e)
		}
	}

	var r = /\r?\n/g, o = {};
	o.fileapi = void 0 !== t('<input type="file">').get(0).files, o.formdata = void 0 !== window.FormData;
	var a = !!t.fn.prop;
	t.fn.attr2 = function () {
		if (!a) return this.attr.apply(this, arguments);
		var t = this.prop.apply(this, arguments);
		return t && t.jquery || "string" == typeof t ? t : this.attr.apply(this, arguments)
	}, t.fn.ajaxSubmit = function (e, i, r, s) {
		function l(i) {
			function r(t) {
				var e = null;
				try {
					t.contentWindow && (e = t.contentWindow.document)
				} catch (t) {
					n("cannot get iframe.contentWindow document: " + t)
				}
				if (e) return e;
				try {
					e = t.contentDocument ? t.contentDocument : t.document
				} catch (i) {
					n("cannot get iframe.contentDocument: " + i), e = t.document
				}
				return e
			}

			function o() {
				var e = d.attr2("target"), i = d.attr2("action"), o = d.attr("enctype") || d.attr("encoding") || "multipart/form-data";
				_.setAttribute("target", f), c && !/post/i.test(c) || _.setAttribute("method", "POST"), i !== h.url && _.setAttribute("action", h.url), h.skipEncodingOverride || c && !/post/i.test(c) || d.attr({
					encoding: "multipart/form-data",
					enctype: "multipart/form-data"
				}), h.timeout && (k = setTimeout(function () {
					x = !0, s(T)
				}, h.timeout));
				var a = [];
				try {
					if (h.extraData) for (var l in h.extraData) h.extraData.hasOwnProperty(l) && (t.isPlainObject(h.extraData[l]) && h.extraData[l].hasOwnProperty("name") && h.extraData[l].hasOwnProperty("value") ? a.push(t('<input type="hidden" name="' + h.extraData[l].name + '">', C).val(h.extraData[l].value).appendTo(_)[0]) : a.push(t('<input type="hidden" name="' + l + '">', C).val(h.extraData[l]).appendTo(_)[0]));
					h.iframeTarget || m.appendTo(D), v.attachEvent ? v.attachEvent("onload", s) : v.addEventListener("load", s, !1), setTimeout(function t() {
						try {
							var e = r(v).readyState;
							n("state = " + e), e && "uninitialized" === e.toLowerCase() && setTimeout(t, 50)
						} catch (e) {
							n("Server abort: ", e, " (", e.name, ")"), s(M), k && clearTimeout(k), k = void 0
						}
					}, 15);
					try {
						_.submit()
					} catch (t) {
						document.createElement("form").submit.apply(_)
					}
				} finally {
					_.setAttribute("action", i), _.setAttribute("enctype", o), e ? _.setAttribute("target", e) : d.removeAttr("target"), t(a).remove()
				}
			}

			function s(e) {
				if (!y.aborted && !O) {
					if ((I = r(v)) || (n("cannot access response document"), e = M), e === T && y) return y.abort("timeout"), void S.reject(y, "timeout");
					if (e === M && y) return y.abort("server abort"), void S.reject(y, "error", "server abort");
					if (I && I.location.href !== h.iframeSrc || x) {
						v.detachEvent ? v.detachEvent("onload", s) : v.removeEventListener("load", s, !1);
						var i, o = "success";
						try {
							if (x) throw"timeout";
							var a = "xml" === h.dataType || I.XMLDocument || t.isXMLDoc(I);
							if (n("isXml=" + a), !a && window.opera && (null === I.body || !I.body.innerHTML) && --L) return n("requeing onLoad callback, DOM not available"), void setTimeout(s, 250);
							var l = I.body ? I.body : I.documentElement;
							y.responseText = l ? l.innerHTML : null, y.responseXML = I.XMLDocument ? I.XMLDocument : I, a && (h.dataType = "xml"), y.getResponseHeader = function (t) {
								return {"content-type": h.dataType}[t.toLowerCase()]
							}, l && (y.status = Number(l.getAttribute("status")) || y.status, y.statusText = l.getAttribute("statusText") || y.statusText);
							var c = (h.dataType || "").toLowerCase(), u = /(json|script|text)/.test(c);
							if (u || h.textarea) {
								var d = I.getElementsByTagName("textarea")[0];
								if (d) y.responseText = d.value, y.status = Number(d.getAttribute("status")) || y.status, y.statusText = d.getAttribute("statusText") || y.statusText; else if (u) {
									var f = I.getElementsByTagName("pre")[0], g = I.getElementsByTagName("body")[0];
									f ? y.responseText = f.textContent ? f.textContent : f.innerText : g && (y.responseText = g.textContent ? g.textContent : g.innerText)
								}
							} else "xml" === c && !y.responseXML && y.responseText && (y.responseXML = F(y.responseText));
							try {
								P = R(y, c, h)
							} catch (t) {
								o = "parsererror", y.error = i = t || o
							}
						} catch (t) {
							n("error caught: ", t), o = "error", y.error = i = t || o
						}
						y.aborted && (n("upload aborted"), o = null), y.status && (o = y.status >= 200 && y.status < 300 || 304 === y.status ? "success" : "error"), "success" === o ? (h.success && h.success.call(h.context, P, "success", y), S.resolve(y.responseText, "success", y), p && t.event.trigger("ajaxSuccess", [y, h])) : o && (void 0 === i && (i = y.statusText), h.error && h.error.call(h.context, y, o, i), S.reject(y, "error", i), p && t.event.trigger("ajaxError", [y, h, i])), p && t.event.trigger("ajaxComplete", [y, h]), p && !--t.active && t.event.trigger("ajaxStop"), h.complete && h.complete.call(h.context, y, o), O = !0, h.timeout && clearTimeout(k), setTimeout(function () {
							h.iframeTarget ? m.attr("src", h.iframeSrc) : m.remove(), y.responseXML = null
						}, 100)
					}
				}
			}

			var l, u, h, p, f, m, v, y, b, w, x, k, _ = d[0], S = t.Deferred();
			if (S.abort = function (t) {
				y.abort(t)
			}, i) for (u = 0; u < g.length; u++) l = t(g[u]), a ? l.prop("disabled", !1) : l.removeAttr("disabled");
			(h = t.extend(!0, {}, t.ajaxSettings, e)).context = h.context || h, f = "jqFormIO" + (new Date).getTime();
			var C = _.ownerDocument, D = d.closest("body");
			if (h.iframeTarget ? (w = (m = t(h.iframeTarget, C)).attr2("name")) ? f = w : m.attr2("name", f) : (m = t('<iframe name="' + f + '" src="' + h.iframeSrc + '" />', C)).css({position: "absolute", top: "-1000px", left: "-1000px"}), v = m[0], y = {
				aborted: 0,
				responseText: null,
				responseXML: null,
				status: 0,
				statusText: "n/a",
				getAllResponseHeaders: function () {
				},
				getResponseHeader: function () {
				},
				setRequestHeader: function () {
				},
				abort: function (e) {
					var i = "timeout" === e ? "timeout" : "aborted";
					n("aborting upload... " + i), this.aborted = 1;
					try {
						v.contentWindow.document.execCommand && v.contentWindow.document.execCommand("Stop")
					} catch (t) {
					}
					m.attr("src", h.iframeSrc), y.error = i, h.error && h.error.call(h.context, y, i, e), p && t.event.trigger("ajaxError", [y, h, i]), h.complete && h.complete.call(h.context, y, i)
				}
			}, (p = h.global) && 0 == t.active++ && t.event.trigger("ajaxStart"), p && t.event.trigger("ajaxSend", [y, h]), h.beforeSend && !1 === h.beforeSend.call(h.context, y, h)) return h.global && t.active--, S.reject(), S;
			if (y.aborted) return S.reject(), S;
			(b = _.clk) && (w = b.name) && !b.disabled && (h.extraData = h.extraData || {}, h.extraData[w] = b.value, "image" === b.type && (h.extraData[w + ".x"] = _.clk_x, h.extraData[w + ".y"] = _.clk_y));
			var T = 1, M = 2, E = t("meta[name=csrf-token]").attr("content"), A = t("meta[name=csrf-param]").attr("content");
			A && E && (h.extraData = h.extraData || {}, h.extraData[A] = E), h.forceSync ? o() : setTimeout(o, 10);
			var P, I, O, L = 50, F = t.parseXML || function (t, e) {
				return window.ActiveXObject ? ((e = new ActiveXObject("Microsoft.XMLDOM")).async = "false", e.loadXML(t)) : e = (new DOMParser).parseFromString(t, "text/xml"), e && e.documentElement && "parsererror" !== e.documentElement.nodeName ? e : null
			}, N = t.parseJSON || function (t) {
				return window.eval("(" + t + ")")
			}, R = function (e, i, n) {
				var r = e.getResponseHeader("content-type") || "", o = ("xml" === i || !i) && r.indexOf("xml") >= 0, a = o ? e.responseXML : e.responseText;
				return o && "parsererror" === a.documentElement.nodeName && t.error && t.error("parsererror"), n && n.dataFilter && (a = n.dataFilter(a, i)), "string" == typeof a && (("json" === i || !i) && r.indexOf("json") >= 0 ? a = N(a) : ("script" === i || !i) && r.indexOf("javascript") >= 0 && t.globalEval(a)), a
			};
			return S
		}

		if (!this.length) return n("ajaxSubmit: skipping submit process - no element selected"), this;
		var c, u, h, d = this;
		"function" == typeof e ? e = {success: e} : "string" == typeof e || !1 === e && arguments.length > 0 ? (e = {
			url: e,
			data: i,
			dataType: r
		}, "function" == typeof s && (e.success = s)) : void 0 === e && (e = {}), c = e.method || e.type || this.attr2("method"), (h = (h = "string" == typeof (u = e.url || this.attr2("action")) ? t.trim(u) : "") || window.location.href || "") && (h = (h.match(/^([^#]+)/) || [])[1]), e = t.extend(!0, {
			url: h,
			success: t.ajaxSettings.success,
			type: c || t.ajaxSettings.type,
			iframeSrc: /^https/i.test(window.location.href || "") ? "javascript:false" : "about:blank"
		}, e);
		var p = {};
		if (this.trigger("form-pre-serialize", [this, e, p]), p.veto) return n("ajaxSubmit: submit vetoed via form-pre-serialize trigger"), this;
		if (e.beforeSerialize && !1 === e.beforeSerialize(this, e)) return n("ajaxSubmit: submit aborted via beforeSerialize callback"), this;
		var f = e.traditional;
		void 0 === f && (f = t.ajaxSettings.traditional);
		var m, g = [], v = this.formToArray(e.semantic, g, e.filtering);
		if (e.data) {
			var y = t.isFunction(e.data) ? e.data(v) : e.data;
			e.extraData = y, m = t.param(y, f)
		}
		if (e.beforeSubmit && !1 === e.beforeSubmit(v, this, e)) return n("ajaxSubmit: submit aborted via beforeSubmit callback"), this;
		if (this.trigger("form-submit-validate", [v, this, e, p]), p.veto) return n("ajaxSubmit: submit vetoed via form-submit-validate trigger"), this;
		var b = t.param(v, f);
		m && (b = b ? b + "&" + m : m), "GET" === e.type.toUpperCase() ? (e.url += (e.url.indexOf("?") >= 0 ? "&" : "?") + b, e.data = null) : e.data = b;
		var w = [];
		if (e.resetForm && w.push(function () {
			d.resetForm()
		}), e.clearForm && w.push(function () {
			d.clearForm(e.includeHidden)
		}), !e.dataType && e.target) {
			var x = e.success || function () {
			};
			w.push(function (i, n, r) {
				var o = arguments, a = e.replaceTarget ? "replaceWith" : "html";
				t(e.target)[a](i).each(function () {
					x.apply(this, o)
				})
			})
		} else e.success && (t.isArray(e.success) ? t.merge(w, e.success) : w.push(e.success));
		if (e.success = function (t, i, n) {
			for (var r = e.context || this, o = 0, a = w.length; o < a; o++) w[o].apply(r, [t, i, n || d, d])
		}, e.error) {
			var k = e.error;
			e.error = function (t, i, n) {
				var r = e.context || this;
				k.apply(r, [t, i, n, d])
			}
		}
		if (e.complete) {
			var _ = e.complete;
			e.complete = function (t, i) {
				var n = e.context || this;
				_.apply(n, [t, i, d])
			}
		}
		var S = t("input[type=file]:enabled", this).filter(function () {
			return "" !== t(this).val()
		}).length > 0, C = "multipart/form-data", D = d.attr("enctype") === C || d.attr("encoding") === C, T = o.fileapi && o.formdata;
		n("fileAPI :" + T);
		var M, E = (S || D) && !T;
		!1 !== e.iframe && (e.iframe || E) ? e.closeKeepAlive ? t.get(e.closeKeepAlive, function () {
			M = l(v)
		}) : M = l(v) : M = (S || D) && T ? function (i) {
			for (var n = new FormData, r = 0; r < i.length; r++) n.append(i[r].name, i[r].value);
			if (e.extraData) {
				var o = function (i) {
					var n, r, o = t.param(i, e.traditional).split("&"), a = o.length, s = [];
					for (n = 0; n < a; n++) o[n] = o[n].replace(/\+/g, " "), r = o[n].split("="), s.push([decodeURIComponent(r[0]), decodeURIComponent(r[1])]);
					return s
				}(e.extraData);
				for (r = 0; r < o.length; r++) o[r] && n.append(o[r][0], o[r][1])
			}
			e.data = null;
			var a = t.extend(!0, {}, t.ajaxSettings, e, {contentType: !1, processData: !1, cache: !1, type: c || "POST"});
			e.uploadProgress && (a.xhr = function () {
				var i = t.ajaxSettings.xhr();
				return i.upload && i.upload.addEventListener("progress", function (t) {
					var i = 0, n = t.loaded || t.position, r = t.total;
					t.lengthComputable && (i = Math.ceil(n / r * 100)), e.uploadProgress(t, n, r, i)
				}, !1), i
			}), a.data = null;
			var s = a.beforeSend;
			return a.beforeSend = function (t, i) {
				e.formData ? i.data = e.formData : i.data = n, s && s.call(this, t, i)
			}, t.ajax(a)
		}(v) : t.ajax(e), d.removeData("jqxhr").data("jqxhr", M);
		for (var A = 0; A < g.length; A++) g[A] = null;
		return this.trigger("form-submit-notify", [this, e]), this
	}, t.fn.ajaxForm = function (r, o, a, s) {
		if (("string" == typeof r || !1 === r && arguments.length > 0) && (r = {url: r, data: o, dataType: a}, "function" == typeof s && (r.success = s)), (r = r || {}).delegation = r.delegation && t.isFunction(t.fn.on), !r.delegation && 0 === this.length) {
			var l = {s: this.selector, c: this.context};
			return !t.isReady && l.s ? (n("DOM not ready, queuing ajaxForm"), t(function () {
				t(l.s, l.c).ajaxForm(r)
			}), this) : (n("terminating; zero elements found by selector" + (t.isReady ? "" : " (DOM not ready)")), this)
		}
		return r.delegation ? (t(document).off("submit.form-plugin", this.selector, e).off("click.form-plugin", this.selector, i).on("submit.form-plugin", this.selector, r, e).on("click.form-plugin", this.selector, r, i), this) : this.ajaxFormUnbind().on("submit.form-plugin", r, e).on("click.form-plugin", r, i)
	}, t.fn.ajaxFormUnbind = function () {
		return this.off("submit.form-plugin click.form-plugin")
	}, t.fn.formToArray = function (e, i, n) {
		var r = [];
		if (0 === this.length) return r;
		var a, s, l, c, u, h, d, p, f = this[0], m = this.attr("id"), g = e || void 0 === f.elements ? f.getElementsByTagName("*") : f.elements;
		if (g && (g = t.makeArray(g)), m && (e || /(Edge|Trident)\//.test(navigator.userAgent)) && (a = t(':input[form="' + m + '"]').get()).length && (g = (g || []).concat(a)), !g || !g.length) return r;
		for (t.isFunction(n) && (g = t.map(g, n)), s = 0, d = g.length; s < d; s++) if ((c = (h = g[s]).name) && !h.disabled) if (e && f.clk && "image" === h.type) f.clk === h && (r.push({name: c, value: t(h).val(), type: h.type}), r.push({name: c + ".x", value: f.clk_x}, {
			name: c + ".y",
			value: f.clk_y
		})); else if ((u = t.fieldValue(h, !0)) && u.constructor === Array) for (i && i.push(h), l = 0, p = u.length; l < p; l++) r.push({name: c, value: u[l]}); else if (o.fileapi && "file" === h.type) {
			i && i.push(h);
			var v = h.files;
			if (v.length) for (l = 0; l < v.length; l++) r.push({name: c, value: v[l], type: h.type}); else r.push({name: c, value: "", type: h.type})
		} else null != u && (i && i.push(h), r.push({name: c, value: u, type: h.type, required: h.required}));
		if (!e && f.clk) {
			var y = t(f.clk), b = y[0];
			(c = b.name) && !b.disabled && "image" === b.type && (r.push({name: c, value: y.val()}), r.push({name: c + ".x", value: f.clk_x}, {name: c + ".y", value: f.clk_y}))
		}
		return r
	}, t.fn.formSerialize = function (e) {
		return t.param(this.formToArray(e))
	}, t.fn.fieldSerialize = function (e) {
		var i = [];
		return this.each(function () {
			var n = this.name;
			if (n) {
				var r = t.fieldValue(this, e);
				if (r && r.constructor === Array) for (var o = 0, a = r.length; o < a; o++) i.push({name: n, value: r[o]}); else null != r && i.push({name: this.name, value: r})
			}
		}), t.param(i)
	}, t.fn.fieldValue = function (e) {
		for (var i = [], n = 0, r = this.length; n < r; n++) {
			var o = this[n], a = t.fieldValue(o, e);
			null == a || a.constructor === Array && !a.length || (a.constructor === Array ? t.merge(i, a) : i.push(a))
		}
		return i
	}, t.fieldValue = function (e, i) {
		var n = e.name, o = e.type, a = e.tagName.toLowerCase();
		if (void 0 === i && (i = !0), i && (!n || e.disabled || "reset" === o || "button" === o || ("checkbox" === o || "radio" === o) && !e.checked || ("submit" === o || "image" === o) && e.form && e.form.clk !== e || "select" === a && -1 === e.selectedIndex)) return null;
		if ("select" === a) {
			var s = e.selectedIndex;
			if (s < 0) return null;
			for (var l = [], c = e.options, u = "select-one" === o, h = u ? s + 1 : c.length, d = u ? s : 0; d < h; d++) {
				var p = c[d];
				if (p.selected && !p.disabled) {
					var f = p.value;
					if (f || (f = p.attributes && p.attributes.value && !p.attributes.value.specified ? p.text : p.value), u) return f;
					l.push(f)
				}
			}
			return l
		}
		return t(e).val().replace(r, "\r\n")
	}, t.fn.clearForm = function (e) {
		return this.each(function () {
			t("input,select,textarea", this).clearFields(e)
		})
	}, t.fn.clearFields = t.fn.clearInputs = function (e) {
		var i = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i;
		return this.each(function () {
			var n = this.type, r = this.tagName.toLowerCase();
			i.test(n) || "textarea" === r ? this.value = "" : "checkbox" === n || "radio" === n ? this.checked = !1 : "select" === r ? this.selectedIndex = -1 : "file" === n ? /MSIE/.test(navigator.userAgent) ? t(this).replaceWith(t(this).clone(!0)) : t(this).val("") : e && (!0 === e && /hidden/.test(n) || "string" == typeof e && t(this).is(e)) && (this.value = "")
		})
	}, t.fn.resetForm = function () {
		return this.each(function () {
			var e = t(this), i = this.tagName.toLowerCase();
			switch (i) {
				case"input":
					this.checked = this.defaultChecked;
				case"textarea":
					return this.value = this.defaultValue, !0;
				case"option":
				case"optgroup":
					var n = e.parents("select");
					return n.length && n[0].multiple ? "option" === i ? this.selected = this.defaultSelected : e.find("option").resetForm() : n.resetForm(), !0;
				case"select":
					return e.find("option").each(function (t) {
						if (this.selected = this.defaultSelected, this.defaultSelected && !e[0].multiple) return e[0].selectedIndex = t, !1
					}), !0;
				case"label":
					var r = t(e.attr("for")), o = e.find("input,select,textarea");
					return r[0] && o.unshift(r[0]), o.resetForm(), !0;
				case"form":
					return ("function" == typeof this.reset || "object" == typeof this.reset && !this.reset.nodeType) && this.reset(), !0;
				default:
					return e.find("form,input,label,select,textarea").resetForm(), !0
			}
		})
	}, t.fn.enable = function (t) {
		return void 0 === t && (t = !0), this.each(function () {
			this.disabled = !t
		})
	}, t.fn.selected = function (e) {
		return void 0 === e && (e = !0), this.each(function () {
			var i = this.type;
			if ("checkbox" === i || "radio" === i) this.checked = e; else if ("option" === this.tagName.toLowerCase()) {
				var n = t(this).parent("select");
				e && n[0] && "select-one" === n[0].type && n.find("option").selected(!1), this.selected = e
			}
		})
	}, t.fn.ajaxSubmit.debug = !1
}), function () {
	"use strict";

	function t(t) {
		t.fn._fadeIn = t.fn.fadeIn;
		var e = t.noop || function () {
		}, i = /MSIE/.test(navigator.userAgent), n = /MSIE 6.0/.test(navigator.userAgent) && !/MSIE 8.0/.test(navigator.userAgent), r = (document.documentMode, t.isFunction(document.createElement("div").style.setExpression));
		t.blockUI = function (t) {
			s(window, t)
		}, t.unblockUI = function (t) {
			l(window, t)
		}, t.growlUI = function (e, i, n, r) {
			var o = t('<div class="growlUI"></div>');
			e && o.append("<h1>" + e + "</h1>"), i && o.append("<h2>" + i + "</h2>"), void 0 === n && (n = 3e3);
			var a = function (e) {
				e = e || {}, t.blockUI({message: o, fadeIn: void 0 !== e.fadeIn ? e.fadeIn : 700, fadeOut: void 0 !== e.fadeOut ? e.fadeOut : 1e3, timeout: void 0 !== e.timeout ? e.timeout : n, centerY: !1, showOverlay: !1, onUnblock: r, css: t.blockUI.defaults.growlCSS})
			};
			a();
			o.css("opacity");
			o.mouseover(function () {
				a({fadeIn: 0, timeout: 3e4});
				var e = t(".blockMsg");
				e.stop(), e.fadeTo(300, 1)
			}).mouseout(function () {
				t(".blockMsg").fadeOut(1e3)
			})
		}, t.fn.block = function (e) {
			if (this[0] === window) return t.blockUI(e), this;
			var i = t.extend({}, t.blockUI.defaults, e || {});
			return this.each(function () {
				var e = t(this);
				i.ignoreIfBlocked && e.data("blockUI.isBlocked") || e.unblock({fadeOut: 0})
			}), this.each(function () {
				"static" == t.css(this, "position") && (this.style.position = "relative", t(this).data("blockUI.static", !0)), this.style.zoom = 1, s(this, e)
			})
		}, t.fn.unblock = function (e) {
			return this[0] === window ? (t.unblockUI(e), this) : this.each(function () {
				l(this, e)
			})
		}, t.blockUI.version = 2.7, t.blockUI.defaults = {
			message: "<h1>Please wait...</h1>",
			title: null,
			draggable: !0,
			theme: !1,
			css: {padding: 0, margin: 0, width: "30%", top: "40%", left: "35%", textAlign: "center", color: "#000", border: "3px solid #aaa", backgroundColor: "#fff", cursor: "wait"},
			themedCSS: {width: "30%", top: "40%", left: "35%"},
			overlayCSS: {backgroundColor: "#000", opacity: .6, cursor: "wait"},
			cursorReset: "default",
			growlCSS: {width: "350px", top: "10px", left: "", right: "10px", border: "none", padding: "5px", opacity: .6, cursor: "default", color: "#fff", backgroundColor: "#000", "-webkit-border-radius": "10px", "-moz-border-radius": "10px", "border-radius": "10px"},
			iframeSrc: /^https/i.test(window.location.href || "") ? "javascript:false" : "about:blank",
			forceIframe: !1,
			baseZ: 1e3,
			centerX: !0,
			centerY: !0,
			allowBodyStretch: !0,
			bindEvents: !0,
			constrainTabKey: !0,
			fadeIn: 200,
			fadeOut: 400,
			timeout: 0,
			showOverlay: !0,
			focusInput: !0,
			focusableElements: ":input:enabled:visible",
			onBlock: null,
			onUnblock: null,
			onOverlayClick: null,
			quirksmodeOffsetHack: 4,
			blockMsgClass: "blockMsg",
			ignoreIfBlocked: !1
		};
		var o = null, a = [];

		function s(s, c) {
			var h, f, m = s == window, g = c && void 0 !== c.message ? c.message : void 0;
			if (!(c = t.extend({}, t.blockUI.defaults, c || {})).ignoreIfBlocked || !t(s).data("blockUI.isBlocked")) {
				if (c.overlayCSS = t.extend({}, t.blockUI.defaults.overlayCSS, c.overlayCSS || {}), h = t.extend({}, t.blockUI.defaults.css, c.css || {}), c.onOverlayClick && (c.overlayCSS.cursor = "pointer"), f = t.extend({}, t.blockUI.defaults.themedCSS, c.themedCSS || {}), g = void 0 === g ? c.message : g, m && o && l(window, {fadeOut: 0}), g && "string" != typeof g && (g.parentNode || g.jquery)) {
					var v = g.jquery ? g[0] : g, y = {};
					t(s).data("blockUI.history", y), y.el = v, y.parent = v.parentNode, y.display = v.style.display, y.position = v.style.position, y.parent && y.parent.removeChild(v)
				}
				t(s).data("blockUI.onUnblock", c.onUnblock);
				var b, w, x, k, _ = c.baseZ;
				b = i || c.forceIframe ? t('<iframe class="blockUI" style="z-index:' + _++ + ';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="' + c.iframeSrc + '"></iframe>') : t('<div class="blockUI" style="display:none"></div>'), w = c.theme ? t('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:' + _++ + ';display:none"></div>') : t('<div class="blockUI blockOverlay" style="z-index:' + _++ + ';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>'), c.theme && m ? (k = '<div class="blockUI ' + c.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:' + (_ + 10) + ';display:none;position:fixed">', c.title && (k += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (c.title || "&nbsp;") + "</div>"), k += '<div class="ui-widget-content ui-dialog-content"></div>', k += "</div>") : c.theme ? (k = '<div class="blockUI ' + c.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:' + (_ + 10) + ';display:none;position:absolute">', c.title && (k += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (c.title || "&nbsp;") + "</div>"), k += '<div class="ui-widget-content ui-dialog-content"></div>', k += "</div>") : k = m ? '<div class="blockUI ' + c.blockMsgClass + ' blockPage" style="z-index:' + (_ + 10) + ';display:none;position:fixed"></div>' : '<div class="blockUI ' + c.blockMsgClass + ' blockElement" style="z-index:' + (_ + 10) + ';display:none;position:absolute"></div>', x = t(k), g && (c.theme ? (x.css(f), x.addClass("ui-widget-content")) : x.css(h)), c.theme || w.css(c.overlayCSS), w.css("position", m ? "fixed" : "absolute"), (i || c.forceIframe) && b.css("opacity", 0);
				var S = [b, w, x], C = t(m ? "body" : s);
				t.each(S, function () {
					this.appendTo(C)
				}), c.theme && c.draggable && t.fn.draggable && x.draggable({handle: ".ui-dialog-titlebar", cancel: "li"});
				var D = r && (!t.support.boxModel || t("object,embed", m ? null : s).length > 0);
				if (n || D) {
					if (m && c.allowBodyStretch && t.support.boxModel && t("html,body").css("height", "100%"), (n || !t.support.boxModel) && !m) var T = p(s, "borderTopWidth"), M = p(s, "borderLeftWidth"), E = T ? "(0 - " + T + ")" : 0, A = M ? "(0 - " + M + ")" : 0;
					t.each(S, function (t, e) {
						var i = e[0].style;
						if (i.position = "absolute", t < 2) m ? i.setExpression("height", "Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:" + c.quirksmodeOffsetHack + ') + "px"') : i.setExpression("height", 'this.parentNode.offsetHeight + "px"'), m ? i.setExpression("width", 'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"') : i.setExpression("width", 'this.parentNode.offsetWidth + "px"'), A && i.setExpression("left", A), E && i.setExpression("top", E); else if (c.centerY) m && i.setExpression("top", '(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"'), i.marginTop = 0; else if (!c.centerY && m) {
							var n = "((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + " + (c.css && c.css.top ? parseInt(c.css.top, 10) : 0) + ') + "px"';
							i.setExpression("top", n)
						}
					})
				}
				if (g && (c.theme ? x.find(".ui-widget-content").append(g) : x.append(g), (g.jquery || g.nodeType) && t(g).show()), (i || c.forceIframe) && c.showOverlay && b.show(), c.fadeIn) {
					var P = c.onBlock ? c.onBlock : e, I = c.showOverlay && !g ? P : e, O = g ? P : e;
					c.showOverlay && w._fadeIn(c.fadeIn, I), g && x._fadeIn(c.fadeIn, O)
				} else c.showOverlay && w.show(), g && x.show(), c.onBlock && c.onBlock.bind(x)();
				if (u(1, s, c), m ? (o = x[0], a = t(c.focusableElements, o), c.focusInput && setTimeout(d, 20)) : function (t, e, i) {
					var n = t.parentNode, r = t.style, o = (n.offsetWidth - t.offsetWidth) / 2 - p(n, "borderLeftWidth"), a = (n.offsetHeight - t.offsetHeight) / 2 - p(n, "borderTopWidth");
					e && (r.left = o > 0 ? o + "px" : "0");
					i && (r.top = a > 0 ? a + "px" : "0")
				}(x[0], c.centerX, c.centerY), c.timeout) {
					var L = setTimeout(function () {
						m ? t.unblockUI(c) : t(s).unblock(c)
					}, c.timeout);
					t(s).data("blockUI.timeout", L)
				}
			}
		}

		function l(e, i) {
			var n, r, s = e == window, l = t(e), h = l.data("blockUI.history"), d = l.data("blockUI.timeout");
			d && (clearTimeout(d), l.removeData("blockUI.timeout")), i = t.extend({}, t.blockUI.defaults, i || {}), u(0, e, i), null === i.onUnblock && (i.onUnblock = l.data("blockUI.onUnblock"), l.removeData("blockUI.onUnblock")), r = s ? t("body").children().filter(".blockUI").add("body > .blockUI") : l.find(">.blockUI"), i.cursorReset && (r.length > 1 && (r[1].style.cursor = i.cursorReset), r.length > 2 && (r[2].style.cursor = i.cursorReset)), s && (o = a = null), i.fadeOut ? (n = r.length, r.stop().fadeOut(i.fadeOut, function () {
				0 == --n && c(r, h, i, e)
			})) : c(r, h, i, e)
		}

		function c(e, i, n, r) {
			var o = t(r);
			if (!o.data("blockUI.isBlocked")) {
				e.each(function (t, e) {
					this.parentNode && this.parentNode.removeChild(this)
				}), i && i.el && (i.el.style.display = i.display, i.el.style.position = i.position, i.el.style.cursor = "default", i.parent && i.parent.appendChild(i.el), o.removeData("blockUI.history")), o.data("blockUI.static") && o.css("position", "static"), "function" == typeof n.onUnblock && n.onUnblock(r, n);
				var a = t(document.body), s = a.width(), l = a[0].style.width;
				a.width(s - 1).width(s), a[0].style.width = l
			}
		}

		function u(e, i, n) {
			var r = i == window, a = t(i);
			if ((e || (!r || o) && (r || a.data("blockUI.isBlocked"))) && (a.data("blockUI.isBlocked", e), r && n.bindEvents && (!e || n.showOverlay))) {
				var s = "mousedown mouseup keydown keypress keyup touchstart touchend touchmove";
				e ? t(document).bind(s, n, h) : t(document).unbind(s, h)
			}
		}

		function h(e) {
			if ("keydown" === e.type && e.keyCode && 9 == e.keyCode && o && e.data.constrainTabKey) {
				var i = a, n = !e.shiftKey && e.target === i[i.length - 1], r = e.shiftKey && e.target === i[0];
				if (n || r) return setTimeout(function () {
					d(r)
				}, 10), !1
			}
			var s = e.data, l = t(e.target);
			return l.hasClass("blockOverlay") && s.onOverlayClick && s.onOverlayClick(e), l.parents("div." + s.blockMsgClass).length > 0 || 0 === l.parents().children().filter("div.blockUI").length
		}

		function d(t) {
			if (a) {
				var e = a[!0 === t ? a.length - 1 : 0];
				e && e.focus()
			}
		}

		function p(e, i) {
			return parseInt(t.css(e, i), 10) || 0
		}
	}

	"function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? t(require("jquery")) : t(jQuery)
}(), function (t) {
	"function" == typeof define && define.amd ? define(["jquery"], t) : t("object" == typeof exports ? require("jquery") : jQuery)
}(function (t, e) {
	function i() {
		return new Date(Date.UTC.apply(Date, arguments))
	}

	function n() {
		var t = new Date;
		return i(t.getFullYear(), t.getMonth(), t.getDate())
	}

	function r(t, e) {
		return t.getUTCFullYear() === e.getUTCFullYear() && t.getUTCMonth() === e.getUTCMonth() && t.getUTCDate() === e.getUTCDate()
	}

	function o(i, n) {
		return function () {
			return n !== e && t.fn.datepicker.deprecated(n), this[i].apply(this, arguments)
		}
	}

	function a(e) {
		var i = {};
		if (f[e] || (e = e.split("-")[0], f[e])) {
			var n = f[e];
			return t.each(p, function (t, e) {
				e in n && (i[e] = n[e])
			}), i
		}
	}

	var s = function () {
		var e = {
			get: function (t) {
				return this.slice(t)[0]
			}, contains: function (t) {
				for (var e = t && t.valueOf(), i = 0, n = this.length; i < n; i++) if (0 <= this[i].valueOf() - e && this[i].valueOf() - e < 864e5) return i;
				return -1
			}, remove: function (t) {
				this.splice(t, 1)
			}, replace: function (e) {
				e && (t.isArray(e) || (e = [e]), this.clear(), this.push.apply(this, e))
			}, clear: function () {
				this.length = 0
			}, copy: function () {
				var t = new s;
				return t.replace(this), t
			}
		};
		return function () {
			var i = [];
			return i.push.apply(i, arguments), t.extend(i, e), i
		}
	}(), l = function (e, i) {
		t.data(e, "datepicker", this), this._process_options(i), this.dates = new s, this.viewDate = this.o.defaultViewDate, this.focusDate = null, this.element = t(e), this.isInput = this.element.is("input"), this.inputField = this.isInput ? this.element : this.element.find("input"), this.component = !!this.element.hasClass("date") && this.element.find(".add-on, .input-group-addon, .btn"), this.component && 0 === this.component.length && (this.component = !1), this.isInline = !this.component && this.element.is("div"), this.picker = t(m.template), this._check_template(this.o.templates.leftArrow) && this.picker.find(".prev").html(this.o.templates.leftArrow), this._check_template(this.o.templates.rightArrow) && this.picker.find(".next").html(this.o.templates.rightArrow), this._buildEvents(), this._attachEvents(), this.isInline ? this.picker.addClass("datepicker-inline").appendTo(this.element) : this.picker.addClass("datepicker-dropdown dropdown-menu"), this.o.rtl && this.picker.addClass("datepicker-rtl"), this.o.calendarWeeks && this.picker.find(".datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan", function (t, e) {
			return Number(e) + 1
		}), this._process_options({
			startDate: this._o.startDate,
			endDate: this._o.endDate,
			daysOfWeekDisabled: this.o.daysOfWeekDisabled,
			daysOfWeekHighlighted: this.o.daysOfWeekHighlighted,
			datesDisabled: this.o.datesDisabled
		}), this._allow_update = !1, this.setViewMode(this.o.startView), this._allow_update = !0, this.fillDow(), this.fillMonths(), this.update(), this.isInline && this.show()
	};
	l.prototype = {
		constructor: l, _resolveViewName: function (e) {
			return t.each(m.viewModes, function (i, n) {
				if (e === i || -1 !== t.inArray(e, n.names)) return e = i, !1
			}), e
		}, _resolveDaysOfWeek: function (e) {
			return t.isArray(e) || (e = e.split(/[,\s]*/)), t.map(e, Number)
		}, _check_template: function (i) {
			try {
				return i !== e && "" !== i && ((i.match(/[<>]/g) || []).length <= 0 || t(i).length > 0)
			} catch (t) {
				return !1
			}
		}, _process_options: function (e) {
			this._o = t.extend({}, this._o, e);
			var r = this.o = t.extend({}, this._o), o = r.language;
			f[o] || (o = o.split("-")[0], f[o] || (o = d.language)), r.language = o, r.startView = this._resolveViewName(r.startView), r.minViewMode = this._resolveViewName(r.minViewMode), r.maxViewMode = this._resolveViewName(r.maxViewMode), r.startView = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, r.startView)), !0 !== r.multidate && (r.multidate = Number(r.multidate) || !1, !1 !== r.multidate && (r.multidate = Math.max(0, r.multidate))), r.multidateSeparator = String(r.multidateSeparator), r.weekStart %= 7, r.weekEnd = (r.weekStart + 6) % 7;
			var a = m.parseFormat(r.format);
			r.startDate !== -1 / 0 && (r.startDate ? r.startDate instanceof Date ? r.startDate = this._local_to_utc(this._zero_time(r.startDate)) : r.startDate = m.parseDate(r.startDate, a, r.language, r.assumeNearbyYear) : r.startDate = -1 / 0), r.endDate !== 1 / 0 && (r.endDate ? r.endDate instanceof Date ? r.endDate = this._local_to_utc(this._zero_time(r.endDate)) : r.endDate = m.parseDate(r.endDate, a, r.language, r.assumeNearbyYear) : r.endDate = 1 / 0), r.daysOfWeekDisabled = this._resolveDaysOfWeek(r.daysOfWeekDisabled || []), r.daysOfWeekHighlighted = this._resolveDaysOfWeek(r.daysOfWeekHighlighted || []), r.datesDisabled = r.datesDisabled || [], t.isArray(r.datesDisabled) || (r.datesDisabled = r.datesDisabled.split(",")), r.datesDisabled = t.map(r.datesDisabled, function (t) {
				return m.parseDate(t, a, r.language, r.assumeNearbyYear)
			});
			var s = String(r.orientation).toLowerCase().split(/\s+/g), l = r.orientation.toLowerCase();
			if (s = t.grep(s, function (t) {
				return /^auto|left|right|top|bottom$/.test(t)
			}), r.orientation = {x: "auto", y: "auto"}, l && "auto" !== l) if (1 === s.length) switch (s[0]) {
				case"top":
				case"bottom":
					r.orientation.y = s[0];
					break;
				case"left":
				case"right":
					r.orientation.x = s[0]
			} else l = t.grep(s, function (t) {
				return /^left|right$/.test(t)
			}), r.orientation.x = l[0] || "auto", l = t.grep(s, function (t) {
				return /^top|bottom$/.test(t)
			}), r.orientation.y = l[0] || "auto";
			if (r.defaultViewDate instanceof Date || "string" == typeof r.defaultViewDate) r.defaultViewDate = m.parseDate(r.defaultViewDate, a, r.language, r.assumeNearbyYear); else if (r.defaultViewDate) {
				var c = r.defaultViewDate.year || (new Date).getFullYear(), u = r.defaultViewDate.month || 0, h = r.defaultViewDate.day || 1;
				r.defaultViewDate = i(c, u, h)
			} else r.defaultViewDate = n()
		}, _events: [], _secondaryEvents: [], _applyEvents: function (t) {
			for (var i, n, r, o = 0; o < t.length; o++) i = t[o][0], 2 === t[o].length ? (n = e, r = t[o][1]) : 3 === t[o].length && (n = t[o][1], r = t[o][2]), i.on(r, n)
		}, _unapplyEvents: function (t) {
			for (var i, n, r, o = 0; o < t.length; o++) i = t[o][0], 2 === t[o].length ? (r = e, n = t[o][1]) : 3 === t[o].length && (r = t[o][1], n = t[o][2]), i.off(n, r)
		}, _buildEvents: function () {
			var e = {
				keyup: t.proxy(function (e) {
					-1 === t.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) && this.update()
				}, this), keydown: t.proxy(this.keydown, this), paste: t.proxy(this.paste, this)
			};
			!0 === this.o.showOnFocus && (e.focus = t.proxy(this.show, this)), this.isInput ? this._events = [[this.element, e]] : this.component && this.inputField.length ? this._events = [[this.inputField, e], [this.component, {click: t.proxy(this.show, this)}]] : this._events = [[this.element, {
				click: t.proxy(this.show, this),
				keydown: t.proxy(this.keydown, this)
			}]], this._events.push([this.element, "*", {
				blur: t.proxy(function (t) {
					this._focused_from = t.target
				}, this)
			}], [this.element, {
				blur: t.proxy(function (t) {
					this._focused_from = t.target
				}, this)
			}]), this.o.immediateUpdates && this._events.push([this.element, {
				"changeYear changeMonth": t.proxy(function (t) {
					this.update(t.date)
				}, this)
			}]), this._secondaryEvents = [[this.picker, {click: t.proxy(this.click, this)}], [this.picker, ".prev, .next", {click: t.proxy(this.navArrowsClick, this)}], [this.picker, ".day:not(.disabled)", {click: t.proxy(this.dayCellClick, this)}], [t(window), {resize: t.proxy(this.place, this)}], [t(document), {
				"mousedown touchstart": t.proxy(function (t) {
					this.element.is(t.target) || this.element.find(t.target).length || this.picker.is(t.target) || this.picker.find(t.target).length || this.isInline || this.hide()
				}, this)
			}]]
		}, _attachEvents: function () {
			this._detachEvents(), this._applyEvents(this._events)
		}, _detachEvents: function () {
			this._unapplyEvents(this._events)
		}, _attachSecondaryEvents: function () {
			this._detachSecondaryEvents(), this._applyEvents(this._secondaryEvents)
		}, _detachSecondaryEvents: function () {
			this._unapplyEvents(this._secondaryEvents)
		}, _trigger: function (e, i) {
			var n = i || this.dates.get(-1), r = this._utc_to_local(n);
			this.element.trigger({
				type: e, date: r, viewMode: this.viewMode, dates: t.map(this.dates, this._utc_to_local), format: t.proxy(function (t, e) {
					0 === arguments.length ? (t = this.dates.length - 1, e = this.o.format) : "string" == typeof t && (e = t, t = this.dates.length - 1), e = e || this.o.format;
					var i = this.dates.get(t);
					return m.formatDate(i, e, this.o.language)
				}, this)
			})
		}, show: function () {
			if (!(this.inputField.prop("disabled") || this.inputField.prop("readonly") && !1 === this.o.enableOnReadonly)) return this.isInline || this.picker.appendTo(this.o.container), this.place(), this.picker.show(), this._attachSecondaryEvents(), this._trigger("show"), (window.navigator.msMaxTouchPoints || "ontouchstart" in document) && this.o.disableTouchKeyboard && t(this.element).blur(), this
		}, hide: function () {
			return this.isInline || !this.picker.is(":visible") ? this : (this.focusDate = null, this.picker.hide().detach(), this._detachSecondaryEvents(), this.setViewMode(this.o.startView), this.o.forceParse && this.inputField.val() && this.setValue(), this._trigger("hide"), this)
		}, destroy: function () {
			return this.hide(), this._detachEvents(), this._detachSecondaryEvents(), this.picker.remove(), delete this.element.data().datepicker, this.isInput || delete this.element.data().date, this
		}, paste: function (e) {
			var i;
			if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.types && -1 !== t.inArray("text/plain", e.originalEvent.clipboardData.types)) i = e.originalEvent.clipboardData.getData("text/plain"); else {
				if (!window.clipboardData) return;
				i = window.clipboardData.getData("Text")
			}
			this.setDate(i), this.update(), e.preventDefault()
		}, _utc_to_local: function (t) {
			if (!t) return t;
			var e = new Date(t.getTime() + 6e4 * t.getTimezoneOffset());
			return e.getTimezoneOffset() !== t.getTimezoneOffset() && (e = new Date(t.getTime() + 6e4 * e.getTimezoneOffset())), e
		}, _local_to_utc: function (t) {
			return t && new Date(t.getTime() - 6e4 * t.getTimezoneOffset())
		}, _zero_time: function (t) {
			return t && new Date(t.getFullYear(), t.getMonth(), t.getDate())
		}, _zero_utc_time: function (t) {
			return t && i(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate())
		}, getDates: function () {
			return t.map(this.dates, this._utc_to_local)
		}, getUTCDates: function () {
			return t.map(this.dates, function (t) {
				return new Date(t)
			})
		}, getDate: function () {
			return this._utc_to_local(this.getUTCDate())
		}, getUTCDate: function () {
			var t = this.dates.get(-1);
			return t !== e ? new Date(t) : null
		}, clearDates: function () {
			this.inputField.val(""), this.update(), this._trigger("changeDate"), this.o.autoclose && this.hide()
		}, setDates: function () {
			var e = t.isArray(arguments[0]) ? arguments[0] : arguments;
			return this.update.apply(this, e), this._trigger("changeDate"), this.setValue(), this
		}, setUTCDates: function () {
			var e = t.isArray(arguments[0]) ? arguments[0] : arguments;
			return this.setDates.apply(this, t.map(e, this._utc_to_local)), this
		}, setDate: o("setDates"), setUTCDate: o("setUTCDates"), remove: o("destroy", "Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead"), setValue: function () {
			var t = this.getFormattedDate();
			return this.inputField.val(t), this
		}, getFormattedDate: function (i) {
			i === e && (i = this.o.format);
			var n = this.o.language;
			return t.map(this.dates, function (t) {
				return m.formatDate(t, i, n)
			}).join(this.o.multidateSeparator)
		}, getStartDate: function () {
			return this.o.startDate
		}, setStartDate: function (t) {
			return this._process_options({startDate: t}), this.update(), this.updateNavArrows(), this
		}, getEndDate: function () {
			return this.o.endDate
		}, setEndDate: function (t) {
			return this._process_options({endDate: t}), this.update(), this.updateNavArrows(), this
		}, setDaysOfWeekDisabled: function (t) {
			return this._process_options({daysOfWeekDisabled: t}), this.update(), this
		}, setDaysOfWeekHighlighted: function (t) {
			return this._process_options({daysOfWeekHighlighted: t}), this.update(), this
		}, setDatesDisabled: function (t) {
			return this._process_options({datesDisabled: t}), this.update(), this
		}, place: function () {
			if (this.isInline) return this;
			var e = this.picker.outerWidth(), i = this.picker.outerHeight(), n = t(this.o.container), r = n.width(), o = "body" === this.o.container ? t(document).scrollTop() : n.scrollTop(), a = n.offset(), s = [0];
			this.element.parents().each(function () {
				var e = t(this).css("z-index");
				"auto" !== e && 0 !== Number(e) && s.push(Number(e))
			});
			var l = Math.max.apply(Math, s) + this.o.zIndexOffset, c = this.component ? this.component.parent().offset() : this.element.offset(), u = this.component ? this.component.outerHeight(!0) : this.element.outerHeight(!1),
				h = this.component ? this.component.outerWidth(!0) : this.element.outerWidth(!1), d = c.left - a.left, p = c.top - a.top;
			"body" !== this.o.container && (p += o), this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"), "auto" !== this.o.orientation.x ? (this.picker.addClass("datepicker-orient-" + this.o.orientation.x), "right" === this.o.orientation.x && (d -= e - h)) : c.left < 0 ? (this.picker.addClass("datepicker-orient-left"), d -= c.left - 10) : d + e > r ? (this.picker.addClass("datepicker-orient-right"), d += h - e) : this.o.rtl ? this.picker.addClass("datepicker-orient-right") : this.picker.addClass("datepicker-orient-left");
			var f = this.o.orientation.y;
			if ("auto" === f && (f = -o + p - i < 0 ? "bottom" : "top"), this.picker.addClass("datepicker-orient-" + f), "top" === f ? p -= i + parseInt(this.picker.css("padding-top")) : p += u, this.o.rtl) {
				var m = r - (d + h);
				this.picker.css({top: p, right: m, zIndex: l})
			} else this.picker.css({top: p, left: d, zIndex: l});
			return this
		}, _allow_update: !0, update: function () {
			if (!this._allow_update) return this;
			var e = this.dates.copy(), i = [], n = !1;
			return arguments.length ? (t.each(arguments, t.proxy(function (t, e) {
				e instanceof Date && (e = this._local_to_utc(e)), i.push(e)
			}, this)), n = !0) : (i = (i = this.isInput ? this.element.val() : this.element.data("date") || this.inputField.val()) && this.o.multidate ? i.split(this.o.multidateSeparator) : [i], delete this.element.data().date), i = t.map(i, t.proxy(function (t) {
				return m.parseDate(t, this.o.format, this.o.language, this.o.assumeNearbyYear)
			}, this)), i = t.grep(i, t.proxy(function (t) {
				return !this.dateWithinRange(t) || !t
			}, this), !0), this.dates.replace(i), this.o.updateViewDate && (this.dates.length ? this.viewDate = new Date(this.dates.get(-1)) : this.viewDate < this.o.startDate ? this.viewDate = new Date(this.o.startDate) : this.viewDate > this.o.endDate ? this.viewDate = new Date(this.o.endDate) : this.viewDate = this.o.defaultViewDate), n ? (this.setValue(), this.element.change()) : this.dates.length && String(e) !== String(this.dates) && n && (this._trigger("changeDate"), this.element.change()), !this.dates.length && e.length && (this._trigger("clearDate"), this.element.change()), this.fill(), this
		}, fillDow: function () {
			if (this.o.showWeekDays) {
				var e = this.o.weekStart, i = "<tr>";
				for (this.o.calendarWeeks && (i += '<th class="cw">&#160;</th>'); e < this.o.weekStart + 7;) i += '<th class="dow', -1 !== t.inArray(e, this.o.daysOfWeekDisabled) && (i += " disabled"), i += '">' + f[this.o.language].daysMin[e++ % 7] + "</th>";
				i += "</tr>", this.picker.find(".datepicker-days thead").append(i)
			}
		}, fillMonths: function () {
			for (var t = this._utc_to_local(this.viewDate), e = "", i = 0; i < 12; i++) e += '<span class="month' + (t && t.getMonth() === i ? " focused" : "") + '">' + f[this.o.language].monthsShort[i] + "</span>";
			this.picker.find(".datepicker-months td").html(e)
		}, setRange: function (e) {
			e && e.length ? this.range = t.map(e, function (t) {
				return t.valueOf()
			}) : delete this.range, this.fill()
		}, getClassNames: function (e) {
			var i = [], o = this.viewDate.getUTCFullYear(), a = this.viewDate.getUTCMonth(), s = n();
			return e.getUTCFullYear() < o || e.getUTCFullYear() === o && e.getUTCMonth() < a ? i.push("old") : (e.getUTCFullYear() > o || e.getUTCFullYear() === o && e.getUTCMonth() > a) && i.push("new"), this.focusDate && e.valueOf() === this.focusDate.valueOf() && i.push("focused"), this.o.todayHighlight && r(e, s) && i.push("today"), -1 !== this.dates.contains(e) && i.push("active"), this.dateWithinRange(e) || i.push("disabled"), this.dateIsDisabled(e) && i.push("disabled", "disabled-date"), -1 !== t.inArray(e.getUTCDay(), this.o.daysOfWeekHighlighted) && i.push("highlighted"), this.range && (e > this.range[0] && e < this.range[this.range.length - 1] && i.push("range"), -1 !== t.inArray(e.valueOf(), this.range) && i.push("selected"), e.valueOf() === this.range[0] && i.push("range-start"), e.valueOf() === this.range[this.range.length - 1] && i.push("range-end")), i
		}, _fill_yearsView: function (i, n, r, o, a, s, l) {
			for (var c, u, h, d = "", p = r / 10, f = this.picker.find(i), m = Math.floor(o / r) * r, g = m + 9 * p, v = Math.floor(this.viewDate.getFullYear() / p) * p, y = t.map(this.dates, function (t) {
				return Math.floor(t.getUTCFullYear() / p) * p
			}), b = m - p; b <= g + p; b += p) c = [n], u = null, b === m - p ? c.push("old") : b === g + p && c.push("new"), -1 !== t.inArray(b, y) && c.push("active"), (b < a || b > s) && c.push("disabled"), b === v && c.push("focused"), l !== t.noop && ((h = l(new Date(b, 0, 1))) === e ? h = {} : "boolean" == typeof h ? h = {enabled: h} : "string" == typeof h && (h = {classes: h}), !1 === h.enabled && c.push("disabled"), h.classes && (c = c.concat(h.classes.split(/\s+/))), h.tooltip && (u = h.tooltip)), d += '<span class="' + c.join(" ") + '"' + (u ? ' title="' + u + '"' : "") + ">" + b + "</span>";
			f.find(".datepicker-switch").text(m + "-" + g), f.find("td").html(d)
		}, fill: function () {
			var n, r, o = new Date(this.viewDate), a = o.getUTCFullYear(), s = o.getUTCMonth(), l = this.o.startDate !== -1 / 0 ? this.o.startDate.getUTCFullYear() : -1 / 0, c = this.o.startDate !== -1 / 0 ? this.o.startDate.getUTCMonth() : -1 / 0,
				u = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCFullYear() : 1 / 0, h = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCMonth() : 1 / 0, d = f[this.o.language].today || f.en.today || "", p = f[this.o.language].clear || f.en.clear || "",
				g = f[this.o.language].titleFormat || f.en.titleFormat;
			if (!isNaN(a) && !isNaN(s)) {
				this.picker.find(".datepicker-days .datepicker-switch").text(m.formatDate(o, g, this.o.language)), this.picker.find("tfoot .today").text(d).css("display", !0 === this.o.todayBtn || "linked" === this.o.todayBtn ? "table-cell" : "none"), this.picker.find("tfoot .clear").text(p).css("display", !0 === this.o.clearBtn ? "table-cell" : "none"), this.picker.find("thead .datepicker-title").text(this.o.title).css("display", "string" == typeof this.o.title && "" !== this.o.title ? "table-cell" : "none"), this.updateNavArrows(), this.fillMonths();
				var v = i(a, s, 0), y = v.getUTCDate();
				v.setUTCDate(y - (v.getUTCDay() - this.o.weekStart + 7) % 7);
				var b = new Date(v);
				v.getUTCFullYear() < 100 && b.setUTCFullYear(v.getUTCFullYear()), b.setUTCDate(b.getUTCDate() + 42), b = b.valueOf();
				for (var w, x, k = []; v.valueOf() < b;) {
					if ((w = v.getUTCDay()) === this.o.weekStart && (k.push("<tr>"), this.o.calendarWeeks)) {
						var _ = new Date(+v + (this.o.weekStart - w - 7) % 7 * 864e5), S = new Date(Number(_) + (11 - _.getUTCDay()) % 7 * 864e5), C = new Date(Number(C = i(S.getUTCFullYear(), 0, 1)) + (11 - C.getUTCDay()) % 7 * 864e5), D = (S - C) / 864e5 / 7 + 1;
						k.push('<td class="cw">' + D + "</td>")
					}
					(x = this.getClassNames(v)).push("day");
					var T = v.getUTCDate();
					this.o.beforeShowDay !== t.noop && ((r = this.o.beforeShowDay(this._utc_to_local(v))) === e ? r = {} : "boolean" == typeof r ? r = {enabled: r} : "string" == typeof r && (r = {classes: r}), !1 === r.enabled && x.push("disabled"), r.classes && (x = x.concat(r.classes.split(/\s+/))), r.tooltip && (n = r.tooltip), r.content && (T = r.content)), x = t.isFunction(t.uniqueSort) ? t.uniqueSort(x) : t.unique(x), k.push('<td class="' + x.join(" ") + '"' + (n ? ' title="' + n + '"' : "") + ' data-date="' + v.getTime().toString() + '">' + T + "</td>"), n = null, w === this.o.weekEnd && k.push("</tr>"), v.setUTCDate(v.getUTCDate() + 1)
				}
				this.picker.find(".datepicker-days tbody").html(k.join(""));
				var M = f[this.o.language].monthsTitle || f.en.monthsTitle || "Months", E = this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode < 2 ? M : a).end().find("tbody span").removeClass("active");
				if (t.each(this.dates, function (t, e) {
					e.getUTCFullYear() === a && E.eq(e.getUTCMonth()).addClass("active")
				}), (a < l || a > u) && E.addClass("disabled"), a === l && E.slice(0, c).addClass("disabled"), a === u && E.slice(h + 1).addClass("disabled"), this.o.beforeShowMonth !== t.noop) {
					var A = this;
					t.each(E, function (i, n) {
						var r = new Date(a, i, 1), o = A.o.beforeShowMonth(r);
						o === e ? o = {} : "boolean" == typeof o ? o = {enabled: o} : "string" == typeof o && (o = {classes: o}), !1 !== o.enabled || t(n).hasClass("disabled") || t(n).addClass("disabled"), o.classes && t(n).addClass(o.classes), o.tooltip && t(n).prop("title", o.tooltip)
					})
				}
				this._fill_yearsView(".datepicker-years", "year", 10, a, l, u, this.o.beforeShowYear), this._fill_yearsView(".datepicker-decades", "decade", 100, a, l, u, this.o.beforeShowDecade), this._fill_yearsView(".datepicker-centuries", "century", 1e3, a, l, u, this.o.beforeShowCentury)
			}
		}, updateNavArrows: function () {
			if (this._allow_update) {
				var t, e, i = new Date(this.viewDate), n = i.getUTCFullYear(), r = i.getUTCMonth(), o = this.o.startDate !== -1 / 0 ? this.o.startDate.getUTCFullYear() : -1 / 0, a = this.o.startDate !== -1 / 0 ? this.o.startDate.getUTCMonth() : -1 / 0,
					s = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCFullYear() : 1 / 0, l = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCMonth() : 1 / 0, c = 1;
				switch (this.viewMode) {
					case 4:
						c *= 10;
					case 3:
						c *= 10;
					case 2:
						c *= 10;
					case 1:
						t = Math.floor(n / c) * c < o, e = Math.floor(n / c) * c + c > s;
						break;
					case 0:
						t = n <= o && r < a, e = n >= s && r > l
				}
				this.picker.find(".prev").toggleClass("disabled", t), this.picker.find(".next").toggleClass("disabled", e)
			}
		}, click: function (e) {
			var r, o, a;
			e.preventDefault(), e.stopPropagation(), (r = t(e.target)).hasClass("datepicker-switch") && this.viewMode !== this.o.maxViewMode && this.setViewMode(this.viewMode + 1), r.hasClass("today") && !r.hasClass("day") && (this.setViewMode(0), this._setDate(n(), "linked" === this.o.todayBtn ? null : "view")), r.hasClass("clear") && this.clearDates(), r.hasClass("disabled") || (r.hasClass("month") || r.hasClass("year") || r.hasClass("decade") || r.hasClass("century")) && (this.viewDate.setUTCDate(1), 1, 1 === this.viewMode ? (a = r.parent().find("span").index(r), o = this.viewDate.getUTCFullYear(), this.viewDate.setUTCMonth(a)) : (a = 0, o = Number(r.text()), this.viewDate.setUTCFullYear(o)), this._trigger(m.viewModes[this.viewMode - 1].e, this.viewDate), this.viewMode === this.o.minViewMode ? this._setDate(i(o, a, 1)) : (this.setViewMode(this.viewMode - 1), this.fill())), this.picker.is(":visible") && this._focused_from && this._focused_from.focus(), delete this._focused_from
		}, dayCellClick: function (e) {
			var i = t(e.currentTarget).data("date"), n = new Date(i);
			this.o.updateViewDate && (n.getUTCFullYear() !== this.viewDate.getUTCFullYear() && this._trigger("changeYear", this.viewDate), n.getUTCMonth() !== this.viewDate.getUTCMonth() && this._trigger("changeMonth", this.viewDate)), this._setDate(n)
		}, navArrowsClick: function (e) {
			var i = t(e.currentTarget).hasClass("prev") ? -1 : 1;
			0 !== this.viewMode && (i *= 12 * m.viewModes[this.viewMode].navStep), this.viewDate = this.moveMonth(this.viewDate, i), this._trigger(m.viewModes[this.viewMode].e, this.viewDate), this.fill()
		}, _toggle_multidate: function (t) {
			var e = this.dates.contains(t);
			if (t || this.dates.clear(), -1 !== e ? (!0 === this.o.multidate || this.o.multidate > 1 || this.o.toggleActive) && this.dates.remove(e) : !1 === this.o.multidate ? (this.dates.clear(), this.dates.push(t)) : this.dates.push(t), "number" == typeof this.o.multidate) for (; this.dates.length > this.o.multidate;) this.dates.remove(0)
		}, _setDate: function (t, e) {
			e && "date" !== e || this._toggle_multidate(t && new Date(t)), (!e && this.o.updateViewDate || "view" === e) && (this.viewDate = t && new Date(t)), this.fill(), this.setValue(), e && "view" === e || this._trigger("changeDate"), this.inputField.trigger("change"), !this.o.autoclose || e && "date" !== e || this.hide()
		}, moveDay: function (t, e) {
			var i = new Date(t);
			return i.setUTCDate(t.getUTCDate() + e), i
		}, moveWeek: function (t, e) {
			return this.moveDay(t, 7 * e)
		}, moveMonth: function (t, e) {
			if (!function (t) {
				return t && !isNaN(t.getTime())
			}(t)) return this.o.defaultViewDate;
			if (!e) return t;
			var i, n, r = new Date(t.valueOf()), o = r.getUTCDate(), a = r.getUTCMonth(), s = Math.abs(e);
			if (e = e > 0 ? 1 : -1, 1 === s) n = -1 === e ? function () {
				return r.getUTCMonth() === a
			} : function () {
				return r.getUTCMonth() !== i
			}, i = a + e, r.setUTCMonth(i), i = (i + 12) % 12; else {
				for (var l = 0; l < s; l++) r = this.moveMonth(r, e);
				i = r.getUTCMonth(), r.setUTCDate(o), n = function () {
					return i !== r.getUTCMonth()
				}
			}
			for (; n();) r.setUTCDate(--o), r.setUTCMonth(i);
			return r
		}, moveYear: function (t, e) {
			return this.moveMonth(t, 12 * e)
		}, moveAvailableDate: function (t, e, i) {
			do {
				if (t = this[i](t, e), !this.dateWithinRange(t)) return !1;
				i = "moveDay"
			} while (this.dateIsDisabled(t));
			return t
		}, weekOfDateIsDisabled: function (e) {
			return -1 !== t.inArray(e.getUTCDay(), this.o.daysOfWeekDisabled)
		}, dateIsDisabled: function (e) {
			return this.weekOfDateIsDisabled(e) || t.grep(this.o.datesDisabled, function (t) {
				return r(e, t)
			}).length > 0
		}, dateWithinRange: function (t) {
			return t >= this.o.startDate && t <= this.o.endDate
		}, keydown: function (t) {
			if (this.picker.is(":visible")) {
				var e, i, n = !1, r = this.focusDate || this.viewDate;
				switch (t.keyCode) {
					case 27:
						this.focusDate ? (this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill()) : this.hide(), t.preventDefault(), t.stopPropagation();
						break;
					case 37:
					case 38:
					case 39:
					case 40:
						if (!this.o.keyboardNavigation || 7 === this.o.daysOfWeekDisabled.length) break;
						e = 37 === t.keyCode || 38 === t.keyCode ? -1 : 1, 0 === this.viewMode ? t.ctrlKey ? (i = this.moveAvailableDate(r, e, "moveYear")) && this._trigger("changeYear", this.viewDate) : t.shiftKey ? (i = this.moveAvailableDate(r, e, "moveMonth")) && this._trigger("changeMonth", this.viewDate) : 37 === t.keyCode || 39 === t.keyCode ? i = this.moveAvailableDate(r, e, "moveDay") : this.weekOfDateIsDisabled(r) || (i = this.moveAvailableDate(r, e, "moveWeek")) : 1 === this.viewMode ? (38 !== t.keyCode && 40 !== t.keyCode || (e *= 4), i = this.moveAvailableDate(r, e, "moveMonth")) : 2 === this.viewMode && (38 !== t.keyCode && 40 !== t.keyCode || (e *= 4), i = this.moveAvailableDate(r, e, "moveYear")), i && (this.focusDate = this.viewDate = i, this.setValue(), this.fill(), t.preventDefault());
						break;
					case 13:
						if (!this.o.forceParse) break;
						r = this.focusDate || this.dates.get(-1) || this.viewDate, this.o.keyboardNavigation && (this._toggle_multidate(r), n = !0), this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.setValue(), this.fill(), this.picker.is(":visible") && (t.preventDefault(), t.stopPropagation(), this.o.autoclose && this.hide());
						break;
					case 9:
						this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill(), this.hide()
				}
				n && (this.dates.length ? this._trigger("changeDate") : this._trigger("clearDate"), this.inputField.trigger("change"))
			} else 40 !== t.keyCode && 27 !== t.keyCode || (this.show(), t.stopPropagation())
		}, setViewMode: function (t) {
			this.viewMode = t, this.picker.children("div").hide().filter(".datepicker-" + m.viewModes[this.viewMode].clsName).show(), this.updateNavArrows(), this._trigger("changeViewMode", new Date(this.viewDate))
		}
	};
	var c = function (e, i) {
		t.data(e, "datepicker", this), this.element = t(e), this.inputs = t.map(i.inputs, function (t) {
			return t.jquery ? t[0] : t
		}), delete i.inputs, this.keepEmptyValues = i.keepEmptyValues, delete i.keepEmptyValues, h.call(t(this.inputs), i).on("changeDate", t.proxy(this.dateUpdated, this)), this.pickers = t.map(this.inputs, function (e) {
			return t.data(e, "datepicker")
		}), this.updateDates()
	};
	c.prototype = {
		updateDates: function () {
			this.dates = t.map(this.pickers, function (t) {
				return t.getUTCDate()
			}), this.updateRanges()
		}, updateRanges: function () {
			var e = t.map(this.dates, function (t) {
				return t.valueOf()
			});
			t.each(this.pickers, function (t, i) {
				i.setRange(e)
			})
		}, clearDates: function () {
			t.each(this.pickers, function (t, e) {
				e.clearDates()
			})
		}, dateUpdated: function (i) {
			if (!this.updating) {
				this.updating = !0;
				var n = t.data(i.target, "datepicker");
				if (n !== e) {
					var r = n.getUTCDate(), o = this.keepEmptyValues, a = t.inArray(i.target, this.inputs), s = a - 1, l = a + 1, c = this.inputs.length;
					if (-1 !== a) {
						if (t.each(this.pickers, function (t, e) {
							e.getUTCDate() || e !== n && o || e.setUTCDate(r)
						}), r < this.dates[s]) for (; s >= 0 && r < this.dates[s];) this.pickers[s--].setUTCDate(r); else if (r > this.dates[l]) for (; l < c && r > this.dates[l];) this.pickers[l++].setUTCDate(r);
						this.updateDates(), delete this.updating
					}
				}
			}
		}, destroy: function () {
			t.map(this.pickers, function (t) {
				t.destroy()
			}), t(this.inputs).off("changeDate", this.dateUpdated), delete this.element.data().datepicker
		}, remove: o("destroy", "Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead")
	};
	var u = t.fn.datepicker, h = function (i) {
		var n, r = Array.apply(null, arguments);
		if (r.shift(), this.each(function () {
			var e = t(this), o = e.data("datepicker"), s = "object" == typeof i && i;
			if (!o) {
				var u = function (e, i) {
					function n(t, e) {
						return e.toLowerCase()
					}

					var r = t(e).data(), o = {}, a = new RegExp("^" + i.toLowerCase() + "([A-Z])");
					for (var s in i = new RegExp("^" + i.toLowerCase()), r) i.test(s) && (o[s.replace(a, n)] = r[s]);
					return o
				}(this, "date"), h = a(t.extend({}, d, u, s).language), p = t.extend({}, d, h, u, s);
				e.hasClass("input-daterange") || p.inputs ? (t.extend(p, {inputs: p.inputs || e.find("input").toArray()}), o = new c(this, p)) : o = new l(this, p), e.data("datepicker", o)
			}
			"string" == typeof i && "function" == typeof o[i] && (n = o[i].apply(o, r))
		}), n === e || n instanceof l || n instanceof c) return this;
		if (this.length > 1) throw new Error("Using only allowed for the collection of a single element (" + i + " function)");
		return n
	};
	t.fn.datepicker = h;
	var d = t.fn.datepicker.defaults = {
		assumeNearbyYear: !1,
		autoclose: !1,
		beforeShowDay: t.noop,
		beforeShowMonth: t.noop,
		beforeShowYear: t.noop,
		beforeShowDecade: t.noop,
		beforeShowCentury: t.noop,
		calendarWeeks: !1,
		clearBtn: !1,
		toggleActive: !1,
		daysOfWeekDisabled: [],
		daysOfWeekHighlighted: [],
		datesDisabled: [],
		endDate: 1 / 0,
		forceParse: !0,
		format: "mm/dd/yyyy",
		keepEmptyValues: !1,
		keyboardNavigation: !0,
		language: "en",
		minViewMode: 0,
		maxViewMode: 4,
		multidate: !1,
		multidateSeparator: ",",
		orientation: "auto",
		rtl: !1,
		startDate: -1 / 0,
		startView: 0,
		todayBtn: !1,
		todayHighlight: !1,
		updateViewDate: !0,
		weekStart: 0,
		disableTouchKeyboard: !1,
		enableOnReadonly: !0,
		showOnFocus: !0,
		zIndexOffset: 10,
		container: "body",
		immediateUpdates: !1,
		title: "",
		templates: {leftArrow: "&#x00AB;", rightArrow: "&#x00BB;"},
		showWeekDays: !0
	}, p = t.fn.datepicker.locale_opts = ["format", "rtl", "weekStart"];
	t.fn.datepicker.Constructor = l;
	var f = t.fn.datepicker.dates = {
		en: {
			days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
			daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
			months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			today: "Today",
			clear: "Clear",
			titleFormat: "MM yyyy"
		}
	}, m = {
		viewModes: [{names: ["days", "month"], clsName: "days", e: "changeMonth"}, {names: ["months", "year"], clsName: "months", e: "changeYear", navStep: 1}, {names: ["years", "decade"], clsName: "years", e: "changeDecade", navStep: 10}, {
			names: ["decades", "century"],
			clsName: "decades",
			e: "changeCentury",
			navStep: 100
		}, {names: ["centuries", "millennium"], clsName: "centuries", e: "changeMillennium", navStep: 1e3}],
		validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
		nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
		parseFormat: function (t) {
			if ("function" == typeof t.toValue && "function" == typeof t.toDisplay) return t;
			var e = t.replace(this.validParts, "\0").split("\0"), i = t.match(this.validParts);
			if (!e || !e.length || !i || 0 === i.length) throw new Error("Invalid date format.");
			return {separators: e, parts: i}
		},
		parseDate: function (i, r, o, a) {
			function s() {
				var t = this.slice(0, c[d].length), e = c[d].slice(0, t.length);
				return t.toLowerCase() === e.toLowerCase()
			}

			if (!i) return e;
			if (i instanceof Date) return i;
			if ("string" == typeof r && (r = m.parseFormat(r)), r.toValue) return r.toValue(i, r, o);
			var c, u, h, d, p, g = {d: "moveDay", m: "moveMonth", w: "moveWeek", y: "moveYear"}, v = {yesterday: "-1d", today: "+0d", tomorrow: "+1d"};
			if (i in v && (i = v[i]), /^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(i)) {
				for (c = i.match(/([\-+]\d+)([dmwy])/gi), i = new Date, d = 0; d < c.length; d++) u = c[d].match(/([\-+]\d+)([dmwy])/i), h = Number(u[1]), p = g[u[2].toLowerCase()], i = l.prototype[p](i, h);
				return l.prototype._zero_utc_time(i)
			}
			c = i && i.match(this.nonpunctuation) || [];
			var y, b, w = {}, x = ["yyyy", "yy", "M", "MM", "m", "mm", "d", "dd"], k = {
				yyyy: function (t, e) {
					return t.setUTCFullYear(a ? function (t, e) {
						return !0 === e && (e = 10), t < 100 && (t += 2e3) > (new Date).getFullYear() + e && (t -= 100), t
					}(e, a) : e)
				}, m: function (t, e) {
					if (isNaN(t)) return t;
					for (e -= 1; e < 0;) e += 12;
					for (e %= 12, t.setUTCMonth(e); t.getUTCMonth() !== e;) t.setUTCDate(t.getUTCDate() - 1);
					return t
				}, d: function (t, e) {
					return t.setUTCDate(e)
				}
			};
			k.yy = k.yyyy, k.M = k.MM = k.mm = k.m, k.dd = k.d, i = n();
			var _ = r.parts.slice();
			if (c.length !== _.length && (_ = t(_).filter(function (e, i) {
				return -1 !== t.inArray(i, x)
			}).toArray()), c.length === _.length) {
				var S, C, D;
				for (d = 0, S = _.length; d < S; d++) {
					if (y = parseInt(c[d], 10), u = _[d], isNaN(y)) switch (u) {
						case"MM":
							b = t(f[o].months).filter(s), y = t.inArray(b[0], f[o].months) + 1;
							break;
						case"M":
							b = t(f[o].monthsShort).filter(s), y = t.inArray(b[0], f[o].monthsShort) + 1
					}
					w[u] = y
				}
				for (d = 0; d < x.length; d++) (D = x[d]) in w && !isNaN(w[D]) && (C = new Date(i), k[D](C, w[D]), isNaN(C) || (i = C))
			}
			return i
		},
		formatDate: function (e, i, n) {
			if (!e) return "";
			if ("string" == typeof i && (i = m.parseFormat(i)), i.toDisplay) return i.toDisplay(e, i, n);
			var r = {d: e.getUTCDate(), D: f[n].daysShort[e.getUTCDay()], DD: f[n].days[e.getUTCDay()], m: e.getUTCMonth() + 1, M: f[n].monthsShort[e.getUTCMonth()], MM: f[n].months[e.getUTCMonth()], yy: e.getUTCFullYear().toString().substring(2), yyyy: e.getUTCFullYear()};
			r.dd = (r.d < 10 ? "0" : "") + r.d, r.mm = (r.m < 10 ? "0" : "") + r.m, e = [];
			for (var o = t.extend([], i.separators), a = 0, s = i.parts.length; a <= s; a++) o.length && e.push(o.shift()), e.push(r[i.parts[a]]);
			return e.join("")
		},
		headTemplate: '<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">' + d.templates.leftArrow + '</th><th colspan="5" class="datepicker-switch"></th><th class="next">' + d.templates.rightArrow + "</th></tr></thead>",
		contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
		footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'
	};
	m.template = '<div class="datepicker"><div class="datepicker-days"><table class="table-condensed">' + m.headTemplate + "<tbody></tbody>" + m.footTemplate + '</table></div><div class="datepicker-months"><table class="table-condensed">' + m.headTemplate + m.contTemplate + m.footTemplate + '</table></div><div class="datepicker-years"><table class="table-condensed">' + m.headTemplate + m.contTemplate + m.footTemplate + '</table></div><div class="datepicker-decades"><table class="table-condensed">' + m.headTemplate + m.contTemplate + m.footTemplate + '</table></div><div class="datepicker-centuries"><table class="table-condensed">' + m.headTemplate + m.contTemplate + m.footTemplate + "</table></div></div>", t.fn.datepicker.DPGlobal = m, t.fn.datepicker.noConflict = function () {
		return t.fn.datepicker = u, this
	}, t.fn.datepicker.version = "1.8.0", t.fn.datepicker.deprecated = function (t) {
		var e = window.console;
		e && e.warn && e.warn("DEPRECATED: " + t)
	}, t(document).on("focus.datepicker.data-api click.datepicker.data-api", '[data-provide="datepicker"]', function (e) {
		var i = t(this);
		i.data("datepicker") || (e.preventDefault(), h.call(i, "show"))
	}), t(function () {
		h.call(t('[data-provide="datepicker-inline"]'))
	})
}), $.fn.datepicker.defaults.zIndexOffset = 10, function (t) {
	"function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? t(require("jquery")) : t(jQuery)
}(function (t, e) {
	function i() {
		return new Date(Date.UTC.apply(Date, arguments))
	}

	"indexOf" in Array.prototype || (Array.prototype.indexOf = function (t, i) {
		i === e && (i = 0), i < 0 && (i += this.length), i < 0 && (i = 0);
		for (var n = this.length; i < n; i++) if (i in this && this[i] === t) return i;
		return -1
	});
	var n = function (i, n) {
		var r = this;
		this.element = t(i), this.container = n.container || "body", this.language = n.language || this.element.data("date-language") || "en", this.language = this.language in o ? this.language : this.language.split("-")[0], this.language = this.language in o ? this.language : "en", this.isRTL = o[this.language].rtl || !1, this.formatType = n.formatType || this.element.data("format-type") || "standard", this.format = a.parseFormat(n.format || this.element.data("date-format") || o[this.language].format || a.getDefaultFormat(this.formatType, "input"), this.formatType), this.isInline = !1, this.isVisible = !1, this.isInput = this.element.is("input"), this.fontAwesome = n.fontAwesome || this.element.data("font-awesome") || !1, this.bootcssVer = n.bootcssVer || (this.isInput ? this.element.is(".form-control") ? 3 : 2 : this.bootcssVer = this.element.is(".input-group") ? 3 : 2), this.component = !!this.element.is(".date") && (3 === this.bootcssVer ? this.element.find(".input-group-addon .glyphicon-th, .input-group-addon .glyphicon-time, .input-group-addon .glyphicon-remove, .input-group-addon .glyphicon-calendar, .input-group-addon .fa-calendar, .input-group-addon .fa-clock-o").parent() : this.element.find(".add-on .icon-th, .add-on .icon-time, .add-on .icon-calendar, .add-on .fa-calendar, .add-on .fa-clock-o").parent()), this.componentReset = !!this.element.is(".date") && (3 === this.bootcssVer ? this.element.find(".input-group-addon .glyphicon-remove, .input-group-addon .fa-times").parent() : this.element.find(".add-on .icon-remove, .add-on .fa-times").parent()), this.hasInput = this.component && this.element.find("input").length, this.component && 0 === this.component.length && (this.component = !1), this.linkField = n.linkField || this.element.data("link-field") || !1, this.linkFormat = a.parseFormat(n.linkFormat || this.element.data("link-format") || a.getDefaultFormat(this.formatType, "link"), this.formatType), this.minuteStep = n.minuteStep || this.element.data("minute-step") || 5, this.pickerPosition = n.pickerPosition || this.element.data("picker-position") || "bottom-right", this.showMeridian = n.showMeridian || this.element.data("show-meridian") || !1, this.initialDate = n.initialDate || new Date, this.zIndex = n.zIndex || this.element.data("z-index") || e, this.title = void 0 !== n.title && n.title, this.timezone = n.timezone || function () {
			var t, e, i, n, r;
			if ((i = (null != (r = (e = (new Date).toString()).split("(")[1]) ? r.slice(0, -1) : 0) || e.split(" ")) instanceof Array) {
				n = [];
				for (var o = 0, a = i.length; o < a; o++) (t = null !== (r = i[o].match(/\b[A-Z]+\b/))) && r[0] && n.push(t);
				i = n.pop()
			}
			return i
		}(), this.icons = {
			leftArrow: this.fontAwesome ? "fa-arrow-left" : 3 === this.bootcssVer ? "glyphicon-arrow-left" : "icon-arrow-left",
			rightArrow: this.fontAwesome ? "fa-arrow-right" : 3 === this.bootcssVer ? "glyphicon-arrow-right" : "icon-arrow-right"
		}, this.icontype = this.fontAwesome ? "fa" : "glyphicon", this._attachEvents(), this.clickedOutside = function (e) {
			0 === t(e.target).closest(".datetimepicker").length && r.hide()
		}, this.formatViewType = "datetime", "formatViewType" in n ? this.formatViewType = n.formatViewType : "formatViewType" in this.element.data() && (this.formatViewType = this.element.data("formatViewType")), this.minView = 0, "minView" in n ? this.minView = n.minView : "minView" in this.element.data() && (this.minView = this.element.data("min-view")), this.minView = a.convertViewMode(this.minView), this.maxView = a.modes.length - 1, "maxView" in n ? this.maxView = n.maxView : "maxView" in this.element.data() && (this.maxView = this.element.data("max-view")), this.maxView = a.convertViewMode(this.maxView), this.wheelViewModeNavigation = !1, "wheelViewModeNavigation" in n ? this.wheelViewModeNavigation = n.wheelViewModeNavigation : "wheelViewModeNavigation" in this.element.data() && (this.wheelViewModeNavigation = this.element.data("view-mode-wheel-navigation")), this.wheelViewModeNavigationInverseDirection = !1, "wheelViewModeNavigationInverseDirection" in n ? this.wheelViewModeNavigationInverseDirection = n.wheelViewModeNavigationInverseDirection : "wheelViewModeNavigationInverseDirection" in this.element.data() && (this.wheelViewModeNavigationInverseDirection = this.element.data("view-mode-wheel-navigation-inverse-dir")), this.wheelViewModeNavigationDelay = 100, "wheelViewModeNavigationDelay" in n ? this.wheelViewModeNavigationDelay = n.wheelViewModeNavigationDelay : "wheelViewModeNavigationDelay" in this.element.data() && (this.wheelViewModeNavigationDelay = this.element.data("view-mode-wheel-navigation-delay")), this.startViewMode = 2, "startView" in n ? this.startViewMode = n.startView : "startView" in this.element.data() && (this.startViewMode = this.element.data("start-view")), this.startViewMode = a.convertViewMode(this.startViewMode), this.viewMode = this.startViewMode, this.viewSelect = this.minView, "viewSelect" in n ? this.viewSelect = n.viewSelect : "viewSelect" in this.element.data() && (this.viewSelect = this.element.data("view-select")), this.viewSelect = a.convertViewMode(this.viewSelect), this.forceParse = !0, "forceParse" in n ? this.forceParse = n.forceParse : "dateForceParse" in this.element.data() && (this.forceParse = this.element.data("date-force-parse"));
		for (var s = 3 === this.bootcssVer ? a.templateV3 : a.template; -1 !== s.indexOf("{iconType}");) s = s.replace("{iconType}", this.icontype);
		for (; -1 !== s.indexOf("{leftArrow}");) s = s.replace("{leftArrow}", this.icons.leftArrow);
		for (; -1 !== s.indexOf("{rightArrow}");) s = s.replace("{rightArrow}", this.icons.rightArrow);
		if (this.picker = t(s).appendTo(this.isInline ? this.element : this.container).on({
			click: t.proxy(this.click, this),
			mousedown: t.proxy(this.mousedown, this)
		}), this.wheelViewModeNavigation && (t.fn.mousewheel ? this.picker.on({mousewheel: t.proxy(this.mousewheel, this)}) : console.log("Mouse Wheel event is not supported. Please include the jQuery Mouse Wheel plugin before enabling this option")), this.isInline ? this.picker.addClass("datetimepicker-inline") : this.picker.addClass("datetimepicker-dropdown-" + this.pickerPosition + " dropdown-menu"), this.isRTL) {
			this.picker.addClass("datetimepicker-rtl");
			var l = 3 === this.bootcssVer ? ".prev span, .next span" : ".prev i, .next i";
			this.picker.find(l).toggleClass(this.icons.leftArrow + " " + this.icons.rightArrow)
		}
		t(document).on("mousedown touchend", this.clickedOutside), this.autoclose = !1, "autoclose" in n ? this.autoclose = n.autoclose : "dateAutoclose" in this.element.data() && (this.autoclose = this.element.data("date-autoclose")), this.keyboardNavigation = !0, "keyboardNavigation" in n ? this.keyboardNavigation = n.keyboardNavigation : "dateKeyboardNavigation" in this.element.data() && (this.keyboardNavigation = this.element.data("date-keyboard-navigation")), this.todayBtn = n.todayBtn || this.element.data("date-today-btn") || !1, this.clearBtn = n.clearBtn || this.element.data("date-clear-btn") || !1, this.todayHighlight = n.todayHighlight || this.element.data("date-today-highlight") || !1, this.weekStart = 0, void 0 !== n.weekStart ? this.weekStart = n.weekStart : void 0 !== this.element.data("date-weekstart") ? this.weekStart = this.element.data("date-weekstart") : void 0 !== o[this.language].weekStart && (this.weekStart = o[this.language].weekStart), this.weekStart = this.weekStart % 7, this.weekEnd = (this.weekStart + 6) % 7, this.onRenderDay = function (t) {
			var e = (n.onRenderDay || function () {
				return []
			})(t);
			"string" == typeof e && (e = [e]);
			return ["day"].concat(e || [])
		}, this.onRenderHour = function (t) {
			var e = (n.onRenderHour || function () {
				return []
			})(t);
			return "string" == typeof e && (e = [e]), ["hour"].concat(e || [])
		}, this.onRenderMinute = function (t) {
			var e = (n.onRenderMinute || function () {
				return []
			})(t), i = ["minute"];
			return "string" == typeof e && (e = [e]), t < this.startDate || t > this.endDate ? i.push("disabled") : Math.floor(this.date.getUTCMinutes() / this.minuteStep) === Math.floor(t.getUTCMinutes() / this.minuteStep) && i.push("active"), i.concat(e || [])
		}, this.onRenderYear = function (t) {
			var e = (n.onRenderYear || function () {
				return []
			})(t), i = ["year"];
			"string" == typeof e && (e = [e]), this.date.getUTCFullYear() === t.getUTCFullYear() && i.push("active");
			var r = t.getUTCFullYear(), o = this.endDate.getUTCFullYear();
			return (t < this.startDate || r > o) && i.push("disabled"), i.concat(e || [])
		}, this.onRenderMonth = function (t) {
			var e = (n.onRenderMonth || function () {
				return []
			})(t);
			return "string" == typeof e && (e = [e]), ["month"].concat(e || [])
		}, this.startDate = new Date(-8639968443048e3), this.endDate = new Date(8639968443048e3), this.datesDisabled = [], this.daysOfWeekDisabled = [], this.setStartDate(n.startDate || this.element.data("date-startdate")), this.setEndDate(n.endDate || this.element.data("date-enddate")), this.setDatesDisabled(n.datesDisabled || this.element.data("date-dates-disabled")), this.setDaysOfWeekDisabled(n.daysOfWeekDisabled || this.element.data("date-days-of-week-disabled")), this.setMinutesDisabled(n.minutesDisabled || this.element.data("date-minute-disabled")), this.setHoursDisabled(n.hoursDisabled || this.element.data("date-hour-disabled")), this.fillDow(), this.fillMonths(), this.update(), this.showMode(), this.isInline && this.show()
	};
	n.prototype = {
		constructor: n, _events: [], _attachEvents: function () {
			this._detachEvents(), this.isInput ? this._events = [[this.element, {
				focus: t.proxy(this.show, this),
				keyup: t.proxy(this.update, this),
				keydown: t.proxy(this.keydown, this)
			}]] : this.component && this.hasInput ? (this._events = [[this.element.find("input"), {
				focus: t.proxy(this.show, this),
				keyup: t.proxy(this.update, this),
				keydown: t.proxy(this.keydown, this)
			}], [this.component, {click: t.proxy(this.show, this)}]], this.componentReset && this._events.push([this.componentReset, {click: t.proxy(this.reset, this)}])) : this.element.is("div") ? this.isInline = !0 : this._events = [[this.element, {click: t.proxy(this.show, this)}]];
			for (var e, i, n = 0; n < this._events.length; n++) e = this._events[n][0], i = this._events[n][1], e.on(i)
		}, _detachEvents: function () {
			for (var t, e, i = 0; i < this._events.length; i++) t = this._events[i][0], e = this._events[i][1], t.off(e);
			this._events = []
		}, show: function (e) {
			this.picker.show(), this.height = this.component ? this.component.outerHeight() : this.element.outerHeight(), this.forceParse && this.update(), this.place(), t(window).on("resize", t.proxy(this.place, this)), e && (e.stopPropagation(), e.preventDefault()), this.isVisible = !0, this.element.trigger({
				type: "show",
				date: this.date
			})
		}, hide: function () {
			this.isVisible && (this.isInline || (this.picker.hide(), t(window).off("resize", this.place), this.viewMode = this.startViewMode, this.showMode(), this.isInput || t(document).off("mousedown", this.hide), this.forceParse && (this.isInput && this.element.val() || this.hasInput && this.element.find("input").val()) && this.setValue(), this.isVisible = !1, this.element.trigger({
				type: "hide",
				date: this.date
			})))
		}, remove: function () {
			this._detachEvents(), t(document).off("mousedown", this.clickedOutside), this.picker.remove(), delete this.picker, delete this.element.data().datetimepicker
		}, getDate: function () {
			var t = this.getUTCDate();
			return null === t ? null : new Date(t.getTime() + 6e4 * t.getTimezoneOffset())
		}, getUTCDate: function () {
			return this.date
		}, getInitialDate: function () {
			return this.initialDate
		}, setInitialDate: function (t) {
			this.initialDate = t
		}, setDate: function (t) {
			this.setUTCDate(new Date(t.getTime() - 6e4 * t.getTimezoneOffset()))
		}, setUTCDate: function (t) {
			t >= this.startDate && t <= this.endDate ? (this.date = t, this.setValue(), this.viewDate = this.date, this.fill()) : this.element.trigger({type: "outOfRange", date: t, startDate: this.startDate, endDate: this.endDate})
		}, setFormat: function (t) {
			var e;
			this.format = a.parseFormat(t, this.formatType), this.isInput ? e = this.element : this.component && (e = this.element.find("input")), e && e.val() && this.setValue()
		}, setValue: function () {
			var e = this.getFormattedDate();
			this.isInput ? this.element.val(e) : (this.component && this.element.find("input").val(e), this.element.data("date", e)), this.linkField && t("#" + this.linkField).val(this.getFormattedDate(this.linkFormat))
		}, getFormattedDate: function (t) {
			return t = t || this.format, a.formatDate(this.date, t, this.language, this.formatType, this.timezone)
		}, setStartDate: function (t) {
			this.startDate = t || this.startDate, 8639968443048e3 !== this.startDate.valueOf() && (this.startDate = a.parseDate(this.startDate, this.format, this.language, this.formatType, this.timezone)), this.update(), this.updateNavArrows()
		}, setEndDate: function (t) {
			this.endDate = t || this.endDate, 8639968443048e3 !== this.endDate.valueOf() && (this.endDate = a.parseDate(this.endDate, this.format, this.language, this.formatType, this.timezone)), this.update(), this.updateNavArrows()
		}, setDatesDisabled: function (e) {
			this.datesDisabled = e || [], t.isArray(this.datesDisabled) || (this.datesDisabled = this.datesDisabled.split(/,\s*/));
			var i = this;
			this.datesDisabled = t.map(this.datesDisabled, function (t) {
				return a.parseDate(t, i.format, i.language, i.formatType, i.timezone).toDateString()
			}), this.update(), this.updateNavArrows()
		}, setTitle: function (t, e) {
			return this.picker.find(t).find("th:eq(1)").text(!1 === this.title ? e : this.title)
		}, setDaysOfWeekDisabled: function (e) {
			this.daysOfWeekDisabled = e || [], t.isArray(this.daysOfWeekDisabled) || (this.daysOfWeekDisabled = this.daysOfWeekDisabled.split(/,\s*/)), this.daysOfWeekDisabled = t.map(this.daysOfWeekDisabled, function (t) {
				return parseInt(t, 10)
			}), this.update(), this.updateNavArrows()
		}, setMinutesDisabled: function (e) {
			this.minutesDisabled = e || [], t.isArray(this.minutesDisabled) || (this.minutesDisabled = this.minutesDisabled.split(/,\s*/)), this.minutesDisabled = t.map(this.minutesDisabled, function (t) {
				return parseInt(t, 10)
			}), this.update(), this.updateNavArrows()
		}, setHoursDisabled: function (e) {
			this.hoursDisabled = e || [], t.isArray(this.hoursDisabled) || (this.hoursDisabled = this.hoursDisabled.split(/,\s*/)), this.hoursDisabled = t.map(this.hoursDisabled, function (t) {
				return parseInt(t, 10)
			}), this.update(), this.updateNavArrows()
		}, place: function () {
			if (!this.isInline) {
				if (!this.zIndex) {
					var e = 0;
					t("div").each(function () {
						var i = parseInt(t(this).css("zIndex"), 10);
						i > e && (e = i)
					}), this.zIndex = e + 10
				}
				var i, n, r, o;
				o = this.container instanceof t ? this.container.offset() : t(this.container).offset(), this.component ? (r = (i = this.component.offset()).left, "bottom-left" !== this.pickerPosition && "top-left" !== this.pickerPosition || (r += this.component.outerWidth() - this.picker.outerWidth())) : (r = (i = this.element.offset()).left, "bottom-left" !== this.pickerPosition && "top-left" !== this.pickerPosition || (r += this.element.outerWidth() - this.picker.outerWidth()));
				var a = document.body.clientWidth || window.innerWidth;
				r + 220 > a && (r = a - 220), n = "top-left" === this.pickerPosition || "top-right" === this.pickerPosition ? i.top - this.picker.outerHeight() : i.top + this.height, n -= o.top, r -= o.left, this.picker.css({top: n, left: r, zIndex: this.zIndex})
			}
		}, hour_minute: "^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]", update: function () {
			var t, e = !1;
			arguments && arguments.length && ("string" == typeof arguments[0] || arguments[0] instanceof Date) ? (t = arguments[0], e = !0) : "string" == typeof (t = (this.isInput ? this.element.val() : this.element.find("input").val()) || this.element.data("date") || this.initialDate) && (t = t.replace(/^\s+|\s+$/g, "")), t || (t = new Date, e = !1), "string" == typeof t && (new RegExp(this.hour_minute).test(t) || new RegExp(this.hour_minute + ":[0-5][0-9]").test(t)) && (t = this.getDate()), this.date = a.parseDate(t, this.format, this.language, this.formatType, this.timezone), e && this.setValue(), this.date < this.startDate ? this.viewDate = new Date(this.startDate) : this.date > this.endDate ? this.viewDate = new Date(this.endDate) : this.viewDate = new Date(this.date), this.fill()
		}, fillDow: function () {
			for (var t = this.weekStart, e = "<tr>"; t < this.weekStart + 7;) e += '<th class="dow">' + o[this.language].daysMin[t++ % 7] + "</th>";
			e += "</tr>", this.picker.find(".datetimepicker-days thead").append(e)
		}, fillMonths: function () {
			for (var t = "", e = new Date(this.viewDate), i = 0; i < 12; i++) {
				e.setUTCMonth(i), t += '<span class="' + this.onRenderMonth(e).join(" ") + '">' + o[this.language].monthsShort[i] + "</span>"
			}
			this.picker.find(".datetimepicker-months td").html(t)
		}, fill: function () {
			if (this.date && this.viewDate) {
				var e = new Date(this.viewDate), n = e.getUTCFullYear(), s = e.getUTCMonth(), l = e.getUTCDate(), c = e.getUTCHours(), u = this.startDate.getUTCFullYear(), h = this.startDate.getUTCMonth(), d = this.endDate.getUTCFullYear(), p = this.endDate.getUTCMonth() + 1,
					f = new i(this.date.getUTCFullYear(), this.date.getUTCMonth(), this.date.getUTCDate()).valueOf(), m = new Date;
				if (this.setTitle(".datetimepicker-days", o[this.language].months[s] + " " + n), "time" === this.formatViewType) {
					var g = this.getFormattedDate();
					this.setTitle(".datetimepicker-hours", g), this.setTitle(".datetimepicker-minutes", g)
				} else this.setTitle(".datetimepicker-hours", l + " " + o[this.language].months[s] + " " + n), this.setTitle(".datetimepicker-minutes", l + " " + o[this.language].months[s] + " " + n);
				this.picker.find("tfoot th.today").text(o[this.language].today || o.en.today).toggle(!1 !== this.todayBtn), this.picker.find("tfoot th.clear").text(o[this.language].clear || o.en.clear).toggle(!1 !== this.clearBtn), this.updateNavArrows(), this.fillMonths();
				var v = i(n, s - 1, 28, 0, 0, 0, 0), y = a.getDaysInMonth(v.getUTCFullYear(), v.getUTCMonth());
				v.setUTCDate(y), v.setUTCDate(y - (v.getUTCDay() - this.weekStart + 7) % 7);
				var b = new Date(v);
				b.setUTCDate(b.getUTCDate() + 42), b = b.valueOf();
				for (var w, x = []; v.valueOf() < b;) v.getUTCDay() === this.weekStart && x.push("<tr>"), w = this.onRenderDay(v), v.getUTCFullYear() < n || v.getUTCFullYear() === n && v.getUTCMonth() < s ? w.push("old") : (v.getUTCFullYear() > n || v.getUTCFullYear() === n && v.getUTCMonth() > s) && w.push("new"), this.todayHighlight && v.getUTCFullYear() === m.getFullYear() && v.getUTCMonth() === m.getMonth() && v.getUTCDate() === m.getDate() && w.push("today"), v.valueOf() === f && w.push("active"), (v.valueOf() + 864e5 <= this.startDate || v.valueOf() > this.endDate || -1 !== t.inArray(v.getUTCDay(), this.daysOfWeekDisabled) || -1 !== t.inArray(v.toDateString(), this.datesDisabled)) && w.push("disabled"), x.push('<td class="' + w.join(" ") + '">' + v.getUTCDate() + "</td>"), v.getUTCDay() === this.weekEnd && x.push("</tr>"), v.setUTCDate(v.getUTCDate() + 1);
				this.picker.find(".datetimepicker-days tbody").empty().append(x.join("")), x = [];
				var k = "", _ = "", S = "", C = this.hoursDisabled || [];
				e = new Date(this.viewDate);
				for (var D = 0; D < 24; D++) {
					e.setUTCHours(D), w = this.onRenderHour(e), -1 !== C.indexOf(D) && w.push("disabled");
					var T = i(n, s, l, D);
					T.valueOf() + 36e5 <= this.startDate || T.valueOf() > this.endDate ? w.push("disabled") : c === D && w.push("active"), this.showMeridian && 2 === o[this.language].meridiem.length ? ((_ = D < 12 ? o[this.language].meridiem[0] : o[this.language].meridiem[1]) !== S && ("" !== S && x.push("</fieldset>"), x.push('<fieldset class="hour"><legend>' + _.toUpperCase() + "</legend>")), S = _, k = D % 12 ? D % 12 : 12, D < 12 ? w.push("hour_am") : w.push("hour_pm"), x.push('<span class="' + w.join(" ") + '">' + k + "</span>"), 23 === D && x.push("</fieldset>")) : (k = D + ":00", x.push('<span class="' + w.join(" ") + '">' + k + "</span>"))
				}
				this.picker.find(".datetimepicker-hours td").html(x.join("")), x = [], k = "", _ = "", S = "";
				var M = this.minutesDisabled || [];
				e = new Date(this.viewDate);
				for (D = 0; D < 60; D += this.minuteStep) -1 === M.indexOf(D) && (e.setUTCMinutes(D), e.setUTCSeconds(0), w = this.onRenderMinute(e), this.showMeridian && 2 === o[this.language].meridiem.length ? ((_ = c < 12 ? o[this.language].meridiem[0] : o[this.language].meridiem[1]) !== S && ("" !== S && x.push("</fieldset>"), x.push('<fieldset class="minute"><legend>' + _.toUpperCase() + "</legend>")), S = _, k = c % 12 ? c % 12 : 12, x.push('<span class="' + w.join(" ") + '">' + k + ":" + (D < 10 ? "0" + D : D) + "</span>"), 59 === D && x.push("</fieldset>")) : (k = D + ":00", x.push('<span class="' + w.join(" ") + '">' + c + ":" + (D < 10 ? "0" + D : D) + "</span>")));
				this.picker.find(".datetimepicker-minutes td").html(x.join(""));
				var E = this.date.getUTCFullYear(), A = this.setTitle(".datetimepicker-months", n).end().find(".month").removeClass("active");
				E === n && A.eq(this.date.getUTCMonth()).addClass("active"), (n < u || n > d) && A.addClass("disabled"), n === u && A.slice(0, h).addClass("disabled"), n === d && A.slice(p).addClass("disabled"), x = "", n = 10 * parseInt(n / 10, 10);
				var P = this.setTitle(".datetimepicker-years", n + "-" + (n + 9)).end().find("td");
				n -= 1, e = new Date(this.viewDate);
				for (D = -1; D < 11; D++) e.setUTCFullYear(n), w = this.onRenderYear(e), -1 !== D && 10 !== D || w.push(r), x += '<span class="' + w.join(" ") + '">' + n + "</span>", n += 1;
				P.html(x), this.place()
			}
		}, updateNavArrows: function () {
			var t = new Date(this.viewDate), e = t.getUTCFullYear(), i = t.getUTCMonth(), n = t.getUTCDate(), r = t.getUTCHours();
			switch (this.viewMode) {
				case 0:
					e <= this.startDate.getUTCFullYear() && i <= this.startDate.getUTCMonth() && n <= this.startDate.getUTCDate() && r <= this.startDate.getUTCHours() ? this.picker.find(".prev").css({visibility: "hidden"}) : this.picker.find(".prev").css({visibility: "visible"}), e >= this.endDate.getUTCFullYear() && i >= this.endDate.getUTCMonth() && n >= this.endDate.getUTCDate() && r >= this.endDate.getUTCHours() ? this.picker.find(".next").css({visibility: "hidden"}) : this.picker.find(".next").css({visibility: "visible"});
					break;
				case 1:
					e <= this.startDate.getUTCFullYear() && i <= this.startDate.getUTCMonth() && n <= this.startDate.getUTCDate() ? this.picker.find(".prev").css({visibility: "hidden"}) : this.picker.find(".prev").css({visibility: "visible"}), e >= this.endDate.getUTCFullYear() && i >= this.endDate.getUTCMonth() && n >= this.endDate.getUTCDate() ? this.picker.find(".next").css({visibility: "hidden"}) : this.picker.find(".next").css({visibility: "visible"});
					break;
				case 2:
					e <= this.startDate.getUTCFullYear() && i <= this.startDate.getUTCMonth() ? this.picker.find(".prev").css({visibility: "hidden"}) : this.picker.find(".prev").css({visibility: "visible"}), e >= this.endDate.getUTCFullYear() && i >= this.endDate.getUTCMonth() ? this.picker.find(".next").css({visibility: "hidden"}) : this.picker.find(".next").css({visibility: "visible"});
					break;
				case 3:
				case 4:
					e <= this.startDate.getUTCFullYear() ? this.picker.find(".prev").css({visibility: "hidden"}) : this.picker.find(".prev").css({visibility: "visible"}), e >= this.endDate.getUTCFullYear() ? this.picker.find(".next").css({visibility: "hidden"}) : this.picker.find(".next").css({visibility: "visible"})
			}
		}, mousewheel: function (e) {
			if (e.preventDefault(), e.stopPropagation(), !this.wheelPause) {
				this.wheelPause = !0;
				var i = e.originalEvent.wheelDelta, n = i > 0 ? 1 : 0 === i ? 0 : -1;
				this.wheelViewModeNavigationInverseDirection && (n = -n), this.showMode(n), setTimeout(t.proxy(function () {
					this.wheelPause = !1
				}, this), this.wheelViewModeNavigationDelay)
			}
		}, click: function (e) {
			e.stopPropagation(), e.preventDefault();
			var n = t(e.target).closest("span, td, th, legend");
			if (n.is("." + this.icontype) && (n = t(n).parent().closest("span, td, th, legend")), 1 === n.length) {
				if (n.is(".disabled")) return void this.element.trigger({type: "outOfRange", date: this.viewDate, startDate: this.startDate, endDate: this.endDate});
				switch (n[0].nodeName.toLowerCase()) {
					case"th":
						switch (n[0].className) {
							case"switch":
								this.showMode(1);
								break;
							case"prev":
							case"next":
								var r = a.modes[this.viewMode].navStep * ("prev" === n[0].className ? -1 : 1);
								switch (this.viewMode) {
									case 0:
										this.viewDate = this.moveHour(this.viewDate, r);
										break;
									case 1:
										this.viewDate = this.moveDate(this.viewDate, r);
										break;
									case 2:
										this.viewDate = this.moveMonth(this.viewDate, r);
										break;
									case 3:
									case 4:
										this.viewDate = this.moveYear(this.viewDate, r)
								}
								this.fill(), this.element.trigger({type: n[0].className + ":" + this.convertViewModeText(this.viewMode), date: this.viewDate, startDate: this.startDate, endDate: this.endDate});
								break;
							case"clear":
								this.reset(), this.autoclose && this.hide();
								break;
							case"today":
								var o = new Date;
								(o = i(o.getFullYear(), o.getMonth(), o.getDate(), o.getHours(), o.getMinutes(), o.getSeconds(), 0)) < this.startDate ? o = this.startDate : o > this.endDate && (o = this.endDate), this.viewMode = this.startViewMode, this.showMode(0), this._setDate(o), this.fill(), this.autoclose && this.hide()
						}
						break;
					case"span":
						if (!n.is(".disabled")) {
							var s = this.viewDate.getUTCFullYear(), l = this.viewDate.getUTCMonth(), c = this.viewDate.getUTCDate(), u = this.viewDate.getUTCHours(), h = this.viewDate.getUTCMinutes(), d = this.viewDate.getUTCSeconds();
							if (n.is(".month") ? (this.viewDate.setUTCDate(1), l = n.parent().find("span").index(n), c = this.viewDate.getUTCDate(), this.viewDate.setUTCMonth(l), this.element.trigger({
								type: "changeMonth",
								date: this.viewDate
							}), this.viewSelect >= 3 && this._setDate(i(s, l, c, u, h, d, 0))) : n.is(".year") ? (this.viewDate.setUTCDate(1), s = parseInt(n.text(), 10) || 0, this.viewDate.setUTCFullYear(s), this.element.trigger({
								type: "changeYear",
								date: this.viewDate
							}), this.viewSelect >= 4 && this._setDate(i(s, l, c, u, h, d, 0))) : n.is(".hour") ? (u = parseInt(n.text(), 10) || 0, (n.hasClass("hour_am") || n.hasClass("hour_pm")) && (12 === u && n.hasClass("hour_am") ? u = 0 : 12 !== u && n.hasClass("hour_pm") && (u += 12)), this.viewDate.setUTCHours(u), this.element.trigger({
								type: "changeHour",
								date: this.viewDate
							}), this.viewSelect >= 1 && this._setDate(i(s, l, c, u, h, d, 0))) : n.is(".minute") && (h = parseInt(n.text().substr(n.text().indexOf(":") + 1), 10) || 0, this.viewDate.setUTCMinutes(h), this.element.trigger({
								type: "changeMinute",
								date: this.viewDate
							}), this.viewSelect >= 0 && this._setDate(i(s, l, c, u, h, d, 0))), 0 !== this.viewMode) {
								var p = this.viewMode;
								this.showMode(-1), this.fill(), p === this.viewMode && this.autoclose && this.hide()
							} else this.fill(), this.autoclose && this.hide()
						}
						break;
					case"td":
						if (n.is(".day") && !n.is(".disabled")) {
							c = parseInt(n.text(), 10) || 1, s = this.viewDate.getUTCFullYear(), l = this.viewDate.getUTCMonth(), u = this.viewDate.getUTCHours(), h = this.viewDate.getUTCMinutes(), d = this.viewDate.getUTCSeconds();
							n.is(".old") ? 0 === l ? (l = 11, s -= 1) : l -= 1 : n.is(".new") && (11 === l ? (l = 0, s += 1) : l += 1), this.viewDate.setUTCFullYear(s), this.viewDate.setUTCMonth(l, c), this.element.trigger({
								type: "changeDay",
								date: this.viewDate
							}), this.viewSelect >= 2 && this._setDate(i(s, l, c, u, h, d, 0))
						}
						p = this.viewMode;
						this.showMode(-1), this.fill(), p === this.viewMode && this.autoclose && this.hide()
				}
			}
		}, _setDate: function (t, e) {
			var i;
			e && "date" !== e || (this.date = t), e && "view" !== e || (this.viewDate = t), this.fill(), this.setValue(), this.isInput ? i = this.element : this.component && (i = this.element.find("input")), i && i.change(), this.element.trigger({
				type: "changeDate",
				date: this.getDate()
			}), null === t && (this.date = this.viewDate)
		}, moveMinute: function (t, e) {
			if (!e) return t;
			var i = new Date(t.valueOf());
			return i.setUTCMinutes(i.getUTCMinutes() + e * this.minuteStep), i
		}, moveHour: function (t, e) {
			if (!e) return t;
			var i = new Date(t.valueOf());
			return i.setUTCHours(i.getUTCHours() + e), i
		}, moveDate: function (t, e) {
			if (!e) return t;
			var i = new Date(t.valueOf());
			return i.setUTCDate(i.getUTCDate() + e), i
		}, moveMonth: function (t, e) {
			if (!e) return t;
			var i, n, r = new Date(t.valueOf()), o = r.getUTCDate(), a = r.getUTCMonth(), s = Math.abs(e);
			if (e = e > 0 ? 1 : -1, 1 === s) n = -1 === e ? function () {
				return r.getUTCMonth() === a
			} : function () {
				return r.getUTCMonth() !== i
			}, i = a + e, r.setUTCMonth(i), (i < 0 || i > 11) && (i = (i + 12) % 12); else {
				for (var l = 0; l < s; l++) r = this.moveMonth(r, e);
				i = r.getUTCMonth(), r.setUTCDate(o), n = function () {
					return i !== r.getUTCMonth()
				}
			}
			for (; n();) r.setUTCDate(--o), r.setUTCMonth(i);
			return r
		}, moveYear: function (t, e) {
			return this.moveMonth(t, 12 * e)
		}, dateWithinRange: function (t) {
			return t >= this.startDate && t <= this.endDate
		}, keydown: function (t) {
			if (this.picker.is(":not(:visible)")) 27 === t.keyCode && this.show(); else {
				var e, i, n, r, o = !1;
				switch (t.keyCode) {
					case 27:
						this.hide(), t.preventDefault();
						break;
					case 37:
					case 39:
						if (!this.keyboardNavigation) break;
						e = 37 === t.keyCode ? -1 : 1;
						var a = this.viewMode;
						t.ctrlKey ? a += 2 : t.shiftKey && (a += 1), 4 === a ? (i = this.moveYear(this.date, e), n = this.moveYear(this.viewDate, e)) : 3 === a ? (i = this.moveMonth(this.date, e), n = this.moveMonth(this.viewDate, e)) : 2 === a ? (i = this.moveDate(this.date, e), n = this.moveDate(this.viewDate, e)) : 1 === a ? (i = this.moveHour(this.date, e), n = this.moveHour(this.viewDate, e)) : 0 === a && (i = this.moveMinute(this.date, e), n = this.moveMinute(this.viewDate, e)), this.dateWithinRange(i) && (this.date = i, this.viewDate = n, this.setValue(), this.update(), t.preventDefault(), o = !0);
						break;
					case 38:
					case 40:
						if (!this.keyboardNavigation) break;
						e = 38 === t.keyCode ? -1 : 1, a = this.viewMode, t.ctrlKey ? a += 2 : t.shiftKey && (a += 1), 4 === a ? (i = this.moveYear(this.date, e), n = this.moveYear(this.viewDate, e)) : 3 === a ? (i = this.moveMonth(this.date, e), n = this.moveMonth(this.viewDate, e)) : 2 === a ? (i = this.moveDate(this.date, 7 * e), n = this.moveDate(this.viewDate, 7 * e)) : 1 === a ? this.showMeridian ? (i = this.moveHour(this.date, 6 * e), n = this.moveHour(this.viewDate, 6 * e)) : (i = this.moveHour(this.date, 4 * e), n = this.moveHour(this.viewDate, 4 * e)) : 0 === a && (i = this.moveMinute(this.date, 4 * e), n = this.moveMinute(this.viewDate, 4 * e)), this.dateWithinRange(i) && (this.date = i, this.viewDate = n, this.setValue(), this.update(), t.preventDefault(), o = !0);
						break;
					case 13:
						if (0 !== this.viewMode) {
							var s = this.viewMode;
							this.showMode(-1), this.fill(), s === this.viewMode && this.autoclose && this.hide()
						} else this.fill(), this.autoclose && this.hide();
						t.preventDefault();
						break;
					case 9:
						this.hide()
				}
				if (o) this.isInput ? r = this.element : this.component && (r = this.element.find("input")), r && r.change(), this.element.trigger({type: "changeDate", date: this.getDate()})
			}
		}, showMode: function (t) {
			if (t) {
				var e = Math.max(0, Math.min(a.modes.length - 1, this.viewMode + t));
				e >= this.minView && e <= this.maxView && (this.element.trigger({type: "changeMode", date: this.viewDate, oldViewMode: this.viewMode, newViewMode: e}), this.viewMode = e)
			}
			this.picker.find(">div").hide().filter(".datetimepicker-" + a.modes[this.viewMode].clsName).css("display", "block"), this.updateNavArrows()
		}, reset: function () {
			this._setDate(null, "date")
		}, convertViewModeText: function (t) {
			switch (t) {
				case 4:
					return "decade";
				case 3:
					return "year";
				case 2:
					return "month";
				case 1:
					return "day";
				case 0:
					return "hour"
			}
		}
	};
	var r = t.fn.datetimepicker;
	t.fn.datetimepicker = function (i) {
		var r, o = Array.apply(null, arguments);
		return o.shift(), this.each(function () {
			var a = t(this), s = a.data("datetimepicker"), l = "object" == typeof i && i;
			if (s || a.data("datetimepicker", s = new n(this, t.extend({}, t.fn.datetimepicker.defaults, l))), "string" == typeof i && "function" == typeof s[i] && (r = s[i].apply(s, o)) !== e) return !1
		}), r !== e ? r : this
	}, t.fn.datetimepicker.defaults = {}, t.fn.datetimepicker.Constructor = n;
	var o = t.fn.datetimepicker.dates = {
		en: {
			days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
			daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
			daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
			months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			meridiem: ["am", "pm"],
			suffix: ["st", "nd", "rd", "th"],
			today: "Today",
			clear: "Clear"
		}
	}, a = {
		modes: [{clsName: "minutes", navFnc: "Hours", navStep: 1}, {clsName: "hours", navFnc: "Date", navStep: 1}, {clsName: "days", navFnc: "Month", navStep: 1}, {clsName: "months", navFnc: "FullYear", navStep: 1}, {clsName: "years", navFnc: "FullYear", navStep: 10}],
		isLeapYear: function (t) {
			return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
		},
		getDaysInMonth: function (t, e) {
			return [31, a.isLeapYear(t) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][e]
		},
		getDefaultFormat: function (t, e) {
			if ("standard" === t) return "input" === e ? "yyyy-mm-dd hh:ii" : "yyyy-mm-dd hh:ii:ss";
			if ("php" === t) return "input" === e ? "Y-m-d H:i" : "Y-m-d H:i:s";
			throw new Error("Invalid format type.")
		},
		validParts: function (t) {
			if ("standard" === t) return /t|hh?|HH?|p|P|z|Z|ii?|ss?|dd?|DD?|mm?|MM?|yy(?:yy)?/g;
			if ("php" === t) return /[dDjlNwzFmMnStyYaABgGhHis]/g;
			throw new Error("Invalid format type.")
		},
		nonpunctuation: /[^ -\/:-@\[-`{-~\t\n\rTZ]+/g,
		parseFormat: function (t, e) {
			var i = t.replace(this.validParts(e), "\0").split("\0"), n = t.match(this.validParts(e));
			if (!i || !i.length || !n || 0 === n.length) throw new Error("Invalid date format.");
			return {separators: i, parts: n}
		},
		parseDate: function (e, r, a, s, l) {
			if (e instanceof Date) {
				var c = new Date(e.valueOf() - 6e4 * e.getTimezoneOffset());
				return c.setMilliseconds(0), c
			}
			if (/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(e) && (r = this.parseFormat("yyyy-mm-dd", s)), /^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}$/.test(e) && (r = this.parseFormat("yyyy-mm-dd hh:ii", s)), /^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}\:\d{1,2}[Z]{0,1}$/.test(e) && (r = this.parseFormat("yyyy-mm-dd hh:ii:ss", s)), /^[-+]\d+[dmwy]([\s,]+[-+]\d+[dmwy])*$/.test(e)) {
				var u, h = /([-+]\d+)([dmwy])/, d = e.match(/([-+]\d+)([dmwy])/g);
				e = new Date;
				for (var p = 0; p < d.length; p++) switch (g = h.exec(d[p]), u = parseInt(g[1]), g[2]) {
					case"d":
						e.setUTCDate(e.getUTCDate() + u);
						break;
					case"m":
						e = n.prototype.moveMonth.call(n.prototype, e, u);
						break;
					case"w":
						e.setUTCDate(e.getUTCDate() + 7 * u);
						break;
					case"y":
						e = n.prototype.moveYear.call(n.prototype, e, u)
				}
				return i(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), 0)
			}
			d = e && e.toString().match(this.nonpunctuation) || [], e = new Date(0, 0, 0, 0, 0, 0, 0);
			var f, m, g, v = {}, y = ["hh", "h", "ii", "i", "ss", "s", "yyyy", "yy", "M", "MM", "m", "mm", "D", "DD", "d", "dd", "H", "HH", "p", "P", "z", "Z"], b = {
				hh: function (t, e) {
					return t.setUTCHours(e)
				}, h: function (t, e) {
					return t.setUTCHours(e)
				}, HH: function (t, e) {
					return t.setUTCHours(12 === e ? 0 : e)
				}, H: function (t, e) {
					return t.setUTCHours(12 === e ? 0 : e)
				}, ii: function (t, e) {
					return t.setUTCMinutes(e)
				}, i: function (t, e) {
					return t.setUTCMinutes(e)
				}, ss: function (t, e) {
					return t.setUTCSeconds(e)
				}, s: function (t, e) {
					return t.setUTCSeconds(e)
				}, yyyy: function (t, e) {
					return t.setUTCFullYear(e)
				}, yy: function (t, e) {
					return t.setUTCFullYear(2e3 + e)
				}, m: function (t, e) {
					for (e -= 1; e < 0;) e += 12;
					for (e %= 12, t.setUTCMonth(e); t.getUTCMonth() !== e;) {
						if (isNaN(t.getUTCMonth())) return t;
						t.setUTCDate(t.getUTCDate() - 1)
					}
					return t
				}, d: function (t, e) {
					return t.setUTCDate(e)
				}, p: function (t, e) {
					return t.setUTCHours(1 === e ? t.getUTCHours() + 12 : t.getUTCHours())
				}, z: function () {
					return l
				}
			};
			if (b.M = b.MM = b.mm = b.m, b.dd = b.d, b.P = b.p, b.Z = b.z, e = i(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()), d.length === r.parts.length) {
				p = 0;
				for (var w = r.parts.length; p < w; p++) {
					if (f = parseInt(d[p], 10), g = r.parts[p], isNaN(f)) switch (g) {
						case"MM":
							m = t(o[a].months).filter(function () {
								var t = this.slice(0, d[p].length);
								return t === d[p].slice(0, t.length)
							}), f = t.inArray(m[0], o[a].months) + 1;
							break;
						case"M":
							m = t(o[a].monthsShort).filter(function () {
								var t = this.slice(0, d[p].length), e = d[p].slice(0, t.length);
								return t.toLowerCase() === e.toLowerCase()
							}), f = t.inArray(m[0], o[a].monthsShort) + 1;
							break;
						case"p":
						case"P":
							f = t.inArray(d[p].toLowerCase(), o[a].meridiem)
					}
					v[g] = f
				}
				var x;
				for (p = 0; p < y.length; p++) (x = y[p]) in v && !isNaN(v[x]) && b[x](e, v[x])
			}
			return e
		},
		formatDate: function (e, i, n, r, s) {
			if (null === e) return "";
			var l;
			if ("standard" === r) l = {
				t: e.getTime(),
				yy: e.getUTCFullYear().toString().substring(2),
				yyyy: e.getUTCFullYear(),
				m: e.getUTCMonth() + 1,
				M: o[n].monthsShort[e.getUTCMonth()],
				MM: o[n].months[e.getUTCMonth()],
				d: e.getUTCDate(),
				D: o[n].daysShort[e.getUTCDay()],
				DD: o[n].days[e.getUTCDay()],
				p: 2 === o[n].meridiem.length ? o[n].meridiem[e.getUTCHours() < 12 ? 0 : 1] : "",
				h: e.getUTCHours(),
				i: e.getUTCMinutes(),
				s: e.getUTCSeconds(),
				z: s
			}, 2 === o[n].meridiem.length ? l.H = l.h % 12 == 0 ? 12 : l.h % 12 : l.H = l.h, l.HH = (l.H < 10 ? "0" : "") + l.H, l.P = l.p.toUpperCase(), l.Z = l.z, l.hh = (l.h < 10 ? "0" : "") + l.h, l.ii = (l.i < 10 ? "0" : "") + l.i, l.ss = (l.s < 10 ? "0" : "") + l.s, l.dd = (l.d < 10 ? "0" : "") + l.d, l.mm = (l.m < 10 ? "0" : "") + l.m; else {
				if ("php" !== r) throw new Error("Invalid format type.");
				(l = {
					y: e.getUTCFullYear().toString().substring(2),
					Y: e.getUTCFullYear(),
					F: o[n].months[e.getUTCMonth()],
					M: o[n].monthsShort[e.getUTCMonth()],
					n: e.getUTCMonth() + 1,
					t: a.getDaysInMonth(e.getUTCFullYear(), e.getUTCMonth()),
					j: e.getUTCDate(),
					l: o[n].days[e.getUTCDay()],
					D: o[n].daysShort[e.getUTCDay()],
					w: e.getUTCDay(),
					N: 0 === e.getUTCDay() ? 7 : e.getUTCDay(),
					S: e.getUTCDate() % 10 <= o[n].suffix.length ? o[n].suffix[e.getUTCDate() % 10 - 1] : "",
					a: 2 === o[n].meridiem.length ? o[n].meridiem[e.getUTCHours() < 12 ? 0 : 1] : "",
					g: e.getUTCHours() % 12 == 0 ? 12 : e.getUTCHours() % 12,
					G: e.getUTCHours(),
					i: e.getUTCMinutes(),
					s: e.getUTCSeconds()
				}).m = (l.n < 10 ? "0" : "") + l.n, l.d = (l.j < 10 ? "0" : "") + l.j, l.A = l.a.toString().toUpperCase(), l.h = (l.g < 10 ? "0" : "") + l.g, l.H = (l.G < 10 ? "0" : "") + l.G, l.i = (l.i < 10 ? "0" : "") + l.i, l.s = (l.s < 10 ? "0" : "") + l.s
			}
			e = [];
			for (var c = t.extend([], i.separators), u = 0, h = i.parts.length; u < h; u++) c.length && e.push(c.shift()), e.push(l[i.parts[u]]);
			return c.length && e.push(c.shift()), e.join("")
		},
		convertViewMode: function (t) {
			switch (t) {
				case 4:
				case"decade":
					t = 4;
					break;
				case 3:
				case"year":
					t = 3;
					break;
				case 2:
				case"month":
					t = 2;
					break;
				case 1:
				case"day":
					t = 1;
					break;
				case 0:
				case"hour":
					t = 0
			}
			return t
		},
		headTemplate: '<thead><tr><th class="prev"><i class="{iconType} {leftArrow}"/></th><th colspan="5" class="switch"></th><th class="next"><i class="{iconType} {rightArrow}"/></th></tr></thead>',
		headTemplateV3: '<thead><tr><th class="prev"><span class="{iconType} {leftArrow}"></span> </th><th colspan="5" class="switch"></th><th class="next"><span class="{iconType} {rightArrow}"></span> </th></tr></thead>',
		contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
		footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'
	};
	a.template = '<div class="datetimepicker"><div class="datetimepicker-minutes"><table class=" table-condensed">' + a.headTemplate + a.contTemplate + a.footTemplate + '</table></div><div class="datetimepicker-hours"><table class=" table-condensed">' + a.headTemplate + a.contTemplate + a.footTemplate + '</table></div><div class="datetimepicker-days"><table class=" table-condensed">' + a.headTemplate + "<tbody></tbody>" + a.footTemplate + '</table></div><div class="datetimepicker-months"><table class="table-condensed">' + a.headTemplate + a.contTemplate + a.footTemplate + '</table></div><div class="datetimepicker-years"><table class="table-condensed">' + a.headTemplate + a.contTemplate + a.footTemplate + "</table></div></div>", a.templateV3 = '<div class="datetimepicker"><div class="datetimepicker-minutes"><table class=" table-condensed">' + a.headTemplateV3 + a.contTemplate + a.footTemplate + '</table></div><div class="datetimepicker-hours"><table class=" table-condensed">' + a.headTemplateV3 + a.contTemplate + a.footTemplate + '</table></div><div class="datetimepicker-days"><table class=" table-condensed">' + a.headTemplateV3 + "<tbody></tbody>" + a.footTemplate + '</table></div><div class="datetimepicker-months"><table class="table-condensed">' + a.headTemplateV3 + a.contTemplate + a.footTemplate + '</table></div><div class="datetimepicker-years"><table class="table-condensed">' + a.headTemplateV3 + a.contTemplate + a.footTemplate + "</table></div></div>", t.fn.datetimepicker.DPGlobal = a, t.fn.datetimepicker.noConflict = function () {
		return t.fn.datetimepicker = r, this
	}, t(document).on("focus.datetimepicker.data-api click.datetimepicker.data-api", '[data-provide="datetimepicker"]', function (e) {
		var i = t(this);
		i.data("datetimepicker") || (e.preventDefault(), i.datetimepicker("show"))
	}), t(function () {
		t('[data-provide="datetimepicker-inline"]').datetimepicker()
	})
}), function (t, e, i) {
	"use strict";
	var n = function (e, i) {
		this.widget = "", this.$element = t(e), this.defaultTime = i.defaultTime, this.disableFocus = i.disableFocus, this.disableMousewheel = i.disableMousewheel, this.isOpen = i.isOpen, this.minuteStep = i.minuteStep, this.modalBackdrop = i.modalBackdrop, this.orientation = i.orientation, this.secondStep = i.secondStep, this.snapToStep = i.snapToStep, this.showInputs = i.showInputs, this.showMeridian = i.showMeridian, this.showSeconds = i.showSeconds, this.template = i.template, this.appendWidgetTo = i.appendWidgetTo, this.showWidgetOnAddonClick = i.showWidgetOnAddonClick, this.icons = i.icons, this.maxHours = i.maxHours, this.explicitMode = i.explicitMode, this.handleDocumentClick = function (t) {
			var e = t.data.scope;
			e.$element.parent().find(t.target).length || e.$widget.is(t.target) || e.$widget.find(t.target).length || e.hideWidget()
		}, this._init()
	};
	n.prototype = {
		constructor: n, _init: function () {
			var e = this;
			this.showWidgetOnAddonClick && this.$element.parent().hasClass("input-group") && this.$element.parent().hasClass("bootstrap-timepicker") ? (this.$element.parent(".input-group.bootstrap-timepicker").find(".input-group-addon").on({"click.timepicker": t.proxy(this.showWidget, this)}), this.$element.on({
				"focus.timepicker": t.proxy(this.highlightUnit, this),
				"click.timepicker": t.proxy(this.highlightUnit, this),
				"keydown.timepicker": t.proxy(this.elementKeydown, this),
				"blur.timepicker": t.proxy(this.blurElement, this),
				"mousewheel.timepicker DOMMouseScroll.timepicker": t.proxy(this.mousewheel, this)
			})) : this.template ? this.$element.on({
				"focus.timepicker": t.proxy(this.showWidget, this),
				"click.timepicker": t.proxy(this.showWidget, this),
				"blur.timepicker": t.proxy(this.blurElement, this),
				"mousewheel.timepicker DOMMouseScroll.timepicker": t.proxy(this.mousewheel, this)
			}) : this.$element.on({
				"focus.timepicker": t.proxy(this.highlightUnit, this),
				"click.timepicker": t.proxy(this.highlightUnit, this),
				"keydown.timepicker": t.proxy(this.elementKeydown, this),
				"blur.timepicker": t.proxy(this.blurElement, this),
				"mousewheel.timepicker DOMMouseScroll.timepicker": t.proxy(this.mousewheel, this)
			}), !1 !== this.template ? this.$widget = t(this.getTemplate()).on("click", t.proxy(this.widgetClick, this)) : this.$widget = !1, this.showInputs && !1 !== this.$widget && this.$widget.find("input").each(function () {
				t(this).on({
					"click.timepicker": function () {
						t(this).select()
					}, "keydown.timepicker": t.proxy(e.widgetKeydown, e), "keyup.timepicker": t.proxy(e.widgetKeyup, e)
				})
			}), this.setDefaultTime(this.defaultTime)
		}, blurElement: function () {
			this.highlightedUnit = null, this.updateFromElementVal()
		}, clear: function () {
			this.hour = "", this.minute = "", this.second = "", this.meridian = "", this.$element.val("")
		}, decrementHour: function () {
			if (this.showMeridian) if (1 === this.hour) this.hour = 12; else {
				if (12 === this.hour) return this.hour--, this.toggleMeridian();
				if (0 === this.hour) return this.hour = 11, this.toggleMeridian();
				this.hour--
			} else this.hour <= 0 ? this.hour = this.maxHours - 1 : this.hour--
		}, decrementMinute: function (t) {
			var e;
			0 > (e = t ? this.minute - t : this.minute - this.minuteStep) ? (this.decrementHour(), this.minute = e + 60) : this.minute = e
		}, decrementSecond: function () {
			var t = this.second - this.secondStep;
			0 > t ? (this.decrementMinute(!0), this.second = t + 60) : this.second = t
		}, elementKeydown: function (t) {
			switch (t.which) {
				case 9:
					if (t.shiftKey) {
						if ("hour" === this.highlightedUnit) {
							this.hideWidget();
							break
						}
						this.highlightPrevUnit()
					} else {
						if (this.showMeridian && "meridian" === this.highlightedUnit || this.showSeconds && "second" === this.highlightedUnit || !this.showMeridian && !this.showSeconds && "minute" === this.highlightedUnit) {
							this.hideWidget();
							break
						}
						this.highlightNextUnit()
					}
					t.preventDefault(), this.updateFromElementVal();
					break;
				case 27:
					this.updateFromElementVal();
					break;
				case 37:
					t.preventDefault(), this.highlightPrevUnit(), this.updateFromElementVal();
					break;
				case 38:
					switch (t.preventDefault(), this.highlightedUnit) {
						case"hour":
							this.incrementHour(), this.highlightHour();
							break;
						case"minute":
							this.incrementMinute(), this.highlightMinute();
							break;
						case"second":
							this.incrementSecond(), this.highlightSecond();
							break;
						case"meridian":
							this.toggleMeridian(), this.highlightMeridian()
					}
					this.update();
					break;
				case 39:
					t.preventDefault(), this.highlightNextUnit(), this.updateFromElementVal();
					break;
				case 40:
					switch (t.preventDefault(), this.highlightedUnit) {
						case"hour":
							this.decrementHour(), this.highlightHour();
							break;
						case"minute":
							this.decrementMinute(), this.highlightMinute();
							break;
						case"second":
							this.decrementSecond(), this.highlightSecond();
							break;
						case"meridian":
							this.toggleMeridian(), this.highlightMeridian()
					}
					this.update()
			}
		}, getCursorPosition: function () {
			var t = this.$element.get(0);
			if ("selectionStart" in t) return t.selectionStart;
			if (i.selection) {
				t.focus();
				var e = i.selection.createRange(), n = i.selection.createRange().text.length;
				return e.moveStart("character", -t.value.length), e.text.length - n
			}
		}, getTemplate: function () {
			var t, e, i, n, r, o;
			switch (this.showInputs ? (e = '<input type="text" class="bootstrap-timepicker-hour" maxlength="2"/>', i = '<input type="text" class="bootstrap-timepicker-minute" maxlength="2"/>', n = '<input type="text" class="bootstrap-timepicker-second" maxlength="2"/>', r = '<input type="text" class="bootstrap-timepicker-meridian" maxlength="2"/>') : (e = '<span class="bootstrap-timepicker-hour"></span>', i = '<span class="bootstrap-timepicker-minute"></span>', n = '<span class="bootstrap-timepicker-second"></span>', r = '<span class="bootstrap-timepicker-meridian"></span>'), o = '<table><tr><td><a href="#" data-action="incrementHour"><span class="' + this.icons.up + '"></span></a></td><td class="separator">&nbsp;</td><td><a href="#" data-action="incrementMinute"><span class="' + this.icons.up + '"></span></a></td>' + (this.showSeconds ? '<td class="separator">&nbsp;</td><td><a href="#" data-action="incrementSecond"><span class="' + this.icons.up + '"></span></a></td>' : "") + (this.showMeridian ? '<td class="separator">&nbsp;</td><td class="meridian-column"><a href="#" data-action="toggleMeridian"><span class="' + this.icons.up + '"></span></a></td>' : "") + "</tr><tr><td>" + e + '</td> <td class="separator">:</td><td>' + i + "</td> " + (this.showSeconds ? '<td class="separator">:</td><td>' + n + "</td>" : "") + (this.showMeridian ? '<td class="separator">&nbsp;</td><td>' + r + "</td>" : "") + '</tr><tr><td><a href="#" data-action="decrementHour"><span class="' + this.icons.down + '"></span></a></td><td class="separator"></td><td><a href="#" data-action="decrementMinute"><span class="' + this.icons.down + '"></span></a></td>' + (this.showSeconds ? '<td class="separator">&nbsp;</td><td><a href="#" data-action="decrementSecond"><span class="' + this.icons.down + '"></span></a></td>' : "") + (this.showMeridian ? '<td class="separator">&nbsp;</td><td><a href="#" data-action="toggleMeridian"><span class="' + this.icons.down + '"></span></a></td>' : "") + "</tr></table>", this.template) {
				case"modal":
					t = '<div class="bootstrap-timepicker-widget modal hide fade in" data-backdrop="' + (this.modalBackdrop ? "true" : "false") + '"><div class="modal-header"><a href="#" class="close" data-dismiss="modal">&times;</a><h3>Pick a Time</h3></div><div class="modal-content">' + o + '</div><div class="modal-footer"><a href="#" class="btn btn-primary" data-dismiss="modal">OK</a></div></div>';
					break;
				case"dropdown":
					t = '<div class="bootstrap-timepicker-widget dropdown-menu">' + o + "</div>"
			}
			return t
		}, getTime: function () {
			return "" === this.hour ? "" : this.hour + ":" + (1 === this.minute.toString().length ? "0" + this.minute : this.minute) + (this.showSeconds ? ":" + (1 === this.second.toString().length ? "0" + this.second : this.second) : "") + (this.showMeridian ? " " + this.meridian : "")
		}, hideWidget: function () {
			!1 !== this.isOpen && (this.$element.trigger({
				type: "hide.timepicker",
				time: {value: this.getTime(), hours: this.hour, minutes: this.minute, seconds: this.second, meridian: this.meridian}
			}), "modal" === this.template && this.$widget.modal ? this.$widget.modal("hide") : this.$widget.removeClass("open"), t(i).off("mousedown.timepicker, touchend.timepicker", this.handleDocumentClick), this.isOpen = !1, this.$widget.detach())
		}, highlightUnit: function () {
			this.position = this.getCursorPosition(), this.position >= 0 && this.position <= 2 ? this.highlightHour() : this.position >= 3 && this.position <= 5 ? this.highlightMinute() : this.position >= 6 && this.position <= 8 ? this.showSeconds ? this.highlightSecond() : this.highlightMeridian() : this.position >= 9 && this.position <= 11 && this.highlightMeridian()
		}, highlightNextUnit: function () {
			switch (this.highlightedUnit) {
				case"hour":
					this.highlightMinute();
					break;
				case"minute":
					this.showSeconds ? this.highlightSecond() : this.showMeridian ? this.highlightMeridian() : this.highlightHour();
					break;
				case"second":
					this.showMeridian ? this.highlightMeridian() : this.highlightHour();
					break;
				case"meridian":
					this.highlightHour()
			}
		}, highlightPrevUnit: function () {
			switch (this.highlightedUnit) {
				case"hour":
					this.showMeridian ? this.highlightMeridian() : this.showSeconds ? this.highlightSecond() : this.highlightMinute();
					break;
				case"minute":
					this.highlightHour();
					break;
				case"second":
					this.highlightMinute();
					break;
				case"meridian":
					this.showSeconds ? this.highlightSecond() : this.highlightMinute()
			}
		}, highlightHour: function () {
			var t = this.$element.get(0), e = this;
			this.highlightedUnit = "hour", t.setSelectionRange && setTimeout(function () {
				e.hour < 10 ? t.setSelectionRange(0, 1) : t.setSelectionRange(0, 2)
			}, 0)
		}, highlightMinute: function () {
			var t = this.$element.get(0), e = this;
			this.highlightedUnit = "minute", t.setSelectionRange && setTimeout(function () {
				e.hour < 10 ? t.setSelectionRange(2, 4) : t.setSelectionRange(3, 5)
			}, 0)
		}, highlightSecond: function () {
			var t = this.$element.get(0), e = this;
			this.highlightedUnit = "second", t.setSelectionRange && setTimeout(function () {
				e.hour < 10 ? t.setSelectionRange(5, 7) : t.setSelectionRange(6, 8)
			}, 0)
		}, highlightMeridian: function () {
			var t = this.$element.get(0), e = this;
			this.highlightedUnit = "meridian", t.setSelectionRange && (this.showSeconds ? setTimeout(function () {
				e.hour < 10 ? t.setSelectionRange(8, 10) : t.setSelectionRange(9, 11)
			}, 0) : setTimeout(function () {
				e.hour < 10 ? t.setSelectionRange(5, 7) : t.setSelectionRange(6, 8)
			}, 0))
		}, incrementHour: function () {
			if (this.showMeridian) {
				if (11 === this.hour) return this.hour++, this.toggleMeridian();
				12 === this.hour && (this.hour = 0)
			}
			return this.hour === this.maxHours - 1 ? void (this.hour = 0) : void this.hour++
		}, incrementMinute: function (t) {
			var e;
			(e = t ? this.minute + t : this.minute + this.minuteStep - this.minute % this.minuteStep) > 59 ? (this.incrementHour(), this.minute = e - 60) : this.minute = e
		}, incrementSecond: function () {
			var t = this.second + this.secondStep - this.second % this.secondStep;
			t > 59 ? (this.incrementMinute(!0), this.second = t - 60) : this.second = t
		}, mousewheel: function (e) {
			if (!this.disableMousewheel) {
				e.preventDefault(), e.stopPropagation();
				var i = e.originalEvent.wheelDelta || -e.originalEvent.detail, n = null;
				switch ("mousewheel" === e.type ? n = -1 * e.originalEvent.wheelDelta : "DOMMouseScroll" === e.type && (n = 40 * e.originalEvent.detail), n && (e.preventDefault(), t(this).scrollTop(n + t(this).scrollTop())), this.highlightedUnit) {
					case"minute":
						i > 0 ? this.incrementMinute() : this.decrementMinute(), this.highlightMinute();
						break;
					case"second":
						i > 0 ? this.incrementSecond() : this.decrementSecond(), this.highlightSecond();
						break;
					case"meridian":
						this.toggleMeridian(), this.highlightMeridian();
						break;
					default:
						i > 0 ? this.incrementHour() : this.decrementHour(), this.highlightHour()
				}
				return !1
			}
		}, changeToNearestStep: function (t, e) {
			return t % e == 0 ? t : Math.round(t % e / e) ? (t + (e - t % e)) % 60 : t - t % e
		}, place: function () {
			if (!this.isInline) {
				var i = this.$widget.outerWidth(), n = this.$widget.outerHeight(), r = t(e).width(), o = t(e).height(), a = t(e).scrollTop(), s = parseInt(this.$element.parents().filter(function () {
						return "auto" !== t(this).css("z-index")
					}).first().css("z-index"), 10) + 10, l = this.component ? this.component.parent().offset() : this.$element.offset(), c = this.component ? this.component.outerHeight(!0) : this.$element.outerHeight(!1), u = this.component ? this.component.outerWidth(!0) : this.$element.outerWidth(!1),
					h = l.left, d = l.top;
				this.$widget.removeClass("timepicker-orient-top timepicker-orient-bottom timepicker-orient-right timepicker-orient-left"), "auto" !== this.orientation.x ? (this.$widget.addClass("timepicker-orient-" + this.orientation.x), "right" === this.orientation.x && (h -= i - u)) : (this.$widget.addClass("timepicker-orient-left"), l.left < 0 ? h -= l.left - 10 : l.left + i > r && (h = r - i - 10));
				var p, f, m = this.orientation.y;
				"auto" === m && (p = -a + l.top - n, f = a + o - (l.top + c + n), m = Math.max(p, f) === f ? "top" : "bottom"), this.$widget.addClass("timepicker-orient-" + m), "top" === m ? d += c : d -= n + parseInt(this.$widget.css("padding-top"), 10), this.$widget.css({top: d, left: h, zIndex: s})
			}
		}, remove: function () {
			t("document").off(".timepicker"), this.$widget && this.$widget.remove(), delete this.$element.data().timepicker
		}, setDefaultTime: function (t) {
			if (this.$element.val()) this.updateFromElementVal(); else if ("current" === t) {
				var e = new Date, i = e.getHours(), n = e.getMinutes(), r = e.getSeconds(), o = "AM";
				0 !== r && (60 === (r = Math.ceil(e.getSeconds() / this.secondStep) * this.secondStep) && (n += 1, r = 0)), 0 !== n && (60 === (n = Math.ceil(e.getMinutes() / this.minuteStep) * this.minuteStep) && (i += 1, n = 0)), this.showMeridian && (0 === i ? i = 12 : i >= 12 ? (i > 12 && (i -= 12), o = "PM") : o = "AM"), this.hour = i, this.minute = n, this.second = r, this.meridian = o, this.update()
			} else !1 === t ? (this.hour = 0, this.minute = 0, this.second = 0, this.meridian = "AM") : this.setTime(t)
		}, setTime: function (t, e) {
			if (t) {
				var i, n, r, o, a, s;
				if ("object" == typeof t && t.getMonth) r = t.getHours(), o = t.getMinutes(), a = t.getSeconds(), this.showMeridian && (s = "AM", r > 12 && (s = "PM", r %= 12), 12 === r && (s = "PM")); else {
					if ((i = (/a/i.test(t) ? 1 : 0) + (/p/i.test(t) ? 2 : 0)) > 2) return void this.clear();
					if (r = (n = t.replace(/[^0-9\:]/g, "").split(":"))[0] ? n[0].toString() : n.toString(), this.explicitMode && r.length > 2 && r.length % 2 != 0) return void this.clear();
					o = n[1] ? n[1].toString() : "", a = n[2] ? n[2].toString() : "", r.length > 4 && (a = r.slice(-2), r = r.slice(0, -2)), r.length > 2 && (o = r.slice(-2), r = r.slice(0, -2)), o.length > 2 && (a = o.slice(-2), o = o.slice(0, -2)), r = parseInt(r, 10), o = parseInt(o, 10), a = parseInt(a, 10), isNaN(r) && (r = 0), isNaN(o) && (o = 0), isNaN(a) && (a = 0), a > 59 && (a = 59), o > 59 && (o = 59), r >= this.maxHours && (r = this.maxHours - 1), this.showMeridian ? (r > 12 && (i = 2, r -= 12), i || (i = 1), 0 === r && (r = 12), s = 1 === i ? "AM" : "PM") : 12 > r && 2 === i ? r += 12 : r >= this.maxHours ? r = this.maxHours - 1 : (0 > r || 12 === r && 1 === i) && (r = 0)
				}
				this.hour = r, this.snapToStep ? (this.minute = this.changeToNearestStep(o, this.minuteStep), this.second = this.changeToNearestStep(a, this.secondStep)) : (this.minute = o, this.second = a), this.meridian = s, this.update(e)
			} else this.clear()
		}, showWidget: function () {
			this.isOpen || this.$element.is(":disabled") || (this.$widget.appendTo(this.appendWidgetTo), t(i).on("mousedown.timepicker, touchend.timepicker", {scope: this}, this.handleDocumentClick), this.$element.trigger({
				type: "show.timepicker",
				time: {value: this.getTime(), hours: this.hour, minutes: this.minute, seconds: this.second, meridian: this.meridian}
			}), this.place(), this.disableFocus && this.$element.blur(), "" === this.hour && (this.defaultTime ? this.setDefaultTime(this.defaultTime) : this.setTime("0:0:0")), "modal" === this.template && this.$widget.modal ? this.$widget.modal("show").on("hidden", t.proxy(this.hideWidget, this)) : !1 === this.isOpen && this.$widget.addClass("open"), this.isOpen = !0)
		}, toggleMeridian: function () {
			this.meridian = "AM" === this.meridian ? "PM" : "AM"
		}, update: function (t) {
			this.updateElement(), t || this.updateWidget(), this.$element.trigger({type: "changeTime.timepicker", time: {value: this.getTime(), hours: this.hour, minutes: this.minute, seconds: this.second, meridian: this.meridian}})
		}, updateElement: function () {
			this.$element.val(this.getTime()).change()
		}, updateFromElementVal: function () {
			this.setTime(this.$element.val())
		}, updateWidget: function () {
			if (!1 !== this.$widget) {
				var t = this.hour, e = 1 === this.minute.toString().length ? "0" + this.minute : this.minute, i = 1 === this.second.toString().length ? "0" + this.second : this.second;
				this.showInputs ? (this.$widget.find("input.bootstrap-timepicker-hour").val(t), this.$widget.find("input.bootstrap-timepicker-minute").val(e), this.showSeconds && this.$widget.find("input.bootstrap-timepicker-second").val(i), this.showMeridian && this.$widget.find("input.bootstrap-timepicker-meridian").val(this.meridian)) : (this.$widget.find("span.bootstrap-timepicker-hour").text(t), this.$widget.find("span.bootstrap-timepicker-minute").text(e), this.showSeconds && this.$widget.find("span.bootstrap-timepicker-second").text(i), this.showMeridian && this.$widget.find("span.bootstrap-timepicker-meridian").text(this.meridian))
			}
		}, updateFromWidgetInputs: function () {
			if (!1 !== this.$widget) {
				var t = this.$widget.find("input.bootstrap-timepicker-hour").val() + ":" + this.$widget.find("input.bootstrap-timepicker-minute").val() + (this.showSeconds ? ":" + this.$widget.find("input.bootstrap-timepicker-second").val() : "") + (this.showMeridian ? this.$widget.find("input.bootstrap-timepicker-meridian").val() : "");
				this.setTime(t, !0)
			}
		}, widgetClick: function (e) {
			e.stopPropagation(), e.preventDefault();
			var i = t(e.target), n = i.closest("a").data("action");
			n && this[n](), this.update(), i.is("input") && i.get(0).setSelectionRange(0, 2)
		}, widgetKeydown: function (e) {
			var i = t(e.target), n = i.attr("class").replace("bootstrap-timepicker-", "");
			switch (e.which) {
				case 9:
					if (e.shiftKey) {
						if ("hour" === n) return this.hideWidget()
					} else if (this.showMeridian && "meridian" === n || this.showSeconds && "second" === n || !this.showMeridian && !this.showSeconds && "minute" === n) return this.hideWidget();
					break;
				case 27:
					this.hideWidget();
					break;
				case 38:
					switch (e.preventDefault(), n) {
						case"hour":
							this.incrementHour();
							break;
						case"minute":
							this.incrementMinute();
							break;
						case"second":
							this.incrementSecond();
							break;
						case"meridian":
							this.toggleMeridian()
					}
					this.setTime(this.getTime()), i.get(0).setSelectionRange(0, 2);
					break;
				case 40:
					switch (e.preventDefault(), n) {
						case"hour":
							this.decrementHour();
							break;
						case"minute":
							this.decrementMinute();
							break;
						case"second":
							this.decrementSecond();
							break;
						case"meridian":
							this.toggleMeridian()
					}
					this.setTime(this.getTime()), i.get(0).setSelectionRange(0, 2)
			}
		}, widgetKeyup: function (t) {
			(65 === t.which || 77 === t.which || 80 === t.which || 46 === t.which || 8 === t.which || t.which >= 48 && t.which <= 57 || t.which >= 96 && t.which <= 105) && this.updateFromWidgetInputs()
		}
	}, t.fn.timepicker = function (e) {
		var i = Array.apply(null, arguments);
		return i.shift(), this.each(function () {
			var r = t(this), o = r.data("timepicker"), a = "object" == typeof e && e;
			o || r.data("timepicker", o = new n(this, t.extend({}, t.fn.timepicker.defaults, a, t(this).data()))), "string" == typeof e && o[e].apply(o, i)
		})
	}, t.fn.timepicker.defaults = {
		defaultTime: "current",
		disableFocus: !1,
		disableMousewheel: !1,
		isOpen: !1,
		minuteStep: 15,
		modalBackdrop: !1,
		orientation: {x: "auto", y: "auto"},
		secondStep: 15,
		snapToStep: !1,
		showSeconds: !1,
		showInputs: !0,
		showMeridian: !0,
		template: "dropdown",
		appendWidgetTo: "body",
		showWidgetOnAddonClick: !0,
		icons: {up: "glyphicon glyphicon-chevron-up", down: "glyphicon glyphicon-chevron-down"},
		maxHours: 24,
		explicitMode: !1
	}, t.fn.timepicker.Constructor = n, t(i).on("focus.timepicker.data-api click.timepicker.data-api", '[data-provide="timepicker"]', function (e) {
		var i = t(this);
		i.data("timepicker") || (e.preventDefault(), i.timepicker())
	})
}(jQuery, window, document), $.fn.timepicker.defaults = $.extend(!0, {}, $.fn.timepicker.defaults, {icons: {up: "la la-angle-up", down: "la la-angle-down"}}), function (t, e) {
	if ("function" == typeof define && define.amd) define(["moment", "jquery"], function (t, i) {
		return i.fn || (i.fn = {}), e(t, i)
	}); else if ("object" == typeof module && module.exports) {
		var i = "undefined" != typeof window ? window.jQuery : void 0;
		i || (i = require("jquery")).fn || (i.fn = {});
		var n = "undefined" != typeof window && void 0 !== window.moment ? window.moment : require("moment");
		module.exports = e(n, i)
	} else t.daterangepicker = e(t.moment, t.jQuery)
}(this, function (t, e) {
	var i = function (i, n, r) {
		if (this.parentEl = "body", this.element = e(i), this.startDate = t().startOf("day"), this.endDate = t().endOf("day"), this.minDate = !1, this.maxDate = !1, this.dateLimit = !1, this.autoApply = !1, this.singleDatePicker = !1, this.showDropdowns = !1, this.showWeekNumbers = !1, this.showISOWeekNumbers = !1, this.showCustomRangeLabel = !0, this.timePicker = !1, this.timePicker24Hour = !1, this.timePickerIncrement = 1, this.timePickerSeconds = !1, this.linkedCalendars = !0, this.autoUpdateInput = !0, this.alwaysShowCalendars = !1, this.ranges = {}, this.opens = "right", this.element.hasClass("pull-right") && (this.opens = "left"), this.drops = "down", this.element.hasClass("dropup") && (this.drops = "up"), this.buttonClasses = "btn btn-sm", this.applyClass = "btn-success", this.cancelClass = "btn-default", this.locale = {
			direction: "ltr",
			format: t.localeData().longDateFormat("L"),
			separator: " - ",
			applyLabel: "Apply",
			cancelLabel: "Cancel",
			weekLabel: "W",
			customRangeLabel: "Custom Range",
			daysOfWeek: t.weekdaysMin(),
			monthNames: t.monthsShort(),
			firstDay: t.localeData().firstDayOfWeek()
		}, this.callback = function () {
		}, this.isShowing = !1, this.leftCalendar = {}, this.rightCalendar = {}, "object" == typeof n && null !== n || (n = {}), "string" == typeof (n = e.extend(this.element.data(), n)).template || n.template instanceof e || (n.template = '<div class="daterangepicker dropdown-menu"><div class="calendar left"><div class="daterangepicker_input"><input class="input-mini form-control" type="text" name="daterangepicker_start" value="" /><i class="fa fa-calendar glyphicon glyphicon-calendar"></i><div class="calendar-time"><div></div><i class="fa fa-clock-o glyphicon glyphicon-time"></i></div></div><div class="calendar-table"></div></div><div class="calendar right"><div class="daterangepicker_input"><input class="input-mini form-control" type="text" name="daterangepicker_end" value="" /><i class="fa fa-calendar glyphicon glyphicon-calendar"></i><div class="calendar-time"><div></div><i class="fa fa-clock-o glyphicon glyphicon-time"></i></div></div><div class="calendar-table"></div></div><div class="ranges"><div class="range_inputs"><button class="applyBtn" disabled="disabled" type="button"></button> <button class="cancelBtn" type="button"></button></div></div></div>'), this.parentEl = n.parentEl && e(n.parentEl).length ? e(n.parentEl) : e(this.parentEl), this.container = e(n.template).appendTo(this.parentEl), "object" == typeof n.locale && ("string" == typeof n.locale.direction && (this.locale.direction = n.locale.direction), "string" == typeof n.locale.format && (this.locale.format = n.locale.format), "string" == typeof n.locale.separator && (this.locale.separator = n.locale.separator), "object" == typeof n.locale.daysOfWeek && (this.locale.daysOfWeek = n.locale.daysOfWeek.slice()), "object" == typeof n.locale.monthNames && (this.locale.monthNames = n.locale.monthNames.slice()), "number" == typeof n.locale.firstDay && (this.locale.firstDay = n.locale.firstDay), "string" == typeof n.locale.applyLabel && (this.locale.applyLabel = n.locale.applyLabel), "string" == typeof n.locale.cancelLabel && (this.locale.cancelLabel = n.locale.cancelLabel), "string" == typeof n.locale.weekLabel && (this.locale.weekLabel = n.locale.weekLabel), "string" == typeof n.locale.customRangeLabel)) {
			(p = document.createElement("textarea")).innerHTML = n.locale.customRangeLabel;
			var o = p.value;
			this.locale.customRangeLabel = o
		}
		if (this.container.addClass(this.locale.direction), "string" == typeof n.startDate && (this.startDate = t(n.startDate, this.locale.format)), "string" == typeof n.endDate && (this.endDate = t(n.endDate, this.locale.format)), "string" == typeof n.minDate && (this.minDate = t(n.minDate, this.locale.format)), "string" == typeof n.maxDate && (this.maxDate = t(n.maxDate, this.locale.format)), "object" == typeof n.startDate && (this.startDate = t(n.startDate)), "object" == typeof n.endDate && (this.endDate = t(n.endDate)), "object" == typeof n.minDate && (this.minDate = t(n.minDate)), "object" == typeof n.maxDate && (this.maxDate = t(n.maxDate)), this.minDate && this.startDate.isBefore(this.minDate) && (this.startDate = this.minDate.clone()), this.maxDate && this.endDate.isAfter(this.maxDate) && (this.endDate = this.maxDate.clone()), "string" == typeof n.applyClass && (this.applyClass = n.applyClass), "string" == typeof n.cancelClass && (this.cancelClass = n.cancelClass), "object" == typeof n.dateLimit && (this.dateLimit = n.dateLimit), "string" == typeof n.opens && (this.opens = n.opens), "string" == typeof n.drops && (this.drops = n.drops), "boolean" == typeof n.showWeekNumbers && (this.showWeekNumbers = n.showWeekNumbers), "boolean" == typeof n.showISOWeekNumbers && (this.showISOWeekNumbers = n.showISOWeekNumbers), "string" == typeof n.buttonClasses && (this.buttonClasses = n.buttonClasses), "object" == typeof n.buttonClasses && (this.buttonClasses = n.buttonClasses.join(" ")), "boolean" == typeof n.showDropdowns && (this.showDropdowns = n.showDropdowns), "boolean" == typeof n.showCustomRangeLabel && (this.showCustomRangeLabel = n.showCustomRangeLabel), "boolean" == typeof n.singleDatePicker && (this.singleDatePicker = n.singleDatePicker, this.singleDatePicker && (this.endDate = this.startDate.clone())), "boolean" == typeof n.timePicker && (this.timePicker = n.timePicker), "boolean" == typeof n.timePickerSeconds && (this.timePickerSeconds = n.timePickerSeconds), "number" == typeof n.timePickerIncrement && (this.timePickerIncrement = n.timePickerIncrement), "boolean" == typeof n.timePicker24Hour && (this.timePicker24Hour = n.timePicker24Hour), "boolean" == typeof n.autoApply && (this.autoApply = n.autoApply), "boolean" == typeof n.autoUpdateInput && (this.autoUpdateInput = n.autoUpdateInput), "boolean" == typeof n.linkedCalendars && (this.linkedCalendars = n.linkedCalendars), "function" == typeof n.isInvalidDate && (this.isInvalidDate = n.isInvalidDate), "function" == typeof n.isCustomDate && (this.isCustomDate = n.isCustomDate), "boolean" == typeof n.alwaysShowCalendars && (this.alwaysShowCalendars = n.alwaysShowCalendars), 0 != this.locale.firstDay) for (var a = this.locale.firstDay; a > 0;) this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift()), a--;
		var s, l, c;
		if (void 0 === n.startDate && void 0 === n.endDate && e(this.element).is("input[type=text]")) {
			var u = e(this.element).val(), h = u.split(this.locale.separator);
			s = l = null, 2 == h.length ? (s = t(h[0], this.locale.format), l = t(h[1], this.locale.format)) : this.singleDatePicker && "" !== u && (s = t(u, this.locale.format), l = t(u, this.locale.format)), null !== s && null !== l && (this.setStartDate(s), this.setEndDate(l))
		}
		if ("object" == typeof n.ranges) {
			for (c in n.ranges) {
				s = "string" == typeof n.ranges[c][0] ? t(n.ranges[c][0], this.locale.format) : t(n.ranges[c][0]), l = "string" == typeof n.ranges[c][1] ? t(n.ranges[c][1], this.locale.format) : t(n.ranges[c][1]), this.minDate && s.isBefore(this.minDate) && (s = this.minDate.clone());
				var d = this.maxDate;
				if (this.dateLimit && d && s.clone().add(this.dateLimit).isAfter(d) && (d = s.clone().add(this.dateLimit)), d && l.isAfter(d) && (l = d.clone()), !(this.minDate && l.isBefore(this.minDate, this.timepicker ? "minute" : "day") || d && s.isAfter(d, this.timepicker ? "minute" : "day"))) {
					var p;
					(p = document.createElement("textarea")).innerHTML = c;
					o = p.value;
					this.ranges[o] = [s, l]
				}
			}
			var f = "<ul>";
			for (c in this.ranges) f += '<li data-range-key="' + c + '">' + c + "</li>";
			this.showCustomRangeLabel && (f += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + "</li>"), f += "</ul>", this.container.find(".ranges").prepend(f)
		}
		"function" == typeof r && (this.callback = r), this.timePicker || (this.startDate = this.startDate.startOf("day"), this.endDate = this.endDate.endOf("day"), this.container.find(".calendar-time").hide()), this.timePicker && this.autoApply && (this.autoApply = !1), this.autoApply && "object" != typeof n.ranges ? this.container.find(".ranges").hide() : this.autoApply && this.container.find(".applyBtn, .cancelBtn").addClass("hide"), this.singleDatePicker && (this.container.addClass("single"), this.container.find(".calendar.left").addClass("single"), this.container.find(".calendar.left").show(), this.container.find(".calendar.right").hide(), this.container.find(".daterangepicker_input input, .daterangepicker_input > i").hide(), this.timePicker ? this.container.find(".ranges ul").hide() : this.container.find(".ranges").hide()), (void 0 === n.ranges && !this.singleDatePicker || this.alwaysShowCalendars) && this.container.addClass("show-calendar"), this.container.addClass("opens" + this.opens), void 0 !== n.ranges && "right" == this.opens && this.container.find(".ranges").prependTo(this.container.find(".calendar.left").parent()), this.container.find(".applyBtn, .cancelBtn").addClass(this.buttonClasses), this.applyClass.length && this.container.find(".applyBtn").addClass(this.applyClass), this.cancelClass.length && this.container.find(".cancelBtn").addClass(this.cancelClass), this.container.find(".applyBtn").html(this.locale.applyLabel), this.container.find(".cancelBtn").html(this.locale.cancelLabel), this.container.find(".calendar").on("click.daterangepicker", ".prev", e.proxy(this.clickPrev, this)).on("click.daterangepicker", ".next", e.proxy(this.clickNext, this)).on("mousedown.daterangepicker", "td.available", e.proxy(this.clickDate, this)).on("mouseenter.daterangepicker", "td.available", e.proxy(this.hoverDate, this)).on("mouseleave.daterangepicker", "td.available", e.proxy(this.updateFormInputs, this)).on("change.daterangepicker", "select.yearselect", e.proxy(this.monthOrYearChanged, this)).on("change.daterangepicker", "select.monthselect", e.proxy(this.monthOrYearChanged, this)).on("change.daterangepicker", "select.hourselect,select.minuteselect,select.secondselect,select.ampmselect", e.proxy(this.timeChanged, this)).on("click.daterangepicker", ".daterangepicker_input input", e.proxy(this.showCalendars, this)).on("focus.daterangepicker", ".daterangepicker_input input", e.proxy(this.formInputsFocused, this)).on("blur.daterangepicker", ".daterangepicker_input input", e.proxy(this.formInputsBlurred, this)).on("change.daterangepicker", ".daterangepicker_input input", e.proxy(this.formInputsChanged, this)).on("keydown.daterangepicker", ".daterangepicker_input input", e.proxy(this.formInputsKeydown, this)), this.container.find(".ranges").on("click.daterangepicker", "button.applyBtn", e.proxy(this.clickApply, this)).on("click.daterangepicker", "button.cancelBtn", e.proxy(this.clickCancel, this)).on("click.daterangepicker", "li", e.proxy(this.clickRange, this)).on("mouseenter.daterangepicker", "li", e.proxy(this.hoverRange, this)).on("mouseleave.daterangepicker", "li", e.proxy(this.updateFormInputs, this)), this.element.is("input") || this.element.is("button") ? this.element.on({
			"click.daterangepicker": e.proxy(this.show, this),
			"focus.daterangepicker": e.proxy(this.show, this),
			"keyup.daterangepicker": e.proxy(this.elementChanged, this),
			"keydown.daterangepicker": e.proxy(this.keydown, this)
		}) : (this.element.on("click.daterangepicker", e.proxy(this.toggle, this)), this.element.on("keydown.daterangepicker", e.proxy(this.toggle, this))), this.element.is("input") && !this.singleDatePicker && this.autoUpdateInput ? (this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format)), this.element.trigger("change")) : this.element.is("input") && this.autoUpdateInput && (this.element.val(this.startDate.format(this.locale.format)), this.element.trigger("change"))
	};
	return i.prototype = {
		constructor: i, setStartDate: function (e) {
			"string" == typeof e && (this.startDate = t(e, this.locale.format)), "object" == typeof e && (this.startDate = t(e)), this.timePicker || (this.startDate = this.startDate.startOf("day")), this.timePicker && this.timePickerIncrement && this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement), this.minDate && this.startDate.isBefore(this.minDate) && (this.startDate = this.minDate.clone(), this.timePicker && this.timePickerIncrement && this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement)), this.maxDate && this.startDate.isAfter(this.maxDate) && (this.startDate = this.maxDate.clone(), this.timePicker && this.timePickerIncrement && this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement)), this.isShowing || this.updateElement(), this.updateMonthsInView()
		}, setEndDate: function (e) {
			"string" == typeof e && (this.endDate = t(e, this.locale.format)), "object" == typeof e && (this.endDate = t(e)), this.timePicker || (this.endDate = this.endDate.add(1, "d").startOf("day").subtract(1, "second")), this.timePicker && this.timePickerIncrement && this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement), this.endDate.isBefore(this.startDate) && (this.endDate = this.startDate.clone()), this.maxDate && this.endDate.isAfter(this.maxDate) && (this.endDate = this.maxDate.clone()), this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate) && (this.endDate = this.startDate.clone().add(this.dateLimit)), this.previousRightTime = this.endDate.clone(), this.isShowing || this.updateElement(), this.updateMonthsInView()
		}, isInvalidDate: function () {
			return !1
		}, isCustomDate: function () {
			return !1
		}, updateView: function () {
			this.timePicker && (this.renderTimePicker("left"), this.renderTimePicker("right"), this.endDate ? this.container.find(".right .calendar-time select").removeAttr("disabled").removeClass("disabled") : this.container.find(".right .calendar-time select").attr("disabled", "disabled").addClass("disabled")), this.endDate ? (this.container.find('input[name="daterangepicker_end"]').removeClass("active"), this.container.find('input[name="daterangepicker_start"]').addClass("active")) : (this.container.find('input[name="daterangepicker_end"]').addClass("active"), this.container.find('input[name="daterangepicker_start"]').removeClass("active")), this.updateMonthsInView(), this.updateCalendars(), this.updateFormInputs()
		}, updateMonthsInView: function () {
			if (this.endDate) {
				if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate.format("YYYY-MM") == this.leftCalendar.month.format("YYYY-MM") || this.startDate.format("YYYY-MM") == this.rightCalendar.month.format("YYYY-MM")) && (this.endDate.format("YYYY-MM") == this.leftCalendar.month.format("YYYY-MM") || this.endDate.format("YYYY-MM") == this.rightCalendar.month.format("YYYY-MM"))) return;
				this.leftCalendar.month = this.startDate.clone().date(2), this.linkedCalendars || this.endDate.month() == this.startDate.month() && this.endDate.year() == this.startDate.year() ? this.rightCalendar.month = this.startDate.clone().date(2).add(1, "month") : this.rightCalendar.month = this.endDate.clone().date(2)
			} else this.leftCalendar.month.format("YYYY-MM") != this.startDate.format("YYYY-MM") && this.rightCalendar.month.format("YYYY-MM") != this.startDate.format("YYYY-MM") && (this.leftCalendar.month = this.startDate.clone().date(2), this.rightCalendar.month = this.startDate.clone().date(2).add(1, "month"));
			this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate && (this.rightCalendar.month = this.maxDate.clone().date(2), this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, "month"))
		}, updateCalendars: function () {
			if (this.timePicker) {
				var t, e, i, n;
				if (this.endDate) {
					if (t = parseInt(this.container.find(".left .hourselect").val(), 10), e = parseInt(this.container.find(".left .minuteselect").val(), 10), i = this.timePickerSeconds ? parseInt(this.container.find(".left .secondselect").val(), 10) : 0, !this.timePicker24Hour) "PM" === (n = this.container.find(".left .ampmselect").val()) && t < 12 && (t += 12), "AM" === n && 12 === t && (t = 0)
				} else if (t = parseInt(this.container.find(".right .hourselect").val(), 10), e = parseInt(this.container.find(".right .minuteselect").val(), 10), i = this.timePickerSeconds ? parseInt(this.container.find(".right .secondselect").val(), 10) : 0, !this.timePicker24Hour) "PM" === (n = this.container.find(".right .ampmselect").val()) && t < 12 && (t += 12), "AM" === n && 12 === t && (t = 0);
				this.leftCalendar.month.hour(t).minute(e).second(i), this.rightCalendar.month.hour(t).minute(e).second(i)
			}
			this.renderCalendar("left"), this.renderCalendar("right"), this.container.find(".ranges li").removeClass("active"), null != this.endDate && this.calculateChosenLabel()
		}, renderCalendar: function (i) {
			var n, r = (n = "left" == i ? this.leftCalendar : this.rightCalendar).month.month(), o = n.month.year(), a = n.month.hour(), s = n.month.minute(), l = n.month.second(), c = t([o, r]).daysInMonth(), u = t([o, r, 1]), h = t([o, r, c]), d = t(u).subtract(1, "month").month(),
				p = t(u).subtract(1, "month").year(), f = t([p, d]).daysInMonth(), m = u.day();
			(n = []).firstDay = u, n.lastDay = h;
			for (var g = 0; g < 6; g++) n[g] = [];
			var v = f - m + this.locale.firstDay + 1;
			v > f && (v -= 7), m == this.locale.firstDay && (v = f - 6);
			for (var y = t([p, d, v, 12, s, l]), b = (g = 0, 0), w = 0; g < 42; g++, b++, y = t(y).add(24, "hour")) g > 0 && b % 7 == 0 && (b = 0, w++), n[w][b] = y.clone().hour(a).minute(s).second(l), y.hour(12), this.minDate && n[w][b].format("YYYY-MM-DD") == this.minDate.format("YYYY-MM-DD") && n[w][b].isBefore(this.minDate) && "left" == i && (n[w][b] = this.minDate.clone()), this.maxDate && n[w][b].format("YYYY-MM-DD") == this.maxDate.format("YYYY-MM-DD") && n[w][b].isAfter(this.maxDate) && "right" == i && (n[w][b] = this.maxDate.clone());
			"left" == i ? this.leftCalendar.calendar = n : this.rightCalendar.calendar = n;
			var x = "left" == i ? this.minDate : this.startDate, k = this.maxDate, _ = ("left" == i ? this.startDate : this.endDate, "ltr" == this.locale.direction ? {left: "chevron-left", right: "chevron-right"} : {left: "chevron-right", right: "chevron-left"}), S = '<table class="table-condensed">';
			S += "<thead>", S += "<tr>", (this.showWeekNumbers || this.showISOWeekNumbers) && (S += "<th></th>"), x && !x.isBefore(n.firstDay) || this.linkedCalendars && "left" != i ? S += "<th></th>" : S += '<th class="prev available"><i class="fa fa-' + _.left + " glyphicon glyphicon-" + _.left + '"></i></th>';
			var C = this.locale.monthNames[n[1][1].month()] + n[1][1].format(" YYYY");
			if (this.showDropdowns) {
				for (var D = n[1][1].month(), T = n[1][1].year(), M = k && k.year() || T + 5, E = x && x.year() || T - 50, A = T == E, P = T == M, I = '<select class="monthselect">', O = 0; O < 12; O++) (!A || O >= x.month()) && (!P || O <= k.month()) ? I += "<option value='" + O + "'" + (O === D ? " selected='selected'" : "") + ">" + this.locale.monthNames[O] + "</option>" : I += "<option value='" + O + "'" + (O === D ? " selected='selected'" : "") + " disabled='disabled'>" + this.locale.monthNames[O] + "</option>";
				I += "</select>";
				for (var L = '<select class="yearselect">', F = E; F <= M; F++) L += '<option value="' + F + '"' + (F === T ? ' selected="selected"' : "") + ">" + F + "</option>";
				C = I + (L += "</select>")
			}
			if (S += '<th colspan="5" class="month">' + C + "</th>", k && !k.isAfter(n.lastDay) || this.linkedCalendars && "right" != i && !this.singleDatePicker ? S += "<th></th>" : S += '<th class="next available"><i class="fa fa-' + _.right + " glyphicon glyphicon-" + _.right + '"></i></th>', S += "</tr>", S += "<tr>", (this.showWeekNumbers || this.showISOWeekNumbers) && (S += '<th class="week">' + this.locale.weekLabel + "</th>"), e.each(this.locale.daysOfWeek, function (t, e) {
				S += "<th>" + e + "</th>"
			}), S += "</tr>", S += "</thead>", S += "<tbody>", null == this.endDate && this.dateLimit) {
				var N = this.startDate.clone().add(this.dateLimit).endOf("day");
				k && !N.isBefore(k) || (k = N)
			}
			for (w = 0; w < 6; w++) {
				S += "<tr>", this.showWeekNumbers ? S += '<td class="week">' + n[w][0].week() + "</td>" : this.showISOWeekNumbers && (S += '<td class="week">' + n[w][0].isoWeek() + "</td>");
				for (b = 0; b < 7; b++) {
					var R = [];
					n[w][b].isSame(new Date, "day") && R.push("today"), n[w][b].isoWeekday() > 5 && R.push("weekend"), n[w][b].month() != n[1][1].month() && R.push("off"), this.minDate && n[w][b].isBefore(this.minDate, "day") && R.push("off", "disabled"), k && n[w][b].isAfter(k, "day") && R.push("off", "disabled"), this.isInvalidDate(n[w][b]) && R.push("off", "disabled"), n[w][b].format("YYYY-MM-DD") == this.startDate.format("YYYY-MM-DD") && R.push("active", "start-date"), null != this.endDate && n[w][b].format("YYYY-MM-DD") == this.endDate.format("YYYY-MM-DD") && R.push("active", "end-date"), null != this.endDate && n[w][b] > this.startDate && n[w][b] < this.endDate && R.push("in-range");
					var H = this.isCustomDate(n[w][b]);
					!1 !== H && ("string" == typeof H ? R.push(H) : Array.prototype.push.apply(R, H));
					var $ = "", B = !1;
					for (g = 0; g < R.length; g++) $ += R[g] + " ", "disabled" == R[g] && (B = !0);
					B || ($ += "available"), S += '<td class="' + $.replace(/^\s+|\s+$/g, "") + '" data-title="r' + w + "c" + b + '">' + n[w][b].date() + "</td>"
				}
				S += "</tr>"
			}
			S += "</tbody>", S += "</table>", this.container.find(".calendar." + i + " .calendar-table").html(S)
		}, renderTimePicker: function (t) {
			if ("right" != t || this.endDate) {
				var e, i, n, r = this.maxDate;
				if (!this.dateLimit || this.maxDate && !this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate) || (r = this.startDate.clone().add(this.dateLimit)), "left" == t) i = this.startDate.clone(), n = this.minDate; else if ("right" == t) {
					i = this.endDate.clone(), n = this.startDate;
					var o = this.container.find(".calendar.right .calendar-time div");
					if ("" != o.html() && (i.hour(o.find(".hourselect option:selected").val() || i.hour()), i.minute(o.find(".minuteselect option:selected").val() || i.minute()), i.second(o.find(".secondselect option:selected").val() || i.second()), !this.timePicker24Hour)) {
						var a = o.find(".ampmselect option:selected").val();
						"PM" === a && i.hour() < 12 && i.hour(i.hour() + 12), "AM" === a && 12 === i.hour() && i.hour(0)
					}
					i.isBefore(this.startDate) && (i = this.startDate.clone()), r && i.isAfter(r) && (i = r.clone())
				}
				e = '<select class="hourselect">';
				for (var s = this.timePicker24Hour ? 0 : 1, l = this.timePicker24Hour ? 23 : 12, c = s; c <= l; c++) {
					var u = c;
					this.timePicker24Hour || (u = i.hour() >= 12 ? 12 == c ? 12 : c + 12 : 12 == c ? 0 : c);
					var h = i.clone().hour(u), d = !1;
					n && h.minute(59).isBefore(n) && (d = !0), r && h.minute(0).isAfter(r) && (d = !0), u != i.hour() || d ? e += d ? '<option value="' + c + '" disabled="disabled" class="disabled">' + c + "</option>" : '<option value="' + c + '">' + c + "</option>" : e += '<option value="' + c + '" selected="selected">' + c + "</option>"
				}
				e += "</select> ", e += ': <select class="minuteselect">';
				for (c = 0; c < 60; c += this.timePickerIncrement) {
					var p = c < 10 ? "0" + c : c;
					h = i.clone().minute(c), d = !1;
					n && h.second(59).isBefore(n) && (d = !0), r && h.second(0).isAfter(r) && (d = !0), i.minute() != c || d ? e += d ? '<option value="' + c + '" disabled="disabled" class="disabled">' + p + "</option>" : '<option value="' + c + '">' + p + "</option>" : e += '<option value="' + c + '" selected="selected">' + p + "</option>"
				}
				if (e += "</select> ", this.timePickerSeconds) {
					e += ': <select class="secondselect">';
					for (c = 0; c < 60; c++) {
						p = c < 10 ? "0" + c : c, h = i.clone().second(c), d = !1;
						n && h.isBefore(n) && (d = !0), r && h.isAfter(r) && (d = !0), i.second() != c || d ? e += d ? '<option value="' + c + '" disabled="disabled" class="disabled">' + p + "</option>" : '<option value="' + c + '">' + p + "</option>" : e += '<option value="' + c + '" selected="selected">' + p + "</option>"
					}
					e += "</select> "
				}
				if (!this.timePicker24Hour) {
					e += '<select class="ampmselect">';
					var f = "", m = "";
					n && i.clone().hour(12).minute(0).second(0).isBefore(n) && (f = ' disabled="disabled" class="disabled"'), r && i.clone().hour(0).minute(0).second(0).isAfter(r) && (m = ' disabled="disabled" class="disabled"'), i.hour() >= 12 ? e += '<option value="AM"' + f + '>AM</option><option value="PM" selected="selected"' + m + ">PM</option>" : e += '<option value="AM" selected="selected"' + f + '>AM</option><option value="PM"' + m + ">PM</option>", e += "</select>"
				}
				this.container.find(".calendar." + t + " .calendar-time div").html(e)
			}
		}, updateFormInputs: function () {
			this.container.find("input[name=daterangepicker_start]").is(":focus") || this.container.find("input[name=daterangepicker_end]").is(":focus") || (this.container.find("input[name=daterangepicker_start]").val(this.startDate.format(this.locale.format)), this.endDate && this.container.find("input[name=daterangepicker_end]").val(this.endDate.format(this.locale.format)), this.singleDatePicker || this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)) ? this.container.find("button.applyBtn").removeAttr("disabled") : this.container.find("button.applyBtn").attr("disabled", "disabled"))
		}, move: function () {
			var t, i = {top: 0, left: 0}, n = e(window).width();
			this.parentEl.is("body") || (i = {
				top: this.parentEl.offset().top - this.parentEl.scrollTop(),
				left: this.parentEl.offset().left - this.parentEl.scrollLeft()
			}, n = this.parentEl[0].clientWidth + this.parentEl.offset().left), t = "up" == this.drops ? this.element.offset().top - this.container.outerHeight() - i.top : this.element.offset().top + this.element.outerHeight() - i.top, this.container["up" == this.drops ? "addClass" : "removeClass"]("dropup"), "left" == this.opens ? (this.container.css({
				top: t,
				right: n - this.element.offset().left - this.element.outerWidth(),
				left: "auto"
			}), this.container.offset().left < 0 && this.container.css({right: "auto", left: 9})) : "center" == this.opens ? (this.container.css({
				top: t,
				left: this.element.offset().left - i.left + this.element.outerWidth() / 2 - this.container.outerWidth() / 2,
				right: "auto"
			}), this.container.offset().left < 0 && this.container.css({right: "auto", left: 9})) : (this.container.css({
				top: t,
				left: this.element.offset().left - i.left,
				right: "auto"
			}), this.container.offset().left + this.container.outerWidth() > e(window).width() && this.container.css({left: "auto", right: 0}))
		}, show: function (t) {
			this.isShowing || (this._outsideClickProxy = e.proxy(function (t) {
				this.outsideClick(t)
			}, this), e(document).on("mousedown.daterangepicker", this._outsideClickProxy).on("touchend.daterangepicker", this._outsideClickProxy).on("click.daterangepicker", "[data-toggle=dropdown]", this._outsideClickProxy).on("focusin.daterangepicker", this._outsideClickProxy), e(window).on("resize.daterangepicker", e.proxy(function (t) {
				this.move(t)
			}, this)), this.oldStartDate = this.startDate.clone(), this.oldEndDate = this.endDate.clone(), this.previousRightTime = this.endDate.clone(), this.updateView(), this.container.show(), this.move(), this.element.trigger("show.daterangepicker", this), this.isShowing = !0)
		}, hide: function (t) {
			this.isShowing && (this.endDate || (this.startDate = this.oldStartDate.clone(), this.endDate = this.oldEndDate.clone()), this.startDate.isSame(this.oldStartDate) && this.endDate.isSame(this.oldEndDate) || this.callback(this.startDate, this.endDate, this.chosenLabel), this.updateElement(), e(document).off(".daterangepicker"), e(window).off(".daterangepicker"), this.container.hide(), this.element.trigger("hide.daterangepicker", this), this.isShowing = !1)
		}, toggle: function (t) {
			this.isShowing ? this.hide() : this.show()
		}, outsideClick: function (t) {
			var i = e(t.target);
			"focusin" == t.type || i.closest(this.element).length || i.closest(this.container).length || i.closest(".calendar-table").length || (this.hide(), this.element.trigger("outsideClick.daterangepicker", this))
		}, showCalendars: function () {
			this.container.addClass("show-calendar"), this.move(), this.element.trigger("showCalendar.daterangepicker", this)
		}, hideCalendars: function () {
			this.container.removeClass("show-calendar"), this.element.trigger("hideCalendar.daterangepicker", this)
		}, hoverRange: function (t) {
			if (!this.container.find("input[name=daterangepicker_start]").is(":focus") && !this.container.find("input[name=daterangepicker_end]").is(":focus")) {
				var e = t.target.getAttribute("data-range-key");
				if (e == this.locale.customRangeLabel) this.updateView(); else {
					var i = this.ranges[e];
					this.container.find("input[name=daterangepicker_start]").val(i[0].format(this.locale.format)), this.container.find("input[name=daterangepicker_end]").val(i[1].format(this.locale.format))
				}
			}
		}, clickRange: function (t) {
			var e = t.target.getAttribute("data-range-key");
			if (this.chosenLabel = e, e == this.locale.customRangeLabel) this.showCalendars(); else {
				var i = this.ranges[e];
				this.startDate = i[0], this.endDate = i[1], this.timePicker || (this.startDate.startOf("day"), this.endDate.endOf("day")), this.alwaysShowCalendars || this.hideCalendars(), this.clickApply()
			}
		}, clickPrev: function (t) {
			e(t.target).parents(".calendar").hasClass("left") ? (this.leftCalendar.month.subtract(1, "month"), this.linkedCalendars && this.rightCalendar.month.subtract(1, "month")) : this.rightCalendar.month.subtract(1, "month"), this.updateCalendars()
		}, clickNext: function (t) {
			e(t.target).parents(".calendar").hasClass("left") ? this.leftCalendar.month.add(1, "month") : (this.rightCalendar.month.add(1, "month"), this.linkedCalendars && this.leftCalendar.month.add(1, "month")), this.updateCalendars()
		}, hoverDate: function (t) {
			if (e(t.target).hasClass("available")) {
				var i = e(t.target).attr("data-title"), n = i.substr(1, 1), r = i.substr(3, 1), o = e(t.target).parents(".calendar").hasClass("left") ? this.leftCalendar.calendar[n][r] : this.rightCalendar.calendar[n][r];
				this.endDate && !this.container.find("input[name=daterangepicker_start]").is(":focus") ? this.container.find("input[name=daterangepicker_start]").val(o.format(this.locale.format)) : this.endDate || this.container.find("input[name=daterangepicker_end]").is(":focus") || this.container.find("input[name=daterangepicker_end]").val(o.format(this.locale.format));
				var a = this.leftCalendar, s = this.rightCalendar, l = this.startDate;
				this.endDate || this.container.find(".calendar tbody td").each(function (t, i) {
					if (!e(i).hasClass("week")) {
						var n = e(i).attr("data-title"), r = n.substr(1, 1), c = n.substr(3, 1), u = e(i).parents(".calendar").hasClass("left") ? a.calendar[r][c] : s.calendar[r][c];
						u.isAfter(l) && u.isBefore(o) || u.isSame(o, "day") ? e(i).addClass("in-range") : e(i).removeClass("in-range")
					}
				})
			}
		}, clickDate: function (t) {
			if (e(t.target).hasClass("available")) {
				var i = e(t.target).attr("data-title"), n = i.substr(1, 1), r = i.substr(3, 1), o = e(t.target).parents(".calendar").hasClass("left") ? this.leftCalendar.calendar[n][r] : this.rightCalendar.calendar[n][r];
				if (this.endDate || o.isBefore(this.startDate, "day")) {
					if (this.timePicker) {
						var a = parseInt(this.container.find(".left .hourselect").val(), 10);
						if (!this.timePicker24Hour) "PM" === (c = this.container.find(".left .ampmselect").val()) && a < 12 && (a += 12), "AM" === c && 12 === a && (a = 0);
						var s = parseInt(this.container.find(".left .minuteselect").val(), 10), l = this.timePickerSeconds ? parseInt(this.container.find(".left .secondselect").val(), 10) : 0;
						o = o.clone().hour(a).minute(s).second(l)
					}
					this.endDate = null, this.setStartDate(o.clone())
				} else if (!this.endDate && o.isBefore(this.startDate)) this.setEndDate(this.startDate.clone()); else {
					if (this.timePicker) {
						var c;
						a = parseInt(this.container.find(".right .hourselect").val(), 10);
						if (!this.timePicker24Hour) "PM" === (c = this.container.find(".right .ampmselect").val()) && a < 12 && (a += 12), "AM" === c && 12 === a && (a = 0);
						s = parseInt(this.container.find(".right .minuteselect").val(), 10), l = this.timePickerSeconds ? parseInt(this.container.find(".right .secondselect").val(), 10) : 0;
						o = o.clone().hour(a).minute(s).second(l)
					}
					this.setEndDate(o.clone()), this.autoApply && (this.calculateChosenLabel(), this.clickApply())
				}
				this.singleDatePicker && (this.setEndDate(this.startDate), this.timePicker || this.clickApply()), this.updateView(), t.stopPropagation()
			}
		}, calculateChosenLabel: function () {
			var t = !0, e = 0;
			for (var i in this.ranges) {
				if (this.timePicker) {
					var n = this.timePickerSeconds ? "YYYY-MM-DD hh:mm:ss" : "YYYY-MM-DD hh:mm";
					if (this.startDate.format(n) == this.ranges[i][0].format(n) && this.endDate.format(n) == this.ranges[i][1].format(n)) {
						t = !1, this.chosenLabel = this.container.find(".ranges li:eq(" + e + ")").addClass("active").html();
						break
					}
				} else if (this.startDate.format("YYYY-MM-DD") == this.ranges[i][0].format("YYYY-MM-DD") && this.endDate.format("YYYY-MM-DD") == this.ranges[i][1].format("YYYY-MM-DD")) {
					t = !1, this.chosenLabel = this.container.find(".ranges li:eq(" + e + ")").addClass("active").html();
					break
				}
				e++
			}
			t && (this.showCustomRangeLabel ? this.chosenLabel = this.container.find(".ranges li:last").addClass("active").html() : this.chosenLabel = null, this.showCalendars())
		}, clickApply: function (t) {
			this.hide(), this.element.trigger("apply.daterangepicker", this)
		}, clickCancel: function (t) {
			this.startDate = this.oldStartDate, this.endDate = this.oldEndDate, this.hide(), this.element.trigger("cancel.daterangepicker", this)
		}, monthOrYearChanged: function (t) {
			var i = e(t.target).closest(".calendar").hasClass("left"), n = i ? "left" : "right", r = this.container.find(".calendar." + n), o = parseInt(r.find(".monthselect").val(), 10), a = r.find(".yearselect").val();
			i || (a < this.startDate.year() || a == this.startDate.year() && o < this.startDate.month()) && (o = this.startDate.month(), a = this.startDate.year()), this.minDate && (a < this.minDate.year() || a == this.minDate.year() && o < this.minDate.month()) && (o = this.minDate.month(), a = this.minDate.year()), this.maxDate && (a > this.maxDate.year() || a == this.maxDate.year() && o > this.maxDate.month()) && (o = this.maxDate.month(), a = this.maxDate.year()), i ? (this.leftCalendar.month.month(o).year(a), this.linkedCalendars && (this.rightCalendar.month = this.leftCalendar.month.clone().add(1, "month"))) : (this.rightCalendar.month.month(o).year(a), this.linkedCalendars && (this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, "month"))), this.updateCalendars()
		}, timeChanged: function (t) {
			var i = e(t.target).closest(".calendar"), n = i.hasClass("left"), r = parseInt(i.find(".hourselect").val(), 10), o = parseInt(i.find(".minuteselect").val(), 10), a = this.timePickerSeconds ? parseInt(i.find(".secondselect").val(), 10) : 0;
			if (!this.timePicker24Hour) {
				var s = i.find(".ampmselect").val();
				"PM" === s && r < 12 && (r += 12), "AM" === s && 12 === r && (r = 0)
			}
			if (n) {
				var l = this.startDate.clone();
				l.hour(r), l.minute(o), l.second(a), this.setStartDate(l), this.singleDatePicker ? this.endDate = this.startDate.clone() : this.endDate && this.endDate.format("YYYY-MM-DD") == l.format("YYYY-MM-DD") && this.endDate.isBefore(l) && this.setEndDate(l.clone())
			} else if (this.endDate) {
				var c = this.endDate.clone();
				c.hour(r), c.minute(o), c.second(a), this.setEndDate(c)
			}
			this.updateCalendars(), this.updateFormInputs(), this.renderTimePicker("left"), this.renderTimePicker("right")
		}, formInputsChanged: function (i) {
			var n = e(i.target).closest(".calendar").hasClass("right"), r = t(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format), o = t(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);
			r.isValid() && o.isValid() && (n && o.isBefore(r) && (r = o.clone()), this.setStartDate(r), this.setEndDate(o), n ? this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format)) : this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format))), this.updateView()
		}, formInputsFocused: function (t) {
			this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass("active"), e(t.target).addClass("active"), e(t.target).closest(".calendar").hasClass("right") && (this.endDate = null, this.setStartDate(this.startDate.clone()), this.updateView())
		}, formInputsBlurred: function (e) {
			if (!this.endDate) {
				var i = this.container.find('input[name="daterangepicker_end"]').val(), n = t(i, this.locale.format);
				n.isValid() && (this.setEndDate(n), this.updateView())
			}
		}, formInputsKeydown: function (t) {
			13 === t.keyCode && (t.preventDefault(), this.formInputsChanged(t))
		}, elementChanged: function () {
			if (this.element.is("input") && this.element.val().length) {
				var e = this.element.val().split(this.locale.separator), i = null, n = null;
				2 === e.length && (i = t(e[0], this.locale.format), n = t(e[1], this.locale.format)), (this.singleDatePicker || null === i || null === n) && (n = i = t(this.element.val(), this.locale.format)), i.isValid() && n.isValid() && (this.setStartDate(i), this.setEndDate(n), this.updateView())
			}
		}, keydown: function (t) {
			9 !== t.keyCode && 13 !== t.keyCode || this.hide(), 27 === t.keyCode && (t.preventDefault(), t.stopPropagation(), this.hide())
		}, updateElement: function () {
			this.element.is("input") && !this.singleDatePicker && this.autoUpdateInput ? (this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format)), this.element.trigger("change")) : this.element.is("input") && this.autoUpdateInput && (this.element.val(this.startDate.format(this.locale.format)), this.element.trigger("change"))
		}, remove: function () {
			this.container.remove(), this.element.off(".daterangepicker"), this.element.removeData()
		}
	}, e.fn.daterangepicker = function (t, n) {
		var r = e.extend(!0, {}, e.fn.daterangepicker.defaultOptions, t);
		return this.each(function () {
			var t = e(this);
			t.data("daterangepicker") && t.data("daterangepicker").remove(), t.data("daterangepicker", new i(t, r, n))
		}), this
	}, i
}), function (t) {
	"use strict";
	var e = 0;

	function i(e, i) {
		return t.map(e, function (t) {
			return function (t, e) {
				return t + ".touchspin_" + e
			}(t, i)
		})
	}

	t.fn.TouchSpin = function (n) {
		if ("destroy" !== n) {
			var r = {
				min: 0,
				max: 100,
				initval: "",
				replacementval: "",
				step: 1,
				decimals: 0,
				stepinterval: 100,
				forcestepdivisibility: "round",
				stepintervaldelay: 500,
				verticalbuttons: !1,
				verticalupclass: "glyphicon glyphicon-chevron-up",
				verticaldownclass: "glyphicon glyphicon-chevron-down",
				prefix: "",
				postfix: "",
				prefix_extraclass: "",
				postfix_extraclass: "",
				booster: !0,
				boostat: 10,
				maxboostedstep: !1,
				mousewheel: !0,
				buttondown_class: "btn btn-default",
				buttonup_class: "btn btn-default",
				buttondown_txt: "-",
				buttonup_txt: "+"
			}, o = {
				min: "min",
				max: "max",
				initval: "init-val",
				replacementval: "replacement-val",
				step: "step",
				decimals: "decimals",
				stepinterval: "step-interval",
				verticalbuttons: "vertical-buttons",
				verticalupclass: "vertical-up-class",
				verticaldownclass: "vertical-down-class",
				forcestepdivisibility: "force-step-divisibility",
				stepintervaldelay: "step-interval-delay",
				prefix: "prefix",
				postfix: "postfix",
				prefix_extraclass: "prefix-extra-class",
				postfix_extraclass: "postfix-extra-class",
				booster: "booster",
				boostat: "boostat",
				maxboostedstep: "max-boosted-step",
				mousewheel: "mouse-wheel",
				buttondown_class: "button-down-class",
				buttonup_class: "button-up-class",
				buttondown_txt: "button-down-txt",
				buttonup_txt: "button-up-txt"
			};
			return this.each(function () {
				var a, s, l, c, u, h, d, p, f = t(this), m = f.data(), g = 0, v = !1;

				function y() {
					var t, e, i;
					"" !== (t = f.val()) ? a.decimals > 0 && "." === t || (e = parseFloat(t), isNaN(e) && (e = "" !== a.replacementval ? a.replacementval : 0), i = e, e.toString() !== t && (i = e), e < a.min && (i = a.min), e > a.max && (i = a.max), i = function (t) {
						switch (a.forcestepdivisibility) {
							case"round":
								return (Math.round(t / a.step) * a.step).toFixed(a.decimals);
							case"floor":
								return (Math.floor(t / a.step) * a.step).toFixed(a.decimals);
							case"ceil":
								return (Math.ceil(t / a.step) * a.step).toFixed(a.decimals);
							default:
								return t
						}
					}(i), Number(t).toString() !== i.toString() && (f.val(i), f.trigger("change"))) : "" !== a.replacementval && (f.val(a.replacementval), f.trigger("change"))
				}

				function b() {
					if (a.booster) {
						var t = Math.pow(2, Math.floor(g / a.boostat)) * a.step;
						return a.maxboostedstep && t > a.maxboostedstep && (t = a.maxboostedstep, c = Math.round(c / t) * t), Math.max(a.step, t)
					}
					return a.step
				}

				function w() {
					y(), c = parseFloat(l.input.val()), isNaN(c) && (c = 0);
					var t = c, e = b();
					(c += e) > a.max && (c = a.max, f.trigger("touchspin.on.max"), S()), l.input.val(Number(c).toFixed(a.decimals)), t !== c && f.trigger("change")
				}

				function x() {
					y(), c = parseFloat(l.input.val()), isNaN(c) && (c = 0);
					var t = c, e = b();
					(c -= e) < a.min && (c = a.min, f.trigger("touchspin.on.min"), S()), l.input.val(c.toFixed(a.decimals)), t !== c && f.trigger("change")
				}

				function k() {
					S(), g = 0, v = "down", f.trigger("touchspin.on.startspin"), f.trigger("touchspin.on.startdownspin"), d = setTimeout(function () {
						u = setInterval(function () {
							g++, x()
						}, a.stepinterval)
					}, a.stepintervaldelay)
				}

				function _() {
					S(), g = 0, v = "up", f.trigger("touchspin.on.startspin"), f.trigger("touchspin.on.startupspin"), p = setTimeout(function () {
						h = setInterval(function () {
							g++, w()
						}, a.stepinterval)
					}, a.stepintervaldelay)
				}

				function S() {
					switch (clearTimeout(d), clearTimeout(p), clearInterval(u), clearInterval(h), v) {
						case"up":
							f.trigger("touchspin.on.stopupspin"), f.trigger("touchspin.on.stopspin");
							break;
						case"down":
							f.trigger("touchspin.on.stopdownspin"), f.trigger("touchspin.on.stopspin")
					}
					g = 0, v = !1
				}

				!function () {
					if (f.data("alreadyinitialized")) return;
					if (f.data("alreadyinitialized", !0), e += 1, f.data("spinnerid", e), !f.is("input")) return void console.log("Must be an input.");
					a = t.extend({}, r, m, (c = {}, t.each(o, function (t, e) {
						var i = "bts-" + e;
						f.is("[data-" + i + "]") && (c[t] = f.data(i))
					}), c), n), "" !== a.initval && "" === f.val() && f.val(a.initval), y(), function () {
						var e = f.val(), i = f.parent();
						"" !== e && (e = Number(e).toFixed(a.decimals));
						f.data("initvalue", e).val(e), f.addClass("form-control"), i.hasClass("input-group") ? function (e) {
							e.addClass("bootstrap-touchspin");
							var i, n, r = f.prev(), o = f.next(), l = '<span class="input-group-addon bootstrap-touchspin-prefix">' + a.prefix + "</span>", c = '<span class="input-group-addon bootstrap-touchspin-postfix">' + a.postfix + "</span>";
							r.hasClass("input-group-btn") ? (i = '<button class="' + a.buttondown_class + ' bootstrap-touchspin-down" type="button">' + a.buttondown_txt + "</button>", r.append(i)) : (i = '<span class="input-group-btn"><button class="' + a.buttondown_class + ' bootstrap-touchspin-down" type="button">' + a.buttondown_txt + "</button></span>", t(i).insertBefore(f));
							o.hasClass("input-group-btn") ? (n = '<button class="' + a.buttonup_class + ' bootstrap-touchspin-up" type="button">' + a.buttonup_txt + "</button>", o.prepend(n)) : (n = '<span class="input-group-btn"><button class="' + a.buttonup_class + ' bootstrap-touchspin-up" type="button">' + a.buttonup_txt + "</button></span>", t(n).insertAfter(f));
							t(l).insertBefore(f), t(c).insertAfter(f), s = e
						}(i) : function () {
							var e;
							e = a.verticalbuttons ? '<div class="input-group bootstrap-touchspin"><span class="input-group-addon bootstrap-touchspin-prefix">' + a.prefix + '</span><span class="input-group-addon bootstrap-touchspin-postfix">' + a.postfix + '</span><span class="input-group-btn-vertical"><button class="' + a.buttondown_class + ' bootstrap-touchspin-up" type="button"><i class="' + a.verticalupclass + '"></i></button><button class="' + a.buttonup_class + ' bootstrap-touchspin-down" type="button"><i class="' + a.verticaldownclass + '"></i></button></span></div>' : '<div class="input-group bootstrap-touchspin"><span class="input-group-btn"><button class="' + a.buttondown_class + ' bootstrap-touchspin-down" type="button">' + a.buttondown_txt + '</button></span><span class="input-group-addon bootstrap-touchspin-prefix">' + a.prefix + '</span><span class="input-group-addon bootstrap-touchspin-postfix">' + a.postfix + '</span><span class="input-group-btn"><button class="' + a.buttonup_class + ' bootstrap-touchspin-up" type="button">' + a.buttonup_txt + "</button></span></div>";
							s = t(e).insertBefore(f), t(".bootstrap-touchspin-prefix", s).after(f), f.hasClass("input-sm") ? s.addClass("input-group-sm") : f.hasClass("input-lg") && s.addClass("input-group-lg")
						}()
					}(), l = {down: t(".bootstrap-touchspin-down", s), up: t(".bootstrap-touchspin-up", s), input: t("input", s), prefix: t(".bootstrap-touchspin-prefix", s).addClass(a.prefix_extraclass), postfix: t(".bootstrap-touchspin-postfix", s).addClass(a.postfix_extraclass)}, function () {
						"" === a.prefix && l.prefix.hide();
						"" === a.postfix && l.postfix.hide()
					}(), f.on("keydown", function (t) {
						var e = t.keyCode || t.which;
						38 === e ? ("up" !== v && (w(), _()), t.preventDefault()) : 40 === e && ("down" !== v && (x(), k()), t.preventDefault())
					}), f.on("keyup", function (t) {
						var e = t.keyCode || t.which;
						38 === e ? S() : 40 === e && S()
					}), f.on("blur", function () {
						y()
					}), l.down.on("keydown", function (t) {
						var e = t.keyCode || t.which;
						32 !== e && 13 !== e || ("down" !== v && (x(), k()), t.preventDefault())
					}), l.down.on("keyup", function (t) {
						var e = t.keyCode || t.which;
						32 !== e && 13 !== e || S()
					}), l.up.on("keydown", function (t) {
						var e = t.keyCode || t.which;
						32 !== e && 13 !== e || ("up" !== v && (w(), _()), t.preventDefault())
					}), l.up.on("keyup", function (t) {
						var e = t.keyCode || t.which;
						32 !== e && 13 !== e || S()
					}), l.down.on("mousedown.touchspin", function (t) {
						l.down.off("touchstart.touchspin"), f.is(":disabled") || (x(), k(), t.preventDefault(), t.stopPropagation())
					}), l.down.on("touchstart.touchspin", function (t) {
						l.down.off("mousedown.touchspin"), f.is(":disabled") || (x(), k(), t.preventDefault(), t.stopPropagation())
					}), l.up.on("mousedown.touchspin", function (t) {
						l.up.off("touchstart.touchspin"), f.is(":disabled") || (w(), _(), t.preventDefault(), t.stopPropagation())
					}), l.up.on("touchstart.touchspin", function (t) {
						l.up.off("mousedown.touchspin"), f.is(":disabled") || (w(), _(), t.preventDefault(), t.stopPropagation())
					}), l.up.on("mouseout touchleave touchend touchcancel", function (t) {
						v && (t.stopPropagation(), S())
					}), l.down.on("mouseout touchleave touchend touchcancel", function (t) {
						v && (t.stopPropagation(), S())
					}), l.down.on("mousemove touchmove", function (t) {
						v && (t.stopPropagation(), t.preventDefault())
					}), l.up.on("mousemove touchmove", function (t) {
						v && (t.stopPropagation(), t.preventDefault())
					}), t(document).on(i(["mouseup", "touchend", "touchcancel"], e).join(" "), function (t) {
						v && (t.preventDefault(), S())
					}), t(document).on(i(["mousemove", "touchmove", "scroll", "scrollstart"], e).join(" "), function (t) {
						v && (t.preventDefault(), S())
					}), f.on("mousewheel DOMMouseScroll", function (t) {
						if (a.mousewheel && f.is(":focus")) {
							var e = t.originalEvent.wheelDelta || -t.originalEvent.deltaY || -t.originalEvent.detail;
							t.stopPropagation(), t.preventDefault(), e < 0 ? x() : w()
						}
					}), f.on("touchspin.uponce", function () {
						S(), w()
					}), f.on("touchspin.downonce", function () {
						S(), x()
					}), f.on("touchspin.startupspin", function () {
						_()
					}), f.on("touchspin.startdownspin", function () {
						k()
					}), f.on("touchspin.stopspin", function () {
						S()
					}), f.on("touchspin.updatesettings", function (e, i) {
						!function (e) {
							(function (e) {
								a = t.extend({}, a, e)
							})(e), y();
							var i = l.input.val();
							"" !== i && (i = Number(l.input.val()), l.input.val(i.toFixed(a.decimals)))
						}(i)
					}), l.input.css("display", "block");
					var c
				}()
			})
		}
		this.each(function () {
			var e = t(this).data();
			t(document).off(i(["mouseup", "touchend", "touchcancel", "mousemove", "touchmove", "scroll", "scrollstart"], e.spinnerid).join(" "))
		})
	}
}(jQuery), function (t) {
	"use strict";
	t.event.special.destroyed || (t.event.special.destroyed = {
		remove: function (t) {
			t.handler && t.handler()
		}
	}), t.fn.extend({
		maxlength: function (e, i) {
			var n = t("body");

			function r(t) {
				var i = t.val();
				i = e.twoCharLinebreak ? i.replace(/\r(?!\n)|\n(?!\r)/g, "\r\n") : i.replace(new RegExp("\r?\n", "g"), "\n");
				return e.utf8 ? function (t) {
					for (var e = 0, i = 0; i < t.length; i++) {
						var n = t.charCodeAt(i);
						n < 128 ? e++ : e += n > 127 && n < 2048 ? 2 : 3
					}
					return e
				}(i) : i.length
			}

			function o(t, e) {
				return e - r(t)
			}

			function a(t, e) {
				e.css({display: "block"}), t.trigger("maxlength.shown")
			}

			function s(t, i, n) {
				var r = "";
				return e.message ? r = "function" == typeof e.message ? e.message(t, i) : e.message.replace("%charsTyped%", n).replace("%charsRemaining%", i - n).replace("%charsTotal%", i) : (e.preText && (r += e.preText), e.showCharsTyped ? r += n : r += i - n, e.showMaxLength && (r += e.separator + i), e.postText && (r += e.postText)), r
			}

			function l(t, i, n, o) {
				var l, c, u, h;
				o && (o.html(s(i.val(), n, n - t)), t > 0 ? (l = i, c = e.threshold, u = n, h = !0, !e.alwaysShow && u - r(l) > c && (h = !1), h ? a(i, o.removeClass(e.limitReachedClass).addClass(e.warningClass)) : function (t, e) {
					e.css({display: "none"}), t.trigger("maxlength.hidden")
				}(i, o)) : a(i, o.removeClass(e.warningClass).addClass(e.limitReachedClass))), e.allowOverMax && (t < 0 ? i.addClass("overmax") : i.removeClass("overmax"))
			}

			function c(i, n) {
				var r = function (e) {
					var i = e[0];
					return t.extend({}, "function" == typeof i.getBoundingClientRect ? i.getBoundingClientRect() : {width: i.offsetWidth, height: i.offsetHeight}, e.offset())
				}(i);
				if ("function" !== t.type(e.placement)) if (t.isPlainObject(e.placement)) !function (i, n) {
					if (!i || !n) return;
					var r = {};
					t.each(["top", "bottom", "left", "right", "position"], function (t, i) {
						var n = e.placement[i];
						void 0 !== n && (r[i] = n)
					}), n.css(r)
				}(e.placement, n); else {
					var o = i.outerWidth(), a = n.outerWidth(), s = n.width(), l = n.height();
					switch (e.appendToParent && (r.top -= i.parent().offset().top, r.left -= i.parent().offset().left), e.placement) {
						case"bottom":
							n.css({top: r.top + r.height, left: r.left + r.width / 2 - s / 2});
							break;
						case"top":
							n.css({top: r.top - l, left: r.left + r.width / 2 - s / 2});
							break;
						case"left":
							n.css({top: r.top + r.height / 2 - l / 2, left: r.left - s});
							break;
						case"right":
							n.css({top: r.top + r.height / 2 - l / 2, left: r.left + r.width});
							break;
						case"bottom-right":
							n.css({top: r.top + r.height, left: r.left + r.width});
							break;
						case"top-right":
							n.css({top: r.top - l, left: r.left + o});
							break;
						case"top-left":
							n.css({top: r.top - l, left: r.left - a});
							break;
						case"bottom-left":
							n.css({top: r.top + i.outerHeight(), left: r.left - a});
							break;
						case"centered-right":
							n.css({top: r.top + l / 2, left: r.left + o - a - 3});
							break;
						case"bottom-right-inside":
							n.css({top: r.top + r.height, left: r.left + r.width - a});
							break;
						case"top-right-inside":
							n.css({top: r.top - l, left: r.left + o - a});
							break;
						case"top-left-inside":
							n.css({top: r.top - l, left: r.left});
							break;
						case"bottom-left-inside":
							n.css({top: r.top + i.outerHeight(), left: r.left})
					}
				} else e.placement(i, n, r)
			}

			function u(t) {
				var i = "maxlength";
				return e.allowOverMax && (i = "data-bs-mxl"), t.attr(i) || t.attr("size")
			}

			return t.isFunction(e) && !i && (i = e, e = {}), e = t.extend({
				showOnReady: !1,
				alwaysShow: !1,
				threshold: 10,
				warningClass: "label label-success",
				limitReachedClass: "label label-important label-danger",
				separator: " / ",
				preText: "",
				postText: "",
				showMaxLength: !0,
				placement: "bottom",
				message: null,
				showCharsTyped: !0,
				validate: !1,
				utf8: !1,
				appendToParent: !1,
				twoCharLinebreak: !0,
				allowOverMax: !1
			}, e), this.each(function () {
				var i, r, a = t(this);

				function h() {
					var h = s(a.val(), i, "0");
					i = u(a), r || (r = t('<span class="bootstrap-maxlength"></span>').css({
						display: "none",
						position: "absolute",
						whiteSpace: "nowrap",
						zIndex: 1099
					}).html(h)), a.is("textarea") && (a.data("maxlenghtsizex", a.outerWidth()), a.data("maxlenghtsizey", a.outerHeight()), a.mouseup(function () {
						a.outerWidth() === a.data("maxlenghtsizex") && a.outerHeight() === a.data("maxlenghtsizey") || c(a, r), a.data("maxlenghtsizex", a.outerWidth()), a.data("maxlenghtsizey", a.outerHeight())
					})), e.appendToParent ? (a.parent().append(r), a.parent().css("position", "relative")) : n.append(r), l(o(a, u(a)), a, i, r), c(a, r)
				}

				t(window).resize(function () {
					r && c(a, r)
				}), e.allowOverMax && (t(this).attr("data-bs-mxl", t(this).attr("maxlength")), t(this).removeAttr("maxlength")), e.showOnReady ? a.ready(function () {
					h()
				}) : a.focus(function () {
					h()
				}), a.on("maxlength.reposition", function () {
					c(a, r)
				}), a.on("destroyed", function () {
					r && r.remove()
				}), a.on("blur", function () {
					r && !e.showOnReady && r.remove()
				}), a.on("input", function () {
					var t = u(a), n = o(a, t), s = !0;
					return e.validate && n < 0 ? (!function (t, i) {
						var n = t.val(), r = 0;
						e.twoCharLinebreak && "\n" === (n = n.replace(/\r(?!\n)|\n(?!\r)/g, "\r\n")).substr(n.length - 1) && n.length % 2 == 1 && (r = 1), t.val(n.substr(0, i - r))
					}(a, t), s = !1) : l(n, a, i, r), "bottom-right-inside" !== e.placement && "top-right-inside" !== e.placement || c(a, r), s
				})
			})
		}
	})
}(jQuery), function (t) {
	"use strict";
	var e = function (t, e) {
		this.init("multiselectsplitter", t, e)
	};
	e.DEFAULTS = {
		selectSize: null,
		maxSelectSize: null,
		clearOnFirstChange: !1,
		onlySameGroup: !1,
		groupCounter: !1,
		maximumSelected: null,
		afterInitialize: null,
		maximumAlert: function (t) {
			alert("Only " + t + " values can be selected")
		},
		createFirstSelect: function (t, e) {
			return "<option>" + t + "</option>"
		},
		createSecondSelect: function (t, e) {
			return "<option>" + t + "</option>"
		},
		template: '<div class="row" data-multiselectsplitter-wrapper-selector><div class="col-xs-6 col-sm-6"><select class="form-control" data-multiselectsplitter-firstselect-selector></select></div> \x3c!-- Add the extra clearfix for only the required viewport --\x3e<div class="col-xs-6 col-sm-6"><select class="form-control" data-multiselectsplitter-secondselect-selector></select></div></div>'
	}, e.prototype.init = function (i, n, r) {
		var o = this;
		o.type = i, o.last$ElementSelected = [], o.initialized = !1, o.$element = t(n), o.$element.hide(), o.options = t.extend({}, e.DEFAULTS, r), o.$element.after(o.options.template), o.$wrapper = o.$element.next("div[data-multiselectsplitter-wrapper-selector]"), o.$firstSelect = t("select[data-multiselectsplitter-firstselect-selector]", o.$wrapper), o.$secondSelect = t("select[data-multiselectsplitter-secondselect-selector]", o.$wrapper);
		var a = 0, s = 0;
		if (0 != o.$element.find("optgroup").length) {
			o.$element.find("optgroup").each(function () {
				var e = t(this).attr("label"), i = t(o.options.createFirstSelect(e, o.$element));
				i.val(e), i.attr("data-current-label", i.text()), o.$firstSelect.append(i);
				var n = t(this).find("option").length;
				n > s && (s = n), a++
			});
			var l = Math.max(a, s);
			l = Math.min(l, 10), o.options.selectSize ? l = o.options.selectSize : o.options.maxSelectSize && (l = Math.min(l, o.options.maxSelectSize)), o.$firstSelect.attr("size", l), o.$secondSelect.attr("size", l), o.$element.attr("multiple") && o.$secondSelect.attr("multiple", "multiple"), o.$element.is(":disabled") && o.disable(), o.$firstSelect.on("change", t.proxy(o.updateParentCategory, o)), o.$secondSelect.on("click change", t.proxy(o.updateChildCategory, o)), o.update = function () {
				if (!(o.$element.find("option").length < 1)) {
					var t, e = o.$element.find("option:selected:first");
					t = e.length ? e.parent().attr("label") : o.$element.find("option:first").parent().attr("label"), o.$firstSelect.find('option[value="' + t + '"]').prop("selected", !0), o.$firstSelect.trigger("change")
				}
			}, o.update(), o.initialized = !0, o.options.afterInitialize && o.options.afterInitialize(o.$firstSelect, o.$secondSelect)
		}
	}, e.prototype.disable = function () {
		this.$secondSelect.prop("disabled", !0), this.$firstSelect.prop("disabled", !0)
	}, e.prototype.enable = function () {
		this.$secondSelect.prop("disabled", !1), this.$firstSelect.prop("disabled", !1)
	}, e.prototype.createSecondSelect = function () {
		var e = this;
		e.$secondSelect.empty(), t.each(e.$element.find('optgroup[label="' + e.$firstSelect.val() + '"] option'), function (i, n) {
			var r = t(this).val(), o = t(this).text(), a = t(e.options.createSecondSelect(o, e.$firstSelect));
			a.val(r), t.each(e.$element.find("option:selected"), function (e, i) {
				t(i).val() == r && a.prop("selected", !0)
			}), e.$secondSelect.append(a)
		})
	}, e.prototype.updateParentCategory = function () {
		var t = this;
		t.last$ElementSelected = t.$element.find("option:selected"), t.options.clearOnFirstChange && t.initialized && t.$element.find("option:selected").prop("selected", !1), t.createSecondSelect(), t.checkSelected(), t.updateCounter()
	}, e.prototype.updateCounter = function () {
		var e = this;
		e.$element.attr("multiple") && e.options.groupCounter && t.each(e.$firstSelect.find("option"), function (i, n) {
			var r = t(n).val(), o = t(n).data("currentLabel"), a = e.$element.find('optgroup[label="' + r + '"] option:selected').length;
			a > 0 && (o += " (" + a + ")"), t(n).html(o)
		})
	}, e.prototype.checkSelected = function () {
		var e = this;
		if (e.$element.attr("multiple") && e.options.maximumSelected) {
			var i;
			if (!((i = "function" == typeof e.options.maximumSelected ? e.options.maximumSelected(e.$firstSelect, e.$secondSelect) : e.options.maximumSelected) < 1)) if (e.$element.find("option:selected").length > i) {
				e.$firstSelect.find("option:selected").prop("selected", !1), e.$secondSelect.find("option:selected").prop("selected", !1), e.initialized ? (e.$element.find("option:selected").prop("selected", !1), e.last$ElementSelected.prop("selected", !0)) : t.each(e.$element.find("option:selected"), function (e, n) {
					e > i - 1 && t(n).prop("selected", !1)
				});
				var n = e.last$ElementSelected.first().parent().attr("label");
				e.$firstSelect.find('option[value="' + n + '"]').prop("selected", !0), e.createSecondSelect(), e.options.maximumAlert(i)
			}
		}
	}, e.prototype.basicUpdateChildCategory = function (e, i) {
		var n = this;
		n.last$ElementSelected = n.$element.find("option:selected");
		var r = n.$secondSelect.val();
		t.isArray(r) || (r = [r]);
		var o = n.$firstSelect.val(), a = !1;
		n.$element.attr("multiple") ? n.options.onlySameGroup ? t.each(n.$element.find("option:selected"), function (e, i) {
			if (t(i).parent().attr("label") != o) return a = !0, !1
		}) : i || (a = !0) : a = !0, a ? n.$element.find("option:selected").prop("selected", !1) : t.each(n.$element.find("option:selected"), function (e, i) {
			o == t(i).parent().attr("label") && -1 == t.inArray(t(i).val(), r) && t(i).prop("selected", !1)
		}), t.each(r, function (t, e) {
			n.$element.find('option[value="' + e + '"]').prop("selected", !0)
		}), n.checkSelected(), n.updateCounter(), n.$element.trigger("change")
	}, e.prototype.updateChildCategory = function (e) {
		"change" == e.type ? this.timeOut = setTimeout(t.proxy(function () {
			this.basicUpdateChildCategory(e, e.ctrlKey)
		}, this), 10) : "click" == e.type && (clearTimeout(this.timeOut), this.basicUpdateChildCategory(e, e.ctrlKey))
	}, e.prototype.destroy = function () {
		this.$wrapper.remove(), this.$element.removeData(this.type), this.$element.show()
	}, t.fn.multiselectsplitter = function (i) {
		return this.each(function () {
			var n = t(this), r = n.data("multiselectsplitter"), o = "object" == typeof i && i;
			(r || "destroy" != i) && (r || n.data("multiselectsplitter", r = new e(this, o)), "string" == typeof i && r[i]())
		})
	}, t.fn.multiselectsplitter.Constructor = e, t.fn.multiselectsplitter.VERSION = "1.0.1"
}(jQuery), function (t, e) {
	"function" == typeof define && define.amd ? define(["jquery"], function (t) {
		return e(t)
	}) : "object" == typeof module && module.exports ? module.exports = e(require("jquery")) : e(t.jQuery)
}(this, function (t) {
	!function (t) {
		"use strict";
		var e, i, n, r = document.createElement("_");
		if (r.classList.toggle("c3", !1), r.classList.contains("c3")) {
			var o = DOMTokenList.prototype.toggle;
			DOMTokenList.prototype.toggle = function (t, e) {
				return 1 in arguments && !this.contains(t) == !e ? e : o.call(this, t)
			}
		}
		String.prototype.startsWith || (e = function () {
			try {
				var t = {}, e = Object.defineProperty, i = e(t, t, t) && e
			} catch (t) {
			}
			return i
		}(), i = {}.toString, n = function (t) {
			if (null == this) throw new TypeError;
			var e = String(this);
			if (t && "[object RegExp]" == i.call(t)) throw new TypeError;
			var n = e.length, r = String(t), o = r.length, a = arguments.length > 1 ? arguments[1] : void 0, s = a ? Number(a) : 0;
			s != s && (s = 0);
			var l = Math.min(Math.max(s, 0), n);
			if (o + l > n) return !1;
			for (var c = -1; ++c < o;) if (e.charCodeAt(l + c) != r.charCodeAt(c)) return !1;
			return !0
		}, e ? e(String.prototype, "startsWith", {value: n, configurable: !0, writable: !0}) : String.prototype.startsWith = n), Object.keys || (Object.keys = function (t, e, i) {
			for (e in i = [], t) i.hasOwnProperty.call(t, e) && i.push(e);
			return i
		});
		var a = {useDefault: !1, _set: t.valHooks.select.set};
		t.valHooks.select.set = function (e, i) {
			return i && !a.useDefault && t(e).data("selected", !0), a._set.apply(this, arguments)
		};
		var s = null, l = function () {
			try {
				return new Event("change"), !0
			} catch (t) {
				return !1
			}
		}();

		function c(t, e, i, n) {
			for (var r = ["content", "subtext", "tokens"], o = !1, a = 0; a < r.length; a++) {
				var s = t[r[a]];
				if (s && (n && (s = h(s)), s = s.toUpperCase(), o = "contains" === i ? s.indexOf(e) >= 0 : s.startsWith(e))) break
			}
			return o
		}

		function u(t) {
			return parseInt(t, 10) || 0
		}

		function h(e) {
			return t.each([{re: /[\xC0-\xC6]/g, ch: "A"}, {re: /[\xE0-\xE6]/g, ch: "a"}, {re: /[\xC8-\xCB]/g, ch: "E"}, {re: /[\xE8-\xEB]/g, ch: "e"}, {re: /[\xCC-\xCF]/g, ch: "I"}, {re: /[\xEC-\xEF]/g, ch: "i"}, {re: /[\xD2-\xD6]/g, ch: "O"}, {re: /[\xF2-\xF6]/g, ch: "o"}, {
				re: /[\xD9-\xDC]/g,
				ch: "U"
			}, {re: /[\xF9-\xFC]/g, ch: "u"}, {re: /[\xC7-\xE7]/g, ch: "c"}, {re: /[\xD1]/g, ch: "N"}, {re: /[\xF1]/g, ch: "n"}], function () {
				e = e ? e.replace(this.re, this.ch) : ""
			}), e
		}

		t.fn.triggerNative = function (t) {
			var e, i = this[0];
			i.dispatchEvent ? (l ? e = new Event(t, {bubbles: !0}) : (e = document.createEvent("Event")).initEvent(t, !0, !1), i.dispatchEvent(e)) : i.fireEvent ? ((e = document.createEventObject()).eventType = t, i.fireEvent("on" + t, e)) : this.trigger(t)
		};
		var d = function (t) {
			var e = function (e) {
				return t[e]
			}, i = "(?:" + Object.keys(t).join("|") + ")", n = RegExp(i), r = RegExp(i, "g");
			return function (t) {
				return t = null == t ? "" : "" + t, n.test(t) ? t.replace(r, e) : t
			}
		}, p = d({"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;"}), f = d({"&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#x27;": "'", "&#x60;": "`"}), m = {
			32: " ",
			48: "0",
			49: "1",
			50: "2",
			51: "3",
			52: "4",
			53: "5",
			54: "6",
			55: "7",
			56: "8",
			57: "9",
			59: ";",
			65: "A",
			66: "B",
			67: "C",
			68: "D",
			69: "E",
			70: "F",
			71: "G",
			72: "H",
			73: "I",
			74: "J",
			75: "K",
			76: "L",
			77: "M",
			78: "N",
			79: "O",
			80: "P",
			81: "Q",
			82: "R",
			83: "S",
			84: "T",
			85: "U",
			86: "V",
			87: "W",
			88: "X",
			89: "Y",
			90: "Z",
			96: "0",
			97: "1",
			98: "2",
			99: "3",
			100: "4",
			101: "5",
			102: "6",
			103: "7",
			104: "8",
			105: "9"
		}, g = 27, v = 13, y = 32, b = 9, w = 38, x = 40, k = {};
		k.full = (t.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split("."), k.major = k.full[0];
		var _ = {DISABLED: "disabled", DIVIDER: "4" === k.major ? "dropdown-divider" : "divider", SHOW: "4" === k.major ? "show" : "open", DROPUP: "dropup", MENURIGHT: "dropdown-menu-right", MENULEFT: "dropdown-menu-left", BUTTONCLASS: "4" === k.major ? "btn-light" : "btn-default"},
			S = new RegExp(w + "|" + x), C = new RegExp("^" + b + "$|" + g), D = (new RegExp(v + "|" + y), function (e, i) {
				var n = this;
				a.useDefault || (t.valHooks.select.set = a._set, a.useDefault = !0), this.$element = t(e), this.$newElement = null, this.$button = null, this.$menu = null, this.options = i, this.selectpicker = {
					main: {map: {newIndex: {}, originalIndex: {}}},
					current: {map: {}},
					search: {map: {}},
					view: {},
					keydown: {
						keyHistory: "", resetKeyHistory: {
							start: function () {
								return setTimeout(function () {
									n.selectpicker.keydown.keyHistory = ""
								}, 800)
							}
						}
					}
				}, null === this.options.title && (this.options.title = this.$element.attr("title"));
				var r = this.options.windowPadding;
				"number" == typeof r && (this.options.windowPadding = [r, r, r, r]), this.val = D.prototype.val, this.render = D.prototype.render, this.refresh = D.prototype.refresh, this.setStyle = D.prototype.setStyle, this.selectAll = D.prototype.selectAll, this.deselectAll = D.prototype.deselectAll, this.destroy = D.prototype.destroy, this.remove = D.prototype.remove, this.show = D.prototype.show, this.hide = D.prototype.hide, this.init()
			});

		function T(e) {
			var i, n = arguments, r = e;
			[].shift.apply(n);
			var o = this.each(function () {
				var e = t(this);
				if (e.is("select")) {
					var o = e.data("selectpicker"), a = "object" == typeof r && r;
					if (o) {
						if (a) for (var s in a) a.hasOwnProperty(s) && (o.options[s] = a[s])
					} else {
						var l = t.extend({}, D.DEFAULTS, t.fn.selectpicker.defaults || {}, e.data(), a);
						l.template = t.extend({}, D.DEFAULTS.template, t.fn.selectpicker.defaults ? t.fn.selectpicker.defaults.template : {}, e.data().template, a.template), e.data("selectpicker", o = new D(this, l))
					}
					"string" == typeof r && (i = o[r] instanceof Function ? o[r].apply(o, n) : o.options[r])
				}
			});
			return void 0 !== i ? i : o
		}

		D.VERSION = "1.13.0-beta", D.DEFAULTS = {
			noneSelectedText: "Nothing selected",
			noneResultsText: "No results matched {0}",
			countSelectedText: function (t, e) {
				return 1 == t ? "{0} item selected" : "{0} items selected"
			},
			maxOptionsText: function (t, e) {
				return [1 == t ? "Limit reached ({n} item max)" : "Limit reached ({n} items max)", 1 == e ? "Group limit reached ({n} item max)" : "Group limit reached ({n} items max)"]
			},
			selectAllText: "Select All",
			deselectAllText: "Deselect All",
			doneButton: !1,
			doneButtonText: "Close",
			multipleSeparator: ", ",
			styleBase: "btn",
			style: "btn-default",
			size: "auto",
			title: null,
			selectedTextFormat: "values",
			width: !1,
			container: !1,
			hideDisabled: !1,
			showSubtext: !1,
			showIcon: !0,
			showContent: !0,
			dropupAuto: !0,
			header: !1,
			liveSearch: !1,
			liveSearchPlaceholder: null,
			liveSearchNormalize: !1,
			liveSearchStyle: "contains",
			actionsBox: !1,
			iconBase: "glyphicon",
			tickIcon: "glyphicon-ok",
			showTick: !1,
			template: {caret: '<span class="caret"></span>'},
			maxOptions: !1,
			mobile: !1,
			selectOnTab: !1,
			dropdownAlignRight: !1,
			windowPadding: 0,
			virtualScroll: 600
		}, "4" === k.major && (D.DEFAULTS.style = "btn-light", D.DEFAULTS.iconBase = "", D.DEFAULTS.tickIcon = "bs-ok-default"), D.prototype = {
			constructor: D, init: function () {
				var t = this, e = this.$element.attr("id");
				this.$element.addClass("bs-select-hidden"), this.multiple = this.$element.prop("multiple"), this.autofocus = this.$element.prop("autofocus"), this.$newElement = this.createDropdown(), this.createLi(), this.$element.after(this.$newElement).prependTo(this.$newElement), this.$button = this.$newElement.children("button"), this.$menu = this.$newElement.children(".dropdown-menu"), this.$menuInner = this.$menu.children(".inner"), this.$searchbox = this.$menu.find("input"), this.$element.removeClass("bs-select-hidden"), !0 === this.options.dropdownAlignRight && this.$menu.addClass(_.MENURIGHT), void 0 !== e && this.$button.attr("data-id", e), this.checkDisabled(), this.clickListener(), this.options.liveSearch && this.liveSearchListener(), this.render(), this.setStyle(), this.setWidth(), this.options.container ? this.selectPosition() : this.$element.on("hide.bs.select", function () {
					if (t.isVirtual()) {
						var e = t.$menuInner[0], i = e.firstChild.cloneNode(!1);
						e.replaceChild(i, e.firstChild), e.scrollTop = 0
					}
				}), this.$menu.data("this", this), this.$newElement.data("this", this), this.options.mobile && this.mobile(), this.$newElement.on({
					"hide.bs.dropdown": function (e) {
						t.$menuInner.attr("aria-expanded", !1), t.$element.trigger("hide.bs.select", e)
					}, "hidden.bs.dropdown": function (e) {
						t.$element.trigger("hidden.bs.select", e)
					}, "show.bs.dropdown": function (e) {
						t.$menuInner.attr("aria-expanded", !0), t.$element.trigger("show.bs.select", e)
					}, "shown.bs.dropdown": function (e) {
						t.$element.trigger("shown.bs.select", e)
					}
				}), t.$element[0].hasAttribute("required") && this.$element.on("invalid", function () {
					t.$button.addClass("bs-invalid"), t.$element.on({
						"shown.bs.select": function () {
							t.$element.val(t.$element.val()).off("shown.bs.select")
						}, "rendered.bs.select": function () {
							this.validity.valid && t.$button.removeClass("bs-invalid"), t.$element.off("rendered.bs.select")
						}
					}), t.$button.on("blur.bs.select", function () {
						t.$element.focus().blur(), t.$button.off("blur.bs.select")
					})
				}), setTimeout(function () {
					t.$element.trigger("loaded.bs.select")
				})
			}, createDropdown: function () {
				var e = this.multiple || this.options.showTick ? " show-tick" : "", i = this.$element.parent().hasClass("input-group") ? " input-group-btn" : "", n = this.autofocus ? " autofocus" : "",
					r = this.options.header ? '<div class="popover-title"><button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + "</div>" : "",
					o = this.options.liveSearch ? '<div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off"' + (null === this.options.liveSearchPlaceholder ? "" : ' placeholder="' + p(this.options.liveSearchPlaceholder) + '"') + ' role="textbox" aria-label="Search"></div>' : "",
					a = this.multiple && this.options.actionsBox ? '<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn ' + _.BUTTONCLASS + '">' + this.options.selectAllText + '</button><button type="button" class="actions-btn bs-deselect-all btn ' + _.BUTTONCLASS + '">' + this.options.deselectAllText + "</button></div></div>" : "",
					s = this.multiple && this.options.doneButton ? '<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm ' + _.BUTTONCLASS + '">' + this.options.doneButtonText + "</button></div></div>" : "",
					l = '<div class="dropdown bootstrap-select' + e + i + '"><button type="button" class="' + this.options.styleBase + ' dropdown-toggle" data-toggle="dropdown"' + n + ' role="button"><div class="filter-option"><div class="filter-option-inner"></div></div>&nbsp;<span class="bs-caret">' + this.options.template.caret + '</span></button><div class="dropdown-menu ' + ("4" === k.major ? "" : _.SHOW) + '" role="combobox">' + r + o + a + '<div class="inner ' + _.SHOW + '" role="listbox" aria-expanded="false" tabindex="-1"><ul class="dropdown-menu inner ' + ("4" === k.major ? _.SHOW : "") + '"></ul></div>' + s + "</div></div>";
				return t(l)
			}, setPositionData: function () {
				this.selectpicker.view.canHighlight = [];
				for (var t = 0; t < this.selectpicker.current.data.length; t++) {
					var e = this.selectpicker.current.data[t], i = !0;
					"divider" === e.type ? (i = !1, e.height = this.sizeInfo.dividerHeight) : "optgroup-label" === e.type ? (i = !1, e.height = this.sizeInfo.dropdownHeaderHeight) : e.height = this.sizeInfo.liHeight, e.disabled && (i = !1), this.selectpicker.view.canHighlight.push(i), e.position = (0 === t ? 0 : this.selectpicker.current.data[t - 1].position) + e.height
				}
			}, isVirtual: function () {
				return !1 !== this.options.virtualScroll && this.selectpicker.main.elements.length >= this.options.virtualScroll || !0 === this.options.virtualScroll
			}, createView: function (e, i) {
				i = i || 0;
				var n = this;
				this.selectpicker.current = e ? this.selectpicker.search : this.selectpicker.main;
				var r, o, a = [];

				function s(t, i) {
					var s, l, c, u, h, d, p, f, m, g = n.selectpicker.current.elements.length, v = [], y = void 0, b = !0, w = n.isVirtual();
					n.selectpicker.view.scrollTop = t, !0 === w && n.sizeInfo.hasScrollBar && n.$menu[0].offsetWidth > n.sizeInfo.totalMenuWidth && (n.sizeInfo.menuWidth = n.$menu[0].offsetWidth, n.sizeInfo.totalMenuWidth = n.sizeInfo.menuWidth + n.sizeInfo.scrollBarWidth, n.$menu.css("min-width", n.sizeInfo.menuWidth)), s = Math.ceil(n.sizeInfo.menuInnerHeight / n.sizeInfo.liHeight * 1.5), l = Math.round(g / s) || 1;
					for (var x = 0; x < l; x++) {
						var k = (x + 1) * s;
						if (x === l - 1 && (k = g), v[x] = [x * s + (x ? 1 : 0), k], !g) break;
						void 0 === y && t <= n.selectpicker.current.data[k - 1].position - n.sizeInfo.menuInnerHeight && (y = x)
					}
					if (void 0 === y && (y = 0), h = [n.selectpicker.view.position0, n.selectpicker.view.position1], c = Math.max(0, y - 1), u = Math.min(l - 1, y + 1), n.selectpicker.view.position0 = Math.max(0, v[c][0]) || 0, n.selectpicker.view.position1 = Math.min(g, v[u][1]) || 0, d = h[0] !== n.selectpicker.view.position0 || h[1] !== n.selectpicker.view.position1, void 0 !== n.activeIndex && (o = n.selectpicker.current.elements[n.selectpicker.current.map.newIndex[n.prevActiveIndex]], a = n.selectpicker.current.elements[n.selectpicker.current.map.newIndex[n.activeIndex]], r = n.selectpicker.current.elements[n.selectpicker.current.map.newIndex[n.selectedIndex]], i && (n.activeIndex !== n.selectedIndex && (a.classList.remove("active"), a.firstChild && a.firstChild.classList.remove("active")), n.activeIndex = void 0), n.activeIndex && n.activeIndex !== n.selectedIndex && r && r.length && (r.classList.remove("active"), r.firstChild && r.firstChild.classList.remove("active"))), void 0 !== n.prevActiveIndex && n.prevActiveIndex !== n.activeIndex && n.prevActiveIndex !== n.selectedIndex && o && o.length && (o.classList.remove("active"), o.firstChild && o.firstChild.classList.remove("active")), (i || d) && (p = n.selectpicker.view.visibleElements ? n.selectpicker.view.visibleElements.slice() : [], n.selectpicker.view.visibleElements = n.selectpicker.current.elements.slice(n.selectpicker.view.position0, n.selectpicker.view.position1), n.setOptionStatus(), (e || !1 === w && i) && (f = p, m = n.selectpicker.view.visibleElements, b = !(f.length === m.length && f.every(function (t, e) {
						return t === m[e]
					}))), (i || !0 === w) && b)) {
						var _, S, C = n.$menuInner[0], D = document.createDocumentFragment(), T = C.firstChild.cloneNode(!1), M = !0 === w ? n.selectpicker.view.visibleElements : n.selectpicker.current.elements;
						C.replaceChild(T, C.firstChild);
						x = 0;
						for (var E = M.length; x < E; x++) D.appendChild(M[x]);
						!0 === w && (_ = 0 === n.selectpicker.view.position0 ? 0 : n.selectpicker.current.data[n.selectpicker.view.position0 - 1].position, S = n.selectpicker.view.position1 > g - 1 ? 0 : n.selectpicker.current.data[g - 1].position - n.selectpicker.current.data[n.selectpicker.view.position1 - 1].position, C.firstChild.style.marginTop = _ + "px", C.firstChild.style.marginBottom = S + "px"), C.firstChild.appendChild(D)
					}
					if (n.prevActiveIndex = n.activeIndex, n.options.liveSearch) {
						if (e && i) {
							var A, P = 0;
							n.selectpicker.view.canHighlight[P] || (P = 1 + n.selectpicker.view.canHighlight.slice(1).indexOf(!0)), A = n.selectpicker.view.visibleElements[P], n.selectpicker.view.currentActive && (n.selectpicker.view.currentActive.classList.remove("active"), n.selectpicker.view.currentActive.firstChild && n.selectpicker.view.currentActive.firstChild.classList.remove("active")), A && (A.classList.add("active"), A.firstChild && A.firstChild.classList.add("active")), n.activeIndex = n.selectpicker.current.map.originalIndex[P]
						}
					} else n.$menuInner.focus()
				}

				this.setPositionData(), s(i, !0), this.$menuInner.off("scroll.createView").on("scroll.createView", function (t, e) {
					n.noScroll || s(this.scrollTop, e), n.noScroll = !1
				}), t(window).off("resize.createView").on("resize.createView", function () {
					s(n.$menuInner[0].scrollTop)
				})
			}, createLi: function () {
				var e, i = this, n = [], r = 0, o = 0, a = [], s = 0, l = 0, c = -1;
				this.selectpicker.view.titleOption || (this.selectpicker.view.titleOption = document.createElement("option"));
				var u = {span: document.createElement("span"), subtext: document.createElement("small"), a: document.createElement("a"), li: document.createElement("li"), whitespace: document.createTextNode(" ")}, h = u.span.cloneNode(!1), d = document.createDocumentFragment();
				h.className = i.options.iconBase + " " + i.options.tickIcon + " check-mark", u.a.appendChild(h), u.a.setAttribute("role", "option"), u.subtext.className = "text-muted", u.text = u.span.cloneNode(!1), u.text.className = "text";
				var f = function (t, e, i, n) {
					var r = u.li.cloneNode(!1);
					return t && (1 === t.nodeType || 11 === t.nodeType ? r.appendChild(t) : r.innerHTML = t), void 0 !== i && "" !== i && (r.className = i), null != n && r.classList.add("optgroup-" + n), r
				}, m = function (t, e, i) {
					var n = u.a.cloneNode(!0);
					return t && (11 === t.nodeType ? n.appendChild(t) : n.insertAdjacentHTML("beforeend", t)), void 0 !== e & "" !== e && (n.className = e), "4" === k.major && n.classList.add("dropdown-item"), i && n.setAttribute("style", i), n
				}, g = function (t) {
					var e, n, r = u.text.cloneNode(!1);
					if (t.optionContent) r.innerHTML = t.optionContent; else {
						if (r.textContent = t.text, t.optionIcon) {
							var o = u.whitespace.cloneNode(!1);
							(n = u.span.cloneNode(!1)).className = i.options.iconBase + " " + t.optionIcon, d.appendChild(n), d.appendChild(o)
						}
						t.optionSubtext && ((e = u.subtext.cloneNode(!1)).textContent = t.optionSubtext, r.appendChild(e))
					}
					return d.appendChild(r), d
				};
				if (this.options.title && !this.multiple) {
					c--;
					var v = this.$element[0], y = !1;
					if (!this.selectpicker.view.titleOption.parentNode) this.selectpicker.view.titleOption.className = "bs-title-option", this.selectpicker.view.titleOption.innerHTML = this.options.title, this.selectpicker.view.titleOption.value = "", y = void 0 === t(v.options[v.selectedIndex]).attr("selected") && void 0 === this.$element.data("selected");
					v.insertBefore(this.selectpicker.view.titleOption, v.firstChild), y && (v.selectedIndex = 0)
				}
				var b = this.$element.find("option");
				b.each(function (h) {
					var v = t(this);
					if (c++, !v.hasClass("bs-title-option")) {
						var y, w, x = v.data(), k = this.className || "", S = p(this.style.cssText), C = x.content, D = this.textContent, T = x.tokens, M = x.subtext, E = x.icon, A = v.parent(), P = A[0], I = "OPTGROUP" === P.tagName, O = I && P.disabled, L = this.disabled || O,
							F = this.previousElementSibling && "OPTGROUP" === this.previousElementSibling.tagName, N = A.data();
						if (!0 === x.hidden || i.options.hideDisabled && (L && !I || O)) {
							y = x.prevHiddenIndex, v.next().data("prevHiddenIndex", void 0 !== y ? y : h), c--, F || void 0 !== y && (W = b[y].previousElementSibling) && "OPTGROUP" === W.tagName && !W.disabled && (F = !0), F && "divider" !== a[a.length - 1].type && (c++, n.push(f(!1, 0, _.DIVIDER, s + "div")), a.push({
								type: "divider",
								optID: s,
								originalIndex: h
							}))
						} else {
							if (I && !0 !== x.divider) {
								if (i.options.hideDisabled && L) {
									if (void 0 === N.allOptionsDisabled) {
										var R = A.children();
										A.data("allOptionsDisabled", R.filter(":disabled").length === R.length)
									}
									if (A.data("allOptionsDisabled")) return void c--
								}
								var H = " " + P.className || "";
								if (!this.previousElementSibling) {
									s += 1;
									var $ = P.label, B = p($), z = N.subtext, j = N.icon;
									0 !== h && n.length > 0 && (c++, n.push(f(!1, 0, _.DIVIDER, s + "div")), a.push({type: "divider", optID: s, originalIndex: h})), c++;
									var U = function (t) {
										var e, n, r = u.text.cloneNode(!1);
										if (r.textContent = t.labelEscaped, t.labelIcon) {
											var o = u.whitespace.cloneNode(!1);
											(n = u.span.cloneNode(!1)).className = i.options.iconBase + " " + t.labelIcon, d.appendChild(n), d.appendChild(o)
										}
										return t.labelSubtext && ((e = u.subtext.cloneNode(!1)).textContent = t.labelSubtext, r.appendChild(e)), d.appendChild(r), d
									}({labelEscaped: B, labelSubtext: z, labelIcon: j});
									n.push(f(U, 0, "dropdown-header" + H, s)), a.push({content: B, subtext: z, type: "optgroup-label", optID: s, originalIndex: h}), l = c - 1
								}
								if (i.options.hideDisabled && L || !0 === x.hidden) return void c--;
								w = g({text: D, optionContent: C, optionSubtext: M, optionIcon: E}), n.push(f(m(w, "opt " + k + H, S), 0, "", s)), a.push({content: D, subtext: M, tokens: T, type: "option", optID: s, headerIndex: l, lastIndex: l + P.childElementCount, originalIndex: h}), r++
							} else if (!0 === x.divider) n.push(f(!1, 0, "divider")), a.push({type: "divider", originalIndex: h}); else {
								var W;
								if (!F && i.options.hideDisabled) if (void 0 !== (y = x.prevHiddenIndex)) (W = b[y].previousElementSibling) && "OPTGROUP" === W.tagName && !W.disabled && (F = !0);
								F && "divider" !== a[a.length - 1].type && (c++, n.push(f(!1, 0, _.DIVIDER, s + "div")), a.push({type: "divider", optID: s, originalIndex: h})), w = g({text: D, optionContent: C, optionSubtext: M, optionIcon: E}), n.push(f(m(w, k, S))), a.push({
									content: D,
									subtext: M,
									tokens: T,
									type: "option",
									originalIndex: h
								}), r++
							}
							i.selectpicker.main.map.newIndex[h] = c, i.selectpicker.main.map.originalIndex[c] = h;
							var Y = a[a.length - 1];
							Y.disabled = L;
							var V = 0;
							Y.content && (V += Y.content.length), Y.subtext && (V += Y.subtext.length), E && (V += 1), V > o && (o = V, e = n[n.length - 1])
						}
					}
				}), this.selectpicker.main.elements = n, this.selectpicker.main.data = a, this.selectpicker.current = this.selectpicker.main, this.selectpicker.view.widestOption = e, this.selectpicker.view.availableOptionsCount = r
			}, findLis: function () {
				return this.$menuInner.find(".inner > li")
			}, render: function () {
				var e = this, i = this.$element.find("option"), n = [], r = [];
				this.togglePlaceholder(), this.tabIndex(), i.each(function (i) {
					if (this.selected && (n.push(this), r.length < 100 && "count" !== e.options.selectedTextFormat)) {
						if (e.options.hideDisabled && (this.disabled || "OPTGROUP" === this.parentNode.tagName && this.parentNode.disabled)) return;
						var o, a, s = t(this), l = s.data(), c = l.icon && e.options.showIcon ? '<i class="' + e.options.iconBase + " " + l.icon + '"></i> ' : "";
						o = e.options.showSubtext && l.subtext && !e.multiple ? ' <small class="text-muted">' + l.subtext + "</small>" : "", a = void 0 !== s.attr("title") ? s.attr("title") : l.content && e.options.showContent ? l.content.toString() : c + s.html() + o, r.push(a)
					}
				});
				var o = this.multiple ? r.join(this.options.multipleSeparator) : r[0];
				if (n.length > 100 && (o += "..."), this.multiple && this.options.selectedTextFormat.indexOf("count") > -1) {
					var a = this.options.selectedTextFormat.split(">");
					if (a.length > 1 && n.length > a[1] || 1 === a.length && n.length >= 2) {
						var s = this.selectpicker.view.availableOptionsCount;
						o = ("function" == typeof this.options.countSelectedText ? this.options.countSelectedText(n.length, s) : this.options.countSelectedText).replace("{0}", n.length.toString()).replace("{1}", s.toString())
					}
				}
				null == this.options.title && (this.options.title = this.$element.attr("title")), "static" == this.options.selectedTextFormat && (o = this.options.title), o || (o = void 0 !== this.options.title ? this.options.title : this.options.noneSelectedText), this.$button.attr("title", f(t.trim(o.replace(/<[^>]*>?/g, "")))), this.$button.find(".filter-option-inner").html(o), this.$element.trigger("rendered.bs.select")
			}, setStyle: function (t, e) {
				this.$element.attr("class") && this.$newElement.addClass(this.$element.attr("class").replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ""));
				var i = t || this.options.style;
				"add" == e ? this.$button.addClass(i) : "remove" == e ? this.$button.removeClass(i) : (this.$button.removeClass(this.options.style), this.$button.addClass(i))
			}, liHeight: function (e) {
				if (e || !1 !== this.options.size && !this.sizeInfo) {
					this.sizeInfo || (this.sizeInfo = {});
					var i = document.createElement("div"), n = document.createElement("div"), r = document.createElement("div"), o = document.createElement("ul"), a = document.createElement("li"), s = document.createElement("li"), l = document.createElement("li"), c = document.createElement("a"),
						h = document.createElement("span"), d = this.options.header && this.$menu.find(".popover-title").length > 0 ? this.$menu.find(".popover-title")[0].cloneNode(!0) : null, p = this.options.liveSearch ? document.createElement("div") : null,
						f = this.options.actionsBox && this.multiple && this.$menu.find(".bs-actionsbox").length > 0 ? this.$menu.find(".bs-actionsbox")[0].cloneNode(!0) : null,
						m = this.options.doneButton && this.multiple && this.$menu.find(".bs-donebutton").length > 0 ? this.$menu.find(".bs-donebutton")[0].cloneNode(!0) : null;
					if (this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth, h.className = "text", c.className = "dropdown-item", i.className = this.$menu[0].parentNode.className + " " + _.SHOW, i.style.width = this.sizeInfo.selectWidth + "px", n.className = "dropdown-menu " + _.SHOW, r.className = "inner " + _.SHOW, o.className = "dropdown-menu inner " + ("4" === k.major ? _.SHOW : ""), a.className = _.DIVIDER, s.className = "dropdown-header", h.appendChild(document.createTextNode("Inner text")), c.appendChild(h), l.appendChild(c), s.appendChild(h.cloneNode(!0)), this.selectpicker.view.widestOption && o.appendChild(this.selectpicker.view.widestOption.cloneNode(!0)), o.appendChild(l), o.appendChild(a), o.appendChild(s), d && n.appendChild(d), p) {
						var g = document.createElement("input");
						p.className = "bs-searchbox", g.className = "form-control", p.appendChild(g), n.appendChild(p)
					}
					f && n.appendChild(f), r.appendChild(o), n.appendChild(r), m && n.appendChild(m), i.appendChild(n), document.body.appendChild(i);
					var v, y = c.offsetHeight, b = s ? s.offsetHeight : 0, w = d ? d.offsetHeight : 0, x = p ? p.offsetHeight : 0, S = f ? f.offsetHeight : 0, C = m ? m.offsetHeight : 0, D = t(a).outerHeight(!0), T = !!window.getComputedStyle && window.getComputedStyle(n), M = n.offsetWidth,
						E = T ? null : t(n), A = {
							vert: u(T ? T.paddingTop : E.css("paddingTop")) + u(T ? T.paddingBottom : E.css("paddingBottom")) + u(T ? T.borderTopWidth : E.css("borderTopWidth")) + u(T ? T.borderBottomWidth : E.css("borderBottomWidth")),
							horiz: u(T ? T.paddingLeft : E.css("paddingLeft")) + u(T ? T.paddingRight : E.css("paddingRight")) + u(T ? T.borderLeftWidth : E.css("borderLeftWidth")) + u(T ? T.borderRightWidth : E.css("borderRightWidth"))
						}, P = {vert: A.vert + u(T ? T.marginTop : E.css("marginTop")) + u(T ? T.marginBottom : E.css("marginBottom")) + 2, horiz: A.horiz + u(T ? T.marginLeft : E.css("marginLeft")) + u(T ? T.marginRight : E.css("marginRight")) + 2};
					r.style.overflowY = "scroll", v = n.offsetWidth - M, document.body.removeChild(i), this.sizeInfo.liHeight = y, this.sizeInfo.dropdownHeaderHeight = b, this.sizeInfo.headerHeight = w, this.sizeInfo.searchHeight = x, this.sizeInfo.actionsHeight = S, this.sizeInfo.doneButtonHeight = C, this.sizeInfo.dividerHeight = D, this.sizeInfo.menuPadding = A, this.sizeInfo.menuExtras = P, this.sizeInfo.menuWidth = M, this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth, this.sizeInfo.scrollBarWidth = v, this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight, this.setPositionData()
				}
			}, getSelectPosition: function () {
				var e, i = t(window), n = this.$newElement.offset(), r = t(this.options.container);
				this.options.container && !r.is("body") ? ((e = r.offset()).top += parseInt(r.css("borderTopWidth")), e.left += parseInt(r.css("borderLeftWidth"))) : e = {top: 0, left: 0};
				var o = this.options.windowPadding;
				this.sizeInfo.selectOffsetTop = n.top - e.top - i.scrollTop(), this.sizeInfo.selectOffsetBot = i.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - e.top - o[2], this.sizeInfo.selectOffsetLeft = n.left - e.left - i.scrollLeft(), this.sizeInfo.selectOffsetRight = i.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - e.left - o[1], this.sizeInfo.selectOffsetTop -= o[0], this.sizeInfo.selectOffsetLeft -= o[3]
			}, setMenuSize: function (t) {
				this.getSelectPosition();
				var e, i, n, r, o, a, s, l = this.sizeInfo.selectWidth, c = this.sizeInfo.liHeight, u = this.sizeInfo.headerHeight, h = this.sizeInfo.searchHeight, d = this.sizeInfo.actionsHeight, p = this.sizeInfo.doneButtonHeight, f = this.sizeInfo.dividerHeight, m = this.sizeInfo.menuPadding, g = 0;
				if (this.options.dropupAuto && (s = c * this.selectpicker.current.elements.length + m.vert, this.$newElement.toggleClass(_.DROPUP, this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && s + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot)), "auto" === this.options.size) r = this.selectpicker.current.elements.length > 3 ? 3 * this.sizeInfo.liHeight + this.sizeInfo.menuExtras.vert - 2 : 0, i = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert, n = r + u + h + d + p, a = Math.max(r - m.vert, 0), this.$newElement.hasClass(_.DROPUP) && (i = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert), o = i, e = i - u - h - d - p - m.vert; else if (this.options.size && "auto" != this.options.size && this.selectpicker.current.elements.length > this.options.size) {
					for (var v = 0; v < this.options.size; v++) "divider" === this.selectpicker.current.data[v].type && g++;
					e = (i = c * this.options.size + g * f + m.vert) - m.vert, o = i + u + h + d + p, n = a = ""
				}
				"auto" === this.options.dropdownAlignRight && this.$menu.toggleClass(_.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < this.$menu[0].offsetWidth - l), this.$menu.css({
					"max-height": o + "px",
					overflow: "hidden",
					"min-height": n + "px"
				}), this.$menuInner.css({
					"max-height": e + "px",
					"overflow-y": "auto",
					"min-height": a + "px"
				}), this.sizeInfo.menuInnerHeight = e, this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight && (this.sizeInfo.hasScrollBar = !0, this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth, this.$menu.css("min-width", this.sizeInfo.totalMenuWidth)), this.dropdown && this.dropdown._popper.update()
			}, setSize: function (e) {
				if (this.liHeight(e), this.options.header && this.$menu.css("padding-top", 0), !1 !== this.options.size) {
					var i, n = this, r = t(window), o = 0;
					this.setMenuSize(), "auto" === this.options.size ? (this.$searchbox.off("input.setMenuSize propertychange.setMenuSize").on("input.setMenuSize propertychange.setMenuSize", function () {
						return n.setMenuSize()
					}), r.off("resize.setMenuSize scroll.setMenuSize").on("resize.setMenuSize scroll.setMenuSize", function () {
						return n.setMenuSize()
					})) : this.options.size && "auto" != this.options.size && this.selectpicker.current.elements.length > this.options.size && (this.$searchbox.off("input.setMenuSize propertychange.setMenuSize"), r.off("resize.setMenuSize scroll.setMenuSize")), e ? o = this.$menuInner[0].scrollTop : n.multiple || "number" == typeof (i = n.selectpicker.main.map.newIndex[n.$element[0].selectedIndex]) && !1 !== n.options.size && (o = (o = n.sizeInfo.liHeight * i) - n.sizeInfo.menuInnerHeight / 2 + n.sizeInfo.liHeight / 2), n.createView(!1, o)
				}
			}, setWidth: function () {
				var t = this;
				"auto" === this.options.width ? requestAnimationFrame(function () {
					t.$menu.css("min-width", "0"), t.liHeight(), t.setMenuSize();
					var e = t.$newElement.clone().appendTo("body"), i = e.css("width", "auto").children("button").outerWidth();
					e.remove(), t.sizeInfo.selectWidth = Math.max(t.sizeInfo.totalMenuWidth, i), t.$newElement.css("width", t.sizeInfo.selectWidth + "px")
				}) : "fit" === this.options.width ? (this.$menu.css("min-width", ""), this.$newElement.css("width", "").addClass("fit-width")) : this.options.width ? (this.$menu.css("min-width", ""), this.$newElement.css("width", this.options.width)) : (this.$menu.css("min-width", ""), this.$newElement.css("width", "")), this.$newElement.hasClass("fit-width") && "fit" !== this.options.width && this.$newElement.removeClass("fit-width")
			}, selectPosition: function () {
				this.$bsContainer = t('<div class="bs-container" />');
				var e, i, n, r = this, o = t(this.options.container), a = function (t) {
					var a = {};
					r.$bsContainer.addClass(t.attr("class").replace(/form-control|fit-width/gi, "")).toggleClass(_.DROPUP, t.hasClass(_.DROPUP)), e = t.offset(), o.is("body") ? i = {
						top: 0,
						left: 0
					} : ((i = o.offset()).top += parseInt(o.css("borderTopWidth")) - o.scrollTop(), i.left += parseInt(o.css("borderLeftWidth")) - o.scrollLeft()), n = t.hasClass(_.DROPUP) ? 0 : t[0].offsetHeight, k.major < 4 && (a.top = e.top - i.top + n, a.left = e.left - i.left), a.width = t[0].offsetWidth, r.$bsContainer.css(a)
				};
				this.$button.on("click.bs.dropdown.data-api", function () {
					r.isDisabled() || (a(r.$newElement), r.$bsContainer.appendTo(r.options.container).toggleClass(_.SHOW, !r.$button.hasClass(_.SHOW)).append(r.$menu))
				}), t(window).on("resize scroll", function () {
					a(r.$newElement)
				}), this.$element.on("hide.bs.select", function () {
					r.$menu.data("height", r.$menu.height()), r.$bsContainer.detach()
				})
			}, setOptionStatus: function () {
				var t = this.$element.find("option");
				if (this.noScroll = !1, this.selectpicker.view.visibleElements && this.selectpicker.view.visibleElements.length) for (var e = 0; e < this.selectpicker.view.visibleElements.length; e++) {
					var i = this.selectpicker.current.map.originalIndex[e + this.selectpicker.view.position0], n = t[i];
					if (n) {
						var r = this.selectpicker.main.map.newIndex[i], o = this.selectpicker.main.elements[r];
						this.setDisabled(i, n.disabled || "OPTGROUP" === n.parentNode.tagName && n.parentNode.disabled, r, o), this.setSelected(i, n.selected, r, o)
					}
				}
			}, setSelected: function (t, e, i, n) {
				var r, o, a, s = void 0 !== this.activeIndex, l = this.activeIndex === t || e && !this.multiple && !s;
				i || (i = this.selectpicker.main.map.newIndex[t]), n || (n = this.selectpicker.main.elements[i]), a = n.firstChild, e && (this.selectedIndex = t), n.classList.toggle("selected", e), n.classList.toggle("active", l), l && (this.selectpicker.view.currentActive = n, this.activeIndex = t), a && (a.classList.toggle("selected", e), a.classList.toggle("active", l), a.setAttribute("aria-selected", e)), l || !s && e && this.prevActiveIndex && (r = this.selectpicker.main.map.newIndex[this.prevActiveIndex], (o = this.selectpicker.main.elements[r]).classList.remove("active"), o.firstChild && o.firstChild.classList.remove("active"))
			}, setDisabled: function (t, e, i, n) {
				var r;
				i || (i = this.selectpicker.main.map.newIndex[t]), n || (n = this.selectpicker.main.elements[i]), r = n.firstChild, n.classList.toggle(_.DISABLED, e), r && ("4" === k.major && r.classList.toggle(_.DISABLED, e), r.setAttribute("aria-disabled", e), e ? r.setAttribute("tabindex", -1) : r.setAttribute("tabindex", 0))
			}, isDisabled: function () {
				return this.$element[0].disabled
			}, checkDisabled: function () {
				var t = this;
				this.isDisabled() ? (this.$newElement.addClass(_.DISABLED), this.$button.addClass(_.DISABLED).attr("tabindex", -1).attr("aria-disabled", !0)) : (this.$button.hasClass(_.DISABLED) && (this.$newElement.removeClass(_.DISABLED), this.$button.removeClass(_.DISABLED).attr("aria-disabled", !1)), -1 != this.$button.attr("tabindex") || this.$element.data("tabindex") || this.$button.removeAttr("tabindex")), this.$button.click(function () {
					return !t.isDisabled()
				})
			}, togglePlaceholder: function () {
				var t = this.$element[0], e = t.selectedIndex, i = -1 === e;
				i || t.options[e].value || (i = !0), this.$button.toggleClass("bs-placeholder", i)
			}, tabIndex: function () {
				this.$element.data("tabindex") !== this.$element.attr("tabindex") && -98 !== this.$element.attr("tabindex") && "-98" !== this.$element.attr("tabindex") && (this.$element.data("tabindex", this.$element.attr("tabindex")), this.$button.attr("tabindex", this.$element.data("tabindex"))), this.$element.attr("tabindex", -98)
			}, clickListener: function () {
				var e = this, i = t(document);
				i.data("spaceSelect", !1), this.$button.on("keyup", function (t) {
					/(32)/.test(t.keyCode.toString(10)) && i.data("spaceSelect") && (t.preventDefault(), i.data("spaceSelect", !1))
				}), this.$newElement.on("show.bs.dropdown", function () {
					k.major > 3 && !e.dropdown && (e.dropdown = e.$button.data("bs.dropdown"), e.dropdown._menu = e.$menu[0])
				}), this.$button.on("click.bs.dropdown.data-api", function () {
					e.$newElement.hasClass(_.SHOW) || e.setSize()
				}), this.$element.on("shown.bs.select", function () {
					e.$menuInner[0].scrollTop !== e.selectpicker.view.scrollTop && (e.$menuInner[0].scrollTop = e.selectpicker.view.scrollTop), e.options.liveSearch ? e.$searchbox.focus() : e.$menuInner.focus()
				}), this.$menuInner.on("click", "li a", function (i, n) {
					var r = t(this), o = e.isVirtual() ? e.selectpicker.view.position0 : 0, a = e.selectpicker.current.map.originalIndex[r.parent().index() + o], l = e.$element.val(), c = e.$element.prop("selectedIndex"), u = !0;
					if (e.multiple && 1 !== e.options.maxOptions && i.stopPropagation(), i.preventDefault(), !e.isDisabled() && !r.parent().hasClass(_.DISABLED)) {
						var h = e.$element.find("option"), d = h.eq(a), p = d.prop("selected"), f = d.parent("optgroup"), m = e.options.maxOptions, g = f.data("maxOptions") || !1;
						if (e.multiple) {
							if (d.prop("selected", !p), a === e.activeIndex && (n = !0), n || (e.prevActiveIndex = e.activeIndex, e.activeIndex = void 0), e.setSelected(a, !p), r.blur(), !1 !== m || !1 !== g) {
								var v = m < h.filter(":selected").length, y = g < f.find("option:selected").length;
								if (m && v || g && y) if (m && 1 == m) h.prop("selected", !1), d.prop("selected", !0), e.$menuInner.find(".selected").removeClass("selected"), e.setSelected(a, !0); else if (g && 1 == g) {
									f.find("option:selected").prop("selected", !1), d.prop("selected", !0);
									var b = e.selectpicker.current.data[r.parent().index() + e.selectpicker.view.position0].optID;
									e.$menuInner.find(".optgroup-" + b).removeClass("selected"), e.setSelected(a, !0)
								} else {
									var w = "string" == typeof e.options.maxOptionsText ? [e.options.maxOptionsText, e.options.maxOptionsText] : e.options.maxOptionsText, x = "function" == typeof w ? w(m, g) : w, k = x[0].replace("{n}", m), S = x[1].replace("{n}", g), C = t('<div class="notify"></div>');
									x[2] && (k = k.replace("{var}", x[2][m > 1 ? 0 : 1]), S = S.replace("{var}", x[2][g > 1 ? 0 : 1])), d.prop("selected", !1), e.$menu.append(C), m && v && (C.append(t("<div>" + k + "</div>")), u = !1, e.$element.trigger("maxReached.bs.select")), g && y && (C.append(t("<div>" + S + "</div>")), u = !1, e.$element.trigger("maxReachedGrp.bs.select")), setTimeout(function () {
										e.setSelected(a, !1)
									}, 10), C.delay(750).fadeOut(300, function () {
										t(this).remove()
									})
								}
							}
						} else h.prop("selected", !1), d.prop("selected", !0), e.setSelected(a, !0);
						!e.multiple || e.multiple && 1 === e.options.maxOptions ? e.$button.focus() : e.options.liveSearch && e.$searchbox.focus(), u && (l != e.$element.val() && e.multiple || c != e.$element.prop("selectedIndex") && !e.multiple) && (s = [a, d.prop("selected"), p], e.$element.triggerNative("change"))
					}
				}), this.$menu.on("click", "li." + _.DISABLED + " a, .popover-title, .popover-title :not(.close)", function (i) {
					i.currentTarget == this && (i.preventDefault(), i.stopPropagation(), e.options.liveSearch && !t(i.target).hasClass("close") ? e.$searchbox.focus() : e.$button.focus())
				}), this.$menuInner.on("click", ".divider, .dropdown-header", function (t) {
					t.preventDefault(), t.stopPropagation(), e.options.liveSearch ? e.$searchbox.focus() : e.$button.focus()
				}), this.$menu.on("click", ".popover-title .close", function () {
					e.$button.click()
				}), this.$searchbox.on("click", function (t) {
					t.stopPropagation()
				}), this.$menu.on("click", ".actions-btn", function (i) {
					e.options.liveSearch ? e.$searchbox.focus() : e.$button.focus(), i.preventDefault(), i.stopPropagation(), t(this).hasClass("bs-select-all") ? e.selectAll() : e.deselectAll()
				}), this.$element.on({
					change: function () {
						e.render(), e.$element.trigger("changed.bs.select", s), s = null
					}, focus: function () {
						e.$button.focus()
					}
				})
			}, liveSearchListener: function () {
				var t = this, e = document.createElement("li");
				this.$button.on("click.bs.dropdown.data-api", function () {
					t.$searchbox.val() && t.$searchbox.val("")
				}), this.$searchbox.on("click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api", function (t) {
					t.stopPropagation()
				}), this.$searchbox.on("input propertychange", function () {
					var i = t.$searchbox.val();
					if (t.selectpicker.search.map.newIndex = {}, t.selectpicker.search.map.originalIndex = {}, t.selectpicker.search.elements = [], t.selectpicker.search.data = [], i) {
						var n = [], r = i.toUpperCase(), o = {}, a = [], s = t._searchStyle(), l = t.options.liveSearchNormalize;
						t._$lisSelected = t.$menuInner.find(".selected");
						for (var u = 0; u < t.selectpicker.main.data.length; u++) {
							var h = t.selectpicker.main.data[u];
							o[u] || (o[u] = c(h, r, s, l)), o[u] && void 0 !== h.headerIndex && -1 === a.indexOf(h.headerIndex) && (h.headerIndex > 0 && (o[h.headerIndex - 1] = !0, a.push(h.headerIndex - 1)), o[h.headerIndex] = !0, a.push(h.headerIndex), o[h.lastIndex + 1] = !0), o[u] && "optgroup-label" !== h.type && a.push(u)
						}
						u = 0;
						for (var d = a.length; u < d; u++) {
							var f = a[u], m = a[u - 1], g = (h = t.selectpicker.main.data[f], t.selectpicker.main.data[m]);
							("divider" !== h.type || "divider" === h.type && g && "divider" !== g.type && d - 1 !== u) && (t.selectpicker.search.data.push(h), n.push(t.selectpicker.main.elements[f]), t.selectpicker.search.map.newIndex[h.originalIndex] = n.length - 1, t.selectpicker.search.map.originalIndex[n.length - 1] = h.originalIndex)
						}
						t.activeIndex = void 0, t.noScroll = !0, t.$menuInner.scrollTop(0), t.selectpicker.search.elements = n, t.createView(!0), n.length || (e.className = "no-results", e.innerHTML = t.options.noneResultsText.replace("{0}", '"' + p(i) + '"'), t.$menuInner[0].firstChild.appendChild(e))
					} else t.$menuInner.scrollTop(0), t.createView(!1)
				})
			}, _searchStyle: function () {
				return this.options.liveSearchStyle || "contains"
			}, val: function (t) {
				return void 0 !== t ? (this.$element.val(t).triggerNative("change"), this.$element) : this.$element.val()
			}, changeAll: function (t) {
				if (this.multiple) {
					void 0 === t && (t = !0);
					for (var e = this.$element.find("option"), i = 0, n = 0, r = 0; r < this.selectpicker.current.elements.length; r++) {
						var o = e[this.selectpicker.current.map.originalIndex[r]];
						o && (o.selected && i++, o.selected = t, o.selected && n++)
					}
					i !== n && (this.setOptionStatus(), this.togglePlaceholder(), this.$element.triggerNative("change"))
				}
			}, selectAll: function () {
				return this.changeAll(!0)
			}, deselectAll: function () {
				return this.changeAll(!1)
			}, toggle: function (t) {
				(t = t || window.event) && t.stopPropagation(), this.$button.trigger("click.bs.dropdown.data-api")
			}, keydown: function (e) {
				var i, n, r, o, a, s = t(this), l = (s.is("input") ? s.parent().parent() : s.parent()).data("this"), u = l.findLis(), h = !1, d = e.which === b && !s.hasClass("dropdown-toggle") && !l.options.selectOnTab, p = S.test(e.which) || d, f = l.$menuInner[0].scrollTop, k = l.isVirtual(),
					D = !0 === k ? l.selectpicker.view.position0 : 0;
				if (!(n = l.$newElement.hasClass(_.SHOW)) && (p || e.which >= 48 && e.which <= 57 || e.which >= 96 && e.which <= 105 || e.which >= 65 && e.which <= 90) && l.$button.trigger("click.bs.dropdown.data-api"), e.which === g && n && (e.preventDefault(), l.$button.trigger("click.bs.dropdown.data-api").focus()), p) {
					if (!u.length) return;
					void 0 === (i = !0 === k ? u.index(u.filter(".active")) : l.selectpicker.current.map.newIndex[l.activeIndex]) && (i = -1), -1 !== i && ((r = l.selectpicker.current.elements[i + D]).classList.remove("active"), r.firstChild && r.firstChild.classList.remove("active")), e.which === w ? (-1 !== i && i--, i + D < 0 && (i += u.length), l.selectpicker.view.canHighlight[i + D] || -1 === (i = l.selectpicker.view.canHighlight.slice(0, i + D).lastIndexOf(!0) - D) && (i = u.length - 1)) : (e.which === x || d) && (++i + D >= l.selectpicker.view.canHighlight.length && (i = 0), l.selectpicker.view.canHighlight[i + D] || (i = i + 1 + l.selectpicker.view.canHighlight.slice(i + D + 1).indexOf(!0))), e.preventDefault();
					var T = D + i;
					e.which === w ? 0 === D && i === u.length - 1 ? (l.$menuInner[0].scrollTop = l.$menuInner[0].scrollHeight, T = l.selectpicker.current.elements.length - 1) : h = (a = (o = l.selectpicker.current.data[T]).position - o.height) < f : (e.which === x || d) && (0 !== D && 0 === i ? (l.$menuInner[0].scrollTop = 0, T = 0) : h = (a = (o = l.selectpicker.current.data[T]).position - l.sizeInfo.menuInnerHeight) > f), (r = l.selectpicker.current.elements[T]).classList.add("active"), r.firstChild && r.firstChild.classList.add("active"), l.activeIndex = l.selectpicker.current.map.originalIndex[T], l.selectpicker.view.currentActive = r, h && (l.$menuInner[0].scrollTop = a), l.options.liveSearch ? l.$searchbox.focus() : s.focus()
				} else if (!s.is("input") && !C.test(e.which) || e.which === y && l.selectpicker.keydown.keyHistory) {
					var M, E, A = [];
					e.preventDefault(), l.selectpicker.keydown.keyHistory += m[e.which], l.selectpicker.keydown.resetKeyHistory.cancel && clearTimeout(l.selectpicker.keydown.resetKeyHistory.cancel), l.selectpicker.keydown.resetKeyHistory.cancel = l.selectpicker.keydown.resetKeyHistory.start(), E = l.selectpicker.keydown.keyHistory, /^(.)\1+$/.test(E) && (E = E.charAt(0));
					for (var P = 0; P < l.selectpicker.current.data.length; P++) {
						var I = l.selectpicker.current.data[P];
						c(I, E, "startsWith", !0) && l.selectpicker.view.canHighlight[P] && (I.index = P, A.push(I.originalIndex))
					}
					if (A.length) {
						var O = 0;
						u.removeClass("active").find("a").removeClass("active"), 1 === E.length && (-1 === (O = A.indexOf(l.activeIndex)) || O === A.length - 1 ? O = 0 : O++), M = l.selectpicker.current.map.newIndex[A[O]], f - (o = l.selectpicker.current.data[M]).position > 0 ? (a = o.position - o.height, h = !0) : (a = o.position - l.sizeInfo.menuInnerHeight, h = o.position > f + l.sizeInfo.menuInnerHeight), (r = l.selectpicker.current.elements[M]).classList.add("active"), r.firstChild && r.firstChild.classList.add("active"), l.activeIndex = A[O], r.firstChild.focus(), h && (l.$menuInner[0].scrollTop = a), s.focus()
					}
				}
				n && (e.which === y && !l.selectpicker.keydown.keyHistory || e.which === v || e.which === b && l.options.selectOnTab) && (e.which !== y && e.preventDefault(), l.options.liveSearch && e.which === y || (l.$menuInner.find(".active a").trigger("click", !0), s.focus(), l.options.liveSearch || (e.preventDefault(), t(document).data("spaceSelect", !0))))
			}, mobile: function () {
				this.$element.addClass("mobile-device")
			}, refresh: function () {
				var e = t.extend({}, this.options, this.$element.data());
				this.options = e, this.selectpicker.main.map.newIndex = {}, this.selectpicker.main.map.originalIndex = {}, this.createLi(), this.checkDisabled(), this.render(), this.setStyle(), this.setWidth(), this.setSize(!0), this.$element.trigger("refreshed.bs.select")
			}, hide: function () {
				this.$newElement.hide()
			}, show: function () {
				this.$newElement.show()
			}, remove: function () {
				this.$newElement.remove(), this.$element.remove()
			}, destroy: function () {
				this.$newElement.before(this.$element).remove(), this.$bsContainer ? this.$bsContainer.remove() : this.$menu.remove(), this.$element.off(".bs.select").removeData("selectpicker").removeClass("bs-select-hidden selectpicker")
			}
		};
		var M = t.fn.selectpicker;
		t.fn.selectpicker = T, t.fn.selectpicker.Constructor = D, t.fn.selectpicker.noConflict = function () {
			return t.fn.selectpicker = M, this
		}, t(document).off("keydown.bs.dropdown.data-api").on("keydown.bs.select", '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bs-searchbox input', D.prototype.keydown).on("focusin.modal", '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bs-searchbox input', function (t) {
			t.stopPropagation()
		}), t(window).on("load.bs.select.data-api", function () {
			t(".selectpicker").each(function () {
				var e = t(this);
				T.call(e, e.data())
			})
		})
	}(t)
}), function (t, e) {
	"function" == typeof define && define.amd ? define("bloodhound", ["jquery"], function (i) {
		return t.Bloodhound = e(i)
	}) : "object" == typeof exports ? module.exports = e(require("jquery")) : t.Bloodhound = e(jQuery)
}(this, function (t) {
	var e = function () {
		"use strict";
		return {
			isMsie: function () {
				return !!/(msie|trident)/i.test(navigator.userAgent) && navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2]
			}, isBlankString: function (t) {
				return !t || /^\s*$/.test(t)
			}, escapeRegExChars: function (t) {
				return t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
			}, isString: function (t) {
				return "string" == typeof t
			}, isNumber: function (t) {
				return "number" == typeof t
			}, isArray: t.isArray, isFunction: t.isFunction, isObject: t.isPlainObject, isUndefined: function (t) {
				return void 0 === t
			}, isElement: function (t) {
				return !(!t || 1 !== t.nodeType)
			}, isJQuery: function (e) {
				return e instanceof t
			}, toStr: function (t) {
				return e.isUndefined(t) || null === t ? "" : t + ""
			}, bind: t.proxy, each: function (e, i) {
				t.each(e, function (t, e) {
					return i(e, t)
				})
			}, map: t.map, filter: t.grep, every: function (e, i) {
				var n = !0;
				return e ? (t.each(e, function (t, r) {
					if (!(n = i.call(null, r, t, e))) return !1
				}), !!n) : n
			}, some: function (e, i) {
				var n = !1;
				return e ? (t.each(e, function (t, r) {
					if (n = i.call(null, r, t, e)) return !1
				}), !!n) : n
			}, mixin: t.extend, identity: function (t) {
				return t
			}, clone: function (e) {
				return t.extend(!0, {}, e)
			}, getIdGenerator: function () {
				var t = 0;
				return function () {
					return t++
				}
			}, templatify: function (e) {
				return t.isFunction(e) ? e : function () {
					return String(e)
				}
			}, defer: function (t) {
				setTimeout(t, 0)
			}, debounce: function (t, e, i) {
				var n, r;
				return function () {
					var o, a, s = this, l = arguments;
					return o = function () {
						n = null, i || (r = t.apply(s, l))
					}, a = i && !n, clearTimeout(n), n = setTimeout(o, e), a && (r = t.apply(s, l)), r
				}
			}, throttle: function (t, e) {
				var i, n, r, o, a, s;
				return a = 0, s = function () {
					a = new Date, r = null, o = t.apply(i, n)
				}, function () {
					var l = new Date, c = e - (l - a);
					return i = this, n = arguments, c <= 0 ? (clearTimeout(r), r = null, a = l, o = t.apply(i, n)) : r || (r = setTimeout(s, c)), o
				}
			}, stringify: function (t) {
				return e.isString(t) ? t : JSON.stringify(t)
			}, noop: function () {
			}
		}
	}(), i = "0.11.1", n = function () {
		"use strict";
		return {nonword: i, whitespace: t, obj: {nonword: n(i), whitespace: n(t)}};

		function t(t) {
			return (t = e.toStr(t)) ? t.split(/\s+/) : []
		}

		function i(t) {
			return (t = e.toStr(t)) ? t.split(/\W+/) : []
		}

		function n(t) {
			return function (i) {
				return i = e.isArray(i) ? i : [].slice.call(arguments, 0), function (n) {
					var r = [];
					return e.each(i, function (i) {
						r = r.concat(t(e.toStr(n[i])))
					}), r
				}
			}
		}
	}(), r = function () {
		"use strict";

		function i(i) {
			this.maxSize = e.isNumber(i) ? i : 100, this.reset(), this.maxSize <= 0 && (this.set = this.get = t.noop)
		}

		function n() {
			this.head = this.tail = null
		}

		function r(t, e) {
			this.key = t, this.val = e, this.prev = this.next = null
		}

		return e.mixin(i.prototype, {
			set: function (t, e) {
				var i, n = this.list.tail;
				this.size >= this.maxSize && (this.list.remove(n), delete this.hash[n.key], this.size--), (i = this.hash[t]) ? (i.val = e, this.list.moveToFront(i)) : (i = new r(t, e), this.list.add(i), this.hash[t] = i, this.size++)
			}, get: function (t) {
				var e = this.hash[t];
				if (e) return this.list.moveToFront(e), e.val
			}, reset: function () {
				this.size = 0, this.hash = {}, this.list = new n
			}
		}), e.mixin(n.prototype, {
			add: function (t) {
				this.head && (t.next = this.head, this.head.prev = t), this.head = t, this.tail = this.tail || t
			}, remove: function (t) {
				t.prev ? t.prev.next = t.next : this.head = t.next, t.next ? t.next.prev = t.prev : this.tail = t.prev
			}, moveToFront: function (t) {
				this.remove(t), this.add(t)
			}
		}), i
	}(), o = function () {
		"use strict";
		var i;
		try {
			(i = window.localStorage).setItem("~~~", "!"), i.removeItem("~~~")
		} catch (t) {
			i = null
		}

		function n(t, n) {
			this.prefix = ["__", t, "__"].join(""), this.ttlKey = "__ttl__", this.keyMatcher = new RegExp("^" + e.escapeRegExChars(this.prefix)), this.ls = n || i, !this.ls && this._noop()
		}

		return e.mixin(n.prototype, {
			_prefix: function (t) {
				return this.prefix + t
			}, _ttlKey: function (t) {
				return this._prefix(t) + this.ttlKey
			}, _noop: function () {
				this.get = this.set = this.remove = this.clear = this.isExpired = e.noop
			}, _safeSet: function (t, e) {
				try {
					this.ls.setItem(t, e)
				} catch (t) {
					"QuotaExceededError" === t.name && (this.clear(), this._noop())
				}
			}, get: function (t) {
				return this.isExpired(t) && this.remove(t), a(this.ls.getItem(this._prefix(t)))
			}, set: function (t, i, n) {
				return e.isNumber(n) ? this._safeSet(this._ttlKey(t), o(r() + n)) : this.ls.removeItem(this._ttlKey(t)), this._safeSet(this._prefix(t), o(i))
			}, remove: function (t) {
				return this.ls.removeItem(this._ttlKey(t)), this.ls.removeItem(this._prefix(t)), this
			}, clear: function () {
				var t, e = function (t) {
					var e, n, r = [], o = i.length;
					for (e = 0; e < o; e++) (n = i.key(e)).match(t) && r.push(n.replace(t, ""));
					return r
				}(this.keyMatcher);
				for (t = e.length; t--;) this.remove(e[t]);
				return this
			}, isExpired: function (t) {
				var i = a(this.ls.getItem(this._ttlKey(t)));
				return !!(e.isNumber(i) && r() > i)
			}
		}), n;

		function r() {
			return (new Date).getTime()
		}

		function o(t) {
			return JSON.stringify(e.isUndefined(t) ? null : t)
		}

		function a(e) {
			return t.parseJSON(e)
		}
	}(), a = function () {
		"use strict";
		var i = 0, n = {}, o = 6, a = new r(10);

		function s(t) {
			t = t || {}, this.cancelled = !1, this.lastReq = null, this._send = t.transport, this._get = t.limiter ? t.limiter(this._get) : this._get, this._cache = !1 === t.cache ? new r(0) : a
		}

		return s.setMaxPendingRequests = function (t) {
			o = t
		}, s.resetCache = function () {
			a.reset()
		}, e.mixin(s.prototype, {
			_fingerprint: function (e) {
				return (e = e || {}).url + e.type + t.param(e.data || {})
			}, _get: function (t, e) {
				var r, a, s = this;

				function l(t) {
					e(null, t), s._cache.set(r, t)
				}

				function c() {
					e(!0)
				}

				r = this._fingerprint(t), this.cancelled || r !== this.lastReq || ((a = n[r]) ? a.done(l).fail(c) : i < o ? (i++, n[r] = this._send(t).done(l).fail(c).always(function () {
					i--, delete n[r], s.onDeckRequestArgs && (s._get.apply(s, s.onDeckRequestArgs), s.onDeckRequestArgs = null)
				})) : this.onDeckRequestArgs = [].slice.call(arguments, 0))
			}, get: function (i, n) {
				var r, o;
				n = n || t.noop, i = e.isString(i) ? {url: i} : i || {}, o = this._fingerprint(i), this.cancelled = !1, this.lastReq = o, (r = this._cache.get(o)) ? n(null, r) : this._get(i, n)
			}, cancel: function () {
				this.cancelled = !0
			}
		}), s
	}(), s = window.SearchIndex = function () {
		"use strict";
		var i = "c", n = "i";

		function r(i) {
			(i = i || {}).datumTokenizer && i.queryTokenizer || t.error("datumTokenizer and queryTokenizer are both required"), this.identify = i.identify || e.stringify, this.datumTokenizer = i.datumTokenizer, this.queryTokenizer = i.queryTokenizer, this.reset()
		}

		return e.mixin(r.prototype, {
			bootstrap: function (t) {
				this.datums = t.datums, this.trie = t.trie
			}, add: function (t) {
				var r = this;
				t = e.isArray(t) ? t : [t], e.each(t, function (t) {
					var s, l;
					r.datums[s = r.identify(t)] = t, l = o(r.datumTokenizer(t)), e.each(l, function (t) {
						var e, o, l;
						for (e = r.trie, o = t.split(""); l = o.shift();) (e = e[i][l] || (e[i][l] = a()))[n].push(s)
					})
				})
			}, get: function (t) {
				var i = this;
				return e.map(t, function (t) {
					return i.datums[t]
				})
			}, search: function (t) {
				var r, a, s = this;
				return r = o(this.queryTokenizer(t)), e.each(r, function (t) {
					var e, r, o, l;
					if (a && 0 === a.length) return !1;
					for (e = s.trie, r = t.split(""); e && (o = r.shift());) e = e[i][o];
					if (!e || 0 !== r.length) return a = [], !1;
					l = e[n].slice(0), a = a ? function (t, e) {
						var i = 0, n = 0, r = [];
						t = t.sort(), e = e.sort();
						var o = t.length, a = e.length;
						for (; i < o && n < a;) t[i] < e[n] ? i++ : t[i] > e[n] ? n++ : (r.push(t[i]), i++, n++);
						return r
					}(a, l) : l
				}), a ? e.map(function (t) {
					for (var e = {}, i = [], n = 0, r = t.length; n < r; n++) e[t[n]] || (e[t[n]] = !0, i.push(t[n]));
					return i
				}(a), function (t) {
					return s.datums[t]
				}) : []
			}, all: function () {
				var t = [];
				for (var e in this.datums) t.push(this.datums[e]);
				return t
			}, reset: function () {
				this.datums = {}, this.trie = a()
			}, serialize: function () {
				return {datums: this.datums, trie: this.trie}
			}
		}), r;

		function o(t) {
			return t = e.filter(t, function (t) {
				return !!t
			}), t = e.map(t, function (t) {
				return t.toLowerCase()
			})
		}

		function a() {
			var t = {};
			return t[n] = [], t[i] = {}, t
		}
	}(), l = function () {
		"use strict";
		var t;

		function i(t) {
			this.url = t.url, this.ttl = t.ttl, this.cache = t.cache, this.prepare = t.prepare, this.transform = t.transform, this.transport = t.transport, this.thumbprint = t.thumbprint, this.storage = new o(t.cacheKey)
		}

		return t = {data: "data", protocol: "protocol", thumbprint: "thumbprint"}, e.mixin(i.prototype, {
			_settings: function () {
				return {url: this.url, type: "GET", dataType: "json"}
			}, store: function (e) {
				this.cache && (this.storage.set(t.data, e, this.ttl), this.storage.set(t.protocol, location.protocol, this.ttl), this.storage.set(t.thumbprint, this.thumbprint, this.ttl))
			}, fromCache: function () {
				var e, i = {};
				return this.cache ? (i.data = this.storage.get(t.data), i.protocol = this.storage.get(t.protocol), i.thumbprint = this.storage.get(t.thumbprint), e = i.thumbprint !== this.thumbprint || i.protocol !== location.protocol, i.data && !e ? i.data : null) : null
			}, fromNetwork: function (t) {
				var e, i = this;
				t && (e = this.prepare(this._settings()), this.transport(e).fail(function () {
					t(!0)
				}).done(function (e) {
					t(null, i.transform(e))
				}))
			}, clear: function () {
				return this.storage.clear(), this
			}
		}), i
	}(), c = function () {
		"use strict";

		function t(t) {
			this.url = t.url, this.prepare = t.prepare, this.transform = t.transform, this.transport = new a({cache: t.cache, limiter: t.limiter, transport: t.transport})
		}

		return e.mixin(t.prototype, {
			_settings: function () {
				return {url: this.url, type: "GET", dataType: "json"}
			}, get: function (t, e) {
				var i, n = this;
				if (e) return t = t || "", i = this.prepare(t, this._settings()), this.transport.get(i, function (t, i) {
					e(t ? [] : n.transform(i))
				})
			}, cancelLastRequest: function () {
				this.transport.cancel()
			}
		}), t
	}(), u = function () {
		"use strict";
		return function (r) {
			var o, a;
			return o = {
				initialize: !0,
				identify: e.stringify,
				datumTokenizer: null,
				queryTokenizer: null,
				sufficient: 5,
				sorter: null,
				local: [],
				prefetch: null,
				remote: null
			}, !(r = e.mixin(o, r || {})).datumTokenizer && t.error("datumTokenizer is required"), !r.queryTokenizer && t.error("queryTokenizer is required"), a = r.sorter, r.sorter = a ? function (t) {
				return t.sort(a)
			} : e.identity, r.local = e.isFunction(r.local) ? r.local() : r.local, r.prefetch = function (r) {
				var o;
				if (!r) return null;
				return o = {
					url: null,
					ttl: 864e5,
					cache: !0,
					cacheKey: null,
					thumbprint: "",
					prepare: e.identity,
					transform: e.identity,
					transport: null
				}, r = e.isString(r) ? {url: r} : r, !(r = e.mixin(o, r)).url && t.error("prefetch requires url to be set"), r.transform = r.filter || r.transform, r.cacheKey = r.cacheKey || r.url, r.thumbprint = i + r.thumbprint, r.transport = r.transport ? n(r.transport) : t.ajax, r
			}(r.prefetch), r.remote = function (i) {
				var r;
				if (!i) return;
				return r = {
					url: null,
					cache: !0,
					prepare: null,
					replace: null,
					wildcard: null,
					limiter: null,
					rateLimitBy: "debounce",
					rateLimitWait: 300,
					transform: e.identity,
					transport: null
				}, i = e.isString(i) ? {url: i} : i, !(i = e.mixin(r, i)).url && t.error("remote requires url to be set"), i.transform = i.filter || i.transform, i.prepare = function (t) {
					var e, i, n;
					return e = t.prepare, i = t.replace, n = t.wildcard, e || (e = i ? function (t, e) {
						return e.url = i(e.url, t), e
					} : t.wildcard ? function (t, e) {
						return e.url = e.url.replace(n, encodeURIComponent(t)), e
					} : function (t, e) {
						return e
					})
				}(i), i.limiter = function (t) {
					var i, n, r;
					return i = t.limiter, n = t.rateLimitBy, r = t.rateLimitWait, i || (i = /^throttle$/i.test(n) ? function (t) {
						return function (i) {
							return e.throttle(i, t)
						}
					}(r) : function (t) {
						return function (i) {
							return e.debounce(i, t)
						}
					}(r)), i
				}(i), i.transport = i.transport ? n(i.transport) : t.ajax, delete i.replace, delete i.wildcard, delete i.rateLimitBy, delete i.rateLimitWait, i
			}(r.remote), r
		};

		function n(i) {
			return function (n) {
				var r = t.Deferred();
				return i(n, function (t) {
					e.defer(function () {
						r.resolve(t)
					})
				}, function (t) {
					e.defer(function () {
						r.reject(t)
					})
				}), r
			}
		}
	}();
	return function () {
		"use strict";
		var i;

		function r(t) {
			t = u(t), this.sorter = t.sorter, this.identify = t.identify, this.sufficient = t.sufficient, this.local = t.local, this.remote = t.remote ? new c(t.remote) : null, this.prefetch = t.prefetch ? new l(t.prefetch) : null, this.index = new s({
				identify: this.identify,
				datumTokenizer: t.datumTokenizer,
				queryTokenizer: t.queryTokenizer
			}), !1 !== t.initialize && this.initialize()
		}

		return i = window && window.Bloodhound, r.noConflict = function () {
			return window && (window.Bloodhound = i), r
		}, r.tokenizers = n, e.mixin(r.prototype, {
			__ttAdapter: function () {
				var t = this;
				return this.remote ? function (e, i, n) {
					return t.search(e, i, n)
				} : function (e, i) {
					return t.search(e, i)
				}
			}, _loadPrefetch: function () {
				var e, i, n = this;
				return e = t.Deferred(), this.prefetch ? (i = this.prefetch.fromCache()) ? (this.index.bootstrap(i), e.resolve()) : this.prefetch.fromNetwork(function (t, i) {
					if (t) return e.reject();
					n.add(i), n.prefetch.store(n.index.serialize()), e.resolve()
				}) : e.resolve(), e.promise()
			}, _initialize: function () {
				var t = this;
				return this.clear(), (this.initPromise = this._loadPrefetch()).done(function () {
					t.add(t.local)
				}), this.initPromise
			}, initialize: function (t) {
				return !this.initPromise || t ? this._initialize() : this.initPromise
			}, add: function (t) {
				return this.index.add(t), this
			}, get: function (t) {
				return t = e.isArray(t) ? t : [].slice.call(arguments), this.index.get(t)
			}, search: function (t, i, n) {
				var r, o = this;
				return r = this.sorter(this.index.search(t)), i(this.remote ? r.slice() : r), this.remote && r.length < this.sufficient ? this.remote.get(t, function (t) {
					var i = [];
					e.each(t, function (t) {
						!e.some(r, function (e) {
							return o.identify(t) === o.identify(e)
						}) && i.push(t)
					}), n && n(i)
				}) : this.remote && this.remote.cancelLastRequest(), this
			}, all: function () {
				return this.index.all()
			}, clear: function () {
				return this.index.reset(), this
			}, clearPrefetchCache: function () {
				return this.prefetch && this.prefetch.clear(), this
			}, clearRemoteCache: function () {
				return a.resetCache(), this
			}, ttAdapter: function () {
				return this.__ttAdapter()
			}
		}), r
	}()
}), function (t, e) {
	"function" == typeof define && define.amd ? define("typeahead.js", ["jquery"], function (t) {
		return e(t)
	}) : "object" == typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
}(0, function (t) {
	var e = function () {
		"use strict";
		return {
			isMsie: function () {
				return !!/(msie|trident)/i.test(navigator.userAgent) && navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2]
			}, isBlankString: function (t) {
				return !t || /^\s*$/.test(t)
			}, escapeRegExChars: function (t) {
				return t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
			}, isString: function (t) {
				return "string" == typeof t
			}, isNumber: function (t) {
				return "number" == typeof t
			}, isArray: t.isArray, isFunction: t.isFunction, isObject: t.isPlainObject, isUndefined: function (t) {
				return void 0 === t
			}, isElement: function (t) {
				return !(!t || 1 !== t.nodeType)
			}, isJQuery: function (e) {
				return e instanceof t
			}, toStr: function (t) {
				return e.isUndefined(t) || null === t ? "" : t + ""
			}, bind: t.proxy, each: function (e, i) {
				t.each(e, function (t, e) {
					return i(e, t)
				})
			}, map: t.map, filter: t.grep, every: function (e, i) {
				var n = !0;
				return e ? (t.each(e, function (t, r) {
					if (!(n = i.call(null, r, t, e))) return !1
				}), !!n) : n
			}, some: function (e, i) {
				var n = !1;
				return e ? (t.each(e, function (t, r) {
					if (n = i.call(null, r, t, e)) return !1
				}), !!n) : n
			}, mixin: t.extend, identity: function (t) {
				return t
			}, clone: function (e) {
				return t.extend(!0, {}, e)
			}, getIdGenerator: function () {
				var t = 0;
				return function () {
					return t++
				}
			}, templatify: function (e) {
				return t.isFunction(e) ? e : function () {
					return String(e)
				}
			}, defer: function (t) {
				setTimeout(t, 0)
			}, debounce: function (t, e, i) {
				var n, r;
				return function () {
					var o, a, s = this, l = arguments;
					return o = function () {
						n = null, i || (r = t.apply(s, l))
					}, a = i && !n, clearTimeout(n), n = setTimeout(o, e), a && (r = t.apply(s, l)), r
				}
			}, throttle: function (t, e) {
				var i, n, r, o, a, s;
				return a = 0, s = function () {
					a = new Date, r = null, o = t.apply(i, n)
				}, function () {
					var l = new Date, c = e - (l - a);
					return i = this, n = arguments, c <= 0 ? (clearTimeout(r), r = null, a = l, o = t.apply(i, n)) : r || (r = setTimeout(s, c)), o
				}
			}, stringify: function (t) {
				return e.isString(t) ? t : JSON.stringify(t)
			}, noop: function () {
			}
		}
	}(), i = function () {
		"use strict";
		var t = {wrapper: "twitter-typeahead", input: "tt-input", hint: "tt-hint", menu: "tt-menu", dataset: "tt-dataset", suggestion: "tt-suggestion", selectable: "tt-selectable", empty: "tt-empty", open: "tt-open", cursor: "tt-cursor", highlight: "tt-highlight"};
		return function (r) {
			var o, a;
			return a = e.mixin({}, t, r), {
				css: (o = {css: n(), classes: a, html: (s = a, {wrapper: '<span class="' + s.wrapper + '"></span>', menu: '<div class="' + s.menu + '"></div>'}), selectors: i(a)}).css, html: o.html, classes: o.classes, selectors: o.selectors, mixin: function (t) {
					e.mixin(t, o)
				}
			};
			var s
		};

		function i(t) {
			var i = {};
			return e.each(t, function (t, e) {
				i[e] = "." + t
			}), i
		}

		function n() {
			var t = {
				wrapper: {position: "relative", display: "inline-block"},
				hint: {position: "absolute", top: "0", left: "0", borderColor: "transparent", boxShadow: "none", opacity: "1"},
				input: {position: "relative", verticalAlign: "top", backgroundColor: "transparent"},
				inputWithNoHint: {position: "relative", verticalAlign: "top"},
				menu: {position: "absolute", top: "100%", left: "0", zIndex: "100", display: "none"},
				ltr: {left: "0", right: "auto"},
				rtl: {left: "auto", right: " 0"}
			};
			return e.isMsie() && e.mixin(t.input, {backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"}), t
		}
	}(), n = function () {
		"use strict";
		var i;

		function n(e) {
			e && e.el || t.error("EventBus initialized without el"), this.$el = t(e.el)
		}

		return "typeahead:", i = {render: "rendered", cursorchange: "cursorchanged", select: "selected", autocomplete: "autocompleted"}, e.mixin(n.prototype, {
			_trigger: function (e, i) {
				var n;
				return n = t.Event("typeahead:" + e), (i = i || []).unshift(n), this.$el.trigger.apply(this.$el, i), n
			}, before: function (t) {
				var e;
				return e = [].slice.call(arguments, 1), this._trigger("before" + t, e).isDefaultPrevented()
			}, trigger: function (t) {
				var e;
				this._trigger(t, [].slice.call(arguments, 1)), (e = i[t]) && this._trigger(e, [].slice.call(arguments, 1))
			}
		}), n
	}(), r = function () {
		"use strict";
		var t = /\s+/, e = function () {
			var t;
			t = window.setImmediate ? function (t) {
				setImmediate(function () {
					t()
				})
			} : function (t) {
				setTimeout(function () {
					t()
				}, 0)
			};
			return t
		}();
		return {
			onSync: function (t, e, n) {
				return i.call(this, "sync", t, e, n)
			}, onAsync: function (t, e, n) {
				return i.call(this, "async", t, e, n)
			}, off: function (e) {
				var i;
				if (!this._callbacks) return this;
				e = e.split(t);
				for (; i = e.shift();) delete this._callbacks[i];
				return this
			}, trigger: function (i) {
				var r, o, a, s, l;
				if (!this._callbacks) return this;
				i = i.split(t), a = [].slice.call(arguments, 1);
				for (; (r = i.shift()) && (o = this._callbacks[r]);) s = n(o.sync, this, [r].concat(a)), l = n(o.async, this, [r].concat(a)), s() && e(l);
				return this
			}
		};

		function i(e, i, n, r) {
			var o;
			if (!n) return this;
			for (i = i.split(t), n = r ? function (t, e) {
				return t.bind ? t.bind(e) : function () {
					t.apply(e, [].slice.call(arguments, 0))
				}
			}(n, r) : n, this._callbacks = this._callbacks || {}; o = i.shift();) this._callbacks[o] = this._callbacks[o] || {sync: [], async: []}, this._callbacks[o][e].push(n);
			return this
		}

		function n(t, e, i) {
			return function () {
				for (var n, r = 0, o = t.length; !n && r < o; r += 1) n = !1 === t[r].apply(e, i);
				return !n
			}
		}
	}(), o = function (t) {
		"use strict";
		var i = {node: null, pattern: null, tagName: "strong", className: null, wordsOnly: !1, caseSensitive: !1};
		return function (n) {
			var r;
			(n = e.mixin({}, i, n)).node && n.pattern && (n.pattern = e.isArray(n.pattern) ? n.pattern : [n.pattern], r = function (t, i, n) {
				for (var r, o = [], a = 0, s = t.length; a < s; a++) o.push(e.escapeRegExChars(t[a]));
				return r = n ? "\\b(" + o.join("|") + ")\\b" : "(" + o.join("|") + ")", i ? new RegExp(r) : new RegExp(r, "i")
			}(n.pattern, n.caseSensitive, n.wordsOnly), function t(e, i) {
				var n;
				for (var r = 0; r < e.childNodes.length; r++) 3 === (n = e.childNodes[r]).nodeType ? r += i(n) ? 1 : 0 : t(n, i)
			}(n.node, function (e) {
				var i, o, a;
				(i = r.exec(e.data)) && (a = t.createElement(n.tagName), n.className && (a.className = n.className), (o = e.splitText(i.index)).splitText(i[0].length), a.appendChild(o.cloneNode(!0)), e.parentNode.replaceChild(a, o));
				return !!i
			}))
		}
	}(window.document), a = function () {
		"use strict";
		var i;

		function n(i, n) {
			var r;
			(i = i || {}).input || t.error("input is missing"), n.mixin(this), this.$hint = t(i.hint), this.$input = t(i.input), this.query = this.$input.val(), this.queryWhenFocused = this.hasFocus() ? this.query : null, this.$overflowHelper = (r = this.$input, t('<pre aria-hidden="true"></pre>').css({
				position: "absolute",
				visibility: "hidden",
				whiteSpace: "pre",
				fontFamily: r.css("font-family"),
				fontSize: r.css("font-size"),
				fontStyle: r.css("font-style"),
				fontVariant: r.css("font-variant"),
				fontWeight: r.css("font-weight"),
				wordSpacing: r.css("word-spacing"),
				letterSpacing: r.css("letter-spacing"),
				textIndent: r.css("text-indent"),
				textRendering: r.css("text-rendering"),
				textTransform: r.css("text-transform")
			}).insertAfter(r)), this._checkLanguageDirection(), 0 === this.$hint.length && (this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = e.noop)
		}

		return i = {9: "tab", 27: "esc", 37: "left", 39: "right", 13: "enter", 38: "up", 40: "down"}, n.normalizeQuery = function (t) {
			return e.toStr(t).replace(/^\s*/g, "").replace(/\s{2,}/g, " ")
		}, e.mixin(n.prototype, r, {
			_onBlur: function () {
				this.resetInputValue(), this.trigger("blurred")
			}, _onFocus: function () {
				this.queryWhenFocused = this.query, this.trigger("focused")
			}, _onKeydown: function (t) {
				var e = i[t.which || t.keyCode];
				this._managePreventDefault(e, t), e && this._shouldTrigger(e, t) && this.trigger(e + "Keyed", t)
			}, _onInput: function () {
				this._setQuery(this.getInputValue()), this.clearHintIfInvalid(), this._checkLanguageDirection()
			}, _managePreventDefault: function (t, e) {
				var i;
				switch (t) {
					case"up":
					case"down":
						i = !o(e);
						break;
					default:
						i = !1
				}
				i && e.preventDefault()
			}, _shouldTrigger: function (t, e) {
				var i;
				switch (t) {
					case"tab":
						i = !o(e);
						break;
					default:
						i = !0
				}
				return i
			}, _checkLanguageDirection: function () {
				var t = (this.$input.css("direction") || "ltr").toLowerCase();
				this.dir !== t && (this.dir = t, this.$hint.attr("dir", t), this.trigger("langDirChanged", t))
			}, _setQuery: function (t, e) {
				var i, r, o, a;
				o = t, a = this.query, r = !!(i = n.normalizeQuery(o) === n.normalizeQuery(a)) && this.query.length !== t.length, this.query = t, e || i ? !e && r && this.trigger("whitespaceChanged", this.query) : this.trigger("queryChanged", this.query)
			}, bind: function () {
				var t, n, r, o, a = this;
				return t = e.bind(this._onBlur, this), n = e.bind(this._onFocus, this), r = e.bind(this._onKeydown, this), o = e.bind(this._onInput, this), this.$input.on("blur.tt", t).on("focus.tt", n).on("keydown.tt", r), !e.isMsie() || e.isMsie() > 9 ? this.$input.on("input.tt", o) : this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function (t) {
					i[t.which || t.keyCode] || e.defer(e.bind(a._onInput, a, t))
				}), this
			}, focus: function () {
				this.$input.focus()
			}, blur: function () {
				this.$input.blur()
			}, getLangDir: function () {
				return this.dir
			}, getQuery: function () {
				return this.query || ""
			}, setQuery: function (t, e) {
				this.setInputValue(t), this._setQuery(t, e)
			}, hasQueryChangedSinceLastFocus: function () {
				return this.query !== this.queryWhenFocused
			}, getInputValue: function () {
				return this.$input.val()
			}, setInputValue: function (t) {
				this.$input.val(t), this.clearHintIfInvalid(), this._checkLanguageDirection()
			}, resetInputValue: function () {
				this.setInputValue(this.query)
			}, getHint: function () {
				return this.$hint.val()
			}, setHint: function (t) {
				this.$hint.val(t)
			}, clearHint: function () {
				this.setHint("")
			}, clearHintIfInvalid: function () {
				var t, e, i;
				i = (t = this.getInputValue()) !== (e = this.getHint()) && 0 === e.indexOf(t), !("" !== t && i && !this.hasOverflow()) && this.clearHint()
			}, hasFocus: function () {
				return this.$input.is(":focus")
			}, hasOverflow: function () {
				var t = this.$input.width() - 2;
				return this.$overflowHelper.text(this.getInputValue()), this.$overflowHelper.width() >= t
			}, isCursorAtEnd: function () {
				var t, i, n;
				return t = this.$input.val().length, i = this.$input[0].selectionStart, e.isNumber(i) ? i === t : !document.selection || ((n = document.selection.createRange()).moveStart("character", -t), t === n.text.length)
			}, destroy: function () {
				this.$hint.off(".tt"), this.$input.off(".tt"), this.$overflowHelper.remove(), this.$hint = this.$input = this.$overflowHelper = t("<div>")
			}
		}), n;

		function o(t) {
			return t.altKey || t.ctrlKey || t.metaKey || t.shiftKey
		}
	}(), s = function () {
		"use strict";
		var i, n;

		function a(i, r) {
			var o;
			(i = i || {}).templates = i.templates || {}, i.templates.notFound = i.templates.notFound || i.templates.empty, i.source || t.error("missing source"), i.node || t.error("missing node"), i.name && (o = i.name, !/^[_a-zA-Z0-9-]+$/.test(o)) && t.error("invalid dataset name: " + i.name), r.mixin(this), this.highlight = !!i.highlight, this.name = i.name || n(), this.limit = i.limit || 5, this.displayFn = function (t) {
				return t = t || e.stringify, e.isFunction(t) ? t : function (e) {
					return e[t]
				}
			}(i.display || i.displayKey), this.templates = function (i, n) {
				return {
					notFound: i.notFound && e.templatify(i.notFound), pending: i.pending && e.templatify(i.pending), header: i.header && e.templatify(i.header), footer: i.footer && e.templatify(i.footer), suggestion: i.suggestion || function (e) {
						return t("<div>").text(n(e))
					}
				}
			}(i.templates, this.displayFn), this.source = i.source.__ttAdapter ? i.source.__ttAdapter() : i.source, this.async = e.isUndefined(i.async) ? this.source.length > 2 : !!i.async, this._resetLastSuggestion(), this.$el = t(i.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name)
		}

		return i = {val: "tt-selectable-display", obj: "tt-selectable-object"}, n = e.getIdGenerator(), a.extractData = function (e) {
			var n = t(e);
			return n.data(i.obj) ? {val: n.data(i.val) || "", obj: n.data(i.obj) || null} : null
		}, e.mixin(a.prototype, r, {
			_overwrite: function (t, e) {
				(e = e || []).length ? this._renderSuggestions(t, e) : this.async && this.templates.pending ? this._renderPending(t) : !this.async && this.templates.notFound ? this._renderNotFound(t) : this._empty(), this.trigger("rendered", this.name, e, !1)
			}, _append: function (t, e) {
				(e = e || []).length && this.$lastSuggestion.length ? this._appendSuggestions(t, e) : e.length ? this._renderSuggestions(t, e) : !this.$lastSuggestion.length && this.templates.notFound && this._renderNotFound(t), this.trigger("rendered", this.name, e, !0)
			}, _renderSuggestions: function (t, e) {
				var i;
				i = this._getSuggestionsFragment(t, e), this.$lastSuggestion = i.children().last(), this.$el.html(i).prepend(this._getHeader(t, e)).append(this._getFooter(t, e))
			}, _appendSuggestions: function (t, e) {
				var i, n;
				n = (i = this._getSuggestionsFragment(t, e)).children().last(), this.$lastSuggestion.after(i), this.$lastSuggestion = n
			}, _renderPending: function (t) {
				var e = this.templates.pending;
				this._resetLastSuggestion(), e && this.$el.html(e({query: t, dataset: this.name}))
			}, _renderNotFound: function (t) {
				var e = this.templates.notFound;
				this._resetLastSuggestion(), e && this.$el.html(e({query: t, dataset: this.name}))
			}, _empty: function () {
				this.$el.empty(), this._resetLastSuggestion()
			}, _getSuggestionsFragment: function (n, r) {
				var a, s = this;
				return a = document.createDocumentFragment(), e.each(r, function (e) {
					var r, o;
					o = s._injectQuery(n, e), r = t(s.templates.suggestion(o)).data(i.obj, e).data(i.val, s.displayFn(e)).addClass(s.classes.suggestion + " " + s.classes.selectable), a.appendChild(r[0])
				}), this.highlight && o({className: this.classes.highlight, node: a, pattern: n}), t(a)
			}, _getFooter: function (t, e) {
				return this.templates.footer ? this.templates.footer({query: t, suggestions: e, dataset: this.name}) : null
			}, _getHeader: function (t, e) {
				return this.templates.header ? this.templates.header({query: t, suggestions: e, dataset: this.name}) : null
			}, _resetLastSuggestion: function () {
				this.$lastSuggestion = t()
			}, _injectQuery: function (t, i) {
				return e.isObject(i) ? e.mixin({_query: t}, i) : i
			}, update: function (e) {
				var i = this, n = !1, r = !1, o = 0;

				function a(t) {
					r || (r = !0, t = (t || []).slice(0, i.limit), o = t.length, i._overwrite(e, t), o < i.limit && i.async && i.trigger("asyncRequested", e))
				}

				this.cancel(), this.cancel = function () {
					n = !0, i.cancel = t.noop, i.async && i.trigger("asyncCanceled", e)
				}, this.source(e, a, function (r) {
					r = r || [], !n && o < i.limit && (i.cancel = t.noop, o += r.length, i._append(e, r.slice(0, i.limit - o)), i.async && i.trigger("asyncReceived", e))
				}), !r && a([])
			}, cancel: t.noop, clear: function () {
				this._empty(), this.cancel(), this.trigger("cleared")
			}, isEmpty: function () {
				return this.$el.is(":empty")
			}, destroy: function () {
				this.$el = t("<div>")
			}
		}), a
	}(), l = function () {
		"use strict";

		function i(i, n) {
			var r = this;
			(i = i || {}).node || t.error("node is required"), n.mixin(this), this.$node = t(i.node), this.query = null, this.datasets = e.map(i.datasets, function (e) {
				var i = r.$node.find(e.node).first();
				return e.node = i.length ? i : t("<div>").appendTo(r.$node), new s(e, n)
			})
		}

		return e.mixin(i.prototype, r, {
			_onSelectableClick: function (e) {
				this.trigger("selectableClicked", t(e.currentTarget))
			}, _onRendered: function (t, e, i, n) {
				this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty()), this.trigger("datasetRendered", e, i, n)
			}, _onCleared: function () {
				this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty()), this.trigger("datasetCleared")
			}, _propagate: function () {
				this.trigger.apply(this, arguments)
			}, _allDatasetsEmpty: function () {
				return e.every(this.datasets, function (t) {
					return t.isEmpty()
				})
			}, _getSelectables: function () {
				return this.$node.find(this.selectors.selectable)
			}, _removeCursor: function () {
				var t = this.getActiveSelectable();
				t && t.removeClass(this.classes.cursor)
			}, _ensureVisible: function (t) {
				var e, i, n, r;
				i = (e = t.position().top) + t.outerHeight(!0), n = this.$node.scrollTop(), r = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10), e < 0 ? this.$node.scrollTop(n + e) : r < i && this.$node.scrollTop(n + (i - r))
			}, bind: function () {
				var t, i = this;
				return t = e.bind(this._onSelectableClick, this), this.$node.on("click.tt", this.selectors.selectable, t), e.each(this.datasets, function (t) {
					t.onSync("asyncRequested", i._propagate, i).onSync("asyncCanceled", i._propagate, i).onSync("asyncReceived", i._propagate, i).onSync("rendered", i._onRendered, i).onSync("cleared", i._onCleared, i)
				}), this
			}, isOpen: function () {
				return this.$node.hasClass(this.classes.open)
			}, open: function () {
				this.$node.addClass(this.classes.open)
			}, close: function () {
				this.$node.removeClass(this.classes.open), this._removeCursor()
			}, setLanguageDirection: function (t) {
				this.$node.attr("dir", t)
			}, selectableRelativeToCursor: function (t) {
				var e, i, n;
				return i = this.getActiveSelectable(), e = this._getSelectables(), -1 === (n = (n = ((n = (i ? e.index(i) : -1) + t) + 1) % (e.length + 1) - 1) < -1 ? e.length - 1 : n) ? null : e.eq(n)
			}, setCursor: function (t) {
				this._removeCursor(), (t = t && t.first()) && (t.addClass(this.classes.cursor), this._ensureVisible(t))
			}, getSelectableData: function (t) {
				return t && t.length ? s.extractData(t) : null
			}, getActiveSelectable: function () {
				var t = this._getSelectables().filter(this.selectors.cursor).first();
				return t.length ? t : null
			}, getTopSelectable: function () {
				var t = this._getSelectables().first();
				return t.length ? t : null
			}, update: function (t) {
				var i = t !== this.query;
				return i && (this.query = t, e.each(this.datasets, function (e) {
					e.update(t)
				})), i
			}, empty: function () {
				e.each(this.datasets, function (t) {
					t.clear()
				}), this.query = null, this.$node.addClass(this.classes.empty)
			}, destroy: function () {
				this.$node.off(".tt"), this.$node = t("<div>"), e.each(this.datasets, function (t) {
					t.destroy()
				})
			}
		}), i
	}(), c = function () {
		"use strict";
		var t = l.prototype;

		function i() {
			l.apply(this, [].slice.call(arguments, 0))
		}

		return e.mixin(i.prototype, l.prototype, {
			open: function () {
				return !this._allDatasetsEmpty() && this._show(), t.open.apply(this, [].slice.call(arguments, 0))
			}, close: function () {
				return this._hide(), t.close.apply(this, [].slice.call(arguments, 0))
			}, _onRendered: function () {
				return this._allDatasetsEmpty() ? this._hide() : this.isOpen() && this._show(), t._onRendered.apply(this, [].slice.call(arguments, 0))
			}, _onCleared: function () {
				return this._allDatasetsEmpty() ? this._hide() : this.isOpen() && this._show(), t._onCleared.apply(this, [].slice.call(arguments, 0))
			}, setLanguageDirection: function (e) {
				return this.$node.css("ltr" === e ? this.css.ltr : this.css.rtl), t.setLanguageDirection.apply(this, [].slice.call(arguments, 0))
			}, _hide: function () {
				this.$node.hide()
			}, _show: function () {
				this.$node.css("display", "block")
			}
		}), i
	}(), u = function () {
		"use strict";

		function i(i, r) {
			var o, a, s, l, c, u, h, d, p, f, m;
			(i = i || {}).input || t.error("missing input"), i.menu || t.error("missing menu"), i.eventBus || t.error("missing event bus"), r.mixin(this), this.eventBus = i.eventBus, this.minLength = e.isNumber(i.minLength) ? i.minLength : 1, this.input = i.input, this.menu = i.menu, this.enabled = !0, this.active = !1, this.input.hasFocus() && this.activate(), this.dir = this.input.getLangDir(), this._hacks(), this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this), o = n(this, "activate", "open", "_onFocused"), a = n(this, "deactivate", "_onBlurred"), s = n(this, "isActive", "isOpen", "_onEnterKeyed"), l = n(this, "isActive", "isOpen", "_onTabKeyed"), c = n(this, "isActive", "_onEscKeyed"), u = n(this, "isActive", "open", "_onUpKeyed"), h = n(this, "isActive", "open", "_onDownKeyed"), d = n(this, "isActive", "isOpen", "_onLeftKeyed"), p = n(this, "isActive", "isOpen", "_onRightKeyed"), f = n(this, "_openIfActive", "_onQueryChanged"), m = n(this, "_openIfActive", "_onWhitespaceChanged"), this.input.bind().onSync("focused", o, this).onSync("blurred", a, this).onSync("enterKeyed", s, this).onSync("tabKeyed", l, this).onSync("escKeyed", c, this).onSync("upKeyed", u, this).onSync("downKeyed", h, this).onSync("leftKeyed", d, this).onSync("rightKeyed", p, this).onSync("queryChanged", f, this).onSync("whitespaceChanged", m, this).onSync("langDirChanged", this._onLangDirChanged, this)
		}

		return e.mixin(i.prototype, {
			_hacks: function () {
				var i, n;
				i = this.input.$input || t("<div>"), n = this.menu.$node || t("<div>"), i.on("blur.tt", function (t) {
					var r, o, a;
					r = document.activeElement, o = n.is(r), a = n.has(r).length > 0, e.isMsie() && (o || a) && (t.preventDefault(), t.stopImmediatePropagation(), e.defer(function () {
						i.focus()
					}))
				}), n.on("mousedown.tt", function (t) {
					t.preventDefault()
				})
			}, _onSelectableClicked: function (t, e) {
				this.select(e)
			}, _onDatasetCleared: function () {
				this._updateHint()
			}, _onDatasetRendered: function (t, e, i, n) {
				this._updateHint(), this.eventBus.trigger("render", i, n, e)
			}, _onAsyncRequested: function (t, e, i) {
				this.eventBus.trigger("asyncrequest", i, e)
			}, _onAsyncCanceled: function (t, e, i) {
				this.eventBus.trigger("asynccancel", i, e)
			}, _onAsyncReceived: function (t, e, i) {
				this.eventBus.trigger("asyncreceive", i, e)
			}, _onFocused: function () {
				this._minLengthMet() && this.menu.update(this.input.getQuery())
			}, _onBlurred: function () {
				this.input.hasQueryChangedSinceLastFocus() && this.eventBus.trigger("change", this.input.getQuery())
			}, _onEnterKeyed: function (t, e) {
				var i;
				(i = this.menu.getActiveSelectable()) && this.select(i) && e.preventDefault()
			}, _onTabKeyed: function (t, e) {
				var i;
				(i = this.menu.getActiveSelectable()) ? this.select(i) && e.preventDefault() : (i = this.menu.getTopSelectable()) && this.autocomplete(i) && e.preventDefault()
			}, _onEscKeyed: function () {
				this.close()
			}, _onUpKeyed: function () {
				this.moveCursor(-1)
			}, _onDownKeyed: function () {
				this.moveCursor(1)
			}, _onLeftKeyed: function () {
				"rtl" === this.dir && this.input.isCursorAtEnd() && this.autocomplete(this.menu.getTopSelectable())
			}, _onRightKeyed: function () {
				"ltr" === this.dir && this.input.isCursorAtEnd() && this.autocomplete(this.menu.getTopSelectable())
			}, _onQueryChanged: function (t, e) {
				this._minLengthMet(e) ? this.menu.update(e) : this.menu.empty()
			}, _onWhitespaceChanged: function () {
				this._updateHint()
			}, _onLangDirChanged: function (t, e) {
				this.dir !== e && (this.dir = e, this.menu.setLanguageDirection(e))
			}, _openIfActive: function () {
				this.isActive() && this.open()
			}, _minLengthMet: function (t) {
				return (t = e.isString(t) ? t : this.input.getQuery() || "").length >= this.minLength
			}, _updateHint: function () {
				var t, i, n, r, o, s;
				t = this.menu.getTopSelectable(), i = this.menu.getSelectableData(t), n = this.input.getInputValue(), !i || e.isBlankString(n) || this.input.hasOverflow() ? this.input.clearHint() : (r = a.normalizeQuery(n), o = e.escapeRegExChars(r), (s = new RegExp("^(?:" + o + ")(.+$)", "i").exec(i.val)) && this.input.setHint(n + s[1]))
			}, isEnabled: function () {
				return this.enabled
			}, enable: function () {
				this.enabled = !0
			}, disable: function () {
				this.enabled = !1
			}, isActive: function () {
				return this.active
			}, activate: function () {
				return !!this.isActive() || !(!this.isEnabled() || this.eventBus.before("active")) && (this.active = !0, this.eventBus.trigger("active"), !0)
			}, deactivate: function () {
				return !this.isActive() || !this.eventBus.before("idle") && (this.active = !1, this.close(), this.eventBus.trigger("idle"), !0)
			}, isOpen: function () {
				return this.menu.isOpen()
			}, open: function () {
				return this.isOpen() || this.eventBus.before("open") || (this.menu.open(), this._updateHint(), this.eventBus.trigger("open")), this.isOpen()
			}, close: function () {
				return this.isOpen() && !this.eventBus.before("close") && (this.menu.close(), this.input.clearHint(), this.input.resetInputValue(), this.eventBus.trigger("close")), !this.isOpen()
			}, setVal: function (t) {
				this.input.setQuery(e.toStr(t))
			}, getVal: function () {
				return this.input.getQuery()
			}, select: function (t) {
				var e = this.menu.getSelectableData(t);
				return !(!e || this.eventBus.before("select", e.obj)) && (this.input.setQuery(e.val, !0), this.eventBus.trigger("select", e.obj), this.close(), !0)
			}, autocomplete: function (t) {
				var e, i;
				return e = this.input.getQuery(), !(!((i = this.menu.getSelectableData(t)) && e !== i.val) || this.eventBus.before("autocomplete", i.obj)) && (this.input.setQuery(i.val), this.eventBus.trigger("autocomplete", i.obj), !0)
			}, moveCursor: function (t) {
				var e, i, n, r;
				return e = this.input.getQuery(), i = this.menu.selectableRelativeToCursor(t), r = (n = this.menu.getSelectableData(i)) ? n.obj : null, !(this._minLengthMet() && this.menu.update(e)) && !this.eventBus.before("cursorchange", r) && (this.menu.setCursor(i), n ? this.input.setInputValue(n.val) : (this.input.resetInputValue(), this._updateHint()), this.eventBus.trigger("cursorchange", r), !0)
			}, destroy: function () {
				this.input.destroy(), this.menu.destroy()
			}
		}), i;

		function n(t) {
			var i = [].slice.call(arguments, 1);
			return function () {
				var n = [].slice.call(arguments);
				e.each(i, function (e) {
					return t[e].apply(t, n)
				})
			}
		}
	}();
	!function () {
		"use strict";
		var r, o, s;

		function h(e, i) {
			e.each(function () {
				var e, n = t(this);
				(e = n.data(o.typeahead)) && i(e, n)
			})
		}

		function d(i) {
			var n;
			return (n = e.isJQuery(i) || e.isElement(i) ? t(i).first() : []).length ? n : null
		}

		r = t.fn.typeahead, o = {www: "tt-www", attrs: "tt-attrs", typeahead: "tt-typeahead"}, s = {
			initialize: function (r, s) {
				var h;
				return s = e.isArray(s) ? s : [].slice.call(arguments, 1), h = i((r = r || {}).classNames), this.each(function () {
					var i, p, f, m, g, v, y, b, w, x, k;
					e.each(s, function (t) {
						t.highlight = !!r.highlight
					}), i = t(this), p = t(h.html.wrapper), f = d(r.hint), m = d(r.menu), g = !1 !== r.hint && !f, v = !1 !== r.menu && !m, g && (f = function (t, e) {
						return t.clone().addClass(e.classes.hint).removeData().css(e.css.hint).css((i = t, {
							backgroundAttachment: i.css("background-attachment"),
							backgroundClip: i.css("background-clip"),
							backgroundColor: i.css("background-color"),
							backgroundImage: i.css("background-image"),
							backgroundOrigin: i.css("background-origin"),
							backgroundPosition: i.css("background-position"),
							backgroundRepeat: i.css("background-repeat"),
							backgroundSize: i.css("background-size")
						})).prop("readonly", !0).removeAttr("id name placeholder required").attr({autocomplete: "off", spellcheck: "false", tabindex: -1});
						var i
					}(i, h)), v && (m = t(h.html.menu).css(h.css.menu)), f && f.val(""), i = function (t, e) {
						t.data(o.attrs, {dir: t.attr("dir"), autocomplete: t.attr("autocomplete"), spellcheck: t.attr("spellcheck"), style: t.attr("style")}), t.addClass(e.classes.input).attr({autocomplete: "off", spellcheck: !1});
						try {
							!t.attr("dir") && t.attr("dir", "auto")
						} catch (t) {
						}
						return t
					}(i, h), (g || v) && (p.css(h.css.wrapper), i.css(g ? h.css.input : h.css.inputWithNoHint), i.wrap(p).parent().prepend(g ? f : null).append(v ? m : null));
					k = v ? c : l, y = new n({el: i}), b = new a({hint: f, input: i}, h), w = new k({node: m, datasets: s}, h), x = new u({input: b, menu: w, eventBus: y, minLength: r.minLength}, h), i.data(o.www, h), i.data(o.typeahead, x)
				})
			}, isEnabled: function () {
				var t;
				return h(this.first(), function (e) {
					t = e.isEnabled()
				}), t
			}, enable: function () {
				return h(this, function (t) {
					t.enable()
				}), this
			}, disable: function () {
				return h(this, function (t) {
					t.disable()
				}), this
			}, isActive: function () {
				var t;
				return h(this.first(), function (e) {
					t = e.isActive()
				}), t
			}, activate: function () {
				return h(this, function (t) {
					t.activate()
				}), this
			}, deactivate: function () {
				return h(this, function (t) {
					t.deactivate()
				}), this
			}, isOpen: function () {
				var t;
				return h(this.first(), function (e) {
					t = e.isOpen()
				}), t
			}, open: function () {
				return h(this, function (t) {
					t.open()
				}), this
			}, close: function () {
				return h(this, function (t) {
					t.close()
				}), this
			}, select: function (e) {
				var i = !1, n = t(e);
				return h(this.first(), function (t) {
					i = t.select(n)
				}), i
			}, autocomplete: function (e) {
				var i = !1, n = t(e);
				return h(this.first(), function (t) {
					i = t.autocomplete(n)
				}), i
			}, moveCursor: function (t) {
				var e = !1;
				return h(this.first(), function (i) {
					e = i.moveCursor(t)
				}), e
			}, val: function (t) {
				var e;
				return arguments.length ? (h(this, function (e) {
					e.setVal(t)
				}), this) : (h(this.first(), function (t) {
					e = t.getVal()
				}), e)
			}, destroy: function () {
				return h(this, function (t, i) {
					!function (t) {
						var i, n;
						i = t.data(o.www), n = t.parent().filter(i.selectors.wrapper), e.each(t.data(o.attrs), function (i, n) {
							e.isUndefined(i) ? t.removeAttr(n) : t.attr(n, i)
						}), t.removeData(o.typeahead).removeData(o.www).removeData(o.attr).removeClass(i.classes.input), n.length && (t.detach().insertAfter(n), n.remove())
					}(i), t.destroy()
				}), this
			}
		}, t.fn.typeahead = function (t) {
			return s[t] ? s[t].apply(this, [].slice.call(arguments, 1)) : s.initialize.apply(this, arguments)
		}, t.fn.typeahead.noConflict = function () {
			return t.fn.typeahead = r, this
		}
	}()
}), function (t, e) {
	"object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Handlebars = e() : t.Handlebars = e()
}(this, function () {
	return function (t) {
		var e = {};

		function i(n) {
			if (e[n]) return e[n].exports;
			var r = e[n] = {exports: {}, id: n, loaded: !1};
			return t[n].call(r.exports, r, r.exports, i), r.loaded = !0, r.exports
		}

		return i.m = t, i.c = e, i.p = "", i(0)
	}([function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0;
		var r = n(i(2)), o = n(i(35)), a = i(36), s = i(41), l = n(i(42)), c = n(i(39)), u = n(i(34)), h = r.default.create;

		function d() {
			var t = h();
			return t.compile = function (e, i) {
				return s.compile(e, i, t)
			}, t.precompile = function (e, i) {
				return s.precompile(e, i, t)
			}, t.AST = o.default, t.Compiler = s.Compiler, t.JavaScriptCompiler = l.default, t.Parser = a.parser, t.parse = a.parse, t
		}

		var p = d();
		p.create = d, u.default(p), p.Visitor = c.default, p.default = p, e.default = p, t.exports = e.default
	}, function (t, e) {
		"use strict";
		e.default = function (t) {
			return t && t.__esModule ? t : {default: t}
		}, e.__esModule = !0
	}, function (t, e, i) {
		"use strict";
		var n = i(3).default, r = i(1).default;
		e.__esModule = !0;
		var o = n(i(4)), a = r(i(21)), s = r(i(6)), l = n(i(5)), c = n(i(22)), u = r(i(34));

		function h() {
			var t = new o.HandlebarsEnvironment;
			return l.extend(t, o), t.SafeString = a.default, t.Exception = s.default, t.Utils = l, t.escapeExpression = l.escapeExpression, t.VM = c, t.template = function (e) {
				return c.template(e, t)
			}, t
		}

		var d = h();
		d.create = h, u.default(d), d.default = d, e.default = d, t.exports = e.default
	}, function (t, e) {
		"use strict";
		e.default = function (t) {
			if (t && t.__esModule) return t;
			var e = {};
			if (null != t) for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
			return e.default = t, e
		}, e.__esModule = !0
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0, e.HandlebarsEnvironment = c;
		var r = i(5), o = n(i(6)), a = i(10), s = i(18), l = n(i(20));
		e.VERSION = "4.0.10";
		e.COMPILER_REVISION = 7;
		e.REVISION_CHANGES = {1: "<= 1.0.rc.2", 2: "== 1.0.0-rc.3", 3: "== 1.0.0-rc.4", 4: "== 1.x.x", 5: "== 2.0.0-alpha.x", 6: ">= 2.0.0-beta.1", 7: ">= 4.0.0"};

		function c(t, e, i) {
			this.helpers = t || {}, this.partials = e || {}, this.decorators = i || {}, a.registerDefaultHelpers(this), s.registerDefaultDecorators(this)
		}

		c.prototype = {
			constructor: c, logger: l.default, log: l.default.log, registerHelper: function (t, e) {
				if ("[object Object]" === r.toString.call(t)) {
					if (e) throw new o.default("Arg not supported with multiple helpers");
					r.extend(this.helpers, t)
				} else this.helpers[t] = e
			}, unregisterHelper: function (t) {
				delete this.helpers[t]
			}, registerPartial: function (t, e) {
				if ("[object Object]" === r.toString.call(t)) r.extend(this.partials, t); else {
					if (void 0 === e) throw new o.default('Attempting to register a partial called "' + t + '" as undefined');
					this.partials[t] = e
				}
			}, unregisterPartial: function (t) {
				delete this.partials[t]
			}, registerDecorator: function (t, e) {
				if ("[object Object]" === r.toString.call(t)) {
					if (e) throw new o.default("Arg not supported with multiple decorators");
					r.extend(this.decorators, t)
				} else this.decorators[t] = e
			}, unregisterDecorator: function (t) {
				delete this.decorators[t]
			}
		};
		var u = l.default.log;
		e.log = u, e.createFrame = r.createFrame, e.logger = l.default
	}, function (t, e) {
		"use strict";
		e.__esModule = !0, e.extend = a, e.indexOf = function (t, e) {
			for (var i = 0, n = t.length; i < n; i++) if (t[i] === e) return i;
			return -1
		}, e.escapeExpression = function (t) {
			if ("string" != typeof t) {
				if (t && t.toHTML) return t.toHTML();
				if (null == t) return "";
				if (!t) return t + "";
				t = "" + t
			}
			if (!r.test(t)) return t;
			return t.replace(n, o)
		}, e.isEmpty = function (t) {
			return !t && 0 !== t || !(!c(t) || 0 !== t.length)
		}, e.createFrame = function (t) {
			var e = a({}, t);
			return e._parent = t, e
		}, e.blockParams = function (t, e) {
			return t.path = e, t
		}, e.appendContextPath = function (t, e) {
			return (t ? t + "." : "") + e
		};
		var i = {"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;", "=": "&#x3D;"}, n = /[&<>"'`=]/g, r = /[&<>"'`=]/;

		function o(t) {
			return i[t]
		}

		function a(t) {
			for (var e = 1; e < arguments.length; e++) for (var i in arguments[e]) Object.prototype.hasOwnProperty.call(arguments[e], i) && (t[i] = arguments[e][i]);
			return t
		}

		var s = Object.prototype.toString;
		e.toString = s;
		var l = function (t) {
			return "function" == typeof t
		};
		l(/x/) && (e.isFunction = l = function (t) {
			return "function" == typeof t && "[object Function]" === s.call(t)
		}), e.isFunction = l;
		var c = Array.isArray || function (t) {
			return !(!t || "object" != typeof t) && "[object Array]" === s.call(t)
		};
		e.isArray = c
	}, function (t, e, i) {
		"use strict";
		var n = i(7).default;
		e.__esModule = !0;
		var r = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];

		function o(t, e) {
			var i = e && e.loc, a = void 0, s = void 0;
			i && (t += " - " + (a = i.start.line) + ":" + (s = i.start.column));
			for (var l = Error.prototype.constructor.call(this, t), c = 0; c < r.length; c++) this[r[c]] = l[r[c]];
			Error.captureStackTrace && Error.captureStackTrace(this, o);
			try {
				i && (this.lineNumber = a, n ? Object.defineProperty(this, "column", {value: s, enumerable: !0}) : this.column = s)
			} catch (t) {
			}
		}

		o.prototype = new Error, e.default = o, t.exports = e.default
	}, function (t, e, i) {
		t.exports = {default: i(8), __esModule: !0}
	}, function (t, e, i) {
		var n = i(9);
		t.exports = function (t, e, i) {
			return n.setDesc(t, e, i)
		}
	}, function (t, e) {
		var i = Object;
		t.exports = {create: i.create, getProto: i.getPrototypeOf, isEnum: {}.propertyIsEnumerable, getDesc: i.getOwnPropertyDescriptor, setDesc: i.defineProperty, setDescs: i.defineProperties, getKeys: i.keys, getNames: i.getOwnPropertyNames, getSymbols: i.getOwnPropertySymbols, each: [].forEach}
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0, e.registerDefaultHelpers = function (t) {
			r.default(t), o.default(t), a.default(t), s.default(t), l.default(t), c.default(t), u.default(t)
		};
		var r = n(i(11)), o = n(i(12)), a = n(i(13)), s = n(i(14)), l = n(i(15)), c = n(i(16)), u = n(i(17))
	}, function (t, e, i) {
		"use strict";
		e.__esModule = !0;
		var n = i(5);
		e.default = function (t) {
			t.registerHelper("blockHelperMissing", function (e, i) {
				var r = i.inverse, o = i.fn;
				if (!0 === e) return o(this);
				if (!1 === e || null == e) return r(this);
				if (n.isArray(e)) return e.length > 0 ? (i.ids && (i.ids = [i.name]), t.helpers.each(e, i)) : r(this);
				if (i.data && i.ids) {
					var a = n.createFrame(i.data);
					a.contextPath = n.appendContextPath(i.data.contextPath, i.name), i = {data: a}
				}
				return o(e, i)
			})
		}, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0;
		var r = i(5), o = n(i(6));
		e.default = function (t) {
			t.registerHelper("each", function (t, e) {
				if (!e) throw new o.default("Must pass iterator to #each");
				var i = e.fn, n = e.inverse, a = 0, s = "", l = void 0, c = void 0;

				function u(e, n, o) {
					l && (l.key = e, l.index = n, l.first = 0 === n, l.last = !!o, c && (l.contextPath = c + e)), s += i(t[e], {data: l, blockParams: r.blockParams([t[e], e], [c + e, null])})
				}

				if (e.data && e.ids && (c = r.appendContextPath(e.data.contextPath, e.ids[0]) + "."), r.isFunction(t) && (t = t.call(this)), e.data && (l = r.createFrame(e.data)), t && "object" == typeof t) if (r.isArray(t)) for (var h = t.length; a < h; a++) a in t && u(a, a, a === t.length - 1); else {
					var d = void 0;
					for (var p in t) t.hasOwnProperty(p) && (void 0 !== d && u(d, a - 1), d = p, a++);
					void 0 !== d && u(d, a - 1, !0)
				}
				return 0 === a && (s = n(this)), s
			})
		}, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0;
		var r = n(i(6));
		e.default = function (t) {
			t.registerHelper("helperMissing", function () {
				if (1 !== arguments.length) throw new r.default('Missing helper: "' + arguments[arguments.length - 1].name + '"')
			})
		}, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		e.__esModule = !0;
		var n = i(5);
		e.default = function (t) {
			t.registerHelper("if", function (t, e) {
				return n.isFunction(t) && (t = t.call(this)), !e.hash.includeZero && !t || n.isEmpty(t) ? e.inverse(this) : e.fn(this)
			}), t.registerHelper("unless", function (e, i) {
				return t.helpers.if.call(this, e, {fn: i.inverse, inverse: i.fn, hash: i.hash})
			})
		}, t.exports = e.default
	}, function (t, e) {
		"use strict";
		e.__esModule = !0, e.default = function (t) {
			t.registerHelper("log", function () {
				for (var e = [void 0], i = arguments[arguments.length - 1], n = 0; n < arguments.length - 1; n++) e.push(arguments[n]);
				var r = 1;
				null != i.hash.level ? r = i.hash.level : i.data && null != i.data.level && (r = i.data.level), e[0] = r, t.log.apply(t, e)
			})
		}, t.exports = e.default
	}, function (t, e) {
		"use strict";
		e.__esModule = !0, e.default = function (t) {
			t.registerHelper("lookup", function (t, e) {
				return t && t[e]
			})
		}, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		e.__esModule = !0;
		var n = i(5);
		e.default = function (t) {
			t.registerHelper("with", function (t, e) {
				n.isFunction(t) && (t = t.call(this));
				var i = e.fn;
				if (n.isEmpty(t)) return e.inverse(this);
				var r = e.data;
				return e.data && e.ids && ((r = n.createFrame(e.data)).contextPath = n.appendContextPath(e.data.contextPath, e.ids[0])), i(t, {data: r, blockParams: n.blockParams([t], [r && r.contextPath])})
			})
		}, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0, e.registerDefaultDecorators = function (t) {
			r.default(t)
		};
		var r = n(i(19))
	}, function (t, e, i) {
		"use strict";
		e.__esModule = !0;
		var n = i(5);
		e.default = function (t) {
			t.registerDecorator("inline", function (t, e, i, r) {
				var o = t;
				return e.partials || (e.partials = {}, o = function (r, o) {
					var a = i.partials;
					i.partials = n.extend({}, a, e.partials);
					var s = t(r, o);
					return i.partials = a, s
				}), e.partials[r.args[0]] = r.fn, o
			})
		}, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		e.__esModule = !0;
		var n = i(5), r = {
			methodMap: ["debug", "info", "warn", "error"], level: "info", lookupLevel: function (t) {
				if ("string" == typeof t) {
					var e = n.indexOf(r.methodMap, t.toLowerCase());
					t = e >= 0 ? e : parseInt(t, 10)
				}
				return t
			}, log: function (t) {
				if (t = r.lookupLevel(t), "undefined" != typeof console && r.lookupLevel(r.level) <= t) {
					var e = r.methodMap[t];
					console[e] || (e = "log");
					for (var i = arguments.length, n = Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) n[o - 1] = arguments[o];
					console[e].apply(console, n)
				}
			}
		};
		e.default = r, t.exports = e.default
	}, function (t, e) {
		"use strict";

		function i(t) {
			this.string = t
		}

		e.__esModule = !0, i.prototype.toString = i.prototype.toHTML = function () {
			return "" + this.string
		}, e.default = i, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		var n = i(23).default, r = i(3).default, o = i(1).default;
		e.__esModule = !0, e.checkRevision = function (t) {
			var e = t && t[0] || 1, i = l.COMPILER_REVISION;
			if (e !== i) {
				if (e < i) {
					var n = l.REVISION_CHANGES[i], r = l.REVISION_CHANGES[e];
					throw new s.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + n + ") or downgrade your runtime to an older version (" + r + ").")
				}
				throw new s.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + t[1] + ").")
			}
		}, e.template = function (t, e) {
			if (!e) throw new s.default("No environment passed to template");
			if (!t || !t.main) throw new s.default("Unknown template object: " + typeof t);
			t.main.decorator = t.main_d, e.VM.checkRevision(t.compiler);
			var i = {
				strict: function (t, e) {
					if (!(e in t)) throw new s.default('"' + e + '" not defined in ' + t);
					return t[e]
				}, lookup: function (t, e) {
					for (var i = t.length, n = 0; n < i; n++) if (t[n] && null != t[n][e]) return t[n][e]
				}, lambda: function (t, e) {
					return "function" == typeof t ? t.call(e) : t
				}, escapeExpression: a.escapeExpression, invokePartial: function (i, n, r) {
					r.hash && (n = a.extend({}, n, r.hash), r.ids && (r.ids[0] = !0));
					i = e.VM.resolvePartial.call(this, i, n, r);
					var o = e.VM.invokePartial.call(this, i, n, r);
					null == o && e.compile && (r.partials[r.name] = e.compile(i, t.compilerOptions, e), o = r.partials[r.name](n, r));
					if (null != o) {
						if (r.indent) {
							for (var l = o.split("\n"), c = 0, u = l.length; c < u && (l[c] || c + 1 !== u); c++) l[c] = r.indent + l[c];
							o = l.join("\n")
						}
						return o
					}
					throw new s.default("The partial " + r.name + " could not be compiled when running in runtime-only mode")
				}, fn: function (e) {
					var i = t[e];
					return i.decorator = t[e + "_d"], i
				}, programs: [], program: function (t, e, i, n, r) {
					var o = this.programs[t], a = this.fn(t);
					return e || r || n || i ? o = c(this, t, a, e, i, n, r) : o || (o = this.programs[t] = c(this, t, a)), o
				}, data: function (t, e) {
					for (; t && e--;) t = t._parent;
					return t
				}, merge: function (t, e) {
					var i = t || e;
					return t && e && t !== e && (i = a.extend({}, e, t)), i
				}, nullContext: n({}), noop: e.VM.noop, compilerInfo: t.compiler
			};

			function r(e) {
				var n = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1], o = n.data;
				r._setup(n), !n.partial && t.useData && (o = function (t, e) {
					e && "root" in e || ((e = e ? l.createFrame(e) : {}).root = t);
					return e
				}(e, o));
				var a = void 0, s = t.useBlockParams ? [] : void 0;

				function c(e) {
					return "" + t.main(i, e, i.helpers, i.partials, o, s, a)
				}

				return t.useDepths && (a = n.depths ? e != n.depths[0] ? [e].concat(n.depths) : n.depths : [e]), (c = h(t.main, c, i, n.depths || [], o, s))(e, n)
			}

			return r.isTop = !0, r._setup = function (n) {
				n.partial ? (i.helpers = n.helpers, i.partials = n.partials, i.decorators = n.decorators) : (i.helpers = i.merge(n.helpers, e.helpers), t.usePartial && (i.partials = i.merge(n.partials, e.partials)), (t.usePartial || t.useDecorators) && (i.decorators = i.merge(n.decorators, e.decorators)))
			}, r._child = function (e, n, r, o) {
				if (t.useBlockParams && !r) throw new s.default("must pass block params");
				if (t.useDepths && !o) throw new s.default("must pass parent depths");
				return c(i, e, t[e], n, 0, r, o)
			}, r
		}, e.wrapProgram = c, e.resolvePartial = function (t, e, i) {
			t ? t.call || i.name || (i.name = t, t = i.partials[t]) : t = "@partial-block" === i.name ? i.data["partial-block"] : i.partials[i.name];
			return t
		}, e.invokePartial = function (t, e, i) {
			var n = i.data && i.data["partial-block"];
			i.partial = !0, i.ids && (i.data.contextPath = i.ids[0] || i.data.contextPath);
			var r = void 0;
			i.fn && i.fn !== u && function () {
				i.data = l.createFrame(i.data);
				var t = i.fn;
				r = i.data["partial-block"] = function (e) {
					var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
					return i.data = l.createFrame(i.data), i.data["partial-block"] = n, t(e, i)
				}, t.partials && (i.partials = a.extend({}, i.partials, t.partials))
			}();
			void 0 === t && r && (t = r);
			if (void 0 === t) throw new s.default("The partial " + i.name + " could not be found");
			if (t instanceof Function) return t(e, i)
		}, e.noop = u;
		var a = r(i(5)), s = o(i(6)), l = i(4);

		function c(t, e, i, n, r, o, a) {
			function s(e) {
				var r = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1], s = a;
				return !a || e == a[0] || e === t.nullContext && null === a[0] || (s = [e].concat(a)), i(t, e, t.helpers, t.partials, r.data || n, o && [r.blockParams].concat(o), s)
			}

			return (s = h(i, s, t, a, n, o)).program = e, s.depth = a ? a.length : 0, s.blockParams = r || 0, s
		}

		function u() {
			return ""
		}

		function h(t, e, i, n, r, o) {
			if (t.decorator) {
				var s = {};
				e = t.decorator(e, s, i, n && n[0], r, o, n), a.extend(e, s)
			}
			return e
		}
	}, function (t, e, i) {
		t.exports = {default: i(24), __esModule: !0}
	}, function (t, e, i) {
		i(25), t.exports = i(30).Object.seal
	}, function (t, e, i) {
		var n = i(26);
		i(27)("seal", function (t) {
			return function (e) {
				return t && n(e) ? t(e) : e
			}
		})
	}, function (t, e) {
		t.exports = function (t) {
			return "object" == typeof t ? null !== t : "function" == typeof t
		}
	}, function (t, e, i) {
		var n = i(28), r = i(30), o = i(33);
		t.exports = function (t, e) {
			var i = (r.Object || {})[t] || Object[t], a = {};
			a[t] = e(i), n(n.S + n.F * o(function () {
				i(1)
			}), "Object", a)
		}
	}, function (t, e, i) {
		var n = i(29), r = i(30), o = i(31), a = function (t, e, i) {
			var s, l, c, u = t & a.F, h = t & a.G, d = t & a.S, p = t & a.P, f = t & a.B, m = t & a.W, g = h ? r : r[e] || (r[e] = {}), v = h ? n : d ? n[e] : (n[e] || {}).prototype;
			for (s in h && (i = e), i) (l = !u && v && s in v) && s in g || (c = l ? v[s] : i[s], g[s] = h && "function" != typeof v[s] ? i[s] : f && l ? o(c, n) : m && v[s] == c ? function (t) {
				var e = function (e) {
					return this instanceof t ? new t(e) : t(e)
				};
				return e.prototype = t.prototype, e
			}(c) : p && "function" == typeof c ? o(Function.call, c) : c, p && ((g.prototype || (g.prototype = {}))[s] = c))
		};
		a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, t.exports = a
	}, function (t, e) {
		var i = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
		"number" == typeof __g && (__g = i)
	}, function (t, e) {
		var i = t.exports = {version: "1.2.6"};
		"number" == typeof __e && (__e = i)
	}, function (t, e, i) {
		var n = i(32);
		t.exports = function (t, e, i) {
			if (n(t), void 0 === e) return t;
			switch (i) {
				case 1:
					return function (i) {
						return t.call(e, i)
					};
				case 2:
					return function (i, n) {
						return t.call(e, i, n)
					};
				case 3:
					return function (i, n, r) {
						return t.call(e, i, n, r)
					}
			}
			return function () {
				return t.apply(e, arguments)
			}
		}
	}, function (t, e) {
		t.exports = function (t) {
			if ("function" != typeof t) throw TypeError(t + " is not a function!");
			return t
		}
	}, function (t, e) {
		t.exports = function (t) {
			try {
				return !!t()
			} catch (t) {
				return !0
			}
		}
	}, function (t, e) {
		(function (i) {
			"use strict";
			e.__esModule = !0, e.default = function (t) {
				var e = void 0 !== i ? i : window, n = e.Handlebars;
				t.noConflict = function () {
					return e.Handlebars === t && (e.Handlebars = n), t
				}
			}, t.exports = e.default
		}).call(e, function () {
			return this
		}())
	}, function (t, e) {
		"use strict";
		e.__esModule = !0;
		var i = {
			helpers: {
				helperExpression: function (t) {
					return "SubExpression" === t.type || ("MustacheStatement" === t.type || "BlockStatement" === t.type) && !!(t.params && t.params.length || t.hash)
				}, scopedId: function (t) {
					return /^\.|this\b/.test(t.original)
				}, simpleId: function (t) {
					return 1 === t.parts.length && !i.helpers.scopedId(t) && !t.depth
				}
			}
		};
		e.default = i, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default, r = i(3).default;
		e.__esModule = !0, e.parse = function (t, e) {
			if ("Program" === t.type) return t;
			return o.default.yy = c, c.locInfo = function (t) {
				return new c.SourceLocation(e && e.srcName, t)
			}, new a.default(e).accept(o.default.parse(t))
		};
		var o = n(i(37)), a = n(i(38)), s = r(i(40)), l = i(5);
		e.parser = o.default;
		var c = {};
		l.extend(c, s)
	}, function (t, e) {
		"use strict";
		e.__esModule = !0;
		var i = function () {
			var t = {
				trace: function () {
				},
				yy: {},
				symbols_: {
					error: 2,
					root: 3,
					program: 4,
					EOF: 5,
					program_repetition0: 6,
					statement: 7,
					mustache: 8,
					block: 9,
					rawBlock: 10,
					partial: 11,
					partialBlock: 12,
					content: 13,
					COMMENT: 14,
					CONTENT: 15,
					openRawBlock: 16,
					rawBlock_repetition_plus0: 17,
					END_RAW_BLOCK: 18,
					OPEN_RAW_BLOCK: 19,
					helperName: 20,
					openRawBlock_repetition0: 21,
					openRawBlock_option0: 22,
					CLOSE_RAW_BLOCK: 23,
					openBlock: 24,
					block_option0: 25,
					closeBlock: 26,
					openInverse: 27,
					block_option1: 28,
					OPEN_BLOCK: 29,
					openBlock_repetition0: 30,
					openBlock_option0: 31,
					openBlock_option1: 32,
					CLOSE: 33,
					OPEN_INVERSE: 34,
					openInverse_repetition0: 35,
					openInverse_option0: 36,
					openInverse_option1: 37,
					openInverseChain: 38,
					OPEN_INVERSE_CHAIN: 39,
					openInverseChain_repetition0: 40,
					openInverseChain_option0: 41,
					openInverseChain_option1: 42,
					inverseAndProgram: 43,
					INVERSE: 44,
					inverseChain: 45,
					inverseChain_option0: 46,
					OPEN_ENDBLOCK: 47,
					OPEN: 48,
					mustache_repetition0: 49,
					mustache_option0: 50,
					OPEN_UNESCAPED: 51,
					mustache_repetition1: 52,
					mustache_option1: 53,
					CLOSE_UNESCAPED: 54,
					OPEN_PARTIAL: 55,
					partialName: 56,
					partial_repetition0: 57,
					partial_option0: 58,
					openPartialBlock: 59,
					OPEN_PARTIAL_BLOCK: 60,
					openPartialBlock_repetition0: 61,
					openPartialBlock_option0: 62,
					param: 63,
					sexpr: 64,
					OPEN_SEXPR: 65,
					sexpr_repetition0: 66,
					sexpr_option0: 67,
					CLOSE_SEXPR: 68,
					hash: 69,
					hash_repetition_plus0: 70,
					hashSegment: 71,
					ID: 72,
					EQUALS: 73,
					blockParams: 74,
					OPEN_BLOCK_PARAMS: 75,
					blockParams_repetition_plus0: 76,
					CLOSE_BLOCK_PARAMS: 77,
					path: 78,
					dataName: 79,
					STRING: 80,
					NUMBER: 81,
					BOOLEAN: 82,
					UNDEFINED: 83,
					NULL: 84,
					DATA: 85,
					pathSegments: 86,
					SEP: 87,
					$accept: 0,
					$end: 1
				},
				terminals_: {
					2: "error",
					5: "EOF",
					14: "COMMENT",
					15: "CONTENT",
					18: "END_RAW_BLOCK",
					19: "OPEN_RAW_BLOCK",
					23: "CLOSE_RAW_BLOCK",
					29: "OPEN_BLOCK",
					33: "CLOSE",
					34: "OPEN_INVERSE",
					39: "OPEN_INVERSE_CHAIN",
					44: "INVERSE",
					47: "OPEN_ENDBLOCK",
					48: "OPEN",
					51: "OPEN_UNESCAPED",
					54: "CLOSE_UNESCAPED",
					55: "OPEN_PARTIAL",
					60: "OPEN_PARTIAL_BLOCK",
					65: "OPEN_SEXPR",
					68: "CLOSE_SEXPR",
					72: "ID",
					73: "EQUALS",
					75: "OPEN_BLOCK_PARAMS",
					77: "CLOSE_BLOCK_PARAMS",
					80: "STRING",
					81: "NUMBER",
					82: "BOOLEAN",
					83: "UNDEFINED",
					84: "NULL",
					85: "DATA",
					87: "SEP"
				},
				productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 1], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
				performAction: function (t, e, i, n, r, o, a) {
					var s = o.length - 1;
					switch (r) {
						case 1:
							return o[s - 1];
						case 2:
							this.$ = n.prepareProgram(o[s]);
							break;
						case 3:
						case 4:
						case 5:
						case 6:
						case 7:
						case 8:
							this.$ = o[s];
							break;
						case 9:
							this.$ = {type: "CommentStatement", value: n.stripComment(o[s]), strip: n.stripFlags(o[s], o[s]), loc: n.locInfo(this._$)};
							break;
						case 10:
							this.$ = {type: "ContentStatement", original: o[s], value: o[s], loc: n.locInfo(this._$)};
							break;
						case 11:
							this.$ = n.prepareRawBlock(o[s - 2], o[s - 1], o[s], this._$);
							break;
						case 12:
							this.$ = {path: o[s - 3], params: o[s - 2], hash: o[s - 1]};
							break;
						case 13:
							this.$ = n.prepareBlock(o[s - 3], o[s - 2], o[s - 1], o[s], !1, this._$);
							break;
						case 14:
							this.$ = n.prepareBlock(o[s - 3], o[s - 2], o[s - 1], o[s], !0, this._$);
							break;
						case 15:
							this.$ = {open: o[s - 5], path: o[s - 4], params: o[s - 3], hash: o[s - 2], blockParams: o[s - 1], strip: n.stripFlags(o[s - 5], o[s])};
							break;
						case 16:
						case 17:
							this.$ = {path: o[s - 4], params: o[s - 3], hash: o[s - 2], blockParams: o[s - 1], strip: n.stripFlags(o[s - 5], o[s])};
							break;
						case 18:
							this.$ = {strip: n.stripFlags(o[s - 1], o[s - 1]), program: o[s]};
							break;
						case 19:
							var l = n.prepareBlock(o[s - 2], o[s - 1], o[s], o[s], !1, this._$), c = n.prepareProgram([l], o[s - 1].loc);
							c.chained = !0, this.$ = {strip: o[s - 2].strip, program: c, chain: !0};
							break;
						case 20:
							this.$ = o[s];
							break;
						case 21:
							this.$ = {path: o[s - 1], strip: n.stripFlags(o[s - 2], o[s])};
							break;
						case 22:
						case 23:
							this.$ = n.prepareMustache(o[s - 3], o[s - 2], o[s - 1], o[s - 4], n.stripFlags(o[s - 4], o[s]), this._$);
							break;
						case 24:
							this.$ = {type: "PartialStatement", name: o[s - 3], params: o[s - 2], hash: o[s - 1], indent: "", strip: n.stripFlags(o[s - 4], o[s]), loc: n.locInfo(this._$)};
							break;
						case 25:
							this.$ = n.preparePartialBlock(o[s - 2], o[s - 1], o[s], this._$);
							break;
						case 26:
							this.$ = {path: o[s - 3], params: o[s - 2], hash: o[s - 1], strip: n.stripFlags(o[s - 4], o[s])};
							break;
						case 27:
						case 28:
							this.$ = o[s];
							break;
						case 29:
							this.$ = {type: "SubExpression", path: o[s - 3], params: o[s - 2], hash: o[s - 1], loc: n.locInfo(this._$)};
							break;
						case 30:
							this.$ = {type: "Hash", pairs: o[s], loc: n.locInfo(this._$)};
							break;
						case 31:
							this.$ = {type: "HashPair", key: n.id(o[s - 2]), value: o[s], loc: n.locInfo(this._$)};
							break;
						case 32:
							this.$ = n.id(o[s - 1]);
							break;
						case 33:
						case 34:
							this.$ = o[s];
							break;
						case 35:
							this.$ = {type: "StringLiteral", value: o[s], original: o[s], loc: n.locInfo(this._$)};
							break;
						case 36:
							this.$ = {type: "NumberLiteral", value: Number(o[s]), original: Number(o[s]), loc: n.locInfo(this._$)};
							break;
						case 37:
							this.$ = {type: "BooleanLiteral", value: "true" === o[s], original: "true" === o[s], loc: n.locInfo(this._$)};
							break;
						case 38:
							this.$ = {type: "UndefinedLiteral", original: void 0, value: void 0, loc: n.locInfo(this._$)};
							break;
						case 39:
							this.$ = {type: "NullLiteral", original: null, value: null, loc: n.locInfo(this._$)};
							break;
						case 40:
						case 41:
							this.$ = o[s];
							break;
						case 42:
							this.$ = n.preparePath(!0, o[s], this._$);
							break;
						case 43:
							this.$ = n.preparePath(!1, o[s], this._$);
							break;
						case 44:
							o[s - 2].push({part: n.id(o[s]), original: o[s], separator: o[s - 1]}), this.$ = o[s - 2];
							break;
						case 45:
							this.$ = [{part: n.id(o[s]), original: o[s]}];
							break;
						case 46:
							this.$ = [];
							break;
						case 47:
							o[s - 1].push(o[s]);
							break;
						case 48:
							this.$ = [o[s]];
							break;
						case 49:
							o[s - 1].push(o[s]);
							break;
						case 50:
							this.$ = [];
							break;
						case 51:
							o[s - 1].push(o[s]);
							break;
						case 58:
							this.$ = [];
							break;
						case 59:
							o[s - 1].push(o[s]);
							break;
						case 64:
							this.$ = [];
							break;
						case 65:
							o[s - 1].push(o[s]);
							break;
						case 70:
							this.$ = [];
							break;
						case 71:
							o[s - 1].push(o[s]);
							break;
						case 78:
							this.$ = [];
							break;
						case 79:
							o[s - 1].push(o[s]);
							break;
						case 82:
							this.$ = [];
							break;
						case 83:
							o[s - 1].push(o[s]);
							break;
						case 86:
							this.$ = [];
							break;
						case 87:
							o[s - 1].push(o[s]);
							break;
						case 90:
							this.$ = [];
							break;
						case 91:
							o[s - 1].push(o[s]);
							break;
						case 94:
							this.$ = [];
							break;
						case 95:
							o[s - 1].push(o[s]);
							break;
						case 98:
							this.$ = [o[s]];
							break;
						case 99:
							o[s - 1].push(o[s]);
							break;
						case 100:
							this.$ = [o[s]];
							break;
						case 101:
							o[s - 1].push(o[s])
					}
				},
				table: [{3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46]}, {1: [3]}, {5: [1, 4]}, {
					5: [2, 2],
					7: 5,
					8: 6,
					9: 7,
					10: 8,
					11: 9,
					12: 10,
					13: 11,
					14: [1, 12],
					15: [1, 20],
					16: 17,
					19: [1, 23],
					24: 15,
					27: 16,
					29: [1, 21],
					34: [1, 22],
					39: [2, 2],
					44: [2, 2],
					47: [2, 2],
					48: [1, 13],
					51: [1, 14],
					55: [1, 18],
					59: 19,
					60: [1, 24]
				}, {1: [2, 1]}, {5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47]}, {
					5: [2, 3],
					14: [2, 3],
					15: [2, 3],
					19: [2, 3],
					29: [2, 3],
					34: [2, 3],
					39: [2, 3],
					44: [2, 3],
					47: [2, 3],
					48: [2, 3],
					51: [2, 3],
					55: [2, 3],
					60: [2, 3]
				}, {5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4]}, {
					5: [2, 5],
					14: [2, 5],
					15: [2, 5],
					19: [2, 5],
					29: [2, 5],
					34: [2, 5],
					39: [2, 5],
					44: [2, 5],
					47: [2, 5],
					48: [2, 5],
					51: [2, 5],
					55: [2, 5],
					60: [2, 5]
				}, {5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6]}, {
					5: [2, 7],
					14: [2, 7],
					15: [2, 7],
					19: [2, 7],
					29: [2, 7],
					34: [2, 7],
					39: [2, 7],
					44: [2, 7],
					47: [2, 7],
					48: [2, 7],
					51: [2, 7],
					55: [2, 7],
					60: [2, 7]
				}, {5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8]}, {
					5: [2, 9],
					14: [2, 9],
					15: [2, 9],
					19: [2, 9],
					29: [2, 9],
					34: [2, 9],
					39: [2, 9],
					44: [2, 9],
					47: [2, 9],
					48: [2, 9],
					51: [2, 9],
					55: [2, 9],
					60: [2, 9]
				}, {20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {
					4: 37,
					6: 3,
					14: [2, 46],
					15: [2, 46],
					19: [2, 46],
					29: [2, 46],
					34: [2, 46],
					39: [2, 46],
					44: [2, 46],
					47: [2, 46],
					48: [2, 46],
					51: [2, 46],
					55: [2, 46],
					60: [2, 46]
				}, {4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46]}, {13: 40, 15: [1, 20], 17: 39}, {
					20: 42,
					56: 41,
					64: 43,
					65: [1, 44],
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {4: 45, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46]}, {
					5: [2, 10],
					14: [2, 10],
					15: [2, 10],
					18: [2, 10],
					19: [2, 10],
					29: [2, 10],
					34: [2, 10],
					39: [2, 10],
					44: [2, 10],
					47: [2, 10],
					48: [2, 10],
					51: [2, 10],
					55: [2, 10],
					60: [2, 10]
				}, {20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {
					20: 48,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {20: 42, 56: 49, 64: 43, 65: [1, 44], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {
					33: [2, 78],
					49: 50,
					65: [2, 78],
					72: [2, 78],
					80: [2, 78],
					81: [2, 78],
					82: [2, 78],
					83: [2, 78],
					84: [2, 78],
					85: [2, 78]
				}, {23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33]}, {
					23: [2, 34],
					33: [2, 34],
					54: [2, 34],
					65: [2, 34],
					68: [2, 34],
					72: [2, 34],
					75: [2, 34],
					80: [2, 34],
					81: [2, 34],
					82: [2, 34],
					83: [2, 34],
					84: [2, 34],
					85: [2, 34]
				}, {23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35]}, {
					23: [2, 36],
					33: [2, 36],
					54: [2, 36],
					65: [2, 36],
					68: [2, 36],
					72: [2, 36],
					75: [2, 36],
					80: [2, 36],
					81: [2, 36],
					82: [2, 36],
					83: [2, 36],
					84: [2, 36],
					85: [2, 36]
				}, {23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37]}, {
					23: [2, 38],
					33: [2, 38],
					54: [2, 38],
					65: [2, 38],
					68: [2, 38],
					72: [2, 38],
					75: [2, 38],
					80: [2, 38],
					81: [2, 38],
					82: [2, 38],
					83: [2, 38],
					84: [2, 38],
					85: [2, 38]
				}, {23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39]}, {
					23: [2, 43],
					33: [2, 43],
					54: [2, 43],
					65: [2, 43],
					68: [2, 43],
					72: [2, 43],
					75: [2, 43],
					80: [2, 43],
					81: [2, 43],
					82: [2, 43],
					83: [2, 43],
					84: [2, 43],
					85: [2, 43],
					87: [1, 51]
				}, {72: [1, 35], 86: 52}, {23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45]}, {
					52: 53,
					54: [2, 82],
					65: [2, 82],
					72: [2, 82],
					80: [2, 82],
					81: [2, 82],
					82: [2, 82],
					83: [2, 82],
					84: [2, 82],
					85: [2, 82]
				}, {25: 54, 38: 56, 39: [1, 58], 43: 57, 44: [1, 59], 45: 55, 47: [2, 54]}, {28: 60, 43: 61, 44: [1, 59], 47: [2, 56]}, {13: 63, 15: [1, 20], 18: [1, 62]}, {15: [2, 48], 18: [2, 48]}, {
					33: [2, 86],
					57: 64,
					65: [2, 86],
					72: [2, 86],
					80: [2, 86],
					81: [2, 86],
					82: [2, 86],
					83: [2, 86],
					84: [2, 86],
					85: [2, 86]
				}, {33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40]}, {33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41]}, {
					20: 65,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {26: 66, 47: [1, 67]}, {30: 68, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58]}, {
					33: [2, 64],
					35: 69,
					65: [2, 64],
					72: [2, 64],
					75: [2, 64],
					80: [2, 64],
					81: [2, 64],
					82: [2, 64],
					83: [2, 64],
					84: [2, 64],
					85: [2, 64]
				}, {21: 70, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50]}, {33: [2, 90], 61: 71, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90]}, {
					20: 75,
					33: [2, 80],
					50: 72,
					63: 73,
					64: 76,
					65: [1, 44],
					69: 74,
					70: 77,
					71: 78,
					72: [1, 79],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {72: [1, 80]}, {23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 51]}, {
					20: 75,
					53: 81,
					54: [2, 84],
					63: 82,
					64: 76,
					65: [1, 44],
					69: 83,
					70: 77,
					71: 78,
					72: [1, 79],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {26: 84, 47: [1, 67]}, {47: [2, 55]}, {4: 85, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46]}, {47: [2, 20]}, {
					20: 86,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {4: 87, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46]}, {26: 88, 47: [1, 67]}, {47: [2, 57]}, {
					5: [2, 11],
					14: [2, 11],
					15: [2, 11],
					19: [2, 11],
					29: [2, 11],
					34: [2, 11],
					39: [2, 11],
					44: [2, 11],
					47: [2, 11],
					48: [2, 11],
					51: [2, 11],
					55: [2, 11],
					60: [2, 11]
				}, {15: [2, 49], 18: [2, 49]}, {20: 75, 33: [2, 88], 58: 89, 63: 90, 64: 76, 65: [1, 44], 69: 91, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {
					65: [2, 94],
					66: 92,
					68: [2, 94],
					72: [2, 94],
					80: [2, 94],
					81: [2, 94],
					82: [2, 94],
					83: [2, 94],
					84: [2, 94],
					85: [2, 94]
				}, {5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25]}, {
					20: 93,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {20: 75, 31: 94, 33: [2, 60], 63: 95, 64: 76, 65: [1, 44], 69: 96, 70: 77, 71: 78, 72: [1, 79], 75: [2, 60], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {
					20: 75,
					33: [2, 66],
					36: 97,
					63: 98,
					64: 76,
					65: [1, 44],
					69: 99,
					70: 77,
					71: 78,
					72: [1, 79],
					75: [2, 66],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {20: 75, 22: 100, 23: [2, 52], 63: 101, 64: 76, 65: [1, 44], 69: 102, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {
					20: 75,
					33: [2, 92],
					62: 103,
					63: 104,
					64: 76,
					65: [1, 44],
					69: 105,
					70: 77,
					71: 78,
					72: [1, 79],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {33: [1, 106]}, {33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79]}, {33: [2, 81]}, {
					23: [2, 27],
					33: [2, 27],
					54: [2, 27],
					65: [2, 27],
					68: [2, 27],
					72: [2, 27],
					75: [2, 27],
					80: [2, 27],
					81: [2, 27],
					82: [2, 27],
					83: [2, 27],
					84: [2, 27],
					85: [2, 27]
				}, {23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28]}, {23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 107, 72: [1, 108], 75: [2, 30]}, {
					23: [2, 98],
					33: [2, 98],
					54: [2, 98],
					68: [2, 98],
					72: [2, 98],
					75: [2, 98]
				}, {23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 109], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45]}, {
					23: [2, 44],
					33: [2, 44],
					54: [2, 44],
					65: [2, 44],
					68: [2, 44],
					72: [2, 44],
					75: [2, 44],
					80: [2, 44],
					81: [2, 44],
					82: [2, 44],
					83: [2, 44],
					84: [2, 44],
					85: [2, 44],
					87: [2, 44]
				}, {54: [1, 110]}, {54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83]}, {54: [2, 85]}, {
					5: [2, 13],
					14: [2, 13],
					15: [2, 13],
					19: [2, 13],
					29: [2, 13],
					34: [2, 13],
					39: [2, 13],
					44: [2, 13],
					47: [2, 13],
					48: [2, 13],
					51: [2, 13],
					55: [2, 13],
					60: [2, 13]
				}, {38: 56, 39: [1, 58], 43: 57, 44: [1, 59], 45: 112, 46: 111, 47: [2, 76]}, {33: [2, 70], 40: 113, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70]}, {47: [2, 18]}, {
					5: [2, 14],
					14: [2, 14],
					15: [2, 14],
					19: [2, 14],
					29: [2, 14],
					34: [2, 14],
					39: [2, 14],
					44: [2, 14],
					47: [2, 14],
					48: [2, 14],
					51: [2, 14],
					55: [2, 14],
					60: [2, 14]
				}, {33: [1, 114]}, {33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87]}, {33: [2, 89]}, {
					20: 75,
					63: 116,
					64: 76,
					65: [1, 44],
					67: 115,
					68: [2, 96],
					69: 117,
					70: 77,
					71: 78,
					72: [1, 79],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				}, {33: [1, 118]}, {32: 119, 33: [2, 62], 74: 120, 75: [1, 121]}, {33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59]}, {33: [2, 61], 75: [2, 61]}, {33: [2, 68], 37: 122, 74: 123, 75: [1, 121]}, {
					33: [2, 65],
					65: [2, 65],
					72: [2, 65],
					75: [2, 65],
					80: [2, 65],
					81: [2, 65],
					82: [2, 65],
					83: [2, 65],
					84: [2, 65],
					85: [2, 65]
				}, {33: [2, 67], 75: [2, 67]}, {23: [1, 124]}, {23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51]}, {23: [2, 53]}, {33: [1, 125]}, {
					33: [2, 91],
					65: [2, 91],
					72: [2, 91],
					80: [2, 91],
					81: [2, 91],
					82: [2, 91],
					83: [2, 91],
					84: [2, 91],
					85: [2, 91]
				}, {33: [2, 93]}, {5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22]}, {
					23: [2, 99],
					33: [2, 99],
					54: [2, 99],
					68: [2, 99],
					72: [2, 99],
					75: [2, 99]
				}, {73: [1, 109]}, {20: 75, 63: 126, 64: 76, 65: [1, 44], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {
					5: [2, 23],
					14: [2, 23],
					15: [2, 23],
					19: [2, 23],
					29: [2, 23],
					34: [2, 23],
					39: [2, 23],
					44: [2, 23],
					47: [2, 23],
					48: [2, 23],
					51: [2, 23],
					55: [2, 23],
					60: [2, 23]
				}, {47: [2, 19]}, {47: [2, 77]}, {20: 75, 33: [2, 72], 41: 127, 63: 128, 64: 76, 65: [1, 44], 69: 129, 70: 77, 71: 78, 72: [1, 79], 75: [2, 72], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33}, {
					5: [2, 24],
					14: [2, 24],
					15: [2, 24],
					19: [2, 24],
					29: [2, 24],
					34: [2, 24],
					39: [2, 24],
					44: [2, 24],
					47: [2, 24],
					48: [2, 24],
					51: [2, 24],
					55: [2, 24],
					60: [2, 24]
				}, {68: [1, 130]}, {65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95]}, {68: [2, 97]}, {
					5: [2, 21],
					14: [2, 21],
					15: [2, 21],
					19: [2, 21],
					29: [2, 21],
					34: [2, 21],
					39: [2, 21],
					44: [2, 21],
					47: [2, 21],
					48: [2, 21],
					51: [2, 21],
					55: [2, 21],
					60: [2, 21]
				}, {33: [1, 131]}, {33: [2, 63]}, {72: [1, 133], 76: 132}, {33: [1, 134]}, {33: [2, 69]}, {15: [2, 12]}, {14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26]}, {
					23: [2, 31],
					33: [2, 31],
					54: [2, 31],
					68: [2, 31],
					72: [2, 31],
					75: [2, 31]
				}, {33: [2, 74], 42: 135, 74: 136, 75: [1, 121]}, {33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71]}, {33: [2, 73], 75: [2, 73]}, {
					23: [2, 29],
					33: [2, 29],
					54: [2, 29],
					65: [2, 29],
					68: [2, 29],
					72: [2, 29],
					75: [2, 29],
					80: [2, 29],
					81: [2, 29],
					82: [2, 29],
					83: [2, 29],
					84: [2, 29],
					85: [2, 29]
				}, {14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15]}, {72: [1, 138], 77: [1, 137]}, {72: [2, 100], 77: [2, 100]}, {
					14: [2, 16],
					15: [2, 16],
					19: [2, 16],
					29: [2, 16],
					34: [2, 16],
					44: [2, 16],
					47: [2, 16],
					48: [2, 16],
					51: [2, 16],
					55: [2, 16],
					60: [2, 16]
				}, {33: [1, 139]}, {33: [2, 75]}, {33: [2, 32]}, {72: [2, 101], 77: [2, 101]}, {14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17]}],
				defaultActions: {4: [2, 1], 55: [2, 55], 57: [2, 20], 61: [2, 57], 74: [2, 81], 83: [2, 85], 87: [2, 18], 91: [2, 89], 102: [2, 53], 105: [2, 93], 111: [2, 19], 112: [2, 77], 117: [2, 97], 120: [2, 63], 123: [2, 69], 124: [2, 12], 136: [2, 75], 137: [2, 32]},
				parseError: function (t, e) {
					throw new Error(t)
				},
				parse: function (t) {
					var e = this, i = [0], n = [null], r = [], o = this.table, a = "", s = 0, l = 0, c = 0;
					this.lexer.setInput(t), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {});
					var u = this.lexer.yylloc;
					r.push(u);
					var h = this.lexer.options && this.lexer.options.ranges;
					"function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
					for (var d, p, f, m, g, v, y, b, w, x, k = {}; ;) {
						if (f = i[i.length - 1], this.defaultActions[f] ? m = this.defaultActions[f] : (null == d && (x = void 0, "number" != typeof (x = e.lexer.lex() || 1) && (x = e.symbols_[x] || x), d = x), m = o[f] && o[f][d]), void 0 === m || !m.length || !m[0]) {
							var _ = "";
							if (!c) {
								for (v in w = [], o[f]) this.terminals_[v] && v > 2 && w.push("'" + this.terminals_[v] + "'");
								_ = this.lexer.showPosition ? "Parse error on line " + (s + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + w.join(", ") + ", got '" + (this.terminals_[d] || d) + "'" : "Parse error on line " + (s + 1) + ": Unexpected " + (1 == d ? "end of input" : "'" + (this.terminals_[d] || d) + "'"), this.parseError(_, {
									text: this.lexer.match,
									token: this.terminals_[d] || d,
									line: this.lexer.yylineno,
									loc: u,
									expected: w
								})
							}
						}
						if (m[0] instanceof Array && m.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + f + ", token: " + d);
						switch (m[0]) {
							case 1:
								i.push(d), n.push(this.lexer.yytext), r.push(this.lexer.yylloc), i.push(m[1]), d = null, p ? (d = p, p = null) : (l = this.lexer.yyleng, a = this.lexer.yytext, s = this.lexer.yylineno, u = this.lexer.yylloc, c > 0 && c--);
								break;
							case 2:
								if (y = this.productions_[m[1]][1], k.$ = n[n.length - y], k._$ = {
									first_line: r[r.length - (y || 1)].first_line,
									last_line: r[r.length - 1].last_line,
									first_column: r[r.length - (y || 1)].first_column,
									last_column: r[r.length - 1].last_column
								}, h && (k._$.range = [r[r.length - (y || 1)].range[0], r[r.length - 1].range[1]]), void 0 !== (g = this.performAction.call(k, a, l, s, this.yy, m[1], n, r))) return g;
								y && (i = i.slice(0, -1 * y * 2), n = n.slice(0, -1 * y), r = r.slice(0, -1 * y)), i.push(this.productions_[m[1]][0]), n.push(k.$), r.push(k._$), b = o[i[i.length - 2]][i[i.length - 1]], i.push(b);
								break;
							case 3:
								return !0
						}
					}
					return !0
				}
			}, e = function () {
				var t = {
					EOF: 1,
					parseError: function (t, e) {
						if (!this.yy.parser) throw new Error(t);
						this.yy.parser.parseError(t, e)
					},
					setInput: function (t) {
						return this._input = t, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
							first_line: 1,
							first_column: 0,
							last_line: 1,
							last_column: 0
						}, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this
					},
					input: function () {
						var t = this._input[0];
						return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t
					},
					unput: function (t) {
						var e = t.length, i = t.split(/(?:\r\n?|\n)/g);
						this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e - 1), this.offset -= e;
						var n = this.match.split(/(?:\r\n?|\n)/g);
						this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), i.length - 1 && (this.yylineno -= i.length - 1);
						var r = this.yylloc.range;
						return this.yylloc = {
							first_line: this.yylloc.first_line,
							last_line: this.yylineno + 1,
							first_column: this.yylloc.first_column,
							last_column: i ? (i.length === n.length ? this.yylloc.first_column : 0) + n[n.length - i.length].length - i[0].length : this.yylloc.first_column - e
						}, this.options.ranges && (this.yylloc.range = [r[0], r[0] + this.yyleng - e]), this
					},
					more: function () {
						return this._more = !0, this
					},
					less: function (t) {
						this.unput(this.match.slice(t))
					},
					pastInput: function () {
						var t = this.matched.substr(0, this.matched.length - this.match.length);
						return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "")
					},
					upcomingInput: function () {
						var t = this.match;
						return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "")
					},
					showPosition: function () {
						var t = this.pastInput(), e = new Array(t.length + 1).join("-");
						return t + this.upcomingInput() + "\n" + e + "^"
					},
					next: function () {
						if (this.done) return this.EOF;
						var t, e, i, n, r;
						this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");
						for (var o = this._currentRules(), a = 0; a < o.length && (!(i = this._input.match(this.rules[o[a]])) || e && !(i[0].length > e[0].length) || (e = i, n = a, this.options.flex)); a++) ;
						return e ? ((r = e[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
							first_line: this.yylloc.last_line,
							last_line: this.yylineno + 1,
							first_column: this.yylloc.last_column,
							last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length
						}, this.yytext += e[0], this.match += e[0], this.matches = e, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._input = this._input.slice(e[0].length), this.matched += e[0], t = this.performAction.call(this, this.yy, this, o[n], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), t || void 0) : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
							text: "",
							token: null,
							line: this.yylineno
						})
					},
					lex: function () {
						var t = this.next();
						return void 0 !== t ? t : this.lex()
					},
					begin: function (t) {
						this.conditionStack.push(t)
					},
					popState: function () {
						return this.conditionStack.pop()
					},
					_currentRules: function () {
						return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules
					},
					topState: function () {
						return this.conditionStack[this.conditionStack.length - 2]
					},
					pushState: function (t) {
						this.begin(t)
					},
					options: {},
					performAction: function (t, e, i, n) {
						function r(t, i) {
							return e.yytext = e.yytext.substr(t, e.yyleng - i)
						}

						switch (i) {
							case 0:
								if ("\\\\" === e.yytext.slice(-2) ? (r(0, 1), this.begin("mu")) : "\\" === e.yytext.slice(-1) ? (r(0, 1), this.begin("emu")) : this.begin("mu"), e.yytext) return 15;
								break;
							case 1:
								return 15;
							case 2:
								return this.popState(), 15;
							case 3:
								return this.begin("raw"), 15;
							case 4:
								return this.popState(), "raw" === this.conditionStack[this.conditionStack.length - 1] ? 15 : (e.yytext = e.yytext.substr(5, e.yyleng - 9), "END_RAW_BLOCK");
							case 5:
								return 15;
							case 6:
								return this.popState(), 14;
							case 7:
								return 65;
							case 8:
								return 68;
							case 9:
								return 19;
							case 10:
								return this.popState(), this.begin("raw"), 23;
							case 11:
								return 55;
							case 12:
								return 60;
							case 13:
								return 29;
							case 14:
								return 47;
							case 15:
							case 16:
								return this.popState(), 44;
							case 17:
								return 34;
							case 18:
								return 39;
							case 19:
								return 51;
							case 20:
								return 48;
							case 21:
								this.unput(e.yytext), this.popState(), this.begin("com");
								break;
							case 22:
								return this.popState(), 14;
							case 23:
								return 48;
							case 24:
								return 73;
							case 25:
							case 26:
								return 72;
							case 27:
								return 87;
							case 28:
								break;
							case 29:
								return this.popState(), 54;
							case 30:
								return this.popState(), 33;
							case 31:
								return e.yytext = r(1, 2).replace(/\\"/g, '"'), 80;
							case 32:
								return e.yytext = r(1, 2).replace(/\\'/g, "'"), 80;
							case 33:
								return 85;
							case 34:
							case 35:
								return 82;
							case 36:
								return 83;
							case 37:
								return 84;
							case 38:
								return 81;
							case 39:
								return 75;
							case 40:
								return 77;
							case 41:
								return 72;
							case 42:
								return e.yytext = e.yytext.replace(/\\([\\\]])/g, "$1"), 72;
							case 43:
								return "INVALID";
							case 44:
								return 5
						}
					},
					rules: [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]*?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/],
					conditions: {
						mu: {rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], inclusive: !1},
						emu: {rules: [2], inclusive: !1},
						com: {rules: [6], inclusive: !1},
						raw: {rules: [3, 4, 5], inclusive: !1},
						INITIAL: {rules: [0, 1, 44], inclusive: !0}
					}
				};
				return t
			}();

			function i() {
				this.yy = {}
			}

			return t.lexer = e, i.prototype = t, t.Parser = i, new i
		}();
		e.default = i, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0;
		var r = n(i(39));

		function o() {
			var t = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
			this.options = t
		}

		function a(t, e, i) {
			void 0 === e && (e = t.length);
			var n = t[e - 1], r = t[e - 2];
			return n ? "ContentStatement" === n.type ? (r || !i ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(n.original) : void 0 : i
		}

		function s(t, e, i) {
			void 0 === e && (e = -1);
			var n = t[e + 1], r = t[e + 2];
			return n ? "ContentStatement" === n.type ? (r || !i ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(n.original) : void 0 : i
		}

		function l(t, e, i) {
			var n = t[null == e ? 0 : e + 1];
			if (n && "ContentStatement" === n.type && (i || !n.rightStripped)) {
				var r = n.value;
				n.value = n.value.replace(i ? /^\s+/ : /^[ \t]*\r?\n?/, ""), n.rightStripped = n.value !== r
			}
		}

		function c(t, e, i) {
			var n = t[null == e ? t.length - 1 : e - 1];
			if (n && "ContentStatement" === n.type && (i || !n.leftStripped)) {
				var r = n.value;
				return n.value = n.value.replace(i ? /\s+$/ : /[ \t]+$/, ""), n.leftStripped = n.value !== r, n.leftStripped
			}
		}

		o.prototype = new r.default, o.prototype.Program = function (t) {
			var e = !this.options.ignoreStandalone, i = !this.isRootSeen;
			this.isRootSeen = !0;
			for (var n = t.body, r = 0, o = n.length; r < o; r++) {
				var u = n[r], h = this.accept(u);
				if (h) {
					var d = a(n, r, i), p = s(n, r, i), f = h.openStandalone && d, m = h.closeStandalone && p, g = h.inlineStandalone && d && p;
					h.close && l(n, r, !0), h.open && c(n, r, !0), e && g && (l(n, r), c(n, r) && "PartialStatement" === u.type && (u.indent = /([ \t]+$)/.exec(n[r - 1].original)[1])), e && f && (l((u.program || u.inverse).body), c(n, r)), e && m && (l(n, r), c((u.inverse || u.program).body))
				}
			}
			return t
		}, o.prototype.BlockStatement = o.prototype.DecoratorBlock = o.prototype.PartialBlockStatement = function (t) {
			this.accept(t.program), this.accept(t.inverse);
			var e = t.program || t.inverse, i = t.program && t.inverse, n = i, r = i;
			if (i && i.chained) for (n = i.body[0].program; r.chained;) r = r.body[r.body.length - 1].program;
			var o = {open: t.openStrip.open, close: t.closeStrip.close, openStandalone: s(e.body), closeStandalone: a((n || e).body)};
			if (t.openStrip.close && l(e.body, null, !0), i) {
				var u = t.inverseStrip;
				u.open && c(e.body, null, !0), u.close && l(n.body, null, !0), t.closeStrip.open && c(r.body, null, !0), !this.options.ignoreStandalone && a(e.body) && s(n.body) && (c(e.body), l(n.body))
			} else t.closeStrip.open && c(e.body, null, !0);
			return o
		}, o.prototype.Decorator = o.prototype.MustacheStatement = function (t) {
			return t.strip
		}, o.prototype.PartialStatement = o.prototype.CommentStatement = function (t) {
			var e = t.strip || {};
			return {inlineStandalone: !0, open: e.open, close: e.close}
		}, e.default = o, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0;
		var r = n(i(6));

		function o() {
			this.parents = []
		}

		function a(t) {
			this.acceptRequired(t, "path"), this.acceptArray(t.params), this.acceptKey(t, "hash")
		}

		function s(t) {
			a.call(this, t), this.acceptKey(t, "program"), this.acceptKey(t, "inverse")
		}

		function l(t) {
			this.acceptRequired(t, "name"), this.acceptArray(t.params), this.acceptKey(t, "hash")
		}

		o.prototype = {
			constructor: o, mutating: !1, acceptKey: function (t, e) {
				var i = this.accept(t[e]);
				if (this.mutating) {
					if (i && !o.prototype[i.type]) throw new r.default('Unexpected node type "' + i.type + '" found when accepting ' + e + " on " + t.type);
					t[e] = i
				}
			}, acceptRequired: function (t, e) {
				if (this.acceptKey(t, e), !t[e]) throw new r.default(t.type + " requires " + e)
			}, acceptArray: function (t) {
				for (var e = 0, i = t.length; e < i; e++) this.acceptKey(t, e), t[e] || (t.splice(e, 1), e--, i--)
			}, accept: function (t) {
				if (t) {
					if (!this[t.type]) throw new r.default("Unknown type: " + t.type, t);
					this.current && this.parents.unshift(this.current), this.current = t;
					var e = this[t.type](t);
					return this.current = this.parents.shift(), !this.mutating || e ? e : !1 !== e ? t : void 0
				}
			}, Program: function (t) {
				this.acceptArray(t.body)
			}, MustacheStatement: a, Decorator: a, BlockStatement: s, DecoratorBlock: s, PartialStatement: l, PartialBlockStatement: function (t) {
				l.call(this, t), this.acceptKey(t, "program")
			}, ContentStatement: function () {
			}, CommentStatement: function () {
			}, SubExpression: a, PathExpression: function () {
			}, StringLiteral: function () {
			}, NumberLiteral: function () {
			}, BooleanLiteral: function () {
			}, UndefinedLiteral: function () {
			}, NullLiteral: function () {
			}, Hash: function (t) {
				this.acceptArray(t.pairs)
			}, HashPair: function (t) {
				this.acceptRequired(t, "value")
			}
		}, e.default = o, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0, e.SourceLocation = function (t, e) {
			this.source = t, this.start = {line: e.first_line, column: e.first_column}, this.end = {line: e.last_line, column: e.last_column}
		}, e.id = function (t) {
			return /^\[.*\]$/.test(t) ? t.substr(1, t.length - 2) : t
		}, e.stripFlags = function (t, e) {
			return {open: "~" === t.charAt(2), close: "~" === e.charAt(e.length - 3)}
		}, e.stripComment = function (t) {
			return t.replace(/^\{\{~?\!-?-?/, "").replace(/-?-?~?\}\}$/, "")
		}, e.preparePath = function (t, e, i) {
			i = this.locInfo(i);
			for (var n = t ? "@" : "", o = [], a = 0, s = 0, l = e.length; s < l; s++) {
				var c = e[s].part, u = e[s].original !== c;
				if (n += (e[s].separator || "") + c, u || ".." !== c && "." !== c && "this" !== c) o.push(c); else {
					if (o.length > 0) throw new r.default("Invalid path: " + n, {loc: i});
					".." === c && (a++, "../")
				}
			}
			return {type: "PathExpression", data: t, depth: a, parts: o, original: n, loc: i}
		}, e.prepareMustache = function (t, e, i, n, r, o) {
			var a = n.charAt(3) || n.charAt(2), s = "{" !== a && "&" !== a;
			return {type: /\*/.test(n) ? "Decorator" : "MustacheStatement", path: t, params: e, hash: i, escaped: s, strip: r, loc: this.locInfo(o)}
		}, e.prepareRawBlock = function (t, e, i, n) {
			o(t, i), n = this.locInfo(n);
			var r = {type: "Program", body: e, strip: {}, loc: n};
			return {type: "BlockStatement", path: t.path, params: t.params, hash: t.hash, program: r, openStrip: {}, inverseStrip: {}, closeStrip: {}, loc: n}
		}, e.prepareBlock = function (t, e, i, n, a, s) {
			n && n.path && o(t, n);
			var l = /\*/.test(t.open);
			e.blockParams = t.blockParams;
			var c = void 0, u = void 0;
			if (i) {
				if (l) throw new r.default("Unexpected inverse block on decorator", i);
				i.chain && (i.program.body[0].closeStrip = n.strip), u = i.strip, c = i.program
			}
			a && (a = c, c = e, e = a);
			return {type: l ? "DecoratorBlock" : "BlockStatement", path: t.path, params: t.params, hash: t.hash, program: e, inverse: c, openStrip: t.strip, inverseStrip: u, closeStrip: n && n.strip, loc: this.locInfo(s)}
		}, e.prepareProgram = function (t, e) {
			if (!e && t.length) {
				var i = t[0].loc, n = t[t.length - 1].loc;
				i && n && (e = {source: i.source, start: {line: i.start.line, column: i.start.column}, end: {line: n.end.line, column: n.end.column}})
			}
			return {type: "Program", body: t, strip: {}, loc: e}
		}, e.preparePartialBlock = function (t, e, i, n) {
			return o(t, i), {type: "PartialBlockStatement", name: t.path, params: t.params, hash: t.hash, program: e, openStrip: t.strip, closeStrip: i && i.strip, loc: this.locInfo(n)}
		};
		var r = n(i(6));

		function o(t, e) {
			if (e = e.path ? e.path.original : e, t.path.original !== e) {
				var i = {loc: t.path.loc};
				throw new r.default(t.path.original + " doesn't match " + e, i)
			}
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0, e.Compiler = l, e.precompile = function (t, e, i) {
			if (null == t || "string" != typeof t && "Program" !== t.type) throw new r.default("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + t);
			"data" in (e = e || {}) || (e.data = !0);
			e.compat && (e.useDepths = !0);
			var n = i.parse(t, e), o = (new i.Compiler).compile(n, e);
			return (new i.JavaScriptCompiler).compile(o, e)
		}, e.compile = function (t, e, i) {
			void 0 === e && (e = {});
			if (null == t || "string" != typeof t && "Program" !== t.type) throw new r.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + t);
			"data" in (e = o.extend({}, e)) || (e.data = !0);
			e.compat && (e.useDepths = !0);
			var n = void 0;

			function a() {
				var n = i.parse(t, e), r = (new i.Compiler).compile(n, e), o = (new i.JavaScriptCompiler).compile(r, e, void 0, !0);
				return i.template(o)
			}

			function s(t, e) {
				return n || (n = a()), n.call(this, t, e)
			}

			return s._setup = function (t) {
				return n || (n = a()), n._setup(t)
			}, s._child = function (t, e, i, r) {
				return n || (n = a()), n._child(t, e, i, r)
			}, s
		};
		var r = n(i(6)), o = i(5), a = n(i(35)), s = [].slice;

		function l() {
		}

		function c(t, e) {
			if (t === e) return !0;
			if (o.isArray(t) && o.isArray(e) && t.length === e.length) {
				for (var i = 0; i < t.length; i++) if (!c(t[i], e[i])) return !1;
				return !0
			}
		}

		function u(t) {
			if (!t.path.parts) {
				var e = t.path;
				t.path = {type: "PathExpression", data: !1, depth: 0, parts: [e.original + ""], original: e.original + "", loc: e.loc}
			}
		}

		l.prototype = {
			compiler: l, equals: function (t) {
				var e = this.opcodes.length;
				if (t.opcodes.length !== e) return !1;
				for (var i = 0; i < e; i++) {
					var n = this.opcodes[i], r = t.opcodes[i];
					if (n.opcode !== r.opcode || !c(n.args, r.args)) return !1
				}
				e = this.children.length;
				for (i = 0; i < e; i++) if (!this.children[i].equals(t.children[i])) return !1;
				return !0
			}, guid: 0, compile: function (t, e) {
				this.sourceNode = [], this.opcodes = [], this.children = [], this.options = e, this.stringParams = e.stringParams, this.trackIds = e.trackIds, e.blockParams = e.blockParams || [];
				var i = e.knownHelpers;
				if (e.knownHelpers = {helperMissing: !0, blockHelperMissing: !0, each: !0, if: !0, unless: !0, with: !0, log: !0, lookup: !0}, i) for (var n in i) n in i && (this.options.knownHelpers[n] = i[n]);
				return this.accept(t)
			}, compileProgram: function (t) {
				var e = (new this.compiler).compile(t, this.options), i = this.guid++;
				return this.usePartial = this.usePartial || e.usePartial, this.children[i] = e, this.useDepths = this.useDepths || e.useDepths, i
			}, accept: function (t) {
				if (!this[t.type]) throw new r.default("Unknown type: " + t.type, t);
				this.sourceNode.unshift(t);
				var e = this[t.type](t);
				return this.sourceNode.shift(), e
			}, Program: function (t) {
				this.options.blockParams.unshift(t.blockParams);
				for (var e = t.body, i = e.length, n = 0; n < i; n++) this.accept(e[n]);
				return this.options.blockParams.shift(), this.isSimple = 1 === i, this.blockParams = t.blockParams ? t.blockParams.length : 0, this
			}, BlockStatement: function (t) {
				u(t);
				var e = t.program, i = t.inverse;
				e = e && this.compileProgram(e), i = i && this.compileProgram(i);
				var n = this.classifySexpr(t);
				"helper" === n ? this.helperSexpr(t, e, i) : "simple" === n ? (this.simpleSexpr(t), this.opcode("pushProgram", e), this.opcode("pushProgram", i), this.opcode("emptyHash"), this.opcode("blockValue", t.path.original)) : (this.ambiguousSexpr(t, e, i), this.opcode("pushProgram", e), this.opcode("pushProgram", i), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")), this.opcode("append")
			}, DecoratorBlock: function (t) {
				var e = t.program && this.compileProgram(t.program), i = this.setupFullMustacheParams(t, e, void 0), n = t.path;
				this.useDecorators = !0, this.opcode("registerDecorator", i.length, n.original)
			}, PartialStatement: function (t) {
				this.usePartial = !0;
				var e = t.program;
				e && (e = this.compileProgram(t.program));
				var i = t.params;
				if (i.length > 1) throw new r.default("Unsupported number of partial arguments: " + i.length, t);
				i.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : i.push({type: "PathExpression", parts: [], depth: 0}));
				var n = t.name.original, o = "SubExpression" === t.name.type;
				o && this.accept(t.name), this.setupFullMustacheParams(t, e, void 0, !0);
				var a = t.indent || "";
				this.options.preventIndent && a && (this.opcode("appendContent", a), a = ""), this.opcode("invokePartial", o, n, a), this.opcode("append")
			}, PartialBlockStatement: function (t) {
				this.PartialStatement(t)
			}, MustacheStatement: function (t) {
				this.SubExpression(t), t.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append")
			}, Decorator: function (t) {
				this.DecoratorBlock(t)
			}, ContentStatement: function (t) {
				t.value && this.opcode("appendContent", t.value)
			}, CommentStatement: function () {
			}, SubExpression: function (t) {
				u(t);
				var e = this.classifySexpr(t);
				"simple" === e ? this.simpleSexpr(t) : "helper" === e ? this.helperSexpr(t) : this.ambiguousSexpr(t)
			}, ambiguousSexpr: function (t, e, i) {
				var n = t.path, r = n.parts[0], o = null != e || null != i;
				this.opcode("getContext", n.depth), this.opcode("pushProgram", e), this.opcode("pushProgram", i), n.strict = !0, this.accept(n), this.opcode("invokeAmbiguous", r, o)
			}, simpleSexpr: function (t) {
				var e = t.path;
				e.strict = !0, this.accept(e), this.opcode("resolvePossibleLambda")
			}, helperSexpr: function (t, e, i) {
				var n = this.setupFullMustacheParams(t, e, i), o = t.path, s = o.parts[0];
				if (this.options.knownHelpers[s]) this.opcode("invokeKnownHelper", n.length, s); else {
					if (this.options.knownHelpersOnly) throw new r.default("You specified knownHelpersOnly, but used the unknown helper " + s, t);
					o.strict = !0, o.falsy = !0, this.accept(o), this.opcode("invokeHelper", n.length, o.original, a.default.helpers.simpleId(o))
				}
			}, PathExpression: function (t) {
				this.addDepth(t.depth), this.opcode("getContext", t.depth);
				var e = t.parts[0], i = a.default.helpers.scopedId(t), n = !t.depth && !i && this.blockParamIndex(e);
				n ? this.opcode("lookupBlockParam", n, t.parts) : e ? t.data ? (this.options.data = !0, this.opcode("lookupData", t.depth, t.parts, t.strict)) : this.opcode("lookupOnContext", t.parts, t.falsy, t.strict, i) : this.opcode("pushContext")
			}, StringLiteral: function (t) {
				this.opcode("pushString", t.value)
			}, NumberLiteral: function (t) {
				this.opcode("pushLiteral", t.value)
			}, BooleanLiteral: function (t) {
				this.opcode("pushLiteral", t.value)
			}, UndefinedLiteral: function () {
				this.opcode("pushLiteral", "undefined")
			}, NullLiteral: function () {
				this.opcode("pushLiteral", "null")
			}, Hash: function (t) {
				var e = t.pairs, i = 0, n = e.length;
				for (this.opcode("pushHash"); i < n; i++) this.pushParam(e[i].value);
				for (; i--;) this.opcode("assignToHash", e[i].key);
				this.opcode("popHash")
			}, opcode: function (t) {
				this.opcodes.push({opcode: t, args: s.call(arguments, 1), loc: this.sourceNode[0].loc})
			}, addDepth: function (t) {
				t && (this.useDepths = !0)
			}, classifySexpr: function (t) {
				var e = a.default.helpers.simpleId(t.path), i = e && !!this.blockParamIndex(t.path.parts[0]), n = !i && a.default.helpers.helperExpression(t), r = !i && (n || e);
				if (r && !n) {
					var o = t.path.parts[0], s = this.options;
					s.knownHelpers[o] ? n = !0 : s.knownHelpersOnly && (r = !1)
				}
				return n ? "helper" : r ? "ambiguous" : "simple"
			}, pushParams: function (t) {
				for (var e = 0, i = t.length; e < i; e++) this.pushParam(t[e])
			}, pushParam: function (t) {
				var e = null != t.value ? t.value : t.original || "";
				if (this.stringParams) e.replace && (e = e.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")), t.depth && this.addDepth(t.depth), this.opcode("getContext", t.depth || 0), this.opcode("pushStringParam", e, t.type), "SubExpression" === t.type && this.accept(t); else {
					if (this.trackIds) {
						var i = void 0;
						if (!t.parts || a.default.helpers.scopedId(t) || t.depth || (i = this.blockParamIndex(t.parts[0])), i) {
							var n = t.parts.slice(1).join(".");
							this.opcode("pushId", "BlockParam", i, n)
						} else (e = t.original || e).replace && (e = e.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "")), this.opcode("pushId", t.type, e)
					}
					this.accept(t)
				}
			}, setupFullMustacheParams: function (t, e, i, n) {
				var r = t.params;
				return this.pushParams(r), this.opcode("pushProgram", e), this.opcode("pushProgram", i), t.hash ? this.accept(t.hash) : this.opcode("emptyHash", n), r
			}, blockParamIndex: function (t) {
				for (var e = 0, i = this.options.blockParams.length; e < i; e++) {
					var n = this.options.blockParams[e], r = n && o.indexOf(n, t);
					if (n && r >= 0) return [e, r]
				}
			}
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(1).default;
		e.__esModule = !0;
		var r = i(4), o = n(i(6)), a = i(5), s = n(i(43));

		function l(t) {
			this.value = t
		}

		function c() {
		}

		c.prototype = {
			nameLookup: function (t, e) {
				return c.isValidJavaScriptVariableName(e) ? [t, ".", e] : [t, "[", JSON.stringify(e), "]"]
			}, depthedLookup: function (t) {
				return [this.aliasable("container.lookup"), '(depths, "', t, '")']
			}, compilerInfo: function () {
				var t = r.COMPILER_REVISION;
				return [t, r.REVISION_CHANGES[t]]
			}, appendToBuffer: function (t, e, i) {
				return a.isArray(t) || (t = [t]), t = this.source.wrap(t, e), this.environment.isSimple ? ["return ", t, ";"] : i ? ["buffer += ", t, ";"] : (t.appendToBuffer = !0, t)
			}, initializeBuffer: function () {
				return this.quotedString("")
			}, compile: function (t, e, i, n) {
				this.environment = t, this.options = e, this.stringParams = this.options.stringParams, this.trackIds = this.options.trackIds, this.precompile = !n, this.name = this.environment.name, this.isChild = !!i, this.context = i || {
					decorators: [],
					programs: [],
					environments: []
				}, this.preamble(), this.stackSlot = 0, this.stackVars = [], this.aliases = {}, this.registers = {list: []}, this.hashes = [], this.compileStack = [], this.inlineStack = [], this.blockParams = [], this.compileChildren(t, e), this.useDepths = this.useDepths || t.useDepths || t.useDecorators || this.options.compat, this.useBlockParams = this.useBlockParams || t.useBlockParams;
				var r = t.opcodes, a = void 0, s = void 0, l = void 0, c = void 0;
				for (l = 0, c = r.length; l < c; l++) a = r[l], this.source.currentLocation = a.loc, s = s || a.loc, this[a.opcode].apply(this, a.args);
				if (this.source.currentLocation = s, this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new o.default("Compile completed with content left on stack");
				this.decorators.isEmpty() ? this.decorators = void 0 : (this.useDecorators = !0, this.decorators.prepend("var decorators = container.decorators;\n"), this.decorators.push("return fn;"), n ? this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]) : (this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"), this.decorators.push("}\n"), this.decorators = this.decorators.merge()));
				var u = this.createFunctionContext(n);
				if (this.isChild) return u;
				var h = {compiler: this.compilerInfo(), main: u};
				this.decorators && (h.main_d = this.decorators, h.useDecorators = !0);
				var d = this.context, p = d.programs, f = d.decorators;
				for (l = 0, c = p.length; l < c; l++) p[l] && (h[l] = p[l], f[l] && (h[l + "_d"] = f[l], h.useDecorators = !0));
				return this.environment.usePartial && (h.usePartial = !0), this.options.data && (h.useData = !0), this.useDepths && (h.useDepths = !0), this.useBlockParams && (h.useBlockParams = !0), this.options.compat && (h.compat = !0), n ? h.compilerOptions = this.options : (h.compiler = JSON.stringify(h.compiler), this.source.currentLocation = {
					start: {
						line: 1,
						column: 0
					}
				}, h = this.objectLiteral(h), e.srcName ? (h = h.toStringWithSourceMap({file: e.destName})).map = h.map && h.map.toString() : h = h.toString()), h
			}, preamble: function () {
				this.lastContext = 0, this.source = new s.default(this.options.srcName), this.decorators = new s.default(this.options.srcName)
			}, createFunctionContext: function (t) {
				var e = "", i = this.stackVars.concat(this.registers.list);
				i.length > 0 && (e += ", " + i.join(", "));
				var n = 0;
				for (var r in this.aliases) {
					var o = this.aliases[r];
					this.aliases.hasOwnProperty(r) && o.children && o.referenceCount > 1 && (e += ", alias" + ++n + "=" + r, o.children[0] = "alias" + n)
				}
				var a = ["container", "depth0", "helpers", "partials", "data"];
				(this.useBlockParams || this.useDepths) && a.push("blockParams"), this.useDepths && a.push("depths");
				var s = this.mergeSource(e);
				return t ? (a.push(s), Function.apply(this, a)) : this.source.wrap(["function(", a.join(","), ") {\n  ", s, "}"])
			}, mergeSource: function (t) {
				var e = this.environment.isSimple, i = !this.forceBuffer, n = void 0, r = void 0, o = void 0, a = void 0;
				return this.source.each(function (t) {
					t.appendToBuffer ? (o ? t.prepend("  + ") : o = t, a = t) : (o && (r ? o.prepend("buffer += ") : n = !0, a.add(";"), o = a = void 0), r = !0, e || (i = !1))
				}), i ? o ? (o.prepend("return "), a.add(";")) : r || this.source.push('return "";') : (t += ", buffer = " + (n ? "" : this.initializeBuffer()), o ? (o.prepend("return buffer + "), a.add(";")) : this.source.push("return buffer;")), t && this.source.prepend("var " + t.substring(2) + (n ? "" : ";\n")), this.source.merge()
			}, blockValue: function (t) {
				var e = this.aliasable("helpers.blockHelperMissing"), i = [this.contextName(0)];
				this.setupHelperArgs(t, 0, i);
				var n = this.popStack();
				i.splice(1, 0, n), this.push(this.source.functionCall(e, "call", i))
			}, ambiguousBlockValue: function () {
				var t = this.aliasable("helpers.blockHelperMissing"), e = [this.contextName(0)];
				this.setupHelperArgs("", 0, e, !0), this.flushInline();
				var i = this.topStack();
				e.splice(1, 0, i), this.pushSource(["if (!", this.lastHelper, ") { ", i, " = ", this.source.functionCall(t, "call", e), "}"])
			}, appendContent: function (t) {
				this.pendingContent ? t = this.pendingContent + t : this.pendingLocation = this.source.currentLocation, this.pendingContent = t
			}, append: function () {
				if (this.isInline()) this.replaceStack(function (t) {
					return [" != null ? ", t, ' : ""']
				}), this.pushSource(this.appendToBuffer(this.popStack())); else {
					var t = this.popStack();
					this.pushSource(["if (", t, " != null) { ", this.appendToBuffer(t, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"])
				}
			}, appendEscaped: function () {
				this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]))
			}, getContext: function (t) {
				this.lastContext = t
			}, pushContext: function () {
				this.pushStackLiteral(this.contextName(this.lastContext))
			}, lookupOnContext: function (t, e, i, n) {
				var r = 0;
				n || !this.options.compat || this.lastContext ? this.pushContext() : this.push(this.depthedLookup(t[r++])), this.resolvePath("context", t, r, e, i)
			}, lookupBlockParam: function (t, e) {
				this.useBlockParams = !0, this.push(["blockParams[", t[0], "][", t[1], "]"]), this.resolvePath("context", e, 1)
			}, lookupData: function (t, e, i) {
				t ? this.pushStackLiteral("container.data(data, " + t + ")") : this.pushStackLiteral("data"), this.resolvePath("data", e, 0, !0, i)
			}, resolvePath: function (t, e, i, n, r) {
				var o = this;
				if (this.options.strict || this.options.assumeObjects) this.push(function (t, e, i, n) {
					var r = e.popStack(), o = 0, a = i.length;
					t && a--;
					for (; o < a; o++) r = e.nameLookup(r, i[o], n);
					return t ? [e.aliasable("container.strict"), "(", r, ", ", e.quotedString(i[o]), ")"] : r
				}(this.options.strict && r, this, e, t)); else for (var a = e.length; i < a; i++) this.replaceStack(function (r) {
					var a = o.nameLookup(r, e[i], t);
					return n ? [" && ", a] : [" != null ? ", a, " : ", r]
				})
			}, resolvePossibleLambda: function () {
				this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"])
			}, pushStringParam: function (t, e) {
				this.pushContext(), this.pushString(e), "SubExpression" !== e && ("string" == typeof t ? this.pushString(t) : this.pushStackLiteral(t))
			}, emptyHash: function (t) {
				this.trackIds && this.push("{}"), this.stringParams && (this.push("{}"), this.push("{}")), this.pushStackLiteral(t ? "undefined" : "{}")
			}, pushHash: function () {
				this.hash && this.hashes.push(this.hash), this.hash = {values: [], types: [], contexts: [], ids: []}
			}, popHash: function () {
				var t = this.hash;
				this.hash = this.hashes.pop(), this.trackIds && this.push(this.objectLiteral(t.ids)), this.stringParams && (this.push(this.objectLiteral(t.contexts)), this.push(this.objectLiteral(t.types))), this.push(this.objectLiteral(t.values))
			}, pushString: function (t) {
				this.pushStackLiteral(this.quotedString(t))
			}, pushLiteral: function (t) {
				this.pushStackLiteral(t)
			}, pushProgram: function (t) {
				null != t ? this.pushStackLiteral(this.programExpression(t)) : this.pushStackLiteral(null)
			}, registerDecorator: function (t, e) {
				var i = this.nameLookup("decorators", e, "decorator"), n = this.setupHelperArgs(e, t);
				this.decorators.push(["fn = ", this.decorators.functionCall(i, "", ["fn", "props", "container", n]), " || fn;"])
			}, invokeHelper: function (t, e, i) {
				var n = this.popStack(), r = this.setupHelper(t, e), o = i ? [r.name, " || "] : "", a = ["("].concat(o, n);
				this.options.strict || a.push(" || ", this.aliasable("helpers.helperMissing")), a.push(")"), this.push(this.source.functionCall(a, "call", r.callParams))
			}, invokeKnownHelper: function (t, e) {
				var i = this.setupHelper(t, e);
				this.push(this.source.functionCall(i.name, "call", i.callParams))
			}, invokeAmbiguous: function (t, e) {
				this.useRegister("helper");
				var i = this.popStack();
				this.emptyHash();
				var n = this.setupHelper(0, t, e), r = ["(", "(helper = ", this.lastHelper = this.nameLookup("helpers", t, "helper"), " || ", i, ")"];
				this.options.strict || (r[0] = "(helper = ", r.push(" != null ? helper : ", this.aliasable("helpers.helperMissing"))), this.push(["(", r, n.paramsInit ? ["),(", n.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", n.callParams), " : helper))"])
			}, invokePartial: function (t, e, i) {
				var n = [], r = this.setupParams(e, 1, n);
				t && (e = this.popStack(), delete r.name), i && (r.indent = JSON.stringify(i)), r.helpers = "helpers", r.partials = "partials", r.decorators = "container.decorators", t ? n.unshift(e) : n.unshift(this.nameLookup("partials", e, "partial")), this.options.compat && (r.depths = "depths"), r = this.objectLiteral(r), n.push(r), this.push(this.source.functionCall("container.invokePartial", "", n))
			}, assignToHash: function (t) {
				var e = this.popStack(), i = void 0, n = void 0, r = void 0;
				this.trackIds && (r = this.popStack()), this.stringParams && (n = this.popStack(), i = this.popStack());
				var o = this.hash;
				i && (o.contexts[t] = i), n && (o.types[t] = n), r && (o.ids[t] = r), o.values[t] = e
			}, pushId: function (t, e, i) {
				"BlockParam" === t ? this.pushStackLiteral("blockParams[" + e[0] + "].path[" + e[1] + "]" + (i ? " + " + JSON.stringify("." + i) : "")) : "PathExpression" === t ? this.pushString(e) : "SubExpression" === t ? this.pushStackLiteral("true") : this.pushStackLiteral("null")
			}, compiler: c, compileChildren: function (t, e) {
				for (var i = t.children, n = void 0, r = void 0, o = 0, a = i.length; o < a; o++) {
					n = i[o], r = new this.compiler;
					var s = this.matchExistingProgram(n);
					if (null == s) {
						this.context.programs.push("");
						var l = this.context.programs.length;
						n.index = l, n.name = "program" + l, this.context.programs[l] = r.compile(n, e, this.context, !this.precompile), this.context.decorators[l] = r.decorators, this.context.environments[l] = n, this.useDepths = this.useDepths || r.useDepths, this.useBlockParams = this.useBlockParams || r.useBlockParams, n.useDepths = this.useDepths, n.useBlockParams = this.useBlockParams
					} else n.index = s.index, n.name = "program" + s.index, this.useDepths = this.useDepths || s.useDepths, this.useBlockParams = this.useBlockParams || s.useBlockParams
				}
			}, matchExistingProgram: function (t) {
				for (var e = 0, i = this.context.environments.length; e < i; e++) {
					var n = this.context.environments[e];
					if (n && n.equals(t)) return n
				}
			}, programExpression: function (t) {
				var e = this.environment.children[t], i = [e.index, "data", e.blockParams];
				return (this.useBlockParams || this.useDepths) && i.push("blockParams"), this.useDepths && i.push("depths"), "container.program(" + i.join(", ") + ")"
			}, useRegister: function (t) {
				this.registers[t] || (this.registers[t] = !0, this.registers.list.push(t))
			}, push: function (t) {
				return t instanceof l || (t = this.source.wrap(t)), this.inlineStack.push(t), t
			}, pushStackLiteral: function (t) {
				this.push(new l(t))
			}, pushSource: function (t) {
				this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), this.pendingContent = void 0), t && this.source.push(t)
			}, replaceStack: function (t) {
				var e = ["("], i = void 0, n = void 0, r = void 0;
				if (!this.isInline()) throw new o.default("replaceStack on non-inline");
				var a = this.popStack(!0);
				if (a instanceof l) e = ["(", i = [a.value]], r = !0; else {
					n = !0;
					var s = this.incrStack();
					e = ["((", this.push(s), " = ", a, ")"], i = this.topStack()
				}
				var c = t.call(this, i);
				r || this.popStack(), n && this.stackSlot--, this.push(e.concat(c, ")"))
			}, incrStack: function () {
				return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName()
			}, topStackName: function () {
				return "stack" + this.stackSlot
			}, flushInline: function () {
				var t = this.inlineStack;
				this.inlineStack = [];
				for (var e = 0, i = t.length; e < i; e++) {
					var n = t[e];
					if (n instanceof l) this.compileStack.push(n); else {
						var r = this.incrStack();
						this.pushSource([r, " = ", n, ";"]), this.compileStack.push(r)
					}
				}
			}, isInline: function () {
				return this.inlineStack.length
			}, popStack: function (t) {
				var e = this.isInline(), i = (e ? this.inlineStack : this.compileStack).pop();
				if (!t && i instanceof l) return i.value;
				if (!e) {
					if (!this.stackSlot) throw new o.default("Invalid stack pop");
					this.stackSlot--
				}
				return i
			}, topStack: function () {
				var t = this.isInline() ? this.inlineStack : this.compileStack, e = t[t.length - 1];
				return e instanceof l ? e.value : e
			}, contextName: function (t) {
				return this.useDepths && t ? "depths[" + t + "]" : "depth" + t
			}, quotedString: function (t) {
				return this.source.quotedString(t)
			}, objectLiteral: function (t) {
				return this.source.objectLiteral(t)
			}, aliasable: function (t) {
				var e = this.aliases[t];
				return e ? (e.referenceCount++, e) : ((e = this.aliases[t] = this.source.wrap(t)).aliasable = !0, e.referenceCount = 1, e)
			}, setupHelper: function (t, e, i) {
				var n = [];
				return {params: n, paramsInit: this.setupHelperArgs(e, t, n, i), name: this.nameLookup("helpers", e, "helper"), callParams: [this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})")].concat(n)}
			}, setupParams: function (t, e, i) {
				var n = {}, r = [], o = [], a = [], s = !i, l = void 0;
				s && (i = []), n.name = this.quotedString(t), n.hash = this.popStack(), this.trackIds && (n.hashIds = this.popStack()), this.stringParams && (n.hashTypes = this.popStack(), n.hashContexts = this.popStack());
				var c = this.popStack(), u = this.popStack();
				(u || c) && (n.fn = u || "container.noop", n.inverse = c || "container.noop");
				for (var h = e; h--;) l = this.popStack(), i[h] = l, this.trackIds && (a[h] = this.popStack()), this.stringParams && (o[h] = this.popStack(), r[h] = this.popStack());
				return s && (n.args = this.source.generateArray(i)), this.trackIds && (n.ids = this.source.generateArray(a)), this.stringParams && (n.types = this.source.generateArray(o), n.contexts = this.source.generateArray(r)), this.options.data && (n.data = "data"), this.useBlockParams && (n.blockParams = "blockParams"), n
			}, setupHelperArgs: function (t, e, i, n) {
				var r = this.setupParams(t, e, i);
				return r = this.objectLiteral(r), n ? (this.useRegister("options"), i.push("options"), ["options=", r]) : i ? (i.push(r), "") : r
			}
		}, function () {
			for (var t = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "), e = c.RESERVED_WORDS = {}, i = 0, n = t.length; i < n; i++) e[t[i]] = !0
		}(), c.isValidJavaScriptVariableName = function (t) {
			return !c.RESERVED_WORDS[t] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(t)
		}, e.default = c, t.exports = e.default
	}, function (t, e, i) {
		"use strict";
		e.__esModule = !0;
		var n = i(5), r = void 0;
		try {
		} catch (t) {
		}

		function o(t, e, i) {
			if (n.isArray(t)) {
				for (var r = [], o = 0, a = t.length; o < a; o++) r.push(e.wrap(t[o], i));
				return r
			}
			return "boolean" == typeof t || "number" == typeof t ? t + "" : t
		}

		function a(t) {
			this.srcFile = t, this.source = []
		}

		r || ((r = function (t, e, i, n) {
			this.src = "", n && this.add(n)
		}).prototype = {
			add: function (t) {
				n.isArray(t) && (t = t.join("")), this.src += t
			}, prepend: function (t) {
				n.isArray(t) && (t = t.join("")), this.src = t + this.src
			}, toStringWithSourceMap: function () {
				return {code: this.toString()}
			}, toString: function () {
				return this.src
			}
		}), a.prototype = {
			isEmpty: function () {
				return !this.source.length
			}, prepend: function (t, e) {
				this.source.unshift(this.wrap(t, e))
			}, push: function (t, e) {
				this.source.push(this.wrap(t, e))
			}, merge: function () {
				var t = this.empty();
				return this.each(function (e) {
					t.add(["  ", e, "\n"])
				}), t
			}, each: function (t) {
				for (var e = 0, i = this.source.length; e < i; e++) t(this.source[e])
			}, empty: function () {
				var t = this.currentLocation || {start: {}};
				return new r(t.start.line, t.start.column, this.srcFile)
			}, wrap: function (t) {
				var e = arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || {start: {}} : arguments[1];
				return t instanceof r ? t : (t = o(t, this, e), new r(e.start.line, e.start.column, this.srcFile, t))
			}, functionCall: function (t, e, i) {
				return i = this.generateList(i), this.wrap([t, e ? "." + e + "(" : "(", i, ")"])
			}, quotedString: function (t) {
				return '"' + (t + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"'
			}, objectLiteral: function (t) {
				var e = [];
				for (var i in t) if (t.hasOwnProperty(i)) {
					var n = o(t[i], this);
					"undefined" !== n && e.push([this.quotedString(i), ":", n])
				}
				var r = this.generateList(e);
				return r.prepend("{"), r.add("}"), r
			}, generateList: function (t) {
				for (var e = this.empty(), i = 0, n = t.length; i < n; i++) i && e.add(","), e.add(o(t[i], this));
				return e
			}, generateArray: function (t) {
				var e = this.generateList(t);
				return e.prepend("["), e.add("]"), e
			}
		}, e.default = a, t.exports = e.default
	}])
}), function (t) {
	function e(n) {
		if (i[n]) return i[n].exports;
		var r = i[n] = {i: n, l: !1, exports: {}};
		return t[n].call(r.exports, r, r.exports, e), r.l = !0, r.exports
	}

	var i = {};
	e.m = t, e.c = i, e.d = function (t, i, n) {
		e.o(t, i) || Object.defineProperty(t, i, {configurable: !1, enumerable: !0, get: n})
	}, e.n = function (t) {
		var i = t && t.__esModule ? function () {
			return t.default
		} : function () {
			return t
		};
		return e.d(i, "a", i), i
	}, e.o = function (t, e) {
		return Object.prototype.hasOwnProperty.call(t, e)
	}, e.p = "", e(e.s = 3)
}([function (t, e, i) {
	"use strict";
	var n, r, o;
	"function" == typeof Symbol && Symbol.iterator, r = [i(2)], void 0 !== (o = "function" == typeof (n = function (t) {
		return t
	}) ? n.apply(e, r) : n) && (t.exports = o)
}, function (t, e, i) {
	"use strict";
	var n, r, o, a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
		return typeof t
	} : function (t) {
		return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
	};
	r = [i(0), i(10), i(11)], void 0 !== (o = "function" == typeof (n = function (t, e, i, n) {
		function r(e, i, a) {
			if (!(this instanceof r)) return new r(e, i, a);
			this.el = n, this.events = {}, this.maskset = n, this.refreshValue = !1, !0 !== a && (t.isPlainObject(e) ? i = e : (i = i || {}).alias = e, this.opts = t.extend(!0, {}, this.defaults, i), this.noMasksCache = i && i.definitions !== n, this.userOptions = i || {}, this.isRTL = this.opts.numericInput, o(this.opts.alias, i, this.opts))
		}

		function o(e, i, a) {
			var s = r.prototype.aliases[e];
			return s ? (s.alias && o(s.alias, n, a), t.extend(!0, a, s), t.extend(!0, a, i), !0) : (null === a.mask && (a.mask = e), !1)
		}

		function s(e, i) {
			function o(e, o, a) {
				var s = !1;
				if (null !== e && "" !== e || ((s = null !== a.regex) ? e = (e = a.regex).replace(/^(\^)(.*)(\$)$/, "$2") : (s = !0, e = ".*")), 1 === e.length && !1 === a.greedy && 0 !== a.repeat && (a.placeholder = ""), a.repeat > 0 || "*" === a.repeat || "+" === a.repeat) {
					var l = "*" === a.repeat ? 0 : "+" === a.repeat ? 1 : a.repeat;
					e = a.groupmarker.start + e + a.groupmarker.end + a.quantifiermarker.start + l + "," + a.repeat + a.quantifiermarker.end
				}
				var c, u = s ? "regex_" + a.regex : a.numericInput ? e.split("").reverse().join("") : e;
				return r.prototype.masksCache[u] === n || !0 === i ? (c = {
					mask: e,
					maskToken: r.prototype.analyseMask(e, s, a),
					validPositions: {},
					_buffer: n,
					buffer: n,
					tests: {},
					metadata: o,
					maskLength: n
				}, !0 !== i && (r.prototype.masksCache[u] = c, c = t.extend(!0, {}, r.prototype.masksCache[u]))) : c = t.extend(!0, {}, r.prototype.masksCache[u]), c
			}

			if (t.isFunction(e.mask) && (e.mask = e.mask(e)), t.isArray(e.mask)) {
				if (e.mask.length > 1) {
					e.keepStatic = null === e.keepStatic || e.keepStatic;
					var a = e.groupmarker.start;
					return t.each(e.numericInput ? e.mask.reverse() : e.mask, function (i, r) {
						a.length > 1 && (a += e.groupmarker.end + e.alternatormarker + e.groupmarker.start), r.mask === n || t.isFunction(r.mask) ? a += r : a += r.mask
					}), o(a += e.groupmarker.end, e.mask, e)
				}
				e.mask = e.mask.pop()
			}
			return e.mask && e.mask.mask !== n && !t.isFunction(e.mask.mask) ? o(e.mask.mask, e.mask, e) : o(e.mask, e.mask, e)
		}

		function l(o, s, c) {
			function f(t, e, i) {
				e = e || 0;
				var r, o, a, s = [], l = 0, u = v();
				do {
					!0 === t && m().validPositions[l] ? (o = (a = m().validPositions[l]).match, r = a.locator.slice(), s.push(!0 === i ? a.input : !1 === i ? o.nativeDef : F(l, o))) : (o = (a = w(l, r, l - 1)).match, r = a.locator.slice(), (!1 === c.jitMasking || l < u || "number" == typeof c.jitMasking && isFinite(c.jitMasking) && c.jitMasking > l) && s.push(!1 === i ? o.nativeDef : F(l, o))), l++
				} while ((q === n || l < q) && (null !== o.fn || "" !== o.def) || e > l);
				return "" === s[s.length - 1] && s.pop(), m().maskLength = l + 1, s
			}

			function m() {
				return s
			}

			function g(t) {
				var e = m();
				e.buffer = n, !0 !== t && (e.validPositions = {}, e.p = 0)
			}

			function v(t, e, i) {
				var r = -1, o = -1, a = i || m().validPositions;
				for (var s in t === n && (t = -1), a) {
					var l = parseInt(s);
					a[l] && (e || !0 !== a[l].generatedInput) && (l <= t && (r = l), l >= t && (o = l))
				}
				return -1 !== r && t - r > 1 || o < t ? r : o
			}

			function y(e, i, r, o) {
				var a, s = e, l = t.extend(!0, {}, m().validPositions), u = !1;
				for (m().p = e, a = i - 1; a >= s; a--) m().validPositions[a] !== n && (!0 !== r && (!m().validPositions[a].match.optionality && function (t) {
					var e = m().validPositions[t];
					if (e !== n && null === e.match.fn) {
						var i = m().validPositions[t - 1], r = m().validPositions[t + 1];
						return i !== n && r !== n
					}
					return !1
				}(a) || !1 === c.canClearPosition(m(), a, v(), o, c)) || delete m().validPositions[a]);
				for (g(!0), a = s + 1; a <= v();) {
					for (; m().validPositions[s] !== n;) s++;
					if (a < s && (a = s + 1), m().validPositions[a] === n && A(a)) a++; else {
						var h = w(a);
						!1 === u && l[s] && l[s].match.def === h.match.def ? (m().validPositions[s] = t.extend(!0, {}, l[s]), m().validPositions[s].input = h.input, delete m().validPositions[a], a++) : k(s, h.match.def) ? !1 !== E(s, h.input || F(a), !0) && (delete m().validPositions[a], a++, u = !0) : A(a) || (a++, s--), s++
					}
				}
				g(!0)
			}

			function b(t, e) {
				for (var i, r = t, o = v(), a = m().validPositions[o] || _(0)[0], s = a.alternation !== n ? a.locator[a.alternation].toString().split(",") : [], l = 0; l < r.length && (!((i = r[l]).match && (c.greedy && !0 !== i.match.optionalQuantifier || (!1 === i.match.optionality || !1 === i.match.newBlockMarker) && !0 !== i.match.optionalQuantifier) && (a.alternation === n || a.alternation !== i.alternation || i.locator[a.alternation] !== n && M(i.locator[a.alternation].toString().split(","), s))) || !0 === e && (null !== i.match.fn || /[0-9a-bA-Z]/.test(i.match.def))); l++) ;
				return i
			}

			function w(t, e, i) {
				return m().validPositions[t] || b(_(t, e ? e.slice() : e, i))
			}

			function x(t) {
				return m().validPositions[t] ? m().validPositions[t] : _(t)[0]
			}

			function k(t, e) {
				for (var i = !1, n = _(t), r = 0; r < n.length; r++) if (n[r].match && n[r].match.def === e) {
					i = !0;
					break
				}
				return i
			}

			function _(e, i, r) {
				function o(i, r, a, l) {
					function u(a, l, h) {
						function p(e, i) {
							var n = 0 === t.inArray(e, i.matches);
							return n || t.each(i.matches, function (t, r) {
								if (!0 === r.isQuantifier && (n = p(e, i.matches[t - 1]))) return !1
							}), n
						}

						function y(e, i, r) {
							var o, a;
							if (m().validPositions[e - 1] && r && m().tests[e]) for (var s = m().validPositions[e - 1].locator, l = m().tests[e][0].locator, c = 0; c < r; c++) if (s[c] !== l[c]) return s.slice(r + 1);
							return (m().tests[e] || m().validPositions[e]) && t.each(m().tests[e] || [m().validPositions[e]], function (t, e) {
								var s = r !== n ? r : e.alternation, l = e.locator[s] !== n ? e.locator[s].toString().indexOf(i) : -1;
								(a === n || l < a) && -1 !== l && (o = e, a = l)
							}), o ? o.locator.slice((r !== n ? r : o.alternation) + 1) : r !== n ? y(e, i) : n
						}

						if (d > 1e4) throw"Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. " + m().mask;
						if (d === e && a.matches === n) return f.push({match: a, locator: l.reverse(), cd: v}), !0;
						if (a.matches !== n) {
							if (a.isGroup && h !== a) {
								if (a = u(i.matches[t.inArray(a, i.matches) + 1], l)) return !0
							} else if (a.isOptional) {
								var b = a;
								if (a = o(a, r, l, h)) {
									if (!p(s = f[f.length - 1].match, b)) return !0;
									g = !0, d = e
								}
							} else if (a.isAlternator) {
								var w, x = a, k = [], _ = f.slice(), S = l.length, C = r.length > 0 ? r.shift() : -1;
								if (-1 === C || "string" == typeof C) {
									var D, T = d, M = r.slice(), E = [];
									if ("string" == typeof C) E = C.split(","); else for (D = 0; D < x.matches.length; D++) E.push(D);
									for (var A = 0; A < E.length; A++) {
										if (D = parseInt(E[A]), f = [], r = y(d, D, S) || M.slice(), !0 !== (a = u(x.matches[D] || i.matches[D], [D].concat(l), h) || a) && a !== n && E[E.length - 1] < x.matches.length) {
											var P = t.inArray(a, i.matches) + 1;
											i.matches.length > P && (a = u(i.matches[P], [P].concat(l.slice(1, l.length)), h)) && (E.push(P.toString()), t.each(f, function (t, e) {
												e.alternation = l.length - 1
											}))
										}
										w = f.slice(), d = T, f = [];
										for (var I = 0; I < w.length; I++) {
											var O = w[I], L = !1;
											O.alternation = O.alternation || S;
											for (var F = 0; F < k.length; F++) {
												var N = k[F];
												if ("string" != typeof C || -1 !== t.inArray(O.locator[O.alternation].toString(), E)) {
													if (z = N, (B = O).match.nativeDef === z.match.nativeDef || B.match.def === z.match.nativeDef || B.match.nativeDef === z.match.def) {
														L = !0, O.alternation === N.alternation && -1 === N.locator[N.alternation].toString().indexOf(O.locator[O.alternation]) && (N.locator[N.alternation] = N.locator[N.alternation] + "," + O.locator[O.alternation], N.alternation = O.alternation), O.match.nativeDef === N.match.def && (O.locator[O.alternation] = N.locator[N.alternation], k.splice(k.indexOf(N), 1, O));
														break
													}
													if (O.match.def === N.match.def) {
														L = !1;
														break
													}
													if (function (t, i) {
														return null === t.match.fn && null !== i.match.fn && i.match.fn.test(t.match.def, m(), e, !1, c, !1)
													}(O, N) || function (t, i) {
														return null !== t.match.fn && null !== i.match.fn && i.match.fn.test(t.match.def.replace(/[\[\]]/g, ""), m(), e, !1, c, !1)
													}(O, N)) {
														O.alternation === N.alternation && -1 === O.locator[O.alternation].toString().indexOf(N.locator[N.alternation].toString().split("")[0]) && (O.na = O.na || O.locator[O.alternation].toString(), -1 === O.na.indexOf(O.locator[O.alternation].toString().split("")[0]) && (O.na = O.na + "," + O.locator[N.alternation].toString().split("")[0]), L = !0, O.locator[O.alternation] = N.locator[N.alternation].toString().split("")[0] + "," + O.locator[O.alternation], k.splice(k.indexOf(N), 0, O));
														break
													}
												}
											}
											L || k.push(O)
										}
									}
									"string" == typeof C && (k = t.map(k, function (e, i) {
										if (isFinite(i)) {
											var r = e.alternation, o = e.locator[r].toString().split(",");
											e.locator[r] = n, e.alternation = n;
											for (var a = 0; a < o.length; a++) -1 !== t.inArray(o[a], E) && (e.locator[r] !== n ? (e.locator[r] += ",", e.locator[r] += o[a]) : e.locator[r] = parseInt(o[a]), e.alternation = r);
											if (e.locator[r] !== n) return e
										}
									})), f = _.concat(k), d = e, g = f.length > 0, a = k.length > 0, r = M.slice()
								} else a = u(x.matches[C] || i.matches[C], [C].concat(l), h);
								if (a) return !0
							} else if (a.isQuantifier && h !== i.matches[t.inArray(a, i.matches) - 1]) for (var R = a, H = r.length > 0 ? r.shift() : 0; H < (isNaN(R.quantifier.max) ? H + 1 : R.quantifier.max) && d <= e; H++) {
								var $ = i.matches[t.inArray(R, i.matches) - 1];
								if (a = u($, [H].concat(l), $)) {
									if ((s = f[f.length - 1].match).optionalQuantifier = H > R.quantifier.min - 1, p(s, $)) {
										if (H > R.quantifier.min - 1) {
											g = !0, d = e;
											break
										}
										return !0
									}
									return !0
								}
							} else if (a = o(a, r, l, h)) return !0
						} else d++;
						var B, z
					}

					for (var h = r.length > 0 ? r.shift() : 0; h < i.matches.length; h++) if (!0 !== i.matches[h].isQuantifier) {
						var p = u(i.matches[h], [h].concat(a), l);
						if (p && d === e) return p;
						if (d > e) break
					}
				}

				function a(t) {
					if (c.keepStatic && e > 0 && t.length > 1 + ("" === t[t.length - 1].match.def ? 1 : 0) && !0 !== t[0].match.optionality && !0 !== t[0].match.optionalQuantifier && null === t[0].match.fn && !/[0-9a-bA-Z]/.test(t[0].match.def)) {
						if (m().validPositions[e - 1] === n) return [b(t)];
						if (m().validPositions[e - 1].alternation === t[0].alternation) return [b(t)];
						if (m().validPositions[e - 1]) return [b(t)]
					}
					return t
				}

				var s, l, u, h = m().maskToken, d = i ? r : 0, p = i ? i.slice() : [0], f = [], g = !1, v = i ? i.join("") : "";
				if (e > -1) {
					if (i === n) {
						for (var y, w = e - 1; (y = m().validPositions[w] || m().tests[w]) === n && w > -1;) w--;
						y !== n && w > -1 && (l = y, u = [], t.isArray(l) || (l = [l]), l.length > 0 && (l[0].alternation === n ? 0 === (u = b(l.slice()).locator.slice()).length && (u = l[0].locator.slice()) : t.each(l, function (t, e) {
							if ("" !== e.def) if (0 === u.length) u = e.locator.slice(); else for (var i = 0; i < u.length; i++) e.locator[i] && -1 === u[i].toString().indexOf(e.locator[i]) && (u[i] += "," + e.locator[i])
						})), v = (p = u).join(""), d = w)
					}
					if (m().tests[e] && m().tests[e][0].cd === v) return a(m().tests[e]);
					for (var x = p.shift(); x < h.length && !(o(h[x], p, [x]) && d === e || d > e); x++) ;
				}
				return (0 === f.length || g) && f.push({match: {fn: null, cardinality: 0, optionality: !0, casing: null, def: "", placeholder: ""}, locator: [], cd: v}), i !== n && m().tests[e] ? a(t.extend(!0, [], f)) : (m().tests[e] = t.extend(!0, [], f), a(m().tests[e]))
			}

			function S() {
				return m()._buffer === n && (m()._buffer = f(!1, 1), m().buffer === n && (m().buffer = m()._buffer.slice())), m()._buffer
			}

			function C(t) {
				return m().buffer !== n && !0 !== t || (m().buffer = f(!0, v(), !0)), m().buffer
			}

			function D(t, e, i) {
				var r, o;
				if (!0 === t) g(), t = 0, e = i.length; else for (r = t; r < e; r++) delete m().validPositions[r];
				for (o = t, r = t; r < e; r++) if (g(!0), i[r] !== c.skipOptionalPartCharacter) {
					var a = E(o, i[r], !0, !0);
					!1 !== a && (g(!0), o = a.caret !== n ? a.caret : a.pos + 1)
				}
			}

			function T(e, i, n) {
				switch (c.casing || i.casing) {
					case"upper":
						e = e.toUpperCase();
						break;
					case"lower":
						e = e.toLowerCase();
						break;
					case"title":
						var o = m().validPositions[n - 1];
						e = 0 === n || o && o.input === String.fromCharCode(r.keyCode.SPACE) ? e.toUpperCase() : e.toLowerCase();
						break;
					default:
						if (t.isFunction(c.casing)) {
							var a = Array.prototype.slice.call(arguments);
							a.push(m().validPositions), e = c.casing.apply(this, a)
						}
				}
				return e
			}

			function M(e, i, r) {
				for (var o, a = c.greedy ? i : i.slice(0, 1), s = !1, l = r !== n ? r.split(",") : [], u = 0; u < l.length; u++) -1 !== (o = e.indexOf(l[u])) && e.splice(o, 1);
				for (var h = 0; h < e.length; h++) if (-1 !== t.inArray(e[h], a)) {
					s = !0;
					break
				}
				return s
			}

			function E(e, i, o, a, s, l) {
				function u(t) {
					var e = Q ? t.begin - t.end > 1 || t.begin - t.end == 1 : t.end - t.begin > 1 || t.end - t.begin == 1;
					return e && 0 === t.begin && t.end === m().maskLength ? "full" : e
				}

				function h(i, r, o) {
					var s = !1;
					return t.each(_(i), function (l, h) {
						for (var p = h.match, f = r ? 1 : 0, b = "", w = p.cardinality; w > f; w--) b += O(i - (w - 1));
						if (r && (b += r), C(!0), !1 !== (s = null != p.fn ? p.fn.test(b, m(), i, o, c, u(e)) : (r === p.def || r === c.skipOptionalPartCharacter) && "" !== p.def && {c: F(i, p, !0) || p.def, pos: i})) {
							var x = s.c !== n ? s.c : r;
							x = x === c.skipOptionalPartCharacter && null === p.fn ? F(i, p, !0) || p.def : x;
							var k = i, _ = C();
							if (s.remove !== n && (t.isArray(s.remove) || (s.remove = [s.remove]), t.each(s.remove.sort(function (t, e) {
								return e - t
							}), function (t, e) {
								y(e, e + 1, !0)
							})), s.insert !== n && (t.isArray(s.insert) || (s.insert = [s.insert]), t.each(s.insert.sort(function (t, e) {
								return t - e
							}), function (t, e) {
								E(e.pos, e.c, !0, a)
							})), s.refreshFromBuffer) {
								var S = s.refreshFromBuffer;
								if (D(!0 === S ? S : S.start, S.end, _), s.pos === n && s.c === n) return s.pos = v(), !1;
								if ((k = s.pos !== n ? s.pos : i) !== i) return s = t.extend(s, E(k, x, !0, a)), !1
							} else if (!0 !== s && s.pos !== n && s.pos !== i && (k = s.pos, D(i, k, C().slice()), k !== i)) return s = t.extend(s, E(k, x, !0)), !1;
							return (!0 === s || s.pos !== n || s.c !== n) && (l > 0 && g(!0), d(k, t.extend({}, h, {input: T(x, p, k)}), a, u(e)) || (s = !1), !1)
						}
					}), s
				}

				function d(e, i, r, o) {
					if (o || c.insertMode && m().validPositions[e] !== n && r === n) {
						var a, s = t.extend(!0, {}, m().validPositions), l = v(n, !0);
						for (a = e; a <= l; a++) delete m().validPositions[a];
						m().validPositions[e] = t.extend(!0, {}, i);
						var u, h = !0, d = m().validPositions, f = !1, y = m().maskLength;
						for (a = u = e; a <= l; a++) {
							var b = s[a];
							if (b !== n) for (var w = u; w < m().maskLength && (null === b.match.fn && d[a] && (!0 === d[a].match.optionalQuantifier || !0 === d[a].match.optionality) || null != b.match.fn);) {
								if (w++, !1 === f && s[w] && s[w].match.def === b.match.def) m().validPositions[w] = t.extend(!0, {}, s[w]), m().validPositions[w].input = b.input, p(w), u = w, h = !0; else if (k(w, b.match.def)) {
									var x = E(w, b.input, !0, !0);
									h = !1 !== x, u = x.caret || x.insert ? v() : w, f = !0
								} else if (!(h = !0 === b.generatedInput) && w >= m().maskLength - 1) break;
								if (m().maskLength < y && (m().maskLength = y), h) break
							}
							if (!h) break
						}
						if (!h) return m().validPositions = t.extend(!0, {}, s), g(!0), !1
					} else m().validPositions[e] = t.extend(!0, {}, i);
					return g(!0), !0
				}

				function p(e) {
					for (var i = e - 1; i > -1 && !m().validPositions[i]; i--) ;
					var r, o;
					for (i++; i < e; i++) m().validPositions[i] === n && (!1 === c.jitMasking || c.jitMasking > i) && ("" === (o = _(i, w(i - 1).locator, i - 1).slice())[o.length - 1].match.def && o.pop(), (r = b(o)) && (r.match.def === c.radixPointDefinitionSymbol || !A(i, !0) || t.inArray(c.radixPoint, C()) < i && r.match.fn && r.match.fn.test(F(i), m(), i, !1, c)) && !1 !== (x = h(i, F(i, r.match, !0) || (null == r.match.fn ? r.match.def : "" !== F(i) ? F(i) : C()[i]), !0)) && (m().validPositions[x.pos || i].generatedInput = !0))
				}

				o = !0 === o;
				var f = e;
				e.begin !== n && (f = Q && !u(e) ? e.end : e.begin);
				var x = !0, S = t.extend(!0, {}, m().validPositions);
				if (t.isFunction(c.preValidation) && !o && !0 !== a && !0 !== l && (x = c.preValidation(C(), f, i, u(e), c)), !0 === x) {
					if (p(f), u(e) && (j(n, r.keyCode.DELETE, e, !0, !0), f = m().p), f < m().maskLength && (q === n || f < q) && (x = h(f, i, o), (!o || !0 === a) && !1 === x && !0 !== l)) {
						var I = m().validPositions[f];
						if (!I || null !== I.match.fn || I.match.def !== i && i !== c.skipOptionalPartCharacter) {
							if ((c.insertMode || m().validPositions[P(f)] === n) && !A(f, !0)) for (var L = f + 1, N = P(f); L <= N; L++) if (!1 !== (x = h(L, i, o))) {
								!function (e, i) {
									var r = m().validPositions[i];
									if (r) for (var o = r.locator, a = o.length, s = e; s < i; s++) if (m().validPositions[s] === n && !A(s, !0)) {
										var l = _(s).slice(), c = b(l, !0), u = -1;
										"" === l[l.length - 1].match.def && l.pop(), t.each(l, function (t, e) {
											for (var i = 0; i < a; i++) {
												if (e.locator[i] === n || !M(e.locator[i].toString().split(","), o[i].toString().split(","), e.na)) {
													var r = o[i], s = c.locator[i], l = e.locator[i];
													r - s > Math.abs(r - l) && (c = e);
													break
												}
												u < i && (u = i, c = e)
											}
										}), (c = t.extend({}, c, {input: F(s, c.match, !0) || c.match.def})).generatedInput = !0, d(s, c, !0), m().validPositions[i] = n, h(i, r.input, !0)
									}
								}(f, x.pos !== n ? x.pos : L), f = L;
								break
							}
						} else x = {caret: P(f)}
					}
					!1 === x && c.keepStatic && !o && !0 !== s && (x = function (e, i, r) {
						var o, s, l, u, h, d, p, f, y = t.extend(!0, {}, m().validPositions), b = !1, w = v();
						for (u = m().validPositions[w]; w >= 0; w--) if ((l = m().validPositions[w]) && l.alternation !== n) {
							if (o = w, s = m().validPositions[o].alternation, u.locator[l.alternation] !== l.locator[l.alternation]) break;
							u = l
						}
						if (s !== n) {
							f = parseInt(o);
							var x = u.locator[u.alternation || s] !== n ? u.locator[u.alternation || s] : p[0];
							x.length > 0 && (x = x.split(",")[0]);
							var k = m().validPositions[f], S = m().validPositions[f - 1];
							t.each(_(f, S ? S.locator : n, f - 1), function (o, l) {
								p = l.locator[s] ? l.locator[s].toString().split(",") : [];
								for (var u = 0; u < p.length; u++) {
									var w = [], _ = 0, S = 0, C = !1;
									if (x < p[u] && (l.na === n || -1 === t.inArray(p[u], l.na.split(",")) || -1 === t.inArray(x.toString(), p))) {
										m().validPositions[f] = t.extend(!0, {}, l);
										var D = m().validPositions[f].locator;
										for (m().validPositions[f].locator[s] = parseInt(p[u]), null == l.match.fn ? (k.input !== l.match.def && (C = !0, !0 !== k.generatedInput && w.push(k.input)), S++, m().validPositions[f].generatedInput = !/[0-9a-bA-Z]/.test(l.match.def), m().validPositions[f].input = l.match.def) : m().validPositions[f].input = k.input, h = f + 1; h < v(n, !0) + 1; h++) (d = m().validPositions[h]) && !0 !== d.generatedInput && /[0-9a-bA-Z]/.test(d.input) ? w.push(d.input) : h < e && _++, delete m().validPositions[h];
										for (C && w[0] === l.match.def && w.shift(), g(!0), b = !0; w.length > 0;) {
											var T = w.shift();
											if (T !== c.skipOptionalPartCharacter && !(b = E(v(n, !0) + 1, T, !1, a, !0))) break
										}
										if (b) {
											m().validPositions[f].locator = D;
											var M = v(e) + 1;
											for (h = f + 1; h < v() + 1; h++) ((d = m().validPositions[h]) === n || null == d.match.fn) && h < e + (S - _) && S++;
											b = E((e += S - _) > M ? M : e, i, r, a, !0)
										}
										if (b) return !1;
										g(), m().validPositions = t.extend(!0, {}, y)
									}
								}
							})
						}
						return b
					}(f, i, o)), !0 === x && (x = {pos: f})
				}
				if (t.isFunction(c.postValidation) && !1 !== x && !o && !0 !== a && !0 !== l) {
					var R = c.postValidation(C(!0), x, c);
					if (R.refreshFromBuffer && R.buffer) {
						var H = R.refreshFromBuffer;
						D(!0 === H ? H : H.start, H.end, R.buffer)
					}
					x = !0 === R ? x : R
				}
				return x && x.pos === n && (x.pos = f), !1 !== x && !0 !== l || (g(!0), m().validPositions = t.extend(!0, {}, S)), x
			}

			function A(t, e) {
				var i = w(t).match;
				if ("" === i.def && (i = x(t).match), null != i.fn) return i.fn;
				if (!0 !== e && t > -1) {
					var n = _(t);
					return n.length > 1 + ("" === n[n.length - 1].match.def ? 1 : 0)
				}
				return !1
			}

			function P(t, e) {
				var i = m().maskLength;
				if (t >= i) return i;
				var n = t;
				for (_(i + 1).length > 1 && (f(!0, i + 1, !0), i = m().maskLength); ++n < i && (!0 === e && (!0 !== x(n).match.newBlockMarker || !A(n)) || !0 !== e && !A(n));) ;
				return n
			}

			function I(t, e) {
				var i, n = t;
				if (n <= 0) return 0;
				for (; --n > 0 && (!0 === e && !0 !== x(n).match.newBlockMarker || !0 !== e && !A(n) && ((i = _(n)).length < 2 || 2 === i.length && "" === i[1].match.def));) ;
				return n
			}

			function O(t) {
				return m().validPositions[t] === n ? F(t) : m().validPositions[t].input
			}

			function L(e, i, r, o, a) {
				if (o && t.isFunction(c.onBeforeWrite)) {
					var s = c.onBeforeWrite.call(X, o, i, r, c);
					if (s) {
						if (s.refreshFromBuffer) {
							var l = s.refreshFromBuffer;
							D(!0 === l ? l : l.start, l.end, s.buffer || i), i = C(!0)
						}
						r !== n && (r = s.caret !== n ? s.caret : r)
					}
				}
				e !== n && (e.inputmask._valueSet(i.join("")), r === n || o !== n && "blur" === o.type ? W(e, r, 0 === i.length) : p && o && "input" === o.type ? setTimeout(function () {
					H(e, r)
				}, 0) : H(e, r), !0 === a && (tt = !0, t(e).trigger("input")))
			}

			function F(e, i, r) {
				if ((i = i || x(e).match).placeholder !== n || !0 === r) return t.isFunction(i.placeholder) ? i.placeholder(c) : i.placeholder;
				if (null === i.fn) {
					if (e > -1 && m().validPositions[e] === n) {
						var o, a = _(e), s = [];
						if (a.length > 1 + ("" === a[a.length - 1].match.def ? 1 : 0)) for (var l = 0; l < a.length; l++) if (!0 !== a[l].match.optionality && !0 !== a[l].match.optionalQuantifier && (null === a[l].match.fn || o === n || !1 !== a[l].match.fn.test(o.match.def, m(), e, !0, c)) && (s.push(a[l]), null === a[l].match.fn && (o = a[l]), s.length > 1 && /[0-9a-bA-Z]/.test(s[0].match.def))) return c.placeholder.charAt(e % c.placeholder.length)
					}
					return i.def
				}
				return c.placeholder.charAt(e % c.placeholder.length)
			}

			function N(e, o, a, s, l) {
				var u = s.slice(), h = "", d = -1, p = n;
				if (g(), a || !0 === c.autoUnmask) d = P(d); else {
					var f = S().slice(0, P(-1)).join(""), y = u.join("").match(new RegExp("^" + r.escapeRegex(f), "g"));
					y && y.length > 0 && (u.splice(0, y.length * f.length), d = P(d))
				}
				if (-1 === d ? (m().p = P(d), d = 0) : m().p = d, t.each(u, function (i, r) {
					if (r !== n) if (m().validPositions[i] === n && u[i] === F(i) && A(i, !0) && !1 === E(i, u[i], !0, n, n, !0)) m().p++; else {
						var o = new t.Event("_checkval");
						o.which = r.charCodeAt(0), h += r;
						var s = v(n, !0), l = m().validPositions[s], f = w(s + 1, l ? l.locator.slice() : n, s);
						if (!function (t, e) {
							return -1 !== S().slice(t, P(t)).join("").indexOf(e) && !A(t) && x(t).match.nativeDef === e.charAt(e.length - 1)
						}(d, h) || a || c.autoUnmask) {
							var y = a ? i : null == f.match.fn && f.match.optionality && s + 1 < m().p ? s + 1 : m().p;
							p = rt.keypressEvent.call(e, o, !0, !1, a, y), d = y + 1, h = ""
						} else p = rt.keypressEvent.call(e, o, !0, !1, !0, s + 1);
						if (!1 !== p && !a && t.isFunction(c.onBeforeWrite)) {
							var b = p;
							if (p = c.onBeforeWrite.call(X, o, C(), p.forwardPosition, c), (p = t.extend(b, p)) && p.refreshFromBuffer) {
								var k = p.refreshFromBuffer;
								D(!0 === k ? k : k.start, k.end, p.buffer), g(!0), p.caret && (m().p = p.caret, p.forwardPosition = p.caret)
							}
						}
					}
				}), o) {
					var b = n;
					i.activeElement === e && p && (b = c.numericInput ? I(p.forwardPosition) : p.forwardPosition), L(e, C(), b, l || new t.Event("checkval"), l && "input" === l.type)
				}
			}

			function R(e) {
				if (e) {
					if (e.inputmask === n) return e.value;
					e.inputmask && e.inputmask.refreshValue && rt.setValueEvent.call(e)
				}
				var i = [], r = m().validPositions;
				for (var o in r) r[o].match && null != r[o].match.fn && i.push(r[o].input);
				var a = 0 === i.length ? "" : (Q ? i.reverse() : i).join("");
				if (t.isFunction(c.onUnMask)) {
					var s = (Q ? C().slice().reverse() : C()).join("");
					a = c.onUnMask.call(X, s, a, c)
				}
				return a
			}

			function H(t, r, o, a) {
				function s(t) {
					return !0 === a || !Q || "number" != typeof t || c.greedy && "" === c.placeholder || (t = C().join("").length - t), t
				}

				var l;
				if (r === n) return t.setSelectionRange ? (r = t.selectionStart, o = t.selectionEnd) : e.getSelection ? (l = e.getSelection().getRangeAt(0)).commonAncestorContainer.parentNode !== t && l.commonAncestorContainer !== t || (r = l.startOffset, o = l.endOffset) : i.selection && i.selection.createRange && (o = (r = 0 - (l = i.selection.createRange()).duplicate().moveStart("character", -t.inputmask._valueGet().length)) + l.text.length), {
					begin: s(r),
					end: s(o)
				};
				if (r.begin !== n && (o = r.end, r = r.begin), "number" == typeof r) {
					r = s(r), o = "number" == typeof (o = s(o)) ? o : r;
					var h = parseInt(((t.ownerDocument.defaultView || e).getComputedStyle ? (t.ownerDocument.defaultView || e).getComputedStyle(t, null) : t.currentStyle).fontSize) * o;
					if (t.scrollLeft = h > t.scrollWidth ? h : 0, u || !1 !== c.insertMode || r !== o || o++, t.setSelectionRange) t.selectionStart = r, t.selectionEnd = o; else if (e.getSelection) {
						if (l = i.createRange(), t.firstChild === n || null === t.firstChild) {
							var d = i.createTextNode("");
							t.appendChild(d)
						}
						l.setStart(t.firstChild, r < t.inputmask._valueGet().length ? r : t.inputmask._valueGet().length), l.setEnd(t.firstChild, o < t.inputmask._valueGet().length ? o : t.inputmask._valueGet().length), l.collapse(!0);
						var p = e.getSelection();
						p.removeAllRanges(), p.addRange(l)
					} else t.createTextRange && ((l = t.createTextRange()).collapse(!0), l.moveEnd("character", o), l.moveStart("character", r), l.select());
					W(t, {begin: r, end: o})
				}
			}

			function $(e) {
				var i, r, o = C(), a = o.length, s = v(), l = {}, c = m().validPositions[s], u = c !== n ? c.locator.slice() : n;
				for (i = s + 1; i < o.length; i++) u = (r = w(i, u, i - 1)).locator.slice(), l[i] = t.extend(!0, {}, r);
				var h = c && c.alternation !== n ? c.locator[c.alternation] : n;
				for (i = a - 1; i > s && ((r = l[i]).match.optionality || r.match.optionalQuantifier && r.match.newBlockMarker || h && (h !== l[i].locator[c.alternation] && null != r.match.fn || null === r.match.fn && r.locator[c.alternation] && M(r.locator[c.alternation].toString().split(","), h.toString().split(",")) && "" !== _(i)[0].def)) && o[i] === F(i, r.match); i--) a--;
				return e ? {l: a, def: l[a] ? l[a].match : n} : a
			}

			function B(t) {
				for (var e, i = $(), r = t.length, o = m().validPositions[v()]; i < r && !A(i, !0) && (e = o !== n ? w(i, o.locator.slice(""), o) : x(i)) && !0 !== e.match.optionality && (!0 !== e.match.optionalQuantifier && !0 !== e.match.newBlockMarker || i + 1 === r && "" === (o !== n ? w(i + 1, o.locator.slice(""), o) : x(i + 1)).match.def);) i++;
				for (; (e = m().validPositions[i - 1]) && e && e.match.optionality && e.input === c.skipOptionalPartCharacter;) i--;
				return t.splice(i), t
			}

			function z(e) {
				if (t.isFunction(c.isComplete)) return c.isComplete(e, c);
				if ("*" === c.repeat) return n;
				var i = !1, r = $(!0), o = I(r.l);
				if (r.def === n || r.def.newBlockMarker || r.def.optionality || r.def.optionalQuantifier) {
					i = !0;
					for (var a = 0; a <= o; a++) {
						var s = w(a).match;
						if (null !== s.fn && m().validPositions[a] === n && !0 !== s.optionality && !0 !== s.optionalQuantifier || null === s.fn && e[a] !== F(a, s)) {
							i = !1;
							break
						}
					}
				}
				return i
			}

			function j(e, i, o, a, s) {
				if ((c.numericInput || Q) && (i === r.keyCode.BACKSPACE ? i = r.keyCode.DELETE : i === r.keyCode.DELETE && (i = r.keyCode.BACKSPACE), Q)) {
					var l = o.end;
					o.end = o.begin, o.begin = l
				}
				i === r.keyCode.BACKSPACE && (o.end - o.begin < 1 || !1 === c.insertMode) ? (o.begin = I(o.begin), m().validPositions[o.begin] !== n && m().validPositions[o.begin].input === c.groupSeparator && o.begin--) : i === r.keyCode.DELETE && o.begin === o.end && (o.end = A(o.end, !0) && m().validPositions[o.end] && m().validPositions[o.end].input !== c.radixPoint ? o.end + 1 : P(o.end) + 1, m().validPositions[o.begin] !== n && m().validPositions[o.begin].input === c.groupSeparator && o.end++), y(o.begin, o.end, !1, a), !0 !== a && function () {
					if (c.keepStatic) {
						for (var i = [], r = v(-1, !0), o = t.extend(!0, {}, m().validPositions), a = m().validPositions[r]; r >= 0; r--) {
							var s = m().validPositions[r];
							if (s) {
								if (!0 !== s.generatedInput && /[0-9a-bA-Z]/.test(s.input) && i.push(s.input), delete m().validPositions[r], s.alternation !== n && s.locator[s.alternation] !== a.locator[s.alternation]) break;
								a = s
							}
						}
						if (r > -1) for (m().p = P(v(-1, !0)); i.length > 0;) {
							var l = new t.Event("keypress");
							l.which = i.pop().charCodeAt(0), rt.keypressEvent.call(e, l, !0, !1, !1, m().p)
						} else m().validPositions = t.extend(!0, {}, o)
					}
				}();
				var u = v(o.begin, !0);
				if (u < o.begin) m().p = P(u); else if (!0 !== a && (m().p = o.begin, !0 !== s)) for (; m().p < u && m().validPositions[m().p] === n;) m().p++
			}

			function U(n) {
				var r = (n.ownerDocument.defaultView || e).getComputedStyle(n, null), o = i.createElement("div");
				o.style.width = r.width, o.style.textAlign = r.textAlign, (G = i.createElement("div")).className = "im-colormask", n.parentNode.insertBefore(G, n), n.parentNode.removeChild(n), G.appendChild(o), G.appendChild(n), n.style.left = o.offsetLeft + "px", t(n).on("click", function (t) {
					return H(n, function (t) {
						var e, o = i.createElement("span");
						for (var a in r) isNaN(a) && -1 !== a.indexOf("font") && (o.style[a] = r[a]);
						o.style.textTransform = r.textTransform, o.style.letterSpacing = r.letterSpacing, o.style.position = "absolute", o.style.height = "auto", o.style.width = "auto", o.style.visibility = "hidden", o.style.whiteSpace = "nowrap", i.body.appendChild(o);
						var s, l = n.inputmask._valueGet(), c = 0;
						for (e = 0, s = l.length; e <= s; e++) {
							if (o.innerHTML += l.charAt(e) || "_", o.offsetWidth >= t) {
								var u = t - c, h = o.offsetWidth - t;
								o.innerHTML = l.charAt(e), e = (u -= o.offsetWidth / 3) < h ? e - 1 : e;
								break
							}
							c = o.offsetWidth
						}
						return i.body.removeChild(o), e
					}(t.clientX)), rt.clickEvent.call(n, [t])
				}), t(n).on("keydown", function (t) {
					t.shiftKey || !1 === c.insertMode || setTimeout(function () {
						W(n)
					}, 0)
				})
			}

			function W(t, e, r) {
				function o() {
					d || null !== s.fn && l.input !== n ? d && (null !== s.fn && l.input !== n || "" === s.def) && (d = !1, h += "</span>") : (d = !0, h += "<span class='im-static'>")
				}

				function a(n) {
					!0 !== n && p !== e.begin || i.activeElement !== t || (h += "<span class='im-caret' style='border-right-width: 1px;border-right-style: solid;'></span>")
				}

				var s, l, u, h = "", d = !1, p = 0;
				if (G !== n) {
					var f = C();
					if (e === n ? e = H(t) : e.begin === n && (e = {begin: e, end: e}), !0 !== r) {
						var g = v();
						do {
							a(), m().validPositions[p] ? (l = m().validPositions[p], s = l.match, u = l.locator.slice(), o(), h += f[p]) : (l = w(p, u, p - 1), s = l.match, u = l.locator.slice(), (!1 === c.jitMasking || p < g || "number" == typeof c.jitMasking && isFinite(c.jitMasking) && c.jitMasking > p) && (o(), h += F(p, s))), p++
						} while ((q === n || p < q) && (null !== s.fn || "" !== s.def) || g > p || d);
						-1 === h.indexOf("im-caret") && a(!0), d && o()
					}
					var y = G.getElementsByTagName("div")[0];
					y.innerHTML = h, t.inputmask.positionColorMask(t, y)
				}
			}

			s = s || this.maskset, c = c || this.opts;
			var Y, V, q, G, K, X = this, Z = this.el, Q = this.isRTL, J = !1, tt = !1, et = !1, it = !1, nt = {
				on: function (e, i, o) {
					var a = function (e) {
						if (this.inputmask === n && "FORM" !== this.nodeName) {
							var i = t.data(this, "_inputmask_opts");
							i ? new r(i).mask(this) : nt.off(this)
						} else {
							if ("setvalue" === e.type || "FORM" === this.nodeName || !(this.disabled || this.readOnly && !("keydown" === e.type && e.ctrlKey && 67 === e.keyCode || !1 === c.tabThrough && e.keyCode === r.keyCode.TAB))) {
								switch (e.type) {
									case"input":
										if (!0 === tt) return tt = !1, e.preventDefault();
										break;
									case"keydown":
										J = !1, tt = !1;
										break;
									case"keypress":
										if (!0 === J) return e.preventDefault();
										J = !0;
										break;
									case"click":
										if (h || d) {
											var a = this, s = arguments;
											return setTimeout(function () {
												o.apply(a, s)
											}, 0), !1
										}
								}
								var l = o.apply(this, arguments);
								return !1 === l && (e.preventDefault(), e.stopPropagation()), l
							}
							e.preventDefault()
						}
					};
					e.inputmask.events[i] = e.inputmask.events[i] || [], e.inputmask.events[i].push(a), -1 !== t.inArray(i, ["submit", "reset"]) ? null !== e.form && t(e.form).on(i, a) : t(e).on(i, a)
				}, off: function (e, i) {
					var n;
					e.inputmask && e.inputmask.events && (i ? (n = [])[i] = e.inputmask.events[i] : n = e.inputmask.events, t.each(n, function (i, n) {
						for (; n.length > 0;) {
							var r = n.pop();
							-1 !== t.inArray(i, ["submit", "reset"]) ? null !== e.form && t(e.form).off(i, r) : t(e).off(i, r)
						}
						delete e.inputmask.events[i]
					}))
				}
			}, rt = {
				keydownEvent: function (e) {
					var n, o, a = this, s = t(a), l = e.keyCode, u = H(a);
					if (l === r.keyCode.BACKSPACE || l === r.keyCode.DELETE || d && l === r.keyCode.BACKSPACE_SAFARI || e.ctrlKey && l === r.keyCode.X && (n = i.createElement("input"), (o = "oncut" in n) || (n.setAttribute("oncut", "return;"), o = "function" == typeof n.oncut), n = null, !o)) e.preventDefault(), j(a, l, u), L(a, C(!0), m().p, e, a.inputmask._valueGet() !== C().join("")), a.inputmask._valueGet() === S().join("") ? s.trigger("cleared") : !0 === z(C()) && s.trigger("complete"); else if (l === r.keyCode.END || l === r.keyCode.PAGE_DOWN) {
						e.preventDefault();
						var h = P(v());
						c.insertMode || h !== m().maskLength || e.shiftKey || h--, H(a, e.shiftKey ? u.begin : h, h, !0)
					} else l === r.keyCode.HOME && !e.shiftKey || l === r.keyCode.PAGE_UP ? (e.preventDefault(), H(a, 0, e.shiftKey ? u.begin : 0, !0)) : (c.undoOnEscape && l === r.keyCode.ESCAPE || 90 === l && e.ctrlKey) && !0 !== e.altKey ? (N(a, !0, !1, Y.split("")), s.trigger("click")) : l !== r.keyCode.INSERT || e.shiftKey || e.ctrlKey ? !0 === c.tabThrough && l === r.keyCode.TAB ? (!0 === e.shiftKey ? (null === x(u.begin).match.fn && (u.begin = P(u.begin)), u.end = I(u.begin, !0), u.begin = I(u.end, !0)) : (u.begin = P(u.begin, !0), u.end = P(u.begin, !0), u.end < m().maskLength && u.end--), u.begin < m().maskLength && (e.preventDefault(), H(a, u.begin, u.end))) : e.shiftKey || !1 === c.insertMode && (l === r.keyCode.RIGHT ? setTimeout(function () {
						var t = H(a);
						H(a, t.begin)
					}, 0) : l === r.keyCode.LEFT && setTimeout(function () {
						var t = H(a);
						H(a, Q ? t.begin + 1 : t.begin - 1)
					}, 0)) : (c.insertMode = !c.insertMode, H(a, c.insertMode || u.begin !== m().maskLength ? u.begin : u.begin - 1));
					c.onKeyDown.call(this, e, C(), H(a).begin, c), et = -1 !== t.inArray(l, c.ignorables)
				}, keypressEvent: function (e, i, o, a, s) {
					var l = this, u = t(l), h = e.which || e.charCode || e.keyCode;
					if (!(!0 === i || e.ctrlKey && e.altKey) && (e.ctrlKey || e.metaKey || et)) return h === r.keyCode.ENTER && Y !== C().join("") && (Y = C().join(""), setTimeout(function () {
						u.trigger("change")
					}, 0)), !0;
					if (h) {
						46 === h && !1 === e.shiftKey && "" !== c.radixPoint && (h = c.radixPoint.charCodeAt(0));
						var d, p = i ? {begin: s, end: s} : H(l), f = String.fromCharCode(h);
						m().writeOutBuffer = !0;
						var v = E(p, f, a);
						if (!1 !== v && (g(!0), d = v.caret !== n ? v.caret : i ? v.pos + 1 : P(v.pos), m().p = d), !1 !== o && (setTimeout(function () {
							c.onKeyValidation.call(l, h, v, c)
						}, 0), m().writeOutBuffer && !1 !== v)) {
							var y = C();
							L(l, y, c.numericInput && v.caret === n ? I(d) : d, e, !0 !== i), !0 !== i && setTimeout(function () {
								!0 === z(y) && u.trigger("complete")
							}, 0)
						}
						if (e.preventDefault(), i) return !1 !== v && (v.forwardPosition = d), v
					}
				}, pasteEvent: function (i) {
					var n, r = i.originalEvent || i, o = t(this), a = this.inputmask._valueGet(!0), s = H(this);
					Q && (n = s.end, s.end = s.begin, s.begin = n);
					var l = a.substr(0, s.begin), u = a.substr(s.end, a.length);
					if (l === (Q ? S().reverse() : S()).slice(0, s.begin).join("") && (l = ""), u === (Q ? S().reverse() : S()).slice(s.end).join("") && (u = ""), Q && (n = l, l = u, u = n), e.clipboardData && e.clipboardData.getData) a = l + e.clipboardData.getData("Text") + u; else {
						if (!r.clipboardData || !r.clipboardData.getData) return !0;
						a = l + r.clipboardData.getData("text/plain") + u
					}
					var h = a;
					if (t.isFunction(c.onBeforePaste)) {
						if (!1 === (h = c.onBeforePaste.call(X, a, c))) return i.preventDefault();
						h || (h = a)
					}
					return N(this, !1, !1, Q ? h.split("").reverse() : h.toString().split("")), L(this, C(), P(v()), i, Y !== C().join("")), !0 === z(C()) && o.trigger("complete"), i.preventDefault()
				}, inputFallBackEvent: function (e) {
					var i = this, n = i.inputmask._valueGet();
					if (C().join("") !== n) {
						var o = H(i);
						if (!1 === function (e, i, n) {
							if ("." === i.charAt(n.begin - 1) && "" !== c.radixPoint && ((i = i.split(""))[n.begin - 1] = c.radixPoint.charAt(0), i = i.join("")), i.charAt(n.begin - 1) === c.radixPoint && i.length > C().length) {
								var r = new t.Event("keypress");
								return r.which = c.radixPoint.charCodeAt(0), rt.keypressEvent.call(e, r, !0, !0, !1, n.begin - 1), !1
							}
						}(i, n, o)) return !1;
						if (n = n.replace(new RegExp("(" + r.escapeRegex(S().join("")) + ")*"), ""), !1 === function (e, i, n) {
							if (h) {
								var r = i.replace(C().join(""), "");
								if (1 === r.length) {
									var o = new t.Event("keypress");
									return o.which = r.charCodeAt(0), rt.keypressEvent.call(e, o, !0, !0, !1, m().validPositions[n.begin - 1] ? n.begin : n.begin - 1), !1
								}
							}
						}(i, n, o)) return !1;
						o.begin > n.length && (H(i, n.length), o = H(i));
						var a = C().join(""), s = n.substr(0, o.begin), l = n.substr(o.begin), u = a.substr(0, o.begin), d = a.substr(o.begin), p = o, f = "", g = !1;
						if (s !== u) {
							p.begin = 0;
							for (var v = (g = s.length >= u.length) ? s.length : u.length, y = 0; s.charAt(y) === u.charAt(y) && y < v; y++) p.begin++;
							g && (f += s.slice(p.begin, p.end))
						}
						l !== d && (l.length > d.length ? g && (p.end = p.begin) : l.length < d.length ? p.end += d.length - l.length : l.charAt(0) !== d.charAt(0) && p.end++), L(i, C(), p), f.length > 0 ? t.each(f.split(""), function (e, n) {
							var r = new t.Event("keypress");
							r.which = n.charCodeAt(0), et = !1, rt.keypressEvent.call(i, r)
						}) : (p.begin === p.end - 1 && H(i, I(p.begin + 1), p.end), e.keyCode = r.keyCode.DELETE, rt.keydownEvent.call(i, e)), e.preventDefault()
					}
				}, setValueEvent: function (e) {
					this.inputmask.refreshValue = !1;
					var i = this.inputmask._valueGet(!0);
					t.isFunction(c.onBeforeMask) && (i = c.onBeforeMask.call(X, i, c) || i), i = i.split(""), N(this, !0, !1, Q ? i.reverse() : i), Y = C().join(""), (c.clearMaskOnLostFocus || c.clearIncomplete) && this.inputmask._valueGet() === S().join("") && this.inputmask._valueSet("")
				}, focusEvent: function (t) {
					var e = this.inputmask._valueGet();
					c.showMaskOnFocus && (!c.showMaskOnHover || c.showMaskOnHover && "" === e) && (this.inputmask._valueGet() !== C().join("") ? L(this, C(), P(v())) : !1 === it && H(this, P(v()))), !0 === c.positionCaretOnTab && !1 === it && "" !== e && (L(this, C(), H(this)), rt.clickEvent.apply(this, [t, !0])), Y = C().join("")
				}, mouseleaveEvent: function (t) {
					if (it = !1, c.clearMaskOnLostFocus && i.activeElement !== this) {
						var e = C().slice(), n = this.inputmask._valueGet();
						n !== this.getAttribute("placeholder") && "" !== n && (-1 === v() && n === S().join("") ? e = [] : B(e), L(this, e))
					}
				}, clickEvent: function (e, r) {
					var o = this;
					setTimeout(function () {
						if (i.activeElement === o) {
							var e = H(o);
							if (r && (Q ? e.end = e.begin : e.begin = e.end), e.begin === e.end) switch (c.positionCaretOnClick) {
								case"none":
									break;
								case"radixFocus":
									if (function (e) {
										if ("" !== c.radixPoint) {
											var i = m().validPositions;
											if (i[e] === n || i[e].input === F(e)) {
												if (e < P(-1)) return !0;
												var r = t.inArray(c.radixPoint, C());
												if (-1 !== r) {
													for (var o in i) if (r < o && i[o].input !== F(o)) return !1;
													return !0
												}
											}
										}
										return !1
									}(e.begin)) {
										var a = C().join("").indexOf(c.radixPoint);
										H(o, c.numericInput ? P(a) : a);
										break
									}
								default:
									var s = e.begin, l = v(s, !0), u = P(l);
									if (s < u) H(o, A(s, !0) || A(s - 1, !0) ? s : P(s)); else {
										var h = m().validPositions[l], d = w(u, h ? h.match.locator : n, h), p = F(u, d.match);
										if ("" !== p && C()[u] !== p && !0 !== d.match.optionalQuantifier && !0 !== d.match.newBlockMarker || !A(u, !0) && d.match.def === p) {
											var f = P(u);
											(s >= f || s === u) && (u = f)
										}
										H(o, u)
									}
							}
						}
					}, 0)
				}, dblclickEvent: function (t) {
					var e = this;
					setTimeout(function () {
						H(e, 0, P(v()))
					}, 0)
				}, cutEvent: function (n) {
					var o = t(this), a = H(this), s = n.originalEvent || n, l = e.clipboardData || s.clipboardData, c = Q ? C().slice(a.end, a.begin) : C().slice(a.begin, a.end);
					l.setData("text", Q ? c.reverse().join("") : c.join("")), i.execCommand && i.execCommand("copy"), j(this, r.keyCode.DELETE, a), L(this, C(), m().p, n, Y !== C().join("")), this.inputmask._valueGet() === S().join("") && o.trigger("cleared")
				}, blurEvent: function (e) {
					var i = t(this);
					if (this.inputmask) {
						var r = this.inputmask._valueGet(), o = C().slice();
						"" !== r && (c.clearMaskOnLostFocus && (-1 === v() && r === S().join("") ? o = [] : B(o)), !1 === z(o) && (setTimeout(function () {
							i.trigger("incomplete")
						}, 0), c.clearIncomplete && (g(), o = c.clearMaskOnLostFocus ? [] : S().slice())), L(this, o, n, e)), Y !== C().join("") && (Y = o.join(""), i.trigger("change"))
					}
				}, mouseenterEvent: function (t) {
					it = !0, i.activeElement !== this && c.showMaskOnHover && this.inputmask._valueGet() !== C().join("") && L(this, C())
				}, submitEvent: function (t) {
					Y !== C().join("") && V.trigger("change"), c.clearMaskOnLostFocus && -1 === v() && Z.inputmask._valueGet && Z.inputmask._valueGet() === S().join("") && Z.inputmask._valueSet(""), c.removeMaskOnSubmit && (Z.inputmask._valueSet(Z.inputmask.unmaskedvalue(), !0), setTimeout(function () {
						L(Z, C())
					}, 0))
				}, resetEvent: function (t) {
					Z.inputmask.refreshValue = !0, setTimeout(function () {
						V.trigger("setvalue")
					}, 0)
				}
			};
			if (r.prototype.positionColorMask = function (t, e) {
				t.style.left = e.offsetLeft + "px"
			}, o !== n) switch (o.action) {
				case"isComplete":
					return Z = o.el, z(C());
				case"unmaskedvalue":
					return Z !== n && o.value === n || (K = o.value, K = (t.isFunction(c.onBeforeMask) && c.onBeforeMask.call(X, K, c) || K).split(""), N(n, !1, !1, Q ? K.reverse() : K), t.isFunction(c.onBeforeWrite) && c.onBeforeWrite.call(X, n, C(), 0, c)), R(Z);
				case"mask":
					!function (e) {
						nt.off(e);
						var r = function (e, r) {
							var o = e.getAttribute("type"), s = "INPUT" === e.tagName && -1 !== t.inArray(o, r.supportsInputType) || e.isContentEditable || "TEXTAREA" === e.tagName;
							if (!s) if ("INPUT" === e.tagName) {
								var l = i.createElement("input");
								l.setAttribute("type", o), s = "text" === l.type, l = null
							} else s = "partial";
							return !1 !== s ? function (e) {
								function o() {
									return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : -1 !== v() || !0 !== r.nullable ? i.activeElement === this && r.clearMaskOnLostFocus ? (Q ? B(C().slice()).reverse() : B(C().slice())).join("") : l.call(this) : "" : l.call(this)
								}

								function s(e) {
									c.call(this, e), this.inputmask && t(this).trigger("setvalue")
								}

								var l, c;
								if (!e.inputmask.__valueGet) {
									if (!0 !== r.noValuePatching) {
										if (Object.getOwnPropertyDescriptor) {
											"function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" === a("test".__proto__) ? function (t) {
												return t.__proto__
											} : function (t) {
												return t.constructor.prototype
											});
											var u = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(e), "value") : n;
											u && u.get && u.set ? (l = u.get, c = u.set, Object.defineProperty(e, "value", {get: o, set: s, configurable: !0})) : "INPUT" !== e.tagName && (l = function () {
												return this.textContent
											}, c = function (t) {
												this.textContent = t
											}, Object.defineProperty(e, "value", {get: o, set: s, configurable: !0}))
										} else i.__lookupGetter__ && e.__lookupGetter__("value") && (l = e.__lookupGetter__("value"), c = e.__lookupSetter__("value"), e.__defineGetter__("value", o), e.__defineSetter__("value", s));
										e.inputmask.__valueGet = l, e.inputmask.__valueSet = c
									}
									e.inputmask._valueGet = function (t) {
										return Q && !0 !== t ? l.call(this.el).split("").reverse().join("") : l.call(this.el)
									}, e.inputmask._valueSet = function (t, e) {
										c.call(this.el, null === t || t === n ? "" : !0 !== e && Q ? t.split("").reverse().join("") : t)
									}, l === n && (l = function () {
										return this.value
									}, c = function (t) {
										this.value = t
									}, function (e) {
										if (t.valHooks && (t.valHooks[e] === n || !0 !== t.valHooks[e].inputmaskpatch)) {
											var i = t.valHooks[e] && t.valHooks[e].get ? t.valHooks[e].get : function (t) {
												return t.value
											}, o = t.valHooks[e] && t.valHooks[e].set ? t.valHooks[e].set : function (t, e) {
												return t.value = e, t
											};
											t.valHooks[e] = {
												get: function (t) {
													if (t.inputmask) {
														if (t.inputmask.opts.autoUnmask) return t.inputmask.unmaskedvalue();
														var e = i(t);
														return -1 !== v(n, n, t.inputmask.maskset.validPositions) || !0 !== r.nullable ? e : ""
													}
													return i(t)
												}, set: function (e, i) {
													var n, r = t(e);
													return n = o(e, i), e.inputmask && r.trigger("setvalue"), n
												}, inputmaskpatch: !0
											}
										}
									}(e.type), function (e) {
										nt.on(e, "mouseenter", function (e) {
											var i = t(this);
											this.inputmask._valueGet() !== C().join("") && i.trigger("setvalue")
										})
									}(e))
								}
							}(e) : e.inputmask = n, s
						}(e, c);
						if (!1 !== r && (V = t(Z = e), -1 === (q = Z !== n ? Z.maxLength : n) && (q = n), !0 === c.colorMask && U(Z), p && (Z.hasOwnProperty("inputmode") && (Z.inputmode = c.inputmode, Z.setAttribute("inputmode", c.inputmode)), "rtfm" === c.androidHack && (!0 !== c.colorMask && U(Z), Z.type = "password")), !0 === r && (nt.on(Z, "submit", rt.submitEvent), nt.on(Z, "reset", rt.resetEvent), nt.on(Z, "mouseenter", rt.mouseenterEvent), nt.on(Z, "blur", rt.blurEvent), nt.on(Z, "focus", rt.focusEvent), nt.on(Z, "mouseleave", rt.mouseleaveEvent), !0 !== c.colorMask && nt.on(Z, "click", rt.clickEvent), nt.on(Z, "dblclick", rt.dblclickEvent), nt.on(Z, "paste", rt.pasteEvent), nt.on(Z, "dragdrop", rt.pasteEvent), nt.on(Z, "drop", rt.pasteEvent), nt.on(Z, "cut", rt.cutEvent), nt.on(Z, "complete", c.oncomplete), nt.on(Z, "incomplete", c.onincomplete), nt.on(Z, "cleared", c.oncleared), p || !0 === c.inputEventOnly ? Z.removeAttribute("maxLength") : (nt.on(Z, "keydown", rt.keydownEvent), nt.on(Z, "keypress", rt.keypressEvent)), nt.on(Z, "compositionstart", t.noop), nt.on(Z, "compositionupdate", t.noop), nt.on(Z, "compositionend", t.noop), nt.on(Z, "keyup", t.noop), nt.on(Z, "input", rt.inputFallBackEvent), nt.on(Z, "beforeinput", t.noop)), nt.on(Z, "setvalue", rt.setValueEvent), Y = S().join(""), "" !== Z.inputmask._valueGet(!0) || !1 === c.clearMaskOnLostFocus || i.activeElement === Z)) {
							var o = t.isFunction(c.onBeforeMask) && c.onBeforeMask.call(X, Z.inputmask._valueGet(!0), c) || Z.inputmask._valueGet(!0);
							"" !== o && N(Z, !0, !1, Q ? o.split("").reverse() : o.split(""));
							var s = C().slice();
							Y = s.join(""), !1 === z(s) && c.clearIncomplete && g(), c.clearMaskOnLostFocus && i.activeElement !== Z && (-1 === v() ? s = [] : B(s)), L(Z, s), i.activeElement === Z && H(Z, P(v()))
						}
					}(Z);
					break;
				case"format":
					return K = (t.isFunction(c.onBeforeMask) && c.onBeforeMask.call(X, o.value, c) || o.value).split(""), N(n, !0, !1, Q ? K.reverse() : K), o.metadata ? {
						value: Q ? C().slice().reverse().join("") : C().join(""),
						metadata: l.call(this, {action: "getmetadata"}, s, c)
					} : Q ? C().slice().reverse().join("") : C().join("");
				case"isValid":
					o.value ? (K = o.value.split(""), N(n, !0, !0, Q ? K.reverse() : K)) : o.value = C().join("");
					for (var ot = C(), at = $(), st = ot.length - 1; st > at && !A(st); st--) ;
					return ot.splice(at, st + 1 - at), z(ot) && o.value === C().join("");
				case"getemptymask":
					return S().join("");
				case"remove":
					return Z && Z.inputmask && (V = t(Z), Z.inputmask._valueSet(c.autoUnmask ? R(Z) : Z.inputmask._valueGet(!0)), nt.off(Z), Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(Z), "value") && Z.inputmask.__valueGet && Object.defineProperty(Z, "value", {
						get: Z.inputmask.__valueGet,
						set: Z.inputmask.__valueSet,
						configurable: !0
					}) : i.__lookupGetter__ && Z.__lookupGetter__("value") && Z.inputmask.__valueGet && (Z.__defineGetter__("value", Z.inputmask.__valueGet), Z.__defineSetter__("value", Z.inputmask.__valueSet)), Z.inputmask = n), Z;
				case"getmetadata":
					if (t.isArray(s.metadata)) {
						var lt = f(!0, 0, !1).join("");
						return t.each(s.metadata, function (t, e) {
							if (e.mask === lt) return lt = e, !1
						}), lt
					}
					return s.metadata
			}
		}

		var c = navigator.userAgent, u = /mobile/i.test(c), h = /iemobile/i.test(c), d = /iphone/i.test(c) && !h, p = /android/i.test(c) && !h;
		return r.prototype = {
			dataAttribute: "data-inputmask", defaults: {
				placeholder: "_",
				optionalmarker: {start: "[", end: "]"},
				quantifiermarker: {start: "{", end: "}"},
				groupmarker: {start: "(", end: ")"},
				alternatormarker: "|",
				escapeChar: "\\",
				mask: null,
				regex: null,
				oncomplete: t.noop,
				onincomplete: t.noop,
				oncleared: t.noop,
				repeat: 0,
				greedy: !0,
				autoUnmask: !1,
				removeMaskOnSubmit: !1,
				clearMaskOnLostFocus: !0,
				insertMode: !0,
				clearIncomplete: !1,
				alias: null,
				onKeyDown: t.noop,
				onBeforeMask: null,
				onBeforePaste: function (e, i) {
					return t.isFunction(i.onBeforeMask) ? i.onBeforeMask.call(this, e, i) : e
				},
				onBeforeWrite: null,
				onUnMask: null,
				showMaskOnFocus: !0,
				showMaskOnHover: !0,
				onKeyValidation: t.noop,
				skipOptionalPartCharacter: " ",
				numericInput: !1,
				rightAlign: !1,
				undoOnEscape: !0,
				radixPoint: "",
				radixPointDefinitionSymbol: n,
				groupSeparator: "",
				keepStatic: null,
				positionCaretOnTab: !0,
				tabThrough: !1,
				supportsInputType: ["text", "tel", "password"],
				ignorables: [8, 9, 13, 19, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 0, 229],
				isComplete: null,
				canClearPosition: t.noop,
				preValidation: null,
				postValidation: null,
				staticDefinitionSymbol: n,
				jitMasking: !1,
				nullable: !0,
				inputEventOnly: !1,
				noValuePatching: !1,
				positionCaretOnClick: "lvp",
				casing: null,
				inputmode: "verbatim",
				colorMask: !1,
				androidHack: !1,
				importDataAttributes: !0
			}, definitions: {9: {validator: "[0-9１-９]", cardinality: 1, definitionSymbol: "*"}, a: {validator: "[A-Za-zА-яЁёÀ-ÿµ]", cardinality: 1, definitionSymbol: "*"}, "*": {validator: "[0-9１-９A-Za-zА-яЁёÀ-ÿµ]", cardinality: 1}}, aliases: {}, masksCache: {}, mask: function (a) {
				var c = this;
				return "string" == typeof a && (a = i.getElementById(a) || i.querySelectorAll(a)), a = a.nodeName ? [a] : a, t.each(a, function (i, a) {
					var u = t.extend(!0, {}, c.opts);
					!function (i, r, a, s) {
						if (!0 === r.importDataAttributes) {
							var l, c, u, h, d = function (t, r) {
								null !== (r = r !== n ? r : i.getAttribute(s + "-" + t)) && ("string" == typeof r && (0 === t.indexOf("on") ? r = e[r] : "false" === r ? r = !1 : "true" === r && (r = !0)), a[t] = r)
							}, p = i.getAttribute(s);
							if (p && "" !== p && (p = p.replace(new RegExp("'", "g"), '"'), c = JSON.parse("{" + p + "}")), c) for (h in u = n, c) if ("alias" === h.toLowerCase()) {
								u = c[h];
								break
							}
							for (l in d("alias", u), a.alias && o(a.alias, a, r), r) {
								if (c) for (h in u = n, c) if (h.toLowerCase() === l.toLowerCase()) {
									u = c[h];
									break
								}
								d(l, u)
							}
						}
						t.extend(!0, r, a), ("rtl" === i.dir || r.rightAlign) && (i.style.textAlign = "right"), ("rtl" === i.dir || r.numericInput) && (i.dir = "ltr", i.removeAttribute("dir"), r.isRTL = !0)
					}(a, u, t.extend(!0, {}, c.userOptions), c.dataAttribute);
					var h = s(u, c.noMasksCache);
					h !== n && (a.inputmask !== n && (a.inputmask.opts.autoUnmask = !0, a.inputmask.remove()), a.inputmask = new r(n, n, !0), a.inputmask.opts = u, a.inputmask.noMasksCache = c.noMasksCache, a.inputmask.userOptions = t.extend(!0, {}, c.userOptions), a.inputmask.isRTL = u.isRTL || u.numericInput, a.inputmask.el = a, a.inputmask.maskset = h, t.data(a, "_inputmask_opts", u), l.call(a.inputmask, {action: "mask"}))
				}), a && a[0] && a[0].inputmask || this
			}, option: function (e, i) {
				return "string" == typeof e ? this.opts[e] : "object" === (void 0 === e ? "undefined" : a(e)) ? (t.extend(this.userOptions, e), this.el && !0 !== i && this.mask(this.el), this) : void 0
			}, unmaskedvalue: function (t) {
				return this.maskset = this.maskset || s(this.opts, this.noMasksCache), l.call(this, {action: "unmaskedvalue", value: t})
			}, remove: function () {
				return l.call(this, {action: "remove"})
			}, getemptymask: function () {
				return this.maskset = this.maskset || s(this.opts, this.noMasksCache), l.call(this, {action: "getemptymask"})
			}, hasMaskedValue: function () {
				return !this.opts.autoUnmask
			}, isComplete: function () {
				return this.maskset = this.maskset || s(this.opts, this.noMasksCache), l.call(this, {action: "isComplete"})
			}, getmetadata: function () {
				return this.maskset = this.maskset || s(this.opts, this.noMasksCache), l.call(this, {action: "getmetadata"})
			}, isValid: function (t) {
				return this.maskset = this.maskset || s(this.opts, this.noMasksCache), l.call(this, {action: "isValid", value: t})
			}, format: function (t, e) {
				return this.maskset = this.maskset || s(this.opts, this.noMasksCache), l.call(this, {action: "format", value: t, metadata: e})
			}, analyseMask: function (e, i, o) {
				function a(t, e, i, n) {
					this.matches = [], this.openGroup = t || !1, this.alternatorGroup = !1, this.isGroup = t || !1, this.isOptional = e || !1, this.isQuantifier = i || !1, this.isAlternator = n || !1, this.quantifier = {min: 1, max: 1}
				}

				function s(e, a, s) {
					s = s !== n ? s : e.matches.length;
					var l = e.matches[s - 1];
					if (i) 0 === a.indexOf("[") || y && /\\d|\\s|\\w]/i.test(a) || "." === a ? e.matches.splice(s++, 0, {
						fn: new RegExp(a, o.casing ? "i" : ""),
						cardinality: 1,
						optionality: e.isOptional,
						newBlockMarker: l === n || l.def !== a,
						casing: null,
						def: a,
						placeholder: n,
						nativeDef: a
					}) : (y && (a = a[a.length - 1]), t.each(a.split(""), function (t, i) {
						l = e.matches[s - 1], e.matches.splice(s++, 0, {fn: null, cardinality: 0, optionality: e.isOptional, newBlockMarker: l === n || l.def !== i && null !== l.fn, casing: null, def: o.staticDefinitionSymbol || i, placeholder: o.staticDefinitionSymbol !== n ? i : n, nativeDef: i})
					})), y = !1; else {
						var c = (o.definitions ? o.definitions[a] : n) || r.prototype.definitions[a];
						if (c && !y) {
							for (var u = c.prevalidator, h = u ? u.length : 0, d = 1; d < c.cardinality; d++) {
								var p = h >= d ? u[d - 1] : [], f = p.validator, m = p.cardinality;
								e.matches.splice(s++, 0, {
									fn: f ? "string" == typeof f ? new RegExp(f, o.casing ? "i" : "") : new function () {
										this.test = f
									} : new RegExp("."), cardinality: m || 1, optionality: e.isOptional, newBlockMarker: l === n || l.def !== (c.definitionSymbol || a), casing: c.casing, def: c.definitionSymbol || a, placeholder: c.placeholder, nativeDef: a
								}), l = e.matches[s - 1]
							}
							e.matches.splice(s++, 0, {
								fn: c.validator ? "string" == typeof c.validator ? new RegExp(c.validator, o.casing ? "i" : "") : new function () {
									this.test = c.validator
								} : new RegExp("."), cardinality: c.cardinality, optionality: e.isOptional, newBlockMarker: l === n || l.def !== (c.definitionSymbol || a), casing: c.casing, def: c.definitionSymbol || a, placeholder: c.placeholder, nativeDef: a
							})
						} else e.matches.splice(s++, 0, {fn: null, cardinality: 0, optionality: e.isOptional, newBlockMarker: l === n || l.def !== a && null !== l.fn, casing: null, def: o.staticDefinitionSymbol || a, placeholder: o.staticDefinitionSymbol !== n ? a : n, nativeDef: a}), y = !1
					}
				}

				function l() {
					if (w.length > 0) {
						if (s(d = w[w.length - 1], u), d.isAlternator) {
							p = w.pop();
							for (var t = 0; t < p.matches.length; t++) p.matches[t].isGroup = !1;
							w.length > 0 ? (d = w[w.length - 1]).matches.push(p) : b.matches.push(p)
						}
					} else s(b, u)
				}

				var c, u, h, d, p, f, m, g = /(?:[?*+]|\{[0-9\+\*]+(?:,[0-9\+\*]*)?\})|[^.?*+^${[]()|\\]+|./g,
					v = /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g, y = !1, b = new a, w = [], x = [];
				for (i && (o.optionalmarker.start = n, o.optionalmarker.end = n); c = i ? v.exec(e) : g.exec(e);) {
					if (u = c[0], i) switch (u.charAt(0)) {
						case"?":
							u = "{0,1}";
							break;
						case"+":
						case"*":
							u = "{" + u + "}"
					}
					if (y) l(); else switch (u.charAt(0)) {
						case o.escapeChar:
							y = !0, i && l();
							break;
						case o.optionalmarker.end:
						case o.groupmarker.end:
							if ((h = w.pop()).openGroup = !1, h !== n) if (w.length > 0) {
								if ((d = w[w.length - 1]).matches.push(h), d.isAlternator) {
									p = w.pop();
									for (var k = 0; k < p.matches.length; k++) p.matches[k].isGroup = !1, p.matches[k].alternatorGroup = !1;
									w.length > 0 ? (d = w[w.length - 1]).matches.push(p) : b.matches.push(p)
								}
							} else b.matches.push(h); else l();
							break;
						case o.optionalmarker.start:
							w.push(new a(!1, !0));
							break;
						case o.groupmarker.start:
							w.push(new a(!0));
							break;
						case o.quantifiermarker.start:
							var _ = new a(!1, !1, !0), S = (u = u.replace(/[{}]/g, "")).split(","), C = isNaN(S[0]) ? S[0] : parseInt(S[0]), D = 1 === S.length ? C : isNaN(S[1]) ? S[1] : parseInt(S[1]);
							if ("*" !== D && "+" !== D || (C = "*" === D ? 0 : 1), _.quantifier = {min: C, max: D}, w.length > 0) {
								var T = w[w.length - 1].matches;
								(c = T.pop()).isGroup || ((m = new a(!0)).matches.push(c), c = m), T.push(c), T.push(_)
							} else (c = b.matches.pop()).isGroup || (i && null === c.fn && "." === c.def && (c.fn = new RegExp(c.def, o.casing ? "i" : "")), (m = new a(!0)).matches.push(c), c = m), b.matches.push(c), b.matches.push(_);
							break;
						case o.alternatormarker:
							if (w.length > 0) {
								var M = (d = w[w.length - 1]).matches[d.matches.length - 1];
								f = d.openGroup && (M.matches === n || !1 === M.isGroup && !1 === M.isAlternator) ? w.pop() : d.matches.pop()
							} else f = b.matches.pop();
							if (f.isAlternator) w.push(f); else if (f.alternatorGroup ? (p = w.pop(), f.alternatorGroup = !1) : p = new a(!1, !1, !1, !0), p.matches.push(f), w.push(p), f.openGroup) {
								f.openGroup = !1;
								var E = new a(!0);
								E.alternatorGroup = !0, w.push(E)
							}
							break;
						default:
							l()
					}
				}
				for (; w.length > 0;) h = w.pop(), b.matches.push(h);
				return b.matches.length > 0 && (function e(r) {
					r && r.matches && t.each(r.matches, function (t, a) {
						var l = r.matches[t + 1];
						(l === n || l.matches === n || !1 === l.isQuantifier) && a && a.isGroup && (a.isGroup = !1, i || (s(a, o.groupmarker.start, 0), !0 !== a.openGroup && s(a, o.groupmarker.end))), e(a)
					})
				}(b), x.push(b)), (o.numericInput || o.isRTL) && function t(e) {
					for (var i in e.matches = e.matches.reverse(), e.matches) if (e.matches.hasOwnProperty(i)) {
						var r = parseInt(i);
						if (e.matches[i].isQuantifier && e.matches[r + 1] && e.matches[r + 1].isGroup) {
							var a = e.matches[i];
							e.matches.splice(i, 1), e.matches.splice(r + 1, 0, a)
						}
						e.matches[i].matches !== n ? e.matches[i] = t(e.matches[i]) : e.matches[i] = ((s = e.matches[i]) === o.optionalmarker.start ? s = o.optionalmarker.end : s === o.optionalmarker.end ? s = o.optionalmarker.start : s === o.groupmarker.start ? s = o.groupmarker.end : s === o.groupmarker.end && (s = o.groupmarker.start), s)
					}
					var s;
					return e
				}(x[0]), x
			}
		}, r.extendDefaults = function (e) {
			t.extend(!0, r.prototype.defaults, e)
		}, r.extendDefinitions = function (e) {
			t.extend(!0, r.prototype.definitions, e)
		}, r.extendAliases = function (e) {
			t.extend(!0, r.prototype.aliases, e)
		}, r.format = function (t, e, i) {
			return r(e).format(t, i)
		}, r.unmask = function (t, e) {
			return r(e).unmaskedvalue(t)
		}, r.isValid = function (t, e) {
			return r(e).isValid(t)
		}, r.remove = function (e) {
			t.each(e, function (t, e) {
				e.inputmask && e.inputmask.remove()
			})
		}, r.escapeRegex = function (t) {
			return t.replace(new RegExp("(\\" + ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^"].join("|\\") + ")", "gim"), "\\$1")
		}, r.keyCode = {
			ALT: 18,
			BACKSPACE: 8,
			BACKSPACE_SAFARI: 127,
			CAPS_LOCK: 20,
			COMMA: 188,
			COMMAND: 91,
			COMMAND_LEFT: 91,
			COMMAND_RIGHT: 93,
			CONTROL: 17,
			DELETE: 46,
			DOWN: 40,
			END: 35,
			ENTER: 13,
			ESCAPE: 27,
			HOME: 36,
			INSERT: 45,
			LEFT: 37,
			MENU: 93,
			NUMPAD_ADD: 107,
			NUMPAD_DECIMAL: 110,
			NUMPAD_DIVIDE: 111,
			NUMPAD_ENTER: 108,
			NUMPAD_MULTIPLY: 106,
			NUMPAD_SUBTRACT: 109,
			PAGE_DOWN: 34,
			PAGE_UP: 33,
			PERIOD: 190,
			RIGHT: 39,
			SHIFT: 16,
			SPACE: 32,
			TAB: 9,
			UP: 38,
			WINDOWS: 91,
			X: 88
		}, r
	}) ? n.apply(e, r) : n) && (t.exports = o)
}, function (t, e) {
	t.exports = jQuery
}, function (t, e, i) {
	"use strict";

	function n(t) {
		return t && t.__esModule ? t : {default: t}
	}

	i(4), i(9), i(12), i(13), i(14), i(15);
	var r = n(i(1)), o = n(i(0)), a = n(i(2));
	o.default === a.default && i(16), window.Inputmask = r.default
}, function (t, e, i) {
	var n = i(5);
	"string" == typeof n && (n = [[t.i, n, ""]]);
	var r = {hmr: !0, transform: void 0};
	i(7)(n, r), n.locals && (t.exports = n.locals)
}, function (t, e, i) {
	(t.exports = i(6)(void 0)).push([t.i, "span.im-caret {\r\n    -webkit-animation: 1s blink step-end infinite;\r\n    animation: 1s blink step-end infinite;\r\n}\r\n\r\n@keyframes blink {\r\n    from, to {\r\n        border-right-color: black;\r\n    }\r\n    50% {\r\n        border-right-color: transparent;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes blink {\r\n    from, to {\r\n        border-right-color: black;\r\n    }\r\n    50% {\r\n        border-right-color: transparent;\r\n    }\r\n}\r\n\r\nspan.im-static {\r\n    color: grey;\r\n}\r\n\r\ndiv.im-colormask {\r\n    display: inline-block;\r\n    border-style: inset;\r\n    border-width: 2px;\r\n    -webkit-appearance: textfield;\r\n    -moz-appearance: textfield;\r\n    appearance: textfield;\r\n}\r\n\r\ndiv.im-colormask > input {\r\n    position: absolute;\r\n    display: inline-block;\r\n    background-color: transparent;\r\n    color: transparent;\r\n    -webkit-appearance: caret;\r\n    -moz-appearance: caret;\r\n    appearance: caret;\r\n    border-style: none;\r\n    left: 0; /*calculated*/\r\n}\r\n\r\ndiv.im-colormask > input:focus {\r\n    outline: none;\r\n}\r\n\r\ndiv.im-colormask > input::-moz-selection{\r\n    background: none;\r\n}\r\n\r\ndiv.im-colormask > input::selection{\r\n    background: none;\r\n}\r\ndiv.im-colormask > input::-moz-selection{\r\n    background: none;\r\n}\r\n\r\ndiv.im-colormask > div {\r\n    color: black;\r\n    display: inline-block;\r\n    width: 100px; /*calculated*/\r\n}", ""])
}, function (t, e) {
	function i(t, e) {
		var i, n = t[1] || "", r = t[3];
		if (!r) return n;
		if (e && "function" == typeof btoa) {
			var o = (i = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */"), a = r.sources.map(function (t) {
				return "/*# sourceURL=" + r.sourceRoot + t + " */"
			});
			return [n].concat(a).concat([o]).join("\n")
		}
		return [n].join("\n")
	}

	t.exports = function (t) {
		var e = [];
		return e.toString = function () {
			return this.map(function (e) {
				var n = i(e, t);
				return e[2] ? "@media " + e[2] + "{" + n + "}" : n
			}).join("")
		}, e.i = function (t, i) {
			"string" == typeof t && (t = [[null, t, ""]]);
			for (var n = {}, r = 0; r < this.length; r++) {
				var o = this[r][0];
				"number" == typeof o && (n[o] = !0)
			}
			for (r = 0; r < t.length; r++) {
				var a = t[r];
				"number" == typeof a[0] && n[a[0]] || (i && !a[2] ? a[2] = i : i && (a[2] = "(" + a[2] + ") and (" + i + ")"), e.push(a))
			}
		}, e
	}
}, function (t, e, i) {
	function n(t, e) {
		for (var i = 0; i < t.length; i++) {
			var n = t[i], r = d[n.id];
			if (r) {
				for (r.refs++, a = 0; a < r.parts.length; a++) r.parts[a](n.parts[a]);
				for (; a < n.parts.length; a++) r.parts.push(c(n.parts[a], e))
			} else {
				for (var o = [], a = 0; a < n.parts.length; a++) o.push(c(n.parts[a], e));
				d[n.id] = {id: n.id, refs: 1, parts: o}
			}
		}
	}

	function r(t, e) {
		for (var i = [], n = {}, r = 0; r < t.length; r++) {
			var o = t[r], a = e.base ? o[0] + e.base : o[0], s = {css: o[1], media: o[2], sourceMap: o[3]};
			n[a] ? n[a].parts.push(s) : i.push(n[a] = {id: a, parts: [s]})
		}
		return i
	}

	function o(t, e) {
		var i = f(t.insertInto);
		if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
		var n = v[v.length - 1];
		if ("top" === t.insertAt) n ? n.nextSibling ? i.insertBefore(e, n.nextSibling) : i.appendChild(e) : i.insertBefore(e, i.firstChild), v.push(e); else if ("bottom" === t.insertAt) i.appendChild(e); else {
			if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
			var r = f(t.insertInto + " " + t.insertAt.before);
			i.insertBefore(e, r)
		}
	}

	function a(t) {
		if (null === t.parentNode) return !1;
		t.parentNode.removeChild(t);
		var e = v.indexOf(t);
		e >= 0 && v.splice(e, 1)
	}

	function s(t) {
		var e = document.createElement("style");
		return t.attrs.type = "text/css", l(e, t.attrs), o(t, e), e
	}

	function l(t, e) {
		Object.keys(e).forEach(function (i) {
			t.setAttribute(i, e[i])
		})
	}

	function c(t, e) {
		var i, n, r, c;
		if (e.transform && t.css) {
			if (!(c = e.transform(t.css))) return function () {
			};
			t.css = c
		}
		if (e.singleton) {
			var h = g++;
			i = m || (m = s(e)), n = u.bind(null, i, h, !1), r = u.bind(null, i, h, !0)
		} else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (i = function (t) {
			var e = document.createElement("link");
			return t.attrs.type = "text/css", t.attrs.rel = "stylesheet", l(e, t.attrs), o(t, e), e
		}(e), n = function (t, e, i) {
			var n = i.css, r = i.sourceMap, o = void 0 === e.convertToAbsoluteUrls && r;
			(e.convertToAbsoluteUrls || o) && (n = y(n)), r && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
			var a = new Blob([n], {type: "text/css"}), s = t.href;
			t.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s)
		}.bind(null, i, e), r = function () {
			a(i), i.href && URL.revokeObjectURL(i.href)
		}) : (i = s(e), n = function (t, e) {
			var i = e.css, n = e.media;
			if (n && t.setAttribute("media", n), t.styleSheet) t.styleSheet.cssText = i; else {
				for (; t.firstChild;) t.removeChild(t.firstChild);
				t.appendChild(document.createTextNode(i))
			}
		}.bind(null, i), r = function () {
			a(i)
		});
		return n(t), function (e) {
			if (e) {
				if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
				n(t = e)
			} else r()
		}
	}

	function u(t, e, i, n) {
		var r = i ? "" : n.css;
		if (t.styleSheet) t.styleSheet.cssText = w(e, r); else {
			var o = document.createTextNode(r), a = t.childNodes;
			a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(o, a[e]) : t.appendChild(o)
		}
	}

	var h, d = {}, p = function () {
		return void 0 === h && (h = function () {
			return window && document && document.all && !window.atob
		}.apply(this, arguments)), h
	}, f = function (t) {
		var e = {};
		return function (t) {
			if (void 0 === e[t]) {
				var i = function (t) {
					return document.querySelector(t)
				}.call(this, t);
				if (i instanceof window.HTMLIFrameElement) try {
					i = i.contentDocument.head
				} catch (t) {
					i = null
				}
				e[t] = i
			}
			return e[t]
		}
	}(), m = null, g = 0, v = [], y = i(8);
	t.exports = function (t, e) {
		if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
		(e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || (e.singleton = p()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
		var i = r(t, e);
		return n(i, e), function (t) {
			for (var o = [], a = 0; a < i.length; a++) {
				var s = i[a];
				(l = d[s.id]).refs--, o.push(l)
			}
			for (t && n(r(t, e), e), a = 0; a < o.length; a++) {
				var l = o[a];
				if (0 === l.refs) {
					for (var c = 0; c < l.parts.length; c++) l.parts[c]();
					delete d[l.id]
				}
			}
		}
	};
	var b, w = (b = [], function (t, e) {
		return b[t] = e, b.filter(Boolean).join("\n")
	})
}, function (t, e) {
	t.exports = function (t) {
		var e = "undefined" != typeof window && window.location;
		if (!e) throw new Error("fixUrls requires window.location");
		if (!t || "string" != typeof t) return t;
		var i = e.protocol + "//" + e.host, n = i + e.pathname.replace(/\/[^\/]*$/, "/");
		return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
			var r, o = e.trim().replace(/^"(.*)"$/, function (t, e) {
				return e
			}).replace(/^'(.*)'$/, function (t, e) {
				return e
			});
			return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(o) ? t : (r = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? i + o : n + o.replace(/^\.\//, ""), "url(" + JSON.stringify(r) + ")")
		})
	}
}, function (t, e, i) {
	"use strict";
	var n, r, o;
	"function" == typeof Symbol && Symbol.iterator, r = [i(0), i(1)], void 0 !== (o = "function" == typeof (n = function (t, e) {
		return e.extendAliases({
			"dd/mm/yyyy": {
				mask: "1/2/y", placeholder: "dd/mm/yyyy", regex: {
					val1pre: new RegExp("[0-3]"), val1: new RegExp("0[1-9]|[12][0-9]|3[01]"), val2pre: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[1-9]|[12][0-9]|3[01])" + i + "[01])")
					}, val2: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[1-9]|[12][0-9])" + i + "(0[1-9]|1[012]))|(30" + i + "(0[13-9]|1[012]))|(31" + i + "(0[13578]|1[02]))")
					}
				}, leapday: "29/02/", separator: "/", yearrange: {minyear: 1900, maxyear: 2099}, isInYearRange: function (t, e, i) {
					if (isNaN(t)) return !1;
					var n = parseInt(t.concat(e.toString().slice(t.length))), r = parseInt(t.concat(i.toString().slice(t.length)));
					return !isNaN(n) && e <= n && n <= i || !isNaN(r) && e <= r && r <= i
				}, determinebaseyear: function (t, e, i) {
					var n = (new Date).getFullYear();
					if (t > n) return t;
					if (e < n) {
						for (var r = e.toString().slice(0, 2), o = e.toString().slice(2, 4); e < r + i;) r--;
						var a = r + o;
						return t > a ? t : a
					}
					if (t <= n && n <= e) {
						for (var s = n.toString().slice(0, 2); e < s + i;) s--;
						var l = s + i;
						return l < t ? t : l
					}
					return n
				}, onKeyDown: function (i, n, r, o) {
					var a = t(this);
					if (i.ctrlKey && i.keyCode === e.keyCode.RIGHT) {
						var s = new Date;
						a.val(s.getDate().toString() + (s.getMonth() + 1).toString() + s.getFullYear().toString()), a.trigger("setvalue")
					}
				}, getFrontValue: function (t, e, i) {
					for (var n = 0, r = 0, o = 0; o < t.length && "2" !== t.charAt(o); o++) {
						var a = i.definitions[t.charAt(o)];
						a ? (n += r, r = a.cardinality) : r++
					}
					return e.join("").substr(n, r)
				}, postValidation: function (t, e, i) {
					var n, r, o = t.join("");
					return 0 === i.mask.indexOf("y") ? (r = o.substr(0, 4), n = o.substring(4, 10)) : (r = o.substring(6, 10), n = o.substr(0, 6)), e && (n !== i.leapday || function (t) {
						return isNaN(t) || 29 === new Date(t, 2, 0).getDate()
					}(r))
				}, definitions: {
					1: {
						validator: function (t, e, i, n, r) {
							var o = r.regex.val1.test(t);
							return n || o || t.charAt(1) !== r.separator && -1 === "-./".indexOf(t.charAt(1)) || !(o = r.regex.val1.test("0" + t.charAt(0))) ? o : (e.buffer[i - 1] = "0", {refreshFromBuffer: {start: i - 1, end: i}, pos: i, c: t.charAt(0)})
						}, cardinality: 2, prevalidator: [{
							validator: function (t, e, i, n, r) {
								var o = t;
								isNaN(e.buffer[i + 1]) || (o += e.buffer[i + 1]);
								var a = 1 === o.length ? r.regex.val1pre.test(o) : r.regex.val1.test(o);
								if (a && e.validPositions[i] && (r.regex.val2(r.separator).test(t + e.validPositions[i].input) || (e.validPositions[i].input = "0" === t ? "1" : "0")), !n && !a) {
									if (a = r.regex.val1.test(t + "0")) return e.buffer[i] = t, e.buffer[++i] = "0", {pos: i, c: "0"};
									if (a = r.regex.val1.test("0" + t)) return e.buffer[i] = "0", {pos: ++i}
								}
								return a
							}, cardinality: 1
						}]
					}, 2: {
						validator: function (t, e, i, n, r) {
							var o = r.getFrontValue(e.mask, e.buffer, r);
							-1 !== o.indexOf(r.placeholder[0]) && (o = "01" + r.separator);
							var a = r.regex.val2(r.separator).test(o + t);
							return n || a || t.charAt(1) !== r.separator && -1 === "-./".indexOf(t.charAt(1)) || !(a = r.regex.val2(r.separator).test(o + "0" + t.charAt(0))) ? a : (e.buffer[i - 1] = "0", {refreshFromBuffer: {start: i - 1, end: i}, pos: i, c: t.charAt(0)})
						}, cardinality: 2, prevalidator: [{
							validator: function (t, e, i, n, r) {
								isNaN(e.buffer[i + 1]) || (t += e.buffer[i + 1]);
								var o = r.getFrontValue(e.mask, e.buffer, r);
								-1 !== o.indexOf(r.placeholder[0]) && (o = "01" + r.separator);
								var a = 1 === t.length ? r.regex.val2pre(r.separator).test(o + t) : r.regex.val2(r.separator).test(o + t);
								return a && e.validPositions[i] && (r.regex.val2(r.separator).test(t + e.validPositions[i].input) || (e.validPositions[i].input = "0" === t ? "1" : "0")), n || a || !(a = r.regex.val2(r.separator).test(o + "0" + t)) ? a : (e.buffer[i] = "0", {pos: ++i})
							}, cardinality: 1
						}]
					}, y: {
						validator: function (t, e, i, n, r) {
							return r.isInYearRange(t, r.yearrange.minyear, r.yearrange.maxyear)
						}, cardinality: 4, prevalidator: [{
							validator: function (t, e, i, n, r) {
								var o = r.isInYearRange(t, r.yearrange.minyear, r.yearrange.maxyear);
								if (!n && !o) {
									var a = r.determinebaseyear(r.yearrange.minyear, r.yearrange.maxyear, t + "0").toString().slice(0, 1);
									if (o = r.isInYearRange(a + t, r.yearrange.minyear, r.yearrange.maxyear)) return e.buffer[i++] = a.charAt(0), {pos: i};
									if (a = r.determinebaseyear(r.yearrange.minyear, r.yearrange.maxyear, t + "0").toString().slice(0, 2), o = r.isInYearRange(a + t, r.yearrange.minyear, r.yearrange.maxyear)) return e.buffer[i++] = a.charAt(0), e.buffer[i++] = a.charAt(1), {pos: i}
								}
								return o
							}, cardinality: 1
						}, {
							validator: function (t, e, i, n, r) {
								var o = r.isInYearRange(t, r.yearrange.minyear, r.yearrange.maxyear);
								if (!n && !o) {
									var a = r.determinebaseyear(r.yearrange.minyear, r.yearrange.maxyear, t).toString().slice(0, 2);
									if (o = r.isInYearRange(t[0] + a[1] + t[1], r.yearrange.minyear, r.yearrange.maxyear)) return e.buffer[i++] = a.charAt(1), {pos: i};
									if (a = r.determinebaseyear(r.yearrange.minyear, r.yearrange.maxyear, t).toString().slice(0, 2), o = r.isInYearRange(a + t, r.yearrange.minyear, r.yearrange.maxyear)) return e.buffer[i - 1] = a.charAt(0), e.buffer[i++] = a.charAt(1), e.buffer[i++] = t.charAt(0), {
										refreshFromBuffer: {
											start: i - 3,
											end: i
										}, pos: i
									}
								}
								return o
							}, cardinality: 2
						}, {
							validator: function (t, e, i, n, r) {
								return r.isInYearRange(t, r.yearrange.minyear, r.yearrange.maxyear)
							}, cardinality: 3
						}]
					}
				}, insertMode: !1, autoUnmask: !1
			},
			"mm/dd/yyyy": {
				placeholder: "mm/dd/yyyy", alias: "dd/mm/yyyy", regex: {
					val2pre: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[13-9]|1[012])" + i + "[0-3])|(02" + i + "[0-2])")
					}, val2: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[1-9]|1[012])" + i + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + i + "30)|((0[13578]|1[02])" + i + "31)")
					}, val1pre: new RegExp("[01]"), val1: new RegExp("0[1-9]|1[012]")
				}, leapday: "02/29/", onKeyDown: function (i, n, r, o) {
					var a = t(this);
					if (i.ctrlKey && i.keyCode === e.keyCode.RIGHT) {
						var s = new Date;
						a.val((s.getMonth() + 1).toString() + s.getDate().toString() + s.getFullYear().toString()), a.trigger("setvalue")
					}
				}
			},
			"yyyy/mm/dd": {
				mask: "y/1/2", placeholder: "yyyy/mm/dd", alias: "mm/dd/yyyy", leapday: "/02/29", onKeyDown: function (i, n, r, o) {
					var a = t(this);
					if (i.ctrlKey && i.keyCode === e.keyCode.RIGHT) {
						var s = new Date;
						a.val(s.getFullYear().toString() + (s.getMonth() + 1).toString() + s.getDate().toString()), a.trigger("setvalue")
					}
				}
			},
			"dd.mm.yyyy": {mask: "1.2.y", placeholder: "dd.mm.yyyy", leapday: "29.02.", separator: ".", alias: "dd/mm/yyyy"},
			"dd-mm-yyyy": {mask: "1-2-y", placeholder: "dd-mm-yyyy", leapday: "29-02-", separator: "-", alias: "dd/mm/yyyy"},
			"mm.dd.yyyy": {mask: "1.2.y", placeholder: "mm.dd.yyyy", leapday: "02.29.", separator: ".", alias: "mm/dd/yyyy"},
			"mm-dd-yyyy": {mask: "1-2-y", placeholder: "mm-dd-yyyy", leapday: "02-29-", separator: "-", alias: "mm/dd/yyyy"},
			"yyyy.mm.dd": {mask: "y.1.2", placeholder: "yyyy.mm.dd", leapday: ".02.29", separator: ".", alias: "yyyy/mm/dd"},
			"yyyy-mm-dd": {mask: "y-1-2", placeholder: "yyyy-mm-dd", leapday: "-02-29", separator: "-", alias: "yyyy/mm/dd"},
			datetime: {
				mask: "1/2/y h:s",
				placeholder: "dd/mm/yyyy hh:mm",
				alias: "dd/mm/yyyy",
				regex: {hrspre: new RegExp("[012]"), hrs24: new RegExp("2[0-4]|1[3-9]"), hrs: new RegExp("[01][0-9]|2[0-4]"), ampm: new RegExp("^[a|p|A|P][m|M]"), mspre: new RegExp("[0-5]"), ms: new RegExp("[0-5][0-9]")},
				timeseparator: ":",
				hourFormat: "24",
				definitions: {
					h: {
						validator: function (t, e, i, n, r) {
							if ("24" === r.hourFormat && 24 === parseInt(t, 10)) return e.buffer[i - 1] = "0", e.buffer[i] = "0", {refreshFromBuffer: {start: i - 1, end: i}, c: "0"};
							var o = r.regex.hrs.test(t);
							if (!n && !o && (t.charAt(1) === r.timeseparator || -1 !== "-.:".indexOf(t.charAt(1))) && (o = r.regex.hrs.test("0" + t.charAt(0)))) return e.buffer[i - 1] = "0", e.buffer[i] = t.charAt(0), {refreshFromBuffer: {start: ++i - 2, end: i}, pos: i, c: r.timeseparator};
							if (o && "24" !== r.hourFormat && r.regex.hrs24.test(t)) {
								var a = parseInt(t, 10);
								return 24 === a ? (e.buffer[i + 5] = "a", e.buffer[i + 6] = "m") : (e.buffer[i + 5] = "p", e.buffer[i + 6] = "m"), (a -= 12) < 10 ? (e.buffer[i] = a.toString(), e.buffer[i - 1] = "0") : (e.buffer[i] = a.toString().charAt(1), e.buffer[i - 1] = a.toString().charAt(0)), {
									refreshFromBuffer: {
										start: i - 1,
										end: i + 6
									}, c: e.buffer[i]
								}
							}
							return o
						}, cardinality: 2, prevalidator: [{
							validator: function (t, e, i, n, r) {
								var o = r.regex.hrspre.test(t);
								return n || o || !(o = r.regex.hrs.test("0" + t)) ? o : (e.buffer[i] = "0", {pos: ++i})
							}, cardinality: 1
						}]
					}, s: {
						validator: "[0-5][0-9]", cardinality: 2, prevalidator: [{
							validator: function (t, e, i, n, r) {
								var o = r.regex.mspre.test(t);
								return n || o || !(o = r.regex.ms.test("0" + t)) ? o : (e.buffer[i] = "0", {pos: ++i})
							}, cardinality: 1
						}]
					}, t: {
						validator: function (t, e, i, n, r) {
							return r.regex.ampm.test(t + "m")
						}, casing: "lower", cardinality: 1
					}
				},
				insertMode: !1,
				autoUnmask: !1
			},
			datetime12: {mask: "1/2/y h:s t\\m", placeholder: "dd/mm/yyyy hh:mm xm", alias: "datetime", hourFormat: "12"},
			"mm/dd/yyyy hh:mm xm": {
				mask: "1/2/y h:s t\\m", placeholder: "mm/dd/yyyy hh:mm xm", alias: "datetime12", regex: {
					val2pre: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[13-9]|1[012])" + i + "[0-3])|(02" + i + "[0-2])")
					}, val2: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[1-9]|1[012])" + i + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + i + "30)|((0[13578]|1[02])" + i + "31)")
					}, val1pre: new RegExp("[01]"), val1: new RegExp("0[1-9]|1[012]")
				}, leapday: "02/29/", onKeyDown: function (i, n, r, o) {
					var a = t(this);
					if (i.ctrlKey && i.keyCode === e.keyCode.RIGHT) {
						var s = new Date;
						a.val((s.getMonth() + 1).toString() + s.getDate().toString() + s.getFullYear().toString()), a.trigger("setvalue")
					}
				}
			},
			"hh:mm t": {mask: "h:s t\\m", placeholder: "hh:mm xm", alias: "datetime", hourFormat: "12"},
			"h:s t": {mask: "h:s t\\m", placeholder: "hh:mm xm", alias: "datetime", hourFormat: "12"},
			"hh:mm:ss": {mask: "h:s:s", placeholder: "hh:mm:ss", alias: "datetime", autoUnmask: !1},
			"hh:mm": {mask: "h:s", placeholder: "hh:mm", alias: "datetime", autoUnmask: !1},
			date: {alias: "dd/mm/yyyy"},
			"mm/yyyy": {mask: "1/y", placeholder: "mm/yyyy", leapday: "donotuse", separator: "/", alias: "mm/dd/yyyy"},
			shamsi: {
				regex: {
					val2pre: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[1-9]|1[012])" + i + "[0-3])")
					}, val2: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[1-9]|1[012])" + i + "(0[1-9]|[12][0-9]))|((0[1-9]|1[012])" + i + "30)|((0[1-6])" + i + "31)")
					}, val1pre: new RegExp("[01]"), val1: new RegExp("0[1-9]|1[012]")
				}, yearrange: {minyear: 1300, maxyear: 1499}, mask: "y/1/2", leapday: "/12/30", placeholder: "yyyy/mm/dd", alias: "mm/dd/yyyy", clearIncomplete: !0
			},
			"yyyy-mm-dd hh:mm:ss": {
				mask: "y-1-2 h:s:s", placeholder: "yyyy-mm-dd hh:mm:ss", alias: "datetime", separator: "-", leapday: "-02-29", regex: {
					val2pre: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[13-9]|1[012])" + i + "[0-3])|(02" + i + "[0-2])")
					}, val2: function (t) {
						var i = e.escapeRegex.call(this, t);
						return new RegExp("((0[1-9]|1[012])" + i + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + i + "30)|((0[13578]|1[02])" + i + "31)")
					}, val1pre: new RegExp("[01]"), val1: new RegExp("0[1-9]|1[012]")
				}, onKeyDown: function (t, e, i, n) {
				}
			}
		}), e
	}) ? n.apply(e, r) : n) && (t.exports = o)
}, function (t, e, i) {
	"use strict";
	var n;
	"function" == typeof Symbol && Symbol.iterator, void 0 !== (n = function () {
		return window
	}.call(e, i, e, t)) && (t.exports = n)
}, function (t, e, i) {
	"use strict";
	var n;
	"function" == typeof Symbol && Symbol.iterator, void 0 !== (n = function () {
		return document
	}.call(e, i, e, t)) && (t.exports = n)
}, function (t, e, i) {
	"use strict";
	var n, r, o;
	"function" == typeof Symbol && Symbol.iterator, r = [i(0), i(1)], void 0 !== (o = "function" == typeof (n = function (t, e) {
		return e.extendDefinitions({A: {validator: "[A-Za-zА-яЁёÀ-ÿµ]", cardinality: 1, casing: "upper"}, "&": {validator: "[0-9A-Za-zА-яЁёÀ-ÿµ]", cardinality: 1, casing: "upper"}, "#": {validator: "[0-9A-Fa-f]", cardinality: 1, casing: "upper"}}), e.extendAliases({
			url: {definitions: {i: {validator: ".", cardinality: 1}}, mask: "(\\http://)|(\\http\\s://)|(ftp://)|(ftp\\s://)i{+}", insertMode: !1, autoUnmask: !1, inputmode: "url"}, ip: {
				mask: "i[i[i]].i[i[i]].i[i[i]].i[i[i]]", definitions: {
					i: {
						validator: function (t, e, i, n, r) {
							return i - 1 > -1 && "." !== e.buffer[i - 1] ? (t = e.buffer[i - 1] + t, t = i - 2 > -1 && "." !== e.buffer[i - 2] ? e.buffer[i - 2] + t : "0" + t) : t = "00" + t, new RegExp("25[0-5]|2[0-4][0-9]|[01][0-9][0-9]").test(t)
						}, cardinality: 1
					}
				}, onUnMask: function (t, e, i) {
					return t
				}, inputmode: "numeric"
			}, email: {
				mask: "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]", greedy: !1, onBeforePaste: function (t, e) {
					return (t = t.toLowerCase()).replace("mailto:", "")
				}, definitions: {"*": {validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~-]", cardinality: 1, casing: "lower"}, "-": {validator: "[0-9A-Za-z-]", cardinality: 1, casing: "lower"}}, onUnMask: function (t, e, i) {
					return t
				}, inputmode: "email"
			}, mac: {mask: "##:##:##:##:##:##"}, vin: {mask: "V{13}9{4}", definitions: {V: {validator: "[A-HJ-NPR-Za-hj-npr-z\\d]", cardinality: 1, casing: "upper"}}, clearIncomplete: !0, autoUnmask: !0}
		}), e
	}) ? n.apply(e, r) : n) && (t.exports = o)
}, function (t, e, i) {
	"use strict";
	var n, r, o;
	"function" == typeof Symbol && Symbol.iterator, r = [i(0), i(1)], void 0 !== (o = "function" == typeof (n = function (t, e, i) {
		function n(t, i) {
			for (var n = "", r = 0; r < t.length; r++) e.prototype.definitions[t.charAt(r)] || i.definitions[t.charAt(r)] || i.optionalmarker.start === t.charAt(r) || i.optionalmarker.end === t.charAt(r) || i.quantifiermarker.start === t.charAt(r) || i.quantifiermarker.end === t.charAt(r) || i.groupmarker.start === t.charAt(r) || i.groupmarker.end === t.charAt(r) || i.alternatormarker === t.charAt(r) ? n += "\\" + t.charAt(r) : n += t.charAt(r);
			return n
		}

		return e.extendAliases({
			numeric: {
				mask: function (t) {
					if (0 !== t.repeat && isNaN(t.integerDigits) && (t.integerDigits = t.repeat), t.repeat = 0, t.groupSeparator === t.radixPoint && ("." === t.radixPoint ? t.groupSeparator = "," : "," === t.radixPoint ? t.groupSeparator = "." : t.groupSeparator = ""), " " === t.groupSeparator && (t.skipOptionalPartCharacter = i), t.autoGroup = t.autoGroup && "" !== t.groupSeparator, t.autoGroup && ("string" == typeof t.groupSize && isFinite(t.groupSize) && (t.groupSize = parseInt(t.groupSize)), isFinite(t.integerDigits))) {
						var e = Math.floor(t.integerDigits / t.groupSize), r = t.integerDigits % t.groupSize;
						t.integerDigits = parseInt(t.integerDigits) + (0 === r ? e - 1 : e), t.integerDigits < 1 && (t.integerDigits = "*")
					}
					t.placeholder.length > 1 && (t.placeholder = t.placeholder.charAt(0)), "radixFocus" === t.positionCaretOnClick && "" === t.placeholder && !1 === t.integerOptional && (t.positionCaretOnClick = "lvp"), t.definitions[";"] = t.definitions["~"], t.definitions[";"].definitionSymbol = "~", !0 === t.numericInput && (t.positionCaretOnClick = "radixFocus" === t.positionCaretOnClick ? "lvp" : t.positionCaretOnClick, t.digitsOptional = !1, isNaN(t.digits) && (t.digits = 2), t.decimalProtect = !1);
					var o = "[+]";
					if (o += n(t.prefix, t), !0 === t.integerOptional ? o += "~{1," + t.integerDigits + "}" : o += "~{" + t.integerDigits + "}", t.digits !== i) {
						t.radixPointDefinitionSymbol = t.decimalProtect ? ":" : t.radixPoint;
						var a = t.digits.toString().split(",");
						isFinite(a[0] && a[1] && isFinite(a[1])) ? o += t.radixPointDefinitionSymbol + ";{" + t.digits + "}" : (isNaN(t.digits) || parseInt(t.digits) > 0) && (t.digitsOptional ? o += "[" + t.radixPointDefinitionSymbol + ";{1," + t.digits + "}]" : o += t.radixPointDefinitionSymbol + ";{" + t.digits + "}")
					}
					return o += n(t.suffix, t), o += "[-]", t.greedy = !1, o
				},
				placeholder: "",
				greedy: !1,
				digits: "*",
				digitsOptional: !0,
				enforceDigitsOnBlur: !1,
				radixPoint: ".",
				positionCaretOnClick: "radixFocus",
				groupSize: 3,
				groupSeparator: "",
				autoGroup: !1,
				allowMinus: !0,
				negationSymbol: {front: "-", back: ""},
				integerDigits: "+",
				integerOptional: !0,
				prefix: "",
				suffix: "",
				rightAlign: !0,
				decimalProtect: !0,
				min: null,
				max: null,
				step: 1,
				insertMode: !0,
				autoUnmask: !1,
				unmaskAsNumber: !1,
				inputmode: "numeric",
				preValidation: function (e, n, r, o, a) {
					if ("-" === r || r === a.negationSymbol.front) return !0 === a.allowMinus && (a.isNegative = a.isNegative === i || !a.isNegative, "" === e.join("") || {caret: n, dopost: !0});
					if (!1 === o && r === a.radixPoint && a.digits !== i && (isNaN(a.digits) || parseInt(a.digits) > 0)) {
						var s = t.inArray(a.radixPoint, e);
						if (-1 !== s) return !0 === a.numericInput ? n === s : {caret: s + 1}
					}
					return !0
				},
				postValidation: function (n, r, o) {
					var a = o.suffix.split(""), s = o.prefix.split("");
					if (r.pos === i && r.caret !== i && !0 !== r.dopost) return r;
					var l = r.caret !== i ? r.caret : r.pos, c = n.slice();
					o.numericInput && (l = c.length - l - 1, c = c.reverse());
					var u = c[l];
					if (u === o.groupSeparator && (u = c[l += 1]), l === c.length - o.suffix.length - 1 && u === o.radixPoint) return r;
					u !== i && u !== o.radixPoint && u !== o.negationSymbol.front && u !== o.negationSymbol.back && (c[l] = "?", o.prefix.length > 0 && l >= (!1 === o.isNegative ? 1 : 0) && l < o.prefix.length - 1 + (!1 === o.isNegative ? 1 : 0) ? s[l - (!1 === o.isNegative ? 1 : 0)] = "?" : o.suffix.length > 0 && l >= c.length - o.suffix.length - (!1 === o.isNegative ? 1 : 0) && (a[l - (c.length - o.suffix.length - (!1 === o.isNegative ? 1 : 0))] = "?")), s = s.join(""), a = a.join("");
					var h = c.join("").replace(s, "");
					if (h = (h = (h = (h = h.replace(a, "")).replace(new RegExp(e.escapeRegex(o.groupSeparator), "g"), "")).replace(new RegExp("[-" + e.escapeRegex(o.negationSymbol.front) + "]", "g"), "")).replace(new RegExp(e.escapeRegex(o.negationSymbol.back) + "$"), ""), isNaN(o.placeholder) && (h = h.replace(new RegExp(e.escapeRegex(o.placeholder), "g"), "")), h.length > 1 && 1 !== h.indexOf(o.radixPoint) && ("0" === u && (h = h.replace(/^\?/g, "")), h = h.replace(/^0/g, "")), h.charAt(0) === o.radixPoint && "" !== o.radixPoint && !0 !== o.numericInput && (h = "0" + h), "" !== h) {
						if (h = h.split(""), (!o.digitsOptional || o.enforceDigitsOnBlur && "blur" === r.event) && isFinite(o.digits)) {
							var d = t.inArray(o.radixPoint, h), p = t.inArray(o.radixPoint, c);
							-1 === d && (h.push(o.radixPoint), d = h.length - 1);
							for (var f = 1; f <= o.digits; f++) o.digitsOptional && (!o.enforceDigitsOnBlur || "blur" !== r.event) || h[d + f] !== i && h[d + f] !== o.placeholder.charAt(0) ? -1 !== p && c[p + f] !== i && (h[d + f] = h[d + f] || c[p + f]) : h[d + f] = r.placeholder || o.placeholder.charAt(0)
						}
						if (!0 !== o.autoGroup || "" === o.groupSeparator || u === o.radixPoint && r.pos === i && !r.dopost) h = h.join(""); else {
							var m = h[h.length - 1] === o.radixPoint && r.c === o.radixPoint;
							h = e(function (t, e) {
								var i = "";
								if (i += "(" + e.groupSeparator + "*{" + e.groupSize + "}){*}", "" !== e.radixPoint) {
									var n = t.join("").split(e.radixPoint);
									n[1] && (i += e.radixPoint + "*{" + n[1].match(/^\d*\??\d*/)[0].length + "}")
								}
								return i
							}(h, o), {numericInput: !0, jitMasking: !0, definitions: {"*": {validator: "[0-9?]", cardinality: 1}}}).format(h.join("")), m && (h += o.radixPoint), h.charAt(0) === o.groupSeparator && h.substr(1)
						}
					}
					if (o.isNegative && "blur" === r.event && (o.isNegative = "0" !== h), h = s + h, h += a, o.isNegative && (h = o.negationSymbol.front + h, h += o.negationSymbol.back), h = h.split(""), u !== i) if (u !== o.radixPoint && u !== o.negationSymbol.front && u !== o.negationSymbol.back) (l = t.inArray("?", h)) > -1 ? h[l] = u : l = r.caret || 0; else if (u === o.radixPoint || u === o.negationSymbol.front || u === o.negationSymbol.back) {
						var g = t.inArray(u, h);
						-1 !== g && (l = g)
					}
					o.numericInput && (l = h.length - l - 1, h = h.reverse());
					var v = {caret: u === i || r.pos !== i ? l + (o.numericInput ? -1 : 1) : l, buffer: h, refreshFromBuffer: r.dopost || n.join("") !== h.join("")};
					return v.refreshFromBuffer ? v : r
				},
				onBeforeWrite: function (n, r, o, a) {
					if (n) switch (n.type) {
						case"keydown":
							return a.postValidation(r, {caret: o, dopost: !0}, a);
						case"blur":
						case"checkval":
							var s;
							if (function (t) {
								t.parseMinMaxOptions === i && (null !== t.min && (t.min = t.min.toString().replace(new RegExp(e.escapeRegex(t.groupSeparator), "g"), ""), "," === t.radixPoint && (t.min = t.min.replace(t.radixPoint, ".")), t.min = isFinite(t.min) ? parseFloat(t.min) : NaN, isNaN(t.min) && (t.min = Number.MIN_VALUE)), null !== t.max && (t.max = t.max.toString().replace(new RegExp(e.escapeRegex(t.groupSeparator), "g"), ""), "," === t.radixPoint && (t.max = t.max.replace(t.radixPoint, ".")), t.max = isFinite(t.max) ? parseFloat(t.max) : NaN, isNaN(t.max) && (t.max = Number.MAX_VALUE)), t.parseMinMaxOptions = "done")
							}(a), null !== a.min || null !== a.max) {
								if (s = a.onUnMask(r.join(""), i, t.extend({}, a, {unmaskAsNumber: !0})), null !== a.min && s < a.min) return a.isNegative = a.min < 0, a.postValidation(a.min.toString().replace(".", a.radixPoint).split(""), {caret: o, dopost: !0, placeholder: "0"}, a);
								if (null !== a.max && s > a.max) return a.isNegative = a.max < 0, a.postValidation(a.max.toString().replace(".", a.radixPoint).split(""), {caret: o, dopost: !0, placeholder: "0"}, a)
							}
							return a.postValidation(r, {caret: o, placeholder: "0", event: "blur"}, a);
						case"_checkval":
							return {caret: o}
					}
				},
				regex: {
					integerPart: function (t, i) {
						return i ? new RegExp("[" + e.escapeRegex(t.negationSymbol.front) + "+]?") : new RegExp("[" + e.escapeRegex(t.negationSymbol.front) + "+]?\\d+")
					}, integerNPart: function (t) {
						return new RegExp("[\\d" + e.escapeRegex(t.groupSeparator) + e.escapeRegex(t.placeholder.charAt(0)) + "]+")
					}
				},
				definitions: {
					"~": {
						validator: function (t, n, r, o, a, s) {
							var l = o ? new RegExp("[0-9" + e.escapeRegex(a.groupSeparator) + "]").test(t) : new RegExp("[0-9]").test(t);
							if (!0 === l) {
								if (!0 !== a.numericInput && n.validPositions[r] !== i && "~" === n.validPositions[r].match.def && !s) {
									var c = n.buffer.join(""), u = (c = (c = c.replace(new RegExp("[-" + e.escapeRegex(a.negationSymbol.front) + "]", "g"), "")).replace(new RegExp(e.escapeRegex(a.negationSymbol.back) + "$"), "")).split(a.radixPoint);
									u.length > 1 && (u[1] = u[1].replace(/0/g, a.placeholder.charAt(0))), "0" === u[0] && (u[0] = u[0].replace(/0/g, a.placeholder.charAt(0))), c = u[0] + a.radixPoint + u[1] || "";
									var h = n._buffer.join("");
									for (c === a.radixPoint && (c = h); null === c.match(e.escapeRegex(h) + "$");) h = h.slice(1);
									l = (c = (c = c.replace(h, "")).split(""))[r] === i ? {pos: r, remove: r} : {pos: r}
								}
							} else o || t !== a.radixPoint || n.validPositions[r - 1] !== i || (n.buffer[r] = "0", l = {pos: r + 1});
							return l
						}, cardinality: 1
					}, "+": {
						validator: function (t, e, i, n, r) {
							return r.allowMinus && ("-" === t || t === r.negationSymbol.front)
						}, cardinality: 1, placeholder: ""
					}, "-": {
						validator: function (t, e, i, n, r) {
							return r.allowMinus && t === r.negationSymbol.back
						}, cardinality: 1, placeholder: ""
					}, ":": {
						validator: function (t, i, n, r, o) {
							var a = "[" + e.escapeRegex(o.radixPoint) + "]", s = new RegExp(a).test(t);
							return s && i.validPositions[n] && i.validPositions[n].match.placeholder === o.radixPoint && (s = {caret: n + 1}), s
						}, cardinality: 1, placeholder: function (t) {
							return t.radixPoint
						}
					}
				},
				onUnMask: function (t, i, n) {
					if ("" === i && !0 === n.nullable) return i;
					var r = t.replace(n.prefix, "");
					return r = (r = r.replace(n.suffix, "")).replace(new RegExp(e.escapeRegex(n.groupSeparator), "g"), ""), "" !== n.placeholder.charAt(0) && (r = r.replace(new RegExp(n.placeholder.charAt(0), "g"), "0")), n.unmaskAsNumber ? ("" !== n.radixPoint && -1 !== r.indexOf(n.radixPoint) && (r = r.replace(e.escapeRegex.call(this, n.radixPoint), ".")), r = (r = r.replace(new RegExp("^" + e.escapeRegex(n.negationSymbol.front)), "-")).replace(new RegExp(e.escapeRegex(n.negationSymbol.back) + "$"), ""), Number(r)) : r
				},
				isComplete: function (t, i) {
					var n = t.join("");
					if (t.slice().join("") !== n) return !1;
					var r = n.replace(i.prefix, "");
					return r = (r = r.replace(i.suffix, "")).replace(new RegExp(e.escapeRegex(i.groupSeparator), "g"), ""), "," === i.radixPoint && (r = r.replace(e.escapeRegex(i.radixPoint), ".")), isFinite(r)
				},
				onBeforeMask: function (t, n) {
					if (n.isNegative = i, t = t.toString().charAt(t.length - 1) === n.radixPoint ? t.toString().substr(0, t.length - 1) : t.toString(), "" !== n.radixPoint && isFinite(t)) {
						var r = t.split("."), o = "" !== n.groupSeparator ? parseInt(n.groupSize) : 0;
						2 === r.length && (r[0].length > o || r[1].length > o || r[0].length <= o && r[1].length < o) && (t = t.replace(".", n.radixPoint))
					}
					var a = t.match(/,/g), s = t.match(/\./g);
					if (t = s && a ? s.length > a.length ? (t = t.replace(/\./g, "")).replace(",", n.radixPoint) : a.length > s.length ? (t = t.replace(/,/g, "")).replace(".", n.radixPoint) : t.indexOf(".") < t.indexOf(",") ? t.replace(/\./g, "") : t.replace(/,/g, "") : t.replace(new RegExp(e.escapeRegex(n.groupSeparator), "g"), ""), 0 === n.digits && (-1 !== t.indexOf(".") ? t = t.substring(0, t.indexOf(".")) : -1 !== t.indexOf(",") && (t = t.substring(0, t.indexOf(",")))), "" !== n.radixPoint && isFinite(n.digits) && -1 !== t.indexOf(n.radixPoint)) {
						var l = t.split(n.radixPoint)[1].match(new RegExp("\\d*"))[0];
						if (parseInt(n.digits) < l.toString().length) {
							var c = Math.pow(10, parseInt(n.digits));
							t = t.replace(e.escapeRegex(n.radixPoint), "."), t = (t = Math.round(parseFloat(t) * c) / c).toString().replace(".", n.radixPoint)
						}
					}
					return t
				},
				canClearPosition: function (t, e, i, n, r) {
					var o = t.validPositions[e],
						a = o.input !== r.radixPoint || null !== t.validPositions[e].match.fn && !1 === r.decimalProtect || o.input === r.radixPoint && t.validPositions[e + 1] && null === t.validPositions[e + 1].match.fn || isFinite(o.input) || e === i || o.input === r.groupSeparator || o.input === r.negationSymbol.front || o.input === r.negationSymbol.back;
					return !a || "+" !== o.match.nativeDef && "-" !== o.match.nativeDef || (r.isNegative = !1), a
				},
				onKeyDown: function (i, n, r, o) {
					var a = t(this);
					if (i.ctrlKey) switch (i.keyCode) {
						case e.keyCode.UP:
							a.val(parseFloat(this.inputmask.unmaskedvalue()) + parseInt(o.step)), a.trigger("setvalue");
							break;
						case e.keyCode.DOWN:
							a.val(parseFloat(this.inputmask.unmaskedvalue()) - parseInt(o.step)), a.trigger("setvalue")
					}
				}
			},
			currency: {prefix: "$ ", groupSeparator: ",", alias: "numeric", placeholder: "0", autoGroup: !0, digits: 2, digitsOptional: !1, clearMaskOnLostFocus: !1},
			decimal: {alias: "numeric"},
			integer: {alias: "numeric", digits: 0, radixPoint: ""},
			percentage: {alias: "numeric", digits: 2, digitsOptional: !0, radixPoint: ".", placeholder: "0", autoGroup: !1, min: 0, max: 100, suffix: " %", allowMinus: !1}
		}), e
	}) ? n.apply(e, r) : n) && (t.exports = o)
}, function (t, e, i) {
	"use strict";
	var n, r, o;
	"function" == typeof Symbol && Symbol.iterator, r = [i(0), i(1)], void 0 !== (o = "function" == typeof (n = function (t, e) {
		function i(t, e) {
			var i = (t.mask || t).replace(/#/g, "9").replace(/\)/, "9").replace(/[+()#-]/g, ""), n = (e.mask || e).replace(/#/g, "9").replace(/\)/, "9").replace(/[+()#-]/g, ""), r = (t.mask || t).split("#")[0], o = (e.mask || e).split("#")[0];
			return 0 === o.indexOf(r) ? -1 : 0 === r.indexOf(o) ? 1 : i.localeCompare(n)
		}

		var n = e.prototype.analyseMask;
		return e.prototype.analyseMask = function (e, i, r) {
			var o = {};
			return r.phoneCodes && (r.phoneCodes && r.phoneCodes.length > 1e3 && (function t(i, n, r) {
				r = r || o, "" !== (n = n || "") && (r[n] = {});
				for (var a = "", s = r[n] || r, l = i.length - 1; l >= 0; l--) s[a = (e = i[l].mask || i[l]).substr(0, 1)] = s[a] || [], s[a].unshift(e.substr(1)), i.splice(l, 1);
				for (var c in s) s[c].length > 500 && t(s[c].slice(), c, s)
			}((e = e.substr(1, e.length - 2)).split(r.groupmarker.end + r.alternatormarker + r.groupmarker.start)), e = function e(i) {
				var n = "", o = [];
				for (var a in i) t.isArray(i[a]) ? 1 === i[a].length ? o.push(a + i[a]) : o.push(a + r.groupmarker.start + i[a].join(r.groupmarker.end + r.alternatormarker + r.groupmarker.start) + r.groupmarker.end) : o.push(a + e(i[a]));
				return 1 === o.length ? n += o[0] : n += r.groupmarker.start + o.join(r.groupmarker.end + r.alternatormarker + r.groupmarker.start) + r.groupmarker.end, n
			}(o)), e = e.replace(/9/g, "\\9")), n.call(this, e, i, r)
		}, e.extendAliases({
			abstractphone: {
				groupmarker: {start: "<", end: ">"}, countrycode: "", phoneCodes: [], mask: function (t) {
					return t.definitions = {"#": e.prototype.definitions[9]}, t.phoneCodes.sort(i)
				}, keepStatic: !0, onBeforeMask: function (t, e) {
					var i = t.replace(/^0{1,2}/, "").replace(/[\s]/g, "");
					return (i.indexOf(e.countrycode) > 1 || -1 === i.indexOf(e.countrycode)) && (i = "+" + e.countrycode + i), i
				}, onUnMask: function (t, e, i) {
					return t.replace(/[()#-]/g, "")
				}, inputmode: "tel"
			}
		}), e
	}) ? n.apply(e, r) : n) && (t.exports = o)
}, function (t, e, i) {
	"use strict";
	var n, r, o;
	"function" == typeof Symbol && Symbol.iterator, r = [i(0), i(1)], void 0 !== (o = "function" == typeof (n = function (t, e) {
		return e.extendAliases({
			Regex: {
				mask: "r",
				greedy: !1,
				repeat: "*",
				regex: null,
				regexTokens: null,
				tokenizer: /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g,
				quantifierFilter: /[0-9]+[^,]/,
				isComplete: function (t, e) {
					return new RegExp(e.regex, e.casing ? "i" : "").test(t.join(""))
				},
				definitions: {
					r: {
						validator: function (e, i, n, r, o) {
							function a(t, e) {
								this.matches = [], this.isGroup = t || !1, this.isQuantifier = e || !1, this.quantifier = {min: 1, max: 1}, this.repeaterPart = void 0
							}

							function s(e, i) {
								var n = !1;
								i && (h += "(", p++);
								for (var r = 0; r < e.matches.length; r++) {
									var a = e.matches[r];
									if (!0 === a.isGroup) n = s(a, !0); else if (!0 === a.isQuantifier) {
										var c = t.inArray(a, e.matches), u = e.matches[c - 1], d = h;
										if (isNaN(a.quantifier.max)) {
											for (; a.repeaterPart && a.repeaterPart !== h && a.repeaterPart.length > h.length && !(n = s(u, !0));) ;
											(n = n || s(u, !0)) && (a.repeaterPart = h), h = d + a.quantifier.max
										} else {
											for (var f = 0, m = a.quantifier.max - 1; f < m && !(n = s(u, !0)); f++) ;
											h = d + "{" + a.quantifier.min + "," + a.quantifier.max + "}"
										}
									} else if (void 0 !== a.matches) for (var g = 0; g < a.length && !(n = s(a[g], i)); g++) ; else {
										var v;
										if ("[" == a.charAt(0)) {
											for (v = h, v += a, w = 0; w < p; w++) v += ")";
											n = (x = new RegExp("^(" + v + ")$", o.casing ? "i" : "")).test(l)
										} else for (var y = 0, b = a.length; y < b; y++) if ("\\" !== a.charAt(y)) {
											v = h, v = (v += a.substr(0, y + 1)).replace(/\|$/, "");
											for (var w = 0; w < p; w++) v += ")";
											var x = new RegExp("^(" + v + ")$", o.casing ? "i" : "");
											if (n = x.test(l)) break
										}
										h += a
									}
									if (n) break
								}
								return i && (h += ")", p--), n
							}

							var l, c, u = i.buffer.slice(), h = "", d = !1, p = 0;
							null === o.regexTokens && function () {
								var t, e, i = new a, n = [];
								for (o.regexTokens = []; t = o.tokenizer.exec(o.regex);) switch ((e = t[0]).charAt(0)) {
									case"(":
										n.push(new a(!0));
										break;
									case")":
										c = n.pop(), n.length > 0 ? n[n.length - 1].matches.push(c) : i.matches.push(c);
										break;
									case"{":
									case"+":
									case"*":
										var r = new a(!1, !0), s = (e = e.replace(/[{}]/g, "")).split(","), l = isNaN(s[0]) ? s[0] : parseInt(s[0]), u = 1 === s.length ? l : isNaN(s[1]) ? s[1] : parseInt(s[1]);
										if (r.quantifier = {min: l, max: u}, n.length > 0) {
											var h = n[n.length - 1].matches;
											(t = h.pop()).isGroup || ((c = new a(!0)).matches.push(t), t = c), h.push(t), h.push(r)
										} else (t = i.matches.pop()).isGroup || ((c = new a(!0)).matches.push(t), t = c), i.matches.push(t), i.matches.push(r);
										break;
									default:
										n.length > 0 ? n[n.length - 1].matches.push(e) : i.matches.push(e)
								}
								i.matches.length > 0 && o.regexTokens.push(i)
							}(), u.splice(n, 0, e), l = u.join("");
							for (var f = 0; f < o.regexTokens.length; f++) {
								var m = o.regexTokens[f];
								if (d = s(m, m.isGroup)) break
							}
							return d
						}, cardinality: 1
					}
				}
			}
		}), e
	}) ? n.apply(e, r) : n) && (t.exports = o)
}, function (t, e, i) {
	"use strict";
	var n, r, o, a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
		return typeof t
	} : function (t) {
		return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
	};
	r = [i(2), i(1)], void 0 !== (o = "function" == typeof (n = function (t, e) {
		return void 0 === t.fn.inputmask && (t.fn.inputmask = function (i, n) {
			var r, o = this[0];
			if (void 0 === n && (n = {}), "string" == typeof i) switch (i) {
				case"unmaskedvalue":
					return o && o.inputmask ? o.inputmask.unmaskedvalue() : t(o).val();
				case"remove":
					return this.each(function () {
						this.inputmask && this.inputmask.remove()
					});
				case"getemptymask":
					return o && o.inputmask ? o.inputmask.getemptymask() : "";
				case"hasMaskedValue":
					return !(!o || !o.inputmask) && o.inputmask.hasMaskedValue();
				case"isComplete":
					return !o || !o.inputmask || o.inputmask.isComplete();
				case"getmetadata":
					return o && o.inputmask ? o.inputmask.getmetadata() : void 0;
				case"setvalue":
					t(o).val(n), o && void 0 === o.inputmask && t(o).triggerHandler("setvalue");
					break;
				case"option":
					if ("string" != typeof n) return this.each(function () {
						if (void 0 !== this.inputmask) return this.inputmask.option(n)
					});
					if (o && void 0 !== o.inputmask) return o.inputmask.option(n);
					break;
				default:
					return n.alias = i, r = new e(n), this.each(function () {
						r.mask(this)
					})
			} else {
				if ("object" == (void 0 === i ? "undefined" : a(i))) return r = new e(i), void 0 === i.mask && void 0 === i.alias ? this.each(function () {
					if (void 0 !== this.inputmask) return this.inputmask.option(i);
					r.mask(this)
				}) : this.each(function () {
					r.mask(this)
				});
				if (void 0 === i) return this.each(function () {
					(r = new e(n)).mask(this)
				})
			}
		}), t.fn.inputmask
	}) ? n.apply(e, r) : n) && (t.exports = o)
}]), function (t) {
	"function" == typeof define && define.amd ? define(["./dependencyLibs/inputmask.dependencyLib", "./inputmask"], t) : "object" == typeof exports ? module.exports = t(require("./dependencyLibs/inputmask.dependencyLib"), require("./inputmask")) : t(window.dependencyLib || jQuery, window.Inputmask)
}(function (t, e) {
	return e.extendAliases({
		"dd/mm/yyyy": {
			mask: "1/2/y", placeholder: "dd/mm/yyyy", regex: {
				val1pre: new RegExp("[0-3]"), val1: new RegExp("0[1-9]|[12][0-9]|3[01]"), val2pre: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[1-9]|[12][0-9]|3[01])" + i + "[01])")
				}, val2: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[1-9]|[12][0-9])" + i + "(0[1-9]|1[012]))|(30" + i + "(0[13-9]|1[012]))|(31" + i + "(0[13578]|1[02]))")
				}
			}, leapday: "29/02/", separator: "/", yearrange: {minyear: 1900, maxyear: 2099}, isInYearRange: function (t, e, i) {
				if (isNaN(t)) return !1;
				var n = parseInt(t.concat(e.toString().slice(t.length))), r = parseInt(t.concat(i.toString().slice(t.length)));
				return !isNaN(n) && e <= n && n <= i || !isNaN(r) && e <= r && r <= i
			}, determinebaseyear: function (t, e, i) {
				var n = (new Date).getFullYear();
				if (t > n) return t;
				if (e < n) {
					for (var r = e.toString().slice(0, 2), o = e.toString().slice(2, 4); e < r + i;) r--;
					var a = r + o;
					return t > a ? t : a
				}
				if (t <= n && n <= e) {
					for (var s = n.toString().slice(0, 2); e < s + i;) s--;
					var l = s + i;
					return l < t ? t : l
				}
				return n
			}, onKeyDown: function (i, n, r, o) {
				var a = t(this);
				if (i.ctrlKey && i.keyCode === e.keyCode.RIGHT) {
					var s = new Date;
					a.val(s.getDate().toString() + (s.getMonth() + 1).toString() + s.getFullYear().toString()), a.trigger("setvalue")
				}
			}, getFrontValue: function (t, e, i) {
				for (var n = 0, r = 0, o = 0; o < t.length && "2" !== t.charAt(o); o++) {
					var a = i.definitions[t.charAt(o)];
					a ? (n += r, r = a.cardinality) : r++
				}
				return e.join("").substr(n, r)
			}, postValidation: function (t, e, i) {
				var n, r, o = t.join("");
				return 0 === i.mask.indexOf("y") ? (r = o.substr(0, 4), n = o.substring(4, 10)) : (r = o.substring(6, 10), n = o.substr(0, 6)), e && (n !== i.leapday || function (t) {
					return isNaN(t) || 29 === new Date(t, 2, 0).getDate()
				}(r))
			}, definitions: {
				1: {
					validator: function (t, e, i, n, r) {
						var o = r.regex.val1.test(t);
						return n || o || t.charAt(1) !== r.separator && -1 === "-./".indexOf(t.charAt(1)) || !(o = r.regex.val1.test("0" + t.charAt(0))) ? o : (e.buffer[i - 1] = "0", {refreshFromBuffer: {start: i - 1, end: i}, pos: i, c: t.charAt(0)})
					}, cardinality: 2, prevalidator: [{
						validator: function (t, e, i, n, r) {
							var o = t;
							isNaN(e.buffer[i + 1]) || (o += e.buffer[i + 1]);
							var a = 1 === o.length ? r.regex.val1pre.test(o) : r.regex.val1.test(o);
							if (a && e.validPositions[i] && (r.regex.val2(r.separator).test(t + e.validPositions[i].input) || (e.validPositions[i].input = "0" === t ? "1" : "0")), !n && !a) {
								if (a = r.regex.val1.test(t + "0")) return e.buffer[i] = t, e.buffer[++i] = "0", {pos: i, c: "0"};
								if (a = r.regex.val1.test("0" + t)) return e.buffer[i] = "0", {pos: ++i}
							}
							return a
						}, cardinality: 1
					}]
				}, 2: {
					validator: function (t, e, i, n, r) {
						var o = r.getFrontValue(e.mask, e.buffer, r);
						-1 !== o.indexOf(r.placeholder[0]) && (o = "01" + r.separator);
						var a = r.regex.val2(r.separator).test(o + t);
						return n || a || t.charAt(1) !== r.separator && -1 === "-./".indexOf(t.charAt(1)) || !(a = r.regex.val2(r.separator).test(o + "0" + t.charAt(0))) ? a : (e.buffer[i - 1] = "0", {refreshFromBuffer: {start: i - 1, end: i}, pos: i, c: t.charAt(0)})
					}, cardinality: 2, prevalidator: [{
						validator: function (t, e, i, n, r) {
							isNaN(e.buffer[i + 1]) || (t += e.buffer[i + 1]);
							var o = r.getFrontValue(e.mask, e.buffer, r);
							-1 !== o.indexOf(r.placeholder[0]) && (o = "01" + r.separator);
							var a = 1 === t.length ? r.regex.val2pre(r.separator).test(o + t) : r.regex.val2(r.separator).test(o + t);
							return a && e.validPositions[i] && (r.regex.val2(r.separator).test(t + e.validPositions[i].input) || (e.validPositions[i].input = "0" === t ? "1" : "0")), n || a || !(a = r.regex.val2(r.separator).test(o + "0" + t)) ? a : (e.buffer[i] = "0", {pos: ++i})
						}, cardinality: 1
					}]
				}, y: {
					validator: function (t, e, i, n, r) {
						return r.isInYearRange(t, r.yearrange.minyear, r.yearrange.maxyear)
					}, cardinality: 4, prevalidator: [{
						validator: function (t, e, i, n, r) {
							var o = r.isInYearRange(t, r.yearrange.minyear, r.yearrange.maxyear);
							if (!n && !o) {
								var a = r.determinebaseyear(r.yearrange.minyear, r.yearrange.maxyear, t + "0").toString().slice(0, 1);
								if (o = r.isInYearRange(a + t, r.yearrange.minyear, r.yearrange.maxyear)) return e.buffer[i++] = a.charAt(0), {pos: i};
								if (a = r.determinebaseyear(r.yearrange.minyear, r.yearrange.maxyear, t + "0").toString().slice(0, 2), o = r.isInYearRange(a + t, r.yearrange.minyear, r.yearrange.maxyear)) return e.buffer[i++] = a.charAt(0), e.buffer[i++] = a.charAt(1), {pos: i}
							}
							return o
						}, cardinality: 1
					}, {
						validator: function (t, e, i, n, r) {
							var o = r.isInYearRange(t, r.yearrange.minyear, r.yearrange.maxyear);
							if (!n && !o) {
								var a = r.determinebaseyear(r.yearrange.minyear, r.yearrange.maxyear, t).toString().slice(0, 2);
								if (o = r.isInYearRange(t[0] + a[1] + t[1], r.yearrange.minyear, r.yearrange.maxyear)) return e.buffer[i++] = a.charAt(1), {pos: i};
								if (a = r.determinebaseyear(r.yearrange.minyear, r.yearrange.maxyear, t).toString().slice(0, 2), o = r.isInYearRange(a + t, r.yearrange.minyear, r.yearrange.maxyear)) return e.buffer[i - 1] = a.charAt(0), e.buffer[i++] = a.charAt(1), e.buffer[i++] = t.charAt(0), {
									refreshFromBuffer: {
										start: i - 3,
										end: i
									}, pos: i
								}
							}
							return o
						}, cardinality: 2
					}, {
						validator: function (t, e, i, n, r) {
							return r.isInYearRange(t, r.yearrange.minyear, r.yearrange.maxyear)
						}, cardinality: 3
					}]
				}
			}, insertMode: !1, autoUnmask: !1
		},
		"mm/dd/yyyy": {
			placeholder: "mm/dd/yyyy", alias: "dd/mm/yyyy", regex: {
				val2pre: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[13-9]|1[012])" + i + "[0-3])|(02" + i + "[0-2])")
				}, val2: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[1-9]|1[012])" + i + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + i + "30)|((0[13578]|1[02])" + i + "31)")
				}, val1pre: new RegExp("[01]"), val1: new RegExp("0[1-9]|1[012]")
			}, leapday: "02/29/", onKeyDown: function (i, n, r, o) {
				var a = t(this);
				if (i.ctrlKey && i.keyCode === e.keyCode.RIGHT) {
					var s = new Date;
					a.val((s.getMonth() + 1).toString() + s.getDate().toString() + s.getFullYear().toString()), a.trigger("setvalue")
				}
			}
		},
		"yyyy/mm/dd": {
			mask: "y/1/2", placeholder: "yyyy/mm/dd", alias: "mm/dd/yyyy", leapday: "/02/29", onKeyDown: function (i, n, r, o) {
				var a = t(this);
				if (i.ctrlKey && i.keyCode === e.keyCode.RIGHT) {
					var s = new Date;
					a.val(s.getFullYear().toString() + (s.getMonth() + 1).toString() + s.getDate().toString()), a.trigger("setvalue")
				}
			}
		},
		"dd.mm.yyyy": {mask: "1.2.y", placeholder: "dd.mm.yyyy", leapday: "29.02.", separator: ".", alias: "dd/mm/yyyy"},
		"dd-mm-yyyy": {mask: "1-2-y", placeholder: "dd-mm-yyyy", leapday: "29-02-", separator: "-", alias: "dd/mm/yyyy"},
		"mm.dd.yyyy": {mask: "1.2.y", placeholder: "mm.dd.yyyy", leapday: "02.29.", separator: ".", alias: "mm/dd/yyyy"},
		"mm-dd-yyyy": {mask: "1-2-y", placeholder: "mm-dd-yyyy", leapday: "02-29-", separator: "-", alias: "mm/dd/yyyy"},
		"yyyy.mm.dd": {mask: "y.1.2", placeholder: "yyyy.mm.dd", leapday: ".02.29", separator: ".", alias: "yyyy/mm/dd"},
		"yyyy-mm-dd": {mask: "y-1-2", placeholder: "yyyy-mm-dd", leapday: "-02-29", separator: "-", alias: "yyyy/mm/dd"},
		datetime: {
			mask: "1/2/y h:s",
			placeholder: "dd/mm/yyyy hh:mm",
			alias: "dd/mm/yyyy",
			regex: {hrspre: new RegExp("[012]"), hrs24: new RegExp("2[0-4]|1[3-9]"), hrs: new RegExp("[01][0-9]|2[0-4]"), ampm: new RegExp("^[a|p|A|P][m|M]"), mspre: new RegExp("[0-5]"), ms: new RegExp("[0-5][0-9]")},
			timeseparator: ":",
			hourFormat: "24",
			definitions: {
				h: {
					validator: function (t, e, i, n, r) {
						if ("24" === r.hourFormat && 24 === parseInt(t, 10)) return e.buffer[i - 1] = "0", e.buffer[i] = "0", {refreshFromBuffer: {start: i - 1, end: i}, c: "0"};
						var o = r.regex.hrs.test(t);
						if (!n && !o && (t.charAt(1) === r.timeseparator || -1 !== "-.:".indexOf(t.charAt(1))) && (o = r.regex.hrs.test("0" + t.charAt(0)))) return e.buffer[i - 1] = "0", e.buffer[i] = t.charAt(0), {refreshFromBuffer: {start: ++i - 2, end: i}, pos: i, c: r.timeseparator};
						if (o && "24" !== r.hourFormat && r.regex.hrs24.test(t)) {
							var a = parseInt(t, 10);
							return 24 === a ? (e.buffer[i + 5] = "a", e.buffer[i + 6] = "m") : (e.buffer[i + 5] = "p", e.buffer[i + 6] = "m"), (a -= 12) < 10 ? (e.buffer[i] = a.toString(), e.buffer[i - 1] = "0") : (e.buffer[i] = a.toString().charAt(1), e.buffer[i - 1] = a.toString().charAt(0)), {
								refreshFromBuffer: {
									start: i - 1,
									end: i + 6
								}, c: e.buffer[i]
							}
						}
						return o
					}, cardinality: 2, prevalidator: [{
						validator: function (t, e, i, n, r) {
							var o = r.regex.hrspre.test(t);
							return n || o || !(o = r.regex.hrs.test("0" + t)) ? o : (e.buffer[i] = "0", {pos: ++i})
						}, cardinality: 1
					}]
				}, s: {
					validator: "[0-5][0-9]", cardinality: 2, prevalidator: [{
						validator: function (t, e, i, n, r) {
							var o = r.regex.mspre.test(t);
							return n || o || !(o = r.regex.ms.test("0" + t)) ? o : (e.buffer[i] = "0", {pos: ++i})
						}, cardinality: 1
					}]
				}, t: {
					validator: function (t, e, i, n, r) {
						return r.regex.ampm.test(t + "m")
					}, casing: "lower", cardinality: 1
				}
			},
			insertMode: !1,
			autoUnmask: !1
		},
		datetime12: {mask: "1/2/y h:s t\\m", placeholder: "dd/mm/yyyy hh:mm xm", alias: "datetime", hourFormat: "12"},
		"mm/dd/yyyy hh:mm xm": {
			mask: "1/2/y h:s t\\m", placeholder: "mm/dd/yyyy hh:mm xm", alias: "datetime12", regex: {
				val2pre: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[13-9]|1[012])" + i + "[0-3])|(02" + i + "[0-2])")
				}, val2: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[1-9]|1[012])" + i + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + i + "30)|((0[13578]|1[02])" + i + "31)")
				}, val1pre: new RegExp("[01]"), val1: new RegExp("0[1-9]|1[012]")
			}, leapday: "02/29/", onKeyDown: function (i, n, r, o) {
				var a = t(this);
				if (i.ctrlKey && i.keyCode === e.keyCode.RIGHT) {
					var s = new Date;
					a.val((s.getMonth() + 1).toString() + s.getDate().toString() + s.getFullYear().toString()), a.trigger("setvalue")
				}
			}
		},
		"hh:mm t": {mask: "h:s t\\m", placeholder: "hh:mm xm", alias: "datetime", hourFormat: "12"},
		"h:s t": {mask: "h:s t\\m", placeholder: "hh:mm xm", alias: "datetime", hourFormat: "12"},
		"hh:mm:ss": {mask: "h:s:s", placeholder: "hh:mm:ss", alias: "datetime", autoUnmask: !1},
		"hh:mm": {mask: "h:s", placeholder: "hh:mm", alias: "datetime", autoUnmask: !1},
		date: {alias: "dd/mm/yyyy"},
		"mm/yyyy": {mask: "1/y", placeholder: "mm/yyyy", leapday: "donotuse", separator: "/", alias: "mm/dd/yyyy"},
		shamsi: {
			regex: {
				val2pre: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[1-9]|1[012])" + i + "[0-3])")
				}, val2: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[1-9]|1[012])" + i + "(0[1-9]|[12][0-9]))|((0[1-9]|1[012])" + i + "30)|((0[1-6])" + i + "31)")
				}, val1pre: new RegExp("[01]"), val1: new RegExp("0[1-9]|1[012]")
			}, yearrange: {minyear: 1300, maxyear: 1499}, mask: "y/1/2", leapday: "/12/30", placeholder: "yyyy/mm/dd", alias: "mm/dd/yyyy", clearIncomplete: !0
		},
		"yyyy-mm-dd hh:mm:ss": {
			mask: "y-1-2 h:s:s", placeholder: "yyyy-mm-dd hh:mm:ss", alias: "datetime", separator: "-", leapday: "-02-29", regex: {
				val2pre: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[13-9]|1[012])" + i + "[0-3])|(02" + i + "[0-2])")
				}, val2: function (t) {
					var i = e.escapeRegex.call(this, t);
					return new RegExp("((0[1-9]|1[012])" + i + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + i + "30)|((0[13578]|1[02])" + i + "31)")
				}, val1pre: new RegExp("[01]"), val1: new RegExp("0[1-9]|1[012]")
			}, onKeyDown: function (t, e, i, n) {
			}
		}
	}), e
}), function (t) {
	"function" == typeof define && define.amd ? define(["./dependencyLibs/inputmask.dependencyLib", "./inputmask"], t) : "object" == typeof exports ? module.exports = t(require("./dependencyLibs/inputmask.dependencyLib"), require("./inputmask")) : t(window.dependencyLib || jQuery, window.Inputmask)
}(function (t, e, i) {
	function n(t, i) {
		for (var n = "", r = 0; r < t.length; r++) e.prototype.definitions[t.charAt(r)] || i.definitions[t.charAt(r)] || i.optionalmarker.start === t.charAt(r) || i.optionalmarker.end === t.charAt(r) || i.quantifiermarker.start === t.charAt(r) || i.quantifiermarker.end === t.charAt(r) || i.groupmarker.start === t.charAt(r) || i.groupmarker.end === t.charAt(r) || i.alternatormarker === t.charAt(r) ? n += "\\" + t.charAt(r) : n += t.charAt(r);
		return n
	}

	return e.extendAliases({
		numeric: {
			mask: function (t) {
				if (0 !== t.repeat && isNaN(t.integerDigits) && (t.integerDigits = t.repeat), t.repeat = 0, t.groupSeparator === t.radixPoint && ("." === t.radixPoint ? t.groupSeparator = "," : "," === t.radixPoint ? t.groupSeparator = "." : t.groupSeparator = ""), " " === t.groupSeparator && (t.skipOptionalPartCharacter = i), t.autoGroup = t.autoGroup && "" !== t.groupSeparator, t.autoGroup && ("string" == typeof t.groupSize && isFinite(t.groupSize) && (t.groupSize = parseInt(t.groupSize)), isFinite(t.integerDigits))) {
					var e = Math.floor(t.integerDigits / t.groupSize), r = t.integerDigits % t.groupSize;
					t.integerDigits = parseInt(t.integerDigits) + (0 === r ? e - 1 : e), t.integerDigits < 1 && (t.integerDigits = "*")
				}
				t.placeholder.length > 1 && (t.placeholder = t.placeholder.charAt(0)), "radixFocus" === t.positionCaretOnClick && "" === t.placeholder && !1 === t.integerOptional && (t.positionCaretOnClick = "lvp"), t.definitions[";"] = t.definitions["~"], t.definitions[";"].definitionSymbol = "~", !0 === t.numericInput && (t.positionCaretOnClick = "radixFocus" === t.positionCaretOnClick ? "lvp" : t.positionCaretOnClick, t.digitsOptional = !1, isNaN(t.digits) && (t.digits = 2), t.decimalProtect = !1);
				var o = "[+]";
				if (o += n(t.prefix, t), !0 === t.integerOptional ? o += "~{1," + t.integerDigits + "}" : o += "~{" + t.integerDigits + "}", t.digits !== i) {
					t.radixPointDefinitionSymbol = t.decimalProtect ? ":" : t.radixPoint;
					var a = t.digits.toString().split(",");
					isFinite(a[0] && a[1] && isFinite(a[1])) ? o += t.radixPointDefinitionSymbol + ";{" + t.digits + "}" : (isNaN(t.digits) || parseInt(t.digits) > 0) && (t.digitsOptional ? o += "[" + t.radixPointDefinitionSymbol + ";{1," + t.digits + "}]" : o += t.radixPointDefinitionSymbol + ";{" + t.digits + "}")
				}
				return o += n(t.suffix, t), o += "[-]", t.greedy = !1, o
			},
			placeholder: "",
			greedy: !1,
			digits: "*",
			digitsOptional: !0,
			enforceDigitsOnBlur: !1,
			radixPoint: ".",
			positionCaretOnClick: "radixFocus",
			groupSize: 3,
			groupSeparator: "",
			autoGroup: !1,
			allowMinus: !0,
			negationSymbol: {front: "-", back: ""},
			integerDigits: "+",
			integerOptional: !0,
			prefix: "",
			suffix: "",
			rightAlign: !0,
			decimalProtect: !0,
			min: null,
			max: null,
			step: 1,
			insertMode: !0,
			autoUnmask: !1,
			unmaskAsNumber: !1,
			inputmode: "numeric",
			preValidation: function (e, n, r, o, a) {
				if ("-" === r || r === a.negationSymbol.front) return !0 === a.allowMinus && (a.isNegative = a.isNegative === i || !a.isNegative, "" === e.join("") || {caret: n, dopost: !0});
				if (!1 === o && r === a.radixPoint && a.digits !== i && (isNaN(a.digits) || parseInt(a.digits) > 0)) {
					var s = t.inArray(a.radixPoint, e);
					if (-1 !== s) return !0 === a.numericInput ? n === s : {caret: s + 1}
				}
				return !0
			},
			postValidation: function (n, r, o) {
				var a = o.suffix.split(""), s = o.prefix.split("");
				if (r.pos === i && r.caret !== i && !0 !== r.dopost) return r;
				var l = r.caret !== i ? r.caret : r.pos, c = n.slice();
				o.numericInput && (l = c.length - l - 1, c = c.reverse());
				var u = c[l];
				if (u === o.groupSeparator && (u = c[l += 1]), l === c.length - o.suffix.length - 1 && u === o.radixPoint) return r;
				u !== i && u !== o.radixPoint && u !== o.negationSymbol.front && u !== o.negationSymbol.back && (c[l] = "?", o.prefix.length > 0 && l >= (!1 === o.isNegative ? 1 : 0) && l < o.prefix.length - 1 + (!1 === o.isNegative ? 1 : 0) ? s[l - (!1 === o.isNegative ? 1 : 0)] = "?" : o.suffix.length > 0 && l >= c.length - o.suffix.length - (!1 === o.isNegative ? 1 : 0) && (a[l - (c.length - o.suffix.length - (!1 === o.isNegative ? 1 : 0))] = "?")), s = s.join(""), a = a.join("");
				var h = c.join("").replace(s, "");
				if (h = (h = (h = (h = h.replace(a, "")).replace(new RegExp(e.escapeRegex(o.groupSeparator), "g"), "")).replace(new RegExp("[-" + e.escapeRegex(o.negationSymbol.front) + "]", "g"), "")).replace(new RegExp(e.escapeRegex(o.negationSymbol.back) + "$"), ""), isNaN(o.placeholder) && (h = h.replace(new RegExp(e.escapeRegex(o.placeholder), "g"), "")), h.length > 1 && 1 !== h.indexOf(o.radixPoint) && ("0" === u && (h = h.replace(/^\?/g, "")), h = h.replace(/^0/g, "")), h.charAt(0) === o.radixPoint && "" !== o.radixPoint && !0 !== o.numericInput && (h = "0" + h), "" !== h) {
					if (h = h.split(""), (!o.digitsOptional || o.enforceDigitsOnBlur && "blur" === r.event) && isFinite(o.digits)) {
						var d = t.inArray(o.radixPoint, h), p = t.inArray(o.radixPoint, c);
						-1 === d && (h.push(o.radixPoint), d = h.length - 1);
						for (var f = 1; f <= o.digits; f++) o.digitsOptional && (!o.enforceDigitsOnBlur || "blur" !== r.event) || h[d + f] !== i && h[d + f] !== o.placeholder.charAt(0) ? -1 !== p && c[p + f] !== i && (h[d + f] = h[d + f] || c[p + f]) : h[d + f] = r.placeholder || o.placeholder.charAt(0)
					}
					if (!0 !== o.autoGroup || "" === o.groupSeparator || u === o.radixPoint && r.pos === i && !r.dopost) h = h.join(""); else {
						var m = h[h.length - 1] === o.radixPoint && r.c === o.radixPoint;
						h = e(function (t, e) {
							var i = "";
							if (i += "(" + e.groupSeparator + "*{" + e.groupSize + "}){*}", "" !== e.radixPoint) {
								var n = t.join("").split(e.radixPoint);
								n[1] && (i += e.radixPoint + "*{" + n[1].match(/^\d*\??\d*/)[0].length + "}")
							}
							return i
						}(h, o), {numericInput: !0, jitMasking: !0, definitions: {"*": {validator: "[0-9?]", cardinality: 1}}}).format(h.join("")), m && (h += o.radixPoint), h.charAt(0) === o.groupSeparator && h.substr(1)
					}
				}
				if (o.isNegative && "blur" === r.event && (o.isNegative = "0" !== h), h = s + h, h += a, o.isNegative && (h = o.negationSymbol.front + h, h += o.negationSymbol.back), h = h.split(""), u !== i) if (u !== o.radixPoint && u !== o.negationSymbol.front && u !== o.negationSymbol.back) (l = t.inArray("?", h)) > -1 ? h[l] = u : l = r.caret || 0; else if (u === o.radixPoint || u === o.negationSymbol.front || u === o.negationSymbol.back) {
					var g = t.inArray(u, h);
					-1 !== g && (l = g)
				}
				o.numericInput && (l = h.length - l - 1, h = h.reverse());
				var v = {caret: u === i || r.pos !== i ? l + (o.numericInput ? -1 : 1) : l, buffer: h, refreshFromBuffer: r.dopost || n.join("") !== h.join("")};
				return v.refreshFromBuffer ? v : r
			},
			onBeforeWrite: function (n, r, o, a) {
				if (n) switch (n.type) {
					case"keydown":
						return a.postValidation(r, {caret: o, dopost: !0}, a);
					case"blur":
					case"checkval":
						var s;
						if (function (t) {
							t.parseMinMaxOptions === i && (null !== t.min && (t.min = t.min.toString().replace(new RegExp(e.escapeRegex(t.groupSeparator), "g"), ""), "," === t.radixPoint && (t.min = t.min.replace(t.radixPoint, ".")), t.min = isFinite(t.min) ? parseFloat(t.min) : NaN, isNaN(t.min) && (t.min = Number.MIN_VALUE)), null !== t.max && (t.max = t.max.toString().replace(new RegExp(e.escapeRegex(t.groupSeparator), "g"), ""), "," === t.radixPoint && (t.max = t.max.replace(t.radixPoint, ".")), t.max = isFinite(t.max) ? parseFloat(t.max) : NaN, isNaN(t.max) && (t.max = Number.MAX_VALUE)), t.parseMinMaxOptions = "done")
						}(a), null !== a.min || null !== a.max) {
							if (s = a.onUnMask(r.join(""), i, t.extend({}, a, {unmaskAsNumber: !0})), null !== a.min && s < a.min) return a.isNegative = a.min < 0, a.postValidation(a.min.toString().replace(".", a.radixPoint).split(""), {caret: o, dopost: !0, placeholder: "0"}, a);
							if (null !== a.max && s > a.max) return a.isNegative = a.max < 0, a.postValidation(a.max.toString().replace(".", a.radixPoint).split(""), {caret: o, dopost: !0, placeholder: "0"}, a)
						}
						return a.postValidation(r, {caret: o, placeholder: "0", event: "blur"}, a);
					case"_checkval":
						return {caret: o}
				}
			},
			regex: {
				integerPart: function (t, i) {
					return i ? new RegExp("[" + e.escapeRegex(t.negationSymbol.front) + "+]?") : new RegExp("[" + e.escapeRegex(t.negationSymbol.front) + "+]?\\d+")
				}, integerNPart: function (t) {
					return new RegExp("[\\d" + e.escapeRegex(t.groupSeparator) + e.escapeRegex(t.placeholder.charAt(0)) + "]+")
				}
			},
			definitions: {
				"~": {
					validator: function (t, n, r, o, a, s) {
						var l = o ? new RegExp("[0-9" + e.escapeRegex(a.groupSeparator) + "]").test(t) : new RegExp("[0-9]").test(t);
						if (!0 === l) {
							if (!0 !== a.numericInput && n.validPositions[r] !== i && "~" === n.validPositions[r].match.def && !s) {
								var c = n.buffer.join(""), u = (c = (c = c.replace(new RegExp("[-" + e.escapeRegex(a.negationSymbol.front) + "]", "g"), "")).replace(new RegExp(e.escapeRegex(a.negationSymbol.back) + "$"), "")).split(a.radixPoint);
								u.length > 1 && (u[1] = u[1].replace(/0/g, a.placeholder.charAt(0))), "0" === u[0] && (u[0] = u[0].replace(/0/g, a.placeholder.charAt(0))), c = u[0] + a.radixPoint + u[1] || "";
								var h = n._buffer.join("");
								for (c === a.radixPoint && (c = h); null === c.match(e.escapeRegex(h) + "$");) h = h.slice(1);
								l = (c = (c = c.replace(h, "")).split(""))[r] === i ? {pos: r, remove: r} : {pos: r}
							}
						} else o || t !== a.radixPoint || n.validPositions[r - 1] !== i || (n.buffer[r] = "0", l = {pos: r + 1});
						return l
					}, cardinality: 1
				}, "+": {
					validator: function (t, e, i, n, r) {
						return r.allowMinus && ("-" === t || t === r.negationSymbol.front)
					}, cardinality: 1, placeholder: ""
				}, "-": {
					validator: function (t, e, i, n, r) {
						return r.allowMinus && t === r.negationSymbol.back
					}, cardinality: 1, placeholder: ""
				}, ":": {
					validator: function (t, i, n, r, o) {
						var a = "[" + e.escapeRegex(o.radixPoint) + "]", s = new RegExp(a).test(t);
						return s && i.validPositions[n] && i.validPositions[n].match.placeholder === o.radixPoint && (s = {caret: n + 1}), s
					}, cardinality: 1, placeholder: function (t) {
						return t.radixPoint
					}
				}
			},
			onUnMask: function (t, i, n) {
				if ("" === i && !0 === n.nullable) return i;
				var r = t.replace(n.prefix, "");
				return r = (r = r.replace(n.suffix, "")).replace(new RegExp(e.escapeRegex(n.groupSeparator), "g"), ""), "" !== n.placeholder.charAt(0) && (r = r.replace(new RegExp(n.placeholder.charAt(0), "g"), "0")), n.unmaskAsNumber ? ("" !== n.radixPoint && -1 !== r.indexOf(n.radixPoint) && (r = r.replace(e.escapeRegex.call(this, n.radixPoint), ".")), r = (r = r.replace(new RegExp("^" + e.escapeRegex(n.negationSymbol.front)), "-")).replace(new RegExp(e.escapeRegex(n.negationSymbol.back) + "$"), ""), Number(r)) : r
			},
			isComplete: function (t, i) {
				var n = t.join("");
				if (t.slice().join("") !== n) return !1;
				var r = n.replace(i.prefix, "");
				return r = (r = r.replace(i.suffix, "")).replace(new RegExp(e.escapeRegex(i.groupSeparator), "g"), ""), "," === i.radixPoint && (r = r.replace(e.escapeRegex(i.radixPoint), ".")), isFinite(r)
			},
			onBeforeMask: function (t, n) {
				if (n.isNegative = i, t = t.toString().charAt(t.length - 1) === n.radixPoint ? t.toString().substr(0, t.length - 1) : t.toString(), "" !== n.radixPoint && isFinite(t)) {
					var r = t.split("."), o = "" !== n.groupSeparator ? parseInt(n.groupSize) : 0;
					2 === r.length && (r[0].length > o || r[1].length > o || r[0].length <= o && r[1].length < o) && (t = t.replace(".", n.radixPoint))
				}
				var a = t.match(/,/g), s = t.match(/\./g);
				if (t = s && a ? s.length > a.length ? (t = t.replace(/\./g, "")).replace(",", n.radixPoint) : a.length > s.length ? (t = t.replace(/,/g, "")).replace(".", n.radixPoint) : t.indexOf(".") < t.indexOf(",") ? t.replace(/\./g, "") : t.replace(/,/g, "") : t.replace(new RegExp(e.escapeRegex(n.groupSeparator), "g"), ""), 0 === n.digits && (-1 !== t.indexOf(".") ? t = t.substring(0, t.indexOf(".")) : -1 !== t.indexOf(",") && (t = t.substring(0, t.indexOf(",")))), "" !== n.radixPoint && isFinite(n.digits) && -1 !== t.indexOf(n.radixPoint)) {
					var l = t.split(n.radixPoint)[1].match(new RegExp("\\d*"))[0];
					if (parseInt(n.digits) < l.toString().length) {
						var c = Math.pow(10, parseInt(n.digits));
						t = t.replace(e.escapeRegex(n.radixPoint), "."), t = (t = Math.round(parseFloat(t) * c) / c).toString().replace(".", n.radixPoint)
					}
				}
				return t
			},
			canClearPosition: function (t, e, i, n, r) {
				var o = t.validPositions[e],
					a = o.input !== r.radixPoint || null !== t.validPositions[e].match.fn && !1 === r.decimalProtect || o.input === r.radixPoint && t.validPositions[e + 1] && null === t.validPositions[e + 1].match.fn || isFinite(o.input) || e === i || o.input === r.groupSeparator || o.input === r.negationSymbol.front || o.input === r.negationSymbol.back;
				return !a || "+" !== o.match.nativeDef && "-" !== o.match.nativeDef || (r.isNegative = !1), a
			},
			onKeyDown: function (i, n, r, o) {
				var a = t(this);
				if (i.ctrlKey) switch (i.keyCode) {
					case e.keyCode.UP:
						a.val(parseFloat(this.inputmask.unmaskedvalue()) + parseInt(o.step)), a.trigger("setvalue");
						break;
					case e.keyCode.DOWN:
						a.val(parseFloat(this.inputmask.unmaskedvalue()) - parseInt(o.step)), a.trigger("setvalue")
				}
			}
		},
		currency: {prefix: "$ ", groupSeparator: ",", alias: "numeric", placeholder: "0", autoGroup: !0, digits: 2, digitsOptional: !1, clearMaskOnLostFocus: !1},
		decimal: {alias: "numeric"},
		integer: {alias: "numeric", digits: 0, radixPoint: ""},
		percentage: {alias: "numeric", digits: 2, digitsOptional: !0, radixPoint: ".", placeholder: "0", autoGroup: !1, min: 0, max: 100, suffix: " %", allowMinus: !1}
	}), e
}), function (t) {
	"function" == typeof define && define.amd ? define(["./dependencyLibs/inputmask.dependencyLib", "./inputmask"], t) : "object" == typeof exports ? module.exports = t(require("./dependencyLibs/inputmask.dependencyLib"), require("./inputmask")) : t(window.dependencyLib || jQuery, window.Inputmask)
}(function (t, e) {
	function i(t, e) {
		var i = (t.mask || t).replace(/#/g, "9").replace(/\)/, "9").replace(/[+()#-]/g, ""), n = (e.mask || e).replace(/#/g, "9").replace(/\)/, "9").replace(/[+()#-]/g, ""), r = (t.mask || t).split("#")[0], o = (e.mask || e).split("#")[0];
		return 0 === o.indexOf(r) ? -1 : 0 === r.indexOf(o) ? 1 : i.localeCompare(n)
	}

	var n = e.prototype.analyseMask;
	return e.prototype.analyseMask = function (e, i, r) {
		var o = {};
		return r.phoneCodes && (r.phoneCodes && r.phoneCodes.length > 1e3 && (function t(i, n, r) {
			r = r || o, "" !== (n = n || "") && (r[n] = {});
			for (var a = "", s = r[n] || r, l = i.length - 1; l >= 0; l--) s[a = (e = i[l].mask || i[l]).substr(0, 1)] = s[a] || [], s[a].unshift(e.substr(1)), i.splice(l, 1);
			for (var c in s) s[c].length > 500 && t(s[c].slice(), c, s)
		}((e = e.substr(1, e.length - 2)).split(r.groupmarker.end + r.alternatormarker + r.groupmarker.start)), e = function e(i) {
			var n = "", o = [];
			for (var a in i) t.isArray(i[a]) ? 1 === i[a].length ? o.push(a + i[a]) : o.push(a + r.groupmarker.start + i[a].join(r.groupmarker.end + r.alternatormarker + r.groupmarker.start) + r.groupmarker.end) : o.push(a + e(i[a]));
			return 1 === o.length ? n += o[0] : n += r.groupmarker.start + o.join(r.groupmarker.end + r.alternatormarker + r.groupmarker.start) + r.groupmarker.end, n
		}(o)), e = e.replace(/9/g, "\\9")), n.call(this, e, i, r)
	}, e.extendAliases({
		abstractphone: {
			groupmarker: {start: "<", end: ">"}, countrycode: "", phoneCodes: [], mask: function (t) {
				return t.definitions = {"#": e.prototype.definitions[9]}, t.phoneCodes.sort(i)
			}, keepStatic: !0, onBeforeMask: function (t, e) {
				var i = t.replace(/^0{1,2}/, "").replace(/[\s]/g, "");
				return (i.indexOf(e.countrycode) > 1 || -1 === i.indexOf(e.countrycode)) && (i = "+" + e.countrycode + i), i
			}, onUnMask: function (t, e, i) {
				return t.replace(/[()#-]/g, "")
			}, inputmode: "tel"
		}
	}), e
}), function (t) {
	"function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? module.exports = t() : window.noUiSlider = t()
}(function () {
	"use strict";
	var t = "10.1.0";

	function e(t) {
		t.preventDefault()
	}

	function i(t) {
		return "number" == typeof t && !isNaN(t) && isFinite(t)
	}

	function n(t, e, i) {
		i > 0 && (a(t, e), setTimeout(function () {
			s(t, e)
		}, i))
	}

	function r(t) {
		return Array.isArray(t) ? t : [t]
	}

	function o(t) {
		var e = (t = String(t)).split(".");
		return e.length > 1 ? e[1].length : 0
	}

	function a(t, e) {
		t.classList ? t.classList.add(e) : t.className += " " + e
	}

	function s(t, e) {
		t.classList ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\b)" + e.split(" ").join("|") + "(\\b|$)", "gi"), " ")
	}

	function l(t) {
		var e = void 0 !== window.pageXOffset, i = "CSS1Compat" === (t.compatMode || "");
		return {x: e ? window.pageXOffset : i ? t.documentElement.scrollLeft : t.body.scrollLeft, y: e ? window.pageYOffset : i ? t.documentElement.scrollTop : t.body.scrollTop}
	}

	function c(t, e) {
		return 100 / (e - t)
	}

	function u(t, e) {
		return 100 * e / (t[1] - t[0])
	}

	function h(t, e) {
		for (var i = 1; t >= e[i];) i += 1;
		return i
	}

	function d(t, e, i) {
		if (i >= t.slice(-1)[0]) return 100;
		var n, r, o, a, s = h(i, t);
		return n = t[s - 1], r = t[s], o = e[s - 1], a = e[s], o + function (t, e) {
			return u(t, t[0] < 0 ? e + Math.abs(t[0]) : e - t[0])
		}([n, r], i) / c(o, a)
	}

	function p(t, e, i, n) {
		if (100 === n) return n;
		var r, o, a = h(n, t);
		return i ? n - (r = t[a - 1]) > ((o = t[a]) - r) / 2 ? o : r : e[a - 1] ? t[a - 1] + function (t, e) {
			return Math.round(t / e) * e
		}(n - t[a - 1], e[a - 1]) : n
	}

	function f(e, n, r) {
		var o;
		if ("number" == typeof n && (n = [n]), "[object Array]" !== Object.prototype.toString.call(n)) throw new Error("noUiSlider (" + t + "): 'range' contains invalid value.");
		if (!i(o = "min" === e ? 0 : "max" === e ? 100 : parseFloat(e)) || !i(n[0])) throw new Error("noUiSlider (" + t + "): 'range' value isn't numeric.");
		r.xPct.push(o), r.xVal.push(n[0]), o ? r.xSteps.push(!isNaN(n[1]) && n[1]) : isNaN(n[1]) || (r.xSteps[0] = n[1]), r.xHighestCompleteStep.push(0)
	}

	function m(t, e, i) {
		if (!e) return !0;
		i.xSteps[t] = u([i.xVal[t], i.xVal[t + 1]], e) / c(i.xPct[t], i.xPct[t + 1]);
		var n = (i.xVal[t + 1] - i.xVal[t]) / i.xNumSteps[t], r = Math.ceil(Number(n.toFixed(3)) - 1), o = i.xVal[t] + i.xNumSteps[t] * r;
		i.xHighestCompleteStep[t] = o
	}

	function g(t, e, i) {
		this.xPct = [], this.xVal = [], this.xSteps = [i || !1], this.xNumSteps = [!1], this.xHighestCompleteStep = [], this.snap = e;
		var n, r = [];
		for (n in t) t.hasOwnProperty(n) && r.push([t[n], n]);
		for (r.length && "object" == typeof r[0][0] ? r.sort(function (t, e) {
			return t[0][0] - e[0][0]
		}) : r.sort(function (t, e) {
			return t[0] - e[0]
		}), n = 0; n < r.length; n++) f(r[n][1], r[n][0], this);
		for (this.xNumSteps = this.xSteps.slice(0), n = 0; n < this.xNumSteps.length; n++) m(n, this.xNumSteps[n], this)
	}

	g.prototype.getMargin = function (e) {
		var i = this.xNumSteps[0];
		if (i && e / i % 1 != 0) throw new Error("noUiSlider (" + t + "): 'limit', 'margin' and 'padding' must be divisible by step.");
		return 2 === this.xPct.length && u(this.xVal, e)
	}, g.prototype.toStepping = function (t) {
		return t = d(this.xVal, this.xPct, t)
	}, g.prototype.fromStepping = function (t) {
		return function (t, e, i) {
			if (i >= 100) return t.slice(-1)[0];
			var n, r = h(i, e);
			return function (t, e) {
				return e * (t[1] - t[0]) / 100 + t[0]
			}([t[r - 1], t[r]], (i - (n = e[r - 1])) * c(n, e[r]))
		}(this.xVal, this.xPct, t)
	}, g.prototype.getStep = function (t) {
		return t = p(this.xPct, this.xSteps, this.snap, t)
	}, g.prototype.getNearbySteps = function (t) {
		var e = h(t, this.xPct);
		return {
			stepBefore: {startValue: this.xVal[e - 2], step: this.xNumSteps[e - 2], highestStep: this.xHighestCompleteStep[e - 2]},
			thisStep: {startValue: this.xVal[e - 1], step: this.xNumSteps[e - 1], highestStep: this.xHighestCompleteStep[e - 1]},
			stepAfter: {startValue: this.xVal[e - 0], step: this.xNumSteps[e - 0], highestStep: this.xHighestCompleteStep[e - 0]}
		}
	}, g.prototype.countStepDecimals = function () {
		var t = this.xNumSteps.map(o);
		return Math.max.apply(null, t)
	}, g.prototype.convert = function (t) {
		return this.getStep(this.toStepping(t))
	};
	var v = {
		to: function (t) {
			return void 0 !== t && t.toFixed(2)
		}, from: Number
	};

	function y(e) {
		if (function (t) {
			return "object" == typeof t && "function" == typeof t.to && "function" == typeof t.from
		}(e)) return !0;
		throw new Error("noUiSlider (" + t + "): 'format' requires 'to' and 'from' methods.")
	}

	function b(e, n) {
		if (!i(n)) throw new Error("noUiSlider (" + t + "): 'step' is not numeric.");
		e.singleStep = n
	}

	function w(e, i) {
		if ("object" != typeof i || Array.isArray(i)) throw new Error("noUiSlider (" + t + "): 'range' is not an object.");
		if (void 0 === i.min || void 0 === i.max) throw new Error("noUiSlider (" + t + "): Missing 'min' or 'max' in 'range'.");
		if (i.min === i.max) throw new Error("noUiSlider (" + t + "): 'range' 'min' and 'max' cannot be equal.");
		e.spectrum = new g(i, e.snap, e.singleStep)
	}

	function x(e, i) {
		if (i = r(i), !Array.isArray(i) || !i.length) throw new Error("noUiSlider (" + t + "): 'start' option is incorrect.");
		e.handles = i.length, e.start = i
	}

	function k(e, i) {
		if (e.snap = i, "boolean" != typeof i) throw new Error("noUiSlider (" + t + "): 'snap' option must be a boolean.")
	}

	function _(e, i) {
		if (e.animate = i, "boolean" != typeof i) throw new Error("noUiSlider (" + t + "): 'animate' option must be a boolean.")
	}

	function S(e, i) {
		if (e.animationDuration = i, "number" != typeof i) throw new Error("noUiSlider (" + t + "): 'animationDuration' option must be a number.")
	}

	function C(e, i) {
		var n, r = [!1];
		if ("lower" === i ? i = [!0, !1] : "upper" === i && (i = [!1, !0]), !0 === i || !1 === i) {
			for (n = 1; n < e.handles; n++) r.push(i);
			r.push(!1)
		} else {
			if (!Array.isArray(i) || !i.length || i.length !== e.handles + 1) throw new Error("noUiSlider (" + t + "): 'connect' option doesn't match handle count.");
			r = i
		}
		e.connect = r
	}

	function D(e, i) {
		switch (i) {
			case"horizontal":
				e.ort = 0;
				break;
			case"vertical":
				e.ort = 1;
				break;
			default:
				throw new Error("noUiSlider (" + t + "): 'orientation' option is invalid.")
		}
	}

	function T(e, n) {
		if (!i(n)) throw new Error("noUiSlider (" + t + "): 'margin' option must be numeric.");
		if (0 !== n && (e.margin = e.spectrum.getMargin(n), !e.margin)) throw new Error("noUiSlider (" + t + "): 'margin' option is only supported on linear sliders.")
	}

	function M(e, n) {
		if (!i(n)) throw new Error("noUiSlider (" + t + "): 'limit' option must be numeric.");
		if (e.limit = e.spectrum.getMargin(n), !e.limit || e.handles < 2) throw new Error("noUiSlider (" + t + "): 'limit' option is only supported on linear sliders with 2 or more handles.")
	}

	function E(e, n) {
		if (!i(n)) throw new Error("noUiSlider (" + t + "): 'padding' option must be numeric.");
		if (0 !== n) {
			if (e.padding = e.spectrum.getMargin(n), !e.padding) throw new Error("noUiSlider (" + t + "): 'padding' option is only supported on linear sliders.");
			if (e.padding < 0) throw new Error("noUiSlider (" + t + "): 'padding' option must be a positive number.");
			if (e.padding >= 50) throw new Error("noUiSlider (" + t + "): 'padding' option must be less than half the range.")
		}
	}

	function A(e, i) {
		switch (i) {
			case"ltr":
				e.dir = 0;
				break;
			case"rtl":
				e.dir = 1;
				break;
			default:
				throw new Error("noUiSlider (" + t + "): 'direction' option was not recognized.")
		}
	}

	function P(e, i) {
		if ("string" != typeof i) throw new Error("noUiSlider (" + t + "): 'behaviour' must be a string containing options.");
		var n = i.indexOf("tap") >= 0, r = i.indexOf("drag") >= 0, o = i.indexOf("fixed") >= 0, a = i.indexOf("snap") >= 0, s = i.indexOf("hover") >= 0;
		if (o) {
			if (2 !== e.handles) throw new Error("noUiSlider (" + t + "): 'fixed' behaviour must be used with 2 handles");
			T(e, e.start[1] - e.start[0])
		}
		e.events = {tap: n || a, drag: r, fixed: o, snap: a, hover: s}
	}

	function I(e, i) {
		if (e.multitouch = i, "boolean" != typeof i) throw new Error("noUiSlider (" + t + "): 'multitouch' option must be a boolean.")
	}

	function O(e, i) {
		if (!1 !== i) if (!0 === i) {
			e.tooltips = [];
			for (var n = 0; n < e.handles; n++) e.tooltips.push(!0)
		} else {
			if (e.tooltips = r(i), e.tooltips.length !== e.handles) throw new Error("noUiSlider (" + t + "): must pass a formatter for all handles.");
			e.tooltips.forEach(function (e) {
				if ("boolean" != typeof e && ("object" != typeof e || "function" != typeof e.to)) throw new Error("noUiSlider (" + t + "): 'tooltips' must be passed a formatter or 'false'.")
			})
		}
	}

	function L(t, e) {
		t.ariaFormat = e, y(e)
	}

	function F(t, e) {
		t.format = e, y(e)
	}

	function N(e, i) {
		if (void 0 !== i && "string" != typeof i && !1 !== i) throw new Error("noUiSlider (" + t + "): 'cssPrefix' must be a string or `false`.");
		e.cssPrefix = i
	}

	function R(e, i) {
		if (void 0 !== i && "object" != typeof i) throw new Error("noUiSlider (" + t + "): 'cssClasses' must be an object.");
		if ("string" == typeof e.cssPrefix) for (var n in e.cssClasses = {}, i) i.hasOwnProperty(n) && (e.cssClasses[n] = e.cssPrefix + i[n]); else e.cssClasses = i
	}

	function H(e, i) {
		if (!0 !== i && !1 !== i) throw new Error("noUiSlider (" + t + "): 'useRequestAnimationFrame' option should be true (default) or false.");
		e.useRequestAnimationFrame = i
	}

	function $(e) {
		var i = {margin: 0, limit: 0, padding: 0, animate: !0, animationDuration: 300, ariaFormat: v, format: v}, n = {
			step: {r: !1, t: b},
			start: {r: !0, t: x},
			connect: {r: !0, t: C},
			direction: {r: !0, t: A},
			snap: {r: !1, t: k},
			animate: {r: !1, t: _},
			animationDuration: {r: !1, t: S},
			range: {r: !0, t: w},
			orientation: {r: !1, t: D},
			margin: {r: !1, t: T},
			limit: {r: !1, t: M},
			padding: {r: !1, t: E},
			behaviour: {r: !0, t: P},
			multitouch: {r: !0, t: I},
			ariaFormat: {r: !1, t: L},
			format: {r: !1, t: F},
			tooltips: {r: !1, t: O},
			cssPrefix: {r: !1, t: N},
			cssClasses: {r: !1, t: R},
			useRequestAnimationFrame: {r: !1, t: H}
		}, r = {
			connect: !1,
			direction: "ltr",
			behaviour: "tap",
			multitouch: !1,
			orientation: "horizontal",
			cssPrefix: "noUi-",
			cssClasses: {
				target: "target",
				base: "base",
				origin: "origin",
				handle: "handle",
				handleLower: "handle-lower",
				handleUpper: "handle-upper",
				horizontal: "horizontal",
				vertical: "vertical",
				background: "background",
				connect: "connect",
				ltr: "ltr",
				rtl: "rtl",
				draggable: "draggable",
				drag: "state-drag",
				tap: "state-tap",
				active: "active",
				tooltip: "tooltip",
				pips: "pips",
				pipsHorizontal: "pips-horizontal",
				pipsVertical: "pips-vertical",
				marker: "marker",
				markerHorizontal: "marker-horizontal",
				markerVertical: "marker-vertical",
				markerNormal: "marker-normal",
				markerLarge: "marker-large",
				markerSub: "marker-sub",
				value: "value",
				valueHorizontal: "value-horizontal",
				valueVertical: "value-vertical",
				valueNormal: "value-normal",
				valueLarge: "value-large",
				valueSub: "value-sub"
			},
			useRequestAnimationFrame: !0
		};
		e.format && !e.ariaFormat && (e.ariaFormat = e.format), Object.keys(n).forEach(function (o) {
			if (void 0 === e[o] && void 0 === r[o]) {
				if (n[o].r) throw new Error("noUiSlider (" + t + "): '" + o + "' is required.");
				return !0
			}
			n[o].t(i, void 0 === e[o] ? r[o] : e[o])
		}), i.pips = e.pips;
		var o = [["left", "top"], ["right", "bottom"]];
		return i.style = o[i.dir][i.ort], i.styleOposite = o[i.dir ? 0 : 1][i.ort], i
	}

	function B(i, o, c) {
		var u, h, d, p, f, m, g, v = window.navigator.pointerEnabled ? {start: "pointerdown", move: "pointermove", end: "pointerup"} : window.navigator.msPointerEnabled ? {start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp"} : {
			start: "mousedown touchstart",
			move: "mousemove touchmove",
			end: "mouseup touchend"
		}, y = window.CSS && CSS.supports && CSS.supports("touch-action", "none") && function () {
			var t = !1;
			try {
				var e = Object.defineProperty({}, "passive", {
					get: function () {
						t = !0
					}
				});
				window.addEventListener("test", null, e)
			} catch (t) {
			}
			return t
		}(), b = i, w = [], x = [], k = 0, _ = o.spectrum, S = [], C = {}, D = i.ownerDocument, T = D.documentElement, M = D.body;

		function E(t, e) {
			var i = D.createElement("div");
			return e && a(i, e), t.appendChild(i), i
		}

		function A(t, e) {
			var i = E(t, o.cssClasses.origin), n = E(i, o.cssClasses.handle);
			return n.setAttribute("data-handle", e), n.setAttribute("tabindex", "0"), n.setAttribute("role", "slider"), n.setAttribute("aria-orientation", o.ort ? "vertical" : "horizontal"), 0 === e ? a(n, o.cssClasses.handleLower) : e === o.handles - 1 && a(n, o.cssClasses.handleUpper), i
		}

		function P(t, e) {
			return !!e && E(t, o.cssClasses.connect)
		}

		function I(t, e) {
			return !!o.tooltips[e] && E(t.firstChild, o.cssClasses.tooltip)
		}

		function O(t, e, i) {
			var n = D.createElement("div"), r = [o.cssClasses.valueNormal, o.cssClasses.valueLarge, o.cssClasses.valueSub], s = [o.cssClasses.markerNormal, o.cssClasses.markerLarge, o.cssClasses.markerSub], l = [o.cssClasses.valueHorizontal, o.cssClasses.valueVertical],
				c = [o.cssClasses.markerHorizontal, o.cssClasses.markerVertical];

			function u(t, e) {
				var i = e === o.cssClasses.value, n = i ? r : s;
				return e + " " + (i ? l : c)[o.ort] + " " + n[t]
			}

			return a(n, o.cssClasses.pips), a(n, 0 === o.ort ? o.cssClasses.pipsHorizontal : o.cssClasses.pipsVertical), Object.keys(t).forEach(function (r) {
				!function (t, r) {
					r[1] = r[1] && e ? e(r[0], r[1]) : r[1];
					var a = E(n, !1);
					a.className = u(r[1], o.cssClasses.marker), a.style[o.style] = t + "%", r[1] && ((a = E(n, !1)).className = u(r[1], o.cssClasses.value), a.style[o.style] = t + "%", a.innerText = i.to(r[0]))
				}(r, t[r])
			}), n
		}

		function L() {
			var t;
			f && ((t = f).parentElement.removeChild(t), f = null)
		}

		function F(e) {
			L();
			var i = e.mode, n = e.density || 1, r = e.filter || !1, o = function (e, i, n) {
				if ("range" === e || "steps" === e) return _.xVal;
				if ("count" === e) {
					if (!i) throw new Error("noUiSlider (" + t + "): 'values' required for mode 'count'.");
					var r, o = 100 / (i - 1), a = 0;
					for (i = []; (r = a++ * o) <= 100;) i.push(r);
					e = "positions"
				}
				return "positions" === e ? i.map(function (t) {
					return _.fromStepping(n ? _.getStep(t) : t)
				}) : "values" === e ? n ? i.map(function (t) {
					return _.fromStepping(_.getStep(_.toStepping(t)))
				}) : i : void 0
			}(i, e.values || !1, e.stepped || !1), a = function (t, e, i) {
				var n, r = {}, o = _.xVal[0], a = _.xVal[_.xVal.length - 1], s = !1, l = !1, c = 0;
				return n = i.slice().sort(function (t, e) {
					return t - e
				}), (i = n.filter(function (t) {
					return !this[t] && (this[t] = !0)
				}, {}))[0] !== o && (i.unshift(o), s = !0), i[i.length - 1] !== a && (i.push(a), l = !0), i.forEach(function (n, o) {
					var a, u, h, d, p, f, m, g, v, y = n, b = i[o + 1];
					if ("steps" === e && (a = _.xNumSteps[o]), a || (a = b - y), !1 !== y && void 0 !== b) for (a = Math.max(a, 1e-7), u = y; u <= b; u = (u + a).toFixed(7) / 1) {
						for (m = (p = (d = _.toStepping(u)) - c) / t, v = p / (g = Math.round(m)), h = 1; h <= g; h += 1) r[(c + h * v).toFixed(5)] = ["x", 0];
						f = i.indexOf(u) > -1 ? 1 : "steps" === e ? 2 : 0, !o && s && (f = 0), u === b && l || (r[d.toFixed(5)] = [u, f]), c = d
					}
				}), r
			}(n, i, o), s = e.format || {to: Math.round};
			return f = b.appendChild(O(a, r, s))
		}

		function N() {
			var t = u.getBoundingClientRect(), e = "offset" + ["Width", "Height"][o.ort];
			return 0 === o.ort ? t.width || u[e] : t.height || u[e]
		}

		function R(t, e, i, n) {
			var r = function (r) {
				return !b.hasAttribute("disabled") && (a = b, s = o.cssClasses.tap, (a.classList ? !a.classList.contains(s) : !new RegExp("\\b" + s + "\\b").test(a.className)) && (!!(r = function (t, e, i) {
					var n, r, a = 0 === t.type.indexOf("touch"), s = 0 === t.type.indexOf("mouse"), c = 0 === t.type.indexOf("pointer");
					0 === t.type.indexOf("MSPointer") && (c = !0);
					if (a && o.multitouch) {
						var u = function (t) {
							return t.target === i || i.contains(t.target)
						};
						if ("touchstart" === t.type) {
							var h = Array.prototype.filter.call(t.touches, u);
							if (h.length > 1) return !1;
							n = h[0].pageX, r = h[0].pageY
						} else {
							var d = Array.prototype.find.call(t.changedTouches, u);
							if (!d) return !1;
							n = d.pageX, r = d.pageY
						}
					} else if (a) {
						if (t.touches.length > 1) return !1;
						n = t.changedTouches[0].pageX, r = t.changedTouches[0].pageY
					}
					e = e || l(D), (s || c) && (n = t.clientX + e.x, r = t.clientY + e.y);
					return t.pageOffset = e, t.points = [n, r], t.cursor = s || c, t
				}(r, n.pageOffset, n.target || e)) && (!(t === v.start && void 0 !== r.buttons && r.buttons > 1) && ((!n.hover || !r.buttons) && (y || r.preventDefault(), r.calcPoint = r.points[o.ort], void i(r, n))))));
				var a, s
			}, a = [];
			return t.split(" ").forEach(function (t) {
				e.addEventListener(t, r, !!y && {passive: !0}), a.push([t, r])
			}), a
		}

		function H(t) {
			var e, i, n, r, a, s, c = 100 * (t - (e = u, i = o.ort, n = e.getBoundingClientRect(), r = e.ownerDocument, a = r.documentElement, s = l(r), /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (s.x = 0), i ? n.top + s.y - a.clientTop : n.left + s.x - a.clientLeft)) / N();
			return o.dir ? 100 - c : c
		}

		function B(t, e, i, n) {
			var r = i.slice(), o = [!t, t], a = [t, !t];
			n = n.slice(), t && n.reverse(), n.length > 1 ? n.forEach(function (t, i) {
				var n = G(r, t, r[t] + e, o[i], a[i], !1);
				!1 === n ? e = 0 : (e = n - r[t], r[t] = n)
			}) : o = a = [!0];
			var s = !1;
			n.forEach(function (t, n) {
				s = Z(t, i[t] + e, o[n], a[n]) || s
			}), s && n.forEach(function (t) {
				z("update", t), z("slide", t)
			})
		}

		function z(t, e, i) {
			Object.keys(C).forEach(function (n) {
				var r = n.split(".")[0];
				t === r && C[n].forEach(function (t) {
					t.call(p, S.map(o.format.to), e, S.slice(), i || !1, w.slice())
				})
			})
		}

		function j(t, e) {
			"mouseout" === t.type && "HTML" === t.target.nodeName && null === t.relatedTarget && W(t, e)
		}

		function U(t, e) {
			if (-1 === navigator.appVersion.indexOf("MSIE 9") && 0 === t.buttons && 0 !== e.buttonsProperty) return W(t, e);
			var i = (o.dir ? -1 : 1) * (t.calcPoint - e.startCalcPoint);
			B(i > 0, 100 * i / e.baseSize, e.locations, e.handleNumbers)
		}

		function W(t, i) {
			i.handle && (s(i.handle, o.cssClasses.active), k -= 1), i.listeners.forEach(function (t) {
				T.removeEventListener(t[0], t[1])
			}), 0 === k && (s(b, o.cssClasses.drag), X(), t.cursor && (M.style.cursor = "", M.removeEventListener("selectstart", e))), i.handleNumbers.forEach(function (t) {
				z("change", t), z("set", t), z("end", t)
			})
		}

		function Y(t, i) {
			var n;
			if (1 === i.handleNumbers.length) {
				var r = h[i.handleNumbers[0]];
				if (r.hasAttribute("disabled")) return !1;
				n = r.children[0], k += 1, a(n, o.cssClasses.active)
			}
			t.stopPropagation();
			var s = [], l = R(v.move, T, U, {target: t.target, handle: n, listeners: s, startCalcPoint: t.calcPoint, baseSize: N(), pageOffset: t.pageOffset, handleNumbers: i.handleNumbers, buttonsProperty: t.buttons, locations: w.slice()}),
				c = R(v.end, T, W, {target: t.target, handle: n, listeners: s, handleNumbers: i.handleNumbers}), u = R("mouseout", T, j, {target: t.target, handle: n, listeners: s, handleNumbers: i.handleNumbers});
			s.push.apply(s, l.concat(c, u)), t.cursor && (M.style.cursor = getComputedStyle(t.target).cursor, h.length > 1 && a(b, o.cssClasses.drag), M.addEventListener("selectstart", e, !1)), i.handleNumbers.forEach(function (t) {
				z("start", t)
			})
		}

		function V(t) {
			t.stopPropagation();
			var e = H(t.calcPoint), i = function (t) {
				var e = 100, i = !1;
				return h.forEach(function (n, r) {
					if (!n.hasAttribute("disabled")) {
						var o = Math.abs(w[r] - t);
						o < e && (i = r, e = o)
					}
				}), i
			}(e);
			if (!1 === i) return !1;
			o.events.snap || n(b, o.cssClasses.tap, o.animationDuration), Z(i, e, !0, !0), X(), z("slide", i, !0), z("update", i, !0), z("change", i, !0), z("set", i, !0), o.events.snap && Y(t, {handleNumbers: [i]})
		}

		function q(t) {
			var e = H(t.calcPoint), i = _.getStep(e), n = _.fromStepping(i);
			Object.keys(C).forEach(function (t) {
				"hover" === t.split(".")[0] && C[t].forEach(function (t) {
					t.call(p, n)
				})
			})
		}

		function G(t, e, i, n, r, a) {
			var s;
			return h.length > 1 && (n && e > 0 && (i = Math.max(i, t[e - 1] + o.margin)), r && e < h.length - 1 && (i = Math.min(i, t[e + 1] - o.margin))), h.length > 1 && o.limit && (n && e > 0 && (i = Math.min(i, t[e - 1] + o.limit)), r && e < h.length - 1 && (i = Math.max(i, t[e + 1] - o.limit))), o.padding && (0 === e && (i = Math.max(i, o.padding)), e === h.length - 1 && (i = Math.min(i, 100 - o.padding))), i = _.getStep(i), s = i, !((i = Math.max(Math.min(s, 100), 0)) === t[e] && !a) && i
		}

		function K(t) {
			return t + "%"
		}

		function X() {
			x.forEach(function (t) {
				var e = w[t] > 50 ? -1 : 1, i = 3 + (h.length + e * t);
				h[t].childNodes[0].style.zIndex = i
			})
		}

		function Z(t, e, i, n) {
			return !1 !== (e = G(w, t, e, i, n, !1)) && (function (t, e) {
				w[t] = e, S[t] = _.fromStepping(e);
				var i = function () {
					h[t].style[o.style] = K(e), Q(t), Q(t + 1)
				};
				window.requestAnimationFrame && o.useRequestAnimationFrame ? window.requestAnimationFrame(i) : i()
			}(t, e), !0)
		}

		function Q(t) {
			if (d[t]) {
				var e = 0, i = 100;
				0 !== t && (e = w[t - 1]), t !== d.length - 1 && (i = w[t]), d[t].style[o.style] = K(e), d[t].style[o.styleOposite] = K(100 - i)
			}
		}

		function J(t, e) {
			null !== t && !1 !== t && ("number" == typeof t && (t = String(t)), !1 === (t = o.format.from(t)) || isNaN(t) || Z(e, _.toStepping(t), !1, !1))
		}

		function tt(t, e) {
			var i = r(t), a = void 0 === w[0];
			e = void 0 === e || !!e, i.forEach(J), o.animate && !a && n(b, o.cssClasses.tap, o.animationDuration), x.forEach(function (t) {
				Z(t, w[t], !0, !1)
			}), X(), x.forEach(function (t) {
				z("update", t), null !== i[t] && e && z("set", t)
			})
		}

		function et() {
			var t = S.map(o.format.to);
			return 1 === t.length ? t[0] : t
		}

		function it(t, e) {
			C[t] = C[t] || [], C[t].push(e), "update" === t.split(".")[0] && h.forEach(function (t, e) {
				z("update", e)
			})
		}

		if (b.noUiSlider) throw new Error("noUiSlider (" + t + "): Slider was already initialized.");
		return function (t) {
			a(t, o.cssClasses.target), 0 === o.dir ? a(t, o.cssClasses.ltr) : a(t, o.cssClasses.rtl), 0 === o.ort ? a(t, o.cssClasses.horizontal) : a(t, o.cssClasses.vertical), u = E(t, o.cssClasses.base)
		}(b), function (t, e) {
			h = [], (d = []).push(P(e, t[0]));
			for (var i = 0; i < o.handles; i++) h.push(A(e, i)), x[i] = i, d.push(P(e, t[i + 1]))
		}(o.connect, u), p = {
			destroy: function () {
				for (var t in o.cssClasses) o.cssClasses.hasOwnProperty(t) && s(b, o.cssClasses[t]);
				for (; b.firstChild;) b.removeChild(b.firstChild);
				delete b.noUiSlider
			}, steps: function () {
				return w.map(function (t, e) {
					var i = _.getNearbySteps(t), n = S[e], r = i.thisStep.step, o = null;
					!1 !== r && n + r > i.stepAfter.startValue && (r = i.stepAfter.startValue - n), o = n > i.thisStep.startValue ? i.thisStep.step : !1 !== i.stepBefore.step && n - i.stepBefore.highestStep, 100 === t ? r = null : 0 === t && (o = null);
					var a = _.countStepDecimals();
					return null !== r && !1 !== r && (r = Number(r.toFixed(a))), null !== o && !1 !== o && (o = Number(o.toFixed(a))), [o, r]
				})
			}, on: it, off: function (t) {
				var e = t && t.split(".")[0], i = e && t.substring(e.length);
				Object.keys(C).forEach(function (t) {
					var n = t.split(".")[0], r = t.substring(n.length);
					e && e !== n || i && i !== r || delete C[t]
				})
			}, get: et, set: tt, reset: function (t) {
				tt(o.start, t)
			}, __moveHandles: function (t, e, i) {
				B(t, e, w, i)
			}, options: c, updateOptions: function (t, e) {
				var i = et(), n = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format"];
				n.forEach(function (e) {
					void 0 !== t[e] && (c[e] = t[e])
				});
				var r = $(c);
				n.forEach(function (e) {
					void 0 !== t[e] && (o[e] = r[e])
				}), _ = r.spectrum, o.margin = r.margin, o.limit = r.limit, o.padding = r.padding, o.pips && F(o.pips), w = [], tt(t.start || i, e)
			}, target: b, removePips: L, pips: F
		}, (m = o.events).fixed || h.forEach(function (t, e) {
			R(v.start, t.children[0], Y, {handleNumbers: [e]})
		}), m.tap && R(v.start, u, V, {}), m.hover && R(v.move, u, q, {hover: !0}), m.drag && d.forEach(function (t, e) {
			if (!1 !== t && 0 !== e && e !== d.length - 1) {
				var i = h[e - 1], n = h[e], r = [t];
				a(t, o.cssClasses.draggable), m.fixed && (r.push(i.children[0]), r.push(n.children[0])), r.forEach(function (t) {
					R(v.start, t, Y, {handles: [i, n], handleNumbers: [e - 1, e]})
				})
			}
		}), tt(o.start), o.pips && F(o.pips), o.tooltips && (g = h.map(I), it("update", function (t, e, i) {
			if (g[e]) {
				var n = t[e];
				!0 !== o.tooltips[e] && (n = o.tooltips[e].to(i[e])), g[e].innerHTML = n
			}
		})), it("update", function (t, e, i, n, r) {
			x.forEach(function (t) {
				var e = h[t], n = G(w, t, 0, !0, !0, !0), a = G(w, t, 100, !0, !0, !0), s = r[t], l = o.ariaFormat.to(i[t]);
				e.children[0].setAttribute("aria-valuemin", n.toFixed(1)), e.children[0].setAttribute("aria-valuemax", a.toFixed(1)), e.children[0].setAttribute("aria-valuenow", s.toFixed(1)), e.children[0].setAttribute("aria-valuetext", l)
			})
		}), p
	}

	return {
		version: t, create: function (e, i) {
			if (!e || !e.nodeName) throw new Error("noUiSlider (" + t + "): create requires a single element, got: " + e);
			var n = B(e, $(i), i);
			return e.noUiSlider = n, n
		}
	}
}), function (t, e, i, n) {
	function r(e, i) {
		this.settings = null, this.options = t.extend({}, r.Defaults, i), this.$element = t(e), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = {
			time: null,
			target: null,
			pointer: null,
			stage: {start: null, current: null},
			direction: null
		}, this._states = {current: {}, tags: {initializing: ["busy"], animating: ["busy"], dragging: ["interacting"]}}, t.each(["onResize", "onThrottledResize"], t.proxy(function (e, i) {
			this._handlers[i] = t.proxy(this[i], this)
		}, this)), t.each(r.Plugins, t.proxy(function (t, e) {
			this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(this)
		}, this)), t.each(r.Workers, t.proxy(function (e, i) {
			this._pipe.push({filter: i.filter, run: t.proxy(i.run, this)})
		}, this)), this.setup(), this.initialize()
	}

	r.Defaults = {
		items: 3,
		loop: !1,
		center: !1,
		rewind: !1,
		checkVisibility: !0,
		mouseDrag: !0,
		touchDrag: !0,
		pullDrag: !0,
		freeDrag: !1,
		margin: 0,
		stagePadding: 0,
		merge: !1,
		mergeFit: !0,
		autoWidth: !1,
		startPosition: 0,
		rtl: !1,
		smartSpeed: 250,
		fluidSpeed: !1,
		dragEndSpeed: !1,
		responsive: {},
		responsiveRefreshRate: 200,
		responsiveBaseElement: e,
		fallbackEasing: "swing",
		slideTransition: "",
		info: !1,
		nestedItemSelector: !1,
		itemElement: "div",
		stageElement: "div",
		refreshClass: "owl-refresh",
		loadedClass: "owl-loaded",
		loadingClass: "owl-loading",
		rtlClass: "owl-rtl",
		responsiveClass: "owl-responsive",
		dragClass: "owl-drag",
		itemClass: "owl-item",
		stageClass: "owl-stage",
		stageOuterClass: "owl-stage-outer",
		grabClass: "owl-grab"
	}, r.Width = {Default: "default", Inner: "inner", Outer: "outer"}, r.Type = {Event: "event", State: "state"}, r.Plugins = {}, r.Workers = [{
		filter: ["width", "settings"], run: function () {
			this._width = this.$element.width()
		}
	}, {
		filter: ["width", "items", "settings"], run: function (t) {
			t.current = this._items && this._items[this.relative(this._current)]
		}
	}, {
		filter: ["items", "settings"], run: function () {
			this.$stage.children(".cloned").remove()
		}
	}, {
		filter: ["width", "items", "settings"], run: function (t) {
			var e = this.settings.margin || "", i = !this.settings.autoWidth, n = this.settings.rtl, r = {width: "auto", "margin-left": n ? e : "", "margin-right": n ? "" : e};
			!i && this.$stage.children().css(r), t.css = r
		}
	}, {
		filter: ["width", "items", "settings"], run: function (t) {
			var e = (this.width() / this.settings.items).toFixed(3) - this.settings.margin, i = null, n = this._items.length, r = !this.settings.autoWidth, o = [];
			for (t.items = {merge: !1, width: e}; n--;) i = this._mergers[n], i = this.settings.mergeFit && Math.min(i, this.settings.items) || i, t.items.merge = i > 1 || t.items.merge, o[n] = r ? e * i : this._items[n].width();
			this._widths = o
		}
	}, {
		filter: ["items", "settings"], run: function () {
			var e = [], i = this._items, n = this.settings, r = Math.max(2 * n.items, 4), o = 2 * Math.ceil(i.length / 2), a = n.loop && i.length ? n.rewind ? r : Math.max(r, o) : 0, s = "", l = "";
			for (a /= 2; a > 0;) e.push(this.normalize(e.length / 2, !0)), s += i[e[e.length - 1]][0].outerHTML, e.push(this.normalize(i.length - 1 - (e.length - 1) / 2, !0)), l = i[e[e.length - 1]][0].outerHTML + l, a -= 1;
			this._clones = e, t(s).addClass("cloned").appendTo(this.$stage), t(l).addClass("cloned").prependTo(this.$stage)
		}
	}, {
		filter: ["width", "items", "settings"], run: function () {
			for (var t = this.settings.rtl ? 1 : -1, e = this._clones.length + this._items.length, i = -1, n = 0, r = 0, o = []; ++i < e;) n = o[i - 1] || 0, r = this._widths[this.relative(i)] + this.settings.margin, o.push(n + r * t);
			this._coordinates = o
		}
	}, {
		filter: ["width", "items", "settings"], run: function () {
			var t = this.settings.stagePadding, e = this._coordinates, i = {width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t, "padding-left": t || "", "padding-right": t || ""};
			this.$stage.css(i)
		}
	}, {
		filter: ["width", "items", "settings"], run: function (t) {
			var e = this._coordinates.length, i = !this.settings.autoWidth, n = this.$stage.children();
			if (i && t.items.merge) for (; e--;) t.css.width = this._widths[this.relative(e)], n.eq(e).css(t.css); else i && (t.css.width = t.items.width, n.css(t.css))
		}
	}, {
		filter: ["items"], run: function () {
			this._coordinates.length < 1 && this.$stage.removeAttr("style")
		}
	}, {
		filter: ["width", "items", "settings"], run: function (t) {
			t.current = t.current ? this.$stage.children().index(t.current) : 0, t.current = Math.max(this.minimum(), Math.min(this.maximum(), t.current)), this.reset(t.current)
		}
	}, {
		filter: ["position"], run: function () {
			this.animate(this.coordinates(this._current))
		}
	}, {
		filter: ["width", "position", "items", "settings"], run: function () {
			var t, e, i, n, r = this.settings.rtl ? 1 : -1, o = 2 * this.settings.stagePadding, a = this.coordinates(this.current()) + o, s = a + this.width() * r, l = [];
			for (i = 0, n = this._coordinates.length; i < n; i++) t = this._coordinates[i - 1] || 0, e = Math.abs(this._coordinates[i]) + o * r, (this.op(t, "<=", a) && this.op(t, ">", s) || this.op(e, "<", a) && this.op(e, ">", s)) && l.push(i);
			this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + l.join("), :eq(") + ")").addClass("active"), this.$stage.children(".center").removeClass("center"), this.settings.center && this.$stage.children().eq(this.current()).addClass("center")
		}
	}], r.prototype.initializeStage = function () {
		this.$stage = this.$element.find("." + this.settings.stageClass), this.$stage.length || (this.$element.addClass(this.options.loadingClass), this.$stage = t("<" + this.settings.stageElement + ">", {class: this.settings.stageClass}).wrap(t("<div/>", {class: this.settings.stageOuterClass})), this.$element.append(this.$stage.parent()))
	}, r.prototype.initializeItems = function () {
		var e = this.$element.find(".owl-item");
		if (e.length) return this._items = e.get().map(function (e) {
			return t(e)
		}), this._mergers = this._items.map(function () {
			return 1
		}), void this.refresh();
		this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)
	}, r.prototype.initialize = function () {
		var t, e, i;
		(this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) && (t = this.$element.find("img"), e = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : void 0, i = this.$element.children(e).width(), t.length && i <= 0 && this.preloadAutoWidthImages(t));
		this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized")
	}, r.prototype.isVisible = function () {
		return !this.settings.checkVisibility || this.$element.is(":visible")
	}, r.prototype.setup = function () {
		var e = this.viewport(), i = this.options.responsive, n = -1, r = null;
		i ? (t.each(i, function (t) {
			t <= e && t > n && (n = Number(t))
		}), "function" == typeof (r = t.extend({}, this.options, i[n])).stagePadding && (r.stagePadding = r.stagePadding()), delete r.responsive, r.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + n))) : r = t.extend({}, this.options), this.trigger("change", {
			property: {
				name: "settings",
				value: r
			}
		}), this._breakpoint = n, this.settings = r, this.invalidate("settings"), this.trigger("changed", {property: {name: "settings", value: this.settings}})
	}, r.prototype.optionsLogic = function () {
		this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
	}, r.prototype.prepare = function (e) {
		var i = this.trigger("prepare", {content: e});
		return i.data || (i.data = t("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(e)), this.trigger("prepared", {content: i.data}), i.data
	}, r.prototype.update = function () {
		for (var e = 0, i = this._pipe.length, n = t.proxy(function (t) {
			return this[t]
		}, this._invalidated), r = {}; e < i;) (this._invalidated.all || t.grep(this._pipe[e].filter, n).length > 0) && this._pipe[e].run(r), e++;
		this._invalidated = {}, !this.is("valid") && this.enter("valid")
	}, r.prototype.width = function (t) {
		switch (t = t || r.Width.Default) {
			case r.Width.Inner:
			case r.Width.Outer:
				return this._width;
			default:
				return this._width - 2 * this.settings.stagePadding + this.settings.margin
		}
	}, r.prototype.refresh = function () {
		this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed")
	}, r.prototype.onThrottledResize = function () {
		e.clearTimeout(this.resizeTimer), this.resizeTimer = e.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
	}, r.prototype.onResize = function () {
		return !!this._items.length && (this._width !== this.$element.width() && (!!this.isVisible() && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))))
	}, r.prototype.registerEventHandlers = function () {
		t.support.transition && this.$stage.on(t.support.transition.end + ".owl.core", t.proxy(this.onTransitionEnd, this)), !1 !== this.settings.responsive && this.on(e, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", t.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
			return !1
		})), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", t.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", t.proxy(this.onDragEnd, this)))
	}, r.prototype.onDragStart = function (e) {
		var n = null;
		3 !== e.which && (t.support.transform ? n = {
			x: (n = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","))[16 === n.length ? 12 : 4],
			y: n[16 === n.length ? 13 : 5]
		} : (n = this.$stage.position(), n = {
			x: this.settings.rtl ? n.left + this.$stage.width() - this.width() + this.settings.margin : n.left,
			y: n.top
		}), this.is("animating") && (t.support.transform ? this.animate(n.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === e.type), this.speed(0), this._drag.time = (new Date).getTime(), this._drag.target = t(e.target), this._drag.stage.start = n, this._drag.stage.current = n, this._drag.pointer = this.pointer(e), t(i).on("mouseup.owl.core touchend.owl.core", t.proxy(this.onDragEnd, this)), t(i).one("mousemove.owl.core touchmove.owl.core", t.proxy(function (e) {
			var n = this.difference(this._drag.pointer, this.pointer(e));
			t(i).on("mousemove.owl.core touchmove.owl.core", t.proxy(this.onDragMove, this)), Math.abs(n.x) < Math.abs(n.y) && this.is("valid") || (e.preventDefault(), this.enter("dragging"), this.trigger("drag"))
		}, this)))
	}, r.prototype.onDragMove = function (t) {
		var e = null, i = null, n = null, r = this.difference(this._drag.pointer, this.pointer(t)), o = this.difference(this._drag.stage.start, r);
		this.is("dragging") && (t.preventDefault(), this.settings.loop ? (e = this.coordinates(this.minimum()), i = this.coordinates(this.maximum() + 1) - e, o.x = ((o.x - e) % i + i) % i + e) : (e = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), i = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), n = this.settings.pullDrag ? -1 * r.x / 5 : 0, o.x = Math.max(Math.min(o.x, e + n), i + n)), this._drag.stage.current = o, this.animate(o.x))
	}, r.prototype.onDragEnd = function (e) {
		var n = this.difference(this._drag.pointer, this.pointer(e)), r = this._drag.stage.current, o = n.x > 0 ^ this.settings.rtl ? "left" : "right";
		t(i).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== n.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(r.x, 0 !== n.x ? o : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = o, (Math.abs(n.x) > 3 || (new Date).getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function () {
			return !1
		})), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"))
	}, r.prototype.closest = function (e, i) {
		var n = -1, r = this.width(), o = this.coordinates();
		return this.settings.freeDrag || t.each(o, t.proxy(function (t, a) {
			return "left" === i && e > a - 30 && e < a + 30 ? n = t : "right" === i && e > a - r - 30 && e < a - r + 30 ? n = t + 1 : this.op(e, "<", a) && this.op(e, ">", void 0 !== o[t + 1] ? o[t + 1] : a - r) && (n = "left" === i ? t + 1 : t), -1 === n
		}, this)), this.settings.loop || (this.op(e, ">", o[this.minimum()]) ? n = e = this.minimum() : this.op(e, "<", o[this.maximum()]) && (n = e = this.maximum())), n
	}, r.prototype.animate = function (e) {
		var i = this.speed() > 0;
		this.is("animating") && this.onTransitionEnd(), i && (this.enter("animating"), this.trigger("translate")), t.support.transform3d && t.support.transition ? this.$stage.css({
			transform: "translate3d(" + e + "px,0px,0px)",
			transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
		}) : i ? this.$stage.animate({left: e + "px"}, this.speed(), this.settings.fallbackEasing, t.proxy(this.onTransitionEnd, this)) : this.$stage.css({left: e + "px"})
	}, r.prototype.is = function (t) {
		return this._states.current[t] && this._states.current[t] > 0
	}, r.prototype.current = function (t) {
		if (void 0 === t) return this._current;
		if (0 !== this._items.length) {
			if (t = this.normalize(t), this._current !== t) {
				var e = this.trigger("change", {property: {name: "position", value: t}});
				void 0 !== e.data && (t = this.normalize(e.data)), this._current = t, this.invalidate("position"), this.trigger("changed", {property: {name: "position", value: this._current}})
			}
			return this._current
		}
	}, r.prototype.invalidate = function (e) {
		return "string" === t.type(e) && (this._invalidated[e] = !0, this.is("valid") && this.leave("valid")), t.map(this._invalidated, function (t, e) {
			return e
		})
	}, r.prototype.reset = function (t) {
		void 0 !== (t = this.normalize(t)) && (this._speed = 0, this._current = t, this.suppress(["translate", "translated"]), this.animate(this.coordinates(t)), this.release(["translate", "translated"]))
	}, r.prototype.normalize = function (t, e) {
		var i = this._items.length, n = e ? 0 : this._clones.length;
		return !this.isNumeric(t) || i < 1 ? t = void 0 : (t < 0 || t >= i + n) && (t = ((t - n / 2) % i + i) % i + n / 2), t
	}, r.prototype.relative = function (t) {
		return t -= this._clones.length / 2, this.normalize(t, !0)
	}, r.prototype.maximum = function (t) {
		var e, i, n, r = this.settings, o = this._coordinates.length;
		if (r.loop) o = this._clones.length / 2 + this._items.length - 1; else if (r.autoWidth || r.merge) {
			if (e = this._items.length) for (i = this._items[--e].width(), n = this.$element.width(); e-- && !((i += this._items[e].width() + this.settings.margin) > n);) ;
			o = e + 1
		} else o = r.center ? this._items.length - 1 : this._items.length - r.items;
		return t && (o -= this._clones.length / 2), Math.max(o, 0)
	}, r.prototype.minimum = function (t) {
		return t ? 0 : this._clones.length / 2
	}, r.prototype.items = function (t) {
		return void 0 === t ? this._items.slice() : (t = this.normalize(t, !0), this._items[t])
	}, r.prototype.mergers = function (t) {
		return void 0 === t ? this._mergers.slice() : (t = this.normalize(t, !0), this._mergers[t])
	}, r.prototype.clones = function (e) {
		var i = this._clones.length / 2, n = i + this._items.length, r = function (t) {
			return t % 2 == 0 ? n + t / 2 : i - (t + 1) / 2
		};
		return void 0 === e ? t.map(this._clones, function (t, e) {
			return r(e)
		}) : t.map(this._clones, function (t, i) {
			return t === e ? r(i) : null
		})
	}, r.prototype.speed = function (t) {
		return void 0 !== t && (this._speed = t), this._speed
	}, r.prototype.coordinates = function (e) {
		var i, n = 1, r = e - 1;
		return void 0 === e ? t.map(this._coordinates, t.proxy(function (t, e) {
			return this.coordinates(e)
		}, this)) : (this.settings.center ? (this.settings.rtl && (n = -1, r = e + 1), i = this._coordinates[e], i += (this.width() - i + (this._coordinates[r] || 0)) / 2 * n) : i = this._coordinates[r] || 0, i = Math.ceil(i))
	}, r.prototype.duration = function (t, e, i) {
		return 0 === i ? 0 : Math.min(Math.max(Math.abs(e - t), 1), 6) * Math.abs(i || this.settings.smartSpeed)
	}, r.prototype.to = function (t, e) {
		var i = this.current(), n = null, r = t - this.relative(i), o = (r > 0) - (r < 0), a = this._items.length, s = this.minimum(), l = this.maximum();
		this.settings.loop ? (!this.settings.rewind && Math.abs(r) > a / 2 && (r += -1 * o * a), (n = (((t = i + r) - s) % a + a) % a + s) !== t && n - r <= l && n - r > 0 && (i = n - r, t = n, this.reset(i))) : t = this.settings.rewind ? (t % (l += 1) + l) % l : Math.max(s, Math.min(l, t)), this.speed(this.duration(i, t, e)), this.current(t), this.isVisible() && this.update()
	}, r.prototype.next = function (t) {
		t = t || !1, this.to(this.relative(this.current()) + 1, t)
	}, r.prototype.prev = function (t) {
		t = t || !1, this.to(this.relative(this.current()) - 1, t)
	}, r.prototype.onTransitionEnd = function (t) {
		if (void 0 !== t && (t.stopPropagation(), (t.target || t.srcElement || t.originalTarget) !== this.$stage.get(0))) return !1;
		this.leave("animating"), this.trigger("translated")
	}, r.prototype.viewport = function () {
		var n;
		return this.options.responsiveBaseElement !== e ? n = t(this.options.responsiveBaseElement).width() : e.innerWidth ? n = e.innerWidth : i.documentElement && i.documentElement.clientWidth ? n = i.documentElement.clientWidth : console.warn("Can not detect viewport width."), n
	}, r.prototype.replace = function (e) {
		this.$stage.empty(), this._items = [], e && (e = e instanceof jQuery ? e : t(e)), this.settings.nestedItemSelector && (e = e.find("." + this.settings.nestedItemSelector)), e.filter(function () {
			return 1 === this.nodeType
		}).each(t.proxy(function (t, e) {
			e = this.prepare(e), this.$stage.append(e), this._items.push(e), this._mergers.push(1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
		}, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
	}, r.prototype.add = function (e, i) {
		var n = this.relative(this._current);
		i = void 0 === i ? this._items.length : this.normalize(i, !0), e = e instanceof jQuery ? e : t(e), this.trigger("add", {
			content: e,
			position: i
		}), e = this.prepare(e), 0 === this._items.length || i === this._items.length ? (0 === this._items.length && this.$stage.append(e), 0 !== this._items.length && this._items[i - 1].after(e), this._items.push(e), this._mergers.push(1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[i].before(e), this._items.splice(i, 0, e), this._mergers.splice(i, 0, 1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[n] && this.reset(this._items[n].index()), this.invalidate("items"), this.trigger("added", {
			content: e,
			position: i
		})
	}, r.prototype.remove = function (t) {
		void 0 !== (t = this.normalize(t, !0)) && (this.trigger("remove", {content: this._items[t], position: t}), this._items[t].remove(), this._items.splice(t, 1), this._mergers.splice(t, 1), this.invalidate("items"), this.trigger("removed", {content: null, position: t}))
	}, r.prototype.preloadAutoWidthImages = function (e) {
		e.each(t.proxy(function (e, i) {
			this.enter("pre-loading"), i = t(i), t(new Image).one("load", t.proxy(function (t) {
				i.attr("src", t.target.src), i.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh()
			}, this)).attr("src", i.attr("src") || i.attr("data-src") || i.attr("data-src-retina"))
		}, this))
	}, r.prototype.destroy = function () {
		for (var n in this.$element.off(".owl.core"), this.$stage.off(".owl.core"), t(i).off(".owl.core"), !1 !== this.settings.responsive && (e.clearTimeout(this.resizeTimer), this.off(e, "resize", this._handlers.onThrottledResize)), this._plugins) this._plugins[n].destroy();
		this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.remove(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel")
	}, r.prototype.op = function (t, e, i) {
		var n = this.settings.rtl;
		switch (e) {
			case"<":
				return n ? t > i : t < i;
			case">":
				return n ? t < i : t > i;
			case">=":
				return n ? t <= i : t >= i;
			case"<=":
				return n ? t >= i : t <= i
		}
	}, r.prototype.on = function (t, e, i, n) {
		t.addEventListener ? t.addEventListener(e, i, n) : t.attachEvent && t.attachEvent("on" + e, i)
	}, r.prototype.off = function (t, e, i, n) {
		t.removeEventListener ? t.removeEventListener(e, i, n) : t.detachEvent && t.detachEvent("on" + e, i)
	}, r.prototype.trigger = function (e, i, n, o, a) {
		var s = {item: {count: this._items.length, index: this.current()}}, l = t.camelCase(t.grep(["on", e, n], function (t) {
			return t
		}).join("-").toLowerCase()), c = t.Event([e, "owl", n || "carousel"].join(".").toLowerCase(), t.extend({relatedTarget: this}, s, i));
		return this._supress[e] || (t.each(this._plugins, function (t, e) {
			e.onTrigger && e.onTrigger(c)
		}), this.register({type: r.Type.Event, name: e}), this.$element.trigger(c), this.settings && "function" == typeof this.settings[l] && this.settings[l].call(this, c)), c
	}, r.prototype.enter = function (e) {
		t.each([e].concat(this._states.tags[e] || []), t.proxy(function (t, e) {
			void 0 === this._states.current[e] && (this._states.current[e] = 0), this._states.current[e]++
		}, this))
	}, r.prototype.leave = function (e) {
		t.each([e].concat(this._states.tags[e] || []), t.proxy(function (t, e) {
			this._states.current[e]--
		}, this))
	}, r.prototype.register = function (e) {
		if (e.type === r.Type.Event) {
			if (t.event.special[e.name] || (t.event.special[e.name] = {}), !t.event.special[e.name].owl) {
				var i = t.event.special[e.name]._default;
				t.event.special[e.name]._default = function (t) {
					return !i || !i.apply || t.namespace && -1 !== t.namespace.indexOf("owl") ? t.namespace && t.namespace.indexOf("owl") > -1 : i.apply(this, arguments)
				}, t.event.special[e.name].owl = !0
			}
		} else e.type === r.Type.State && (this._states.tags[e.name] ? this._states.tags[e.name] = this._states.tags[e.name].concat(e.tags) : this._states.tags[e.name] = e.tags, this._states.tags[e.name] = t.grep(this._states.tags[e.name], t.proxy(function (i, n) {
			return t.inArray(i, this._states.tags[e.name]) === n
		}, this)))
	}, r.prototype.suppress = function (e) {
		t.each(e, t.proxy(function (t, e) {
			this._supress[e] = !0
		}, this))
	}, r.prototype.release = function (e) {
		t.each(e, t.proxy(function (t, e) {
			delete this._supress[e]
		}, this))
	}, r.prototype.pointer = function (t) {
		var i = {x: null, y: null};
		return (t = (t = t.originalEvent || t || e.event).touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t).pageX ? (i.x = t.pageX, i.y = t.pageY) : (i.x = t.clientX, i.y = t.clientY), i
	}, r.prototype.isNumeric = function (t) {
		return !isNaN(parseFloat(t))
	}, r.prototype.difference = function (t, e) {
		return {x: t.x - e.x, y: t.y - e.y}
	}, t.fn.owlCarousel = function (e) {
		var i = Array.prototype.slice.call(arguments, 1);
		return this.each(function () {
			var n = t(this), o = n.data("owl.carousel");
			o || (o = new r(this, "object" == typeof e && e), n.data("owl.carousel", o), t.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (e, i) {
				o.register({type: r.Type.Event, name: i}), o.$element.on(i + ".owl.carousel.core", t.proxy(function (t) {
					t.namespace && t.relatedTarget !== this && (this.suppress([i]), o[i].apply(this, [].slice.call(arguments, 1)), this.release([i]))
				}, o))
			})), "string" == typeof e && "_" !== e.charAt(0) && o[e].apply(o, i)
		})
	}, t.fn.owlCarousel.Constructor = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	var r = function (e) {
		this._core = e, this._interval = null, this._visible = null, this._handlers = {
			"initialized.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.settings.autoRefresh && this.watch()
			}, this)
		}, this._core.options = t.extend({}, r.Defaults, this._core.options), this._core.$element.on(this._handlers)
	};
	r.Defaults = {autoRefresh: !0, autoRefreshInterval: 500}, r.prototype.watch = function () {
		this._interval || (this._visible = this._core.isVisible(), this._interval = e.setInterval(t.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
	}, r.prototype.refresh = function () {
		this._core.isVisible() !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh())
	}, r.prototype.destroy = function () {
		var t, i;
		for (t in e.clearInterval(this._interval), this._handlers) this._core.$element.off(t, this._handlers[t]);
		for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
	}, t.fn.owlCarousel.Constructor.Plugins.AutoRefresh = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	var r = function (e) {
		this._core = e, this._loaded = [], this._handlers = {
			"initialized.owl.carousel change.owl.carousel resized.owl.carousel": t.proxy(function (e) {
				if (e.namespace && this._core.settings && this._core.settings.lazyLoad && (e.property && "position" == e.property.name || "initialized" == e.type)) {
					var i = this._core.settings, n = i.center && Math.ceil(i.items / 2) || i.items, r = i.center && -1 * n || 0, o = (e.property && void 0 !== e.property.value ? e.property.value : this._core.current()) + r, a = this._core.clones().length, s = t.proxy(function (t, e) {
						this.load(e)
					}, this);
					for (i.lazyLoadEager > 0 && (n += i.lazyLoadEager, i.loop && (o -= i.lazyLoadEager, n++)); r++ < n;) this.load(a / 2 + this._core.relative(o)), a && t.each(this._core.clones(this._core.relative(o)), s), o++
				}
			}, this)
		}, this._core.options = t.extend({}, r.Defaults, this._core.options), this._core.$element.on(this._handlers)
	};
	r.Defaults = {lazyLoad: !1, lazyLoadEager: 0}, r.prototype.load = function (i) {
		var n = this._core.$stage.children().eq(i), r = n && n.find(".owl-lazy");
		!r || t.inArray(n.get(0), this._loaded) > -1 || (r.each(t.proxy(function (i, n) {
			var r, o = t(n), a = e.devicePixelRatio > 1 && o.attr("data-src-retina") || o.attr("data-src") || o.attr("data-srcset");
			this._core.trigger("load", {element: o, url: a}, "lazy"), o.is("img") ? o.one("load.owl.lazy", t.proxy(function () {
				o.css("opacity", 1), this._core.trigger("loaded", {element: o, url: a}, "lazy")
			}, this)).attr("src", a) : o.is("source") ? o.one("load.owl.lazy", t.proxy(function () {
				this._core.trigger("loaded", {element: o, url: a}, "lazy")
			}, this)).attr("srcset", a) : ((r = new Image).onload = t.proxy(function () {
				o.css({"background-image": 'url("' + a + '")', opacity: "1"}), this._core.trigger("loaded", {element: o, url: a}, "lazy")
			}, this), r.src = a)
		}, this)), this._loaded.push(n.get(0)))
	}, r.prototype.destroy = function () {
		var t, e;
		for (t in this.handlers) this._core.$element.off(t, this.handlers[t]);
		for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
	}, t.fn.owlCarousel.Constructor.Plugins.Lazy = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	var r = function (i) {
		this._core = i, this._previousHeight = null, this._handlers = {
			"initialized.owl.carousel refreshed.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.settings.autoHeight && this.update()
			}, this), "changed.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.settings.autoHeight && "position" === t.property.name && this.update()
			}, this), "loaded.owl.lazy": t.proxy(function (t) {
				t.namespace && this._core.settings.autoHeight && t.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
			}, this)
		}, this._core.options = t.extend({}, r.Defaults, this._core.options), this._core.$element.on(this._handlers), this._intervalId = null;
		var n = this;
		t(e).on("load", function () {
			n._core.settings.autoHeight && n.update()
		}), t(e).resize(function () {
			n._core.settings.autoHeight && (null != n._intervalId && clearTimeout(n._intervalId), n._intervalId = setTimeout(function () {
				n.update()
			}, 250))
		})
	};
	r.Defaults = {autoHeight: !1, autoHeightClass: "owl-height"}, r.prototype.update = function () {
		var e = this._core._current, i = e + this._core.settings.items, n = this._core.settings.lazyLoad, r = this._core.$stage.children().toArray().slice(e, i), o = [], a = 0;
		t.each(r, function (e, i) {
			o.push(t(i).height())
		}), (a = Math.max.apply(null, o)) <= 1 && n && this._previousHeight && (a = this._previousHeight), this._previousHeight = a, this._core.$stage.parent().height(a).addClass(this._core.settings.autoHeightClass)
	}, r.prototype.destroy = function () {
		var t, e;
		for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
		for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
	}, t.fn.owlCarousel.Constructor.Plugins.AutoHeight = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	var r = function (e) {
		this._core = e, this._videos = {}, this._playing = null, this._handlers = {
			"initialized.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.register({type: "state", name: "playing", tags: ["interacting"]})
			}, this), "resize.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.settings.video && this.isInFullScreen() && t.preventDefault()
			}, this), "refreshed.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
			}, this), "changed.owl.carousel": t.proxy(function (t) {
				t.namespace && "position" === t.property.name && this._playing && this.stop()
			}, this), "prepared.owl.carousel": t.proxy(function (e) {
				if (e.namespace) {
					var i = t(e.content).find(".owl-video");
					i.length && (i.css("display", "none"), this.fetch(i, t(e.content)))
				}
			}, this)
		}, this._core.options = t.extend({}, r.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", t.proxy(function (t) {
			this.play(t)
		}, this))
	};
	r.Defaults = {video: !1, videoHeight: !1, videoWidth: !1}, r.prototype.fetch = function (t, e) {
		var i = t.attr("data-vimeo-id") ? "vimeo" : t.attr("data-vzaar-id") ? "vzaar" : "youtube", n = t.attr("data-vimeo-id") || t.attr("data-youtube-id") || t.attr("data-vzaar-id"), r = t.attr("data-width") || this._core.settings.videoWidth,
			o = t.attr("data-height") || this._core.settings.videoHeight, a = t.attr("href");
		if (!a) throw new Error("Missing video URL.");
		if ((n = a.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu") > -1) i = "youtube"; else if (n[3].indexOf("vimeo") > -1) i = "vimeo"; else {
			if (!(n[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
			i = "vzaar"
		}
		n = n[6], this._videos[a] = {type: i, id: n, width: r, height: o}, e.attr("data-video", a), this.thumbnail(t, this._videos[a])
	}, r.prototype.thumbnail = function (e, i) {
		var n, r, o = i.width && i.height ? "width:" + i.width + "px;height:" + i.height + "px;" : "", a = e.find("img"), s = "src", l = "", c = this._core.settings, u = function (i) {
			'<div class="owl-video-play-icon"></div>', n = c.lazyLoad ? t("<div/>", {class: "owl-video-tn " + l, srcType: i}) : t("<div/>", {class: "owl-video-tn", style: "opacity:1;background-image:url(" + i + ")"}), e.after(n), e.after('<div class="owl-video-play-icon"></div>')
		};
		if (e.wrap(t("<div/>", {class: "owl-video-wrapper", style: o})), this._core.settings.lazyLoad && (s = "data-src", l = "owl-lazy"), a.length) return u(a.attr(s)), a.remove(), !1;
		"youtube" === i.type ? (r = "//img.youtube.com/vi/" + i.id + "/hqdefault.jpg", u(r)) : "vimeo" === i.type ? t.ajax({
			type: "GET", url: "//vimeo.com/api/v2/video/" + i.id + ".json", jsonp: "callback", dataType: "jsonp", success: function (t) {
				r = t[0].thumbnail_large, u(r)
			}
		}) : "vzaar" === i.type && t.ajax({
			type: "GET", url: "//vzaar.com/api/videos/" + i.id + ".json", jsonp: "callback", dataType: "jsonp", success: function (t) {
				r = t.framegrab_url, u(r)
			}
		})
	}, r.prototype.stop = function () {
		this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video")
	}, r.prototype.play = function (e) {
		var i, n = t(e.target).closest("." + this._core.settings.itemClass), r = this._videos[n.attr("data-video")], o = r.width || "100%", a = r.height || this._core.$stage.height();
		this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), n = this._core.items(this._core.relative(n.index())), this._core.reset(n.index()), (i = t('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height", a), i.attr("width", o), "youtube" === r.type ? i.attr("src", "//www.youtube.com/embed/" + r.id + "?autoplay=1&rel=0&v=" + r.id) : "vimeo" === r.type ? i.attr("src", "//player.vimeo.com/video/" + r.id + "?autoplay=1") : "vzaar" === r.type && i.attr("src", "//view.vzaar.com/" + r.id + "/player?autoplay=true"), t(i).wrap('<div class="owl-video-frame" />').insertAfter(n.find(".owl-video")), this._playing = n.addClass("owl-video-playing"))
	}, r.prototype.isInFullScreen = function () {
		var e = i.fullscreenElement || i.mozFullScreenElement || i.webkitFullscreenElement;
		return e && t(e).parent().hasClass("owl-video-frame")
	}, r.prototype.destroy = function () {
		var t, e;
		for (t in this._core.$element.off("click.owl.video"), this._handlers) this._core.$element.off(t, this._handlers[t]);
		for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
	}, t.fn.owlCarousel.Constructor.Plugins.Video = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	var r = function (e) {
		this.core = e, this.core.options = t.extend({}, r.Defaults, this.core.options), this.swapping = !0, this.previous = void 0, this.next = void 0, this.handlers = {
			"change.owl.carousel": t.proxy(function (t) {
				t.namespace && "position" == t.property.name && (this.previous = this.core.current(), this.next = t.property.value)
			}, this), "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": t.proxy(function (t) {
				t.namespace && (this.swapping = "translated" == t.type)
			}, this), "translate.owl.carousel": t.proxy(function (t) {
				t.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
			}, this)
		}, this.core.$element.on(this.handlers)
	};
	r.Defaults = {animateOut: !1, animateIn: !1}, r.prototype.swap = function () {
		if (1 === this.core.settings.items && t.support.animation && t.support.transition) {
			this.core.speed(0);
			var e, i = t.proxy(this.clear, this), n = this.core.$stage.children().eq(this.previous), r = this.core.$stage.children().eq(this.next), o = this.core.settings.animateIn, a = this.core.settings.animateOut;
			this.core.current() !== this.previous && (a && (e = this.core.coordinates(this.previous) - this.core.coordinates(this.next), n.one(t.support.animation.end, i).css({left: e + "px"}).addClass("animated owl-animated-out").addClass(a)), o && r.one(t.support.animation.end, i).addClass("animated owl-animated-in").addClass(o))
		}
	}, r.prototype.clear = function (e) {
		t(e.target).css({left: ""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd()
	}, r.prototype.destroy = function () {
		var t, e;
		for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
		for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
	}, t.fn.owlCarousel.Constructor.Plugins.Animate = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	var r = function (e) {
		this._core = e, this._call = null, this._time = 0, this._timeout = 0, this._paused = !0, this._handlers = {
			"changed.owl.carousel": t.proxy(function (t) {
				t.namespace && "settings" === t.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : t.namespace && "position" === t.property.name && this._paused && (this._time = 0)
			}, this), "initialized.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.settings.autoplay && this.play()
			}, this), "play.owl.autoplay": t.proxy(function (t, e, i) {
				t.namespace && this.play(e, i)
			}, this), "stop.owl.autoplay": t.proxy(function (t) {
				t.namespace && this.stop()
			}, this), "mouseover.owl.autoplay": t.proxy(function () {
				this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
			}, this), "mouseleave.owl.autoplay": t.proxy(function () {
				this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
			}, this), "touchstart.owl.core": t.proxy(function () {
				this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
			}, this), "touchend.owl.core": t.proxy(function () {
				this._core.settings.autoplayHoverPause && this.play()
			}, this)
		}, this._core.$element.on(this._handlers), this._core.options = t.extend({}, r.Defaults, this._core.options)
	};
	r.Defaults = {autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1}, r.prototype._next = function (n) {
		this._call = e.setTimeout(t.proxy(this._next, this, n), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()), this._core.is("interacting") || i.hidden || this._core.next(n || this._core.settings.autoplaySpeed)
	}, r.prototype.read = function () {
		return (new Date).getTime() - this._time
	}, r.prototype.play = function (i, n) {
		var r;
		this._core.is("rotating") || this._core.enter("rotating"), i = i || this._core.settings.autoplayTimeout, r = Math.min(this._time % (this._timeout || i), i), this._paused ? (this._time = this.read(), this._paused = !1) : e.clearTimeout(this._call), this._time += this.read() % i - r, this._timeout = i, this._call = e.setTimeout(t.proxy(this._next, this, n), i - r)
	}, r.prototype.stop = function () {
		this._core.is("rotating") && (this._time = 0, this._paused = !0, e.clearTimeout(this._call), this._core.leave("rotating"))
	}, r.prototype.pause = function () {
		this._core.is("rotating") && !this._paused && (this._time = this.read(), this._paused = !0, e.clearTimeout(this._call))
	}, r.prototype.destroy = function () {
		var t, e;
		for (t in this.stop(), this._handlers) this._core.$element.off(t, this._handlers[t]);
		for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
	}, t.fn.owlCarousel.Constructor.Plugins.autoplay = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	"use strict";
	var r = function (e) {
		this._core = e, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {next: this._core.next, prev: this._core.prev, to: this._core.to}, this._handlers = {
			"prepared.owl.carousel": t.proxy(function (e) {
				e.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + t(e.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
			}, this), "added.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 0, this._templates.pop())
			}, this), "remove.owl.carousel": t.proxy(function (t) {
				t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 1)
			}, this), "changed.owl.carousel": t.proxy(function (t) {
				t.namespace && "position" == t.property.name && this.draw()
			}, this), "initialized.owl.carousel": t.proxy(function (t) {
				t.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"))
			}, this), "refreshed.owl.carousel": t.proxy(function (t) {
				t.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"))
			}, this)
		}, this._core.options = t.extend({}, r.Defaults, this._core.options), this.$element.on(this._handlers)
	};
	r.Defaults = {
		nav: !1,
		navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
		navSpeed: !1,
		navElement: 'button type="button" role="presentation"',
		navContainer: !1,
		navContainerClass: "owl-nav",
		navClass: ["owl-prev", "owl-next"],
		slideBy: 1,
		dotClass: "owl-dot",
		dotsClass: "owl-dots",
		dots: !0,
		dotsEach: !1,
		dotsData: !1,
		dotsSpeed: !1,
		dotsContainer: !1
	}, r.prototype.initialize = function () {
		var e, i = this._core.settings;
		for (e in this._controls.$relative = (i.navContainer ? t(i.navContainer) : t("<div>").addClass(i.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = t("<" + i.navElement + ">").addClass(i.navClass[0]).html(i.navText[0]).prependTo(this._controls.$relative).on("click", t.proxy(function (t) {
			this.prev(i.navSpeed)
		}, this)), this._controls.$next = t("<" + i.navElement + ">").addClass(i.navClass[1]).html(i.navText[1]).appendTo(this._controls.$relative).on("click", t.proxy(function (t) {
			this.next(i.navSpeed)
		}, this)), i.dotsData || (this._templates = [t('<button role="button">').addClass(i.dotClass).append(t("<span>")).prop("outerHTML")]), this._controls.$absolute = (i.dotsContainer ? t(i.dotsContainer) : t("<div>").addClass(i.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "button", t.proxy(function (e) {
			var n = t(e.target).parent().is(this._controls.$absolute) ? t(e.target).index() : t(e.target).parent().index();
			e.preventDefault(), this.to(n, i.dotsSpeed)
		}, this)), this._overrides) this._core[e] = t.proxy(this[e], this)
	}, r.prototype.destroy = function () {
		var t, e, i, n, r;
		for (t in r = this._core.settings, this._handlers) this.$element.off(t, this._handlers[t]);
		for (e in this._controls) "$relative" === e && r.navContainer ? this._controls[e].html("") : this._controls[e].remove();
		for (n in this.overides) this._core[n] = this._overrides[n];
		for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
	}, r.prototype.update = function () {
		var t, e, i = this._core.clones().length / 2, n = i + this._core.items().length, r = this._core.maximum(!0), o = this._core.settings, a = o.center || o.autoWidth || o.dotsData ? 1 : o.dotsEach || o.items;
		if ("page" !== o.slideBy && (o.slideBy = Math.min(o.slideBy, o.items)), o.dots || "page" == o.slideBy) for (this._pages = [], t = i, e = 0, 0; t < n; t++) {
			if (e >= a || 0 === e) {
				if (this._pages.push({start: Math.min(r, t - i), end: t - i + a - 1}), Math.min(r, t - i) === r) break;
				e = 0, 0
			}
			e += this._core.mergers(this._core.relative(t))
		}
	}, r.prototype.draw = function () {
		var e, i = this._core.settings, n = this._core.items().length <= i.items, r = this._core.relative(this._core.current()), o = i.loop || i.rewind;
		this._controls.$relative.toggleClass("disabled", !i.nav || n), i.nav && (this._controls.$previous.toggleClass("disabled", !o && r <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !o && r >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !i.dots || n), i.dots && (e = this._pages.length - this._controls.$absolute.children().length, i.dotsData && 0 !== e ? this._controls.$absolute.html(this._templates.join("")) : e > 0 ? this._controls.$absolute.append(new Array(e + 1).join(this._templates[0])) : e < 0 && this._controls.$absolute.children().slice(e).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(t.inArray(this.current(), this._pages)).addClass("active"))
	}, r.prototype.onTrigger = function (e) {
		var i = this._core.settings;
		e.page = {index: t.inArray(this.current(), this._pages), count: this._pages.length, size: i && (i.center || i.autoWidth || i.dotsData ? 1 : i.dotsEach || i.items)}
	}, r.prototype.current = function () {
		var e = this._core.relative(this._core.current());
		return t.grep(this._pages, t.proxy(function (t, i) {
			return t.start <= e && t.end >= e
		}, this)).pop()
	}, r.prototype.getPosition = function (e) {
		var i, n, r = this._core.settings;
		return "page" == r.slideBy ? (i = t.inArray(this.current(), this._pages), n = this._pages.length, e ? ++i : --i, i = this._pages[(i % n + n) % n].start) : (i = this._core.relative(this._core.current()), n = this._core.items().length, e ? i += r.slideBy : i -= r.slideBy), i
	}, r.prototype.next = function (e) {
		t.proxy(this._overrides.to, this._core)(this.getPosition(!0), e)
	}, r.prototype.prev = function (e) {
		t.proxy(this._overrides.to, this._core)(this.getPosition(!1), e)
	}, r.prototype.to = function (e, i, n) {
		var r;
		!n && this._pages.length ? (r = this._pages.length, t.proxy(this._overrides.to, this._core)(this._pages[(e % r + r) % r].start, i)) : t.proxy(this._overrides.to, this._core)(e, i)
	}, t.fn.owlCarousel.Constructor.Plugins.Navigation = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	"use strict";
	var r = function (i) {
		this._core = i, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
			"initialized.owl.carousel": t.proxy(function (i) {
				i.namespace && "URLHash" === this._core.settings.startPosition && t(e).trigger("hashchange.owl.navigation")
			}, this), "prepared.owl.carousel": t.proxy(function (e) {
				if (e.namespace) {
					var i = t(e.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
					if (!i) return;
					this._hashes[i] = e.content
				}
			}, this), "changed.owl.carousel": t.proxy(function (i) {
				if (i.namespace && "position" === i.property.name) {
					var n = this._core.items(this._core.relative(this._core.current())), r = t.map(this._hashes, function (t, e) {
						return t === n ? e : null
					}).join();
					if (!r || e.location.hash.slice(1) === r) return;
					e.location.hash = r
				}
			}, this)
		}, this._core.options = t.extend({}, r.Defaults, this._core.options), this.$element.on(this._handlers), t(e).on("hashchange.owl.navigation", t.proxy(function (t) {
			var i = e.location.hash.substring(1), n = this._core.$stage.children(), r = this._hashes[i] && n.index(this._hashes[i]);
			void 0 !== r && r !== this._core.current() && this._core.to(this._core.relative(r), !1, !0)
		}, this))
	};
	r.Defaults = {URLhashListener: !1}, r.prototype.destroy = function () {
		var i, n;
		for (i in t(e).off("hashchange.owl.navigation"), this._handlers) this._core.$element.off(i, this._handlers[i]);
		for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null)
	}, t.fn.owlCarousel.Constructor.Plugins.Hash = r
}(window.Zepto || window.jQuery, window, document), function (t, e, i, n) {
	var r = t("<support>").get(0).style, o = "Webkit Moz O ms".split(" "), a = {
		transition: {end: {WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend"}},
		animation: {end: {WebkitAnimation: "webkitAnimationEnd", MozAnimation: "animationend", OAnimation: "oAnimationEnd", animation: "animationend"}}
	}, s = function () {
		return !!u("transform")
	}, l = function () {
		return !!u("perspective")
	}, c = function () {
		return !!u("animation")
	};

	function u(e, i) {
		var a = !1, s = e.charAt(0).toUpperCase() + e.slice(1);
		return t.each((e + " " + o.join(s + " ") + s).split(" "), function (t, e) {
			if (r[e] !== n) return a = !i || e, !1
		}), a
	}

	function h(t) {
		return u(t, !0)
	}

	(function () {
		return !!u("transition")
	})() && (t.support.transition = new String(h("transition")), t.support.transition.end = a.transition.end[t.support.transition]), c() && (t.support.animation = new String(h("animation")), t.support.animation.end = a.animation.end[t.support.animation]), s() && (t.support.transform = new String(h("transform")), t.support.transform3d = l())
}(window.Zepto || window.jQuery, window, document), function (t, e) {
	if ("function" == typeof define && define.amd) define(["module", "exports"], e); else if ("undefined" != typeof exports) e(module, exports); else {
		var i = {exports: {}};
		e(i, i.exports), t.autosize = i.exports
	}
}(this, function (t, e) {
	"use strict";
	var i, n, r = "function" == typeof Map ? new Map : (i = [], n = [], {
		has: function (t) {
			return i.indexOf(t) > -1
		}, get: function (t) {
			return n[i.indexOf(t)]
		}, set: function (t, e) {
			-1 === i.indexOf(t) && (i.push(t), n.push(e))
		}, delete: function (t) {
			var e = i.indexOf(t);
			e > -1 && (i.splice(e, 1), n.splice(e, 1))
		}
	}), o = function (t) {
		return new Event(t, {bubbles: !0})
	};
	try {
		new Event("test")
	} catch (t) {
		o = function (t) {
			var e = document.createEvent("Event");
			return e.initEvent(t, !0, !1), e
		}
	}

	function a(t) {
		if (t && t.nodeName && "TEXTAREA" === t.nodeName && !r.has(t)) {
			var e, i = null, n = null, a = null, s = function () {
				t.clientWidth !== n && h()
			}, l = function (e) {
				window.removeEventListener("resize", s, !1), t.removeEventListener("input", h, !1), t.removeEventListener("keyup", h, !1), t.removeEventListener("autosize:destroy", l, !1), t.removeEventListener("autosize:update", h, !1), Object.keys(e).forEach(function (i) {
					t.style[i] = e[i]
				}), r.delete(t)
			}.bind(t, {height: t.style.height, resize: t.style.resize, overflowY: t.style.overflowY, overflowX: t.style.overflowX, wordWrap: t.style.wordWrap});
			t.addEventListener("autosize:destroy", l, !1), "onpropertychange" in t && "oninput" in t && t.addEventListener("keyup", h, !1), window.addEventListener("resize", s, !1), t.addEventListener("input", h, !1), t.addEventListener("autosize:update", h, !1), t.style.overflowX = "hidden", t.style.wordWrap = "break-word", r.set(t, {
				destroy: l,
				update: h
			}), "vertical" === (e = window.getComputedStyle(t, null)).resize ? t.style.resize = "none" : "both" === e.resize && (t.style.resize = "horizontal"), i = "content-box" === e.boxSizing ? -(parseFloat(e.paddingTop) + parseFloat(e.paddingBottom)) : parseFloat(e.borderTopWidth) + parseFloat(e.borderBottomWidth), isNaN(i) && (i = 0), h()
		}

		function c(e) {
			var i = t.style.width;
			t.style.width = "0px", t.offsetWidth, t.style.width = i, t.style.overflowY = e
		}

		function u() {
			if (0 !== t.scrollHeight) {
				var e = function (t) {
					for (var e = []; t && t.parentNode && t.parentNode instanceof Element;) t.parentNode.scrollTop && e.push({node: t.parentNode, scrollTop: t.parentNode.scrollTop}), t = t.parentNode;
					return e
				}(t), r = document.documentElement && document.documentElement.scrollTop;
				t.style.height = "", t.style.height = t.scrollHeight + i + "px", n = t.clientWidth, e.forEach(function (t) {
					t.node.scrollTop = t.scrollTop
				}), r && (document.documentElement.scrollTop = r)
			}
		}

		function h() {
			u();
			var e = Math.round(parseFloat(t.style.height)), i = window.getComputedStyle(t, null), n = "content-box" === i.boxSizing ? Math.round(parseFloat(i.height)) : t.offsetHeight;
			if (n < e ? "hidden" === i.overflowY && (c("scroll"), u(), n = "content-box" === i.boxSizing ? Math.round(parseFloat(window.getComputedStyle(t, null).height)) : t.offsetHeight) : "hidden" !== i.overflowY && (c("hidden"), u(), n = "content-box" === i.boxSizing ? Math.round(parseFloat(window.getComputedStyle(t, null).height)) : t.offsetHeight), a !== n) {
				a = n;
				var r = o("autosize:resized");
				try {
					t.dispatchEvent(r)
				} catch (t) {
				}
			}
		}
	}

	function s(t) {
		var e = r.get(t);
		e && e.destroy()
	}

	function l(t) {
		var e = r.get(t);
		e && e.update()
	}

	var c = null;
	"undefined" == typeof window || "function" != typeof window.getComputedStyle ? ((c = function (t) {
		return t
	}).destroy = function (t) {
		return t
	}, c.update = function (t) {
		return t
	}) : ((c = function (t, e) {
		return t && Array.prototype.forEach.call(t.length ? t : [t], function (t) {
			return a(t)
		}), t
	}).destroy = function (t) {
		return t && Array.prototype.forEach.call(t.length ? t : [t], s), t
	}, c.update = function (t) {
		return t && Array.prototype.forEach.call(t.length ? t : [t], l), t
	}), e.default = c, t.exports = e.default
}), function (t) {
	if ("object" == typeof exports && "undefined" != typeof module) module.exports = t(); else if ("function" == typeof define && define.amd) define([], t); else {
		("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).Clipboard = t()
	}
}(function () {
	return function t(e, i, n) {
		function r(a, s) {
			if (!i[a]) {
				if (!e[a]) {
					var l = "function" == typeof require && require;
					if (!s && l) return l(a, !0);
					if (o) return o(a, !0);
					var c = new Error("Cannot find module '" + a + "'");
					throw c.code = "MODULE_NOT_FOUND", c
				}
				var u = i[a] = {exports: {}};
				e[a][0].call(u.exports, function (t) {
					return r(e[a][1][t] || t)
				}, u, u.exports, t, e, i, n)
			}
			return i[a].exports
		}

		for (var o = "function" == typeof require && require, a = 0; a < n.length; a++) r(n[a]);
		return r
	}({
		1: [function (t, e, i) {
			var n = 9;
			if ("undefined" != typeof Element && !Element.prototype.matches) {
				var r = Element.prototype;
				r.matches = r.matchesSelector || r.mozMatchesSelector || r.msMatchesSelector || r.oMatchesSelector || r.webkitMatchesSelector
			}
			e.exports = function (t, e) {
				for (; t && t.nodeType !== n;) {
					if ("function" == typeof t.matches && t.matches(e)) return t;
					t = t.parentNode
				}
			}
		}, {}], 2: [function (t, e, i) {
			function n(t, e, i, n) {
				return function (i) {
					i.delegateTarget = r(i.target, e), i.delegateTarget && n.call(t, i)
				}
			}

			var r = t("./closest");
			e.exports = function (t, e, i, r, o) {
				var a = n.apply(this, arguments);
				return t.addEventListener(i, a, o), {
					destroy: function () {
						t.removeEventListener(i, a, o)
					}
				}
			}
		}, {"./closest": 1}], 3: [function (t, e, i) {
			i.node = function (t) {
				return void 0 !== t && t instanceof HTMLElement && 1 === t.nodeType
			}, i.nodeList = function (t) {
				var e = Object.prototype.toString.call(t);
				return void 0 !== t && ("[object NodeList]" === e || "[object HTMLCollection]" === e) && "length" in t && (0 === t.length || i.node(t[0]))
			}, i.string = function (t) {
				return "string" == typeof t || t instanceof String
			}, i.fn = function (t) {
				return "[object Function]" === Object.prototype.toString.call(t)
			}
		}, {}], 4: [function (t, e, i) {
			var n = t("./is"), r = t("delegate");
			e.exports = function (t, e, i) {
				if (!t && !e && !i) throw new Error("Missing required arguments");
				if (!n.string(e)) throw new TypeError("Second argument must be a String");
				if (!n.fn(i)) throw new TypeError("Third argument must be a Function");
				if (n.node(t)) return function (t, e, i) {
					return t.addEventListener(e, i), {
						destroy: function () {
							t.removeEventListener(e, i)
						}
					}
				}(t, e, i);
				if (n.nodeList(t)) return function (t, e, i) {
					return Array.prototype.forEach.call(t, function (t) {
						t.addEventListener(e, i)
					}), {
						destroy: function () {
							Array.prototype.forEach.call(t, function (t) {
								t.removeEventListener(e, i)
							})
						}
					}
				}(t, e, i);
				if (n.string(t)) return function (t, e, i) {
					return r(document.body, t, e, i)
				}(t, e, i);
				throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")
			}
		}, {"./is": 3, delegate: 2}], 5: [function (t, e, i) {
			e.exports = function (t) {
				var e;
				if ("SELECT" === t.nodeName) t.focus(), e = t.value; else if ("INPUT" === t.nodeName || "TEXTAREA" === t.nodeName) {
					var i = t.hasAttribute("readonly");
					i || t.setAttribute("readonly", ""), t.select(), t.setSelectionRange(0, t.value.length), i || t.removeAttribute("readonly"), e = t.value
				} else {
					t.hasAttribute("contenteditable") && t.focus();
					var n = window.getSelection(), r = document.createRange();
					r.selectNodeContents(t), n.removeAllRanges(), n.addRange(r), e = n.toString()
				}
				return e
			}
		}, {}], 6: [function (t, e, i) {
			function n() {
			}

			n.prototype = {
				on: function (t, e, i) {
					var n = this.e || (this.e = {});
					return (n[t] || (n[t] = [])).push({fn: e, ctx: i}), this
				}, once: function (t, e, i) {
					function n() {
						r.off(t, n), e.apply(i, arguments)
					}

					var r = this;
					return n._ = e, this.on(t, n, i)
				}, emit: function (t) {
					for (var e = [].slice.call(arguments, 1), i = ((this.e || (this.e = {}))[t] || []).slice(), n = 0, r = i.length; n < r; n++) i[n].fn.apply(i[n].ctx, e);
					return this
				}, off: function (t, e) {
					var i = this.e || (this.e = {}), n = i[t], r = [];
					if (n && e) for (var o = 0, a = n.length; o < a; o++) n[o].fn !== e && n[o].fn._ !== e && r.push(n[o]);
					return r.length ? i[t] = r : delete i[t], this
				}
			}, e.exports = n
		}, {}], 7: [function (t, e, i) {
			!function (n, r) {
				if (void 0 !== i) r(e, t("select")); else {
					var o = {exports: {}};
					r(o, n.select), n.clipboardAction = o.exports
				}
			}(this, function (t, e) {
				"use strict";
				var i = function (t) {
					return t && t.__esModule ? t : {default: t}
				}(e), n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
					return typeof t
				} : function (t) {
					return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
				}, r = function () {
					function t(t, e) {
						for (var i = 0; i < e.length; i++) {
							var n = e[i];
							n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
						}
					}

					return function (e, i, n) {
						return i && t(e.prototype, i), n && t(e, n), e
					}
				}(), o = function () {
					function t(e) {
						(function (t, e) {
							if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
						})(this, t), this.resolveOptions(e), this.initSelection()
					}

					return r(t, [{
						key: "resolveOptions", value: function () {
							var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
							this.action = t.action, this.container = t.container, this.emitter = t.emitter, this.target = t.target, this.text = t.text, this.trigger = t.trigger, this.selectedText = ""
						}
					}, {
						key: "initSelection", value: function () {
							this.text ? this.selectFake() : this.target && this.selectTarget()
						}
					}, {
						key: "selectFake", value: function () {
							var t = this, e = "rtl" == document.documentElement.getAttribute("dir");
							this.removeFake(), this.fakeHandlerCallback = function () {
								return t.removeFake()
							}, this.fakeHandler = this.container.addEventListener("click", this.fakeHandlerCallback) || !0, this.fakeElem = document.createElement("textarea"), this.fakeElem.style.fontSize = "12pt", this.fakeElem.style.border = "0", this.fakeElem.style.padding = "0", this.fakeElem.style.margin = "0", this.fakeElem.style.position = "absolute", this.fakeElem.style[e ? "right" : "left"] = "-9999px";
							var n = window.pageYOffset || document.documentElement.scrollTop;
							this.fakeElem.style.top = n + "px", this.fakeElem.setAttribute("readonly", ""), this.fakeElem.value = this.text, this.container.appendChild(this.fakeElem), this.selectedText = (0, i.default)(this.fakeElem), this.copyText()
						}
					}, {
						key: "removeFake", value: function () {
							this.fakeHandler && (this.container.removeEventListener("click", this.fakeHandlerCallback), this.fakeHandler = null, this.fakeHandlerCallback = null), this.fakeElem && (this.container.removeChild(this.fakeElem), this.fakeElem = null)
						}
					}, {
						key: "selectTarget", value: function () {
							this.selectedText = (0, i.default)(this.target), this.copyText()
						}
					}, {
						key: "copyText", value: function () {
							var t = void 0;
							try {
								t = document.execCommand(this.action)
							} catch (e) {
								t = !1
							}
							this.handleResult(t)
						}
					}, {
						key: "handleResult", value: function (t) {
							this.emitter.emit(t ? "success" : "error", {action: this.action, text: this.selectedText, trigger: this.trigger, clearSelection: this.clearSelection.bind(this)})
						}
					}, {
						key: "clearSelection", value: function () {
							this.trigger && this.trigger.focus(), window.getSelection().removeAllRanges()
						}
					}, {
						key: "destroy", value: function () {
							this.removeFake()
						}
					}, {
						key: "action", set: function () {
							var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "copy";
							if (this._action = t, "copy" !== this._action && "cut" !== this._action) throw new Error('Invalid "action" value, use either "copy" or "cut"')
						}, get: function () {
							return this._action
						}
					}, {
						key: "target", set: function (t) {
							if (void 0 !== t) {
								if (!t || "object" !== (void 0 === t ? "undefined" : n(t)) || 1 !== t.nodeType) throw new Error('Invalid "target" value, use a valid Element');
								if ("copy" === this.action && t.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
								if ("cut" === this.action && (t.hasAttribute("readonly") || t.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
								this._target = t
							}
						}, get: function () {
							return this._target
						}
					}]), t
				}();
				t.exports = o
			})
		}, {select: 5}], 8: [function (t, e, i) {
			!function (n, r) {
				if (void 0 !== i) r(e, t("./clipboard-action"), t("tiny-emitter"), t("good-listener")); else {
					var o = {exports: {}};
					r(o, n.clipboardAction, n.tinyEmitter, n.goodListener), n.clipboard = o.exports
				}
			}(this, function (t, e, i, n) {
				"use strict";

				function r(t) {
					return t && t.__esModule ? t : {default: t}
				}

				function o(t, e) {
					var i = "data-clipboard-" + t;
					if (e.hasAttribute(i)) return e.getAttribute(i)
				}

				var a = r(e), s = r(i), l = r(n), c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
					return typeof t
				} : function (t) {
					return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
				}, u = function () {
					function t(t, e) {
						for (var i = 0; i < e.length; i++) {
							var n = e[i];
							n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
						}
					}

					return function (e, i, n) {
						return i && t(e.prototype, i), n && t(e, n), e
					}
				}(), h = function (t) {
					function e(t, i) {
						!function (t, e) {
							if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
						}(this, e);
						var n = function (t, e) {
							if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
							return !e || "object" != typeof e && "function" != typeof e ? t : e
						}(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
						return n.resolveOptions(i), n.listenClick(t), n
					}

					return function (t, e) {
						if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
						t.prototype = Object.create(e && e.prototype, {constructor: {value: t, enumerable: !1, writable: !0, configurable: !0}}), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e)
					}(e, s.default), u(e, [{
						key: "resolveOptions", value: function () {
							var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
							this.action = "function" == typeof t.action ? t.action : this.defaultAction, this.target = "function" == typeof t.target ? t.target : this.defaultTarget, this.text = "function" == typeof t.text ? t.text : this.defaultText, this.container = "object" === c(t.container) ? t.container : document.body
						}
					}, {
						key: "listenClick", value: function (t) {
							var e = this;
							this.listener = (0, l.default)(t, "click", function (t) {
								return e.onClick(t)
							})
						}
					}, {
						key: "onClick", value: function (t) {
							var e = t.delegateTarget || t.currentTarget;
							this.clipboardAction && (this.clipboardAction = null), this.clipboardAction = new a.default({action: this.action(e), target: this.target(e), text: this.text(e), container: this.container, trigger: e, emitter: this})
						}
					}, {
						key: "defaultAction", value: function (t) {
							return o("action", t)
						}
					}, {
						key: "defaultTarget", value: function (t) {
							var e = o("target", t);
							if (e) return document.querySelector(e)
						}
					}, {
						key: "defaultText", value: function (t) {
							return o("text", t)
						}
					}, {
						key: "destroy", value: function () {
							this.listener.destroy(), this.clipboardAction && (this.clipboardAction.destroy(), this.clipboardAction = null)
						}
					}], [{
						key: "isSupported", value: function () {
							var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["copy", "cut"], e = "string" == typeof t ? [t] : t, i = !!document.queryCommandSupported;
							return e.forEach(function (t) {
								i = i && !!document.queryCommandSupported(t)
							}), i
						}
					}]), e
				}();
				t.exports = h
			})
		}, {"./clipboard-action": 7, "good-listener": 4, "tiny-emitter": 6}]
	}, {}, [8])(8)
});
var _createClass = function () {
	function t(t, e) {
		for (var i = 0; i < e.length; i++) {
			var n = e[i];
			n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
		}
	}

	return function (e, i, n) {
		return i && t(e.prototype, i), n && t(e, n), e
	}
}();

function _possibleConstructorReturn(t, e) {
	if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	return !e || "object" != typeof e && "function" != typeof e ? t : e
}

function _inherits(t, e) {
	if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
	t.prototype = Object.create(e && e.prototype, {constructor: {value: t, enumerable: !1, writable: !0, configurable: !0}}), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e)
}

function _classCallCheck(t, e) {
	if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
}

var Emitter = function () {
	function t() {
		_classCallCheck(this, t)
	}

	return _createClass(t, [{
		key: "on", value: function (t, e) {
			return this._callbacks = this._callbacks || {}, this._callbacks[t] || (this._callbacks[t] = []), this._callbacks[t].push(e), this
		}
	}, {
		key: "emit", value: function (t) {
			this._callbacks = this._callbacks || {};
			var e = this._callbacks[t];
			if (e) {
				for (var i = arguments.length, n = Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) n[r - 1] = arguments[r];
				for (var o = 0, a = a = e; ;) {
					if (o >= a.length) break;
					a[o++].apply(this, n)
				}
			}
			return this
		}
	}, {
		key: "off", value: function (t, e) {
			if (!this._callbacks || 0 === arguments.length) return this._callbacks = {}, this;
			var i = this._callbacks[t];
			if (!i) return this;
			if (1 === arguments.length) return delete this._callbacks[t], this;
			for (var n = 0; n < i.length; n++) {
				if (i[n] === e) {
					i.splice(n, 1);
					break
				}
			}
			return this
		}
	}]), t
}(), Dropzone = function (t) {
	function e(t, i) {
		_classCallCheck(this, e);
		var n, r = _possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this)), o = void 0;
		if (r.element = t, r.version = e.version, r.defaultOptions.previewTemplate = r.defaultOptions.previewTemplate.replace(/\n*/g, ""), r.clickableElements = [], r.listeners = [], r.files = [], "string" == typeof r.element && (r.element = document.querySelector(r.element)), !r.element || null == r.element.nodeType) throw new Error("Invalid dropzone element.");
		if (r.element.dropzone) throw new Error("Dropzone already attached.");
		e.instances.push(r), r.element.dropzone = r;
		var a, s = null != (n = e.optionsForElement(r.element)) ? n : {};
		if (r.options = e.extend({}, r.defaultOptions, s, null != i ? i : {}), r.options.forceFallback || !e.isBrowserSupported()) return a = r.options.fallback.call(r), _possibleConstructorReturn(r, a);
		if (null == r.options.url && (r.options.url = r.element.getAttribute("action")), !r.options.url) throw new Error("No URL provided.");
		if (r.options.acceptedFiles && r.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
		if (r.options.uploadMultiple && r.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
		return r.options.acceptedMimeTypes && (r.options.acceptedFiles = r.options.acceptedMimeTypes, delete r.options.acceptedMimeTypes), null != r.options.renameFilename && (r.options.renameFile = function (t) {
			return r.options.renameFilename.call(r, t.name, t)
		}), r.options.method = r.options.method.toUpperCase(), (o = r.getExistingFallback()) && o.parentNode && o.parentNode.removeChild(o), !1 !== r.options.previewsContainer && (r.options.previewsContainer ? r.previewsContainer = e.getElement(r.options.previewsContainer, "previewsContainer") : r.previewsContainer = r.element), r.options.clickable && (!0 === r.options.clickable ? r.clickableElements = [r.element] : r.clickableElements = e.getElements(r.options.clickable, "clickable")), r.init(), r
	}

	return _inherits(e, Emitter), _createClass(e, null, [{
		key: "initClass", value: function () {
			this.prototype.Emitter = Emitter, this.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"], this.prototype.defaultOptions = {
				url: null,
				method: "post",
				withCredentials: !1,
				timeout: 3e4,
				parallelUploads: 2,
				uploadMultiple: !1,
				chunking: !1,
				forceChunking: !1,
				chunkSize: 2e6,
				parallelChunkUploads: !1,
				retryChunks: !1,
				retryChunksLimit: 3,
				maxFilesize: 256,
				paramName: "file",
				createImageThumbnails: !0,
				maxThumbnailFilesize: 10,
				thumbnailWidth: 120,
				thumbnailHeight: 120,
				thumbnailMethod: "crop",
				resizeWidth: null,
				resizeHeight: null,
				resizeMimeType: null,
				resizeQuality: .8,
				resizeMethod: "contain",
				filesizeBase: 1e3,
				maxFiles: null,
				headers: null,
				clickable: !0,
				ignoreHiddenFiles: !0,
				acceptedFiles: null,
				acceptedMimeTypes: null,
				autoProcessQueue: !0,
				autoQueue: !0,
				addRemoveLinks: !1,
				previewsContainer: null,
				hiddenInputContainer: "body",
				capture: null,
				renameFilename: null,
				renameFile: null,
				forceFallback: !1,
				dictDefaultMessage: "Drop files here to upload",
				dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
				dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
				dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
				dictInvalidFileType: "You can't upload files of this type.",
				dictResponseError: "Server responded with {{statusCode}} code.",
				dictCancelUpload: "Cancel upload",
				dictUploadCanceled: "Upload canceled.",
				dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
				dictRemoveFile: "Remove file",
				dictRemoveFileConfirmation: null,
				dictMaxFilesExceeded: "You can not upload any more files.",
				dictFileSizeUnits: {tb: "TB", gb: "GB", mb: "MB", kb: "KB", b: "b"},
				init: function () {
				},
				params: function (t, e, i) {
					if (i) return {dzuuid: i.file.upload.uuid, dzchunkindex: i.index, dztotalfilesize: i.file.size, dzchunksize: this.options.chunkSize, dztotalchunkcount: i.file.upload.totalChunkCount, dzchunkbyteoffset: i.index * this.options.chunkSize}
				},
				accept: function (t, e) {
					return e()
				},
				chunksUploaded: function (t, e) {
					e()
				},
				fallback: function () {
					var t = void 0;
					this.element.className = this.element.className + " dz-browser-not-supported";
					for (var i = 0, n = n = this.element.getElementsByTagName("div"); ;) {
						if (i >= n.length) break;
						var r = n[i++];
						if (/(^| )dz-message($| )/.test(r.className)) {
							t = r, r.className = "dz-message";
							break
						}
					}
					t || (t = e.createElement('<div class="dz-message"><span></span></div>'), this.element.appendChild(t));
					var o = t.getElementsByTagName("span")[0];
					return o && (null != o.textContent ? o.textContent = this.options.dictFallbackMessage : null != o.innerText && (o.innerText = this.options.dictFallbackMessage)), this.element.appendChild(this.getFallbackForm())
				},
				resize: function (t, e, i, n) {
					var r = {srcX: 0, srcY: 0, srcWidth: t.width, srcHeight: t.height}, o = t.width / t.height;
					null == e && null == i ? (e = r.srcWidth, i = r.srcHeight) : null == e ? e = i * o : null == i && (i = e / o);
					var a = (e = Math.min(e, r.srcWidth)) / (i = Math.min(i, r.srcHeight));
					if (r.srcWidth > e || r.srcHeight > i) if ("crop" === n) o > a ? (r.srcHeight = t.height, r.srcWidth = r.srcHeight * a) : (r.srcWidth = t.width, r.srcHeight = r.srcWidth / a); else {
						if ("contain" !== n) throw new Error("Unknown resizeMethod '" + n + "'");
						o > a ? i = e / o : e = i * o
					}
					return r.srcX = (t.width - r.srcWidth) / 2, r.srcY = (t.height - r.srcHeight) / 2, r.trgWidth = e, r.trgHeight = i, r
				},
				transformFile: function (t, e) {
					return (this.options.resizeWidth || this.options.resizeHeight) && t.type.match(/image.*/) ? this.resizeImage(t, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, e) : e(t)
				},
				previewTemplate: '<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail /></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size></span></div>\n    <div class="dz-filename"><span data-dz-name></span></div>\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-error-message"><span data-dz-errormessage></span></div>\n  <div class="dz-success-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Check</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>\n      </g>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Error</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">\n          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>',
				drop: function (t) {
					return this.element.classList.remove("dz-drag-hover")
				},
				dragstart: function (t) {
				},
				dragend: function (t) {
					return this.element.classList.remove("dz-drag-hover")
				},
				dragenter: function (t) {
					return this.element.classList.add("dz-drag-hover")
				},
				dragover: function (t) {
					return this.element.classList.add("dz-drag-hover")
				},
				dragleave: function (t) {
					return this.element.classList.remove("dz-drag-hover")
				},
				paste: function (t) {
				},
				reset: function () {
					return this.element.classList.remove("dz-started")
				},
				addedfile: function (t) {
					var i = this;
					if (this.element === this.previewsContainer && this.element.classList.add("dz-started"), this.previewsContainer) {
						t.previewElement = e.createElement(this.options.previewTemplate.trim()), t.previewTemplate = t.previewElement, this.previewsContainer.appendChild(t.previewElement);
						for (var n = 0, r = r = t.previewElement.querySelectorAll("[data-dz-name]"); ;) {
							if (n >= r.length) break;
							var o = r[n++];
							o.textContent = t.name
						}
						for (var a = 0, s = s = t.previewElement.querySelectorAll("[data-dz-size]"); !(a >= s.length);) (o = s[a++]).innerHTML = this.filesize(t.size);
						this.options.addRemoveLinks && (t._removeLink = e.createElement('<a class="dz-remove" href="javascript:undefined;" data-dz-remove>' + this.options.dictRemoveFile + "</a>"), t.previewElement.appendChild(t._removeLink));
						for (var l = function (n) {
							return n.preventDefault(), n.stopPropagation(), t.status === e.UPLOADING ? e.confirm(i.options.dictCancelUploadConfirmation, function () {
								return i.removeFile(t)
							}) : i.options.dictRemoveFileConfirmation ? e.confirm(i.options.dictRemoveFileConfirmation, function () {
								return i.removeFile(t)
							}) : i.removeFile(t)
						}, c = 0, u = u = t.previewElement.querySelectorAll("[data-dz-remove]"); ;) {
							if (c >= u.length) break;
							u[c++].addEventListener("click", l)
						}
					}
				},
				removedfile: function (t) {
					return null != t.previewElement && null != t.previewElement.parentNode && t.previewElement.parentNode.removeChild(t.previewElement), this._updateMaxFilesReachedClass()
				},
				thumbnail: function (t, e) {
					if (t.previewElement) {
						t.previewElement.classList.remove("dz-file-preview");
						for (var i = 0, n = n = t.previewElement.querySelectorAll("[data-dz-thumbnail]"); ;) {
							if (i >= n.length) break;
							var r = n[i++];
							r.alt = t.name, r.src = e
						}
						return setTimeout(function () {
							return t.previewElement.classList.add("dz-image-preview")
						}, 1)
					}
				},
				error: function (t, e) {
					if (t.previewElement) {
						t.previewElement.classList.add("dz-error"), "String" != typeof e && e.error && (e = e.error);
						for (var i = 0, n = n = t.previewElement.querySelectorAll("[data-dz-errormessage]"); ;) {
							if (i >= n.length) break;
							n[i++].textContent = e
						}
					}
				},
				errormultiple: function () {
				},
				processing: function (t) {
					if (t.previewElement && (t.previewElement.classList.add("dz-processing"), t._removeLink)) return t._removeLink.innerHTML = this.options.dictCancelUpload
				},
				processingmultiple: function () {
				},
				uploadprogress: function (t, e, i) {
					if (t.previewElement) for (var n = 0, r = r = t.previewElement.querySelectorAll("[data-dz-uploadprogress]"); ;) {
						if (n >= r.length) break;
						var o = r[n++];
						"PROGRESS" === o.nodeName ? o.value = e : o.style.width = e + "%"
					}
				},
				totaluploadprogress: function () {
				},
				sending: function () {
				},
				sendingmultiple: function () {
				},
				success: function (t) {
					if (t.previewElement) return t.previewElement.classList.add("dz-success")
				},
				successmultiple: function () {
				},
				canceled: function (t) {
					return this.emit("error", t, this.options.dictUploadCanceled)
				},
				canceledmultiple: function () {
				},
				complete: function (t) {
					if (t._removeLink && (t._removeLink.innerHTML = this.options.dictRemoveFile), t.previewElement) return t.previewElement.classList.add("dz-complete")
				},
				completemultiple: function () {
				},
				maxfilesexceeded: function () {
				},
				maxfilesreached: function () {
				},
				queuecomplete: function () {
				},
				addedfiles: function () {
				}
			}, this.prototype._thumbnailQueue = [], this.prototype._processingThumbnail = !1
		}
	}, {
		key: "extend", value: function (t) {
			for (var e = arguments.length, i = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) i[n - 1] = arguments[n];
			for (var r = 0, o = o = i; ;) {
				if (r >= o.length) break;
				var a = o[r++];
				for (var s in a) {
					var l = a[s];
					t[s] = l
				}
			}
			return t
		}
	}]), _createClass(e, [{
		key: "getAcceptedFiles", value: function () {
			return this.files.filter(function (t) {
				return t.accepted
			}).map(function (t) {
				return t
			})
		}
	}, {
		key: "getRejectedFiles", value: function () {
			return this.files.filter(function (t) {
				return !t.accepted
			}).map(function (t) {
				return t
			})
		}
	}, {
		key: "getFilesWithStatus", value: function (t) {
			return this.files.filter(function (e) {
				return e.status === t
			}).map(function (t) {
				return t
			})
		}
	}, {
		key: "getQueuedFiles", value: function () {
			return this.getFilesWithStatus(e.QUEUED)
		}
	}, {
		key: "getUploadingFiles", value: function () {
			return this.getFilesWithStatus(e.UPLOADING)
		}
	}, {
		key: "getAddedFiles", value: function () {
			return this.getFilesWithStatus(e.ADDED)
		}
	}, {
		key: "getActiveFiles", value: function () {
			return this.files.filter(function (t) {
				return t.status === e.UPLOADING || t.status === e.QUEUED
			}).map(function (t) {
				return t
			})
		}
	}, {
		key: "init", value: function () {
			var t = this;
			if ("form" === this.element.tagName && this.element.setAttribute("enctype", "multipart/form-data"), this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message") && this.element.appendChild(e.createElement('<div class="dz-default dz-message"><span>' + this.options.dictDefaultMessage + "</span></div>")), this.clickableElements.length) {
				!function i() {
					return t.hiddenFileInput && t.hiddenFileInput.parentNode.removeChild(t.hiddenFileInput), t.hiddenFileInput = document.createElement("input"), t.hiddenFileInput.setAttribute("type", "file"), (null === t.options.maxFiles || t.options.maxFiles > 1) && t.hiddenFileInput.setAttribute("multiple", "multiple"), t.hiddenFileInput.className = "dz-hidden-input", null !== t.options.acceptedFiles && t.hiddenFileInput.setAttribute("accept", t.options.acceptedFiles), null !== t.options.capture && t.hiddenFileInput.setAttribute("capture", t.options.capture), t.hiddenFileInput.style.visibility = "hidden", t.hiddenFileInput.style.position = "absolute", t.hiddenFileInput.style.top = "0", t.hiddenFileInput.style.left = "0", t.hiddenFileInput.style.height = "0", t.hiddenFileInput.style.width = "0", e.getElement(t.options.hiddenInputContainer, "hiddenInputContainer").appendChild(t.hiddenFileInput), t.hiddenFileInput.addEventListener("change", function () {
						var e = t.hiddenFileInput.files;
						if (e.length) for (var n = 0, r = r = e; !(n >= r.length);) {
							var o = r[n++];
							t.addFile(o)
						}
						return t.emit("addedfiles", e), i()
					})
				}()
			}
			this.URL = null !== window.URL ? window.URL : window.webkitURL;
			for (var i = 0, n = n = this.events; ;) {
				if (i >= n.length) break;
				var r = n[i++];
				this.on(r, this.options[r])
			}
			this.on("uploadprogress", function () {
				return t.updateTotalUploadProgress()
			}), this.on("removedfile", function () {
				return t.updateTotalUploadProgress()
			}), this.on("canceled", function (e) {
				return t.emit("complete", e)
			}), this.on("complete", function (e) {
				if (0 === t.getAddedFiles().length && 0 === t.getUploadingFiles().length && 0 === t.getQueuedFiles().length) return setTimeout(function () {
					return t.emit("queuecomplete")
				}, 0)
			});
			var o = function (t) {
				return t.stopPropagation(), t.preventDefault ? t.preventDefault() : t.returnValue = !1
			};
			return this.listeners = [{
				element: this.element, events: {
					dragstart: function (e) {
						return t.emit("dragstart", e)
					}, dragenter: function (e) {
						return o(e), t.emit("dragenter", e)
					}, dragover: function (e) {
						var i = void 0;
						try {
							i = e.dataTransfer.effectAllowed
						} catch (t) {
						}
						return e.dataTransfer.dropEffect = "move" === i || "linkMove" === i ? "move" : "copy", o(e), t.emit("dragover", e)
					}, dragleave: function (e) {
						return t.emit("dragleave", e)
					}, drop: function (e) {
						return o(e), t.drop(e)
					}, dragend: function (e) {
						return t.emit("dragend", e)
					}
				}
			}], this.clickableElements.forEach(function (i) {
				return t.listeners.push({
					element: i, events: {
						click: function (n) {
							return (i !== t.element || n.target === t.element || e.elementInside(n.target, t.element.querySelector(".dz-message"))) && t.hiddenFileInput.click(), !0
						}
					}
				})
			}), this.enable(), this.options.init.call(this)
		}
	}, {
		key: "destroy", value: function () {
			return this.disable(), this.removeAllFiles(!0), (null != this.hiddenFileInput ? this.hiddenFileInput.parentNode : void 0) && (this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput), this.hiddenFileInput = null), delete this.element.dropzone, e.instances.splice(e.instances.indexOf(this), 1)
		}
	}, {
		key: "updateTotalUploadProgress", value: function () {
			var t = void 0, e = 0, i = 0;
			if (this.getActiveFiles().length) {
				for (var n = 0, r = r = this.getActiveFiles(); ;) {
					if (n >= r.length) break;
					var o = r[n++];
					e += o.upload.bytesSent, i += o.upload.total
				}
				t = 100 * e / i
			} else t = 100;
			return this.emit("totaluploadprogress", t, i, e)
		}
	}, {
		key: "_getParamName", value: function (t) {
			return "function" == typeof this.options.paramName ? this.options.paramName(t) : this.options.paramName + (this.options.uploadMultiple ? "[" + t + "]" : "")
		}
	}, {
		key: "_renameFile", value: function (t) {
			return "function" != typeof this.options.renameFile ? t.name : this.options.renameFile(t)
		}
	}, {
		key: "getFallbackForm", value: function () {
			var t, i = void 0;
			if (t = this.getExistingFallback()) return t;
			var n = '<div class="dz-fallback">';
			this.options.dictFallbackText && (n += "<p>" + this.options.dictFallbackText + "</p>"), n += '<input type="file" name="' + this._getParamName(0) + '" ' + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + ' /><input type="submit" value="Upload!"></div>';
			var r = e.createElement(n);
			return "FORM" !== this.element.tagName ? (i = e.createElement('<form action="' + this.options.url + '" enctype="multipart/form-data" method="' + this.options.method + '"></form>')).appendChild(r) : (this.element.setAttribute("enctype", "multipart/form-data"), this.element.setAttribute("method", this.options.method)), null != i ? i : r
		}
	}, {
		key: "getExistingFallback", value: function () {
			for (var t = function (t) {
				for (var e = 0, i = i = t; ;) {
					if (e >= i.length) break;
					var n = i[e++];
					if (/(^| )fallback($| )/.test(n.className)) return n
				}
			}, e = ["div", "form"], i = 0; i < e.length; i++) {
				var n, r = e[i];
				if (n = t(this.element.getElementsByTagName(r))) return n
			}
		}
	}, {
		key: "setupEventListeners", value: function () {
			return this.listeners.map(function (t) {
				return function () {
					var e = [];
					for (var i in t.events) {
						var n = t.events[i];
						e.push(t.element.addEventListener(i, n, !1))
					}
					return e
				}()
			})
		}
	}, {
		key: "removeEventListeners", value: function () {
			return this.listeners.map(function (t) {
				return function () {
					var e = [];
					for (var i in t.events) {
						var n = t.events[i];
						e.push(t.element.removeEventListener(i, n, !1))
					}
					return e
				}()
			})
		}
	}, {
		key: "disable", value: function () {
			var t = this;
			return this.clickableElements.forEach(function (t) {
				return t.classList.remove("dz-clickable")
			}), this.removeEventListeners(), this.disabled = !0, this.files.map(function (e) {
				return t.cancelUpload(e)
			})
		}
	}, {
		key: "enable", value: function () {
			return delete this.disabled, this.clickableElements.forEach(function (t) {
				return t.classList.add("dz-clickable")
			}), this.setupEventListeners()
		}
	}, {
		key: "filesize", value: function (t) {
			var e = 0, i = "b";
			if (t > 0) {
				for (var n = ["tb", "gb", "mb", "kb", "b"], r = 0; r < n.length; r++) {
					var o = n[r];
					if (t >= Math.pow(this.options.filesizeBase, 4 - r) / 10) {
						e = t / Math.pow(this.options.filesizeBase, 4 - r), i = o;
						break
					}
				}
				e = Math.round(10 * e) / 10
			}
			return "<strong>" + e + "</strong> " + this.options.dictFileSizeUnits[i]
		}
	}, {
		key: "_updateMaxFilesReachedClass", value: function () {
			return null != this.options.maxFiles && this.getAcceptedFiles().length >= this.options.maxFiles ? (this.getAcceptedFiles().length === this.options.maxFiles && this.emit("maxfilesreached", this.files), this.element.classList.add("dz-max-files-reached")) : this.element.classList.remove("dz-max-files-reached")
		}
	}, {
		key: "drop", value: function (t) {
			if (t.dataTransfer) {
				this.emit("drop", t);
				for (var e = [], i = 0; i < t.dataTransfer.files.length; i++) e[i] = t.dataTransfer.files[i];
				if (this.emit("addedfiles", e), e.length) {
					var n = t.dataTransfer.items;
					n && n.length && null != n[0].webkitGetAsEntry ? this._addFilesFromItems(n) : this.handleFiles(e)
				}
			}
		}
	}, {
		key: "paste", value: function (t) {
			if (null != __guard__(null != t ? t.clipboardData : void 0, function (t) {
				return t.items
			})) {
				this.emit("paste", t);
				var e = t.clipboardData.items;
				return e.length ? this._addFilesFromItems(e) : void 0
			}
		}
	}, {
		key: "handleFiles", value: function (t) {
			for (var e = 0, i = i = t; ;) {
				if (e >= i.length) break;
				var n = i[e++];
				this.addFile(n)
			}
		}
	}, {
		key: "_addFilesFromItems", value: function (t) {
			var e = this;
			return function () {
				for (var i = [], n = 0, r = r = t; ;) {
					if (n >= r.length) break;
					var o, a = r[n++];
					null != a.webkitGetAsEntry && (o = a.webkitGetAsEntry()) ? o.isFile ? i.push(e.addFile(a.getAsFile())) : o.isDirectory ? i.push(e._addFilesFromDirectory(o, o.name)) : i.push(void 0) : null != a.getAsFile && (null == a.kind || "file" === a.kind) ? i.push(e.addFile(a.getAsFile())) : i.push(void 0)
				}
				return i
			}()
		}
	}, {
		key: "_addFilesFromDirectory", value: function (t, e) {
			var i = this, n = t.createReader(), r = function (t) {
				return __guardMethod__(console, "log", function (e) {
					return e.log(t)
				})
			};
			return function t() {
				return n.readEntries(function (n) {
					if (n.length > 0) {
						for (var r = 0, o = o = n; !(r >= o.length);) {
							var a = o[r++];
							a.isFile ? a.file(function (t) {
								if (!i.options.ignoreHiddenFiles || "." !== t.name.substring(0, 1)) return t.fullPath = e + "/" + t.name, i.addFile(t)
							}) : a.isDirectory && i._addFilesFromDirectory(a, e + "/" + a.name)
						}
						t()
					}
					return null
				}, r)
			}()
		}
	}, {
		key: "accept", value: function (t, i) {
			return this.options.maxFilesize && t.size > 1024 * this.options.maxFilesize * 1024 ? i(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(t.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize)) : e.isValidFile(t, this.options.acceptedFiles) ? null != this.options.maxFiles && this.getAcceptedFiles().length >= this.options.maxFiles ? (i(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles)), this.emit("maxfilesexceeded", t)) : this.options.accept.call(this, t, i) : i(this.options.dictInvalidFileType)
		}
	}, {
		key: "addFile", value: function (t) {
			var i = this;
			return t.upload = {
				uuid: e.uuidv4(),
				progress: 0,
				total: t.size,
				bytesSent: 0,
				filename: this._renameFile(t),
				chunked: this.options.chunking && (this.options.forceChunking || t.size > this.options.chunkSize),
				totalChunkCount: Math.ceil(t.size / this.options.chunkSize)
			}, this.files.push(t), t.status = e.ADDED, this.emit("addedfile", t), this._enqueueThumbnail(t), this.accept(t, function (e) {
				return e ? (t.accepted = !1, i._errorProcessing([t], e)) : (t.accepted = !0, i.options.autoQueue && i.enqueueFile(t)), i._updateMaxFilesReachedClass()
			})
		}
	}, {
		key: "enqueueFiles", value: function (t) {
			for (var e = 0, i = i = t; ;) {
				if (e >= i.length) break;
				var n = i[e++];
				this.enqueueFile(n)
			}
			return null
		}
	}, {
		key: "enqueueFile", value: function (t) {
			var i = this;
			if (t.status !== e.ADDED || !0 !== t.accepted) throw new Error("This file can't be queued because it has already been processed or was rejected.");
			if (t.status = e.QUEUED, this.options.autoProcessQueue) return setTimeout(function () {
				return i.processQueue()
			}, 0)
		}
	}, {
		key: "_enqueueThumbnail", value: function (t) {
			var e = this;
			if (this.options.createImageThumbnails && t.type.match(/image.*/) && t.size <= 1024 * this.options.maxThumbnailFilesize * 1024) return this._thumbnailQueue.push(t), setTimeout(function () {
				return e._processThumbnailQueue()
			}, 0)
		}
	}, {
		key: "_processThumbnailQueue", value: function () {
			var t = this;
			if (!this._processingThumbnail && 0 !== this._thumbnailQueue.length) {
				this._processingThumbnail = !0;
				var e = this._thumbnailQueue.shift();
				return this.createThumbnail(e, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, !0, function (i) {
					return t.emit("thumbnail", e, i), t._processingThumbnail = !1, t._processThumbnailQueue()
				})
			}
		}
	}, {
		key: "removeFile", value: function (t) {
			if (t.status === e.UPLOADING && this.cancelUpload(t), this.files = without(this.files, t), this.emit("removedfile", t), 0 === this.files.length) return this.emit("reset")
		}
	}, {
		key: "removeAllFiles", value: function (t) {
			null == t && (t = !1);
			for (var i = 0, n = n = this.files.slice(); ;) {
				if (i >= n.length) break;
				var r = n[i++];
				(r.status !== e.UPLOADING || t) && this.removeFile(r)
			}
			return null
		}
	}, {
		key: "resizeImage", value: function (t, i, n, r, o) {
			var a = this;
			return this.createThumbnail(t, i, n, r, !0, function (i, n) {
				if (null == n) return o(t);
				var r = a.options.resizeMimeType;
				null == r && (r = t.type);
				var s = n.toDataURL(r, a.options.resizeQuality);
				return "image/jpeg" !== r && "image/jpg" !== r || (s = ExifRestore.restore(t.dataURL, s)), o(e.dataURItoBlob(s))
			})
		}
	}, {
		key: "createThumbnail", value: function (t, e, i, n, r, o) {
			var a = this, s = new FileReader;
			return s.onload = function () {
				if (t.dataURL = s.result, "image/svg+xml" !== t.type) return a.createThumbnailFromUrl(t, e, i, n, r, o);
				null != o && o(s.result)
			}, s.readAsDataURL(t)
		}
	}, {
		key: "createThumbnailFromUrl", value: function (t, e, i, n, r, o, a) {
			var s = this, l = document.createElement("img");
			return a && (l.crossOrigin = a), l.onload = function () {
				var a = function (t) {
					return t(1)
				};
				return "undefined" != typeof EXIF && null !== EXIF && r && (a = function (t) {
					return EXIF.getData(l, function () {
						return t(EXIF.getTag(this, "Orientation"))
					})
				}), a(function (r) {
					t.width = l.width, t.height = l.height;
					var a = s.options.resize.call(s, t, e, i, n), c = document.createElement("canvas"), u = c.getContext("2d");
					switch (c.width = a.trgWidth, c.height = a.trgHeight, r > 4 && (c.width = a.trgHeight, c.height = a.trgWidth), r) {
						case 2:
							u.translate(c.width, 0), u.scale(-1, 1);
							break;
						case 3:
							u.translate(c.width, c.height), u.rotate(Math.PI);
							break;
						case 4:
							u.translate(0, c.height), u.scale(1, -1);
							break;
						case 5:
							u.rotate(.5 * Math.PI), u.scale(1, -1);
							break;
						case 6:
							u.rotate(.5 * Math.PI), u.translate(0, -c.width);
							break;
						case 7:
							u.rotate(.5 * Math.PI), u.translate(c.height, -c.width), u.scale(-1, 1);
							break;
						case 8:
							u.rotate(-.5 * Math.PI), u.translate(-c.height, 0)
					}
					drawImageIOSFix(u, l, null != a.srcX ? a.srcX : 0, null != a.srcY ? a.srcY : 0, a.srcWidth, a.srcHeight, null != a.trgX ? a.trgX : 0, null != a.trgY ? a.trgY : 0, a.trgWidth, a.trgHeight);
					var h = c.toDataURL("image/png");
					if (null != o) return o(h, c)
				})
			}, null != o && (l.onerror = o), l.src = t.dataURL
		}
	}, {
		key: "processQueue", value: function () {
			var t = this.options.parallelUploads, e = this.getUploadingFiles().length, i = e;
			if (!(e >= t)) {
				var n = this.getQueuedFiles();
				if (n.length > 0) {
					if (this.options.uploadMultiple) return this.processFiles(n.slice(0, t - e));
					for (; i < t;) {
						if (!n.length) return;
						this.processFile(n.shift()), i++
					}
				}
			}
		}
	}, {
		key: "processFile", value: function (t) {
			return this.processFiles([t])
		}
	}, {
		key: "processFiles", value: function (t) {
			for (var i = 0, n = n = t; ;) {
				if (i >= n.length) break;
				var r = n[i++];
				r.processing = !0, r.status = e.UPLOADING, this.emit("processing", r)
			}
			return this.options.uploadMultiple && this.emit("processingmultiple", t), this.uploadFiles(t)
		}
	}, {
		key: "_getFilesWithXhr", value: function (t) {
			return this.files.filter(function (e) {
				return e.xhr === t
			}).map(function (t) {
				return t
			})
		}
	}, {
		key: "cancelUpload", value: function (t) {
			if (t.status === e.UPLOADING) {
				for (var i = this._getFilesWithXhr(t.xhr), n = 0, r = r = i; ;) {
					if (n >= r.length) break;
					r[n++].status = e.CANCELED
				}
				void 0 !== t.xhr && t.xhr.abort();
				for (var o = 0, a = a = i; ;) {
					if (o >= a.length) break;
					var s = a[o++];
					this.emit("canceled", s)
				}
				this.options.uploadMultiple && this.emit("canceledmultiple", i)
			} else t.status !== e.ADDED && t.status !== e.QUEUED || (t.status = e.CANCELED, this.emit("canceled", t), this.options.uploadMultiple && this.emit("canceledmultiple", [t]));
			if (this.options.autoProcessQueue) return this.processQueue()
		}
	}, {
		key: "resolveOption", value: function (t) {
			if ("function" == typeof t) {
				for (var e = arguments.length, i = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) i[n - 1] = arguments[n];
				return t.apply(this, i)
			}
			return t
		}
	}, {
		key: "uploadFile", value: function (t) {
			return this.uploadFiles([t])
		}
	}, {
		key: "uploadFiles", value: function (t) {
			var i = this;
			this._transformFiles(t, function (n) {
				if (t[0].upload.chunked) {
					var r = t[0], o = n[0];
					r.upload.chunks = [];
					var a = function () {
						for (var n = 0; void 0 !== r.upload.chunks[n];) n++;
						if (!(n >= r.upload.totalChunkCount)) {
							0;
							var a = n * i.options.chunkSize, s = Math.min(a + i.options.chunkSize, r.size), l = {name: i._getParamName(0), data: o.webkitSlice ? o.webkitSlice(a, s) : o.slice(a, s), filename: r.upload.filename, chunkIndex: n};
							r.upload.chunks[n] = {file: r, index: n, dataBlock: l, status: e.UPLOADING, progress: 0, retries: 0}, i._uploadData(t, [l])
						}
					};
					if (r.upload.finishedChunkUpload = function (n) {
						var o = !0;
						n.status = e.SUCCESS, n.dataBlock = null, n.xhr = null;
						for (var s = 0; s < r.upload.totalChunkCount; s++) {
							if (void 0 === r.upload.chunks[s]) return a();
							r.upload.chunks[s].status !== e.SUCCESS && (o = !1)
						}
						o && i.options.chunksUploaded(r, function () {
							i._finished(t, "", null)
						})
					}, i.options.parallelChunkUploads) for (var s = 0; s < r.upload.totalChunkCount; s++) a(); else a()
				} else {
					for (var l = [], c = 0; c < t.length; c++) l[c] = {name: i._getParamName(c), data: n[c], filename: t[c].upload.filename};
					i._uploadData(t, l)
				}
			})
		}
	}, {
		key: "_getChunk", value: function (t, e) {
			for (var i = 0; i < t.upload.totalChunkCount; i++) if (void 0 !== t.upload.chunks[i] && t.upload.chunks[i].xhr === e) return t.upload.chunks[i]
		}
	}, {
		key: "_uploadData", value: function (t, i) {
			for (var n = this, r = new XMLHttpRequest, o = 0, a = a = t; ;) {
				if (o >= a.length) break;
				a[o++].xhr = r
			}
			t[0].upload.chunked && (t[0].upload.chunks[i[0].chunkIndex].xhr = r);
			var s = this.resolveOption(this.options.method, t), l = this.resolveOption(this.options.url, t);
			r.open(s, l, !0), r.timeout = this.resolveOption(this.options.timeout, t), r.withCredentials = !!this.options.withCredentials, r.onload = function (e) {
				n._finishedUploading(t, r, e)
			}, r.onerror = function () {
				n._handleUploadError(t, r)
			}, (null != r.upload ? r.upload : r).onprogress = function (e) {
				return n._updateFilesUploadProgress(t, r, e)
			};
			var c = {Accept: "application/json", "Cache-Control": "no-cache", "X-Requested-With": "XMLHttpRequest"};
			for (var u in this.options.headers && e.extend(c, this.options.headers), c) {
				var h = c[u];
				h && r.setRequestHeader(u, h)
			}
			var d = new FormData;
			if (this.options.params) {
				var p = this.options.params;
				for (var f in"function" == typeof p && (p = p.call(this, t, r, t[0].upload.chunked ? this._getChunk(t[0], r) : null)), p) {
					var m = p[f];
					d.append(f, m)
				}
			}
			for (var g = 0, v = v = t; ;) {
				if (g >= v.length) break;
				var y = v[g++];
				this.emit("sending", y, r, d)
			}
			this.options.uploadMultiple && this.emit("sendingmultiple", t, r, d), this._addFormElementData(d);
			for (var b = 0; b < i.length; b++) {
				var w = i[b];
				d.append(w.name, w.data, w.filename)
			}
			this.submitRequest(r, d, t)
		}
	}, {
		key: "_transformFiles", value: function (t, e) {
			for (var i = this, n = [], r = 0, o = function (o) {
				i.options.transformFile.call(i, t[o], function (i) {
					n[o] = i, ++r === t.length && e(n)
				})
			}, a = 0; a < t.length; a++) o(a)
		}
	}, {
		key: "_addFormElementData", value: function (t) {
			if ("FORM" === this.element.tagName) for (var e = 0, i = i = this.element.querySelectorAll("input, textarea, select, button"); ;) {
				if (e >= i.length) break;
				var n = i[e++], r = n.getAttribute("name"), o = n.getAttribute("type");
				if (o && (o = o.toLowerCase()), null != r) if ("SELECT" === n.tagName && n.hasAttribute("multiple")) for (var a = 0, s = s = n.options; ;) {
					if (a >= s.length) break;
					var l = s[a++];
					l.selected && t.append(r, l.value)
				} else (!o || "checkbox" !== o && "radio" !== o || n.checked) && t.append(r, n.value)
			}
		}
	}, {
		key: "_updateFilesUploadProgress", value: function (t, e, i) {
			var n = void 0;
			if (void 0 !== i) {
				if (n = 100 * i.loaded / i.total, t[0].upload.chunked) {
					var r = t[0], o = this._getChunk(r, e);
					o.progress = n, o.total = i.total, o.bytesSent = i.loaded;
					r.upload.progress = 0, r.upload.total = 0, r.upload.bytesSent = 0;
					for (var a = 0; a < r.upload.totalChunkCount; a++) void 0 !== r.upload.chunks[a] && void 0 !== r.upload.chunks[a].progress && (r.upload.progress += r.upload.chunks[a].progress, r.upload.total += r.upload.chunks[a].total, r.upload.bytesSent += r.upload.chunks[a].bytesSent);
					r.upload.progress = r.upload.progress / r.upload.totalChunkCount
				} else for (var s = 0, l = l = t; ;) {
					if (s >= l.length) break;
					var c = l[s++];
					c.upload.progress = n, c.upload.total = i.total, c.upload.bytesSent = i.loaded
				}
				for (var u = 0, h = h = t; ;) {
					if (u >= h.length) break;
					var d = h[u++];
					this.emit("uploadprogress", d, d.upload.progress, d.upload.bytesSent)
				}
			} else {
				var p = !0;
				n = 100;
				for (var f = 0, m = m = t; ;) {
					if (f >= m.length) break;
					var g = m[f++];
					100 === g.upload.progress && g.upload.bytesSent === g.upload.total || (p = !1), g.upload.progress = n, g.upload.bytesSent = g.upload.total
				}
				if (p) return;
				for (var v = 0, y = y = t; ;) {
					if (v >= y.length) break;
					var b = y[v++];
					this.emit("uploadprogress", b, n, b.upload.bytesSent)
				}
			}
		}
	}, {
		key: "_finishedUploading", value: function (t, i, n) {
			var r = void 0;
			if (t[0].status !== e.CANCELED && 4 === i.readyState) {
				if ("arraybuffer" !== i.responseType && "blob" !== i.responseType && (r = i.responseText, i.getResponseHeader("content-type") && ~i.getResponseHeader("content-type").indexOf("application/json"))) try {
					r = JSON.parse(r)
				} catch (t) {
					n = t, r = "Invalid JSON response from server."
				}
				this._updateFilesUploadProgress(t), 200 <= i.status && i.status < 300 ? t[0].upload.chunked ? t[0].upload.finishedChunkUpload(this._getChunk(t[0], i)) : this._finished(t, r, n) : this._handleUploadError(t, i, r)
			}
		}
	}, {
		key: "_handleUploadError", value: function (t, i, n) {
			if (t[0].status !== e.CANCELED) {
				if (t[0].upload.chunked && this.options.retryChunks) {
					var r = this._getChunk(t[0], i);
					if (r.retries++ < this.options.retryChunksLimit) return void this._uploadData(t, [r.dataBlock]);
					console.warn("Retried this chunk too often. Giving up.")
				}
				for (var o = 0, a = a = t; ;) {
					if (o >= a.length) break;
					a[o++];
					this._errorProcessing(t, n || this.options.dictResponseError.replace("{{statusCode}}", i.status), i)
				}
			}
		}
	}, {
		key: "submitRequest", value: function (t, e, i) {
			t.send(e)
		}
	}, {
		key: "_finished", value: function (t, i, n) {
			for (var r = 0, o = o = t; ;) {
				if (r >= o.length) break;
				var a = o[r++];
				a.status = e.SUCCESS, this.emit("success", a, i, n), this.emit("complete", a)
			}
			if (this.options.uploadMultiple && (this.emit("successmultiple", t, i, n), this.emit("completemultiple", t)), this.options.autoProcessQueue) return this.processQueue()
		}
	}, {
		key: "_errorProcessing", value: function (t, i, n) {
			for (var r = 0, o = o = t; ;) {
				if (r >= o.length) break;
				var a = o[r++];
				a.status = e.ERROR, this.emit("error", a, i, n), this.emit("complete", a)
			}
			if (this.options.uploadMultiple && (this.emit("errormultiple", t, i, n), this.emit("completemultiple", t)), this.options.autoProcessQueue) return this.processQueue()
		}
	}], [{
		key: "uuidv4", value: function () {
			return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
				var e = 16 * Math.random() | 0;
				return ("x" === t ? e : 3 & e | 8).toString(16)
			})
		}
	}]), e
}();
Dropzone.initClass(), Dropzone.version = "5.5.1", Dropzone.options = {}, Dropzone.optionsForElement = function (t) {
	return t.getAttribute("id") ? Dropzone.options[camelize(t.getAttribute("id"))] : void 0
}, Dropzone.instances = [], Dropzone.forElement = function (t) {
	if ("string" == typeof t && (t = document.querySelector(t)), null == (null != t ? t.dropzone : void 0)) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
	return t.dropzone
}, Dropzone.autoDiscover = !0, Dropzone.discover = function () {
	var t = void 0;
	if (document.querySelectorAll) t = document.querySelectorAll(".dropzone"); else {
		t = [];
		var e = function (e) {
			return function () {
				for (var i = [], n = 0, r = r = e; ;) {
					if (n >= r.length) break;
					var o = r[n++];
					/(^| )dropzone($| )/.test(o.className) ? i.push(t.push(o)) : i.push(void 0)
				}
				return i
			}()
		};
		e(document.getElementsByTagName("div")), e(document.getElementsByTagName("form"))
	}
	return function () {
		for (var e = [], i = 0, n = n = t; ;) {
			if (i >= n.length) break;
			var r = n[i++];
			!1 !== Dropzone.optionsForElement(r) ? e.push(new Dropzone(r)) : e.push(void 0)
		}
		return e
	}()
}, Dropzone.blacklistedBrowsers = [/opera.*(Macintosh|Windows Phone).*version\/12/i], Dropzone.isBrowserSupported = function () {
	var t = !0;
	if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) if ("classList" in document.createElement("a")) for (var e = 0, i = i = Dropzone.blacklistedBrowsers; ;) {
		if (e >= i.length) break;
		i[e++].test(navigator.userAgent) && (t = !1)
	} else t = !1; else t = !1;
	return t
}, Dropzone.dataURItoBlob = function (t) {
	for (var e = atob(t.split(",")[1]), i = t.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(e.length), r = new Uint8Array(n), o = 0, a = e.length, s = 0 <= a; s ? o <= a : o >= a; s ? o++ : o--) r[o] = e.charCodeAt(o);
	return new Blob([n], {type: i})
};
var without = function (t, e) {
	return t.filter(function (t) {
		return t !== e
	}).map(function (t) {
		return t
	})
}, camelize = function (t) {
	return t.replace(/[\-_](\w)/g, function (t) {
		return t.charAt(1).toUpperCase()
	})
};
Dropzone.createElement = function (t) {
	var e = document.createElement("div");
	return e.innerHTML = t, e.childNodes[0]
}, Dropzone.elementInside = function (t, e) {
	if (t === e) return !0;
	for (; t = t.parentNode;) if (t === e) return !0;
	return !1
}, Dropzone.getElement = function (t, e) {
	var i = void 0;
	if ("string" == typeof t ? i = document.querySelector(t) : null != t.nodeType && (i = t), null == i) throw new Error("Invalid `" + e + "` option provided. Please provide a CSS selector or a plain HTML element.");
	return i
}, Dropzone.getElements = function (t, e) {
	var i = void 0, n = void 0;
	if (t instanceof Array) {
		n = [];
		try {
			for (var r = 0, o = o = t; !(r >= o.length);) i = o[r++], n.push(this.getElement(i, e))
		} catch (t) {
			n = null
		}
	} else if ("string" == typeof t) {
		n = [];
		for (var a = 0, s = s = document.querySelectorAll(t); !(a >= s.length);) i = s[a++], n.push(i)
	} else null != t.nodeType && (n = [t]);
	if (null == n || !n.length) throw new Error("Invalid `" + e + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
	return n
}, Dropzone.confirm = function (t, e, i) {
	return window.confirm(t) ? e() : null != i ? i() : void 0
}, Dropzone.isValidFile = function (t, e) {
	if (!e) return !0;
	e = e.split(",");
	for (var i = t.type, n = i.replace(/\/.*$/, ""), r = 0, o = o = e; ;) {
		if (r >= o.length) break;
		var a = o[r++];
		if ("." === (a = a.trim()).charAt(0)) {
			if (-1 !== t.name.toLowerCase().indexOf(a.toLowerCase(), t.name.length - a.length)) return !0
		} else if (/\/\*$/.test(a)) {
			if (n === a.replace(/\/.*$/, "")) return !0
		} else if (i === a) return !0
	}
	return !1
}, "undefined" != typeof jQuery && null !== jQuery && (jQuery.fn.dropzone = function (t) {
	return this.each(function () {
		return new Dropzone(this, t)
	})
}), "undefined" != typeof module && null !== module ? module.exports = Dropzone : window.Dropzone = Dropzone, Dropzone.ADDED = "added", Dropzone.QUEUED = "queued", Dropzone.ACCEPTED = Dropzone.QUEUED, Dropzone.UPLOADING = "uploading", Dropzone.PROCESSING = Dropzone.UPLOADING, Dropzone.CANCELED = "canceled", Dropzone.ERROR = "error", Dropzone.SUCCESS = "success";
var detectVerticalSquash = function (t) {
	t.naturalWidth;
	var e = t.naturalHeight, i = document.createElement("canvas");
	i.width = 1, i.height = e;
	var n = i.getContext("2d");
	n.drawImage(t, 0, 0);
	for (var r = n.getImageData(1, 0, 1, e).data, o = 0, a = e, s = e; s > o;) {
		0 === r[4 * (s - 1) + 3] ? a = s : o = s, s = a + o >> 1
	}
	var l = s / e;
	return 0 === l ? 1 : l
}, drawImageIOSFix = function (t, e, i, n, r, o, a, s, l, c) {
	var u = detectVerticalSquash(e);
	return t.drawImage(e, i, n, r, o, a, s, l, c / u)
}, ExifRestore = function () {
	function t() {
		_classCallCheck(this, t)
	}

	return _createClass(t, null, [{
		key: "initClass", value: function () {
			this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
		}
	}, {
		key: "encode64", value: function (t) {
			for (var e = "", i = void 0, n = void 0, r = "", o = void 0, a = void 0, s = void 0, l = "", c = 0; o = (i = t[c++]) >> 2, a = (3 & i) << 4 | (n = t[c++]) >> 4, s = (15 & n) << 2 | (r = t[c++]) >> 6, l = 63 & r, isNaN(n) ? s = l = 64 : isNaN(r) && (l = 64), e = e + this.KEY_STR.charAt(o) + this.KEY_STR.charAt(a) + this.KEY_STR.charAt(s) + this.KEY_STR.charAt(l), i = n = r = "", o = a = s = l = "", c < t.length;) ;
			return e
		}
	}, {
		key: "restore", value: function (t, e) {
			if (!t.match("data:image/jpeg;base64,")) return e;
			var i = this.decode64(t.replace("data:image/jpeg;base64,", "")), n = this.slice2Segments(i), r = this.exifManipulation(e, n);
			return "data:image/jpeg;base64," + this.encode64(r)
		}
	}, {
		key: "exifManipulation", value: function (t, e) {
			var i = this.getExifArray(e), n = this.insertExif(t, i);
			return new Uint8Array(n)
		}
	}, {
		key: "getExifArray", value: function (t) {
			for (var e = void 0, i = 0; i < t.length;) {
				if (255 === (e = t[i])[0] & 225 === e[1]) return e;
				i++
			}
			return []
		}
	}, {
		key: "insertExif", value: function (t, e) {
			var i = t.replace("data:image/jpeg;base64,", ""), n = this.decode64(i), r = n.indexOf(255, 3), o = n.slice(0, r), a = n.slice(r), s = o;
			return s = (s = s.concat(e)).concat(a)
		}
	}, {
		key: "slice2Segments", value: function (t) {
			for (var e = 0, i = []; ;) {
				if (255 === t[e] & 218 === t[e + 1]) break;
				if (255 === t[e] & 216 === t[e + 1]) e += 2; else {
					var n = e + (256 * t[e + 2] + t[e + 3]) + 2, r = t.slice(e, n);
					i.push(r), e = n
				}
				if (e > t.length) break
			}
			return i
		}
	}, {
		key: "decode64", value: function (t) {
			var e = void 0, i = void 0, n = "", r = void 0, o = void 0, a = "", s = 0, l = [];
			for (/[^A-Za-z0-9\+\/\=]/g.exec(t) && console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."), t = t.replace(/[^A-Za-z0-9\+\/\=]/g, ""); e = this.KEY_STR.indexOf(t.charAt(s++)) << 2 | (r = this.KEY_STR.indexOf(t.charAt(s++))) >> 4, i = (15 & r) << 4 | (o = this.KEY_STR.indexOf(t.charAt(s++))) >> 2, n = (3 & o) << 6 | (a = this.KEY_STR.indexOf(t.charAt(s++))), l.push(e), 64 !== o && l.push(i), 64 !== a && l.push(n), e = i = n = "", r = o = a = "", s < t.length;) ;
			return l
		}
	}]), t
}();
ExifRestore.initClass();
var contentLoaded = function (t, e) {
	var i = !1, n = !0, r = t.document, o = r.documentElement, a = r.addEventListener ? "addEventListener" : "attachEvent", s = r.addEventListener ? "removeEventListener" : "detachEvent", l = r.addEventListener ? "" : "on", c = function n(o) {
		if ("readystatechange" !== o.type || "complete" === r.readyState) return ("load" === o.type ? t : r)[s](l + o.type, n, !1), !i && (i = !0) ? e.call(t, o.type || o) : void 0
	};
	if ("complete" !== r.readyState) {
		if (r.createEventObject && o.doScroll) {
			try {
				n = !t.frameElement
			} catch (t) {
			}
			n && function t() {
				try {
					o.doScroll("left")
				} catch (e) {
					return void setTimeout(t, 50)
				}
				return c("poll")
			}()
		}
		return r[a](l + "DOMContentLoaded", c, !1), r[a](l + "readystatechange", c, !1), t[a](l + "load", c, !1)
	}
};

function __guard__(t, e) {
	return null != t ? e(t) : void 0
}

function __guardMethod__(t, e, i) {
	return null != t && "function" == typeof t[e] ? i(t, e) : void 0
}

Dropzone._autoDiscoverFunction = function () {
	if (Dropzone.autoDiscover) return Dropzone.discover()
}, contentLoaded(window, Dropzone._autoDiscoverFunction), function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? e(require("jquery")) : "function" == typeof define && define.amd ? define(["jquery"], e) : e(t.jQuery)
}(this, function (t) {
	"use strict";
	t = t && t.hasOwnProperty("default") ? t.default : t;
	var e = function () {
			function e(t, e, i, n) {
				this.markup = t, this.children = e, this.options = i, this.callback = n
			}

			return e.prototype.render = function (e) {
				var i = t(this.markup);
				if (this.options && this.options.contents && i.html(this.options.contents), this.options && this.options.className && i.addClass(this.options.className), this.options && this.options.data && t.each(this.options.data, function (t, e) {
					i.attr("data-" + t, e)
				}), this.options && this.options.click && i.on("click", this.options.click), this.children) {
					var n = i.find(".note-children-container");
					this.children.forEach(function (t) {
						t.render(n.length ? n : i)
					})
				}
				return this.callback && this.callback(i, this.options), this.options && this.options.callback && this.options.callback(i), e && e.append(i), i
			}, e
		}(), i = function (i, n) {
			return function () {
				var r = "object" == typeof arguments[1] ? arguments[1] : arguments[0], o = t.isArray(arguments[0]) ? arguments[0] : [];
				return r && r.children && (o = r.children), new e(i, o, r, n)
			}
		}, n = i('<div class="note-editor note-frame panel panel-default"/>'), r = i('<div class="note-toolbar panel-heading" role="toolbar"></div></div>'), o = i('<div class="note-editing-area"/>'), a = i('<textarea class="note-codable" role="textbox" aria-multiline="true"/>'),
		s = i('<div class="note-editable" contentEditable="true" role="textbox" aria-multiline="true"/>'),
		l = i(['<output class="note-status-output" aria-live="polite"/>', '<div class="note-statusbar" role="status">', '  <div class="note-resizebar" role="seperator" aria-orientation="horizontal" aria-label="Resize">', '    <div class="note-icon-bar"/>', '    <div class="note-icon-bar"/>', '    <div class="note-icon-bar"/>', "  </div>", "</div>"].join("")),
		c = i('<div class="note-editor"/>'), u = i(['<div class="note-editable" contentEditable="true" role="textbox" aria-multiline="true"/>', '<output class="note-status-output" aria-live="polite"/>'].join("")), h = i('<div class="note-btn-group btn-group">'),
		d = i('<ul class="dropdown-menu" role="list">', function (e, i) {
			var n = t.isArray(i.items) ? i.items.map(function (t) {
				var e = "string" == typeof t ? t : t.value || "", n = i.template ? i.template(t) : t, r = "object" == typeof t ? t.option : void 0;
				return '<li role="listitem" aria-label="' + t + '"><a href="#" ' + ('data-value="' + e + '"' + (void 0 !== r ? ' data-option="' + r + '"' : "")) + ">" + n + "</a></li>"
			}).join("") : i.items;
			e.html(n).attr({"aria-label": i.title})
		}), p = i('<ul class="dropdown-menu note-check" role="list">', function (e, i) {
			var n = t.isArray(i.items) ? i.items.map(function (t) {
				var e = "string" == typeof t ? t : t.value || "", n = i.template ? i.template(t) : t;
				return '<li role="listitem" aria-label="' + t + '"><a href="#" data-value="' + e + '">' + y(i.checkClassName) + " " + n + "</a></li>"
			}).join("") : i.items;
			e.html(n).attr({"aria-label": i.title})
		}), f = i('<div class="note-color-palette"/>', function (t, e) {
			for (var i = [], n = 0, r = e.colors.length; n < r; n++) {
				for (var o = e.eventName, a = e.colors[n], s = e.colorsName[n], l = [], c = 0, u = a.length; c < u; c++) {
					var h = a[c], d = s[c];
					l.push(['<button type="button" class="note-color-btn"', 'style="background-color:', h, '" ', 'data-event="', o, '" ', 'data-value="', h, '" ', 'title="', d, '" ', 'aria-label="', d, '" ', 'data-toggle="button" tabindex="-1"></button>'].join(""))
				}
				i.push('<div class="note-color-row">' + l.join("") + "</div>")
			}
			t.html(i.join("")), e.tooltip && t.find(".note-color-btn").tooltip({container: e.container, trigger: "hover", placement: "bottom"})
		}), m = i('<div class="modal" aria-hidden="false" tabindex="-1" role="dialog"/>', function (t, e) {
			e.fade && t.addClass("fade"), t.attr({"aria-label": e.title}), t.html(['<div class="modal-dialog">', '  <div class="modal-content">', e.title ? '    <div class="modal-header">      <button type="button" class="close" data-dismiss="modal" aria-label="Close" aria-hidden="true">&times;</button>      <h4 class="modal-title">' + e.title + "</h4>    </div>" : "", '    <div class="modal-body">' + e.body + "</div>", e.footer ? '    <div class="modal-footer">' + e.footer + "</div>" : "", "  </div>", "</div>"].join(""))
		}), g = i(['<div class="note-popover popover in">', '  <div class="arrow"/>', '  <div class="popover-content note-children-container"/>', "</div>"].join(""), function (t, e) {
			var i = void 0 !== e.direction ? e.direction : "bottom";
			t.addClass(i), e.hideArrow && t.find(".arrow").hide()
		}), v = i('<div class="checkbox"></div>', function (t, e) {
			t.html(["<label" + (e.id ? ' for="' + e.id + '"' : "") + ">", ' <input role="checkbox" type="checkbox"' + (e.id ? ' id="' + e.id + '"' : ""), e.checked ? " checked" : "", ' aria-checked="' + (e.checked ? "true" : "false") + '"/>', e.text ? e.text : "", "</label>"].join(""))
		}), y = function (t, e) {
			return "<" + (e = e || "i") + ' class="' + t + '"/>'
		}, b = {
			editor: n, toolbar: r, editingArea: o, codable: a, editable: s, statusbar: l, airEditor: c, airEditable: u, buttonGroup: h, dropdown: d, dropdownButtonContents: function (t, e) {
				return t + " " + y(e.icons.caret, "span")
			}, dropdownCheck: p, palette: f, dialog: m, popover: g, checkbox: v, icon: y, options: {}, button: function (t, e) {
				return i('<button type="button" class="note-btn btn btn-default btn-sm" role="button" tabindex="-1">', function (t, e) {
					e && e.tooltip && t.attr({title: e.tooltip, "aria-label": e.tooltip}).tooltip({container: void 0 !== e.container ? e.container : "body", trigger: "hover", placement: "bottom"})
				})(t, e)
			}, toggleBtn: function (t, e) {
				t.toggleClass("disabled", !e), t.attr("disabled", !e)
			}, toggleBtnActive: function (t, e) {
				t.toggleClass("active", e)
			}, onDialogShown: function (t, e) {
				t.one("shown.bs.modal", e)
			}, onDialogHidden: function (t, e) {
				t.one("hidden.bs.modal", e)
			}, showDialog: function (t) {
				t.modal("show")
			}, hideDialog: function (t) {
				t.modal("hide")
			}, createLayout: function (t, e) {
				var i = (e.airMode ? b.airEditor([b.editingArea([b.airEditable()])]) : b.editor([b.toolbar(), b.editingArea([b.codable(), b.editable()]), b.statusbar()])).render();
				return i.insertAfter(t), {note: t, editor: i, toolbar: i.find(".note-toolbar"), editingArea: i.find(".note-editing-area"), editable: i.find(".note-editable"), codable: i.find(".note-codable"), statusbar: i.find(".note-statusbar")}
			}, removeLayout: function (t, e) {
				t.html(e.editable.html()), e.editor.remove(), t.show()
			}
		};
	var w = 0;
	var x = {
		eq: function (t) {
			return function (e) {
				return t === e
			}
		}, eq2: function (t, e) {
			return t === e
		}, peq2: function (t) {
			return function (e, i) {
				return e[t] === i[t]
			}
		}, ok: function () {
			return !0
		}, fail: function () {
			return !1
		}, self: function (t) {
			return t
		}, not: function (t) {
			return function () {
				return !t.apply(t, arguments)
			}
		}, and: function (t, e) {
			return function (i) {
				return t(i) && e(i)
			}
		}, invoke: function (t, e) {
			return function () {
				return t[e].apply(t, arguments)
			}
		}, uniqueId: function (t) {
			var e = ++w + "";
			return t ? t + e : e
		}, rect2bnd: function (t) {
			var e = $(document);
			return {top: t.top + e.scrollTop(), left: t.left + e.scrollLeft(), width: t.right - t.left, height: t.bottom - t.top}
		}, invertObject: function (t) {
			var e = {};
			for (var i in t) t.hasOwnProperty(i) && (e[t[i]] = i);
			return e
		}, namespaceToCamel: function (t, e) {
			return (e = e || "") + t.split(".").map(function (t) {
				return t.substring(0, 1).toUpperCase() + t.substring(1)
			}).join("")
		}, debounce: function (t, e, i) {
			var n;
			return function () {
				var r = this, o = arguments, a = i && !n;
				clearTimeout(n), n = setTimeout(function () {
					n = null, i || t.apply(r, o)
				}, e), a && t.apply(r, o)
			}
		}
	};

	function k(t) {
		return t[0]
	}

	function _(t) {
		return t[t.length - 1]
	}

	function S(t) {
		return t.slice(1)
	}

	function C(e, i) {
		return t.inArray(i, e)
	}

	function D(t, e) {
		return -1 !== C(t, e)
	}

	var T = {
		head: k, last: _, initial: function (t) {
			return t.slice(0, t.length - 1)
		}, tail: S, prev: function (t, e) {
			var i = C(t, e);
			return -1 === i ? null : t[i - 1]
		}, next: function (t, e) {
			var i = C(t, e);
			return -1 === i ? null : t[i + 1]
		}, find: function (t, e) {
			for (var i = 0, n = t.length; i < n; i++) {
				var r = t[i];
				if (e(r)) return r
			}
		}, contains: D, all: function (t, e) {
			for (var i = 0, n = t.length; i < n; i++) if (!e(t[i])) return !1;
			return !0
		}, sum: function (t, e) {
			return e = e || x.self, t.reduce(function (t, i) {
				return t + e(i)
			}, 0)
		}, from: function (t) {
			for (var e = [], i = t.length, n = -1; ++n < i;) e[n] = t[n];
			return e
		}, isEmpty: function (t) {
			return !t || !t.length
		}, clusterBy: function (t, e) {
			return t.length ? S(t).reduce(function (t, i) {
				var n = _(t);
				return e(_(n), i) ? n[n.length] = i : t[t.length] = [i], t
			}, [[k(t)]]) : []
		}, compact: function (t) {
			for (var e = [], i = 0, n = t.length; i < n; i++) t[i] && e.push(t[i]);
			return e
		}, unique: function (t) {
			for (var e = [], i = 0, n = t.length; i < n; i++) D(e, t[i]) || e.push(t[i]);
			return e
		}
	}, M = "function" == typeof define && define.amd;
	var E, A = navigator.userAgent, P = /MSIE|Trident/i.test(A);
	if (P) {
		var I = /MSIE (\d+[.]\d+)/.exec(A);
		I && (E = parseFloat(I[1])), (I = /Trident\/.*rv:([0-9]{1,}[.0-9]{0,})/.exec(A)) && (E = parseFloat(I[1]))
	}
	var O = /Edge\/\d+/.test(A), L = !!window.CodeMirror;
	if (!L && M) if ("function" == typeof __webpack_require__) try {
		require.resolve("codemirror"), L = !0
	} catch (t) {
	} else if ("undefined" != typeof require) if (void 0 !== require.resolve) try {
		require.resolve("codemirror"), L = !0
	} catch (t) {
	} else void 0 !== require.specified && (L = require.specified("codemirror"));
	var F = "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0, N = P || O ? "DOMCharacterDataModified DOMSubtreeModified DOMNodeInserted" : "input", R = {
		isMac: navigator.appVersion.indexOf("Mac") > -1,
		isMSIE: P,
		isEdge: O,
		isFF: !O && /firefox/i.test(A),
		isPhantom: /PhantomJS/i.test(A),
		isWebkit: !O && /webkit/i.test(A),
		isChrome: !O && /chrome/i.test(A),
		isSafari: !O && /safari/i.test(A),
		browserVersion: E,
		jqueryVersion: parseFloat(t.fn.jquery),
		isSupportAmd: M,
		isSupportTouch: F,
		hasCodeMirror: L,
		isFontInstalled: function (e) {
			var i = "Comic Sans MS" === e ? "Courier New" : "Comic Sans MS", n = t("<div>").css({position: "absolute", left: "-9999px", top: "-9999px", fontSize: "200px"}).text("mmmmmmmmmwwwwwww").appendTo(document.body), r = n.css("fontFamily", i).width(), o = n.css("fontFamily", e + "," + i).width();
			return n.remove(), r !== o
		},
		isW3CRangeSupport: !!document.createRange,
		inputEventName: N
	}, H = String.fromCharCode(160);

	function B(e) {
		return e && t(e).hasClass("note-editable")
	}

	function z(t) {
		return t = t.toUpperCase(), function (e) {
			return e && e.nodeName.toUpperCase() === t
		}
	}

	function j(t) {
		return t && 3 === t.nodeType
	}

	function U(t) {
		return t && /^BR|^IMG|^HR|^IFRAME|^BUTTON|^INPUT|^VIDEO|^EMBED/.test(t.nodeName.toUpperCase())
	}

	function W(t) {
		return !B(t) && (t && /^DIV|^P|^LI|^H[1-7]/.test(t.nodeName.toUpperCase()))
	}

	var Y = z("PRE"), V = z("LI");
	var q = z("TABLE"), G = z("DATA");

	function K(t) {
		return !(tt(t) || X(t) || Z(t) || W(t) || q(t) || J(t) || G(t))
	}

	function X(t) {
		return t && /^UL|^OL/.test(t.nodeName.toUpperCase())
	}

	var Z = z("HR");

	function Q(t) {
		return t && /^TD|^TH/.test(t.nodeName.toUpperCase())
	}

	var J = z("BLOCKQUOTE");

	function tt(t) {
		return Q(t) || J(t) || B(t)
	}

	var et = z("A");
	var it = z("BODY");
	var nt = R.isMSIE && R.browserVersion < 11 ? "&nbsp;" : "<br>";

	function rt(t) {
		return j(t) ? t.nodeValue.length : t ? t.childNodes.length : 0
	}

	function ot(t) {
		var e = rt(t);
		return 0 === e || (!j(t) && 1 === e && t.innerHTML === nt || !(!T.all(t.childNodes, j) || "" !== t.innerHTML))
	}

	function at(t) {
		U(t) || rt(t) || (t.innerHTML = nt)
	}

	function st(t, e) {
		for (; t;) {
			if (e(t)) return t;
			if (B(t)) break;
			t = t.parentNode
		}
		return null
	}

	function lt(t, e) {
		e = e || x.fail;
		var i = [];
		return st(t, function (t) {
			return B(t) || i.push(t), e(t)
		}), i
	}

	function ct(t, e) {
		e = e || x.fail;
		for (var i = []; t && !e(t);) i.push(t), t = t.nextSibling;
		return i
	}

	function ut(t, e) {
		var i = e.nextSibling, n = e.parentNode;
		return i ? n.insertBefore(t, i) : n.appendChild(t), t
	}

	function ht(e, i) {
		return t.each(i, function (t, i) {
			e.appendChild(i)
		}), e
	}

	function dt(t) {
		return 0 === t.offset
	}

	function pt(t) {
		return t.offset === rt(t.node)
	}

	function ft(t) {
		return dt(t) || pt(t)
	}

	function mt(t, e) {
		for (; t && t !== e;) {
			if (0 !== vt(t)) return !1;
			t = t.parentNode
		}
		return !0
	}

	function gt(t, e) {
		if (!e) return !1;
		for (; t && t !== e;) {
			if (vt(t) !== rt(t.parentNode) - 1) return !1;
			t = t.parentNode
		}
		return !0
	}

	function vt(t) {
		for (var e = 0; t = t.previousSibling;) e += 1;
		return e
	}

	function yt(t) {
		return !!(t && t.childNodes && t.childNodes.length)
	}

	function bt(t, e) {
		var i, n;
		if (0 === t.offset) {
			if (B(t.node)) return null;
			i = t.node.parentNode, n = vt(t.node)
		} else yt(t.node) ? n = rt(i = t.node.childNodes[t.offset - 1]) : (i = t.node, n = e ? 0 : t.offset - 1);
		return {node: i, offset: n}
	}

	function wt(t, e) {
		var i, n;
		if (rt(t.node) === t.offset) {
			if (B(t.node)) return null;
			i = t.node.parentNode, n = vt(t.node) + 1
		} else yt(t.node) ? (i = t.node.childNodes[t.offset], n = 0) : (i = t.node, n = e ? rt(t.node) : t.offset + 1);
		return {node: i, offset: n}
	}

	function xt(t, e) {
		return t.node === e.node && t.offset === e.offset
	}

	function kt(t, e) {
		var i = e && e.isSkipPaddingBlankHTML, n = e && e.isNotSplitEdgePoint, r = e && e.isDiscardEmptySplits;
		if (r && (i = !0), ft(t) && (j(t.node) || n)) {
			if (dt(t)) return t.node;
			if (pt(t)) return t.node.nextSibling
		}
		if (j(t.node)) return t.node.splitText(t.offset);
		var o = t.node.childNodes[t.offset], a = ut(t.node.cloneNode(!1), t.node);
		return ht(a, ct(o)), i || (at(t.node), at(a)), r && (ot(t.node) && Ct(t.node), ot(a)) ? (Ct(a), t.node.nextSibling) : a
	}

	function _t(t, e, i) {
		var n = lt(e.node, x.eq(t));
		return n.length ? 1 === n.length ? kt(e, i) : n.reduce(function (t, n) {
			return t === e.node && (t = kt(e, i)), kt({node: n, offset: t ? vt(t) : rt(n)}, i)
		}) : null
	}

	function St(t) {
		return document.createElement(t)
	}

	function Ct(t, e) {
		if (t && t.parentNode) {
			if (t.removeNode) return t.removeNode(e);
			var i = t.parentNode;
			if (!e) {
				for (var n = [], r = 0, o = t.childNodes.length; r < o; r++) n.push(t.childNodes[r]);
				for (r = 0, o = n.length; r < o; r++) i.insertBefore(n[r], t)
			}
			i.removeChild(t)
		}
	}

	var Dt = z("TEXTAREA");

	function Tt(t, e) {
		var i = Dt(t[0]) ? t.val() : t.html();
		return e ? i.replace(/[\n\r]/g, "") : i
	}

	var Mt = {
		NBSP_CHAR: H,
		ZERO_WIDTH_NBSP_CHAR: "\ufeff",
		blank: nt,
		emptyPara: "<p>" + nt + "</p>",
		makePredByNodeName: z,
		isEditable: B,
		isControlSizing: function (e) {
			return e && t(e).hasClass("note-control-sizing")
		},
		isText: j,
		isElement: function (t) {
			return t && 1 === t.nodeType
		},
		isVoid: U,
		isPara: W,
		isPurePara: function (t) {
			return W(t) && !V(t)
		},
		isHeading: function (t) {
			return t && /^H[1-7]/.test(t.nodeName.toUpperCase())
		},
		isInline: K,
		isBlock: x.not(K),
		isBodyInline: function (t) {
			return K(t) && !st(t, W)
		},
		isBody: it,
		isParaInline: function (t) {
			return K(t) && !!st(t, W)
		},
		isPre: Y,
		isList: X,
		isTable: q,
		isData: G,
		isCell: Q,
		isBlockquote: J,
		isBodyContainer: tt,
		isAnchor: et,
		isDiv: z("DIV"),
		isLi: V,
		isBR: z("BR"),
		isSpan: z("SPAN"),
		isB: z("B"),
		isU: z("U"),
		isS: z("S"),
		isI: z("I"),
		isImg: z("IMG"),
		isTextarea: Dt,
		isEmpty: ot,
		isEmptyAnchor: x.and(et, ot),
		isClosestSibling: function (t, e) {
			return t.nextSibling === e || t.previousSibling === e
		},
		withClosestSiblings: function (t, e) {
			e = e || x.ok;
			var i = [];
			return t.previousSibling && e(t.previousSibling) && i.push(t.previousSibling), i.push(t), t.nextSibling && e(t.nextSibling) && i.push(t.nextSibling), i
		},
		nodeLength: rt,
		isLeftEdgePoint: dt,
		isRightEdgePoint: pt,
		isEdgePoint: ft,
		isLeftEdgeOf: mt,
		isRightEdgeOf: gt,
		isLeftEdgePointOf: function (t, e) {
			return dt(t) && mt(t.node, e)
		},
		isRightEdgePointOf: function (t, e) {
			return pt(t) && gt(t.node, e)
		},
		prevPoint: bt,
		nextPoint: wt,
		isSamePoint: xt,
		isVisiblePoint: function (t) {
			if (j(t.node) || !yt(t.node) || ot(t.node)) return !0;
			var e = t.node.childNodes[t.offset - 1], i = t.node.childNodes[t.offset];
			return !(e && !U(e) || i && !U(i))
		},
		prevPointUntil: function (t, e) {
			for (; t;) {
				if (e(t)) return t;
				t = bt(t)
			}
			return null
		},
		nextPointUntil: function (t, e) {
			for (; t;) {
				if (e(t)) return t;
				t = wt(t)
			}
			return null
		},
		isCharPoint: function (t) {
			if (!j(t.node)) return !1;
			var e = t.node.nodeValue.charAt(t.offset - 1);
			return e && " " !== e && e !== H
		},
		walkPoint: function (t, e, i, n) {
			for (var r = t; r && (i(r), !xt(r, e));) r = wt(r, n && t.node !== r.node && e.node !== r.node)
		},
		ancestor: st,
		singleChildAncestor: function (t, e) {
			for (t = t.parentNode; t && 1 === rt(t);) {
				if (e(t)) return t;
				if (B(t)) break;
				t = t.parentNode
			}
			return null
		},
		listAncestor: lt,
		lastAncestor: function (t, e) {
			var i = lt(t);
			return T.last(i.filter(e))
		},
		listNext: ct,
		listPrev: function (t, e) {
			e = e || x.fail;
			for (var i = []; t && !e(t);) i.push(t), t = t.previousSibling;
			return i
		},
		listDescendant: function (t, e) {
			var i = [];
			return e = e || x.ok, function n(r) {
				t !== r && e(r) && i.push(r);
				for (var o = 0, a = r.childNodes.length; o < a; o++) n(r.childNodes[o])
			}(t), i
		},
		commonAncestor: function (e, i) {
			for (var n = lt(e), r = i; r; r = r.parentNode) if (t.inArray(r, n) > -1) return r;
			return null
		},
		wrap: function (e, i) {
			var n = e.parentNode, r = t("<" + i + ">")[0];
			return n.insertBefore(r, e), r.appendChild(e), r
		},
		insertAfter: ut,
		appendChildNodes: ht,
		position: vt,
		hasChildren: yt,
		makeOffsetPath: function (t, e) {
			return lt(e, x.eq(t)).map(vt).reverse()
		},
		fromOffsetPath: function (t, e) {
			for (var i = t, n = 0, r = e.length; n < r; n++) i = i.childNodes.length <= e[n] ? i.childNodes[i.childNodes.length - 1] : i.childNodes[e[n]];
			return i
		},
		splitTree: _t,
		splitPoint: function (t, e) {
			var i, n, r = e ? W : tt, o = lt(t.node, r), a = T.last(o) || t.node;
			r(a) ? (i = o[o.length - 2], n = a) : n = (i = a).parentNode;
			var s = i && _t(i, t, {isSkipPaddingBlankHTML: e, isNotSplitEdgePoint: e});
			return s || n !== t.node || (s = t.node.childNodes[t.offset]), {rightNode: s, container: n}
		},
		create: St,
		createText: function (t) {
			return document.createTextNode(t)
		},
		remove: Ct,
		removeWhile: function (t, e) {
			for (; t && !B(t) && e(t);) {
				var i = t.parentNode;
				Ct(t), t = i
			}
		},
		replace: function (t, e) {
			if (t.nodeName.toUpperCase() === e.toUpperCase()) return t;
			var i = St(e);
			return t.style.cssText && (i.style.cssText = t.style.cssText), ht(i, T.from(t.childNodes)), ut(i, t), Ct(t), i
		},
		html: function (e, i) {
			var n = Tt(e);
			i && (n = n.replace(/<(\/?)(\b(?!!)[^>\s]*)(.*?)(\s*\/?>)/g, function (t, e, i) {
				i = i.toUpperCase();
				var n = /^DIV|^TD|^TH|^P|^LI|^H[1-7]/.test(i) && !!e, r = /^BLOCKQUOTE|^TABLE|^TBODY|^TR|^HR|^UL|^OL/.test(i);
				return t + (n || r ? "\n" : "")
			}), n = t.trim(n));
			return n
		},
		value: Tt,
		posFromPlaceholder: function (e) {
			var i = t(e), n = i.offset(), r = i.outerHeight(!0);
			return {left: n.left, top: n.top + r}
		},
		attachEvents: function (t, e) {
			Object.keys(e).forEach(function (i) {
				t.on(i, e[i])
			})
		},
		detachEvents: function (t, e) {
			Object.keys(e).forEach(function (i) {
				t.off(i, e[i])
			})
		},
		isCustomStyleTag: function (t) {
			return t && !j(t) && T.contains(t.classList, "note-styletag")
		}
	};

	function Et(t, e) {
		var i, n, r = t.parentElement(), o = document.body.createTextRange(), a = T.from(r.childNodes);
		for (i = 0; i < a.length; i++) if (!Mt.isText(a[i])) {
			if (o.moveToElementText(a[i]), o.compareEndPoints("StartToStart", t) >= 0) break;
			n = a[i]
		}
		if (0 !== i && Mt.isText(a[i - 1])) {
			var s = document.body.createTextRange(), l = null;
			s.moveToElementText(n || r), s.collapse(!n), l = n ? n.nextSibling : r.firstChild;
			var c = t.duplicate();
			c.setEndPoint("StartToStart", s);
			for (var u = c.text.replace(/[\r\n]/g, "").length; u > l.nodeValue.length && l.nextSibling;) u -= l.nodeValue.length, l = l.nextSibling;
			l.nodeValue;
			e && l.nextSibling && Mt.isText(l.nextSibling) && u === l.nodeValue.length && (u -= l.nodeValue.length, l = l.nextSibling), r = l, i = u
		}
		return {cont: r, offset: i}
	}

	function At(t) {
		var e = function (t, i) {
			var n, r;
			if (Mt.isText(t)) {
				var o = Mt.listPrev(t, x.not(Mt.isText)), a = T.last(o).previousSibling;
				n = a || t.parentNode, i += T.sum(T.tail(o), Mt.nodeLength), r = !a
			} else {
				if (n = t.childNodes[i] || t, Mt.isText(n)) return e(n, 0);
				i = 0, r = !1
			}
			return {node: n, collapseToStart: r, offset: i}
		}, i = document.body.createTextRange(), n = e(t.node, t.offset);
		return i.moveToElementText(n.node), i.collapse(n.collapseToStart), i.moveStart("character", n.offset), i
	}

	var Pt = function () {
		function e(t, e, i, n) {
			this.sc = t, this.so = e, this.ec = i, this.eo = n, this.isOnEditable = this.makeIsOn(Mt.isEditable), this.isOnList = this.makeIsOn(Mt.isList), this.isOnAnchor = this.makeIsOn(Mt.isAnchor), this.isOnCell = this.makeIsOn(Mt.isCell), this.isOnData = this.makeIsOn(Mt.isData)
		}

		return e.prototype.nativeRange = function () {
			if (R.isW3CRangeSupport) {
				var t = document.createRange();
				return t.setStart(this.sc, this.so), t.setEnd(this.ec, this.eo), t
			}
			var e = At({node: this.sc, offset: this.so});
			return e.setEndPoint("EndToEnd", At({node: this.ec, offset: this.eo})), e
		}, e.prototype.getPoints = function () {
			return {sc: this.sc, so: this.so, ec: this.ec, eo: this.eo}
		}, e.prototype.getStartPoint = function () {
			return {node: this.sc, offset: this.so}
		}, e.prototype.getEndPoint = function () {
			return {node: this.ec, offset: this.eo}
		}, e.prototype.select = function () {
			var t = this.nativeRange();
			if (R.isW3CRangeSupport) {
				var e = document.getSelection();
				e.rangeCount > 0 && e.removeAllRanges(), e.addRange(t)
			} else t.select();
			return this
		}, e.prototype.scrollIntoView = function (e) {
			var i = t(e).height();
			return e.scrollTop + i < this.sc.offsetTop && (e.scrollTop += Math.abs(e.scrollTop + i - this.sc.offsetTop)), this
		}, e.prototype.normalize = function () {
			var t = function (t, e) {
				if (Mt.isVisiblePoint(t) && !Mt.isEdgePoint(t) || Mt.isVisiblePoint(t) && Mt.isRightEdgePoint(t) && !e || Mt.isVisiblePoint(t) && Mt.isLeftEdgePoint(t) && e || Mt.isVisiblePoint(t) && Mt.isBlock(t.node) && Mt.isEmpty(t.node)) return t;
				var i = Mt.ancestor(t.node, Mt.isBlock);
				if ((Mt.isLeftEdgePointOf(t, i) || Mt.isVoid(Mt.prevPoint(t).node)) && !e || (Mt.isRightEdgePointOf(t, i) || Mt.isVoid(Mt.nextPoint(t).node)) && e) {
					if (Mt.isVisiblePoint(t)) return t;
					e = !e
				}
				return (e ? Mt.nextPointUntil(Mt.nextPoint(t), Mt.isVisiblePoint) : Mt.prevPointUntil(Mt.prevPoint(t), Mt.isVisiblePoint)) || t
			}, i = t(this.getEndPoint(), !1), n = this.isCollapsed() ? i : t(this.getStartPoint(), !0);
			return new e(n.node, n.offset, i.node, i.offset)
		}, e.prototype.nodes = function (t, e) {
			t = t || x.ok;
			var i = e && e.includeAncestor, n = e && e.fullyContains, r = this.getStartPoint(), o = this.getEndPoint(), a = [], s = [];
			return Mt.walkPoint(r, o, function (e) {
				var r;
				Mt.isEditable(e.node) || (n ? (Mt.isLeftEdgePoint(e) && s.push(e.node), Mt.isRightEdgePoint(e) && T.contains(s, e.node) && (r = e.node)) : r = i ? Mt.ancestor(e.node, t) : e.node, r && t(r) && a.push(r))
			}, !0), T.unique(a)
		}, e.prototype.commonAncestor = function () {
			return Mt.commonAncestor(this.sc, this.ec)
		}, e.prototype.expand = function (t) {
			var i = Mt.ancestor(this.sc, t), n = Mt.ancestor(this.ec, t);
			if (!i && !n) return new e(this.sc, this.so, this.ec, this.eo);
			var r = this.getPoints();
			return i && (r.sc = i, r.so = 0), n && (r.ec = n, r.eo = Mt.nodeLength(n)), new e(r.sc, r.so, r.ec, r.eo)
		}, e.prototype.collapse = function (t) {
			return t ? new e(this.sc, this.so, this.sc, this.so) : new e(this.ec, this.eo, this.ec, this.eo)
		}, e.prototype.splitText = function () {
			var t = this.sc === this.ec, i = this.getPoints();
			return Mt.isText(this.ec) && !Mt.isEdgePoint(this.getEndPoint()) && this.ec.splitText(this.eo), Mt.isText(this.sc) && !Mt.isEdgePoint(this.getStartPoint()) && (i.sc = this.sc.splitText(this.so), i.so = 0, t && (i.ec = i.sc, i.eo = this.eo - this.so)), new e(i.sc, i.so, i.ec, i.eo)
		}, e.prototype.deleteContents = function () {
			if (this.isCollapsed()) return this;
			var i = this.splitText(), n = i.nodes(null, {fullyContains: !0}), r = Mt.prevPointUntil(i.getStartPoint(), function (t) {
				return !T.contains(n, t.node)
			}), o = [];
			return t.each(n, function (t, e) {
				var i = e.parentNode;
				r.node !== i && 1 === Mt.nodeLength(i) && o.push(i), Mt.remove(e, !1)
			}), t.each(o, function (t, e) {
				Mt.remove(e, !1)
			}), new e(r.node, r.offset, r.node, r.offset).normalize()
		}, e.prototype.makeIsOn = function (t) {
			return function () {
				var e = Mt.ancestor(this.sc, t);
				return !!e && e === Mt.ancestor(this.ec, t)
			}
		}, e.prototype.isLeftEdgeOf = function (t) {
			if (!Mt.isLeftEdgePoint(this.getStartPoint())) return !1;
			var e = Mt.ancestor(this.sc, t);
			return e && Mt.isLeftEdgeOf(this.sc, e)
		}, e.prototype.isCollapsed = function () {
			return this.sc === this.ec && this.so === this.eo
		}, e.prototype.wrapBodyInlineWithPara = function () {
			if (Mt.isBodyContainer(this.sc) && Mt.isEmpty(this.sc)) return this.sc.innerHTML = Mt.emptyPara, new e(this.sc.firstChild, 0, this.sc.firstChild, 0);
			var t, i = this.normalize();
			if (Mt.isParaInline(this.sc) || Mt.isPara(this.sc)) return i;
			if (Mt.isInline(i.sc)) {
				var n = Mt.listAncestor(i.sc, x.not(Mt.isInline));
				t = T.last(n), Mt.isInline(t) || (t = n[n.length - 2] || i.sc.childNodes[i.so])
			} else t = i.sc.childNodes[i.so > 0 ? i.so - 1 : 0];
			var r = Mt.listPrev(t, Mt.isParaInline).reverse();
			if ((r = r.concat(Mt.listNext(t.nextSibling, Mt.isParaInline))).length) {
				var o = Mt.wrap(T.head(r), "p");
				Mt.appendChildNodes(o, T.tail(r))
			}
			return this.normalize()
		}, e.prototype.insertNode = function (t) {
			var e = this.wrapBodyInlineWithPara().deleteContents(), i = Mt.splitPoint(e.getStartPoint(), Mt.isInline(t));
			return i.rightNode ? i.rightNode.parentNode.insertBefore(t, i.rightNode) : i.container.appendChild(t), t
		}, e.prototype.pasteHTML = function (e) {
			var i = t("<div></div>").html(e)[0], n = T.from(i.childNodes), r = this.wrapBodyInlineWithPara().deleteContents();
			return r.so > 0 && (n = n.reverse()), n = n.map(function (t) {
				return r.insertNode(t)
			}), r.so > 0 && (n = n.reverse()), n
		}, e.prototype.toString = function () {
			var t = this.nativeRange();
			return R.isW3CRangeSupport ? t.toString() : t.text
		}, e.prototype.getWordRange = function (t) {
			var i = this.getEndPoint();
			if (!Mt.isCharPoint(i)) return this;
			var n = Mt.prevPointUntil(i, function (t) {
				return !Mt.isCharPoint(t)
			});
			return t && (i = Mt.nextPointUntil(i, function (t) {
				return !Mt.isCharPoint(t)
			})), new e(n.node, n.offset, i.node, i.offset)
		}, e.prototype.bookmark = function (t) {
			return {s: {path: Mt.makeOffsetPath(t, this.sc), offset: this.so}, e: {path: Mt.makeOffsetPath(t, this.ec), offset: this.eo}}
		}, e.prototype.paraBookmark = function (t) {
			return {s: {path: T.tail(Mt.makeOffsetPath(T.head(t), this.sc)), offset: this.so}, e: {path: T.tail(Mt.makeOffsetPath(T.last(t), this.ec)), offset: this.eo}}
		}, e.prototype.getClientRects = function () {
			return this.nativeRange().getClientRects()
		}, e
	}(), It = {
		create: function (t, e, i, n) {
			if (4 === arguments.length) return new Pt(t, e, i, n);
			if (2 === arguments.length) return new Pt(t, e, i = t, n = e);
			var r = this.createFromSelection();
			return r || 1 !== arguments.length ? r : (r = this.createFromNode(arguments[0])).collapse(Mt.emptyPara === arguments[0].innerHTML)
		}, createFromSelection: function () {
			var t, e, i, n;
			if (R.isW3CRangeSupport) {
				var r = document.getSelection();
				if (!r || 0 === r.rangeCount) return null;
				if (Mt.isBody(r.anchorNode)) return null;
				var o = r.getRangeAt(0);
				t = o.startContainer, e = o.startOffset, i = o.endContainer, n = o.endOffset
			} else {
				var a = document.selection.createRange(), s = a.duplicate();
				s.collapse(!1);
				var l = a;
				l.collapse(!0);
				var c = Et(l, !0), u = Et(s, !1);
				Mt.isText(c.node) && Mt.isLeftEdgePoint(c) && Mt.isTextNode(u.node) && Mt.isRightEdgePoint(u) && u.node.nextSibling === c.node && (c = u), t = c.cont, e = c.offset, i = u.cont, n = u.offset
			}
			return new Pt(t, e, i, n)
		}, createFromNode: function (t) {
			var e = t, i = 0, n = t, r = Mt.nodeLength(n);
			return Mt.isVoid(e) && (i = Mt.listPrev(e).length - 1, e = e.parentNode), Mt.isBR(n) ? (r = Mt.listPrev(n).length - 1, n = n.parentNode) : Mt.isVoid(n) && (r = Mt.listPrev(n).length, n = n.parentNode), this.create(e, i, n, r)
		}, createFromNodeBefore: function (t) {
			return this.createFromNode(t).collapse(!0)
		}, createFromNodeAfter: function (t) {
			return this.createFromNode(t).collapse()
		}, createFromBookmark: function (t, e) {
			var i = Mt.fromOffsetPath(t, e.s.path), n = e.s.offset, r = Mt.fromOffsetPath(t, e.e.path), o = e.e.offset;
			return new Pt(i, n, r, o)
		}, createFromParaBookmark: function (t, e) {
			var i = t.s.offset, n = t.e.offset, r = Mt.fromOffsetPath(T.head(e), t.s.path), o = Mt.fromOffsetPath(T.last(e), t.e.path);
			return new Pt(r, i, o, n)
		}
	};
	t.summernote = t.summernote || {lang: {}}, t.extend(t.summernote.lang, {
		"en-US": {
			font: {bold: "Bold", italic: "Italic", underline: "Underline", clear: "Remove Font Style", height: "Line Height", name: "Font Family", strikethrough: "Strikethrough", subscript: "Subscript", superscript: "Superscript", size: "Font Size"},
			image: {
				image: "Picture",
				insert: "Insert Image",
				resizeFull: "Resize Full",
				resizeHalf: "Resize Half",
				resizeQuarter: "Resize Quarter",
				floatLeft: "Float Left",
				floatRight: "Float Right",
				floatNone: "Float None",
				shapeRounded: "Shape: Rounded",
				shapeCircle: "Shape: Circle",
				shapeThumbnail: "Shape: Thumbnail",
				shapeNone: "Shape: None",
				dragImageHere: "Drag image or text here",
				dropImage: "Drop image or Text",
				selectFromFiles: "Select from files",
				maximumFileSize: "Maximum file size",
				maximumFileSizeError: "Maximum file size exceeded.",
				url: "Image URL",
				remove: "Remove Image",
				original: "Original"
			},
			video: {video: "Video", videoLink: "Video Link", insert: "Insert Video", url: "Video URL", providers: "(YouTube, Vimeo, Vine, Instagram, DailyMotion or Youku)"},
			link: {link: "Link", insert: "Insert Link", unlink: "Unlink", edit: "Edit", textToDisplay: "Text to display", url: "To what URL should this link go?", openInNewWindow: "Open in new window"},
			table: {table: "Table", addRowAbove: "Add row above", addRowBelow: "Add row below", addColLeft: "Add column left", addColRight: "Add column right", delRow: "Delete row", delCol: "Delete column", delTable: "Delete table"},
			hr: {insert: "Insert Horizontal Rule"},
			style: {style: "Style", p: "Normal", blockquote: "Quote", pre: "Code", h1: "Header 1", h2: "Header 2", h3: "Header 3", h4: "Header 4", h5: "Header 5", h6: "Header 6"},
			lists: {unordered: "Unordered list", ordered: "Ordered list"},
			options: {help: "Help", fullscreen: "Full Screen", codeview: "Code View"},
			paragraph: {paragraph: "Paragraph", outdent: "Outdent", indent: "Indent", left: "Align left", center: "Align center", right: "Align right", justify: "Justify full"},
			color: {recent: "Recent Color", more: "More Color", background: "Background Color", foreground: "Foreground Color", transparent: "Transparent", setTransparent: "Set transparent", reset: "Reset", resetToDefault: "Reset to default", cpSelect: "Select"},
			shortcut: {shortcuts: "Keyboard shortcuts", close: "Close", textFormatting: "Text formatting", action: "Action", paragraphFormatting: "Paragraph formatting", documentStyle: "Document Style", extraKeys: "Extra keys"},
			help: {
				insertParagraph: "Insert Paragraph",
				undo: "Undoes the last command",
				redo: "Redoes the last command",
				tab: "Tab",
				untab: "Untab",
				bold: "Set a bold style",
				italic: "Set a italic style",
				underline: "Set a underline style",
				strikethrough: "Set a strikethrough style",
				removeFormat: "Clean a style",
				justifyLeft: "Set left align",
				justifyCenter: "Set center align",
				justifyRight: "Set right align",
				justifyFull: "Set full align",
				insertUnorderedList: "Toggle unordered list",
				insertOrderedList: "Toggle ordered list",
				outdent: "Outdent on current paragraph",
				indent: "Indent on current paragraph",
				formatPara: "Change current block's format as a paragraph(P tag)",
				formatH1: "Change current block's format as H1",
				formatH2: "Change current block's format as H2",
				formatH3: "Change current block's format as H3",
				formatH4: "Change current block's format as H4",
				formatH5: "Change current block's format as H5",
				formatH6: "Change current block's format as H6",
				insertHorizontalRule: "Insert horizontal rule",
				"linkDialog.show": "Show Link Dialog"
			},
			history: {undo: "Undo", redo: "Redo"},
			specialChar: {specialChar: "SPECIAL CHARACTERS", select: "Select Special characters"}
		}
	});
	var Ot = {
		BACKSPACE: 8,
		TAB: 9,
		ENTER: 13,
		SPACE: 32,
		DELETE: 46,
		LEFT: 37,
		UP: 38,
		RIGHT: 39,
		DOWN: 40,
		NUM0: 48,
		NUM1: 49,
		NUM2: 50,
		NUM3: 51,
		NUM4: 52,
		NUM5: 53,
		NUM6: 54,
		NUM7: 55,
		NUM8: 56,
		B: 66,
		E: 69,
		I: 73,
		J: 74,
		K: 75,
		L: 76,
		R: 82,
		S: 83,
		U: 85,
		V: 86,
		Y: 89,
		Z: 90,
		SLASH: 191,
		LEFTBRACKET: 219,
		BACKSLASH: 220,
		RIGHTBRACKET: 221
	}, Lt = {
		isEdit: function (t) {
			return T.contains([Ot.BACKSPACE, Ot.TAB, Ot.ENTER, Ot.SPACE, Ot.DELETE], t)
		}, isMove: function (t) {
			return T.contains([Ot.LEFT, Ot.UP, Ot.RIGHT, Ot.DOWN], t)
		}, nameFromCode: x.invertObject(Ot), code: Ot
	};
	var Ft = function () {
		function t(t) {
			this.stack = [], this.stackOffset = -1, this.$editable = t, this.editable = t[0]
		}

		return t.prototype.makeSnapshot = function () {
			var t = It.create(this.editable);
			return {contents: this.$editable.html(), bookmark: t ? t.bookmark(this.editable) : {s: {path: [], offset: 0}, e: {path: [], offset: 0}}}
		}, t.prototype.applySnapshot = function (t) {
			null !== t.contents && this.$editable.html(t.contents), null !== t.bookmark && It.createFromBookmark(this.editable, t.bookmark).select()
		}, t.prototype.rewind = function () {
			this.$editable.html() !== this.stack[this.stackOffset].contents && this.recordUndo(), this.stackOffset = 0, this.applySnapshot(this.stack[this.stackOffset])
		}, t.prototype.commit = function () {
			this.stack = [], this.stackOffset = -1, this.recordUndo()
		}, t.prototype.reset = function () {
			this.stack = [], this.stackOffset = -1, this.$editable.html(""), this.recordUndo()
		}, t.prototype.undo = function () {
			this.$editable.html() !== this.stack[this.stackOffset].contents && this.recordUndo(), this.stackOffset > 0 && (this.stackOffset--, this.applySnapshot(this.stack[this.stackOffset]))
		}, t.prototype.redo = function () {
			this.stack.length - 1 > this.stackOffset && (this.stackOffset++, this.applySnapshot(this.stack[this.stackOffset]))
		}, t.prototype.recordUndo = function () {
			this.stackOffset++, this.stack.length > this.stackOffset && (this.stack = this.stack.slice(0, this.stackOffset)), this.stack.push(this.makeSnapshot())
		}, t
	}(), Nt = function () {
		function e() {
		}

		return e.prototype.jQueryCSS = function (e, i) {
			if (R.jqueryVersion < 1.9) {
				var n = {};
				return t.each(i, function (t, i) {
					n[i] = e.css(i)
				}), n
			}
			return e.css(i)
		}, e.prototype.fromNode = function (t) {
			var e = this.jQueryCSS(t, ["font-family", "font-size", "text-align", "list-style-type", "line-height"]) || {};
			return e["font-size"] = parseInt(e["font-size"], 10), e
		}, e.prototype.stylePara = function (e, i) {
			t.each(e.nodes(Mt.isPara, {includeAncestor: !0}), function (e, n) {
				t(n).css(i)
			})
		}, e.prototype.styleNodes = function (e, i) {
			e = e.splitText();
			var n = i && i.nodeName || "SPAN", r = !(!i || !i.expandClosestSibling), o = !(!i || !i.onlyPartialContains);
			if (e.isCollapsed()) return [e.insertNode(Mt.create(n))];
			var a = Mt.makePredByNodeName(n), s = e.nodes(Mt.isText, {fullyContains: !0}).map(function (t) {
				return Mt.singleChildAncestor(t, a) || Mt.wrap(t, n)
			});
			if (r) {
				if (o) {
					var l = e.nodes();
					a = x.and(a, function (t) {
						return T.contains(l, t)
					})
				}
				return s.map(function (e) {
					var i = Mt.withClosestSiblings(e, a), n = T.head(i), r = T.tail(i);
					return t.each(r, function (t, e) {
						Mt.appendChildNodes(n, e.childNodes), Mt.remove(e)
					}), T.head(i)
				})
			}
			return s
		}, e.prototype.current = function (e) {
			var i = t(Mt.isElement(e.sc) ? e.sc : e.sc.parentNode), n = this.fromNode(i);
			try {
				n = t.extend(n, {
					"font-bold": document.queryCommandState("bold") ? "bold" : "normal",
					"font-italic": document.queryCommandState("italic") ? "italic" : "normal",
					"font-underline": document.queryCommandState("underline") ? "underline" : "normal",
					"font-subscript": document.queryCommandState("subscript") ? "subscript" : "normal",
					"font-superscript": document.queryCommandState("superscript") ? "superscript" : "normal",
					"font-strikethrough": document.queryCommandState("strikethrough") ? "strikethrough" : "normal",
					"font-family": document.queryCommandValue("fontname") || n["font-family"]
				})
			} catch (t) {
			}
			if (e.isOnList()) {
				var r = t.inArray(n["list-style-type"], ["circle", "disc", "disc-leading-zero", "square"]) > -1;
				n["list-style"] = r ? "unordered" : "ordered"
			} else n["list-style"] = "none";
			var o = Mt.ancestor(e.sc, Mt.isPara);
			if (o && o.style["line-height"]) n["line-height"] = o.style.lineHeight; else {
				var a = parseInt(n["line-height"], 10) / parseInt(n["font-size"], 10);
				n["line-height"] = a.toFixed(1)
			}
			return n.anchor = e.isOnAnchor() && Mt.ancestor(e.sc, Mt.isAnchor), n.ancestors = Mt.listAncestor(e.sc, Mt.isEditable), n.range = e, n
		}, e
	}(), Rt = function () {
		function e() {
		}

		return e.prototype.insertOrderedList = function (t) {
			this.toggleList("OL", t)
		}, e.prototype.insertUnorderedList = function (t) {
			this.toggleList("UL", t)
		}, e.prototype.indent = function (e) {
			var i = this, n = It.create(e).wrapBodyInlineWithPara(), r = n.nodes(Mt.isPara, {includeAncestor: !0}), o = T.clusterBy(r, x.peq2("parentNode"));
			t.each(o, function (e, n) {
				var r = T.head(n);
				if (Mt.isLi(r)) {
					var o = i.findList(r.previousSibling);
					o ? n.map(function (t) {
						return o.appendChild(t)
					}) : (i.wrapList(n, r.parentNode.nodeName), n.map(function (t) {
						return t.parentNode
					}).map(function (t) {
						return i.appendToPrevious(t)
					}))
				} else t.each(n, function (e, i) {
					t(i).css("marginLeft", function (t, e) {
						return (parseInt(e, 10) || 0) + 25
					})
				})
			}), n.select()
		}, e.prototype.outdent = function (e) {
			var i = this, n = It.create(e).wrapBodyInlineWithPara(), r = n.nodes(Mt.isPara, {includeAncestor: !0}), o = T.clusterBy(r, x.peq2("parentNode"));
			t.each(o, function (e, n) {
				var r = T.head(n);
				Mt.isLi(r) ? i.releaseList([n]) : t.each(n, function (e, i) {
					t(i).css("marginLeft", function (t, e) {
						return (e = parseInt(e, 10) || 0) > 25 ? e - 25 : ""
					})
				})
			}), n.select()
		}, e.prototype.toggleList = function (e, i) {
			var n = this, r = It.create(i).wrapBodyInlineWithPara(), o = r.nodes(Mt.isPara, {includeAncestor: !0}), a = r.paraBookmark(o), s = T.clusterBy(o, x.peq2("parentNode"));
			if (T.find(o, Mt.isPurePara)) {
				var l = [];
				t.each(s, function (t, i) {
					l = l.concat(n.wrapList(i, e))
				}), o = l
			} else {
				var c = r.nodes(Mt.isList, {includeAncestor: !0}).filter(function (i) {
					return !t.nodeName(i, e)
				});
				c.length ? t.each(c, function (t, i) {
					Mt.replace(i, e)
				}) : o = this.releaseList(s, !0)
			}
			It.createFromParaBookmark(a, o).select()
		}, e.prototype.wrapList = function (t, e) {
			var i = T.head(t), n = T.last(t), r = Mt.isList(i.previousSibling) && i.previousSibling, o = Mt.isList(n.nextSibling) && n.nextSibling, a = r || Mt.insertAfter(Mt.create(e || "UL"), n);
			return t = t.map(function (t) {
				return Mt.isPurePara(t) ? Mt.replace(t, "LI") : t
			}), Mt.appendChildNodes(a, t), o && (Mt.appendChildNodes(a, T.from(o.childNodes)), Mt.remove(o)), t
		}, e.prototype.releaseList = function (e, i) {
			var n = this, r = [];
			return t.each(e, function (e, o) {
				var a = T.head(o), s = T.last(o), l = i ? Mt.lastAncestor(a, Mt.isList) : a.parentNode, c = l.parentNode;
				if ("LI" === l.parentNode.nodeName) o.map(function (t) {
					var e = n.findNextSiblings(t);
					c.nextSibling ? c.parentNode.insertBefore(t, c.nextSibling) : c.parentNode.appendChild(t), e.length && (n.wrapList(e, l.nodeName), t.appendChild(e[0].parentNode))
				}), 0 === l.children.length && c.removeChild(l), 0 === c.childNodes.length && c.parentNode.removeChild(c); else {
					var u = l.childNodes.length > 1 ? Mt.splitTree(l, {node: s.parentNode, offset: Mt.position(s) + 1}, {isSkipPaddingBlankHTML: !0}) : null, h = Mt.splitTree(l, {node: a.parentNode, offset: Mt.position(a)}, {isSkipPaddingBlankHTML: !0});
					o = i ? Mt.listDescendant(h, Mt.isLi) : T.from(h.childNodes).filter(Mt.isLi), !i && Mt.isList(l.parentNode) || (o = o.map(function (t) {
						return Mt.replace(t, "P")
					})), t.each(T.from(o).reverse(), function (t, e) {
						Mt.insertAfter(e, l)
					});
					var d = T.compact([l, h, u]);
					t.each(d, function (e, i) {
						var n = [i].concat(Mt.listDescendant(i, Mt.isList));
						t.each(n.reverse(), function (t, e) {
							Mt.nodeLength(e) || Mt.remove(e, !0)
						})
					})
				}
				r = r.concat(o)
			}), r
		}, e.prototype.appendToPrevious = function (t) {
			return t.previousSibling ? Mt.appendChildNodes(t.previousSibling, [t]) : this.wrapList([t], "LI")
		}, e.prototype.findList = function (t) {
			return t ? T.find(t.children, function (t) {
				return ["OL", "UL"].indexOf(t.nodeName) > -1
			}) : null
		}, e.prototype.findNextSiblings = function (t) {
			for (var e = []; t.nextSibling;) e.push(t.nextSibling), t = t.nextSibling;
			return e
		}, e
	}(), Ht = function () {
		function e(t) {
			this.bullet = new Rt, this.options = t.options
		}

		return e.prototype.insertTab = function (t, e) {
			var i = Mt.createText(new Array(e + 1).join(Mt.NBSP_CHAR));
			(t = t.deleteContents()).insertNode(i, !0), (t = It.create(i, e)).select()
		}, e.prototype.insertParagraph = function (e, i) {
			i = (i = (i = i || It.create(e)).deleteContents()).wrapBodyInlineWithPara();
			var n, r = Mt.ancestor(i.sc, Mt.isPara);
			if (r) {
				if (Mt.isEmpty(r) && Mt.isLi(r)) return void this.bullet.toggleList(r.parentNode.nodeName);
				var o = null;
				if (1 === this.options.blockquoteBreakingLevel ? o = Mt.ancestor(r, Mt.isBlockquote) : 2 === this.options.blockquoteBreakingLevel && (o = Mt.lastAncestor(r, Mt.isBlockquote)), o) {
					n = t(Mt.emptyPara)[0], Mt.isRightEdgePoint(i.getStartPoint()) && Mt.isBR(i.sc.nextSibling) && t(i.sc.nextSibling).remove();
					var a = Mt.splitTree(o, i.getStartPoint(), {isDiscardEmptySplits: !0});
					a ? a.parentNode.insertBefore(n, a) : Mt.insertAfter(n, o)
				} else {
					n = Mt.splitTree(r, i.getStartPoint());
					var s = Mt.listDescendant(r, Mt.isEmptyAnchor);
					s = s.concat(Mt.listDescendant(n, Mt.isEmptyAnchor)), t.each(s, function (t, e) {
						Mt.remove(e)
					}), (Mt.isHeading(n) || Mt.isPre(n) || Mt.isCustomStyleTag(n)) && Mt.isEmpty(n) && (n = Mt.replace(n, "p"))
				}
			} else {
				var l = i.sc.childNodes[i.so];
				n = t(Mt.emptyPara)[0], l ? i.sc.insertBefore(n, l) : i.sc.appendChild(n)
			}
			It.create(n, 0).normalize().select().scrollIntoView(e)
		}, e
	}(), $t = function (t, e, i, n) {
		var r = {colPos: 0, rowPos: 0}, o = [], a = [];

		function s(t, e, i, n, r, a, s) {
			var l = {baseRow: i, baseCell: n, isRowSpan: r, isColSpan: a, isVirtual: s};
			o[t] || (o[t] = []), o[t][e] = l
		}

		function l(t, e, i, n) {
			return {baseCell: t.baseCell, action: e, virtualTable: {rowIndex: i, cellIndex: n}}
		}

		function c(t, e) {
			if (!o[t]) return e;
			if (!o[t][e]) return e;
			for (var i = e; o[t][i];) if (i++, !o[t][i]) return i
		}

		function u(t, e) {
			var i = c(t.rowIndex, e.cellIndex), n = e.colSpan > 1, o = e.rowSpan > 1, a = t.rowIndex === r.rowPos && e.cellIndex === r.colPos;
			s(t.rowIndex, i, t, e, o, n, !1);
			var l = e.attributes.rowSpan ? parseInt(e.attributes.rowSpan.value, 10) : 0;
			if (l > 1) for (var u = 1; u < l; u++) {
				var d = t.rowIndex + u;
				h(d, i, e, a), s(d, i, t, e, !0, n, !0)
			}
			var p = e.attributes.colSpan ? parseInt(e.attributes.colSpan.value, 10) : 0;
			if (p > 1) for (var f = 1; f < p; f++) {
				var m = c(t.rowIndex, i + f);
				h(t.rowIndex, m, e, a), s(t.rowIndex, m, t, e, o, !0, !0)
			}
		}

		function h(t, e, i, n) {
			t === r.rowPos && r.colPos >= i.cellIndex && i.cellIndex <= e && !n && r.colPos++
		}

		function d(t) {
			switch (e) {
				case $t.where.Column:
					if (t.isColSpan) return $t.resultAction.SubtractSpanCount;
					break;
				case $t.where.Row:
					if (!t.isVirtual && t.isRowSpan) return $t.resultAction.AddCell;
					if (t.isRowSpan) return $t.resultAction.SubtractSpanCount
			}
			return $t.resultAction.RemoveCell
		}

		function p(t) {
			switch (e) {
				case $t.where.Column:
					if (t.isColSpan) return $t.resultAction.SumSpanCount;
					if (t.isRowSpan && t.isVirtual) return $t.resultAction.Ignore;
					break;
				case $t.where.Row:
					if (t.isRowSpan) return $t.resultAction.SumSpanCount;
					if (t.isColSpan && t.isVirtual) return $t.resultAction.Ignore
			}
			return $t.resultAction.AddCell
		}

		this.getActionList = function () {
			for (var t = e === $t.where.Row ? r.rowPos : -1, n = e === $t.where.Column ? r.colPos : -1, s = 0, c = !0; c;) {
				var u = t >= 0 ? t : s, h = n >= 0 ? n : s, f = o[u];
				if (!f) return c = !1, a;
				var m = f[h];
				if (!m) return c = !1, a;
				var g = $t.resultAction.Ignore;
				switch (i) {
					case $t.requestAction.Add:
						g = p(m);
						break;
					case $t.requestAction.Delete:
						g = d(m)
				}
				a.push(l(m, g, u, h)), s++
			}
			return a
		}, t && t.tagName && ("td" === t.tagName.toLowerCase() || "th" === t.tagName.toLowerCase()) ? (r.colPos = t.cellIndex, t.parentElement && t.parentElement.tagName && "tr" === t.parentElement.tagName.toLowerCase() ? r.rowPos = t.parentElement.rowIndex : console.error("Impossible to identify start Row point.", t)) : console.error("Impossible to identify start Cell point.", t), function () {
			for (var t = n.rows, e = 0; e < t.length; e++) for (var i = t[e].cells, r = 0; r < i.length; r++) u(t[e], i[r])
		}()
	};
	$t.where = {Row: 0, Column: 1}, $t.requestAction = {Add: 0, Delete: 1}, $t.resultAction = {Ignore: 0, SubtractSpanCount: 1, RemoveCell: 2, AddCell: 3, SumSpanCount: 4};
	var Bt, zt = function () {
		function e() {
		}

		return e.prototype.tab = function (t, e) {
			var i = Mt.ancestor(t.commonAncestor(), Mt.isCell), n = Mt.ancestor(i, Mt.isTable), r = Mt.listDescendant(n, Mt.isCell), o = T[e ? "prev" : "next"](r, i);
			o && It.create(o, 0).select()
		}, e.prototype.addRow = function (e, i) {
			for (var n = Mt.ancestor(e.commonAncestor(), Mt.isCell), r = t(n).closest("tr"), o = this.recoverAttributes(r), a = t("<tr" + o + "></tr>"), s = new $t(n, $t.where.Row, $t.requestAction.Add, t(r).closest("table")[0]).getActionList(), l = 0; l < s.length; l++) {
				var c = s[l], u = this.recoverAttributes(c.baseCell);
				switch (c.action) {
					case $t.resultAction.AddCell:
						a.append("<td" + u + ">" + Mt.blank + "</td>");
						break;
					case $t.resultAction.SumSpanCount:
						if ("top" === i) if ((c.baseCell.parent ? c.baseCell.closest("tr").rowIndex : 0) <= r[0].rowIndex) {
							var h = t("<div></div>").append(t("<td" + u + ">" + Mt.blank + "</td>").removeAttr("rowspan")).html();
							a.append(h);
							break
						}
						var d = parseInt(c.baseCell.rowSpan, 10);
						d++, c.baseCell.setAttribute("rowSpan", d)
				}
			}
			if ("top" === i) r.before(a); else {
				if (n.rowSpan > 1) {
					var p = r[0].rowIndex + (n.rowSpan - 2);
					return void t(t(r).parent().find("tr")[p]).after(t(a))
				}
				r.after(a)
			}
		}, e.prototype.addCol = function (e, i) {
			var n = Mt.ancestor(e.commonAncestor(), Mt.isCell), r = t(n).closest("tr");
			t(r).siblings().push(r);
			for (var o = new $t(n, $t.where.Column, $t.requestAction.Add, t(r).closest("table")[0]).getActionList(), a = 0; a < o.length; a++) {
				var s = o[a], l = this.recoverAttributes(s.baseCell);
				switch (s.action) {
					case $t.resultAction.AddCell:
						"right" === i ? t(s.baseCell).after("<td" + l + ">" + Mt.blank + "</td>") : t(s.baseCell).before("<td" + l + ">" + Mt.blank + "</td>");
						break;
					case $t.resultAction.SumSpanCount:
						if ("right" === i) {
							var c = parseInt(s.baseCell.colSpan, 10);
							c++, s.baseCell.setAttribute("colSpan", c)
						} else t(s.baseCell).before("<td" + l + ">" + Mt.blank + "</td>")
				}
			}
		}, e.prototype.recoverAttributes = function (t) {
			var e = "";
			if (!t) return e;
			for (var i = t.attributes || [], n = 0; n < i.length; n++) "id" !== i[n].name.toLowerCase() && i[n].specified && (e += " " + i[n].name + "='" + i[n].value + "'");
			return e
		}, e.prototype.deleteRow = function (e) {
			for (var i = Mt.ancestor(e.commonAncestor(), Mt.isCell), n = t(i).closest("tr"), r = n.children("td, th").index(t(i)), o = n[0].rowIndex, a = new $t(i, $t.where.Row, $t.requestAction.Delete, t(n).closest("table")[0]).getActionList(), s = 0; s < a.length; s++) if (a[s]) {
				var l = a[s].baseCell, c = a[s].virtualTable, u = l.rowSpan && l.rowSpan > 1, h = u ? parseInt(l.rowSpan, 10) : 0;
				switch (a[s].action) {
					case $t.resultAction.Ignore:
						continue;
					case $t.resultAction.AddCell:
						var d = n.next("tr")[0];
						if (!d) continue;
						var p = n[0].cells[r];
						u && (h > 2 ? (h--, d.insertBefore(p, d.cells[r]), d.cells[r].setAttribute("rowSpan", h), d.cells[r].innerHTML = "") : 2 === h && (d.insertBefore(p, d.cells[r]), d.cells[r].removeAttribute("rowSpan"), d.cells[r].innerHTML = ""));
						continue;
					case $t.resultAction.SubtractSpanCount:
						u && (h > 2 ? (h--, l.setAttribute("rowSpan", h), c.rowIndex !== o && l.cellIndex === r && (l.innerHTML = "")) : 2 === h && (l.removeAttribute("rowSpan"), c.rowIndex !== o && l.cellIndex === r && (l.innerHTML = "")));
						continue;
					case $t.resultAction.RemoveCell:
						continue
				}
			}
			n.remove()
		}, e.prototype.deleteCol = function (e) {
			for (var i = Mt.ancestor(e.commonAncestor(), Mt.isCell), n = t(i).closest("tr"), r = n.children("td, th").index(t(i)), o = new $t(i, $t.where.Column, $t.requestAction.Delete, t(n).closest("table")[0]).getActionList(), a = 0; a < o.length; a++) if (o[a]) switch (o[a].action) {
				case $t.resultAction.Ignore:
					continue;
				case $t.resultAction.SubtractSpanCount:
					var s = o[a].baseCell;
					if (s.colSpan && s.colSpan > 1) {
						var l = s.colSpan ? parseInt(s.colSpan, 10) : 0;
						l > 2 ? (l--, s.setAttribute("colSpan", l), s.cellIndex === r && (s.innerHTML = "")) : 2 === l && (s.removeAttribute("colSpan"), s.cellIndex === r && (s.innerHTML = ""))
					}
					continue;
				case $t.resultAction.RemoveCell:
					Mt.remove(o[a].baseCell, !0);
					continue
			}
		}, e.prototype.createTable = function (e, i, n) {
			for (var r, o = [], a = 0; a < e; a++) o.push("<td>" + Mt.blank + "</td>");
			r = o.join("");
			for (var s, l = [], c = 0; c < i; c++) l.push("<tr>" + r + "</tr>");
			s = l.join("");
			var u = t("<table>" + s + "</table>");
			return n && n.tableClassName && u.addClass(n.tableClassName), u[0]
		}, e.prototype.deleteTable = function (e) {
			var i = Mt.ancestor(e.commonAncestor(), Mt.isCell);
			t(i).closest("table").remove()
		}, e
	}(), jt = function () {
		function e(e) {
			var i = this;
			this.context = e, this.$note = e.layoutInfo.note, this.$editor = e.layoutInfo.editor, this.$editable = e.layoutInfo.editable, this.options = e.options, this.lang = this.options.langInfo, this.editable = this.$editable[0], this.lastRange = null, this.style = new Nt, this.table = new zt, this.typing = new Ht(e), this.bullet = new Rt, this.history = new Ft(this.$editable), this.context.memo("help.undo", this.lang.help.undo), this.context.memo("help.redo", this.lang.help.redo), this.context.memo("help.tab", this.lang.help.tab), this.context.memo("help.untab", this.lang.help.untab), this.context.memo("help.insertParagraph", this.lang.help.insertParagraph), this.context.memo("help.insertOrderedList", this.lang.help.insertOrderedList), this.context.memo("help.insertUnorderedList", this.lang.help.insertUnorderedList), this.context.memo("help.indent", this.lang.help.indent), this.context.memo("help.outdent", this.lang.help.outdent), this.context.memo("help.formatPara", this.lang.help.formatPara), this.context.memo("help.insertHorizontalRule", this.lang.help.insertHorizontalRule), this.context.memo("help.fontName", this.lang.help.fontName);
			for (var n = ["bold", "italic", "underline", "strikethrough", "superscript", "subscript", "justifyLeft", "justifyCenter", "justifyRight", "justifyFull", "formatBlock", "removeFormat", "backColor"], r = 0, o = n.length; r < o; r++) this[n[r]] = function (t) {
				return function (e) {
					i.beforeCommand(), document.execCommand(t, !1, e), i.afterCommand(!0)
				}
			}(n[r]), this.context.memo("help." + n[r], this.lang.help[n[r]]);
			this.fontName = this.wrapCommand(function (t) {
				return i.fontStyling("font-family", "'" + t + "'")
			}), this.fontSize = this.wrapCommand(function (t) {
				return i.fontStyling("font-size", t + "px")
			});
			for (r = 1; r <= 6; r++) this["formatH" + r] = function (t) {
				return function () {
					i.formatBlock("H" + t)
				}
			}(r), this.context.memo("help.formatH" + r, this.lang.help["formatH" + r]);
			this.insertParagraph = this.wrapCommand(function () {
				i.typing.insertParagraph(i.editable)
			}), this.insertOrderedList = this.wrapCommand(function () {
				i.bullet.insertOrderedList(i.editable)
			}), this.insertUnorderedList = this.wrapCommand(function () {
				i.bullet.insertUnorderedList(i.editable)
			}), this.indent = this.wrapCommand(function () {
				i.bullet.indent(i.editable)
			}), this.outdent = this.wrapCommand(function () {
				i.bullet.outdent(i.editable)
			}), this.insertNode = this.wrapCommand(function (e) {
				i.isLimited(t(e).text().length) || (i.createRange().insertNode(e), It.createFromNodeAfter(e).select())
			}), this.insertText = this.wrapCommand(function (t) {
				if (!i.isLimited(t.length)) {
					var e = i.createRange().insertNode(Mt.createText(t));
					It.create(e, Mt.nodeLength(e)).select()
				}
			}), this.pasteHTML = this.wrapCommand(function (t) {
				if (!i.isLimited(t.length)) {
					var e = i.createRange().pasteHTML(t);
					It.createFromNodeAfter(T.last(e)).select()
				}
			}), this.formatBlock = this.wrapCommand(function (t, e) {
				var n = i.options.callbacks.onApplyCustomStyle;
				n ? n.call(i, e, i.context, i.onFormatBlock) : i.onFormatBlock(t, e)
			}), this.insertHorizontalRule = this.wrapCommand(function () {
				var t = i.createRange().insertNode(Mt.create("HR"));
				t.nextSibling && It.create(t.nextSibling, 0).normalize().select()
			}), this.lineHeight = this.wrapCommand(function (t) {
				i.style.stylePara(i.createRange(), {lineHeight: t})
			}), this.createLink = this.wrapCommand(function (e) {
				var n = e.url, r = e.text, o = e.isNewWindow, a = e.range || i.createRange(), s = r.length - a.toString().length;
				if (!(s > 0 && i.isLimited(s))) {
					var l = a.toString() !== r;
					"string" == typeof n && (n = n.trim()), i.options.onCreateLink ? n = i.options.onCreateLink(n) : /^\.?\/(.*)/.test(n) || (n = /^[A-Za-z][A-Za-z0-9+-.]*\:[\/\/]?/.test(n) ? n : "http://" + n);
					var c = [];
					if (l) {
						var u = (a = a.deleteContents()).insertNode(t("<A>" + r + "</A>")[0]);
						c.push(u)
					} else c = i.style.styleNodes(a, {nodeName: "A", expandClosestSibling: !0, onlyPartialContains: !0});
					t.each(c, function (e, i) {
						t(i).attr("href", n), o ? t(i).attr("target", "_blank") : t(i).removeAttr("target")
					});
					var h = It.createFromNodeBefore(T.head(c)).getStartPoint(), d = It.createFromNodeAfter(T.last(c)).getEndPoint();
					It.create(h.node, h.offset, d.node, d.offset).select()
				}
			}), this.color = this.wrapCommand(function (t) {
				var e = t.foreColor, i = t.backColor;
				e && document.execCommand("foreColor", !1, e), i && document.execCommand("backColor", !1, i)
			}), this.foreColor = this.wrapCommand(function (t) {
				document.execCommand("styleWithCSS", !1, !0), document.execCommand("foreColor", !1, t)
			}), this.insertTable = this.wrapCommand(function (t) {
				var e = t.split("x");
				i.createRange().deleteContents().insertNode(i.table.createTable(e[0], e[1], i.options))
			}), this.removeMedia = this.wrapCommand(function () {
				var e = t(i.restoreTarget()).parent();
				e.parent("figure").length ? e.parent("figure").remove() : e = t(i.restoreTarget()).detach(), i.context.triggerEvent("media.delete", e, i.$editable)
			}), this.floatMe = this.wrapCommand(function (e) {
				var n = t(i.restoreTarget());
				n.toggleClass("note-float-left", "left" === e), n.toggleClass("note-float-right", "right" === e), n.css("float", e)
			}), this.resize = this.wrapCommand(function (e) {
				t(i.restoreTarget()).css({width: 100 * e + "%", height: ""})
			})
		}

		return e.prototype.initialize = function () {
			var t = this;
			this.$editable.on("keydown", function (e) {
				if (e.keyCode === Lt.code.ENTER && t.context.triggerEvent("enter", e), t.context.triggerEvent("keydown", e), e.isDefaultPrevented() || (t.options.shortcuts ? t.handleKeyMap(e) : t.preventDefaultEditableShortCuts(e)), t.isLimited(1, e)) return !1
			}).on("keyup", function (e) {
				t.context.triggerEvent("keyup", e)
			}).on("focus", function (e) {
				t.context.triggerEvent("focus", e)
			}).on("blur", function (e) {
				t.context.triggerEvent("blur", e)
			}).on("mousedown", function (e) {
				t.context.triggerEvent("mousedown", e)
			}).on("mouseup", function (e) {
				t.context.triggerEvent("mouseup", e)
			}).on("scroll", function (e) {
				t.context.triggerEvent("scroll", e)
			}).on("paste", function (e) {
				t.context.triggerEvent("paste", e)
			}), this.$editable.html(Mt.html(this.$note) || Mt.emptyPara), this.$editable.on(R.inputEventName, x.debounce(function () {
				t.context.triggerEvent("change", t.$editable.html())
			}, 10)), this.$editor.on("focusin", function (e) {
				t.context.triggerEvent("focusin", e)
			}).on("focusout", function (e) {
				t.context.triggerEvent("focusout", e)
			}), this.options.airMode || (this.options.width && this.$editor.outerWidth(this.options.width), this.options.height && this.$editable.outerHeight(this.options.height), this.options.maxHeight && this.$editable.css("max-height", this.options.maxHeight), this.options.minHeight && this.$editable.css("min-height", this.options.minHeight)), this.history.recordUndo()
		}, e.prototype.destroy = function () {
			this.$editable.off()
		}, e.prototype.handleKeyMap = function (t) {
			var e = this.options.keyMap[R.isMac ? "mac" : "pc"], i = [];
			t.metaKey && i.push("CMD"), t.ctrlKey && !t.altKey && i.push("CTRL"), t.shiftKey && i.push("SHIFT");
			var n = Lt.nameFromCode[t.keyCode];
			n && i.push(n);
			var r = e[i.join("+")];
			r ? !1 !== this.context.invoke(r) && t.preventDefault() : Lt.isEdit(t.keyCode) && this.afterCommand()
		}, e.prototype.preventDefaultEditableShortCuts = function (t) {
			(t.ctrlKey || t.metaKey) && T.contains([66, 73, 85], t.keyCode) && t.preventDefault()
		}, e.prototype.isLimited = function (t, e) {
			return t = t || 0, (void 0 === e || !(Lt.isMove(e.keyCode) || e.ctrlKey || e.metaKey || T.contains([Lt.code.BACKSPACE, Lt.code.DELETE], e.keyCode))) && (this.options.maxTextLength > 0 && this.$editable.text().length + t >= this.options.maxTextLength)
		}, e.prototype.createRange = function () {
			return this.focus(), It.create(this.editable)
		}, e.prototype.saveRange = function (t) {
			this.lastRange = this.createRange(), t && this.lastRange.collapse().select()
		}, e.prototype.restoreRange = function () {
			this.lastRange && (this.lastRange.select(), this.focus())
		}, e.prototype.saveTarget = function (t) {
			this.$editable.data("target", t)
		}, e.prototype.clearTarget = function () {
			this.$editable.removeData("target")
		}, e.prototype.restoreTarget = function () {
			return this.$editable.data("target")
		}, e.prototype.currentStyle = function () {
			var t = It.create();
			return t && (t = t.normalize()), t ? this.style.current(t) : this.style.fromNode(this.$editable)
		}, e.prototype.styleFromNode = function (t) {
			return this.style.fromNode(t)
		}, e.prototype.undo = function () {
			this.context.triggerEvent("before.command", this.$editable.html()), this.history.undo(), this.context.triggerEvent("change", this.$editable.html())
		}, e.prototype.commit = function () {
			this.context.triggerEvent("before.command", this.$editable.html()), this.history.commit(), this.context.triggerEvent("change", this.$editable.html())
		}, e.prototype.redo = function () {
			this.context.triggerEvent("before.command", this.$editable.html()), this.history.redo(), this.context.triggerEvent("change", this.$editable.html())
		}, e.prototype.beforeCommand = function () {
			this.context.triggerEvent("before.command", this.$editable.html()), this.focus()
		}, e.prototype.afterCommand = function (t) {
			this.normalizeContent(), this.history.recordUndo(), t || this.context.triggerEvent("change", this.$editable.html())
		}, e.prototype.tab = function () {
			var t = this.createRange();
			if (t.isCollapsed() && t.isOnCell()) this.table.tab(t); else {
				if (0 === this.options.tabSize) return !1;
				this.isLimited(this.options.tabSize) || (this.beforeCommand(), this.typing.insertTab(t, this.options.tabSize), this.afterCommand())
			}
		}, e.prototype.untab = function () {
			var t = this.createRange();
			if (t.isCollapsed() && t.isOnCell()) this.table.tab(t, !0); else if (0 === this.options.tabSize) return !1
		}, e.prototype.wrapCommand = function (t) {
			return function () {
				this.beforeCommand(), t.apply(this, arguments), this.afterCommand()
			}
		}, e.prototype.insertImage = function (e, i) {
			var n, r = this;
			return (n = e, t.Deferred(function (e) {
				var i = t("<img>");
				i.one("load", function () {
					i.off("error abort"), e.resolve(i)
				}).one("error abort", function () {
					i.off("load").detach(), e.reject(i)
				}).css({display: "none"}).appendTo(document.body).attr("src", n)
			}).promise()).then(function (t) {
				r.beforeCommand(), "function" == typeof i ? i(t) : ("string" == typeof i && t.attr("data-filename", i), t.css("width", Math.min(r.$editable.width(), t.width()))), t.show(), It.create(r.editable).insertNode(t[0]), It.createFromNodeAfter(t[0]).select(), r.afterCommand()
			}).fail(function (t) {
				r.context.triggerEvent("image.upload.error", t)
			})
		}, e.prototype.insertImagesAsDataURL = function (e) {
			var i = this;
			t.each(e, function (e, n) {
				var r = n.name;
				i.options.maximumImageFileSize && i.options.maximumImageFileSize < n.size ? i.context.triggerEvent("image.upload.error", i.lang.image.maximumFileSizeError) : function (e) {
					return t.Deferred(function (i) {
						t.extend(new FileReader, {
							onload: function (t) {
								var e = t.target.result;
								i.resolve(e)
							}, onerror: function (t) {
								i.reject(t)
							}
						}).readAsDataURL(e)
					}).promise()
				}(n).then(function (t) {
					return i.insertImage(t, r)
				}).fail(function () {
					i.context.triggerEvent("image.upload.error")
				})
			})
		}, e.prototype.getSelectedText = function () {
			var t = this.createRange();
			return t.isOnAnchor() && (t = It.createFromNode(Mt.ancestor(t.sc, Mt.isAnchor))), t.toString()
		}, e.prototype.onFormatBlock = function (e, i) {
			if (e = R.isMSIE ? "<" + e + ">" : e, document.execCommand("FormatBlock", !1, e), i && i.length) {
				var n = i[0].className || "";
				if (n) {
					var r = this.createRange();
					t([r.sc, r.ec]).closest(e).addClass(n)
				}
			}
		}, e.prototype.formatPara = function () {
			this.formatBlock("P")
		}, e.prototype.fontStyling = function (e, i) {
			var n = this.createRange();
			if (n) {
				var r = this.style.styleNodes(n);
				if (t(r).css(e, i), n.isCollapsed()) {
					var o = T.head(r);
					o && !Mt.nodeLength(o) && (o.innerHTML = Mt.ZERO_WIDTH_NBSP_CHAR, It.createFromNodeAfter(o.firstChild).select(), this.$editable.data("bogus", o))
				}
			}
		}, e.prototype.unlink = function () {
			var t = this.createRange();
			if (t.isOnAnchor()) {
				var e = Mt.ancestor(t.sc, Mt.isAnchor);
				(t = It.createFromNode(e)).select(), this.beforeCommand(), document.execCommand("unlink"), this.afterCommand()
			}
		}, e.prototype.getLinkInfo = function () {
			var e = this.createRange().expand(Mt.isAnchor), i = t(T.head(e.nodes(Mt.isAnchor))), n = {range: e, text: e.toString(), url: i.length ? i.attr("href") : ""};
			return i.length && (n.isNewWindow = "_blank" === i.attr("target")), n
		}, e.prototype.addRow = function (t) {
			var e = this.createRange(this.$editable);
			e.isCollapsed() && e.isOnCell() && (this.beforeCommand(), this.table.addRow(e, t), this.afterCommand())
		}, e.prototype.addCol = function (t) {
			var e = this.createRange(this.$editable);
			e.isCollapsed() && e.isOnCell() && (this.beforeCommand(), this.table.addCol(e, t), this.afterCommand())
		}, e.prototype.deleteRow = function () {
			var t = this.createRange(this.$editable);
			t.isCollapsed() && t.isOnCell() && (this.beforeCommand(), this.table.deleteRow(t), this.afterCommand())
		}, e.prototype.deleteCol = function () {
			var t = this.createRange(this.$editable);
			t.isCollapsed() && t.isOnCell() && (this.beforeCommand(), this.table.deleteCol(t), this.afterCommand())
		}, e.prototype.deleteTable = function () {
			var t = this.createRange(this.$editable);
			t.isCollapsed() && t.isOnCell() && (this.beforeCommand(), this.table.deleteTable(t), this.afterCommand())
		}, e.prototype.resizeTo = function (t, e, i) {
			var n;
			if (i) {
				var r = t.y / t.x, o = e.data("ratio");
				n = {width: o > r ? t.x : t.y / o, height: o > r ? t.x * o : t.y}
			} else n = {width: t.x, height: t.y};
			e.css(n)
		}, e.prototype.hasFocus = function () {
			return this.$editable.is(":focus")
		}, e.prototype.focus = function () {
			this.hasFocus() || this.$editable.focus()
		}, e.prototype.isEmpty = function () {
			return Mt.isEmpty(this.$editable[0]) || Mt.emptyPara === this.$editable.html()
		}, e.prototype.empty = function () {
			this.context.invoke("code", Mt.emptyPara)
		}, e.prototype.normalizeContent = function () {
			this.$editable[0].normalize()
		}, e
	}(), Ut = function () {
		function t(t) {
			this.context = t, this.$editable = t.layoutInfo.editable
		}

		return t.prototype.initialize = function () {
			this.$editable.on("paste", this.pasteByEvent.bind(this))
		}, t.prototype.pasteByEvent = function (t) {
			var e = t.originalEvent.clipboardData;
			if (e && e.items && e.items.length) {
				var i = e.items.length > 1 ? e.items[1] : T.head(e.items);
				"file" === i.kind && -1 !== i.type.indexOf("image/") && this.context.invoke("editor.insertImagesOrCallback", [i.getAsFile()]), this.context.invoke("editor.afterCommand")
			}
		}, t
	}(), Wt = function () {
		function e(e) {
			this.context = e, this.$eventListener = t(document), this.$editor = e.layoutInfo.editor, this.$editable = e.layoutInfo.editable, this.options = e.options, this.lang = this.options.langInfo, this.documentEventHandlers = {}, this.$dropzone = t(['<div class="note-dropzone">', '  <div class="note-dropzone-message"/>', "</div>"].join("")).prependTo(this.$editor)
		}

		return e.prototype.initialize = function () {
			this.options.disableDragAndDrop ? (this.documentEventHandlers.onDrop = function (t) {
				t.preventDefault()
			}, this.$eventListener = this.$dropzone, this.$eventListener.on("drop", this.documentEventHandlers.onDrop)) : this.attachDragAndDropEvent()
		}, e.prototype.attachDragAndDropEvent = function () {
			var e = this, i = t(), n = this.$dropzone.find(".note-dropzone-message");
			this.documentEventHandlers.onDragenter = function (t) {
				var r = e.context.invoke("codeview.isActivated"), o = e.$editor.width() > 0 && e.$editor.height() > 0;
				r || i.length || !o || (e.$editor.addClass("dragover"), e.$dropzone.width(e.$editor.width()), e.$dropzone.height(e.$editor.height()), n.text(e.lang.image.dragImageHere)), i = i.add(t.target)
			}, this.documentEventHandlers.onDragleave = function (t) {
				(i = i.not(t.target)).length || e.$editor.removeClass("dragover")
			}, this.documentEventHandlers.onDrop = function () {
				i = t(), e.$editor.removeClass("dragover")
			}, this.$eventListener.on("dragenter", this.documentEventHandlers.onDragenter).on("dragleave", this.documentEventHandlers.onDragleave).on("drop", this.documentEventHandlers.onDrop), this.$dropzone.on("dragenter", function () {
				e.$dropzone.addClass("hover"), n.text(e.lang.image.dropImage)
			}).on("dragleave", function () {
				e.$dropzone.removeClass("hover"), n.text(e.lang.image.dragImageHere)
			}), this.$dropzone.on("drop", function (i) {
				var n = i.originalEvent.dataTransfer;
				i.preventDefault(), n && n.files && n.files.length ? (e.$editable.focus(), e.context.invoke("editor.insertImagesOrCallback", n.files)) : t.each(n.types, function (i, r) {
					var o = n.getData(r);
					r.toLowerCase().indexOf("text") > -1 ? e.context.invoke("editor.pasteHTML", o) : t(o).each(function (t, i) {
						e.context.invoke("editor.insertNode", i)
					})
				})
			}).on("dragover", !1)
		}, e.prototype.destroy = function () {
			var t = this;
			Object.keys(this.documentEventHandlers).forEach(function (e) {
				t.$eventListener.off(e.substr(2).toLowerCase(), t.documentEventHandlers[e])
			}), this.documentEventHandlers = {}
		}, e
	}();
	R.hasCodeMirror && (R.isSupportAmd ? require(["codemirror"], function (t) {
		Bt = t
	}) : Bt = window.CodeMirror);
	var Yt = function () {
		function t(t) {
			this.context = t, this.$editor = t.layoutInfo.editor, this.$editable = t.layoutInfo.editable, this.$codable = t.layoutInfo.codable, this.options = t.options
		}

		return t.prototype.sync = function () {
			this.isActivated() && R.hasCodeMirror && this.$codable.data("cmEditor").save()
		}, t.prototype.isActivated = function () {
			return this.$editor.hasClass("codeview")
		}, t.prototype.toggle = function () {
			this.isActivated() ? this.deactivate() : this.activate(), this.context.triggerEvent("codeview.toggled")
		}, t.prototype.activate = function () {
			var t = this;
			if (this.$codable.val(Mt.html(this.$editable, this.options.prettifyHtml)), this.$codable.height(this.$editable.height()), this.context.invoke("toolbar.updateCodeview", !0), this.$editor.addClass("codeview"), this.$codable.focus(), R.hasCodeMirror) {
				var e = Bt.fromTextArea(this.$codable[0], this.options.codemirror);
				if (this.options.codemirror.tern) {
					var i = new Bt.TernServer(this.options.codemirror.tern);
					e.ternServer = i, e.on("cursorActivity", function (t) {
						i.updateArgHints(t)
					})
				}
				e.on("blur", function (i) {
					t.context.triggerEvent("blur.codeview", e.getValue(), i)
				}), e.setSize(null, this.$editable.outerHeight()), this.$codable.data("cmEditor", e)
			} else this.$codable.on("blur", function (e) {
				t.context.triggerEvent("blur.codeview", t.$codable.val(), e)
			})
		}, t.prototype.deactivate = function () {
			if (R.hasCodeMirror) {
				var t = this.$codable.data("cmEditor");
				this.$codable.val(t.getValue()), t.toTextArea()
			}
			var e = Mt.value(this.$codable, this.options.prettifyHtml) || Mt.emptyPara, i = this.$editable.html() !== e;
			this.$editable.html(e), this.$editable.height(this.options.height ? this.$codable.height() : "auto"), this.$editor.removeClass("codeview"), i && this.context.triggerEvent("change", this.$editable.html(), this.$editable), this.$editable.focus(), this.context.invoke("toolbar.updateCodeview", !1)
		}, t.prototype.destroy = function () {
			this.isActivated() && this.deactivate()
		}, t
	}(), Vt = function () {
		function e(e) {
			this.$document = t(document), this.$statusbar = e.layoutInfo.statusbar, this.$editable = e.layoutInfo.editable, this.options = e.options
		}

		return e.prototype.initialize = function () {
			var t = this;
			this.options.airMode || this.options.disableResizeEditor ? this.destroy() : this.$statusbar.on("mousedown", function (e) {
				e.preventDefault(), e.stopPropagation();
				var i = t.$editable.offset().top - t.$document.scrollTop(), n = function (e) {
					var n = e.clientY - (i + 24);
					n = t.options.minheight > 0 ? Math.max(n, t.options.minheight) : n, n = t.options.maxHeight > 0 ? Math.min(n, t.options.maxHeight) : n, t.$editable.height(n)
				};
				t.$document.on("mousemove", n).one("mouseup", function () {
					t.$document.off("mousemove", n)
				})
			})
		}, e.prototype.destroy = function () {
			this.$statusbar.off(), this.$statusbar.addClass("locked")
		}, e
	}(), qt = function () {
		function e(e) {
			var i = this;
			this.context = e, this.$editor = e.layoutInfo.editor, this.$toolbar = e.layoutInfo.toolbar, this.$editable = e.layoutInfo.editable, this.$codable = e.layoutInfo.codable, this.$window = t(window), this.$scrollbar = t("html, body"), this.onResize = function () {
				i.resizeTo({h: i.$window.height() - i.$toolbar.outerHeight()})
			}
		}

		return e.prototype.resizeTo = function (t) {
			this.$editable.css("height", t.h), this.$codable.css("height", t.h), this.$codable.data("cmeditor") && this.$codable.data("cmeditor").setsize(null, t.h)
		}, e.prototype.toggle = function () {
			this.$editor.toggleClass("fullscreen"), this.isFullscreen() ? (this.$editable.data("orgHeight", this.$editable.css("height")), this.$editable.data("orgMaxHeight", this.$editable.css("maxHeight")), this.$editable.css("maxHeight", ""), this.$window.on("resize", this.onResize).trigger("resize"), this.$scrollbar.css("overflow", "hidden")) : (this.$window.off("resize", this.onResize), this.resizeTo({h: this.$editable.data("orgHeight")}), this.$editable.css("maxHeight", this.$editable.css("orgMaxHeight")), this.$scrollbar.css("overflow", "visible")), this.context.invoke("toolbar.updateFullscreen", this.isFullscreen())
		}, e.prototype.isFullscreen = function () {
			return this.$editor.hasClass("fullscreen")
		}, e
	}(), Gt = function () {
		function e(e) {
			var i = this;
			this.context = e, this.$document = t(document), this.$editingArea = e.layoutInfo.editingArea, this.options = e.options, this.lang = this.options.langInfo, this.events = {
				"summernote.mousedown": function (t, e) {
					i.update(e.target) && e.preventDefault()
				}, "summernote.keyup summernote.scroll summernote.change summernote.dialog.shown": function () {
					i.update()
				}, "summernote.disable": function () {
					i.hide()
				}, "summernote.codeview.toggled": function () {
					i.update()
				}
			}
		}

		return e.prototype.initialize = function () {
			var e = this;
			this.$handle = t(['<div class="note-handle">', '<div class="note-control-selection">', '<div class="note-control-selection-bg"></div>', '<div class="note-control-holder note-control-nw"></div>', '<div class="note-control-holder note-control-ne"></div>', '<div class="note-control-holder note-control-sw"></div>', '<div class="', this.options.disableResizeImage ? "note-control-holder" : "note-control-sizing", ' note-control-se"></div>', this.options.disableResizeImage ? "" : '<div class="note-control-selection-info"></div>', "</div>", "</div>"].join("")).prependTo(this.$editingArea), this.$handle.on("mousedown", function (t) {
				if (Mt.isControlSizing(t.target)) {
					t.preventDefault(), t.stopPropagation();
					var i = e.$handle.find(".note-control-selection").data("target"), n = i.offset(), r = e.$document.scrollTop(), o = function (t) {
						e.context.invoke("editor.resizeTo", {x: t.clientX - n.left, y: t.clientY - (n.top - r)}, i, !t.shiftKey), e.update(i[0])
					};
					e.$document.on("mousemove", o).one("mouseup", function (t) {
						t.preventDefault(), e.$document.off("mousemove", o), e.context.invoke("editor.afterCommand")
					}), i.data("ratio") || i.data("ratio", i.height() / i.width())
				}
			}), this.$handle.on("wheel", function (t) {
				t.preventDefault(), e.update()
			})
		}, e.prototype.destroy = function () {
			this.$handle.remove()
		}, e.prototype.update = function (e) {
			if (this.context.isDisabled()) return !1;
			var i = Mt.isImg(e), n = this.$handle.find(".note-control-selection");
			if (this.context.invoke("imagePopover.update", e), i) {
				var r = t(e), o = r.position(), a = {left: o.left + parseInt(r.css("marginLeft"), 10), top: o.top + parseInt(r.css("marginTop"), 10)}, s = {w: r.outerWidth(!1), h: r.outerHeight(!1)};
				n.css({display: "block", left: a.left, top: a.top, width: s.w, height: s.h}).data("target", r);
				var l = new Image;
				l.src = r.attr("src");
				var c = s.w + "x" + s.h + " (" + this.lang.image.original + ": " + l.width + "x" + l.height + ")";
				n.find(".note-control-selection-info").text(c), this.context.invoke("editor.saveTarget", e)
			} else this.hide();
			return i
		}, e.prototype.hide = function () {
			this.context.invoke("editor.clearTarget"), this.$handle.children().hide()
		}, e
	}(), Kt = /^([A-Za-z][A-Za-z0-9+-.]*\:[\/]{2}|mailto:[A-Z0-9._%+-]+@)?(www\.)?(.+)$/i, Xt = function () {
		function e(t) {
			var e = this;
			this.context = t, this.events = {
				"summernote.keyup": function (t, i) {
					i.isDefaultPrevented() || e.handleKeyup(i)
				}, "summernote.keydown": function (t, i) {
					e.handleKeydown(i)
				}
			}
		}

		return e.prototype.initialize = function () {
			this.lastWordRange = null
		}, e.prototype.destroy = function () {
			this.lastWordRange = null
		}, e.prototype.replace = function () {
			if (this.lastWordRange) {
				var e = this.lastWordRange.toString(), i = e.match(Kt);
				if (i && (i[1] || i[2])) {
					var n = i[1] ? e : "http://" + e, r = t("<a />").html(e).attr("href", n)[0];
					this.context.options.linkTargetBlank && t(r).attr("target", "_blank"), this.lastWordRange.insertNode(r), this.lastWordRange = null, this.context.invoke("editor.focus")
				}
			}
		}, e.prototype.handleKeydown = function (t) {
			if (T.contains([Lt.code.ENTER, Lt.code.SPACE], t.keyCode)) {
				var e = this.context.invoke("editor.createRange").getWordRange();
				this.lastWordRange = e
			}
		}, e.prototype.handleKeyup = function (t) {
			T.contains([Lt.code.ENTER, Lt.code.SPACE], t.keyCode) && this.replace()
		}, e
	}(), Zt = function () {
		function t(t) {
			var e = this;
			this.$note = t.layoutInfo.note, this.events = {
				"summernote.change": function () {
					e.$note.val(t.invoke("code"))
				}
			}
		}

		return t.prototype.shouldInitialize = function () {
			return Mt.isTextarea(this.$note[0])
		}, t
	}(), Qt = function () {
		function e(t) {
			var e = this;
			this.context = t, this.$editingArea = t.layoutInfo.editingArea, this.options = t.options, this.events = {
				"summernote.init summernote.change": function () {
					e.update()
				}, "summernote.codeview.toggled": function () {
					e.update()
				}
			}
		}

		return e.prototype.shouldInitialize = function () {
			return !!this.options.placeholder
		}, e.prototype.initialize = function () {
			var e = this;
			this.$placeholder = t('<div class="note-placeholder">'), this.$placeholder.on("click", function () {
				e.context.invoke("focus")
			}).html(this.options.placeholder).prependTo(this.$editingArea), this.update()
		}, e.prototype.destroy = function () {
			this.$placeholder.remove()
		}, e.prototype.update = function () {
			var t = !this.context.invoke("codeview.isActivated") && this.context.invoke("editor.isEmpty");
			this.$placeholder.toggle(t)
		}, e
	}(), Jt = function () {
		function e(e) {
			this.ui = t.summernote.ui, this.context = e, this.$toolbar = e.layoutInfo.toolbar, this.options = e.options, this.lang = this.options.langInfo, this.invertedKeyMap = x.invertObject(this.options.keyMap[R.isMac ? "mac" : "pc"])
		}

		return e.prototype.representShortcut = function (t) {
			var e = this.invertedKeyMap[t];
			return this.options.shortcuts && e ? (R.isMac && (e = e.replace("CMD", "⌘").replace("SHIFT", "⇧")), " (" + (e = e.replace("BACKSLASH", "\\").replace("SLASH", "/").replace("LEFTBRACKET", "[").replace("RIGHTBRACKET", "]")) + ")") : ""
		}, e.prototype.button = function (t) {
			return !this.options.tooltip && t.tooltip && delete t.tooltip, t.container = this.options.container, this.ui.button(t)
		}, e.prototype.initialize = function () {
			this.addToolbarButtons(), this.addImagePopoverButtons(), this.addLinkPopoverButtons(), this.addTablePopoverButtons(), this.fontInstalledMap = {}
		}, e.prototype.destroy = function () {
			delete this.fontInstalledMap
		}, e.prototype.isFontInstalled = function (t) {
			return this.fontInstalledMap.hasOwnProperty(t) || (this.fontInstalledMap[t] = R.isFontInstalled(t) || T.contains(this.options.fontNamesIgnoreCheck, t)), this.fontInstalledMap[t]
		}, e.prototype.isFontDeservedToAdd = function (e) {
			return "" !== (e = e.toLowerCase()) && this.isFontInstalled(e) && -1 === t.inArray(e, ["sans-serif", "serif", "monospace", "cursive", "fantasy"])
		}, e.prototype.colorPalette = function (e, i, n, r) {
			var o = this;
			return this.ui.buttonGroup({
				className: "note-color " + e, children: [this.button({
					className: "note-current-color-button", contents: this.ui.icon(this.options.icons.font + " note-recent-color"), tooltip: i, click: function (e) {
						var i = t(e.currentTarget);
						n && r ? o.context.invoke("editor.color", {backColor: i.attr("data-backColor"), foreColor: i.attr("data-foreColor")}) : n ? o.context.invoke("editor.color", {backColor: i.attr("data-backColor")}) : r && o.context.invoke("editor.color", {foreColor: i.attr("data-foreColor")})
					}, callback: function (t) {
						var e = t.find(".note-recent-color");
						n && (e.css("background-color", "#FFFF00"), t.attr("data-backColor", "#FFFF00")), r || e.css("color", "transparent")
					}
				}), this.button({className: "dropdown-toggle", contents: this.ui.dropdownButtonContents("", this.options), tooltip: this.lang.color.more, data: {toggle: "dropdown"}}), this.ui.dropdown({
					items: (n ? ['<div class="note-palette">', '  <div class="note-palette-title">' + this.lang.color.background + "</div>", "  <div>", '    <button type="button" class="note-color-reset btn btn-light" data-event="backColor" data-value="inherit">', this.lang.color.transparent, "    </button>", "  </div>", '  <div class="note-holder" data-event="backColor"/>', "  <div>", '    <button type="button" class="note-color-select btn" data-event="openPalette" data-value="backColorPicker">', this.lang.color.cpSelect, "    </button>", '    <input type="color" id="backColorPicker" class="note-btn note-color-select-btn" value="#FFFF00" data-event="backColorPalette">', "  </div>", '  <div class="note-holder-custom" id="backColorPalette" data-event="backColor"/>', "</div>"].join("") : "") + (r ? ['<div class="note-palette">', '  <div class="note-palette-title">' + this.lang.color.foreground + "</div>", "  <div>", '    <button type="button" class="note-color-reset btn btn-light" data-event="removeFormat" data-value="foreColor">', this.lang.color.resetToDefault, "    </button>", "  </div>", '  <div class="note-holder" data-event="foreColor"/>', "  <div>", '    <button type="button" class="note-color-select btn" data-event="openPalette" data-value="foreColorPicker">', this.lang.color.cpSelect, "    </button>", '    <input type="color" id="foreColorPicker" class="note-btn note-color-select-btn" value="#000000" data-event="foreColorPalette">', '  <div class="note-holder-custom" id="foreColorPalette" data-event="foreColor"/>', "</div>"].join("") : ""),
					callback: function (e) {
						e.find(".note-holder").each(function (e, i) {
							var n = t(i);
							n.append(o.ui.palette({colors: o.options.colors, colorsName: o.options.colorsName, eventName: n.data("event"), container: o.options.container, tooltip: o.options.tooltip}).render())
						});
						var i = [["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"]];
						e.find(".note-holder-custom").each(function (e, n) {
							var r = t(n);
							r.append(o.ui.palette({colors: i, colorsName: i, eventName: r.data("event"), container: o.options.container, tooltip: o.options.tooltip}).render())
						}), e.find("input[type=color]").each(function (i, n) {
							t(n).change(function () {
								var i = e.find("#" + t(this).data("event")).find(".note-color-btn").first(), n = this.value.toUpperCase();
								i.css("background-color", n).attr("aria-label", n).attr("data-value", n).attr("data-original-title", n), i.click()
							})
						})
					},
					click: function (i) {
						i.stopPropagation();
						var n = t("." + e), r = t(i.target), a = r.data("event"), s = r.attr("data-value");
						if ("openPalette" === a) {
							var l = n.find("#" + s), c = t(n.find("#" + l.data("event")).find(".note-color-row")[0]), u = c.find(".note-color-btn").last().detach(), h = l.val();
							u.css("background-color", h).attr("aria-label", h).attr("data-value", h).attr("data-original-title", h), c.prepend(u), l.click()
						} else if (T.contains(["backColor", "foreColor"], a)) {
							var d = "backColor" === a ? "background-color" : "color", p = r.closest(".note-color").find(".note-recent-color"), f = r.closest(".note-color").find(".note-current-color-button");
							p.css(d, s), f.attr("data-" + a, s), o.context.invoke("editor." + a, s)
						}
					}
				})]
			}).render()
		}, e.prototype.addToolbarButtons = function () {
			var e = this;
			this.context.memo("button.style", function () {
				return e.ui.buttonGroup([e.button({className: "dropdown-toggle", contents: e.ui.dropdownButtonContents(e.ui.icon(e.options.icons.magic), e.options), tooltip: e.lang.style.style, data: {toggle: "dropdown"}}), e.ui.dropdown({
					className: "dropdown-style",
					items: e.options.styleTags,
					title: e.lang.style.style,
					template: function (t) {
						"string" == typeof t && (t = {tag: t, title: e.lang.style.hasOwnProperty(t) ? e.lang.style[t] : t});
						var i = t.tag, n = t.title;
						return "<" + i + (t.style ? ' style="' + t.style + '" ' : "") + (t.className ? ' class="' + t.className + '"' : "") + ">" + n + "</" + i + ">"
					},
					click: e.context.createInvokeHandler("editor.formatBlock")
				})]).render()
			});
			for (var i = function (t, i) {
				var r = n.options.styleTags[t];
				n.context.memo("button.style." + r, function () {
					return e.button({className: "note-btn-style-" + r, contents: '<div data-value="' + r + '">' + r.toUpperCase() + "</div>", tooltip: e.lang.style[r], click: e.context.createInvokeHandler("editor.formatBlock")}).render()
				})
			}, n = this, r = 0, o = this.options.styleTags.length; r < o; r++) i(r);
			this.context.memo("button.bold", function () {
				return e.button({className: "note-btn-bold", contents: e.ui.icon(e.options.icons.bold), tooltip: e.lang.font.bold + e.representShortcut("bold"), click: e.context.createInvokeHandlerAndUpdateState("editor.bold")}).render()
			}), this.context.memo("button.italic", function () {
				return e.button({className: "note-btn-italic", contents: e.ui.icon(e.options.icons.italic), tooltip: e.lang.font.italic + e.representShortcut("italic"), click: e.context.createInvokeHandlerAndUpdateState("editor.italic")}).render()
			}), this.context.memo("button.underline", function () {
				return e.button({className: "note-btn-underline", contents: e.ui.icon(e.options.icons.underline), tooltip: e.lang.font.underline + e.representShortcut("underline"), click: e.context.createInvokeHandlerAndUpdateState("editor.underline")}).render()
			}), this.context.memo("button.clear", function () {
				return e.button({contents: e.ui.icon(e.options.icons.eraser), tooltip: e.lang.font.clear + e.representShortcut("removeFormat"), click: e.context.createInvokeHandler("editor.removeFormat")}).render()
			}), this.context.memo("button.strikethrough", function () {
				return e.button({className: "note-btn-strikethrough", contents: e.ui.icon(e.options.icons.strikethrough), tooltip: e.lang.font.strikethrough + e.representShortcut("strikethrough"), click: e.context.createInvokeHandlerAndUpdateState("editor.strikethrough")}).render()
			}), this.context.memo("button.superscript", function () {
				return e.button({className: "note-btn-superscript", contents: e.ui.icon(e.options.icons.superscript), tooltip: e.lang.font.superscript, click: e.context.createInvokeHandlerAndUpdateState("editor.superscript")}).render()
			}), this.context.memo("button.subscript", function () {
				return e.button({className: "note-btn-subscript", contents: e.ui.icon(e.options.icons.subscript), tooltip: e.lang.font.subscript, click: e.context.createInvokeHandlerAndUpdateState("editor.subscript")}).render()
			}), this.context.memo("button.fontname", function () {
				var i = e.context.invoke("editor.currentStyle");
				return t.each(i["font-family"].split(","), function (i, n) {
					n = n.trim().replace(/['"]+/g, ""), e.isFontDeservedToAdd(n) && -1 === t.inArray(n, e.options.fontNames) && e.options.fontNames.push(n)
				}), e.ui.buttonGroup([e.button({className: "dropdown-toggle", contents: e.ui.dropdownButtonContents('<span class="note-current-fontname"/>', e.options), tooltip: e.lang.font.name, data: {toggle: "dropdown"}}), e.ui.dropdownCheck({
					className: "dropdown-fontname",
					checkClassName: e.options.icons.menuCheck,
					items: e.options.fontNames.filter(e.isFontInstalled.bind(e)),
					title: e.lang.font.name,
					template: function (t) {
						return "<span style=\"font-family: '" + t + "'\">" + t + "</span>"
					},
					click: e.context.createInvokeHandlerAndUpdateState("editor.fontName")
				})]).render()
			}), this.context.memo("button.fontsize", function () {
				return e.ui.buttonGroup([e.button({className: "dropdown-toggle", contents: e.ui.dropdownButtonContents('<span class="note-current-fontsize"/>', e.options), tooltip: e.lang.font.size, data: {toggle: "dropdown"}}), e.ui.dropdownCheck({
					className: "dropdown-fontsize",
					checkClassName: e.options.icons.menuCheck,
					items: e.options.fontSizes,
					title: e.lang.font.size,
					click: e.context.createInvokeHandlerAndUpdateState("editor.fontSize")
				})]).render()
			}), this.context.memo("button.color", function () {
				return e.colorPalette("note-color-all", e.lang.color.recent, !0, !0)
			}), this.context.memo("button.forecolor", function () {
				return e.colorPalette("note-color-fore", e.lang.color.foreground, !1, !0)
			}), this.context.memo("button.backcolor", function () {
				return e.colorPalette("note-color-back", e.lang.color.background, !0, !1)
			}), this.context.memo("button.ul", function () {
				return e.button({contents: e.ui.icon(e.options.icons.unorderedlist), tooltip: e.lang.lists.unordered + e.representShortcut("insertUnorderedList"), click: e.context.createInvokeHandler("editor.insertUnorderedList")}).render()
			}), this.context.memo("button.ol", function () {
				return e.button({contents: e.ui.icon(e.options.icons.orderedlist), tooltip: e.lang.lists.ordered + e.representShortcut("insertOrderedList"), click: e.context.createInvokeHandler("editor.insertOrderedList")}).render()
			});
			var a = this.button({contents: this.ui.icon(this.options.icons.alignLeft), tooltip: this.lang.paragraph.left + this.representShortcut("justifyLeft"), click: this.context.createInvokeHandler("editor.justifyLeft")}),
				s = this.button({contents: this.ui.icon(this.options.icons.alignCenter), tooltip: this.lang.paragraph.center + this.representShortcut("justifyCenter"), click: this.context.createInvokeHandler("editor.justifyCenter")}),
				l = this.button({contents: this.ui.icon(this.options.icons.alignRight), tooltip: this.lang.paragraph.right + this.representShortcut("justifyRight"), click: this.context.createInvokeHandler("editor.justifyRight")}),
				c = this.button({contents: this.ui.icon(this.options.icons.alignJustify), tooltip: this.lang.paragraph.justify + this.representShortcut("justifyFull"), click: this.context.createInvokeHandler("editor.justifyFull")}),
				u = this.button({contents: this.ui.icon(this.options.icons.outdent), tooltip: this.lang.paragraph.outdent + this.representShortcut("outdent"), click: this.context.createInvokeHandler("editor.outdent")}),
				h = this.button({contents: this.ui.icon(this.options.icons.indent), tooltip: this.lang.paragraph.indent + this.representShortcut("indent"), click: this.context.createInvokeHandler("editor.indent")});
			this.context.memo("button.justifyLeft", x.invoke(a, "render")), this.context.memo("button.justifyCenter", x.invoke(s, "render")), this.context.memo("button.justifyRight", x.invoke(l, "render")), this.context.memo("button.justifyFull", x.invoke(c, "render")), this.context.memo("button.outdent", x.invoke(u, "render")), this.context.memo("button.indent", x.invoke(h, "render")), this.context.memo("button.paragraph", function () {
				return e.ui.buttonGroup([e.button({className: "dropdown-toggle", contents: e.ui.dropdownButtonContents(e.ui.icon(e.options.icons.alignLeft), e.options), tooltip: e.lang.paragraph.paragraph, data: {toggle: "dropdown"}}), e.ui.dropdown([e.ui.buttonGroup({
					className: "note-align",
					children: [a, s, l, c]
				}), e.ui.buttonGroup({className: "note-list", children: [u, h]})])]).render()
			}), this.context.memo("button.height", function () {
				return e.ui.buttonGroup([e.button({className: "dropdown-toggle", contents: e.ui.dropdownButtonContents(e.ui.icon(e.options.icons.textHeight), e.options), tooltip: e.lang.font.height, data: {toggle: "dropdown"}}), e.ui.dropdownCheck({
					items: e.options.lineHeights,
					checkClassName: e.options.icons.menuCheck,
					className: "dropdown-line-height",
					title: e.lang.font.height,
					click: e.context.createInvokeHandler("editor.lineHeight")
				})]).render()
			}), this.context.memo("button.table", function () {
				return e.ui.buttonGroup([e.button({className: "dropdown-toggle", contents: e.ui.dropdownButtonContents(e.ui.icon(e.options.icons.table), e.options), tooltip: e.lang.table.table, data: {toggle: "dropdown"}}), e.ui.dropdown({
					title: e.lang.table.table,
					className: "note-table",
					items: ['<div class="note-dimension-picker">', '  <div class="note-dimension-picker-mousecatcher" data-event="insertTable" data-value="1x1"/>', '  <div class="note-dimension-picker-highlighted"/>', '  <div class="note-dimension-picker-unhighlighted"/>', "</div>", '<div class="note-dimension-display">1 x 1</div>'].join("")
				})], {
					callback: function (t) {
						t.find(".note-dimension-picker-mousecatcher").css({width: e.options.insertTableMaxSize.col + "em", height: e.options.insertTableMaxSize.row + "em"}).mousedown(e.context.createInvokeHandler("editor.insertTable")).on("mousemove", e.tableMoveHandler.bind(e))
					}
				}).render()
			}), this.context.memo("button.link", function () {
				return e.button({contents: e.ui.icon(e.options.icons.link), tooltip: e.lang.link.link + e.representShortcut("linkDialog.show"), click: e.context.createInvokeHandler("linkDialog.show")}).render()
			}), this.context.memo("button.picture", function () {
				return e.button({contents: e.ui.icon(e.options.icons.picture), tooltip: e.lang.image.image, click: e.context.createInvokeHandler("imageDialog.show")}).render()
			}), this.context.memo("button.video", function () {
				return e.button({contents: e.ui.icon(e.options.icons.video), tooltip: e.lang.video.video, click: e.context.createInvokeHandler("videoDialog.show")}).render()
			}), this.context.memo("button.hr", function () {
				return e.button({contents: e.ui.icon(e.options.icons.minus), tooltip: e.lang.hr.insert + e.representShortcut("insertHorizontalRule"), click: e.context.createInvokeHandler("editor.insertHorizontalRule")}).render()
			}), this.context.memo("button.fullscreen", function () {
				return e.button({className: "btn-fullscreen", contents: e.ui.icon(e.options.icons.arrowsAlt), tooltip: e.lang.options.fullscreen, click: e.context.createInvokeHandler("fullscreen.toggle")}).render()
			}), this.context.memo("button.codeview", function () {
				return e.button({className: "btn-codeview", contents: e.ui.icon(e.options.icons.code), tooltip: e.lang.options.codeview, click: e.context.createInvokeHandler("codeview.toggle")}).render()
			}), this.context.memo("button.redo", function () {
				return e.button({contents: e.ui.icon(e.options.icons.redo), tooltip: e.lang.history.redo + e.representShortcut("redo"), click: e.context.createInvokeHandler("editor.redo")}).render()
			}), this.context.memo("button.undo", function () {
				return e.button({contents: e.ui.icon(e.options.icons.undo), tooltip: e.lang.history.undo + e.representShortcut("undo"), click: e.context.createInvokeHandler("editor.undo")}).render()
			}), this.context.memo("button.help", function () {
				return e.button({contents: e.ui.icon(e.options.icons.question), tooltip: e.lang.options.help, click: e.context.createInvokeHandler("helpDialog.show")}).render()
			})
		}, e.prototype.addImagePopoverButtons = function () {
			var t = this;
			this.context.memo("button.imageSize100", function () {
				return t.button({contents: '<span class="note-fontsize-10">100%</span>', tooltip: t.lang.image.resizeFull, click: t.context.createInvokeHandler("editor.resize", "1")}).render()
			}), this.context.memo("button.imageSize50", function () {
				return t.button({contents: '<span class="note-fontsize-10">50%</span>', tooltip: t.lang.image.resizeHalf, click: t.context.createInvokeHandler("editor.resize", "0.5")}).render()
			}), this.context.memo("button.imageSize25", function () {
				return t.button({contents: '<span class="note-fontsize-10">25%</span>', tooltip: t.lang.image.resizeQuarter, click: t.context.createInvokeHandler("editor.resize", "0.25")}).render()
			}), this.context.memo("button.floatLeft", function () {
				return t.button({contents: t.ui.icon(t.options.icons.alignLeft), tooltip: t.lang.image.floatLeft, click: t.context.createInvokeHandler("editor.floatMe", "left")}).render()
			}), this.context.memo("button.floatRight", function () {
				return t.button({contents: t.ui.icon(t.options.icons.alignRight), tooltip: t.lang.image.floatRight, click: t.context.createInvokeHandler("editor.floatMe", "right")}).render()
			}), this.context.memo("button.floatNone", function () {
				return t.button({contents: t.ui.icon(t.options.icons.alignJustify), tooltip: t.lang.image.floatNone, click: t.context.createInvokeHandler("editor.floatMe", "none")}).render()
			}), this.context.memo("button.removeMedia", function () {
				return t.button({contents: t.ui.icon(t.options.icons.trash), tooltip: t.lang.image.remove, click: t.context.createInvokeHandler("editor.removeMedia")}).render()
			})
		}, e.prototype.addLinkPopoverButtons = function () {
			var t = this;
			this.context.memo("button.linkDialogShow", function () {
				return t.button({contents: t.ui.icon(t.options.icons.link), tooltip: t.lang.link.edit, click: t.context.createInvokeHandler("linkDialog.show")}).render()
			}), this.context.memo("button.unlink", function () {
				return t.button({contents: t.ui.icon(t.options.icons.unlink), tooltip: t.lang.link.unlink, click: t.context.createInvokeHandler("editor.unlink")}).render()
			})
		}, e.prototype.addTablePopoverButtons = function () {
			var t = this;
			this.context.memo("button.addRowUp", function () {
				return t.button({className: "btn-md", contents: t.ui.icon(t.options.icons.rowAbove), tooltip: t.lang.table.addRowAbove, click: t.context.createInvokeHandler("editor.addRow", "top")}).render()
			}), this.context.memo("button.addRowDown", function () {
				return t.button({className: "btn-md", contents: t.ui.icon(t.options.icons.rowBelow), tooltip: t.lang.table.addRowBelow, click: t.context.createInvokeHandler("editor.addRow", "bottom")}).render()
			}), this.context.memo("button.addColLeft", function () {
				return t.button({className: "btn-md", contents: t.ui.icon(t.options.icons.colBefore), tooltip: t.lang.table.addColLeft, click: t.context.createInvokeHandler("editor.addCol", "left")}).render()
			}), this.context.memo("button.addColRight", function () {
				return t.button({className: "btn-md", contents: t.ui.icon(t.options.icons.colAfter), tooltip: t.lang.table.addColRight, click: t.context.createInvokeHandler("editor.addCol", "right")}).render()
			}), this.context.memo("button.deleteRow", function () {
				return t.button({className: "btn-md", contents: t.ui.icon(t.options.icons.rowRemove), tooltip: t.lang.table.delRow, click: t.context.createInvokeHandler("editor.deleteRow")}).render()
			}), this.context.memo("button.deleteCol", function () {
				return t.button({className: "btn-md", contents: t.ui.icon(t.options.icons.colRemove), tooltip: t.lang.table.delCol, click: t.context.createInvokeHandler("editor.deleteCol")}).render()
			}), this.context.memo("button.deleteTable", function () {
				return t.button({className: "btn-md", contents: t.ui.icon(t.options.icons.trash), tooltip: t.lang.table.delTable, click: t.context.createInvokeHandler("editor.deleteTable")}).render()
			})
		}, e.prototype.build = function (e, i) {
			for (var n = 0, r = i.length; n < r; n++) {
				for (var o = i[n], a = t.isArray(o) ? o[0] : o, s = t.isArray(o) ? 1 === o.length ? [o[0]] : o[1] : [o], l = this.ui.buttonGroup({className: "note-" + a}).render(), c = 0, u = s.length; c < u; c++) {
					var h = this.context.memo("button." + s[c]);
					h && l.append("function" == typeof h ? h(this.context) : h)
				}
				l.appendTo(e)
			}
		}, e.prototype.updateCurrentStyle = function (e) {
			var i = this, n = e || this.$toolbar, r = this.context.invoke("editor.currentStyle");
			if (this.updateBtnStates(n, {
				".note-btn-bold": function () {
					return "bold" === r["font-bold"]
				}, ".note-btn-italic": function () {
					return "italic" === r["font-italic"]
				}, ".note-btn-underline": function () {
					return "underline" === r["font-underline"]
				}, ".note-btn-subscript": function () {
					return "subscript" === r["font-subscript"]
				}, ".note-btn-superscript": function () {
					return "superscript" === r["font-superscript"]
				}, ".note-btn-strikethrough": function () {
					return "strikethrough" === r["font-strikethrough"]
				}
			}), r["font-family"]) {
				var o = r["font-family"].split(",").map(function (t) {
					return t.replace(/[\'\"]/g, "").replace(/\s+$/, "").replace(/^\s+/, "")
				}), a = T.find(o, this.isFontInstalled.bind(this));
				n.find(".dropdown-fontname a").each(function (e, i) {
					var n = t(i), r = n.data("value") + "" == a + "";
					n.toggleClass("checked", r)
				}), n.find(".note-current-fontname").text(a).css("font-family", a)
			}
			if (r["font-size"]) {
				var s = r["font-size"];
				n.find(".dropdown-fontsize a").each(function (e, i) {
					var n = t(i), r = n.data("value") + "" == s + "";
					n.toggleClass("checked", r)
				}), n.find(".note-current-fontsize").text(s)
			}
			if (r["line-height"]) {
				var l = r["line-height"];
				n.find(".dropdown-line-height li a").each(function (e, n) {
					var r = t(n).data("value") + "" == l + "";
					i.className = r ? "checked" : ""
				})
			}
		}, e.prototype.updateBtnStates = function (e, i) {
			var n = this;
			t.each(i, function (t, i) {
				n.ui.toggleBtnActive(e.find(t), i())
			})
		}, e.prototype.tableMoveHandler = function (e) {
			var i, n = t(e.target.parentNode), r = n.next(), o = n.find(".note-dimension-picker-mousecatcher"), a = n.find(".note-dimension-picker-highlighted"), s = n.find(".note-dimension-picker-unhighlighted");
			if (void 0 === e.offsetX) {
				var l = t(e.target).offset();
				i = {x: e.pageX - l.left, y: e.pageY - l.top}
			} else i = {x: e.offsetX, y: e.offsetY};
			var c = Math.ceil(i.x / 18) || 1, u = Math.ceil(i.y / 18) || 1;
			a.css({width: c + "em", height: u + "em"}), o.data("value", c + "x" + u), c > 3 && c < this.options.insertTableMaxSize.col && s.css({width: c + 1 + "em"}), u > 3 && u < this.options.insertTableMaxSize.row && s.css({height: u + 1 + "em"}), r.html(c + " x " + u)
		}, e
	}(), te = function () {
		function e(e) {
			this.context = e, this.$window = t(window), this.$document = t(document), this.ui = t.summernote.ui, this.$note = e.layoutInfo.note, this.$editor = e.layoutInfo.editor, this.$toolbar = e.layoutInfo.toolbar, this.options = e.options, this.followScroll = this.followScroll.bind(this)
		}

		return e.prototype.shouldInitialize = function () {
			return !this.options.airMode
		}, e.prototype.initialize = function () {
			var t = this;
			this.options.toolbar = this.options.toolbar || [], this.options.toolbar.length ? this.context.invoke("buttons.build", this.$toolbar, this.options.toolbar) : this.$toolbar.hide(), this.options.toolbarContainer && this.$toolbar.appendTo(this.options.toolbarContainer), this.changeContainer(!1), this.$note.on("summernote.keyup summernote.mouseup summernote.change", function () {
				t.context.invoke("buttons.updateCurrentStyle")
			}), this.context.invoke("buttons.updateCurrentStyle"), this.options.followingToolbar && this.$window.on("scroll resize", this.followScroll)
		}, e.prototype.destroy = function () {
			this.$toolbar.children().remove(), this.options.followingToolbar && this.$window.off("scroll resize", this.followScroll)
		}, e.prototype.followScroll = function () {
			if (this.$editor.hasClass("fullscreen")) return !1;
			var e = this.$toolbar.parent(".note-toolbar-wrapper"), i = this.$editor.outerHeight(), n = this.$editor.width(), r = this.$toolbar.height();
			e.css({height: r});
			var o = 0;
			this.options.otherStaticBar && (o = t(this.options.otherStaticBar).outerHeight());
			var a = this.$document.scrollTop(), s = this.$editor.offset().top;
			a > s - o && a < s + i - o - r ? this.$toolbar.css({position: "fixed", top: o, width: n}) : this.$toolbar.css({position: "relative", top: 0, width: "100%"})
		}, e.prototype.changeContainer = function (t) {
			t ? this.$toolbar.prependTo(this.$editor) : this.options.toolbarContainer && this.$toolbar.appendTo(this.options.toolbarContainer)
		}, e.prototype.updateFullscreen = function (t) {
			this.ui.toggleBtnActive(this.$toolbar.find(".btn-fullscreen"), t), this.changeContainer(t)
		}, e.prototype.updateCodeview = function (t) {
			this.ui.toggleBtnActive(this.$toolbar.find(".btn-codeview"), t), t ? this.deactivate() : this.activate()
		}, e.prototype.activate = function (t) {
			var e = this.$toolbar.find("button");
			t || (e = e.not(".btn-codeview")), this.ui.toggleBtn(e, !0)
		}, e.prototype.deactivate = function (t) {
			var e = this.$toolbar.find("button");
			t || (e = e.not(".btn-codeview")), this.ui.toggleBtn(e, !1)
		}, e
	}(), ee = function () {
		function e(e) {
			this.context = e, this.ui = t.summernote.ui, this.$body = t(document.body), this.$editor = e.layoutInfo.editor, this.options = e.options, this.lang = this.options.langInfo, e.memo("help.linkDialog.show", this.options.langInfo.help["linkDialog.show"])
		}

		return e.prototype.initialize = function () {
			var e = this.options.dialogsInBody ? this.$body : this.$editor,
				i = ['<div class="form-group note-form-group">', '<label class="note-form-label">' + this.lang.link.textToDisplay + "</label>", '<input class="note-link-text form-control note-form-control note-input" type="text" />', "</div>", '<div class="form-group note-form-group">', '<label class="note-form-label">' + this.lang.link.url + "</label>", '<input class="note-link-url form-control note-form-control note-input" type="text" value="http://" />', "</div>", this.options.disableLinkTarget ? "" : t("<div/>").append(this.ui.checkbox({
					className: "sn-checkbox-open-in-new-window",
					text: this.lang.link.openInNewWindow,
					checked: !0
				}).render()).html()].join(""), n = '<input type="button" href="#" class="btn btn-primary note-btn note-btn-primary note-link-btn" value="' + this.lang.link.insert + '" disabled>';
			this.$dialog = this.ui.dialog({className: "link-dialog", title: this.lang.link.insert, fade: this.options.dialogsFade, body: i, footer: n}).render().appendTo(e)
		}, e.prototype.destroy = function () {
			this.ui.hideDialog(this.$dialog), this.$dialog.remove()
		}, e.prototype.bindEnterKey = function (t, e) {
			t.on("keypress", function (t) {
				t.keyCode === Lt.code.ENTER && (t.preventDefault(), e.trigger("click"))
			})
		}, e.prototype.toggleLinkBtn = function (t, e, i) {
			this.ui.toggleBtn(t, e.val() && i.val())
		}, e.prototype.showLinkDialog = function (e) {
			var i = this;
			return t.Deferred(function (t) {
				var n = i.$dialog.find(".note-link-text"), r = i.$dialog.find(".note-link-url"), o = i.$dialog.find(".note-link-btn"), a = i.$dialog.find(".sn-checkbox-open-in-new-window input[type=checkbox]");
				i.ui.onDialogShown(i.$dialog, function () {
					i.context.triggerEvent("dialog.shown"), e.url || (e.url = e.text), n.val(e.text);
					var s = function () {
						i.toggleLinkBtn(o, n, r), e.text = n.val()
					};
					n.on("input", s).on("paste", function () {
						setTimeout(s, 0)
					});
					var l = function () {
						i.toggleLinkBtn(o, n, r), e.text || n.val(r.val())
					};
					r.on("input", l).on("paste", function () {
						setTimeout(l, 0)
					}).val(e.url), R.isSupportTouch || r.trigger("focus"), i.toggleLinkBtn(o, n, r), i.bindEnterKey(r, o), i.bindEnterKey(n, o);
					var c = void 0 !== e.isNewWindow ? e.isNewWindow : i.context.options.linkTargetBlank;
					a.prop("checked", c), o.one("click", function (o) {
						o.preventDefault(), t.resolve({range: e.range, url: r.val(), text: n.val(), isNewWindow: a.is(":checked")}), i.ui.hideDialog(i.$dialog)
					})
				}), i.ui.onDialogHidden(i.$dialog, function () {
					n.off("input paste keypress"), r.off("input paste keypress"), o.off("click"), "pending" === t.state() && t.reject()
				}), i.ui.showDialog(i.$dialog)
			}).promise()
		}, e.prototype.show = function () {
			var t = this, e = this.context.invoke("editor.getLinkInfo");
			this.context.invoke("editor.saveRange"), this.showLinkDialog(e).then(function (e) {
				t.context.invoke("editor.restoreRange"), t.context.invoke("editor.createLink", e)
			}).fail(function () {
				t.context.invoke("editor.restoreRange")
			})
		}, e
	}(), ie = function () {
		function e(e) {
			var i = this;
			this.context = e, this.ui = t.summernote.ui, this.options = e.options, this.events = {
				"summernote.keyup summernote.mouseup summernote.change summernote.scroll": function () {
					i.update()
				}, "summernote.disable summernote.dialog.shown": function () {
					i.hide()
				}
			}
		}

		return e.prototype.shouldInitialize = function () {
			return !T.isEmpty(this.options.popover.link)
		}, e.prototype.initialize = function () {
			this.$popover = this.ui.popover({
				className: "note-link-popover", callback: function (t) {
					t.find(".popover-content,.note-popover-content").prepend('<span><a target="_blank"></a>&nbsp;</span>')
				}
			}).render().appendTo(this.options.container);
			var t = this.$popover.find(".popover-content,.note-popover-content");
			this.context.invoke("buttons.build", t, this.options.popover.link)
		}, e.prototype.destroy = function () {
			this.$popover.remove()
		}, e.prototype.update = function () {
			if (this.context.invoke("editor.hasFocus")) {
				var e = this.context.invoke("editor.createRange");
				if (e.isCollapsed() && e.isOnAnchor()) {
					var i = Mt.ancestor(e.sc, Mt.isAnchor), n = t(i).attr("href");
					this.$popover.find("a").attr("href", n).html(n);
					var r = Mt.posFromPlaceholder(i);
					this.$popover.css({display: "block", left: r.left, top: r.top})
				} else this.hide()
			} else this.hide()
		}, e.prototype.hide = function () {
			this.$popover.hide()
		}, e
	}(), ne = function () {
		function e(e) {
			this.context = e, this.ui = t.summernote.ui, this.$body = t(document.body), this.$editor = e.layoutInfo.editor, this.options = e.options, this.lang = this.options.langInfo
		}

		return e.prototype.initialize = function () {
			var t = this.options.dialogsInBody ? this.$body : this.$editor, e = "";
			if (this.options.maximumImageFileSize) {
				var i = Math.floor(Math.log(this.options.maximumImageFileSize) / Math.log(1024)), n = 1 * (this.options.maximumImageFileSize / Math.pow(1024, i)).toFixed(2) + " " + " KMGTP"[i] + "B";
				e = "<small>" + this.lang.image.maximumFileSize + " : " + n + "</small>"
			}
			var r = ['<div class="form-group note-form-group note-group-select-from-files">', '<label class="note-form-label">' + this.lang.image.selectFromFiles + "</label>", '<input class="note-image-input note-form-control note-input" ', ' type="file" name="files" accept="image/*" multiple="multiple" />', e, "</div>", '<div class="form-group note-group-image-url" style="overflow:auto;">', '<label class="note-form-label">' + this.lang.image.url + "</label>", '<input class="note-image-url form-control note-form-control note-input ', ' col-md-12" type="text" />', "</div>"].join(""),
				o = '<input type="button" href="#" class="btn btn-primary note-btn note-btn-primary note-image-btn" value="' + this.lang.image.insert + '" disabled>';
			this.$dialog = this.ui.dialog({title: this.lang.image.insert, fade: this.options.dialogsFade, body: r, footer: o}).render().appendTo(t)
		}, e.prototype.destroy = function () {
			this.ui.hideDialog(this.$dialog), this.$dialog.remove()
		}, e.prototype.bindEnterKey = function (t, e) {
			t.on("keypress", function (t) {
				t.keyCode === Lt.code.ENTER && (t.preventDefault(), e.trigger("click"))
			})
		}, e.prototype.show = function () {
			var t = this;
			this.context.invoke("editor.saveRange"), this.showImageDialog().then(function (e) {
				t.ui.hideDialog(t.$dialog), t.context.invoke("editor.restoreRange"), "string" == typeof e ? t.options.callbacks.onImageLinkInsert ? t.context.triggerEvent("image.link.insert", e) : t.context.invoke("editor.insertImage", e) : t.options.callbacks.onImageUpload ? t.context.triggerEvent("image.upload", e) : t.context.invoke("editor.insertImagesAsDataURL", e)
			}).fail(function () {
				t.context.invoke("editor.restoreRange")
			})
		}, e.prototype.showImageDialog = function () {
			var e = this;
			return t.Deferred(function (t) {
				var i = e.$dialog.find(".note-image-input"), n = e.$dialog.find(".note-image-url"), r = e.$dialog.find(".note-image-btn");
				e.ui.onDialogShown(e.$dialog, function () {
					e.context.triggerEvent("dialog.shown"), i.replaceWith(i.clone().on("change", function (e) {
						t.resolve(e.target.files || e.target.value)
					}).val("")), r.click(function (e) {
						e.preventDefault(), t.resolve(n.val())
					}), n.on("keyup paste", function () {
						var t = n.val();
						e.ui.toggleBtn(r, t)
					}).val(""), R.isSupportTouch || n.trigger("focus"), e.bindEnterKey(n, r)
				}), e.ui.onDialogHidden(e.$dialog, function () {
					i.off("change"), n.off("keyup paste keypress"), r.off("click"), "pending" === t.state() && t.reject()
				}), e.ui.showDialog(e.$dialog)
			})
		}, e
	}(), re = function () {
		function e(e) {
			var i = this;
			this.context = e, this.ui = t.summernote.ui, this.editable = e.layoutInfo.editable[0], this.options = e.options, this.events = {
				"summernote.disable": function () {
					i.hide()
				}
			}
		}

		return e.prototype.shouldInitialize = function () {
			return !T.isEmpty(this.options.popover.image)
		}, e.prototype.initialize = function () {
			this.$popover = this.ui.popover({className: "note-image-popover"}).render().appendTo(this.options.container);
			var t = this.$popover.find(".popover-content,.note-popover-content");
			this.context.invoke("buttons.build", t, this.options.popover.image)
		}, e.prototype.destroy = function () {
			this.$popover.remove()
		}, e.prototype.update = function (t) {
			if (Mt.isImg(t)) {
				var e = Mt.posFromPlaceholder(t), i = Mt.posFromPlaceholder(this.editable);
				this.$popover.css({display: "block", left: this.options.popatmouse ? event.pageX - 20 : e.left, top: this.options.popatmouse ? event.pageY : Math.min(e.top, i.top)})
			} else this.hide()
		}, e.prototype.hide = function () {
			this.$popover.hide()
		}, e
	}(), oe = function () {
		function e(e) {
			var i = this;
			this.context = e, this.ui = t.summernote.ui, this.options = e.options, this.events = {
				"summernote.mousedown": function (t, e) {
					i.update(e.target)
				}, "summernote.keyup summernote.scroll summernote.change": function () {
					i.update()
				}, "summernote.disable": function () {
					i.hide()
				}
			}
		}

		return e.prototype.shouldInitialize = function () {
			return !T.isEmpty(this.options.popover.table)
		}, e.prototype.initialize = function () {
			this.$popover = this.ui.popover({className: "note-table-popover"}).render().appendTo(this.options.container);
			var t = this.$popover.find(".popover-content,.note-popover-content");
			this.context.invoke("buttons.build", t, this.options.popover.table), R.isFF && document.execCommand("enableInlineTableEditing", !1, !1)
		}, e.prototype.destroy = function () {
			this.$popover.remove()
		}, e.prototype.update = function (t) {
			if (this.context.isDisabled()) return !1;
			var e = Mt.isCell(t);
			if (e) {
				var i = Mt.posFromPlaceholder(t);
				this.$popover.css({display: "block", left: i.left, top: i.top})
			} else this.hide();
			return e
		}, e.prototype.hide = function () {
			this.$popover.hide()
		}, e
	}(), ae = function () {
		function e(e) {
			this.context = e, this.ui = t.summernote.ui, this.$body = t(document.body), this.$editor = e.layoutInfo.editor, this.options = e.options, this.lang = this.options.langInfo
		}

		return e.prototype.initialize = function () {
			var t = this.options.dialogsInBody ? this.$body : this.$editor,
				e = ['<div class="form-group note-form-group row-fluid">', '<label class="note-form-label">' + this.lang.video.url + ' <small class="text-muted">' + this.lang.video.providers + "</small></label>", '<input class="note-video-url form-control note-form-control note-input" type="text" />', "</div>"].join(""),
				i = '<input type="button" href="#" class="btn btn-primary note-btn note-btn-primary note-video-btn" value="' + this.lang.video.insert + '" disabled>';
			this.$dialog = this.ui.dialog({title: this.lang.video.insert, fade: this.options.dialogsFade, body: e, footer: i}).render().appendTo(t)
		}, e.prototype.destroy = function () {
			this.ui.hideDialog(this.$dialog), this.$dialog.remove()
		}, e.prototype.bindEnterKey = function (t, e) {
			t.on("keypress", function (t) {
				t.keyCode === Lt.code.ENTER && (t.preventDefault(), e.trigger("click"))
			})
		}, e.prototype.createVideoNode = function (e) {
			var i, n = e.match(/\/\/(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w|-]{11})(?:(?:[\?&]t=)(\S+))?$/), r = e.match(/(?:www\.|\/\/)instagram\.com\/p\/(.[a-zA-Z0-9_-]*)/), o = e.match(/\/\/vine\.co\/v\/([a-zA-Z0-9]+)/),
				a = e.match(/\/\/(player\.)?vimeo\.com\/([a-z]*\/)*(\d+)[?]?.*/), s = e.match(/.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/), l = e.match(/\/\/v\.youku\.com\/v_show\/id_(\w+)=*\.html/), c = e.match(/\/\/v\.qq\.com.*?vid=(.+)/),
				u = e.match(/\/\/v\.qq\.com\/x?\/?(page|cover).*?\/([^\/]+)\.html\??.*/), h = e.match(/^.+.(mp4|m4v)$/), d = e.match(/^.+.(ogg|ogv)$/), p = e.match(/^.+.(webm)$/);
			if (n && 11 === n[1].length) {
				var f = n[1], m = 0;
				if (void 0 !== n[2]) {
					var g = n[2].match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
					if (g) for (var v = [3600, 60, 1], y = 0, b = v.length; y < b; y++) m += void 0 !== g[y + 1] ? v[y] * parseInt(g[y + 1], 10) : 0
				}
				i = t("<iframe>").attr("frameborder", 0).attr("src", "//www.youtube.com/embed/" + f + (m > 0 ? "?start=" + m : "")).attr("width", "640").attr("height", "360")
			} else if (r && r[0].length) i = t("<iframe>").attr("frameborder", 0).attr("src", "https://instagram.com/p/" + r[1] + "/embed/").attr("width", "612").attr("height", "710").attr("scrolling", "no").attr("allowtransparency", "true"); else if (o && o[0].length) i = t("<iframe>").attr("frameborder", 0).attr("src", o[0] + "/embed/simple").attr("width", "600").attr("height", "600").attr("class", "vine-embed"); else if (a && a[3].length) i = t("<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>").attr("frameborder", 0).attr("src", "//player.vimeo.com/video/" + a[3]).attr("width", "640").attr("height", "360"); else if (s && s[2].length) i = t("<iframe>").attr("frameborder", 0).attr("src", "//www.dailymotion.com/embed/video/" + s[2]).attr("width", "640").attr("height", "360"); else if (l && l[1].length) i = t("<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>").attr("frameborder", 0).attr("height", "498").attr("width", "510").attr("src", "//player.youku.com/embed/" + l[1]); else if (c && c[1].length || u && u[2].length) {
				var w = c && c[1].length ? c[1] : u[2];
				i = t("<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>").attr("frameborder", 0).attr("height", "310").attr("width", "500").attr("src", "http://v.qq.com/iframe/player.html?vid=" + w + "&amp;auto=0")
			} else {
				if (!(h || d || p)) return !1;
				i = t("<video controls>").attr("src", e).attr("width", "640").attr("height", "360")
			}
			return i.addClass("note-video-clip"), i[0]
		}, e.prototype.show = function () {
			var t = this, e = this.context.invoke("editor.getSelectedText");
			this.context.invoke("editor.saveRange"), this.showVideoDialog(e).then(function (e) {
				t.ui.hideDialog(t.$dialog), t.context.invoke("editor.restoreRange");
				var i = t.createVideoNode(e);
				i && t.context.invoke("editor.insertNode", i)
			}).fail(function () {
				t.context.invoke("editor.restoreRange")
			})
		}, e.prototype.showVideoDialog = function (e) {
			var i = this;
			return t.Deferred(function (t) {
				var n = i.$dialog.find(".note-video-url"), r = i.$dialog.find(".note-video-btn");
				i.ui.onDialogShown(i.$dialog, function () {
					i.context.triggerEvent("dialog.shown"), n.val(e).on("input", function () {
						i.ui.toggleBtn(r, n.val())
					}), R.isSupportTouch || n.trigger("focus"), r.click(function (e) {
						e.preventDefault(), t.resolve(n.val())
					}), i.bindEnterKey(n, r)
				}), i.ui.onDialogHidden(i.$dialog, function () {
					n.off("input"), r.off("click"), "pending" === t.state() && t.reject()
				}), i.ui.showDialog(i.$dialog)
			})
		}, e
	}(), se = function () {
		function e(e) {
			this.context = e, this.ui = t.summernote.ui, this.$body = t(document.body), this.$editor = e.layoutInfo.editor, this.options = e.options, this.lang = this.options.langInfo
		}

		return e.prototype.initialize = function () {
			var t = this.options.dialogsInBody ? this.$body : this.$editor,
				e = ['<p class="text-center">', '<a href="http://summernote.org/" target="_blank">Summernote 0.8.11</a> · ', '<a href="https://github.com/summernote/summernote" target="_blank">Project</a> · ', '<a href="https://github.com/summernote/summernote/issues" target="_blank">Issues</a>', "</p>"].join("");
			this.$dialog = this.ui.dialog({
				title: this.lang.options.help, fade: this.options.dialogsFade, body: this.createShortcutList(), footer: e, callback: function (t) {
					t.find(".modal-body,.note-modal-body").css({"max-height": 300, overflow: "scroll"})
				}
			}).render().appendTo(t)
		}, e.prototype.destroy = function () {
			this.ui.hideDialog(this.$dialog), this.$dialog.remove()
		}, e.prototype.createShortcutList = function () {
			var e = this, i = this.options.keyMap[R.isMac ? "mac" : "pc"];
			return Object.keys(i).map(function (n) {
				var r = i[n], o = t('<div><div class="help-list-item"/></div>');
				return o.append(t("<label><kbd>" + n + "</kdb></label>").css({width: 180, "margin-right": 10})).append(t("<span/>").html(e.context.memo("help." + r) || r)), o.html()
			}).join("")
		}, e.prototype.showHelpDialog = function () {
			var e = this;
			return t.Deferred(function (t) {
				e.ui.onDialogShown(e.$dialog, function () {
					e.context.triggerEvent("dialog.shown"), t.resolve()
				}), e.ui.showDialog(e.$dialog)
			}).promise()
		}, e.prototype.show = function () {
			var t = this;
			this.context.invoke("editor.saveRange"), this.showHelpDialog().then(function () {
				t.context.invoke("editor.restoreRange")
			})
		}, e
	}(), le = function () {
		function e(e) {
			var i = this;
			this.context = e, this.ui = t.summernote.ui, this.options = e.options, this.events = {
				"summernote.keyup summernote.mouseup summernote.scroll": function () {
					i.update()
				}, "summernote.disable summernote.change summernote.dialog.shown": function () {
					i.hide()
				}, "summernote.focusout": function (t, e) {
					R.isFF || e.relatedTarget && Mt.ancestor(e.relatedTarget, x.eq(i.$popover[0])) || i.hide()
				}
			}
		}

		return e.prototype.shouldInitialize = function () {
			return this.options.airMode && !T.isEmpty(this.options.popover.air)
		}, e.prototype.initialize = function () {
			this.$popover = this.ui.popover({className: "note-air-popover"}).render().appendTo(this.options.container);
			var t = this.$popover.find(".popover-content");
			this.context.invoke("buttons.build", t, this.options.popover.air)
		}, e.prototype.destroy = function () {
			this.$popover.remove()
		}, e.prototype.update = function () {
			var t = this.context.invoke("editor.currentStyle");
			if (t.range && !t.range.isCollapsed()) {
				var e = T.last(t.range.getClientRects());
				if (e) {
					var i = x.rect2bnd(e);
					this.$popover.css({display: "block", left: Math.max(i.left + i.width / 2, 0) - 20, top: i.top + i.height}), this.context.invoke("buttons.updateCurrentStyle", this.$popover)
				}
			} else this.hide()
		}, e.prototype.hide = function () {
			this.$popover.hide()
		}, e
	}(), ce = function () {
		function e(e) {
			var i = this;
			this.context = e, this.ui = t.summernote.ui, this.$editable = e.layoutInfo.editable, this.options = e.options, this.hint = this.options.hint || [], this.direction = this.options.hintDirection || "bottom", this.hints = t.isArray(this.hint) ? this.hint : [this.hint], this.events = {
				"summernote.keyup": function (t, e) {
					e.isDefaultPrevented() || i.handleKeyup(e)
				}, "summernote.keydown": function (t, e) {
					i.handleKeydown(e)
				}, "summernote.disable summernote.dialog.shown": function () {
					i.hide()
				}
			}
		}

		return e.prototype.shouldInitialize = function () {
			return this.hints.length > 0
		}, e.prototype.initialize = function () {
			var e = this;
			this.lastWordRange = null, this.$popover = this.ui.popover({
				className: "note-hint-popover",
				hideArrow: !0,
				direction: ""
			}).render().appendTo(this.options.container), this.$popover.hide(), this.$content = this.$popover.find(".popover-content,.note-popover-content"), this.$content.on("click", ".note-hint-item", function (i) {
				e.$content.find(".active").removeClass("active"), t(i.currentTarget).addClass("active"), e.replace()
			})
		}, e.prototype.destroy = function () {
			this.$popover.remove()
		}, e.prototype.selectItem = function (t) {
			this.$content.find(".active").removeClass("active"), t.addClass("active"), this.$content[0].scrollTop = t[0].offsetTop - this.$content.innerHeight() / 2
		}, e.prototype.moveDown = function () {
			var t = this.$content.find(".note-hint-item.active"), e = t.next();
			if (e.length) this.selectItem(e); else {
				var i = t.parent().next();
				i.length || (i = this.$content.find(".note-hint-group").first()), this.selectItem(i.find(".note-hint-item").first())
			}
		}, e.prototype.moveUp = function () {
			var t = this.$content.find(".note-hint-item.active"), e = t.prev();
			if (e.length) this.selectItem(e); else {
				var i = t.parent().prev();
				i.length || (i = this.$content.find(".note-hint-group").last()), this.selectItem(i.find(".note-hint-item").last())
			}
		}, e.prototype.replace = function () {
			var t = this.$content.find(".note-hint-item.active");
			if (t.length) {
				var e = this.nodeFromItem(t);
				this.lastWordRange.insertNode(e), It.createFromNode(e).collapse().select(), this.lastWordRange = null, this.hide(), this.context.triggerEvent("change", this.$editable.html(), this.$editable[0]), this.context.invoke("editor.focus")
			}
		}, e.prototype.nodeFromItem = function (t) {
			var e = this.hints[t.data("index")], i = t.data("item"), n = e.content ? e.content(i) : i;
			return "string" == typeof n && (n = Mt.createText(n)), n
		}, e.prototype.createItemTemplates = function (e, i) {
			var n = this.hints[e];
			return i.map(function (i, r) {
				var o = t('<div class="note-hint-item"/>');
				return o.append(n.template ? n.template(i) : i + ""), o.data({index: e, item: i}), o
			})
		}, e.prototype.handleKeydown = function (t) {
			this.$popover.is(":visible") && (t.keyCode === Lt.code.ENTER ? (t.preventDefault(), this.replace()) : t.keyCode === Lt.code.UP ? (t.preventDefault(), this.moveUp()) : t.keyCode === Lt.code.DOWN && (t.preventDefault(), this.moveDown()))
		}, e.prototype.searchKeyword = function (t, e, i) {
			var n = this.hints[t];
			if (n && n.match.test(e) && n.search) {
				var r = n.match.exec(e);
				n.search(r[1], i)
			} else i()
		}, e.prototype.createGroup = function (e, i) {
			var n = this, r = t('<div class="note-hint-group note-hint-group-' + e + '"/>');
			return this.searchKeyword(e, i, function (t) {
				(t = t || []).length && (r.html(n.createItemTemplates(e, t)), n.show())
			}), r
		}, e.prototype.handleKeyup = function (t) {
			var e = this;
			if (!T.contains([Lt.code.ENTER, Lt.code.UP, Lt.code.DOWN], t.keyCode)) {
				var i = this.context.invoke("editor.createRange").getWordRange(), n = i.toString();
				if (this.hints.length && n) {
					this.$content.empty();
					var r = x.rect2bnd(T.last(i.getClientRects()));
					r && (this.$popover.hide(), this.lastWordRange = i, this.hints.forEach(function (t, i) {
						t.match.test(n) && e.createGroup(i, n).appendTo(e.$content)
					}), this.$content.find(".note-hint-item:first").addClass("active"), "top" === this.direction ? this.$popover.css({left: r.left, top: r.top - this.$popover.outerHeight() - 5}) : this.$popover.css({left: r.left, top: r.top + r.height + 5}))
				} else this.hide()
			}
		}, e.prototype.show = function () {
			this.$popover.show()
		}, e.prototype.hide = function () {
			this.$popover.hide()
		}, e
	}(), ue = function () {
		function e(e, i) {
			this.ui = t.summernote.ui, this.$note = e, this.memos = {}, this.modules = {}, this.layoutInfo = {}, this.options = i, this.initialize()
		}

		return e.prototype.initialize = function () {
			return this.layoutInfo = this.ui.createLayout(this.$note, this.options), this._initialize(), this.$note.hide(), this
		}, e.prototype.destroy = function () {
			this._destroy(), this.$note.removeData("summernote"), this.ui.removeLayout(this.$note, this.layoutInfo)
		}, e.prototype.reset = function () {
			var t = this.isDisabled();
			this.code(Mt.emptyPara), this._destroy(), this._initialize(), t && this.disable()
		}, e.prototype._initialize = function () {
			var e = this, i = t.extend({}, this.options.buttons);
			Object.keys(i).forEach(function (t) {
				e.memo("button." + t, i[t])
			});
			var n = t.extend({}, this.options.modules, t.summernote.plugins || {});
			Object.keys(n).forEach(function (t) {
				e.module(t, n[t], !0)
			}), Object.keys(this.modules).forEach(function (t) {
				e.initializeModule(t)
			})
		}, e.prototype._destroy = function () {
			var t = this;
			Object.keys(this.modules).reverse().forEach(function (e) {
				t.removeModule(e)
			}), Object.keys(this.memos).forEach(function (e) {
				t.removeMemo(e)
			}), this.triggerEvent("destroy", this)
		}, e.prototype.code = function (t) {
			var e = this.invoke("codeview.isActivated");
			if (void 0 === t) return this.invoke("codeview.sync"), e ? this.layoutInfo.codable.val() : this.layoutInfo.editable.html();
			e ? this.layoutInfo.codable.val(t) : this.layoutInfo.editable.html(t), this.$note.val(t), this.triggerEvent("change", t)
		}, e.prototype.isDisabled = function () {
			return "false" === this.layoutInfo.editable.attr("contenteditable")
		}, e.prototype.enable = function () {
			this.layoutInfo.editable.attr("contenteditable", !0), this.invoke("toolbar.activate", !0), this.triggerEvent("disable", !1)
		}, e.prototype.disable = function () {
			this.invoke("codeview.isActivated") && this.invoke("codeview.deactivate"), this.layoutInfo.editable.attr("contenteditable", !1), this.invoke("toolbar.deactivate", !0), this.triggerEvent("disable", !0)
		}, e.prototype.triggerEvent = function () {
			var t = T.head(arguments), e = T.tail(T.from(arguments)), i = this.options.callbacks[x.namespaceToCamel(t, "on")];
			i && i.apply(this.$note[0], e), this.$note.trigger("summernote." + t, e)
		}, e.prototype.initializeModule = function (t) {
			var e = this.modules[t];
			e.shouldInitialize = e.shouldInitialize || x.ok, e.shouldInitialize() && (e.initialize && e.initialize(), e.events && Mt.attachEvents(this.$note, e.events))
		}, e.prototype.module = function (t, e, i) {
			if (1 === arguments.length) return this.modules[t];
			this.modules[t] = new e(this), i || this.initializeModule(t)
		}, e.prototype.removeModule = function (t) {
			var e = this.modules[t];
			e.shouldInitialize() && (e.events && Mt.detachEvents(this.$note, e.events), e.destroy && e.destroy()), delete this.modules[t]
		}, e.prototype.memo = function (t, e) {
			if (1 === arguments.length) return this.memos[t];
			this.memos[t] = e
		}, e.prototype.removeMemo = function (t) {
			this.memos[t] && this.memos[t].destroy && this.memos[t].destroy(), delete this.memos[t]
		}, e.prototype.createInvokeHandlerAndUpdateState = function (t, e) {
			var i = this;
			return function (n) {
				i.createInvokeHandler(t, e)(n), i.invoke("buttons.updateCurrentStyle")
			}
		}, e.prototype.createInvokeHandler = function (e, i) {
			var n = this;
			return function (r) {
				r.preventDefault();
				var o = t(r.target);
				n.invoke(e, i || o.closest("[data-value]").data("value"), o)
			}
		}, e.prototype.invoke = function () {
			var t = T.head(arguments), e = T.tail(T.from(arguments)), i = t.split("."), n = i.length > 1, r = n && T.head(i), o = n ? T.last(i) : T.head(i), a = this.modules[r || "editor"];
			return !r && this[o] ? this[o].apply(this, e) : a && a[o] && a.shouldInitialize() ? a[o].apply(a, e) : void 0
		}, e
	}();
	t.fn.extend({
		summernote: function () {
			var e = t.type(T.head(arguments)), i = "string" === e, n = "object" === e, r = t.extend({}, t.summernote.options, n ? T.head(arguments) : {});
			r.langInfo = t.extend(!0, {}, t.summernote.lang["en-US"], t.summernote.lang[r.lang]), r.icons = t.extend(!0, {}, t.summernote.options.icons, r.icons), r.tooltip = "auto" === r.tooltip ? !R.isSupportTouch : r.tooltip, this.each(function (e, i) {
				var n = t(i);
				if (!n.data("summernote")) {
					var o = new ue(n, r);
					n.data("summernote", o), n.data("summernote").triggerEvent("init", o.layoutInfo)
				}
			});
			var o = this.first();
			if (o.length) {
				var a = o.data("summernote");
				if (i) return a.invoke.apply(a, T.from(arguments));
				r.focus && a.invoke("editor.focus")
			}
			return this
		}
	}), t.summernote = t.extend(t.summernote, {
		version: "0.8.11", ui: b, dom: Mt, range: It, plugins: {}, options: {
			modules: {
				editor: jt,
				clipboard: Ut,
				dropzone: Wt,
				codeview: Yt,
				statusbar: Vt,
				fullscreen: qt,
				handle: Gt,
				hintPopover: ce,
				autoLink: Xt,
				autoSync: Zt,
				placeholder: Qt,
				buttons: Jt,
				toolbar: te,
				linkDialog: ee,
				linkPopover: ie,
				imageDialog: ne,
				imagePopover: re,
				tablePopover: oe,
				videoDialog: ae,
				helpDialog: se,
				airPopover: le
			},
			buttons: {},
			lang: "en-US",
			followingToolbar: !0,
			otherStaticBar: "",
			toolbar: [["style", ["style"]], ["font", ["bold", "underline", "clear"]], ["fontname", ["fontname"]], ["color", ["color"]], ["para", ["ul", "ol", "paragraph"]], ["table", ["table"]], ["insert", ["link", "picture", "video"]], ["view", ["fullscreen", "codeview", "help"]]],
			popatmouse: !0,
			popover: {
				image: [["imagesize", ["imageSize100", "imageSize50", "imageSize25"]], ["float", ["floatLeft", "floatRight", "floatNone"]], ["remove", ["removeMedia"]]],
				link: [["link", ["linkDialogShow", "unlink"]]],
				table: [["add", ["addRowDown", "addRowUp", "addColLeft", "addColRight"]], ["delete", ["deleteRow", "deleteCol", "deleteTable"]]],
				air: [["color", ["color"]], ["font", ["bold", "underline", "clear"]], ["para", ["ul", "paragraph"]], ["table", ["table"]], ["insert", ["link", "picture"]]]
			},
			airMode: !1,
			width: null,
			height: null,
			linkTargetBlank: !0,
			focus: !1,
			tabSize: 4,
			styleWithSpan: !0,
			shortcuts: !0,
			textareaAutoSync: !0,
			hintDirection: "bottom",
			tooltip: "auto",
			container: "body",
			maxTextLength: 0,
			blockquoteBreakingLevel: 2,
			styleTags: ["p", "blockquote", "pre", "h1", "h2", "h3", "h4", "h5", "h6"],
			fontNames: ["Arial", "Arial Black", "Comic Sans MS", "Courier New", "Helvetica Neue", "Helvetica", "Impact", "Lucida Grande", "Tahoma", "Times New Roman", "Verdana"],
			fontSizes: ["8", "9", "10", "11", "12", "14", "18", "24", "36"],
			colors: [["#000000", "#424242", "#636363", "#9C9C94", "#CEC6CE", "#EFEFEF", "#F7F7F7", "#FFFFFF"], ["#FF0000", "#FF9C00", "#FFFF00", "#00FF00", "#00FFFF", "#0000FF", "#9C00FF", "#FF00FF"], ["#F7C6CE", "#FFE7CE", "#FFEFC6", "#D6EFD6", "#CEDEE7", "#CEE7F7", "#D6D6E7", "#E7D6DE"], ["#E79C9C", "#FFC69C", "#FFE79C", "#B5D6A5", "#A5C6CE", "#9CC6EF", "#B5A5D6", "#D6A5BD"], ["#E76363", "#F7AD6B", "#FFD663", "#94BD7B", "#73A5AD", "#6BADDE", "#8C7BC6", "#C67BA5"], ["#CE0000", "#E79439", "#EFC631", "#6BA54A", "#4A7B8C", "#3984C6", "#634AA5", "#A54A7B"], ["#9C0000", "#B56308", "#BD9400", "#397B21", "#104A5A", "#085294", "#311873", "#731842"], ["#630000", "#7B3900", "#846300", "#295218", "#083139", "#003163", "#21104A", "#4A1031"]],
			colorsName: [["Black", "Tundora", "Dove Gray", "Star Dust", "Pale Slate", "Gallery", "Alabaster", "White"], ["Red", "Orange Peel", "Yellow", "Green", "Cyan", "Blue", "Electric Violet", "Magenta"], ["Azalea", "Karry", "Egg White", "Zanah", "Botticelli", "Tropical Blue", "Mischka", "Twilight"], ["Tonys Pink", "Peach Orange", "Cream Brulee", "Sprout", "Casper", "Perano", "Cold Purple", "Careys Pink"], ["Mandy", "Rajah", "Dandelion", "Olivine", "Gulf Stream", "Viking", "Blue Marguerite", "Puce"], ["Guardsman Red", "Fire Bush", "Golden Dream", "Chelsea Cucumber", "Smalt Blue", "Boston Blue", "Butterfly Bush", "Cadillac"], ["Sangria", "Mai Tai", "Buddha Gold", "Forest Green", "Eden", "Venice Blue", "Meteorite", "Claret"], ["Rosewood", "Cinnamon", "Olive", "Parsley", "Tiber", "Midnight Blue", "Valentino", "Loulou"]],
			lineHeights: ["1.0", "1.2", "1.4", "1.5", "1.6", "1.8", "2.0", "3.0"],
			tableClassName: "table table-bordered",
			insertTableMaxSize: {col: 10, row: 10},
			dialogsInBody: !1,
			dialogsFade: !1,
			maximumImageFileSize: null,
			callbacks: {onInit: null, onFocus: null, onBlur: null, onBlurCodeview: null, onEnter: null, onKeyup: null, onKeydown: null, onImageUpload: null, onImageUploadError: null, onImageLinkInsert: null},
			codemirror: {mode: "text/html", htmlMode: !0, lineNumbers: !0},
			keyMap: {
				pc: {
					ENTER: "insertParagraph",
					"CTRL+Z": "undo",
					"CTRL+Y": "redo",
					TAB: "tab",
					"SHIFT+TAB": "untab",
					"CTRL+B": "bold",
					"CTRL+I": "italic",
					"CTRL+U": "underline",
					"CTRL+SHIFT+S": "strikethrough",
					"CTRL+BACKSLASH": "removeFormat",
					"CTRL+SHIFT+L": "justifyLeft",
					"CTRL+SHIFT+E": "justifyCenter",
					"CTRL+SHIFT+R": "justifyRight",
					"CTRL+SHIFT+J": "justifyFull",
					"CTRL+SHIFT+NUM7": "insertUnorderedList",
					"CTRL+SHIFT+NUM8": "insertOrderedList",
					"CTRL+LEFTBRACKET": "outdent",
					"CTRL+RIGHTBRACKET": "indent",
					"CTRL+NUM0": "formatPara",
					"CTRL+NUM1": "formatH1",
					"CTRL+NUM2": "formatH2",
					"CTRL+NUM3": "formatH3",
					"CTRL+NUM4": "formatH4",
					"CTRL+NUM5": "formatH5",
					"CTRL+NUM6": "formatH6",
					"CTRL+ENTER": "insertHorizontalRule",
					"CTRL+K": "linkDialog.show"
				},
				mac: {
					ENTER: "insertParagraph",
					"CMD+Z": "undo",
					"CMD+SHIFT+Z": "redo",
					TAB: "tab",
					"SHIFT+TAB": "untab",
					"CMD+B": "bold",
					"CMD+I": "italic",
					"CMD+U": "underline",
					"CMD+SHIFT+S": "strikethrough",
					"CMD+BACKSLASH": "removeFormat",
					"CMD+SHIFT+L": "justifyLeft",
					"CMD+SHIFT+E": "justifyCenter",
					"CMD+SHIFT+R": "justifyRight",
					"CMD+SHIFT+J": "justifyFull",
					"CMD+SHIFT+NUM7": "insertUnorderedList",
					"CMD+SHIFT+NUM8": "insertOrderedList",
					"CMD+LEFTBRACKET": "outdent",
					"CMD+RIGHTBRACKET": "indent",
					"CMD+NUM0": "formatPara",
					"CMD+NUM1": "formatH1",
					"CMD+NUM2": "formatH2",
					"CMD+NUM3": "formatH3",
					"CMD+NUM4": "formatH4",
					"CMD+NUM5": "formatH5",
					"CMD+NUM6": "formatH6",
					"CMD+ENTER": "insertHorizontalRule",
					"CMD+K": "linkDialog.show"
				}
			},
			icons: {
				align: "note-icon-align",
				alignCenter: "note-icon-align-center",
				alignJustify: "note-icon-align-justify",
				alignLeft: "note-icon-align-left",
				alignRight: "note-icon-align-right",
				rowBelow: "note-icon-row-below",
				colBefore: "note-icon-col-before",
				colAfter: "note-icon-col-after",
				rowAbove: "note-icon-row-above",
				rowRemove: "note-icon-row-remove",
				colRemove: "note-icon-col-remove",
				indent: "note-icon-align-indent",
				outdent: "note-icon-align-outdent",
				arrowsAlt: "note-icon-arrows-alt",
				bold: "note-icon-bold",
				caret: "note-icon-caret",
				circle: "note-icon-circle",
				close: "note-icon-close",
				code: "note-icon-code",
				eraser: "note-icon-eraser",
				font: "note-icon-font",
				frame: "note-icon-frame",
				italic: "note-icon-italic",
				link: "note-icon-link",
				unlink: "note-icon-chain-broken",
				magic: "note-icon-magic",
				menuCheck: "note-icon-menu-check",
				minus: "note-icon-minus",
				orderedlist: "note-icon-orderedlist",
				pencil: "note-icon-pencil",
				picture: "note-icon-picture",
				question: "note-icon-question",
				redo: "note-icon-redo",
				square: "note-icon-square",
				strikethrough: "note-icon-strikethrough",
				subscript: "note-icon-subscript",
				superscript: "note-icon-superscript",
				table: "note-icon-table",
				textHeight: "note-icon-text-height",
				trash: "note-icon-trash",
				underline: "note-icon-underline",
				undo: "note-icon-undo",
				unorderedlist: "note-icon-unorderedlist",
				video: "note-icon-video"
			}
		}
	})
}), function (t) {
	var e = t.Markdown = function (t) {
		switch (typeof t) {
			case"undefined":
				this.dialect = e.dialects.Gruber;
				break;
			case"object":
				this.dialect = t;
				break;
			default:
				if (!(t in e.dialects)) throw new Error("Unknown Markdown dialect '" + String(t) + "'");
				this.dialect = e.dialects[t]
		}
		this.em_state = [], this.strong_state = [], this.debug_indent = ""
	};

	function i() {
		return "Markdown.mk_block( " + uneval(this.toString()) + ", " + uneval(this.trailing) + ", " + uneval(this.lineNumber) + " )"
	}

	function n() {
		var t = require("util");
		return "Markdown.mk_block( " + t.inspect(this.toString()) + ", " + t.inspect(this.trailing) + ", " + t.inspect(this.lineNumber) + " )"
	}

	t.parse = function (t, i) {
		return new e(i).toTree(t)
	}, t.toHTML = function (e, i, n) {
		var r = t.toHTMLTree(e, i, n);
		return t.renderJsonML(r)
	}, t.toHTMLTree = function (t, e, i) {
		"string" == typeof t && (t = this.parse(t, e));
		var n = h(t), r = {};
		n && n.references && (r = n.references);
		var o = function t(e, i, n) {
			var r;
			n = n || {};
			var o = e.slice(0);
			"function" == typeof n.preprocessTreeNode && (o = n.preprocessTreeNode(o, i));
			var a = h(o);
			if (a) {
				for (r in o[1] = {}, a) o[1][r] = a[r];
				a = o[1]
			}
			if ("string" == typeof o) return o;
			switch (o[0]) {
				case"header":
					o[0] = "h" + o[1].level, delete o[1].level;
					break;
				case"bulletlist":
					o[0] = "ul";
					break;
				case"numberlist":
					o[0] = "ol";
					break;
				case"listitem":
					o[0] = "li";
					break;
				case"para":
					o[0] = "p";
					break;
				case"markdown":
					o[0] = "html", a && delete a.references;
					break;
				case"code_block":
					o[0] = "pre", r = a ? 2 : 1;
					var s = ["code"];
					s.push.apply(s, o.splice(r, o.length - r)), o[r] = s;
					break;
				case"inlinecode":
					o[0] = "code";
					break;
				case"img":
					o[1].src = o[1].href, delete o[1].href;
					break;
				case"linebreak":
					o[0] = "br";
					break;
				case"link":
					o[0] = "a";
					break;
				case"link_ref":
					o[0] = "a";
					var l = i[a.ref];
					if (!l) return a.original;
					delete a.ref, a.href = l.href, l.title && (a.title = l.title), delete a.original;
					break;
				case"img_ref":
					o[0] = "img";
					var l = i[a.ref];
					if (!l) return a.original;
					delete a.ref, a.src = l.href, l.title && (a.title = l.title), delete a.original
			}
			r = 1;
			if (a) {
				for (var c in o[1]) {
					r = 2;
					break
				}
				1 === r && o.splice(r, 1)
			}
			for (; r < o.length; ++r) o[r] = t(o[r], i, n);
			return o
		}(t, r, i);
		return function t(e) {
			var i = h(e) ? 2 : 1;
			for (; i < e.length;) "string" == typeof e[i] ? i + 1 < e.length && "string" == typeof e[i + 1] ? e[i] += e.splice(i + 1, 1)[0] : ++i : (t(e[i]), ++i)
		}(o), o
	};
	var r = e.mk_block = function (t, e, r) {
		1 == arguments.length && (e = "\n\n");
		var o = new String(t);
		return o.trailing = e, o.inspect = n, o.toSource = i, null != r && (o.lineNumber = r), o
	};

	function o(t) {
		for (var e = 0, i = -1; -1 !== (i = t.indexOf("\n", i + 1));) e++;
		return e
	}

	function s(t, e) {
		var i = t + "_state", n = "strong" == t ? "em_state" : "strong_state";

		function r(t) {
			this.len_after = t, this.name = "close_" + e
		}

		return function (o, a) {
			if (this[i][0] == e) return this[i].shift(), [o.length, new r(o.length - e.length)];
			var s = this[n].slice(), l = this[i].slice();
			this[i].unshift(e);
			var c = this.processInline(o.substr(e.length)), u = c[c.length - 1];
			this[i].shift();
			return u instanceof r ? (c.pop(), [o.length - u.len_after, [t].concat(c)]) : (this[n] = s, this[i] = l, [e.length, e])
		}
	}

	e.prototype.split_blocks = function (t, e) {
		t = t.replace(/(\r\n|\n|\r)/g, "\n");
		var i, n = /([\s\S]+?)($|\n#|\n(?:\s*\n|$)+)/g, a = [], s = 1;
		for (null != (i = /^(\s*\n)/.exec(t)) && (s += o(i[0]), n.lastIndex = i[0].length); null !== (i = n.exec(t));) "\n#" == i[2] && (i[2] = "\n", n.lastIndex--), a.push(r(i[1], i[2], s)), s += o(i[0]);
		return a
	}, e.prototype.processBlock = function (t, e) {
		var i = this.dialect.block, n = i.__order__;
		if ("__call__" in i) return i.__call__.call(this, t, e);
		for (var r = 0; r < n.length; r++) {
			var o = i[n[r]].call(this, t, e);
			if (o) return (!c(o) || o.length > 0 && !c(o[0])) && this.debug(n[r], "didn't return a proper array"), o
		}
		return []
	}, e.prototype.processInline = function (t) {
		return this.dialect.inline.__call__.call(this, String(t))
	}, e.prototype.toTree = function (t, e) {
		var i = t instanceof Array ? t : this.split_blocks(t), n = this.tree;
		try {
			for (this.tree = e || this.tree || ["markdown"]; i.length;) {
				var r = this.processBlock(i.shift(), i);
				r.length && this.tree.push.apply(this.tree, r)
			}
			return this.tree
		} finally {
			e && (this.tree = n)
		}
	}, e.prototype.debug = function () {
		var t = Array.prototype.slice.call(arguments);
		t.unshift(this.debug_indent), "undefined" != typeof print && print.apply(print, t), "undefined" != typeof console && void 0 !== console.log && console.log.apply(null, t)
	}, e.prototype.loop_re_over_block = function (t, e, i) {
		for (var n, r = e.valueOf(); r.length && null != (n = t.exec(r));) r = r.substr(n[0].length), i.call(this, n);
		return r
	}, e.dialects = {}, e.dialects.Gruber = {
		block: {
			atxHeader: function (t, e) {
				var i = t.match(/^(#{1,6})\s*(.*?)\s*#*\s*(?:\n|$)/);
				if (i) {
					var n = ["header", {level: i[1].length}];
					return Array.prototype.push.apply(n, this.processInline(i[2])), i[0].length < t.length && e.unshift(r(t.substr(i[0].length), t.trailing, t.lineNumber + 2)), [n]
				}
			}, setextHeader: function (t, e) {
				var i = t.match(/^(.*)\n([-=])\2\2+(?:\n|$)/);
				if (i) {
					var n = ["header", {level: "=" === i[2] ? 1 : 2}, i[1]];
					return i[0].length < t.length && e.unshift(r(t.substr(i[0].length), t.trailing, t.lineNumber + 2)), [n]
				}
			}, code: function (t, e) {
				var i = [], n = /^(?: {0,3}\t| {4})(.*)\n?/;
				if (t.match(n)) {
					t:for (; ;) {
						var o = this.loop_re_over_block(n, t.valueOf(), function (t) {
							i.push(t[1])
						});
						if (o.length) {
							e.unshift(r(o, t.trailing));
							break t
						}
						if (!e.length) break t;
						if (!e[0].match(n)) break t;
						i.push(t.trailing.replace(/[^\n]/g, "").substring(2)), t = e.shift()
					}
					return [["code_block", i.join("\n")]]
				}
			}, horizRule: function (t, e) {
				var i = t.match(/^(?:([\s\S]*?)\n)?[ \t]*([-_*])(?:[ \t]*\2){2,}[ \t]*(?:\n([\s\S]*))?$/);
				if (i) {
					var n = [["hr"]];
					return i[1] && n.unshift.apply(n, this.processBlock(i[1], [])), i[3] && e.unshift(r(i[3])), n
				}
			}, lists: function () {
				var t = "[*+-]|\\d+\\.", e = /[*+-]/, i = new RegExp("^( {0,3})(" + t + ")[ \t]+"), n = "(?: {0,3}\\t| {4})";

				function o(t, e, i, n) {
					if (e) t.push(["para"].concat(i)); else {
						var r = t[t.length - 1] instanceof Array && "para" == t[t.length - 1][0] ? t[t.length - 1] : t;
						n && t.length > 1 && i.unshift(n);
						for (var o = 0; o < i.length; o++) {
							var a = i[o];
							"string" == typeof a && r.length > 1 && "string" == typeof r[r.length - 1] ? r[r.length - 1] += a : r.push(a)
						}
					}
				}

				function a(t, e) {
					for (var i = new RegExp("^(" + n + "{" + t + "}.*?\\n?)*$"), o = new RegExp("^" + n + "{" + t + "}", "gm"), a = []; e.length > 0 && i.exec(e[0]);) {
						var s = e.shift(), l = s.replace(o, "");
						a.push(r(l, s.trailing, s.lineNumber))
					}
					return a
				}

				function s(t, e, i) {
					var n = t.list, r = n[n.length - 1];
					if (!(r[1] instanceof Array && "para" == r[1][0])) if (e + 1 == i.length) r.push(["para"].concat(r.splice(1, r.length - 1))); else {
						var o = r.pop();
						r.push(["para"].concat(r.splice(1, r.length - 1)), o)
					}
				}

				return function (r, c) {
					var u = r.match(i);
					if (u) {
						for (var h, d, p, f = [], m = E(u), g = !1, v = [f[0].list]; ;) {
							for (var y = r.split(/(?=\n)/), b = "", w = 0; w < y.length; w++) {
								var x = "", k = y[w].replace(/^\n/, function (t) {
									return x = t, ""
								}), _ = (p = f.length, new RegExp("(?:^(" + n + "{0," + p + "} {0,3})(" + t + ")\\s+)|(^" + n + "{0," + (p - 1) + "}[ ]{0,4})"));
								if (void 0 !== (u = k.match(_))[1]) {
									b.length && (o(h, g, this.processInline(b), x), g = !1, b = ""), u[1] = u[1].replace(/ {0,3}\t/g, "    ");
									var S = Math.floor(u[1].length / 4) + 1;
									if (S > f.length) m = E(u), h.push(m), h = m[1] = ["listitem"]; else {
										var C = !1;
										for (d = 0; d < f.length; d++) if (f[d].indent == u[1]) {
											m = f[d].list, f.splice(d + 1, f.length - (d + 1)), C = !0;
											break
										}
										C || (++S <= f.length ? (f.splice(S, f.length - S), m = f[S - 1].list) : (m = E(u), h.push(m))), h = ["listitem"], m.push(h)
									}
									x = ""
								}
								k.length > u[0].length && (b += x + k.substr(u[0].length))
							}
							b.length && (o(h, g, this.processInline(b), x), g = !1, b = "");
							var D = a(f.length, c);
							D.length > 0 && (l(f, s, this), h.push.apply(h, this.toTree(D, [])));
							var T = c[0] && c[0].valueOf() || "";
							if (!T.match(i) && !T.match(/^ /)) break;
							r = c.shift();
							var M = this.dialect.block.horizRule(r, c);
							if (M) {
								v.push.apply(v, M);
								break
							}
							l(f, s, this), g = !0
						}
						return v
					}

					function E(t) {
						var i = e.exec(t[2]) ? ["bulletlist"] : ["numberlist"];
						return f.push({list: i, indent: t[1]}), i
					}
				}
			}(), blockquote: function (t, e) {
				if (t.match(/^>/m)) {
					var i = [];
					if (">" != t[0]) {
						for (var n = t.split(/\n/), o = [], a = t.lineNumber; n.length && ">" != n[0][0];) o.push(n.shift()), a++;
						var s = r(o.join("\n"), "\n", t.lineNumber);
						i.push.apply(i, this.processBlock(s, [])), t = r(n.join("\n"), t.trailing, a)
					}
					for (; e.length && ">" == e[0][0];) {
						var l = e.shift();
						t = r(t + t.trailing + l, l.trailing, t.lineNumber)
					}
					var c = t.replace(/^> ?/gm, ""), d = (this.tree, this.toTree(c, ["blockquote"])), p = h(d);
					return p && p.references && (delete p.references, u(p) && d.splice(1, 1)), i.push(d), i
				}
			}, referenceDefn: function (t, e) {
				var i = /^\s*\[(.*?)\]:\s*(\S+)(?:\s+(?:(['"])(.*?)\3|\((.*?)\)))?\n?/;
				if (t.match(i)) {
					h(this.tree) || this.tree.splice(1, 0, {});
					var n = h(this.tree);
					void 0 === n.references && (n.references = {});
					var o = this.loop_re_over_block(i, t, function (t) {
						t[2] && "<" == t[2][0] && ">" == t[2][t[2].length - 1] && (t[2] = t[2].substring(1, t[2].length - 1));
						var e = n.references[t[1].toLowerCase()] = {href: t[2]};
						void 0 !== t[4] ? e.title = t[4] : void 0 !== t[5] && (e.title = t[5])
					});
					return o.length && e.unshift(r(o, t.trailing)), []
				}
			}, para: function (t, e) {
				return [["para"].concat(this.processInline(t))]
			}
		}
	}, e.dialects.Gruber.inline = {
		__oneElement__: function (t, e, i) {
			var n, r;
			return e = e || this.dialect.inline.__patterns__, (n = new RegExp("([\\s\\S]*?)(" + (e.source || e) + ")").exec(t)) ? n[1] ? [n[1].length, n[1]] : (n[2] in this.dialect.inline && (r = this.dialect.inline[n[2]].call(this, t.substr(n.index), n, i || [])), r = r || [n[2].length, n[2]]) : [t.length, t]
		}, __call__: function (t, e) {
			var i, n = [];

			function r(t) {
				"string" == typeof t && "string" == typeof n[n.length - 1] ? n[n.length - 1] += t : n.push(t)
			}

			for (; t.length > 0;) i = this.dialect.inline.__oneElement__.call(this, t, e, n), t = t.substr(i.shift()), l(i, r);
			return n
		}, "]": function () {
		}, "}": function () {
		}, __escape__: /^\\[\\`\*_{}\[\]()#\+.!\-]/, "\\": function (t) {
			return this.dialect.inline.__escape__.exec(t) ? [2, t.charAt(1)] : [1, "\\"]
		}, "![": function (t) {
			var e = t.match(/^!\[(.*?)\][ \t]*\([ \t]*([^")]*?)(?:[ \t]+(["'])(.*?)\3)?[ \t]*\)/);
			if (e) {
				e[2] && "<" == e[2][0] && ">" == e[2][e[2].length - 1] && (e[2] = e[2].substring(1, e[2].length - 1)), e[2] = this.dialect.inline.__call__.call(this, e[2], /\\/)[0];
				var i = {alt: e[1], href: e[2] || ""};
				return void 0 !== e[4] && (i.title = e[4]), [e[0].length, ["img", i]]
			}
			return (e = t.match(/^!\[(.*?)\][ \t]*\[(.*?)\]/)) ? [e[0].length, ["img_ref", {alt: e[1], ref: e[2].toLowerCase(), original: e[0]}]] : [2, "!["]
		}, "[": function (t) {
			var i = String(t), n = e.DialectHelpers.inline_until_char.call(this, t.substr(1), "]");
			if (!n) return [1, "["];
			var r, o, a = 1 + n[0], s = n[1], l = (t = t.substr(a)).match(/^\s*\([ \t]*([^"']*)(?:[ \t]+(["'])(.*?)\2)?[ \t]*\)/);
			if (l) {
				var c = l[1];
				if (a += l[0].length, c && "<" == c[0] && ">" == c[c.length - 1] && (c = c.substring(1, c.length - 1)), !l[3]) for (var u = 1, h = 0; h < c.length; h++) switch (c[h]) {
					case"(":
						u++;
						break;
					case")":
						0 == --u && (a -= c.length - h, c = c.substring(0, h))
				}
				return o = {href: (c = this.dialect.inline.__call__.call(this, c, /\\/)[0]) || ""}, void 0 !== l[3] && (o.title = l[3]), r = ["link", o].concat(s), [a, r]
			}
			return (l = t.match(/^\s*\[(.*?)\]/)) ? (a += l[0].length, r = ["link_ref", o = {ref: (l[1] || String(s)).toLowerCase(), original: i.substr(0, a)}].concat(s), [a, r]) : 1 == s.length && "string" == typeof s[0] ? (r = ["link_ref", o = {
				ref: s[0].toLowerCase(),
				original: i.substr(0, a)
			}, s[0]], [a, r]) : [1, "["]
		}, "<": function (t) {
			var e;
			return null != (e = t.match(/^<(?:((https?|ftp|mailto):[^>]+)|(.*?@.*?\.[a-zA-Z]+))>/)) ? e[3] ? [e[0].length, ["link", {href: "mailto:" + e[3]}, e[3]]] : "mailto" == e[2] ? [e[0].length, ["link", {href: e[1]}, e[1].substr("mailto:".length)]] : [e[0].length, ["link", {href: e[1]}, e[1]]] : [1, "<"]
		}, "`": function (t) {
			var e = t.match(/(`+)(([\s\S]*?)\1)/);
			return e && e[2] ? [e[1].length + e[2].length, ["inlinecode", e[3]]] : [1, "`"]
		}, "  \n": function (t) {
			return [3, ["linebreak"]]
		}
	}, e.dialects.Gruber.inline["**"] = s("strong", "**"), e.dialects.Gruber.inline.__ = s("strong", "__"), e.dialects.Gruber.inline["*"] = s("em", "*"), e.dialects.Gruber.inline._ = s("em", "_"), e.buildBlockOrder = function (t) {
		var e = [];
		for (var i in t) "__order__" != i && "__call__" != i && e.push(i);
		t.__order__ = e
	}, e.buildInlinePatterns = function (t) {
		var e = [];
		for (var i in t) if (!i.match(/^__.*__$/)) {
			var n = i.replace(/([\\.*+?|()\[\]{}])/g, "\\$1").replace(/\n/, "\\n");
			e.push(1 == i.length ? n : "(?:" + n + ")")
		}
		e = e.join("|"), t.__patterns__ = e;
		var r = t.__call__;
		t.__call__ = function (t, i) {
			return null != i ? r.call(this, t, i) : r.call(this, t, e)
		}
	}, e.DialectHelpers = {}, e.DialectHelpers.inline_until_char = function (t, e) {
		for (var i = 0, n = []; ;) {
			if (t.charAt(i) == e) return [++i, n];
			if (i >= t.length) return null;
			var r = this.dialect.inline.__oneElement__.call(this, t.substr(i));
			i += r[0], n.push.apply(n, r.slice(1))
		}
	}, e.subclassDialect = function (t) {
		function e() {
		}

		function i() {
		}

		return e.prototype = t.block, i.prototype = t.inline, {block: new e, inline: new i}
	}, e.buildBlockOrder(e.dialects.Gruber.block), e.buildInlinePatterns(e.dialects.Gruber.inline), e.dialects.Maruku = e.subclassDialect(e.dialects.Gruber), e.dialects.Maruku.processMetaHash = function (t) {
		for (var e = function (t) {
			var e = t.split(""), i = [""], n = !1;
			for (; e.length;) {
				var r = e.shift();
				switch (r) {
					case" ":
						n ? i[i.length - 1] += r : i.push("");
						break;
					case"'":
					case'"':
						n = !n;
						break;
					case"\\":
						r = e.shift();
					default:
						i[i.length - 1] += r
				}
			}
			return i
		}(t), i = {}, n = 0; n < e.length; ++n) if (/^#/.test(e[n])) i.id = e[n].substring(1); else if (/^\./.test(e[n])) i.class ? i.class = i.class + e[n].replace(/./, " ") : i.class = e[n].substring(1); else if (/\=/.test(e[n])) {
			var r = e[n].split(/\=/);
			i[r[0]] = r[1]
		}
		return i
	}, e.dialects.Maruku.block.document_meta = function (t, e) {
		if (!(t.lineNumber > 1) && t.match(/^(?:\w+:.*\n)*\w+:.*$/)) {
			h(this.tree) || this.tree.splice(1, 0, {});
			var i = t.split(/\n/);
			for (p in i) {
				var n = i[p].match(/(\w+):\s*(.*)$/), r = n[1].toLowerCase(), o = n[2];
				this.tree[1][r] = o
			}
			return []
		}
	}, e.dialects.Maruku.block.block_meta = function (t, e) {
		var i = t.match(/(^|\n) {0,3}\{:\s*((?:\\\}|[^\}])*)\s*\}$/);
		if (i) {
			var n, r = this.dialect.processMetaHash(i[2]);
			if ("" === i[1]) {
				var o = this.tree[this.tree.length - 1];
				if (n = h(o), "string" == typeof o) return;
				for (a in n || (n = {}, o.splice(1, 0, n)), r) n[a] = r[a];
				return []
			}
			var s = t.replace(/\n.*$/, ""), l = this.processBlock(s, []);
			for (a in(n = h(l[0])) || (n = {}, l[0].splice(1, 0, n)), r) n[a] = r[a];
			return l
		}
	}, e.dialects.Maruku.block.definition_list = function (t, e) {
		var i, n = /^((?:[^\s:].*\n)+):\s+([\s\S]+)$/, r = ["dl"];
		if (s = t.match(n)) {
			for (var o = [t]; e.length && n.exec(e[0]);) o.push(e.shift());
			for (var a = 0; a < o.length; ++a) {
				var s, l = (s = o[a].match(n))[1].replace(/\n$/, "").split(/\n/), c = s[2].split(/\n:\s+/);
				for (i = 0; i < l.length; ++i) r.push(["dt", l[i]]);
				for (i = 0; i < c.length; ++i) r.push(["dd"].concat(this.processInline(c[i].replace(/(\n)\s+/, "$1"))))
			}
			return [r]
		}
	}, e.dialects.Maruku.block.table = function (t, e) {
		var i, n, r = function (t, e) {
			(e = e || "\\s").match(/^[\\|\[\]{}?*.+^$]$/) && (e = "\\" + e);
			for (var i, n = [], r = new RegExp("^((?:\\\\.|[^\\\\" + e + "])*)" + e + "(.*)"); i = t.match(r);) n.push(i[1]), t = i[2];
			return n.push(t), n
		};
		if (n = t.match(/^ {0,3}\|(.+)\n {0,3}\|\s*([\-:]+[\-| :]*)\n((?:\s*\|.*(?:\n|$))*)(?=\n|$)/)) n[3] = n[3].replace(/^\s*\|/gm, ""); else if (!(n = t.match(/^ {0,3}(\S(?:\\.|[^\\|])*\|.*)\n {0,3}([\-:]+\s*\|[\-| :]*)\n((?:(?:\\.|[^\\|])*\|.*(?:\n|$))*)(?=\n|$)/))) return;
		var o = ["table", ["thead", ["tr"]], ["tbody"]];
		n[2] = n[2].replace(/\|\s*$/, "").split("|");
		var a = [];
		for (l(n[2], function (t) {
			t.match(/^\s*-+:\s*$/) ? a.push({align: "right"}) : t.match(/^\s*:-+\s*$/) ? a.push({align: "left"}) : t.match(/^\s*:-+:\s*$/) ? a.push({align: "center"}) : a.push({})
		}), n[1] = r(n[1].replace(/\|\s*$/, ""), "|"), i = 0; i < n[1].length; i++) o[1][1].push(["th", a[i] || {}].concat(this.processInline(n[1][i].trim())));
		return l(n[3].replace(/\|\s*$/gm, "").split("\n"), function (t) {
			var e = ["tr"];
			for (t = r(t, "|"), i = 0; i < t.length; i++) e.push(["td", a[i] || {}].concat(this.processInline(t[i].trim())));
			o[2].push(e)
		}, this), [o]
	}, e.dialects.Maruku.inline["{:"] = function (t, e, i) {
		if (!i.length) return [2, "{:"];
		var n = i[i.length - 1];
		if ("string" == typeof n) return [2, "{:"];
		var r = t.match(/^\{:\s*((?:\\\}|[^\}])*)\s*\}/);
		if (!r) return [2, "{:"];
		var o = this.dialect.processMetaHash(r[1]), a = h(n);
		for (var s in a || (a = {}, n.splice(1, 0, a)), o) a[s] = o[s];
		return [r[0].length, ""]
	}, e.dialects.Maruku.inline.__escape__ = /^\\[\\`\*_{}\[\]()#\+.!\-|:]/, e.buildBlockOrder(e.dialects.Maruku.block), e.buildInlinePatterns(e.dialects.Maruku.inline);
	var l, c = Array.isArray || function (t) {
		return "[object Array]" == Object.prototype.toString.call(t)
	};
	l = Array.prototype.forEach ? function (t, e, i) {
		return t.forEach(e, i)
	} : function (t, e, i) {
		for (var n = 0; n < t.length; n++) e.call(i || t, t[n], n, t)
	};
	var u = function (t) {
		for (var e in t) if (hasOwnProperty.call(t, e)) return !1;
		return !0
	};

	function h(t) {
		return c(t) && t.length > 1 && "object" == typeof t[1] && !c(t[1]) ? t[1] : void 0
	}

	function d(t) {
		return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;")
	}

	function f(t) {
		if ("string" == typeof t) return d(t);
		var e = t.shift(), i = {}, n = [];
		for (!t.length || "object" != typeof t[0] || t[0] instanceof Array || (i = t.shift()); t.length;) n.push(f(t.shift()));
		var r = "";
		for (var o in i) r += " " + o + '="' + d(i[o]) + '"';
		return "img" == e || "br" == e || "hr" == e ? "<" + e + r + "/>" : "<" + e + r + ">" + n.join("") + "</" + e + ">"
	}

	t.renderJsonML = function (t, e) {
		(e = e || {}).root = e.root || !1;
		var i = [];
		if (e.root) i.push(f(t)); else for (t.shift(), !t.length || "object" != typeof t[0] || t[0] instanceof Array || t.shift(); t.length;) i.push(f(t.shift()));
		return i.join("\n\n")
	}
}("undefined" == typeof exports ? (window.markdown = {}, window.markdown) : exports), function (t) {
	"function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? t(require("jquery")) : t(jQuery)
}(function (t) {
	"use strict";
	var e = function (e, i) {
		t.each(["autofocus", "savable", "hideable", "width", "height", "resize", "iconlibrary", "language", "footer", "fullscreen", "hiddenButtons", "disabledButtons"], function (n, r) {
			void 0 !== t(e).data(r) && ((i = "object" == typeof i ? i : {})[r] = t(e).data(r))
		}), this.$ns = "bootstrap-markdown", this.$element = t(e), this.$editable = {
			el: null,
			type: null,
			attrKeys: [],
			attrValues: [],
			content: null
		}, this.$options = t.extend(!0, {}, t.fn.markdown.defaults, i, this.$element.data("options")), this.$oldContent = null, this.$isPreview = !1, this.$isFullscreen = !1, this.$editor = null, this.$textarea = null, this.$handler = [], this.$callback = [], this.$nextTab = [], this.showEditor()
	};
	e.prototype = {
		constructor: e, __alterButtons: function (e, i) {
			var n = this.$handler, r = "all" == e, o = this;
			t.each(n, function (t, n) {
				!1 === (!r && n.indexOf(e) < 0) && i(o.$editor.find('button[data-handler="' + n + '"]'))
			})
		}, __buildButtons: function (e, i) {
			var n, r = this.$ns, o = this.$handler, a = this.$callback;
			for (n = 0; n < e.length; n++) {
				var s, l = e[n];
				for (s = 0; s < l.length; s++) {
					var c, u = l[s].data, h = t("<div/>", {class: "btn-group"});
					for (c = 0; c < u.length; c++) {
						var d, p, f = u[c], m = r + "-" + f.name, g = this.__getIcon(f.icon), v = f.btnText ? f.btnText : "", y = f.btnClass ? f.btnClass : "btn", b = f.tabIndex ? f.tabIndex : "-1", w = void 0 !== f.hotkey ? f.hotkey : "", x = void 0 !== jQuery.hotkeys && "" !== w ? " (" + w + ")" : "";
						(d = t("<button></button>")).text(" " + this.__localize(v)).addClass("btn-default btn-sm").addClass(y), y.match(/btn\-(primary|success|info|warning|danger|link)/) && d.removeClass("btn-default"), d.attr({
							type: "button",
							title: this.__localize(f.title) + x,
							tabindex: b,
							"data-provider": r,
							"data-handler": m,
							"data-hotkey": w
						}), !0 === f.toggle && d.attr("data-toggle", "button"), (p = t("<span/>")).addClass(g), p.prependTo(d), h.append(d), o.push(m), a.push(f.callback)
					}
					i.append(h)
				}
			}
			return i
		}, __setListener: function () {
			var e = void 0 !== this.$textarea.attr("rows"), i = this.$textarea.val().split("\n").length > 5 ? this.$textarea.val().split("\n").length : "5", n = e ? this.$textarea.attr("rows") : i;
			this.$textarea.attr("rows", n), this.$options.resize && this.$textarea.css("resize", this.$options.resize), this.$textarea.on({
				focus: t.proxy(this.focus, this),
				keyup: t.proxy(this.keyup, this),
				change: t.proxy(this.change, this),
				select: t.proxy(this.select, this)
			}), this.eventSupported("keydown") && this.$textarea.on("keydown", t.proxy(this.keydown, this)), this.eventSupported("keypress") && this.$textarea.on("keypress", t.proxy(this.keypress, this)), this.$textarea.data("markdown", this)
		}, __handle: function (e) {
			var i = t(e.currentTarget), n = this.$handler, r = this.$callback, o = i.attr("data-handler"), a = r[n.indexOf(o)];
			t(e.currentTarget).focus(), a(this), this.change(this), o.indexOf("cmdSave") < 0 && this.$textarea.focus(), e.preventDefault()
		}, __localize: function (e) {
			var i = t.fn.markdown.messages, n = this.$options.language;
			return void 0 !== i && void 0 !== i[n] && void 0 !== i[n][e] ? i[n][e] : e
		}, __getIcon: function (t) {
			return "object" == typeof t ? t[this.$options.iconlibrary] : t
		}, setFullscreen: function (e) {
			var i = this.$editor, n = this.$textarea;
			!0 === e ? (i.addClass("md-fullscreen-mode"), t("body").addClass("md-nooverflow"), this.$options.onFullscreen(this)) : (i.removeClass("md-fullscreen-mode"), t("body").removeClass("md-nooverflow"), 1 == this.$isPreview && this.hidePreview().showPreview()), this.$isFullscreen = e, n.focus()
		}, showEditor: function () {
			var e, i = this, n = this.$ns, r = this.$element, o = (r.css("height"), r.css("width"), this.$editable), a = this.$handler, s = this.$callback, l = this.$options, c = t("<div/>", {
				class: "md-editor", click: function () {
					i.focus()
				}
			});
			if (null === this.$editor) {
				var u = t("<div/>", {class: "md-header btn-toolbar"}), h = [];
				if (l.buttons.length > 0 && (h = h.concat(l.buttons[0])), l.additionalButtons.length > 0 && t.each(l.additionalButtons[0], function (e, i) {
					var n = t.grep(h, function (t, e) {
						return t.name === i.name
					});
					n.length > 0 ? n[0].data = n[0].data.concat(i.data) : h.push(l.additionalButtons[0][e])
				}), l.reorderButtonGroups.length > 0 && (h = h.filter(function (t) {
					return l.reorderButtonGroups.indexOf(t.name) > -1
				}).sort(function (t, e) {
					return l.reorderButtonGroups.indexOf(t.name) < l.reorderButtonGroups.indexOf(e.name) ? -1 : l.reorderButtonGroups.indexOf(t.name) > l.reorderButtonGroups.indexOf(e.name) ? 1 : 0
				})), h.length > 0 && (u = this.__buildButtons([h], u)), l.fullscreen.enable && u.append('<div class="md-controls"><a class="md-control md-control-fullscreen" href="#"><span class="' + this.__getIcon(l.fullscreen.icons.fullscreenOn) + '"></span></a></div>').on("click", ".md-control-fullscreen", function (t) {
					t.preventDefault(), i.setFullscreen(!0)
				}), c.append(u), r.is("textarea")) r.before(c), (e = r).addClass("md-input"), c.append(e); else {
					var d = "function" == typeof toMarkdown ? toMarkdown(r.html()) : r.html(), p = t.trim(d);
					e = t("<textarea/>", {class: "md-input", val: p}), c.append(e), o.el = r, o.type = r.prop("tagName").toLowerCase(), o.content = r.html(), t(r[0].attributes).each(function () {
						o.attrKeys.push(this.nodeName), o.attrValues.push(this.nodeValue)
					}), r.replaceWith(c)
				}
				var f, m = t("<div/>", {class: "md-footer"}), g = !1;
				if (l.savable) {
					g = !0;
					a.push("cmdSave"), s.push(l.onSave), m.append('<button class="btn btn-success" data-provider="' + n + '" data-handler="cmdSave"><i class="icon icon-white icon-ok"></i> ' + this.__localize("Save") + "</button>")
				}
				if (f = "function" == typeof l.footer ? l.footer(this) : l.footer, "" !== t.trim(f) && (g = !0, m.append(f)), g && c.append(m), l.width && "inherit" !== l.width && (jQuery.isNumeric(l.width) ? (c.css("display", "table"), e.css("width", l.width + "px")) : c.addClass(l.width)), l.height && "inherit" !== l.height) if (jQuery.isNumeric(l.height)) {
					var v = l.height;
					u && (v = Math.max(0, v - u.outerHeight())), m && (v = Math.max(0, v - m.outerHeight())), e.css("height", v + "px")
				} else c.addClass(l.height);
				this.$editor = c, this.$textarea = e, this.$editable = o, this.$oldContent = this.getContent(), this.__setListener(), this.$editor.attr("id", (new Date).getTime()), this.$editor.on("click", '[data-provider="bootstrap-markdown"]', t.proxy(this.__handle, this)), (this.$element.is(":disabled") || this.$element.is("[readonly]")) && (this.$editor.addClass("md-editor-disabled"), this.disableButtons("all")), this.eventSupported("keydown") && "object" == typeof jQuery.hotkeys && u.find('[data-provider="bootstrap-markdown"]').each(function () {
					var i = t(this), n = i.attr("data-hotkey");
					"" !== n.toLowerCase() && e.bind("keydown", n, function () {
						return i.trigger("click"), !1
					})
				}), "preview" === l.initialstate ? this.showPreview() : "fullscreen" === l.initialstate && l.fullscreen.enable && this.setFullscreen(!0)
			} else this.$editor.show();
			return l.autofocus && (this.$textarea.focus(), this.$editor.addClass("active")), l.fullscreen.enable && !1 !== l.fullscreen && (this.$editor.append('<div class="md-fullscreen-controls"><a href="#" class="exit-fullscreen" title="Exit fullscreen"><span class="' + this.__getIcon(l.fullscreen.icons.fullscreenOff) + '"></span></a></div>'), this.$editor.on("click", ".exit-fullscreen", function (t) {
				t.preventDefault(), i.setFullscreen(!1)
			})), this.hideButtons(l.hiddenButtons), this.disableButtons(l.disabledButtons), l.onShow(this), this
		}, parseContent: function (t) {
			t = t || this.$textarea.val();
			return this.$options.parser ? this.$options.parser(t) : "object" == typeof markdown ? markdown.toHTML(t) : "function" == typeof marked ? marked(t) : t
		}, showPreview: function () {
			var e, i, n = this.$options, r = this.$textarea, o = r.next(), a = t("<div/>", {class: "md-preview", "data-provider": "markdown-preview"});
			return 1 == this.$isPreview ? this : (this.$isPreview = !0, this.disableButtons("all").enableButtons("cmdPreview"), e = "string" == typeof (i = n.onPreview(this)) ? i : this.parseContent(), a.html(e), o && "md-footer" == o.attr("class") ? a.insertBefore(o) : r.parent().append(a), a.css({
				width: r.outerWidth() + "px",
				height: r.outerHeight() + "px"
			}), this.$options.resize && a.css("resize", this.$options.resize), r.hide(), a.data("markdown", this), (this.$element.is(":disabled") || this.$element.is("[readonly]")) && (this.$editor.addClass("md-editor-disabled"), this.disableButtons("all")), this)
		}, hidePreview: function () {
			return this.$isPreview = !1, this.$editor.find('div[data-provider="markdown-preview"]').remove(), this.enableButtons("all"), this.disableButtons(this.$options.disabledButtons), this.$textarea.show(), this.__setListener(), this
		}, isDirty: function () {
			return this.$oldContent != this.getContent()
		}, getContent: function () {
			return this.$textarea.val()
		}, setContent: function (t) {
			return this.$textarea.val(t), this
		}, findSelection: function (t) {
			var e;
			if ((e = this.getContent().indexOf(t)) >= 0 && t.length > 0) {
				var i, n = this.getSelection();
				return this.setSelection(e, e + t.length), i = this.getSelection(), this.setSelection(n.start, n.end), i
			}
			return null
		}, getSelection: function () {
			var t = this.$textarea[0];
			return ("selectionStart" in t && function () {
				var e = t.selectionEnd - t.selectionStart;
				return {start: t.selectionStart, end: t.selectionEnd, length: e, text: t.value.substr(t.selectionStart, e)}
			} || function () {
				return null
			})()
		}, setSelection: function (t, e) {
			var i = this.$textarea[0];
			return ("selectionStart" in i && function () {
				i.selectionStart = t, i.selectionEnd = e
			} || function () {
				return null
			})()
		}, replaceSelection: function (t) {
			var e = this.$textarea[0];
			return ("selectionStart" in e && function () {
				return e.value = e.value.substr(0, e.selectionStart) + t + e.value.substr(e.selectionEnd, e.value.length), e.selectionStart = e.value.length, this
			} || function () {
				return e.value += t, jQuery(e)
			})()
		}, getNextTab: function () {
			if (0 === this.$nextTab.length) return null;
			var t, e = this.$nextTab.shift();
			return "function" == typeof e ? t = e() : "object" == typeof e && e.length > 0 && (t = e), t
		}, setNextTab: function (t, e) {
			if ("string" == typeof t) {
				var i = this;
				this.$nextTab.push(function () {
					return i.findSelection(t)
				})
			} else if ("number" == typeof t && "number" == typeof e) {
				var n = this.getSelection();
				this.setSelection(t, e), this.$nextTab.push(this.getSelection()), this.setSelection(n.start, n.end)
			}
		}, __parseButtonNameParam: function (t) {
			return "string" == typeof t ? t.split(" ") : t
		}, enableButtons: function (e) {
			var i = this.__parseButtonNameParam(e), n = this;
			return t.each(i, function (t, e) {
				n.__alterButtons(i[t], function (t) {
					t.removeAttr("disabled")
				})
			}), this
		}, disableButtons: function (e) {
			var i = this.__parseButtonNameParam(e), n = this;
			return t.each(i, function (t, e) {
				n.__alterButtons(i[t], function (t) {
					t.attr("disabled", "disabled")
				})
			}), this
		}, hideButtons: function (e) {
			var i = this.__parseButtonNameParam(e), n = this;
			return t.each(i, function (t, e) {
				n.__alterButtons(i[t], function (t) {
					t.addClass("hidden")
				})
			}), this
		}, showButtons: function (e) {
			var i = this.__parseButtonNameParam(e), n = this;
			return t.each(i, function (t, e) {
				n.__alterButtons(i[t], function (t) {
					t.removeClass("hidden")
				})
			}), this
		}, eventSupported: function (t) {
			var e = t in this.$element;
			return e || (this.$element.setAttribute(t, "return;"), e = "function" == typeof this.$element[t]), e
		}, keyup: function (t) {
			var e = !1;
			switch (t.keyCode) {
				case 40:
				case 38:
				case 16:
				case 17:
				case 18:
					break;
				case 9:
					var i;
					if (null !== (i = this.getNextTab())) {
						var n = this;
						setTimeout(function () {
							n.setSelection(i.start, i.end)
						}, 500), e = !0
					} else {
						var r = this.getSelection();
						r.start == r.end && r.end == this.getContent().length ? e = !1 : (this.setSelection(this.getContent().length, this.getContent().length), e = !0)
					}
					break;
				case 13:
					e = !1;
					break;
				case 27:
					this.$isFullscreen && this.setFullscreen(!1), e = !1;
					break;
				default:
					e = !1
			}
			e && (t.stopPropagation(), t.preventDefault()), this.$options.onChange(this)
		}, change: function (t) {
			return this.$options.onChange(this), this
		}, select: function (t) {
			return this.$options.onSelect(this), this
		}, focus: function (e) {
			var i = this.$options, n = (i.hideable, this.$editor);
			return n.addClass("active"), t(document).find(".md-editor").each(function () {
				var e;
				t(this).attr("id") !== n.attr("id") && (null === (e = t(this).find("textarea").data("markdown")) && (e = t(this).find('div[data-provider="markdown-preview"]').data("markdown")), e && e.blur())
			}), i.onFocus(this), this
		}, blur: function (e) {
			var i = this.$options, n = i.hideable, r = this.$editor, o = this.$editable;
			if (r.hasClass("active") || 0 === this.$element.parent().length) {
				if (r.removeClass("active"), n) if (null !== o.el) {
					var a = t("<" + o.type + "/>"), s = this.getContent(), l = this.parseContent(s);
					t(o.attrKeys).each(function (t, e) {
						a.attr(o.attrKeys[t], o.attrValues[t])
					}), a.html(l), r.replaceWith(a)
				} else r.hide();
				i.onBlur(this)
			}
			return this
		}
	};
	var i = t.fn.markdown;
	t.fn.markdown = function (i) {
		return this.each(function () {
			var n = t(this), r = n.data("markdown"), o = "object" == typeof i && i;
			r || n.data("markdown", r = new e(this, o))
		})
	}, t.fn.markdown.messages = {}, t.fn.markdown.defaults = {
		autofocus: !1,
		hideable: !1,
		savable: !1,
		width: "inherit",
		height: "inherit",
		resize: "none",
		iconlibrary: "glyph",
		language: "en",
		initialstate: "editor",
		parser: null,
		buttons: [[{
			name: "groupFont", data: [{
				name: "cmdBold", hotkey: "Ctrl+B", title: "Bold", icon: {glyph: "glyphicon glyphicon-bold", fa: "fa fa-bold", "fa-3": "icon-bold"}, callback: function (t) {
					var e, i, n = t.getSelection(), r = t.getContent();
					e = 0 === n.length ? t.__localize("strong text") : n.text, "**" === r.substr(n.start - 2, 2) && "**" === r.substr(n.end, 2) ? (t.setSelection(n.start - 2, n.end + 2), t.replaceSelection(e), i = n.start - 2) : (t.replaceSelection("**" + e + "**"), i = n.start + 2), t.setSelection(i, i + e.length)
				}
			}, {
				name: "cmdItalic", title: "Italic", hotkey: "Ctrl+I", icon: {glyph: "glyphicon glyphicon-italic", fa: "fa fa-italic", "fa-3": "icon-italic"}, callback: function (t) {
					var e, i, n = t.getSelection(), r = t.getContent();
					e = 0 === n.length ? t.__localize("emphasized text") : n.text, "_" === r.substr(n.start - 1, 1) && "_" === r.substr(n.end, 1) ? (t.setSelection(n.start - 1, n.end + 1), t.replaceSelection(e), i = n.start - 1) : (t.replaceSelection("_" + e + "_"), i = n.start + 1), t.setSelection(i, i + e.length)
				}
			}, {
				name: "cmdHeading", title: "Heading", hotkey: "Ctrl+H", icon: {glyph: "glyphicon glyphicon-header", fa: "fa fa-header", "fa-3": "icon-font"}, callback: function (t) {
					var e, i, n, r, o = t.getSelection(), a = t.getContent();
					e = 0 === o.length ? t.__localize("heading text") : o.text + "\n", n = 4, "### " === a.substr(o.start - n, n) || (n = 3, "###" === a.substr(o.start - n, n)) ? (t.setSelection(o.start - n, o.end), t.replaceSelection(e), i = o.start - n) : o.start > 0 && ((r = a.substr(o.start - 1, 1)) && "\n" != r) ? (t.replaceSelection("\n\n### " + e), i = o.start + 6) : (t.replaceSelection("### " + e), i = o.start + 4), t.setSelection(i, i + e.length)
				}
			}]
		}, {
			name: "groupLink", data: [{
				name: "cmdUrl", title: "URL/Link", hotkey: "Ctrl+L", icon: {glyph: "glyphicon glyphicon-link", fa: "fa fa-link", "fa-3": "icon-link"}, callback: function (e) {
					var i, n, r, o = e.getSelection();
					e.getContent();
					i = 0 === o.length ? e.__localize("enter link description here") : o.text, r = prompt(e.__localize("Insert Hyperlink"), "http://");
					var a = new RegExp("^((http|https)://|(mailto:)|(//))[a-z0-9]", "i");
					if (null !== r && "" !== r && "http://" !== r && a.test(r)) {
						var s = t("<div>" + r + "</div>").text();
						e.replaceSelection("[" + i + "](" + s + ")"), n = o.start + 1, e.setSelection(n, n + i.length)
					}
				}
			}, {
				name: "cmdImage", title: "Image", hotkey: "Ctrl+G", icon: {glyph: "glyphicon glyphicon-picture", fa: "fa fa-picture-o", "fa-3": "icon-picture"}, callback: function (e) {
					var i, n, r, o = e.getSelection();
					e.getContent();
					i = 0 === o.length ? e.__localize("enter image description here") : o.text, r = prompt(e.__localize("Insert Image Hyperlink"), "http://");
					var a = new RegExp("^((http|https)://|(//))[a-z0-9]", "i");
					if (null !== r && "" !== r && "http://" !== r && a.test(r)) {
						var s = t("<div>" + r + "</div>").text();
						e.replaceSelection("![" + i + "](" + s + ' "' + e.__localize("enter image title here") + '")'), n = o.start + 2, e.setNextTab(e.__localize("enter image title here")), e.setSelection(n, n + i.length)
					}
				}
			}]
		}, {
			name: "groupMisc", data: [{
				name: "cmdList", hotkey: "Ctrl+U", title: "Unordered List", icon: {glyph: "glyphicon glyphicon-list", fa: "fa fa-list", "fa-3": "icon-list-ul"}, callback: function (e) {
					var i, n, r = e.getSelection();
					e.getContent();
					if (0 === r.length) i = e.__localize("list text here"), e.replaceSelection("- " + i), n = r.start + 2; else if (r.text.indexOf("\n") < 0) i = r.text, e.replaceSelection("- " + i), n = r.start + 2; else {
						var o = [];
						i = (o = r.text.split("\n"))[0], t.each(o, function (t, e) {
							o[t] = "- " + e
						}), e.replaceSelection("\n\n" + o.join("\n")), n = r.start + 4
					}
					e.setSelection(n, n + i.length)
				}
			}, {
				name: "cmdListO", hotkey: "Ctrl+O", title: "Ordered List", icon: {glyph: "glyphicon glyphicon-th-list", fa: "fa fa-list-ol", "fa-3": "icon-list-ol"}, callback: function (e) {
					var i, n, r = e.getSelection();
					e.getContent();
					if (0 === r.length) i = e.__localize("list text here"), e.replaceSelection("1. " + i), n = r.start + 3; else if (r.text.indexOf("\n") < 0) i = r.text, e.replaceSelection("1. " + i), n = r.start + 3; else {
						var o = [];
						i = (o = r.text.split("\n"))[0], t.each(o, function (t, e) {
							o[t] = "1. " + e
						}), e.replaceSelection("\n\n" + o.join("\n")), n = r.start + 5
					}
					e.setSelection(n, n + i.length)
				}
			}, {
				name: "cmdCode", hotkey: "Ctrl+K", title: "Code", icon: {glyph: "glyphicon glyphicon-asterisk", fa: "fa fa-code", "fa-3": "icon-code"}, callback: function (t) {
					var e, i, n = t.getSelection(), r = t.getContent();
					e = 0 === n.length ? t.__localize("code text here") : n.text, "```\n" === r.substr(n.start - 4, 4) && "\n```" === r.substr(n.end, 4) ? (t.setSelection(n.start - 4, n.end + 4), t.replaceSelection(e), i = n.start - 4) : "`" === r.substr(n.start - 1, 1) && "`" === r.substr(n.end, 1) ? (t.setSelection(n.start - 1, n.end + 1), t.replaceSelection(e), i = n.start - 1) : r.indexOf("\n") > -1 ? (t.replaceSelection("```\n" + e + "\n```"), i = n.start + 4) : (t.replaceSelection("`" + e + "`"), i = n.start + 1), t.setSelection(i, i + e.length)
				}
			}, {
				name: "cmdQuote", hotkey: "Ctrl+Q", title: "Quote", icon: {glyph: "glyphicon glyphicon-comment", fa: "fa fa-quote-left", "fa-3": "icon-quote-left"}, callback: function (e) {
					var i, n, r = e.getSelection();
					e.getContent();
					if (0 === r.length) i = e.__localize("quote here"), e.replaceSelection("> " + i), n = r.start + 2; else if (r.text.indexOf("\n") < 0) i = r.text, e.replaceSelection("> " + i), n = r.start + 2; else {
						var o = [];
						i = (o = r.text.split("\n"))[0], t.each(o, function (t, e) {
							o[t] = "> " + e
						}), e.replaceSelection("\n\n" + o.join("\n")), n = r.start + 4
					}
					e.setSelection(n, n + i.length)
				}
			}]
		}, {
			name: "groupUtil", data: [{
				name: "cmdPreview", toggle: !0, hotkey: "Ctrl+P", title: "Preview", btnText: "Preview", btnClass: "btn btn-primary btn-sm", icon: {glyph: "glyphicon glyphicon-search", fa: "fa fa-search", "fa-3": "icon-search"}, callback: function (t) {
					!1 === t.$isPreview ? t.showPreview() : t.hidePreview()
				}
			}]
		}]],
		additionalButtons: [],
		reorderButtonGroups: [],
		hiddenButtons: [],
		disabledButtons: [],
		footer: "",
		fullscreen: {enable: !0, icons: {fullscreenOn: {fa: "fa fa-expand", glyph: "glyphicon glyphicon-fullscreen", "fa-3": "icon-resize-full"}, fullscreenOff: {fa: "fa fa-compress", glyph: "glyphicon glyphicon-fullscreen", "fa-3": "icon-resize-small"}}},
		onShow: function (t) {
		},
		onPreview: function (t) {
		},
		onSave: function (t) {
		},
		onBlur: function (t) {
		},
		onFocus: function (t) {
		},
		onChange: function (t) {
		},
		onFullscreen: function (t) {
		},
		onSelect: function (t) {
		}
	}, t.fn.markdown.Constructor = e, t.fn.markdown.noConflict = function () {
		return t.fn.markdown = i, this
	};
	var n = function (t) {
		var e = t;
		e.data("markdown") ? e.data("markdown").showEditor() : e.markdown()
	};
	t(document).on("click.markdown.data-api", '[data-provide="markdown-editable"]', function (e) {
		n(t(this)), e.preventDefault()
	}).on("click focusin", function (e) {
		var i;
		i = t(document.activeElement), t(document).find(".md-editor").each(function () {
			var e = t(this), n = i.closest(".md-editor")[0] === this, r = e.find("textarea").data("markdown") || e.find('div[data-provider="markdown-preview"]').data("markdown");
			r && !n && r.blur()
		})
	}).ready(function () {
		t('textarea[data-provide="markdown"]').each(function () {
			n(t(this))
		})
	})
}), $.fn.markdown.defaults.iconlibrary = "fa", $.fn.markdown.defaults.buttons[0][0].data[2].icon.fa = "fa fa-heading", $.fn.markdown.defaults.buttons[0][1].data[1].icon.fa = "fa fa-image", $.fn.markdown.defaults.buttons[0][2].data[1].icon.fa = "fa fa-list-ol", function (t) {
	"function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof module && module.exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function (t) {
	t.extend(t.fn, {
		validate: function (e) {
			if (this.length) {
				var i = t.data(this[0], "validator");
				return i || (this.attr("novalidate", "novalidate"), i = new t.validator(e, this[0]), t.data(this[0], "validator", i), i.settings.onsubmit && (this.on("click.validate", ":submit", function (e) {
					i.submitButton = e.currentTarget, t(this).hasClass("cancel") && (i.cancelSubmit = !0), void 0 !== t(this).attr("formnovalidate") && (i.cancelSubmit = !0)
				}), this.on("submit.validate", function (e) {
					function n() {
						var n, r;
						return i.submitButton && (i.settings.submitHandler || i.formSubmitted) && (n = t("<input type='hidden'/>").attr("name", i.submitButton.name).val(t(i.submitButton).val()).appendTo(i.currentForm)), !i.settings.submitHandler || (r = i.settings.submitHandler.call(i, i.currentForm, e), n && n.remove(), void 0 !== r && r)
					}

					return i.settings.debug && e.preventDefault(), i.cancelSubmit ? (i.cancelSubmit = !1, n()) : i.form() ? i.pendingRequest ? (i.formSubmitted = !0, !1) : n() : (i.focusInvalid(), !1)
				})), i)
			}
			e && e.debug && window.console && console.warn("Nothing selected, can't validate, returning nothing.")
		}, valid: function () {
			var e, i, n;
			return t(this[0]).is("form") ? e = this.validate().form() : (n = [], e = !0, i = t(this[0].form).validate(), this.each(function () {
				(e = i.element(this) && e) || (n = n.concat(i.errorList))
			}), i.errorList = n), e
		}, rules: function (e, i) {
			var n, r, o, a, s, l, c = this[0];
			if (null != c && (!c.form && c.hasAttribute("contenteditable") && (c.form = this.closest("form")[0], c.name = this.attr("name")), null != c.form)) {
				if (e) switch (r = (n = t.data(c.form, "validator").settings).rules, o = t.validator.staticRules(c), e) {
					case"add":
						t.extend(o, t.validator.normalizeRule(i)), delete o.messages, r[c.name] = o, i.messages && (n.messages[c.name] = t.extend(n.messages[c.name], i.messages));
						break;
					case"remove":
						return i ? (l = {}, t.each(i.split(/\s/), function (t, e) {
							l[e] = o[e], delete o[e]
						}), l) : (delete r[c.name], o)
				}
				return (a = t.validator.normalizeRules(t.extend({}, t.validator.classRules(c), t.validator.attributeRules(c), t.validator.dataRules(c), t.validator.staticRules(c)), c)).required && (s = a.required, delete a.required, a = t.extend({required: s}, a)), a.remote && (s = a.remote, delete a.remote, a = t.extend(a, {remote: s})), a
			}
		}
	}), t.extend(t.expr.pseudos || t.expr[":"], {
		blank: function (e) {
			return !t.trim("" + t(e).val())
		}, filled: function (e) {
			var i = t(e).val();
			return null !== i && !!t.trim("" + i)
		}, unchecked: function (e) {
			return !t(e).prop("checked")
		}
	}), t.validator = function (e, i) {
		this.settings = t.extend(!0, {}, t.validator.defaults, e), this.currentForm = i, this.init()
	}, t.validator.format = function (e, i) {
		return 1 === arguments.length ? function () {
			var i = t.makeArray(arguments);
			return i.unshift(e), t.validator.format.apply(this, i)
		} : void 0 === i ? e : (arguments.length > 2 && i.constructor !== Array && (i = t.makeArray(arguments).slice(1)), i.constructor !== Array && (i = [i]), t.each(i, function (t, i) {
			e = e.replace(new RegExp("\\{" + t + "\\}", "g"), function () {
				return i
			})
		}), e)
	}, t.extend(t.validator, {
		defaults: {
			messages: {}, groups: {}, rules: {}, errorClass: "error", pendingClass: "pending", validClass: "valid", errorElement: "label", focusCleanup: !1, focusInvalid: !0, errorContainer: t([]), errorLabelContainer: t([]), onsubmit: !0, ignore: ":hidden", ignoreTitle: !1, onfocusin: function (t) {
				this.lastActive = t, this.settings.focusCleanup && (this.settings.unhighlight && this.settings.unhighlight.call(this, t, this.settings.errorClass, this.settings.validClass), this.hideThese(this.errorsFor(t)))
			}, onfocusout: function (t) {
				this.checkable(t) || !(t.name in this.submitted) && this.optional(t) || this.element(t)
			}, onkeyup: function (e, i) {
				9 === i.which && "" === this.elementValue(e) || -1 !== t.inArray(i.keyCode, [16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225]) || (e.name in this.submitted || e.name in this.invalid) && this.element(e)
			}, onclick: function (t) {
				t.name in this.submitted ? this.element(t) : t.parentNode.name in this.submitted && this.element(t.parentNode)
			}, highlight: function (e, i, n) {
				"radio" === e.type ? this.findByName(e.name).addClass(i).removeClass(n) : t(e).addClass(i).removeClass(n)
			}, unhighlight: function (e, i, n) {
				"radio" === e.type ? this.findByName(e.name).removeClass(i).addClass(n) : t(e).removeClass(i).addClass(n)
			}
		},
		setDefaults: function (e) {
			t.extend(t.validator.defaults, e)
		},
		messages: {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			equalTo: "Please enter the same value again.",
			maxlength: t.validator.format("Please enter no more than {0} characters."),
			minlength: t.validator.format("Please enter at least {0} characters."),
			rangelength: t.validator.format("Please enter a value between {0} and {1} characters long."),
			range: t.validator.format("Please enter a value between {0} and {1}."),
			max: t.validator.format("Please enter a value less than or equal to {0}."),
			min: t.validator.format("Please enter a value greater than or equal to {0}."),
			step: t.validator.format("Please enter a multiple of {0}.")
		},
		autoCreateRanges: !1,
		prototype: {
			init: function () {
				this.labelContainer = t(this.settings.errorLabelContainer), this.errorContext = this.labelContainer.length && this.labelContainer || t(this.currentForm), this.containers = t(this.settings.errorContainer).add(this.settings.errorLabelContainer), this.submitted = {}, this.valueCache = {}, this.pendingRequest = 0, this.pending = {}, this.invalid = {}, this.reset();
				var e, i = this.groups = {};

				function n(e) {
					!this.form && this.hasAttribute("contenteditable") && (this.form = t(this).closest("form")[0], this.name = t(this).attr("name"));
					var i = t.data(this.form, "validator"), n = "on" + e.type.replace(/^validate/, ""), r = i.settings;
					r[n] && !t(this).is(r.ignore) && r[n].call(i, this, e)
				}

				t.each(this.settings.groups, function (e, n) {
					"string" == typeof n && (n = n.split(/\s/)), t.each(n, function (t, n) {
						i[n] = e
					})
				}), e = this.settings.rules, t.each(e, function (i, n) {
					e[i] = t.validator.normalizeRule(n)
				}), t(this.currentForm).on("focusin.validate focusout.validate keyup.validate", ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']", n).on("click.validate", "select, option, [type='radio'], [type='checkbox']", n), this.settings.invalidHandler && t(this.currentForm).on("invalid-form.validate", this.settings.invalidHandler)
			}, form: function () {
				return this.checkForm(), t.extend(this.submitted, this.errorMap), this.invalid = t.extend({}, this.errorMap), this.valid() || t(this.currentForm).triggerHandler("invalid-form", [this]), this.showErrors(), this.valid()
			}, checkForm: function () {
				this.prepareForm();
				for (var t = 0, e = this.currentElements = this.elements(); e[t]; t++) this.check(e[t]);
				return this.valid()
			}, element: function (e) {
				var i, n, r = this.clean(e), o = this.validationTargetFor(r), a = this, s = !0;
				return void 0 === o ? delete this.invalid[r.name] : (this.prepareElement(o), this.currentElements = t(o), (n = this.groups[o.name]) && t.each(this.groups, function (t, e) {
					e === n && t !== o.name && (r = a.validationTargetFor(a.clean(a.findByName(t)))) && r.name in a.invalid && (a.currentElements.push(r), s = a.check(r) && s)
				}), i = !1 !== this.check(o), s = s && i, this.invalid[o.name] = !i, this.numberOfInvalids() || (this.toHide = this.toHide.add(this.containers)), this.showErrors(), t(e).attr("aria-invalid", !i)), s
			}, showErrors: function (e) {
				if (e) {
					var i = this;
					t.extend(this.errorMap, e), this.errorList = t.map(this.errorMap, function (t, e) {
						return {message: t, element: i.findByName(e)[0]}
					}), this.successList = t.grep(this.successList, function (t) {
						return !(t.name in e)
					})
				}
				this.settings.showErrors ? this.settings.showErrors.call(this, this.errorMap, this.errorList) : this.defaultShowErrors()
			}, resetForm: function () {
				t.fn.resetForm && t(this.currentForm).resetForm(), this.invalid = {}, this.submitted = {}, this.prepareForm(), this.hideErrors();
				var e = this.elements().removeData("previousValue").removeAttr("aria-invalid");
				this.resetElements(e)
			}, resetElements: function (t) {
				var e;
				if (this.settings.unhighlight) for (e = 0; t[e]; e++) this.settings.unhighlight.call(this, t[e], this.settings.errorClass, ""), this.findByName(t[e].name).removeClass(this.settings.validClass); else t.removeClass(this.settings.errorClass).removeClass(this.settings.validClass)
			}, numberOfInvalids: function () {
				return this.objectLength(this.invalid)
			}, objectLength: function (t) {
				var e, i = 0;
				for (e in t) void 0 !== t[e] && null !== t[e] && !1 !== t[e] && i++;
				return i
			}, hideErrors: function () {
				this.hideThese(this.toHide)
			}, hideThese: function (t) {
				t.not(this.containers).text(""), this.addWrapper(t).hide()
			}, valid: function () {
				return 0 === this.size()
			}, size: function () {
				return this.errorList.length
			}, focusInvalid: function () {
				if (this.settings.focusInvalid) try {
					t(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").focus().trigger("focusin")
				} catch (t) {
				}
			}, findLastActive: function () {
				var e = this.lastActive;
				return e && 1 === t.grep(this.errorList, function (t) {
					return t.element.name === e.name
				}).length && e
			}, elements: function () {
				var e = this, i = {};
				return t(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function () {
					var n = this.name || t(this).attr("name");
					return !n && e.settings.debug && window.console && console.error("%o has no name assigned", this), this.hasAttribute("contenteditable") && (this.form = t(this).closest("form")[0], this.name = n), !(n in i || !e.objectLength(t(this).rules())) && (i[n] = !0, !0)
				})
			}, clean: function (e) {
				return t(e)[0]
			}, errors: function () {
				var e = this.settings.errorClass.split(" ").join(".");
				return t(this.settings.errorElement + "." + e, this.errorContext)
			}, resetInternals: function () {
				this.successList = [], this.errorList = [], this.errorMap = {}, this.toShow = t([]), this.toHide = t([])
			}, reset: function () {
				this.resetInternals(), this.currentElements = t([])
			}, prepareForm: function () {
				this.reset(), this.toHide = this.errors().add(this.containers)
			}, prepareElement: function (t) {
				this.reset(), this.toHide = this.errorsFor(t)
			}, elementValue: function (e) {
				var i, n, r = t(e), o = e.type;
				return "radio" === o || "checkbox" === o ? this.findByName(e.name).filter(":checked").val() : "number" === o && void 0 !== e.validity ? e.validity.badInput ? "NaN" : r.val() : (i = e.hasAttribute("contenteditable") ? r.text() : r.val(), "file" === o ? "C:\\fakepath\\" === i.substr(0, 12) ? i.substr(12) : (n = i.lastIndexOf("/")) >= 0 ? i.substr(n + 1) : (n = i.lastIndexOf("\\")) >= 0 ? i.substr(n + 1) : i : "string" == typeof i ? i.replace(/\r/g, "") : i)
			}, check: function (e) {
				e = this.validationTargetFor(this.clean(e));
				var i, n, r, o, a = t(e).rules(), s = t.map(a, function (t, e) {
					return e
				}).length, l = !1, c = this.elementValue(e);
				if ("function" == typeof a.normalizer ? o = a.normalizer : "function" == typeof this.settings.normalizer && (o = this.settings.normalizer), o) {
					if ("string" != typeof (c = o.call(e, c))) throw new TypeError("The normalizer should return a string value.");
					delete a.normalizer
				}
				for (n in a) {
					r = {method: n, parameters: a[n]};
					try {
						if ("dependency-mismatch" === (i = t.validator.methods[n].call(this, c, e, r.parameters)) && 1 === s) {
							l = !0;
							continue
						}
						if (l = !1, "pending" === i) return void (this.toHide = this.toHide.not(this.errorsFor(e)));
						if (!i) return this.formatAndAdd(e, r), !1
					} catch (t) {
						throw this.settings.debug && window.console && console.log("Exception occurred when checking element " + e.id + ", check the '" + r.method + "' method.", t), t instanceof TypeError && (t.message += ".  Exception occurred when checking element " + e.id + ", check the '" + r.method + "' method."), t
					}
				}
				if (!l) return this.objectLength(a) && this.successList.push(e), !0
			}, customDataMessage: function (e, i) {
				return t(e).data("msg" + i.charAt(0).toUpperCase() + i.substring(1).toLowerCase()) || t(e).data("msg")
			}, customMessage: function (t, e) {
				var i = this.settings.messages[t];
				return i && (i.constructor === String ? i : i[e])
			}, findDefined: function () {
				for (var t = 0; t < arguments.length; t++) if (void 0 !== arguments[t]) return arguments[t]
			}, defaultMessage: function (e, i) {
				"string" == typeof i && (i = {method: i});
				var n = this.findDefined(this.customMessage(e.name, i.method), this.customDataMessage(e, i.method), !this.settings.ignoreTitle && e.title || void 0, t.validator.messages[i.method], "<strong>Warning: No message defined for " + e.name + "</strong>"), r = /\$?\{(\d+)\}/g;
				return "function" == typeof n ? n = n.call(this, i.parameters, e) : r.test(n) && (n = t.validator.format(n.replace(r, "{$1}"), i.parameters)), n
			}, formatAndAdd: function (t, e) {
				var i = this.defaultMessage(t, e);
				this.errorList.push({message: i, element: t, method: e.method}), this.errorMap[t.name] = i, this.submitted[t.name] = i
			}, addWrapper: function (t) {
				return this.settings.wrapper && (t = t.add(t.parent(this.settings.wrapper))), t
			}, defaultShowErrors: function () {
				var t, e, i;
				for (t = 0; this.errorList[t]; t++) i = this.errorList[t], this.settings.highlight && this.settings.highlight.call(this, i.element, this.settings.errorClass, this.settings.validClass), this.showLabel(i.element, i.message);
				if (this.errorList.length && (this.toShow = this.toShow.add(this.containers)), this.settings.success) for (t = 0; this.successList[t]; t++) this.showLabel(this.successList[t]);
				if (this.settings.unhighlight) for (t = 0, e = this.validElements(); e[t]; t++) this.settings.unhighlight.call(this, e[t], this.settings.errorClass, this.settings.validClass);
				this.toHide = this.toHide.not(this.toShow), this.hideErrors(), this.addWrapper(this.toShow).show()
			}, validElements: function () {
				return this.currentElements.not(this.invalidElements())
			}, invalidElements: function () {
				return t(this.errorList).map(function () {
					return this.element
				})
			}, showLabel: function (e, i) {
				var n, r, o, a, s = this.errorsFor(e), l = this.idOrName(e), c = t(e).attr("aria-describedby");
				s.length ? (s.removeClass(this.settings.validClass).addClass(this.settings.errorClass), s.html(i)) : (n = s = t("<" + this.settings.errorElement + ">").attr("id", l + "-error").addClass(this.settings.errorClass).html(i || ""), this.settings.wrapper && (n = s.hide().show().wrap("<" + this.settings.wrapper + "/>").parent()), this.labelContainer.length ? this.labelContainer.append(n) : this.settings.errorPlacement ? this.settings.errorPlacement.call(this, n, t(e)) : n.insertAfter(e), s.is("label") ? s.attr("for", l) : 0 === s.parents("label[for='" + this.escapeCssMeta(l) + "']").length && (o = s.attr("id"), c ? c.match(new RegExp("\\b" + this.escapeCssMeta(o) + "\\b")) || (c += " " + o) : c = o, t(e).attr("aria-describedby", c), (r = this.groups[e.name]) && (a = this, t.each(a.groups, function (e, i) {
					i === r && t("[name='" + a.escapeCssMeta(e) + "']", a.currentForm).attr("aria-describedby", s.attr("id"))
				})))), !i && this.settings.success && (s.text(""), "string" == typeof this.settings.success ? s.addClass(this.settings.success) : this.settings.success(s, e)), this.toShow = this.toShow.add(s)
			}, errorsFor: function (e) {
				var i = this.escapeCssMeta(this.idOrName(e)), n = t(e).attr("aria-describedby"), r = "label[for='" + i + "'], label[for='" + i + "'] *";
				return n && (r = r + ", #" + this.escapeCssMeta(n).replace(/\s+/g, ", #")), this.errors().filter(r)
			}, escapeCssMeta: function (t) {
				return t.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g, "\\$1")
			}, idOrName: function (t) {
				return this.groups[t.name] || (this.checkable(t) ? t.name : t.id || t.name)
			}, validationTargetFor: function (e) {
				return this.checkable(e) && (e = this.findByName(e.name)), t(e).not(this.settings.ignore)[0]
			}, checkable: function (t) {
				return /radio|checkbox/i.test(t.type)
			}, findByName: function (e) {
				return t(this.currentForm).find("[name='" + this.escapeCssMeta(e) + "']")
			}, getLength: function (e, i) {
				switch (i.nodeName.toLowerCase()) {
					case"select":
						return t("option:selected", i).length;
					case"input":
						if (this.checkable(i)) return this.findByName(i.name).filter(":checked").length
				}
				return e.length
			}, depend: function (t, e) {
				return !this.dependTypes[typeof t] || this.dependTypes[typeof t](t, e)
			}, dependTypes: {
				boolean: function (t) {
					return t
				}, string: function (e, i) {
					return !!t(e, i.form).length
				}, function: function (t, e) {
					return t(e)
				}
			}, optional: function (e) {
				var i = this.elementValue(e);
				return !t.validator.methods.required.call(this, i, e) && "dependency-mismatch"
			}, startRequest: function (e) {
				this.pending[e.name] || (this.pendingRequest++, t(e).addClass(this.settings.pendingClass), this.pending[e.name] = !0)
			}, stopRequest: function (e, i) {
				this.pendingRequest--, this.pendingRequest < 0 && (this.pendingRequest = 0), delete this.pending[e.name], t(e).removeClass(this.settings.pendingClass), i && 0 === this.pendingRequest && this.formSubmitted && this.form() ? (t(this.currentForm).submit(), this.submitButton && t("input:hidden[name='" + this.submitButton.name + "']", this.currentForm).remove(), this.formSubmitted = !1) : !i && 0 === this.pendingRequest && this.formSubmitted && (t(this.currentForm).triggerHandler("invalid-form", [this]), this.formSubmitted = !1)
			}, previousValue: function (e, i) {
				return i = "string" == typeof i && i || "remote", t.data(e, "previousValue") || t.data(e, "previousValue", {old: null, valid: !0, message: this.defaultMessage(e, {method: i})})
			}, destroy: function () {
				this.resetForm(), t(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur")
			}
		},
		classRuleSettings: {required: {required: !0}, email: {email: !0}, url: {url: !0}, date: {date: !0}, dateISO: {dateISO: !0}, number: {number: !0}, digits: {digits: !0}, creditcard: {creditcard: !0}},
		addClassRules: function (e, i) {
			e.constructor === String ? this.classRuleSettings[e] = i : t.extend(this.classRuleSettings, e)
		},
		classRules: function (e) {
			var i = {}, n = t(e).attr("class");
			return n && t.each(n.split(" "), function () {
				this in t.validator.classRuleSettings && t.extend(i, t.validator.classRuleSettings[this])
			}), i
		},
		normalizeAttributeRule: function (t, e, i, n) {
			/min|max|step/.test(i) && (null === e || /number|range|text/.test(e)) && (n = Number(n), isNaN(n) && (n = void 0)), n || 0 === n ? t[i] = n : e === i && "range" !== e && (t[i] = !0)
		},
		attributeRules: function (e) {
			var i, n, r = {}, o = t(e), a = e.getAttribute("type");
			for (i in t.validator.methods) "required" === i ? ("" === (n = e.getAttribute(i)) && (n = !0), n = !!n) : n = o.attr(i), this.normalizeAttributeRule(r, a, i, n);
			return r.maxlength && /-1|2147483647|524288/.test(r.maxlength) && delete r.maxlength, r
		},
		dataRules: function (e) {
			var i, n, r = {}, o = t(e), a = e.getAttribute("type");
			for (i in t.validator.methods) n = o.data("rule" + i.charAt(0).toUpperCase() + i.substring(1).toLowerCase()), this.normalizeAttributeRule(r, a, i, n);
			return r
		},
		staticRules: function (e) {
			var i = {}, n = t.data(e.form, "validator");
			return n.settings.rules && (i = t.validator.normalizeRule(n.settings.rules[e.name]) || {}), i
		},
		normalizeRules: function (e, i) {
			return t.each(e, function (n, r) {
				if (!1 !== r) {
					if (r.param || r.depends) {
						var o = !0;
						switch (typeof r.depends) {
							case"string":
								o = !!t(r.depends, i.form).length;
								break;
							case"function":
								o = r.depends.call(i, i)
						}
						o ? e[n] = void 0 === r.param || r.param : (t.data(i.form, "validator").resetElements(t(i)), delete e[n])
					}
				} else delete e[n]
			}), t.each(e, function (n, r) {
				e[n] = t.isFunction(r) && "normalizer" !== n ? r(i) : r
			}), t.each(["minlength", "maxlength"], function () {
				e[this] && (e[this] = Number(e[this]))
			}), t.each(["rangelength", "range"], function () {
				var i;
				e[this] && (t.isArray(e[this]) ? e[this] = [Number(e[this][0]), Number(e[this][1])] : "string" == typeof e[this] && (i = e[this].replace(/[\[\]]/g, "").split(/[\s,]+/), e[this] = [Number(i[0]), Number(i[1])]))
			}), t.validator.autoCreateRanges && (null != e.min && null != e.max && (e.range = [e.min, e.max], delete e.min, delete e.max), null != e.minlength && null != e.maxlength && (e.rangelength = [e.minlength, e.maxlength], delete e.minlength, delete e.maxlength)), e
		},
		normalizeRule: function (e) {
			if ("string" == typeof e) {
				var i = {};
				t.each(e.split(/\s/), function () {
					i[this] = !0
				}), e = i
			}
			return e
		},
		addMethod: function (e, i, n) {
			t.validator.methods[e] = i, t.validator.messages[e] = void 0 !== n ? n : t.validator.messages[e], i.length < 3 && t.validator.addClassRules(e, t.validator.normalizeRule(e))
		},
		methods: {
			required: function (e, i, n) {
				if (!this.depend(n, i)) return "dependency-mismatch";
				if ("select" === i.nodeName.toLowerCase()) {
					var r = t(i).val();
					return r && r.length > 0
				}
				return this.checkable(i) ? this.getLength(e, i) > 0 : e.length > 0
			}, email: function (t, e) {
				return this.optional(e) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(t)
			}, url: function (t, e) {
				return this.optional(e) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(t)
			}, date: function (t, e) {
				return this.optional(e) || !/Invalid|NaN/.test(new Date(t).toString())
			}, dateISO: function (t, e) {
				return this.optional(e) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(t)
			}, number: function (t, e) {
				return this.optional(e) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(t)
			}, digits: function (t, e) {
				return this.optional(e) || /^\d+$/.test(t)
			}, minlength: function (e, i, n) {
				var r = t.isArray(e) ? e.length : this.getLength(e, i);
				return this.optional(i) || r >= n
			}, maxlength: function (e, i, n) {
				var r = t.isArray(e) ? e.length : this.getLength(e, i);
				return this.optional(i) || r <= n
			}, rangelength: function (e, i, n) {
				var r = t.isArray(e) ? e.length : this.getLength(e, i);
				return this.optional(i) || r >= n[0] && r <= n[1]
			}, min: function (t, e, i) {
				return this.optional(e) || t >= i
			}, max: function (t, e, i) {
				return this.optional(e) || t <= i
			}, range: function (t, e, i) {
				return this.optional(e) || t >= i[0] && t <= i[1]
			}, step: function (e, i, n) {
				var r, o = t(i).attr("type"), a = "Step attribute on input type " + o + " is not supported.", s = new RegExp("\\b" + o + "\\b"), l = function (t) {
					var e = ("" + t).match(/(?:\.(\d+))?$/);
					return e && e[1] ? e[1].length : 0
				}, c = function (t) {
					return Math.round(t * Math.pow(10, r))
				}, u = !0;
				if (o && !s.test(["text", "number", "range"].join())) throw new Error(a);
				return r = l(n), (l(e) > r || c(e) % c(n) != 0) && (u = !1), this.optional(i) || u
			}, equalTo: function (e, i, n) {
				var r = t(n);
				return this.settings.onfocusout && r.not(".validate-equalTo-blur").length && r.addClass("validate-equalTo-blur").on("blur.validate-equalTo", function () {
					t(i).valid()
				}), e === r.val()
			}, remote: function (e, i, n, r) {
				if (this.optional(i)) return "dependency-mismatch";
				r = "string" == typeof r && r || "remote";
				var o, a, s, l = this.previousValue(i, r);
				return this.settings.messages[i.name] || (this.settings.messages[i.name] = {}), l.originalMessage = l.originalMessage || this.settings.messages[i.name][r], this.settings.messages[i.name][r] = l.message, n = "string" == typeof n && {url: n} || n, s = t.param(t.extend({data: e}, n.data)), l.old === s ? l.valid : (l.old = s, o = this, this.startRequest(i), (a = {})[i.name] = e, t.ajax(t.extend(!0, {
					mode: "abort",
					port: "validate" + i.name,
					dataType: "json",
					data: a,
					context: o.currentForm,
					success: function (t) {
						var n, a, s, c = !0 === t || "true" === t;
						o.settings.messages[i.name][r] = l.originalMessage, c ? (s = o.formSubmitted, o.resetInternals(), o.toHide = o.errorsFor(i), o.formSubmitted = s, o.successList.push(i), o.invalid[i.name] = !1, o.showErrors()) : (n = {}, a = t || o.defaultMessage(i, {
							method: r,
							parameters: e
						}), n[i.name] = l.message = a, o.invalid[i.name] = !0, o.showErrors(n)), l.valid = c, o.stopRequest(i, c)
					}
				}, n)), "pending")
			}
		}
	});
	var e, i = {};
	return t.ajaxPrefilter ? t.ajaxPrefilter(function (t, e, n) {
		var r = t.port;
		"abort" === t.mode && (i[r] && i[r].abort(), i[r] = n)
	}) : (e = t.ajax, t.ajax = function (n) {
		var r = ("mode" in n ? n : t.ajaxSettings).mode, o = ("port" in n ? n : t.ajaxSettings).port;
		return "abort" === r ? (i[o] && i[o].abort(), i[o] = e.apply(this, arguments), i[o]) : e.apply(this, arguments)
	}), t
}), function (t) {
	"function" == typeof define && define.amd ? define(["jquery", "./jquery.validate"], t) : "object" == typeof module && module.exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function (t) {
	return function () {
		function e(t) {
			return t.replace(/<.[^<>]*?>/g, " ").replace(/&nbsp;|&#160;/gi, " ").replace(/[.(),;:!?%#$'\"_+=\/\-“”’]*/g, "")
		}

		t.validator.addMethod("maxWords", function (t, i, n) {
			return this.optional(i) || e(t).match(/\b\w+\b/g).length <= n
		}, t.validator.format("Please enter {0} words or less.")), t.validator.addMethod("minWords", function (t, i, n) {
			return this.optional(i) || e(t).match(/\b\w+\b/g).length >= n
		}, t.validator.format("Please enter at least {0} words.")), t.validator.addMethod("rangeWords", function (t, i, n) {
			var r = e(t), o = /\b\w+\b/g;
			return this.optional(i) || r.match(o).length >= n[0] && r.match(o).length <= n[1]
		}, t.validator.format("Please enter between {0} and {1} words."))
	}(), t.validator.addMethod("accept", function (e, i, n) {
		var r, o, a = "string" == typeof n ? n.replace(/\s/g, "") : "image/*", s = this.optional(i);
		if (s) return s;
		if ("file" === t(i).attr("type") && (a = a.replace(/[\-\[\]\/\{\}\(\)\+\?\.\\\^\$\|]/g, "\\$&").replace(/,/g, "|").replace(/\/\*/g, "/.*"), i.files && i.files.length)) for (o = new RegExp(".?(" + a + ")$", "i"), r = 0; r < i.files.length; r++) if (!i.files[r].type.match(o)) return !1;
		return !0
	}, t.validator.format("Please enter a value with a valid mimetype.")), t.validator.addMethod("alphanumeric", function (t, e) {
		return this.optional(e) || /^\w+$/i.test(t)
	}, "Letters, numbers, and underscores only please"), t.validator.addMethod("bankaccountNL", function (t, e) {
		if (this.optional(e)) return !0;
		if (!/^[0-9]{9}|([0-9]{2} ){3}[0-9]{3}$/.test(t)) return !1;
		var i, n = t.replace(/ /g, ""), r = 0, o = n.length;
		for (i = 0; i < o; i++) r += (o - i) * n.substring(i, i + 1);
		return r % 11 == 0
	}, "Please specify a valid bank account number"), t.validator.addMethod("bankorgiroaccountNL", function (e, i) {
		return this.optional(i) || t.validator.methods.bankaccountNL.call(this, e, i) || t.validator.methods.giroaccountNL.call(this, e, i)
	}, "Please specify a valid bank or giro account number"), t.validator.addMethod("bic", function (t, e) {
		return this.optional(e) || /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(t.toUpperCase())
	}, "Please specify a valid BIC code"), t.validator.addMethod("cifES", function (t, e) {
		"use strict";
		if (this.optional(e)) return !0;
		var i, n, r, o, a = new RegExp(/^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/gi), s = t.substring(0, 1), l = t.substring(1, 8), c = t.substring(8, 9), u = 0, h = 0;

		function d(t) {
			return t % 2 == 0
		}

		if (9 !== t.length || !a.test(t)) return !1;
		for (i = 0; i < l.length; i++) n = parseInt(l[i], 10), d(i) ? h += (n *= 2) < 10 ? n : n - 9 : u += n;
		return r = (10 - (u + h).toString().substr(-1)).toString(), r = parseInt(r, 10) > 9 ? "0" : r, o = "JABCDEFGHI".substr(r, 1).toString(), s.match(/[ABEH]/) ? c === r : s.match(/[KPQS]/) ? c === o : c === r || c === o
	}, "Please specify a valid CIF number."), t.validator.addMethod("cpfBR", function (t) {
		if (11 !== (t = t.replace(/([~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/? ])+/g, "")).length) return !1;
		var e, i, n, r, o = 0;
		if (e = parseInt(t.substring(9, 10), 10), i = parseInt(t.substring(10, 11), 10), n = function (t, e) {
			var i = 10 * t % 11;
			return 10 !== i && 11 !== i || (i = 0), i === e
		}, "" === t || "00000000000" === t || "11111111111" === t || "22222222222" === t || "33333333333" === t || "44444444444" === t || "55555555555" === t || "66666666666" === t || "77777777777" === t || "88888888888" === t || "99999999999" === t) return !1;
		for (r = 1; r <= 9; r++) o += parseInt(t.substring(r - 1, r), 10) * (11 - r);
		if (n(o, e)) {
			for (o = 0, r = 1; r <= 10; r++) o += parseInt(t.substring(r - 1, r), 10) * (12 - r);
			return n(o, i)
		}
		return !1
	}, "Please specify a valid CPF number"), t.validator.addMethod("creditcard", function (t, e) {
		if (this.optional(e)) return "dependency-mismatch";
		if (/[^0-9 \-]+/.test(t)) return !1;
		var i, n, r = 0, o = 0, a = !1;
		if ((t = t.replace(/\D/g, "")).length < 13 || t.length > 19) return !1;
		for (i = t.length - 1; i >= 0; i--) n = t.charAt(i), o = parseInt(n, 10), a && (o *= 2) > 9 && (o -= 9), r += o, a = !a;
		return r % 10 == 0
	}, "Please enter a valid credit card number."), t.validator.addMethod("creditcardtypes", function (t, e, i) {
		if (/[^0-9\-]+/.test(t)) return !1;
		t = t.replace(/\D/g, "");
		var n = 0;
		return i.mastercard && (n |= 1), i.visa && (n |= 2), i.amex && (n |= 4), i.dinersclub && (n |= 8), i.enroute && (n |= 16), i.discover && (n |= 32), i.jcb && (n |= 64), i.unknown && (n |= 128), i.all && (n = 255), 1 & n && /^(5[12345])/.test(t) ? 16 === t.length : 2 & n && /^(4)/.test(t) ? 16 === t.length : 4 & n && /^(3[47])/.test(t) ? 15 === t.length : 8 & n && /^(3(0[012345]|[68]))/.test(t) ? 14 === t.length : 16 & n && /^(2(014|149))/.test(t) ? 15 === t.length : 32 & n && /^(6011)/.test(t) ? 16 === t.length : 64 & n && /^(3)/.test(t) ? 16 === t.length : 64 & n && /^(2131|1800)/.test(t) ? 15 === t.length : !!(128 & n)
	}, "Please enter a valid credit card number."), t.validator.addMethod("currency", function (t, e, i) {
		var n, r = "string" == typeof i, o = r ? i : i[0], a = !!r || i[1];
		return o = o.replace(/,/g, ""), n = "^[" + (o = a ? o + "]" : o + "]?") + "([1-9]{1}[0-9]{0,2}(\\,[0-9]{3})*(\\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\\.[0-9]{0,2})?|0(\\.[0-9]{0,2})?|(\\.[0-9]{1,2})?)$", n = new RegExp(n), this.optional(e) || n.test(t)
	}, "Please specify a valid currency"), t.validator.addMethod("dateFA", function (t, e) {
		return this.optional(e) || /^[1-4]\d{3}\/((0?[1-6]\/((3[0-1])|([1-2][0-9])|(0?[1-9])))|((1[0-2]|(0?[7-9]))\/(30|([1-2][0-9])|(0?[1-9]))))$/.test(t)
	}, t.validator.messages.date), t.validator.addMethod("dateITA", function (t, e) {
		var i, n, r, o, a, s = !1;
		return /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(t) ? (i = t.split("/"), n = parseInt(i[0], 10), r = parseInt(i[1], 10), o = parseInt(i[2], 10), s = (a = new Date(Date.UTC(o, r - 1, n, 12, 0, 0, 0))).getUTCFullYear() === o && a.getUTCMonth() === r - 1 && a.getUTCDate() === n) : s = !1, this.optional(e) || s
	}, t.validator.messages.date), t.validator.addMethod("dateNL", function (t, e) {
		return this.optional(e) || /^(0?[1-9]|[12]\d|3[01])[\.\/\-](0?[1-9]|1[012])[\.\/\-]([12]\d)?(\d\d)$/.test(t)
	}, t.validator.messages.date), t.validator.addMethod("extension", function (t, e, i) {
		return i = "string" == typeof i ? i.replace(/,/g, "|") : "png|jpe?g|gif", this.optional(e) || t.match(new RegExp("\\.(" + i + ")$", "i"))
	}, t.validator.format("Please enter a value with a valid extension.")), t.validator.addMethod("giroaccountNL", function (t, e) {
		return this.optional(e) || /^[0-9]{1,7}$/.test(t)
	}, "Please specify a valid giro account number"), t.validator.addMethod("iban", function (t, e) {
		if (this.optional(e)) return !0;
		var i, n, r, o, a, s = t.replace(/ /g, "").toUpperCase(), l = "", c = !0, u = "";
		if (s.length < 5) return !1;
		if (void 0 !== (r = {
			AL: "\\d{8}[\\dA-Z]{16}",
			AD: "\\d{8}[\\dA-Z]{12}",
			AT: "\\d{16}",
			AZ: "[\\dA-Z]{4}\\d{20}",
			BE: "\\d{12}",
			BH: "[A-Z]{4}[\\dA-Z]{14}",
			BA: "\\d{16}",
			BR: "\\d{23}[A-Z][\\dA-Z]",
			BG: "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
			CR: "\\d{17}",
			HR: "\\d{17}",
			CY: "\\d{8}[\\dA-Z]{16}",
			CZ: "\\d{20}",
			DK: "\\d{14}",
			DO: "[A-Z]{4}\\d{20}",
			EE: "\\d{16}",
			FO: "\\d{14}",
			FI: "\\d{14}",
			FR: "\\d{10}[\\dA-Z]{11}\\d{2}",
			GE: "[\\dA-Z]{2}\\d{16}",
			DE: "\\d{18}",
			GI: "[A-Z]{4}[\\dA-Z]{15}",
			GR: "\\d{7}[\\dA-Z]{16}",
			GL: "\\d{14}",
			GT: "[\\dA-Z]{4}[\\dA-Z]{20}",
			HU: "\\d{24}",
			IS: "\\d{22}",
			IE: "[\\dA-Z]{4}\\d{14}",
			IL: "\\d{19}",
			IT: "[A-Z]\\d{10}[\\dA-Z]{12}",
			KZ: "\\d{3}[\\dA-Z]{13}",
			KW: "[A-Z]{4}[\\dA-Z]{22}",
			LV: "[A-Z]{4}[\\dA-Z]{13}",
			LB: "\\d{4}[\\dA-Z]{20}",
			LI: "\\d{5}[\\dA-Z]{12}",
			LT: "\\d{16}",
			LU: "\\d{3}[\\dA-Z]{13}",
			MK: "\\d{3}[\\dA-Z]{10}\\d{2}",
			MT: "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
			MR: "\\d{23}",
			MU: "[A-Z]{4}\\d{19}[A-Z]{3}",
			MC: "\\d{10}[\\dA-Z]{11}\\d{2}",
			MD: "[\\dA-Z]{2}\\d{18}",
			ME: "\\d{18}",
			NL: "[A-Z]{4}\\d{10}",
			NO: "\\d{11}",
			PK: "[\\dA-Z]{4}\\d{16}",
			PS: "[\\dA-Z]{4}\\d{21}",
			PL: "\\d{24}",
			PT: "\\d{21}",
			RO: "[A-Z]{4}[\\dA-Z]{16}",
			SM: "[A-Z]\\d{10}[\\dA-Z]{12}",
			SA: "\\d{2}[\\dA-Z]{18}",
			RS: "\\d{18}",
			SK: "\\d{20}",
			SI: "\\d{15}",
			ES: "\\d{20}",
			SE: "\\d{20}",
			CH: "\\d{5}[\\dA-Z]{12}",
			TN: "\\d{20}",
			TR: "\\d{5}[\\dA-Z]{17}",
			AE: "\\d{3}\\d{16}",
			GB: "[A-Z]{4}\\d{14}",
			VG: "[\\dA-Z]{4}\\d{16}"
		}[s.substring(0, 2)]) && !new RegExp("^[A-Z]{2}\\d{2}" + r + "$", "").test(s)) return !1;
		for (i = s.substring(4, s.length) + s.substring(0, 4), o = 0; o < i.length; o++) "0" !== (n = i.charAt(o)) && (c = !1), c || (l += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(n));
		for (a = 0; a < l.length; a++) u = ("" + u + l.charAt(a)) % 97;
		return 1 === u
	}, "Please specify a valid IBAN"), t.validator.addMethod("integer", function (t, e) {
		return this.optional(e) || /^-?\d+$/.test(t)
	}, "A positive or negative non-decimal number please"), t.validator.addMethod("ipv4", function (t, e) {
		return this.optional(e) || /^(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)$/i.test(t)
	}, "Please enter a valid IP v4 address."), t.validator.addMethod("ipv6", function (t, e) {
		return this.optional(e) || /^((([0-9A-Fa-f]{1,4}:){7}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){6}:[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){5}:([0-9A-Fa-f]{1,4}:)?[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){4}:([0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){3}:([0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){2}:([0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){6}((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|(([0-9A-Fa-f]{1,4}:){0,5}:((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|(::([0-9A-Fa-f]{1,4}:){0,5}((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|([0-9A-Fa-f]{1,4}::([0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})|(::([0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){1,7}:))$/i.test(t)
	}, "Please enter a valid IP v6 address."), t.validator.addMethod("lettersonly", function (t, e) {
		return this.optional(e) || /^[a-z]+$/i.test(t)
	}, "Letters only please"), t.validator.addMethod("letterswithbasicpunc", function (t, e) {
		return this.optional(e) || /^[a-z\-.,()'"\s]+$/i.test(t)
	}, "Letters or punctuation only please"), t.validator.addMethod("mobileNL", function (t, e) {
		return this.optional(e) || /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)6((\s|\s?\-\s?)?[0-9]){8}$/.test(t)
	}, "Please specify a valid mobile number"), t.validator.addMethod("mobileUK", function (t, e) {
		return t = t.replace(/\(|\)|\s+|-/g, ""), this.optional(e) || t.length > 9 && t.match(/^(?:(?:(?:00\s?|\+)44\s?|0)7(?:[1345789]\d{2}|624)\s?\d{3}\s?\d{3})$/)
	}, "Please specify a valid mobile number"), t.validator.addMethod("netmask", function (t, e) {
		return this.optional(e) || /^(254|252|248|240|224|192|128)\.0\.0\.0|255\.(254|252|248|240|224|192|128|0)\.0\.0|255\.255\.(254|252|248|240|224|192|128|0)\.0|255\.255\.255\.(254|252|248|240|224|192|128|0)/i.test(t)
	}, "Please enter a valid netmask."), t.validator.addMethod("nieES", function (t, e) {
		"use strict";
		if (this.optional(e)) return !0;
		var i, n = new RegExp(/^[MXYZ]{1}[0-9]{7,8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/gi), r = t.substr(t.length - 1).toUpperCase();
		return !((t = t.toString().toUpperCase()).length > 10 || t.length < 9 || !n.test(t)) && (i = 9 === (t = t.replace(/^[X]/, "0").replace(/^[Y]/, "1").replace(/^[Z]/, "2")).length ? t.substr(0, 8) : t.substr(0, 9), "TRWAGMYFPDXBNJZSQVHLCKET".charAt(parseInt(i, 10) % 23) === r)
	}, "Please specify a valid NIE number."), t.validator.addMethod("nifES", function (t, e) {
		"use strict";
		return !!this.optional(e) || !!(t = t.toUpperCase()).match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)") && (/^[0-9]{8}[A-Z]{1}$/.test(t) ? "TRWAGMYFPDXBNJZSQVHLCKE".charAt(t.substring(8, 0) % 23) === t.charAt(8) : !!/^[KLM]{1}/.test(t) && t[8] === "TRWAGMYFPDXBNJZSQVHLCKE".charAt(t.substring(8, 1) % 23))
	}, "Please specify a valid NIF number."), t.validator.addMethod("nipPL", function (t) {
		"use strict";
		if (10 !== (t = t.replace(/[^0-9]/g, "")).length) return !1;
		for (var e = [6, 5, 7, 2, 3, 4, 5, 6, 7], i = 0, n = 0; n < 9; n++) i += e[n] * t[n];
		var r = i % 11;
		return (10 === r ? 0 : r) === parseInt(t[9], 10)
	}, "Please specify a valid NIP number."), t.validator.addMethod("notEqualTo", function (e, i, n) {
		return this.optional(i) || !t.validator.methods.equalTo.call(this, e, i, n)
	}, "Please enter a different value, values must not be the same."), t.validator.addMethod("nowhitespace", function (t, e) {
		return this.optional(e) || /^\S+$/i.test(t)
	}, "No white space please"), t.validator.addMethod("pattern", function (t, e, i) {
		return !!this.optional(e) || ("string" == typeof i && (i = new RegExp("^(?:" + i + ")$")), i.test(t))
	}, "Invalid format."), t.validator.addMethod("phoneNL", function (t, e) {
		return this.optional(e) || /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9]){8}$/.test(t)
	}, "Please specify a valid phone number."), t.validator.addMethod("phonesUK", function (t, e) {
		return t = t.replace(/\(|\)|\s+|-/g, ""), this.optional(e) || t.length > 9 && t.match(/^(?:(?:(?:00\s?|\+)44\s?|0)(?:1\d{8,9}|[23]\d{9}|7(?:[1345789]\d{8}|624\d{6})))$/)
	}, "Please specify a valid uk phone number"), t.validator.addMethod("phoneUK", function (t, e) {
		return t = t.replace(/\(|\)|\s+|-/g, ""), this.optional(e) || t.length > 9 && t.match(/^(?:(?:(?:00\s?|\+)44\s?)|(?:\(?0))(?:\d{2}\)?\s?\d{4}\s?\d{4}|\d{3}\)?\s?\d{3}\s?\d{3,4}|\d{4}\)?\s?(?:\d{5}|\d{3}\s?\d{3})|\d{5}\)?\s?\d{4,5})$/)
	}, "Please specify a valid phone number"), t.validator.addMethod("phoneUS", function (t, e) {
		return t = t.replace(/\s+/g, ""), this.optional(e) || t.length > 9 && t.match(/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/)
	}, "Please specify a valid phone number"), t.validator.addMethod("postalcodeBR", function (t, e) {
		return this.optional(e) || /^\d{2}.\d{3}-\d{3}?$|^\d{5}-?\d{3}?$/.test(t)
	}, "Informe um CEP válido."), t.validator.addMethod("postalCodeCA", function (t, e) {
		return this.optional(e) || /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ] *\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i.test(t)
	}, "Please specify a valid postal code"), t.validator.addMethod("postalcodeIT", function (t, e) {
		return this.optional(e) || /^\d{5}$/.test(t)
	}, "Please specify a valid postal code"), t.validator.addMethod("postalcodeNL", function (t, e) {
		return this.optional(e) || /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/.test(t)
	}, "Please specify a valid postal code"), t.validator.addMethod("postcodeUK", function (t, e) {
		return this.optional(e) || /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i.test(t)
	}, "Please specify a valid UK postcode"), t.validator.addMethod("require_from_group", function (e, i, n) {
		var r = t(n[1], i.form), o = r.eq(0), a = o.data("valid_req_grp") ? o.data("valid_req_grp") : t.extend({}, this), s = r.filter(function () {
			return a.elementValue(this)
		}).length >= n[0];
		return o.data("valid_req_grp", a), t(i).data("being_validated") || (r.data("being_validated", !0), r.each(function () {
			a.element(this)
		}), r.data("being_validated", !1)), s
	}, t.validator.format("Please fill at least {0} of these fields.")), t.validator.addMethod("skip_or_fill_minimum", function (e, i, n) {
		var r = t(n[1], i.form), o = r.eq(0), a = o.data("valid_skip") ? o.data("valid_skip") : t.extend({}, this), s = r.filter(function () {
			return a.elementValue(this)
		}).length, l = 0 === s || s >= n[0];
		return o.data("valid_skip", a), t(i).data("being_validated") || (r.data("being_validated", !0), r.each(function () {
			a.element(this)
		}), r.data("being_validated", !1)), l
	}, t.validator.format("Please either skip these fields or fill at least {0} of them.")), t.validator.addMethod("stateUS", function (t, e, i) {
		var n, r = void 0 === i, o = !r && void 0 !== i.caseSensitive && i.caseSensitive, a = !r && void 0 !== i.includeTerritories && i.includeTerritories, s = !r && void 0 !== i.includeMilitary && i.includeMilitary;
		return n = a || s ? a && s ? "^(A[AEKLPRSZ]|C[AOT]|D[CE]|FL|G[AU]|HI|I[ADLN]|K[SY]|LA|M[ADEINOPST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$" : a ? "^(A[KLRSZ]|C[AOT]|D[CE]|FL|G[AU]|HI|I[ADLN]|K[SY]|LA|M[ADEINOPST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$" : "^(A[AEKLPRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])$" : "^(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])$", n = o ? new RegExp(n) : new RegExp(n, "i"), this.optional(e) || n.test(t)
	}, "Please specify a valid state"), t.validator.addMethod("strippedminlength", function (e, i, n) {
		return t(e).text().length >= n
	}, t.validator.format("Please enter at least {0} characters")), t.validator.addMethod("time", function (t, e) {
		return this.optional(e) || /^([01]\d|2[0-3]|[0-9])(:[0-5]\d){1,2}$/.test(t)
	}, "Please enter a valid time, between 00:00 and 23:59"), t.validator.addMethod("time12h", function (t, e) {
		return this.optional(e) || /^((0?[1-9]|1[012])(:[0-5]\d){1,2}(\ ?[AP]M))$/i.test(t)
	}, "Please enter a valid time in 12-hour am/pm format"), t.validator.addMethod("url2", function (t, e) {
		return this.optional(e) || /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)*(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(t)
	}, t.validator.messages.url), t.validator.addMethod("vinUS", function (t) {
		if (17 !== t.length) return !1;
		var e, i, n, r, o, a, s = ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"], l = [1, 2, 3, 4, 5, 6, 7, 8, 1, 2, 3, 4, 5, 7, 9, 2, 3, 4, 5, 6, 7, 8, 9], c = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2], u = 0;
		for (e = 0; e < 17; e++) {
			if (r = c[e], n = t.slice(e, e + 1), 8 === e && (a = n), isNaN(n)) {
				for (i = 0; i < s.length; i++) if (n.toUpperCase() === s[i]) {
					n = l[i], n *= r, isNaN(a) && 8 === i && (a = s[i]);
					break
				}
			} else n *= r;
			u += n
		}
		return 10 === (o = u % 11) && (o = "X"), o === a
	}, "The specified vehicle identification number (VIN) is invalid."), t.validator.addMethod("zipcodeUS", function (t, e) {
		return this.optional(e) || /^\d{5}(-\d{4})?$/.test(t)
	}, "The specified US ZIP Code is invalid"), t.validator.addMethod("ziprange", function (t, e) {
		return this.optional(e) || /^90[2-5]\d\{2\}-\d{4}$/.test(t)
	}, "Your ZIP-code must be in the range 902xx-xxxx to 905xx-xxxx"), t
});
var valGetParentContainer = function (t) {
	t = $(t);
	return $(t).closest(".form-group-sub").length > 0 ? $(t).closest(".form-group-sub") : $(t).closest(".bootstrap-select").length > 0 ? $(t).closest(".bootstrap-select") : $(t).closest(".form-group")
};
jQuery.validator.setDefaults({
	errorElement: "div", focusInvalid: !1, ignore: "", errorPlacement: function (t, e) {
		e = $(e);
		var i = valGetParentContainer(e), n = i.find(".form-text");
		0 === i.find(".valid-feedback, .invalid-feedback").length && (e.addClass("is-invalid"), t.addClass("invalid-feedback"), n.length > 0 ? n.before(t) : e.closest(".bootstrap-select").length > 0 ? e.closest(".bootstrap-select").find(".bs-placeholder").after(t) : e.closest(".input-group").length > 0 ? e.after(t) : e.is(":checkbox") ? e.closest(".k-checkbox").find("> span").after(t) : e.after(t))
	}, highlight: function (t) {
		var e = valGetParentContainer(t);
		e.addClass("validate"), e.addClass("is-invalid"), $(t).removeClass("is-valid")
	}, unhighlight: function (t) {
		var e = valGetParentContainer(t);
		e.removeClass("validate"), e.removeClass("is-invalid"), $(t).removeClass("is-invalid")
	}, success: function (t, e) {
		var i = valGetParentContainer(e);
		i.removeClass("validate"), i.find(".invalid-feedback").remove()
	}
}), jQuery.validator.addMethod("email", function (t, e) {
	return !!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(t)
}, "Please enter a valid Email."), ("function" == typeof define && define.amd ? define : function (t, e) {
	"undefined" != typeof module && module.exports ? module.exports = e(require("jquery")) : window.toastr = e(window.jQuery)
})(["jquery"], function (t) {
	return function () {
		function e(e, i) {
			return e || (e = a()), (l = t("#" + e.containerId)).length ? l : (i && (l = function (e) {
				return (l = t("<div/>").attr("id", e.containerId).addClass(e.positionClass)).appendTo(t(e.target)), l
			}(e)), l)
		}

		function i(e) {
			for (var i = l.children(), r = i.length - 1; r >= 0; r--) n(t(i[r]), e)
		}

		function n(e, i, n) {
			var r = !(!n || !n.force) && n.force;
			return !(!e || !r && 0 !== t(":focus", e).length || (e[i.hideMethod]({
				duration: i.hideDuration, easing: i.hideEasing, complete: function () {
					s(e)
				}
			}), 0))
		}

		function r(t) {
			c && c(t)
		}

		function o(i) {
			function n(t) {
				return null == t && (t = ""), t.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
			}

			function o(e) {
				var i = e && !1 !== f.closeMethod ? f.closeMethod : f.hideMethod, n = e && !1 !== f.closeDuration ? f.closeDuration : f.hideDuration, o = e && !1 !== f.closeEasing ? f.closeEasing : f.hideEasing;
				if (!t(":focus", v).length || e) return clearTimeout(k.intervalId), v[i]({
					duration: n, easing: o, complete: function () {
						s(v), clearTimeout(g), f.onHidden && "hidden" !== _.state && f.onHidden(), _.state = "hidden", _.endTime = new Date, r(_)
					}
				})
			}

			function c() {
				(f.timeOut > 0 || f.extendedTimeOut > 0) && (g = setTimeout(o, f.extendedTimeOut), k.maxHideTime = parseFloat(f.extendedTimeOut), k.hideEta = (new Date).getTime() + k.maxHideTime)
			}

			function d() {
				clearTimeout(g), k.hideEta = 0, v.stop(!0, !0)[f.showMethod]({duration: f.showDuration, easing: f.showEasing})
			}

			function p() {
				var t = (k.hideEta - (new Date).getTime()) / k.maxHideTime * 100;
				w.width(t + "%")
			}

			var f = a(), m = i.iconClass || f.iconClass;
			if (void 0 !== i.optionsOverride && (f = t.extend(f, i.optionsOverride), m = i.optionsOverride.iconClass || m), !function (t, e) {
				if (t.preventDuplicates) {
					if (e.message === u) return !0;
					u = e.message
				}
				return !1
			}(f, i)) {
				h++, l = e(f, !0);
				var g = null, v = t("<div/>"), y = t("<div/>"), b = t("<div/>"), w = t("<div/>"), x = t(f.closeHtml), k = {intervalId: null, hideEta: null, maxHideTime: null}, _ = {toastId: h, state: "visible", startTime: new Date, options: f, map: i};
				return i.iconClass && v.addClass(f.toastClass).addClass(m), function () {
					if (i.title) {
						var t = i.title;
						f.escapeHtml && (t = n(i.title)), y.append(t).addClass(f.titleClass), v.append(y)
					}
				}(), function () {
					if (i.message) {
						var t = i.message;
						f.escapeHtml && (t = n(i.message)), b.append(t).addClass(f.messageClass), v.append(b)
					}
				}(), f.closeButton && (x.addClass(f.closeClass).attr("role", "button"), v.prepend(x)), f.progressBar && (w.addClass(f.progressClass), v.prepend(w)), f.rtl && v.addClass("rtl"), f.newestOnTop ? l.prepend(v) : l.append(v), function () {
					var t = "";
					switch (i.iconClass) {
						case"toast-success":
						case"toast-info":
							t = "polite";
							break;
						default:
							t = "assertive"
					}
					v.attr("aria-live", t)
				}(), v.hide(), v[f.showMethod]({
					duration: f.showDuration,
					easing: f.showEasing,
					complete: f.onShown
				}), f.timeOut > 0 && (g = setTimeout(o, f.timeOut), k.maxHideTime = parseFloat(f.timeOut), k.hideEta = (new Date).getTime() + k.maxHideTime, f.progressBar && (k.intervalId = setInterval(p, 10))), f.closeOnHover && v.hover(d, c), !f.onclick && f.tapToDismiss && v.click(o), f.closeButton && x && x.click(function (t) {
					t.stopPropagation ? t.stopPropagation() : void 0 !== t.cancelBubble && !0 !== t.cancelBubble && (t.cancelBubble = !0), f.onCloseClick && f.onCloseClick(t), o(!0)
				}), f.onclick && v.click(function (t) {
					f.onclick(t), o()
				}), r(_), f.debug && console && console.log(_), v
			}
		}

		function a() {
			return t.extend({}, {
				tapToDismiss: !0,
				toastClass: "toast",
				containerId: "toast-container",
				debug: !1,
				showMethod: "fadeIn",
				showDuration: 300,
				showEasing: "swing",
				onShown: void 0,
				hideMethod: "fadeOut",
				hideDuration: 1e3,
				hideEasing: "swing",
				onHidden: void 0,
				closeMethod: !1,
				closeDuration: !1,
				closeEasing: !1,
				closeOnHover: !0,
				extendedTimeOut: 1e3,
				iconClasses: {error: "toast-error", info: "toast-info", success: "toast-success", warning: "toast-warning"},
				iconClass: "toast-info",
				positionClass: "toast-top-right",
				timeOut: 5e3,
				titleClass: "toast-title",
				messageClass: "toast-message",
				escapeHtml: !1,
				target: "body",
				closeHtml: '<button type="button">&times;</button>',
				closeClass: "toast-close-button",
				newestOnTop: !0,
				preventDuplicates: !1,
				progressBar: !1,
				progressClass: "toast-progress",
				rtl: !1
			}, p.options)
		}

		function s(t) {
			l || (l = e()), t.is(":visible") || (t.remove(), t = null, 0 === l.children().length && (l.remove(), u = void 0))
		}

		var l, c, u, h = 0, d = {error: "error", info: "info", success: "success", warning: "warning"}, p = {
			clear: function (t, r) {
				var o = a();
				l || e(o), n(t, o, r) || i(o)
			}, remove: function (i) {
				var n = a();
				return l || e(n), i && 0 === t(":focus", i).length ? void s(i) : void (l.children().length && l.remove())
			}, error: function (t, e, i) {
				return o({type: d.error, iconClass: a().iconClasses.error, message: t, optionsOverride: i, title: e})
			}, getContainer: e, info: function (t, e, i) {
				return o({type: d.info, iconClass: a().iconClasses.info, message: t, optionsOverride: i, title: e})
			}, options: {}, subscribe: function (t) {
				c = t
			}, success: function (t, e, i) {
				return o({type: d.success, iconClass: a().iconClasses.success, message: t, optionsOverride: i, title: e})
			}, version: "2.1.4", warning: function (t, e, i) {
				return o({type: d.warning, iconClass: a().iconClasses.warning, message: t, optionsOverride: i, title: e})
			}
		};
		return p
	}()
}), function (t, e) {
	"object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Raphael = e() : t.Raphael = e()
}(this, function () {
	return function (t) {
		var e = {};

		function i(n) {
			if (e[n]) return e[n].exports;
			var r = e[n] = {exports: {}, id: n, loaded: !1};
			return t[n].call(r.exports, r, r.exports, i), r.loaded = !0, r.exports
		}

		return i.m = t, i.c = e, i.p = "", i(0)
	}([function (t, e, i) {
		var n, r;
		n = [i(1), i(3), i(4)], void 0 === (r = function (t) {
			return t
		}.apply(e, n)) || (t.exports = r)
	}, function (t, e, i) {
		var n, r;
		n = [i(2)], void 0 === (r = function (t) {
			function e(n) {
				if (e.is(n, "function")) return i ? n() : t.on("raphael.DOMload", n);
				if (e.is(n, M)) return e._engine.create[h](e, n.splice(0, 3 + e.is(n[0], T))).add(n);
				var r = Array.prototype.slice.call(arguments, 0);
				if (e.is(r[r.length - 1], "function")) {
					var o = r.pop();
					return i ? o.call(e._engine.create[h](e, r)) : t.on("raphael.DOMload", function () {
						o.call(e._engine.create[h](e, r))
					})
				}
				return e._engine.create[h](e, arguments)
			}

			e.version = "2.2.0", e.eve = t;
			var i, n, r = /[, ]+/, o = {circle: 1, rect: 1, path: 1, ellipse: 1, text: 1, image: 1}, a = /\{(\d+)\}/g, s = "hasOwnProperty", l = {doc: document, win: window}, c = {was: Object.prototype[s].call(l.win, "Raphael"), is: l.win.Raphael}, u = function () {
					this.ca = this.customAttributes = {}
				}, h = "apply", d = "concat", p = "ontouchstart" in l.win || l.win.DocumentTouch && l.doc instanceof DocumentTouch, f = "", m = " ", g = String, v = "split", y = "click dblclick mousedown mousemove mouseout mouseover mouseup touchstart touchmove touchend touchcancel"[v](m),
				b = {mousedown: "touchstart", mousemove: "touchmove", mouseup: "touchend"}, w = g.prototype.toLowerCase, x = Math, k = x.max, _ = x.min, S = x.abs, C = x.pow, D = x.PI, T = "number", M = "array", E = Object.prototype.toString,
				A = (e._ISURL = /^url\(['"]?(.+?)['"]?\)$/i, /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i),
				P = {NaN: 1, Infinity: 1, "-Infinity": 1}, I = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/, O = x.round, L = parseFloat, F = parseInt, N = g.prototype.toUpperCase, R = e._availableAttrs = {
					"arrow-end": "none",
					"arrow-start": "none",
					blur: 0,
					"clip-rect": "0 0 1e9 1e9",
					cursor: "default",
					cx: 0,
					cy: 0,
					fill: "#fff",
					"fill-opacity": 1,
					font: '10px "Arial"',
					"font-family": '"Arial"',
					"font-size": "10",
					"font-style": "normal",
					"font-weight": 400,
					gradient: 0,
					height: 0,
					href: "http://raphaeljs.com/",
					"letter-spacing": 0,
					opacity: 1,
					path: "M0,0",
					r: 0,
					rx: 0,
					ry: 0,
					src: "",
					stroke: "#000",
					"stroke-dasharray": "",
					"stroke-linecap": "butt",
					"stroke-linejoin": "butt",
					"stroke-miterlimit": 0,
					"stroke-opacity": 1,
					"stroke-width": 1,
					target: "_blank",
					"text-anchor": "middle",
					title: "Raphael",
					transform: "",
					width: 0,
					x: 0,
					y: 0,
					class: ""
				}, H = e._availableAnimAttrs = {blur: T, "clip-rect": "csv", cx: T, cy: T, fill: "colour", "fill-opacity": T, "font-size": T, height: T, opacity: T, path: "path", r: T, rx: T, ry: T, stroke: "colour", "stroke-opacity": T, "stroke-width": T, transform: "transform", width: T, x: T, y: T},
				$ = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/,
				B = {hs: 1, rg: 1}, z = /,?([achlmqrstvxz]),?/gi,
				j = /([achlmrqstvz])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/gi,
				U = /([rstm])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/gi,
				W = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/gi,
				Y = (e._radial_gradient = /^r(?:\(([^,]+?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*([^\)]+?)\))?/, {}),
				V = function (t, e) {
					return L(t) - L(e)
				}, q = function (t) {
					return t
				}, G = e._rectPath = function (t, e, i, n, r) {
					return r ? [["M", t + r, e], ["l", i - 2 * r, 0], ["a", r, r, 0, 0, 1, r, r], ["l", 0, n - 2 * r], ["a", r, r, 0, 0, 1, -r, r], ["l", 2 * r - i, 0], ["a", r, r, 0, 0, 1, -r, -r], ["l", 0, 2 * r - n], ["a", r, r, 0, 0, 1, r, -r], ["z"]] : [["M", t, e], ["l", i, 0], ["l", 0, n], ["l", -i, 0], ["z"]]
				}, K = function (t, e, i, n) {
					return null == n && (n = i), [["M", t, e], ["m", 0, -n], ["a", i, n, 0, 1, 1, 0, 2 * n], ["a", i, n, 0, 1, 1, 0, -2 * n], ["z"]]
				}, X = e._getPath = {
					path: function (t) {
						return t.attr("path")
					}, circle: function (t) {
						var e = t.attrs;
						return K(e.cx, e.cy, e.r)
					}, ellipse: function (t) {
						var e = t.attrs;
						return K(e.cx, e.cy, e.rx, e.ry)
					}, rect: function (t) {
						var e = t.attrs;
						return G(e.x, e.y, e.width, e.height, e.r)
					}, image: function (t) {
						var e = t.attrs;
						return G(e.x, e.y, e.width, e.height)
					}, text: function (t) {
						var e = t._getBBox();
						return G(e.x, e.y, e.width, e.height)
					}, set: function (t) {
						var e = t._getBBox();
						return G(e.x, e.y, e.width, e.height)
					}
				}, Z = e.mapPath = function (t, e) {
					if (!e) return t;
					var i, n, r, o, a, s, l;
					for (r = 0, a = (t = Tt(t)).length; r < a; r++) for (o = 1, s = (l = t[r]).length; o < s; o += 2) i = e.x(l[o], l[o + 1]), n = e.y(l[o], l[o + 1]), l[o] = i, l[o + 1] = n;
					return t
				};
			if (e._g = l, e.type = l.win.SVGAngle || l.doc.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1") ? "SVG" : "VML", "VML" == e.type) {
				var Q, J = l.doc.createElement("div");
				if (J.innerHTML = '<v:shape adj="1"/>', (Q = J.firstChild).style.behavior = "url(#default#VML)", !Q || "object" != typeof Q.adj) return e.type = f;
				J = null
			}

			function tt(t) {
				if ("function" == typeof t || Object(t) !== t) return t;
				var e = new t.constructor;
				for (var i in t) t[s](i) && (e[i] = tt(t[i]));
				return e
			}

			e.svg = !(e.vml = "VML" == e.type), e._Paper = u, e.fn = n = u.prototype = e.prototype, e._id = 0, e.is = function (t, e) {
				return "finite" == (e = w.call(e)) ? !P[s](+t) : "array" == e ? t instanceof Array : "null" == e && null === t || e == typeof t && null !== t || "object" == e && t === Object(t) || "array" == e && Array.isArray && Array.isArray(t) || E.call(t).slice(8, -1).toLowerCase() == e
			}, e.angle = function (t, i, n, r, o, a) {
				if (null == o) {
					var s = t - n, l = i - r;
					return s || l ? (180 + 180 * x.atan2(-l, -s) / D + 360) % 360 : 0
				}
				return e.angle(t, i, o, a) - e.angle(n, r, o, a)
			}, e.rad = function (t) {
				return t % 360 * D / 180
			}, e.deg = function (t) {
				return Math.round(180 * t / D % 360 * 1e3) / 1e3
			}, e.snapTo = function (t, i, n) {
				if (n = e.is(n, "finite") ? n : 10, e.is(t, M)) {
					for (var r = t.length; r--;) if (S(t[r] - i) <= n) return t[r]
				} else {
					var o = i % (t = +t);
					if (o < n) return i - o;
					if (o > t - n) return i - o + t
				}
				return i
			};
			var et, it;
			e.createUUID = (et = /[xy]/g, it = function (t) {
				var e = 16 * x.random() | 0;
				return ("x" == t ? e : 3 & e | 8).toString(16)
			}, function () {
				return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(et, it).toUpperCase()
			});
			e.setWindow = function (i) {
				t("raphael.setWindow", e, l.win, i), l.win = i, l.doc = l.win.document, e._engine.initWin && e._engine.initWin(l.win)
			};
			var nt = function (t) {
				if (e.vml) {
					var i, n = /^\s+|\s+$/g;
					try {
						var r = new ActiveXObject("htmlfile");
						r.write("<body>"), r.close(), i = r.body
					} catch (t) {
						i = createPopup().document.body
					}
					var o = i.createTextRange();
					nt = ct(function (t) {
						try {
							i.style.color = g(t).replace(n, f);
							var e = o.queryCommandValue("ForeColor");
							return "#" + ("000000" + (e = (255 & e) << 16 | 65280 & e | (16711680 & e) >>> 16).toString(16)).slice(-6)
						} catch (t) {
							return "none"
						}
					})
				} else {
					var a = l.doc.createElement("i");
					a.title = "Raphaël Colour Picker", a.style.display = "none", l.doc.body.appendChild(a), nt = ct(function (t) {
						return a.style.color = t, l.doc.defaultView.getComputedStyle(a, f).getPropertyValue("color")
					})
				}
				return nt(t)
			}, rt = function () {
				return "hsb(" + [this.h, this.s, this.b] + ")"
			}, ot = function () {
				return "hsl(" + [this.h, this.s, this.l] + ")"
			}, at = function () {
				return this.hex
			}, st = function (t, i, n) {
				if (null == i && e.is(t, "object") && "r" in t && "g" in t && "b" in t && (n = t.b, i = t.g, t = t.r), null == i && e.is(t, "string")) {
					var r = e.getRGB(t);
					t = r.r, i = r.g, n = r.b
				}
				return (t > 1 || i > 1 || n > 1) && (t /= 255, i /= 255, n /= 255), [t, i, n]
			}, lt = function (t, i, n, r) {
				var o = {r: t *= 255, g: i *= 255, b: n *= 255, hex: e.rgb(t, i, n), toString: at};
				return e.is(r, "finite") && (o.opacity = r), o
			};

			function ct(t, e, i) {
				return function n() {
					var r = Array.prototype.slice.call(arguments, 0), o = r.join("␀"), a = n.cache = n.cache || {}, l = n.count = n.count || [];
					return a[s](o) ? (function (t, e) {
						for (var i = 0, n = t.length; i < n; i++) if (t[i] === e) return t.push(t.splice(i, 1)[0])
					}(l, o), i ? i(a[o]) : a[o]) : (l.length >= 1e3 && delete a[l.shift()], l.push(o), a[o] = t[h](e, r), i ? i(a[o]) : a[o])
				}
			}

			e.color = function (t) {
				var i;
				return e.is(t, "object") && "h" in t && "s" in t && "b" in t ? (i = e.hsb2rgb(t), t.r = i.r, t.g = i.g, t.b = i.b, t.hex = i.hex) : e.is(t, "object") && "h" in t && "s" in t && "l" in t ? (i = e.hsl2rgb(t), t.r = i.r, t.g = i.g, t.b = i.b, t.hex = i.hex) : (e.is(t, "string") && (t = e.getRGB(t)), e.is(t, "object") && "r" in t && "g" in t && "b" in t ? (i = e.rgb2hsl(t), t.h = i.h, t.s = i.s, t.l = i.l, i = e.rgb2hsb(t), t.v = i.b) : (t = {hex: "none"}).r = t.g = t.b = t.h = t.s = t.v = t.l = -1), t.toString = at, t
			}, e.hsb2rgb = function (t, e, i, n) {
				var r, o, a, s, l;
				return this.is(t, "object") && "h" in t && "s" in t && "b" in t && (i = t.b, e = t.s, n = t.o, t = t.h), s = (l = i * e) * (1 - S((t = (t *= 360) % 360 / 60) % 2 - 1)), r = o = a = i - l, lt(r += [l, s, 0, 0, s, l][t = ~~t], o += [s, l, l, s, 0, 0][t], a += [0, 0, s, l, l, s][t], n)
			}, e.hsl2rgb = function (t, e, i, n) {
				var r, o, a, s, l;
				return this.is(t, "object") && "h" in t && "s" in t && "l" in t && (i = t.l, e = t.s, t = t.h), (t > 1 || e > 1 || i > 1) && (t /= 360, e /= 100, i /= 100), s = (l = 2 * e * (i < .5 ? i : 1 - i)) * (1 - S((t = (t *= 360) % 360 / 60) % 2 - 1)), r = o = a = i - l / 2, lt(r += [l, s, 0, 0, s, l][t = ~~t], o += [s, l, l, s, 0, 0][t], a += [0, 0, s, l, l, s][t], n)
			}, e.rgb2hsb = function (t, e, i) {
				var n, r;
				return t = (i = st(t, e, i))[0], e = i[1], i = i[2], {h: ((0 == (r = (n = k(t, e, i)) - _(t, e, i)) ? null : n == t ? (e - i) / r : n == e ? (i - t) / r + 2 : (t - e) / r + 4) + 360) % 6 * 60 / 360, s: 0 == r ? 0 : r / n, b: n, toString: rt}
			}, e.rgb2hsl = function (t, e, i) {
				var n, r, o, a;
				return t = (i = st(t, e, i))[0], e = i[1], i = i[2], n = ((r = k(t, e, i)) + (o = _(t, e, i))) / 2, {
					h: ((0 == (a = r - o) ? null : r == t ? (e - i) / a : r == e ? (i - t) / a + 2 : (t - e) / a + 4) + 360) % 6 * 60 / 360,
					s: 0 == a ? 0 : n < .5 ? a / (2 * n) : a / (2 - 2 * n),
					l: n,
					toString: ot
				}
			}, e._path2string = function () {
				return this.join(",").replace(z, "$1")
			};
			e._preload = function (t, e) {
				var i = l.doc.createElement("img");
				i.style.cssText = "position:absolute;left:-9999em;top:-9999em", i.onload = function () {
					e.call(this), this.onload = null, l.doc.body.removeChild(this)
				}, i.onerror = function () {
					l.doc.body.removeChild(this)
				}, l.doc.body.appendChild(i), i.src = t
			};

			function ut() {
				return this.hex
			}

			function ht(t, e) {
				for (var i = [], n = 0, r = t.length; r - 2 * !e > n; n += 2) {
					var o = [{x: +t[n - 2], y: +t[n - 1]}, {x: +t[n], y: +t[n + 1]}, {x: +t[n + 2], y: +t[n + 3]}, {x: +t[n + 4], y: +t[n + 5]}];
					e ? n ? r - 4 == n ? o[3] = {x: +t[0], y: +t[1]} : r - 2 == n && (o[2] = {x: +t[0], y: +t[1]}, o[3] = {x: +t[2], y: +t[3]}) : o[0] = {x: +t[r - 2], y: +t[r - 1]} : r - 4 == n ? o[3] = o[2] : n || (o[0] = {
						x: +t[n],
						y: +t[n + 1]
					}), i.push(["C", (-o[0].x + 6 * o[1].x + o[2].x) / 6, (-o[0].y + 6 * o[1].y + o[2].y) / 6, (o[1].x + 6 * o[2].x - o[3].x) / 6, (o[1].y + 6 * o[2].y - o[3].y) / 6, o[2].x, o[2].y])
				}
				return i
			}

			e.getRGB = ct(function (t) {
				if (!t || (t = g(t)).indexOf("-") + 1) return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: ut};
				if ("none" == t) return {r: -1, g: -1, b: -1, hex: "none", toString: ut};
				!B[s](t.toLowerCase().substring(0, 2)) && "#" != t.charAt() && (t = nt(t));
				var i, n, r, o, a, l, c = t.match(A);
				return c ? (c[2] && (r = F(c[2].substring(5), 16), n = F(c[2].substring(3, 5), 16), i = F(c[2].substring(1, 3), 16)), c[3] && (r = F((a = c[3].charAt(3)) + a, 16), n = F((a = c[3].charAt(2)) + a, 16), i = F((a = c[3].charAt(1)) + a, 16)), c[4] && (l = c[4][v]($), i = L(l[0]), "%" == l[0].slice(-1) && (i *= 2.55), n = L(l[1]), "%" == l[1].slice(-1) && (n *= 2.55), r = L(l[2]), "%" == l[2].slice(-1) && (r *= 2.55), "rgba" == c[1].toLowerCase().slice(0, 4) && (o = L(l[3])), l[3] && "%" == l[3].slice(-1) && (o /= 100)), c[5] ? (l = c[5][v]($), i = L(l[0]), "%" == l[0].slice(-1) && (i *= 2.55), n = L(l[1]), "%" == l[1].slice(-1) && (n *= 2.55), r = L(l[2]), "%" == l[2].slice(-1) && (r *= 2.55), ("deg" == l[0].slice(-3) || "°" == l[0].slice(-1)) && (i /= 360), "hsba" == c[1].toLowerCase().slice(0, 4) && (o = L(l[3])), l[3] && "%" == l[3].slice(-1) && (o /= 100), e.hsb2rgb(i, n, r, o)) : c[6] ? (l = c[6][v]($), i = L(l[0]), "%" == l[0].slice(-1) && (i *= 2.55), n = L(l[1]), "%" == l[1].slice(-1) && (n *= 2.55), r = L(l[2]), "%" == l[2].slice(-1) && (r *= 2.55), ("deg" == l[0].slice(-3) || "°" == l[0].slice(-1)) && (i /= 360), "hsla" == c[1].toLowerCase().slice(0, 4) && (o = L(l[3])), l[3] && "%" == l[3].slice(-1) && (o /= 100), e.hsl2rgb(i, n, r, o)) : ((c = {
					r: i,
					g: n,
					b: r,
					toString: ut
				}).hex = "#" + (16777216 | r | n << 8 | i << 16).toString(16).slice(1), e.is(o, "finite") && (c.opacity = o), c)) : {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: ut}
			}, e), e.hsb = ct(function (t, i, n) {
				return e.hsb2rgb(t, i, n).hex
			}), e.hsl = ct(function (t, i, n) {
				return e.hsl2rgb(t, i, n).hex
			}), e.rgb = ct(function (t, e, i) {
				function n(t) {
					return t + .5 | 0
				}

				return "#" + (16777216 | n(i) | n(e) << 8 | n(t) << 16).toString(16).slice(1)
			}), e.getColor = function (t) {
				var e = this.getColor.start = this.getColor.start || {h: 0, s: 1, b: t || .75}, i = this.hsb2rgb(e.h, e.s, e.b);
				return e.h += .075, e.h > 1 && (e.h = 0, e.s -= .2, e.s <= 0 && (this.getColor.start = {h: 0, s: 1, b: e.b})), i.hex
			}, e.getColor.reset = function () {
				delete this.start
			}, e.parsePathString = function (t) {
				if (!t) return null;
				var i = dt(t);
				if (i.arr) return bt(i.arr);
				var n = {a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0}, r = [];
				return e.is(t, M) && e.is(t[0], M) && (r = bt(t)), r.length || g(t).replace(j, function (t, e, i) {
					var o = [], a = e.toLowerCase();
					if (i.replace(W, function (t, e) {
						e && o.push(+e)
					}), "m" == a && o.length > 2 && (r.push([e][d](o.splice(0, 2))), a = "l", e = "m" == e ? "l" : "L"), "r" == a) r.push([e][d](o)); else for (; o.length >= n[a] && (r.push([e][d](o.splice(0, n[a]))), n[a]);) ;
				}), r.toString = e._path2string, i.arr = bt(r), r
			}, e.parseTransformString = ct(function (t) {
				if (!t) return null;
				var i = [];
				return e.is(t, M) && e.is(t[0], M) && (i = bt(t)), i.length || g(t).replace(U, function (t, e, n) {
					var r = [];
					w.call(e);
					n.replace(W, function (t, e) {
						e && r.push(+e)
					}), i.push([e][d](r))
				}), i.toString = e._path2string, i
			});
			var dt = function (t) {
				var e = dt.ps = dt.ps || {};
				return e[t] ? e[t].sleep = 100 : e[t] = {sleep: 100}, setTimeout(function () {
					for (var i in e) e[s](i) && i != t && (e[i].sleep--, !e[i].sleep && delete e[i])
				}), e[t]
			};

			function pt(t, e, i, n, r) {
				return t * (t * (-3 * e + 9 * i - 9 * n + 3 * r) + 6 * e - 12 * i + 6 * n) - 3 * e + 3 * i
			}

			function ft(t, e, i, n, r, o, a, s, l) {
				null == l && (l = 1);
				for (var c = (l = l > 1 ? 1 : l < 0 ? 0 : l) / 2, u = [-.1252, .1252, -.3678, .3678, -.5873, .5873, -.7699, .7699, -.9041, .9041, -.9816, .9816], h = [.2491, .2491, .2335, .2335, .2032, .2032, .1601, .1601, .1069, .1069, .0472, .0472], d = 0, p = 0; p < 12; p++) {
					var f = c * u[p] + c, m = pt(f, t, i, r, a), g = pt(f, e, n, o, s), v = m * m + g * g;
					d += h[p] * x.sqrt(v)
				}
				return c * d
			}

			function mt(t, e, i, n, r, o, a, s) {
				if (!(k(t, i) < _(r, a) || _(t, i) > k(r, a) || k(e, n) < _(o, s) || _(e, n) > k(o, s))) {
					var l = (t - i) * (o - s) - (e - n) * (r - a);
					if (l) {
						var c = ((t * n - e * i) * (r - a) - (t - i) * (r * s - o * a)) / l, u = ((t * n - e * i) * (o - s) - (e - n) * (r * s - o * a)) / l, h = +c.toFixed(2), d = +u.toFixed(2);
						if (!(h < +_(t, i).toFixed(2) || h > +k(t, i).toFixed(2) || h < +_(r, a).toFixed(2) || h > +k(r, a).toFixed(2) || d < +_(e, n).toFixed(2) || d > +k(e, n).toFixed(2) || d < +_(o, s).toFixed(2) || d > +k(o, s).toFixed(2))) return {x: c, y: u}
					}
				}
			}

			function gt(t, i, n) {
				var r = e.bezierBBox(t), o = e.bezierBBox(i);
				if (!e.isBBoxIntersect(r, o)) return n ? 0 : [];
				for (var a = ft.apply(0, t), s = ft.apply(0, i), l = k(~~(a / 5), 1), c = k(~~(s / 5), 1), u = [], h = [], d = {}, p = n ? 0 : [], f = 0; f < l + 1; f++) {
					var m = e.findDotsAtSegment.apply(e, t.concat(f / l));
					u.push({x: m.x, y: m.y, t: f / l})
				}
				for (f = 0; f < c + 1; f++) m = e.findDotsAtSegment.apply(e, i.concat(f / c)), h.push({x: m.x, y: m.y, t: f / c});
				for (f = 0; f < l; f++) for (var g = 0; g < c; g++) {
					var v = u[f], y = u[f + 1], b = h[g], w = h[g + 1], x = S(y.x - v.x) < .001 ? "y" : "x", C = S(w.x - b.x) < .001 ? "y" : "x", D = mt(v.x, v.y, y.x, y.y, b.x, b.y, w.x, w.y);
					if (D) {
						if (d[D.x.toFixed(4)] == D.y.toFixed(4)) continue;
						d[D.x.toFixed(4)] = D.y.toFixed(4);
						var T = v.t + S((D[x] - v[x]) / (y[x] - v[x])) * (y.t - v.t), M = b.t + S((D[C] - b[C]) / (w[C] - b[C])) * (w.t - b.t);
						T >= 0 && T <= 1.001 && M >= 0 && M <= 1.001 && (n ? p++ : p.push({x: D.x, y: D.y, t1: _(T, 1), t2: _(M, 1)}))
					}
				}
				return p
			}

			function vt(t, i, n) {
				t = e._path2curve(t), i = e._path2curve(i);
				for (var r, o, a, s, l, c, u, h, d, p, f = n ? 0 : [], m = 0, g = t.length; m < g; m++) {
					var v = t[m];
					if ("M" == v[0]) r = l = v[1], o = c = v[2]; else {
						"C" == v[0] ? (d = [r, o].concat(v.slice(1)), r = d[6], o = d[7]) : (d = [r, o, r, o, l, c, l, c], r = l, o = c);
						for (var y = 0, b = i.length; y < b; y++) {
							var w = i[y];
							if ("M" == w[0]) a = u = w[1], s = h = w[2]; else {
								"C" == w[0] ? (p = [a, s].concat(w.slice(1)), a = p[6], s = p[7]) : (p = [a, s, a, s, u, h, u, h], a = u, s = h);
								var x = gt(d, p, n);
								if (n) f += x; else {
									for (var k = 0, _ = x.length; k < _; k++) x[k].segment1 = m, x[k].segment2 = y, x[k].bez1 = d, x[k].bez2 = p;
									f = f.concat(x)
								}
							}
						}
					}
				}
				return f
			}

			e.findDotsAtSegment = function (t, e, i, n, r, o, a, s, l) {
				var c = 1 - l, u = C(c, 3), h = C(c, 2), d = l * l, p = d * l, f = u * t + 3 * h * l * i + 3 * c * l * l * r + p * a, m = u * e + 3 * h * l * n + 3 * c * l * l * o + p * s, g = t + 2 * l * (i - t) + d * (r - 2 * i + t), v = e + 2 * l * (n - e) + d * (o - 2 * n + e),
					y = i + 2 * l * (r - i) + d * (a - 2 * r + i), b = n + 2 * l * (o - n) + d * (s - 2 * o + n), w = c * t + l * i, k = c * e + l * n, _ = c * r + l * a, S = c * o + l * s, T = 90 - 180 * x.atan2(g - y, v - b) / D;
				return (g > y || v < b) && (T += 180), {x: f, y: m, m: {x: g, y: v}, n: {x: y, y: b}, start: {x: w, y: k}, end: {x: _, y: S}, alpha: T}
			}, e.bezierBBox = function (t, i, n, r, o, a, s, l) {
				e.is(t, "array") || (t = [t, i, n, r, o, a, s, l]);
				var c = Dt.apply(null, t);
				return {x: c.min.x, y: c.min.y, x2: c.max.x, y2: c.max.y, width: c.max.x - c.min.x, height: c.max.y - c.min.y}
			}, e.isPointInsideBBox = function (t, e, i) {
				return e >= t.x && e <= t.x2 && i >= t.y && i <= t.y2
			}, e.isBBoxIntersect = function (t, i) {
				var n = e.isPointInsideBBox;
				return n(i, t.x, t.y) || n(i, t.x2, t.y) || n(i, t.x, t.y2) || n(i, t.x2, t.y2) || n(t, i.x, i.y) || n(t, i.x2, i.y) || n(t, i.x, i.y2) || n(t, i.x2, i.y2) || (t.x < i.x2 && t.x > i.x || i.x < t.x2 && i.x > t.x) && (t.y < i.y2 && t.y > i.y || i.y < t.y2 && i.y > t.y)
			}, e.pathIntersection = function (t, e) {
				return vt(t, e)
			}, e.pathIntersectionNumber = function (t, e) {
				return vt(t, e, 1)
			}, e.isPointInsidePath = function (t, i, n) {
				var r = e.pathBBox(t);
				return e.isPointInsideBBox(r, i, n) && vt(t, [["M", i, n], ["H", r.x2 + 10]], 1) % 2 == 1
			}, e._removedFactory = function (e) {
				return function () {
					t("raphael.log", null, "Raphaël: you are calling to method “" + e + "” of removed object", e)
				}
			};
			var yt = e.pathBBox = function (t) {
				var e = dt(t);
				if (e.bbox) return tt(e.bbox);
				if (!t) return {x: 0, y: 0, width: 0, height: 0, x2: 0, y2: 0};
				for (var i, n = 0, r = 0, o = [], a = [], s = 0, l = (t = Tt(t)).length; s < l; s++) if ("M" == (i = t[s])[0]) n = i[1], r = i[2], o.push(n), a.push(r); else {
					var c = Dt(n, r, i[1], i[2], i[3], i[4], i[5], i[6]);
					o = o[d](c.min.x, c.max.x), a = a[d](c.min.y, c.max.y), n = i[5], r = i[6]
				}
				var u = _[h](0, o), p = _[h](0, a), f = k[h](0, o), m = k[h](0, a), g = f - u, v = m - p, y = {x: u, y: p, x2: f, y2: m, width: g, height: v, cx: u + g / 2, cy: p + v / 2};
				return e.bbox = tt(y), y
			}, bt = function (t) {
				var i = tt(t);
				return i.toString = e._path2string, i
			}, wt = e._pathToRelative = function (t) {
				var i = dt(t);
				if (i.rel) return bt(i.rel);
				e.is(t, M) && e.is(t && t[0], M) || (t = e.parsePathString(t));
				var n = [], r = 0, o = 0, a = 0, s = 0, l = 0;
				"M" == t[0][0] && (a = r = t[0][1], s = o = t[0][2], l++, n.push(["M", r, o]));
				for (var c = l, u = t.length; c < u; c++) {
					var h = n[c] = [], d = t[c];
					if (d[0] != w.call(d[0])) switch (h[0] = w.call(d[0]), h[0]) {
						case"a":
							h[1] = d[1], h[2] = d[2], h[3] = d[3], h[4] = d[4], h[5] = d[5], h[6] = +(d[6] - r).toFixed(3), h[7] = +(d[7] - o).toFixed(3);
							break;
						case"v":
							h[1] = +(d[1] - o).toFixed(3);
							break;
						case"m":
							a = d[1], s = d[2];
						default:
							for (var p = 1, f = d.length; p < f; p++) h[p] = +(d[p] - (p % 2 ? r : o)).toFixed(3)
					} else {
						h = n[c] = [], "m" == d[0] && (a = d[1] + r, s = d[2] + o);
						for (var m = 0, g = d.length; m < g; m++) n[c][m] = d[m]
					}
					var v = n[c].length;
					switch (n[c][0]) {
						case"z":
							r = a, o = s;
							break;
						case"h":
							r += +n[c][v - 1];
							break;
						case"v":
							o += +n[c][v - 1];
							break;
						default:
							r += +n[c][v - 2], o += +n[c][v - 1]
					}
				}
				return n.toString = e._path2string, i.rel = bt(n), n
			}, xt = e._pathToAbsolute = function (t) {
				var i = dt(t);
				if (i.abs) return bt(i.abs);
				if (e.is(t, M) && e.is(t && t[0], M) || (t = e.parsePathString(t)), !t || !t.length) return [["M", 0, 0]];
				var n = [], r = 0, o = 0, a = 0, s = 0, l = 0;
				"M" == t[0][0] && (a = r = +t[0][1], s = o = +t[0][2], l++, n[0] = ["M", r, o]);
				for (var c, u, h = 3 == t.length && "M" == t[0][0] && "R" == t[1][0].toUpperCase() && "Z" == t[2][0].toUpperCase(), p = l, f = t.length; p < f; p++) {
					if (n.push(c = []), (u = t[p])[0] != N.call(u[0])) switch (c[0] = N.call(u[0]), c[0]) {
						case"A":
							c[1] = u[1], c[2] = u[2], c[3] = u[3], c[4] = u[4], c[5] = u[5], c[6] = +(u[6] + r), c[7] = +(u[7] + o);
							break;
						case"V":
							c[1] = +u[1] + o;
							break;
						case"H":
							c[1] = +u[1] + r;
							break;
						case"R":
							for (var m = [r, o][d](u.slice(1)), g = 2, v = m.length; g < v; g++) m[g] = +m[g] + r, m[++g] = +m[g] + o;
							n.pop(), n = n[d](ht(m, h));
							break;
						case"M":
							a = +u[1] + r, s = +u[2] + o;
						default:
							for (g = 1, v = u.length; g < v; g++) c[g] = +u[g] + (g % 2 ? r : o)
					} else if ("R" == u[0]) m = [r, o][d](u.slice(1)), n.pop(), n = n[d](ht(m, h)), c = ["R"][d](u.slice(-2)); else for (var y = 0, b = u.length; y < b; y++) c[y] = u[y];
					switch (c[0]) {
						case"Z":
							r = a, o = s;
							break;
						case"H":
							r = c[1];
							break;
						case"V":
							o = c[1];
							break;
						case"M":
							a = c[c.length - 2], s = c[c.length - 1];
						default:
							r = c[c.length - 2], o = c[c.length - 1]
					}
				}
				return n.toString = e._path2string, i.abs = bt(n), n
			}, kt = function (t, e, i, n) {
				return [t, e, i, n, i, n]
			}, _t = function (t, e, i, n, r, o) {
				return [1 / 3 * t + 2 / 3 * i, 1 / 3 * e + 2 / 3 * n, 1 / 3 * r + 2 / 3 * i, 1 / 3 * o + 2 / 3 * n, r, o]
			}, St = function (t, e, i, n, r, o, a, s, l, c) {
				var u, h = 120 * D / 180, p = D / 180 * (+r || 0), f = [], m = ct(function (t, e, i) {
					return {x: t * x.cos(i) - e * x.sin(i), y: t * x.sin(i) + e * x.cos(i)}
				});
				if (c) M = c[0], E = c[1], C = c[2], T = c[3]; else {
					t = (u = m(t, e, -p)).x, e = u.y, s = (u = m(s, l, -p)).x, l = u.y;
					x.cos(D / 180 * r), x.sin(D / 180 * r);
					var g = (t - s) / 2, y = (e - l) / 2, b = g * g / (i * i) + y * y / (n * n);
					b > 1 && (i *= b = x.sqrt(b), n *= b);
					var w = i * i, k = n * n, _ = (o == a ? -1 : 1) * x.sqrt(S((w * k - w * y * y - k * g * g) / (w * y * y + k * g * g))), C = _ * i * y / n + (t + s) / 2, T = _ * -n * g / i + (e + l) / 2, M = x.asin(((e - T) / n).toFixed(9)), E = x.asin(((l - T) / n).toFixed(9));
					(M = t < C ? D - M : M) < 0 && (M = 2 * D + M), (E = s < C ? D - E : E) < 0 && (E = 2 * D + E), a && M > E && (M -= 2 * D), !a && E > M && (E -= 2 * D)
				}
				var A = E - M;
				if (S(A) > h) {
					var P = E, I = s, O = l;
					E = M + h * (a && E > M ? 1 : -1), s = C + i * x.cos(E), l = T + n * x.sin(E), f = St(s, l, i, n, r, 0, a, I, O, [E, P, C, T])
				}
				A = E - M;
				var L = x.cos(M), F = x.sin(M), N = x.cos(E), R = x.sin(E), H = x.tan(A / 4), $ = 4 / 3 * i * H, B = 4 / 3 * n * H, z = [t, e], j = [t + $ * F, e - B * L], U = [s + $ * R, l - B * N], W = [s, l];
				if (j[0] = 2 * z[0] - j[0], j[1] = 2 * z[1] - j[1], c) return [j, U, W][d](f);
				for (var Y = [], V = 0, q = (f = [j, U, W][d](f).join()[v](",")).length; V < q; V++) Y[V] = V % 2 ? m(f[V - 1], f[V], p).y : m(f[V], f[V + 1], p).x;
				return Y
			}, Ct = function (t, e, i, n, r, o, a, s, l) {
				var c = 1 - l;
				return {x: C(c, 3) * t + 3 * C(c, 2) * l * i + 3 * c * l * l * r + C(l, 3) * a, y: C(c, 3) * e + 3 * C(c, 2) * l * n + 3 * c * l * l * o + C(l, 3) * s}
			}, Dt = ct(function (t, e, i, n, r, o, a, s) {
				var l, c = r - 2 * i + t - (a - 2 * r + i), u = 2 * (i - t) - 2 * (r - i), d = t - i, p = (-u + x.sqrt(u * u - 4 * c * d)) / 2 / c, f = (-u - x.sqrt(u * u - 4 * c * d)) / 2 / c, m = [e, s], g = [t, a];
				return S(p) > "1e12" && (p = .5), S(f) > "1e12" && (f = .5), p > 0 && p < 1 && (l = Ct(t, e, i, n, r, o, a, s, p), g.push(l.x), m.push(l.y)), f > 0 && f < 1 && (l = Ct(t, e, i, n, r, o, a, s, f), g.push(l.x), m.push(l.y)), c = o - 2 * n + e - (s - 2 * o + n), d = e - n, p = (-(u = 2 * (n - e) - 2 * (o - n)) + x.sqrt(u * u - 4 * c * d)) / 2 / c, f = (-u - x.sqrt(u * u - 4 * c * d)) / 2 / c, S(p) > "1e12" && (p = .5), S(f) > "1e12" && (f = .5), p > 0 && p < 1 && (l = Ct(t, e, i, n, r, o, a, s, p), g.push(l.x), m.push(l.y)), f > 0 && f < 1 && (l = Ct(t, e, i, n, r, o, a, s, f), g.push(l.x), m.push(l.y)), {
					min: {
						x: _[h](0, g),
						y: _[h](0, m)
					}, max: {x: k[h](0, g), y: k[h](0, m)}
				}
			}), Tt = e._path2curve = ct(function (t, e) {
				var i = !e && dt(t);
				if (!e && i.curve) return bt(i.curve);
				for (var n = xt(t), r = e && xt(e), o = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null}, a = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null}, s = function (t, e, i) {
					var n, r;
					if (!t) return ["C", e.x, e.y, e.x, e.y, e.x, e.y];
					switch (!(t[0] in {T: 1, Q: 1}) && (e.qx = e.qy = null), t[0]) {
						case"M":
							e.X = t[1], e.Y = t[2];
							break;
						case"A":
							t = ["C"][d](St[h](0, [e.x, e.y][d](t.slice(1))));
							break;
						case"S":
							"C" == i || "S" == i ? (n = 2 * e.x - e.bx, r = 2 * e.y - e.by) : (n = e.x, r = e.y), t = ["C", n, r][d](t.slice(1));
							break;
						case"T":
							"Q" == i || "T" == i ? (e.qx = 2 * e.x - e.qx, e.qy = 2 * e.y - e.qy) : (e.qx = e.x, e.qy = e.y), t = ["C"][d](_t(e.x, e.y, e.qx, e.qy, t[1], t[2]));
							break;
						case"Q":
							e.qx = t[1], e.qy = t[2], t = ["C"][d](_t(e.x, e.y, t[1], t[2], t[3], t[4]));
							break;
						case"L":
							t = ["C"][d](kt(e.x, e.y, t[1], t[2]));
							break;
						case"H":
							t = ["C"][d](kt(e.x, e.y, t[1], e.y));
							break;
						case"V":
							t = ["C"][d](kt(e.x, e.y, e.x, t[1]));
							break;
						case"Z":
							t = ["C"][d](kt(e.x, e.y, e.X, e.Y))
					}
					return t
				}, l = function (t, e) {
					if (t[e].length > 7) {
						t[e].shift();
						for (var i = t[e]; i.length;) u[e] = "A", r && (p[e] = "A"), t.splice(e++, 0, ["C"][d](i.splice(0, 6)));
						t.splice(e, 1), v = k(n.length, r && r.length || 0)
					}
				}, c = function (t, e, i, o, a) {
					t && e && "M" == t[a][0] && "M" != e[a][0] && (e.splice(a, 0, ["M", o.x, o.y]), i.bx = 0, i.by = 0, i.x = t[a][1], i.y = t[a][2], v = k(n.length, r && r.length || 0))
				}, u = [], p = [], f = "", m = "", g = 0, v = k(n.length, r && r.length || 0); g < v; g++) {
					n[g] && (f = n[g][0]), "C" != f && (u[g] = f, g && (m = u[g - 1])), n[g] = s(n[g], o, m), "A" != u[g] && "C" == f && (u[g] = "C"), l(n, g), r && (r[g] && (f = r[g][0]), "C" != f && (p[g] = f, g && (m = p[g - 1])), r[g] = s(r[g], a, m), "A" != p[g] && "C" == f && (p[g] = "C"), l(r, g)), c(n, r, o, a, g), c(r, n, a, o, g);
					var y = n[g], b = r && r[g], w = y.length, x = r && b.length;
					o.x = y[w - 2], o.y = y[w - 1], o.bx = L(y[w - 4]) || o.x, o.by = L(y[w - 3]) || o.y, a.bx = r && (L(b[x - 4]) || a.x), a.by = r && (L(b[x - 3]) || a.y), a.x = r && b[x - 2], a.y = r && b[x - 1]
				}
				return r || (i.curve = bt(n)), r ? [n, r] : n
			}, null, bt), Mt = (e._parseDots = ct(function (t) {
				for (var i = [], n = 0, r = t.length; n < r; n++) {
					var o = {}, a = t[n].match(/^([^:]*):?([\d\.]*)/);
					if (o.color = e.getRGB(a[1]), o.color.error) return null;
					o.opacity = o.color.opacity, o.color = o.color.hex, a[2] && (o.offset = a[2] + "%"), i.push(o)
				}
				for (n = 1, r = i.length - 1; n < r; n++) if (!i[n].offset) {
					for (var s = L(i[n - 1].offset || 0), l = 0, c = n + 1; c < r; c++) if (i[c].offset) {
						l = i[c].offset;
						break
					}
					l || (l = 100, c = r);
					for (var u = ((l = L(l)) - s) / (c - n + 1); n < c; n++) s += u, i[n].offset = s + "%"
				}
				return i
			}), e._tear = function (t, e) {
				t == e.top && (e.top = t.prev), t == e.bottom && (e.bottom = t.next), t.next && (t.next.prev = t.prev), t.prev && (t.prev.next = t.next)
			}), Et = (e._tofront = function (t, e) {
				e.top !== t && (Mt(t, e), t.next = null, t.prev = e.top, e.top.next = t, e.top = t)
			}, e._toback = function (t, e) {
				e.bottom !== t && (Mt(t, e), t.next = e.bottom, t.prev = null, e.bottom.prev = t, e.bottom = t)
			}, e._insertafter = function (t, e, i) {
				Mt(t, i), e == i.top && (i.top = t), e.next && (e.next.prev = t), t.next = e.next, t.prev = e, e.next = t
			}, e._insertbefore = function (t, e, i) {
				Mt(t, i), e == i.bottom && (i.bottom = t), e.prev && (e.prev.next = t), t.prev = e.prev, e.prev = t, t.next = e
			}, e.toMatrix = function (t, e) {
				var i = yt(t), n = {
					_: {transform: f}, getBBox: function () {
						return i
					}
				};
				return At(n, e), n.matrix
			}), At = (e.transformPath = function (t, e) {
				return Z(t, Et(t, e))
			}, e._extractTransform = function (t, i) {
				if (null == i) return t._.transform;
				i = g(i).replace(/\.{3}|\u2026/g, t._.transform || f);
				var n, r, o = e.parseTransformString(i), a = 0, s = 1, l = 1, c = t._, u = new Ot;
				if (c.transform = o || [], o) for (var h = 0, d = o.length; h < d; h++) {
					var p, m, v, y, b, w = o[h], x = w.length, k = g(w[0]).toLowerCase(), _ = w[0] != k, S = _ ? u.invert() : 0;
					"t" == k && 3 == x ? _ ? (p = S.x(0, 0), m = S.y(0, 0), v = S.x(w[1], w[2]), y = S.y(w[1], w[2]), u.translate(v - p, y - m)) : u.translate(w[1], w[2]) : "r" == k ? 2 == x ? (b = b || t.getBBox(1), u.rotate(w[1], b.x + b.width / 2, b.y + b.height / 2), a += w[1]) : 4 == x && (_ ? (v = S.x(w[2], w[3]), y = S.y(w[2], w[3]), u.rotate(w[1], v, y)) : u.rotate(w[1], w[2], w[3]), a += w[1]) : "s" == k ? 2 == x || 3 == x ? (b = b || t.getBBox(1), u.scale(w[1], w[x - 1], b.x + b.width / 2, b.y + b.height / 2), s *= w[1], l *= w[x - 1]) : 5 == x && (_ ? (v = S.x(w[3], w[4]), y = S.y(w[3], w[4]), u.scale(w[1], w[2], v, y)) : u.scale(w[1], w[2], w[3], w[4]), s *= w[1], l *= w[2]) : "m" == k && 7 == x && u.add(w[1], w[2], w[3], w[4], w[5], w[6]), c.dirtyT = 1, t.matrix = u
				}
				t.matrix = u, c.sx = s, c.sy = l, c.deg = a, c.dx = n = u.e, c.dy = r = u.f, 1 == s && 1 == l && !a && c.bbox ? (c.bbox.x += +n, c.bbox.y += +r) : c.dirtyT = 1
			}), Pt = function (t) {
				var e = t[0];
				switch (e.toLowerCase()) {
					case"t":
						return [e, 0, 0];
					case"m":
						return [e, 1, 0, 0, 1, 0, 0];
					case"r":
						return 4 == t.length ? [e, 0, t[2], t[3]] : [e, 0];
					case"s":
						return 5 == t.length ? [e, 1, 1, t[3], t[4]] : 3 == t.length ? [e, 1, 1] : [e, 1]
				}
			}, It = e._equaliseTransform = function (t, i) {
				i = g(i).replace(/\.{3}|\u2026/g, t), t = e.parseTransformString(t) || [], i = e.parseTransformString(i) || [];
				for (var n, r, o, a, s = k(t.length, i.length), l = [], c = [], u = 0; u < s; u++) {
					if (o = t[u] || Pt(i[u]), a = i[u] || Pt(o), o[0] != a[0] || "r" == o[0].toLowerCase() && (o[2] != a[2] || o[3] != a[3]) || "s" == o[0].toLowerCase() && (o[3] != a[3] || o[4] != a[4])) return;
					for (l[u] = [], c[u] = [], n = 0, r = k(o.length, a.length); n < r; n++) n in o && (l[u][n] = o[n]), n in a && (c[u][n] = a[n])
				}
				return {from: l, to: c}
			};

			function Ot(t, e, i, n, r, o) {
				null != t ? (this.a = +t, this.b = +e, this.c = +i, this.d = +n, this.e = +r, this.f = +o) : (this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.e = 0, this.f = 0)
			}

			e._getContainer = function (t, i, n, r) {
				var o;
				if (null != (o = null != r || e.is(t, "object") ? t : l.doc.getElementById(t))) return o.tagName ? null == i ? {container: o, width: o.style.pixelWidth || o.offsetWidth, height: o.style.pixelHeight || o.offsetHeight} : {container: o, width: i, height: n} : {
					container: 1,
					x: t,
					y: i,
					width: n,
					height: r
				}
			}, e.pathToRelative = wt, e._engine = {}, e.path2curve = Tt, e.matrix = function (t, e, i, n, r, o) {
				return new Ot(t, e, i, n, r, o)
			}, function (t) {
				function i(t) {
					return t[0] * t[0] + t[1] * t[1]
				}

				function n(t) {
					var e = x.sqrt(i(t));
					t[0] && (t[0] /= e), t[1] && (t[1] /= e)
				}

				t.add = function (t, e, i, n, r, o) {
					var a, s, l, c, u = [[], [], []], h = [[this.a, this.c, this.e], [this.b, this.d, this.f], [0, 0, 1]], d = [[t, i, r], [e, n, o], [0, 0, 1]];
					for (t && t instanceof Ot && (d = [[t.a, t.c, t.e], [t.b, t.d, t.f], [0, 0, 1]]), a = 0; a < 3; a++) for (s = 0; s < 3; s++) {
						for (c = 0, l = 0; l < 3; l++) c += h[a][l] * d[l][s];
						u[a][s] = c
					}
					this.a = u[0][0], this.b = u[1][0], this.c = u[0][1], this.d = u[1][1], this.e = u[0][2], this.f = u[1][2]
				}, t.invert = function () {
					var t = this, e = t.a * t.d - t.b * t.c;
					return new Ot(t.d / e, -t.b / e, -t.c / e, t.a / e, (t.c * t.f - t.d * t.e) / e, (t.b * t.e - t.a * t.f) / e)
				}, t.clone = function () {
					return new Ot(this.a, this.b, this.c, this.d, this.e, this.f)
				}, t.translate = function (t, e) {
					this.add(1, 0, 0, 1, t, e)
				}, t.scale = function (t, e, i, n) {
					null == e && (e = t), (i || n) && this.add(1, 0, 0, 1, i, n), this.add(t, 0, 0, e, 0, 0), (i || n) && this.add(1, 0, 0, 1, -i, -n)
				}, t.rotate = function (t, i, n) {
					t = e.rad(t), i = i || 0, n = n || 0;
					var r = +x.cos(t).toFixed(9), o = +x.sin(t).toFixed(9);
					this.add(r, o, -o, r, i, n), this.add(1, 0, 0, 1, -i, -n)
				}, t.x = function (t, e) {
					return t * this.a + e * this.c + this.e
				}, t.y = function (t, e) {
					return t * this.b + e * this.d + this.f
				}, t.get = function (t) {
					return +this[g.fromCharCode(97 + t)].toFixed(4)
				}, t.toString = function () {
					return e.svg ? "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")" : [this.get(0), this.get(2), this.get(1), this.get(3), 0, 0].join()
				}, t.toFilter = function () {
					return "progid:DXImageTransform.Microsoft.Matrix(M11=" + this.get(0) + ", M12=" + this.get(2) + ", M21=" + this.get(1) + ", M22=" + this.get(3) + ", Dx=" + this.get(4) + ", Dy=" + this.get(5) + ", sizingmethod='auto expand')"
				}, t.offset = function () {
					return [this.e.toFixed(4), this.f.toFixed(4)]
				}, t.split = function () {
					var t = {};
					t.dx = this.e, t.dy = this.f;
					var r = [[this.a, this.c], [this.b, this.d]];
					t.scalex = x.sqrt(i(r[0])), n(r[0]), t.shear = r[0][0] * r[1][0] + r[0][1] * r[1][1], r[1] = [r[1][0] - r[0][0] * t.shear, r[1][1] - r[0][1] * t.shear], t.scaley = x.sqrt(i(r[1])), n(r[1]), t.shear /= t.scaley;
					var o = -r[0][1], a = r[1][1];
					return a < 0 ? (t.rotate = e.deg(x.acos(a)), o < 0 && (t.rotate = 360 - t.rotate)) : t.rotate = e.deg(x.asin(o)), t.isSimple = !(+t.shear.toFixed(9) || t.scalex.toFixed(9) != t.scaley.toFixed(9) && t.rotate), t.isSuperSimple = !+t.shear.toFixed(9) && t.scalex.toFixed(9) == t.scaley.toFixed(9) && !t.rotate, t.noRotation = !+t.shear.toFixed(9) && !t.rotate, t
				}, t.toTransformString = function (t) {
					var e = t || this[v]();
					return e.isSimple ? (e.scalex = +e.scalex.toFixed(4), e.scaley = +e.scaley.toFixed(4), e.rotate = +e.rotate.toFixed(4), (e.dx || e.dy ? "t" + [e.dx, e.dy] : f) + (1 != e.scalex || 1 != e.scaley ? "s" + [e.scalex, e.scaley, 0, 0] : f) + (e.rotate ? "r" + [e.rotate, 0, 0] : f)) : "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)]
				}
			}(Ot.prototype);
			for (var Lt = function () {
				this.returnValue = !1
			}, Ft = function () {
				return this.originalEvent.preventDefault()
			}, Nt = function () {
				this.cancelBubble = !0
			}, Rt = function () {
				return this.originalEvent.stopPropagation()
			}, Ht = function (t) {
				var e = l.doc.documentElement.scrollTop || l.doc.body.scrollTop, i = l.doc.documentElement.scrollLeft || l.doc.body.scrollLeft;
				return {x: t.clientX + i, y: t.clientY + e}
			}, $t = l.doc.addEventListener ? function (t, e, i, n) {
				var r = function (t) {
					var e = Ht(t);
					return i.call(n, t, e.x, e.y)
				};
				if (t.addEventListener(e, r, !1), p && b[e]) {
					var o = function (e) {
						for (var r = Ht(e), o = e, a = 0, s = e.targetTouches && e.targetTouches.length; a < s; a++) if (e.targetTouches[a].target == t) {
							(e = e.targetTouches[a]).originalEvent = o, e.preventDefault = Ft, e.stopPropagation = Rt;
							break
						}
						return i.call(n, e, r.x, r.y)
					};
					t.addEventListener(b[e], o, !1)
				}
				return function () {
					return t.removeEventListener(e, r, !1), p && b[e] && t.removeEventListener(b[e], o, !1), !0
				}
			} : l.doc.attachEvent ? function (t, e, i, n) {
				var r = function (t) {
					t = t || l.win.event;
					var e = l.doc.documentElement.scrollTop || l.doc.body.scrollTop, r = l.doc.documentElement.scrollLeft || l.doc.body.scrollLeft, o = t.clientX + r, a = t.clientY + e;
					return t.preventDefault = t.preventDefault || Lt, t.stopPropagation = t.stopPropagation || Nt, i.call(n, t, o, a)
				};
				return t.attachEvent("on" + e, r), function () {
					return t.detachEvent("on" + e, r), !0
				}
			} : void 0, Bt = [], zt = function (e) {
				for (var i, n = e.clientX, r = e.clientY, o = l.doc.documentElement.scrollTop || l.doc.body.scrollTop, a = l.doc.documentElement.scrollLeft || l.doc.body.scrollLeft, s = Bt.length; s--;) {
					if (i = Bt[s], p && e.touches) {
						for (var c, u = e.touches.length; u--;) if ((c = e.touches[u]).identifier == i.el._drag.id) {
							n = c.clientX, r = c.clientY, (e.originalEvent ? e.originalEvent : e).preventDefault();
							break
						}
					} else e.preventDefault();
					var h, d = i.el.node, f = d.nextSibling, m = d.parentNode, g = d.style.display;
					l.win.opera && m.removeChild(d), d.style.display = "none", h = i.el.paper.getElementByPoint(n, r), d.style.display = g, l.win.opera && (f ? m.insertBefore(d, f) : m.appendChild(d)), h && t("raphael.drag.over." + i.el.id, i.el, h), n += a, r += o, t("raphael.drag.move." + i.el.id, i.move_scope || i.el, n - i.el._drag.x, r - i.el._drag.y, n, r, e)
				}
			}, jt = function (i) {
				e.unmousemove(zt).unmouseup(jt);
				for (var n, r = Bt.length; r--;) (n = Bt[r]).el._drag = {}, t("raphael.drag.end." + n.el.id, n.end_scope || n.start_scope || n.move_scope || n.el, i);
				Bt = []
			}, Ut = e.el = {}, Wt = y.length; Wt--;) !function (t) {
				e[t] = Ut[t] = function (i, n) {
					return e.is(i, "function") && (this.events = this.events || [], this.events.push({name: t, f: i, unbind: $t(this.shape || this.node || l.doc, t, i, n || this)})), this
				}, e["un" + t] = Ut["un" + t] = function (i) {
					for (var n = this.events || [], r = n.length; r--;) n[r].name != t || !e.is(i, "undefined") && n[r].f != i || (n[r].unbind(), n.splice(r, 1), !n.length && delete this.events);
					return this
				}
			}(y[Wt]);
			Ut.data = function (i, n) {
				var r = Y[this.id] = Y[this.id] || {};
				if (0 == arguments.length) return r;
				if (1 == arguments.length) {
					if (e.is(i, "object")) {
						for (var o in i) i[s](o) && this.data(o, i[o]);
						return this
					}
					return t("raphael.data.get." + this.id, this, r[i], i), r[i]
				}
				return r[i] = n, t("raphael.data.set." + this.id, this, n, i), this
			}, Ut.removeData = function (t) {
				return null == t ? Y[this.id] = {} : Y[this.id] && delete Y[this.id][t], this
			}, Ut.getData = function () {
				return tt(Y[this.id] || {})
			}, Ut.hover = function (t, e, i, n) {
				return this.mouseover(t, i).mouseout(e, n || i)
			}, Ut.unhover = function (t, e) {
				return this.unmouseover(t).unmouseout(e)
			};
			var Yt = [];
			Ut.drag = function (i, n, r, o, a, s) {
				function c(c) {
					(c.originalEvent || c).preventDefault();
					var u = c.clientX, h = c.clientY, d = l.doc.documentElement.scrollTop || l.doc.body.scrollTop, f = l.doc.documentElement.scrollLeft || l.doc.body.scrollLeft;
					if (this._drag.id = c.identifier, p && c.touches) for (var m, g = c.touches.length; g--;) if (m = c.touches[g], this._drag.id = m.identifier, m.identifier == this._drag.id) {
						u = m.clientX, h = m.clientY;
						break
					}
					this._drag.x = u + f, this._drag.y = h + d, !Bt.length && e.mousemove(zt).mouseup(jt), Bt.push({
						el: this,
						move_scope: o,
						start_scope: a,
						end_scope: s
					}), n && t.on("raphael.drag.start." + this.id, n), i && t.on("raphael.drag.move." + this.id, i), r && t.on("raphael.drag.end." + this.id, r), t("raphael.drag.start." + this.id, a || o || this, c.clientX + f, c.clientY + d, c)
				}

				return this._drag = {}, Yt.push({el: this, start: c}), this.mousedown(c), this
			}, Ut.onDragOver = function (e) {
				e ? t.on("raphael.drag.over." + this.id, e) : t.unbind("raphael.drag.over." + this.id)
			}, Ut.undrag = function () {
				for (var i = Yt.length; i--;) Yt[i].el == this && (this.unmousedown(Yt[i].start), Yt.splice(i, 1), t.unbind("raphael.drag.*." + this.id));
				!Yt.length && e.unmousemove(zt).unmouseup(jt), Bt = []
			}, n.circle = function (t, i, n) {
				var r = e._engine.circle(this, t || 0, i || 0, n || 0);
				return this.__set__ && this.__set__.push(r), r
			}, n.rect = function (t, i, n, r, o) {
				var a = e._engine.rect(this, t || 0, i || 0, n || 0, r || 0, o || 0);
				return this.__set__ && this.__set__.push(a), a
			}, n.ellipse = function (t, i, n, r) {
				var o = e._engine.ellipse(this, t || 0, i || 0, n || 0, r || 0);
				return this.__set__ && this.__set__.push(o), o
			}, n.path = function (t) {
				t && !e.is(t, "string") && !e.is(t[0], M) && (t += f);
				var i = e._engine.path(e.format[h](e, arguments), this);
				return this.__set__ && this.__set__.push(i), i
			}, n.image = function (t, i, n, r, o) {
				var a = e._engine.image(this, t || "about:blank", i || 0, n || 0, r || 0, o || 0);
				return this.__set__ && this.__set__.push(a), a
			}, n.text = function (t, i, n) {
				var r = e._engine.text(this, t || 0, i || 0, g(n));
				return this.__set__ && this.__set__.push(r), r
			}, n.set = function (t) {
				!e.is(t, "array") && (t = Array.prototype.splice.call(arguments, 0, arguments.length));
				var i = new ce(t);
				return this.__set__ && this.__set__.push(i), i.paper = this, i.type = "set", i
			}, n.setStart = function (t) {
				this.__set__ = t || this.set()
			}, n.setFinish = function (t) {
				var e = this.__set__;
				return delete this.__set__, e
			}, n.getSize = function () {
				var t = this.canvas.parentNode;
				return {width: t.offsetWidth, height: t.offsetHeight}
			}, n.setSize = function (t, i) {
				return e._engine.setSize.call(this, t, i)
			}, n.setViewBox = function (t, i, n, r, o) {
				return e._engine.setViewBox.call(this, t, i, n, r, o)
			}, n.top = n.bottom = null, n.raphael = e;

			function Vt() {
				return this.x + m + this.y + m + this.width + " × " + this.height
			}

			n.getElementByPoint = function (t, e) {
				var i, n, r, o, a, s, c, u = this.canvas, h = l.doc.elementFromPoint(t, e);
				if (l.win.opera && "svg" == h.tagName) {
					var d = (n = (i = u).getBoundingClientRect(), r = i.ownerDocument, o = r.body, a = r.documentElement, s = a.clientTop || o.clientTop || 0, c = a.clientLeft || o.clientLeft || 0, {
						y: n.top + (l.win.pageYOffset || a.scrollTop || o.scrollTop) - s,
						x: n.left + (l.win.pageXOffset || a.scrollLeft || o.scrollLeft) - c
					}), p = u.createSVGRect();
					p.x = t - d.x, p.y = e - d.y, p.width = p.height = 1;
					var f = u.getIntersectionList(p, null);
					f.length && (h = f[f.length - 1])
				}
				if (!h) return null;
				for (; h.parentNode && h != u.parentNode && !h.raphael;) h = h.parentNode;
				return h == this.canvas.parentNode && (h = u), h = h && h.raphael ? this.getById(h.raphaelid) : null
			}, n.getElementsByBBox = function (t) {
				var i = this.set();
				return this.forEach(function (n) {
					e.isBBoxIntersect(n.getBBox(), t) && i.push(n)
				}), i
			}, n.getById = function (t) {
				for (var e = this.bottom; e;) {
					if (e.id == t) return e;
					e = e.next
				}
				return null
			}, n.forEach = function (t, e) {
				for (var i = this.bottom; i;) {
					if (!1 === t.call(e, i)) return this;
					i = i.next
				}
				return this
			}, n.getElementsByPoint = function (t, e) {
				var i = this.set();
				return this.forEach(function (n) {
					n.isPointInside(t, e) && i.push(n)
				}), i
			}, Ut.isPointInside = function (t, i) {
				var n = this.realPath = X[this.type](this);
				return this.attr("transform") && this.attr("transform").length && (n = e.transformPath(n, this.attr("transform"))), e.isPointInsidePath(n, t, i)
			}, Ut.getBBox = function (t) {
				if (this.removed) return {};
				var e = this._;
				return t ? (!e.dirty && e.bboxwt || (this.realPath = X[this.type](this), e.bboxwt = yt(this.realPath), e.bboxwt.toString = Vt, e.dirty = 0), e.bboxwt) : ((e.dirty || e.dirtyT || !e.bbox) && (!e.dirty && this.realPath || (e.bboxwt = 0, this.realPath = X[this.type](this)), e.bbox = yt(Z(this.realPath, this.matrix)), e.bbox.toString = Vt, e.dirty = e.dirtyT = 0), e.bbox)
			}, Ut.clone = function () {
				if (this.removed) return null;
				var t = this.paper[this.type]().attr(this.attr());
				return this.__set__ && this.__set__.push(t), t
			}, Ut.glow = function (t) {
				if ("text" == this.type) return null;
				var e = {width: ((t = t || {}).width || 10) + (+this.attr("stroke-width") || 1), fill: t.fill || !1, opacity: null == t.opacity ? .5 : t.opacity, offsetx: t.offsetx || 0, offsety: t.offsety || 0, color: t.color || "#000"}, i = e.width / 2, n = this.paper, r = n.set(),
					o = this.realPath || X[this.type](this);
				o = this.matrix ? Z(o, this.matrix) : o;
				for (var a = 1; a < i + 1; a++) r.push(n.path(o).attr({stroke: e.color, fill: e.fill ? e.color : "none", "stroke-linejoin": "round", "stroke-linecap": "round", "stroke-width": +(e.width / i * a).toFixed(3), opacity: +(e.opacity / i).toFixed(3)}));
				return r.insertBefore(this).translate(e.offsetx, e.offsety)
			};
			var qt = function (t, i, n, r, o, a, s, l, c) {
				return null == c ? ft(t, i, n, r, o, a, s, l) : e.findDotsAtSegment(t, i, n, r, o, a, s, l, function (t, e, i, n, r, o, a, s, l) {
					if (!(l < 0 || ft(t, e, i, n, r, o, a, s) < l)) {
						var c, u = .5, h = 1 - u;
						for (c = ft(t, e, i, n, r, o, a, s, h); S(c - l) > .01;) c = ft(t, e, i, n, r, o, a, s, h += (c < l ? 1 : -1) * (u /= 2));
						return h
					}
				}(t, i, n, r, o, a, s, l, c))
			}, Gt = function (t, i) {
				return function (n, r, o) {
					for (var a, s, l, c, u, h = "", d = {}, p = 0, f = 0, m = (n = Tt(n)).length; f < m; f++) {
						if ("M" == (l = n[f])[0]) a = +l[1], s = +l[2]; else {
							if (p + (c = qt(a, s, l[1], l[2], l[3], l[4], l[5], l[6])) > r) {
								if (i && !d.start) {
									if (h += ["C" + (u = qt(a, s, l[1], l[2], l[3], l[4], l[5], l[6], r - p)).start.x, u.start.y, u.m.x, u.m.y, u.x, u.y], o) return h;
									d.start = h, h = ["M" + u.x, u.y + "C" + u.n.x, u.n.y, u.end.x, u.end.y, l[5], l[6]].join(), p += c, a = +l[5], s = +l[6];
									continue
								}
								if (!t && !i) return {x: (u = qt(a, s, l[1], l[2], l[3], l[4], l[5], l[6], r - p)).x, y: u.y, alpha: u.alpha}
							}
							p += c, a = +l[5], s = +l[6]
						}
						h += l.shift() + l
					}
					return d.end = h, (u = t ? p : i ? d : e.findDotsAtSegment(a, s, l[0], l[1], l[2], l[3], l[4], l[5], 1)).alpha && (u = {x: u.x, y: u.y, alpha: u.alpha}), u
				}
			}, Kt = Gt(1), Xt = Gt(), Zt = Gt(0, 1);
			e.getTotalLength = Kt, e.getPointAtLength = Xt, e.getSubpath = function (t, e, i) {
				if (this.getTotalLength(t) - i < 1e-6) return Zt(t, e).end;
				var n = Zt(t, i, 1);
				return e ? Zt(n, e).end : n
			}, Ut.getTotalLength = function () {
				var t = this.getPath();
				if (t) return this.node.getTotalLength ? this.node.getTotalLength() : Kt(t)
			}, Ut.getPointAtLength = function (t) {
				var e = this.getPath();
				if (e) return Xt(e, t)
			}, Ut.getPath = function () {
				var t, i = e._getPath[this.type];
				if ("text" != this.type && "set" != this.type) return i && (t = i(this)), t
			}, Ut.getSubpath = function (t, i) {
				var n = this.getPath();
				if (n) return e.getSubpath(n, t, i)
			};
			var Qt = e.easing_formulas = {
				linear: function (t) {
					return t
				}, "<": function (t) {
					return C(t, 1.7)
				}, ">": function (t) {
					return C(t, .48)
				}, "<>": function (t) {
					var e = .48 - t / 1.04, i = x.sqrt(.1734 + e * e), n = i - e, r = -i - e, o = C(S(n), 1 / 3) * (n < 0 ? -1 : 1) + C(S(r), 1 / 3) * (r < 0 ? -1 : 1) + .5;
					return 3 * (1 - o) * o * o + o * o * o
				}, backIn: function (t) {
					var e = 1.70158;
					return t * t * ((e + 1) * t - e)
				}, backOut: function (t) {
					var e = 1.70158;
					return (t -= 1) * t * ((e + 1) * t + e) + 1
				}, elastic: function (t) {
					return t == !!t ? t : C(2, -10 * t) * x.sin(2 * D * (t - .075) / .3) + 1
				}, bounce: function (t) {
					var e = 7.5625, i = 2.75;
					return t < 1 / i ? e * t * t : t < 2 / i ? e * (t -= 1.5 / i) * t + .75 : t < 2.5 / i ? e * (t -= 2.25 / i) * t + .9375 : e * (t -= 2.625 / i) * t + .984375
				}
			};
			Qt.easeIn = Qt["ease-in"] = Qt["<"], Qt.easeOut = Qt["ease-out"] = Qt[">"], Qt.easeInOut = Qt["ease-in-out"] = Qt["<>"], Qt["back-in"] = Qt.backIn, Qt["back-out"] = Qt.backOut;
			var Jt = [], te = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (t) {
				setTimeout(t, 16)
			}, ee = function () {
				for (var i = +new Date, n = 0; n < Jt.length; n++) {
					var r = Jt[n];
					if (!r.el.removed && !r.paused) {
						var o, a, l = i - r.start, c = r.ms, u = r.easing, h = r.from, p = r.diff, f = r.to, g = (r.t, r.el), v = {}, y = {};
						if (r.initstatus ? (l = (r.initstatus * r.anim.top - r.prev) / (r.percent - r.prev) * c, r.status = r.initstatus, delete r.initstatus, r.stop && Jt.splice(n--, 1)) : r.status = (r.prev + (r.percent - r.prev) * (l / c)) / r.anim.top, !(l < 0)) if (l < c) {
							var b = u(l / c);
							for (var w in h) if (h[s](w)) {
								switch (H[w]) {
									case T:
										o = +h[w] + b * c * p[w];
										break;
									case"colour":
										o = "rgb(" + [ie(O(h[w].r + b * c * p[w].r)), ie(O(h[w].g + b * c * p[w].g)), ie(O(h[w].b + b * c * p[w].b))].join(",") + ")";
										break;
									case"path":
										o = [];
										for (var x = 0, k = h[w].length; x < k; x++) {
											o[x] = [h[w][x][0]];
											for (var _ = 1, S = h[w][x].length; _ < S; _++) o[x][_] = +h[w][x][_] + b * c * p[w][x][_];
											o[x] = o[x].join(m)
										}
										o = o.join(m);
										break;
									case"transform":
										if (p[w].real) for (o = [], x = 0, k = h[w].length; x < k; x++) for (o[x] = [h[w][x][0]], _ = 1, S = h[w][x].length; _ < S; _++) o[x][_] = h[w][x][_] + b * c * p[w][x][_]; else {
											var C = function (t) {
												return +h[w][t] + b * c * p[w][t]
											};
											o = [["m", C(0), C(1), C(2), C(3), C(4), C(5)]]
										}
										break;
									case"csv":
										if ("clip-rect" == w) for (o = [], x = 4; x--;) o[x] = +h[w][x] + b * c * p[w][x];
										break;
									default:
										var D = [][d](h[w]);
										for (o = [], x = g.paper.customAttributes[w].length; x--;) o[x] = +D[x] + b * c * p[w][x]
								}
								v[w] = o
							}
							g.attr(v), function (e, i, n) {
								setTimeout(function () {
									t("raphael.anim.frame." + e, i, n)
								})
							}(g.id, g, r.anim)
						} else {
							if (function (i, n, r) {
								setTimeout(function () {
									t("raphael.anim.frame." + n.id, n, r), t("raphael.anim.finish." + n.id, n, r), e.is(i, "function") && i.call(n)
								})
							}(r.callback, g, r.anim), g.attr(f), Jt.splice(n--, 1), r.repeat > 1 && !r.next) {
								for (a in f) f[s](a) && (y[a] = r.totalOrigin[a]);
								r.el.attr(y), oe(r.anim, r.el, r.anim.percents[0], null, r.totalOrigin, r.repeat - 1)
							}
							r.next && !r.stop && oe(r.anim, r.el, r.next, null, r.totalOrigin, r.repeat)
						}
					}
				}
				Jt.length && te(ee)
			}, ie = function (t) {
				return t > 255 ? 255 : t < 0 ? 0 : t
			};

			function ne(t, e, i, n, r, o) {
				var a = 3 * e, s = 3 * (n - e) - a, l = 1 - a - s, c = 3 * i, u = 3 * (r - i) - c, h = 1 - c - u;

				function d(t) {
					return ((l * t + s) * t + a) * t
				}

				return function (t, e) {
					var i = function (t, e) {
						var i, n, r, o, c, u;
						for (r = t, u = 0; u < 8; u++) {
							if (o = d(r) - t, S(o) < e) return r;
							if (S(c = (3 * l * r + 2 * s) * r + a) < 1e-6) break;
							r -= o / c
						}
						if (n = 1, (r = t) < (i = 0)) return i;
						if (r > n) return n;
						for (; i < n;) {
							if (o = d(r), S(o - t) < e) return r;
							t > o ? i = r : n = r, r = (n - i) / 2 + i
						}
						return r
					}(t, e);
					return ((h * i + u) * i + c) * i
				}(t, 1 / (200 * o))
			}

			function re(t, e) {
				var i = [], n = {};
				if (this.ms = e, this.times = 1, t) {
					for (var r in t) t[s](r) && (n[L(r)] = t[r], i.push(L(r)));
					i.sort(V)
				}
				this.anim = n, this.top = i[i.length - 1], this.percents = i
			}

			function oe(i, n, o, a, l, c) {
				o = L(o);
				var u, h, p, f, m, y, b = i.ms, w = {}, x = {}, k = {};
				if (a) for (S = 0, C = Jt.length; S < C; S++) {
					var _ = Jt[S];
					if (_.el.id == n.id && _.anim == i) {
						_.percent != o ? (Jt.splice(S, 1), p = 1) : h = _, n.attr(_.totalOrigin);
						break
					}
				} else a = +x;
				for (var S = 0, C = i.percents.length; S < C; S++) {
					if (i.percents[S] == o || i.percents[S] > a * i.top) {
						o = i.percents[S], m = i.percents[S - 1] || 0, b = b / i.top * (o - m), f = i.percents[S + 1], u = i.anim[o];
						break
					}
					a && n.attr(i.anim[i.percents[S]])
				}
				if (u) {
					if (h) h.initstatus = a, h.start = new Date - h.ms * a; else {
						for (var D in u) if (u[s](D) && (H[s](D) || n.paper.customAttributes[s](D))) switch (w[D] = n.attr(D), null == w[D] && (w[D] = R[D]), x[D] = u[D], H[D]) {
							case T:
								k[D] = (x[D] - w[D]) / b;
								break;
							case"colour":
								w[D] = e.getRGB(w[D]);
								var M = e.getRGB(x[D]);
								k[D] = {r: (M.r - w[D].r) / b, g: (M.g - w[D].g) / b, b: (M.b - w[D].b) / b};
								break;
							case"path":
								var E = Tt(w[D], x[D]), A = E[1];
								for (w[D] = E[0], k[D] = [], S = 0, C = w[D].length; S < C; S++) {
									k[D][S] = [0];
									for (var P = 1, O = w[D][S].length; P < O; P++) k[D][S][P] = (A[S][P] - w[D][S][P]) / b
								}
								break;
							case"transform":
								var F = n._, N = It(F[D], x[D]);
								if (N) for (w[D] = N.from, x[D] = N.to, k[D] = [], k[D].real = !0, S = 0, C = w[D].length; S < C; S++) for (k[D][S] = [w[D][S][0]], P = 1, O = w[D][S].length; P < O; P++) k[D][S][P] = (x[D][S][P] - w[D][S][P]) / b; else {
									var $ = n.matrix || new Ot, B = {
										_: {transform: F.transform}, getBBox: function () {
											return n.getBBox(1)
										}
									};
									w[D] = [$.a, $.b, $.c, $.d, $.e, $.f], At(B, x[D]), x[D] = B._.transform, k[D] = [(B.matrix.a - $.a) / b, (B.matrix.b - $.b) / b, (B.matrix.c - $.c) / b, (B.matrix.d - $.d) / b, (B.matrix.e - $.e) / b, (B.matrix.f - $.f) / b]
								}
								break;
							case"csv":
								var z = g(u[D])[v](r), j = g(w[D])[v](r);
								if ("clip-rect" == D) for (w[D] = j, k[D] = [], S = j.length; S--;) k[D][S] = (z[S] - w[D][S]) / b;
								x[D] = z;
								break;
							default:
								for (z = [][d](u[D]), j = [][d](w[D]), k[D] = [], S = n.paper.customAttributes[D].length; S--;) k[D][S] = ((z[S] || 0) - (j[S] || 0)) / b
						}
						var U = u.easing, W = e.easing_formulas[U];
						if (!W) if ((W = g(U).match(I)) && 5 == W.length) {
							var Y = W;
							W = function (t) {
								return ne(t, +Y[1], +Y[2], +Y[3], +Y[4], b)
							}
						} else W = q;
						if (_ = {
							anim: i,
							percent: o,
							timestamp: y = u.start || i.start || +new Date,
							start: y + (i.del || 0),
							status: 0,
							initstatus: a || 0,
							stop: !1,
							ms: b,
							easing: W,
							from: w,
							diff: k,
							to: x,
							el: n,
							callback: u.callback,
							prev: m,
							next: f,
							repeat: c || i.times,
							origin: n.attr(),
							totalOrigin: l
						}, Jt.push(_), a && !h && !p && (_.stop = !0, _.start = new Date - b * a, 1 == Jt.length)) return ee();
						p && (_.start = new Date - _.ms * a), 1 == Jt.length && te(ee)
					}
					t("raphael.anim.start." + n.id, n, i)
				}
			}

			function ae(t) {
				for (var e = 0; e < Jt.length; e++) Jt[e].el.paper == t && Jt.splice(e--, 1)
			}

			Ut.animateWith = function (t, i, n, r, o, a) {
				if (this.removed) return a && a.call(this), this;
				var s = n instanceof re ? n : e.animation(n, r, o, a);
				oe(s, this, s.percents[0], null, this.attr());
				for (var l = 0, c = Jt.length; l < c; l++) if (Jt[l].anim == i && Jt[l].el == t) {
					Jt[c - 1].start = Jt[l].start;
					break
				}
				return this
			}, Ut.onAnimation = function (e) {
				return e ? t.on("raphael.anim.frame." + this.id, e) : t.unbind("raphael.anim.frame." + this.id), this
			}, re.prototype.delay = function (t) {
				var e = new re(this.anim, this.ms);
				return e.times = this.times, e.del = +t || 0, e
			}, re.prototype.repeat = function (t) {
				var e = new re(this.anim, this.ms);
				return e.del = this.del, e.times = x.floor(k(t, 0)) || 1, e
			}, e.animation = function (t, i, n, r) {
				if (t instanceof re) return t;
				!e.is(n, "function") && n || (r = r || n || null, n = null), t = Object(t), i = +i || 0;
				var o, a, l = {};
				for (a in t) t[s](a) && L(a) != a && L(a) + "%" != a && (o = !0, l[a] = t[a]);
				if (o) return n && (l.easing = n), r && (l.callback = r), new re({100: l}, i);
				if (r) {
					var c = 0;
					for (var u in t) {
						var h = F(u);
						t[s](u) && h > c && (c = h)
					}
					!t[c += "%"].callback && (t[c].callback = r)
				}
				return new re(t, i)
			}, Ut.animate = function (t, i, n, r) {
				if (this.removed) return r && r.call(this), this;
				var o = t instanceof re ? t : e.animation(t, i, n, r);
				return oe(o, this, o.percents[0], null, this.attr()), this
			}, Ut.setTime = function (t, e) {
				return t && null != e && this.status(t, _(e, t.ms) / t.ms), this
			}, Ut.status = function (t, e) {
				var i, n, r = [], o = 0;
				if (null != e) return oe(t, this, -1, _(e, 1)), this;
				for (i = Jt.length; o < i; o++) if ((n = Jt[o]).el.id == this.id && (!t || n.anim == t)) {
					if (t) return n.status;
					r.push({anim: n.anim, status: n.status})
				}
				return t ? 0 : r
			}, Ut.pause = function (e) {
				for (var i = 0; i < Jt.length; i++) Jt[i].el.id != this.id || e && Jt[i].anim != e || !1 !== t("raphael.anim.pause." + this.id, this, Jt[i].anim) && (Jt[i].paused = !0);
				return this
			}, Ut.resume = function (e) {
				for (var i = 0; i < Jt.length; i++) if (Jt[i].el.id == this.id && (!e || Jt[i].anim == e)) {
					var n = Jt[i];
					!1 !== t("raphael.anim.resume." + this.id, this, n.anim) && (delete n.paused, this.status(n.anim, n.status))
				}
				return this
			}, Ut.stop = function (e) {
				for (var i = 0; i < Jt.length; i++) Jt[i].el.id != this.id || e && Jt[i].anim != e || !1 !== t("raphael.anim.stop." + this.id, this, Jt[i].anim) && Jt.splice(i--, 1);
				return this
			}, t.on("raphael.remove", ae), t.on("raphael.clear", ae), Ut.toString = function () {
				return "Raphaël’s object"
			};
			var se, le, ce = function (t) {
				if (this.items = [], this.length = 0, this.type = "set", t) for (var e = 0, i = t.length; e < i; e++) !t[e] || t[e].constructor != Ut.constructor && t[e].constructor != ce || (this[this.items.length] = this.items[this.items.length] = t[e], this.length++)
			}, ue = ce.prototype;
			for (var he in ue.push = function () {
				for (var t, e, i = 0, n = arguments.length; i < n; i++) !(t = arguments[i]) || t.constructor != Ut.constructor && t.constructor != ce || (this[e = this.items.length] = this.items[e] = t, this.length++);
				return this
			}, ue.pop = function () {
				return this.length && delete this[this.length--], this.items.pop()
			}, ue.forEach = function (t, e) {
				for (var i = 0, n = this.items.length; i < n; i++) if (!1 === t.call(e, this.items[i], i)) return this;
				return this
			}, Ut) Ut[s](he) && (ue[he] = function (t) {
				return function () {
					var e = arguments;
					return this.forEach(function (i) {
						i[t][h](i, e)
					})
				}
			}(he));
			return ue.attr = function (t, i) {
				if (t && e.is(t, M) && e.is(t[0], "object")) for (var n = 0, r = t.length; n < r; n++) this.items[n].attr(t[n]); else for (var o = 0, a = this.items.length; o < a; o++) this.items[o].attr(t, i);
				return this
			}, ue.clear = function () {
				for (; this.length;) this.pop()
			}, ue.splice = function (t, e, i) {
				t = t < 0 ? k(this.length + t, 0) : t, e = k(0, _(this.length - t, e));
				var n, r = [], o = [], a = [];
				for (n = 2; n < arguments.length; n++) a.push(arguments[n]);
				for (n = 0; n < e; n++) o.push(this[t + n]);
				for (; n < this.length - t; n++) r.push(this[t + n]);
				var s = a.length;
				for (n = 0; n < s + r.length; n++) this.items[t + n] = this[t + n] = n < s ? a[n] : r[n - s];
				for (n = this.items.length = this.length -= e - s; this[n];) delete this[n++];
				return new ce(o)
			}, ue.exclude = function (t) {
				for (var e = 0, i = this.length; e < i; e++) if (this[e] == t) return this.splice(e, 1), !0
			}, ue.animate = function (t, i, n, r) {
				(e.is(n, "function") || !n) && (r = n || null);
				var o, a, s = this.items.length, l = s, c = this;
				if (!s) return this;
				r && (a = function () {
					!--s && r.call(c)
				}), n = e.is(n, "string") ? n : a;
				var u = e.animation(t, i, n, a);
				for (o = this.items[--l].animate(u); l--;) this.items[l] && !this.items[l].removed && this.items[l].animateWith(o, u, u), this.items[l] && !this.items[l].removed || s--;
				return this
			}, ue.insertAfter = function (t) {
				for (var e = this.items.length; e--;) this.items[e].insertAfter(t);
				return this
			}, ue.getBBox = function () {
				for (var t = [], e = [], i = [], n = [], r = this.items.length; r--;) if (!this.items[r].removed) {
					var o = this.items[r].getBBox();
					t.push(o.x), e.push(o.y), i.push(o.x + o.width), n.push(o.y + o.height)
				}
				return {x: t = _[h](0, t), y: e = _[h](0, e), x2: i = k[h](0, i), y2: n = k[h](0, n), width: i - t, height: n - e}
			}, ue.clone = function (t) {
				t = this.paper.set();
				for (var e = 0, i = this.items.length; e < i; e++) t.push(this.items[e].clone());
				return t
			}, ue.toString = function () {
				return "Raphaël‘s set"
			}, ue.glow = function (t) {
				var e = this.paper.set();
				return this.forEach(function (i, n) {
					var r = i.glow(t);
					null != r && r.forEach(function (t, i) {
						e.push(t)
					})
				}), e
			}, ue.isPointInside = function (t, e) {
				var i = !1;
				return this.forEach(function (n) {
					if (n.isPointInside(t, e)) return i = !0, !1
				}), i
			}, e.registerFont = function (t) {
				if (!t.face) return t;
				this.fonts = this.fonts || {};
				var e = {w: t.w, face: {}, glyphs: {}}, i = t.face["font-family"];
				for (var n in t.face) t.face[s](n) && (e.face[n] = t.face[n]);
				if (this.fonts[i] ? this.fonts[i].push(e) : this.fonts[i] = [e], !t.svg) for (var r in e.face["units-per-em"] = F(t.face["units-per-em"], 10), t.glyphs) if (t.glyphs[s](r)) {
					var o = t.glyphs[r];
					if (e.glyphs[r] = {
						w: o.w, k: {}, d: o.d && "M" + o.d.replace(/[mlcxtrv]/g, function (t) {
							return {l: "L", c: "C", x: "z", t: "m", r: "l", v: "c"}[t] || "M"
						}) + "z"
					}, o.k) for (var a in o.k) o[s](a) && (e.glyphs[r].k[a] = o.k[a])
				}
				return t
			}, n.getFont = function (t, i, n, r) {
				if (r = r || "normal", n = n || "normal", i = +i || {normal: 400, bold: 700, lighter: 300, bolder: 800}[i] || 400, e.fonts) {
					var o, a = e.fonts[t];
					if (!a) {
						var l = new RegExp("(^|\\s)" + t.replace(/[^\w\d\s+!~.:_-]/g, f) + "(\\s|$)", "i");
						for (var c in e.fonts) if (e.fonts[s](c) && l.test(c)) {
							a = e.fonts[c];
							break
						}
					}
					if (a) for (var u = 0, h = a.length; u < h && ((o = a[u]).face["font-weight"] != i || o.face["font-style"] != n && o.face["font-style"] || o.face["font-stretch"] != r); u++) ;
					return o
				}
			}, n.print = function (t, i, n, o, a, s, l, c) {
				s = s || "middle", l = k(_(l || 0, 1), -1), c = k(_(c || 1, 3), 1);
				var u, h = g(n)[v](f), d = 0, p = 0, m = f;
				if (e.is(o, "string") && (o = this.getFont(o)), o) {
					u = (a || 16) / o.face["units-per-em"];
					for (var y = o.face.bbox[v](r), b = +y[0], w = y[3] - y[1], x = 0, S = +y[1] + ("baseline" == s ? w + +o.face.descent : w / 2), C = 0, D = h.length; C < D; C++) {
						if ("\n" == h[C]) d = 0, M = 0, p = 0, x += w * c; else {
							var T = p && o.glyphs[h[C - 1]] || {}, M = o.glyphs[h[C]];
							d += p ? (T.w || o.w) + (T.k && T.k[h[C]] || 0) + o.w * l : 0, p = 1
						}
						M && M.d && (m += e.transformPath(M.d, ["t", d * u, x * u, "s", u, u, b, S, "t", (t - b) / u, (i - S) / u]))
					}
				}
				return this.path(m).attr({fill: "#000", stroke: "none"})
			}, n.add = function (t) {
				if (e.is(t, "array")) for (var i, n = this.set(), r = 0, a = t.length; r < a; r++) i = t[r] || {}, o[s](i.type) && n.push(this[i.type]().attr(i));
				return n
			}, e.format = function (t, i) {
				var n = e.is(i, M) ? [0][d](i) : arguments;
				return t && e.is(t, "string") && n.length - 1 && (t = t.replace(a, function (t, e) {
					return null == n[++e] ? f : n[e]
				})), t || f
			}, e.fullfill = (se = /\{([^\}]+)\}/g, le = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, function (t, e) {
				return String(t).replace(se, function (t, i) {
					return function (t, e, i) {
						var n = i;
						return e.replace(le, function (t, e, i, r, o) {
							e = e || r, n && (e in n && (n = n[e]), "function" == typeof n && o && (n = n()))
						}), n = (null == n || n == i ? t : n) + ""
					}(t, i, e)
				})
			}), e.ninja = function () {
				if (c.was) l.win.Raphael = c.is; else {
					window.Raphael = void 0;
					try {
						delete window.Raphael
					} catch (t) {
					}
				}
				return e
			}, e.st = ue, t.on("raphael.DOMload", function () {
				i = !0
			}), function (t, i, n) {
				null == t.readyState && t.addEventListener && (t.addEventListener("DOMContentLoaded", n = function () {
					t.removeEventListener("DOMContentLoaded", n, !1), t.readyState = "complete"
				}, !1), t.readyState = "loading"), function i() {
					/in/.test(t.readyState) ? setTimeout(i, 9) : e.eve("raphael.DOMload")
				}()
			}(document), e
		}.apply(e, n)) || (t.exports = r)
	}, function (t, e, i) {
		var n, r, o, a, s, l, c, u, h, d, p, f, m;
		a = "hasOwnProperty", s = /[\.\/]/, l = /\s*,\s*/, c = function (t, e) {
			return t - e
		}, u = {n: {}}, h = function () {
			for (var t = 0, e = this.length; t < e; t++) if (void 0 !== this[t]) return this[t]
		}, d = function () {
			for (var t = this.length; --t;) if (void 0 !== this[t]) return this[t]
		}, p = Object.prototype.toString, f = String, m = Array.isArray || function (t) {
			return t instanceof Array || "[object Array]" == p.call(t)
		}, eve = function (t, e) {
			var i, n = o, a = Array.prototype.slice.call(arguments, 2), s = eve.listeners(t), l = 0, u = [], p = {}, f = [], m = r;
			f.firstDefined = h, f.lastDefined = d, r = t, o = 0;
			for (var g = 0, v = s.length; g < v; g++) "zIndex" in s[g] && (u.push(s[g].zIndex), s[g].zIndex < 0 && (p[s[g].zIndex] = s[g]));
			for (u.sort(c); u[l] < 0;) if (i = p[u[l++]], f.push(i.apply(e, a)), o) return o = n, f;
			for (g = 0; g < v; g++) if ("zIndex" in (i = s[g])) if (i.zIndex == u[l]) {
				if (f.push(i.apply(e, a)), o) break;
				do {
					if ((i = p[u[++l]]) && f.push(i.apply(e, a)), o) break
				} while (i)
			} else p[i.zIndex] = i; else if (f.push(i.apply(e, a)), o) break;
			return o = n, r = m, f
		}, eve._events = u, eve.listeners = function (t) {
			var e, i, n, r, o, a, l, c, h = m(t) ? t : t.split(s), d = u, p = [d], f = [];
			for (r = 0, o = h.length; r < o; r++) {
				for (c = [], a = 0, l = p.length; a < l; a++) for (i = [(d = p[a].n)[h[r]], d["*"]], n = 2; n--;) (e = i[n]) && (c.push(e), f = f.concat(e.f || []));
				p = c
			}
			return f
		}, eve.separator = function (t) {
			t ? (t = "[" + (t = f(t).replace(/(?=[\.\^\]\[\-])/g, "\\")) + "]", s = new RegExp(t)) : s = /[\.\/]/
		}, eve.on = function (t, e) {
			if ("function" != typeof e) return function () {
			};
			for (var i = m(t) ? m(t[0]) ? t : [t] : f(t).split(l), n = 0, r = i.length; n < r; n++) !function (t) {
				for (var i, n = m(t) ? t : f(t).split(s), r = u, o = 0, a = n.length; o < a; o++) r = (r = r.n).hasOwnProperty(n[o]) && r[n[o]] || (r[n[o]] = {n: {}});
				for (r.f = r.f || [], o = 0, a = r.f.length; o < a; o++) if (r.f[o] == e) {
					i = !0;
					break
				}
				!i && r.f.push(e)
			}(i[n]);
			return function (t) {
				+t == +t && (e.zIndex = +t)
			}
		}, eve.f = function (t) {
			var e = [].slice.call(arguments, 1);
			return function () {
				eve.apply(null, [t, null].concat(e).concat([].slice.call(arguments, 0)))
			}
		}, eve.stop = function () {
			o = 1
		}, eve.nt = function (t) {
			var e = m(r) ? r.join(".") : r;
			return t ? new RegExp("(?:\\.|\\/|^)" + t + "(?:\\.|\\/|$)").test(e) : e
		}, eve.nts = function () {
			return m(r) ? r : r.split(s)
		}, eve.off = eve.unbind = function (t, e) {
			if (t) {
				var i = m(t) ? m(t[0]) ? t : [t] : f(t).split(l);
				if (i.length > 1) for (var n = 0, r = i.length; n < r; n++) eve.off(i[n], e); else {
					i = m(t) ? t : f(t).split(s);
					var o, c, h, d, p, g = [u];
					for (n = 0, r = i.length; n < r; n++) for (d = 0; d < g.length; d += h.length - 2) {
						if (h = [d, 1], o = g[d].n, "*" != i[n]) o[i[n]] && h.push(o[i[n]]); else for (c in o) o[a](c) && h.push(o[c]);
						g.splice.apply(g, h)
					}
					for (n = 0, r = g.length; n < r; n++) for (o = g[n]; o.n;) {
						if (e) {
							if (o.f) {
								for (d = 0, p = o.f.length; d < p; d++) if (o.f[d] == e) {
									o.f.splice(d, 1);
									break
								}
								!o.f.length && delete o.f
							}
							for (c in o.n) if (o.n[a](c) && o.n[c].f) {
								var v = o.n[c].f;
								for (d = 0, p = v.length; d < p; d++) if (v[d] == e) {
									v.splice(d, 1);
									break
								}
								!v.length && delete o.n[c].f
							}
						} else for (c in delete o.f, o.n) o.n[a](c) && o.n[c].f && delete o.n[c].f;
						o = o.n
					}
				}
			} else eve._events = u = {n: {}}
		}, eve.once = function (t, e) {
			var i = function () {
				return eve.off(t, i), e.apply(this, arguments)
			};
			return eve.on(t, i)
		}, eve.version = "0.5.0", eve.toString = function () {
			return "You are running Eve 0.5.0"
		}, void 0 !== t && t.exports ? t.exports = eve : void 0 === (n = function () {
			return eve
		}.apply(e, [])) || (t.exports = n)
	}, function (t, e, i) {
		var n, r;
		n = [i(1)], void 0 === (r = function (t) {
			if (!t || t.svg) {
				var e = "hasOwnProperty", i = String, n = parseFloat, r = parseInt, o = Math, a = o.max, s = o.abs, l = o.pow, c = /[, ]+/, u = t.eve, h = "", d = " ", p = "http://www.w3.org/1999/xlink",
					f = {block: "M5,0 0,2.5 5,5z", classic: "M5,0 0,2.5 5,5 3.5,3 3.5,2z", diamond: "M2.5,0 5,2.5 2.5,5 0,2.5z", open: "M6,1 1,3.5 6,6", oval: "M2.5,0A2.5,2.5,0,0,1,2.5,5 2.5,2.5,0,0,1,2.5,0z"}, m = {};
				t.toString = function () {
					return "Your browser supports SVG.\nYou are running Raphaël " + this.version
				};
				var g = function (n, r) {
					if (r) for (var o in"string" == typeof n && (n = g(n)), r) r[e](o) && ("xlink:" == o.substring(0, 6) ? n.setAttributeNS(p, o.substring(6), i(r[o])) : n.setAttribute(o, i(r[o]))); else (n = t._g.doc.createElementNS("http://www.w3.org/2000/svg", n)).style && (n.style.webkitTapHighlightColor = "rgba(0,0,0,0)");
					return n
				}, v = function (e, r) {
					var c = "linear", u = e.id + r, d = .5, p = .5, f = e.node, m = e.paper, v = f.style, b = t._g.doc.getElementById(u);
					if (!b) {
						if (r = (r = i(r).replace(t._radial_gradient, function (t, e, i) {
							if (c = "radial", e && i) {
								d = n(e);
								var r = 2 * ((p = n(i)) > .5) - 1;
								l(d - .5, 2) + l(p - .5, 2) > .25 && (p = o.sqrt(.25 - l(d - .5, 2)) * r + .5) && .5 != p && (p = p.toFixed(5) - 1e-5 * r)
							}
							return h
						})).split(/\s*\-\s*/), "linear" == c) {
							var w = r.shift();
							if (w = -n(w), isNaN(w)) return null;
							var x = [0, 0, o.cos(t.rad(w)), o.sin(t.rad(w))], k = 1 / (a(s(x[2]), s(x[3])) || 1);
							x[2] *= k, x[3] *= k, x[2] < 0 && (x[0] = -x[2], x[2] = 0), x[3] < 0 && (x[1] = -x[3], x[3] = 0)
						}
						var _ = t._parseDots(r);
						if (!_) return null;
						if (u = u.replace(/[\(\)\s,\xb0#]/g, "_"), e.gradient && u != e.gradient.id && (m.defs.removeChild(e.gradient), delete e.gradient), !e.gradient) {
							b = g(c + "Gradient", {id: u}), e.gradient = b, g(b, "radial" == c ? {fx: d, fy: p} : {x1: x[0], y1: x[1], x2: x[2], y2: x[3], gradientTransform: e.matrix.invert()}), m.defs.appendChild(b);
							for (var S = 0, C = _.length; S < C; S++) b.appendChild(g("stop", {offset: _[S].offset ? _[S].offset : S ? "100%" : "0%", "stop-color": _[S].color || "#fff", "stop-opacity": isFinite(_[S].opacity) ? _[S].opacity : 1}))
						}
					}
					return g(f, {fill: y(u), opacity: 1, "fill-opacity": 1}), v.fill = h, v.opacity = 1, v.fillOpacity = 1, 1
				}, y = function (t) {
					if ((e = document.documentMode) && (9 === e || 10 === e)) return "url('#" + t + "')";
					var e, i = document.location;
					return "url('" + (i.protocol + "//" + i.host + i.pathname + i.search) + "#" + t + "')"
				}, b = function (t) {
					var e = t.getBBox(1);
					g(t.pattern, {patternTransform: t.matrix.invert() + " translate(" + e.x + "," + e.y + ")"})
				}, w = function (n, r, o) {
					if ("path" == n.type) {
						for (var a, s, l, c, u, d = i(r).toLowerCase().split("-"), p = n.paper, v = o ? "end" : "start", y = n.node, b = n.attrs, w = b["stroke-width"], x = d.length, k = "classic", _ = 3, S = 3, C = 5; x--;) switch (d[x]) {
							case"block":
							case"classic":
							case"oval":
							case"diamond":
							case"open":
							case"none":
								k = d[x];
								break;
							case"wide":
								S = 5;
								break;
							case"narrow":
								S = 2;
								break;
							case"long":
								_ = 5;
								break;
							case"short":
								_ = 2
						}
						if ("open" == k ? (_ += 2, S += 2, C += 2, l = 1, c = o ? 4 : 1, u = {fill: "none", stroke: b.stroke}) : (c = l = _ / 2, u = {
							fill: b.stroke,
							stroke: "none"
						}), n._.arrows ? o ? (n._.arrows.endPath && m[n._.arrows.endPath]--, n._.arrows.endMarker && m[n._.arrows.endMarker]--) : (n._.arrows.startPath && m[n._.arrows.startPath]--, n._.arrows.startMarker && m[n._.arrows.startMarker]--) : n._.arrows = {}, "none" != k) {
							var D = "raphael-marker-" + k, T = "raphael-marker-" + v + k + _ + S + "-obj" + n.id;
							t._g.doc.getElementById(D) ? m[D]++ : (p.defs.appendChild(g(g("path"), {"stroke-linecap": "round", d: f[k], id: D})), m[D] = 1);
							var M, E = t._g.doc.getElementById(T);
							E ? (m[T]++, M = E.getElementsByTagName("use")[0]) : (E = g(g("marker"), {id: T, markerHeight: S, markerWidth: _, orient: "auto", refX: c, refY: S / 2}), M = g(g("use"), {
								"xlink:href": "#" + D,
								transform: (o ? "rotate(180 " + _ / 2 + " " + S / 2 + ") " : h) + "scale(" + _ / C + "," + S / C + ")",
								"stroke-width": (1 / ((_ / C + S / C) / 2)).toFixed(4)
							}), E.appendChild(M), p.defs.appendChild(E), m[T] = 1), g(M, u);
							var A = l * ("diamond" != k && "oval" != k);
							o ? (a = n._.arrows.startdx * w || 0, s = t.getTotalLength(b.path) - A * w) : (a = A * w, s = t.getTotalLength(b.path) - (n._.arrows.enddx * w || 0)), (u = {})["marker-" + v] = "url(#" + T + ")", (s || a) && (u.d = t.getSubpath(b.path, a, s)), g(y, u), n._.arrows[v + "Path"] = D, n._.arrows[v + "Marker"] = T, n._.arrows[v + "dx"] = A, n._.arrows[v + "Type"] = k, n._.arrows[v + "String"] = r
						} else o ? (a = n._.arrows.startdx * w || 0, s = t.getTotalLength(b.path) - a) : (a = 0, s = t.getTotalLength(b.path) - (n._.arrows.enddx * w || 0)), n._.arrows[v + "Path"] && g(y, {d: t.getSubpath(b.path, a, s)}), delete n._.arrows[v + "Path"], delete n._.arrows[v + "Marker"], delete n._.arrows[v + "dx"], delete n._.arrows[v + "Type"], delete n._.arrows[v + "String"];
						for (u in m) if (m[e](u) && !m[u]) {
							var P = t._g.doc.getElementById(u);
							P && P.parentNode.removeChild(P)
						}
					}
				}, x = {"-": [3, 1], ".": [1, 1], "-.": [3, 1, 1, 1], "-..": [3, 1, 1, 1, 1, 1], ". ": [1, 3], "- ": [4, 3], "--": [8, 3], "- .": [4, 3, 1, 3], "--.": [8, 3, 1, 3], "--..": [8, 3, 1, 3, 1, 3]}, k = function (t, e, n) {
					if (e = x[i(e).toLowerCase()]) {
						for (var r = t.attrs["stroke-width"] || "1", o = {round: r, square: r, butt: 0}[t.attrs["stroke-linecap"] || n["stroke-linecap"]] || 0, a = [], s = e.length; s--;) a[s] = e[s] * r + (s % 2 ? 1 : -1) * o;
						g(t.node, {"stroke-dasharray": a.join(",")})
					} else g(t.node, {"stroke-dasharray": "none"})
				}, _ = function (n, o) {
					var l = n.node, u = n.attrs, d = l.style.visibility;
					for (var f in l.style.visibility = "hidden", o) if (o[e](f)) {
						if (!t._availableAttrs[e](f)) continue;
						var m = o[f];
						switch (u[f] = m, f) {
							case"blur":
								n.blur(m);
								break;
							case"title":
								var y = l.getElementsByTagName("title");
								if (y.length && (y = y[0])) y.firstChild.nodeValue = m; else {
									y = g("title");
									var x = t._g.doc.createTextNode(m);
									y.appendChild(x), l.appendChild(y)
								}
								break;
							case"href":
							case"target":
								var _ = l.parentNode;
								if ("a" != _.tagName.toLowerCase()) {
									var C = g("a");
									_.insertBefore(C, l), C.appendChild(l), _ = C
								}
								"target" == f ? _.setAttributeNS(p, "show", "blank" == m ? "new" : m) : _.setAttributeNS(p, f, m);
								break;
							case"cursor":
								l.style.cursor = m;
								break;
							case"transform":
								n.transform(m);
								break;
							case"arrow-start":
								w(n, m);
								break;
							case"arrow-end":
								w(n, m, 1);
								break;
							case"clip-rect":
								var D = i(m).split(c);
								if (4 == D.length) {
									n.clip && n.clip.parentNode.parentNode.removeChild(n.clip.parentNode);
									var T = g("clipPath"), M = g("rect");
									T.id = t.createUUID(), g(M, {x: D[0], y: D[1], width: D[2], height: D[3]}), T.appendChild(M), n.paper.defs.appendChild(T), g(l, {"clip-path": "url(#" + T.id + ")"}), n.clip = M
								}
								if (!m) {
									var E = l.getAttribute("clip-path");
									if (E) {
										var A = t._g.doc.getElementById(E.replace(/(^url\(#|\)$)/g, h));
										A && A.parentNode.removeChild(A), g(l, {"clip-path": h}), delete n.clip
									}
								}
								break;
							case"path":
								"path" == n.type && (g(l, {d: m ? u.path = t._pathToAbsolute(m) : "M0,0"}), n._.dirty = 1, n._.arrows && ("startString" in n._.arrows && w(n, n._.arrows.startString), "endString" in n._.arrows && w(n, n._.arrows.endString, 1)));
								break;
							case"width":
								if (l.setAttribute(f, m), n._.dirty = 1, !u.fx) break;
								f = "x", m = u.x;
							case"x":
								u.fx && (m = -u.x - (u.width || 0));
							case"rx":
								if ("rx" == f && "rect" == n.type) break;
							case"cx":
								l.setAttribute(f, m), n.pattern && b(n), n._.dirty = 1;
								break;
							case"height":
								if (l.setAttribute(f, m), n._.dirty = 1, !u.fy) break;
								f = "y", m = u.y;
							case"y":
								u.fy && (m = -u.y - (u.height || 0));
							case"ry":
								if ("ry" == f && "rect" == n.type) break;
							case"cy":
								l.setAttribute(f, m), n.pattern && b(n), n._.dirty = 1;
								break;
							case"r":
								"rect" == n.type ? g(l, {rx: m, ry: m}) : l.setAttribute(f, m), n._.dirty = 1;
								break;
							case"src":
								"image" == n.type && l.setAttributeNS(p, "href", m);
								break;
							case"stroke-width":
								1 == n._.sx && 1 == n._.sy || (m /= a(s(n._.sx), s(n._.sy)) || 1), l.setAttribute(f, m), u["stroke-dasharray"] && k(n, u["stroke-dasharray"], o), n._.arrows && ("startString" in n._.arrows && w(n, n._.arrows.startString), "endString" in n._.arrows && w(n, n._.arrows.endString, 1));
								break;
							case"stroke-dasharray":
								k(n, m, o);
								break;
							case"fill":
								var P = i(m).match(t._ISURL);
								if (P) {
									T = g("pattern");
									var I = g("image");
									T.id = t.createUUID(), g(T, {x: 0, y: 0, patternUnits: "userSpaceOnUse", height: 1, width: 1}), g(I, {x: 0, y: 0, "xlink:href": P[1]}), T.appendChild(I), function (e) {
										t._preload(P[1], function () {
											var t = this.offsetWidth, i = this.offsetHeight;
											g(e, {width: t, height: i}), g(I, {width: t, height: i})
										})
									}(T), n.paper.defs.appendChild(T), g(l, {fill: "url(#" + T.id + ")"}), n.pattern = T, n.pattern && b(n);
									break
								}
								var O = t.getRGB(m);
								if (O.error) {
									if (("circle" == n.type || "ellipse" == n.type || "r" != i(m).charAt()) && v(n, m)) {
										if ("opacity" in u || "fill-opacity" in u) {
											var L = t._g.doc.getElementById(l.getAttribute("fill").replace(/^url\(#|\)$/g, h));
											if (L) {
												var F = L.getElementsByTagName("stop");
												g(F[F.length - 1], {"stop-opacity": ("opacity" in u ? u.opacity : 1) * ("fill-opacity" in u ? u["fill-opacity"] : 1)})
											}
										}
										u.gradient = m, u.fill = "none";
										break
									}
								} else delete o.gradient, delete u.gradient, !t.is(u.opacity, "undefined") && t.is(o.opacity, "undefined") && g(l, {opacity: u.opacity}), !t.is(u["fill-opacity"], "undefined") && t.is(o["fill-opacity"], "undefined") && g(l, {"fill-opacity": u["fill-opacity"]});
								O[e]("opacity") && g(l, {"fill-opacity": O.opacity > 1 ? O.opacity / 100 : O.opacity});
							case"stroke":
								O = t.getRGB(m), l.setAttribute(f, O.hex), "stroke" == f && O[e]("opacity") && g(l, {"stroke-opacity": O.opacity > 1 ? O.opacity / 100 : O.opacity}), "stroke" == f && n._.arrows && ("startString" in n._.arrows && w(n, n._.arrows.startString), "endString" in n._.arrows && w(n, n._.arrows.endString, 1));
								break;
							case"gradient":
								("circle" == n.type || "ellipse" == n.type || "r" != i(m).charAt()) && v(n, m);
								break;
							case"opacity":
								u.gradient && !u[e]("stroke-opacity") && g(l, {"stroke-opacity": m > 1 ? m / 100 : m});
							case"fill-opacity":
								if (u.gradient) {
									(L = t._g.doc.getElementById(l.getAttribute("fill").replace(/^url\(#|\)$/g, h))) && (F = L.getElementsByTagName("stop"), g(F[F.length - 1], {"stop-opacity": m}));
									break
								}
							default:
								"font-size" == f && (m = r(m, 10) + "px");
								var N = f.replace(/(\-.)/g, function (t) {
									return t.substring(1).toUpperCase()
								});
								l.style[N] = m, n._.dirty = 1, l.setAttribute(f, m)
						}
					}
					S(n, o), l.style.visibility = d
				}, S = function (n, o) {
					if ("text" == n.type && (o[e]("text") || o[e]("font") || o[e]("font-size") || o[e]("x") || o[e]("y"))) {
						var a = n.attrs, s = n.node, l = s.firstChild ? r(t._g.doc.defaultView.getComputedStyle(s.firstChild, h).getPropertyValue("font-size"), 10) : 10;
						if (o[e]("text")) {
							for (a.text = o.text; s.firstChild;) s.removeChild(s.firstChild);
							for (var c, u = i(o.text).split("\n"), d = [], p = 0, f = u.length; p < f; p++) c = g("tspan"), p && g(c, {dy: 1.2 * l, x: a.x}), c.appendChild(t._g.doc.createTextNode(u[p])), s.appendChild(c), d[p] = c
						} else for (p = 0, f = (d = s.getElementsByTagName("tspan")).length; p < f; p++) p ? g(d[p], {dy: 1.2 * l, x: a.x}) : g(d[0], {dy: 0});
						g(s, {x: a.x, y: a.y}), n._.dirty = 1;
						var m = n._getBBox(), v = a.y - (m.y + m.height / 2);
						v && t.is(v, "finite") && g(d[0], {dy: v})
					}
				}, C = function (t) {
					return t.parentNode && "a" === t.parentNode.tagName.toLowerCase() ? t.parentNode : t
				}, D = function (e, i) {
					this[0] = this.node = e, e.raphael = !0, this.id = ("0000" + (Math.random() * Math.pow(36, 5) << 0).toString(36)).slice(-5), e.raphaelid = this.id, this.matrix = t.matrix(), this.realPath = null, this.paper = i, this.attrs = this.attrs || {}, this._ = {
						transform: [],
						sx: 1,
						sy: 1,
						deg: 0,
						dx: 0,
						dy: 0,
						dirty: 1
					}, !i.bottom && (i.bottom = this), this.prev = i.top, i.top && (i.top.next = this), i.top = this, this.next = null
				}, T = t.el;
				D.prototype = T, T.constructor = D, t._engine.path = function (t, e) {
					var i = g("path");
					e.canvas && e.canvas.appendChild(i);
					var n = new D(i, e);
					return n.type = "path", _(n, {fill: "none", stroke: "#000", path: t}), n
				}, T.rotate = function (t, e, r) {
					if (this.removed) return this;
					if ((t = i(t).split(c)).length - 1 && (e = n(t[1]), r = n(t[2])), t = n(t[0]), null == r && (e = r), null == e || null == r) {
						var o = this.getBBox(1);
						e = o.x + o.width / 2, r = o.y + o.height / 2
					}
					return this.transform(this._.transform.concat([["r", t, e, r]])), this
				}, T.scale = function (t, e, r, o) {
					if (this.removed) return this;
					if ((t = i(t).split(c)).length - 1 && (e = n(t[1]), r = n(t[2]), o = n(t[3])), t = n(t[0]), null == e && (e = t), null == o && (r = o), null == r || null == o) var a = this.getBBox(1);
					return r = null == r ? a.x + a.width / 2 : r, o = null == o ? a.y + a.height / 2 : o, this.transform(this._.transform.concat([["s", t, e, r, o]])), this
				}, T.translate = function (t, e) {
					return this.removed ? this : ((t = i(t).split(c)).length - 1 && (e = n(t[1])), t = n(t[0]) || 0, e = +e || 0, this.transform(this._.transform.concat([["t", t, e]])), this)
				}, T.transform = function (i) {
					var n = this._;
					if (null == i) return n.transform;
					if (t._extractTransform(this, i), this.clip && g(this.clip, {transform: this.matrix.invert()}), this.pattern && b(this), this.node && g(this.node, {transform: this.matrix}), 1 != n.sx || 1 != n.sy) {
						var r = this.attrs[e]("stroke-width") ? this.attrs["stroke-width"] : 1;
						this.attr({"stroke-width": r})
					}
					return this
				}, T.hide = function () {
					return this.removed || (this.node.style.display = "none"), this
				}, T.show = function () {
					return this.removed || (this.node.style.display = ""), this
				}, T.remove = function () {
					var e = C(this.node);
					if (!this.removed && e.parentNode) {
						var i = this.paper;
						for (var n in i.__set__ && i.__set__.exclude(this), u.unbind("raphael.*.*." + this.id), this.gradient && i.defs.removeChild(this.gradient), t._tear(this, i), e.parentNode.removeChild(e), this.removeData(), this) this[n] = "function" == typeof this[n] ? t._removedFactory(n) : null;
						this.removed = !0
					}
				}, T._getBBox = function () {
					if ("none" == this.node.style.display) {
						this.show();
						var t = !0
					}
					var e, i = !1;
					this.paper.canvas.parentElement ? e = this.paper.canvas.parentElement.style : this.paper.canvas.parentNode && (e = this.paper.canvas.parentNode.style), e && "none" == e.display && (i = !0, e.display = "");
					var n = {};
					try {
						n = this.node.getBBox()
					} catch (t) {
						n = {x: this.node.clientLeft, y: this.node.clientTop, width: this.node.clientWidth, height: this.node.clientHeight}
					} finally {
						n = n || {}, i && (e.display = "none")
					}
					return t && this.hide(), n
				}, T.attr = function (i, n) {
					if (this.removed) return this;
					if (null == i) {
						var r = {};
						for (var o in this.attrs) this.attrs[e](o) && (r[o] = this.attrs[o]);
						return r.gradient && "none" == r.fill && (r.fill = r.gradient) && delete r.gradient, r.transform = this._.transform, r
					}
					if (null == n && t.is(i, "string")) {
						if ("fill" == i && "none" == this.attrs.fill && this.attrs.gradient) return this.attrs.gradient;
						if ("transform" == i) return this._.transform;
						for (var a = i.split(c), s = {}, l = 0, h = a.length; l < h; l++) (i = a[l]) in this.attrs ? s[i] = this.attrs[i] : t.is(this.paper.customAttributes[i], "function") ? s[i] = this.paper.customAttributes[i].def : s[i] = t._availableAttrs[i];
						return h - 1 ? s : s[a[0]]
					}
					if (null == n && t.is(i, "array")) {
						for (s = {}, l = 0, h = i.length; l < h; l++) s[i[l]] = this.attr(i[l]);
						return s
					}
					if (null != n) {
						var d = {};
						d[i] = n
					} else null != i && t.is(i, "object") && (d = i);
					for (var p in d) u("raphael.attr." + p + "." + this.id, this, d[p]);
					for (p in this.paper.customAttributes) if (this.paper.customAttributes[e](p) && d[e](p) && t.is(this.paper.customAttributes[p], "function")) {
						var f = this.paper.customAttributes[p].apply(this, [].concat(d[p]));
						for (var m in this.attrs[p] = d[p], f) f[e](m) && (d[m] = f[m])
					}
					return _(this, d), this
				}, T.toFront = function () {
					if (this.removed) return this;
					var e = C(this.node);
					e.parentNode.appendChild(e);
					var i = this.paper;
					return i.top != this && t._tofront(this, i), this
				}, T.toBack = function () {
					if (this.removed) return this;
					var e = C(this.node), i = e.parentNode;
					i.insertBefore(e, i.firstChild), t._toback(this, this.paper);
					this.paper;
					return this
				}, T.insertAfter = function (e) {
					if (this.removed || !e) return this;
					var i = C(this.node), n = C(e.node || e[e.length - 1].node);
					return n.nextSibling ? n.parentNode.insertBefore(i, n.nextSibling) : n.parentNode.appendChild(i), t._insertafter(this, e, this.paper), this
				}, T.insertBefore = function (e) {
					if (this.removed || !e) return this;
					var i = C(this.node), n = C(e.node || e[0].node);
					return n.parentNode.insertBefore(i, n), t._insertbefore(this, e, this.paper), this
				}, T.blur = function (e) {
					var i = this;
					if (0 != +e) {
						var n = g("filter"), r = g("feGaussianBlur");
						i.attrs.blur = e, n.id = t.createUUID(), g(r, {stdDeviation: +e || 1.5}), n.appendChild(r), i.paper.defs.appendChild(n), i._blur = n, g(i.node, {filter: "url(#" + n.id + ")"})
					} else i._blur && (i._blur.parentNode.removeChild(i._blur), delete i._blur, delete i.attrs.blur), i.node.removeAttribute("filter");
					return i
				}, t._engine.circle = function (t, e, i, n) {
					var r = g("circle");
					t.canvas && t.canvas.appendChild(r);
					var o = new D(r, t);
					return o.attrs = {cx: e, cy: i, r: n, fill: "none", stroke: "#000"}, o.type = "circle", g(r, o.attrs), o
				}, t._engine.rect = function (t, e, i, n, r, o) {
					var a = g("rect");
					t.canvas && t.canvas.appendChild(a);
					var s = new D(a, t);
					return s.attrs = {x: e, y: i, width: n, height: r, rx: o || 0, ry: o || 0, fill: "none", stroke: "#000"}, s.type = "rect", g(a, s.attrs), s
				}, t._engine.ellipse = function (t, e, i, n, r) {
					var o = g("ellipse");
					t.canvas && t.canvas.appendChild(o);
					var a = new D(o, t);
					return a.attrs = {cx: e, cy: i, rx: n, ry: r, fill: "none", stroke: "#000"}, a.type = "ellipse", g(o, a.attrs), a
				}, t._engine.image = function (t, e, i, n, r, o) {
					var a = g("image");
					g(a, {x: i, y: n, width: r, height: o, preserveAspectRatio: "none"}), a.setAttributeNS(p, "href", e), t.canvas && t.canvas.appendChild(a);
					var s = new D(a, t);
					return s.attrs = {x: i, y: n, width: r, height: o, src: e}, s.type = "image", s
				}, t._engine.text = function (e, i, n, r) {
					var o = g("text");
					e.canvas && e.canvas.appendChild(o);
					var a = new D(o, e);
					return a.attrs = {x: i, y: n, "text-anchor": "middle", text: r, "font-family": t._availableAttrs["font-family"], "font-size": t._availableAttrs["font-size"], stroke: "none", fill: "#000"}, a.type = "text", _(a, a.attrs), a
				}, t._engine.setSize = function (t, e) {
					return this.width = t || this.width, this.height = e || this.height, this.canvas.setAttribute("width", this.width), this.canvas.setAttribute("height", this.height), this._viewBox && this.setViewBox.apply(this, this._viewBox), this
				}, t._engine.create = function () {
					var e = t._getContainer.apply(0, arguments), i = e && e.container, n = e.x, r = e.y, o = e.width, a = e.height;
					if (!i) throw new Error("SVG container not found.");
					var s, l = g("svg"), c = "overflow:hidden;";
					return n = n || 0, r = r || 0, g(l, {
						height: a = a || 342,
						version: 1.1,
						width: o = o || 512,
						xmlns: "http://www.w3.org/2000/svg",
						"xmlns:xlink": "http://www.w3.org/1999/xlink"
					}), 1 == i ? (l.style.cssText = c + "position:absolute;left:" + n + "px;top:" + r + "px", t._g.doc.body.appendChild(l), s = 1) : (l.style.cssText = c + "position:relative", i.firstChild ? i.insertBefore(l, i.firstChild) : i.appendChild(l)), (i = new t._Paper).width = o, i.height = a, i.canvas = l, i.clear(), i._left = i._top = 0, s && (i.renderfix = function () {
					}), i.renderfix(), i
				}, t._engine.setViewBox = function (t, e, i, n, r) {
					u("raphael.setViewBox", this, this._viewBox, [t, e, i, n, r]);
					var o, s, l = this.getSize(), c = a(i / l.width, n / l.height), h = this.top, p = r ? "xMidYMid meet" : "xMinYMin";
					for (null == t ? (this._vbSize && (c = 1), delete this._vbSize, o = "0 0 " + this.width + d + this.height) : (this._vbSize = c, o = t + d + e + d + i + d + n), g(this.canvas, {
						viewBox: o,
						preserveAspectRatio: p
					}); c && h;) s = "stroke-width" in h.attrs ? h.attrs["stroke-width"] : 1, h.attr({"stroke-width": s}), h._.dirty = 1, h._.dirtyT = 1, h = h.prev;
					return this._viewBox = [t, e, i, n, !!r], this
				}, t.prototype.renderfix = function () {
					var t, e = this.canvas, i = e.style;
					try {
						t = e.getScreenCTM() || e.createSVGMatrix()
					} catch (i) {
						t = e.createSVGMatrix()
					}
					var n = -t.e % 1, r = -t.f % 1;
					(n || r) && (n && (this._left = (this._left + n) % 1, i.left = this._left + "px"), r && (this._top = (this._top + r) % 1, i.top = this._top + "px"))
				}, t.prototype.clear = function () {
					t.eve("raphael.clear", this);
					for (var e = this.canvas; e.firstChild;) e.removeChild(e.firstChild);
					this.bottom = this.top = null, (this.desc = g("desc")).appendChild(t._g.doc.createTextNode("Created with Raphaël " + t.version)), e.appendChild(this.desc), e.appendChild(this.defs = g("defs"))
				}, t.prototype.remove = function () {
					for (var e in u("raphael.remove", this), this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas), this) this[e] = "function" == typeof this[e] ? t._removedFactory(e) : null
				};
				var M = t.st;
				for (var E in T) T[e](E) && !M[e](E) && (M[E] = function (t) {
					return function () {
						var e = arguments;
						return this.forEach(function (i) {
							i[t].apply(i, e)
						})
					}
				}(E))
			}
		}.apply(e, n)) || (t.exports = r)
	}, function (t, e, i) {
		var n, r;
		n = [i(1)], void 0 === (r = function (t) {
			if (!t || t.vml) {
				var e = "hasOwnProperty", i = String, n = parseFloat, r = Math, o = r.round, a = r.max, s = r.min, l = r.abs, c = /[, ]+/, u = t.eve, h = " ", d = "", p = {M: "m", L: "l", C: "c", Z: "x", m: "t", l: "r", c: "v", z: "x"}, f = /([clmz]),?([^clmz]*)/gi, m = / progid:\S+Blur\([^\)]+\)/g,
					g = /-?[^,\s-]+/g, v = "position:absolute;left:0;top:0;width:1px;height:1px;behavior:url(#default#VML)", y = 21600, b = {path: 1, rect: 1, image: 1}, w = {circle: 1, ellipse: 1}, x = function (e, i, n) {
						var r = t.matrix();
						return r.rotate(-e, .5, .5), {dx: r.x(i, n), dy: r.y(i, n)}
					}, k = function (t, e, i, n, r, o) {
						var a = t._, s = t.matrix, c = a.fillpos, u = t.node, d = u.style, p = 1, f = "", m = y / e, g = y / i;
						if (d.visibility = "hidden", e && i) {
							if (u.coordsize = l(m) + h + l(g), d.rotation = o * (e * i < 0 ? -1 : 1), o) {
								var v = x(o, n, r);
								n = v.dx, r = v.dy
							}
							if (e < 0 && (f += "x"), i < 0 && (f += " y") && (p = -1), d.flip = f, u.coordorigin = n * -m + h + r * -g, c || a.fillsize) {
								var b = u.getElementsByTagName("fill");
								b = b && b[0], u.removeChild(b), c && (v = x(o, s.x(c[0], c[1]), s.y(c[0], c[1])), b.position = v.dx * p + h + v.dy * p), a.fillsize && (b.size = a.fillsize[0] * l(e) + h + a.fillsize[1] * l(i)), u.appendChild(b)
							}
							d.visibility = "visible"
						}
					};
				t.toString = function () {
					return "Your browser doesn’t support SVG. Falling down to VML.\nYou are running Raphaël " + this.version
				};
				var _, S = function (t, e, n) {
					for (var r = i(e).toLowerCase().split("-"), o = n ? "end" : "start", a = r.length, s = "classic", l = "medium", c = "medium"; a--;) switch (r[a]) {
						case"block":
						case"classic":
						case"oval":
						case"diamond":
						case"open":
						case"none":
							s = r[a];
							break;
						case"wide":
						case"narrow":
							c = r[a];
							break;
						case"long":
						case"short":
							l = r[a]
					}
					var u = t.node.getElementsByTagName("stroke")[0];
					u[o + "arrow"] = s, u[o + "arrowlength"] = l, u[o + "arrowwidth"] = c
				}, C = function (r, l) {
					r.attrs = r.attrs || {};
					var u = r.node, m = r.attrs, v = u.style, x = b[r.type] && (l.x != m.x || l.y != m.y || l.width != m.width || l.height != m.height || l.cx != m.cx || l.cy != m.cy || l.rx != m.rx || l.ry != m.ry || l.r != m.r),
						C = w[r.type] && (m.cx != l.cx || m.cy != l.cy || m.r != l.r || m.rx != l.rx || m.ry != l.ry), T = r;
					for (var M in l) l[e](M) && (m[M] = l[M]);
					if (x && (m.path = t._getPath[r.type](r), r._.dirty = 1), l.href && (u.href = l.href), l.title && (u.title = l.title), l.target && (u.target = l.target), l.cursor && (v.cursor = l.cursor), "blur" in l && r.blur(l.blur), (l.path && "path" == r.type || x) && (u.path = function (e) {
						var n = /[ahqstv]/gi, r = t._pathToAbsolute;
						if (i(e).match(n) && (r = t._path2curve), n = /[clmz]/g, r == t._pathToAbsolute && !i(e).match(n)) {
							var a = i(e).replace(f, function (t, e, i) {
								var n = [], r = "m" == e.toLowerCase(), a = p[e];
								return i.replace(g, function (t) {
									r && 2 == n.length && (a += n + p["m" == e ? "l" : "L"], n = []), n.push(o(t * y))
								}), a + n
							});
							return a
						}
						var s, l, c = r(e);
						a = [];
						for (var u = 0, m = c.length; u < m; u++) {
							s = c[u], "z" == (l = c[u][0].toLowerCase()) && (l = "x");
							for (var v = 1, b = s.length; v < b; v++) l += o(s[v] * y) + (v != b - 1 ? "," : d);
							a.push(l)
						}
						return a.join(h)
					}(~i(m.path).toLowerCase().indexOf("r") ? t._pathToAbsolute(m.path) : m.path), r._.dirty = 1, "image" == r.type && (r._.fillpos = [m.x, m.y], r._.fillsize = [m.width, m.height], k(r, 1, 1, 0, 0, 0))), "transform" in l && r.transform(l.transform), C) {
						var E = +m.cx, A = +m.cy, P = +m.rx || +m.r || 0, I = +m.ry || +m.r || 0;
						u.path = t.format("ar{0},{1},{2},{3},{4},{1},{4},{1}x", o((E - P) * y), o((A - I) * y), o((E + P) * y), o((A + I) * y), o(E * y)), r._.dirty = 1
					}
					if ("clip-rect" in l) {
						var O = i(l["clip-rect"]).split(c);
						if (4 == O.length) {
							O[2] = +O[2] + +O[0], O[3] = +O[3] + +O[1];
							var L = u.clipRect || t._g.doc.createElement("div"), F = L.style;
							F.clip = t.format("rect({1}px {2}px {3}px {0}px)", O), u.clipRect || (F.position = "absolute", F.top = 0, F.left = 0, F.width = r.paper.width + "px", F.height = r.paper.height + "px", u.parentNode.insertBefore(L, u), L.appendChild(u), u.clipRect = L)
						}
						l["clip-rect"] || u.clipRect && (u.clipRect.style.clip = "auto")
					}
					if (r.textpath) {
						var N = r.textpath.style;
						l.font && (N.font = l.font), l["font-family"] && (N.fontFamily = '"' + l["font-family"].split(",")[0].replace(/^['"]+|['"]+$/g, d) + '"'), l["font-size"] && (N.fontSize = l["font-size"]), l["font-weight"] && (N.fontWeight = l["font-weight"]), l["font-style"] && (N.fontStyle = l["font-style"])
					}
					if ("arrow-start" in l && S(T, l["arrow-start"]), "arrow-end" in l && S(T, l["arrow-end"], 1), null != l.opacity || null != l.fill || null != l.src || null != l.stroke || null != l["stroke-width"] || null != l["stroke-opacity"] || null != l["fill-opacity"] || null != l["stroke-dasharray"] || null != l["stroke-miterlimit"] || null != l["stroke-linejoin"] || null != l["stroke-linecap"]) {
						var R = u.getElementsByTagName("fill");
						if (!(R = R && R[0]) && (R = _("fill")), "image" == r.type && l.src && (R.src = l.src), l.fill && (R.on = !0), null != R.on && "none" != l.fill && null !== l.fill || (R.on = !1), R.on && l.fill) {
							var H = i(l.fill).match(t._ISURL);
							if (H) {
								R.parentNode == u && u.removeChild(R), R.rotate = !0, R.src = H[1], R.type = "tile";
								var $ = r.getBBox(1);
								R.position = $.x + h + $.y, r._.fillpos = [$.x, $.y], t._preload(H[1], function () {
									r._.fillsize = [this.offsetWidth, this.offsetHeight]
								})
							} else R.color = t.getRGB(l.fill).hex, R.src = d, R.type = "solid", t.getRGB(l.fill).error && (T.type in {circle: 1, ellipse: 1} || "r" != i(l.fill).charAt()) && D(T, l.fill, R) && (m.fill = "none", m.gradient = l.fill, R.rotate = !1)
						}
						if ("fill-opacity" in l || "opacity" in l) {
							var B = ((+m["fill-opacity"] + 1 || 2) - 1) * ((+m.opacity + 1 || 2) - 1) * ((+t.getRGB(l.fill).o + 1 || 2) - 1);
							B = s(a(B, 0), 1), R.opacity = B, R.src && (R.color = "none")
						}
						u.appendChild(R);
						var z = u.getElementsByTagName("stroke") && u.getElementsByTagName("stroke")[0], j = !1;
						!z && (j = z = _("stroke")), (l.stroke && "none" != l.stroke || l["stroke-width"] || null != l["stroke-opacity"] || l["stroke-dasharray"] || l["stroke-miterlimit"] || l["stroke-linejoin"] || l["stroke-linecap"]) && (z.on = !0), ("none" == l.stroke || null === l.stroke || null == z.on || 0 == l.stroke || 0 == l["stroke-width"]) && (z.on = !1);
						var U = t.getRGB(l.stroke);
						z.on && l.stroke && (z.color = U.hex), B = ((+m["stroke-opacity"] + 1 || 2) - 1) * ((+m.opacity + 1 || 2) - 1) * ((+U.o + 1 || 2) - 1);
						var W = .75 * (n(l["stroke-width"]) || 1);
						if (B = s(a(B, 0), 1), null == l["stroke-width"] && (W = m["stroke-width"]), l["stroke-width"] && (z.weight = W), W && W < 1 && (B *= W) && (z.weight = 1), z.opacity = B, l["stroke-linejoin"] && (z.joinstyle = l["stroke-linejoin"] || "miter"), z.miterlimit = l["stroke-miterlimit"] || 8, l["stroke-linecap"] && (z.endcap = "butt" == l["stroke-linecap"] ? "flat" : "square" == l["stroke-linecap"] ? "square" : "round"), "stroke-dasharray" in l) {
							var Y = {"-": "shortdash", ".": "shortdot", "-.": "shortdashdot", "-..": "shortdashdotdot", ". ": "dot", "- ": "dash", "--": "longdash", "- .": "dashdot", "--.": "longdashdot", "--..": "longdashdotdot"};
							z.dashstyle = Y[e](l["stroke-dasharray"]) ? Y[l["stroke-dasharray"]] : d
						}
						j && u.appendChild(z)
					}
					if ("text" == T.type) {
						T.paper.canvas.style.display = d;
						var V = T.paper.span, q = m.font && m.font.match(/\d+(?:\.\d*)?(?=px)/);
						v = V.style, m.font && (v.font = m.font), m["font-family"] && (v.fontFamily = m["font-family"]), m["font-weight"] && (v.fontWeight = m["font-weight"]), m["font-style"] && (v.fontStyle = m["font-style"]), q = n(m["font-size"] || q && q[0]) || 10, v.fontSize = 100 * q + "px", T.textpath.string && (V.innerHTML = i(T.textpath.string).replace(/</g, "&#60;").replace(/&/g, "&#38;").replace(/\n/g, "<br>"));
						var G = V.getBoundingClientRect();
						T.W = m.w = (G.right - G.left) / 100, T.H = m.h = (G.bottom - G.top) / 100, T.X = m.x, T.Y = m.y + T.H / 2, ("x" in l || "y" in l) && (T.path.v = t.format("m{0},{1}l{2},{1}", o(m.x * y), o(m.y * y), o(m.x * y) + 1));
						for (var K = ["x", "y", "text", "font", "font-family", "font-weight", "font-style", "font-size"], X = 0, Z = K.length; X < Z; X++) if (K[X] in l) {
							T._.dirty = 1;
							break
						}
						switch (m["text-anchor"]) {
							case"start":
								T.textpath.style["v-text-align"] = "left", T.bbx = T.W / 2;
								break;
							case"end":
								T.textpath.style["v-text-align"] = "right", T.bbx = -T.W / 2;
								break;
							default:
								T.textpath.style["v-text-align"] = "center", T.bbx = 0
						}
						T.textpath.style["v-text-kern"] = !0
					}
				}, D = function (e, o, a) {
					e.attrs = e.attrs || {};
					e.attrs;
					var s = Math.pow, l = "linear", c = ".5 .5";
					if (e.attrs.gradient = o, o = (o = i(o).replace(t._radial_gradient, function (t, e, i) {
						return l = "radial", e && i && (e = n(e), i = n(i), s(e - .5, 2) + s(i - .5, 2) > .25 && (i = r.sqrt(.25 - s(e - .5, 2)) * (2 * (i > .5) - 1) + .5), c = e + h + i), d
					})).split(/\s*\-\s*/), "linear" == l) {
						var u = o.shift();
						if (u = -n(u), isNaN(u)) return null
					}
					var p = t._parseDots(o);
					if (!p) return null;
					if (e = e.shape || e.node, p.length) {
						e.removeChild(a), a.on = !0, a.method = "none", a.color = p[0].color, a.color2 = p[p.length - 1].color;
						for (var f = [], m = 0, g = p.length; m < g; m++) p[m].offset && f.push(p[m].offset + h + p[m].color);
						a.colors = f.length ? f.join() : "0% " + a.color, "radial" == l ? (a.type = "gradientTitle", a.focus = "100%", a.focussize = "0 0", a.focusposition = c, a.angle = 0) : (a.type = "gradient", a.angle = (270 - u) % 360), e.appendChild(a)
					}
					return 1
				}, T = function (e, i) {
					this[0] = this.node = e, e.raphael = !0, this.id = t._oid++, e.raphaelid = this.id, this.X = 0, this.Y = 0, this.attrs = {}, this.paper = i, this.matrix = t.matrix(), this._ = {
						transform: [],
						sx: 1,
						sy: 1,
						dx: 0,
						dy: 0,
						deg: 0,
						dirty: 1,
						dirtyT: 1
					}, !i.bottom && (i.bottom = this), this.prev = i.top, i.top && (i.top.next = this), i.top = this, this.next = null
				}, M = t.el;
				T.prototype = M, M.constructor = T, M.transform = function (e) {
					if (null == e) return this._.transform;
					var n, r = this.paper._viewBoxShift, o = r ? "s" + [r.scale, r.scale] + "-1-1t" + [r.dx, r.dy] : d;
					r && (n = e = i(e).replace(/\.{3}|\u2026/g, this._.transform || d)), t._extractTransform(this, o + e);
					var a, s = this.matrix.clone(), l = this.skew, c = this.node, u = ~i(this.attrs.fill).indexOf("-"), p = !i(this.attrs.fill).indexOf("url(");
					if (s.translate(1, 1), p || u || "image" == this.type) if (l.matrix = "1 0 0 1", l.offset = "0 0", a = s.split(), u && a.noRotation || !a.isSimple) {
						c.style.filter = s.toFilter();
						var f = this.getBBox(), m = this.getBBox(1), g = f.x - m.x, v = f.y - m.y;
						c.coordorigin = g * -y + h + v * -y, k(this, 1, 1, g, v, 0)
					} else c.style.filter = d, k(this, a.scalex, a.scaley, a.dx, a.dy, a.rotate); else c.style.filter = d, l.matrix = i(s), l.offset = s.offset();
					return null !== n && (this._.transform = n, t._extractTransform(this, n)), this
				}, M.rotate = function (t, e, r) {
					if (this.removed) return this;
					if (null != t) {
						if ((t = i(t).split(c)).length - 1 && (e = n(t[1]), r = n(t[2])), t = n(t[0]), null == r && (e = r), null == e || null == r) {
							var o = this.getBBox(1);
							e = o.x + o.width / 2, r = o.y + o.height / 2
						}
						return this._.dirtyT = 1, this.transform(this._.transform.concat([["r", t, e, r]])), this
					}
				}, M.translate = function (t, e) {
					return this.removed ? this : ((t = i(t).split(c)).length - 1 && (e = n(t[1])), t = n(t[0]) || 0, e = +e || 0, this._.bbox && (this._.bbox.x += t, this._.bbox.y += e), this.transform(this._.transform.concat([["t", t, e]])), this)
				}, M.scale = function (t, e, r, o) {
					if (this.removed) return this;
					if ((t = i(t).split(c)).length - 1 && (e = n(t[1]), r = n(t[2]), o = n(t[3]), isNaN(r) && (r = null), isNaN(o) && (o = null)), t = n(t[0]), null == e && (e = t), null == o && (r = o), null == r || null == o) var a = this.getBBox(1);
					return r = null == r ? a.x + a.width / 2 : r, o = null == o ? a.y + a.height / 2 : o, this.transform(this._.transform.concat([["s", t, e, r, o]])), this._.dirtyT = 1, this
				}, M.hide = function () {
					return !this.removed && (this.node.style.display = "none"), this
				}, M.show = function () {
					return !this.removed && (this.node.style.display = d), this
				}, M.auxGetBBox = t.el.getBBox, M.getBBox = function () {
					var t = this.auxGetBBox();
					if (this.paper && this.paper._viewBoxShift) {
						var e = {}, i = 1 / this.paper._viewBoxShift.scale;
						return e.x = t.x - this.paper._viewBoxShift.dx, e.x *= i, e.y = t.y - this.paper._viewBoxShift.dy, e.y *= i, e.width = t.width * i, e.height = t.height * i, e.x2 = e.x + e.width, e.y2 = e.y + e.height, e
					}
					return t
				}, M._getBBox = function () {
					return this.removed ? {} : {x: this.X + (this.bbx || 0) - this.W / 2, y: this.Y - this.H, width: this.W, height: this.H}
				}, M.remove = function () {
					if (!this.removed && this.node.parentNode) {
						for (var e in this.paper.__set__ && this.paper.__set__.exclude(this), t.eve.unbind("raphael.*.*." + this.id), t._tear(this, this.paper), this.node.parentNode.removeChild(this.node), this.shape && this.shape.parentNode.removeChild(this.shape), this) this[e] = "function" == typeof this[e] ? t._removedFactory(e) : null;
						this.removed = !0
					}
				}, M.attr = function (i, n) {
					if (this.removed) return this;
					if (null == i) {
						var r = {};
						for (var o in this.attrs) this.attrs[e](o) && (r[o] = this.attrs[o]);
						return r.gradient && "none" == r.fill && (r.fill = r.gradient) && delete r.gradient, r.transform = this._.transform, r
					}
					if (null == n && t.is(i, "string")) {
						if ("fill" == i && "none" == this.attrs.fill && this.attrs.gradient) return this.attrs.gradient;
						for (var a = i.split(c), s = {}, l = 0, h = a.length; l < h; l++) (i = a[l]) in this.attrs ? s[i] = this.attrs[i] : t.is(this.paper.customAttributes[i], "function") ? s[i] = this.paper.customAttributes[i].def : s[i] = t._availableAttrs[i];
						return h - 1 ? s : s[a[0]]
					}
					if (this.attrs && null == n && t.is(i, "array")) {
						for (s = {}, l = 0, h = i.length; l < h; l++) s[i[l]] = this.attr(i[l]);
						return s
					}
					var d;
					for (var p in null != n && ((d = {})[i] = n), null == n && t.is(i, "object") && (d = i), d) u("raphael.attr." + p + "." + this.id, this, d[p]);
					if (d) {
						for (p in this.paper.customAttributes) if (this.paper.customAttributes[e](p) && d[e](p) && t.is(this.paper.customAttributes[p], "function")) {
							var f = this.paper.customAttributes[p].apply(this, [].concat(d[p]));
							for (var m in this.attrs[p] = d[p], f) f[e](m) && (d[m] = f[m])
						}
						d.text && "text" == this.type && (this.textpath.string = d.text), C(this, d)
					}
					return this
				}, M.toFront = function () {
					return !this.removed && this.node.parentNode.appendChild(this.node), this.paper && this.paper.top != this && t._tofront(this, this.paper), this
				}, M.toBack = function () {
					return this.removed ? this : (this.node.parentNode.firstChild != this.node && (this.node.parentNode.insertBefore(this.node, this.node.parentNode.firstChild), t._toback(this, this.paper)), this)
				}, M.insertAfter = function (e) {
					return this.removed ? this : (e.constructor == t.st.constructor && (e = e[e.length - 1]), e.node.nextSibling ? e.node.parentNode.insertBefore(this.node, e.node.nextSibling) : e.node.parentNode.appendChild(this.node), t._insertafter(this, e, this.paper), this)
				}, M.insertBefore = function (e) {
					return this.removed ? this : (e.constructor == t.st.constructor && (e = e[0]), e.node.parentNode.insertBefore(this.node, e.node), t._insertbefore(this, e, this.paper), this)
				}, M.blur = function (e) {
					var i = this.node.runtimeStyle, n = i.filter;
					return n = n.replace(m, d), 0 != +e ? (this.attrs.blur = e, i.filter = n + h + " progid:DXImageTransform.Microsoft.Blur(pixelradius=" + (+e || 1.5) + ")", i.margin = t.format("-{0}px 0 0 -{0}px", o(+e || 1.5))) : (i.filter = n, i.margin = 0, delete this.attrs.blur), this
				}, t._engine.path = function (t, e) {
					var i = _("shape");
					i.style.cssText = v, i.coordsize = y + h + y, i.coordorigin = e.coordorigin;
					var n = new T(i, e), r = {fill: "none", stroke: "#000"};
					t && (r.path = t), n.type = "path", n.path = [], n.Path = d, C(n, r), e.canvas && e.canvas.appendChild(i);
					var o = _("skew");
					return o.on = !0, i.appendChild(o), n.skew = o, n.transform(d), n
				}, t._engine.rect = function (e, i, n, r, o, a) {
					var s = t._rectPath(i, n, r, o, a), l = e.path(s), c = l.attrs;
					return l.X = c.x = i, l.Y = c.y = n, l.W = c.width = r, l.H = c.height = o, c.r = a, c.path = s, l.type = "rect", l
				}, t._engine.ellipse = function (t, e, i, n, r) {
					var o = t.path();
					o.attrs;
					return o.X = e - n, o.Y = i - r, o.W = 2 * n, o.H = 2 * r, o.type = "ellipse", C(o, {cx: e, cy: i, rx: n, ry: r}), o
				}, t._engine.circle = function (t, e, i, n) {
					var r = t.path();
					r.attrs;
					return r.X = e - n, r.Y = i - n, r.W = r.H = 2 * n, r.type = "circle", C(r, {cx: e, cy: i, r: n}), r
				}, t._engine.image = function (e, i, n, r, o, a) {
					var s = t._rectPath(n, r, o, a), l = e.path(s).attr({stroke: "none"}), c = l.attrs, u = l.node, h = u.getElementsByTagName("fill")[0];
					return c.src = i, l.X = c.x = n, l.Y = c.y = r, l.W = c.width = o, l.H = c.height = a, c.path = s, l.type = "image", h.parentNode == u && u.removeChild(h), h.rotate = !0, h.src = i, h.type = "tile", l._.fillpos = [n, r], l._.fillsize = [o, a], u.appendChild(h), k(l, 1, 1, 0, 0, 0), l
				}, t._engine.text = function (e, n, r, a) {
					var s = _("shape"), l = _("path"), c = _("textpath");
					n = n || 0, r = r || 0, a = a || "", l.v = t.format("m{0},{1}l{2},{1}", o(n * y), o(r * y), o(n * y) + 1), l.textpathok = !0, c.string = i(a), c.on = !0, s.style.cssText = v, s.coordsize = y + h + y, s.coordorigin = "0 0";
					var u = new T(s, e), p = {fill: "#000", stroke: "none", font: t._availableAttrs.font, text: a};
					u.shape = s, u.path = l, u.textpath = c, u.type = "text", u.attrs.text = i(a), u.attrs.x = n, u.attrs.y = r, u.attrs.w = 1, u.attrs.h = 1, C(u, p), s.appendChild(c), s.appendChild(l), e.canvas.appendChild(s);
					var f = _("skew");
					return f.on = !0, s.appendChild(f), u.skew = f, u.transform(d), u
				}, t._engine.setSize = function (e, i) {
					var n = this.canvas.style;
					return this.width = e, this.height = i, e == +e && (e += "px"), i == +i && (i += "px"), n.width = e, n.height = i, n.clip = "rect(0 " + e + " " + i + " 0)", this._viewBox && t._engine.setViewBox.apply(this, this._viewBox), this
				}, t._engine.setViewBox = function (e, i, n, r, o) {
					t.eve("raphael.setViewBox", this, this._viewBox, [e, i, n, r, o]);
					var a, s, l = this.getSize(), c = l.width, u = l.height;
					return o && (n * (a = u / r) < c && (e -= (c - n * a) / 2 / a), r * (s = c / n) < u && (i -= (u - r * s) / 2 / s)), this._viewBox = [e, i, n, r, !!o], this._viewBoxShift = {dx: -e, dy: -i, scale: l}, this.forEach(function (t) {
						t.transform("...")
					}), this
				}, t._engine.initWin = function (t) {
					var e = t.document;
					e.styleSheets.length < 31 ? e.createStyleSheet().addRule(".rvml", "behavior:url(#default#VML)") : e.styleSheets[0].addRule(".rvml", "behavior:url(#default#VML)");
					try {
						!e.namespaces.rvml && e.namespaces.add("rvml", "urn:schemas-microsoft-com:vml"), _ = function (t) {
							return e.createElement("<rvml:" + t + ' class="rvml">')
						}
					} catch (t) {
						_ = function (t) {
							return e.createElement("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="rvml">')
						}
					}
				}, t._engine.initWin(t._g.win), t._engine.create = function () {
					var e = t._getContainer.apply(0, arguments), i = e.container, n = e.height, r = e.width, o = e.x, a = e.y;
					if (!i) throw new Error("VML container not found.");
					var s = new t._Paper, l = s.canvas = t._g.doc.createElement("div"), c = l.style;
					return o = o || 0, a = a || 0, r = r || 512, n = n || 342, s.width = r, s.height = n, r == +r && (r += "px"), n == +n && (n += "px"), s.coordsize = 216e5 + h + 216e5, s.coordorigin = "0 0", s.span = t._g.doc.createElement("span"), s.span.style.cssText = "position:absolute;left:-9999em;top:-9999em;padding:0;margin:0;line-height:1;", l.appendChild(s.span), c.cssText = t.format("top:0;left:0;width:{0};height:{1};display:inline-block;position:relative;clip:rect(0 {0} {1} 0);overflow:hidden", r, n), 1 == i ? (t._g.doc.body.appendChild(l), c.left = o + "px", c.top = a + "px", c.position = "absolute") : i.firstChild ? i.insertBefore(l, i.firstChild) : i.appendChild(l), s.renderfix = function () {
					}, s
				}, t.prototype.clear = function () {
					t.eve("raphael.clear", this), this.canvas.innerHTML = d, this.span = t._g.doc.createElement("span"), this.span.style.cssText = "position:absolute;left:-9999em;top:-9999em;padding:0;margin:0;line-height:1;display:inline;", this.canvas.appendChild(this.span), this.bottom = this.top = null
				}, t.prototype.remove = function () {
					for (var e in t.eve("raphael.remove", this), this.canvas.parentNode.removeChild(this.canvas), this) this[e] = "function" == typeof this[e] ? t._removedFactory(e) : null;
					return !0
				};
				var E = t.st;
				for (var A in M) M[e](A) && !E[e](A) && (E[A] = function (t) {
					return function () {
						var e = arguments;
						return this.forEach(function (i) {
							i[t].apply(i, e)
						})
					}
				}(A))
			}
		}.apply(e, n)) || (t.exports = r)
	}])
}), function () {
	var t, e, i, n, r = [].slice, o = function (t, e) {
		return function () {
			return t.apply(e, arguments)
		}
	}, a = {}.hasOwnProperty, s = function (t, e) {
		for (var i in e) a.call(e, i) && (t[i] = e[i]);

		function n() {
			this.constructor = t
		}

		return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t
	}, l = [].indexOf || function (t) {
		for (var e = 0, i = this.length; e < i; e++) if (e in this && this[e] === t) return e;
		return -1
	};
	e = window.Morris = {}, t = jQuery, e.EventEmitter = function () {
		function t() {
		}

		return t.prototype.on = function (t, e) {
			return null == this.handlers && (this.handlers = {}), null == this.handlers[t] && (this.handlers[t] = []), this.handlers[t].push(e), this
		}, t.prototype.fire = function () {
			var t, e, i, n, o, a, s;
			if (i = arguments[0], t = 2 <= arguments.length ? r.call(arguments, 1) : [], null != this.handlers && null != this.handlers[i]) {
				for (s = [], n = 0, o = (a = this.handlers[i]).length; n < o; n++) e = a[n], s.push(e.apply(null, t));
				return s
			}
		}, t
	}(), e.commas = function (t) {
		var e, i, n, r;
		return null != t ? (n = t < 0 ? "-" : "", e = Math.abs(t), n += (i = Math.floor(e).toFixed(0)).replace(/(?=(?:\d{3})+$)(?!^)/g, ","), (r = e.toString()).length > i.length && (n += r.slice(i.length)), n) : "-"
	}, e.pad2 = function (t) {
		return (t < 10 ? "0" : "") + t
	}, e.Grid = function (i) {
		function n(e) {
			this.resizeHandler = o(this.resizeHandler, this);
			var i = this;
			if ("string" == typeof e.element ? this.el = t(document.getElementById(e.element)) : this.el = t(e.element), null == this.el || 0 === this.el.length) throw new Error("Graph container element not found");
			"static" === this.el.css("position") && this.el.css("position", "relative"), this.options = t.extend({}, this.gridDefaults, this.defaults || {}, e), "string" == typeof this.options.units && (this.options.postUnits = e.units), this.raphael = new Raphael(this.el[0]), this.elementWidth = null, this.elementHeight = null, this.dirty = !1, this.selectFrom = null, this.init && this.init(), this.setData(this.options.data), this.el.bind("mousemove", function (t) {
				var e, n, r, o;
				return n = i.el.offset(), o = t.pageX - n.left, i.selectFrom ? (e = i.data[i.hitTest(Math.min(o, i.selectFrom))]._x, r = i.data[i.hitTest(Math.max(o, i.selectFrom))]._x - e, i.selectionRect.attr({x: e, width: r})) : i.fire("hovermove", o, t.pageY - n.top)
			}), this.el.bind("mouseleave", function (t) {
				return i.selectFrom && (i.selectionRect.hide(), i.selectFrom = null), i.fire("hoverout")
			}), this.el.bind("touchstart touchmove touchend", function (t) {
				var e, n;
				return n = t.originalEvent.touches[0] || t.originalEvent.changedTouches[0], e = i.el.offset(), i.fire("hovermove", n.pageX - e.left, n.pageY - e.top)
			}), this.el.bind("click", function (t) {
				var e;
				return e = i.el.offset(), i.fire("gridclick", t.pageX - e.left, t.pageY - e.top)
			}), this.options.rangeSelect && (this.selectionRect = this.raphael.rect(0, 0, 0, this.el.innerHeight()).attr({fill: this.options.rangeSelectColor, stroke: !1}).toBack().hide(), this.el.bind("mousedown", function (t) {
				var e;
				return e = i.el.offset(), i.startRange(t.pageX - e.left)
			}), this.el.bind("mouseup", function (t) {
				var e;
				return e = i.el.offset(), i.endRange(t.pageX - e.left), i.fire("hovermove", t.pageX - e.left, t.pageY - e.top)
			})), this.options.resize && t(window).bind("resize", function (t) {
				return null != i.timeoutId && window.clearTimeout(i.timeoutId), i.timeoutId = window.setTimeout(i.resizeHandler, 100)
			}), this.el.css("-webkit-tap-highlight-color", "rgba(0,0,0,0)"), this.postInit && this.postInit()
		}

		return s(n, i), n.prototype.gridDefaults = {
			dateFormat: null,
			axes: !0,
			grid: !0,
			gridLineColor: "#aaa",
			gridStrokeWidth: .5,
			gridTextColor: "#888",
			gridTextSize: 12,
			gridTextFamily: "sans-serif",
			gridTextWeight: "normal",
			hideHover: !1,
			yLabelFormat: null,
			xLabelAngle: 0,
			numLines: 5,
			padding: 25,
			parseTime: !0,
			postUnits: "",
			preUnits: "",
			ymax: "auto",
			ymin: "auto 0",
			goals: [],
			goalStrokeWidth: 1,
			goalLineColors: ["#666633", "#999966", "#cc6666", "#663333"],
			events: [],
			eventStrokeWidth: 1,
			eventLineColors: ["#005a04", "#ccffbb", "#3a5f0b", "#005502"],
			rangeSelect: null,
			rangeSelectColor: "#eef",
			resize: !1
		}, n.prototype.setData = function (t, i) {
			var n, r, o, a, s, l, c, u, h, d, p, f, m, g, v;
			return null == i && (i = !0), this.options.data = t, null == t || 0 === t.length ? (this.data = [], this.raphael.clear(), void (null != this.hover && this.hover.hide())) : (f = this.cumulative ? 0 : null, m = this.cumulative ? 0 : null, this.options.goals.length > 0 && (s = Math.min.apply(Math, this.options.goals), a = Math.max.apply(Math, this.options.goals), m = null != m ? Math.min(m, s) : s, f = null != f ? Math.max(f, a) : a), this.data = function () {
				var i, n, a;
				for (a = [], o = i = 0, n = t.length; i < n; o = ++i) c = t[o], (l = {src: c}).label = c[this.options.xkey], this.options.parseTime ? (l.x = e.parseDate(l.label), this.options.dateFormat ? l.label = this.options.dateFormat(l.x) : "number" == typeof l.label && (l.label = new Date(l.label).toString())) : (l.x = o, this.options.xLabelFormat && (l.label = this.options.xLabelFormat(l))), h = 0, l.y = function () {
					var t, e, i, n;
					for (i = this.options.ykeys, n = [], r = t = 0, e = i.length; t < e; r = ++t) p = i[r], "string" == typeof (g = c[p]) && (g = parseFloat(g)), null != g && "number" != typeof g && (g = null), null != g && (this.cumulative ? h += g : null != f ? (f = Math.max(g, f), m = Math.min(g, m)) : f = m = g), this.cumulative && null != h && (f = Math.max(h, f), m = Math.min(h, m)), n.push(g);
					return n
				}.call(this), a.push(l);
				return a
			}.call(this), this.options.parseTime && (this.data = this.data.sort(function (t, e) {
				return (t.x > e.x) - (e.x > t.x)
			})), this.xmin = this.data[0].x, this.xmax = this.data[this.data.length - 1].x, this.events = [], this.options.events.length > 0 && (this.options.parseTime ? this.events = function () {
				var t, i, r, o;
				for (o = [], t = 0, i = (r = this.options.events).length; t < i; t++) n = r[t], o.push(e.parseDate(n));
				return o
			}.call(this) : this.events = this.options.events, this.xmax = Math.max(this.xmax, Math.max.apply(Math, this.events)), this.xmin = Math.min(this.xmin, Math.min.apply(Math, this.events))), this.xmin === this.xmax && (this.xmin -= 1, this.xmax += 1), this.ymin = this.yboundary("min", m), this.ymax = this.yboundary("max", f), this.ymin === this.ymax && (m && (this.ymin -= 1), this.ymax += 1), !0 !== (v = this.options.axes) && "both" !== v && "y" !== v && !0 !== this.options.grid || (this.options.ymax === this.gridDefaults.ymax && this.options.ymin === this.gridDefaults.ymin ? (this.grid = this.autoGridLines(this.ymin, this.ymax, this.options.numLines), this.ymin = Math.min(this.ymin, this.grid[0]), this.ymax = Math.max(this.ymax, this.grid[this.grid.length - 1])) : (u = (this.ymax - this.ymin) / (this.options.numLines - 1), this.grid = function () {
				var t, e, i;
				for (i = [], d = t = this.ymin, e = this.ymax; u > 0 ? t <= e : t >= e; d = t += u) i.push(d);
				return i
			}.call(this))), this.dirty = !0, i ? this.redraw() : void 0)
		}, n.prototype.yboundary = function (t, e) {
			var i, n;
			return "string" == typeof (i = this.options["y" + t]) ? "auto" === i.slice(0, 4) ? i.length > 5 ? (n = parseInt(i.slice(5), 10), null == e ? n : Math[t](e, n)) : null != e ? e : 0 : parseInt(i, 10) : i
		}, n.prototype.autoGridLines = function (t, e, i) {
			var n, r, o, a, s, l, c, u, h;
			return s = e - t, h = Math.floor(Math.log(s) / Math.log(10)), c = Math.pow(10, h), r = Math.floor(t / c) * c, n = Math.ceil(e / c) * c, l = (n - r) / (i - 1), 1 === c && l > 1 && Math.ceil(l) !== l && (l = Math.ceil(l), n = r + l * (i - 1)), r < 0 && n > 0 && (r = Math.floor(t / l) * l, n = Math.ceil(e / l) * l), l < 1 ? (a = Math.floor(Math.log(l) / Math.log(10)), o = function () {
				var t, e;
				for (e = [], u = t = r; l > 0 ? t <= n : t >= n; u = t += l) e.push(parseFloat(u.toFixed(1 - a)));
				return e
			}()) : o = function () {
				var t, e;
				for (e = [], u = t = r; l > 0 ? t <= n : t >= n; u = t += l) e.push(u);
				return e
			}(), o
		}, n.prototype._calc = function () {
			var t, e, i, n, r, o, a, s;
			if (r = this.el.width(), i = this.el.height(), (this.elementWidth !== r || this.elementHeight !== i || this.dirty) && (this.elementWidth = r, this.elementHeight = i, this.dirty = !1, this.left = this.options.padding, this.right = this.elementWidth - this.options.padding, this.top = this.options.padding, this.bottom = this.elementHeight - this.options.padding, !0 !== (a = this.options.axes) && "both" !== a && "y" !== a || (o = function () {
				var t, i, n, r;
				for (r = [], t = 0, i = (n = this.grid).length; t < i; t++) e = n[t], r.push(this.measureText(this.yAxisFormat(e)).width);
				return r
			}.call(this), this.left += Math.max.apply(Math, o)), !0 !== (s = this.options.axes) && "both" !== s && "x" !== s || (t = function () {
				var t, e, i;
				for (i = [], n = t = 0, e = this.data.length; 0 <= e ? t < e : t > e; n = 0 <= e ? ++t : --t) i.push(this.measureText(this.data[n].text, -this.options.xLabelAngle).height);
				return i
			}.call(this), this.bottom -= Math.max.apply(Math, t)), this.width = Math.max(1, this.right - this.left), this.height = Math.max(1, this.bottom - this.top), this.dx = this.width / (this.xmax - this.xmin), this.dy = this.height / (this.ymax - this.ymin), this.calc)) return this.calc()
		}, n.prototype.transY = function (t) {
			return this.bottom - (t - this.ymin) * this.dy
		}, n.prototype.transX = function (t) {
			return 1 === this.data.length ? (this.left + this.right) / 2 : this.left + (t - this.xmin) * this.dx
		}, n.prototype.redraw = function () {
			if (this.raphael.clear(), this._calc(), this.drawGrid(), this.drawGoals(), this.drawEvents(), this.draw) return this.draw()
		}, n.prototype.measureText = function (t, e) {
			var i, n;
			return null == e && (e = 0), i = (n = this.raphael.text(100, 100, t).attr("font-size", this.options.gridTextSize).attr("font-family", this.options.gridTextFamily).attr("font-weight", this.options.gridTextWeight).rotate(e)).getBBox(), n.remove(), i
		}, n.prototype.yAxisFormat = function (t) {
			return this.yLabelFormat(t)
		}, n.prototype.yLabelFormat = function (t) {
			return "function" == typeof this.options.yLabelFormat ? this.options.yLabelFormat(t) : "" + this.options.preUnits + e.commas(t) + this.options.postUnits
		}, n.prototype.drawGrid = function () {
			var t, e, i, n, r, o, a, s;
			if (!1 !== this.options.grid || !0 === (r = this.options.axes) || "both" === r || "y" === r) {
				for (s = [], i = 0, n = (o = this.grid).length; i < n; i++) t = o[i], e = this.transY(t), !0 !== (a = this.options.axes) && "both" !== a && "y" !== a || this.drawYAxisLabel(this.left - this.options.padding / 2, e, this.yAxisFormat(t)), this.options.grid ? s.push(this.drawGridLine("M" + this.left + "," + e + "H" + (this.left + this.width))) : s.push(void 0);
				return s
			}
		}, n.prototype.drawGoals = function () {
			var t, e, i, n, r, o, a;
			for (a = [], i = n = 0, r = (o = this.options.goals).length; n < r; i = ++n) e = o[i], t = this.options.goalLineColors[i % this.options.goalLineColors.length], a.push(this.drawGoal(e, t));
			return a
		}, n.prototype.drawEvents = function () {
			var t, e, i, n, r, o, a;
			for (a = [], i = n = 0, r = (o = this.events).length; n < r; i = ++n) e = o[i], t = this.options.eventLineColors[i % this.options.eventLineColors.length], a.push(this.drawEvent(e, t));
			return a
		}, n.prototype.drawGoal = function (t, e) {
			return this.raphael.path("M" + this.left + "," + this.transY(t) + "H" + this.right).attr("stroke", e).attr("stroke-width", this.options.goalStrokeWidth)
		}, n.prototype.drawEvent = function (t, e) {
			return this.raphael.path("M" + this.transX(t) + "," + this.bottom + "V" + this.top).attr("stroke", e).attr("stroke-width", this.options.eventStrokeWidth)
		}, n.prototype.drawYAxisLabel = function (t, e, i) {
			return this.raphael.text(t, e, i).attr("font-size", this.options.gridTextSize).attr("font-family", this.options.gridTextFamily).attr("font-weight", this.options.gridTextWeight).attr("fill", this.options.gridTextColor).attr("text-anchor", "end")
		}, n.prototype.drawGridLine = function (t) {
			return this.raphael.path(t).attr("stroke", this.options.gridLineColor).attr("stroke-width", this.options.gridStrokeWidth)
		}, n.prototype.startRange = function (t) {
			return this.hover.hide(), this.selectFrom = t, this.selectionRect.attr({x: t, width: 0}).show()
		}, n.prototype.endRange = function (t) {
			var e, i;
			if (this.selectFrom) return i = Math.min(this.selectFrom, t), e = Math.max(this.selectFrom, t), this.options.rangeSelect.call(this.el, {start: this.data[this.hitTest(i)].x, end: this.data[this.hitTest(e)].x}), this.selectFrom = null
		}, n.prototype.resizeHandler = function () {
			return this.timeoutId = null, this.raphael.setSize(this.el.width(), this.el.height()), this.redraw()
		}, n
	}(e.EventEmitter), e.parseDate = function (t) {
		var e, i, n, r, o, a, s, l, c, u, h;
		return "number" == typeof t ? t : (i = t.match(/^(\d+) Q(\d)$/), r = t.match(/^(\d+)-(\d+)$/), o = t.match(/^(\d+)-(\d+)-(\d+)$/), s = t.match(/^(\d+) W(\d+)$/), l = t.match(/^(\d+)-(\d+)-(\d+)[ T](\d+):(\d+)(Z|([+-])(\d\d):?(\d\d))?$/), c = t.match(/^(\d+)-(\d+)-(\d+)[ T](\d+):(\d+):(\d+(\.\d+)?)(Z|([+-])(\d\d):?(\d\d))?$/), i ? new Date(parseInt(i[1], 10), 3 * parseInt(i[2], 10) - 1, 1).getTime() : r ? new Date(parseInt(r[1], 10), parseInt(r[2], 10) - 1, 1).getTime() : o ? new Date(parseInt(o[1], 10), parseInt(o[2], 10) - 1, parseInt(o[3], 10)).getTime() : s ? (4 !== (u = new Date(parseInt(s[1], 10), 0, 1)).getDay() && u.setMonth(0, 1 + (4 - u.getDay() + 7) % 7), u.getTime() + 6048e5 * parseInt(s[2], 10)) : l ? l[6] ? (a = 0, "Z" !== l[6] && (a = 60 * parseInt(l[8], 10) + parseInt(l[9], 10), "+" === l[7] && (a = 0 - a)), Date.UTC(parseInt(l[1], 10), parseInt(l[2], 10) - 1, parseInt(l[3], 10), parseInt(l[4], 10), parseInt(l[5], 10) + a)) : new Date(parseInt(l[1], 10), parseInt(l[2], 10) - 1, parseInt(l[3], 10), parseInt(l[4], 10), parseInt(l[5], 10)).getTime() : c ? (h = parseFloat(c[6]), e = Math.floor(h), n = Math.round(1e3 * (h - e)), c[8] ? (a = 0, "Z" !== c[8] && (a = 60 * parseInt(c[10], 10) + parseInt(c[11], 10), "+" === c[9] && (a = 0 - a)), Date.UTC(parseInt(c[1], 10), parseInt(c[2], 10) - 1, parseInt(c[3], 10), parseInt(c[4], 10), parseInt(c[5], 10) + a, e, n)) : new Date(parseInt(c[1], 10), parseInt(c[2], 10) - 1, parseInt(c[3], 10), parseInt(c[4], 10), parseInt(c[5], 10), e, n).getTime()) : new Date(parseInt(t, 10), 0, 1).getTime())
	}, e.Hover = function () {
		function i(i) {
			null == i && (i = {}), this.options = t.extend({}, e.Hover.defaults, i), this.el = t("<div class='" + this.options.class + "'></div>"), this.el.hide(), this.options.parent.append(this.el)
		}

		return i.defaults = {class: "morris-hover morris-default-style"}, i.prototype.update = function (t, e, i) {
			return t ? (this.html(t), this.show(), this.moveTo(e, i)) : this.hide()
		}, i.prototype.html = function (t) {
			return this.el.html(t)
		}, i.prototype.moveTo = function (t, e) {
			var i, n, r, o, a, s;
			return a = this.options.parent.innerWidth(), o = this.options.parent.innerHeight(), n = this.el.outerWidth(), i = this.el.outerHeight(), r = Math.min(Math.max(0, t - n / 2), a - n), null != e ? (s = e - i - 10) < 0 && (s = e + 10) + i > o && (s = o / 2 - i / 2) : s = o / 2 - i / 2, this.el.css({
				left: r + "px",
				top: parseInt(s) + "px"
			})
		}, i.prototype.show = function () {
			return this.el.show()
		}, i.prototype.hide = function () {
			return this.el.hide()
		}, i
	}(), e.Line = function (t) {
		function i(t) {
			if (this.hilight = o(this.hilight, this), this.onHoverOut = o(this.onHoverOut, this), this.onHoverMove = o(this.onHoverMove, this), this.onGridClick = o(this.onGridClick, this), !(this instanceof e.Line)) return new e.Line(t);
			i.__super__.constructor.call(this, t)
		}

		return s(i, t), i.prototype.init = function () {
			if ("always" !== this.options.hideHover) return this.hover = new e.Hover({parent: this.el}), this.on("hovermove", this.onHoverMove), this.on("hoverout", this.onHoverOut), this.on("gridclick", this.onGridClick)
		}, i.prototype.defaults = {
			lineWidth: 3,
			pointSize: 4,
			lineColors: ["#0b62a4", "#7A92A3", "#4da74d", "#afd8f8", "#edc240", "#cb4b4b", "#9440ed"],
			pointStrokeWidths: [1],
			pointStrokeColors: ["#ffffff"],
			pointFillColors: [],
			smooth: !0,
			xLabels: "auto",
			xLabelFormat: null,
			xLabelMargin: 24,
			hideHover: !1
		}, i.prototype.calc = function () {
			return this.calcPoints(), this.generatePaths()
		}, i.prototype.calcPoints = function () {
			var t, e, i, n, r, o;
			for (o = [], i = 0, n = (r = this.data).length; i < n; i++) (t = r[i])._x = this.transX(t.x), t._y = function () {
				var i, n, r, o;
				for (o = [], i = 0, n = (r = t.y).length; i < n; i++) null != (e = r[i]) ? o.push(this.transY(e)) : o.push(e);
				return o
			}.call(this), o.push(t._ymax = Math.min.apply(Math, [this.bottom].concat(function () {
				var i, n, r, o;
				for (o = [], i = 0, n = (r = t._y).length; i < n; i++) null != (e = r[i]) && o.push(e);
				return o
			}())));
			return o
		}, i.prototype.hitTest = function (t) {
			var e, i, n, r;
			if (0 === this.data.length) return null;
			for (e = i = 0, n = (r = this.data.slice(1)).length; i < n && !(t < (r[e]._x + this.data[e]._x) / 2); e = ++i) ;
			return e
		}, i.prototype.onGridClick = function (t, e) {
			var i;
			return i = this.hitTest(t), this.fire("click", i, this.data[i].src, t, e)
		}, i.prototype.onHoverMove = function (t, e) {
			var i;
			return i = this.hitTest(t), this.displayHoverForRow(i)
		}, i.prototype.onHoverOut = function () {
			if (!1 !== this.options.hideHover) return this.displayHoverForRow(null)
		}, i.prototype.displayHoverForRow = function (t) {
			var e;
			return null != t ? ((e = this.hover).update.apply(e, this.hoverContentForRow(t)), this.hilight(t)) : (this.hover.hide(), this.hilight())
		}, i.prototype.hoverContentForRow = function (t) {
			var e, i, n, r, o, a, s;
			for (e = "<div class='morris-hover-row-label'>" + (n = this.data[t]).label + "</div>", i = o = 0, a = (s = n.y).length; o < a; i = ++o) r = s[i], e += "<div class='morris-hover-point' style='color: " + this.colorFor(n, i, "label") + "'>\n  " + this.options.labels[i] + ":\n  " + this.yLabelFormat(r) + "\n</div>";
			return "function" == typeof this.options.hoverCallback && (e = this.options.hoverCallback(t, this.options, e, n.src)), [e, n._x, n._ymax]
		}, i.prototype.generatePaths = function () {
			var t, i, n, r;
			return this.paths = function () {
				var o, a, s, c;
				for (c = [], i = o = 0, a = this.options.ykeys.length; 0 <= a ? o < a : o > a; i = 0 <= a ? ++o : --o) r = "boolean" == typeof this.options.smooth ? this.options.smooth : (s = this.options.ykeys[i], l.call(this.options.smooth, s) >= 0), (t = function () {
					var t, e, r, o;
					for (o = [], t = 0, e = (r = this.data).length; t < e; t++) void 0 !== (n = r[t])._y[i] && o.push({x: n._x, y: n._y[i]});
					return o
				}.call(this)).length > 1 ? c.push(e.Line.createPath(t, r, this.bottom)) : c.push(null);
				return c
			}.call(this)
		}, i.prototype.draw = function () {
			var t;
			if (!0 !== (t = this.options.axes) && "both" !== t && "x" !== t || this.drawXAxis(), this.drawSeries(), !1 === this.options.hideHover) return this.displayHoverForRow(this.data.length - 1)
		}, i.prototype.drawXAxis = function () {
			var t, i, n, r, o, a, s, l, c, u, h = this;
			for (s = this.bottom + this.options.padding / 2, o = null, r = null, t = function (t, e) {
				var i, n, a, l, c;
				return c = (i = h.drawXAxisLabel(h.transX(e), s, t)).getBBox(), i.transform("r" + -h.options.xLabelAngle), n = i.getBBox(), i.transform("t0," + n.height / 2 + "..."), 0 !== h.options.xLabelAngle && (l = -.5 * c.width * Math.cos(h.options.xLabelAngle * Math.PI / 180), i.transform("t" + l + ",0...")), n = i.getBBox(), (null == o || o >= n.x + n.width || null != r && r >= n.x) && n.x >= 0 && n.x + n.width < h.el.width() ? (0 !== h.options.xLabelAngle && (a = 1.25 * h.options.gridTextSize / Math.sin(h.options.xLabelAngle * Math.PI / 180), r = n.x - a), o = n.x - h.options.xLabelMargin) : i.remove()
			}, (n = this.options.parseTime ? 1 === this.data.length && "auto" === this.options.xLabels ? [[this.data[0].label, this.data[0].x]] : e.labelSeries(this.xmin, this.xmax, this.width, this.options.xLabels, this.options.xLabelFormat) : function () {
				var t, e, i, n;
				for (n = [], t = 0, e = (i = this.data).length; t < e; t++) a = i[t], n.push([a.label, a.x]);
				return n
			}.call(this)).reverse(), u = [], l = 0, c = n.length; l < c; l++) i = n[l], u.push(t(i[0], i[1]));
			return u
		}, i.prototype.drawSeries = function () {
			var t, e, i, n, r, o;
			for (this.seriesPoints = [], t = e = n = this.options.ykeys.length - 1; n <= 0 ? e <= 0 : e >= 0; t = n <= 0 ? ++e : --e) this._drawLineFor(t);
			for (o = [], t = i = r = this.options.ykeys.length - 1; r <= 0 ? i <= 0 : i >= 0; t = r <= 0 ? ++i : --i) o.push(this._drawPointFor(t));
			return o
		}, i.prototype._drawPointFor = function (t) {
			var e, i, n, r, o, a;
			for (this.seriesPoints[t] = [], a = [], n = 0, r = (o = this.data).length; n < r; n++) e = null, null != (i = o[n])._y[t] && (e = this.drawLinePoint(i._x, i._y[t], this.colorFor(i, t, "point"), t)), a.push(this.seriesPoints[t].push(e));
			return a
		}, i.prototype._drawLineFor = function (t) {
			var e;
			if (null !== (e = this.paths[t])) return this.drawLinePath(e, this.colorFor(null, t, "line"), t)
		}, i.createPath = function (t, i, n) {
			var r, o, a, s, l, c, u, h, d, p;
			for (u = "", i && (a = e.Line.gradients(t)), h = {y: null}, s = d = 0, p = t.length; d < p; s = ++d) null != (r = t[s]).y && (null != h.y ? i ? (o = a[s], c = a[s - 1], l = (r.x - h.x) / 4, u += "C" + (h.x + l) + "," + Math.min(n, h.y + l * c) + "," + (r.x - l) + "," + Math.min(n, r.y - l * o) + "," + r.x + "," + r.y) : u += "L" + r.x + "," + r.y : i && null == a[s] || (u += "M" + r.x + "," + r.y)), h = r;
			return u
		}, i.gradients = function (t) {
			var e, i, n, r, o, a, s, l;
			for (i = function (t, e) {
				return (t.y - e.y) / (t.x - e.x)
			}, l = [], n = a = 0, s = t.length; a < s; n = ++a) null != (e = t[n]).y ? (r = t[n + 1] || {y: null}, null != (o = t[n - 1] || {y: null}).y && null != r.y ? l.push(i(o, r)) : null != o.y ? l.push(i(o, e)) : null != r.y ? l.push(i(e, r)) : l.push(null)) : l.push(null);
			return l
		}, i.prototype.hilight = function (t) {
			var e, i, n, r, o;
			if (null !== this.prevHilight && this.prevHilight !== t) for (e = i = 0, r = this.seriesPoints.length - 1; 0 <= r ? i <= r : i >= r; e = 0 <= r ? ++i : --i) this.seriesPoints[e][this.prevHilight] && this.seriesPoints[e][this.prevHilight].animate(this.pointShrinkSeries(e));
			if (null !== t && this.prevHilight !== t) for (e = n = 0, o = this.seriesPoints.length - 1; 0 <= o ? n <= o : n >= o; e = 0 <= o ? ++n : --n) this.seriesPoints[e][t] && this.seriesPoints[e][t].animate(this.pointGrowSeries(e));
			return this.prevHilight = t
		}, i.prototype.colorFor = function (t, e, i) {
			return "function" == typeof this.options.lineColors ? this.options.lineColors.call(this, t, e, i) : "point" === i && this.options.pointFillColors[e % this.options.pointFillColors.length] || this.options.lineColors[e % this.options.lineColors.length]
		}, i.prototype.drawXAxisLabel = function (t, e, i) {
			return this.raphael.text(t, e, i).attr("font-size", this.options.gridTextSize).attr("font-family", this.options.gridTextFamily).attr("font-weight", this.options.gridTextWeight).attr("fill", this.options.gridTextColor)
		}, i.prototype.drawLinePath = function (t, e, i) {
			return this.raphael.path(t).attr("stroke", e).attr("stroke-width", this.lineWidthForSeries(i))
		}, i.prototype.drawLinePoint = function (t, e, i, n) {
			return this.raphael.circle(t, e, this.pointSizeForSeries(n)).attr("fill", i).attr("stroke-width", this.pointStrokeWidthForSeries(n)).attr("stroke", this.pointStrokeColorForSeries(n))
		}, i.prototype.pointStrokeWidthForSeries = function (t) {
			return this.options.pointStrokeWidths[t % this.options.pointStrokeWidths.length]
		}, i.prototype.pointStrokeColorForSeries = function (t) {
			return this.options.pointStrokeColors[t % this.options.pointStrokeColors.length]
		}, i.prototype.lineWidthForSeries = function (t) {
			return this.options.lineWidth instanceof Array ? this.options.lineWidth[t % this.options.lineWidth.length] : this.options.lineWidth
		}, i.prototype.pointSizeForSeries = function (t) {
			return this.options.pointSize instanceof Array ? this.options.pointSize[t % this.options.pointSize.length] : this.options.pointSize
		}, i.prototype.pointGrowSeries = function (t) {
			return Raphael.animation({r: this.pointSizeForSeries(t) + 3}, 25, "linear")
		}, i.prototype.pointShrinkSeries = function (t) {
			return Raphael.animation({r: this.pointSizeForSeries(t)}, 25, "linear")
		}, i
	}(e.Grid), e.labelSeries = function (i, n, r, o, a) {
		var s, l, c, u, h, d, p, f, m, g, v;
		if (c = 200 * (n - i) / r, l = new Date(i), void 0 === (p = e.LABEL_SPECS[o])) for (m = 0, g = (v = e.AUTO_LABEL_ORDER).length; m < g; m++) if (u = v[m], c >= (d = e.LABEL_SPECS[u]).span) {
			p = d;
			break
		}
		for (void 0 === p && (p = e.LABEL_SPECS.second), a && (p = t.extend({}, p, {fmt: a})), s = p.start(l), h = []; (f = s.getTime()) <= n;) f >= i && h.push([p.fmt(s), f]), p.incr(s);
		return h
	}, i = function (t) {
		return {
			span: 60 * t * 1e3, start: function (t) {
				return new Date(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours())
			}, fmt: function (t) {
				return e.pad2(t.getHours()) + ":" + e.pad2(t.getMinutes())
			}, incr: function (e) {
				return e.setUTCMinutes(e.getUTCMinutes() + t)
			}
		}
	}, n = function (t) {
		return {
			span: 1e3 * t, start: function (t) {
				return new Date(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes())
			}, fmt: function (t) {
				return e.pad2(t.getHours()) + ":" + e.pad2(t.getMinutes()) + ":" + e.pad2(t.getSeconds())
			}, incr: function (e) {
				return e.setUTCSeconds(e.getUTCSeconds() + t)
			}
		}
	}, e.LABEL_SPECS = {
		decade: {
			span: 1728e8, start: function (t) {
				return new Date(t.getFullYear() - t.getFullYear() % 10, 0, 1)
			}, fmt: function (t) {
				return "" + t.getFullYear()
			}, incr: function (t) {
				return t.setFullYear(t.getFullYear() + 10)
			}
		}, year: {
			span: 1728e7, start: function (t) {
				return new Date(t.getFullYear(), 0, 1)
			}, fmt: function (t) {
				return "" + t.getFullYear()
			}, incr: function (t) {
				return t.setFullYear(t.getFullYear() + 1)
			}
		}, month: {
			span: 24192e5, start: function (t) {
				return new Date(t.getFullYear(), t.getMonth(), 1)
			}, fmt: function (t) {
				return t.getFullYear() + "-" + e.pad2(t.getMonth() + 1)
			}, incr: function (t) {
				return t.setMonth(t.getMonth() + 1)
			}
		}, week: {
			span: 6048e5, start: function (t) {
				return new Date(t.getFullYear(), t.getMonth(), t.getDate())
			}, fmt: function (t) {
				return t.getFullYear() + "-" + e.pad2(t.getMonth() + 1) + "-" + e.pad2(t.getDate())
			}, incr: function (t) {
				return t.setDate(t.getDate() + 7)
			}
		}, day: {
			span: 864e5, start: function (t) {
				return new Date(t.getFullYear(), t.getMonth(), t.getDate())
			}, fmt: function (t) {
				return t.getFullYear() + "-" + e.pad2(t.getMonth() + 1) + "-" + e.pad2(t.getDate())
			}, incr: function (t) {
				return t.setDate(t.getDate() + 1)
			}
		}, hour: i(60), "30min": i(30), "15min": i(15), "10min": i(10), "5min": i(5), minute: i(1), "30sec": n(30), "15sec": n(15), "10sec": n(10), "5sec": n(5), second: n(1)
	}, e.AUTO_LABEL_ORDER = ["decade", "year", "month", "week", "day", "hour", "30min", "15min", "10min", "5min", "minute", "30sec", "15sec", "10sec", "5sec", "second"], e.Area = function (i) {
		var n;

		function r(i) {
			var o;
			if (!(this instanceof e.Area)) return new e.Area(i);
			o = t.extend({}, n, i), this.cumulative = !o.behaveLikeLine, "auto" === o.fillOpacity && (o.fillOpacity = o.behaveLikeLine ? .8 : 1), r.__super__.constructor.call(this, o)
		}

		return s(r, i), n = {fillOpacity: "auto", behaveLikeLine: !1}, r.prototype.calcPoints = function () {
			var t, e, i, n, r, o, a;
			for (a = [], n = 0, r = (o = this.data).length; n < r; n++) (t = o[n])._x = this.transX(t.x), e = 0, t._y = function () {
				var n, r, o, a;
				for (a = [], n = 0, r = (o = t.y).length; n < r; n++) i = o[n], this.options.behaveLikeLine ? a.push(this.transY(i)) : (e += i || 0, a.push(this.transY(e)));
				return a
			}.call(this), a.push(t._ymax = Math.max.apply(Math, t._y));
			return a
		}, r.prototype.drawSeries = function () {
			var t, e, i, n, r, o, a, s;
			for (this.seriesPoints = [], s = [], i = 0, n = (e = this.options.behaveLikeLine ? function () {
				o = [];
				for (var t = 0, e = this.options.ykeys.length - 1; 0 <= e ? t <= e : t >= e; 0 <= e ? t++ : t--) o.push(t);
				return o
			}.apply(this) : function () {
				a = [];
				for (var t = r = this.options.ykeys.length - 1; r <= 0 ? t <= 0 : t >= 0; r <= 0 ? t++ : t--) a.push(t);
				return a
			}.apply(this)).length; i < n; i++) t = e[i], this._drawFillFor(t), this._drawLineFor(t), s.push(this._drawPointFor(t));
			return s
		}, r.prototype._drawFillFor = function (t) {
			var e;
			if (null !== (e = this.paths[t])) return e = e + "L" + this.transX(this.xmax) + "," + this.bottom + "L" + this.transX(this.xmin) + "," + this.bottom + "Z", this.drawFilledPath(e, this.fillForSeries(t))
		}, r.prototype.fillForSeries = function (t) {
			var e;
			return e = Raphael.rgb2hsl(this.colorFor(this.data[t], t, "line")), Raphael.hsl(e.h, this.options.behaveLikeLine ? .9 * e.s : .75 * e.s, Math.min(.98, this.options.behaveLikeLine ? 1.2 * e.l : 1.25 * e.l))
		}, r.prototype.drawFilledPath = function (t, e) {
			return this.raphael.path(t).attr("fill", e).attr("fill-opacity", this.options.fillOpacity).attr("stroke", "none")
		}, r
	}(e.Line), e.Bar = function (i) {
		function n(i) {
			if (this.onHoverOut = o(this.onHoverOut, this), this.onHoverMove = o(this.onHoverMove, this), this.onGridClick = o(this.onGridClick, this), !(this instanceof e.Bar)) return new e.Bar(i);
			n.__super__.constructor.call(this, t.extend({}, i, {parseTime: !1}))
		}

		return s(n, i), n.prototype.init = function () {
			if (this.cumulative = this.options.stacked, "always" !== this.options.hideHover) return this.hover = new e.Hover({parent: this.el}), this.on("hovermove", this.onHoverMove), this.on("hoverout", this.onHoverOut), this.on("gridclick", this.onGridClick)
		}, n.prototype.defaults = {barSizeRatio: .75, barGap: 3, barColors: ["#0b62a4", "#7a92a3", "#4da74d", "#afd8f8", "#edc240", "#cb4b4b", "#9440ed"], barOpacity: 1, barRadius: [0, 0, 0, 0], xLabelMargin: 50}, n.prototype.calc = function () {
			var t;
			if (this.calcBars(), !1 === this.options.hideHover) return (t = this.hover).update.apply(t, this.hoverContentForRow(this.data.length - 1))
		}, n.prototype.calcBars = function () {
			var t, e, i, n, r, o, a;
			for (a = [], t = n = 0, r = (o = this.data).length; n < r; t = ++n) (e = o[t])._x = this.left + this.width * (t + .5) / this.data.length, a.push(e._y = function () {
				var t, n, r, o;
				for (o = [], t = 0, n = (r = e.y).length; t < n; t++) null != (i = r[t]) ? o.push(this.transY(i)) : o.push(null);
				return o
			}.call(this));
			return a
		}, n.prototype.draw = function () {
			var t;
			return !0 !== (t = this.options.axes) && "both" !== t && "x" !== t || this.drawXAxis(), this.drawSeries()
		}, n.prototype.drawXAxis = function () {
			var t, e, i, n, r, o, a, s, l, c, u, h, d;
			for (c = this.bottom + (this.options.xAxisLabelTopPadding || this.options.padding / 2), a = null, o = null, d = [], t = u = 0, h = this.data.length; 0 <= h ? u < h : u > h; t = 0 <= h ? ++u : --u) s = this.data[this.data.length - 1 - t], l = (e = this.drawXAxisLabel(s._x, c, s.label)).getBBox(), e.transform("r" + -this.options.xLabelAngle), i = e.getBBox(), e.transform("t0," + i.height / 2 + "..."), 0 !== this.options.xLabelAngle && (r = -.5 * l.width * Math.cos(this.options.xLabelAngle * Math.PI / 180), e.transform("t" + r + ",0...")), (null == a || a >= i.x + i.width || null != o && o >= i.x) && i.x >= 0 && i.x + i.width < this.el.width() ? (0 !== this.options.xLabelAngle && (n = 1.25 * this.options.gridTextSize / Math.sin(this.options.xLabelAngle * Math.PI / 180), o = i.x - n), d.push(a = i.x - this.options.xLabelMargin)) : d.push(e.remove());
			return d
		}, n.prototype.drawSeries = function () {
			var t, e, i, n, r, o, a, s, l, c, u, h, d, p, f;
			return i = this.width / this.options.data.length, s = this.options.stacked ? 1 : this.options.ykeys.length, t = (i * this.options.barSizeRatio - this.options.barGap * (s - 1)) / s, this.options.barSize && (t = Math.min(t, this.options.barSize)), h = i - t * s - this.options.barGap * (s - 1), a = h / 2, f = this.ymin <= 0 && this.ymax >= 0 ? this.transY(0) : null, this.bars = function () {
				var s, h, m, g;
				for (m = this.data, g = [], n = s = 0, h = m.length; s < h; n = ++s) l = m[n], r = 0, g.push(function () {
					var s, h, m, g;
					for (m = l._y, g = [], c = s = 0, h = m.length; s < h; c = ++s) null !== (p = m[c]) ? (f ? (d = Math.min(p, f), e = Math.max(p, f)) : (d = p, e = this.bottom), o = this.left + n * i + a, this.options.stacked || (o += c * (t + this.options.barGap)), u = e - d, this.options.verticalGridCondition && this.options.verticalGridCondition(l.x) && this.drawBar(this.left + n * i, this.top, i, Math.abs(this.top - this.bottom), this.options.verticalGridColor, this.options.verticalGridOpacity, this.options.barRadius), this.options.stacked && (d -= r), this.drawBar(o, d, t, u, this.colorFor(l, c, "bar"), this.options.barOpacity, this.options.barRadius), g.push(r += u)) : g.push(null);
					return g
				}.call(this));
				return g
			}.call(this)
		}, n.prototype.colorFor = function (t, e, i) {
			var n, r;
			return "function" == typeof this.options.barColors ? (n = {x: t.x, y: t.y[e], label: t.label}, r = {index: e, key: this.options.ykeys[e], label: this.options.labels[e]}, this.options.barColors.call(this, n, r, i)) : this.options.barColors[e % this.options.barColors.length]
		}, n.prototype.hitTest = function (t) {
			return 0 === this.data.length ? null : (t = Math.max(Math.min(t, this.right), this.left), Math.min(this.data.length - 1, Math.floor((t - this.left) / (this.width / this.data.length))))
		}, n.prototype.onGridClick = function (t, e) {
			var i;
			return i = this.hitTest(t), this.fire("click", i, this.data[i].src, t, e)
		}, n.prototype.onHoverMove = function (t, e) {
			var i, n;
			return i = this.hitTest(t), (n = this.hover).update.apply(n, this.hoverContentForRow(i))
		}, n.prototype.onHoverOut = function () {
			if (!1 !== this.options.hideHover) return this.hover.hide()
		}, n.prototype.hoverContentForRow = function (t) {
			var e, i, n, r, o, a, s;
			for (e = "<div class='morris-hover-row-label'>" + (n = this.data[t]).label + "</div>", i = o = 0, a = (s = n.y).length; o < a; i = ++o) r = s[i], e += "<div class='morris-hover-point' style='color: " + this.colorFor(n, i, "label") + "'>\n  " + this.options.labels[i] + ":\n  " + this.yLabelFormat(r) + "\n</div>";
			return "function" == typeof this.options.hoverCallback && (e = this.options.hoverCallback(t, this.options, e, n.src)), [e, this.left + (t + .5) * this.width / this.data.length]
		}, n.prototype.drawXAxisLabel = function (t, e, i) {
			return this.raphael.text(t, e, i).attr("font-size", this.options.gridTextSize).attr("font-family", this.options.gridTextFamily).attr("font-weight", this.options.gridTextWeight).attr("fill", this.options.gridTextColor)
		}, n.prototype.drawBar = function (t, e, i, n, r, o, a) {
			var s;
			return (0 === (s = Math.max.apply(Math, a)) || s > n ? this.raphael.rect(t, e, i, n) : this.raphael.path(this.roundedRect(t, e, i, n, a))).attr("fill", r).attr("fill-opacity", o).attr("stroke", "none")
		}, n.prototype.roundedRect = function (t, e, i, n, r) {
			return null == r && (r = [0, 0, 0, 0]), ["M", t, r[0] + e, "Q", t, e, t + r[0], e, "L", t + i - r[1], e, "Q", t + i, e, t + i, e + r[1], "L", t + i, e + n - r[2], "Q", t + i, e + n, t + i - r[2], e + n, "L", t + r[3], e + n, "Q", t, e + n, t, e + n - r[3], "Z"]
		}, n
	}(e.Grid), e.Donut = function (i) {
		function n(i) {
			this.resizeHandler = o(this.resizeHandler, this), this.select = o(this.select, this), this.click = o(this.click, this);
			var n = this;
			if (!(this instanceof e.Donut)) return new e.Donut(i);
			if (this.options = t.extend({}, this.defaults, i), "string" == typeof i.element ? this.el = t(document.getElementById(i.element)) : this.el = t(i.element), null === this.el || 0 === this.el.length) throw new Error("Graph placeholder not found.");
			void 0 !== i.data && 0 !== i.data.length && (this.raphael = new Raphael(this.el[0]), this.options.resize && t(window).bind("resize", function (t) {
				return null != n.timeoutId && window.clearTimeout(n.timeoutId), n.timeoutId = window.setTimeout(n.resizeHandler, 100)
			}), this.setData(i.data))
		}

		return s(n, i), n.prototype.defaults = {colors: ["#0B62A4", "#3980B5", "#679DC6", "#95BBD7", "#B0CCE1", "#095791", "#095085", "#083E67", "#052C48", "#042135"], backgroundColor: "#FFFFFF", labelColor: "#000000", formatter: e.commas, resize: !1}, n.prototype.redraw = function () {
			var t, i, n, r, o, a, s, l, c, u, h, d, p, f, m, g, v, y, b, w, x, k;
			for (this.raphael.clear(), i = this.el.width() / 2, n = this.el.height() / 2, d = (Math.min(i, n) - 10) / 3, h = 0, p = 0, g = (b = this.values).length; p < g; p++) h += b[p];
			for (l = 5 / (2 * d), t = 1.9999 * Math.PI - l * this.data.length, a = 0, o = 0, this.segments = [], r = f = 0, v = (w = this.values).length; f < v; r = ++f) c = a + l + t * (w[r] / h), (u = new e.DonutSegment(i, n, 2 * d, d, a, c, this.data[r].color || this.options.colors[o % this.options.colors.length], this.options.backgroundColor, o, this.raphael)).render(), this.segments.push(u), u.on("hover", this.select), u.on("click", this.click), a = c, o += 1;
			for (this.text1 = this.drawEmptyDonutLabel(i, n - 10, this.options.labelColor, 15, 800), this.text2 = this.drawEmptyDonutLabel(i, n + 10, this.options.labelColor, 14), s = Math.max.apply(Math, this.values), o = 0, k = [], m = 0, y = (x = this.values).length; m < y; m++) {
				if (x[m] === s) {
					this.select(o);
					break
				}
				k.push(o += 1)
			}
			return k
		}, n.prototype.setData = function (t) {
			var e;
			return this.data = t, this.values = function () {
				var t, i, n, r;
				for (r = [], t = 0, i = (n = this.data).length; t < i; t++) e = n[t], r.push(parseFloat(e.value));
				return r
			}.call(this), this.redraw()
		}, n.prototype.click = function (t) {
			return this.fire("click", t, this.data[t])
		}, n.prototype.select = function (t) {
			var e, i, n, r;
			for (i = 0, n = (r = this.segments).length; i < n; i++) r[i].deselect();
			return this.segments[t].select(), e = this.data[t], this.setLabels(e.label, this.options.formatter(e.value, e))
		}, n.prototype.setLabels = function (t, e) {
			var i, n, r, o, a, s, l, c;
			return o = 1.8 * (i = 2 * (Math.min(this.el.width() / 2, this.el.height() / 2) - 10) / 3), r = i / 2, n = i / 3, this.text1.attr({
				text: t,
				transform: ""
			}), a = this.text1.getBBox(), s = Math.min(o / a.width, r / a.height), this.text1.attr({transform: "S" + s + "," + s + "," + (a.x + a.width / 2) + "," + (a.y + a.height)}), this.text2.attr({
				text: e,
				transform: ""
			}), l = this.text2.getBBox(), c = Math.min(o / l.width, n / l.height), this.text2.attr({transform: "S" + c + "," + c + "," + (l.x + l.width / 2) + "," + l.y})
		}, n.prototype.drawEmptyDonutLabel = function (t, e, i, n, r) {
			var o;
			return o = this.raphael.text(t, e, "").attr("font-size", n).attr("fill", i), null != r && o.attr("font-weight", r), o
		}, n.prototype.resizeHandler = function () {
			return this.timeoutId = null, this.raphael.setSize(this.el.width(), this.el.height()), this.redraw()
		}, n
	}(e.EventEmitter), e.DonutSegment = function (t) {
		function e(t, e, i, n, r, a, s, l, c, u) {
			this.cx = t, this.cy = e, this.inner = i, this.outer = n, this.color = s, this.backgroundColor = l, this.index = c, this.raphael = u, this.deselect = o(this.deselect, this), this.select = o(this.select, this), this.sin_p0 = Math.sin(r), this.cos_p0 = Math.cos(r), this.sin_p1 = Math.sin(a), this.cos_p1 = Math.cos(a), this.is_long = a - r > Math.PI ? 1 : 0, this.path = this.calcSegment(this.inner + 3, this.inner + this.outer - 5), this.selectedPath = this.calcSegment(this.inner + 3, this.inner + this.outer), this.hilight = this.calcArc(this.inner)
		}

		return s(e, t), e.prototype.calcArcPoints = function (t) {
			return [this.cx + t * this.sin_p0, this.cy + t * this.cos_p0, this.cx + t * this.sin_p1, this.cy + t * this.cos_p1]
		}, e.prototype.calcSegment = function (t, e) {
			var i, n, r, o, a, s, l, c, u, h;
			return i = (u = this.calcArcPoints(t))[0], r = u[1], n = u[2], o = u[3], a = (h = this.calcArcPoints(e))[0], l = h[1], s = h[2], c = h[3], "M" + i + "," + r + "A" + t + "," + t + ",0," + this.is_long + ",0," + n + "," + o + "L" + s + "," + c + "A" + e + "," + e + ",0," + this.is_long + ",1," + a + "," + l + "Z"
		}, e.prototype.calcArc = function (t) {
			var e, i, n, r, o;
			return e = (o = this.calcArcPoints(t))[0], n = o[1], i = o[2], r = o[3], "M" + e + "," + n + "A" + t + "," + t + ",0," + this.is_long + ",0," + i + "," + r
		}, e.prototype.render = function () {
			var t = this;
			return this.arc = this.drawDonutArc(this.hilight, this.color), this.seg = this.drawDonutSegment(this.path, this.color, this.backgroundColor, function () {
				return t.fire("hover", t.index)
			}, function () {
				return t.fire("click", t.index)
			})
		}, e.prototype.drawDonutArc = function (t, e) {
			return this.raphael.path(t).attr({stroke: e, "stroke-width": 2, opacity: 0})
		}, e.prototype.drawDonutSegment = function (t, e, i, n, r) {
			return this.raphael.path(t).attr({fill: e, stroke: i, "stroke-width": 3}).hover(n).click(r)
		}, e.prototype.select = function () {
			if (!this.selected) return this.seg.animate({path: this.selectedPath}, 150, "<>"), this.arc.animate({opacity: 1}, 150, "<>"), this.selected = !0
		}, e.prototype.deselect = function () {
			if (this.selected) return this.seg.animate({path: this.path}, 150, "<>"), this.arc.animate({opacity: 0}, 150, "<>"), this.selected = !1
		}, e
	}(e.EventEmitter)
}.call(this), function (t) {
	if ("object" == typeof exports && "undefined" != typeof module) module.exports = t(); else if ("function" == typeof define && define.amd) define([], t); else {
		("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).Chart = t()
	}
}(function () {
	return function () {
		return function t(e, i, n) {
			function r(a, s) {
				if (!i[a]) {
					if (!e[a]) {
						var l = "function" == typeof require && require;
						if (!s && l) return l(a, !0);
						if (o) return o(a, !0);
						var c = new Error("Cannot find module '" + a + "'");
						throw c.code = "MODULE_NOT_FOUND", c
					}
					var u = i[a] = {exports: {}};
					e[a][0].call(u.exports, function (t) {
						return r(e[a][1][t] || t)
					}, u, u.exports, t, e, i, n)
				}
				return i[a].exports
			}

			for (var o = "function" == typeof require && require, a = 0; a < n.length; a++) r(n[a]);
			return r
		}
	}()({
		1: [function (t, e, i) {
			var n = t(5);

			function r(t) {
				if (t) {
					var e = [0, 0, 0], i = 1, r = t.match(/^#([a-fA-F0-9]{3})$/i);
					if (r) {
						r = r[1];
						for (var o = 0; o < e.length; o++) e[o] = parseInt(r[o] + r[o], 16)
					} else if (r = t.match(/^#([a-fA-F0-9]{6})$/i)) {
						r = r[1];
						for (o = 0; o < e.length; o++) e[o] = parseInt(r.slice(2 * o, 2 * o + 2), 16)
					} else if (r = t.match(/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i)) {
						for (o = 0; o < e.length; o++) e[o] = parseInt(r[o + 1]);
						i = parseFloat(r[4])
					} else if (r = t.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i)) {
						for (o = 0; o < e.length; o++) e[o] = Math.round(2.55 * parseFloat(r[o + 1]));
						i = parseFloat(r[4])
					} else if (r = t.match(/(\w+)/)) {
						if ("transparent" == r[1]) return [0, 0, 0, 0];
						if (!(e = n[r[1]])) return
					}
					for (o = 0; o < e.length; o++) e[o] = u(e[o], 0, 255);
					return i = i || 0 == i ? u(i, 0, 1) : 1, e[3] = i, e
				}
			}

			function o(t) {
				if (t) {
					var e = t.match(/^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/);
					if (e) {
						var i = parseFloat(e[4]);
						return [u(parseInt(e[1]), 0, 360), u(parseFloat(e[2]), 0, 100), u(parseFloat(e[3]), 0, 100), u(isNaN(i) ? 1 : i, 0, 1)]
					}
				}
			}

			function a(t) {
				if (t) {
					var e = t.match(/^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/);
					if (e) {
						var i = parseFloat(e[4]);
						return [u(parseInt(e[1]), 0, 360), u(parseFloat(e[2]), 0, 100), u(parseFloat(e[3]), 0, 100), u(isNaN(i) ? 1 : i, 0, 1)]
					}
				}
			}

			function s(t, e) {
				return void 0 === e && (e = void 0 !== t[3] ? t[3] : 1), "rgba(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + e + ")"
			}

			function l(t, e) {
				return "rgba(" + Math.round(t[0] / 255 * 100) + "%, " + Math.round(t[1] / 255 * 100) + "%, " + Math.round(t[2] / 255 * 100) + "%, " + (e || t[3] || 1) + ")"
			}

			function c(t, e) {
				return void 0 === e && (e = void 0 !== t[3] ? t[3] : 1), "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + e + ")"
			}

			function u(t, e, i) {
				return Math.min(Math.max(e, t), i)
			}

			function h(t) {
				var e = t.toString(16).toUpperCase();
				return e.length < 2 ? "0" + e : e
			}

			e.exports = {
				getRgba: r, getHsla: o, getRgb: function (t) {
					var e = r(t);
					return e && e.slice(0, 3)
				}, getHsl: function (t) {
					var e = o(t);
					return e && e.slice(0, 3)
				}, getHwb: a, getAlpha: function (t) {
					var e = r(t);
					if (e) return e[3];
					if (e = o(t)) return e[3];
					if (e = a(t)) return e[3]
				}, hexString: function (t) {
					return "#" + h(t[0]) + h(t[1]) + h(t[2])
				}, rgbString: function (t, e) {
					if (e < 1 || t[3] && t[3] < 1) return s(t, e);
					return "rgb(" + t[0] + ", " + t[1] + ", " + t[2] + ")"
				}, rgbaString: s, percentString: function (t, e) {
					if (e < 1 || t[3] && t[3] < 1) return l(t, e);
					var i = Math.round(t[0] / 255 * 100), n = Math.round(t[1] / 255 * 100), r = Math.round(t[2] / 255 * 100);
					return "rgb(" + i + "%, " + n + "%, " + r + "%)"
				}, percentaString: l, hslString: function (t, e) {
					if (e < 1 || t[3] && t[3] < 1) return c(t, e);
					return "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)"
				}, hslaString: c, hwbString: function (t, e) {
					void 0 === e && (e = void 0 !== t[3] ? t[3] : 1);
					return "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + (void 0 !== e && 1 !== e ? ", " + e : "") + ")"
				}, keyword: function (t) {
					return d[t.slice(0, 3)]
				}
			};
			var d = {};
			for (var p in n) d[n[p]] = p
		}, {5: 5}], 2: [function (t, e, i) {
			var n = t(4), r = t(1), o = function (t) {
				return t instanceof o ? t : this instanceof o ? (this.valid = !1, this.values = {
					rgb: [0, 0, 0],
					hsl: [0, 0, 0],
					hsv: [0, 0, 0],
					hwb: [0, 0, 0],
					cmyk: [0, 0, 0, 0],
					alpha: 1
				}, void ("string" == typeof t ? (e = r.getRgba(t)) ? this.setValues("rgb", e) : (e = r.getHsla(t)) ? this.setValues("hsl", e) : (e = r.getHwb(t)) && this.setValues("hwb", e) : "object" == typeof t && (void 0 !== (e = t).r || void 0 !== e.red ? this.setValues("rgb", e) : void 0 !== e.l || void 0 !== e.lightness ? this.setValues("hsl", e) : void 0 !== e.v || void 0 !== e.value ? this.setValues("hsv", e) : void 0 !== e.w || void 0 !== e.whiteness ? this.setValues("hwb", e) : void 0 === e.c && void 0 === e.cyan || this.setValues("cmyk", e)))) : new o(t);
				var e
			};
			o.prototype = {
				isValid: function () {
					return this.valid
				}, rgb: function () {
					return this.setSpace("rgb", arguments)
				}, hsl: function () {
					return this.setSpace("hsl", arguments)
				}, hsv: function () {
					return this.setSpace("hsv", arguments)
				}, hwb: function () {
					return this.setSpace("hwb", arguments)
				}, cmyk: function () {
					return this.setSpace("cmyk", arguments)
				}, rgbArray: function () {
					return this.values.rgb
				}, hslArray: function () {
					return this.values.hsl
				}, hsvArray: function () {
					return this.values.hsv
				}, hwbArray: function () {
					var t = this.values;
					return 1 !== t.alpha ? t.hwb.concat([t.alpha]) : t.hwb
				}, cmykArray: function () {
					return this.values.cmyk
				}, rgbaArray: function () {
					var t = this.values;
					return t.rgb.concat([t.alpha])
				}, hslaArray: function () {
					var t = this.values;
					return t.hsl.concat([t.alpha])
				}, alpha: function (t) {
					return void 0 === t ? this.values.alpha : (this.setValues("alpha", t), this)
				}, red: function (t) {
					return this.setChannel("rgb", 0, t)
				}, green: function (t) {
					return this.setChannel("rgb", 1, t)
				}, blue: function (t) {
					return this.setChannel("rgb", 2, t)
				}, hue: function (t) {
					return t && (t = (t %= 360) < 0 ? 360 + t : t), this.setChannel("hsl", 0, t)
				}, saturation: function (t) {
					return this.setChannel("hsl", 1, t)
				}, lightness: function (t) {
					return this.setChannel("hsl", 2, t)
				}, saturationv: function (t) {
					return this.setChannel("hsv", 1, t)
				}, whiteness: function (t) {
					return this.setChannel("hwb", 1, t)
				}, blackness: function (t) {
					return this.setChannel("hwb", 2, t)
				}, value: function (t) {
					return this.setChannel("hsv", 2, t)
				}, cyan: function (t) {
					return this.setChannel("cmyk", 0, t)
				}, magenta: function (t) {
					return this.setChannel("cmyk", 1, t)
				}, yellow: function (t) {
					return this.setChannel("cmyk", 2, t)
				}, black: function (t) {
					return this.setChannel("cmyk", 3, t)
				}, hexString: function () {
					return r.hexString(this.values.rgb)
				}, rgbString: function () {
					return r.rgbString(this.values.rgb, this.values.alpha)
				}, rgbaString: function () {
					return r.rgbaString(this.values.rgb, this.values.alpha)
				}, percentString: function () {
					return r.percentString(this.values.rgb, this.values.alpha)
				}, hslString: function () {
					return r.hslString(this.values.hsl, this.values.alpha)
				}, hslaString: function () {
					return r.hslaString(this.values.hsl, this.values.alpha)
				}, hwbString: function () {
					return r.hwbString(this.values.hwb, this.values.alpha)
				}, keyword: function () {
					return r.keyword(this.values.rgb, this.values.alpha)
				}, rgbNumber: function () {
					var t = this.values.rgb;
					return t[0] << 16 | t[1] << 8 | t[2]
				}, luminosity: function () {
					for (var t = this.values.rgb, e = [], i = 0; i < t.length; i++) {
						var n = t[i] / 255;
						e[i] = n <= .03928 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4)
					}
					return .2126 * e[0] + .7152 * e[1] + .0722 * e[2]
				}, contrast: function (t) {
					var e = this.luminosity(), i = t.luminosity();
					return e > i ? (e + .05) / (i + .05) : (i + .05) / (e + .05)
				}, level: function (t) {
					var e = this.contrast(t);
					return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : ""
				}, dark: function () {
					var t = this.values.rgb;
					return (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3 < 128
				}, light: function () {
					return !this.dark()
				}, negate: function () {
					for (var t = [], e = 0; e < 3; e++) t[e] = 255 - this.values.rgb[e];
					return this.setValues("rgb", t), this
				}, lighten: function (t) {
					var e = this.values.hsl;
					return e[2] += e[2] * t, this.setValues("hsl", e), this
				}, darken: function (t) {
					var e = this.values.hsl;
					return e[2] -= e[2] * t, this.setValues("hsl", e), this
				}, saturate: function (t) {
					var e = this.values.hsl;
					return e[1] += e[1] * t, this.setValues("hsl", e), this
				}, desaturate: function (t) {
					var e = this.values.hsl;
					return e[1] -= e[1] * t, this.setValues("hsl", e), this
				}, whiten: function (t) {
					var e = this.values.hwb;
					return e[1] += e[1] * t, this.setValues("hwb", e), this
				}, blacken: function (t) {
					var e = this.values.hwb;
					return e[2] += e[2] * t, this.setValues("hwb", e), this
				}, greyscale: function () {
					var t = this.values.rgb, e = .3 * t[0] + .59 * t[1] + .11 * t[2];
					return this.setValues("rgb", [e, e, e]), this
				}, clearer: function (t) {
					var e = this.values.alpha;
					return this.setValues("alpha", e - e * t), this
				}, opaquer: function (t) {
					var e = this.values.alpha;
					return this.setValues("alpha", e + e * t), this
				}, rotate: function (t) {
					var e = this.values.hsl, i = (e[0] + t) % 360;
					return e[0] = i < 0 ? 360 + i : i, this.setValues("hsl", e), this
				}, mix: function (t, e) {
					var i = t, n = void 0 === e ? .5 : e, r = 2 * n - 1, o = this.alpha() - i.alpha(), a = ((r * o == -1 ? r : (r + o) / (1 + r * o)) + 1) / 2, s = 1 - a;
					return this.rgb(a * this.red() + s * i.red(), a * this.green() + s * i.green(), a * this.blue() + s * i.blue()).alpha(this.alpha() * n + i.alpha() * (1 - n))
				}, toJSON: function () {
					return this.rgb()
				}, clone: function () {
					var t, e, i = new o, n = this.values, r = i.values;
					for (var a in n) n.hasOwnProperty(a) && (t = n[a], "[object Array]" === (e = {}.toString.call(t)) ? r[a] = t.slice(0) : "[object Number]" === e ? r[a] = t : console.error("unexpected color value:", t));
					return i
				}
			}, o.prototype.spaces = {rgb: ["red", "green", "blue"], hsl: ["hue", "saturation", "lightness"], hsv: ["hue", "saturation", "value"], hwb: ["hue", "whiteness", "blackness"], cmyk: ["cyan", "magenta", "yellow", "black"]}, o.prototype.maxes = {
				rgb: [255, 255, 255],
				hsl: [360, 100, 100],
				hsv: [360, 100, 100],
				hwb: [360, 100, 100],
				cmyk: [100, 100, 100, 100]
			}, o.prototype.getValues = function (t) {
				for (var e = this.values, i = {}, n = 0; n < t.length; n++) i[t.charAt(n)] = e[t][n];
				return 1 !== e.alpha && (i.a = e.alpha), i
			}, o.prototype.setValues = function (t, e) {
				var i, r, o = this.values, a = this.spaces, s = this.maxes, l = 1;
				if (this.valid = !0, "alpha" === t) l = e; else if (e.length) o[t] = e.slice(0, t.length), l = e[t.length]; else if (void 0 !== e[t.charAt(0)]) {
					for (i = 0; i < t.length; i++) o[t][i] = e[t.charAt(i)];
					l = e.a
				} else if (void 0 !== e[a[t][0]]) {
					var c = a[t];
					for (i = 0; i < t.length; i++) o[t][i] = e[c[i]];
					l = e.alpha
				}
				if (o.alpha = Math.max(0, Math.min(1, void 0 === l ? o.alpha : l)), "alpha" === t) return !1;
				for (i = 0; i < t.length; i++) r = Math.max(0, Math.min(s[t][i], o[t][i])), o[t][i] = Math.round(r);
				for (var u in a) u !== t && (o[u] = n[t][u](o[t]));
				return !0
			}, o.prototype.setSpace = function (t, e) {
				var i = e[0];
				return void 0 === i ? this.getValues(t) : ("number" == typeof i && (i = Array.prototype.slice.call(e)), this.setValues(t, i), this)
			}, o.prototype.setChannel = function (t, e, i) {
				var n = this.values[t];
				return void 0 === i ? n[e] : i === n[e] ? this : (n[e] = i, this.setValues(t, n), this)
			}, "undefined" != typeof window && (window.Color = o), e.exports = o
		}, {1: 1, 4: 4}], 3: [function (t, e, i) {
			function n(t) {
				var e, i, n = t[0] / 255, r = t[1] / 255, o = t[2] / 255, a = Math.min(n, r, o), s = Math.max(n, r, o), l = s - a;
				return s == a ? e = 0 : n == s ? e = (r - o) / l : r == s ? e = 2 + (o - n) / l : o == s && (e = 4 + (n - r) / l), (e = Math.min(60 * e, 360)) < 0 && (e += 360), i = (a + s) / 2, [e, 100 * (s == a ? 0 : i <= .5 ? l / (s + a) : l / (2 - s - a)), 100 * i]
			}

			function o(t) {
				var e, i, n = t[0], r = t[1], o = t[2], a = Math.min(n, r, o), s = Math.max(n, r, o), l = s - a;
				return i = 0 == s ? 0 : l / s * 1e3 / 10, s == a ? e = 0 : n == s ? e = (r - o) / l : r == s ? e = 2 + (o - n) / l : o == s && (e = 4 + (n - r) / l), (e = Math.min(60 * e, 360)) < 0 && (e += 360), [e, i, s / 255 * 1e3 / 10]
			}

			function a(t) {
				var e = t[0], i = t[1], r = t[2];
				return [n(t)[0], 100 * (1 / 255 * Math.min(e, Math.min(i, r))), 100 * (r = 1 - 1 / 255 * Math.max(e, Math.max(i, r)))]
			}

			function s(t) {
				var e, i = t[0] / 255, n = t[1] / 255, r = t[2] / 255;
				return [100 * ((1 - i - (e = Math.min(1 - i, 1 - n, 1 - r))) / (1 - e) || 0), 100 * ((1 - n - e) / (1 - e) || 0), 100 * ((1 - r - e) / (1 - e) || 0), 100 * e]
			}

			function l(t) {
				return C[JSON.stringify(t)]
			}

			function c(t) {
				var e = t[0] / 255, i = t[1] / 255, n = t[2] / 255;
				return [100 * (.4124 * (e = e > .04045 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92) + .3576 * (i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92) + .1805 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92)), 100 * (.2126 * e + .7152 * i + .0722 * n), 100 * (.0193 * e + .1192 * i + .9505 * n)]
			}

			function u(t) {
				var e = c(t), i = e[0], n = e[1], r = e[2];
				return n /= 100, r /= 108.883, i = (i /= 95.047) > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116, [116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (i - n), 200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))]
			}

			function h(t) {
				var e, i, n, r, o, a = t[0] / 360, s = t[1] / 100, l = t[2] / 100;
				if (0 == s) return [o = 255 * l, o, o];
				e = 2 * l - (i = l < .5 ? l * (1 + s) : l + s - l * s), r = [0, 0, 0];
				for (var c = 0; c < 3; c++) (n = a + 1 / 3 * -(c - 1)) < 0 && n++, n > 1 && n--, o = 6 * n < 1 ? e + 6 * (i - e) * n : 2 * n < 1 ? i : 3 * n < 2 ? e + (i - e) * (2 / 3 - n) * 6 : e, r[c] = 255 * o;
				return r
			}

			function d(t) {
				var e = t[0] / 60, i = t[1] / 100, n = t[2] / 100, r = Math.floor(e) % 6, o = e - Math.floor(e), a = 255 * n * (1 - i), s = 255 * n * (1 - i * o), l = 255 * n * (1 - i * (1 - o));
				n *= 255;
				switch (r) {
					case 0:
						return [n, l, a];
					case 1:
						return [s, n, a];
					case 2:
						return [a, n, l];
					case 3:
						return [a, s, n];
					case 4:
						return [l, a, n];
					case 5:
						return [n, a, s]
				}
			}

			function p(t) {
				var e, i, n, o, a = t[0] / 360, s = t[1] / 100, l = t[2] / 100, c = s + l;
				switch (c > 1 && (s /= c, l /= c), n = 6 * a - (e = Math.floor(6 * a)), 0 != (1 & e) && (n = 1 - n), o = s + n * ((i = 1 - l) - s), e) {
					default:
					case 6:
					case 0:
						r = i, g = o, b = s;
						break;
					case 1:
						r = o, g = i, b = s;
						break;
					case 2:
						r = s, g = i, b = o;
						break;
					case 3:
						r = s, g = o, b = i;
						break;
					case 4:
						r = o, g = s, b = i;
						break;
					case 5:
						r = i, g = s, b = o
				}
				return [255 * r, 255 * g, 255 * b]
			}

			function f(t) {
				var e = t[0] / 100, i = t[1] / 100, n = t[2] / 100, r = t[3] / 100;
				return [255 * (1 - Math.min(1, e * (1 - r) + r)), 255 * (1 - Math.min(1, i * (1 - r) + r)), 255 * (1 - Math.min(1, n * (1 - r) + r))]
			}

			function m(t) {
				var e, i, n, r = t[0] / 100, o = t[1] / 100, a = t[2] / 100;
				return i = -.9689 * r + 1.8758 * o + .0415 * a, n = .0557 * r + -.204 * o + 1.057 * a, e = (e = 3.2406 * r + -1.5372 * o + -.4986 * a) > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : e *= 12.92, i = i > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : i *= 12.92, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : n *= 12.92, [255 * (e = Math.min(Math.max(0, e), 1)), 255 * (i = Math.min(Math.max(0, i), 1)), 255 * (n = Math.min(Math.max(0, n), 1))]
			}

			function v(t) {
				var e = t[0], i = t[1], n = t[2];
				return i /= 100, n /= 108.883, e = (e /= 95.047) > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, [116 * (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116) - 16, 500 * (e - i), 200 * (i - (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116))]
			}

			function y(t) {
				var e, i, n, r, o = t[0], a = t[1], s = t[2];
				return o <= 8 ? r = (i = 100 * o / 903.3) / 100 * 7.787 + 16 / 116 : (i = 100 * Math.pow((o + 16) / 116, 3), r = Math.pow(i / 100, 1 / 3)), [e = e / 95.047 <= .008856 ? e = 95.047 * (a / 500 + r - 16 / 116) / 7.787 : 95.047 * Math.pow(a / 500 + r, 3), i, n = n / 108.883 <= .008859 ? n = 108.883 * (r - s / 200 - 16 / 116) / 7.787 : 108.883 * Math.pow(r - s / 200, 3)]
			}

			function w(t) {
				var e, i = t[0], n = t[1], r = t[2];
				return (e = 360 * Math.atan2(r, n) / 2 / Math.PI) < 0 && (e += 360), [i, Math.sqrt(n * n + r * r), e]
			}

			function x(t) {
				return m(y(t))
			}

			function k(t) {
				var e, i = t[0], n = t[1];
				return e = t[2] / 360 * 2 * Math.PI, [i, n * Math.cos(e), n * Math.sin(e)]
			}

			function _(t) {
				return S[t]
			}

			e.exports = {
				rgb2hsl: n, rgb2hsv: o, rgb2hwb: a, rgb2cmyk: s, rgb2keyword: l, rgb2xyz: c, rgb2lab: u, rgb2lch: function (t) {
					return w(u(t))
				}, hsl2rgb: h, hsl2hsv: function (t) {
					var e = t[0], i = t[1] / 100, n = t[2] / 100;
					if (0 === n) return [0, 0, 0];
					return [e, 100 * (2 * (i *= (n *= 2) <= 1 ? n : 2 - n) / (n + i)), 100 * ((n + i) / 2)]
				}, hsl2hwb: function (t) {
					return a(h(t))
				}, hsl2cmyk: function (t) {
					return s(h(t))
				}, hsl2keyword: function (t) {
					return l(h(t))
				}, hsv2rgb: d, hsv2hsl: function (t) {
					var e, i, n = t[0], r = t[1] / 100, o = t[2] / 100;
					return e = r * o, [n, 100 * (e = (e /= (i = (2 - r) * o) <= 1 ? i : 2 - i) || 0), 100 * (i /= 2)]
				}, hsv2hwb: function (t) {
					return a(d(t))
				}, hsv2cmyk: function (t) {
					return s(d(t))
				}, hsv2keyword: function (t) {
					return l(d(t))
				}, hwb2rgb: p, hwb2hsl: function (t) {
					return n(p(t))
				}, hwb2hsv: function (t) {
					return o(p(t))
				}, hwb2cmyk: function (t) {
					return s(p(t))
				}, hwb2keyword: function (t) {
					return l(p(t))
				}, cmyk2rgb: f, cmyk2hsl: function (t) {
					return n(f(t))
				}, cmyk2hsv: function (t) {
					return o(f(t))
				}, cmyk2hwb: function (t) {
					return a(f(t))
				}, cmyk2keyword: function (t) {
					return l(f(t))
				}, keyword2rgb: _, keyword2hsl: function (t) {
					return n(_(t))
				}, keyword2hsv: function (t) {
					return o(_(t))
				}, keyword2hwb: function (t) {
					return a(_(t))
				}, keyword2cmyk: function (t) {
					return s(_(t))
				}, keyword2lab: function (t) {
					return u(_(t))
				}, keyword2xyz: function (t) {
					return c(_(t))
				}, xyz2rgb: m, xyz2lab: v, xyz2lch: function (t) {
					return w(v(t))
				}, lab2xyz: y, lab2rgb: x, lab2lch: w, lch2lab: k, lch2xyz: function (t) {
					return y(k(t))
				}, lch2rgb: function (t) {
					return x(k(t))
				}
			};
			var S = {
				aliceblue: [240, 248, 255],
				antiquewhite: [250, 235, 215],
				aqua: [0, 255, 255],
				aquamarine: [127, 255, 212],
				azure: [240, 255, 255],
				beige: [245, 245, 220],
				bisque: [255, 228, 196],
				black: [0, 0, 0],
				blanchedalmond: [255, 235, 205],
				blue: [0, 0, 255],
				blueviolet: [138, 43, 226],
				brown: [165, 42, 42],
				burlywood: [222, 184, 135],
				cadetblue: [95, 158, 160],
				chartreuse: [127, 255, 0],
				chocolate: [210, 105, 30],
				coral: [255, 127, 80],
				cornflowerblue: [100, 149, 237],
				cornsilk: [255, 248, 220],
				crimson: [220, 20, 60],
				cyan: [0, 255, 255],
				darkblue: [0, 0, 139],
				darkcyan: [0, 139, 139],
				darkgoldenrod: [184, 134, 11],
				darkgray: [169, 169, 169],
				darkgreen: [0, 100, 0],
				darkgrey: [169, 169, 169],
				darkkhaki: [189, 183, 107],
				darkmagenta: [139, 0, 139],
				darkolivegreen: [85, 107, 47],
				darkorange: [255, 140, 0],
				darkorchid: [153, 50, 204],
				darkred: [139, 0, 0],
				darksalmon: [233, 150, 122],
				darkseagreen: [143, 188, 143],
				darkslateblue: [72, 61, 139],
				darkslategray: [47, 79, 79],
				darkslategrey: [47, 79, 79],
				darkturquoise: [0, 206, 209],
				darkviolet: [148, 0, 211],
				deeppink: [255, 20, 147],
				deepskyblue: [0, 191, 255],
				dimgray: [105, 105, 105],
				dimgrey: [105, 105, 105],
				dodgerblue: [30, 144, 255],
				firebrick: [178, 34, 34],
				floralwhite: [255, 250, 240],
				forestgreen: [34, 139, 34],
				fuchsia: [255, 0, 255],
				gainsboro: [220, 220, 220],
				ghostwhite: [248, 248, 255],
				gold: [255, 215, 0],
				goldenrod: [218, 165, 32],
				gray: [128, 128, 128],
				green: [0, 128, 0],
				greenyellow: [173, 255, 47],
				grey: [128, 128, 128],
				honeydew: [240, 255, 240],
				hotpink: [255, 105, 180],
				indianred: [205, 92, 92],
				indigo: [75, 0, 130],
				ivory: [255, 255, 240],
				khaki: [240, 230, 140],
				lavender: [230, 230, 250],
				lavenderblush: [255, 240, 245],
				lawngreen: [124, 252, 0],
				lemonchiffon: [255, 250, 205],
				lightblue: [173, 216, 230],
				lightcoral: [240, 128, 128],
				lightcyan: [224, 255, 255],
				lightgoldenrodyellow: [250, 250, 210],
				lightgray: [211, 211, 211],
				lightgreen: [144, 238, 144],
				lightgrey: [211, 211, 211],
				lightpink: [255, 182, 193],
				lightsalmon: [255, 160, 122],
				lightseagreen: [32, 178, 170],
				lightskyblue: [135, 206, 250],
				lightslategray: [119, 136, 153],
				lightslategrey: [119, 136, 153],
				lightsteelblue: [176, 196, 222],
				lightyellow: [255, 255, 224],
				lime: [0, 255, 0],
				limegreen: [50, 205, 50],
				linen: [250, 240, 230],
				magenta: [255, 0, 255],
				maroon: [128, 0, 0],
				mediumaquamarine: [102, 205, 170],
				mediumblue: [0, 0, 205],
				mediumorchid: [186, 85, 211],
				mediumpurple: [147, 112, 219],
				mediumseagreen: [60, 179, 113],
				mediumslateblue: [123, 104, 238],
				mediumspringgreen: [0, 250, 154],
				mediumturquoise: [72, 209, 204],
				mediumvioletred: [199, 21, 133],
				midnightblue: [25, 25, 112],
				mintcream: [245, 255, 250],
				mistyrose: [255, 228, 225],
				moccasin: [255, 228, 181],
				navajowhite: [255, 222, 173],
				navy: [0, 0, 128],
				oldlace: [253, 245, 230],
				olive: [128, 128, 0],
				olivedrab: [107, 142, 35],
				orange: [255, 165, 0],
				orangered: [255, 69, 0],
				orchid: [218, 112, 214],
				palegoldenrod: [238, 232, 170],
				palegreen: [152, 251, 152],
				paleturquoise: [175, 238, 238],
				palevioletred: [219, 112, 147],
				papayawhip: [255, 239, 213],
				peachpuff: [255, 218, 185],
				peru: [205, 133, 63],
				pink: [255, 192, 203],
				plum: [221, 160, 221],
				powderblue: [176, 224, 230],
				purple: [128, 0, 128],
				rebeccapurple: [102, 51, 153],
				red: [255, 0, 0],
				rosybrown: [188, 143, 143],
				royalblue: [65, 105, 225],
				saddlebrown: [139, 69, 19],
				salmon: [250, 128, 114],
				sandybrown: [244, 164, 96],
				seagreen: [46, 139, 87],
				seashell: [255, 245, 238],
				sienna: [160, 82, 45],
				silver: [192, 192, 192],
				skyblue: [135, 206, 235],
				slateblue: [106, 90, 205],
				slategray: [112, 128, 144],
				slategrey: [112, 128, 144],
				snow: [255, 250, 250],
				springgreen: [0, 255, 127],
				steelblue: [70, 130, 180],
				tan: [210, 180, 140],
				teal: [0, 128, 128],
				thistle: [216, 191, 216],
				tomato: [255, 99, 71],
				turquoise: [64, 224, 208],
				violet: [238, 130, 238],
				wheat: [245, 222, 179],
				white: [255, 255, 255],
				whitesmoke: [245, 245, 245],
				yellow: [255, 255, 0],
				yellowgreen: [154, 205, 50]
			}, C = {};
			for (var D in S) C[JSON.stringify(S[D])] = D
		}, {}], 4: [function (t, e, i) {
			var n = t(3), r = function () {
				return new c
			};
			for (var o in n) {
				r[o + "Raw"] = function (t) {
					return function (e) {
						return "number" == typeof e && (e = Array.prototype.slice.call(arguments)), n[t](e)
					}
				}(o);
				var a = /(\w+)2(\w+)/.exec(o), s = a[1], l = a[2];
				(r[s] = r[s] || {})[l] = r[o] = function (t) {
					return function (e) {
						"number" == typeof e && (e = Array.prototype.slice.call(arguments));
						var i = n[t](e);
						if ("string" == typeof i || void 0 === i) return i;
						for (var r = 0; r < i.length; r++) i[r] = Math.round(i[r]);
						return i
					}
				}(o)
			}
			var c = function () {
				this.convs = {}
			};
			c.prototype.routeSpace = function (t, e) {
				var i = e[0];
				return void 0 === i ? this.getValues(t) : ("number" == typeof i && (i = Array.prototype.slice.call(e)), this.setValues(t, i))
			}, c.prototype.setValues = function (t, e) {
				return this.space = t, this.convs = {}, this.convs[t] = e, this
			}, c.prototype.getValues = function (t) {
				var e = this.convs[t];
				if (!e) {
					var i = this.space, n = this.convs[i];
					e = r[i][t](n), this.convs[t] = e
				}
				return e
			}, ["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function (t) {
				c.prototype[t] = function (e) {
					return this.routeSpace(t, arguments)
				}
			}), e.exports = r
		}, {3: 3}], 5: [function (t, e, i) {
			"use strict";
			e.exports = {
				aliceblue: [240, 248, 255],
				antiquewhite: [250, 235, 215],
				aqua: [0, 255, 255],
				aquamarine: [127, 255, 212],
				azure: [240, 255, 255],
				beige: [245, 245, 220],
				bisque: [255, 228, 196],
				black: [0, 0, 0],
				blanchedalmond: [255, 235, 205],
				blue: [0, 0, 255],
				blueviolet: [138, 43, 226],
				brown: [165, 42, 42],
				burlywood: [222, 184, 135],
				cadetblue: [95, 158, 160],
				chartreuse: [127, 255, 0],
				chocolate: [210, 105, 30],
				coral: [255, 127, 80],
				cornflowerblue: [100, 149, 237],
				cornsilk: [255, 248, 220],
				crimson: [220, 20, 60],
				cyan: [0, 255, 255],
				darkblue: [0, 0, 139],
				darkcyan: [0, 139, 139],
				darkgoldenrod: [184, 134, 11],
				darkgray: [169, 169, 169],
				darkgreen: [0, 100, 0],
				darkgrey: [169, 169, 169],
				darkkhaki: [189, 183, 107],
				darkmagenta: [139, 0, 139],
				darkolivegreen: [85, 107, 47],
				darkorange: [255, 140, 0],
				darkorchid: [153, 50, 204],
				darkred: [139, 0, 0],
				darksalmon: [233, 150, 122],
				darkseagreen: [143, 188, 143],
				darkslateblue: [72, 61, 139],
				darkslategray: [47, 79, 79],
				darkslategrey: [47, 79, 79],
				darkturquoise: [0, 206, 209],
				darkviolet: [148, 0, 211],
				deeppink: [255, 20, 147],
				deepskyblue: [0, 191, 255],
				dimgray: [105, 105, 105],
				dimgrey: [105, 105, 105],
				dodgerblue: [30, 144, 255],
				firebrick: [178, 34, 34],
				floralwhite: [255, 250, 240],
				forestgreen: [34, 139, 34],
				fuchsia: [255, 0, 255],
				gainsboro: [220, 220, 220],
				ghostwhite: [248, 248, 255],
				gold: [255, 215, 0],
				goldenrod: [218, 165, 32],
				gray: [128, 128, 128],
				green: [0, 128, 0],
				greenyellow: [173, 255, 47],
				grey: [128, 128, 128],
				honeydew: [240, 255, 240],
				hotpink: [255, 105, 180],
				indianred: [205, 92, 92],
				indigo: [75, 0, 130],
				ivory: [255, 255, 240],
				khaki: [240, 230, 140],
				lavender: [230, 230, 250],
				lavenderblush: [255, 240, 245],
				lawngreen: [124, 252, 0],
				lemonchiffon: [255, 250, 205],
				lightblue: [173, 216, 230],
				lightcoral: [240, 128, 128],
				lightcyan: [224, 255, 255],
				lightgoldenrodyellow: [250, 250, 210],
				lightgray: [211, 211, 211],
				lightgreen: [144, 238, 144],
				lightgrey: [211, 211, 211],
				lightpink: [255, 182, 193],
				lightsalmon: [255, 160, 122],
				lightseagreen: [32, 178, 170],
				lightskyblue: [135, 206, 250],
				lightslategray: [119, 136, 153],
				lightslategrey: [119, 136, 153],
				lightsteelblue: [176, 196, 222],
				lightyellow: [255, 255, 224],
				lime: [0, 255, 0],
				limegreen: [50, 205, 50],
				linen: [250, 240, 230],
				magenta: [255, 0, 255],
				maroon: [128, 0, 0],
				mediumaquamarine: [102, 205, 170],
				mediumblue: [0, 0, 205],
				mediumorchid: [186, 85, 211],
				mediumpurple: [147, 112, 219],
				mediumseagreen: [60, 179, 113],
				mediumslateblue: [123, 104, 238],
				mediumspringgreen: [0, 250, 154],
				mediumturquoise: [72, 209, 204],
				mediumvioletred: [199, 21, 133],
				midnightblue: [25, 25, 112],
				mintcream: [245, 255, 250],
				mistyrose: [255, 228, 225],
				moccasin: [255, 228, 181],
				navajowhite: [255, 222, 173],
				navy: [0, 0, 128],
				oldlace: [253, 245, 230],
				olive: [128, 128, 0],
				olivedrab: [107, 142, 35],
				orange: [255, 165, 0],
				orangered: [255, 69, 0],
				orchid: [218, 112, 214],
				palegoldenrod: [238, 232, 170],
				palegreen: [152, 251, 152],
				paleturquoise: [175, 238, 238],
				palevioletred: [219, 112, 147],
				papayawhip: [255, 239, 213],
				peachpuff: [255, 218, 185],
				peru: [205, 133, 63],
				pink: [255, 192, 203],
				plum: [221, 160, 221],
				powderblue: [176, 224, 230],
				purple: [128, 0, 128],
				rebeccapurple: [102, 51, 153],
				red: [255, 0, 0],
				rosybrown: [188, 143, 143],
				royalblue: [65, 105, 225],
				saddlebrown: [139, 69, 19],
				salmon: [250, 128, 114],
				sandybrown: [244, 164, 96],
				seagreen: [46, 139, 87],
				seashell: [255, 245, 238],
				sienna: [160, 82, 45],
				silver: [192, 192, 192],
				skyblue: [135, 206, 235],
				slateblue: [106, 90, 205],
				slategray: [112, 128, 144],
				slategrey: [112, 128, 144],
				snow: [255, 250, 250],
				springgreen: [0, 255, 127],
				steelblue: [70, 130, 180],
				tan: [210, 180, 140],
				teal: [0, 128, 128],
				thistle: [216, 191, 216],
				tomato: [255, 99, 71],
				turquoise: [64, 224, 208],
				violet: [238, 130, 238],
				wheat: [245, 222, 179],
				white: [255, 255, 255],
				whitesmoke: [245, 245, 245],
				yellow: [255, 255, 0],
				yellowgreen: [154, 205, 50]
			}
		}, {}], 6: [function (t, e, i) {
			var n, r;
			n = this, r = function () {
				"use strict";
				var i, n;

				function r() {
					return i.apply(null, arguments)
				}

				function o(t) {
					return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t)
				}

				function a(t) {
					return null != t && "[object Object]" === Object.prototype.toString.call(t)
				}

				function s(t) {
					return void 0 === t
				}

				function l(t) {
					return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t)
				}

				function c(t) {
					return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t)
				}

				function u(t, e) {
					var i, n = [];
					for (i = 0; i < t.length; ++i) n.push(e(t[i], i));
					return n
				}

				function h(t, e) {
					return Object.prototype.hasOwnProperty.call(t, e)
				}

				function d(t, e) {
					for (var i in e) h(e, i) && (t[i] = e[i]);
					return h(e, "toString") && (t.toString = e.toString), h(e, "valueOf") && (t.valueOf = e.valueOf), t
				}

				function p(t, e, i, n) {
					return Ee(t, e, i, n, !0).utc()
				}

				function f(t) {
					return null == t._pf && (t._pf = {empty: !1, unusedTokens: [], unusedInput: [], overflow: -2, charsLeftOver: 0, nullInput: !1, invalidMonth: null, invalidFormat: !1, userInvalidated: !1, iso: !1, parsedDateParts: [], meridiem: null, rfc2822: !1, weekdayMismatch: !1}), t._pf
				}

				function m(t) {
					if (null == t._isValid) {
						var e = f(t), i = n.call(e.parsedDateParts, function (t) {
							return null != t
						}), r = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && i);
						if (t._strict && (r = r && 0 === e.charsLeftOver && 0 === e.unusedTokens.length && void 0 === e.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return r;
						t._isValid = r
					}
					return t._isValid
				}

				function g(t) {
					var e = p(NaN);
					return null != t ? d(f(e), t) : f(e).userInvalidated = !0, e
				}

				n = Array.prototype.some ? Array.prototype.some : function (t) {
					for (var e = Object(this), i = e.length >>> 0, n = 0; n < i; n++) if (n in e && t.call(this, e[n], n, e)) return !0;
					return !1
				};
				var v = r.momentProperties = [];

				function y(t, e) {
					var i, n, r;
					if (s(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), s(e._i) || (t._i = e._i), s(e._f) || (t._f = e._f), s(e._l) || (t._l = e._l), s(e._strict) || (t._strict = e._strict), s(e._tzm) || (t._tzm = e._tzm), s(e._isUTC) || (t._isUTC = e._isUTC), s(e._offset) || (t._offset = e._offset), s(e._pf) || (t._pf = f(e)), s(e._locale) || (t._locale = e._locale), v.length > 0) for (i = 0; i < v.length; i++) s(r = e[n = v[i]]) || (t[n] = r);
					return t
				}

				var b = !1;

				function w(t) {
					y(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === b && (b = !0, r.updateOffset(this), b = !1)
				}

				function x(t) {
					return t instanceof w || null != t && null != t._isAMomentObject
				}

				function k(t) {
					return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
				}

				function _(t) {
					var e = +t, i = 0;
					return 0 !== e && isFinite(e) && (i = k(e)), i
				}

				function S(t, e, i) {
					var n, r = Math.min(t.length, e.length), o = Math.abs(t.length - e.length), a = 0;
					for (n = 0; n < r; n++) (i && t[n] !== e[n] || !i && _(t[n]) !== _(e[n])) && a++;
					return a + o
				}

				function C(t) {
					!1 === r.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t)
				}

				function D(t, e) {
					var i = !0;
					return d(function () {
						if (null != r.deprecationHandler && r.deprecationHandler(null, t), i) {
							for (var n, o = [], a = 0; a < arguments.length; a++) {
								if (n = "", "object" == typeof arguments[a]) {
									for (var s in n += "\n[" + a + "] ", arguments[0]) n += s + ": " + arguments[0][s] + ", ";
									n = n.slice(0, -2)
								} else n = arguments[a];
								o.push(n)
							}
							C(t + "\nArguments: " + Array.prototype.slice.call(o).join("") + "\n" + (new Error).stack), i = !1
						}
						return e.apply(this, arguments)
					}, e)
				}

				var T, M = {};

				function E(t, e) {
					null != r.deprecationHandler && r.deprecationHandler(t, e), M[t] || (C(e), M[t] = !0)
				}

				function A(t) {
					return t instanceof Function || "[object Function]" === Object.prototype.toString.call(t)
				}

				function P(t, e) {
					var i, n = d({}, t);
					for (i in e) h(e, i) && (a(t[i]) && a(e[i]) ? (n[i] = {}, d(n[i], t[i]), d(n[i], e[i])) : null != e[i] ? n[i] = e[i] : delete n[i]);
					for (i in t) h(t, i) && !h(e, i) && a(t[i]) && (n[i] = d({}, n[i]));
					return n
				}

				function I(t) {
					null != t && this.set(t)
				}

				r.suppressDeprecationWarnings = !1, r.deprecationHandler = null, T = Object.keys ? Object.keys : function (t) {
					var e, i = [];
					for (e in t) h(t, e) && i.push(e);
					return i
				};
				var O = {};

				function L(t, e) {
					var i = t.toLowerCase();
					O[i] = O[i + "s"] = O[e] = t
				}

				function F(t) {
					return "string" == typeof t ? O[t] || O[t.toLowerCase()] : void 0
				}

				function N(t) {
					var e, i, n = {};
					for (i in t) h(t, i) && (e = F(i)) && (n[e] = t[i]);
					return n
				}

				var R = {};

				function H(t, e) {
					R[t] = e
				}

				function $(t, e, i) {
					var n = "" + Math.abs(t), r = e - n.length;
					return (t >= 0 ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + n
				}

				var B = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, z = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, j = {}, U = {};

				function W(t, e, i, n) {
					var r = n;
					"string" == typeof n && (r = function () {
						return this[n]()
					}), t && (U[t] = r), e && (U[e[0]] = function () {
						return $(r.apply(this, arguments), e[1], e[2])
					}), i && (U[i] = function () {
						return this.localeData().ordinal(r.apply(this, arguments), t)
					})
				}

				function Y(t, e) {
					return t.isValid() ? (e = V(e, t.localeData()), j[e] = j[e] || function (t) {
						var e, i, n, r = t.match(B);
						for (e = 0, i = r.length; e < i; e++) U[r[e]] ? r[e] = U[r[e]] : r[e] = (n = r[e]).match(/\[[\s\S]/) ? n.replace(/^\[|\]$/g, "") : n.replace(/\\/g, "");
						return function (e) {
							var n, o = "";
							for (n = 0; n < i; n++) o += A(r[n]) ? r[n].call(e, t) : r[n];
							return o
						}
					}(e), j[e](t)) : t.localeData().invalidDate()
				}

				function V(t, e) {
					var i = 5;

					function n(t) {
						return e.longDateFormat(t) || t
					}

					for (z.lastIndex = 0; i >= 0 && z.test(t);) t = t.replace(z, n), z.lastIndex = 0, i -= 1;
					return t
				}

				var q = /\d/, G = /\d\d/, K = /\d{3}/, X = /\d{4}/, Z = /[+-]?\d{6}/, Q = /\d\d?/, J = /\d\d\d\d?/, tt = /\d\d\d\d\d\d?/, et = /\d{1,3}/, it = /\d{1,4}/, nt = /[+-]?\d{1,6}/, rt = /\d+/, ot = /[+-]?\d+/, at = /Z|[+-]\d\d:?\d\d/gi, st = /Z|[+-]\d\d(?::?\d\d)?/gi,
					lt = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, ct = {};

				function ut(t, e, i) {
					ct[t] = A(e) ? e : function (t, n) {
						return t && i ? i : e
					}
				}

				function ht(t, e) {
					return h(ct, t) ? ct[t](e._strict, e._locale) : new RegExp(dt(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (t, e, i, n, r) {
						return e || i || n || r
					})))
				}

				function dt(t) {
					return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
				}

				var pt = {};

				function ft(t, e) {
					var i, n = e;
					for ("string" == typeof t && (t = [t]), l(e) && (n = function (t, i) {
						i[e] = _(t)
					}), i = 0; i < t.length; i++) pt[t[i]] = n
				}

				function mt(t, e) {
					ft(t, function (t, i, n, r) {
						n._w = n._w || {}, e(t, n._w, n, r)
					})
				}

				function gt(t, e, i) {
					null != e && h(pt, t) && pt[t](e, i._a, i, t)
				}

				var vt = 0, yt = 1, bt = 2, wt = 3, xt = 4, kt = 5, _t = 6, St = 7, Ct = 8;

				function Dt(t) {
					return Tt(t) ? 366 : 365
				}

				function Tt(t) {
					return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
				}

				W("Y", 0, 0, function () {
					var t = this.year();
					return t <= 9999 ? "" + t : "+" + t
				}), W(0, ["YY", 2], 0, function () {
					return this.year() % 100
				}), W(0, ["YYYY", 4], 0, "year"), W(0, ["YYYYY", 5], 0, "year"), W(0, ["YYYYYY", 6, !0], 0, "year"), L("year", "y"), H("year", 1), ut("Y", ot), ut("YY", Q, G), ut("YYYY", it, X), ut("YYYYY", nt, Z), ut("YYYYYY", nt, Z), ft(["YYYYY", "YYYYYY"], vt), ft("YYYY", function (t, e) {
					e[vt] = 2 === t.length ? r.parseTwoDigitYear(t) : _(t)
				}), ft("YY", function (t, e) {
					e[vt] = r.parseTwoDigitYear(t)
				}), ft("Y", function (t, e) {
					e[vt] = parseInt(t, 10)
				}), r.parseTwoDigitYear = function (t) {
					return _(t) + (_(t) > 68 ? 1900 : 2e3)
				};
				var Mt, Et = At("FullYear", !0);

				function At(t, e) {
					return function (i) {
						return null != i ? (It(this, t, i), r.updateOffset(this, e), this) : Pt(this, t)
					}
				}

				function Pt(t, e) {
					return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN
				}

				function It(t, e, i) {
					t.isValid() && !isNaN(i) && ("FullYear" === e && Tt(t.year()) && 1 === t.month() && 29 === t.date() ? t._d["set" + (t._isUTC ? "UTC" : "") + e](i, t.month(), Ot(i, t.month())) : t._d["set" + (t._isUTC ? "UTC" : "") + e](i))
				}

				function Ot(t, e) {
					if (isNaN(t) || isNaN(e)) return NaN;
					var i, n = (e % (i = 12) + i) % i;
					return t += (e - n) / 12, 1 === n ? Tt(t) ? 29 : 28 : 31 - n % 7 % 2
				}

				Mt = Array.prototype.indexOf ? Array.prototype.indexOf : function (t) {
					var e;
					for (e = 0; e < this.length; ++e) if (this[e] === t) return e;
					return -1
				}, W("M", ["MM", 2], "Mo", function () {
					return this.month() + 1
				}), W("MMM", 0, 0, function (t) {
					return this.localeData().monthsShort(this, t)
				}), W("MMMM", 0, 0, function (t) {
					return this.localeData().months(this, t)
				}), L("month", "M"), H("month", 8), ut("M", Q), ut("MM", Q, G), ut("MMM", function (t, e) {
					return e.monthsShortRegex(t)
				}), ut("MMMM", function (t, e) {
					return e.monthsRegex(t)
				}), ft(["M", "MM"], function (t, e) {
					e[yt] = _(t) - 1
				}), ft(["MMM", "MMMM"], function (t, e, i, n) {
					var r = i._locale.monthsParse(t, n, i._strict);
					null != r ? e[yt] = r : f(i).invalidMonth = t
				});
				var Lt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Ft = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), Nt = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");

				function Rt(t, e) {
					var i;
					if (!t.isValid()) return t;
					if ("string" == typeof e) if (/^\d+$/.test(e)) e = _(e); else if (!l(e = t.localeData().monthsParse(e))) return t;
					return i = Math.min(t.date(), Ot(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i), t
				}

				function Ht(t) {
					return null != t ? (Rt(this, t), r.updateOffset(this, !0), this) : Pt(this, "Month")
				}

				var $t = lt, Bt = lt;

				function zt() {
					function t(t, e) {
						return e.length - t.length
					}

					var e, i, n = [], r = [], o = [];
					for (e = 0; e < 12; e++) i = p([2e3, e]), n.push(this.monthsShort(i, "")), r.push(this.months(i, "")), o.push(this.months(i, "")), o.push(this.monthsShort(i, ""));
					for (n.sort(t), r.sort(t), o.sort(t), e = 0; e < 12; e++) n[e] = dt(n[e]), r[e] = dt(r[e]);
					for (e = 0; e < 24; e++) o[e] = dt(o[e]);
					this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + n.join("|") + ")", "i")
				}

				function jt(t) {
					var e = new Date(Date.UTC.apply(null, arguments));
					return t < 100 && t >= 0 && isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t), e
				}

				function Ut(t, e, i) {
					var n = 7 + e - i;
					return -((7 + jt(t, 0, n).getUTCDay() - e) % 7) + n - 1
				}

				function Wt(t, e, i, n, r) {
					var o, a, s = 1 + 7 * (e - 1) + (7 + i - n) % 7 + Ut(t, n, r);
					return s <= 0 ? a = Dt(o = t - 1) + s : s > Dt(t) ? (o = t + 1, a = s - Dt(t)) : (o = t, a = s), {year: o, dayOfYear: a}
				}

				function Yt(t, e, i) {
					var n, r, o = Ut(t.year(), e, i), a = Math.floor((t.dayOfYear() - o - 1) / 7) + 1;
					return a < 1 ? n = a + Vt(r = t.year() - 1, e, i) : a > Vt(t.year(), e, i) ? (n = a - Vt(t.year(), e, i), r = t.year() + 1) : (r = t.year(), n = a), {week: n, year: r}
				}

				function Vt(t, e, i) {
					var n = Ut(t, e, i), r = Ut(t + 1, e, i);
					return (Dt(t) - n + r) / 7
				}

				W("w", ["ww", 2], "wo", "week"), W("W", ["WW", 2], "Wo", "isoWeek"), L("week", "w"), L("isoWeek", "W"), H("week", 5), H("isoWeek", 5), ut("w", Q), ut("ww", Q, G), ut("W", Q), ut("WW", Q, G), mt(["w", "ww", "W", "WW"], function (t, e, i, n) {
					e[n.substr(0, 1)] = _(t)
				}), W("d", 0, "do", "day"), W("dd", 0, 0, function (t) {
					return this.localeData().weekdaysMin(this, t)
				}), W("ddd", 0, 0, function (t) {
					return this.localeData().weekdaysShort(this, t)
				}), W("dddd", 0, 0, function (t) {
					return this.localeData().weekdays(this, t)
				}), W("e", 0, 0, "weekday"), W("E", 0, 0, "isoWeekday"), L("day", "d"), L("weekday", "e"), L("isoWeekday", "E"), H("day", 11), H("weekday", 11), H("isoWeekday", 11), ut("d", Q), ut("e", Q), ut("E", Q), ut("dd", function (t, e) {
					return e.weekdaysMinRegex(t)
				}), ut("ddd", function (t, e) {
					return e.weekdaysShortRegex(t)
				}), ut("dddd", function (t, e) {
					return e.weekdaysRegex(t)
				}), mt(["dd", "ddd", "dddd"], function (t, e, i, n) {
					var r = i._locale.weekdaysParse(t, n, i._strict);
					null != r ? e.d = r : f(i).invalidWeekday = t
				}), mt(["d", "e", "E"], function (t, e, i, n) {
					e[n] = _(t)
				});
				var qt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Gt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Kt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Xt = lt, Zt = lt, Qt = lt;

				function Jt() {
					function t(t, e) {
						return e.length - t.length
					}

					var e, i, n, r, o, a = [], s = [], l = [], c = [];
					for (e = 0; e < 7; e++) i = p([2e3, 1]).day(e), n = this.weekdaysMin(i, ""), r = this.weekdaysShort(i, ""), o = this.weekdays(i, ""), a.push(n), s.push(r), l.push(o), c.push(n), c.push(r), c.push(o);
					for (a.sort(t), s.sort(t), l.sort(t), c.sort(t), e = 0; e < 7; e++) s[e] = dt(s[e]), l[e] = dt(l[e]), c[e] = dt(c[e]);
					this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + a.join("|") + ")", "i")
				}

				function te() {
					return this.hours() % 12 || 12
				}

				function ee(t, e) {
					W(t, 0, 0, function () {
						return this.localeData().meridiem(this.hours(), this.minutes(), e)
					})
				}

				function ie(t, e) {
					return e._meridiemParse
				}

				W("H", ["HH", 2], 0, "hour"), W("h", ["hh", 2], 0, te), W("k", ["kk", 2], 0, function () {
					return this.hours() || 24
				}), W("hmm", 0, 0, function () {
					return "" + te.apply(this) + $(this.minutes(), 2)
				}), W("hmmss", 0, 0, function () {
					return "" + te.apply(this) + $(this.minutes(), 2) + $(this.seconds(), 2)
				}), W("Hmm", 0, 0, function () {
					return "" + this.hours() + $(this.minutes(), 2)
				}), W("Hmmss", 0, 0, function () {
					return "" + this.hours() + $(this.minutes(), 2) + $(this.seconds(), 2)
				}), ee("a", !0), ee("A", !1), L("hour", "h"), H("hour", 13), ut("a", ie), ut("A", ie), ut("H", Q), ut("h", Q), ut("k", Q), ut("HH", Q, G), ut("hh", Q, G), ut("kk", Q, G), ut("hmm", J), ut("hmmss", tt), ut("Hmm", J), ut("Hmmss", tt), ft(["H", "HH"], wt), ft(["k", "kk"], function (t, e, i) {
					var n = _(t);
					e[wt] = 24 === n ? 0 : n
				}), ft(["a", "A"], function (t, e, i) {
					i._isPm = i._locale.isPM(t), i._meridiem = t
				}), ft(["h", "hh"], function (t, e, i) {
					e[wt] = _(t), f(i).bigHour = !0
				}), ft("hmm", function (t, e, i) {
					var n = t.length - 2;
					e[wt] = _(t.substr(0, n)), e[xt] = _(t.substr(n)), f(i).bigHour = !0
				}), ft("hmmss", function (t, e, i) {
					var n = t.length - 4, r = t.length - 2;
					e[wt] = _(t.substr(0, n)), e[xt] = _(t.substr(n, 2)), e[kt] = _(t.substr(r)), f(i).bigHour = !0
				}), ft("Hmm", function (t, e, i) {
					var n = t.length - 2;
					e[wt] = _(t.substr(0, n)), e[xt] = _(t.substr(n))
				}), ft("Hmmss", function (t, e, i) {
					var n = t.length - 4, r = t.length - 2;
					e[wt] = _(t.substr(0, n)), e[xt] = _(t.substr(n, 2)), e[kt] = _(t.substr(r))
				});
				var ne, re = At("Hours", !0), oe = {
					calendar: {sameDay: "[Today at] LT", nextDay: "[Tomorrow at] LT", nextWeek: "dddd [at] LT", lastDay: "[Yesterday at] LT", lastWeek: "[Last] dddd [at] LT", sameElse: "L"},
					longDateFormat: {LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A"},
					invalidDate: "Invalid date",
					ordinal: "%d",
					dayOfMonthOrdinalParse: /\d{1,2}/,
					relativeTime: {future: "in %s", past: "%s ago", s: "a few seconds", ss: "%d seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years"},
					months: Ft,
					monthsShort: Nt,
					week: {dow: 0, doy: 6},
					weekdays: qt,
					weekdaysMin: Kt,
					weekdaysShort: Gt,
					meridiemParse: /[ap]\.?m?\.?/i
				}, ae = {}, se = {};

				function le(t) {
					return t ? t.toLowerCase().replace("_", "-") : t
				}

				function ce(i) {
					var n = null;
					if (!ae[i] && void 0 !== e && e && e.exports) try {
						n = ne._abbr, t("./locale/" + i), ue(n)
					} catch (t) {
					}
					return ae[i]
				}

				function ue(t, e) {
					var i;
					return t && ((i = s(e) ? de(t) : he(t, e)) ? ne = i : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), ne._abbr
				}

				function he(t, e) {
					if (null !== e) {
						var i, n = oe;
						if (e.abbr = t, null != ae[t]) E("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), n = ae[t]._config; else if (null != e.parentLocale) if (null != ae[e.parentLocale]) n = ae[e.parentLocale]._config; else {
							if (null == (i = ce(e.parentLocale))) return se[e.parentLocale] || (se[e.parentLocale] = []), se[e.parentLocale].push({name: t, config: e}), null;
							n = i._config
						}
						return ae[t] = new I(P(n, e)), se[t] && se[t].forEach(function (t) {
							he(t.name, t.config)
						}), ue(t), ae[t]
					}
					return delete ae[t], null
				}

				function de(t) {
					var e;
					if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return ne;
					if (!o(t)) {
						if (e = ce(t)) return e;
						t = [t]
					}
					return function (t) {
						for (var e, i, n, r, o = 0; o < t.length;) {
							for (e = (r = le(t[o]).split("-")).length, i = (i = le(t[o + 1])) ? i.split("-") : null; e > 0;) {
								if (n = ce(r.slice(0, e).join("-"))) return n;
								if (i && i.length >= e && S(r, i, !0) >= e - 1) break;
								e--
							}
							o++
						}
						return ne
					}(t)
				}

				function pe(t) {
					var e, i = t._a;
					return i && -2 === f(t).overflow && (e = i[yt] < 0 || i[yt] > 11 ? yt : i[bt] < 1 || i[bt] > Ot(i[vt], i[yt]) ? bt : i[wt] < 0 || i[wt] > 24 || 24 === i[wt] && (0 !== i[xt] || 0 !== i[kt] || 0 !== i[_t]) ? wt : i[xt] < 0 || i[xt] > 59 ? xt : i[kt] < 0 || i[kt] > 59 ? kt : i[_t] < 0 || i[_t] > 999 ? _t : -1, f(t)._overflowDayOfYear && (e < vt || e > bt) && (e = bt), f(t)._overflowWeeks && -1 === e && (e = St), f(t)._overflowWeekday && -1 === e && (e = Ct), f(t).overflow = e), t
				}

				function fe(t, e, i) {
					return null != t ? t : null != e ? e : i
				}

				function me(t) {
					var e, i, n, o, a, s = [];
					if (!t._d) {
						for (n = function (t) {
							var e = new Date(r.now());
							return t._useUTC ? [e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()] : [e.getFullYear(), e.getMonth(), e.getDate()]
						}(t), t._w && null == t._a[bt] && null == t._a[yt] && function (t) {
							var e, i, n, r, o, a, s, l;
							if (null != (e = t._w).GG || null != e.W || null != e.E) o = 1, a = 4, i = fe(e.GG, t._a[vt], Yt(Ae(), 1, 4).year), n = fe(e.W, 1), ((r = fe(e.E, 1)) < 1 || r > 7) && (l = !0); else {
								o = t._locale._week.dow, a = t._locale._week.doy;
								var c = Yt(Ae(), o, a);
								i = fe(e.gg, t._a[vt], c.year), n = fe(e.w, c.week), null != e.d ? ((r = e.d) < 0 || r > 6) && (l = !0) : null != e.e ? (r = e.e + o, (e.e < 0 || e.e > 6) && (l = !0)) : r = o
							}
							n < 1 || n > Vt(i, o, a) ? f(t)._overflowWeeks = !0 : null != l ? f(t)._overflowWeekday = !0 : (s = Wt(i, n, r, o, a), t._a[vt] = s.year, t._dayOfYear = s.dayOfYear)
						}(t), null != t._dayOfYear && (a = fe(t._a[vt], n[vt]), (t._dayOfYear > Dt(a) || 0 === t._dayOfYear) && (f(t)._overflowDayOfYear = !0), i = jt(a, 0, t._dayOfYear), t._a[yt] = i.getUTCMonth(), t._a[bt] = i.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) t._a[e] = s[e] = n[e];
						for (; e < 7; e++) t._a[e] = s[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
						24 === t._a[wt] && 0 === t._a[xt] && 0 === t._a[kt] && 0 === t._a[_t] && (t._nextDay = !0, t._a[wt] = 0), t._d = (t._useUTC ? jt : function (t, e, i, n, r, o, a) {
							var s = new Date(t, e, i, n, r, o, a);
							return t < 100 && t >= 0 && isFinite(s.getFullYear()) && s.setFullYear(t), s
						}).apply(null, s), o = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[wt] = 24), t._w && void 0 !== t._w.d && t._w.d !== o && (f(t).weekdayMismatch = !0)
					}
				}

				var ge = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
					ve = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ye = /Z|[+-]\d\d(?::?\d\d)?/,
					be = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/]],
					we = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
					xe = /^\/?Date\((\-?\d+)/i;

				function ke(t) {
					var e, i, n, r, o, a, s = t._i, l = ge.exec(s) || ve.exec(s);
					if (l) {
						for (f(t).iso = !0, e = 0, i = be.length; e < i; e++) if (be[e][1].exec(l[1])) {
							r = be[e][0], n = !1 !== be[e][2];
							break
						}
						if (null == r) return void (t._isValid = !1);
						if (l[3]) {
							for (e = 0, i = we.length; e < i; e++) if (we[e][1].exec(l[3])) {
								o = (l[2] || " ") + we[e][0];
								break
							}
							if (null == o) return void (t._isValid = !1)
						}
						if (!n && null != o) return void (t._isValid = !1);
						if (l[4]) {
							if (!ye.exec(l[4])) return void (t._isValid = !1);
							a = "Z"
						}
						t._f = r + (o || "") + (a || ""), Te(t)
					} else t._isValid = !1
				}

				var _e = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

				function Se(t) {
					var e = parseInt(t, 10);
					return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e
				}

				var Ce = {UT: 0, GMT: 0, EDT: -240, EST: -300, CDT: -300, CST: -360, MDT: -360, MST: -420, PDT: -420, PST: -480};

				function De(t) {
					var e, i, n, r, o, a, s, l = _e.exec(t._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
					if (l) {
						var c = (e = l[4], i = l[3], n = l[2], r = l[5], o = l[6], a = l[7], s = [Se(e), Nt.indexOf(i), parseInt(n, 10), parseInt(r, 10), parseInt(o, 10)], a && s.push(parseInt(a, 10)), s);
						if (!function (t, e, i) {
							return !t || Gt.indexOf(t) === new Date(e[0], e[1], e[2]).getDay() || (f(i).weekdayMismatch = !0, i._isValid = !1, !1)
						}(l[1], c, t)) return;
						t._a = c, t._tzm = function (t, e, i) {
							if (t) return Ce[t];
							if (e) return 0;
							var n = parseInt(i, 10), r = n % 100;
							return (n - r) / 100 * 60 + r
						}(l[8], l[9], l[10]), t._d = jt.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), f(t).rfc2822 = !0
					} else t._isValid = !1
				}

				function Te(t) {
					if (t._f !== r.ISO_8601) if (t._f !== r.RFC_2822) {
						t._a = [], f(t).empty = !0;
						var e, i, n, o, a, s = "" + t._i, l = s.length, c = 0;
						for (n = V(t._f, t._locale).match(B) || [], e = 0; e < n.length; e++) o = n[e], (i = (s.match(ht(o, t)) || [])[0]) && ((a = s.substr(0, s.indexOf(i))).length > 0 && f(t).unusedInput.push(a), s = s.slice(s.indexOf(i) + i.length), c += i.length), U[o] ? (i ? f(t).empty = !1 : f(t).unusedTokens.push(o), gt(o, i, t)) : t._strict && !i && f(t).unusedTokens.push(o);
						f(t).charsLeftOver = l - c, s.length > 0 && f(t).unusedInput.push(s), t._a[wt] <= 12 && !0 === f(t).bigHour && t._a[wt] > 0 && (f(t).bigHour = void 0), f(t).parsedDateParts = t._a.slice(0), f(t).meridiem = t._meridiem, t._a[wt] = function (t, e, i) {
							var n;
							if (null == i) return e;
							return null != t.meridiemHour ? t.meridiemHour(e, i) : null != t.isPM ? ((n = t.isPM(i)) && e < 12 && (e += 12), n || 12 !== e || (e = 0), e) : e
						}(t._locale, t._a[wt], t._meridiem), me(t), pe(t)
					} else De(t); else ke(t)
				}

				function Me(t) {
					var e = t._i, i = t._f;
					return t._locale = t._locale || de(t._l), null === e || void 0 === i && "" === e ? g({nullInput: !0}) : ("string" == typeof e && (t._i = e = t._locale.preparse(e)), x(e) ? new w(pe(e)) : (c(e) ? t._d = e : o(i) ? function (t) {
						var e, i, n, r, o;
						if (0 === t._f.length) return f(t).invalidFormat = !0, void (t._d = new Date(NaN));
						for (r = 0; r < t._f.length; r++) o = 0, e = y({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[r], Te(e), m(e) && (o += f(e).charsLeftOver, o += 10 * f(e).unusedTokens.length, f(e).score = o, (null == n || o < n) && (n = o, i = e));
						d(t, i || e)
					}(t) : i ? Te(t) : function (t) {
						var e = t._i;
						s(e) ? t._d = new Date(r.now()) : c(e) ? t._d = new Date(e.valueOf()) : "string" == typeof e ? function (t) {
							var e = xe.exec(t._i);
							null === e ? (ke(t), !1 === t._isValid && (delete t._isValid, De(t), !1 === t._isValid && (delete t._isValid, r.createFromInputFallback(t)))) : t._d = new Date(+e[1])
						}(t) : o(e) ? (t._a = u(e.slice(0), function (t) {
							return parseInt(t, 10)
						}), me(t)) : a(e) ? function (t) {
							if (!t._d) {
								var e = N(t._i);
								t._a = u([e.year, e.month, e.day || e.date, e.hour, e.minute, e.second, e.millisecond], function (t) {
									return t && parseInt(t, 10)
								}), me(t)
							}
						}(t) : l(e) ? t._d = new Date(e) : r.createFromInputFallback(t)
					}(t), m(t) || (t._d = null), t))
				}

				function Ee(t, e, i, n, r) {
					var s, l = {};
					return !0 !== i && !1 !== i || (n = i, i = void 0), (a(t) && function (t) {
						if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
						var e;
						for (e in t) if (t.hasOwnProperty(e)) return !1;
						return !0
					}(t) || o(t) && 0 === t.length) && (t = void 0), l._isAMomentObject = !0, l._useUTC = l._isUTC = r, l._l = i, l._i = t, l._f = e, l._strict = n, (s = new w(pe(Me(l))))._nextDay && (s.add(1, "d"), s._nextDay = void 0), s
				}

				function Ae(t, e, i, n) {
					return Ee(t, e, i, n, !1)
				}

				r.createFromInputFallback = D("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (t) {
					t._d = new Date(t._i + (t._useUTC ? " UTC" : ""))
				}), r.ISO_8601 = function () {
				}, r.RFC_2822 = function () {
				};
				var Pe = D("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
					var t = Ae.apply(null, arguments);
					return this.isValid() && t.isValid() ? t < this ? this : t : g()
				}), Ie = D("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
					var t = Ae.apply(null, arguments);
					return this.isValid() && t.isValid() ? t > this ? this : t : g()
				});

				function Oe(t, e) {
					var i, n;
					if (1 === e.length && o(e[0]) && (e = e[0]), !e.length) return Ae();
					for (i = e[0], n = 1; n < e.length; ++n) e[n].isValid() && !e[n][t](i) || (i = e[n]);
					return i
				}

				var Le = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

				function Fe(t) {
					var e = N(t), i = e.year || 0, n = e.quarter || 0, r = e.month || 0, o = e.week || 0, a = e.day || 0, s = e.hour || 0, l = e.minute || 0, c = e.second || 0, u = e.millisecond || 0;
					this._isValid = function (t) {
						for (var e in t) if (-1 === Mt.call(Le, e) || null != t[e] && isNaN(t[e])) return !1;
						for (var i = !1, n = 0; n < Le.length; ++n) if (t[Le[n]]) {
							if (i) return !1;
							parseFloat(t[Le[n]]) !== _(t[Le[n]]) && (i = !0)
						}
						return !0
					}(e), this._milliseconds = +u + 1e3 * c + 6e4 * l + 1e3 * s * 60 * 60, this._days = +a + 7 * o, this._months = +r + 3 * n + 12 * i, this._data = {}, this._locale = de(), this._bubble()
				}

				function Ne(t) {
					return t instanceof Fe
				}

				function Re(t) {
					return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t)
				}

				function He(t, e) {
					W(t, 0, 0, function () {
						var t = this.utcOffset(), i = "+";
						return t < 0 && (t = -t, i = "-"), i + $(~~(t / 60), 2) + e + $(~~t % 60, 2)
					})
				}

				He("Z", ":"), He("ZZ", ""), ut("Z", st), ut("ZZ", st), ft(["Z", "ZZ"], function (t, e, i) {
					i._useUTC = !0, i._tzm = Be(st, t)
				});
				var $e = /([\+\-]|\d\d)/gi;

				function Be(t, e) {
					var i = (e || "").match(t);
					if (null === i) return null;
					var n = ((i[i.length - 1] || []) + "").match($e) || ["-", 0, 0], r = 60 * n[1] + _(n[2]);
					return 0 === r ? 0 : "+" === n[0] ? r : -r
				}

				function ze(t, e) {
					var i, n;
					return e._isUTC ? (i = e.clone(), n = (x(t) || c(t) ? t.valueOf() : Ae(t).valueOf()) - i.valueOf(), i._d.setTime(i._d.valueOf() + n), r.updateOffset(i, !1), i) : Ae(t).local()
				}

				function je(t) {
					return 15 * -Math.round(t._d.getTimezoneOffset() / 15)
				}

				function Ue() {
					return !!this.isValid() && (this._isUTC && 0 === this._offset)
				}

				r.updateOffset = function () {
				};
				var We = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/, Ye = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

				function Ve(t, e) {
					var i, n, r, o = t, a = null;
					return Ne(t) ? o = {ms: t._milliseconds, d: t._days, M: t._months} : l(t) ? (o = {}, e ? o[e] = t : o.milliseconds = t) : (a = We.exec(t)) ? (i = "-" === a[1] ? -1 : 1, o = {
						y: 0,
						d: _(a[bt]) * i,
						h: _(a[wt]) * i,
						m: _(a[xt]) * i,
						s: _(a[kt]) * i,
						ms: _(Re(1e3 * a[_t])) * i
					}) : (a = Ye.exec(t)) ? (i = "-" === a[1] ? -1 : (a[1], 1), o = {y: qe(a[2], i), M: qe(a[3], i), w: qe(a[4], i), d: qe(a[5], i), h: qe(a[6], i), m: qe(a[7], i), s: qe(a[8], i)}) : null == o ? o = {} : "object" == typeof o && ("from" in o || "to" in o) && (r = function (t, e) {
						var i;
						if (!t.isValid() || !e.isValid()) return {milliseconds: 0, months: 0};
						e = ze(e, t), t.isBefore(e) ? i = Ge(t, e) : ((i = Ge(e, t)).milliseconds = -i.milliseconds, i.months = -i.months);
						return i
					}(Ae(o.from), Ae(o.to)), (o = {}).ms = r.milliseconds, o.M = r.months), n = new Fe(o), Ne(t) && h(t, "_locale") && (n._locale = t._locale), n
				}

				function qe(t, e) {
					var i = t && parseFloat(t.replace(",", "."));
					return (isNaN(i) ? 0 : i) * e
				}

				function Ge(t, e) {
					var i = {milliseconds: 0, months: 0};
					return i.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(i.months, "M").isAfter(e) && --i.months, i.milliseconds = +e - +t.clone().add(i.months, "M"), i
				}

				function Ke(t, e) {
					return function (i, n) {
						var r;
						return null === n || isNaN(+n) || (E(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), r = i, i = n, n = r), Xe(this, Ve(i = "string" == typeof i ? +i : i, n), t), this
					}
				}

				function Xe(t, e, i, n) {
					var o = e._milliseconds, a = Re(e._days), s = Re(e._months);
					t.isValid() && (n = null == n || n, s && Rt(t, Pt(t, "Month") + s * i), a && It(t, "Date", Pt(t, "Date") + a * i), o && t._d.setTime(t._d.valueOf() + o * i), n && r.updateOffset(t, a || s))
				}

				Ve.fn = Fe.prototype, Ve.invalid = function () {
					return Ve(NaN)
				};
				var Ze = Ke(1, "add"), Qe = Ke(-1, "subtract");

				function Je(t, e) {
					var i = 12 * (e.year() - t.year()) + (e.month() - t.month()), n = t.clone().add(i, "months");
					return -(i + (e - n < 0 ? (e - n) / (n - t.clone().add(i - 1, "months")) : (e - n) / (t.clone().add(i + 1, "months") - n))) || 0
				}

				function ti(t) {
					var e;
					return void 0 === t ? this._locale._abbr : (null != (e = de(t)) && (this._locale = e), this)
				}

				r.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", r.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
				var ei = D("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (t) {
					return void 0 === t ? this.localeData() : this.locale(t)
				});

				function ii() {
					return this._locale
				}

				function ni(t, e) {
					W(0, [t, t.length], 0, e)
				}

				function ri(t, e, i, n, r) {
					var o;
					return null == t ? Yt(this, n, r).year : (e > (o = Vt(t, n, r)) && (e = o), function (t, e, i, n, r) {
						var o = Wt(t, e, i, n, r), a = jt(o.year, 0, o.dayOfYear);
						return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this
					}.call(this, t, e, i, n, r))
				}

				W(0, ["gg", 2], 0, function () {
					return this.weekYear() % 100
				}), W(0, ["GG", 2], 0, function () {
					return this.isoWeekYear() % 100
				}), ni("gggg", "weekYear"), ni("ggggg", "weekYear"), ni("GGGG", "isoWeekYear"), ni("GGGGG", "isoWeekYear"), L("weekYear", "gg"), L("isoWeekYear", "GG"), H("weekYear", 1), H("isoWeekYear", 1), ut("G", ot), ut("g", ot), ut("GG", Q, G), ut("gg", Q, G), ut("GGGG", it, X), ut("gggg", it, X), ut("GGGGG", nt, Z), ut("ggggg", nt, Z), mt(["gggg", "ggggg", "GGGG", "GGGGG"], function (t, e, i, n) {
					e[n.substr(0, 2)] = _(t)
				}), mt(["gg", "GG"], function (t, e, i, n) {
					e[n] = r.parseTwoDigitYear(t)
				}), W("Q", 0, "Qo", "quarter"), L("quarter", "Q"), H("quarter", 7), ut("Q", q), ft("Q", function (t, e) {
					e[yt] = 3 * (_(t) - 1)
				}), W("D", ["DD", 2], "Do", "date"), L("date", "D"), H("date", 9), ut("D", Q), ut("DD", Q, G), ut("Do", function (t, e) {
					return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient
				}), ft(["D", "DD"], bt), ft("Do", function (t, e) {
					e[bt] = _(t.match(Q)[0])
				});
				var oi = At("Date", !0);
				W("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), L("dayOfYear", "DDD"), H("dayOfYear", 4), ut("DDD", et), ut("DDDD", K), ft(["DDD", "DDDD"], function (t, e, i) {
					i._dayOfYear = _(t)
				}), W("m", ["mm", 2], 0, "minute"), L("minute", "m"), H("minute", 14), ut("m", Q), ut("mm", Q, G), ft(["m", "mm"], xt);
				var ai = At("Minutes", !1);
				W("s", ["ss", 2], 0, "second"), L("second", "s"), H("second", 15), ut("s", Q), ut("ss", Q, G), ft(["s", "ss"], kt);
				var si, li = At("Seconds", !1);
				for (W("S", 0, 0, function () {
					return ~~(this.millisecond() / 100)
				}), W(0, ["SS", 2], 0, function () {
					return ~~(this.millisecond() / 10)
				}), W(0, ["SSS", 3], 0, "millisecond"), W(0, ["SSSS", 4], 0, function () {
					return 10 * this.millisecond()
				}), W(0, ["SSSSS", 5], 0, function () {
					return 100 * this.millisecond()
				}), W(0, ["SSSSSS", 6], 0, function () {
					return 1e3 * this.millisecond()
				}), W(0, ["SSSSSSS", 7], 0, function () {
					return 1e4 * this.millisecond()
				}), W(0, ["SSSSSSSS", 8], 0, function () {
					return 1e5 * this.millisecond()
				}), W(0, ["SSSSSSSSS", 9], 0, function () {
					return 1e6 * this.millisecond()
				}), L("millisecond", "ms"), H("millisecond", 16), ut("S", et, q), ut("SS", et, G), ut("SSS", et, K), si = "SSSS"; si.length <= 9; si += "S") ut(si, rt);

				function ci(t, e) {
					e[_t] = _(1e3 * ("0." + t))
				}

				for (si = "S"; si.length <= 9; si += "S") ft(si, ci);
				var ui = At("Milliseconds", !1);
				W("z", 0, 0, "zoneAbbr"), W("zz", 0, 0, "zoneName");
				var hi = w.prototype;

				function di(t) {
					return t
				}

				hi.add = Ze, hi.calendar = function (t, e) {
					var i = t || Ae(), n = ze(i, this).startOf("day"), o = r.calendarFormat(this, n) || "sameElse", a = e && (A(e[o]) ? e[o].call(this, i) : e[o]);
					return this.format(a || this.localeData().calendar(o, this, Ae(i)))
				}, hi.clone = function () {
					return new w(this)
				}, hi.diff = function (t, e, i) {
					var n, r, o;
					if (!this.isValid()) return NaN;
					if (!(n = ze(t, this)).isValid()) return NaN;
					switch (r = 6e4 * (n.utcOffset() - this.utcOffset()), e = F(e)) {
						case"year":
							o = Je(this, n) / 12;
							break;
						case"month":
							o = Je(this, n);
							break;
						case"quarter":
							o = Je(this, n) / 3;
							break;
						case"second":
							o = (this - n) / 1e3;
							break;
						case"minute":
							o = (this - n) / 6e4;
							break;
						case"hour":
							o = (this - n) / 36e5;
							break;
						case"day":
							o = (this - n - r) / 864e5;
							break;
						case"week":
							o = (this - n - r) / 6048e5;
							break;
						default:
							o = this - n
					}
					return i ? o : k(o)
				}, hi.endOf = function (t) {
					return void 0 === (t = F(t)) || "millisecond" === t ? this : ("date" === t && (t = "day"), this.startOf(t).add(1, "isoWeek" === t ? "week" : t).subtract(1, "ms"))
				}, hi.format = function (t) {
					t || (t = this.isUtc() ? r.defaultFormatUtc : r.defaultFormat);
					var e = Y(this, t);
					return this.localeData().postformat(e)
				}, hi.from = function (t, e) {
					return this.isValid() && (x(t) && t.isValid() || Ae(t).isValid()) ? Ve({to: this, from: t}).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
				}, hi.fromNow = function (t) {
					return this.from(Ae(), t)
				}, hi.to = function (t, e) {
					return this.isValid() && (x(t) && t.isValid() || Ae(t).isValid()) ? Ve({from: this, to: t}).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
				}, hi.toNow = function (t) {
					return this.to(Ae(), t)
				}, hi.get = function (t) {
					return A(this[t = F(t)]) ? this[t]() : this
				}, hi.invalidAt = function () {
					return f(this).overflow
				}, hi.isAfter = function (t, e) {
					var i = x(t) ? t : Ae(t);
					return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = F(s(e) ? "millisecond" : e)) ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf())
				}, hi.isBefore = function (t, e) {
					var i = x(t) ? t : Ae(t);
					return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = F(s(e) ? "millisecond" : e)) ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf())
				}, hi.isBetween = function (t, e, i, n) {
					return ("(" === (n = n || "()")[0] ? this.isAfter(t, i) : !this.isBefore(t, i)) && (")" === n[1] ? this.isBefore(e, i) : !this.isAfter(e, i))
				}, hi.isSame = function (t, e) {
					var i, n = x(t) ? t : Ae(t);
					return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = F(e || "millisecond")) ? this.valueOf() === n.valueOf() : (i = n.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()))
				}, hi.isSameOrAfter = function (t, e) {
					return this.isSame(t, e) || this.isAfter(t, e)
				}, hi.isSameOrBefore = function (t, e) {
					return this.isSame(t, e) || this.isBefore(t, e)
				}, hi.isValid = function () {
					return m(this)
				}, hi.lang = ei, hi.locale = ti, hi.localeData = ii, hi.max = Ie, hi.min = Pe, hi.parsingFlags = function () {
					return d({}, f(this))
				}, hi.set = function (t, e) {
					if ("object" == typeof t) for (var i = function (t) {
						var e = [];
						for (var i in t) e.push({unit: i, priority: R[i]});
						return e.sort(function (t, e) {
							return t.priority - e.priority
						}), e
					}(t = N(t)), n = 0; n < i.length; n++) this[i[n].unit](t[i[n].unit]); else if (A(this[t = F(t)])) return this[t](e);
					return this
				}, hi.startOf = function (t) {
					switch (t = F(t)) {
						case"year":
							this.month(0);
						case"quarter":
						case"month":
							this.date(1);
						case"week":
						case"isoWeek":
						case"day":
						case"date":
							this.hours(0);
						case"hour":
							this.minutes(0);
						case"minute":
							this.seconds(0);
						case"second":
							this.milliseconds(0)
					}
					return "week" === t && this.weekday(0), "isoWeek" === t && this.isoWeekday(1), "quarter" === t && this.month(3 * Math.floor(this.month() / 3)), this
				}, hi.subtract = Qe, hi.toArray = function () {
					var t = this;
					return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()]
				}, hi.toObject = function () {
					var t = this;
					return {years: t.year(), months: t.month(), date: t.date(), hours: t.hours(), minutes: t.minutes(), seconds: t.seconds(), milliseconds: t.milliseconds()}
				}, hi.toDate = function () {
					return new Date(this.valueOf())
				}, hi.toISOString = function (t) {
					if (!this.isValid()) return null;
					var e = !0 !== t, i = e ? this.clone().utc() : this;
					return i.year() < 0 || i.year() > 9999 ? Y(i, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : A(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", Y(i, "Z")) : Y(i, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ")
				}, hi.inspect = function () {
					if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
					var t = "moment", e = "";
					this.isLocal() || (t = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", e = "Z");
					var i = "[" + t + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", r = e + '[")]';
					return this.format(i + n + "-MM-DD[T]HH:mm:ss.SSS" + r)
				}, hi.toJSON = function () {
					return this.isValid() ? this.toISOString() : null
				}, hi.toString = function () {
					return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
				}, hi.unix = function () {
					return Math.floor(this.valueOf() / 1e3)
				}, hi.valueOf = function () {
					return this._d.valueOf() - 6e4 * (this._offset || 0)
				}, hi.creationData = function () {
					return {input: this._i, format: this._f, locale: this._locale, isUTC: this._isUTC, strict: this._strict}
				}, hi.year = Et, hi.isLeapYear = function () {
					return Tt(this.year())
				}, hi.weekYear = function (t) {
					return ri.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
				}, hi.isoWeekYear = function (t) {
					return ri.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4)
				}, hi.quarter = hi.quarters = function (t) {
					return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3)
				}, hi.month = Ht, hi.daysInMonth = function () {
					return Ot(this.year(), this.month())
				}, hi.week = hi.weeks = function (t) {
					var e = this.localeData().week(this);
					return null == t ? e : this.add(7 * (t - e), "d")
				}, hi.isoWeek = hi.isoWeeks = function (t) {
					var e = Yt(this, 1, 4).week;
					return null == t ? e : this.add(7 * (t - e), "d")
				}, hi.weeksInYear = function () {
					var t = this.localeData()._week;
					return Vt(this.year(), t.dow, t.doy)
				}, hi.isoWeeksInYear = function () {
					return Vt(this.year(), 1, 4)
				}, hi.date = oi, hi.day = hi.days = function (t) {
					if (!this.isValid()) return null != t ? this : NaN;
					var e = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
					return null != t ? (t = function (t, e) {
						return "string" != typeof t ? t : isNaN(t) ? "number" == typeof (t = e.weekdaysParse(t)) ? t : null : parseInt(t, 10)
					}(t, this.localeData()), this.add(t - e, "d")) : e
				}, hi.weekday = function (t) {
					if (!this.isValid()) return null != t ? this : NaN;
					var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
					return null == t ? e : this.add(t - e, "d")
				}, hi.isoWeekday = function (t) {
					if (!this.isValid()) return null != t ? this : NaN;
					if (null != t) {
						var e = function (t, e) {
							return "string" == typeof t ? e.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t
						}(t, this.localeData());
						return this.day(this.day() % 7 ? e : e - 7)
					}
					return this.day() || 7
				}, hi.dayOfYear = function (t) {
					var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
					return null == t ? e : this.add(t - e, "d")
				}, hi.hour = hi.hours = re, hi.minute = hi.minutes = ai, hi.second = hi.seconds = li, hi.millisecond = hi.milliseconds = ui, hi.utcOffset = function (t, e, i) {
					var n, o = this._offset || 0;
					if (!this.isValid()) return null != t ? this : NaN;
					if (null != t) {
						if ("string" == typeof t) {
							if (null === (t = Be(st, t))) return this
						} else Math.abs(t) < 16 && !i && (t *= 60);
						return !this._isUTC && e && (n = je(this)), this._offset = t, this._isUTC = !0, null != n && this.add(n, "m"), o !== t && (!e || this._changeInProgress ? Xe(this, Ve(t - o, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, r.updateOffset(this, !0), this._changeInProgress = null)), this
					}
					return this._isUTC ? o : je(this)
				}, hi.utc = function (t) {
					return this.utcOffset(0, t)
				}, hi.local = function (t) {
					return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(je(this), "m")), this
				}, hi.parseZone = function () {
					if (null != this._tzm) this.utcOffset(this._tzm, !1, !0); else if ("string" == typeof this._i) {
						var t = Be(at, this._i);
						null != t ? this.utcOffset(t) : this.utcOffset(0, !0)
					}
					return this
				}, hi.hasAlignedHourOffset = function (t) {
					return !!this.isValid() && (t = t ? Ae(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0)
				}, hi.isDST = function () {
					return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
				}, hi.isLocal = function () {
					return !!this.isValid() && !this._isUTC
				}, hi.isUtcOffset = function () {
					return !!this.isValid() && this._isUTC
				}, hi.isUtc = Ue, hi.isUTC = Ue, hi.zoneAbbr = function () {
					return this._isUTC ? "UTC" : ""
				}, hi.zoneName = function () {
					return this._isUTC ? "Coordinated Universal Time" : ""
				}, hi.dates = D("dates accessor is deprecated. Use date instead.", oi), hi.months = D("months accessor is deprecated. Use month instead", Ht), hi.years = D("years accessor is deprecated. Use year instead", Et), hi.zone = D("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (t, e) {
					return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset()
				}), hi.isDSTShifted = D("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
					if (!s(this._isDSTShifted)) return this._isDSTShifted;
					var t = {};
					if (y(t, this), (t = Me(t))._a) {
						var e = t._isUTC ? p(t._a) : Ae(t._a);
						this._isDSTShifted = this.isValid() && S(t._a, e.toArray()) > 0
					} else this._isDSTShifted = !1;
					return this._isDSTShifted
				});
				var pi = I.prototype;

				function fi(t, e, i, n) {
					var r = de(), o = p().set(n, e);
					return r[i](o, t)
				}

				function mi(t, e, i) {
					if (l(t) && (e = t, t = void 0), t = t || "", null != e) return fi(t, e, i, "month");
					var n, r = [];
					for (n = 0; n < 12; n++) r[n] = fi(t, n, i, "month");
					return r
				}

				function gi(t, e, i, n) {
					"boolean" == typeof t ? (l(e) && (i = e, e = void 0), e = e || "") : (i = e = t, t = !1, l(e) && (i = e, e = void 0), e = e || "");
					var r, o = de(), a = t ? o._week.dow : 0;
					if (null != i) return fi(e, (i + a) % 7, n, "day");
					var s = [];
					for (r = 0; r < 7; r++) s[r] = fi(e, (r + a) % 7, n, "day");
					return s
				}

				pi.calendar = function (t, e, i) {
					var n = this._calendar[t] || this._calendar.sameElse;
					return A(n) ? n.call(e, i) : n
				}, pi.longDateFormat = function (t) {
					var e = this._longDateFormat[t], i = this._longDateFormat[t.toUpperCase()];
					return e || !i ? e : (this._longDateFormat[t] = i.replace(/MMMM|MM|DD|dddd/g, function (t) {
						return t.slice(1)
					}), this._longDateFormat[t])
				}, pi.invalidDate = function () {
					return this._invalidDate
				}, pi.ordinal = function (t) {
					return this._ordinal.replace("%d", t)
				}, pi.preparse = di, pi.postformat = di, pi.relativeTime = function (t, e, i, n) {
					var r = this._relativeTime[i];
					return A(r) ? r(t, e, i, n) : r.replace(/%d/i, t)
				}, pi.pastFuture = function (t, e) {
					var i = this._relativeTime[t > 0 ? "future" : "past"];
					return A(i) ? i(e) : i.replace(/%s/i, e)
				}, pi.set = function (t) {
					var e, i;
					for (i in t) A(e = t[i]) ? this[i] = e : this["_" + i] = e;
					this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source)
				}, pi.months = function (t, e) {
					return t ? o(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || Lt).test(e) ? "format" : "standalone"][t.month()] : o(this._months) ? this._months : this._months.standalone
				}, pi.monthsShort = function (t, e) {
					return t ? o(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[Lt.test(e) ? "format" : "standalone"][t.month()] : o(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone
				}, pi.monthsParse = function (t, e, i) {
					var n, r, o;
					if (this._monthsParseExact) return function (t, e, i) {
						var n, r, o, a = t.toLocaleLowerCase();
						if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n) o = p([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(o, "").toLocaleLowerCase(), this._longMonthsParse[n] = this.months(o, "").toLocaleLowerCase();
						return i ? "MMM" === e ? -1 !== (r = Mt.call(this._shortMonthsParse, a)) ? r : null : -1 !== (r = Mt.call(this._longMonthsParse, a)) ? r : null : "MMM" === e ? -1 !== (r = Mt.call(this._shortMonthsParse, a)) ? r : -1 !== (r = Mt.call(this._longMonthsParse, a)) ? r : null : -1 !== (r = Mt.call(this._longMonthsParse, a)) ? r : -1 !== (r = Mt.call(this._shortMonthsParse, a)) ? r : null
					}.call(this, t, e, i);
					for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
						if (r = p([2e3, n]), i && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp("^" + this.months(r, "").replace(".", "") + "$", "i"), this._shortMonthsParse[n] = new RegExp("^" + this.monthsShort(r, "").replace(".", "") + "$", "i")), i || this._monthsParse[n] || (o = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[n] = new RegExp(o.replace(".", ""), "i")), i && "MMMM" === e && this._longMonthsParse[n].test(t)) return n;
						if (i && "MMM" === e && this._shortMonthsParse[n].test(t)) return n;
						if (!i && this._monthsParse[n].test(t)) return n
					}
				}, pi.monthsRegex = function (t) {
					return this._monthsParseExact ? (h(this, "_monthsRegex") || zt.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (h(this, "_monthsRegex") || (this._monthsRegex = Bt), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex)
				}, pi.monthsShortRegex = function (t) {
					return this._monthsParseExact ? (h(this, "_monthsRegex") || zt.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (h(this, "_monthsShortRegex") || (this._monthsShortRegex = $t), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex)
				}, pi.week = function (t) {
					return Yt(t, this._week.dow, this._week.doy).week
				}, pi.firstDayOfYear = function () {
					return this._week.doy
				}, pi.firstDayOfWeek = function () {
					return this._week.dow
				}, pi.weekdays = function (t, e) {
					return t ? o(this._weekdays) ? this._weekdays[t.day()] : this._weekdays[this._weekdays.isFormat.test(e) ? "format" : "standalone"][t.day()] : o(this._weekdays) ? this._weekdays : this._weekdays.standalone
				}, pi.weekdaysMin = function (t) {
					return t ? this._weekdaysMin[t.day()] : this._weekdaysMin
				}, pi.weekdaysShort = function (t) {
					return t ? this._weekdaysShort[t.day()] : this._weekdaysShort
				}, pi.weekdaysParse = function (t, e, i) {
					var n, r, o;
					if (this._weekdaysParseExact) return function (t, e, i) {
						var n, r, o, a = t.toLocaleLowerCase();
						if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n) o = p([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(o, "").toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(o, "").toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(o, "").toLocaleLowerCase();
						return i ? "dddd" === e ? -1 !== (r = Mt.call(this._weekdaysParse, a)) ? r : null : "ddd" === e ? -1 !== (r = Mt.call(this._shortWeekdaysParse, a)) ? r : null : -1 !== (r = Mt.call(this._minWeekdaysParse, a)) ? r : null : "dddd" === e ? -1 !== (r = Mt.call(this._weekdaysParse, a)) ? r : -1 !== (r = Mt.call(this._shortWeekdaysParse, a)) ? r : -1 !== (r = Mt.call(this._minWeekdaysParse, a)) ? r : null : "ddd" === e ? -1 !== (r = Mt.call(this._shortWeekdaysParse, a)) ? r : -1 !== (r = Mt.call(this._weekdaysParse, a)) ? r : -1 !== (r = Mt.call(this._minWeekdaysParse, a)) ? r : null : -1 !== (r = Mt.call(this._minWeekdaysParse, a)) ? r : -1 !== (r = Mt.call(this._weekdaysParse, a)) ? r : -1 !== (r = Mt.call(this._shortWeekdaysParse, a)) ? r : null
					}.call(this, t, e, i);
					for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
						if (r = p([2e3, 1]).day(n), i && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp("^" + this.weekdays(r, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[n] = new RegExp("^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[n] = new RegExp("^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[n] || (o = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[n] = new RegExp(o.replace(".", ""), "i")), i && "dddd" === e && this._fullWeekdaysParse[n].test(t)) return n;
						if (i && "ddd" === e && this._shortWeekdaysParse[n].test(t)) return n;
						if (i && "dd" === e && this._minWeekdaysParse[n].test(t)) return n;
						if (!i && this._weekdaysParse[n].test(t)) return n
					}
				}, pi.weekdaysRegex = function (t) {
					return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || Jt.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (h(this, "_weekdaysRegex") || (this._weekdaysRegex = Xt), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex)
				}, pi.weekdaysShortRegex = function (t) {
					return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || Jt.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (h(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Zt), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
				}, pi.weekdaysMinRegex = function (t) {
					return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || Jt.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (h(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Qt), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
				}, pi.isPM = function (t) {
					return "p" === (t + "").toLowerCase().charAt(0)
				}, pi.meridiem = function (t, e, i) {
					return t > 11 ? i ? "pm" : "PM" : i ? "am" : "AM"
				}, ue("en", {
					dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/, ordinal: function (t) {
						var e = t % 10;
						return t + (1 === _(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th")
					}
				}), r.lang = D("moment.lang is deprecated. Use moment.locale instead.", ue), r.langData = D("moment.langData is deprecated. Use moment.localeData instead.", de);
				var vi = Math.abs;

				function yi(t, e, i, n) {
					var r = Ve(e, i);
					return t._milliseconds += n * r._milliseconds, t._days += n * r._days, t._months += n * r._months, t._bubble()
				}

				function bi(t) {
					return t < 0 ? Math.floor(t) : Math.ceil(t)
				}

				function wi(t) {
					return 4800 * t / 146097
				}

				function xi(t) {
					return 146097 * t / 4800
				}

				function ki(t) {
					return function () {
						return this.as(t)
					}
				}

				var _i = ki("ms"), Si = ki("s"), Ci = ki("m"), Di = ki("h"), Ti = ki("d"), Mi = ki("w"), Ei = ki("M"), Ai = ki("y");

				function Pi(t) {
					return function () {
						return this.isValid() ? this._data[t] : NaN
					}
				}

				var Ii = Pi("milliseconds"), Oi = Pi("seconds"), Li = Pi("minutes"), Fi = Pi("hours"), Ni = Pi("days"), Ri = Pi("months"), Hi = Pi("years"), $i = Math.round, Bi = {ss: 44, s: 45, m: 45, h: 22, d: 26, M: 11}, zi = Math.abs;

				function ji(t) {
					return (t > 0) - (t < 0) || +t
				}

				function Ui() {
					if (!this.isValid()) return this.localeData().invalidDate();
					var t, e, i = zi(this._milliseconds) / 1e3, n = zi(this._days), r = zi(this._months);
					t = k(i / 60), e = k(t / 60), i %= 60, t %= 60;
					var o = k(r / 12), a = r %= 12, s = n, l = e, c = t, u = i ? i.toFixed(3).replace(/\.?0+$/, "") : "", h = this.asSeconds();
					if (!h) return "P0D";
					var d = h < 0 ? "-" : "", p = ji(this._months) !== ji(h) ? "-" : "", f = ji(this._days) !== ji(h) ? "-" : "", m = ji(this._milliseconds) !== ji(h) ? "-" : "";
					return d + "P" + (o ? p + o + "Y" : "") + (a ? p + a + "M" : "") + (s ? f + s + "D" : "") + (l || c || u ? "T" : "") + (l ? m + l + "H" : "") + (c ? m + c + "M" : "") + (u ? m + u + "S" : "")
				}

				var Wi = Fe.prototype;
				return Wi.isValid = function () {
					return this._isValid
				}, Wi.abs = function () {
					var t = this._data;
					return this._milliseconds = vi(this._milliseconds), this._days = vi(this._days), this._months = vi(this._months), t.milliseconds = vi(t.milliseconds), t.seconds = vi(t.seconds), t.minutes = vi(t.minutes), t.hours = vi(t.hours), t.months = vi(t.months), t.years = vi(t.years), this
				}, Wi.add = function (t, e) {
					return yi(this, t, e, 1)
				}, Wi.subtract = function (t, e) {
					return yi(this, t, e, -1)
				}, Wi.as = function (t) {
					if (!this.isValid()) return NaN;
					var e, i, n = this._milliseconds;
					if ("month" === (t = F(t)) || "year" === t) return e = this._days + n / 864e5, i = this._months + wi(e), "month" === t ? i : i / 12;
					switch (e = this._days + Math.round(xi(this._months)), t) {
						case"week":
							return e / 7 + n / 6048e5;
						case"day":
							return e + n / 864e5;
						case"hour":
							return 24 * e + n / 36e5;
						case"minute":
							return 1440 * e + n / 6e4;
						case"second":
							return 86400 * e + n / 1e3;
						case"millisecond":
							return Math.floor(864e5 * e) + n;
						default:
							throw new Error("Unknown unit " + t)
					}
				}, Wi.asMilliseconds = _i, Wi.asSeconds = Si, Wi.asMinutes = Ci, Wi.asHours = Di, Wi.asDays = Ti, Wi.asWeeks = Mi, Wi.asMonths = Ei, Wi.asYears = Ai, Wi.valueOf = function () {
					return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * _(this._months / 12) : NaN
				}, Wi._bubble = function () {
					var t, e, i, n, r, o = this._milliseconds, a = this._days, s = this._months, l = this._data;
					return o >= 0 && a >= 0 && s >= 0 || o <= 0 && a <= 0 && s <= 0 || (o += 864e5 * bi(xi(s) + a), a = 0, s = 0), l.milliseconds = o % 1e3, t = k(o / 1e3), l.seconds = t % 60, e = k(t / 60), l.minutes = e % 60, i = k(e / 60), l.hours = i % 24, a += k(i / 24), s += r = k(wi(a)), a -= bi(xi(r)), n = k(s / 12), s %= 12, l.days = a, l.months = s, l.years = n, this
				}, Wi.clone = function () {
					return Ve(this)
				}, Wi.get = function (t) {
					return t = F(t), this.isValid() ? this[t + "s"]() : NaN
				}, Wi.milliseconds = Ii, Wi.seconds = Oi, Wi.minutes = Li, Wi.hours = Fi, Wi.days = Ni, Wi.weeks = function () {
					return k(this.days() / 7)
				}, Wi.months = Ri, Wi.years = Hi, Wi.humanize = function (t) {
					if (!this.isValid()) return this.localeData().invalidDate();
					var e = this.localeData(), i = function (t, e, i) {
						var n = Ve(t).abs(), r = $i(n.as("s")), o = $i(n.as("m")), a = $i(n.as("h")), s = $i(n.as("d")), l = $i(n.as("M")), c = $i(n.as("y")),
							u = r <= Bi.ss && ["s", r] || r < Bi.s && ["ss", r] || o <= 1 && ["m"] || o < Bi.m && ["mm", o] || a <= 1 && ["h"] || a < Bi.h && ["hh", a] || s <= 1 && ["d"] || s < Bi.d && ["dd", s] || l <= 1 && ["M"] || l < Bi.M && ["MM", l] || c <= 1 && ["y"] || ["yy", c];
						return u[2] = e, u[3] = +t > 0, u[4] = i, function (t, e, i, n, r) {
							return r.relativeTime(e || 1, !!i, t, n)
						}.apply(null, u)
					}(this, !t, e);
					return t && (i = e.pastFuture(+this, i)), e.postformat(i)
				}, Wi.toISOString = Ui, Wi.toString = Ui, Wi.toJSON = Ui, Wi.locale = ti, Wi.localeData = ii, Wi.toIsoString = D("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Ui), Wi.lang = ei, W("X", 0, 0, "unix"), W("x", 0, 0, "valueOf"), ut("x", ot), ut("X", /[+-]?\d+(\.\d{1,3})?/), ft("X", function (t, e, i) {
					i._d = new Date(1e3 * parseFloat(t, 10))
				}), ft("x", function (t, e, i) {
					i._d = new Date(_(t))
				}), r.version = "2.22.2", i = Ae, r.fn = hi, r.min = function () {
					return Oe("isBefore", [].slice.call(arguments, 0))
				}, r.max = function () {
					return Oe("isAfter", [].slice.call(arguments, 0))
				}, r.now = function () {
					return Date.now ? Date.now() : +new Date
				}, r.utc = p, r.unix = function (t) {
					return Ae(1e3 * t)
				}, r.months = function (t, e) {
					return mi(t, e, "months")
				}, r.isDate = c, r.locale = ue, r.invalid = g, r.duration = Ve, r.isMoment = x, r.weekdays = function (t, e, i) {
					return gi(t, e, i, "weekdays")
				}, r.parseZone = function () {
					return Ae.apply(null, arguments).parseZone()
				}, r.localeData = de, r.isDuration = Ne, r.monthsShort = function (t, e) {
					return mi(t, e, "monthsShort")
				}, r.weekdaysMin = function (t, e, i) {
					return gi(t, e, i, "weekdaysMin")
				}, r.defineLocale = he, r.updateLocale = function (t, e) {
					if (null != e) {
						var i, n, r = oe;
						null != (n = ce(t)) && (r = n._config), (i = new I(e = P(r, e))).parentLocale = ae[t], ae[t] = i, ue(t)
					} else null != ae[t] && (null != ae[t].parentLocale ? ae[t] = ae[t].parentLocale : null != ae[t] && delete ae[t]);
					return ae[t]
				}, r.locales = function () {
					return T(ae)
				}, r.weekdaysShort = function (t, e, i) {
					return gi(t, e, i, "weekdaysShort")
				}, r.normalizeUnits = F, r.relativeTimeRounding = function (t) {
					return void 0 === t ? $i : "function" == typeof t && ($i = t, !0)
				}, r.relativeTimeThreshold = function (t, e) {
					return void 0 !== Bi[t] && (void 0 === e ? Bi[t] : (Bi[t] = e, "s" === t && (Bi.ss = e - 1), !0))
				}, r.calendarFormat = function (t, e) {
					var i = t.diff(e, "days", !0);
					return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse"
				}, r.prototype = hi, r.HTML5_FMT = {
					DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
					DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
					DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
					DATE: "YYYY-MM-DD",
					TIME: "HH:mm",
					TIME_SECONDS: "HH:mm:ss",
					TIME_MS: "HH:mm:ss.SSS",
					WEEK: "YYYY-[W]WW",
					MONTH: "YYYY-MM"
				}, r
			}, "object" == typeof i && void 0 !== e ? e.exports = r() : n.moment = r()
		}, {}], 7: [function (t, e, i) {
			var n = t(30)();
			n.helpers = t(46), t(28)(n), n.Animation = t(22), n.animationService = t(23), n.defaults = t(26), n.Element = t(27), n.elements = t(41), n.Interaction = t(29), n.layouts = t(31), n.platform = t(49), n.plugins = t(32), n.Scale = t(33), n.scaleService = t(34), n.Ticks = t(35), n.Tooltip = t(36), t(24)(n), t(25)(n), t(56)(n), t(54)(n), t(55)(n), t(57)(n), t(58)(n), t(59)(n), t(15)(n), t(16)(n), t(17)(n), t(18)(n), t(19)(n), t(20)(n), t(21)(n), t(8)(n), t(9)(n), t(10)(n), t(11)(n), t(12)(n), t(13)(n), t(14)(n);
			var r = t(50);
			for (var o in r) r.hasOwnProperty(o) && n.plugins.register(r[o]);
			n.platform.initialize(), e.exports = n, "undefined" != typeof window && (window.Chart = n), n.Legend = r.legend._element, n.Title = r.title._element, n.pluginService = n.plugins, n.PluginBase = n.Element.extend({}), n.canvasHelpers = n.helpers.canvas, n.layoutService = n.layouts
		}, {
			10: 10,
			11: 11,
			12: 12,
			13: 13,
			14: 14,
			15: 15,
			16: 16,
			17: 17,
			18: 18,
			19: 19,
			20: 20,
			21: 21,
			22: 22,
			23: 23,
			24: 24,
			25: 25,
			26: 26,
			27: 27,
			28: 28,
			29: 29,
			30: 30,
			31: 31,
			32: 32,
			33: 33,
			34: 34,
			35: 35,
			36: 36,
			41: 41,
			46: 46,
			49: 49,
			50: 50,
			54: 54,
			55: 55,
			56: 56,
			57: 57,
			58: 58,
			59: 59,
			8: 8,
			9: 9
		}], 8: [function (t, e, i) {
			"use strict";
			e.exports = function (t) {
				t.Bar = function (e, i) {
					return i.type = "bar", new t(e, i)
				}
			}
		}, {}], 9: [function (t, e, i) {
			"use strict";
			e.exports = function (t) {
				t.Bubble = function (e, i) {
					return i.type = "bubble", new t(e, i)
				}
			}
		}, {}], 10: [function (t, e, i) {
			"use strict";
			e.exports = function (t) {
				t.Doughnut = function (e, i) {
					return i.type = "doughnut", new t(e, i)
				}
			}
		}, {}], 11: [function (t, e, i) {
			"use strict";
			e.exports = function (t) {
				t.Line = function (e, i) {
					return i.type = "line", new t(e, i)
				}
			}
		}, {}], 12: [function (t, e, i) {
			"use strict";
			e.exports = function (t) {
				t.PolarArea = function (e, i) {
					return i.type = "polarArea", new t(e, i)
				}
			}
		}, {}], 13: [function (t, e, i) {
			"use strict";
			e.exports = function (t) {
				t.Radar = function (e, i) {
					return i.type = "radar", new t(e, i)
				}
			}
		}, {}], 14: [function (t, e, i) {
			"use strict";
			e.exports = function (t) {
				t.Scatter = function (e, i) {
					return i.type = "scatter", new t(e, i)
				}
			}
		}, {}], 15: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(41), o = t(46);
			n._set("bar", {hover: {mode: "label"}, scales: {xAxes: [{type: "category", categoryPercentage: .8, barPercentage: .9, offset: !0, gridLines: {offsetGridLines: !0}}], yAxes: [{type: "linear"}]}}), n._set("horizontalBar", {
				hover: {mode: "index", axis: "y"},
				scales: {xAxes: [{type: "linear", position: "bottom"}], yAxes: [{position: "left", type: "category", categoryPercentage: .8, barPercentage: .9, offset: !0, gridLines: {offsetGridLines: !0}}]},
				elements: {rectangle: {borderSkipped: "left"}},
				tooltips: {
					callbacks: {
						title: function (t, e) {
							var i = "";
							return t.length > 0 && (t[0].yLabel ? i = t[0].yLabel : e.labels.length > 0 && t[0].index < e.labels.length && (i = e.labels[t[0].index])), i
						}, label: function (t, e) {
							return (e.datasets[t.datasetIndex].label || "") + ": " + t.xLabel
						}
					}, mode: "index", axis: "y"
				}
			}), e.exports = function (t) {
				t.controllers.bar = t.DatasetController.extend({
					dataElementType: r.Rectangle, initialize: function () {
						var e;
						t.DatasetController.prototype.initialize.apply(this, arguments), (e = this.getMeta()).stack = this.getDataset().stack, e.bar = !0
					}, update: function (t) {
						var e, i, n = this.getMeta().data;
						for (this._ruler = this.getRuler(), e = 0, i = n.length; e < i; ++e) this.updateElement(n[e], e, t)
					}, updateElement: function (t, e, i) {
						var n = this, r = n.chart, a = n.getMeta(), s = n.getDataset(), l = t.custom || {}, c = r.options.elements.rectangle;
						t._xScale = n.getScaleForId(a.xAxisID), t._yScale = n.getScaleForId(a.yAxisID), t._datasetIndex = n.index, t._index = e, t._model = {
							datasetLabel: s.label,
							label: r.data.labels[e],
							borderSkipped: l.borderSkipped ? l.borderSkipped : c.borderSkipped,
							backgroundColor: l.backgroundColor ? l.backgroundColor : o.valueAtIndexOrDefault(s.backgroundColor, e, c.backgroundColor),
							borderColor: l.borderColor ? l.borderColor : o.valueAtIndexOrDefault(s.borderColor, e, c.borderColor),
							borderWidth: l.borderWidth ? l.borderWidth : o.valueAtIndexOrDefault(s.borderWidth, e, c.borderWidth)
						}, n.updateElementGeometry(t, e, i), t.pivot()
					}, updateElementGeometry: function (t, e, i) {
						var n = this, r = t._model, o = n.getValueScale(), a = o.getBasePixel(), s = o.isHorizontal(), l = n._ruler || n.getRuler(), c = n.calculateBarValuePixels(n.index, e), u = n.calculateBarIndexPixels(n.index, e, l);
						r.horizontal = s, r.base = i ? a : c.base, r.x = s ? i ? a : c.head : u.center, r.y = s ? u.center : i ? a : c.head, r.height = s ? u.size : void 0, r.width = s ? void 0 : u.size
					}, getValueScaleId: function () {
						return this.getMeta().yAxisID
					}, getIndexScaleId: function () {
						return this.getMeta().xAxisID
					}, getValueScale: function () {
						return this.getScaleForId(this.getValueScaleId())
					}, getIndexScale: function () {
						return this.getScaleForId(this.getIndexScaleId())
					}, _getStacks: function (t) {
						var e, i, n = this.chart, r = this.getIndexScale().options.stacked, o = void 0 === t ? n.data.datasets.length : t + 1, a = [];
						for (e = 0; e < o; ++e) (i = n.getDatasetMeta(e)).bar && n.isDatasetVisible(e) && (!1 === r || !0 === r && -1 === a.indexOf(i.stack) || void 0 === r && (void 0 === i.stack || -1 === a.indexOf(i.stack))) && a.push(i.stack);
						return a
					}, getStackCount: function () {
						return this._getStacks().length
					}, getStackIndex: function (t, e) {
						var i = this._getStacks(t), n = void 0 !== e ? i.indexOf(e) : -1;
						return -1 === n ? i.length - 1 : n
					}, getRuler: function () {
						var t, e, i = this.getIndexScale(), n = this.getStackCount(), r = this.index, a = i.isHorizontal(), s = a ? i.left : i.top, l = s + (a ? i.width : i.height), c = [];
						for (t = 0, e = this.getMeta().data.length; t < e; ++t) c.push(i.getPixelForValue(null, t, r));
						return {
							min: o.isNullOrUndef(i.options.barThickness) ? function (t, e) {
								var i, n, r, o, a = t.isHorizontal() ? t.width : t.height, s = t.getTicks();
								for (r = 1, o = e.length; r < o; ++r) a = Math.min(a, e[r] - e[r - 1]);
								for (r = 0, o = s.length; r < o; ++r) n = t.getPixelForTick(r), a = r > 0 ? Math.min(a, n - i) : a, i = n;
								return a
							}(i, c) : -1, pixels: c, start: s, end: l, stackCount: n, scale: i
						}
					}, calculateBarValuePixels: function (t, e) {
						var i, n, r, o, a, s, l = this.chart, c = this.getMeta(), u = this.getValueScale(), h = l.data.datasets, d = u.getRightValue(h[t].data[e]), p = u.options.stacked, f = c.stack, m = 0;
						if (p || void 0 === p && void 0 !== f) for (i = 0; i < t; ++i) (n = l.getDatasetMeta(i)).bar && n.stack === f && n.controller.getValueScaleId() === u.id && l.isDatasetVisible(i) && (r = u.getRightValue(h[i].data[e]), (d < 0 && r < 0 || d >= 0 && r > 0) && (m += r));
						return o = u.getPixelForValue(m), {size: s = ((a = u.getPixelForValue(m + d)) - o) / 2, base: o, head: a, center: a + s / 2}
					}, calculateBarIndexPixels: function (t, e, i) {
						var n = i.scale.options, r = "flex" === n.barThickness ? function (t, e, i) {
							var n, r = e.pixels, o = r[t], a = t > 0 ? r[t - 1] : null, s = t < r.length - 1 ? r[t + 1] : null, l = i.categoryPercentage;
							return null === a && (a = o - (null === s ? e.end - o : s - o)), null === s && (s = o + o - a), n = o - (o - a) / 2 * l, {chunk: (s - a) / 2 * l / e.stackCount, ratio: i.barPercentage, start: n}
						}(e, i, n) : function (t, e, i) {
							var n, r, a = i.barThickness, s = e.stackCount, l = e.pixels[t];
							return o.isNullOrUndef(a) ? (n = e.min * i.categoryPercentage, r = i.barPercentage) : (n = a * s, r = 1), {chunk: n / s, ratio: r, start: l - n / 2}
						}(e, i, n), a = this.getStackIndex(t, this.getMeta().stack), s = r.start + r.chunk * a + r.chunk / 2, l = Math.min(o.valueOrDefault(n.maxBarThickness, 1 / 0), r.chunk * r.ratio);
						return {base: s - l / 2, head: s + l / 2, center: s, size: l}
					}, draw: function () {
						var t = this.chart, e = this.getValueScale(), i = this.getMeta().data, n = this.getDataset(), r = i.length, a = 0;
						for (o.canvas.clipArea(t.ctx, t.chartArea); a < r; ++a) isNaN(e.getRightValue(n.data[a])) || i[a].draw();
						o.canvas.unclipArea(t.ctx)
					}
				}), t.controllers.horizontalBar = t.controllers.bar.extend({
					getValueScaleId: function () {
						return this.getMeta().xAxisID
					}, getIndexScaleId: function () {
						return this.getMeta().yAxisID
					}
				})
			}
		}, {26: 26, 41: 41, 46: 46}], 16: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(41), o = t(46);
			n._set("bubble", {
				hover: {mode: "single"}, scales: {xAxes: [{type: "linear", position: "bottom", id: "x-axis-0"}], yAxes: [{type: "linear", position: "left", id: "y-axis-0"}]}, tooltips: {
					callbacks: {
						title: function () {
							return ""
						}, label: function (t, e) {
							var i = e.datasets[t.datasetIndex].label || "", n = e.datasets[t.datasetIndex].data[t.index];
							return i + ": (" + t.xLabel + ", " + t.yLabel + ", " + n.r + ")"
						}
					}
				}
			}), e.exports = function (t) {
				t.controllers.bubble = t.DatasetController.extend({
					dataElementType: r.Point, update: function (t) {
						var e = this, i = e.getMeta().data;
						o.each(i, function (i, n) {
							e.updateElement(i, n, t)
						})
					}, updateElement: function (t, e, i) {
						var n = this, r = n.getMeta(), o = t.custom || {}, a = n.getScaleForId(r.xAxisID), s = n.getScaleForId(r.yAxisID), l = n._resolveElementOptions(t, e), c = n.getDataset().data[e], u = n.index,
							h = i ? a.getPixelForDecimal(.5) : a.getPixelForValue("object" == typeof c ? c : NaN, e, u), d = i ? s.getBasePixel() : s.getPixelForValue(c, e, u);
						t._xScale = a, t._yScale = s, t._options = l, t._datasetIndex = u, t._index = e, t._model = {
							backgroundColor: l.backgroundColor,
							borderColor: l.borderColor,
							borderWidth: l.borderWidth,
							hitRadius: l.hitRadius,
							pointStyle: l.pointStyle,
							rotation: l.rotation,
							radius: i ? 0 : l.radius,
							skip: o.skip || isNaN(h) || isNaN(d),
							x: h,
							y: d
						}, t.pivot()
					}, setHoverStyle: function (t) {
						var e = t._model, i = t._options;
						t.$previousStyle = {
							backgroundColor: e.backgroundColor,
							borderColor: e.borderColor,
							borderWidth: e.borderWidth,
							radius: e.radius
						}, e.backgroundColor = o.valueOrDefault(i.hoverBackgroundColor, o.getHoverColor(i.backgroundColor)), e.borderColor = o.valueOrDefault(i.hoverBorderColor, o.getHoverColor(i.borderColor)), e.borderWidth = o.valueOrDefault(i.hoverBorderWidth, i.borderWidth), e.radius = i.radius + i.hoverRadius
					}, _resolveElementOptions: function (t, e) {
						var i, n, r, a = this.chart, s = a.data.datasets[this.index], l = t.custom || {}, c = a.options.elements.point, u = o.options.resolve, h = s.data[e], d = {}, p = {chart: a, dataIndex: e, dataset: s, datasetIndex: this.index},
							f = ["backgroundColor", "borderColor", "borderWidth", "hoverBackgroundColor", "hoverBorderColor", "hoverBorderWidth", "hoverRadius", "hitRadius", "pointStyle", "rotation"];
						for (i = 0, n = f.length; i < n; ++i) d[r = f[i]] = u([l[r], s[r], c[r]], p, e);
						return d.radius = u([l.radius, h ? h.r : void 0, s.radius, c.radius], p, e), d
					}
				})
			}
		}, {26: 26, 41: 41, 46: 46}], 17: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(41), o = t(46);
			n._set("doughnut", {
				animation: {animateRotate: !0, animateScale: !1}, hover: {mode: "single"}, legendCallback: function (t) {
					var e = [];
					e.push('<ul class="' + t.id + '-legend">');
					var i = t.data, n = i.datasets, r = i.labels;
					if (n.length) for (var o = 0; o < n[0].data.length; ++o) e.push('<li><span style="background-color:' + n[0].backgroundColor[o] + '"></span>'), r[o] && e.push(r[o]), e.push("</li>");
					return e.push("</ul>"), e.join("")
				}, legend: {
					labels: {
						generateLabels: function (t) {
							var e = t.data;
							return e.labels.length && e.datasets.length ? e.labels.map(function (i, n) {
								var r = t.getDatasetMeta(0), a = e.datasets[0], s = r.data[n], l = s && s.custom || {}, c = o.valueAtIndexOrDefault, u = t.options.elements.arc;
								return {
									text: i,
									fillStyle: l.backgroundColor ? l.backgroundColor : c(a.backgroundColor, n, u.backgroundColor),
									strokeStyle: l.borderColor ? l.borderColor : c(a.borderColor, n, u.borderColor),
									lineWidth: l.borderWidth ? l.borderWidth : c(a.borderWidth, n, u.borderWidth),
									hidden: isNaN(a.data[n]) || r.data[n].hidden,
									index: n
								}
							}) : []
						}
					}, onClick: function (t, e) {
						var i, n, r, o = e.index, a = this.chart;
						for (i = 0, n = (a.data.datasets || []).length; i < n; ++i) (r = a.getDatasetMeta(i)).data[o] && (r.data[o].hidden = !r.data[o].hidden);
						a.update()
					}
				}, cutoutPercentage: 50, rotation: -.5 * Math.PI, circumference: 2 * Math.PI, tooltips: {
					callbacks: {
						title: function () {
							return ""
						}, label: function (t, e) {
							var i = e.labels[t.index], n = ": " + e.datasets[t.datasetIndex].data[t.index];
							return o.isArray(i) ? (i = i.slice())[0] += n : i += n, i
						}
					}
				}
			}), n._set("pie", o.clone(n.doughnut)), n._set("pie", {cutoutPercentage: 0}), e.exports = function (t) {
				t.controllers.doughnut = t.controllers.pie = t.DatasetController.extend({
					dataElementType: r.Arc, linkScales: o.noop, getRingIndex: function (t) {
						for (var e = 0, i = 0; i < t; ++i) this.chart.isDatasetVisible(i) && ++e;
						return e
					}, update: function (t) {
						var e = this, i = e.chart, n = i.chartArea, r = i.options, a = r.elements.arc, s = n.right - n.left - a.borderWidth, l = n.bottom - n.top - a.borderWidth, c = Math.min(s, l), u = {x: 0, y: 0}, h = e.getMeta(), d = r.cutoutPercentage, p = r.circumference;
						if (p < 2 * Math.PI) {
							var f = r.rotation % (2 * Math.PI), m = (f += 2 * Math.PI * (f >= Math.PI ? -1 : f < -Math.PI ? 1 : 0)) + p, g = {x: Math.cos(f), y: Math.sin(f)}, v = {x: Math.cos(m), y: Math.sin(m)}, y = f <= 0 && m >= 0 || f <= 2 * Math.PI && 2 * Math.PI <= m,
								b = f <= .5 * Math.PI && .5 * Math.PI <= m || f <= 2.5 * Math.PI && 2.5 * Math.PI <= m, w = f <= -Math.PI && -Math.PI <= m || f <= Math.PI && Math.PI <= m, x = f <= .5 * -Math.PI && .5 * -Math.PI <= m || f <= 1.5 * Math.PI && 1.5 * Math.PI <= m, k = d / 100,
								_ = {x: w ? -1 : Math.min(g.x * (g.x < 0 ? 1 : k), v.x * (v.x < 0 ? 1 : k)), y: x ? -1 : Math.min(g.y * (g.y < 0 ? 1 : k), v.y * (v.y < 0 ? 1 : k))},
								S = {x: y ? 1 : Math.max(g.x * (g.x > 0 ? 1 : k), v.x * (v.x > 0 ? 1 : k)), y: b ? 1 : Math.max(g.y * (g.y > 0 ? 1 : k), v.y * (v.y > 0 ? 1 : k))}, C = {width: .5 * (S.x - _.x), height: .5 * (S.y - _.y)};
							c = Math.min(s / C.width, l / C.height), u = {x: -.5 * (S.x + _.x), y: -.5 * (S.y + _.y)}
						}
						i.borderWidth = e.getMaxBorderWidth(h.data), i.outerRadius = Math.max((c - i.borderWidth) / 2, 0), i.innerRadius = Math.max(d ? i.outerRadius / 100 * d : 0, 0), i.radiusLength = (i.outerRadius - i.innerRadius) / i.getVisibleDatasetCount(), i.offsetX = u.x * i.outerRadius, i.offsetY = u.y * i.outerRadius, h.total = e.calculateTotal(), e.outerRadius = i.outerRadius - i.radiusLength * e.getRingIndex(e.index), e.innerRadius = Math.max(e.outerRadius - i.radiusLength, 0), o.each(h.data, function (i, n) {
							e.updateElement(i, n, t)
						})
					}, updateElement: function (t, e, i) {
						var n = this, r = n.chart, a = r.chartArea, s = r.options, l = s.animation, c = (a.left + a.right) / 2, u = (a.top + a.bottom) / 2, h = s.rotation, d = s.rotation, p = n.getDataset(),
							f = i && l.animateRotate ? 0 : t.hidden ? 0 : n.calculateCircumference(p.data[e]) * (s.circumference / (2 * Math.PI)), m = i && l.animateScale ? 0 : n.innerRadius, g = i && l.animateScale ? 0 : n.outerRadius, v = o.valueAtIndexOrDefault;
						o.extend(t, {_datasetIndex: n.index, _index: e, _model: {x: c + r.offsetX, y: u + r.offsetY, startAngle: h, endAngle: d, circumference: f, outerRadius: g, innerRadius: m, label: v(p.label, e, r.data.labels[e])}});
						var y = t._model, b = t.custom || {}, w = o.valueAtIndexOrDefault, x = this.chart.options.elements.arc;
						y.backgroundColor = b.backgroundColor ? b.backgroundColor : w(p.backgroundColor, e, x.backgroundColor), y.borderColor = b.borderColor ? b.borderColor : w(p.borderColor, e, x.borderColor), y.borderWidth = b.borderWidth ? b.borderWidth : w(p.borderWidth, e, x.borderWidth), i && l.animateRotate || (y.startAngle = 0 === e ? s.rotation : n.getMeta().data[e - 1]._model.endAngle, y.endAngle = y.startAngle + y.circumference), t.pivot()
					}, calculateTotal: function () {
						var t, e = this.getDataset(), i = this.getMeta(), n = 0;
						return o.each(i.data, function (i, r) {
							t = e.data[r], isNaN(t) || i.hidden || (n += Math.abs(t))
						}), n
					}, calculateCircumference: function (t) {
						var e = this.getMeta().total;
						return e > 0 && !isNaN(t) ? 2 * Math.PI * (Math.abs(t) / e) : 0
					}, getMaxBorderWidth: function (t) {
						for (var e, i, n = 0, r = this.index, o = t.length, a = 0; a < o; a++) e = t[a]._model ? t[a]._model.borderWidth : 0, n = (i = t[a]._chart ? t[a]._chart.config.data.datasets[r].hoverBorderWidth : 0) > (n = e > n ? e : n) ? i : n;
						return n
					}
				})
			}
		}, {26: 26, 41: 41, 46: 46}], 18: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(41), o = t(46);
			n._set("line", {showLines: !0, spanGaps: !1, hover: {mode: "label"}, scales: {xAxes: [{type: "category", id: "x-axis-0"}], yAxes: [{type: "linear", id: "y-axis-0"}]}}), e.exports = function (t) {
				function e(t, e) {
					return o.valueOrDefault(t.showLine, e.showLines)
				}

				t.controllers.line = t.DatasetController.extend({
					datasetElementType: r.Line, dataElementType: r.Point, update: function (t) {
						var i, n, r, a = this, s = a.getMeta(), l = s.dataset, c = s.data || [], u = a.chart.options, h = u.elements.line, d = a.getScaleForId(s.yAxisID), p = a.getDataset(), f = e(p, u);
						for (f && (r = l.custom || {}, void 0 !== p.tension && void 0 === p.lineTension && (p.lineTension = p.tension), l._scale = d, l._datasetIndex = a.index, l._children = c, l._model = {
							spanGaps: p.spanGaps ? p.spanGaps : u.spanGaps,
							tension: r.tension ? r.tension : o.valueOrDefault(p.lineTension, h.tension),
							backgroundColor: r.backgroundColor ? r.backgroundColor : p.backgroundColor || h.backgroundColor,
							borderWidth: r.borderWidth ? r.borderWidth : p.borderWidth || h.borderWidth,
							borderColor: r.borderColor ? r.borderColor : p.borderColor || h.borderColor,
							borderCapStyle: r.borderCapStyle ? r.borderCapStyle : p.borderCapStyle || h.borderCapStyle,
							borderDash: r.borderDash ? r.borderDash : p.borderDash || h.borderDash,
							borderDashOffset: r.borderDashOffset ? r.borderDashOffset : p.borderDashOffset || h.borderDashOffset,
							borderJoinStyle: r.borderJoinStyle ? r.borderJoinStyle : p.borderJoinStyle || h.borderJoinStyle,
							fill: r.fill ? r.fill : void 0 !== p.fill ? p.fill : h.fill,
							steppedLine: r.steppedLine ? r.steppedLine : o.valueOrDefault(p.steppedLine, h.stepped),
							cubicInterpolationMode: r.cubicInterpolationMode ? r.cubicInterpolationMode : o.valueOrDefault(p.cubicInterpolationMode, h.cubicInterpolationMode)
						}, l.pivot()), i = 0, n = c.length; i < n; ++i) a.updateElement(c[i], i, t);
						for (f && 0 !== l._model.tension && a.updateBezierControlPoints(), i = 0, n = c.length; i < n; ++i) c[i].pivot()
					}, getPointBackgroundColor: function (t, e) {
						var i = this.chart.options.elements.point.backgroundColor, n = this.getDataset(), r = t.custom || {};
						return r.backgroundColor ? i = r.backgroundColor : n.pointBackgroundColor ? i = o.valueAtIndexOrDefault(n.pointBackgroundColor, e, i) : n.backgroundColor && (i = n.backgroundColor), i
					}, getPointBorderColor: function (t, e) {
						var i = this.chart.options.elements.point.borderColor, n = this.getDataset(), r = t.custom || {};
						return r.borderColor ? i = r.borderColor : n.pointBorderColor ? i = o.valueAtIndexOrDefault(n.pointBorderColor, e, i) : n.borderColor && (i = n.borderColor), i
					}, getPointBorderWidth: function (t, e) {
						var i = this.chart.options.elements.point.borderWidth, n = this.getDataset(), r = t.custom || {};
						return isNaN(r.borderWidth) ? !isNaN(n.pointBorderWidth) || o.isArray(n.pointBorderWidth) ? i = o.valueAtIndexOrDefault(n.pointBorderWidth, e, i) : isNaN(n.borderWidth) || (i = n.borderWidth) : i = r.borderWidth, i
					}, getPointRotation: function (t, e) {
						var i = this.chart.options.elements.point.rotation, n = this.getDataset(), r = t.custom || {};
						return isNaN(r.rotation) ? isNaN(n.pointRotation) && !o.isArray(n.pointRotation) || (i = o.valueAtIndexOrDefault(n.pointRotation, e, i)) : i = r.rotation, i
					}, updateElement: function (t, e, i) {
						var n, r, a = this, s = a.getMeta(), l = t.custom || {}, c = a.getDataset(), u = a.index, h = c.data[e], d = a.getScaleForId(s.yAxisID), p = a.getScaleForId(s.xAxisID), f = a.chart.options.elements.point;
						void 0 !== c.radius && void 0 === c.pointRadius && (c.pointRadius = c.radius), void 0 !== c.hitRadius && void 0 === c.pointHitRadius && (c.pointHitRadius = c.hitRadius), n = p.getPixelForValue("object" == typeof h ? h : NaN, e, u), r = i ? d.getBasePixel() : a.calculatePointY(h, e, u), t._xScale = p, t._yScale = d, t._datasetIndex = u, t._index = e, t._model = {
							x: n,
							y: r,
							skip: l.skip || isNaN(n) || isNaN(r),
							radius: l.radius || o.valueAtIndexOrDefault(c.pointRadius, e, f.radius),
							pointStyle: l.pointStyle || o.valueAtIndexOrDefault(c.pointStyle, e, f.pointStyle),
							rotation: a.getPointRotation(t, e),
							backgroundColor: a.getPointBackgroundColor(t, e),
							borderColor: a.getPointBorderColor(t, e),
							borderWidth: a.getPointBorderWidth(t, e),
							tension: s.dataset._model ? s.dataset._model.tension : 0,
							steppedLine: !!s.dataset._model && s.dataset._model.steppedLine,
							hitRadius: l.hitRadius || o.valueAtIndexOrDefault(c.pointHitRadius, e, f.hitRadius)
						}
					}, calculatePointY: function (t, e, i) {
						var n, r, o, a = this.chart, s = this.getMeta(), l = this.getScaleForId(s.yAxisID), c = 0, u = 0;
						if (l.options.stacked) {
							for (n = 0; n < i; n++) if (r = a.data.datasets[n], "line" === (o = a.getDatasetMeta(n)).type && o.yAxisID === l.id && a.isDatasetVisible(n)) {
								var h = Number(l.getRightValue(r.data[e]));
								h < 0 ? u += h || 0 : c += h || 0
							}
							var d = Number(l.getRightValue(t));
							return d < 0 ? l.getPixelForValue(u + d) : l.getPixelForValue(c + d)
						}
						return l.getPixelForValue(t)
					}, updateBezierControlPoints: function () {
						var t, e, i, n, r = this.getMeta(), a = this.chart.chartArea, s = r.data || [];

						function l(t, e, i) {
							return Math.max(Math.min(t, i), e)
						}

						if (r.dataset._model.spanGaps && (s = s.filter(function (t) {
							return !t._model.skip
						})), "monotone" === r.dataset._model.cubicInterpolationMode) o.splineCurveMonotone(s); else for (t = 0, e = s.length; t < e; ++t) i = s[t]._model, n = o.splineCurve(o.previousItem(s, t)._model, i, o.nextItem(s, t)._model, r.dataset._model.tension), i.controlPointPreviousX = n.previous.x, i.controlPointPreviousY = n.previous.y, i.controlPointNextX = n.next.x, i.controlPointNextY = n.next.y;
						if (this.chart.options.elements.line.capBezierPoints) for (t = 0, e = s.length; t < e; ++t) (i = s[t]._model).controlPointPreviousX = l(i.controlPointPreviousX, a.left, a.right), i.controlPointPreviousY = l(i.controlPointPreviousY, a.top, a.bottom), i.controlPointNextX = l(i.controlPointNextX, a.left, a.right), i.controlPointNextY = l(i.controlPointNextY, a.top, a.bottom)
					}, draw: function () {
						var t, i = this.chart, n = this.getMeta(), r = n.data || [], a = i.chartArea, s = r.length, l = 0;
						for (e(this.getDataset(), i.options) && (t = (n.dataset._model.borderWidth || 0) / 2, o.canvas.clipArea(i.ctx, {left: a.left, right: a.right, top: a.top - t, bottom: a.bottom + t}), n.dataset.draw(), o.canvas.unclipArea(i.ctx)); l < s; ++l) r[l].draw(a)
					}, setHoverStyle: function (t) {
						var e = this.chart.data.datasets[t._datasetIndex], i = t._index, n = t.custom || {}, r = t._model;
						t.$previousStyle = {
							backgroundColor: r.backgroundColor,
							borderColor: r.borderColor,
							borderWidth: r.borderWidth,
							radius: r.radius
						}, r.backgroundColor = n.hoverBackgroundColor || o.valueAtIndexOrDefault(e.pointHoverBackgroundColor, i, o.getHoverColor(r.backgroundColor)), r.borderColor = n.hoverBorderColor || o.valueAtIndexOrDefault(e.pointHoverBorderColor, i, o.getHoverColor(r.borderColor)), r.borderWidth = n.hoverBorderWidth || o.valueAtIndexOrDefault(e.pointHoverBorderWidth, i, r.borderWidth), r.radius = n.hoverRadius || o.valueAtIndexOrDefault(e.pointHoverRadius, i, this.chart.options.elements.point.hoverRadius)
					}
				})
			}
		}, {26: 26, 41: 41, 46: 46}], 19: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(41), o = t(46);
			n._set("polarArea", {
				scale: {type: "radialLinear", angleLines: {display: !1}, gridLines: {circular: !0}, pointLabels: {display: !1}, ticks: {beginAtZero: !0}}, animation: {animateRotate: !0, animateScale: !0}, startAngle: -.5 * Math.PI, legendCallback: function (t) {
					var e = [];
					e.push('<ul class="' + t.id + '-legend">');
					var i = t.data, n = i.datasets, r = i.labels;
					if (n.length) for (var o = 0; o < n[0].data.length; ++o) e.push('<li><span style="background-color:' + n[0].backgroundColor[o] + '"></span>'), r[o] && e.push(r[o]), e.push("</li>");
					return e.push("</ul>"), e.join("")
				}, legend: {
					labels: {
						generateLabels: function (t) {
							var e = t.data;
							return e.labels.length && e.datasets.length ? e.labels.map(function (i, n) {
								var r = t.getDatasetMeta(0), a = e.datasets[0], s = r.data[n].custom || {}, l = o.valueAtIndexOrDefault, c = t.options.elements.arc;
								return {
									text: i,
									fillStyle: s.backgroundColor ? s.backgroundColor : l(a.backgroundColor, n, c.backgroundColor),
									strokeStyle: s.borderColor ? s.borderColor : l(a.borderColor, n, c.borderColor),
									lineWidth: s.borderWidth ? s.borderWidth : l(a.borderWidth, n, c.borderWidth),
									hidden: isNaN(a.data[n]) || r.data[n].hidden,
									index: n
								}
							}) : []
						}
					}, onClick: function (t, e) {
						var i, n, r, o = e.index, a = this.chart;
						for (i = 0, n = (a.data.datasets || []).length; i < n; ++i) (r = a.getDatasetMeta(i)).data[o].hidden = !r.data[o].hidden;
						a.update()
					}
				}, tooltips: {
					callbacks: {
						title: function () {
							return ""
						}, label: function (t, e) {
							return e.labels[t.index] + ": " + t.yLabel
						}
					}
				}
			}), e.exports = function (t) {
				t.controllers.polarArea = t.DatasetController.extend({
					dataElementType: r.Arc, linkScales: o.noop, update: function (t) {
						var e, i, n, r = this, a = r.getDataset(), s = r.getMeta(), l = r.chart.options.startAngle || 0, c = r._starts = [], u = r._angles = [];
						for (r._updateRadius(), s.count = r.countVisibleElements(), e = 0, i = a.data.length; e < i; e++) c[e] = l, n = r._computeAngle(e), u[e] = n, l += n;
						o.each(s.data, function (e, i) {
							r.updateElement(e, i, t)
						})
					}, _updateRadius: function () {
						var t = this, e = t.chart, i = e.chartArea, n = e.options, r = n.elements.arc, o = Math.min(i.right - i.left, i.bottom - i.top);
						e.outerRadius = Math.max((o - r.borderWidth / 2) / 2, 0), e.innerRadius = Math.max(n.cutoutPercentage ? e.outerRadius / 100 * n.cutoutPercentage : 1, 0), e.radiusLength = (e.outerRadius - e.innerRadius) / e.getVisibleDatasetCount(), t.outerRadius = e.outerRadius - e.radiusLength * t.index, t.innerRadius = t.outerRadius - e.radiusLength
					}, updateElement: function (t, e, i) {
						var n = this, r = n.chart, a = n.getDataset(), s = r.options, l = s.animation, c = r.scale, u = r.data.labels, h = c.xCenter, d = c.yCenter, p = s.startAngle, f = t.hidden ? 0 : c.getDistanceFromCenterForValue(a.data[e]), m = n._starts[e], g = m + (t.hidden ? 0 : n._angles[e]),
							v = l.animateScale ? 0 : c.getDistanceFromCenterForValue(a.data[e]);
						o.extend(t, {_datasetIndex: n.index, _index: e, _scale: c, _model: {x: h, y: d, innerRadius: 0, outerRadius: i ? v : f, startAngle: i && l.animateRotate ? p : m, endAngle: i && l.animateRotate ? p : g, label: o.valueAtIndexOrDefault(u, e, u[e])}});
						var y = this.chart.options.elements.arc, b = t.custom || {}, w = o.valueAtIndexOrDefault, x = t._model;
						x.backgroundColor = b.backgroundColor ? b.backgroundColor : w(a.backgroundColor, e, y.backgroundColor), x.borderColor = b.borderColor ? b.borderColor : w(a.borderColor, e, y.borderColor), x.borderWidth = b.borderWidth ? b.borderWidth : w(a.borderWidth, e, y.borderWidth), t.pivot()
					}, countVisibleElements: function () {
						var t = this.getDataset(), e = this.getMeta(), i = 0;
						return o.each(e.data, function (e, n) {
							isNaN(t.data[n]) || e.hidden || i++
						}), i
					}, _computeAngle: function (t) {
						var e = this, i = this.getMeta().count, n = e.getDataset(), r = e.getMeta();
						if (isNaN(n.data[t]) || r.data[t].hidden) return 0;
						var a = {chart: e.chart, dataIndex: t, dataset: n, datasetIndex: e.index};
						return o.options.resolve([e.chart.options.elements.arc.angle, 2 * Math.PI / i], a, t)
					}
				})
			}
		}, {26: 26, 41: 41, 46: 46}], 20: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(41), o = t(46);
			n._set("radar", {scale: {type: "radialLinear"}, elements: {line: {tension: 0}}}), e.exports = function (t) {
				t.controllers.radar = t.DatasetController.extend({
					datasetElementType: r.Line, dataElementType: r.Point, linkScales: o.noop, update: function (t) {
						var e = this, i = e.getMeta(), n = i.dataset, r = i.data, a = n.custom || {}, s = e.getDataset(), l = e.chart.options.elements.line, c = e.chart.scale;
						void 0 !== s.tension && void 0 === s.lineTension && (s.lineTension = s.tension), o.extend(i.dataset, {
							_datasetIndex: e.index,
							_scale: c,
							_children: r,
							_loop: !0,
							_model: {
								tension: a.tension ? a.tension : o.valueOrDefault(s.lineTension, l.tension),
								backgroundColor: a.backgroundColor ? a.backgroundColor : s.backgroundColor || l.backgroundColor,
								borderWidth: a.borderWidth ? a.borderWidth : s.borderWidth || l.borderWidth,
								borderColor: a.borderColor ? a.borderColor : s.borderColor || l.borderColor,
								fill: a.fill ? a.fill : void 0 !== s.fill ? s.fill : l.fill,
								borderCapStyle: a.borderCapStyle ? a.borderCapStyle : s.borderCapStyle || l.borderCapStyle,
								borderDash: a.borderDash ? a.borderDash : s.borderDash || l.borderDash,
								borderDashOffset: a.borderDashOffset ? a.borderDashOffset : s.borderDashOffset || l.borderDashOffset,
								borderJoinStyle: a.borderJoinStyle ? a.borderJoinStyle : s.borderJoinStyle || l.borderJoinStyle
							}
						}), i.dataset.pivot(), o.each(r, function (i, n) {
							e.updateElement(i, n, t)
						}, e), e.updateBezierControlPoints()
					}, updateElement: function (t, e, i) {
						var n = this, r = t.custom || {}, a = n.getDataset(), s = n.chart.scale, l = n.chart.options.elements.point, c = s.getPointPositionForValue(e, a.data[e]);
						void 0 !== a.radius && void 0 === a.pointRadius && (a.pointRadius = a.radius), void 0 !== a.hitRadius && void 0 === a.pointHitRadius && (a.pointHitRadius = a.hitRadius), o.extend(t, {
							_datasetIndex: n.index,
							_index: e,
							_scale: s,
							_model: {
								x: i ? s.xCenter : c.x,
								y: i ? s.yCenter : c.y,
								tension: r.tension ? r.tension : o.valueOrDefault(a.lineTension, n.chart.options.elements.line.tension),
								radius: r.radius ? r.radius : o.valueAtIndexOrDefault(a.pointRadius, e, l.radius),
								backgroundColor: r.backgroundColor ? r.backgroundColor : o.valueAtIndexOrDefault(a.pointBackgroundColor, e, l.backgroundColor),
								borderColor: r.borderColor ? r.borderColor : o.valueAtIndexOrDefault(a.pointBorderColor, e, l.borderColor),
								borderWidth: r.borderWidth ? r.borderWidth : o.valueAtIndexOrDefault(a.pointBorderWidth, e, l.borderWidth),
								pointStyle: r.pointStyle ? r.pointStyle : o.valueAtIndexOrDefault(a.pointStyle, e, l.pointStyle),
								rotation: r.rotation ? r.rotation : o.valueAtIndexOrDefault(a.pointRotation, e, l.rotation),
								hitRadius: r.hitRadius ? r.hitRadius : o.valueAtIndexOrDefault(a.pointHitRadius, e, l.hitRadius)
							}
						}), t._model.skip = r.skip ? r.skip : isNaN(t._model.x) || isNaN(t._model.y)
					}, updateBezierControlPoints: function () {
						var t = this.chart.chartArea, e = this.getMeta();
						o.each(e.data, function (i, n) {
							var r = i._model, a = o.splineCurve(o.previousItem(e.data, n, !0)._model, r, o.nextItem(e.data, n, !0)._model, r.tension);
							r.controlPointPreviousX = Math.max(Math.min(a.previous.x, t.right), t.left), r.controlPointPreviousY = Math.max(Math.min(a.previous.y, t.bottom), t.top), r.controlPointNextX = Math.max(Math.min(a.next.x, t.right), t.left), r.controlPointNextY = Math.max(Math.min(a.next.y, t.bottom), t.top), i.pivot()
						})
					}, setHoverStyle: function (t) {
						var e = this.chart.data.datasets[t._datasetIndex], i = t.custom || {}, n = t._index, r = t._model;
						t.$previousStyle = {
							backgroundColor: r.backgroundColor,
							borderColor: r.borderColor,
							borderWidth: r.borderWidth,
							radius: r.radius
						}, r.radius = i.hoverRadius ? i.hoverRadius : o.valueAtIndexOrDefault(e.pointHoverRadius, n, this.chart.options.elements.point.hoverRadius), r.backgroundColor = i.hoverBackgroundColor ? i.hoverBackgroundColor : o.valueAtIndexOrDefault(e.pointHoverBackgroundColor, n, o.getHoverColor(r.backgroundColor)), r.borderColor = i.hoverBorderColor ? i.hoverBorderColor : o.valueAtIndexOrDefault(e.pointHoverBorderColor, n, o.getHoverColor(r.borderColor)), r.borderWidth = i.hoverBorderWidth ? i.hoverBorderWidth : o.valueAtIndexOrDefault(e.pointHoverBorderWidth, n, r.borderWidth)
					}
				})
			}
		}, {26: 26, 41: 41, 46: 46}], 21: [function (t, e, i) {
			"use strict";
			t(26)._set("scatter", {
				hover: {mode: "single"}, scales: {xAxes: [{id: "x-axis-1", type: "linear", position: "bottom"}], yAxes: [{id: "y-axis-1", type: "linear", position: "left"}]}, showLines: !1, tooltips: {
					callbacks: {
						title: function () {
							return ""
						}, label: function (t) {
							return "(" + t.xLabel + ", " + t.yLabel + ")"
						}
					}
				}
			}), e.exports = function (t) {
				t.controllers.scatter = t.controllers.line
			}
		}, {26: 26}], 22: [function (t, e, i) {
			"use strict";
			var n = t(27);
			i = e.exports = n.extend({chart: null, currentStep: 0, numSteps: 60, easing: "", render: null, onAnimationProgress: null, onAnimationComplete: null});
			Object.defineProperty(i.prototype, "animationObject", {
				get: function () {
					return this
				}
			}), Object.defineProperty(i.prototype, "chartInstance", {
				get: function () {
					return this.chart
				}, set: function (t) {
					this.chart = t
				}
			})
		}, {27: 27}], 23: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(46);
			n._set("global", {animation: {duration: 1e3, easing: "easeOutQuart", onProgress: r.noop, onComplete: r.noop}}), e.exports = {
				frameDuration: 17, animations: [], dropFrames: 0, request: null, addAnimation: function (t, e, i, n) {
					var r, o, a = this.animations;
					for (e.chart = t, n || (t.animating = !0), r = 0, o = a.length; r < o; ++r) if (a[r].chart === t) return void (a[r] = e);
					a.push(e), 1 === a.length && this.requestAnimationFrame()
				}, cancelAnimation: function (t) {
					var e = r.findIndex(this.animations, function (e) {
						return e.chart === t
					});
					-1 !== e && (this.animations.splice(e, 1), t.animating = !1)
				}, requestAnimationFrame: function () {
					var t = this;
					null === t.request && (t.request = r.requestAnimFrame.call(window, function () {
						t.request = null, t.startDigest()
					}))
				}, startDigest: function () {
					var t = this, e = Date.now(), i = 0;
					t.dropFrames > 1 && (i = Math.floor(t.dropFrames), t.dropFrames = t.dropFrames % 1), t.advance(1 + i);
					var n = Date.now();
					t.dropFrames += (n - e) / t.frameDuration, t.animations.length > 0 && t.requestAnimationFrame()
				}, advance: function (t) {
					for (var e, i, n = this.animations, o = 0; o < n.length;) i = (e = n[o]).chart, e.currentStep = (e.currentStep || 0) + t, e.currentStep = Math.min(e.currentStep, e.numSteps), r.callback(e.render, [i, e], i), r.callback(e.onAnimationProgress, [e], i), e.currentStep >= e.numSteps ? (r.callback(e.onAnimationComplete, [e], i), i.animating = !1, n.splice(o, 1)) : ++o
				}
			}
		}, {26: 26, 46: 46}], 24: [function (t, e, i) {
			"use strict";
			var n = t(22), r = t(23), o = t(26), a = t(46), s = t(29), l = t(31), c = t(49), u = t(32), h = t(34), d = t(36);
			e.exports = function (t) {
				function e(t) {
					return "top" === t || "bottom" === t
				}

				t.types = {}, t.instances = {}, t.controllers = {}, a.extend(t.prototype, {
					construct: function (e, i) {
						var n = this;
						i = function (t) {
							var e = (t = t || {}).data = t.data || {};
							return e.datasets = e.datasets || [], e.labels = e.labels || [], t.options = a.configMerge(o.global, o[t.type], t.options || {}), t
						}(i);
						var r = c.acquireContext(e, i), s = r && r.canvas, l = s && s.height, u = s && s.width;
						n.id = a.uid(), n.ctx = r, n.canvas = s, n.config = i, n.width = u, n.height = l, n.aspectRatio = l ? u / l : null, n.options = i.options, n._bufferedRender = !1, n.chart = n, n.controller = n, t.instances[n.id] = n, Object.defineProperty(n, "data", {
							get: function () {
								return n.config.data
							}, set: function (t) {
								n.config.data = t
							}
						}), r && s ? (n.initialize(), n.update()) : console.error("Failed to create chart: can't acquire context from the given item")
					}, initialize: function () {
						var t = this;
						return u.notify(t, "beforeInit"), a.retinaScale(t, t.options.devicePixelRatio), t.bindEvents(), t.options.responsive && t.resize(!0), t.ensureScalesHaveIDs(), t.buildOrUpdateScales(), t.initToolTip(), u.notify(t, "afterInit"), t
					}, clear: function () {
						return a.canvas.clear(this), this
					}, stop: function () {
						return r.cancelAnimation(this), this
					}, resize: function (t) {
						var e = this, i = e.options, n = e.canvas, r = i.maintainAspectRatio && e.aspectRatio || null, o = Math.max(0, Math.floor(a.getMaximumWidth(n))), s = Math.max(0, Math.floor(r ? o / r : a.getMaximumHeight(n)));
						if ((e.width !== o || e.height !== s) && (n.width = e.width = o, n.height = e.height = s, n.style.width = o + "px", n.style.height = s + "px", a.retinaScale(e, i.devicePixelRatio), !t)) {
							var l = {width: o, height: s};
							u.notify(e, "resize", [l]), e.options.onResize && e.options.onResize(e, l), e.stop(), e.update({duration: e.options.responsiveAnimationDuration})
						}
					}, ensureScalesHaveIDs: function () {
						var t = this.options, e = t.scales || {}, i = t.scale;
						a.each(e.xAxes, function (t, e) {
							t.id = t.id || "x-axis-" + e
						}), a.each(e.yAxes, function (t, e) {
							t.id = t.id || "y-axis-" + e
						}), i && (i.id = i.id || "scale")
					}, buildOrUpdateScales: function () {
						var t = this, i = t.options, n = t.scales || {}, r = [], o = Object.keys(n).reduce(function (t, e) {
							return t[e] = !1, t
						}, {});
						i.scales && (r = r.concat((i.scales.xAxes || []).map(function (t) {
							return {options: t, dtype: "category", dposition: "bottom"}
						}), (i.scales.yAxes || []).map(function (t) {
							return {options: t, dtype: "linear", dposition: "left"}
						}))), i.scale && r.push({options: i.scale, dtype: "radialLinear", isDefault: !0, dposition: "chartArea"}), a.each(r, function (i) {
							var r = i.options, s = r.id, l = a.valueOrDefault(r.type, i.dtype);
							e(r.position) !== e(i.dposition) && (r.position = i.dposition), o[s] = !0;
							var c = null;
							if (s in n && n[s].type === l) (c = n[s]).options = r, c.ctx = t.ctx, c.chart = t; else {
								var u = h.getScaleConstructor(l);
								if (!u) return;
								c = new u({id: s, type: l, options: r, ctx: t.ctx, chart: t}), n[c.id] = c
							}
							c.mergeTicksOptions(), i.isDefault && (t.scale = c)
						}), a.each(o, function (t, e) {
							t || delete n[e]
						}), t.scales = n, h.addScalesToLayout(this)
					}, buildOrUpdateControllers: function () {
						var e = this, i = [], n = [];
						return a.each(e.data.datasets, function (r, o) {
							var a = e.getDatasetMeta(o), s = r.type || e.config.type;
							if (a.type && a.type !== s && (e.destroyDatasetMeta(o), a = e.getDatasetMeta(o)), a.type = s, i.push(a.type), a.controller) a.controller.updateIndex(o), a.controller.linkScales(); else {
								var l = t.controllers[a.type];
								if (void 0 === l) throw new Error('"' + a.type + '" is not a chart type.');
								a.controller = new l(e, o), n.push(a.controller)
							}
						}, e), n
					}, resetElements: function () {
						var t = this;
						a.each(t.data.datasets, function (e, i) {
							t.getDatasetMeta(i).controller.reset()
						}, t)
					}, reset: function () {
						this.resetElements(), this.tooltip.initialize()
					}, update: function (e) {
						var i, n, r = this;
						if (e && "object" == typeof e || (e = {duration: e, lazy: arguments[1]}), n = (i = r).options, a.each(i.scales, function (t) {
							l.removeBox(i, t)
						}), n = a.configMerge(t.defaults.global, t.defaults[i.config.type], n), i.options = i.config.options = n, i.ensureScalesHaveIDs(), i.buildOrUpdateScales(), i.tooltip._options = n.tooltips, i.tooltip.initialize(), u._invalidate(r), !1 !== u.notify(r, "beforeUpdate")) {
							r.tooltip._data = r.data;
							var o = r.buildOrUpdateControllers();
							a.each(r.data.datasets, function (t, e) {
								r.getDatasetMeta(e).controller.buildOrUpdateElements()
							}, r), r.updateLayout(), r.options.animation && r.options.animation.duration && a.each(o, function (t) {
								t.reset()
							}), r.updateDatasets(), r.tooltip.initialize(), r.lastActive = [], u.notify(r, "afterUpdate"), r._bufferedRender ? r._bufferedRequest = {duration: e.duration, easing: e.easing, lazy: e.lazy} : r.render(e)
						}
					}, updateLayout: function () {
						!1 !== u.notify(this, "beforeLayout") && (l.update(this, this.width, this.height), u.notify(this, "afterScaleUpdate"), u.notify(this, "afterLayout"))
					}, updateDatasets: function () {
						if (!1 !== u.notify(this, "beforeDatasetsUpdate")) {
							for (var t = 0, e = this.data.datasets.length; t < e; ++t) this.updateDataset(t);
							u.notify(this, "afterDatasetsUpdate")
						}
					}, updateDataset: function (t) {
						var e = this.getDatasetMeta(t), i = {meta: e, index: t};
						!1 !== u.notify(this, "beforeDatasetUpdate", [i]) && (e.controller.update(), u.notify(this, "afterDatasetUpdate", [i]))
					}, render: function (t) {
						var e = this;
						t && "object" == typeof t || (t = {duration: t, lazy: arguments[1]});
						var i = t.duration, o = t.lazy;
						if (!1 !== u.notify(e, "beforeRender")) {
							var s = e.options.animation, l = function (t) {
								u.notify(e, "afterRender"), a.callback(s && s.onComplete, [t], e)
							};
							if (s && (void 0 !== i && 0 !== i || void 0 === i && 0 !== s.duration)) {
								var c = new n({
									numSteps: (i || s.duration) / 16.66, easing: t.easing || s.easing, render: function (t, e) {
										var i = a.easing.effects[e.easing], n = e.currentStep, r = n / e.numSteps;
										t.draw(i(r), r, n)
									}, onAnimationProgress: s.onProgress, onAnimationComplete: l
								});
								r.addAnimation(e, c, i, o)
							} else e.draw(), l(new n({numSteps: 0, chart: e}));
							return e
						}
					}, draw: function (t) {
						var e = this;
						e.clear(), a.isNullOrUndef(t) && (t = 1), e.transition(t), e.width <= 0 || e.height <= 0 || !1 !== u.notify(e, "beforeDraw", [t]) && (a.each(e.boxes, function (t) {
							t.draw(e.chartArea)
						}, e), e.scale && e.scale.draw(), e.drawDatasets(t), e._drawTooltip(t), u.notify(e, "afterDraw", [t]))
					}, transition: function (t) {
						for (var e = 0, i = (this.data.datasets || []).length; e < i; ++e) this.isDatasetVisible(e) && this.getDatasetMeta(e).controller.transition(t);
						this.tooltip.transition(t)
					}, drawDatasets: function (t) {
						var e = this;
						if (!1 !== u.notify(e, "beforeDatasetsDraw", [t])) {
							for (var i = (e.data.datasets || []).length - 1; i >= 0; --i) e.isDatasetVisible(i) && e.drawDataset(i, t);
							u.notify(e, "afterDatasetsDraw", [t])
						}
					}, drawDataset: function (t, e) {
						var i = this.getDatasetMeta(t), n = {meta: i, index: t, easingValue: e};
						!1 !== u.notify(this, "beforeDatasetDraw", [n]) && (i.controller.draw(e), u.notify(this, "afterDatasetDraw", [n]))
					}, _drawTooltip: function (t) {
						var e = this.tooltip, i = {tooltip: e, easingValue: t};
						!1 !== u.notify(this, "beforeTooltipDraw", [i]) && (e.draw(), u.notify(this, "afterTooltipDraw", [i]))
					}, getElementAtEvent: function (t) {
						return s.modes.single(this, t)
					}, getElementsAtEvent: function (t) {
						return s.modes.label(this, t, {intersect: !0})
					}, getElementsAtXAxis: function (t) {
						return s.modes["x-axis"](this, t, {intersect: !0})
					}, getElementsAtEventForMode: function (t, e, i) {
						var n = s.modes[e];
						return "function" == typeof n ? n(this, t, i) : []
					}, getDatasetAtEvent: function (t) {
						return s.modes.dataset(this, t, {intersect: !0})
					}, getDatasetMeta: function (t) {
						var e = this.data.datasets[t];
						e._meta || (e._meta = {});
						var i = e._meta[this.id];
						return i || (i = e._meta[this.id] = {type: null, data: [], dataset: null, controller: null, hidden: null, xAxisID: null, yAxisID: null}), i
					}, getVisibleDatasetCount: function () {
						for (var t = 0, e = 0, i = this.data.datasets.length; e < i; ++e) this.isDatasetVisible(e) && t++;
						return t
					}, isDatasetVisible: function (t) {
						var e = this.getDatasetMeta(t);
						return "boolean" == typeof e.hidden ? !e.hidden : !this.data.datasets[t].hidden
					}, generateLegend: function () {
						return this.options.legendCallback(this)
					}, destroyDatasetMeta: function (t) {
						var e = this.id, i = this.data.datasets[t], n = i._meta && i._meta[e];
						n && (n.controller.destroy(), delete i._meta[e])
					}, destroy: function () {
						var e, i, n = this, r = n.canvas;
						for (n.stop(), e = 0, i = n.data.datasets.length; e < i; ++e) n.destroyDatasetMeta(e);
						r && (n.unbindEvents(), a.canvas.clear(n), c.releaseContext(n.ctx), n.canvas = null, n.ctx = null), u.notify(n, "destroy"), delete t.instances[n.id]
					}, toBase64Image: function () {
						return this.canvas.toDataURL.apply(this.canvas, arguments)
					}, initToolTip: function () {
						var t = this;
						t.tooltip = new d({_chart: t, _chartInstance: t, _data: t.data, _options: t.options.tooltips}, t)
					}, bindEvents: function () {
						var t = this, e = t._listeners = {}, i = function () {
							t.eventHandler.apply(t, arguments)
						};
						a.each(t.options.events, function (n) {
							c.addEventListener(t, n, i), e[n] = i
						}), t.options.responsive && (i = function () {
							t.resize()
						}, c.addEventListener(t, "resize", i), e.resize = i)
					}, unbindEvents: function () {
						var t = this, e = t._listeners;
						e && (delete t._listeners, a.each(e, function (e, i) {
							c.removeEventListener(t, i, e)
						}))
					}, updateHoverStyle: function (t, e, i) {
						var n, r, o, a = i ? "setHoverStyle" : "removeHoverStyle";
						for (r = 0, o = t.length; r < o; ++r) (n = t[r]) && this.getDatasetMeta(n._datasetIndex).controller[a](n)
					}, eventHandler: function (t) {
						var e = this, i = e.tooltip;
						if (!1 !== u.notify(e, "beforeEvent", [t])) {
							e._bufferedRender = !0, e._bufferedRequest = null;
							var n = e.handleEvent(t);
							i && (n = i._start ? i.handleEvent(t) : n | i.handleEvent(t)), u.notify(e, "afterEvent", [t]);
							var r = e._bufferedRequest;
							return r ? e.render(r) : n && !e.animating && (e.stop(), e.render({duration: e.options.hover.animationDuration, lazy: !0})), e._bufferedRender = !1, e._bufferedRequest = null, e
						}
					}, handleEvent: function (t) {
						var e, i = this, n = i.options || {}, r = n.hover;
						return i.lastActive = i.lastActive || [], "mouseout" === t.type ? i.active = [] : i.active = i.getElementsAtEventForMode(t, r.mode, r), a.callback(n.onHover || n.hover.onHover, [t.native, i.active], i), "mouseup" !== t.type && "click" !== t.type || n.onClick && n.onClick.call(i, t.native, i.active), i.lastActive.length && i.updateHoverStyle(i.lastActive, r.mode, !1), i.active.length && r.mode && i.updateHoverStyle(i.active, r.mode, !0), e = !a.arrayEquals(i.active, i.lastActive), i.lastActive = i.active, e
					}
				}), t.Controller = t
			}
		}, {22: 22, 23: 23, 26: 26, 29: 29, 31: 31, 32: 32, 34: 34, 36: 36, 46: 46, 49: 49}], 25: [function (t, e, i) {
			"use strict";
			var n = t(46);
			e.exports = function (t) {
				var e = ["push", "pop", "shift", "splice", "unshift"];

				function i(t, i) {
					var n = t._chartjs;
					if (n) {
						var r = n.listeners, o = r.indexOf(i);
						-1 !== o && r.splice(o, 1), r.length > 0 || (e.forEach(function (e) {
							delete t[e]
						}), delete t._chartjs)
					}
				}

				t.DatasetController = function (t, e) {
					this.initialize(t, e)
				}, n.extend(t.DatasetController.prototype, {
					datasetElementType: null, dataElementType: null, initialize: function (t, e) {
						this.chart = t, this.index = e, this.linkScales(), this.addElements()
					}, updateIndex: function (t) {
						this.index = t
					}, linkScales: function () {
						var t = this, e = t.getMeta(), i = t.getDataset();
						null !== e.xAxisID && e.xAxisID in t.chart.scales || (e.xAxisID = i.xAxisID || t.chart.options.scales.xAxes[0].id), null !== e.yAxisID && e.yAxisID in t.chart.scales || (e.yAxisID = i.yAxisID || t.chart.options.scales.yAxes[0].id)
					}, getDataset: function () {
						return this.chart.data.datasets[this.index]
					}, getMeta: function () {
						return this.chart.getDatasetMeta(this.index)
					}, getScaleForId: function (t) {
						return this.chart.scales[t]
					}, reset: function () {
						this.update(!0)
					}, destroy: function () {
						this._data && i(this._data, this)
					}, createMetaDataset: function () {
						var t = this.datasetElementType;
						return t && new t({_chart: this.chart, _datasetIndex: this.index})
					}, createMetaData: function (t) {
						var e = this.dataElementType;
						return e && new e({_chart: this.chart, _datasetIndex: this.index, _index: t})
					}, addElements: function () {
						var t, e, i = this.getMeta(), n = this.getDataset().data || [], r = i.data;
						for (t = 0, e = n.length; t < e; ++t) r[t] = r[t] || this.createMetaData(t);
						i.dataset = i.dataset || this.createMetaDataset()
					}, addElementAndReset: function (t) {
						var e = this.createMetaData(t);
						this.getMeta().data.splice(t, 0, e), this.updateElement(e, t, !0)
					}, buildOrUpdateElements: function () {
						var t, r, o = this, a = o.getDataset(), s = a.data || (a.data = []);
						o._data !== s && (o._data && i(o._data, o), r = o, (t = s)._chartjs ? t._chartjs.listeners.push(r) : (Object.defineProperty(t, "_chartjs", {configurable: !0, enumerable: !1, value: {listeners: [r]}}), e.forEach(function (e) {
							var i = "onData" + e.charAt(0).toUpperCase() + e.slice(1), r = t[e];
							Object.defineProperty(t, e, {
								configurable: !0, enumerable: !1, value: function () {
									var e = Array.prototype.slice.call(arguments), o = r.apply(this, e);
									return n.each(t._chartjs.listeners, function (t) {
										"function" == typeof t[i] && t[i].apply(t, e)
									}), o
								}
							})
						})), o._data = s), o.resyncElements()
					}, update: n.noop, transition: function (t) {
						for (var e = this.getMeta(), i = e.data || [], n = i.length, r = 0; r < n; ++r) i[r].transition(t);
						e.dataset && e.dataset.transition(t)
					}, draw: function () {
						var t = this.getMeta(), e = t.data || [], i = e.length, n = 0;
						for (t.dataset && t.dataset.draw(); n < i; ++n) e[n].draw()
					}, removeHoverStyle: function (t) {
						n.merge(t._model, t.$previousStyle || {}), delete t.$previousStyle
					}, setHoverStyle: function (t) {
						var e = this.chart.data.datasets[t._datasetIndex], i = t._index, r = t.custom || {}, o = n.valueAtIndexOrDefault, a = n.getHoverColor, s = t._model;
						t.$previousStyle = {
							backgroundColor: s.backgroundColor,
							borderColor: s.borderColor,
							borderWidth: s.borderWidth
						}, s.backgroundColor = r.hoverBackgroundColor ? r.hoverBackgroundColor : o(e.hoverBackgroundColor, i, a(s.backgroundColor)), s.borderColor = r.hoverBorderColor ? r.hoverBorderColor : o(e.hoverBorderColor, i, a(s.borderColor)), s.borderWidth = r.hoverBorderWidth ? r.hoverBorderWidth : o(e.hoverBorderWidth, i, s.borderWidth)
					}, resyncElements: function () {
						var t = this.getMeta(), e = this.getDataset().data, i = t.data.length, n = e.length;
						n < i ? t.data.splice(n, i - n) : n > i && this.insertElements(i, n - i)
					}, insertElements: function (t, e) {
						for (var i = 0; i < e; ++i) this.addElementAndReset(t + i)
					}, onDataPush: function () {
						this.insertElements(this.getDataset().data.length - 1, arguments.length)
					}, onDataPop: function () {
						this.getMeta().data.pop()
					}, onDataShift: function () {
						this.getMeta().data.shift()
					}, onDataSplice: function (t, e) {
						this.getMeta().data.splice(t, e), this.insertElements(t, arguments.length - 2)
					}, onDataUnshift: function () {
						this.insertElements(0, arguments.length)
					}
				}), t.DatasetController.extend = n.inherits
			}
		}, {46: 46}], 26: [function (t, e, i) {
			"use strict";
			var n = t(46);
			e.exports = {
				_set: function (t, e) {
					return n.merge(this[t] || (this[t] = {}), e)
				}
			}
		}, {46: 46}], 27: [function (t, e, i) {
			"use strict";
			var n = t(2), r = t(46);
			var o = function (t) {
				r.extend(this, t), this.initialize.apply(this, arguments)
			};
			r.extend(o.prototype, {
				initialize: function () {
					this.hidden = !1
				}, pivot: function () {
					var t = this;
					return t._view || (t._view = r.clone(t._model)), t._start = {}, t
				}, transition: function (t) {
					var e = this, i = e._model, r = e._start, o = e._view;
					return i && 1 !== t ? (o || (o = e._view = {}), r || (r = e._start = {}), function (t, e, i, r) {
						var o, a, s, l, c, u, h, d, p, f = Object.keys(i);
						for (o = 0, a = f.length; o < a; ++o) if (u = i[s = f[o]], e.hasOwnProperty(s) || (e[s] = u), (l = e[s]) !== u && "_" !== s[0]) {
							if (t.hasOwnProperty(s) || (t[s] = l), (h = typeof u) == typeof (c = t[s])) if ("string" === h) {
								if ((d = n(c)).valid && (p = n(u)).valid) {
									e[s] = p.mix(d, r).rgbString();
									continue
								}
							} else if ("number" === h && isFinite(c) && isFinite(u)) {
								e[s] = c + (u - c) * r;
								continue
							}
							e[s] = u
						}
					}(r, o, i, t), e) : (e._view = i, e._start = null, e)
				}, tooltipPosition: function () {
					return {x: this._model.x, y: this._model.y}
				}, hasValue: function () {
					return r.isNumber(this._model.x) && r.isNumber(this._model.y)
				}
			}), o.extend = r.inherits, e.exports = o
		}, {2: 2, 46: 46}], 28: [function (t, e, i) {
			"use strict";
			var n = t(2), r = t(26), o = t(46), a = t(34);
			e.exports = function () {
				function t(t, e, i) {
					var n;
					return "string" == typeof t ? (n = parseInt(t, 10), -1 !== t.indexOf("%") && (n = n / 100 * e.parentNode[i])) : n = t, n
				}

				function e(t) {
					return null != t && "none" !== t
				}

				function i(i, n, r) {
					var a = document.defaultView, s = o._getParentNode(i), l = a.getComputedStyle(i)[n], c = a.getComputedStyle(s)[n], u = e(l), h = e(c), d = Number.POSITIVE_INFINITY;
					return u || h ? Math.min(u ? t(l, i, r) : d, h ? t(c, s, r) : d) : "none"
				}

				o.configMerge = function () {
					return o.merge(o.clone(arguments[0]), [].slice.call(arguments, 1), {
						merger: function (t, e, i, n) {
							var r = e[t] || {}, s = i[t];
							"scales" === t ? e[t] = o.scaleMerge(r, s) : "scale" === t ? e[t] = o.merge(r, [a.getScaleDefaults(s.type), s]) : o._merger(t, e, i, n)
						}
					})
				}, o.scaleMerge = function () {
					return o.merge(o.clone(arguments[0]), [].slice.call(arguments, 1), {
						merger: function (t, e, i, n) {
							if ("xAxes" === t || "yAxes" === t) {
								var r, s, l, c = i[t].length;
								for (e[t] || (e[t] = []), r = 0; r < c; ++r) l = i[t][r], s = o.valueOrDefault(l.type, "xAxes" === t ? "category" : "linear"), r >= e[t].length && e[t].push({}), !e[t][r].type || l.type && l.type !== e[t][r].type ? o.merge(e[t][r], [a.getScaleDefaults(s), l]) : o.merge(e[t][r], l)
							} else o._merger(t, e, i, n)
						}
					})
				}, o.where = function (t, e) {
					if (o.isArray(t) && Array.prototype.filter) return t.filter(e);
					var i = [];
					return o.each(t, function (t) {
						e(t) && i.push(t)
					}), i
				}, o.findIndex = Array.prototype.findIndex ? function (t, e, i) {
					return t.findIndex(e, i)
				} : function (t, e, i) {
					i = void 0 === i ? t : i;
					for (var n = 0, r = t.length; n < r; ++n) if (e.call(i, t[n], n, t)) return n;
					return -1
				}, o.findNextWhere = function (t, e, i) {
					o.isNullOrUndef(i) && (i = -1);
					for (var n = i + 1; n < t.length; n++) {
						var r = t[n];
						if (e(r)) return r
					}
				}, o.findPreviousWhere = function (t, e, i) {
					o.isNullOrUndef(i) && (i = t.length);
					for (var n = i - 1; n >= 0; n--) {
						var r = t[n];
						if (e(r)) return r
					}
				}, o.isNumber = function (t) {
					return !isNaN(parseFloat(t)) && isFinite(t)
				}, o.almostEquals = function (t, e, i) {
					return Math.abs(t - e) < i
				}, o.almostWhole = function (t, e) {
					var i = Math.round(t);
					return i - e < t && i + e > t
				}, o.max = function (t) {
					return t.reduce(function (t, e) {
						return isNaN(e) ? t : Math.max(t, e)
					}, Number.NEGATIVE_INFINITY)
				}, o.min = function (t) {
					return t.reduce(function (t, e) {
						return isNaN(e) ? t : Math.min(t, e)
					}, Number.POSITIVE_INFINITY)
				}, o.sign = Math.sign ? function (t) {
					return Math.sign(t)
				} : function (t) {
					return 0 === (t = +t) || isNaN(t) ? t : t > 0 ? 1 : -1
				}, o.log10 = Math.log10 ? function (t) {
					return Math.log10(t)
				} : function (t) {
					var e = Math.log(t) * Math.LOG10E, i = Math.round(e);
					return t === Math.pow(10, i) ? i : e
				}, o.toRadians = function (t) {
					return t * (Math.PI / 180)
				}, o.toDegrees = function (t) {
					return t * (180 / Math.PI)
				}, o.getAngleFromPoint = function (t, e) {
					var i = e.x - t.x, n = e.y - t.y, r = Math.sqrt(i * i + n * n), o = Math.atan2(n, i);
					return o < -.5 * Math.PI && (o += 2 * Math.PI), {angle: o, distance: r}
				}, o.distanceBetweenPoints = function (t, e) {
					return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))
				}, o.aliasPixel = function (t) {
					return t % 2 == 0 ? 0 : .5
				}, o.splineCurve = function (t, e, i, n) {
					var r = t.skip ? e : t, o = e, a = i.skip ? e : i, s = Math.sqrt(Math.pow(o.x - r.x, 2) + Math.pow(o.y - r.y, 2)), l = Math.sqrt(Math.pow(a.x - o.x, 2) + Math.pow(a.y - o.y, 2)), c = s / (s + l), u = l / (s + l), h = n * (c = isNaN(c) ? 0 : c), d = n * (u = isNaN(u) ? 0 : u);
					return {previous: {x: o.x - h * (a.x - r.x), y: o.y - h * (a.y - r.y)}, next: {x: o.x + d * (a.x - r.x), y: o.y + d * (a.y - r.y)}}
				}, o.EPSILON = Number.EPSILON || 1e-14, o.splineCurveMonotone = function (t) {
					var e, i, n, r, a, s, l, c, u, h = (t || []).map(function (t) {
						return {model: t._model, deltaK: 0, mK: 0}
					}), d = h.length;
					for (e = 0; e < d; ++e) if (!(n = h[e]).model.skip) {
						if (i = e > 0 ? h[e - 1] : null, (r = e < d - 1 ? h[e + 1] : null) && !r.model.skip) {
							var p = r.model.x - n.model.x;
							n.deltaK = 0 !== p ? (r.model.y - n.model.y) / p : 0
						}
						!i || i.model.skip ? n.mK = n.deltaK : !r || r.model.skip ? n.mK = i.deltaK : this.sign(i.deltaK) !== this.sign(n.deltaK) ? n.mK = 0 : n.mK = (i.deltaK + n.deltaK) / 2
					}
					for (e = 0; e < d - 1; ++e) n = h[e], r = h[e + 1], n.model.skip || r.model.skip || (o.almostEquals(n.deltaK, 0, this.EPSILON) ? n.mK = r.mK = 0 : (a = n.mK / n.deltaK, s = r.mK / n.deltaK, (c = Math.pow(a, 2) + Math.pow(s, 2)) <= 9 || (l = 3 / Math.sqrt(c), n.mK = a * l * n.deltaK, r.mK = s * l * n.deltaK)));
					for (e = 0; e < d; ++e) (n = h[e]).model.skip || (i = e > 0 ? h[e - 1] : null, r = e < d - 1 ? h[e + 1] : null, i && !i.model.skip && (u = (n.model.x - i.model.x) / 3, n.model.controlPointPreviousX = n.model.x - u, n.model.controlPointPreviousY = n.model.y - u * n.mK), r && !r.model.skip && (u = (r.model.x - n.model.x) / 3, n.model.controlPointNextX = n.model.x + u, n.model.controlPointNextY = n.model.y + u * n.mK))
				}, o.nextItem = function (t, e, i) {
					return i ? e >= t.length - 1 ? t[0] : t[e + 1] : e >= t.length - 1 ? t[t.length - 1] : t[e + 1]
				}, o.previousItem = function (t, e, i) {
					return i ? e <= 0 ? t[t.length - 1] : t[e - 1] : e <= 0 ? t[0] : t[e - 1]
				}, o.niceNum = function (t, e) {
					var i = Math.floor(o.log10(t)), n = t / Math.pow(10, i);
					return (e ? n < 1.5 ? 1 : n < 3 ? 2 : n < 7 ? 5 : 10 : n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * Math.pow(10, i)
				}, o.requestAnimFrame = "undefined" == typeof window ? function (t) {
					t()
				} : window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (t) {
					return window.setTimeout(t, 1e3 / 60)
				}, o.getRelativePosition = function (t, e) {
					var i, n, r = t.originalEvent || t, a = t.target || t.srcElement, s = a.getBoundingClientRect(), l = r.touches;
					l && l.length > 0 ? (i = l[0].clientX, n = l[0].clientY) : (i = r.clientX, n = r.clientY);
					var c = parseFloat(o.getStyle(a, "padding-left")), u = parseFloat(o.getStyle(a, "padding-top")), h = parseFloat(o.getStyle(a, "padding-right")), d = parseFloat(o.getStyle(a, "padding-bottom")), p = s.right - s.left - c - h, f = s.bottom - s.top - u - d;
					return {x: i = Math.round((i - s.left - c) / p * a.width / e.currentDevicePixelRatio), y: n = Math.round((n - s.top - u) / f * a.height / e.currentDevicePixelRatio)}
				}, o.getConstraintWidth = function (t) {
					return i(t, "max-width", "clientWidth")
				}, o.getConstraintHeight = function (t) {
					return i(t, "max-height", "clientHeight")
				}, o._calculatePadding = function (t, e, i) {
					return (e = o.getStyle(t, e)).indexOf("%") > -1 ? i / parseInt(e, 10) : parseInt(e, 10)
				}, o._getParentNode = function (t) {
					var e = t.parentNode;
					return e && e.host && (e = e.host), e
				}, o.getMaximumWidth = function (t) {
					var e = o._getParentNode(t);
					if (!e) return t.clientWidth;
					var i = e.clientWidth, n = i - o._calculatePadding(e, "padding-left", i) - o._calculatePadding(e, "padding-right", i), r = o.getConstraintWidth(t);
					return isNaN(r) ? n : Math.min(n, r)
				}, o.getMaximumHeight = function (t) {
					var e = o._getParentNode(t);
					if (!e) return t.clientHeight;
					var i = e.clientHeight, n = i - o._calculatePadding(e, "padding-top", i) - o._calculatePadding(e, "padding-bottom", i), r = o.getConstraintHeight(t);
					return isNaN(r) ? n : Math.min(n, r)
				}, o.getStyle = function (t, e) {
					return t.currentStyle ? t.currentStyle[e] : document.defaultView.getComputedStyle(t, null).getPropertyValue(e)
				}, o.retinaScale = function (t, e) {
					var i = t.currentDevicePixelRatio = e || "undefined" != typeof window && window.devicePixelRatio || 1;
					if (1 !== i) {
						var n = t.canvas, r = t.height, o = t.width;
						n.height = r * i, n.width = o * i, t.ctx.scale(i, i), n.style.height || n.style.width || (n.style.height = r + "px", n.style.width = o + "px")
					}
				}, o.fontString = function (t, e, i) {
					return e + " " + t + "px " + i
				}, o.longestText = function (t, e, i, n) {
					var r = (n = n || {}).data = n.data || {}, a = n.garbageCollect = n.garbageCollect || [];
					n.font !== e && (r = n.data = {}, a = n.garbageCollect = [], n.font = e), t.font = e;
					var s = 0;
					o.each(i, function (e) {
						null != e && !0 !== o.isArray(e) ? s = o.measureText(t, r, a, s, e) : o.isArray(e) && o.each(e, function (e) {
							null == e || o.isArray(e) || (s = o.measureText(t, r, a, s, e))
						})
					});
					var l = a.length / 2;
					if (l > i.length) {
						for (var c = 0; c < l; c++) delete r[a[c]];
						a.splice(0, l)
					}
					return s
				}, o.measureText = function (t, e, i, n, r) {
					var o = e[r];
					return o || (o = e[r] = t.measureText(r).width, i.push(r)), o > n && (n = o), n
				}, o.numberOfLabelLines = function (t) {
					var e = 1;
					return o.each(t, function (t) {
						o.isArray(t) && t.length > e && (e = t.length)
					}), e
				}, o.color = n ? function (t) {
					return t instanceof CanvasGradient && (t = r.global.defaultColor), n(t)
				} : function (t) {
					return console.error("Color.js not found!"), t
				}, o.getHoverColor = function (t) {
					return t instanceof CanvasPattern ? t : o.color(t).saturate(.5).darken(.1).rgbString()
				}
			}
		}, {2: 2, 26: 26, 34: 34, 46: 46}], 29: [function (t, e, i) {
			"use strict";
			var n = t(46);

			function r(t, e) {
				return t.native ? {x: t.x, y: t.y} : n.getRelativePosition(t, e)
			}

			function o(t, e) {
				var i, n, r, o, a;
				for (n = 0, o = t.data.datasets.length; n < o; ++n) if (t.isDatasetVisible(n)) for (r = 0, a = (i = t.getDatasetMeta(n)).data.length; r < a; ++r) {
					var s = i.data[r];
					s._view.skip || e(s)
				}
			}

			function a(t, e) {
				var i = [];
				return o(t, function (t) {
					t.inRange(e.x, e.y) && i.push(t)
				}), i
			}

			function s(t, e, i, n) {
				var r = Number.POSITIVE_INFINITY, a = [];
				return o(t, function (t) {
					if (!i || t.inRange(e.x, e.y)) {
						var o = t.getCenterPoint(), s = n(e, o);
						s < r ? (a = [t], r = s) : s === r && a.push(t)
					}
				}), a
			}

			function l(t) {
				var e = -1 !== t.indexOf("x"), i = -1 !== t.indexOf("y");
				return function (t, n) {
					var r = e ? Math.abs(t.x - n.x) : 0, o = i ? Math.abs(t.y - n.y) : 0;
					return Math.sqrt(Math.pow(r, 2) + Math.pow(o, 2))
				}
			}

			function c(t, e, i) {
				var n = r(e, t);
				i.axis = i.axis || "x";
				var o = l(i.axis), c = i.intersect ? a(t, n) : s(t, n, !1, o), u = [];
				return c.length ? (t.data.datasets.forEach(function (e, i) {
					if (t.isDatasetVisible(i)) {
						var n = t.getDatasetMeta(i).data[c[0]._index];
						n && !n._view.skip && u.push(n)
					}
				}), u) : []
			}

			e.exports = {
				modes: {
					single: function (t, e) {
						var i = r(e, t), n = [];
						return o(t, function (t) {
							if (t.inRange(i.x, i.y)) return n.push(t), n
						}), n.slice(0, 1)
					}, label: c, index: c, dataset: function (t, e, i) {
						var n = r(e, t);
						i.axis = i.axis || "xy";
						var o = l(i.axis), c = i.intersect ? a(t, n) : s(t, n, !1, o);
						return c.length > 0 && (c = t.getDatasetMeta(c[0]._datasetIndex).data), c
					}, "x-axis": function (t, e) {
						return c(t, e, {intersect: !1})
					}, point: function (t, e) {
						return a(t, r(e, t))
					}, nearest: function (t, e, i) {
						var n = r(e, t);
						i.axis = i.axis || "xy";
						var o = l(i.axis), a = s(t, n, i.intersect, o);
						return a.length > 1 && a.sort(function (t, e) {
							var i = t.getArea() - e.getArea();
							return 0 === i && (i = t._datasetIndex - e._datasetIndex), i
						}), a.slice(0, 1)
					}, x: function (t, e, i) {
						var n = r(e, t), a = [], s = !1;
						return o(t, function (t) {
							t.inXRange(n.x) && a.push(t), t.inRange(n.x, n.y) && (s = !0)
						}), i.intersect && !s && (a = []), a
					}, y: function (t, e, i) {
						var n = r(e, t), a = [], s = !1;
						return o(t, function (t) {
							t.inYRange(n.y) && a.push(t), t.inRange(n.x, n.y) && (s = !0)
						}), i.intersect && !s && (a = []), a
					}
				}
			}
		}, {46: 46}], 30: [function (t, e, i) {
			"use strict";
			t(26)._set("global", {
				responsive: !0,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: !0,
				events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"],
				hover: {onHover: null, mode: "nearest", intersect: !0, animationDuration: 400},
				onClick: null,
				defaultColor: "rgba(0,0,0,0.1)",
				defaultFontColor: "#666",
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: "normal",
				showLines: !0,
				elements: {},
				layout: {padding: {top: 0, right: 0, bottom: 0, left: 0}}
			}), e.exports = function () {
				var t = function (t, e) {
					return this.construct(t, e), this
				};
				return t.Chart = t, t
			}
		}, {26: 26}], 31: [function (t, e, i) {
			"use strict";
			var n = t(46);

			function r(t, e) {
				return n.where(t, function (t) {
					return t.position === e
				})
			}

			function o(t, e) {
				t.forEach(function (t, e) {
					return t._tmpIndex_ = e, t
				}), t.sort(function (t, i) {
					var n = e ? i : t, r = e ? t : i;
					return n.weight === r.weight ? n._tmpIndex_ - r._tmpIndex_ : n.weight - r.weight
				}), t.forEach(function (t) {
					delete t._tmpIndex_
				})
			}

			e.exports = {
				defaults: {}, addBox: function (t, e) {
					t.boxes || (t.boxes = []), e.fullWidth = e.fullWidth || !1, e.position = e.position || "top", e.weight = e.weight || 0, t.boxes.push(e)
				}, removeBox: function (t, e) {
					var i = t.boxes ? t.boxes.indexOf(e) : -1;
					-1 !== i && t.boxes.splice(i, 1)
				}, configure: function (t, e, i) {
					for (var n, r = ["fullWidth", "position", "weight"], o = r.length, a = 0; a < o; ++a) n = r[a], i.hasOwnProperty(n) && (e[n] = i[n])
				}, update: function (t, e, i) {
					if (t) {
						var a = t.options.layout || {}, s = n.options.toPadding(a.padding), l = s.left, c = s.right, u = s.top, h = s.bottom, d = r(t.boxes, "left"), p = r(t.boxes, "right"), f = r(t.boxes, "top"), m = r(t.boxes, "bottom"), g = r(t.boxes, "chartArea");
						o(d, !0), o(p, !1), o(f, !0), o(m, !1);
						var v = e - l - c, y = i - u - h, b = y / 2, w = (e - v / 2) / (d.length + p.length), x = (i - b) / (f.length + m.length), k = v, _ = y, S = [];
						n.each(d.concat(p, f, m), function (t) {
							var e, i = t.isHorizontal();
							i ? (e = t.update(t.fullWidth ? v : k, x), _ -= e.height) : (e = t.update(w, _), k -= e.width), S.push({horizontal: i, minSize: e, box: t})
						});
						var C = 0, D = 0, T = 0, M = 0;
						n.each(f.concat(m), function (t) {
							if (t.getPadding) {
								var e = t.getPadding();
								C = Math.max(C, e.left), D = Math.max(D, e.right)
							}
						}), n.each(d.concat(p), function (t) {
							if (t.getPadding) {
								var e = t.getPadding();
								T = Math.max(T, e.top), M = Math.max(M, e.bottom)
							}
						});
						var E = l, A = c, P = u, I = h;
						n.each(d.concat(p), $), n.each(d, function (t) {
							E += t.width
						}), n.each(p, function (t) {
							A += t.width
						}), n.each(f.concat(m), $), n.each(f, function (t) {
							P += t.height
						}), n.each(m, function (t) {
							I += t.height
						}), n.each(d.concat(p), function (t) {
							var e = n.findNextWhere(S, function (e) {
								return e.box === t
							}), i = {left: 0, right: 0, top: P, bottom: I};
							e && t.update(e.minSize.width, _, i)
						}), E = l, A = c, P = u, I = h, n.each(d, function (t) {
							E += t.width
						}), n.each(p, function (t) {
							A += t.width
						}), n.each(f, function (t) {
							P += t.height
						}), n.each(m, function (t) {
							I += t.height
						});
						var O = Math.max(C - E, 0);
						E += O, A += Math.max(D - A, 0);
						var L = Math.max(T - P, 0);
						P += L, I += Math.max(M - I, 0);
						var F = i - P - I, N = e - E - A;
						N === k && F === _ || (n.each(d, function (t) {
							t.height = F
						}), n.each(p, function (t) {
							t.height = F
						}), n.each(f, function (t) {
							t.fullWidth || (t.width = N)
						}), n.each(m, function (t) {
							t.fullWidth || (t.width = N)
						}), _ = F, k = N);
						var R = l + O, H = u + L;
						n.each(d.concat(f), B), R += k, H += _, n.each(p, B), n.each(m, B), t.chartArea = {left: E, top: P, right: E + k, bottom: P + _}, n.each(g, function (e) {
							e.left = t.chartArea.left, e.top = t.chartArea.top, e.right = t.chartArea.right, e.bottom = t.chartArea.bottom, e.update(k, _)
						})
					}

					function $(t) {
						var e = n.findNextWhere(S, function (e) {
							return e.box === t
						});
						if (e) if (t.isHorizontal()) {
							var i = {left: Math.max(E, C), right: Math.max(A, D), top: 0, bottom: 0};
							t.update(t.fullWidth ? v : k, y / 2, i)
						} else t.update(e.minSize.width, _)
					}

					function B(t) {
						t.isHorizontal() ? (t.left = t.fullWidth ? l : E, t.right = t.fullWidth ? e - c : E + k, t.top = H, t.bottom = H + t.height, H = t.bottom) : (t.left = R, t.right = R + t.width, t.top = P, t.bottom = P + _, R = t.right)
					}
				}
			}
		}, {46: 46}], 32: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(46);
			n._set("global", {plugins: {}}), e.exports = {
				_plugins: [], _cacheId: 0, register: function (t) {
					var e = this._plugins;
					[].concat(t).forEach(function (t) {
						-1 === e.indexOf(t) && e.push(t)
					}), this._cacheId++
				}, unregister: function (t) {
					var e = this._plugins;
					[].concat(t).forEach(function (t) {
						var i = e.indexOf(t);
						-1 !== i && e.splice(i, 1)
					}), this._cacheId++
				}, clear: function () {
					this._plugins = [], this._cacheId++
				}, count: function () {
					return this._plugins.length
				}, getAll: function () {
					return this._plugins
				}, notify: function (t, e, i) {
					var n, r, o, a, s, l = this.descriptors(t), c = l.length;
					for (n = 0; n < c; ++n) if ("function" == typeof (s = (o = (r = l[n]).plugin)[e]) && ((a = [t].concat(i || [])).push(r.options), !1 === s.apply(o, a))) return !1;
					return !0
				}, descriptors: function (t) {
					var e = t.$plugins || (t.$plugins = {});
					if (e.id === this._cacheId) return e.descriptors;
					var i = [], o = [], a = t && t.config || {}, s = a.options && a.options.plugins || {};
					return this._plugins.concat(a.plugins || []).forEach(function (t) {
						if (-1 === i.indexOf(t)) {
							var e = t.id, a = s[e];
							!1 !== a && (!0 === a && (a = r.clone(n.global.plugins[e])), i.push(t), o.push({plugin: t, options: a || {}}))
						}
					}), e.descriptors = o, e.id = this._cacheId, o
				}, _invalidate: function (t) {
					delete t.$plugins
				}
			}
		}, {26: 26, 46: 46}], 33: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(27), o = t(46), a = t(35);

			function s(t) {
				var e, i, n = [];
				for (e = 0, i = t.length; e < i; ++e) n.push(t[e].label);
				return n
			}

			function l(t, e, i) {
				var n = t.getPixelForTick(e);
				return i && (n -= 0 === e ? (t.getPixelForTick(1) - n) / 2 : (n - t.getPixelForTick(e - 1)) / 2), n
			}

			function c(t, e, i) {
				return o.isArray(e) ? o.longestText(t, i, e) : t.measureText(e).width
			}

			function u(t) {
				var e = o.valueOrDefault, i = n.global, r = e(t.fontSize, i.defaultFontSize), a = e(t.fontStyle, i.defaultFontStyle), s = e(t.fontFamily, i.defaultFontFamily);
				return {size: r, style: a, family: s, font: o.fontString(r, a, s)}
			}

			function h(t) {
				return o.options.toLineHeight(o.valueOrDefault(t.lineHeight, 1.2), o.valueOrDefault(t.fontSize, n.global.defaultFontSize))
			}

			n._set("scale", {
				display: !0,
				position: "left",
				offset: !1,
				gridLines: {
					display: !0,
					color: "rgba(0, 0, 0, 0.1)",
					lineWidth: 1,
					drawBorder: !0,
					drawOnChartArea: !0,
					drawTicks: !0,
					tickMarkLength: 10,
					zeroLineWidth: 1,
					zeroLineColor: "rgba(0,0,0,0.25)",
					zeroLineBorderDash: [],
					zeroLineBorderDashOffset: 0,
					offsetGridLines: !1,
					borderDash: [],
					borderDashOffset: 0
				},
				scaleLabel: {display: !1, labelString: "", lineHeight: 1.2, padding: {top: 4, bottom: 4}},
				ticks: {beginAtZero: !1, minRotation: 0, maxRotation: 50, mirror: !1, padding: 0, reverse: !1, display: !0, autoSkip: !0, autoSkipPadding: 0, labelOffset: 0, callback: a.formatters.values, minor: {}, major: {}}
			}), e.exports = r.extend({
				getPadding: function () {
					return {left: this.paddingLeft || 0, top: this.paddingTop || 0, right: this.paddingRight || 0, bottom: this.paddingBottom || 0}
				}, getTicks: function () {
					return this._ticks
				}, mergeTicksOptions: function () {
					var t = this.options.ticks;
					for (var e in!1 === t.minor && (t.minor = {display: !1}), !1 === t.major && (t.major = {display: !1}), t) "major" !== e && "minor" !== e && (void 0 === t.minor[e] && (t.minor[e] = t[e]), void 0 === t.major[e] && (t.major[e] = t[e]))
				}, beforeUpdate: function () {
					o.callback(this.options.beforeUpdate, [this])
				}, update: function (t, e, i) {
					var n, r, a, s, l, c, u = this;
					for (u.beforeUpdate(), u.maxWidth = t, u.maxHeight = e, u.margins = o.extend({
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}, i), u.longestTextCache = u.longestTextCache || {}, u.beforeSetDimensions(), u.setDimensions(), u.afterSetDimensions(), u.beforeDataLimits(), u.determineDataLimits(), u.afterDataLimits(), u.beforeBuildTicks(), l = u.buildTicks() || [], u.afterBuildTicks(), u.beforeTickToLabelConversion(), a = u.convertTicksToLabels(l) || u.ticks, u.afterTickToLabelConversion(), u.ticks = a, n = 0, r = a.length; n < r; ++n) s = a[n], (c = l[n]) ? c.label = s : l.push(c = {
						label: s,
						major: !1
					});
					return u._ticks = l, u.beforeCalculateTickRotation(), u.calculateTickRotation(), u.afterCalculateTickRotation(), u.beforeFit(), u.fit(), u.afterFit(), u.afterUpdate(), u.minSize
				}, afterUpdate: function () {
					o.callback(this.options.afterUpdate, [this])
				}, beforeSetDimensions: function () {
					o.callback(this.options.beforeSetDimensions, [this])
				}, setDimensions: function () {
					var t = this;
					t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0
				}, afterSetDimensions: function () {
					o.callback(this.options.afterSetDimensions, [this])
				}, beforeDataLimits: function () {
					o.callback(this.options.beforeDataLimits, [this])
				}, determineDataLimits: o.noop, afterDataLimits: function () {
					o.callback(this.options.afterDataLimits, [this])
				}, beforeBuildTicks: function () {
					o.callback(this.options.beforeBuildTicks, [this])
				}, buildTicks: o.noop, afterBuildTicks: function () {
					o.callback(this.options.afterBuildTicks, [this])
				}, beforeTickToLabelConversion: function () {
					o.callback(this.options.beforeTickToLabelConversion, [this])
				}, convertTicksToLabels: function () {
					var t = this.options.ticks;
					this.ticks = this.ticks.map(t.userCallback || t.callback, this)
				}, afterTickToLabelConversion: function () {
					o.callback(this.options.afterTickToLabelConversion, [this])
				}, beforeCalculateTickRotation: function () {
					o.callback(this.options.beforeCalculateTickRotation, [this])
				}, calculateTickRotation: function () {
					var t = this, e = t.ctx, i = t.options.ticks, n = s(t._ticks), r = u(i);
					e.font = r.font;
					var a = i.minRotation || 0;
					if (n.length && t.options.display && t.isHorizontal()) for (var l, c = o.longestText(e, r.font, n, t.longestTextCache), h = c, d = t.getPixelForTick(1) - t.getPixelForTick(0) - 6; h > d && a < i.maxRotation;) {
						var p = o.toRadians(a);
						if (l = Math.cos(p), Math.sin(p) * c > t.maxHeight) {
							a--;
							break
						}
						a++, h = l * c
					}
					t.labelRotation = a
				}, afterCalculateTickRotation: function () {
					o.callback(this.options.afterCalculateTickRotation, [this])
				}, beforeFit: function () {
					o.callback(this.options.beforeFit, [this])
				}, fit: function () {
					var t = this, e = t.minSize = {width: 0, height: 0}, i = s(t._ticks), n = t.options, r = n.ticks, a = n.scaleLabel, l = n.gridLines, d = n.display, p = t.isHorizontal(), f = u(r), m = n.gridLines.tickMarkLength;
					if (e.width = p ? t.isFullWidth() ? t.maxWidth - t.margins.left - t.margins.right : t.maxWidth : d && l.drawTicks ? m : 0, e.height = p ? d && l.drawTicks ? m : 0 : t.maxHeight, a.display && d) {
						var g = h(a) + o.options.toPadding(a.padding).height;
						p ? e.height += g : e.width += g
					}
					if (r.display && d) {
						var v = o.longestText(t.ctx, f.font, i, t.longestTextCache), y = o.numberOfLabelLines(i), b = .5 * f.size, w = t.options.ticks.padding;
						if (p) {
							t.longestLabelWidth = v;
							var x = o.toRadians(t.labelRotation), k = Math.cos(x), _ = Math.sin(x) * v + f.size * y + b * (y - 1) + b;
							e.height = Math.min(t.maxHeight, e.height + _ + w), t.ctx.font = f.font;
							var S = c(t.ctx, i[0], f.font), C = c(t.ctx, i[i.length - 1], f.font);
							0 !== t.labelRotation ? (t.paddingLeft = "bottom" === n.position ? k * S + 3 : k * b + 3, t.paddingRight = "bottom" === n.position ? k * b + 3 : k * C + 3) : (t.paddingLeft = S / 2 + 3, t.paddingRight = C / 2 + 3)
						} else r.mirror ? v = 0 : v += w + b, e.width = Math.min(t.maxWidth, e.width + v), t.paddingTop = f.size / 2, t.paddingBottom = f.size / 2
					}
					t.handleMargins(), t.width = e.width, t.height = e.height
				}, handleMargins: function () {
					var t = this;
					t.margins && (t.paddingLeft = Math.max(t.paddingLeft - t.margins.left, 0), t.paddingTop = Math.max(t.paddingTop - t.margins.top, 0), t.paddingRight = Math.max(t.paddingRight - t.margins.right, 0), t.paddingBottom = Math.max(t.paddingBottom - t.margins.bottom, 0))
				}, afterFit: function () {
					o.callback(this.options.afterFit, [this])
				}, isHorizontal: function () {
					return "top" === this.options.position || "bottom" === this.options.position
				}, isFullWidth: function () {
					return this.options.fullWidth
				}, getRightValue: function (t) {
					if (o.isNullOrUndef(t)) return NaN;
					if ("number" == typeof t && !isFinite(t)) return NaN;
					if (t) if (this.isHorizontal()) {
						if (void 0 !== t.x) return this.getRightValue(t.x)
					} else if (void 0 !== t.y) return this.getRightValue(t.y);
					return t
				}, getLabelForIndex: o.noop, getPixelForValue: o.noop, getValueForPixel: o.noop, getPixelForTick: function (t) {
					var e = this, i = e.options.offset;
					if (e.isHorizontal()) {
						var n = (e.width - (e.paddingLeft + e.paddingRight)) / Math.max(e._ticks.length - (i ? 0 : 1), 1), r = n * t + e.paddingLeft;
						i && (r += n / 2);
						var o = e.left + Math.round(r);
						return o += e.isFullWidth() ? e.margins.left : 0
					}
					var a = e.height - (e.paddingTop + e.paddingBottom);
					return e.top + t * (a / (e._ticks.length - 1))
				}, getPixelForDecimal: function (t) {
					var e = this;
					if (e.isHorizontal()) {
						var i = (e.width - (e.paddingLeft + e.paddingRight)) * t + e.paddingLeft, n = e.left + Math.round(i);
						return n += e.isFullWidth() ? e.margins.left : 0
					}
					return e.top + t * e.height
				}, getBasePixel: function () {
					return this.getPixelForValue(this.getBaseValue())
				}, getBaseValue: function () {
					var t = this.min, e = this.max;
					return this.beginAtZero ? 0 : t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0
				}, _autoSkip: function (t) {
					var e, i, n, r, a = this, s = a.isHorizontal(), l = a.options.ticks.minor, c = t.length, u = o.toRadians(a.labelRotation), h = Math.cos(u), d = a.longestLabelWidth * h, p = [];
					for (l.maxTicksLimit && (r = l.maxTicksLimit), s && (e = !1, (d + l.autoSkipPadding) * c > a.width - (a.paddingLeft + a.paddingRight) && (e = 1 + Math.floor((d + l.autoSkipPadding) * c / (a.width - (a.paddingLeft + a.paddingRight)))), r && c > r && (e = Math.max(e, Math.floor(c / r)))), i = 0; i < c; i++) n = t[i], (e > 1 && i % e > 0 || i % e == 0 && i + e >= c) && i !== c - 1 && delete n.label, p.push(n);
					return p
				}, draw: function (t) {
					var e = this, i = e.options;
					if (i.display) {
						var r = e.ctx, a = n.global, s = i.ticks.minor, c = i.ticks.major || s, d = i.gridLines, p = i.scaleLabel, f = 0 !== e.labelRotation, m = e.isHorizontal(), g = s.autoSkip ? e._autoSkip(e.getTicks()) : e.getTicks(), v = o.valueOrDefault(s.fontColor, a.defaultFontColor), y = u(s),
							b = o.valueOrDefault(c.fontColor, a.defaultFontColor), w = u(c), x = d.drawTicks ? d.tickMarkLength : 0, k = o.valueOrDefault(p.fontColor, a.defaultFontColor), _ = u(p), S = o.options.toPadding(p.padding), C = o.toRadians(e.labelRotation), D = [],
							T = e.options.gridLines.lineWidth, M = "right" === i.position ? e.left : e.right - T - x, E = "right" === i.position ? e.left + x : e.right, A = "bottom" === i.position ? e.top + T : e.bottom - x - T, P = "bottom" === i.position ? e.top + T + x : e.bottom + T;
						if (o.each(g, function (n, r) {
							if (!o.isNullOrUndef(n.label)) {
								var c, u, h, p, v, y, b, w, k, _, S, I, O, L, F = n.label;
								r === e.zeroLineIndex && i.offset === d.offsetGridLines ? (c = d.zeroLineWidth, u = d.zeroLineColor, h = d.zeroLineBorderDash, p = d.zeroLineBorderDashOffset) : (c = o.valueAtIndexOrDefault(d.lineWidth, r), u = o.valueAtIndexOrDefault(d.color, r), h = o.valueOrDefault(d.borderDash, a.borderDash), p = o.valueOrDefault(d.borderDashOffset, a.borderDashOffset));
								var N = "middle", R = "middle", H = s.padding;
								if (m) {
									var $ = x + H;
									"bottom" === i.position ? (R = f ? "middle" : "top", N = f ? "right" : "center", L = e.top + $) : (R = f ? "middle" : "bottom", N = f ? "left" : "center", L = e.bottom - $);
									var B = l(e, r, d.offsetGridLines && g.length > 1);
									B < e.left && (u = "rgba(0,0,0,0)"), B += o.aliasPixel(c), O = e.getPixelForTick(r) + s.labelOffset, v = b = k = S = B, y = A, w = P, _ = t.top, I = t.bottom + T
								} else {
									var z, j = "left" === i.position;
									s.mirror ? (N = j ? "left" : "right", z = H) : (N = j ? "right" : "left", z = x + H), O = j ? e.right - z : e.left + z;
									var U = l(e, r, d.offsetGridLines && g.length > 1);
									U < e.top && (u = "rgba(0,0,0,0)"), U += o.aliasPixel(c), L = e.getPixelForTick(r) + s.labelOffset, v = M, b = E, k = t.left, S = t.right + T, y = w = _ = I = U
								}
								D.push({tx1: v, ty1: y, tx2: b, ty2: w, x1: k, y1: _, x2: S, y2: I, labelX: O, labelY: L, glWidth: c, glColor: u, glBorderDash: h, glBorderDashOffset: p, rotation: -1 * C, label: F, major: n.major, textBaseline: R, textAlign: N})
							}
						}), o.each(D, function (t) {
							if (d.display && (r.save(), r.lineWidth = t.glWidth, r.strokeStyle = t.glColor, r.setLineDash && (r.setLineDash(t.glBorderDash), r.lineDashOffset = t.glBorderDashOffset), r.beginPath(), d.drawTicks && (r.moveTo(t.tx1, t.ty1), r.lineTo(t.tx2, t.ty2)), d.drawOnChartArea && (r.moveTo(t.x1, t.y1), r.lineTo(t.x2, t.y2)), r.stroke(), r.restore()), s.display) {
								r.save(), r.translate(t.labelX, t.labelY), r.rotate(t.rotation), r.font = t.major ? w.font : y.font, r.fillStyle = t.major ? b : v, r.textBaseline = t.textBaseline, r.textAlign = t.textAlign;
								var i = t.label;
								if (o.isArray(i)) for (var n = i.length, a = 1.5 * y.size, l = e.isHorizontal() ? 0 : -a * (n - 1) / 2, c = 0; c < n; ++c) r.fillText("" + i[c], 0, l), l += a; else r.fillText(i, 0, 0);
								r.restore()
							}
						}), p.display) {
							var I, O, L = 0, F = h(p) / 2;
							if (m) I = e.left + (e.right - e.left) / 2, O = "bottom" === i.position ? e.bottom - F - S.bottom : e.top + F + S.top; else {
								var N = "left" === i.position;
								I = N ? e.left + F + S.top : e.right - F - S.top, O = e.top + (e.bottom - e.top) / 2, L = N ? -.5 * Math.PI : .5 * Math.PI
							}
							r.save(), r.translate(I, O), r.rotate(L), r.textAlign = "center", r.textBaseline = "middle", r.fillStyle = k, r.font = _.font, r.fillText(p.labelString, 0, 0), r.restore()
						}
						if (d.drawBorder) {
							r.lineWidth = o.valueAtIndexOrDefault(d.lineWidth, 0), r.strokeStyle = o.valueAtIndexOrDefault(d.color, 0);
							var R = e.left, H = e.right + T, $ = e.top, B = e.bottom + T, z = o.aliasPixel(r.lineWidth);
							m ? ($ = B = "top" === i.position ? e.bottom : e.top, $ += z, B += z) : (R = H = "left" === i.position ? e.right : e.left, R += z, H += z), r.beginPath(), r.moveTo(R, $), r.lineTo(H, B), r.stroke()
						}
					}
				}
			})
		}, {26: 26, 27: 27, 35: 35, 46: 46}], 34: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(46), o = t(31);
			e.exports = {
				constructors: {}, defaults: {}, registerScaleType: function (t, e, i) {
					this.constructors[t] = e, this.defaults[t] = r.clone(i)
				}, getScaleConstructor: function (t) {
					return this.constructors.hasOwnProperty(t) ? this.constructors[t] : void 0
				}, getScaleDefaults: function (t) {
					return this.defaults.hasOwnProperty(t) ? r.merge({}, [n.scale, this.defaults[t]]) : {}
				}, updateScaleDefaults: function (t, e) {
					this.defaults.hasOwnProperty(t) && (this.defaults[t] = r.extend(this.defaults[t], e))
				}, addScalesToLayout: function (t) {
					r.each(t.scales, function (e) {
						e.fullWidth = e.options.fullWidth, e.position = e.options.position, e.weight = e.options.weight, o.addBox(t, e)
					})
				}
			}
		}, {26: 26, 31: 31, 46: 46}], 35: [function (t, e, i) {
			"use strict";
			var n = t(46);
			e.exports = {
				formatters: {
					values: function (t) {
						return n.isArray(t) ? t : "" + t
					}, linear: function (t, e, i) {
						var r = i.length > 3 ? i[2] - i[1] : i[1] - i[0];
						Math.abs(r) > 1 && t !== Math.floor(t) && (r = t - Math.floor(t));
						var o = n.log10(Math.abs(r)), a = "";
						if (0 !== t) if (Math.max(Math.abs(i[0]), Math.abs(i[i.length - 1])) < 1e-4) {
							var s = n.log10(Math.abs(t));
							a = t.toExponential(Math.floor(s) - Math.floor(o))
						} else {
							var l = -1 * Math.floor(o);
							l = Math.max(Math.min(l, 20), 0), a = t.toFixed(l)
						} else a = "0";
						return a
					}, logarithmic: function (t, e, i) {
						var r = t / Math.pow(10, Math.floor(n.log10(t)));
						return 0 === t ? "0" : 1 === r || 2 === r || 5 === r || 0 === e || e === i.length - 1 ? t.toExponential() : ""
					}
				}
			}
		}, {46: 46}], 36: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(27), o = t(46);
			n._set("global", {
				tooltips: {
					enabled: !0,
					custom: null,
					mode: "nearest",
					position: "average",
					intersect: !0,
					backgroundColor: "rgba(0,0,0,0.8)",
					titleFontStyle: "bold",
					titleSpacing: 2,
					titleMarginBottom: 6,
					titleFontColor: "#fff",
					titleAlign: "left",
					bodySpacing: 2,
					bodyFontColor: "#fff",
					bodyAlign: "left",
					footerFontStyle: "bold",
					footerSpacing: 2,
					footerMarginTop: 6,
					footerFontColor: "#fff",
					footerAlign: "left",
					yPadding: 6,
					xPadding: 6,
					caretPadding: 2,
					caretSize: 5,
					cornerRadius: 6,
					multiKeyBackground: "#fff",
					displayColors: !0,
					borderColor: "rgba(0,0,0,0)",
					borderWidth: 0,
					callbacks: {
						beforeTitle: o.noop, title: function (t, e) {
							var i = "", n = e.labels, r = n ? n.length : 0;
							if (t.length > 0) {
								var o = t[0];
								o.xLabel ? i = o.xLabel : r > 0 && o.index < r && (i = n[o.index])
							}
							return i
						}, afterTitle: o.noop, beforeBody: o.noop, beforeLabel: o.noop, label: function (t, e) {
							var i = e.datasets[t.datasetIndex].label || "";
							return i && (i += ": "), i += t.yLabel
						}, labelColor: function (t, e) {
							var i = e.getDatasetMeta(t.datasetIndex).data[t.index]._view;
							return {borderColor: i.borderColor, backgroundColor: i.backgroundColor}
						}, labelTextColor: function () {
							return this._options.bodyFontColor
						}, afterLabel: o.noop, afterBody: o.noop, beforeFooter: o.noop, footer: o.noop, afterFooter: o.noop
					}
				}
			});
			var a = {
				average: function (t) {
					if (!t.length) return !1;
					var e, i, n = 0, r = 0, o = 0;
					for (e = 0, i = t.length; e < i; ++e) {
						var a = t[e];
						if (a && a.hasValue()) {
							var s = a.tooltipPosition();
							n += s.x, r += s.y, ++o
						}
					}
					return {x: Math.round(n / o), y: Math.round(r / o)}
				}, nearest: function (t, e) {
					var i, n, r, a = e.x, s = e.y, l = Number.POSITIVE_INFINITY;
					for (i = 0, n = t.length; i < n; ++i) {
						var c = t[i];
						if (c && c.hasValue()) {
							var u = c.getCenterPoint(), h = o.distanceBetweenPoints(e, u);
							h < l && (l = h, r = c)
						}
					}
					if (r) {
						var d = r.tooltipPosition();
						a = d.x, s = d.y
					}
					return {x: a, y: s}
				}
			};

			function s(t, e) {
				var i = o.color(t);
				return i.alpha(e * i.alpha()).rgbaString()
			}

			function l(t, e) {
				return e && (o.isArray(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t
			}

			function c(t) {
				return ("string" == typeof t || t instanceof String) && t.indexOf("\n") > -1 ? t.split("\n") : t
			}

			function u(t) {
				var e = n.global, i = o.valueOrDefault;
				return {
					xPadding: t.xPadding,
					yPadding: t.yPadding,
					xAlign: t.xAlign,
					yAlign: t.yAlign,
					bodyFontColor: t.bodyFontColor,
					_bodyFontFamily: i(t.bodyFontFamily, e.defaultFontFamily),
					_bodyFontStyle: i(t.bodyFontStyle, e.defaultFontStyle),
					_bodyAlign: t.bodyAlign,
					bodyFontSize: i(t.bodyFontSize, e.defaultFontSize),
					bodySpacing: t.bodySpacing,
					titleFontColor: t.titleFontColor,
					_titleFontFamily: i(t.titleFontFamily, e.defaultFontFamily),
					_titleFontStyle: i(t.titleFontStyle, e.defaultFontStyle),
					titleFontSize: i(t.titleFontSize, e.defaultFontSize),
					_titleAlign: t.titleAlign,
					titleSpacing: t.titleSpacing,
					titleMarginBottom: t.titleMarginBottom,
					footerFontColor: t.footerFontColor,
					_footerFontFamily: i(t.footerFontFamily, e.defaultFontFamily),
					_footerFontStyle: i(t.footerFontStyle, e.defaultFontStyle),
					footerFontSize: i(t.footerFontSize, e.defaultFontSize),
					_footerAlign: t.footerAlign,
					footerSpacing: t.footerSpacing,
					footerMarginTop: t.footerMarginTop,
					caretSize: t.caretSize,
					cornerRadius: t.cornerRadius,
					backgroundColor: t.backgroundColor,
					opacity: 0,
					legendColorBackground: t.multiKeyBackground,
					displayColors: t.displayColors,
					borderColor: t.borderColor,
					borderWidth: t.borderWidth
				}
			}

			function h(t) {
				return l([], c(t))
			}

			(e.exports = r.extend({
				initialize: function () {
					this._model = u(this._options), this._lastActive = []
				}, getTitle: function () {
					var t = this._options.callbacks, e = t.beforeTitle.apply(this, arguments), i = t.title.apply(this, arguments), n = t.afterTitle.apply(this, arguments), r = [];
					return r = l(r, c(e)), r = l(r, c(i)), r = l(r, c(n))
				}, getBeforeBody: function () {
					return h(this._options.callbacks.beforeBody.apply(this, arguments))
				}, getBody: function (t, e) {
					var i = this, n = i._options.callbacks, r = [];
					return o.each(t, function (t) {
						var o = {before: [], lines: [], after: []};
						l(o.before, c(n.beforeLabel.call(i, t, e))), l(o.lines, n.label.call(i, t, e)), l(o.after, c(n.afterLabel.call(i, t, e))), r.push(o)
					}), r
				}, getAfterBody: function () {
					return h(this._options.callbacks.afterBody.apply(this, arguments))
				}, getFooter: function () {
					var t = this._options.callbacks, e = t.beforeFooter.apply(this, arguments), i = t.footer.apply(this, arguments), n = t.afterFooter.apply(this, arguments), r = [];
					return r = l(r, c(e)), r = l(r, c(i)), r = l(r, c(n))
				}, update: function (t) {
					var e, i, n, r, s, l, c, h = this, d = h._options, p = h._model, f = h._model = u(d), m = h._active, g = h._data, v = {xAlign: p.xAlign, yAlign: p.yAlign}, y = {x: p.x, y: p.y}, b = {width: p.width, height: p.height}, w = {x: p.caretX, y: p.caretY};
					if (m.length) {
						f.opacity = 1;
						var x = [], k = [];
						w = a[d.position].call(h, m, h._eventPosition);
						var _ = [];
						for (e = 0, i = m.length; e < i; ++e) _.push((n = m[e], r = void 0, s = void 0, l = void 0, c = void 0, r = n._xScale, s = n._yScale || n._scale, l = n._index, c = n._datasetIndex, {
							xLabel: r ? r.getLabelForIndex(l, c) : "",
							yLabel: s ? s.getLabelForIndex(l, c) : "",
							index: l,
							datasetIndex: c,
							x: n._model.x,
							y: n._model.y
						}));
						d.filter && (_ = _.filter(function (t) {
							return d.filter(t, g)
						})), d.itemSort && (_ = _.sort(function (t, e) {
							return d.itemSort(t, e, g)
						})), o.each(_, function (t) {
							x.push(d.callbacks.labelColor.call(h, t, h._chart)), k.push(d.callbacks.labelTextColor.call(h, t, h._chart))
						}), f.title = h.getTitle(_, g), f.beforeBody = h.getBeforeBody(_, g), f.body = h.getBody(_, g), f.afterBody = h.getAfterBody(_, g), f.footer = h.getFooter(_, g), f.x = Math.round(w.x), f.y = Math.round(w.y), f.caretPadding = d.caretPadding, f.labelColors = x, f.labelTextColors = k, f.dataPoints = _, b = function (t, e) {
							var i = t._chart.ctx, n = 2 * e.yPadding, r = 0, a = e.body, s = a.reduce(function (t, e) {
								return t + e.before.length + e.lines.length + e.after.length
							}, 0);
							s += e.beforeBody.length + e.afterBody.length;
							var l = e.title.length, c = e.footer.length, u = e.titleFontSize, h = e.bodyFontSize, d = e.footerFontSize;
							n += l * u, n += l ? (l - 1) * e.titleSpacing : 0, n += l ? e.titleMarginBottom : 0, n += s * h, n += s ? (s - 1) * e.bodySpacing : 0, n += c ? e.footerMarginTop : 0, n += c * d, n += c ? (c - 1) * e.footerSpacing : 0;
							var p = 0, f = function (t) {
								r = Math.max(r, i.measureText(t).width + p)
							};
							return i.font = o.fontString(u, e._titleFontStyle, e._titleFontFamily), o.each(e.title, f), i.font = o.fontString(h, e._bodyFontStyle, e._bodyFontFamily), o.each(e.beforeBody.concat(e.afterBody), f), p = e.displayColors ? h + 2 : 0, o.each(a, function (t) {
								o.each(t.before, f), o.each(t.lines, f), o.each(t.after, f)
							}), p = 0, i.font = o.fontString(d, e._footerFontStyle, e._footerFontFamily), o.each(e.footer, f), {width: r += 2 * e.xPadding, height: n}
						}(this, f), y = function (t, e, i, n) {
							var r = t.x, o = t.y, a = t.caretSize, s = t.caretPadding, l = t.cornerRadius, c = i.xAlign, u = i.yAlign, h = a + s, d = l + s;
							return "right" === c ? r -= e.width : "center" === c && ((r -= e.width / 2) + e.width > n.width && (r = n.width - e.width), r < 0 && (r = 0)), "top" === u ? o += h : o -= "bottom" === u ? e.height + h : e.height / 2, "center" === u ? "left" === c ? r += h : "right" === c && (r -= h) : "left" === c ? r -= d : "right" === c && (r += d), {
								x: r,
								y: o
							}
						}(f, b, v = function (t, e) {
							var i, n, r, o, a, s = t._model, l = t._chart, c = t._chart.chartArea, u = "center", h = "center";
							s.y < e.height ? h = "top" : s.y > l.height - e.height && (h = "bottom");
							var d = (c.left + c.right) / 2, p = (c.top + c.bottom) / 2;
							"center" === h ? (i = function (t) {
								return t <= d
							}, n = function (t) {
								return t > d
							}) : (i = function (t) {
								return t <= e.width / 2
							}, n = function (t) {
								return t >= l.width - e.width / 2
							}), r = function (t) {
								return t + e.width + s.caretSize + s.caretPadding > l.width
							}, o = function (t) {
								return t - e.width - s.caretSize - s.caretPadding < 0
							}, a = function (t) {
								return t <= p ? "top" : "bottom"
							}, i(s.x) ? (u = "left", r(s.x) && (u = "center", h = a(s.y))) : n(s.x) && (u = "right", o(s.x) && (u = "center", h = a(s.y)));
							var f = t._options;
							return {xAlign: f.xAlign ? f.xAlign : u, yAlign: f.yAlign ? f.yAlign : h}
						}(this, b), h._chart)
					} else f.opacity = 0;
					return f.xAlign = v.xAlign, f.yAlign = v.yAlign, f.x = y.x, f.y = y.y, f.width = b.width, f.height = b.height, f.caretX = w.x, f.caretY = w.y, h._model = f, t && d.custom && d.custom.call(h, f), h
				}, drawCaret: function (t, e) {
					var i = this._chart.ctx, n = this._view, r = this.getCaretPosition(t, e, n);
					i.lineTo(r.x1, r.y1), i.lineTo(r.x2, r.y2), i.lineTo(r.x3, r.y3)
				}, getCaretPosition: function (t, e, i) {
					var n, r, o, a, s, l, c = i.caretSize, u = i.cornerRadius, h = i.xAlign, d = i.yAlign, p = t.x, f = t.y, m = e.width, g = e.height;
					if ("center" === d) s = f + g / 2, "left" === h ? (r = (n = p) - c, o = n, a = s + c, l = s - c) : (r = (n = p + m) + c, o = n, a = s - c, l = s + c); else if ("left" === h ? (n = (r = p + u + c) - c, o = r + c) : "right" === h ? (n = (r = p + m - u - c) - c, o = r + c) : (n = (r = i.caretX) - c, o = r + c), "top" === d) s = (a = f) - c, l = a; else {
						s = (a = f + g) + c, l = a;
						var v = o;
						o = n, n = v
					}
					return {x1: n, x2: r, x3: o, y1: a, y2: s, y3: l}
				}, drawTitle: function (t, e, i, n) {
					var r = e.title;
					if (r.length) {
						i.textAlign = e._titleAlign, i.textBaseline = "top";
						var a, l, c = e.titleFontSize, u = e.titleSpacing;
						for (i.fillStyle = s(e.titleFontColor, n), i.font = o.fontString(c, e._titleFontStyle, e._titleFontFamily), a = 0, l = r.length; a < l; ++a) i.fillText(r[a], t.x, t.y), t.y += c + u, a + 1 === r.length && (t.y += e.titleMarginBottom - u)
					}
				}, drawBody: function (t, e, i, n) {
					var r = e.bodyFontSize, a = e.bodySpacing, l = e.body;
					i.textAlign = e._bodyAlign, i.textBaseline = "top", i.font = o.fontString(r, e._bodyFontStyle, e._bodyFontFamily);
					var c = 0, u = function (e) {
						i.fillText(e, t.x + c, t.y), t.y += r + a
					};
					i.fillStyle = s(e.bodyFontColor, n), o.each(e.beforeBody, u);
					var h = e.displayColors;
					c = h ? r + 2 : 0, o.each(l, function (a, l) {
						var c = s(e.labelTextColors[l], n);
						i.fillStyle = c, o.each(a.before, u), o.each(a.lines, function (o) {
							h && (i.fillStyle = s(e.legendColorBackground, n), i.fillRect(t.x, t.y, r, r), i.lineWidth = 1, i.strokeStyle = s(e.labelColors[l].borderColor, n), i.strokeRect(t.x, t.y, r, r), i.fillStyle = s(e.labelColors[l].backgroundColor, n), i.fillRect(t.x + 1, t.y + 1, r - 2, r - 2), i.fillStyle = c), u(o)
						}), o.each(a.after, u)
					}), c = 0, o.each(e.afterBody, u), t.y -= a
				}, drawFooter: function (t, e, i, n) {
					var r = e.footer;
					r.length && (t.y += e.footerMarginTop, i.textAlign = e._footerAlign, i.textBaseline = "top", i.fillStyle = s(e.footerFontColor, n), i.font = o.fontString(e.footerFontSize, e._footerFontStyle, e._footerFontFamily), o.each(r, function (n) {
						i.fillText(n, t.x, t.y), t.y += e.footerFontSize + e.footerSpacing
					}))
				}, drawBackground: function (t, e, i, n, r) {
					i.fillStyle = s(e.backgroundColor, r), i.strokeStyle = s(e.borderColor, r), i.lineWidth = e.borderWidth;
					var o = e.xAlign, a = e.yAlign, l = t.x, c = t.y, u = n.width, h = n.height, d = e.cornerRadius;
					i.beginPath(), i.moveTo(l + d, c), "top" === a && this.drawCaret(t, n), i.lineTo(l + u - d, c), i.quadraticCurveTo(l + u, c, l + u, c + d), "center" === a && "right" === o && this.drawCaret(t, n), i.lineTo(l + u, c + h - d), i.quadraticCurveTo(l + u, c + h, l + u - d, c + h), "bottom" === a && this.drawCaret(t, n), i.lineTo(l + d, c + h), i.quadraticCurveTo(l, c + h, l, c + h - d), "center" === a && "left" === o && this.drawCaret(t, n), i.lineTo(l, c + d), i.quadraticCurveTo(l, c, l + d, c), i.closePath(), i.fill(), e.borderWidth > 0 && i.stroke()
				}, draw: function () {
					var t = this._chart.ctx, e = this._view;
					if (0 !== e.opacity) {
						var i = {width: e.width, height: e.height}, n = {x: e.x, y: e.y}, r = Math.abs(e.opacity < .001) ? 0 : e.opacity, o = e.title.length || e.beforeBody.length || e.body.length || e.afterBody.length || e.footer.length;
						this._options.enabled && o && (this.drawBackground(n, e, t, i, r), n.x += e.xPadding, n.y += e.yPadding, this.drawTitle(n, e, t, r), this.drawBody(n, e, t, r), this.drawFooter(n, e, t, r))
					}
				}, handleEvent: function (t) {
					var e, i = this, n = i._options;
					return i._lastActive = i._lastActive || [], "mouseout" === t.type ? i._active = [] : i._active = i._chart.getElementsAtEventForMode(t, n.mode, n), (e = !o.arrayEquals(i._active, i._lastActive)) && (i._lastActive = i._active, (n.enabled || n.custom) && (i._eventPosition = {
						x: t.x,
						y: t.y
					}, i.update(!0), i.pivot())), e
				}
			})).positioners = a
		}, {26: 26, 27: 27, 46: 46}], 37: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(27), o = t(46);
			n._set("global", {elements: {arc: {backgroundColor: n.global.defaultColor, borderColor: "#fff", borderWidth: 2}}}), e.exports = r.extend({
				inLabelRange: function (t) {
					var e = this._view;
					return !!e && Math.pow(t - e.x, 2) < Math.pow(e.radius + e.hoverRadius, 2)
				}, inRange: function (t, e) {
					var i = this._view;
					if (i) {
						for (var n = o.getAngleFromPoint(i, {x: t, y: e}), r = n.angle, a = n.distance, s = i.startAngle, l = i.endAngle; l < s;) l += 2 * Math.PI;
						for (; r > l;) r -= 2 * Math.PI;
						for (; r < s;) r += 2 * Math.PI;
						var c = r >= s && r <= l, u = a >= i.innerRadius && a <= i.outerRadius;
						return c && u
					}
					return !1
				}, getCenterPoint: function () {
					var t = this._view, e = (t.startAngle + t.endAngle) / 2, i = (t.innerRadius + t.outerRadius) / 2;
					return {x: t.x + Math.cos(e) * i, y: t.y + Math.sin(e) * i}
				}, getArea: function () {
					var t = this._view;
					return Math.PI * ((t.endAngle - t.startAngle) / (2 * Math.PI)) * (Math.pow(t.outerRadius, 2) - Math.pow(t.innerRadius, 2))
				}, tooltipPosition: function () {
					var t = this._view, e = t.startAngle + (t.endAngle - t.startAngle) / 2, i = (t.outerRadius - t.innerRadius) / 2 + t.innerRadius;
					return {x: t.x + Math.cos(e) * i, y: t.y + Math.sin(e) * i}
				}, draw: function () {
					var t = this._chart.ctx, e = this._view, i = e.startAngle, n = e.endAngle;
					t.beginPath(), t.arc(e.x, e.y, e.outerRadius, i, n), t.arc(e.x, e.y, e.innerRadius, n, i, !0), t.closePath(), t.strokeStyle = e.borderColor, t.lineWidth = e.borderWidth, t.fillStyle = e.backgroundColor, t.fill(), t.lineJoin = "bevel", e.borderWidth && t.stroke()
				}
			})
		}, {26: 26, 27: 27, 46: 46}], 38: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(27), o = t(46), a = n.global;
			n._set("global", {elements: {line: {tension: .4, backgroundColor: a.defaultColor, borderWidth: 3, borderColor: a.defaultColor, borderCapStyle: "butt", borderDash: [], borderDashOffset: 0, borderJoinStyle: "miter", capBezierPoints: !0, fill: !0}}}), e.exports = r.extend({
				draw: function () {
					var t, e, i, n, r = this._view, s = this._chart.ctx, l = r.spanGaps, c = this._children.slice(), u = a.elements.line, h = -1;
					for (this._loop && c.length && c.push(c[0]), s.save(), s.lineCap = r.borderCapStyle || u.borderCapStyle, s.setLineDash && s.setLineDash(r.borderDash || u.borderDash), s.lineDashOffset = r.borderDashOffset || u.borderDashOffset, s.lineJoin = r.borderJoinStyle || u.borderJoinStyle, s.lineWidth = r.borderWidth || u.borderWidth, s.strokeStyle = r.borderColor || a.defaultColor, s.beginPath(), h = -1, t = 0; t < c.length; ++t) e = c[t], i = o.previousItem(c, t), n = e._view, 0 === t ? n.skip || (s.moveTo(n.x, n.y), h = t) : (i = -1 === h ? i : c[h], n.skip || (h !== t - 1 && !l || -1 === h ? s.moveTo(n.x, n.y) : o.canvas.lineTo(s, i._view, e._view), h = t));
					s.stroke(), s.restore()
				}
			})
		}, {26: 26, 27: 27, 46: 46}], 39: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(27), o = t(46), a = n.global.defaultColor;

			function s(t) {
				var e = this._view;
				return !!e && Math.abs(t - e.x) < e.radius + e.hitRadius
			}

			n._set("global", {elements: {point: {radius: 3, pointStyle: "circle", backgroundColor: a, borderColor: a, borderWidth: 1, hitRadius: 1, hoverRadius: 4, hoverBorderWidth: 1}}}), e.exports = r.extend({
				inRange: function (t, e) {
					var i = this._view;
					return !!i && Math.pow(t - i.x, 2) + Math.pow(e - i.y, 2) < Math.pow(i.hitRadius + i.radius, 2)
				}, inLabelRange: s, inXRange: s, inYRange: function (t) {
					var e = this._view;
					return !!e && Math.abs(t - e.y) < e.radius + e.hitRadius
				}, getCenterPoint: function () {
					var t = this._view;
					return {x: t.x, y: t.y}
				}, getArea: function () {
					return Math.PI * Math.pow(this._view.radius, 2)
				}, tooltipPosition: function () {
					var t = this._view;
					return {x: t.x, y: t.y, padding: t.radius + t.borderWidth}
				}, draw: function (t) {
					var e = this._view, i = this._model, r = this._chart.ctx, s = e.pointStyle, l = e.rotation, c = e.radius, u = e.x, h = e.y;
					e.skip || (void 0 === t || i.x >= t.left && 1.01 * t.right >= i.x && i.y >= t.top && 1.01 * t.bottom >= i.y) && (r.strokeStyle = e.borderColor || a, r.lineWidth = o.valueOrDefault(e.borderWidth, n.global.elements.point.borderWidth), r.fillStyle = e.backgroundColor || a, o.canvas.drawPoint(r, s, c, u, h, l))
				}
			})
		}, {26: 26, 27: 27, 46: 46}], 40: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(27);

			function o(t) {
				return void 0 !== t._view.width
			}

			function a(t) {
				var e, i, n, r, a = t._view;
				if (o(t)) {
					var s = a.width / 2;
					e = a.x - s, i = a.x + s, n = Math.min(a.y, a.base), r = Math.max(a.y, a.base)
				} else {
					var l = a.height / 2;
					e = Math.min(a.x, a.base), i = Math.max(a.x, a.base), n = a.y - l, r = a.y + l
				}
				return {left: e, top: n, right: i, bottom: r}
			}

			n._set("global", {elements: {rectangle: {backgroundColor: n.global.defaultColor, borderColor: n.global.defaultColor, borderSkipped: "bottom", borderWidth: 0}}}), e.exports = r.extend({
				draw: function () {
					var t, e, i, n, r, o, a, s = this._chart.ctx, l = this._view, c = l.borderWidth;
					if (l.horizontal ? (t = l.base, e = l.x, i = l.y - l.height / 2, n = l.y + l.height / 2, r = e > t ? 1 : -1, o = 1, a = l.borderSkipped || "left") : (t = l.x - l.width / 2, e = l.x + l.width / 2, i = l.y, r = 1, o = (n = l.base) > i ? 1 : -1, a = l.borderSkipped || "bottom"), c) {
						var u = Math.min(Math.abs(t - e), Math.abs(i - n)), h = (c = c > u ? u : c) / 2, d = t + ("left" !== a ? h * r : 0), p = e + ("right" !== a ? -h * r : 0), f = i + ("top" !== a ? h * o : 0), m = n + ("bottom" !== a ? -h * o : 0);
						d !== p && (i = f, n = m), f !== m && (t = d, e = p)
					}
					s.beginPath(), s.fillStyle = l.backgroundColor, s.strokeStyle = l.borderColor, s.lineWidth = c;
					var g = [[t, n], [t, i], [e, i], [e, n]], v = ["bottom", "left", "top", "right"].indexOf(a, 0);

					function y(t) {
						return g[(v + t) % 4]
					}

					-1 === v && (v = 0);
					var b = y(0);
					s.moveTo(b[0], b[1]);
					for (var w = 1; w < 4; w++) b = y(w), s.lineTo(b[0], b[1]);
					s.fill(), c && s.stroke()
				}, height: function () {
					var t = this._view;
					return t.base - t.y
				}, inRange: function (t, e) {
					var i = !1;
					if (this._view) {
						var n = a(this);
						i = t >= n.left && t <= n.right && e >= n.top && e <= n.bottom
					}
					return i
				}, inLabelRange: function (t, e) {
					if (!this._view) return !1;
					var i = a(this);
					return o(this) ? t >= i.left && t <= i.right : e >= i.top && e <= i.bottom
				}, inXRange: function (t) {
					var e = a(this);
					return t >= e.left && t <= e.right
				}, inYRange: function (t) {
					var e = a(this);
					return t >= e.top && t <= e.bottom
				}, getCenterPoint: function () {
					var t, e, i = this._view;
					return o(this) ? (t = i.x, e = (i.y + i.base) / 2) : (t = (i.x + i.base) / 2, e = i.y), {x: t, y: e}
				}, getArea: function () {
					var t = this._view;
					return t.width * Math.abs(t.y - t.base)
				}, tooltipPosition: function () {
					var t = this._view;
					return {x: t.x, y: t.y}
				}
			})
		}, {26: 26, 27: 27}], 41: [function (t, e, i) {
			"use strict";
			e.exports = {}, e.exports.Arc = t(37), e.exports.Line = t(38), e.exports.Point = t(39), e.exports.Rectangle = t(40)
		}, {37: 37, 38: 38, 39: 39, 40: 40}], 42: [function (t, e, i) {
			"use strict";
			var n = t(43);
			i = e.exports = {
				clear: function (t) {
					t.ctx.clearRect(0, 0, t.width, t.height)
				}, roundedRect: function (t, e, i, n, r, o) {
					if (o) {
						var a = Math.min(o, r / 2 - 1e-7, n / 2 - 1e-7);
						t.moveTo(e + a, i), t.lineTo(e + n - a, i), t.arcTo(e + n, i, e + n, i + a, a), t.lineTo(e + n, i + r - a), t.arcTo(e + n, i + r, e + n - a, i + r, a), t.lineTo(e + a, i + r), t.arcTo(e, i + r, e, i + r - a, a), t.lineTo(e, i + a), t.arcTo(e, i, e + a, i, a), t.closePath(), t.moveTo(e, i)
					} else t.rect(e, i, n, r)
				}, drawPoint: function (t, e, i, n, r, o) {
					var a, s, l, c, u, h;
					if (o = o || 0, !e || "object" != typeof e || "[object HTMLImageElement]" !== (a = e.toString()) && "[object HTMLCanvasElement]" !== a) {
						if (!(isNaN(i) || i <= 0)) {
							switch (t.save(), t.translate(n, r), t.rotate(o * Math.PI / 180), t.beginPath(), e) {
								default:
									t.arc(0, 0, i, 0, 2 * Math.PI), t.closePath();
									break;
								case"triangle":
									u = (s = 3 * i / Math.sqrt(3)) * Math.sqrt(3) / 2, t.moveTo(-s / 2, u / 3), t.lineTo(s / 2, u / 3), t.lineTo(0, -2 * u / 3), t.closePath();
									break;
								case"rect":
									h = 1 / Math.SQRT2 * i, t.rect(-h, -h, 2 * h, 2 * h);
									break;
								case"rectRounded":
									var d = i / Math.SQRT2, p = -d, f = -d, m = Math.SQRT2 * i;
									this.roundedRect(t, p, f, m, m, .425 * i);
									break;
								case"rectRot":
									h = 1 / Math.SQRT2 * i, t.moveTo(-h, 0), t.lineTo(0, h), t.lineTo(h, 0), t.lineTo(0, -h), t.closePath();
									break;
								case"cross":
									t.moveTo(0, i), t.lineTo(0, -i), t.moveTo(-i, 0), t.lineTo(i, 0);
									break;
								case"crossRot":
									l = Math.cos(Math.PI / 4) * i, c = Math.sin(Math.PI / 4) * i, t.moveTo(-l, -c), t.lineTo(l, c), t.moveTo(-l, c), t.lineTo(l, -c);
									break;
								case"star":
									t.moveTo(0, i), t.lineTo(0, -i), t.moveTo(-i, 0), t.lineTo(i, 0), l = Math.cos(Math.PI / 4) * i, c = Math.sin(Math.PI / 4) * i, t.moveTo(-l, -c), t.lineTo(l, c), t.moveTo(-l, c), t.lineTo(l, -c);
									break;
								case"line":
									t.moveTo(-i, 0), t.lineTo(i, 0);
									break;
								case"dash":
									t.moveTo(0, 0), t.lineTo(i, 0)
							}
							t.fill(), t.stroke(), t.restore()
						}
					} else t.drawImage(e, n - e.width / 2, r - e.height / 2, e.width, e.height)
				}, clipArea: function (t, e) {
					t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip()
				}, unclipArea: function (t) {
					t.restore()
				}, lineTo: function (t, e, i, n) {
					if (i.steppedLine) return "after" === i.steppedLine && !n || "after" !== i.steppedLine && n ? t.lineTo(e.x, i.y) : t.lineTo(i.x, e.y), void t.lineTo(i.x, i.y);
					i.tension ? t.bezierCurveTo(n ? e.controlPointPreviousX : e.controlPointNextX, n ? e.controlPointPreviousY : e.controlPointNextY, n ? i.controlPointNextX : i.controlPointPreviousX, n ? i.controlPointNextY : i.controlPointPreviousY, i.x, i.y) : t.lineTo(i.x, i.y)
				}
			};
			n.clear = i.clear, n.drawRoundedRectangle = function (t) {
				t.beginPath(), i.roundedRect.apply(i, arguments)
			}
		}, {43: 43}], 43: [function (t, e, i) {
			"use strict";
			var n, r = {
				noop: function () {
				}, uid: (n = 0, function () {
					return n++
				}), isNullOrUndef: function (t) {
					return null == t
				}, isArray: Array.isArray ? Array.isArray : function (t) {
					return "[object Array]" === Object.prototype.toString.call(t)
				}, isObject: function (t) {
					return null !== t && "[object Object]" === Object.prototype.toString.call(t)
				}, valueOrDefault: function (t, e) {
					return void 0 === t ? e : t
				}, valueAtIndexOrDefault: function (t, e, i) {
					return r.valueOrDefault(r.isArray(t) ? t[e] : t, i)
				}, callback: function (t, e, i) {
					if (t && "function" == typeof t.call) return t.apply(i, e)
				}, each: function (t, e, i, n) {
					var o, a, s;
					if (r.isArray(t)) if (a = t.length, n) for (o = a - 1; o >= 0; o--) e.call(i, t[o], o); else for (o = 0; o < a; o++) e.call(i, t[o], o); else if (r.isObject(t)) for (a = (s = Object.keys(t)).length, o = 0; o < a; o++) e.call(i, t[s[o]], s[o])
				}, arrayEquals: function (t, e) {
					var i, n, o, a;
					if (!t || !e || t.length !== e.length) return !1;
					for (i = 0, n = t.length; i < n; ++i) if (o = t[i], a = e[i], o instanceof Array && a instanceof Array) {
						if (!r.arrayEquals(o, a)) return !1
					} else if (o !== a) return !1;
					return !0
				}, clone: function (t) {
					if (r.isArray(t)) return t.map(r.clone);
					if (r.isObject(t)) {
						for (var e = {}, i = Object.keys(t), n = i.length, o = 0; o < n; ++o) e[i[o]] = r.clone(t[i[o]]);
						return e
					}
					return t
				}, _merger: function (t, e, i, n) {
					var o = e[t], a = i[t];
					r.isObject(o) && r.isObject(a) ? r.merge(o, a, n) : e[t] = r.clone(a)
				}, _mergerIf: function (t, e, i) {
					var n = e[t], o = i[t];
					r.isObject(n) && r.isObject(o) ? r.mergeIf(n, o) : e.hasOwnProperty(t) || (e[t] = r.clone(o))
				}, merge: function (t, e, i) {
					var n, o, a, s, l, c = r.isArray(e) ? e : [e], u = c.length;
					if (!r.isObject(t)) return t;
					for (n = (i = i || {}).merger || r._merger, o = 0; o < u; ++o) if (e = c[o], r.isObject(e)) for (l = 0, s = (a = Object.keys(e)).length; l < s; ++l) n(a[l], t, e, i);
					return t
				}, mergeIf: function (t, e) {
					return r.merge(t, e, {merger: r._mergerIf})
				}, extend: function (t) {
					for (var e = function (e, i) {
						t[i] = e
					}, i = 1, n = arguments.length; i < n; ++i) r.each(arguments[i], e);
					return t
				}, inherits: function (t) {
					var e = this, i = t && t.hasOwnProperty("constructor") ? t.constructor : function () {
						return e.apply(this, arguments)
					}, n = function () {
						this.constructor = i
					};
					return n.prototype = e.prototype, i.prototype = new n, i.extend = r.inherits, t && r.extend(i.prototype, t), i.__super__ = e.prototype, i
				}
			};
			e.exports = r, r.callCallback = r.callback, r.indexOf = function (t, e, i) {
				return Array.prototype.indexOf.call(t, e, i)
			}, r.getValueOrDefault = r.valueOrDefault, r.getValueAtIndexOrDefault = r.valueAtIndexOrDefault
		}, {}], 44: [function (t, e, i) {
			"use strict";
			var n = t(43), r = {
				linear: function (t) {
					return t
				}, easeInQuad: function (t) {
					return t * t
				}, easeOutQuad: function (t) {
					return -t * (t - 2)
				}, easeInOutQuad: function (t) {
					return (t /= .5) < 1 ? .5 * t * t : -.5 * (--t * (t - 2) - 1)
				}, easeInCubic: function (t) {
					return t * t * t
				}, easeOutCubic: function (t) {
					return (t -= 1) * t * t + 1
				}, easeInOutCubic: function (t) {
					return (t /= .5) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2)
				}, easeInQuart: function (t) {
					return t * t * t * t
				}, easeOutQuart: function (t) {
					return -((t -= 1) * t * t * t - 1)
				}, easeInOutQuart: function (t) {
					return (t /= .5) < 1 ? .5 * t * t * t * t : -.5 * ((t -= 2) * t * t * t - 2)
				}, easeInQuint: function (t) {
					return t * t * t * t * t
				}, easeOutQuint: function (t) {
					return (t -= 1) * t * t * t * t + 1
				}, easeInOutQuint: function (t) {
					return (t /= .5) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2)
				}, easeInSine: function (t) {
					return 1 - Math.cos(t * (Math.PI / 2))
				}, easeOutSine: function (t) {
					return Math.sin(t * (Math.PI / 2))
				}, easeInOutSine: function (t) {
					return -.5 * (Math.cos(Math.PI * t) - 1)
				}, easeInExpo: function (t) {
					return 0 === t ? 0 : Math.pow(2, 10 * (t - 1))
				}, easeOutExpo: function (t) {
					return 1 === t ? 1 : 1 - Math.pow(2, -10 * t)
				}, easeInOutExpo: function (t) {
					return 0 === t ? 0 : 1 === t ? 1 : (t /= .5) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (2 - Math.pow(2, -10 * --t))
				}, easeInCirc: function (t) {
					return t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1)
				}, easeOutCirc: function (t) {
					return Math.sqrt(1 - (t -= 1) * t)
				}, easeInOutCirc: function (t) {
					return (t /= .5) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1)
				}, easeInElastic: function (t) {
					var e = 1.70158, i = 0, n = 1;
					return 0 === t ? 0 : 1 === t ? 1 : (i || (i = .3), n < 1 ? (n = 1, e = i / 4) : e = i / (2 * Math.PI) * Math.asin(1 / n), -n * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / i))
				}, easeOutElastic: function (t) {
					var e = 1.70158, i = 0, n = 1;
					return 0 === t ? 0 : 1 === t ? 1 : (i || (i = .3), n < 1 ? (n = 1, e = i / 4) : e = i / (2 * Math.PI) * Math.asin(1 / n), n * Math.pow(2, -10 * t) * Math.sin((t - e) * (2 * Math.PI) / i) + 1)
				}, easeInOutElastic: function (t) {
					var e = 1.70158, i = 0, n = 1;
					return 0 === t ? 0 : 2 == (t /= .5) ? 1 : (i || (i = .45), n < 1 ? (n = 1, e = i / 4) : e = i / (2 * Math.PI) * Math.asin(1 / n), t < 1 ? n * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / i) * -.5 : n * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / i) * .5 + 1)
				}, easeInBack: function (t) {
					var e = 1.70158;
					return t * t * ((e + 1) * t - e)
				}, easeOutBack: function (t) {
					var e = 1.70158;
					return (t -= 1) * t * ((e + 1) * t + e) + 1
				}, easeInOutBack: function (t) {
					var e = 1.70158;
					return (t /= .5) < 1 ? t * t * ((1 + (e *= 1.525)) * t - e) * .5 : .5 * ((t -= 2) * t * ((1 + (e *= 1.525)) * t + e) + 2)
				}, easeInBounce: function (t) {
					return 1 - r.easeOutBounce(1 - t)
				}, easeOutBounce: function (t) {
					return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375
				}, easeInOutBounce: function (t) {
					return t < .5 ? .5 * r.easeInBounce(2 * t) : .5 * r.easeOutBounce(2 * t - 1) + .5
				}
			};
			e.exports = {effects: r}, n.easingEffects = r
		}, {43: 43}], 45: [function (t, e, i) {
			"use strict";
			var n = t(43);
			e.exports = {
				toLineHeight: function (t, e) {
					var i = ("" + t).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
					if (!i || "normal" === i[1]) return 1.2 * e;
					switch (t = +i[2], i[3]) {
						case"px":
							return t;
						case"%":
							t /= 100
					}
					return e * t
				}, toPadding: function (t) {
					var e, i, r, o;
					return n.isObject(t) ? (e = +t.top || 0, i = +t.right || 0, r = +t.bottom || 0, o = +t.left || 0) : e = i = r = o = +t || 0, {top: e, right: i, bottom: r, left: o, height: e + r, width: o + i}
				}, resolve: function (t, e, i) {
					var r, o, a;
					for (r = 0, o = t.length; r < o; ++r) if (void 0 !== (a = t[r]) && (void 0 !== e && "function" == typeof a && (a = a(e)), void 0 !== i && n.isArray(a) && (a = a[i]), void 0 !== a)) return a
				}
			}
		}, {43: 43}], 46: [function (t, e, i) {
			"use strict";
			e.exports = t(43), e.exports.easing = t(44), e.exports.canvas = t(42), e.exports.options = t(45)
		}, {42: 42, 43: 43, 44: 44, 45: 45}], 47: [function (t, e, i) {
			e.exports = {
				acquireContext: function (t) {
					return t && t.canvas && (t = t.canvas), t && t.getContext("2d") || null
				}
			}
		}, {}], 48: [function (t, e, i) {
			"use strict";
			var n = t(46), r = "$chartjs", o = "chartjs-", a = o + "render-monitor", s = o + "render-animation", l = ["animationstart", "webkitAnimationStart"],
				c = {touchstart: "mousedown", touchmove: "mousemove", touchend: "mouseup", pointerenter: "mouseenter", pointerdown: "mousedown", pointermove: "mousemove", pointerup: "mouseup", pointerleave: "mouseout", pointerout: "mouseout"};

			function u(t, e) {
				var i = n.getStyle(t, e), r = i && i.match(/^(\d+)(\.\d+)?px$/);
				return r ? Number(r[1]) : void 0
			}

			var h = !!function () {
				var t = !1;
				try {
					var e = Object.defineProperty({}, "passive", {
						get: function () {
							t = !0
						}
					});
					window.addEventListener("e", null, e)
				} catch (t) {
				}
				return t
			}() && {passive: !0};

			function d(t, e, i) {
				t.addEventListener(e, i, h)
			}

			function p(t, e, i) {
				t.removeEventListener(e, i, h)
			}

			function f(t, e, i, n, r) {
				return {type: t, chart: e, native: r || null, x: void 0 !== i ? i : null, y: void 0 !== n ? n : null}
			}

			function m(t, e, i) {
				var c, u, h, p, m = t[r] || (t[r] = {}), g = m.resizer = function (t) {
					var e = document.createElement("div"), i = o + "size-monitor", n = "position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;";
					e.style.cssText = n, e.className = i, e.innerHTML = '<div class="' + i + '-expand" style="' + n + '"><div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div></div><div class="' + i + '-shrink" style="' + n + '"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div>';
					var r = e.childNodes[0], a = e.childNodes[1];
					e._reset = function () {
						r.scrollLeft = 1e6, r.scrollTop = 1e6, a.scrollLeft = 1e6, a.scrollTop = 1e6
					};
					var s = function () {
						e._reset(), t()
					};
					return d(r, "scroll", s.bind(r, "expand")), d(a, "scroll", s.bind(a, "shrink")), e
				}((c = function () {
					if (m.resizer) return e(f("resize", i))
				}, h = !1, p = [], function () {
					p = Array.prototype.slice.call(arguments), u = u || this, h || (h = !0, n.requestAnimFrame.call(window, function () {
						h = !1, c.apply(u, p)
					}))
				}));
				!function (t, e) {
					var i = t[r] || (t[r] = {}), o = i.renderProxy = function (t) {
						t.animationName === s && e()
					};
					n.each(l, function (e) {
						d(t, e, o)
					}), i.reflow = !!t.offsetParent, t.classList.add(a)
				}(t, function () {
					if (m.resizer) {
						var e = t.parentNode;
						e && e !== g.parentNode && e.insertBefore(g, e.firstChild), g._reset()
					}
				})
			}

			function g(t) {
				var e = t[r] || {}, i = e.resizer;
				delete e.resizer, function (t) {
					var e = t[r] || {}, i = e.renderProxy;
					i && (n.each(l, function (e) {
						p(t, e, i)
					}), delete e.renderProxy), t.classList.remove(a)
				}(t), i && i.parentNode && i.parentNode.removeChild(i)
			}

			e.exports = {
				_enabled: "undefined" != typeof window && "undefined" != typeof document, initialize: function () {
					var t, e, i, n = "from{opacity:0.99}to{opacity:1}";
					e = "@-webkit-keyframes " + s + "{" + n + "}@keyframes " + s + "{" + n + "}." + a + "{-webkit-animation:" + s + " 0.001s;animation:" + s + " 0.001s;}", i = (t = this)._style || document.createElement("style"), t._style || (t._style = i, e = "/* Chart.js */\n" + e, i.setAttribute("type", "text/css"), document.getElementsByTagName("head")[0].appendChild(i)), i.appendChild(document.createTextNode(e))
				}, acquireContext: function (t, e) {
					"string" == typeof t ? t = document.getElementById(t) : t.length && (t = t[0]), t && t.canvas && (t = t.canvas);
					var i = t && t.getContext && t.getContext("2d");
					return i && i.canvas === t ? (function (t, e) {
						var i = t.style, n = t.getAttribute("height"), o = t.getAttribute("width");
						if (t[r] = {initial: {height: n, width: o, style: {display: i.display, height: i.height, width: i.width}}}, i.display = i.display || "block", null === o || "" === o) {
							var a = u(t, "width");
							void 0 !== a && (t.width = a)
						}
						if (null === n || "" === n) if ("" === t.style.height) t.height = t.width / (e.options.aspectRatio || 2); else {
							var s = u(t, "height");
							void 0 !== a && (t.height = s)
						}
					}(t, e), i) : null
				}, releaseContext: function (t) {
					var e = t.canvas;
					if (e[r]) {
						var i = e[r].initial;
						["height", "width"].forEach(function (t) {
							var r = i[t];
							n.isNullOrUndef(r) ? e.removeAttribute(t) : e.setAttribute(t, r)
						}), n.each(i.style || {}, function (t, i) {
							e.style[i] = t
						}), e.width = e.width, delete e[r]
					}
				}, addEventListener: function (t, e, i) {
					var o = t.canvas;
					if ("resize" !== e) {
						var a = i[r] || (i[r] = {});
						d(o, e, (a.proxies || (a.proxies = {}))[t.id + "_" + e] = function (e) {
							i(function (t, e) {
								var i = c[t.type] || t.type, r = n.getRelativePosition(t, e);
								return f(i, e, r.x, r.y, t)
							}(e, t))
						})
					} else m(o, i, t)
				}, removeEventListener: function (t, e, i) {
					var n = t.canvas;
					if ("resize" !== e) {
						var o = ((i[r] || {}).proxies || {})[t.id + "_" + e];
						o && p(n, e, o)
					} else g(n)
				}
			}, n.addEvent = d, n.removeEvent = p
		}, {46: 46}], 49: [function (t, e, i) {
			"use strict";
			var n = t(46), r = t(47), o = t(48), a = o._enabled ? o : r;
			e.exports = n.extend({
				initialize: function () {
				}, acquireContext: function () {
				}, releaseContext: function () {
				}, addEventListener: function () {
				}, removeEventListener: function () {
				}
			}, a)
		}, {46: 46, 47: 47, 48: 48}], 50: [function (t, e, i) {
			"use strict";
			e.exports = {}, e.exports.filler = t(51), e.exports.legend = t(52), e.exports.title = t(53)
		}, {51: 51, 52: 52, 53: 53}], 51: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(41), o = t(46);
			n._set("global", {plugins: {filler: {propagate: !0}}});
			var a = {
				dataset: function (t) {
					var e = t.fill, i = t.chart, n = i.getDatasetMeta(e), r = n && i.isDatasetVisible(e) && n.dataset._children || [], o = r.length || 0;
					return o ? function (t, e) {
						return e < o && r[e]._view || null
					} : null
				}, boundary: function (t) {
					var e = t.boundary, i = e ? e.x : null, n = e ? e.y : null;
					return function (t) {
						return {x: null === i ? t.x : i, y: null === n ? t.y : n}
					}
				}
			};

			function s(t, e, i) {
				var n, r = t._model || {}, o = r.fill;
				if (void 0 === o && (o = !!r.backgroundColor), !1 === o || null === o) return !1;
				if (!0 === o) return "origin";
				if (n = parseFloat(o, 10), isFinite(n) && Math.floor(n) === n) return "-" !== o[0] && "+" !== o[0] || (n = e + n), !(n === e || n < 0 || n >= i) && n;
				switch (o) {
					case"bottom":
						return "start";
					case"top":
						return "end";
					case"zero":
						return "origin";
					case"origin":
					case"start":
					case"end":
						return o;
					default:
						return !1
				}
			}

			function l(t) {
				var e, i = t.el._model || {}, n = t.el._scale || {}, r = t.fill, o = null;
				if (isFinite(r)) return null;
				if ("start" === r ? o = void 0 === i.scaleBottom ? n.bottom : i.scaleBottom : "end" === r ? o = void 0 === i.scaleTop ? n.top : i.scaleTop : void 0 !== i.scaleZero ? o = i.scaleZero : n.getBasePosition ? o = n.getBasePosition() : n.getBasePixel && (o = n.getBasePixel()), null != o) {
					if (void 0 !== o.x && void 0 !== o.y) return o;
					if ("number" == typeof o && isFinite(o)) return {x: (e = n.isHorizontal()) ? o : null, y: e ? null : o}
				}
				return null
			}

			function c(t, e, i) {
				var n, r = t[e].fill, o = [e];
				if (!i) return r;
				for (; !1 !== r && -1 === o.indexOf(r);) {
					if (!isFinite(r)) return r;
					if (!(n = t[r])) return !1;
					if (n.visible) return r;
					o.push(r), r = n.fill
				}
				return !1
			}

			function u(t) {
				var e = t.fill, i = "dataset";
				return !1 === e ? null : (isFinite(e) || (i = "boundary"), a[i](t))
			}

			function h(t) {
				return t && !t.skip
			}

			function d(t, e, i, n, r) {
				var a;
				if (n && r) {
					for (t.moveTo(e[0].x, e[0].y), a = 1; a < n; ++a) o.canvas.lineTo(t, e[a - 1], e[a]);
					for (t.lineTo(i[r - 1].x, i[r - 1].y), a = r - 1; a > 0; --a) o.canvas.lineTo(t, i[a], i[a - 1], !0)
				}
			}

			e.exports = {
				id: "filler", afterDatasetsUpdate: function (t, e) {
					var i, n, o, a, h = (t.data.datasets || []).length, d = e.propagate, p = [];
					for (n = 0; n < h; ++n) a = null, (o = (i = t.getDatasetMeta(n)).dataset) && o._model && o instanceof r.Line && (a = {visible: t.isDatasetVisible(n), fill: s(o, n, h), chart: t, el: o}), i.$filler = a, p.push(a);
					for (n = 0; n < h; ++n) (a = p[n]) && (a.fill = c(p, n, d), a.boundary = l(a), a.mapper = u(a))
				}, beforeDatasetDraw: function (t, e) {
					var i = e.meta.$filler;
					if (i) {
						var r = t.ctx, a = i.el, s = a._view, l = a._children || [], c = i.mapper, u = s.backgroundColor || n.global.defaultColor;
						c && u && l.length && (o.canvas.clipArea(r, t.chartArea), function (t, e, i, n, r, o) {
							var a, s, l, c, u, p, f, m = e.length, g = n.spanGaps, v = [], y = [], b = 0, w = 0;
							for (t.beginPath(), a = 0, s = m + !!o; a < s; ++a) u = i(c = e[l = a % m]._view, l, n), p = h(c), f = h(u), p && f ? (b = v.push(c), w = y.push(u)) : b && w && (g ? (p && v.push(c), f && y.push(u)) : (d(t, v, y, b, w), b = w = 0, v = [], y = []));
							d(t, v, y, b, w), t.closePath(), t.fillStyle = r, t.fill()
						}(r, l, c, s, u, a._loop), o.canvas.unclipArea(r))
					}
				}
			}
		}, {26: 26, 41: 41, 46: 46}], 52: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(27), o = t(46), a = t(31), s = o.noop;

			function l(t, e) {
				return t.usePointStyle ? e * Math.SQRT2 : t.boxWidth
			}

			n._set("global", {
				legend: {
					display: !0, position: "top", fullWidth: !0, reverse: !1, weight: 1e3, onClick: function (t, e) {
						var i = e.datasetIndex, n = this.chart, r = n.getDatasetMeta(i);
						r.hidden = null === r.hidden ? !n.data.datasets[i].hidden : null, n.update()
					}, onHover: null, labels: {
						boxWidth: 40, padding: 10, generateLabels: function (t) {
							var e = t.data;
							return o.isArray(e.datasets) ? e.datasets.map(function (e, i) {
								return {
									text: e.label,
									fillStyle: o.isArray(e.backgroundColor) ? e.backgroundColor[0] : e.backgroundColor,
									hidden: !t.isDatasetVisible(i),
									lineCap: e.borderCapStyle,
									lineDash: e.borderDash,
									lineDashOffset: e.borderDashOffset,
									lineJoin: e.borderJoinStyle,
									lineWidth: e.borderWidth,
									strokeStyle: e.borderColor,
									pointStyle: e.pointStyle,
									datasetIndex: i
								}
							}, this) : []
						}
					}
				}, legendCallback: function (t) {
					var e = [];
					e.push('<ul class="' + t.id + '-legend">');
					for (var i = 0; i < t.data.datasets.length; i++) e.push('<li><span style="background-color:' + t.data.datasets[i].backgroundColor + '"></span>'), t.data.datasets[i].label && e.push(t.data.datasets[i].label), e.push("</li>");
					return e.push("</ul>"), e.join("")
				}
			});
			var c = r.extend({
				initialize: function (t) {
					o.extend(this, t), this.legendHitBoxes = [], this.doughnutMode = !1
				}, beforeUpdate: s, update: function (t, e, i) {
					var n = this;
					return n.beforeUpdate(), n.maxWidth = t, n.maxHeight = e, n.margins = i, n.beforeSetDimensions(), n.setDimensions(), n.afterSetDimensions(), n.beforeBuildLabels(), n.buildLabels(), n.afterBuildLabels(), n.beforeFit(), n.fit(), n.afterFit(), n.afterUpdate(), n.minSize
				}, afterUpdate: s, beforeSetDimensions: s, setDimensions: function () {
					var t = this;
					t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0, t.minSize = {width: 0, height: 0}
				}, afterSetDimensions: s, beforeBuildLabels: s, buildLabels: function () {
					var t = this, e = t.options.labels || {}, i = o.callback(e.generateLabels, [t.chart], t) || [];
					e.filter && (i = i.filter(function (i) {
						return e.filter(i, t.chart.data)
					})), t.options.reverse && i.reverse(), t.legendItems = i
				}, afterBuildLabels: s, beforeFit: s, fit: function () {
					var t = this, e = t.options, i = e.labels, r = e.display, a = t.ctx, s = n.global, c = o.valueOrDefault, u = c(i.fontSize, s.defaultFontSize), h = c(i.fontStyle, s.defaultFontStyle), d = c(i.fontFamily, s.defaultFontFamily), p = o.fontString(u, h, d), f = t.legendHitBoxes = [],
						m = t.minSize, g = t.isHorizontal();
					if (g ? (m.width = t.maxWidth, m.height = r ? 10 : 0) : (m.width = r ? 10 : 0, m.height = t.maxHeight), r) if (a.font = p, g) {
						var v = t.lineWidths = [0], y = t.legendItems.length ? u + i.padding : 0;
						a.textAlign = "left", a.textBaseline = "top", o.each(t.legendItems, function (e, n) {
							var r = l(i, u) + u / 2 + a.measureText(e.text).width;
							v[v.length - 1] + r + i.padding >= t.width && (y += u + i.padding, v[v.length] = t.left), f[n] = {left: 0, top: 0, width: r, height: u}, v[v.length - 1] += r + i.padding
						}), m.height += y
					} else {
						var b = i.padding, w = t.columnWidths = [], x = i.padding, k = 0, _ = 0, S = u + b;
						o.each(t.legendItems, function (t, e) {
							var n = l(i, u) + u / 2 + a.measureText(t.text).width;
							_ + S > m.height && (x += k + i.padding, w.push(k), k = 0, _ = 0), k = Math.max(k, n), _ += S, f[e] = {left: 0, top: 0, width: n, height: u}
						}), x += k, w.push(k), m.width += x
					}
					t.width = m.width, t.height = m.height
				}, afterFit: s, isHorizontal: function () {
					return "top" === this.options.position || "bottom" === this.options.position
				}, draw: function () {
					var t = this, e = t.options, i = e.labels, r = n.global, a = r.elements.line, s = t.width, c = t.lineWidths;
					if (e.display) {
						var u, h = t.ctx, d = o.valueOrDefault, p = d(i.fontColor, r.defaultFontColor), f = d(i.fontSize, r.defaultFontSize), m = d(i.fontStyle, r.defaultFontStyle), g = d(i.fontFamily, r.defaultFontFamily), v = o.fontString(f, m, g);
						h.textAlign = "left", h.textBaseline = "middle", h.lineWidth = .5, h.strokeStyle = p, h.fillStyle = p, h.font = v;
						var y = l(i, f), b = t.legendHitBoxes, w = t.isHorizontal();
						u = w ? {x: t.left + (s - c[0]) / 2, y: t.top + i.padding, line: 0} : {x: t.left + i.padding, y: t.top + i.padding, line: 0};
						var x = f + i.padding;
						o.each(t.legendItems, function (n, l) {
							var p = h.measureText(n.text).width, m = y + f / 2 + p, g = u.x, v = u.y;
							w ? g + m >= s && (v = u.y += x, u.line++, g = u.x = t.left + (s - c[u.line]) / 2) : v + x > t.bottom && (g = u.x = g + t.columnWidths[u.line] + i.padding, v = u.y = t.top + i.padding, u.line++), function (t, i, n) {
								if (!(isNaN(y) || y <= 0)) {
									h.save(), h.fillStyle = d(n.fillStyle, r.defaultColor), h.lineCap = d(n.lineCap, a.borderCapStyle), h.lineDashOffset = d(n.lineDashOffset, a.borderDashOffset), h.lineJoin = d(n.lineJoin, a.borderJoinStyle), h.lineWidth = d(n.lineWidth, a.borderWidth), h.strokeStyle = d(n.strokeStyle, r.defaultColor);
									var s = 0 === d(n.lineWidth, a.borderWidth);
									if (h.setLineDash && h.setLineDash(d(n.lineDash, a.borderDash)), e.labels && e.labels.usePointStyle) {
										var l = f * Math.SQRT2 / 2, c = l / Math.SQRT2, u = t + c, p = i + c;
										o.canvas.drawPoint(h, n.pointStyle, l, u, p)
									} else s || h.strokeRect(t, i, y, f), h.fillRect(t, i, y, f);
									h.restore()
								}
							}(g, v, n), b[l].left = g, b[l].top = v, function (t, e, i, n) {
								var r = f / 2, o = y + r + t, a = e + r;
								h.fillText(i.text, o, a), i.hidden && (h.beginPath(), h.lineWidth = 2, h.moveTo(o, a), h.lineTo(o + n, a), h.stroke())
							}(g, v, n, p), w ? u.x += m + i.padding : u.y += x
						})
					}
				}, handleEvent: function (t) {
					var e = this, i = e.options, n = "mouseup" === t.type ? "click" : t.type, r = !1;
					if ("mousemove" === n) {
						if (!i.onHover) return
					} else {
						if ("click" !== n) return;
						if (!i.onClick) return
					}
					var o = t.x, a = t.y;
					if (o >= e.left && o <= e.right && a >= e.top && a <= e.bottom) for (var s = e.legendHitBoxes, l = 0; l < s.length; ++l) {
						var c = s[l];
						if (o >= c.left && o <= c.left + c.width && a >= c.top && a <= c.top + c.height) {
							if ("click" === n) {
								i.onClick.call(e, t.native, e.legendItems[l]), r = !0;
								break
							}
							if ("mousemove" === n) {
								i.onHover.call(e, t.native, e.legendItems[l]), r = !0;
								break
							}
						}
					}
					return r
				}
			});

			function u(t, e) {
				var i = new c({ctx: t.ctx, options: e, chart: t});
				a.configure(t, i, e), a.addBox(t, i), t.legend = i
			}

			e.exports = {
				id: "legend", _element: c, beforeInit: function (t) {
					var e = t.options.legend;
					e && u(t, e)
				}, beforeUpdate: function (t) {
					var e = t.options.legend, i = t.legend;
					e ? (o.mergeIf(e, n.global.legend), i ? (a.configure(t, i, e), i.options = e) : u(t, e)) : i && (a.removeBox(t, i), delete t.legend)
				}, afterEvent: function (t, e) {
					var i = t.legend;
					i && i.handleEvent(e)
				}
			}
		}, {26: 26, 27: 27, 31: 31, 46: 46}], 53: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(27), o = t(46), a = t(31), s = o.noop;
			n._set("global", {title: {display: !1, fontStyle: "bold", fullWidth: !0, lineHeight: 1.2, padding: 10, position: "top", text: "", weight: 2e3}});
			var l = r.extend({
				initialize: function (t) {
					o.extend(this, t), this.legendHitBoxes = []
				}, beforeUpdate: s, update: function (t, e, i) {
					var n = this;
					return n.beforeUpdate(), n.maxWidth = t, n.maxHeight = e, n.margins = i, n.beforeSetDimensions(), n.setDimensions(), n.afterSetDimensions(), n.beforeBuildLabels(), n.buildLabels(), n.afterBuildLabels(), n.beforeFit(), n.fit(), n.afterFit(), n.afterUpdate(), n.minSize
				}, afterUpdate: s, beforeSetDimensions: s, setDimensions: function () {
					var t = this;
					t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0, t.minSize = {width: 0, height: 0}
				}, afterSetDimensions: s, beforeBuildLabels: s, buildLabels: s, afterBuildLabels: s, beforeFit: s, fit: function () {
					var t = this, e = o.valueOrDefault, i = t.options, r = i.display, a = e(i.fontSize, n.global.defaultFontSize), s = t.minSize, l = o.isArray(i.text) ? i.text.length : 1, c = o.options.toLineHeight(i.lineHeight, a), u = r ? l * c + 2 * i.padding : 0;
					t.isHorizontal() ? (s.width = t.maxWidth, s.height = u) : (s.width = u, s.height = t.maxHeight), t.width = s.width, t.height = s.height
				}, afterFit: s, isHorizontal: function () {
					var t = this.options.position;
					return "top" === t || "bottom" === t
				}, draw: function () {
					var t = this, e = t.ctx, i = o.valueOrDefault, r = t.options, a = n.global;
					if (r.display) {
						var s, l, c, u = i(r.fontSize, a.defaultFontSize), h = i(r.fontStyle, a.defaultFontStyle), d = i(r.fontFamily, a.defaultFontFamily), p = o.fontString(u, h, d), f = o.options.toLineHeight(r.lineHeight, u), m = f / 2 + r.padding, g = 0, v = t.top, y = t.left, b = t.bottom,
							w = t.right;
						e.fillStyle = i(r.fontColor, a.defaultFontColor), e.font = p, t.isHorizontal() ? (l = y + (w - y) / 2, c = v + m, s = w - y) : (l = "left" === r.position ? y + m : w - m, c = v + (b - v) / 2, s = b - v, g = Math.PI * ("left" === r.position ? -.5 : .5)), e.save(), e.translate(l, c), e.rotate(g), e.textAlign = "center", e.textBaseline = "middle";
						var x = r.text;
						if (o.isArray(x)) for (var k = 0, _ = 0; _ < x.length; ++_) e.fillText(x[_], 0, k, s), k += f; else e.fillText(x, 0, 0, s);
						e.restore()
					}
				}
			});

			function c(t, e) {
				var i = new l({ctx: t.ctx, options: e, chart: t});
				a.configure(t, i, e), a.addBox(t, i), t.titleBlock = i
			}

			e.exports = {
				id: "title", _element: l, beforeInit: function (t) {
					var e = t.options.title;
					e && c(t, e)
				}, beforeUpdate: function (t) {
					var e = t.options.title, i = t.titleBlock;
					e ? (o.mergeIf(e, n.global.title), i ? (a.configure(t, i, e), i.options = e) : c(t, e)) : i && (a.removeBox(t, i), delete t.titleBlock)
				}
			}
		}, {26: 26, 27: 27, 31: 31, 46: 46}], 54: [function (t, e, i) {
			"use strict";
			var n = t(33), r = t(34);
			e.exports = function () {
				var t = n.extend({
					getLabels: function () {
						var t = this.chart.data;
						return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels
					}, determineDataLimits: function () {
						var t, e = this, i = e.getLabels();
						e.minIndex = 0, e.maxIndex = i.length - 1, void 0 !== e.options.ticks.min && (t = i.indexOf(e.options.ticks.min), e.minIndex = -1 !== t ? t : e.minIndex), void 0 !== e.options.ticks.max && (t = i.indexOf(e.options.ticks.max), e.maxIndex = -1 !== t ? t : e.maxIndex), e.min = i[e.minIndex], e.max = i[e.maxIndex]
					}, buildTicks: function () {
						var t = this, e = t.getLabels();
						t.ticks = 0 === t.minIndex && t.maxIndex === e.length - 1 ? e : e.slice(t.minIndex, t.maxIndex + 1)
					}, getLabelForIndex: function (t, e) {
						var i = this, n = i.chart.data, r = i.isHorizontal();
						return n.yLabels && !r ? i.getRightValue(n.datasets[e].data[t]) : i.ticks[t - i.minIndex]
					}, getPixelForValue: function (t, e) {
						var i, n = this, r = n.options.offset, o = Math.max(n.maxIndex + 1 - n.minIndex - (r ? 0 : 1), 1);
						if (null != t && (i = n.isHorizontal() ? t.x : t.y), void 0 !== i || void 0 !== t && isNaN(e)) {
							t = i || t;
							var a = n.getLabels().indexOf(t);
							e = -1 !== a ? a : e
						}
						if (n.isHorizontal()) {
							var s = n.width / o, l = s * (e - n.minIndex);
							return r && (l += s / 2), n.left + Math.round(l)
						}
						var c = n.height / o, u = c * (e - n.minIndex);
						return r && (u += c / 2), n.top + Math.round(u)
					}, getPixelForTick: function (t) {
						return this.getPixelForValue(this.ticks[t], t + this.minIndex, null)
					}, getValueForPixel: function (t) {
						var e = this, i = e.options.offset, n = Math.max(e._ticks.length - (i ? 0 : 1), 1), r = e.isHorizontal(), o = (r ? e.width : e.height) / n;
						return t -= r ? e.left : e.top, i && (t -= o / 2), (t <= 0 ? 0 : Math.round(t / o)) + e.minIndex
					}, getBasePixel: function () {
						return this.bottom
					}
				});
				r.registerScaleType("category", t, {position: "bottom"})
			}
		}, {33: 33, 34: 34}], 55: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(46), o = t(34), a = t(35);
			e.exports = function (t) {
				var e = {position: "left", ticks: {callback: a.formatters.linear}}, i = t.LinearScaleBase.extend({
					determineDataLimits: function () {
						var t = this, e = t.options, i = t.chart, n = i.data.datasets, o = t.isHorizontal();

						function a(e) {
							return o ? e.xAxisID === t.id : e.yAxisID === t.id
						}

						t.min = null, t.max = null;
						var s = e.stacked;
						if (void 0 === s && r.each(n, function (t, e) {
							if (!s) {
								var n = i.getDatasetMeta(e);
								i.isDatasetVisible(e) && a(n) && void 0 !== n.stack && (s = !0)
							}
						}), e.stacked || s) {
							var l = {};
							r.each(n, function (n, o) {
								var s = i.getDatasetMeta(o), c = [s.type, void 0 === e.stacked && void 0 === s.stack ? o : "", s.stack].join(".");
								void 0 === l[c] && (l[c] = {positiveValues: [], negativeValues: []});
								var u = l[c].positiveValues, h = l[c].negativeValues;
								i.isDatasetVisible(o) && a(s) && r.each(n.data, function (i, n) {
									var r = +t.getRightValue(i);
									isNaN(r) || s.data[n].hidden || (u[n] = u[n] || 0, h[n] = h[n] || 0, e.relativePoints ? u[n] = 100 : r < 0 ? h[n] += r : u[n] += r)
								})
							}), r.each(l, function (e) {
								var i = e.positiveValues.concat(e.negativeValues), n = r.min(i), o = r.max(i);
								t.min = null === t.min ? n : Math.min(t.min, n), t.max = null === t.max ? o : Math.max(t.max, o)
							})
						} else r.each(n, function (e, n) {
							var o = i.getDatasetMeta(n);
							i.isDatasetVisible(n) && a(o) && r.each(e.data, function (e, i) {
								var n = +t.getRightValue(e);
								isNaN(n) || o.data[i].hidden || (null === t.min ? t.min = n : n < t.min && (t.min = n), null === t.max ? t.max = n : n > t.max && (t.max = n))
							})
						});
						t.min = isFinite(t.min) && !isNaN(t.min) ? t.min : 0, t.max = isFinite(t.max) && !isNaN(t.max) ? t.max : 1, this.handleTickRangeOptions()
					}, getTickLimit: function () {
						var t, e = this.options.ticks;
						if (this.isHorizontal()) t = Math.min(e.maxTicksLimit ? e.maxTicksLimit : 11, Math.ceil(this.width / 50)); else {
							var i = r.valueOrDefault(e.fontSize, n.global.defaultFontSize);
							t = Math.min(e.maxTicksLimit ? e.maxTicksLimit : 11, Math.ceil(this.height / (2 * i)))
						}
						return t
					}, handleDirectionalChanges: function () {
						this.isHorizontal() || this.ticks.reverse()
					}, getLabelForIndex: function (t, e) {
						return +this.getRightValue(this.chart.data.datasets[e].data[t])
					}, getPixelForValue: function (t) {
						var e = this, i = e.start, n = +e.getRightValue(t), r = e.end - i;
						return e.isHorizontal() ? e.left + e.width / r * (n - i) : e.bottom - e.height / r * (n - i)
					}, getValueForPixel: function (t) {
						var e = this, i = e.isHorizontal(), n = i ? e.width : e.height, r = (i ? t - e.left : e.bottom - t) / n;
						return e.start + (e.end - e.start) * r
					}, getPixelForTick: function (t) {
						return this.getPixelForValue(this.ticksAsNumbers[t])
					}
				});
				o.registerScaleType("linear", i, e)
			}
		}, {26: 26, 34: 34, 35: 35, 46: 46}], 56: [function (t, e, i) {
			"use strict";
			var n = t(46), r = t(33);
			e.exports = function (t) {
				var e = n.noop;
				t.LinearScaleBase = r.extend({
					getRightValue: function (t) {
						return "string" == typeof t ? +t : r.prototype.getRightValue.call(this, t)
					}, handleTickRangeOptions: function () {
						var t = this, e = t.options.ticks;
						if (e.beginAtZero) {
							var i = n.sign(t.min), r = n.sign(t.max);
							i < 0 && r < 0 ? t.max = 0 : i > 0 && r > 0 && (t.min = 0)
						}
						var o = void 0 !== e.min || void 0 !== e.suggestedMin, a = void 0 !== e.max || void 0 !== e.suggestedMax;
						void 0 !== e.min ? t.min = e.min : void 0 !== e.suggestedMin && (null === t.min ? t.min = e.suggestedMin : t.min = Math.min(t.min, e.suggestedMin)), void 0 !== e.max ? t.max = e.max : void 0 !== e.suggestedMax && (null === t.max ? t.max = e.suggestedMax : t.max = Math.max(t.max, e.suggestedMax)), o !== a && t.min >= t.max && (o ? t.max = t.min + 1 : t.min = t.max - 1), t.min === t.max && (t.max++, e.beginAtZero || t.min--)
					}, getTickLimit: e, handleDirectionalChanges: e, buildTicks: function () {
						var t = this, e = t.options.ticks, i = t.getTickLimit(), r = {maxTicks: i = Math.max(2, i), min: e.min, max: e.max, precision: e.precision, stepSize: n.valueOrDefault(e.fixedStepSize, e.stepSize)}, o = t.ticks = function (t, e) {
							var i, r, o, a = [];
							if (t.stepSize && t.stepSize > 0) o = t.stepSize; else {
								var s = n.niceNum(e.max - e.min, !1);
								o = n.niceNum(s / (t.maxTicks - 1), !0), void 0 !== (r = t.precision) && (i = Math.pow(10, r), o = Math.ceil(o * i) / i)
							}
							var l = Math.floor(e.min / o) * o, c = Math.ceil(e.max / o) * o;
							n.isNullOrUndef(t.min) || n.isNullOrUndef(t.max) || !t.stepSize || n.almostWhole((t.max - t.min) / t.stepSize, o / 1e3) && (l = t.min, c = t.max);
							var u = (c - l) / o;
							u = n.almostEquals(u, Math.round(u), o / 1e3) ? Math.round(u) : Math.ceil(u), r = 1, o < 1 && (r = Math.pow(10, 1 - Math.floor(n.log10(o))), l = Math.round(l * r) / r, c = Math.round(c * r) / r), a.push(void 0 !== t.min ? t.min : l);
							for (var h = 1; h < u; ++h) a.push(Math.round((l + h * o) * r) / r);
							return a.push(void 0 !== t.max ? t.max : c), a
						}(r, t);
						t.handleDirectionalChanges(), t.max = n.max(o), t.min = n.min(o), e.reverse ? (o.reverse(), t.start = t.max, t.end = t.min) : (t.start = t.min, t.end = t.max)
					}, convertTicksToLabels: function () {
						var t = this;
						t.ticksAsNumbers = t.ticks.slice(), t.zeroLineIndex = t.ticks.indexOf(0), r.prototype.convertTicksToLabels.call(t)
					}
				})
			}
		}, {33: 33, 46: 46}], 57: [function (t, e, i) {
			"use strict";
			var n = t(46), r = t(33), o = t(34), a = t(35);
			e.exports = function (t) {
				var e = {position: "left", ticks: {callback: a.formatters.logarithmic}}, i = r.extend({
					determineDataLimits: function () {
						var t = this, e = t.options, i = t.chart, r = i.data.datasets, o = t.isHorizontal();

						function a(e) {
							return o ? e.xAxisID === t.id : e.yAxisID === t.id
						}

						t.min = null, t.max = null, t.minNotZero = null;
						var s = e.stacked;
						if (void 0 === s && n.each(r, function (t, e) {
							if (!s) {
								var n = i.getDatasetMeta(e);
								i.isDatasetVisible(e) && a(n) && void 0 !== n.stack && (s = !0)
							}
						}), e.stacked || s) {
							var l = {};
							n.each(r, function (r, o) {
								var s = i.getDatasetMeta(o), c = [s.type, void 0 === e.stacked && void 0 === s.stack ? o : "", s.stack].join(".");
								i.isDatasetVisible(o) && a(s) && (void 0 === l[c] && (l[c] = []), n.each(r.data, function (e, i) {
									var n = l[c], r = +t.getRightValue(e);
									isNaN(r) || s.data[i].hidden || r < 0 || (n[i] = n[i] || 0, n[i] += r)
								}))
							}), n.each(l, function (e) {
								if (e.length > 0) {
									var i = n.min(e), r = n.max(e);
									t.min = null === t.min ? i : Math.min(t.min, i), t.max = null === t.max ? r : Math.max(t.max, r)
								}
							})
						} else n.each(r, function (e, r) {
							var o = i.getDatasetMeta(r);
							i.isDatasetVisible(r) && a(o) && n.each(e.data, function (e, i) {
								var n = +t.getRightValue(e);
								isNaN(n) || o.data[i].hidden || n < 0 || (null === t.min ? t.min = n : n < t.min && (t.min = n), null === t.max ? t.max = n : n > t.max && (t.max = n), 0 !== n && (null === t.minNotZero || n < t.minNotZero) && (t.minNotZero = n))
							})
						});
						this.handleTickRangeOptions()
					}, handleTickRangeOptions: function () {
						var t = this, e = t.options.ticks, i = n.valueOrDefault;
						t.min = i(e.min, t.min), t.max = i(e.max, t.max), t.min === t.max && (0 !== t.min && null !== t.min ? (t.min = Math.pow(10, Math.floor(n.log10(t.min)) - 1), t.max = Math.pow(10, Math.floor(n.log10(t.max)) + 1)) : (t.min = 1, t.max = 10)), null === t.min && (t.min = Math.pow(10, Math.floor(n.log10(t.max)) - 1)), null === t.max && (t.max = 0 !== t.min ? Math.pow(10, Math.floor(n.log10(t.min)) + 1) : 10), null === t.minNotZero && (t.min > 0 ? t.minNotZero = t.min : t.max < 1 ? t.minNotZero = Math.pow(10, Math.floor(n.log10(t.max))) : t.minNotZero = 1)
					}, buildTicks: function () {
						var t = this, e = t.options.ticks, i = !t.isHorizontal(), r = {min: e.min, max: e.max}, o = t.ticks = function (t, e) {
							var i, r, o = [], a = n.valueOrDefault, s = a(t.min, Math.pow(10, Math.floor(n.log10(e.min)))), l = Math.floor(n.log10(e.max)), c = Math.ceil(e.max / Math.pow(10, l));
							0 === s ? (i = Math.floor(n.log10(e.minNotZero)), r = Math.floor(e.minNotZero / Math.pow(10, i)), o.push(s), s = r * Math.pow(10, i)) : (i = Math.floor(n.log10(s)), r = Math.floor(s / Math.pow(10, i)));
							var u = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
							do {
								o.push(s), 10 == ++r && (r = 1, u = ++i >= 0 ? 1 : u), s = Math.round(r * Math.pow(10, i) * u) / u
							} while (i < l || i === l && r < c);
							var h = a(t.max, s);
							return o.push(h), o
						}(r, t);
						t.max = n.max(o), t.min = n.min(o), e.reverse ? (i = !i, t.start = t.max, t.end = t.min) : (t.start = t.min, t.end = t.max), i && o.reverse()
					}, convertTicksToLabels: function () {
						this.tickValues = this.ticks.slice(), r.prototype.convertTicksToLabels.call(this)
					}, getLabelForIndex: function (t, e) {
						return +this.getRightValue(this.chart.data.datasets[e].data[t])
					}, getPixelForTick: function (t) {
						return this.getPixelForValue(this.tickValues[t])
					}, _getFirstTickValue: function (t) {
						var e = Math.floor(n.log10(t));
						return Math.floor(t / Math.pow(10, e)) * Math.pow(10, e)
					}, getPixelForValue: function (e) {
						var i, r, o, a, s, l = this, c = l.options.ticks.reverse, u = n.log10, h = l._getFirstTickValue(l.minNotZero), d = 0;
						return e = +l.getRightValue(e), c ? (o = l.end, a = l.start, s = -1) : (o = l.start, a = l.end, s = 1), l.isHorizontal() ? (i = l.width, r = c ? l.right : l.left) : (i = l.height, s *= -1, r = c ? l.top : l.bottom), e !== o && (0 === o && (i -= d = n.getValueOrDefault(l.options.ticks.fontSize, t.defaults.global.defaultFontSize), o = h), 0 !== e && (d += i / (u(a) - u(o)) * (u(e) - u(o))), r += s * d), r
					}, getValueForPixel: function (e) {
						var i, r, o, a, s = this, l = s.options.ticks.reverse, c = n.log10, u = s._getFirstTickValue(s.minNotZero);
						if (l ? (r = s.end, o = s.start) : (r = s.start, o = s.end), s.isHorizontal() ? (i = s.width, a = l ? s.right - e : e - s.left) : (i = s.height, a = l ? e - s.top : s.bottom - e), a !== r) {
							if (0 === r) {
								var h = n.getValueOrDefault(s.options.ticks.fontSize, t.defaults.global.defaultFontSize);
								a -= h, i -= h, r = u
							}
							a *= c(o) - c(r), a /= i, a = Math.pow(10, c(r) + a)
						}
						return a
					}
				});
				o.registerScaleType("logarithmic", i, e)
			}
		}, {33: 33, 34: 34, 35: 35, 46: 46}], 58: [function (t, e, i) {
			"use strict";
			var n = t(26), r = t(46), o = t(34), a = t(35);
			e.exports = function (t) {
				var e = n.global, i = {
					display: !0,
					animate: !0,
					position: "chartArea",
					angleLines: {display: !0, color: "rgba(0, 0, 0, 0.1)", lineWidth: 1},
					gridLines: {circular: !1},
					ticks: {showLabelBackdrop: !0, backdropColor: "rgba(255,255,255,0.75)", backdropPaddingY: 2, backdropPaddingX: 2, callback: a.formatters.linear},
					pointLabels: {
						display: !0, fontSize: 10, callback: function (t) {
							return t
						}
					}
				};

				function s(t) {
					var e = t.options;
					return e.angleLines.display || e.pointLabels.display ? t.chart.data.labels.length : 0
				}

				function l(t) {
					var i = t.options.pointLabels, n = r.valueOrDefault(i.fontSize, e.defaultFontSize), o = r.valueOrDefault(i.fontStyle, e.defaultFontStyle), a = r.valueOrDefault(i.fontFamily, e.defaultFontFamily);
					return {size: n, style: o, family: a, font: r.fontString(n, o, a)}
				}

				function c(t, e, i, n, r) {
					return t === n || t === r ? {start: e - i / 2, end: e + i / 2} : t < n || t > r ? {start: e - i - 5, end: e} : {start: e, end: e + i + 5}
				}

				function u(t) {
					return 0 === t || 180 === t ? "center" : t < 180 ? "left" : "right"
				}

				function h(t, e, i, n) {
					if (r.isArray(e)) for (var o = i.y, a = 1.5 * n, s = 0; s < e.length; ++s) t.fillText(e[s], i.x, o), o += a; else t.fillText(e, i.x, i.y)
				}

				function d(t, e, i) {
					90 === t || 270 === t ? i.y -= e.h / 2 : (t > 270 || t < 90) && (i.y -= e.h)
				}

				function p(t) {
					return r.isNumber(t) ? t : 0
				}

				var f = t.LinearScaleBase.extend({
					setDimensions: function () {
						var t = this, i = t.options, n = i.ticks;
						t.width = t.maxWidth, t.height = t.maxHeight, t.xCenter = Math.round(t.width / 2), t.yCenter = Math.round(t.height / 2);
						var o = r.min([t.height, t.width]), a = r.valueOrDefault(n.fontSize, e.defaultFontSize);
						t.drawingArea = i.display ? o / 2 - (a / 2 + n.backdropPaddingY) : o / 2
					}, determineDataLimits: function () {
						var t = this, e = t.chart, i = Number.POSITIVE_INFINITY, n = Number.NEGATIVE_INFINITY;
						r.each(e.data.datasets, function (o, a) {
							if (e.isDatasetVisible(a)) {
								var s = e.getDatasetMeta(a);
								r.each(o.data, function (e, r) {
									var o = +t.getRightValue(e);
									isNaN(o) || s.data[r].hidden || (i = Math.min(o, i), n = Math.max(o, n))
								})
							}
						}), t.min = i === Number.POSITIVE_INFINITY ? 0 : i, t.max = n === Number.NEGATIVE_INFINITY ? 0 : n, t.handleTickRangeOptions()
					}, getTickLimit: function () {
						var t = this.options.ticks, i = r.valueOrDefault(t.fontSize, e.defaultFontSize);
						return Math.min(t.maxTicksLimit ? t.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * i)))
					}, convertTicksToLabels: function () {
						var e = this;
						t.LinearScaleBase.prototype.convertTicksToLabels.call(e), e.pointLabels = e.chart.data.labels.map(e.options.pointLabels.callback, e)
					}, getLabelForIndex: function (t, e) {
						return +this.getRightValue(this.chart.data.datasets[e].data[t])
					}, fit: function () {
						var t, e;
						this.options.pointLabels.display ? function (t) {
							var e, i, n, o = l(t), a = Math.min(t.height / 2, t.width / 2), u = {r: t.width, l: 0, t: t.height, b: 0}, h = {};
							t.ctx.font = o.font, t._pointLabelSizes = [];
							var d, p, f, m = s(t);
							for (e = 0; e < m; e++) {
								n = t.getPointPosition(e, a), d = t.ctx, p = o.size, f = t.pointLabels[e] || "", i = r.isArray(f) ? {w: r.longestText(d, d.font, f), h: f.length * p + 1.5 * (f.length - 1) * p} : {w: d.measureText(f).width, h: p}, t._pointLabelSizes[e] = i;
								var g = t.getIndexAngle(e), v = r.toDegrees(g) % 360, y = c(v, n.x, i.w, 0, 180), b = c(v, n.y, i.h, 90, 270);
								y.start < u.l && (u.l = y.start, h.l = g), y.end > u.r && (u.r = y.end, h.r = g), b.start < u.t && (u.t = b.start, h.t = g), b.end > u.b && (u.b = b.end, h.b = g)
							}
							t.setReductions(a, u, h)
						}(this) : (t = this, e = Math.min(t.height / 2, t.width / 2), t.drawingArea = Math.round(e), t.setCenterPoint(0, 0, 0, 0))
					}, setReductions: function (t, e, i) {
						var n = e.l / Math.sin(i.l), r = Math.max(e.r - this.width, 0) / Math.sin(i.r), o = -e.t / Math.cos(i.t), a = -Math.max(e.b - this.height, 0) / Math.cos(i.b);
						n = p(n), r = p(r), o = p(o), a = p(a), this.drawingArea = Math.min(Math.round(t - (n + r) / 2), Math.round(t - (o + a) / 2)), this.setCenterPoint(n, r, o, a)
					}, setCenterPoint: function (t, e, i, n) {
						var r = this, o = r.width - e - r.drawingArea, a = t + r.drawingArea, s = i + r.drawingArea, l = r.height - n - r.drawingArea;
						r.xCenter = Math.round((a + o) / 2 + r.left), r.yCenter = Math.round((s + l) / 2 + r.top)
					}, getIndexAngle: function (t) {
						return t * (2 * Math.PI / s(this)) + (this.chart.options && this.chart.options.startAngle ? this.chart.options.startAngle : 0) * Math.PI * 2 / 360
					}, getDistanceFromCenterForValue: function (t) {
						var e = this;
						if (null === t) return 0;
						var i = e.drawingArea / (e.max - e.min);
						return e.options.ticks.reverse ? (e.max - t) * i : (t - e.min) * i
					}, getPointPosition: function (t, e) {
						var i = this.getIndexAngle(t) - Math.PI / 2;
						return {x: Math.round(Math.cos(i) * e) + this.xCenter, y: Math.round(Math.sin(i) * e) + this.yCenter}
					}, getPointPositionForValue: function (t, e) {
						return this.getPointPosition(t, this.getDistanceFromCenterForValue(e))
					}, getBasePosition: function () {
						var t = this.min, e = this.max;
						return this.getPointPositionForValue(0, this.beginAtZero ? 0 : t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0)
					}, draw: function () {
						var t = this, i = t.options, n = i.gridLines, o = i.ticks, a = r.valueOrDefault;
						if (i.display) {
							var c = t.ctx, p = this.getIndexAngle(0), f = a(o.fontSize, e.defaultFontSize), m = a(o.fontStyle, e.defaultFontStyle), g = a(o.fontFamily, e.defaultFontFamily), v = r.fontString(f, m, g);
							r.each(t.ticks, function (i, l) {
								if (l > 0 || o.reverse) {
									var u = t.getDistanceFromCenterForValue(t.ticksAsNumbers[l]);
									if (n.display && 0 !== l && function (t, e, i, n) {
										var o = t.ctx;
										if (o.strokeStyle = r.valueAtIndexOrDefault(e.color, n - 1), o.lineWidth = r.valueAtIndexOrDefault(e.lineWidth, n - 1), t.options.gridLines.circular) o.beginPath(), o.arc(t.xCenter, t.yCenter, i, 0, 2 * Math.PI), o.closePath(), o.stroke(); else {
											var a = s(t);
											if (0 === a) return;
											o.beginPath();
											var l = t.getPointPosition(0, i);
											o.moveTo(l.x, l.y);
											for (var c = 1; c < a; c++) l = t.getPointPosition(c, i), o.lineTo(l.x, l.y);
											o.closePath(), o.stroke()
										}
									}(t, n, u, l), o.display) {
										var h = a(o.fontColor, e.defaultFontColor);
										if (c.font = v, c.save(), c.translate(t.xCenter, t.yCenter), c.rotate(p), o.showLabelBackdrop) {
											var d = c.measureText(i).width;
											c.fillStyle = o.backdropColor, c.fillRect(-d / 2 - o.backdropPaddingX, -u - f / 2 - o.backdropPaddingY, d + 2 * o.backdropPaddingX, f + 2 * o.backdropPaddingY)
										}
										c.textAlign = "center", c.textBaseline = "middle", c.fillStyle = h, c.fillText(i, 0, -u), c.restore()
									}
								}
							}), (i.angleLines.display || i.pointLabels.display) && function (t) {
								var i = t.ctx, n = t.options, o = n.angleLines, a = n.pointLabels;
								i.lineWidth = o.lineWidth, i.strokeStyle = o.color;
								var c = t.getDistanceFromCenterForValue(n.ticks.reverse ? t.min : t.max), p = l(t);
								i.textBaseline = "top";
								for (var f = s(t) - 1; f >= 0; f--) {
									if (o.display) {
										var m = t.getPointPosition(f, c);
										i.beginPath(), i.moveTo(t.xCenter, t.yCenter), i.lineTo(m.x, m.y), i.stroke(), i.closePath()
									}
									if (a.display) {
										var g = t.getPointPosition(f, c + 5), v = r.valueAtIndexOrDefault(a.fontColor, f, e.defaultFontColor);
										i.font = p.font, i.fillStyle = v;
										var y = t.getIndexAngle(f), b = r.toDegrees(y);
										i.textAlign = u(b), d(b, t._pointLabelSizes[f], g), h(i, t.pointLabels[f] || "", g, p.size)
									}
								}
							}(t)
						}
					}
				});
				o.registerScaleType("radialLinear", f, i)
			}
		}, {26: 26, 34: 34, 35: 35, 46: 46}], 59: [function (t, e, i) {
			"use strict";
			var n = t(6);
			n = "function" == typeof n ? n : window.moment;
			var r = t(26), o = t(46), a = t(33), s = t(34), l = Number.MIN_SAFE_INTEGER || -9007199254740991, c = Number.MAX_SAFE_INTEGER || 9007199254740991, u = {
				millisecond: {common: !0, size: 1, steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]},
				second: {common: !0, size: 1e3, steps: [1, 2, 5, 10, 15, 30]},
				minute: {common: !0, size: 6e4, steps: [1, 2, 5, 10, 15, 30]},
				hour: {common: !0, size: 36e5, steps: [1, 2, 3, 6, 12]},
				day: {common: !0, size: 864e5, steps: [1, 2, 5]},
				week: {common: !1, size: 6048e5, steps: [1, 2, 3, 4]},
				month: {common: !0, size: 2628e6, steps: [1, 2, 3]},
				quarter: {common: !1, size: 7884e6, steps: [1, 2, 3, 4]},
				year: {common: !0, size: 3154e7}
			}, h = Object.keys(u);

			function d(t, e) {
				return t - e
			}

			function p(t) {
				var e, i, n, r = {}, o = [];
				for (e = 0, i = t.length; e < i; ++e) r[n = t[e]] || (r[n] = !0, o.push(n));
				return o
			}

			function f(t, e, i, n) {
				var r = function (t, e, i) {
					for (var n, r, o, a = 0, s = t.length - 1; a >= 0 && a <= s;) {
						if (r = t[(n = a + s >> 1) - 1] || null, o = t[n], !r) return {lo: null, hi: o};
						if (o[e] < i) a = n + 1; else {
							if (!(r[e] > i)) return {lo: r, hi: o};
							s = n - 1
						}
					}
					return {lo: o, hi: null}
				}(t, e, i), o = r.lo ? r.hi ? r.lo : t[t.length - 2] : t[0], a = r.lo ? r.hi ? r.hi : t[t.length - 1] : t[1], s = a[e] - o[e], l = s ? (i - o[e]) / s : 0, c = (a[n] - o[n]) * l;
				return o[n] + c
			}

			function m(t, e) {
				var i = e.parser, r = e.parser || e.format;
				return "function" == typeof i ? i(t) : "string" == typeof t && "string" == typeof r ? n(t, r) : (t instanceof n || (t = n(t)), t.isValid() ? t : "function" == typeof r ? r(t) : t)
			}

			function g(t, e) {
				if (o.isNullOrUndef(t)) return null;
				var i = e.options.time, n = m(e.getRightValue(t), i);
				return n.isValid() ? (i.round && n.startOf(i.round), n.valueOf()) : null
			}

			function v(t) {
				for (var e = h.indexOf(t) + 1, i = h.length; e < i; ++e) if (u[h[e]].common) return h[e]
			}

			function y(t, e, i, r) {
				var a, s = r.time, l = s.unit || function (t, e, i, n) {
					var r, o, a, s = h.length;
					for (r = h.indexOf(t); r < s - 1; ++r) if (a = (o = u[h[r]]).steps ? o.steps[o.steps.length - 1] : c, o.common && Math.ceil((i - e) / (a * o.size)) <= n) return h[r];
					return h[s - 1]
				}(s.minUnit, t, e, i), d = v(l), p = o.valueOrDefault(s.stepSize, s.unitStepSize), f = "week" === l && s.isoWeekday, m = r.ticks.major.enabled, g = u[l], y = n(t), b = n(e), w = [];
				for (p || (p = function (t, e, i, n) {
					var r, o, a, s = e - t, l = u[i], c = l.size, h = l.steps;
					if (!h) return Math.ceil(s / (n * c));
					for (r = 0, o = h.length; r < o && (a = h[r], !(Math.ceil(s / (c * a)) <= n)); ++r) ;
					return a
				}(t, e, l, i)), f && (y = y.isoWeekday(f), b = b.isoWeekday(f)), y = y.startOf(f ? "day" : l), (b = b.startOf(f ? "day" : l)) < e && b.add(1, l), a = n(y), m && d && !f && !s.round && (a.startOf(d), a.add(~~((y - a) / (g.size * p)) * p, l)); a < b; a.add(p, l)) w.push(+a);
				return w.push(+a), w
			}

			e.exports = function () {
				var t = a.extend({
					initialize: function () {
						if (!n) throw new Error("Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com");
						this.mergeTicksOptions(), a.prototype.initialize.call(this)
					}, update: function () {
						var t = this.options;
						return t.time && t.time.format && console.warn("options.time.format is deprecated and replaced by options.time.parser."), a.prototype.update.apply(this, arguments)
					}, getRightValue: function (t) {
						return t && void 0 !== t.t && (t = t.t), a.prototype.getRightValue.call(this, t)
					}, determineDataLimits: function () {
						var t, e, i, r, a, s, u = this, h = u.chart, f = u.options.time, m = f.unit || "day", v = c, y = l, b = [], w = [], x = [];
						for (t = 0, i = h.data.labels.length; t < i; ++t) x.push(g(h.data.labels[t], u));
						for (t = 0, i = (h.data.datasets || []).length; t < i; ++t) if (h.isDatasetVisible(t)) if (a = h.data.datasets[t].data, o.isObject(a[0])) for (w[t] = [], e = 0, r = a.length; e < r; ++e) s = g(a[e], u), b.push(s), w[t][e] = s; else b.push.apply(b, x), w[t] = x.slice(0); else w[t] = [];
						x.length && (x = p(x).sort(d), v = Math.min(v, x[0]), y = Math.max(y, x[x.length - 1])), b.length && (b = p(b).sort(d), v = Math.min(v, b[0]), y = Math.max(y, b[b.length - 1])), v = g(f.min, u) || v, y = g(f.max, u) || y, v = v === c ? +n().startOf(m) : v, y = y === l ? +n().endOf(m) + 1 : y, u.min = Math.min(v, y), u.max = Math.max(v + 1, y), u._horizontal = u.isHorizontal(), u._table = [], u._timestamps = {
							data: b,
							datasets: w,
							labels: x
						}
					}, buildTicks: function () {
						var t, e, i, r = this, o = r.min, a = r.max, s = r.options, l = s.time, c = [], d = [];
						switch (s.ticks.source) {
							case"data":
								c = r._timestamps.data;
								break;
							case"labels":
								c = r._timestamps.labels;
								break;
							case"auto":
							default:
								c = y(o, a, r.getLabelCapacity(o), s)
						}
						for ("ticks" === s.bounds && c.length && (o = c[0], a = c[c.length - 1]), o = g(l.min, r) || o, a = g(l.max, r) || a, t = 0, e = c.length; t < e; ++t) (i = c[t]) >= o && i <= a && d.push(i);
						return r.min = o, r.max = a, r._unit = l.unit || function (t, e, i, r) {
							var o, a, s = n.duration(n(r).diff(n(i)));
							for (o = h.length - 1; o >= h.indexOf(e); o--) if (a = h[o], u[a].common && s.as(a) >= t.length) return a;
							return h[e ? h.indexOf(e) : 0]
						}(d, l.minUnit, r.min, r.max), r._majorUnit = v(r._unit), r._table = function (t, e, i, n) {
							if ("linear" === n || !t.length) return [{time: e, pos: 0}, {time: i, pos: 1}];
							var r, o, a, s, l, c = [], u = [e];
							for (r = 0, o = t.length; r < o; ++r) (s = t[r]) > e && s < i && u.push(s);
							for (u.push(i), r = 0, o = u.length; r < o; ++r) l = u[r + 1], a = u[r - 1], s = u[r], void 0 !== a && void 0 !== l && Math.round((l + a) / 2) === s || c.push({time: s, pos: r / (o - 1)});
							return c
						}(r._timestamps.data, o, a, s.distribution), r._offsets = function (t, e, i, n, r) {
							var o, a, s = 0, l = 0;
							return r.offset && e.length && (r.time.min || (o = e.length > 1 ? e[1] : n, a = e[0], s = (f(t, "time", o, "pos") - f(t, "time", a, "pos")) / 2), r.time.max || (o = e[e.length - 1], a = e.length > 1 ? e[e.length - 2] : i, l = (f(t, "time", o, "pos") - f(t, "time", a, "pos")) / 2)), {
								left: s,
								right: l
							}
						}(r._table, d, o, a, s), r._labelFormat = function (t, e) {
							var i, n, r, o = t.length;
							for (i = 0; i < o; i++) {
								if (0 !== (n = m(t[i], e)).millisecond()) return "MMM D, YYYY h:mm:ss.SSS a";
								0 === n.second() && 0 === n.minute() && 0 === n.hour() || (r = !0)
							}
							return r ? "MMM D, YYYY h:mm:ss a" : "MMM D, YYYY"
						}(r._timestamps.data, l), function (t, e) {
							var i, r, o, a, s = [];
							for (i = 0, r = t.length; i < r; ++i) o = t[i], a = !!e && o === +n(o).startOf(e), s.push({value: o, major: a});
							return s
						}(d, r._majorUnit)
					}, getLabelForIndex: function (t, e) {
						var i = this.chart.data, n = this.options.time, r = i.labels && t < i.labels.length ? i.labels[t] : "", a = i.datasets[e].data[t];
						return o.isObject(a) && (r = this.getRightValue(a)), n.tooltipFormat ? m(r, n).format(n.tooltipFormat) : "string" == typeof r ? r : m(r, n).format(this._labelFormat)
					}, tickFormatFunction: function (t, e, i, n) {
						var r = this.options, a = t.valueOf(), s = r.time.displayFormats, l = s[this._unit], c = this._majorUnit, u = s[c], h = t.clone().startOf(c).valueOf(), d = r.ticks.major, p = d.enabled && c && u && a === h, f = t.format(n || (p ? u : l)), m = p ? d : r.ticks.minor,
							g = o.valueOrDefault(m.callback, m.userCallback);
						return g ? g(f, e, i) : f
					}, convertTicksToLabels: function (t) {
						var e, i, r = [];
						for (e = 0, i = t.length; e < i; ++e) r.push(this.tickFormatFunction(n(t[e].value), e, t));
						return r
					}, getPixelForOffset: function (t) {
						var e = this, i = e._horizontal ? e.width : e.height, n = e._horizontal ? e.left : e.top, r = f(e._table, "time", t, "pos");
						return n + i * (e._offsets.left + r) / (e._offsets.left + 1 + e._offsets.right)
					}, getPixelForValue: function (t, e, i) {
						var n = null;
						if (void 0 !== e && void 0 !== i && (n = this._timestamps.datasets[i][e]), null === n && (n = g(t, this)), null !== n) return this.getPixelForOffset(n)
					}, getPixelForTick: function (t) {
						var e = this.getTicks();
						return t >= 0 && t < e.length ? this.getPixelForOffset(e[t].value) : null
					}, getValueForPixel: function (t) {
						var e = this, i = e._horizontal ? e.width : e.height, r = e._horizontal ? e.left : e.top, o = (i ? (t - r) / i : 0) * (e._offsets.left + 1 + e._offsets.left) - e._offsets.right, a = f(e._table, "pos", o, "time");
						return n(a)
					}, getLabelWidth: function (t) {
						var e = this.options.ticks, i = this.ctx.measureText(t).width, n = o.toRadians(e.maxRotation), a = Math.cos(n), s = Math.sin(n);
						return i * a + o.valueOrDefault(e.fontSize, r.global.defaultFontSize) * s
					}, getLabelCapacity: function (t) {
						var e = this, i = e.options.time.displayFormats.millisecond, r = e.tickFormatFunction(n(t), 0, [], i), o = e.getLabelWidth(r), a = e.isHorizontal() ? e.width : e.height, s = Math.floor(a / o);
						return s > 0 ? s : 1
					}
				});
				s.registerScaleType("time", t, {
					position: "bottom",
					distribution: "linear",
					bounds: "data",
					time: {
						parser: !1,
						format: !1,
						unit: !1,
						round: !1,
						displayFormat: !1,
						isoWeekday: !1,
						minUnit: "millisecond",
						displayFormats: {millisecond: "h:mm:ss.SSS a", second: "h:mm:ss a", minute: "h:mm a", hour: "hA", day: "MMM D", week: "ll", month: "MMM YYYY", quarter: "[Q]Q - YYYY", year: "YYYY"}
					},
					ticks: {autoSkip: !1, source: "auto", major: {enabled: !1}}
				})
			}
		}, {26: 26, 33: 33, 34: 34, 46: 46, 6: 6}]
	}, {}, [7])(7)
}), function (t) {
	"use strict";
	t.sessionTimeout = function (e) {
		function i() {
			clearTimeout(r), (a.countdownMessage || a.countdownBar) && n("session", !0), "function" == typeof a.onStart && a.onStart(a), a.keepAlive && (h || (t.ajax({type: a.ajaxType, url: a.keepAliveUrl, data: a.ajaxData}), h = !0, setTimeout(function () {
				h = !1
			}, a.keepAliveInterval))), r = setTimeout(function () {
				"function" != typeof a.onWarn ? t("#session-timeout-dialog").modal("show") : a.onWarn(a), clearTimeout(r), t("#session-timeout-dialog").hasClass("in") || !a.countdownMessage && !a.countdownBar || n("dialog", !0), r = setTimeout(function () {
					"function" != typeof a.onRedir ? window.location = a.redirUrl : a.onRedir(a)
				}, a.redirAfter - a.warnAfter)
			}, a.warnAfter)
		}

		function n(e, i) {
			clearTimeout(s.timer), "dialog" === e && i ? s.timeLeft = Math.floor((a.redirAfter - a.warnAfter) / 1e3) : "session" === e && i && (s.timeLeft = Math.floor(a.redirAfter / 1e3)), a.countdownBar && "dialog" === e ? s.percentLeft = Math.floor(s.timeLeft / ((a.redirAfter - a.warnAfter) / 1e3) * 100) : a.countdownBar && "session" === e && (s.percentLeft = Math.floor(s.timeLeft / (a.redirAfter / 1e3) * 100));
			var r = t(".countdown-holder"), o = s.timeLeft >= 0 ? s.timeLeft : 0;
			if (a.countdownSmart) {
				var l = Math.floor(o / 60), c = o % 60, u = l > 0 ? l + "m" : "";
				u.length > 0 && (u += " "), u += c + "s", r.text(u)
			} else r.text(o + "s");
			a.countdownBar && t(".countdown-bar").css("width", s.percentLeft + "%"), s.timeLeft = s.timeLeft - 1, s.timer = setTimeout(function () {
				n(e)
			}, 1e3)
		}

		var r, o = {
			title: "Your Session is About to Expire!",
			message: "Your session is about to expire.",
			logoutButton: "Logout",
			keepAliveButton: "Stay Connected",
			keepAliveUrl: "/keep-alive",
			ajaxType: "POST",
			ajaxData: "",
			redirUrl: "/timed-out",
			logoutUrl: "/log-out",
			warnAfter: 9e5,
			redirAfter: 12e5,
			keepAliveInterval: 5e3,
			keepAlive: !0,
			ignoreUserActivity: !1,
			onStart: !1,
			onWarn: !1,
			onRedir: !1,
			countdownMessage: !1,
			countdownBar: !1,
			countdownSmart: !1
		}, a = o, s = {};
		if (e && (a = t.extend(o, e)), a.warnAfter >= a.redirAfter) return console.error('Bootstrap-session-timeout plugin is miss-configured. Option "redirAfter" must be equal or greater than "warnAfter".'), !1;
		if ("function" != typeof a.onWarn) {
			var l = a.countdownMessage ? "<p>" + a.countdownMessage.replace(/{timer}/g, '<span class="countdown-holder"></span>') + "</p>" : "",
				c = a.countdownBar ? '<div class="progress">                   <div class="progress-bar progress-bar-striped countdown-bar active" role="progressbar" style="min-width: 15px; width: 100%;">                     <span class="countdown-holder"></span>                   </div>                 </div>' : "";
			t("body").append('<div class="modal fade" id="session-timeout-dialog">               <div class="modal-dialog">                 <div class="modal-content">                   <div class="modal-header">                     <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>                     <h4 class="modal-title">' + a.title + '</h4>                   </div>                   <div class="modal-body">                     <p>' + a.message + "</p>                     " + l + "                     " + c + '                   </div>                   <div class="modal-footer">                     <button id="session-timeout-dialog-logout" type="button" class="btn btn-default">' + a.logoutButton + '</button>                     <button id="session-timeout-dialog-keepalive" type="button" class="btn btn-primary" data-dismiss="modal">' + a.keepAliveButton + "</button>                   </div>                 </div>               </div>              </div>"), t("#session-timeout-dialog-logout").on("click", function () {
				window.location = a.logoutUrl
			}), t("#session-timeout-dialog").on("hide.bs.modal", function () {
				i()
			})
		}
		if (!a.ignoreUserActivity) {
			var u = [-1, -1];
			t(document).on("keyup mouseup mousemove touchend touchmove", function (e) {
				if ("mousemove" === e.type) {
					if (e.clientX === u[0] && e.clientY === u[1]) return;
					u[0] = e.clientX, u[1] = e.clientY
				}
				i(), t("#session-timeout-dialog").length > 0 && t("#session-timeout-dialog").data("bs.modal") && t("#session-timeout-dialog").data("bs.modal").isShown && (t("#session-timeout-dialog").modal("hide"), t("body").removeClass("modal-open"), t("div.modal-backdrop").remove())
			})
		}
		var h = !1;
		i()
	}
}(jQuery), function (t) {
	t.idleTimer = function (e, i) {
		var n;
		"object" == typeof e ? (n = e, e = null) : "number" == typeof e && (n = {timeout: e}, e = null), i = i || document, n = t.extend({idle: !1, timeout: 3e4, events: "mousemove keydown wheel DOMMouseScroll mousewheel mousedown touchstart touchmove MSPointerDown MSPointerMove"}, n);
		var r = t(i), o = r.data("idleTimerObj") || {}, a = function (e) {
			var n = t.data(i, "idleTimerObj") || {};
			n.idle = !n.idle, n.olddate = +new Date;
			var r = t.Event((n.idle ? "idle" : "active") + ".idleTimer");
			t(i).trigger(r, [i, t.extend({}, n), e])
		}, s = function (e) {
			var n = t.data(i, "idleTimerObj") || {};
			if (("storage" !== e.type || e.originalEvent.key === n.timerSyncId) && null == n.remaining) {
				if ("mousemove" === e.type) {
					if (e.pageX === n.pageX && e.pageY === n.pageY) return;
					if (void 0 === e.pageX && void 0 === e.pageY) return;
					if (200 > +new Date - n.olddate) return
				}
				clearTimeout(n.tId), n.idle && a(e), n.lastActive = +new Date, n.pageX = e.pageX, n.pageY = e.pageY, "storage" !== e.type && n.timerSyncId && "undefined" != typeof localStorage && localStorage.setItem(n.timerSyncId, n.lastActive), n.tId = setTimeout(a, n.timeout)
			}
		}, l = function () {
			var e = t.data(i, "idleTimerObj") || {};
			e.idle = e.idleBackup, e.olddate = +new Date, e.lastActive = e.olddate, e.remaining = null, clearTimeout(e.tId), e.idle || (e.tId = setTimeout(a, e.timeout))
		};
		if (null === e && void 0 !== o.idle) return l(), r;
		if (null === e) ; else {
			if (null !== e && void 0 === o.idle) return !1;
			if ("destroy" === e) return function () {
				var e = t.data(i, "idleTimerObj") || {};
				clearTimeout(e.tId), r.removeData("idleTimerObj"), r.off("._idleTimer")
			}(), r;
			if ("pause" === e) return function () {
				var e = t.data(i, "idleTimerObj") || {};
				null == e.remaining && (e.remaining = e.timeout - (+new Date - e.olddate), clearTimeout(e.tId))
			}(), r;
			if ("resume" === e) return function () {
				var e = t.data(i, "idleTimerObj") || {};
				null != e.remaining && (e.idle || (e.tId = setTimeout(a, e.remaining)), e.remaining = null)
			}(), r;
			if ("reset" === e) return l(), r;
			if ("getRemainingTime" === e) return function () {
				var e = t.data(i, "idleTimerObj") || {};
				if (e.idle) return 0;
				if (null != e.remaining) return e.remaining;
				var n = e.timeout - (+new Date - e.lastActive);
				return 0 > n && (n = 0), n
			}();
			if ("getElapsedTime" === e) return +new Date - o.olddate;
			if ("getLastActiveTime" === e) return o.lastActive;
			if ("isIdle" === e) return o.idle
		}
		return r.on(t.trim((n.events + " ").split(" ").join("._idleTimer ")), function (t) {
			s(t)
		}), n.timerSyncId && t(window).bind("storage", s), (o = t.extend({}, {
			olddate: +new Date,
			lastActive: +new Date,
			idle: n.idle,
			idleBackup: n.idle,
			timeout: n.timeout,
			remaining: null,
			timerSyncId: n.timerSyncId,
			tId: null,
			pageX: null,
			pageY: null
		})).idle || (o.tId = setTimeout(a, o.timeout)), t.data(i, "idleTimerObj", o), r
	}, t.fn.idleTimer = function (e) {
		return this[0] ? t.idleTimer(e, this[0]) : this
	}
}(jQuery), function () {
	"use strict";
	var t = 0, e = {};

	function i(n) {
		if (!n) throw new Error("No options passed to Waypoint constructor");
		if (!n.element) throw new Error("No element option passed to Waypoint constructor");
		if (!n.handler) throw new Error("No handler option passed to Waypoint constructor");
		this.key = "waypoint-" + t, this.options = i.Adapter.extend({}, i.defaults, n), this.element = this.options.element, this.adapter = new i.Adapter(this.element), this.callback = n.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = i.Group.findOrCreate({
			name: this.options.group,
			axis: this.axis
		}), this.context = i.Context.findOrCreateByElement(this.options.context), i.offsetAliases[this.options.offset] && (this.options.offset = i.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), e[this.key] = this, t += 1
	}

	i.prototype.queueTrigger = function (t) {
		this.group.queueTrigger(this, t)
	}, i.prototype.trigger = function (t) {
		this.enabled && this.callback && this.callback.apply(this, t)
	}, i.prototype.destroy = function () {
		this.context.remove(this), this.group.remove(this), delete e[this.key]
	}, i.prototype.disable = function () {
		return this.enabled = !1, this
	}, i.prototype.enable = function () {
		return this.context.refresh(), this.enabled = !0, this
	}, i.prototype.next = function () {
		return this.group.next(this)
	}, i.prototype.previous = function () {
		return this.group.previous(this)
	}, i.invokeAll = function (t) {
		var i = [];
		for (var n in e) i.push(e[n]);
		for (var r = 0, o = i.length; r < o; r++) i[r][t]()
	}, i.destroyAll = function () {
		i.invokeAll("destroy")
	}, i.disableAll = function () {
		i.invokeAll("disable")
	}, i.enableAll = function () {
		for (var t in i.Context.refreshAll(), e) e[t].enabled = !0;
		return this
	}, i.refreshAll = function () {
		i.Context.refreshAll()
	}, i.viewportHeight = function () {
		return window.innerHeight || document.documentElement.clientHeight
	}, i.viewportWidth = function () {
		return document.documentElement.clientWidth
	}, i.adapters = [], i.defaults = {context: window, continuous: !0, enabled: !0, group: "default", horizontal: !1, offset: 0}, i.offsetAliases = {
		"bottom-in-view": function () {
			return this.context.innerHeight() - this.adapter.outerHeight()
		}, "right-in-view": function () {
			return this.context.innerWidth() - this.adapter.outerWidth()
		}
	}, window.Waypoint = i
}(), function () {
	"use strict";

	function t(t) {
		window.setTimeout(t, 1e3 / 60)
	}

	var e = 0, i = {}, n = window.Waypoint, r = window.onload;

	function o(t) {
		this.element = t, this.Adapter = n.Adapter, this.adapter = new this.Adapter(t), this.key = "waypoint-context-" + e, this.didScroll = !1, this.didResize = !1, this.oldScroll = {x: this.adapter.scrollLeft(), y: this.adapter.scrollTop()}, this.waypoints = {
			vertical: {},
			horizontal: {}
		}, t.waypointContextKey = this.key, i[t.waypointContextKey] = this, e += 1, n.windowContext || (n.windowContext = !0, n.windowContext = new o(window)), this.createThrottledScrollHandler(), this.createThrottledResizeHandler()
	}

	o.prototype.add = function (t) {
		var e = t.options.horizontal ? "horizontal" : "vertical";
		this.waypoints[e][t.key] = t, this.refresh()
	}, o.prototype.checkEmpty = function () {
		var t = this.Adapter.isEmptyObject(this.waypoints.horizontal), e = this.Adapter.isEmptyObject(this.waypoints.vertical), n = this.element == this.element.window;
		t && e && !n && (this.adapter.off(".waypoints"), delete i[this.key])
	}, o.prototype.createThrottledResizeHandler = function () {
		var t = this;

		function e() {
			t.handleResize(), t.didResize = !1
		}

		this.adapter.on("resize.waypoints", function () {
			t.didResize || (t.didResize = !0, n.requestAnimationFrame(e))
		})
	}, o.prototype.createThrottledScrollHandler = function () {
		var t = this;

		function e() {
			t.handleScroll(), t.didScroll = !1
		}

		this.adapter.on("scroll.waypoints", function () {
			t.didScroll && !n.isTouch || (t.didScroll = !0, n.requestAnimationFrame(e))
		})
	}, o.prototype.handleResize = function () {
		n.Context.refreshAll()
	}, o.prototype.handleScroll = function () {
		var t = {}, e = {horizontal: {newScroll: this.adapter.scrollLeft(), oldScroll: this.oldScroll.x, forward: "right", backward: "left"}, vertical: {newScroll: this.adapter.scrollTop(), oldScroll: this.oldScroll.y, forward: "down", backward: "up"}};
		for (var i in e) {
			var n = e[i], r = n.newScroll > n.oldScroll ? n.forward : n.backward;
			for (var o in this.waypoints[i]) {
				var a = this.waypoints[i][o];
				if (null !== a.triggerPoint) {
					var s = n.oldScroll < a.triggerPoint, l = n.newScroll >= a.triggerPoint;
					(s && l || !s && !l) && (a.queueTrigger(r), t[a.group.id] = a.group)
				}
			}
		}
		for (var c in t) t[c].flushTriggers();
		this.oldScroll = {x: e.horizontal.newScroll, y: e.vertical.newScroll}
	}, o.prototype.innerHeight = function () {
		return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight()
	}, o.prototype.remove = function (t) {
		delete this.waypoints[t.axis][t.key], this.checkEmpty()
	}, o.prototype.innerWidth = function () {
		return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth()
	}, o.prototype.destroy = function () {
		var t = [];
		for (var e in this.waypoints) for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]);
		for (var n = 0, r = t.length; n < r; n++) t[n].destroy()
	}, o.prototype.refresh = function () {
		var t, e = this.element == this.element.window, i = e ? void 0 : this.adapter.offset(), r = {};
		for (var o in this.handleScroll(), t = {
			horizontal: {contextOffset: e ? 0 : i.left, contextScroll: e ? 0 : this.oldScroll.x, contextDimension: this.innerWidth(), oldScroll: this.oldScroll.x, forward: "right", backward: "left", offsetProp: "left"},
			vertical: {contextOffset: e ? 0 : i.top, contextScroll: e ? 0 : this.oldScroll.y, contextDimension: this.innerHeight(), oldScroll: this.oldScroll.y, forward: "down", backward: "up", offsetProp: "top"}
		}) {
			var a = t[o];
			for (var s in this.waypoints[o]) {
				var l, c, u, h, d = this.waypoints[o][s], p = d.options.offset, f = d.triggerPoint, m = 0, g = null == f;
				d.element !== d.element.window && (m = d.adapter.offset()[a.offsetProp]), "function" == typeof p ? p = p.apply(d) : "string" == typeof p && (p = parseFloat(p), d.options.offset.indexOf("%") > -1 && (p = Math.ceil(a.contextDimension * p / 100))), l = a.contextScroll - a.contextOffset, d.triggerPoint = Math.floor(m + l - p), c = f < a.oldScroll, u = d.triggerPoint >= a.oldScroll, h = !c && !u, !g && (c && u) ? (d.queueTrigger(a.backward), r[d.group.id] = d.group) : !g && h ? (d.queueTrigger(a.forward), r[d.group.id] = d.group) : g && a.oldScroll >= d.triggerPoint && (d.queueTrigger(a.forward), r[d.group.id] = d.group)
			}
		}
		return n.requestAnimationFrame(function () {
			for (var t in r) r[t].flushTriggers()
		}), this
	}, o.findOrCreateByElement = function (t) {
		return o.findByElement(t) || new o(t)
	}, o.refreshAll = function () {
		for (var t in i) i[t].refresh()
	}, o.findByElement = function (t) {
		return i[t.waypointContextKey]
	}, window.onload = function () {
		r && r(), o.refreshAll()
	}, n.requestAnimationFrame = function (e) {
		(window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t).call(window, e)
	}, n.Context = o
}(), function () {
	"use strict";

	function t(t, e) {
		return t.triggerPoint - e.triggerPoint
	}

	function e(t, e) {
		return e.triggerPoint - t.triggerPoint
	}

	var i = {vertical: {}, horizontal: {}}, n = window.Waypoint;

	function r(t) {
		this.name = t.name, this.axis = t.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), i[this.axis][this.name] = this
	}

	r.prototype.add = function (t) {
		this.waypoints.push(t)
	}, r.prototype.clearTriggerQueues = function () {
		this.triggerQueues = {up: [], down: [], left: [], right: []}
	}, r.prototype.flushTriggers = function () {
		for (var i in this.triggerQueues) {
			var n = this.triggerQueues[i], r = "up" === i || "left" === i;
			n.sort(r ? e : t);
			for (var o = 0, a = n.length; o < a; o += 1) {
				var s = n[o];
				(s.options.continuous || o === n.length - 1) && s.trigger([i])
			}
		}
		this.clearTriggerQueues()
	}, r.prototype.next = function (e) {
		this.waypoints.sort(t);
		var i = n.Adapter.inArray(e, this.waypoints);
		return i === this.waypoints.length - 1 ? null : this.waypoints[i + 1]
	}, r.prototype.previous = function (e) {
		this.waypoints.sort(t);
		var i = n.Adapter.inArray(e, this.waypoints);
		return i ? this.waypoints[i - 1] : null
	}, r.prototype.queueTrigger = function (t, e) {
		this.triggerQueues[e].push(t)
	}, r.prototype.remove = function (t) {
		var e = n.Adapter.inArray(t, this.waypoints);
		e > -1 && this.waypoints.splice(e, 1)
	}, r.prototype.first = function () {
		return this.waypoints[0]
	}, r.prototype.last = function () {
		return this.waypoints[this.waypoints.length - 1]
	}, r.findOrCreate = function (t) {
		return i[t.axis][t.name] || new r(t)
	}, n.Group = r
}(), function () {
	"use strict";
	var t = window.jQuery, e = window.Waypoint;

	function i(e) {
		this.$element = t(e)
	}

	t.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function (t, e) {
		i.prototype[e] = function () {
			var t = Array.prototype.slice.call(arguments);
			return this.$element[e].apply(this.$element, t)
		}
	}), t.each(["extend", "inArray", "isEmptyObject"], function (e, n) {
		i[n] = t[n]
	}), e.adapters.push({name: "jquery", Adapter: i}), e.Adapter = i
}(), function () {
	"use strict";
	var t = window.Waypoint;

	function e(e) {
		return function () {
			var i = [], n = arguments[0];
			return e.isFunction(arguments[0]) && ((n = e.extend({}, arguments[1])).handler = arguments[0]), this.each(function () {
				var r = e.extend({}, n, {element: this});
				"string" == typeof r.context && (r.context = e(this).closest(r.context)[0]), i.push(new t(r))
			}), i
		}
	}

	window.jQuery && (window.jQuery.fn.waypoint = e(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = e(window.Zepto))
}(), function (t) {
	"use strict";
	t.fn.counterUp = function (e) {
		var i = t.extend({time: 400, delay: 10}, e);
		return this.each(function () {
			var e = t(this), n = i;
			e.waypoint(function () {
				var t = n.time / n.delay, i = e.attr("data-value"), r = [i], o = /[0-9]+,[0-9]+/.test(i);
				i = i.replace(/,/g, "");
				for (var a = (/^[0-9]+$/.test(i), /^[0-9]+\.[0-9]+$/.test(i)), s = a ? (i.split(".")[1] || []).length : 0, l = t; l >= 1; l--) {
					var c = parseInt(i / t * l);
					if (a && (c = parseFloat(i / t * l).toFixed(s)), o) for (; /(\d+)(\d{3})/.test(c.toString());) c = c.toString().replace(/(\d+)(\d{3})/, "$1,$2");
					r.unshift(c)
				}
				e.data("counterup-nums", r), e.text("0");
				e.data("counterup-func", function () {
					e.data("counterup-nums") && (e.text(e.data("counterup-nums").shift()), e.data("counterup-nums").length ? setTimeout(e.data("counterup-func"), n.delay) : (e.data("counterup-nums"), e.data("counterup-nums", null), e.data("counterup-func", null)))
				}), setTimeout(e.data("counterup-func"), n.delay)
			}, {offset: "100%", triggerOnce: !0})
		})
	}
}(jQuery), function (t) {
	function e() {
		for (var t = 0; t < k.length; t++) k[t][0](k[t][1]);
		k = [], m = !1
	}

	function i(t, i) {
		k.push([t, i]), m || (m = !0, x(e, 0))
	}

	function n(t) {
		var e = (i = t.owner).state_, i = i.data_, n = t[e];
		if (t = t.then, "function" == typeof n) {
			e = y;
			try {
				i = n(i)
			} catch (e) {
				s(t, e)
			}
		}
		r(t, i) || (e === y && o(t, i), e === b && s(t, i))
	}

	function r(t, e) {
		var i;
		try {
			if (t === e) throw new TypeError("A promises callback cannot return that same promise.");
			if (e && ("function" == typeof e || "object" == typeof e)) {
				var n = e.then;
				if ("function" == typeof n) return n.call(e, function (n) {
					i || (i = !0, e !== n ? o(t, n) : a(t, n))
				}, function (e) {
					i || (i = !0, s(t, e))
				}), !0
			}
		} catch (e) {
			return i || s(t, e), !0
		}
		return !1
	}

	function o(t, e) {
		t !== e && r(t, e) || a(t, e)
	}

	function a(t, e) {
		t.state_ === g && (t.state_ = v, t.data_ = e, i(c, t))
	}

	function s(t, e) {
		t.state_ === g && (t.state_ = v, t.data_ = e, i(u, t))
	}

	function l(t) {
		var e = t.then_;
		for (t.then_ = void 0, t = 0; t < e.length; t++) n(e[t])
	}

	function c(t) {
		t.state_ = y, l(t)
	}

	function u(t) {
		t.state_ = b, l(t)
	}

	function h(t) {
		if ("function" != typeof t) throw new TypeError("Promise constructor takes a function argument");
		if (!1 == this instanceof h) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
		this.then_ = [], function (t, e) {
			function i(t) {
				s(e, t)
			}

			try {
				t(function (t) {
					o(e, t)
				}, i)
			} catch (t) {
				i(t)
			}
		}(t, this)
	}

	var d, p = t.Promise, f = p && "resolve" in p && "reject" in p && "all" in p && "race" in p && (new p(function (t) {
		d = t
	}), "function" == typeof d);
	"undefined" != typeof exports && exports ? (exports.Promise = f ? p : h, exports.Polyfill = h) : "function" == typeof define && define.amd ? define(function () {
		return f ? p : h
	}) : f || (t.Promise = h);
	var m, g = "pending", v = "sealed", y = "fulfilled", b = "rejected", w = function () {
	}, x = "undefined" != typeof setImmediate ? setImmediate : setTimeout, k = [];
	h.prototype = {
		constructor: h, state_: g, then_: null, data_: void 0, then: function (t, e) {
			var r = {owner: this, then: new this.constructor(w), fulfilled: t, rejected: e};
			return this.state_ === y || this.state_ === b ? i(n, r) : this.then_.push(r), r.then
		}, catch: function (t) {
			return this.then(null, t)
		}
	}, h.all = function (t) {
		if ("[object Array]" !== Object.prototype.toString.call(t)) throw new TypeError("You must pass an array to Promise.all().");
		return new this(function (e, i) {
			function n(t) {
				return a++, function (i) {
					o[t] = i, --a || e(o)
				}
			}

			for (var r, o = [], a = 0, s = 0; s < t.length; s++) (r = t[s]) && "function" == typeof r.then ? r.then(n(s), i) : o[s] = r;
			a || e(o)
		})
	}, h.race = function (t) {
		if ("[object Array]" !== Object.prototype.toString.call(t)) throw new TypeError("You must pass an array to Promise.race().");
		return new this(function (e, i) {
			for (var n, r = 0; r < t.length; r++) (n = t[r]) && "function" == typeof n.then ? n.then(e, i) : e(n)
		})
	}, h.resolve = function (t) {
		return t && "object" == typeof t && t.constructor === this ? t : new this(function (e) {
			e(t)
		})
	}, h.reject = function (t) {
		return new this(function (e, i) {
			i(t)
		})
	}
}("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this), function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Sweetalert2 = e()
}(this, function () {
	"use strict";

	function t(e) {
		return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
			return typeof t
		} : function (t) {
			return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
		})(e)
	}

	function e(t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}

	function i(t, e) {
		for (var i = 0; i < e.length; i++) {
			var n = e[i];
			n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
		}
	}

	function n(t, e, n) {
		return e && i(t.prototype, e), n && i(t, n), t
	}

	function r() {
		return (r = Object.assign || function (t) {
			for (var e = 1; e < arguments.length; e++) {
				var i = arguments[e];
				for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
			}
			return t
		}).apply(this, arguments)
	}

	function o(t, e) {
		if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
		t.prototype = Object.create(e && e.prototype, {constructor: {value: t, writable: !0, configurable: !0}}), e && s(t, e)
	}

	function a(t) {
		return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
			return t.__proto__ || Object.getPrototypeOf(t)
		})(t)
	}

	function s(t, e) {
		return (s = Object.setPrototypeOf || function (t, e) {
			return t.__proto__ = e, t
		})(t, e)
	}

	function l(t, e, i) {
		return (l = function () {
			if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
			if (Reflect.construct.sham) return !1;
			if ("function" == typeof Proxy) return !0;
			try {
				return Date.prototype.toString.call(Reflect.construct(Date, [], function () {
				})), !0
			} catch (t) {
				return !1
			}
		}() ? Reflect.construct : function (t, e, i) {
			var n = [null];
			n.push.apply(n, e);
			var r = new (Function.bind.apply(t, n));
			return i && s(r, i.prototype), r
		}).apply(null, arguments)
	}

	function c(t, e) {
		return !e || "object" != typeof e && "function" != typeof e ? function (t) {
			if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
			return t
		}(t) : e
	}

	function u(t, e, i) {
		return (u = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, i) {
			var n = function (t, e) {
				for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = a(t));) ;
				return t
			}(t, e);
			if (n) {
				var r = Object.getOwnPropertyDescriptor(n, e);
				return r.get ? r.get.call(i) : r.value
			}
		})(t, e, i || t)
	}

	var h = "SweetAlert2:", d = function (t) {
			return Array.prototype.slice.call(t)
		}, p = function (t) {
			console.warn("".concat(h, " ").concat(t))
		}, f = function (t) {
			console.error("".concat(h, " ").concat(t))
		}, m = [], g = function (t) {
			-1 === m.indexOf(t) && (m.push(t), p(t))
		}, v = function (t) {
			return "function" == typeof t ? t() : t
		}, y = function (t) {
			return t && Promise.resolve(t) === t
		}, b = Object.freeze({cancel: "cancel", backdrop: "overlay", close: "close", esc: "esc", timer: "timer"}), w = function (t) {
			var e = {};
			for (var i in t) e[t[i]] = "swal2-" + t[i];
			return e
		},
		x = w(["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "toast", "toast-shown", "toast-column", "fade", "show", "hide", "noanimation", "close", "title", "header", "content", "actions", "confirm", "cancel", "footer", "icon", "icon-text", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "validation-message", "progresssteps", "activeprogressstep", "progresscircle", "progressline", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl"]),
		k = w(["success", "warning", "info", "question", "error"]), _ = {previousBodyPadding: null}, S = function (t, e) {
			return t.classList.contains(e)
		}, C = function (t) {
			if (t.focus(), "file" !== t.type) {
				var e = t.value;
				t.value = "", t.value = e
			}
		}, D = function (t, e, i) {
			t && e && ("string" == typeof e && (e = e.split(/\s+/).filter(Boolean)), e.forEach(function (e) {
				t.forEach ? t.forEach(function (t) {
					i ? t.classList.add(e) : t.classList.remove(e)
				}) : i ? t.classList.add(e) : t.classList.remove(e)
			}))
		}, T = function (t, e) {
			D(t, e, !0)
		}, M = function (t, e) {
			D(t, e, !1)
		}, E = function (t, e) {
			for (var i = 0; i < t.childNodes.length; i++) if (S(t.childNodes[i], e)) return t.childNodes[i]
		}, A = function (t) {
			t.style.opacity = "", t.style.display = t.id === x.content ? "block" : "flex"
		}, P = function (t) {
			t.style.opacity = "", t.style.display = "none"
		}, I = function (t) {
			return t && (t.offsetWidth || t.offsetHeight || t.getClientRects().length)
		}, O = function () {
			return document.body.querySelector("." + x.container)
		}, L = function (t) {
			var e = O();
			return e ? e.querySelector("." + t) : null
		}, F = function () {
			return L(x.popup)
		}, N = function () {
			var t = F();
			return d(t.querySelectorAll("." + x.icon))
		}, R = function () {
			return L(x.title)
		}, H = function () {
			return L(x.content)
		}, $ = function () {
			return L(x.image)
		}, B = function () {
			return L(x.progresssteps)
		}, z = function () {
			return L(x["validation-message"])
		}, j = function () {
			return L(x.confirm)
		}, U = function () {
			return L(x.cancel)
		}, W = function () {
			return L(x.actions)
		}, Y = function () {
			return L(x.footer)
		}, V = function () {
			return L(x.close)
		}, q = function () {
			var t = d(F().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')).sort(function (t, e) {
				return t = parseInt(t.getAttribute("tabindex")), (e = parseInt(e.getAttribute("tabindex"))) < t ? 1 : t < e ? -1 : 0
			}), e = d(F().querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls]')).filter(function (t) {
				return "-1" !== t.getAttribute("tabindex")
			});
			return function (t) {
				for (var e = [], i = 0; i < t.length; i++) -1 === e.indexOf(t[i]) && e.push(t[i]);
				return e
			}(t.concat(e)).filter(function (t) {
				return I(t)
			})
		}, G = function () {
			return !K() && !document.body.classList.contains(x["no-backdrop"])
		}, K = function () {
			return document.body.classList.contains(x["toast-shown"])
		}, X = function () {
			return "undefined" == typeof window || "undefined" == typeof document
		},
		Z = '\n <div aria-labelledby="'.concat(x.title, '" aria-describedby="').concat(x.content, '" class="').concat(x.popup, '" tabindex="-1">\n   <div class="').concat(x.header, '">\n     <ul class="').concat(x.progresssteps, '"></ul>\n     <div class="').concat(x.icon, " ").concat(k.error, '">\n       <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span></span>\n     </div>\n     <div class="').concat(x.icon, " ").concat(k.question, '">\n       <span class="').concat(x["icon-text"], '">?</span>\n      </div>\n     <div class="').concat(x.icon, " ").concat(k.warning, '">\n       <span class="').concat(x["icon-text"], '">!</span>\n      </div>\n     <div class="').concat(x.icon, " ").concat(k.info, '">\n       <span class="').concat(x["icon-text"], '">i</span>\n      </div>\n     <div class="').concat(x.icon, " ").concat(k.success, '">\n       <div class="swal2-success-circular-line-left"></div>\n       <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n       <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n       <div class="swal2-success-circular-line-right"></div>\n     </div>\n     <img class="').concat(x.image, '" />\n     <h2 class="').concat(x.title, '" id="').concat(x.title, '"></h2>\n     <button type="button" class="').concat(x.close, '">×</button>\n   </div>\n   <div class="').concat(x.content, '">\n     <div id="').concat(x.content, '"></div>\n     <input class="').concat(x.input, '" />\n     <input type="file" class="').concat(x.file, '" />\n     <div class="').concat(x.range, '">\n       <input type="range" />\n       <output></output>\n     </div>\n     <select class="').concat(x.select, '"></select>\n     <div class="').concat(x.radio, '"></div>\n     <label for="').concat(x.checkbox, '" class="').concat(x.checkbox, '">\n       <input type="checkbox" />\n       <span class="').concat(x.label, '"></span>\n     </label>\n     <textarea class="').concat(x.textarea, '"></textarea>\n     <div class="').concat(x["validation-message"], '" id="').concat(x["validation-message"], '"></div>\n   </div>\n   <div class="').concat(x.actions, '">\n     <button type="button" class="').concat(x.confirm, '">OK</button>\n     <button type="button" class="').concat(x.cancel, '">Cancel</button>\n   </div>\n   <div class="').concat(x.footer, '">\n   </div>\n </div>\n').replace(/(^|\n)\s*/g, ""),
		Q = function (t) {
			var e = O();
			if (e && (e.parentNode.removeChild(e), M([document.documentElement, document.body], [x["no-backdrop"], x["toast-shown"], x["has-column"]])), !X()) {
				var i = document.createElement("div");
				i.className = x.container, i.innerHTML = Z;
				var n = "string" == typeof t.target ? document.querySelector(t.target) : t.target;
				n.appendChild(i);
				var r, o = F(), a = H(), s = E(a, x.input), l = E(a, x.file), c = a.querySelector(".".concat(x.range, " input")), u = a.querySelector(".".concat(x.range, " output")), h = E(a, x.select), d = a.querySelector(".".concat(x.checkbox, " input")), p = E(a, x.textarea);
				o.setAttribute("role", t.toast ? "alert" : "dialog"), o.setAttribute("aria-live", t.toast ? "polite" : "assertive"), t.toast || o.setAttribute("aria-modal", "true"), "rtl" === window.getComputedStyle(n).direction && T(O(), x.rtl);
				var m = function (t) {
					Ot.isVisible() && r !== t.target.value && Ot.resetValidationMessage(), r = t.target.value
				};
				return s.oninput = m, l.onchange = m, h.onchange = m, d.onchange = m, p.oninput = m, c.oninput = function (t) {
					m(t), u.value = c.value
				}, c.onchange = function (t) {
					m(t), c.nextSibling.value = c.value
				}, o
			}
			f("SweetAlert2 requires document to initialize")
		}, J = function (e, i) {
			if (!e) return P(i);
			if (e instanceof HTMLElement) i.appendChild(e); else if ("object" === t(e)) if (i.innerHTML = "", 0 in e) for (var n = 0; n in e; n++) i.appendChild(e[n].cloneNode(!0)); else i.appendChild(e.cloneNode(!0)); else e && (i.innerHTML = e);
			A(i)
		}, tt = function () {
			if (X()) return !1;
			var t = document.createElement("div"), e = {WebkitAnimation: "webkitAnimationEnd", OAnimation: "oAnimationEnd oanimationend", animation: "animationend"};
			for (var i in e) if (e.hasOwnProperty(i) && void 0 !== t.style[i]) return e[i];
			return !1
		}(), et = function (t) {
			var e = B(), i = parseInt(null === t.currentProgressStep ? Ot.getQueueStep() : t.currentProgressStep, 10);
			t.progressSteps && t.progressSteps.length ? (A(e), e.innerHTML = "", i >= t.progressSteps.length && p("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), t.progressSteps.forEach(function (n, r) {
				var o = document.createElement("li");
				if (T(o, x.progresscircle), o.innerHTML = n, r === i && T(o, x.activeprogressstep), e.appendChild(o), r !== t.progressSteps.length - 1) {
					var a = document.createElement("li");
					T(a, x.progressline), t.progressStepsDistance && (a.style.width = t.progressStepsDistance), e.appendChild(a)
				}
			})) : P(e)
		}, it = function () {
			return !!window.MSInputMethodContext && !!document.documentMode
		}, nt = function () {
			var t = O(), e = F();
			t.style.removeProperty("align-items"), e.offsetTop < 0 && (t.style.alignItems = "flex-start")
		}, rt = {}, ot = function (t, e) {
			var i = O(), n = F();
			if (n) {
				null !== t && "function" == typeof t && t(n), M(n, x.show), T(n, x.hide);
				var r = function () {
					K() ? at(e) : (new Promise(function (t) {
						var e = window.scrollX, i = window.scrollY;
						rt.restoreFocusTimeout = setTimeout(function () {
							rt.previousActiveElement && rt.previousActiveElement.focus ? (rt.previousActiveElement.focus(), rt.previousActiveElement = null) : document.body && document.body.focus(), t()
						}, 100), void 0 !== e && void 0 !== i && window.scrollTo(e, i)
					}).then(function () {
						return at(e)
					}), rt.keydownTarget.removeEventListener("keydown", rt.keydownHandler, {capture: rt.keydownListenerCapture}), rt.keydownHandlerAdded = !1), i.parentNode && i.parentNode.removeChild(i), M([document.documentElement, document.body], [x.shown, x["height-auto"], x["no-backdrop"], x["toast-shown"], x["toast-column"]]), G() && (null !== _.previousBodyPadding && (document.body.style.paddingRight = _.previousBodyPadding, _.previousBodyPadding = null), function () {
						if (S(document.body, x.iosfix)) {
							var t = parseInt(document.body.style.top, 10);
							M(document.body, x.iosfix), document.body.style.top = "", document.body.scrollTop = -1 * t
						}
					}(), "undefined" != typeof window && it() && window.removeEventListener("resize", nt), d(document.body.children).forEach(function (t) {
						t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden")), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden")
					}))
				};
				tt && !S(n, x.noanimation) ? n.addEventListener(tt, function t() {
					n.removeEventListener(tt, t), S(n, x.hide) && r()
				}) : r()
			}
		}, at = function (t) {
			null !== t && "function" == typeof t && setTimeout(function () {
				t()
			})
		};

	function st(t) {
		var e = function t() {
			for (var e = arguments.length, i = new Array(e), n = 0; n < e; n++) i[n] = arguments[n];
			if (!(this instanceof t)) return l(t, i);
			Object.getPrototypeOf(t).apply(this, i)
		};
		return e.prototype = r(Object.create(t.prototype), {constructor: e}), "function" == typeof Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t, e
	}

	var lt = {
			title: "",
			titleText: "",
			text: "",
			html: "",
			footer: "",
			type: null,
			toast: !1,
			customClass: "",
			target: "body",
			backdrop: !0,
			animation: !0,
			heightAuto: !0,
			allowOutsideClick: !0,
			allowEscapeKey: !0,
			allowEnterKey: !0,
			stopKeydownPropagation: !0,
			keydownListenerCapture: !1,
			showConfirmButton: !0,
			showCancelButton: !1,
			preConfirm: null,
			confirmButtonText: "OK",
			confirmButtonAriaLabel: "",
			confirmButtonColor: null,
			confirmButtonClass: null,
			cancelButtonText: "Cancel",
			cancelButtonAriaLabel: "",
			cancelButtonColor: null,
			cancelButtonClass: null,
			buttonsStyling: !0,
			reverseButtons: !1,
			focusConfirm: !0,
			focusCancel: !1,
			showCloseButton: !1,
			closeButtonAriaLabel: "Close this dialog",
			showLoaderOnConfirm: !1,
			imageUrl: null,
			imageWidth: null,
			imageHeight: null,
			imageAlt: "",
			imageClass: null,
			timer: null,
			width: null,
			padding: null,
			background: null,
			input: null,
			inputPlaceholder: "",
			inputValue: "",
			inputOptions: {},
			inputAutoTrim: !0,
			inputClass: null,
			inputAttributes: {},
			inputValidator: null,
			validationMessage: null,
			grow: !1,
			position: "center",
			progressSteps: [],
			currentProgressStep: null,
			progressStepsDistance: null,
			onBeforeOpen: null,
			onAfterClose: null,
			onOpen: null,
			onClose: null,
			useRejections: !1,
			expectRejections: !1
		}, ct = ["useRejections", "expectRejections", "extraParams"], ut = ["allowOutsideClick", "allowEnterKey", "backdrop", "focusConfirm", "focusCancel", "heightAuto", "keydownListenerCapture"], ht = function (t) {
			return lt.hasOwnProperty(t) || "extraParams" === t
		}, dt = function (t) {
			return -1 !== ct.indexOf(t)
		}, pt = function (t) {
			for (var e in t) ht(e) || p('Unknown parameter "'.concat(e, '"')), t.toast && -1 !== ut.indexOf(e) && p('The parameter "'.concat(e, '" is incompatible with toasts')), dt(e) && g('The parameter "'.concat(e, '" is deprecated and will be removed in the next major release.'))
		}, ft = '"setDefaults" & "resetDefaults" methods are deprecated in favor of "mixin" method and will be removed in the next major release. For new projects, use "mixin". For past projects already using "setDefaults", support will be provided through an additional package.', mt = {}, gt = [],
		vt = function () {
			var t = F();
			t || Ot(""), t = F();
			var e = W(), i = j(), n = U();
			A(e), A(i), T([t, e], x.loading), i.disabled = !0, n.disabled = !0, t.setAttribute("data-loading", !0), t.setAttribute("aria-busy", !0), t.focus()
		}, yt = Object.freeze({
			isValidParameter: ht, isDeprecatedParameter: dt, argsToParams: function (e) {
				var i = {};
				switch (t(e[0])) {
					case"object":
						r(i, e[0]);
						break;
					default:
						["title", "html", "type"].forEach(function (n, r) {
							switch (t(e[r])) {
								case"string":
									i[n] = e[r];
									break;
								case"undefined":
									break;
								default:
									f("Unexpected type of ".concat(n, '! Expected "string", got ').concat(t(e[r])))
							}
						})
				}
				return i
			}, adaptInputValidator: function (t) {
				return function (e, i) {
					return t.call(this, e, i).then(function () {
					}, function (t) {
						return t
					})
				}
			}, close: ot, closePopup: ot, closeModal: ot, closeToast: ot, isVisible: function () {
				return !!F()
			}, clickConfirm: function () {
				return j().click()
			}, clickCancel: function () {
				return U().click()
			}, getContainer: O, getPopup: F, getTitle: R, getContent: H, getImage: $, getIcons: N, getCloseButton: V, getButtonsWrapper: function () {
				return g("swal.getButtonsWrapper() is deprecated and will be removed in the next major release, use swal.getActions() instead"), L(x.actions)
			}, getActions: W, getConfirmButton: j, getCancelButton: U, getFooter: Y, getFocusableElements: q, getValidationMessage: z, isLoading: function () {
				return F().hasAttribute("data-loading")
			}, fire: function () {
				for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
				return l(this, e)
			}, mixin: function (t) {
				return st(function (i) {
					function s() {
						return e(this, s), c(this, a(s).apply(this, arguments))
					}

					return o(s, i), n(s, [{
						key: "_main", value: function (e) {
							return u(a(s.prototype), "_main", this).call(this, r({}, t, e))
						}
					}]), s
				}(this))
			}, queue: function (t) {
				var e = this;
				gt = t;
				var i = function () {
					gt = [], document.body.removeAttribute("data-swal2-queue-step")
				}, n = [];
				return new Promise(function (t) {
					!function r(o, a) {
						o < gt.length ? (document.body.setAttribute("data-swal2-queue-step", o), e(gt[o]).then(function (e) {
							void 0 !== e.value ? (n.push(e.value), r(o + 1, a)) : (i(), t({dismiss: e.dismiss}))
						})) : (i(), t({value: n}))
					}(0)
				})
			}, getQueueStep: function () {
				return document.body.getAttribute("data-swal2-queue-step")
			}, insertQueueStep: function (t, e) {
				return e && e < gt.length ? gt.splice(e, 0, t) : gt.push(t)
			}, deleteQueueStep: function (t) {
				void 0 !== gt[t] && gt.splice(t, 1)
			}, showLoading: vt, enableLoading: vt, getTimerLeft: function () {
				return rt.timeout && rt.timeout.getTimerLeft()
			}, stopTimer: function () {
				return rt.timeout && rt.timeout.stop()
			}, resumeTimer: function () {
				return rt.timeout && rt.timeout.start()
			}, toggleTimer: function () {
				var t = rt.timeout;
				return t && (t.running ? t.stop() : t.start())
			}, increaseTimer: function (t) {
				return rt.timeout && rt.timeout.increase(t)
			}, isTimerRunning: function () {
				return rt.timeout && rt.timeout.isRunning()
			}
		}), bt = "function" == typeof Symbol ? Symbol : function () {
			var t = 0;

			function e(e) {
				return "__" + e + "_" + Math.floor(1e9 * Math.random()) + "_" + ++t + "__"
			}

			return e.iterator = e("Symbol.iterator"), e
		}(), wt = "function" == typeof WeakMap ? WeakMap : function (t, e, i) {
			function n() {
				e(this, t, {value: bt("WeakMap")})
			}

			return n.prototype = {
				delete: function (e) {
					delete e[this[t]]
				}, get: function (e) {
					return e[this[t]]
				}, has: function (e) {
					return i.call(e, this[t])
				}, set: function (i, n) {
					e(i, this[t], {configurable: !0, value: n})
				}
			}, n
		}(bt("WeakMap"), Object.defineProperty, {}.hasOwnProperty), xt = {promise: new wt, innerParams: new wt, domCache: new wt};

	function kt() {
		var t = xt.innerParams.get(this), e = xt.domCache.get(this);
		t.showConfirmButton || (P(e.confirmButton), t.showCancelButton || P(e.actions)), M([e.popup, e.actions], x.loading), e.popup.removeAttribute("aria-busy"), e.popup.removeAttribute("data-loading"), e.confirmButton.disabled = !1, e.cancelButton.disabled = !1
	}

	function _t(t) {
		var e = xt.domCache.get(this);
		e.validationMessage.innerHTML = t;
		var i = window.getComputedStyle(e.popup);
		e.validationMessage.style.marginLeft = "-".concat(i.getPropertyValue("padding-left")), e.validationMessage.style.marginRight = "-".concat(i.getPropertyValue("padding-right")), A(e.validationMessage);
		var n = this.getInput();
		n && (n.setAttribute("aria-invalid", !0), n.setAttribute("aria-describedBy", x["validation-message"]), C(n), T(n, x.inputerror))
	}

	function St() {
		var t = xt.domCache.get(this);
		t.validationMessage && P(t.validationMessage);
		var e = this.getInput();
		e && (e.removeAttribute("aria-invalid"), e.removeAttribute("aria-describedBy"), M(e, x.inputerror))
	}

	var Ct, Dt = function t(i, n) {
		e(this, t);
		var r, o, a = n;
		this.running = !1, this.start = function () {
			return this.running || (this.running = !0, o = new Date, r = setTimeout(i, a)), a
		}, this.stop = function () {
			return this.running && (this.running = !1, clearTimeout(r), a -= new Date - o), a
		}, this.increase = function (t) {
			var e = this.running;
			return e && this.stop(), a += t, e && this.start(), a
		}, this.getTimerLeft = function () {
			return this.running && (this.stop(), this.start()), a
		}, this.isRunning = function () {
			return this.running
		}, this.start()
	}, Tt = {
		email: function (t, e) {
			return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(t) ? Promise.resolve() : Promise.reject(e && e.validationMessage ? e.validationMessage : "Invalid email address")
		}, url: function (t, e) {
			return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&\/\/=]*)$/.test(t) ? Promise.resolve() : Promise.reject(e && e.validationMessage ? e.validationMessage : "Invalid URL")
		}
	}, Mt = function (t) {
		var e = O(), i = F();
		null !== t.onBeforeOpen && "function" == typeof t.onBeforeOpen && t.onBeforeOpen(i), t.animation ? (T(i, x.show), T(e, x.fade), M(i, x.hide)) : M(i, x.fade), A(i), e.style.overflowY = "hidden", tt && !S(i, x.noanimation) ? i.addEventListener(tt, function t() {
			i.removeEventListener(tt, t), e.style.overflowY = "auto"
		}) : e.style.overflowY = "auto", T([document.documentElement, document.body, e], x.shown), t.heightAuto && t.backdrop && !t.toast && T([document.documentElement, document.body], x["height-auto"]), G() && (null === _.previousBodyPadding && document.body.scrollHeight > window.innerHeight && (_.previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = _.previousBodyPadding + function () {
			if ("ontouchstart" in window || navigator.msMaxTouchPoints) return 0;
			var t = document.createElement("div");
			t.style.width = "50px", t.style.height = "50px", t.style.overflow = "scroll", document.body.appendChild(t);
			var e = t.offsetWidth - t.clientWidth;
			return document.body.removeChild(t), e
		}() + "px"), function () {
			if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && !S(document.body, x.iosfix)) {
				var t = document.body.scrollTop;
				document.body.style.top = -1 * t + "px", T(document.body, x.iosfix)
			}
		}(), "undefined" != typeof window && it() && (nt(), window.addEventListener("resize", nt)), d(document.body.children).forEach(function (t) {
			t === O() || function (t, e) {
				if ("function" == typeof t.contains) return t.contains(e)
			}(t, O()) || (t.hasAttribute("aria-hidden") && t.setAttribute("data-previous-aria-hidden", t.getAttribute("aria-hidden")), t.setAttribute("aria-hidden", "true"))
		}), setTimeout(function () {
			e.scrollTop = 0
		})), K() || rt.previousActiveElement || (rt.previousActiveElement = document.activeElement), null !== t.onOpen && "function" == typeof t.onOpen && setTimeout(function () {
			t.onOpen(i)
		})
	}, Et = Object.freeze({
		hideLoading: kt, disableLoading: kt, getInput: function (t) {
			var e = xt.innerParams.get(this), i = xt.domCache.get(this);
			if (!(t = t || e.input)) return null;
			switch (t) {
				case"select":
				case"textarea":
				case"file":
					return E(i.content, x[t]);
				case"checkbox":
					return i.popup.querySelector(".".concat(x.checkbox, " input"));
				case"radio":
					return i.popup.querySelector(".".concat(x.radio, " input:checked")) || i.popup.querySelector(".".concat(x.radio, " input:first-child"));
				case"range":
					return i.popup.querySelector(".".concat(x.range, " input"));
				default:
					return E(i.content, x.input)
			}
		}, enableButtons: function () {
			var t = xt.domCache.get(this);
			t.confirmButton.disabled = !1, t.cancelButton.disabled = !1
		}, disableButtons: function () {
			var t = xt.domCache.get(this);
			t.confirmButton.disabled = !0, t.cancelButton.disabled = !0
		}, enableConfirmButton: function () {
			xt.domCache.get(this).confirmButton.disabled = !1
		}, disableConfirmButton: function () {
			xt.domCache.get(this).confirmButton.disabled = !0
		}, enableInput: function () {
			var t = this.getInput();
			if (!t) return !1;
			if ("radio" === t.type) for (var e = t.parentNode.parentNode.querySelectorAll("input"), i = 0; i < e.length; i++) e[i].disabled = !1; else t.disabled = !1
		}, disableInput: function () {
			var t = this.getInput();
			if (!t) return !1;
			if (t && "radio" === t.type) for (var e = t.parentNode.parentNode.querySelectorAll("input"), i = 0; i < e.length; i++) e[i].disabled = !0; else t.disabled = !0
		}, showValidationMessage: _t, resetValidationMessage: St, resetValidationError: function () {
			g("Swal.resetValidationError() is deprecated and will be removed in the next major release, use Swal.resetValidationMessage() instead"), St.bind(this)()
		}, showValidationError: function (t) {
			g("Swal.showValidationError() is deprecated and will be removed in the next major release, use Swal.showValidationMessage() instead"), _t.bind(this)(t)
		}, getProgressSteps: function () {
			return xt.innerParams.get(this).progressSteps
		}, setProgressSteps: function (t) {
			var e = r({}, xt.innerParams.get(this), {progressSteps: t});
			xt.innerParams.set(this, e), et(e)
		}, showProgressSteps: function () {
			var t = xt.domCache.get(this);
			A(t.progressSteps)
		}, hideProgressSteps: function () {
			var t = xt.domCache.get(this);
			P(t.progressSteps)
		}, _main: function (e) {
			var i = this;
			pt(e);
			var n = r({}, lt, e);
			!function (e) {
				var i;
				e.inputValidator || Object.keys(Tt).forEach(function (t) {
					e.input === t && (e.inputValidator = e.expectRejections ? Tt[t] : Ot.adaptInputValidator(Tt[t]))
				}), e.validationMessage && ("object" !== t(e.extraParams) && (e.extraParams = {}), e.extraParams.validationMessage = e.validationMessage), (!e.target || "string" == typeof e.target && !document.querySelector(e.target) || "string" != typeof e.target && !e.target.appendChild) && (p('Target parameter is not valid, defaulting to "body"'), e.target = "body"), "function" == typeof e.animation && (e.animation = e.animation.call());
				var n = F(), r = "string" == typeof e.target ? document.querySelector(e.target) : e.target;
				i = n && r && n.parentNode !== r.parentNode ? Q(e) : n || Q(e), e.width && (i.style.width = "number" == typeof e.width ? e.width + "px" : e.width), e.padding && (i.style.padding = "number" == typeof e.padding ? e.padding + "px" : e.padding), e.background && (i.style.background = e.background);
				for (var o = window.getComputedStyle(i).getPropertyValue("background-color"), a = i.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix"), s = 0; s < a.length; s++) a[s].style.backgroundColor = o;
				var l = O(), c = V(), u = Y();
				if (function (t) {
					var e = R();
					t.titleText ? e.innerText = t.titleText : t.title && ("string" == typeof t.title && (t.title = t.title.split("\n").join("<br />")), J(t.title, e))
				}(e), function (t) {
					var e = H().querySelector("#" + x.content);
					t.html ? J(t.html, e) : t.text ? (e.textContent = t.text, A(e)) : P(e)
				}(e), "string" == typeof e.backdrop ? O().style.background = e.backdrop : e.backdrop || T([document.documentElement, document.body], x["no-backdrop"]), !e.backdrop && e.allowOutsideClick && p('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.position in x ? T(l, x[e.position]) : (p('The "position" parameter is not valid, defaulting to "center"'), T(l, x.center)), e.grow && "string" == typeof e.grow) {
					var h = "grow-" + e.grow;
					h in x && T(l, x[h])
				}
				e.showCloseButton ? (c.setAttribute("aria-label", e.closeButtonAriaLabel), A(c)) : P(c), i.className = x.popup, e.toast ? (T([document.documentElement, document.body], x["toast-shown"]), T(i, x.toast)) : T(i, x.modal), e.customClass && T(i, e.customClass), et(e), function (t) {
					for (var e = N(), i = 0; i < e.length; i++) P(e[i]);
					if (t.type) if (-1 !== Object.keys(k).indexOf(t.type)) {
						var n = Ot.getPopup().querySelector(".".concat(x.icon, ".").concat(k[t.type]));
						A(n), t.animation && T(n, "swal2-animate-".concat(t.type, "-icon"))
					} else f('Unknown type! Expected "success", "error", "warning", "info" or "question", got "'.concat(t.type, '"'))
				}(e), function (t) {
					var e = $();
					t.imageUrl ? (e.setAttribute("src", t.imageUrl), e.setAttribute("alt", t.imageAlt), A(e), t.imageWidth ? e.setAttribute("width", t.imageWidth) : e.removeAttribute("width"), t.imageHeight ? e.setAttribute("height", t.imageHeight) : e.removeAttribute("height"), e.className = x.image, t.imageClass && T(e, t.imageClass)) : P(e)
				}(e), function (t) {
					var e = W(), i = j(), n = U();
					if (t.showConfirmButton || t.showCancelButton ? A(e) : P(e), t.showCancelButton ? n.style.display = "inline-block" : P(n), t.showConfirmButton ? i.style.removeProperty("display") : P(i), i.innerHTML = t.confirmButtonText, n.innerHTML = t.cancelButtonText, i.setAttribute("aria-label", t.confirmButtonAriaLabel), n.setAttribute("aria-label", t.cancelButtonAriaLabel), i.className = x.confirm, T(i, t.confirmButtonClass), n.className = x.cancel, T(n, t.cancelButtonClass), t.buttonsStyling) {
						T([i, n], x.styled), t.confirmButtonColor && (i.style.backgroundColor = t.confirmButtonColor), t.cancelButtonColor && (n.style.backgroundColor = t.cancelButtonColor);
						var r = window.getComputedStyle(i).getPropertyValue("background-color");
						i.style.borderLeftColor = r, i.style.borderRightColor = r
					} else M([i, n], x.styled), i.style.backgroundColor = i.style.borderLeftColor = i.style.borderRightColor = "", n.style.backgroundColor = n.style.borderLeftColor = n.style.borderRightColor = ""
				}(e), J(e.footer, u), !0 === e.animation ? M(i, x.noanimation) : T(i, x.noanimation), e.showLoaderOnConfirm && !e.preConfirm && p("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request")
			}(n), Object.freeze(n), xt.innerParams.set(this, n), rt.timeout && (rt.timeout.stop(), delete rt.timeout), clearTimeout(rt.restoreFocusTimeout);
			var o = {popup: F(), container: O(), content: H(), actions: W(), confirmButton: j(), cancelButton: U(), closeButton: V(), validationMessage: z(), progressSteps: B()};
			xt.domCache.set(this, o);
			var a = this.constructor;
			return new Promise(function (e, r) {
				var s = function (t) {
					a.closePopup(n.onClose, n.onAfterClose), n.useRejections ? e(t) : e({value: t})
				}, l = function (t) {
					a.closePopup(n.onClose, n.onAfterClose), n.useRejections ? r(t) : e({dismiss: t})
				}, c = function (t) {
					a.closePopup(n.onClose, n.onAfterClose), r(t)
				};
				n.timer && (rt.timeout = new Dt(function () {
					l("timer"), delete rt.timeout
				}, n.timer)), n.input && setTimeout(function () {
					var t = i.getInput();
					t && C(t)
				}, 0);
				for (var u = function (t) {
					if (n.showLoaderOnConfirm && a.showLoading(), n.preConfirm) {
						i.resetValidationMessage();
						var e = Promise.resolve().then(function () {
							return n.preConfirm(t, n.extraParams)
						});
						n.expectRejections ? e.then(function (e) {
							return s(e || t)
						}, function (t) {
							i.hideLoading(), t && i.showValidationMessage(t)
						}) : e.then(function (e) {
							I(o.validationMessage) || !1 === e ? i.hideLoading() : s(e || t)
						}, function (t) {
							return c(t)
						})
					} else s(t)
				}, h = function (t) {
					var e = t.target, r = o.confirmButton, s = o.cancelButton, h = r && (r === e || r.contains(e)), d = s && (s === e || s.contains(e));
					switch (t.type) {
						case"click":
							if (h && a.isVisible()) if (i.disableButtons(), n.input) {
								var p = function () {
									var t = i.getInput();
									if (!t) return null;
									switch (n.input) {
										case"checkbox":
											return t.checked ? 1 : 0;
										case"radio":
											return t.checked ? t.value : null;
										case"file":
											return t.files.length ? t.files[0] : null;
										default:
											return n.inputAutoTrim ? t.value.trim() : t.value
									}
								}();
								if (n.inputValidator) {
									i.disableInput();
									var f = Promise.resolve().then(function () {
										return n.inputValidator(p, n.extraParams)
									});
									n.expectRejections ? f.then(function () {
										i.enableButtons(), i.enableInput(), u(p)
									}, function (t) {
										i.enableButtons(), i.enableInput(), t && i.showValidationMessage(t)
									}) : f.then(function (t) {
										i.enableButtons(), i.enableInput(), t ? i.showValidationMessage(t) : u(p)
									}, function (t) {
										return c(t)
									})
								} else i.getInput().checkValidity() ? u(p) : (i.enableButtons(), i.showValidationMessage(n.validationMessage))
							} else u(!0); else d && a.isVisible() && (i.disableButtons(), l(a.DismissReason.cancel))
					}
				}, d = o.popup.querySelectorAll("button"), m = 0; m < d.length; m++) d[m].onclick = h, d[m].onmouseover = h, d[m].onmouseout = h, d[m].onmousedown = h;
				if (o.closeButton.onclick = function () {
					l(a.DismissReason.close)
				}, n.toast) o.popup.onclick = function () {
					n.showConfirmButton || n.showCancelButton || n.showCloseButton || n.input || l(a.DismissReason.close)
				}; else {
					var g = !1;
					o.popup.onmousedown = function () {
						o.container.onmouseup = function (t) {
							o.container.onmouseup = void 0, t.target === o.container && (g = !0)
						}
					}, o.container.onmousedown = function () {
						o.popup.onmouseup = function (t) {
							o.popup.onmouseup = void 0, (t.target === o.popup || o.popup.contains(t.target)) && (g = !0)
						}
					}, o.container.onclick = function (t) {
						g ? g = !1 : t.target === o.container && v(n.allowOutsideClick) && l(a.DismissReason.backdrop)
					}
				}
				n.reverseButtons ? o.confirmButton.parentNode.insertBefore(o.cancelButton, o.confirmButton) : o.confirmButton.parentNode.insertBefore(o.confirmButton, o.cancelButton);
				var b = function (t, e) {
					for (var i = q(n.focusCancel), r = 0; r < i.length; r++) return (t += e) === i.length ? t = 0 : -1 === t && (t = i.length - 1), i[t].focus();
					o.popup.focus()
				};
				rt.keydownHandlerAdded && (rt.keydownTarget.removeEventListener("keydown", rt.keydownHandler, {capture: rt.keydownListenerCapture}), rt.keydownHandlerAdded = !1), n.toast || (rt.keydownHandler = function (t) {
					return function (t, e) {
						if (e.stopKeydownPropagation && t.stopPropagation(), "Enter" !== t.key || t.isComposing) if ("Tab" === t.key) {
							for (var n = t.target, r = q(e.focusCancel), s = -1, c = 0; c < r.length; c++) if (n === r[c]) {
								s = c;
								break
							}
							t.shiftKey ? b(s, -1) : b(s, 1), t.stopPropagation(), t.preventDefault()
						} else -1 !== ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Left", "Right", "Up", "Down"].indexOf(t.key) ? document.activeElement === o.confirmButton && I(o.cancelButton) ? o.cancelButton.focus() : document.activeElement === o.cancelButton && I(o.confirmButton) && o.confirmButton.focus() : "Escape" !== t.key && "Esc" !== t.key || !0 !== v(e.allowEscapeKey) || (t.preventDefault(), l(a.DismissReason.esc)); else if (t.target && i.getInput() && t.target.outerHTML === i.getInput().outerHTML) {
							if (-1 !== ["textarea", "file"].indexOf(e.input)) return;
							a.clickConfirm(), t.preventDefault()
						}
					}(t, n)
				}, rt.keydownTarget = n.keydownListenerCapture ? window : o.popup, rt.keydownListenerCapture = n.keydownListenerCapture, rt.keydownTarget.addEventListener("keydown", rt.keydownHandler, {capture: rt.keydownListenerCapture}), rt.keydownHandlerAdded = !0), i.enableButtons(), i.hideLoading(), i.resetValidationMessage(), n.toast && (n.input || n.footer || n.showCloseButton) ? T(document.body, x["toast-column"]) : M(document.body, x["toast-column"]);
				for (var w, k, _ = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], S = function (t) {
					t.placeholder && !n.inputPlaceholder || (t.placeholder = n.inputPlaceholder)
				}, D = 0; D < _.length; D++) {
					var O = x[_[D]], L = E(o.content, O);
					if (w = i.getInput(_[D])) {
						for (var F in w.attributes) if (w.attributes.hasOwnProperty(F)) {
							var N = w.attributes[F].name;
							"type" !== N && "value" !== N && w.removeAttribute(N)
						}
						for (var R in n.inputAttributes) "range" === _[D] && "placeholder" === R || w.setAttribute(R, n.inputAttributes[R])
					}
					L.className = O, n.inputClass && T(L, n.inputClass), P(L)
				}
				switch (n.input) {
					case"text":
					case"email":
					case"password":
					case"number":
					case"tel":
					case"url":
						w = E(o.content, x.input), "string" == typeof n.inputValue || "number" == typeof n.inputValue ? w.value = n.inputValue : y(n.inputValue) || p('Unexpected type of inputValue! Expected "string", "number" or "Promise", got "'.concat(t(n.inputValue), '"')), S(w), w.type = n.input, A(w);
						break;
					case"file":
						S(w = E(o.content, x.file)), w.type = n.input, A(w);
						break;
					case"range":
						var H = E(o.content, x.range), $ = H.querySelector("input"), B = H.querySelector("output");
						$.value = n.inputValue, $.type = n.input, B.value = n.inputValue, A(H);
						break;
					case"select":
						var z = E(o.content, x.select);
						if (z.innerHTML = "", n.inputPlaceholder) {
							var j = document.createElement("option");
							j.innerHTML = n.inputPlaceholder, j.value = "", j.disabled = !0, j.selected = !0, z.appendChild(j)
						}
						k = function (t) {
							t.forEach(function (t) {
								var e = t[0], i = t[1], r = document.createElement("option");
								r.value = e, r.innerHTML = i, n.inputValue.toString() === e.toString() && (r.selected = !0), z.appendChild(r)
							}), A(z), z.focus()
						};
						break;
					case"radio":
						var U = E(o.content, x.radio);
						U.innerHTML = "", k = function (t) {
							t.forEach(function (t) {
								var e = t[0], i = t[1], r = document.createElement("input"), o = document.createElement("label");
								r.type = "radio", r.name = x.radio, r.value = e, n.inputValue.toString() === e.toString() && (r.checked = !0);
								var a = document.createElement("span");
								a.innerHTML = i, a.className = x.label, o.appendChild(r), o.appendChild(a), U.appendChild(o)
							}), A(U);
							var e = U.querySelectorAll("input");
							e.length && e[0].focus()
						};
						break;
					case"checkbox":
						var W = E(o.content, x.checkbox), Y = i.getInput("checkbox");
						Y.type = "checkbox", Y.value = 1, Y.id = x.checkbox, Y.checked = Boolean(n.inputValue), W.querySelector("span").innerHTML = n.inputPlaceholder, A(W);
						break;
					case"textarea":
						var V = E(o.content, x.textarea);
						V.value = n.inputValue, S(V), A(V);
						break;
					case null:
						break;
					default:
						f('Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "'.concat(n.input, '"'))
				}
				if ("select" === n.input || "radio" === n.input) {
					var G = function (t) {
						return k((e = t, i = [], "undefined" != typeof Map && e instanceof Map ? e.forEach(function (t, e) {
							i.push([e, t])
						}) : Object.keys(e).forEach(function (t) {
							i.push([t, e[t]])
						}), i));
						var e, i
					};
					y(n.inputOptions) ? (a.showLoading(), n.inputOptions.then(function (t) {
						i.hideLoading(), G(t)
					})) : "object" === t(n.inputOptions) ? G(n.inputOptions) : f("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(t(n.inputOptions)))
				} else -1 !== ["text", "email", "number", "tel", "textarea"].indexOf(n.input) && y(n.inputValue) && (a.showLoading(), P(w), n.inputValue.then(function (t) {
					w.value = "number" === n.input ? parseFloat(t) || 0 : t + "", A(w), w.focus(), i.hideLoading()
				}).catch(function (t) {
					f("Error in inputValue promise: " + t), w.value = "", A(w), w.focus(), i.hideLoading()
				}));
				Mt(n), n.toast || (v(n.allowEnterKey) ? n.focusCancel && I(o.cancelButton) ? o.cancelButton.focus() : n.focusConfirm && I(o.confirmButton) ? o.confirmButton.focus() : b(-1, 1) : document.activeElement && "function" == typeof document.activeElement.blur && document.activeElement.blur()), o.container.scrollTop = 0
			})
		}
	});

	function At() {
		if ("undefined" != typeof window) {
			"undefined" == typeof Promise && f("This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)");
			for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
			if (0 === e.length) return f("At least 1 argument is expected!"), !1;
			Ct = this;
			var n = Object.freeze(this.constructor.argsToParams(e));
			Object.defineProperties(this, {params: {value: n, writable: !1, enumerable: !0}});
			var r = this._main(this.params);
			xt.promise.set(this, r)
		}
	}

	At.prototype.then = function (t, e) {
		return xt.promise.get(this).then(t, e)
	}, At.prototype.catch = function (t) {
		return xt.promise.get(this).catch(t)
	}, At.prototype.finally = function (t) {
		return xt.promise.get(this).finally(t)
	}, r(At.prototype, Et), r(At, yt), Object.keys(Et).forEach(function (t) {
		At[t] = function () {
			var e;
			if (Ct) return (e = Ct)[t].apply(e, arguments)
		}
	}), At.DismissReason = b, At.noop = function () {
	};
	var Pt, It, Ot = st((Pt = At, It = function (i) {
		function s() {
			return e(this, s), c(this, a(s).apply(this, arguments))
		}

		return o(s, Pt), n(s, [{
			key: "_main", value: function (t) {
				return u(a(s.prototype), "_main", this).call(this, r({}, mt, t))
			}
		}], [{
			key: "setDefaults", value: function (e) {
				if (g(ft), !e || "object" !== t(e)) throw new TypeError("SweetAlert2: The argument for setDefaults() is required and has to be a object");
				pt(e), Object.keys(e).forEach(function (t) {
					Pt.isValidParameter(t) && (mt[t] = e[t])
				})
			}
		}, {
			key: "resetDefaults", value: function () {
				g(ft), mt = {}
			}
		}]), s
	}(), "undefined" != typeof window && "object" === t(window._swalDefaults) && It.setDefaults(window._swalDefaults), It));
	return Ot.default = Ot
}), "undefined" != typeof window && window.Sweetalert2 && (window.Sweetalert2.version = "7.32.2", window.swal = window.sweetAlert = window.Swal = window.SweetAlert = window.Sweetalert2), swal.setDefaults({
	width: 400,
	heightAuto: !1,
	padding: "2.5rem",
	buttonsStyling: !1,
	confirmButtonClass: "btn btn-success",
	confirmButtonColor: null,
	cancelButtonClass: "btn btn-secondary",
	cancelButtonColor: null
});
var identity = function (t) {
	return t
}, isArray = function (t) {
	return $.isArray(t)
}, isObject = function (t) {
	return !isArray(t) && t instanceof Object
}, isNumber = function (t) {
	return t instanceof Number
}, isFunction = function (t) {
	return t instanceof Function
}, indexOf = function (t, e) {
	return $.inArray(e, t)
}, inArray = function (t, e) {
	return -1 !== indexOf(t, e)
}, foreach = function (t, e) {
	for (var i in t) t.hasOwnProperty(i) && e(t[i], i, t)
}, last = function (t) {
	return t[t.length - 1]
}, argumentsToArray = function (t) {
	return Array.prototype.slice.call(t)
}, extend = function () {
	var t = {};
	return foreach(argumentsToArray(arguments), function (e) {
		foreach(e, function (e, i) {
			t[i] = e
		})
	}), t
}, mapToArray = function (t, e) {
	var i = [];
	return foreach(t, function (t, n, r) {
		i.push(e(t, n, r))
	}), i
}, mapToObject = function (t, e, i) {
	var n = {};
	return foreach(t, function (t, r, o) {
		r = i ? i(r, t) : r, n[r] = e(t, r, o)
	}), n
}, map = function (t, e, i) {
	return isArray(t) ? mapToArray(t, e) : mapToObject(t, e, i)
}, pluck = function (t, e) {
	return map(t, function (t) {
		return t[e]
	})
}, filter = function (t, e) {
	var i;
	return isArray(t) ? (i = [], foreach(t, function (t, n, r) {
		e(t, n, r) && i.push(t)
	})) : (i = {}, foreach(t, function (t, n, r) {
		e(t, n, r) && (i[n] = t)
	})), i
}, call = function (t, e, i) {
	return map(t, function (t, n) {
		return t[e].apply(t, i || [])
	})
}, throttle = function (t, e) {
	var i = null;
	return function () {
		var n = arguments;
		null === i && (i = setTimeout(function () {
			i = null
		}, t), e.apply(this, n))
	}
}, mixinPubSub = function (t) {
	var e = {};
	return (t = t || {}).publish = function (t, i) {
		foreach(e[t], function (t) {
			t(i)
		})
	}, t.subscribe = function (t, i) {
		e[t] = e[t] || [], e[t].push(i)
	}, t.unsubscribe = function (t) {
		foreach(e, function (e) {
			var i = indexOf(e, t);
			-1 !== i && e.splice(i, 1)
		})
	}, t
};
!function (t) {
	"use strict";
	var e = function (t, e) {
		var i, n = mixinPubSub(), r = t.$;
		return n.getType = function () {
			throw'implement me (return type. "text", "radio", etc.)'
		}, n.$ = function (t) {
			return t ? r.find(t) : r
		}, n.disable = function () {
			n.$().prop("disabled", !0), n.publish("isEnabled", !1)
		}, n.enable = function () {
			n.$().prop("disabled", !1), n.publish("isEnabled", !0)
		}, e.equalTo = function (t, e) {
			return t === e
		}, e.publishChange = function (t, r) {
			var o = n.get();
			e.equalTo(o, i) || n.publish("change", {e: t, domElement: r}), i = o
		}, n
	}, i = function (t, i) {
		var n = e(t, i);
		return n.get = function () {
			return n.$().val()
		}, n.set = function (t) {
			n.$().val(t)
		}, n.clear = function () {
			n.set("")
		}, i.buildSetter = function (t) {
			return function (e) {
				t.call(n, e)
			}
		}, n
	}, n = function (t, e) {
		t = isArray(t) ? t : [t], e = isArray(e) ? e : [e];
		var i = !0;
		return t.length !== e.length ? i = !1 : foreach(t, function (t) {
			inArray(e, t) || (i = !1)
		}), i
	}, r = function (t) {
		var e = {}, n = i(t, e);
		return n.getType = function () {
			return "button"
		}, n.$().on("change", function (t) {
			e.publishChange(t, this)
		}), n
	}, o = function (e) {
		var r = {}, o = i(e, r);
		return o.getType = function () {
			return "checkbox"
		}, o.get = function () {
			var e = [];
			return o.$().filter(":checked").each(function () {
				e.push(t(this).val())
			}), e
		}, o.set = function (e) {
			e = isArray(e) ? e : [e], o.$().each(function () {
				t(this).prop("checked", !1)
			}), foreach(e, function (t) {
				o.$().filter('[value="' + t + '"]').prop("checked", !0)
			})
		}, r.equalTo = n, o.$().change(function (t) {
			r.publishChange(t, this)
		}), o
	}, a = function (t) {
		var e = m(t, {});
		return e.getType = function () {
			return "email"
		}, e
	}, s = function (i) {
		var n = {}, r = e(i, n);
		return r.getType = function () {
			return "file"
		}, r.get = function () {
			return last(r.$().val().split("\\"))
		}, r.clear = function () {
			this.$().each(function () {
				t(this).wrap("<form>").closest("form").get(0).reset(), t(this).unwrap()
			})
		}, r.$().change(function (t) {
			n.publishChange(t, this)
		}), r
	}, l = function (t) {
		var e = {}, n = i(t, e);
		return n.getType = function () {
			return "hidden"
		}, n.$().change(function (t) {
			e.publishChange(t, this)
		}), n
	}, c = function (i) {
		var n = {}, r = e(i, n);
		return r.getType = function () {
			return "file[multiple]"
		}, r.get = function () {
			var t, e = r.$().get(0).files || [], i = [];
			for (t = 0; t < (e.length || 0); t += 1) i.push(e[t].name);
			return i
		}, r.clear = function () {
			this.$().each(function () {
				t(this).wrap("<form>").closest("form").get(0).reset(), t(this).unwrap()
			})
		}, r.$().change(function (t) {
			n.publishChange(t, this)
		}), r
	}, u = function (t) {
		var e = {}, r = i(t, e);
		return r.getType = function () {
			return "select[multiple]"
		}, r.get = function () {
			return r.$().val() || []
		}, r.set = function (t) {
			r.$().val("" === t ? [] : isArray(t) ? t : [t])
		}, e.equalTo = n, r.$().change(function (t) {
			e.publishChange(t, this)
		}), r
	}, h = function (t) {
		var e = m(t, {});
		return e.getType = function () {
			return "password"
		}, e
	}, d = function (e) {
		var n = {}, r = i(e, n);
		return r.getType = function () {
			return "radio"
		}, r.get = function () {
			return r.$().filter(":checked").val() || null
		}, r.set = function (e) {
			e ? r.$().filter('[value="' + e + '"]').prop("checked", !0) : r.$().each(function () {
				t(this).prop("checked", !1)
			})
		}, r.$().change(function (t) {
			n.publishChange(t, this)
		}), r
	}, p = function (t) {
		var e = {}, n = i(t, e);
		return n.getType = function () {
			return "range"
		}, n.$().change(function (t) {
			e.publishChange(t, this)
		}), n
	}, f = function (t) {
		var e = {}, n = i(t, e);
		return n.getType = function () {
			return "select"
		}, n.$().change(function (t) {
			e.publishChange(t, this)
		}), n
	}, m = function (t) {
		var e = {}, n = i(t, e);
		return n.getType = function () {
			return "text"
		}, n.$().on("change keyup keydown", function (t) {
			e.publishChange(t, this)
		}), n
	}, g = function (t) {
		var e = {}, n = i(t, e);
		return n.getType = function () {
			return "textarea"
		}, n.$().on("change keyup keydown", function (t) {
			e.publishChange(t, this)
		}), n
	}, v = function (t) {
		var e = m(t, {});
		return e.getType = function () {
			return "url"
		}, e
	}, y = function (e) {
		var i = {}, n = e.$, y = e.constructorOverride || {button: r, text: m, url: v, email: a, password: h, range: p, textarea: g, select: f, "select[multiple]": u, radio: d, checkbox: o, file: s, "file[multiple]": c, hidden: l}, b = function (e, r) {
			(isObject(r) ? r : n.find(r)).each(function () {
				var n = t(this).attr("name");
				i[n] = y[e]({$: t(this)})
			})
		}, w = function (e, r) {
			var o = [], a = isObject(r) ? r : n.find(r);
			isObject(r) ? i[a.attr("name")] = y[e]({$: a}) : (a.each(function () {
				-1 === indexOf(o, t(this).attr("name")) && o.push(t(this).attr("name"))
			}), foreach(o, function (t) {
				i[t] = y[e]({$: n.find('input[name="' + t + '"]')})
			}))
		};
		return n.is("input, select, textarea") ? n.is('input[type="button"], button, input[type="submit"]') ? b("button", n) : n.is("textarea") ? b("textarea", n) : n.is('input[type="text"]') || n.is("input") && !n.attr("type") ? b("text", n) : n.is('input[type="password"]') ? b("password", n) : n.is('input[type="email"]') ? b("email", n) : n.is('input[type="url"]') ? b("url", n) : n.is('input[type="range"]') ? b("range", n) : n.is("select") ? n.is("[multiple]") ? b("select[multiple]", n) : b("select", n) : n.is('input[type="file"]') ? n.is("[multiple]") ? b("file[multiple]", n) : b("file", n) : n.is('input[type="hidden"]') ? b("hidden", n) : n.is('input[type="radio"]') ? w("radio", n) : n.is('input[type="checkbox"]') ? w("checkbox", n) : b("text", n) : (b("button", 'input[type="button"], button, input[type="submit"]'), b("text", 'input[type="text"]'), b("password", 'input[type="password"]'), b("email", 'input[type="email"]'), b("url", 'input[type="url"]'), b("range", 'input[type="range"]'), b("textarea", "textarea"), b("select", "select:not([multiple])"), b("select[multiple]", "select[multiple]"), b("file", 'input[type="file"]:not([multiple])'), b("file[multiple]", 'input[type="file"][multiple]'), b("hidden", 'input[type="hidden"]'), w("radio", 'input[type="radio"]'), w("checkbox", 'input[type="checkbox"]')), i
	};
	t.fn.inputVal = function (e) {
		var i = t(this), n = y({$: i});
		return i.is("input, textarea, select") ? void 0 === e ? n[i.attr("name")].get() : (n[i.attr("name")].set(e), i) : void 0 === e ? call(n, "get") : (foreach(e, function (t, e) {
			n[e].set(t)
		}), i)
	}, t.fn.inputOnChange = function (e) {
		var i = t(this), n = y({$: i});
		return foreach(n, function (t) {
			t.subscribe("change", function (t) {
				e.call(t.domElement, t.e)
			})
		}), i
	}, t.fn.inputDisable = function () {
		var e = t(this);
		return call(y({$: e}), "disable"), e
	}, t.fn.inputEnable = function () {
		var e = t(this);
		return call(y({$: e}), "enable"), e
	}, t.fn.inputClear = function () {
		var e = t(this);
		return call(y({$: e}), "clear"), e
	}
}(jQuery), $.fn.repeaterVal = function () {
	var t, e, i = function (t) {
		if (1 === t.length && (0 === t[0].key.length || 1 === t[0].key.length && !t[0].key[0])) return t[0].val;
		foreach(t, function (t) {
			t.head = t.key.shift()
		});
		var e, n = function () {
			var e = {};
			return foreach(t, function (t) {
				e[t.head] || (e[t.head] = []), e[t.head].push(t)
			}), e
		}();
		return /^[0-9]+$/.test(t[0].head) ? (e = [], foreach(n, function (t) {
			e.push(i(t))
		})) : (e = {}, foreach(n, function (t, n) {
			e[n] = i(t)
		})), e
	};
	return i((t = $(this).inputVal(), e = [], foreach(t, function (t, i) {
		var n = [];
		"undefined" !== i && (n.push(i.match(/^[^\[]*/)[0]), n = n.concat(map(i.match(/\[[^\]]*\]/g), function (t) {
			return t.replace(/[\[\]]/g, "")
		})), e.push({val: t, key: n}))
	}), e))
}, $.fn.repeater = function (t) {
	var e;
	return t = t || {}, $(this).each(function () {
		var i = $(this), n = t.show || function () {
			$(this).show()
		}, r = t.hide || function (t) {
			t()
		}, o = i.find("[data-repeater-list]").first(), a = function (t, e) {
			return t.filter(function () {
				return !e || 0 === $(this).closest(pluck(e, "selector").join(",")).length
			})
		}, s = function () {
			return a(o.find("[data-repeater-item]"), t.repeaters)
		}, l = o.find("[data-repeater-item]").first().clone().hide(), c = a(a($(this).find("[data-repeater-item]"), t.repeaters).first().find("[data-repeater-delete]"), t.repeaters);
		t.isFirstItemUndeletable && c && c.remove();
		var u = function () {
			var e = o.data("repeater-list");
			return t.$parent ? t.$parent.data("item-name") + "[" + e + "]" : e
		}, h = function (e) {
			t.repeaters && e.each(function () {
				var e = $(this);
				foreach(t.repeaters, function (t) {
					e.find(t.selector).repeater(extend(t, {$parent: e}))
				})
			})
		}, d = function (t, e, i) {
			t && foreach(t, function (t) {
				i.call(e.find(t.selector)[0], t)
			})
		}, p = function (t, e, i) {
			t.each(function (t) {
				var n = $(this);
				n.data("item-name", e + "[" + t + "]"), a(n.find("[name]"), i).each(function () {
					var r = $(this), o = r.attr("name").match(/\[[^\]]+\]/g), s = o ? last(o).replace(/\[|\]/g, "") : r.attr("name"), l = e + "[" + t + "][" + s + "]" + (r.is(":checkbox") || r.attr("multiple") ? "[]" : "");
					r.attr("name", l), d(i, n, function (i) {
						var n = $(this);
						p(a(n.find("[data-repeater-item]"), i.repeaters || []), e + "[" + t + "][" + n.find("[data-repeater-list]").first().data("repeater-list") + "]", i.repeaters)
					})
				})
			}), o.find("input[name][checked]").removeAttr("checked").prop("checked", !0)
		};
		p(s(), u(), t.repeaters), h(s()), t.initEmpty && s().remove(), t.ready && t.ready(function () {
			p(s(), u(), t.repeaters)
		});
		var f, m = (f = function (e, i, n) {
			if (i || t.defaultValues) {
				var r = {};
				a(e.find("[name]"), n).each(function () {
					var t = $(this).attr("name").match(/\[([^\]]*)(\]|\]\[\])$/)[1];
					r[t] = $(this).attr("name")
				}), e.inputVal(map(filter(i || t.defaultValues, function (t, e) {
					return r[e]
				}), identity, function (t) {
					return r[t]
				}))
			}
			d(n, e, function (t) {
				var e = $(this);
				a(e.find("[data-repeater-item]"), t.repeaters).each(function () {
					var n = e.find("[data-repeater-list]").data("repeater-list");
					if (i && i[n]) {
						var r = $(this).clone();
						e.find("[data-repeater-item]").remove(), foreach(i[n], function (i) {
							var n = r.clone();
							f(n, i, t.repeaters || []), e.find("[data-repeater-list]").append(n)
						})
					} else f($(this), t.defaultValues, t.repeaters || [])
				})
			})
		}, function (e, i) {
			o.append(e), p(s(), u(), t.repeaters), e.find("[name]").each(function () {
				$(this).inputClear()
			}), f(e, i || t.defaultValues, t.repeaters)
		}), g = function (e) {
			var i = l.clone();
			m(i, e), t.repeaters && h(i), n.call(i.get(0))
		};
		e = function (t) {
			s().remove(), foreach(t, g)
		}, a(i.find("[data-repeater-create]"), t.repeaters).click(function () {
			g()
		}), o.on("click", "[data-repeater-delete]", function () {
			var e = $(this).closest("[data-repeater-item]").get(0);
			r.call(e, function () {
				$(e).remove(), p(s(), u(), t.repeaters)
			})
		})
	}), this.setList = e, this
}, function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.DOMPurify = e()
}(this, function () {
	"use strict";
	var t = ["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"],
		e = ["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "audio", "canvas", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "video", "view", "vkern"],
		i = ["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"],
		n = ["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmuliscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mpspace", "msqrt", "mystyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"],
		r = ["#text"],
		o = ["accept", "action", "align", "alt", "autocomplete", "background", "bgcolor", "border", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "coords", "crossorigin", "datetime", "default", "dir", "disabled", "download", "enctype", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "integrity", "ismap", "label", "lang", "list", "loop", "low", "max", "maxlength", "media", "method", "min", "multiple", "name", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "type", "usemap", "valign", "value", "width", "xmlns"],
		a = ["accent-height", "accumulate", "additivive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "tabindex", "targetx", "targety", "transform", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"],
		s = ["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"],
		l = ["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"];

	function c(t, e) {
		for (var i = e.length; i--;) "string" == typeof e[i] && (e[i] = e[i].toLowerCase()), t[e[i]] = !0;
		return t
	}

	function u(t) {
		var e = {}, i = void 0;
		for (i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e
	}

	var h = /\{\{[\s\S]*|[\s\S]*\}\}/gm, d = /<%[\s\S]*|[\s\S]*%>/gm, p = /^data-[\-\w.\u00B7-\uFFFF]/, f = /^aria-[\-\w]+$/, m = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i, g = /^(?:\w+script|data):/i,
		v = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
			return typeof t
		} : function (t) {
			return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
		};

	function b(t) {
		if (Array.isArray(t)) {
			for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
			return i
		}
		return Array.from(t)
	}

	var w = function () {
		return "undefined" == typeof window ? null : window
	};
	return function x() {
		var k = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : w(), _ = function (t) {
			return x(t)
		};
		if (_.version = "1.0.8", _.removed = [], !k || !k.document || 9 !== k.document.nodeType) return _.isSupported = !1, _;
		var S = k.document, C = !1, D = !1, T = k.document, M = k.DocumentFragment, E = k.HTMLTemplateElement, A = k.Node, P = k.NodeFilter, I = k.NamedNodeMap, O = void 0 === I ? k.NamedNodeMap || k.MozNamedAttrMap : I, L = k.Text, F = k.Comment, N = k.DOMParser;
		if ("function" == typeof E) {
			var R = T.createElement("template");
			R.content && R.content.ownerDocument && (T = R.content.ownerDocument)
		}
		var H = T, $ = H.implementation, B = H.createNodeIterator, z = H.getElementsByTagName, j = H.createDocumentFragment, U = S.importNode, W = {};
		_.isSupported = $ && void 0 !== $.createHTMLDocument && 9 !== T.documentMode;
		var Y = h, V = d, q = p, G = f, K = g, X = v, Z = m, Q = null, J = c({}, [].concat(b(t), b(e), b(i), b(n), b(r))), tt = null, et = c({}, [].concat(b(o), b(a), b(s), b(l))), it = null, nt = null, rt = !0, ot = !0, at = !1, st = !1, lt = !1, ct = !1, ut = !1, ht = !1, dt = !1, pt = !1, ft = !1,
			mt = !0, gt = !0, vt = !1, yt = {}, bt = c({}, ["audio", "head", "math", "script", "style", "template", "svg", "video"]), wt = c({}, ["audio", "video", "img", "source", "image"]),
			xt = c({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "summary", "title", "value", "style", "xmlns"]), kt = null, _t = T.createElement("form"), St = function (h) {
				"object" !== (void 0 === h ? "undefined" : y(h)) && (h = {}), Q = "ALLOWED_TAGS" in h ? c({}, h.ALLOWED_TAGS) : J, tt = "ALLOWED_ATTR" in h ? c({}, h.ALLOWED_ATTR) : et, it = "FORBID_TAGS" in h ? c({}, h.FORBID_TAGS) : {}, nt = "FORBID_ATTR" in h ? c({}, h.FORBID_ATTR) : {}, yt = "USE_PROFILES" in h && h.USE_PROFILES, rt = !1 !== h.ALLOW_ARIA_ATTR, ot = !1 !== h.ALLOW_DATA_ATTR, at = h.ALLOW_UNKNOWN_PROTOCOLS || !1, st = h.SAFE_FOR_JQUERY || !1, lt = h.SAFE_FOR_TEMPLATES || !1, ct = h.WHOLE_DOCUMENT || !1, dt = h.RETURN_DOM || !1, pt = h.RETURN_DOM_FRAGMENT || !1, ft = h.RETURN_DOM_IMPORT || !1, ht = h.FORCE_BODY || !1, mt = !1 !== h.SANITIZE_DOM, gt = !1 !== h.KEEP_CONTENT, vt = h.IN_PLACE || !1, Z = h.ALLOWED_URI_REGEXP || Z, lt && (ot = !1), pt && (dt = !0), yt && (Q = c({}, [].concat(b(r))), tt = [], !0 === yt.html && (c(Q, t), c(tt, o)), !0 === yt.svg && (c(Q, e), c(tt, a), c(tt, l)), !0 === yt.svgFilters && (c(Q, i), c(tt, a), c(tt, l)), !0 === yt.mathMl && (c(Q, n), c(tt, s), c(tt, l))), h.ADD_TAGS && (Q === J && (Q = u(Q)), c(Q, h.ADD_TAGS)), h.ADD_ATTR && (tt === et && (tt = u(tt)), c(tt, h.ADD_ATTR)), h.ADD_URI_SAFE_ATTR && c(xt, h.ADD_URI_SAFE_ATTR), gt && (Q["#text"] = !0), ct && c(Q, ["html", "head", "body"]), Q.table && c(Q, ["tbody"]), Object && "freeze" in Object && Object.freeze(h), kt = h
			}, Ct = function (t) {
				_.removed.push({element: t});
				try {
					t.parentNode.removeChild(t)
				} catch (e) {
					t.outerHTML = ""
				}
			}, Dt = function (t, e) {
				try {
					_.removed.push({attribute: e.getAttributeNode(t), from: e})
				} catch (t) {
					_.removed.push({attribute: null, from: e})
				}
				e.removeAttribute(t)
			}, Tt = function (t) {
				var e = void 0;
				if (ht && (t = "<remove></remove>" + t), C) try {
					e = (new N).parseFromString(t, "text/html")
				} catch (t) {
				}
				if (D && c(it, ["title"]), !e || !e.documentElement) {
					var i = (e = $.createHTMLDocument("")).body;
					i.parentNode.removeChild(i.parentNode.firstElementChild), i.outerHTML = t
				}
				return z.call(e, ct ? "html" : "body")[0]
			};
		_.isSupported && (function () {
			try {
				Tt('<svg><p><style><img src="</style><img src=x onerror=alert(1)//">').querySelector("svg img") && (C = !0)
			} catch (t) {
			}
		}(), function () {
			try {
				Tt("<x/><title>&lt;/title&gt;&lt;img&gt;").querySelector("title").textContent.match(/<\/title/) && (D = !0)
			} catch (t) {
			}
		}());
		var Mt = function (t) {
			return B.call(t.ownerDocument || t, t, P.SHOW_ELEMENT | P.SHOW_COMMENT | P.SHOW_TEXT, function () {
				return P.FILTER_ACCEPT
			}, !1)
		}, Et = function (t) {
			return "object" === (void 0 === A ? "undefined" : y(A)) ? t instanceof A : t && "object" === (void 0 === t ? "undefined" : y(t)) && "number" == typeof t.nodeType && "string" == typeof t.nodeName
		}, At = function (t, e, i) {
			W[t] && W[t].forEach(function (t) {
				t.call(_, e, i, kt)
			})
		}, Pt = function (t) {
			var e, i = void 0;
			if (At("beforeSanitizeElements", t, null), !((e = t) instanceof L || e instanceof F || "string" == typeof e.nodeName && "string" == typeof e.textContent && "function" == typeof e.removeChild && e.attributes instanceof O && "function" == typeof e.removeAttribute && "function" == typeof e.setAttribute)) return Ct(t), !0;
			var n = t.nodeName.toLowerCase();
			if (At("uponSanitizeElement", t, {tagName: n, allowedTags: Q}), !Q[n] || it[n]) {
				if (gt && !bt[n] && "function" == typeof t.insertAdjacentHTML) try {
					t.insertAdjacentHTML("AfterEnd", t.innerHTML)
				} catch (t) {
				}
				return Ct(t), !0
			}
			return !st || t.firstElementChild || t.content && t.content.firstElementChild || !/</g.test(t.textContent) || (_.removed.push({element: t.cloneNode()}), t.innerHTML ? t.innerHTML = t.innerHTML.replace(/</g, "&lt;") : t.innerHTML = t.textContent.replace(/</g, "&lt;")), lt && 3 === t.nodeType && (i = (i = (i = t.textContent).replace(Y, " ")).replace(V, " "), t.textContent !== i && (_.removed.push({element: t.cloneNode()}), t.textContent = i)), At("afterSanitizeElements", t, null), !1
		}, It = function (t, e, i) {
			if (mt && ("id" === e || "name" === e) && (i in T || i in _t)) return !1;
			if (lt && (i = (i = i.replace(Y, " ")).replace(V, " ")), ot && q.test(e)) ; else if (rt && G.test(e)) ; else {
				if (!tt[e] || nt[e]) return !1;
				if (xt[e]) ; else if (Z.test(i.replace(X, ""))) ; else if ("src" !== e && "xlink:href" !== e || "script" === t || 0 !== i.indexOf("data:") || !wt[t]) if (at && !K.test(i.replace(X, ""))) ; else if (i) return !1
			}
			return !0
		}, Ot = function (t) {
			var e = void 0, i = void 0, n = void 0, r = void 0, o = void 0;
			At("beforeSanitizeAttributes", t, null);
			var a = t.attributes;
			if (a) {
				var s = {attrName: "", attrValue: "", keepAttr: !0, allowedAttributes: tt};
				for (o = a.length; o--;) {
					var l = e = a[o], c = l.name, u = l.namespaceURI;
					if (i = e.value.trim(), n = c.toLowerCase(), s.attrName = n, s.attrValue = i, s.keepAttr = !0, At("uponSanitizeAttribute", t, s), i = s.attrValue, "name" === n && "IMG" === t.nodeName && a.id) r = a.id, a = Array.prototype.slice.apply(a), Dt("id", t), Dt(c, t), a.indexOf(r) > o && t.setAttribute("id", r.value); else {
						if ("INPUT" === t.nodeName && "type" === n && "file" === i && (tt[n] || !nt[n])) continue;
						"id" === c && t.setAttribute(c, ""), Dt(c, t)
					}
					if (s.keepAttr) {
						var h = t.nodeName.toLowerCase();
						if (It(h, n, i)) try {
							u ? t.setAttributeNS(u, c, i) : t.setAttribute(c, i), _.removed.pop()
						} catch (t) {
						}
					}
				}
				At("afterSanitizeAttributes", t, null)
			}
		}, Lt = function t(e) {
			var i = void 0, n = Mt(e);
			for (At("beforeSanitizeShadowDOM", e, null); i = n.nextNode();) At("uponSanitizeShadowNode", i, null), Pt(i) || (i.content instanceof M && t(i.content), Ot(i));
			At("afterSanitizeShadowDOM", e, null)
		};
		return _.sanitize = function (t, e) {
			var i = void 0, n = void 0, r = void 0, o = void 0, a = void 0;
			if (t || (t = "\x3c!--\x3e"), "string" != typeof t && !Et(t)) {
				if ("function" != typeof t.toString) throw new TypeError("toString is not a function");
				if ("string" != typeof (t = t.toString())) throw new TypeError("dirty is not a string, aborting")
			}
			if (!_.isSupported) {
				if ("object" === y(k.toStaticHTML) || "function" == typeof k.toStaticHTML) {
					if ("string" == typeof t) return k.toStaticHTML(t);
					if (Et(t)) return k.toStaticHTML(t.outerHTML)
				}
				return t
			}
			if (ut || St(e), _.removed = [], vt) ; else if (t instanceof A) 1 === (n = (i = Tt("\x3c!--\x3e")).ownerDocument.importNode(t, !0)).nodeType && "BODY" === n.nodeName ? i = n : i.appendChild(n); else {
				if (!dt && !ct && -1 === t.indexOf("<")) return t;
				if (!(i = Tt(t))) return dt ? null : ""
			}
			i && ht && Ct(i.firstChild);
			for (var s = Mt(vt ? t : i); r = s.nextNode();) 3 === r.nodeType && r === o || Pt(r) || (r.content instanceof M && Lt(r.content), Ot(r), o = r);
			if (vt) return t;
			if (dt) {
				if (pt) for (a = j.call(i.ownerDocument); i.firstChild;) a.appendChild(i.firstChild); else a = i;
				return ft && (a = U.call(S, a, !0)), a
			}
			return ct ? i.outerHTML : i.innerHTML
		}, _.setConfig = function (t) {
			St(t), ut = !0
		}, _.clearConfig = function () {
			kt = null, ut = !1
		}, _.isValidAttribute = function (t, e, i) {
			kt || St({});
			var n = t.toLowerCase(), r = e.toLowerCase();
			return It(n, r, i)
		}, _.addHook = function (t, e) {
			"function" == typeof e && (W[t] = W[t] || [], W[t].push(e))
		}, _.removeHook = function (t) {
			W[t] && W[t].pop()
		}, _.removeHooks = function (t) {
			W[t] && (W[t] = [])
		}, _.removeAllHooks = function () {
			W = {}
		}, _
	}()
});